export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Hex: { input: any; output: any; }
  Json: { input: any; output: any; }
  Long: { input: any; output: any; }
  RGBAHue: { input: any; output: any; }
  RGBATransparency: { input: any; output: any; }
  RichTextAST: { input: any; output: any; }
};

/** Accordion */
export type Accordion = Entity & Node & {
  __typename?: 'Accordion';
  accordionItems: Array<AccordionItem>;
  anchorNav?: Maybe<AnchorNavigation>;
  /** By default all accordion items are expanded, this field make it expanded. */
  collapsed?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Accordion>;
  /** List of Accordion versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** Accordion name, should be unique per page */
  name: Scalars['String']['output'];
  /** Parent navigation url */
  navUrl?: Maybe<Scalars['String']['output']>;
  /** Show item number on left side of accordion item title */
  numbered?: Maybe<Scalars['Boolean']['output']>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Accordion */
export type AccordionAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionItemWhereInput>;
};


/** Accordion */
export type AccordionAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Accordion */
export type AccordionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Accordion */
export type AccordionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Accordion */
export type AccordionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Accordion */
export type AccordionMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Accordion */
export type AccordionProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


/** Accordion */
export type AccordionProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


/** Accordion */
export type AccordionProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


/** Accordion */
export type AccordionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Accordion */
export type AccordionRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


/** Accordion */
export type AccordionRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


/** Accordion */
export type AccordionRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


/** Accordion */
export type AccordionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Accordion */
export type AccordionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AccordionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AccordionWhereUniqueInput;
};

/** A connection to a list of items. */
export type AccordionConnection = {
  __typename?: 'AccordionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AccordionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export enum AccordionContentAlignment {
  ImageFullWidth = 'ImageFullWidth',
  ImageLeftTextRight = 'ImageLeftTextRight',
  ImageRightTextLeft = 'ImageRightTextLeft',
  NoImage = 'NoImage'
}

export type AccordionCreateInput = {
  accordionItems?: InputMaybe<AccordionItemCreateManyInlineInput>;
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  name: Scalars['String']['input'];
  navUrl?: InputMaybe<Scalars['String']['input']>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccordionCreateManyInlineInput = {
  /** Connect multiple existing Accordion documents */
  connect?: InputMaybe<Array<AccordionWhereUniqueInput>>;
  /** Create and connect multiple existing Accordion documents */
  create?: InputMaybe<Array<AccordionCreateInput>>;
};

export type AccordionCreateOneInlineInput = {
  /** Connect one existing Accordion document */
  connect?: InputMaybe<AccordionWhereUniqueInput>;
  /** Create and connect one Accordion document */
  create?: InputMaybe<AccordionCreateInput>;
};

/** An edge in a connection. */
export type AccordionEdge = {
  __typename?: 'AccordionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Accordion;
};

/** Accordion Item */
export type AccordionItem = Entity & Node & {
  __typename?: 'AccordionItem';
  accordion?: Maybe<Accordion>;
  /** Accordion item body content */
  body?: Maybe<AccordionItemBodyRichText>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<AccordionItem>;
  /** List of AccordionItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Accordion item title, which is clickable */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Accordion Item */
export type AccordionItemAccordionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Accordion Item */
export type AccordionItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Accordion Item */
export type AccordionItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Accordion Item */
export type AccordionItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Accordion Item */
export type AccordionItemMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Accordion Item */
export type AccordionItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Accordion Item */
export type AccordionItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Accordion Item */
export type AccordionItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AccordionItemBodyRichText = {
  __typename?: 'AccordionItemBodyRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<AccordionItemBodyRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type AccordionItemBodyRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type AccordionItemBodyRichTextEmbeddedTypes = Asset;

export type AccordionItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AccordionItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type AccordionItemConnection = {
  __typename?: 'AccordionItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AccordionItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AccordionItemCreateInput = {
  accordion?: InputMaybe<AccordionCreateOneInlineInput>;
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccordionItemCreateManyInlineInput = {
  /** Connect multiple existing AccordionItem documents */
  connect?: InputMaybe<Array<AccordionItemWhereUniqueInput>>;
  /** Create and connect multiple existing AccordionItem documents */
  create?: InputMaybe<Array<AccordionItemCreateInput>>;
};

export type AccordionItemCreateOneInlineInput = {
  /** Connect one existing AccordionItem document */
  connect?: InputMaybe<AccordionItemWhereUniqueInput>;
  /** Create and connect one AccordionItem document */
  create?: InputMaybe<AccordionItemCreateInput>;
};

/** An edge in a connection. */
export type AccordionItemEdge = {
  __typename?: 'AccordionItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AccordionItem;
};

/** Identifies documents */
export type AccordionItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordion?: InputMaybe<AccordionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AccordionItemWhereStageInput>;
  documentInStages_none?: InputMaybe<AccordionItemWhereStageInput>;
  documentInStages_some?: InputMaybe<AccordionItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AccordionItemOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AccordionItemUpdateInput = {
  accordion?: InputMaybe<AccordionUpdateOneInlineInput>;
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AccordionItemUpdateManyInlineInput = {
  /** Connect multiple existing AccordionItem documents */
  connect?: InputMaybe<Array<AccordionItemConnectInput>>;
  /** Create and connect multiple AccordionItem documents */
  create?: InputMaybe<Array<AccordionItemCreateInput>>;
  /** Delete multiple AccordionItem documents */
  delete?: InputMaybe<Array<AccordionItemWhereUniqueInput>>;
  /** Disconnect multiple AccordionItem documents */
  disconnect?: InputMaybe<Array<AccordionItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AccordionItem documents */
  set?: InputMaybe<Array<AccordionItemWhereUniqueInput>>;
  /** Update multiple AccordionItem documents */
  update?: InputMaybe<Array<AccordionItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AccordionItem documents */
  upsert?: InputMaybe<Array<AccordionItemUpsertWithNestedWhereUniqueInput>>;
};

export type AccordionItemUpdateManyInput = {
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AccordionItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AccordionItemUpdateManyInput;
  /** Document search */
  where: AccordionItemWhereInput;
};

export type AccordionItemUpdateOneInlineInput = {
  /** Connect existing AccordionItem document */
  connect?: InputMaybe<AccordionItemWhereUniqueInput>;
  /** Create and connect one AccordionItem document */
  create?: InputMaybe<AccordionItemCreateInput>;
  /** Delete currently connected AccordionItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AccordionItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AccordionItem document */
  update?: InputMaybe<AccordionItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AccordionItem document */
  upsert?: InputMaybe<AccordionItemUpsertWithNestedWhereUniqueInput>;
};

export type AccordionItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AccordionItemUpdateInput;
  /** Unique document search */
  where: AccordionItemWhereUniqueInput;
};

export type AccordionItemUpsertInput = {
  /** Create document if it didn't exist */
  create: AccordionItemCreateInput;
  /** Update document if it exists */
  update: AccordionItemUpdateInput;
};

export type AccordionItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AccordionItemUpsertInput;
  /** Unique document search */
  where: AccordionItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AccordionItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AccordionItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordion?: InputMaybe<AccordionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AccordionItemWhereStageInput>;
  documentInStages_none?: InputMaybe<AccordionItemWhereStageInput>;
  documentInStages_some?: InputMaybe<AccordionItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AccordionItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AccordionItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AccordionItem record uniquely */
export type AccordionItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type AccordionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordionItems_every?: InputMaybe<AccordionItemWhereInput>;
  accordionItems_none?: InputMaybe<AccordionItemWhereInput>;
  accordionItems_some?: InputMaybe<AccordionItemWhereInput>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  collapsed_not?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AccordionWhereStageInput>;
  documentInStages_none?: InputMaybe<AccordionWhereStageInput>;
  documentInStages_some?: InputMaybe<AccordionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  navUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  navUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  navUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  navUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  navUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  navUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  navUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  navUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  navUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  navUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  numbered_not?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AccordionOrderByInput {
  collapsed_ASC = 'collapsed_ASC',
  collapsed_DESC = 'collapsed_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  navUrl_ASC = 'navUrl_ASC',
  navUrl_DESC = 'navUrl_DESC',
  numbered_ASC = 'numbered_ASC',
  numbered_DESC = 'numbered_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AccordionUpdateInput = {
  accordionItems?: InputMaybe<AccordionItemUpdateManyInlineInput>;
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  navUrl?: InputMaybe<Scalars['String']['input']>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
};

export type AccordionUpdateManyInlineInput = {
  /** Connect multiple existing Accordion documents */
  connect?: InputMaybe<Array<AccordionConnectInput>>;
  /** Create and connect multiple Accordion documents */
  create?: InputMaybe<Array<AccordionCreateInput>>;
  /** Delete multiple Accordion documents */
  delete?: InputMaybe<Array<AccordionWhereUniqueInput>>;
  /** Disconnect multiple Accordion documents */
  disconnect?: InputMaybe<Array<AccordionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Accordion documents */
  set?: InputMaybe<Array<AccordionWhereUniqueInput>>;
  /** Update multiple Accordion documents */
  update?: InputMaybe<Array<AccordionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Accordion documents */
  upsert?: InputMaybe<Array<AccordionUpsertWithNestedWhereUniqueInput>>;
};

export type AccordionUpdateManyInput = {
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  navUrl?: InputMaybe<Scalars['String']['input']>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AccordionUpdateManyInput;
  /** Document search */
  where: AccordionWhereInput;
};

export type AccordionUpdateOneInlineInput = {
  /** Connect existing Accordion document */
  connect?: InputMaybe<AccordionWhereUniqueInput>;
  /** Create and connect one Accordion document */
  create?: InputMaybe<AccordionCreateInput>;
  /** Delete currently connected Accordion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Accordion document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Accordion document */
  update?: InputMaybe<AccordionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Accordion document */
  upsert?: InputMaybe<AccordionUpsertWithNestedWhereUniqueInput>;
};

export type AccordionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AccordionUpdateInput;
  /** Unique document search */
  where: AccordionWhereUniqueInput;
};

export type AccordionUpsertInput = {
  /** Create document if it didn't exist */
  create: AccordionCreateInput;
  /** Update document if it exists */
  update: AccordionUpdateInput;
};

export type AccordionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AccordionUpsertInput;
  /** Unique document search */
  where: AccordionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AccordionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AccordionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordionItems_every?: InputMaybe<AccordionItemWhereInput>;
  accordionItems_none?: InputMaybe<AccordionItemWhereInput>;
  accordionItems_some?: InputMaybe<AccordionItemWhereInput>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  collapsed_not?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AccordionWhereStageInput>;
  documentInStages_none?: InputMaybe<AccordionWhereStageInput>;
  documentInStages_some?: InputMaybe<AccordionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  navUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  navUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  navUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  navUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  navUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  navUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  navUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  navUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  navUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  navUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  numbered_not?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AccordionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AccordionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Accordion record uniquely */
export type AccordionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Aggregate = {
  __typename?: 'Aggregate';
  count: Scalars['Int']['output'];
};

export type AlgoliaExtension = Entity & Node & {
  __typename?: 'AlgoliaExtension';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<AlgoliaExtension>;
  environment: DbEnvironment;
  extension?: Maybe<Scalars['Json']['output']>;
  /** List of AlgoliaExtension versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** field to select the market to query */
  markets: Markets;
  products?: Maybe<Scalars['Json']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  tipsAndTricks?: Maybe<Scalars['Json']['output']>;
  /** This is only used internally and won't be shown on the site */
  title?: Maybe<Scalars['String']['output']>;
  /** Note: Top Rated can only be used in the Accordion component. Please do not use in other components. */
  topRated?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type AlgoliaExtensionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AlgoliaExtensionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type AlgoliaExtensionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type AlgoliaExtensionMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AlgoliaExtensionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AlgoliaExtensionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type AlgoliaExtensionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AlgoliaExtensionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AlgoliaExtensionWhereUniqueInput;
};

/** A connection to a list of items. */
export type AlgoliaExtensionConnection = {
  __typename?: 'AlgoliaExtensionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AlgoliaExtensionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AlgoliaExtensionCreateInput = {
  cksiw0ula2b4s01xl8e1i7zfj?: InputMaybe<GenericAccordionTopRatedCreateManyInlineInput>;
  cksn2f67511sp01y2e9hg1dqr?: InputMaybe<GenericCardCarouseComponentCreateManyInlineInput>;
  cksogvh9x1sgv01w9e5lhachb?: InputMaybe<DynamicCardGridCreateManyInlineInput>;
  cksot7ya42aaf01w98fc79roj?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  cleihrznf363201t69wer26it?: InputMaybe<TeaserCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  environment: DbEnvironment;
  extension?: InputMaybe<Scalars['Json']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  markets: Markets;
  products?: InputMaybe<Scalars['Json']['input']>;
  tipsAndTricks?: InputMaybe<Scalars['Json']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topRated?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AlgoliaExtensionCreateManyInlineInput = {
  /** Connect multiple existing AlgoliaExtension documents */
  connect?: InputMaybe<Array<AlgoliaExtensionWhereUniqueInput>>;
  /** Create and connect multiple existing AlgoliaExtension documents */
  create?: InputMaybe<Array<AlgoliaExtensionCreateInput>>;
};

export type AlgoliaExtensionCreateOneInlineInput = {
  /** Connect one existing AlgoliaExtension document */
  connect?: InputMaybe<AlgoliaExtensionWhereUniqueInput>;
  /** Create and connect one AlgoliaExtension document */
  create?: InputMaybe<AlgoliaExtensionCreateInput>;
};

/** An edge in a connection. */
export type AlgoliaExtensionEdge = {
  __typename?: 'AlgoliaExtensionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlgoliaExtension;
};

/** Identifies documents */
export type AlgoliaExtensionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AlgoliaExtensionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AlgoliaExtensionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AlgoliaExtensionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AlgoliaExtensionWhereStageInput>;
  documentInStages_none?: InputMaybe<AlgoliaExtensionWhereStageInput>;
  documentInStages_some?: InputMaybe<AlgoliaExtensionWhereStageInput>;
  environment?: InputMaybe<DbEnvironment>;
  /** All values that are contained in given list. */
  environment_in?: InputMaybe<Array<InputMaybe<DbEnvironment>>>;
  /** Any other value that exists and is not equal to the given value. */
  environment_not?: InputMaybe<DbEnvironment>;
  /** All values that are not contained in given list. */
  environment_not_in?: InputMaybe<Array<InputMaybe<DbEnvironment>>>;
  /** All values containing the given json path. */
  extension_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  extension_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  markets?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  markets_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  markets_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  markets_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** All values containing the given json path. */
  products_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  products_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values containing the given json path. */
  tipsAndTricks_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  tipsAndTricks_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  topRated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  topRated_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AlgoliaExtensionOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  environment_ASC = 'environment_ASC',
  environment_DESC = 'environment_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  markets_ASC = 'markets_ASC',
  markets_DESC = 'markets_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  topRated_ASC = 'topRated_ASC',
  topRated_DESC = 'topRated_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AlgoliaExtensionUpdateInput = {
  cksiw0ula2b4s01xl8e1i7zfj?: InputMaybe<GenericAccordionTopRatedUpdateManyInlineInput>;
  cksn2f67511sp01y2e9hg1dqr?: InputMaybe<GenericCardCarouseComponentUpdateManyInlineInput>;
  cksogvh9x1sgv01w9e5lhachb?: InputMaybe<DynamicCardGridUpdateManyInlineInput>;
  cksot7ya42aaf01w98fc79roj?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  cleihrznf363201t69wer26it?: InputMaybe<TeaserUpdateManyInlineInput>;
  environment?: InputMaybe<DbEnvironment>;
  extension?: InputMaybe<Scalars['Json']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  markets?: InputMaybe<Markets>;
  products?: InputMaybe<Scalars['Json']['input']>;
  tipsAndTricks?: InputMaybe<Scalars['Json']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topRated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AlgoliaExtensionUpdateManyInlineInput = {
  /** Connect multiple existing AlgoliaExtension documents */
  connect?: InputMaybe<Array<AlgoliaExtensionConnectInput>>;
  /** Create and connect multiple AlgoliaExtension documents */
  create?: InputMaybe<Array<AlgoliaExtensionCreateInput>>;
  /** Delete multiple AlgoliaExtension documents */
  delete?: InputMaybe<Array<AlgoliaExtensionWhereUniqueInput>>;
  /** Disconnect multiple AlgoliaExtension documents */
  disconnect?: InputMaybe<Array<AlgoliaExtensionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AlgoliaExtension documents */
  set?: InputMaybe<Array<AlgoliaExtensionWhereUniqueInput>>;
  /** Update multiple AlgoliaExtension documents */
  update?: InputMaybe<Array<AlgoliaExtensionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AlgoliaExtension documents */
  upsert?: InputMaybe<Array<AlgoliaExtensionUpsertWithNestedWhereUniqueInput>>;
};

export type AlgoliaExtensionUpdateManyInput = {
  environment?: InputMaybe<DbEnvironment>;
  extension?: InputMaybe<Scalars['Json']['input']>;
  market?: InputMaybe<Markets>;
  markets?: InputMaybe<Markets>;
  products?: InputMaybe<Scalars['Json']['input']>;
  tipsAndTricks?: InputMaybe<Scalars['Json']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topRated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AlgoliaExtensionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AlgoliaExtensionUpdateManyInput;
  /** Document search */
  where: AlgoliaExtensionWhereInput;
};

export type AlgoliaExtensionUpdateOneInlineInput = {
  /** Connect existing AlgoliaExtension document */
  connect?: InputMaybe<AlgoliaExtensionWhereUniqueInput>;
  /** Create and connect one AlgoliaExtension document */
  create?: InputMaybe<AlgoliaExtensionCreateInput>;
  /** Delete currently connected AlgoliaExtension document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AlgoliaExtension document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AlgoliaExtension document */
  update?: InputMaybe<AlgoliaExtensionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AlgoliaExtension document */
  upsert?: InputMaybe<AlgoliaExtensionUpsertWithNestedWhereUniqueInput>;
};

export type AlgoliaExtensionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AlgoliaExtensionUpdateInput;
  /** Unique document search */
  where: AlgoliaExtensionWhereUniqueInput;
};

export type AlgoliaExtensionUpsertInput = {
  /** Create document if it didn't exist */
  create: AlgoliaExtensionCreateInput;
  /** Update document if it exists */
  update: AlgoliaExtensionUpdateInput;
};

export type AlgoliaExtensionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AlgoliaExtensionUpsertInput;
  /** Unique document search */
  where: AlgoliaExtensionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AlgoliaExtensionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AlgoliaExtensionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AlgoliaExtensionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AlgoliaExtensionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AlgoliaExtensionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AlgoliaExtensionWhereStageInput>;
  documentInStages_none?: InputMaybe<AlgoliaExtensionWhereStageInput>;
  documentInStages_some?: InputMaybe<AlgoliaExtensionWhereStageInput>;
  environment?: InputMaybe<DbEnvironment>;
  /** All values that are contained in given list. */
  environment_in?: InputMaybe<Array<InputMaybe<DbEnvironment>>>;
  /** Any other value that exists and is not equal to the given value. */
  environment_not?: InputMaybe<DbEnvironment>;
  /** All values that are not contained in given list. */
  environment_not_in?: InputMaybe<Array<InputMaybe<DbEnvironment>>>;
  /** All values containing the given json path. */
  extension_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  extension_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  markets?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  markets_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  markets_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  markets_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** All values containing the given json path. */
  products_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  products_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values containing the given json path. */
  tipsAndTricks_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  tipsAndTricks_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  topRated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  topRated_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AlgoliaExtensionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AlgoliaExtensionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AlgoliaExtensionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AlgoliaExtensionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AlgoliaExtensionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AlgoliaExtension record uniquely */
export type AlgoliaExtensionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum AlignmentTypes {
  Center = 'Center',
  Left = 'Left',
  Right = 'Right'
}

/** this will be deprecated soon */
export type AnchorNav = Entity & Node & {
  __typename?: 'AnchorNav';
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<AnchorNav>;
  genericPages: Array<GenericPage>;
  /** List of AnchorNav versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  links: Array<Link>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** this will be deprecated soon */
export type AnchorNavCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** this will be deprecated soon */
export type AnchorNavDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** this will be deprecated soon */
export type AnchorNavGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** this will be deprecated soon */
export type AnchorNavHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** this will be deprecated soon */
export type AnchorNavLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


/** this will be deprecated soon */
export type AnchorNavMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** this will be deprecated soon */
export type AnchorNavPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** this will be deprecated soon */
export type AnchorNavScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** this will be deprecated soon */
export type AnchorNavUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AnchorNavConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AnchorNavWhereUniqueInput;
};

/** A connection to a list of items. */
export type AnchorNavConnection = {
  __typename?: 'AnchorNavConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AnchorNavEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AnchorNavCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  links?: InputMaybe<LinkCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnchorNavCreateManyInlineInput = {
  /** Connect multiple existing AnchorNav documents */
  connect?: InputMaybe<Array<AnchorNavWhereUniqueInput>>;
  /** Create and connect multiple existing AnchorNav documents */
  create?: InputMaybe<Array<AnchorNavCreateInput>>;
};

export type AnchorNavCreateOneInlineInput = {
  /** Connect one existing AnchorNav document */
  connect?: InputMaybe<AnchorNavWhereUniqueInput>;
  /** Create and connect one AnchorNav document */
  create?: InputMaybe<AnchorNavCreateInput>;
};

/** An edge in a connection. */
export type AnchorNavEdge = {
  __typename?: 'AnchorNavEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AnchorNav;
};

/** Identifies documents */
export type AnchorNavManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AnchorNavWhereStageInput>;
  documentInStages_none?: InputMaybe<AnchorNavWhereStageInput>;
  documentInStages_some?: InputMaybe<AnchorNavWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AnchorNavOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AnchorNavUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  links?: InputMaybe<LinkUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
};

export type AnchorNavUpdateManyInlineInput = {
  /** Connect multiple existing AnchorNav documents */
  connect?: InputMaybe<Array<AnchorNavConnectInput>>;
  /** Create and connect multiple AnchorNav documents */
  create?: InputMaybe<Array<AnchorNavCreateInput>>;
  /** Delete multiple AnchorNav documents */
  delete?: InputMaybe<Array<AnchorNavWhereUniqueInput>>;
  /** Disconnect multiple AnchorNav documents */
  disconnect?: InputMaybe<Array<AnchorNavWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AnchorNav documents */
  set?: InputMaybe<Array<AnchorNavWhereUniqueInput>>;
  /** Update multiple AnchorNav documents */
  update?: InputMaybe<Array<AnchorNavUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AnchorNav documents */
  upsert?: InputMaybe<Array<AnchorNavUpsertWithNestedWhereUniqueInput>>;
};

export type AnchorNavUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
};

export type AnchorNavUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AnchorNavUpdateManyInput;
  /** Document search */
  where: AnchorNavWhereInput;
};

export type AnchorNavUpdateOneInlineInput = {
  /** Connect existing AnchorNav document */
  connect?: InputMaybe<AnchorNavWhereUniqueInput>;
  /** Create and connect one AnchorNav document */
  create?: InputMaybe<AnchorNavCreateInput>;
  /** Delete currently connected AnchorNav document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AnchorNav document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AnchorNav document */
  update?: InputMaybe<AnchorNavUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AnchorNav document */
  upsert?: InputMaybe<AnchorNavUpsertWithNestedWhereUniqueInput>;
};

export type AnchorNavUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AnchorNavUpdateInput;
  /** Unique document search */
  where: AnchorNavWhereUniqueInput;
};

export type AnchorNavUpsertInput = {
  /** Create document if it didn't exist */
  create: AnchorNavCreateInput;
  /** Update document if it exists */
  update: AnchorNavUpdateInput;
};

export type AnchorNavUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AnchorNavUpsertInput;
  /** Unique document search */
  where: AnchorNavWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AnchorNavWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AnchorNavWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AnchorNavWhereStageInput>;
  documentInStages_none?: InputMaybe<AnchorNavWhereStageInput>;
  documentInStages_some?: InputMaybe<AnchorNavWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AnchorNavWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AnchorNavWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AnchorNav record uniquely */
export type AnchorNavWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** used to author anchor navigations for each page */
export type AnchorNavigation = Entity & Node & {
  __typename?: 'AnchorNavigation';
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** reference for authorable components */
  component: Array<NavLinkComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<AnchorNavigation>;
  /** select the external component displayed on this page (recipe/ tips and tricks etc) */
  externalComponent: Array<AnchorNavigationExternalComponents>;
  /** List of AnchorNavigation versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<AnchorNavigation>;
  market: Markets;
  marketName?: Maybe<Market>;
  navigationTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AnchorNavigationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AnchorNavigationWhereUniqueInput;
};

/** A connection to a list of items. */
export type AnchorNavigationConnection = {
  __typename?: 'AnchorNavigationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AnchorNavigationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AnchorNavigationCreateInput = {
  ckugul8wz9ryq01xh1lxag0vv?: InputMaybe<AnchorNavigationListCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  component?: InputMaybe<NavLinkComponentCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** externalComponent input for default locale (en) */
  externalComponent?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AnchorNavigationCreateLocalizationsInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  navigationTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnchorNavigationCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalComponent?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnchorNavigationCreateLocalizationInput = {
  /** Localization input */
  data: AnchorNavigationCreateLocalizationDataInput;
  locale: Locale;
};

export type AnchorNavigationCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AnchorNavigationCreateLocalizationInput>>;
};

export type AnchorNavigationCreateManyInlineInput = {
  /** Connect multiple existing AnchorNavigation documents */
  connect?: InputMaybe<Array<AnchorNavigationWhereUniqueInput>>;
  /** Create and connect multiple existing AnchorNavigation documents */
  create?: InputMaybe<Array<AnchorNavigationCreateInput>>;
};

export type AnchorNavigationCreateOneInlineInput = {
  /** Connect one existing AnchorNavigation document */
  connect?: InputMaybe<AnchorNavigationWhereUniqueInput>;
  /** Create and connect one AnchorNavigation document */
  create?: InputMaybe<AnchorNavigationCreateInput>;
};

/** An edge in a connection. */
export type AnchorNavigationEdge = {
  __typename?: 'AnchorNavigationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AnchorNavigation;
};

/** enumeration for componnets used in pages like recipes, tips and tricks, products, details pages */
export enum AnchorNavigationExternalComponents {
  ProductDetailPage_Footer = 'ProductDetailPage_Footer',
  ProductDetailPage_Hero_Banner = 'ProductDetailPage_Hero_Banner',
  ProductDetailPage_Recipe_Nutrition = 'ProductDetailPage_Recipe_Nutrition',
  ProductDetailPage_Related_Recipe = 'ProductDetailPage_Related_Recipe',
  ProductDetailPage_Social_Media = 'ProductDetailPage_Social_Media',
  ProductLandingPage_Category_Subcategory = 'ProductLandingPage_Category_Subcategory',
  ProductLandingPage_Footer = 'ProductLandingPage_Footer'
}

/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationList = Entity & Node & {
  __typename?: 'AnchorNavigationList';
  /** list of anchor navigation links */
  anchorNavigations: Array<AnchorNavigation>;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<AnchorNavigationList>;
  genericPages: Array<GenericPage>;
  /** List of AnchorNavigationList versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListAnchorNavigationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AnchorNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorNavigationWhereInput>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AnchorNavigationListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AnchorNavigationListWhereUniqueInput;
};

/** A connection to a list of items. */
export type AnchorNavigationListConnection = {
  __typename?: 'AnchorNavigationListConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AnchorNavigationListEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AnchorNavigationListCreateInput = {
  anchorNavigations?: InputMaybe<AnchorNavigationCreateManyInlineInput>;
  ckunnoqb44a6n01xp9zt7cqwj?: InputMaybe<TipsAndTricksDetailsPageCreateManyInlineInput>;
  ckuno0wca49hq01xqfgd374fm?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  ckw45enc40b7z01z89ob5bdaw?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnchorNavigationListCreateManyInlineInput = {
  /** Connect multiple existing AnchorNavigationList documents */
  connect?: InputMaybe<Array<AnchorNavigationListWhereUniqueInput>>;
  /** Create and connect multiple existing AnchorNavigationList documents */
  create?: InputMaybe<Array<AnchorNavigationListCreateInput>>;
};

export type AnchorNavigationListCreateOneInlineInput = {
  /** Connect one existing AnchorNavigationList document */
  connect?: InputMaybe<AnchorNavigationListWhereUniqueInput>;
  /** Create and connect one AnchorNavigationList document */
  create?: InputMaybe<AnchorNavigationListCreateInput>;
};

/** An edge in a connection. */
export type AnchorNavigationListEdge = {
  __typename?: 'AnchorNavigationListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AnchorNavigationList;
};

/** Identifies documents */
export type AnchorNavigationListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavigationListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavigationListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavigationListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNavigations_every?: InputMaybe<AnchorNavigationWhereInput>;
  anchorNavigations_none?: InputMaybe<AnchorNavigationWhereInput>;
  anchorNavigations_some?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AnchorNavigationListWhereStageInput>;
  documentInStages_none?: InputMaybe<AnchorNavigationListWhereStageInput>;
  documentInStages_some?: InputMaybe<AnchorNavigationListWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AnchorNavigationListOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AnchorNavigationListUpdateInput = {
  anchorNavigations?: InputMaybe<AnchorNavigationUpdateManyInlineInput>;
  ckunnoqb44a6n01xp9zt7cqwj?: InputMaybe<TipsAndTricksDetailsPageUpdateManyInlineInput>;
  ckuno0wca49hq01xqfgd374fm?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  ckw45enc40b7z01z89ob5bdaw?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
};

export type AnchorNavigationListUpdateManyInlineInput = {
  /** Connect multiple existing AnchorNavigationList documents */
  connect?: InputMaybe<Array<AnchorNavigationListConnectInput>>;
  /** Create and connect multiple AnchorNavigationList documents */
  create?: InputMaybe<Array<AnchorNavigationListCreateInput>>;
  /** Delete multiple AnchorNavigationList documents */
  delete?: InputMaybe<Array<AnchorNavigationListWhereUniqueInput>>;
  /** Disconnect multiple AnchorNavigationList documents */
  disconnect?: InputMaybe<Array<AnchorNavigationListWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AnchorNavigationList documents */
  set?: InputMaybe<Array<AnchorNavigationListWhereUniqueInput>>;
  /** Update multiple AnchorNavigationList documents */
  update?: InputMaybe<Array<AnchorNavigationListUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AnchorNavigationList documents */
  upsert?: InputMaybe<Array<AnchorNavigationListUpsertWithNestedWhereUniqueInput>>;
};

export type AnchorNavigationListUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
};

export type AnchorNavigationListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AnchorNavigationListUpdateManyInput;
  /** Document search */
  where: AnchorNavigationListWhereInput;
};

export type AnchorNavigationListUpdateOneInlineInput = {
  /** Connect existing AnchorNavigationList document */
  connect?: InputMaybe<AnchorNavigationListWhereUniqueInput>;
  /** Create and connect one AnchorNavigationList document */
  create?: InputMaybe<AnchorNavigationListCreateInput>;
  /** Delete currently connected AnchorNavigationList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AnchorNavigationList document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AnchorNavigationList document */
  update?: InputMaybe<AnchorNavigationListUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AnchorNavigationList document */
  upsert?: InputMaybe<AnchorNavigationListUpsertWithNestedWhereUniqueInput>;
};

export type AnchorNavigationListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AnchorNavigationListUpdateInput;
  /** Unique document search */
  where: AnchorNavigationListWhereUniqueInput;
};

export type AnchorNavigationListUpsertInput = {
  /** Create document if it didn't exist */
  create: AnchorNavigationListCreateInput;
  /** Update document if it exists */
  update: AnchorNavigationListUpdateInput;
};

export type AnchorNavigationListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AnchorNavigationListUpsertInput;
  /** Unique document search */
  where: AnchorNavigationListWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AnchorNavigationListWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AnchorNavigationListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavigationListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavigationListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavigationListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNavigations_every?: InputMaybe<AnchorNavigationWhereInput>;
  anchorNavigations_none?: InputMaybe<AnchorNavigationWhereInput>;
  anchorNavigations_some?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AnchorNavigationListWhereStageInput>;
  documentInStages_none?: InputMaybe<AnchorNavigationListWhereStageInput>;
  documentInStages_some?: InputMaybe<AnchorNavigationListWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AnchorNavigationListWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavigationListWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavigationListWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavigationListWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AnchorNavigationListWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AnchorNavigationList record uniquely */
export type AnchorNavigationListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type AnchorNavigationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  component_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  component_some?: InputMaybe<NavLinkComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AnchorNavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<AnchorNavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<AnchorNavigationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  navigationTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  navigationTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  navigationTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  navigationTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  navigationTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  navigationTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  navigationTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  navigationTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  navigationTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  navigationTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AnchorNavigationOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  externalComponent_ASC = 'externalComponent_ASC',
  externalComponent_DESC = 'externalComponent_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  navigationTitle_ASC = 'navigationTitle_ASC',
  navigationTitle_DESC = 'navigationTitle_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AnchorNavigationUpdateInput = {
  ckugul8wz9ryq01xh1lxag0vv?: InputMaybe<AnchorNavigationListUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  component?: InputMaybe<NavLinkComponentUpdateManyInlineInput>;
  /** externalComponent input for default locale (en) */
  externalComponent?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  /** Manage document localizations */
  localizations?: InputMaybe<AnchorNavigationUpdateLocalizationsInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  navigationTitle?: InputMaybe<Scalars['String']['input']>;
};

export type AnchorNavigationUpdateLocalizationDataInput = {
  externalComponent?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
};

export type AnchorNavigationUpdateLocalizationInput = {
  data: AnchorNavigationUpdateLocalizationDataInput;
  locale: Locale;
};

export type AnchorNavigationUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AnchorNavigationCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AnchorNavigationUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AnchorNavigationUpsertLocalizationInput>>;
};

export type AnchorNavigationUpdateManyInlineInput = {
  /** Connect multiple existing AnchorNavigation documents */
  connect?: InputMaybe<Array<AnchorNavigationConnectInput>>;
  /** Create and connect multiple AnchorNavigation documents */
  create?: InputMaybe<Array<AnchorNavigationCreateInput>>;
  /** Delete multiple AnchorNavigation documents */
  delete?: InputMaybe<Array<AnchorNavigationWhereUniqueInput>>;
  /** Disconnect multiple AnchorNavigation documents */
  disconnect?: InputMaybe<Array<AnchorNavigationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AnchorNavigation documents */
  set?: InputMaybe<Array<AnchorNavigationWhereUniqueInput>>;
  /** Update multiple AnchorNavigation documents */
  update?: InputMaybe<Array<AnchorNavigationUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AnchorNavigation documents */
  upsert?: InputMaybe<Array<AnchorNavigationUpsertWithNestedWhereUniqueInput>>;
};

export type AnchorNavigationUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** externalComponent input for default locale (en) */
  externalComponent?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<AnchorNavigationUpdateManyLocalizationsInput>;
  market?: InputMaybe<Markets>;
  navigationTitle?: InputMaybe<Scalars['String']['input']>;
};

export type AnchorNavigationUpdateManyLocalizationDataInput = {
  externalComponent?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
};

export type AnchorNavigationUpdateManyLocalizationInput = {
  data: AnchorNavigationUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type AnchorNavigationUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<AnchorNavigationUpdateManyLocalizationInput>>;
};

export type AnchorNavigationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AnchorNavigationUpdateManyInput;
  /** Document search */
  where: AnchorNavigationWhereInput;
};

export type AnchorNavigationUpdateOneInlineInput = {
  /** Connect existing AnchorNavigation document */
  connect?: InputMaybe<AnchorNavigationWhereUniqueInput>;
  /** Create and connect one AnchorNavigation document */
  create?: InputMaybe<AnchorNavigationCreateInput>;
  /** Delete currently connected AnchorNavigation document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AnchorNavigation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AnchorNavigation document */
  update?: InputMaybe<AnchorNavigationUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AnchorNavigation document */
  upsert?: InputMaybe<AnchorNavigationUpsertWithNestedWhereUniqueInput>;
};

export type AnchorNavigationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AnchorNavigationUpdateInput;
  /** Unique document search */
  where: AnchorNavigationWhereUniqueInput;
};

export type AnchorNavigationUpsertInput = {
  /** Create document if it didn't exist */
  create: AnchorNavigationCreateInput;
  /** Update document if it exists */
  update: AnchorNavigationUpdateInput;
};

export type AnchorNavigationUpsertLocalizationInput = {
  create: AnchorNavigationCreateLocalizationDataInput;
  locale: Locale;
  update: AnchorNavigationUpdateLocalizationDataInput;
};

export type AnchorNavigationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AnchorNavigationUpsertInput;
  /** Unique document search */
  where: AnchorNavigationWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AnchorNavigationWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AnchorNavigationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  component_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  component_some?: InputMaybe<NavLinkComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AnchorNavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<AnchorNavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<AnchorNavigationWhereStageInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  externalComponent?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  /** Matches if the field array contains *all* items provided to the filter */
  externalComponent_contains_all?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  externalComponent_contains_none?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  /** Matches if the field array contains at least one item provided to the filter */
  externalComponent_contains_some?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  externalComponent_not?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  navigationTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  navigationTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  navigationTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  navigationTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  navigationTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  navigationTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  navigationTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  navigationTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  navigationTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  navigationTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AnchorNavigationWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavigationWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavigationWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavigationWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AnchorNavigationWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AnchorNavigation record uniquely */
export type AnchorNavigationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Asset system model */
export type Asset = Entity & Node & {
  __typename?: 'Asset';
  /** Please add an alt text for any asset being uploaded */
  altText?: Maybe<Scalars['String']['output']>;
  appleTouchIconGlobalMetaData: Array<GlobalMetaData>;
  /** Please dont upload any asset bigger than 3mb. This is for site performance reasons. */
  assetAssetComponent: Array<AssetComponent>;
  audioFileAudioComponent: Array<AudioComponent>;
  backgroundImgCarouselComponent: Array<CarouselComponent>;
  backgroundIngredientImageProductCategoryPage: Array<ProductCategoryPage>;
  backgroundRating: Array<Rating>;
  bannerImageHeroBanner: Array<HeroBanner>;
  bannerImageHeroBannerMasterbrand: Array<HeroBannerMasterbrand>;
  bottomLeftAssetCarouselComponent: Array<CarouselComponent>;
  bottomLeftImageAssetHeroComponent: Array<HeroComponent>;
  /** Optional caption for asset */
  caption?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Asset>;
  downloadableFileGenericDownloadComponent: Array<GenericDownloadComponent>;
  faviconGlobalMetaData: Array<GlobalMetaData>;
  /** The file name */
  fileName: Scalars['String']['output'];
  filePromotionDownload: Array<PromotionDownload>;
  forAllRecipePagesSubCategoryKeyImage: Array<SubCategoryKeyImage>;
  forRecipeCategoryPageSubCategoryKeyImage: Array<SubCategoryKeyImage>;
  foregroundIngredientImageProductCategoryPage: Array<ProductCategoryPage>;
  /** The file handle */
  handle: Scalars['String']['output'];
  /** The height of the file */
  height?: Maybe<Scalars['Float']['output']>;
  /** List of Asset versions */
  history: Array<Version>;
  iconLeftFormSelectOption: Array<FormSelectOption>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  imageGlobalMetaData: Array<GlobalMetaData>;
  imagesMetaData: Array<MetaData>;
  keyImageProductCategoryPage: Array<ProductCategoryPage>;
  lifestyleImageProduct: Array<Product>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Asset>;
  logoGlobalMetaData: Array<GlobalMetaData>;
  lowerLeftCornerForm: Array<Form>;
  lowerRightCornerSpicesRating: Array<Rating>;
  /** The mime type of the file */
  mimeType?: Maybe<Scalars['String']['output']>;
  mobileImageHeroBanner: Array<HeroBanner>;
  mobileImageHeroBannerMasterbrand: Array<HeroBannerMasterbrand>;
  mobileImageHeroComponent: Array<HeroComponent>;
  productImageProduct: Array<Product>;
  promoImageProductCategoryPage: Array<ProductCategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** The file size */
  size?: Maybe<Scalars['Float']['output']>;
  slideAssetCarouselSlide: Array<CarouselSlide>;
  /** System stage field */
  stage: Stage;
  topRightAssetCarouselComponent: Array<CarouselComponent>;
  topRightImageAssetHeroComponent: Array<HeroComponent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Returns information you need to upload the asset. The type of upload is dependant on what you pass into asset creations as upload type. */
  upload?: Maybe<AssetUpload>;
  upperRightCornerForm: Array<Form>;
  upperRightCornerImageRating: Array<Rating>;
  /** Get the url for the asset with provided transformations applied. */
  url: Scalars['String']['output'];
  videoFallbackHeroLoopAnimationComponent: Array<HeroLoopAnimationComponent>;
  videoHeroLoopAnimationComponent: Array<HeroLoopAnimationComponent>;
  /** The file width */
  width?: Maybe<Scalars['Float']['output']>;
};


/** Asset system model */
export type AssetAppleTouchIconGlobalMetaDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GlobalMetaDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GlobalMetaDataWhereInput>;
};


/** Asset system model */
export type AssetAssetAssetComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentWhereInput>;
};


/** Asset system model */
export type AssetAudioFileAudioComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AudioComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AudioComponentWhereInput>;
};


/** Asset system model */
export type AssetBackgroundImgCarouselComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselComponentWhereInput>;
};


/** Asset system model */
export type AssetBackgroundIngredientImageProductCategoryPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


/** Asset system model */
export type AssetBackgroundRatingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RatingOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RatingWhereInput>;
};


/** Asset system model */
export type AssetBannerImageHeroBannerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroBannerWhereInput>;
};


/** Asset system model */
export type AssetBannerImageHeroBannerMasterbrandArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroBannerMasterbrandOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroBannerMasterbrandWhereInput>;
};


/** Asset system model */
export type AssetBottomLeftAssetCarouselComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselComponentWhereInput>;
};


/** Asset system model */
export type AssetBottomLeftImageAssetHeroComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroComponentWhereInput>;
};


/** Asset system model */
export type AssetCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Asset system model */
export type AssetDownloadableFileGenericDownloadComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericDownloadComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericDownloadComponentWhereInput>;
};


/** Asset system model */
export type AssetFaviconGlobalMetaDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GlobalMetaDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GlobalMetaDataWhereInput>;
};


/** Asset system model */
export type AssetFilePromotionDownloadArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PromotionDownloadOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PromotionDownloadWhereInput>;
};


/** Asset system model */
export type AssetForAllRecipePagesSubCategoryKeyImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SubCategoryKeyImageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubCategoryKeyImageWhereInput>;
};


/** Asset system model */
export type AssetForRecipeCategoryPageSubCategoryKeyImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SubCategoryKeyImageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubCategoryKeyImageWhereInput>;
};


/** Asset system model */
export type AssetForegroundIngredientImageProductCategoryPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


/** Asset system model */
export type AssetHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Asset system model */
export type AssetIconLeftFormSelectOptionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormSelectOptionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSelectOptionWhereInput>;
};


/** Asset system model */
export type AssetImageGlobalMetaDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GlobalMetaDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GlobalMetaDataWhereInput>;
};


/** Asset system model */
export type AssetImagesMetaDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<MetaDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetaDataWhereInput>;
};


/** Asset system model */
export type AssetKeyImageProductCategoryPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


/** Asset system model */
export type AssetLifestyleImageProductArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductWhereInput>;
};


/** Asset system model */
export type AssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Asset system model */
export type AssetLogoGlobalMetaDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GlobalMetaDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GlobalMetaDataWhereInput>;
};


/** Asset system model */
export type AssetLowerLeftCornerFormArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


/** Asset system model */
export type AssetLowerRightCornerSpicesRatingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RatingOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RatingWhereInput>;
};


/** Asset system model */
export type AssetMobileImageHeroBannerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroBannerWhereInput>;
};


/** Asset system model */
export type AssetMobileImageHeroBannerMasterbrandArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroBannerMasterbrandOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroBannerMasterbrandWhereInput>;
};


/** Asset system model */
export type AssetMobileImageHeroComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroComponentWhereInput>;
};


/** Asset system model */
export type AssetProductImageProductArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductWhereInput>;
};


/** Asset system model */
export type AssetPromoImageProductCategoryPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


/** Asset system model */
export type AssetPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Asset system model */
export type AssetSlideAssetCarouselSlideArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CarouselSlideOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselSlideWhereInput>;
};


/** Asset system model */
export type AssetTopRightAssetCarouselComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselComponentWhereInput>;
};


/** Asset system model */
export type AssetTopRightImageAssetHeroComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroComponentWhereInput>;
};


/** Asset system model */
export type AssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetUpperRightCornerFormArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


/** Asset system model */
export type AssetUpperRightCornerImageRatingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RatingOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RatingWhereInput>;
};


/** Asset system model */
export type AssetUrlArgs = {
  transformation?: InputMaybe<AssetTransformationInput>;
};


/** Asset system model */
export type AssetVideoFallbackHeroLoopAnimationComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroLoopAnimationComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroLoopAnimationComponentWhereInput>;
};


/** Asset system model */
export type AssetVideoHeroLoopAnimationComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroLoopAnimationComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroLoopAnimationComponentWhereInput>;
};

/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponent = Entity & Node & {
  __typename?: 'AssetComponent';
  appStore?: Maybe<DownloadApp>;
  /** Asset to be used on the Oetker platform */
  asset: Array<Asset>;
  audioComponents: Array<AudioComponent>;
  cardComponents: Array<CardComponent>;
  /** Title to be used to identify the image */
  cmsAssetTitle?: Maybe<Scalars['String']['output']>;
  countrySelectorItem?: Maybe<CountrySelectorItem>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<AssetComponent>;
  genericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  genericCardLayoutComponents: Array<GenericCardCarouseComponent>;
  heroComponent?: Maybe<HeroComponent>;
  /** List of AssetComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  imageAndTextCard?: Maybe<ImageAndTextCard>;
  imageCopy?: Maybe<ImageCopy>;
  imageCopyBottom?: Maybe<ImageCopy>;
  imageCopyItem?: Maybe<ImageCopyItem>;
  imageCopyItems: Array<ImageCopyItem>;
  leftColumn?: Maybe<LeftColumn>;
  market: Markets;
  marketName?: Maybe<Market>;
  mobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  navigation?: Maybe<Navigation>;
  playStore?: Maybe<DownloadApp>;
  productBannerBackground: Array<ProductBanner>;
  productBannerTool: Array<ProductBanner>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipe?: Maybe<Recipe>;
  rightColumn?: Maybe<RightColumn>;
  scheduledIn: Array<ScheduledOperation>;
  socialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentAppStoreArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentAssetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentAudioComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AudioComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AudioComponentWhereInput>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentCardComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardComponentWhereInput>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentCountrySelectorItemArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentGenericCardCarouseComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentGenericCardLayoutComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericCardCarouseComponentWhereInput>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentHeroComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentImageAndTextCardArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentImageCopyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentImageCopyBottomArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentImageCopyItemArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentImageCopyItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageCopyItemWhereInput>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentLeftColumnArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentMobileOnlyMainNavigationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentNavigationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentPlayStoreArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentProductBannerBackgroundArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductBannerWhereInput>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentProductBannerToolArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductBannerWhereInput>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentRecipeArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentRightColumnArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentSocialMediaListComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AssetComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AssetComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type AssetComponentConnection = {
  __typename?: 'AssetComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AssetComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AssetComponentCreateInput = {
  appStore?: InputMaybe<DownloadAppCreateOneInlineInput>;
  asset?: InputMaybe<AssetCreateManyInlineInput>;
  audioComponents?: InputMaybe<AudioComponentCreateManyInlineInput>;
  cardComponents?: InputMaybe<CardComponentCreateManyInlineInput>;
  ckrk9huql1fdt01xn9qu6dc45?: InputMaybe<GridColumnComponentCreateManyInlineInput>;
  ckrovksh302bv01xtfgtlcaa8?: InputMaybe<CategoryCardCreateManyInlineInput>;
  ckruap8rn1vif01xzbdup9cjd?: InputMaybe<Banner1CreateManyInlineInput>;
  ckruaq9j01vjq01xz3eykb02p?: InputMaybe<Banner1CreateManyInlineInput>;
  ckruar0081u0i01xh9yyi4oip?: InputMaybe<Banner1CreateManyInlineInput>;
  ckrunvowk07md01zbfwtsdkco?: InputMaybe<GenericAccordionItemCreateManyInlineInput>;
  ckryx0unj25j501yydmyqb278?: InputMaybe<GenericFollowUsCreateManyInlineInput>;
  ckryx4ls4284h01xveanyfmjz?: InputMaybe<GenericFollowUsCreateManyInlineInput>;
  ckryx64l0286b01xv5y4l9bcp?: InputMaybe<GenericFollowUsCreateManyInlineInput>;
  cks9cwg6f1yqi01wc184refe7?: InputMaybe<Banner2CreateManyInlineInput>;
  cks9v9aou297q01xp179b589s?: InputMaybe<AuthorableContentCardCreateManyInlineInput>;
  cksu3bhyb5ogg01w9589ueomo?: InputMaybe<SustainabilityBannerCreateManyInlineInput>;
  cksu3dg725tgn01yuc2537ro4?: InputMaybe<SustainabilityBannerCreateManyInlineInput>;
  ckt3cnpy0049m01yz1kivcfvi?: InputMaybe<Banner2CreateManyInlineInput>;
  ckt4a2fgv0jvr01xq8dmdgy1g?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  ckta6vdrf3zrf01xq76wdcwyo?: InputMaybe<ExampleComponentCreateManyInlineInput>;
  cktbfexu30k9e01z7ap94gdj9?: InputMaybe<ProductHeroCreateManyInlineInput>;
  cktbfgbjk0kaj01z70rvyek7d?: InputMaybe<ProductHeroCreateManyInlineInput>;
  cktcqvnpx1irc01xq9zfwdw38?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  cktcqx52s1jvg01z7hk7e0k6f?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  cktd3e5au1ykk01xk7udubvkf?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  cktieas6n4ila01xqdnvjczed?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  cktink5wy4rfb01xq1xafbyl8?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  cktlgzjsv10zs01xxfskybyp2?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  cktv4dykm0wrp01xz8xswed7w?: InputMaybe<GenericDownloadComponentCreateManyInlineInput>;
  cku3q4xpx6imm01xmgn9nb3zh?: InputMaybe<PopularSearchComponentCreateManyInlineInput>;
  ckuo0nett4rb301z65vyo3xf0?: InputMaybe<SustainabilityInfoCreateManyInlineInput>;
  ckuo0ounf4qr201xpe0y3gyrs?: InputMaybe<SustainabilityInfoCreateManyInlineInput>;
  ckuo0qk6m4rhq01z63gqz7fqq?: InputMaybe<SustainabilityInfoCreateManyInlineInput>;
  ckuo0s22f4qz001xp76kqge4s?: InputMaybe<SustainabilityInfoCreateManyInlineInput>;
  ckur7zoix02px01z70vesb5de?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  ckv8dgzhw631501xvaoz199u7?: InputMaybe<ProductBannerCreateManyInlineInput>;
  ckw4og3g90qgf01xk9lrqbczl?: InputMaybe<ErrorPageCreateManyInlineInput>;
  ckykdbd8700bs01xs88q2d79l?: InputMaybe<GridColumnCreateManyInlineInput>;
  cl8t1g5os495v01t8chfvbr1d?: InputMaybe<QuestionCreateManyInlineInput>;
  clc9j5wud1y3v01uo5d1v8vnh?: InputMaybe<GlobalSearchCreateManyInlineInput>;
  clc9jbv711wyf01umggtyfr9t?: InputMaybe<GlobalSearchCreateManyInlineInput>;
  clc9jxzm41t3w01ulashiery9?: InputMaybe<GlobalSearchCreateManyInlineInput>;
  clc9jysd51w9d01uh7p1a26ta?: InputMaybe<GlobalSearchCreateManyInlineInput>;
  cleiho3xq352501uhc3fg7qns?: InputMaybe<TeaserCreateManyInlineInput>;
  clesnhk4r2dfc01t93radc5p7?: InputMaybe<PageFooterCreateManyInlineInput>;
  clf9n1ggl12x001uea0mz7sf6?: InputMaybe<FooterSealCreateManyInlineInput>;
  clfv5tehy4evu01ui5n9k3gne?: InputMaybe<GenericPageCreateManyInlineInput>;
  cmsAssetTitle?: InputMaybe<Scalars['String']['input']>;
  countrySelectorItem?: InputMaybe<CountrySelectorItemCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateOneInlineInput>;
  genericCardLayoutComponents?: InputMaybe<GenericCardCarouseComponentCreateManyInlineInput>;
  heroComponent?: InputMaybe<HeroComponentCreateOneInlineInput>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardCreateOneInlineInput>;
  imageCopy?: InputMaybe<ImageCopyCreateOneInlineInput>;
  imageCopyBottom?: InputMaybe<ImageCopyCreateOneInlineInput>;
  imageCopyItem?: InputMaybe<ImageCopyItemCreateOneInlineInput>;
  imageCopyItems?: InputMaybe<ImageCopyItemCreateManyInlineInput>;
  leftColumn?: InputMaybe<LeftColumnCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  mobileOnlyMainNavigation?: InputMaybe<MobileOnlyMainNavigationCreateOneInlineInput>;
  navigation?: InputMaybe<NavigationCreateOneInlineInput>;
  playStore?: InputMaybe<DownloadAppCreateOneInlineInput>;
  productBannerBackground?: InputMaybe<ProductBannerCreateManyInlineInput>;
  productBannerTool?: InputMaybe<ProductBannerCreateManyInlineInput>;
  recipe?: InputMaybe<RecipeCreateOneInlineInput>;
  rightColumn?: InputMaybe<RightColumnCreateOneInlineInput>;
  socialMediaListComponent?: InputMaybe<SocialMediaListComponentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssetComponentCreateManyInlineInput = {
  /** Connect multiple existing AssetComponent documents */
  connect?: InputMaybe<Array<AssetComponentWhereUniqueInput>>;
  /** Create and connect multiple existing AssetComponent documents */
  create?: InputMaybe<Array<AssetComponentCreateInput>>;
};

export type AssetComponentCreateOneInlineInput = {
  /** Connect one existing AssetComponent document */
  connect?: InputMaybe<AssetComponentWhereUniqueInput>;
  /** Create and connect one AssetComponent document */
  create?: InputMaybe<AssetComponentCreateInput>;
};

/** An edge in a connection. */
export type AssetComponentEdge = {
  __typename?: 'AssetComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AssetComponent;
};

/** Identifies documents */
export type AssetComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  appStore?: InputMaybe<DownloadAppWhereInput>;
  asset_every?: InputMaybe<AssetWhereInput>;
  asset_none?: InputMaybe<AssetWhereInput>;
  asset_some?: InputMaybe<AssetWhereInput>;
  audioComponents_every?: InputMaybe<AudioComponentWhereInput>;
  audioComponents_none?: InputMaybe<AudioComponentWhereInput>;
  audioComponents_some?: InputMaybe<AudioComponentWhereInput>;
  cardComponents_every?: InputMaybe<CardComponentWhereInput>;
  cardComponents_none?: InputMaybe<CardComponentWhereInput>;
  cardComponents_some?: InputMaybe<CardComponentWhereInput>;
  cmsAssetTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsAssetTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsAssetTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsAssetTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsAssetTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsAssetTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsAssetTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsAssetTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsAssetTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsAssetTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  countrySelectorItem?: InputMaybe<CountrySelectorItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetComponentWhereStageInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericCardLayoutComponents_every?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericCardLayoutComponents_none?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericCardLayoutComponents_some?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  heroComponent?: InputMaybe<HeroComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardWhereInput>;
  imageCopy?: InputMaybe<ImageCopyWhereInput>;
  imageCopyBottom?: InputMaybe<ImageCopyWhereInput>;
  imageCopyItem?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopyItems_every?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopyItems_none?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopyItems_some?: InputMaybe<ImageCopyItemWhereInput>;
  leftColumn?: InputMaybe<LeftColumnWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  mobileOnlyMainNavigation?: InputMaybe<MobileOnlyMainNavigationWhereInput>;
  navigation?: InputMaybe<NavigationWhereInput>;
  playStore?: InputMaybe<DownloadAppWhereInput>;
  productBannerBackground_every?: InputMaybe<ProductBannerWhereInput>;
  productBannerBackground_none?: InputMaybe<ProductBannerWhereInput>;
  productBannerBackground_some?: InputMaybe<ProductBannerWhereInput>;
  productBannerTool_every?: InputMaybe<ProductBannerWhereInput>;
  productBannerTool_none?: InputMaybe<ProductBannerWhereInput>;
  productBannerTool_some?: InputMaybe<ProductBannerWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipe?: InputMaybe<RecipeWhereInput>;
  rightColumn?: InputMaybe<RightColumnWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  socialMediaListComponent?: InputMaybe<SocialMediaListComponentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AssetComponentOrderByInput {
  cmsAssetTitle_ASC = 'cmsAssetTitle_ASC',
  cmsAssetTitle_DESC = 'cmsAssetTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AssetComponentUpdateInput = {
  appStore?: InputMaybe<DownloadAppUpdateOneInlineInput>;
  asset?: InputMaybe<AssetUpdateManyInlineInput>;
  audioComponents?: InputMaybe<AudioComponentUpdateManyInlineInput>;
  cardComponents?: InputMaybe<CardComponentUpdateManyInlineInput>;
  ckrk9huql1fdt01xn9qu6dc45?: InputMaybe<GridColumnComponentUpdateManyInlineInput>;
  ckrovksh302bv01xtfgtlcaa8?: InputMaybe<CategoryCardUpdateManyInlineInput>;
  ckruap8rn1vif01xzbdup9cjd?: InputMaybe<Banner1UpdateManyInlineInput>;
  ckruaq9j01vjq01xz3eykb02p?: InputMaybe<Banner1UpdateManyInlineInput>;
  ckruar0081u0i01xh9yyi4oip?: InputMaybe<Banner1UpdateManyInlineInput>;
  ckrunvowk07md01zbfwtsdkco?: InputMaybe<GenericAccordionItemUpdateManyInlineInput>;
  ckryx0unj25j501yydmyqb278?: InputMaybe<GenericFollowUsUpdateManyInlineInput>;
  ckryx4ls4284h01xveanyfmjz?: InputMaybe<GenericFollowUsUpdateManyInlineInput>;
  ckryx64l0286b01xv5y4l9bcp?: InputMaybe<GenericFollowUsUpdateManyInlineInput>;
  cks9cwg6f1yqi01wc184refe7?: InputMaybe<Banner2UpdateManyInlineInput>;
  cks9v9aou297q01xp179b589s?: InputMaybe<AuthorableContentCardUpdateManyInlineInput>;
  cksu3bhyb5ogg01w9589ueomo?: InputMaybe<SustainabilityBannerUpdateManyInlineInput>;
  cksu3dg725tgn01yuc2537ro4?: InputMaybe<SustainabilityBannerUpdateManyInlineInput>;
  ckt3cnpy0049m01yz1kivcfvi?: InputMaybe<Banner2UpdateManyInlineInput>;
  ckt4a2fgv0jvr01xq8dmdgy1g?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  ckta6vdrf3zrf01xq76wdcwyo?: InputMaybe<ExampleComponentUpdateManyInlineInput>;
  cktbfexu30k9e01z7ap94gdj9?: InputMaybe<ProductHeroUpdateManyInlineInput>;
  cktbfgbjk0kaj01z70rvyek7d?: InputMaybe<ProductHeroUpdateManyInlineInput>;
  cktcqvnpx1irc01xq9zfwdw38?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  cktcqx52s1jvg01z7hk7e0k6f?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  cktd3e5au1ykk01xk7udubvkf?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  cktieas6n4ila01xqdnvjczed?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  cktink5wy4rfb01xq1xafbyl8?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  cktlgzjsv10zs01xxfskybyp2?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  cktv4dykm0wrp01xz8xswed7w?: InputMaybe<GenericDownloadComponentUpdateManyInlineInput>;
  cku3q4xpx6imm01xmgn9nb3zh?: InputMaybe<PopularSearchComponentUpdateManyInlineInput>;
  ckuo0nett4rb301z65vyo3xf0?: InputMaybe<SustainabilityInfoUpdateManyInlineInput>;
  ckuo0ounf4qr201xpe0y3gyrs?: InputMaybe<SustainabilityInfoUpdateManyInlineInput>;
  ckuo0qk6m4rhq01z63gqz7fqq?: InputMaybe<SustainabilityInfoUpdateManyInlineInput>;
  ckuo0s22f4qz001xp76kqge4s?: InputMaybe<SustainabilityInfoUpdateManyInlineInput>;
  ckur7zoix02px01z70vesb5de?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  ckv8dgzhw631501xvaoz199u7?: InputMaybe<ProductBannerUpdateManyInlineInput>;
  ckw4og3g90qgf01xk9lrqbczl?: InputMaybe<ErrorPageUpdateManyInlineInput>;
  ckykdbd8700bs01xs88q2d79l?: InputMaybe<GridColumnUpdateManyInlineInput>;
  cl8t1g5os495v01t8chfvbr1d?: InputMaybe<QuestionUpdateManyInlineInput>;
  clc9j5wud1y3v01uo5d1v8vnh?: InputMaybe<GlobalSearchUpdateManyInlineInput>;
  clc9jbv711wyf01umggtyfr9t?: InputMaybe<GlobalSearchUpdateManyInlineInput>;
  clc9jxzm41t3w01ulashiery9?: InputMaybe<GlobalSearchUpdateManyInlineInput>;
  clc9jysd51w9d01uh7p1a26ta?: InputMaybe<GlobalSearchUpdateManyInlineInput>;
  cleiho3xq352501uhc3fg7qns?: InputMaybe<TeaserUpdateManyInlineInput>;
  clesnhk4r2dfc01t93radc5p7?: InputMaybe<PageFooterUpdateManyInlineInput>;
  clf9n1ggl12x001uea0mz7sf6?: InputMaybe<FooterSealUpdateManyInlineInput>;
  clfv5tehy4evu01ui5n9k3gne?: InputMaybe<GenericPageUpdateManyInlineInput>;
  cmsAssetTitle?: InputMaybe<Scalars['String']['input']>;
  countrySelectorItem?: InputMaybe<CountrySelectorItemUpdateOneInlineInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateOneInlineInput>;
  genericCardLayoutComponents?: InputMaybe<GenericCardCarouseComponentUpdateManyInlineInput>;
  heroComponent?: InputMaybe<HeroComponentUpdateOneInlineInput>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardUpdateOneInlineInput>;
  imageCopy?: InputMaybe<ImageCopyUpdateOneInlineInput>;
  imageCopyBottom?: InputMaybe<ImageCopyUpdateOneInlineInput>;
  imageCopyItem?: InputMaybe<ImageCopyItemUpdateOneInlineInput>;
  imageCopyItems?: InputMaybe<ImageCopyItemUpdateManyInlineInput>;
  leftColumn?: InputMaybe<LeftColumnUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  mobileOnlyMainNavigation?: InputMaybe<MobileOnlyMainNavigationUpdateOneInlineInput>;
  navigation?: InputMaybe<NavigationUpdateOneInlineInput>;
  playStore?: InputMaybe<DownloadAppUpdateOneInlineInput>;
  productBannerBackground?: InputMaybe<ProductBannerUpdateManyInlineInput>;
  productBannerTool?: InputMaybe<ProductBannerUpdateManyInlineInput>;
  recipe?: InputMaybe<RecipeUpdateOneInlineInput>;
  rightColumn?: InputMaybe<RightColumnUpdateOneInlineInput>;
  socialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateOneInlineInput>;
};

export type AssetComponentUpdateManyInlineInput = {
  /** Connect multiple existing AssetComponent documents */
  connect?: InputMaybe<Array<AssetComponentConnectInput>>;
  /** Create and connect multiple AssetComponent documents */
  create?: InputMaybe<Array<AssetComponentCreateInput>>;
  /** Delete multiple AssetComponent documents */
  delete?: InputMaybe<Array<AssetComponentWhereUniqueInput>>;
  /** Disconnect multiple AssetComponent documents */
  disconnect?: InputMaybe<Array<AssetComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AssetComponent documents */
  set?: InputMaybe<Array<AssetComponentWhereUniqueInput>>;
  /** Update multiple AssetComponent documents */
  update?: InputMaybe<Array<AssetComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AssetComponent documents */
  upsert?: InputMaybe<Array<AssetComponentUpsertWithNestedWhereUniqueInput>>;
};

export type AssetComponentUpdateManyInput = {
  cmsAssetTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
};

export type AssetComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AssetComponentUpdateManyInput;
  /** Document search */
  where: AssetComponentWhereInput;
};

export type AssetComponentUpdateOneInlineInput = {
  /** Connect existing AssetComponent document */
  connect?: InputMaybe<AssetComponentWhereUniqueInput>;
  /** Create and connect one AssetComponent document */
  create?: InputMaybe<AssetComponentCreateInput>;
  /** Delete currently connected AssetComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AssetComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AssetComponent document */
  update?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AssetComponent document */
  upsert?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type AssetComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AssetComponentUpdateInput;
  /** Unique document search */
  where: AssetComponentWhereUniqueInput;
};

export type AssetComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: AssetComponentCreateInput;
  /** Update document if it exists */
  update: AssetComponentUpdateInput;
};

export type AssetComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AssetComponentUpsertInput;
  /** Unique document search */
  where: AssetComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AssetComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AssetComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  appStore?: InputMaybe<DownloadAppWhereInput>;
  asset_every?: InputMaybe<AssetWhereInput>;
  asset_none?: InputMaybe<AssetWhereInput>;
  asset_some?: InputMaybe<AssetWhereInput>;
  audioComponents_every?: InputMaybe<AudioComponentWhereInput>;
  audioComponents_none?: InputMaybe<AudioComponentWhereInput>;
  audioComponents_some?: InputMaybe<AudioComponentWhereInput>;
  cardComponents_every?: InputMaybe<CardComponentWhereInput>;
  cardComponents_none?: InputMaybe<CardComponentWhereInput>;
  cardComponents_some?: InputMaybe<CardComponentWhereInput>;
  cmsAssetTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsAssetTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsAssetTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsAssetTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsAssetTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsAssetTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsAssetTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsAssetTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsAssetTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsAssetTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  countrySelectorItem?: InputMaybe<CountrySelectorItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetComponentWhereStageInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericCardLayoutComponents_every?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericCardLayoutComponents_none?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericCardLayoutComponents_some?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  heroComponent?: InputMaybe<HeroComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardWhereInput>;
  imageCopy?: InputMaybe<ImageCopyWhereInput>;
  imageCopyBottom?: InputMaybe<ImageCopyWhereInput>;
  imageCopyItem?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopyItems_every?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopyItems_none?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopyItems_some?: InputMaybe<ImageCopyItemWhereInput>;
  leftColumn?: InputMaybe<LeftColumnWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  mobileOnlyMainNavigation?: InputMaybe<MobileOnlyMainNavigationWhereInput>;
  navigation?: InputMaybe<NavigationWhereInput>;
  playStore?: InputMaybe<DownloadAppWhereInput>;
  productBannerBackground_every?: InputMaybe<ProductBannerWhereInput>;
  productBannerBackground_none?: InputMaybe<ProductBannerWhereInput>;
  productBannerBackground_some?: InputMaybe<ProductBannerWhereInput>;
  productBannerTool_every?: InputMaybe<ProductBannerWhereInput>;
  productBannerTool_none?: InputMaybe<ProductBannerWhereInput>;
  productBannerTool_some?: InputMaybe<ProductBannerWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipe?: InputMaybe<RecipeWhereInput>;
  rightColumn?: InputMaybe<RightColumnWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  socialMediaListComponent?: InputMaybe<SocialMediaListComponentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AssetComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AssetComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AssetComponent record uniquely */
export type AssetComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AssetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AssetWhereUniqueInput;
};

/** A connection to a list of items. */
export type AssetConnection = {
  __typename?: 'AssetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AssetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AssetCreateInput = {
  /** altText input for default locale (en) */
  altText?: InputMaybe<Scalars['String']['input']>;
  appleTouchIconGlobalMetaData?: InputMaybe<GlobalMetaDataCreateManyInlineInput>;
  assetAssetComponent?: InputMaybe<AssetComponentCreateManyInlineInput>;
  audioFileAudioComponent?: InputMaybe<AudioComponentCreateManyInlineInput>;
  backgroundImgCarouselComponent?: InputMaybe<CarouselComponentCreateManyInlineInput>;
  backgroundIngredientImageProductCategoryPage?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  backgroundRating?: InputMaybe<RatingCreateManyInlineInput>;
  bannerImageHeroBanner?: InputMaybe<HeroBannerCreateManyInlineInput>;
  bannerImageHeroBannerMasterbrand?: InputMaybe<HeroBannerMasterbrandCreateManyInlineInput>;
  bottomLeftAssetCarouselComponent?: InputMaybe<CarouselComponentCreateManyInlineInput>;
  bottomLeftImageAssetHeroComponent?: InputMaybe<HeroComponentCreateManyInlineInput>;
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadableFileGenericDownloadComponent?: InputMaybe<GenericDownloadComponentCreateManyInlineInput>;
  faviconGlobalMetaData?: InputMaybe<GlobalMetaDataCreateManyInlineInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  filePromotionDownload?: InputMaybe<PromotionDownloadCreateManyInlineInput>;
  forAllRecipePagesSubCategoryKeyImage?: InputMaybe<SubCategoryKeyImageCreateManyInlineInput>;
  forRecipeCategoryPageSubCategoryKeyImage?: InputMaybe<SubCategoryKeyImageCreateManyInlineInput>;
  foregroundIngredientImageProductCategoryPage?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  iconLeftFormSelectOption?: InputMaybe<FormSelectOptionCreateManyInlineInput>;
  imageGlobalMetaData?: InputMaybe<GlobalMetaDataCreateManyInlineInput>;
  imageMultiStepFormStepNew?: InputMaybe<MultiStepPromotionFormStepCreateManyInlineInput>;
  imagesMetaData?: InputMaybe<MetaDataCreateManyInlineInput>;
  keyImageProductCategoryPage?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  lifestyleImageProduct?: InputMaybe<ProductCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AssetCreateLocalizationsInput>;
  logoGlobalMetaData?: InputMaybe<GlobalMetaDataCreateManyInlineInput>;
  lowerLeftCornerForm?: InputMaybe<FormCreateManyInlineInput>;
  lowerRightCornerSpicesRating?: InputMaybe<RatingCreateManyInlineInput>;
  mobileImageHeroBanner?: InputMaybe<HeroBannerCreateManyInlineInput>;
  mobileImageHeroBannerMasterbrand?: InputMaybe<HeroBannerMasterbrandCreateManyInlineInput>;
  mobileImageHeroComponent?: InputMaybe<HeroComponentCreateManyInlineInput>;
  productImageProduct?: InputMaybe<ProductCreateManyInlineInput>;
  promoImageProductCategoryPage?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  slideAssetCarouselSlide?: InputMaybe<CarouselSlideCreateManyInlineInput>;
  topRightAssetCarouselComponent?: InputMaybe<CarouselComponentCreateManyInlineInput>;
  topRightImageAssetHeroComponent?: InputMaybe<HeroComponentCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
  upperRightCornerForm?: InputMaybe<FormCreateManyInlineInput>;
  upperRightCornerImageRating?: InputMaybe<RatingCreateManyInlineInput>;
  videoFallbackHeroLoopAnimationComponent?: InputMaybe<HeroLoopAnimationComponentCreateManyInlineInput>;
  videoHeroLoopAnimationComponent?: InputMaybe<HeroLoopAnimationComponentCreateManyInlineInput>;
};

export type AssetCreateLocalizationDataInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCreateLocalizationInput = {
  /** Localization input */
  data: AssetCreateLocalizationDataInput;
  locale: Locale;
};

export type AssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
};

export type AssetCreateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Create and connect multiple existing Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
};

export type AssetCreateOneInlineInput = {
  /** Connect one existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
};

/** An edge in a connection. */
export type AssetEdge = {
  __typename?: 'AssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Asset;
};

/** Identifies documents */
export type AssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  appleTouchIconGlobalMetaData_every?: InputMaybe<GlobalMetaDataWhereInput>;
  appleTouchIconGlobalMetaData_none?: InputMaybe<GlobalMetaDataWhereInput>;
  appleTouchIconGlobalMetaData_some?: InputMaybe<GlobalMetaDataWhereInput>;
  assetAssetComponent_every?: InputMaybe<AssetComponentWhereInput>;
  assetAssetComponent_none?: InputMaybe<AssetComponentWhereInput>;
  assetAssetComponent_some?: InputMaybe<AssetComponentWhereInput>;
  audioFileAudioComponent_every?: InputMaybe<AudioComponentWhereInput>;
  audioFileAudioComponent_none?: InputMaybe<AudioComponentWhereInput>;
  audioFileAudioComponent_some?: InputMaybe<AudioComponentWhereInput>;
  backgroundImgCarouselComponent_every?: InputMaybe<CarouselComponentWhereInput>;
  backgroundImgCarouselComponent_none?: InputMaybe<CarouselComponentWhereInput>;
  backgroundImgCarouselComponent_some?: InputMaybe<CarouselComponentWhereInput>;
  backgroundIngredientImageProductCategoryPage_every?: InputMaybe<ProductCategoryPageWhereInput>;
  backgroundIngredientImageProductCategoryPage_none?: InputMaybe<ProductCategoryPageWhereInput>;
  backgroundIngredientImageProductCategoryPage_some?: InputMaybe<ProductCategoryPageWhereInput>;
  backgroundRating_every?: InputMaybe<RatingWhereInput>;
  backgroundRating_none?: InputMaybe<RatingWhereInput>;
  backgroundRating_some?: InputMaybe<RatingWhereInput>;
  bannerImageHeroBannerMasterbrand_every?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  bannerImageHeroBannerMasterbrand_none?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  bannerImageHeroBannerMasterbrand_some?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  bannerImageHeroBanner_every?: InputMaybe<HeroBannerWhereInput>;
  bannerImageHeroBanner_none?: InputMaybe<HeroBannerWhereInput>;
  bannerImageHeroBanner_some?: InputMaybe<HeroBannerWhereInput>;
  bottomLeftAssetCarouselComponent_every?: InputMaybe<CarouselComponentWhereInput>;
  bottomLeftAssetCarouselComponent_none?: InputMaybe<CarouselComponentWhereInput>;
  bottomLeftAssetCarouselComponent_some?: InputMaybe<CarouselComponentWhereInput>;
  bottomLeftImageAssetHeroComponent_every?: InputMaybe<HeroComponentWhereInput>;
  bottomLeftImageAssetHeroComponent_none?: InputMaybe<HeroComponentWhereInput>;
  bottomLeftImageAssetHeroComponent_some?: InputMaybe<HeroComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  downloadableFileGenericDownloadComponent_every?: InputMaybe<GenericDownloadComponentWhereInput>;
  downloadableFileGenericDownloadComponent_none?: InputMaybe<GenericDownloadComponentWhereInput>;
  downloadableFileGenericDownloadComponent_some?: InputMaybe<GenericDownloadComponentWhereInput>;
  faviconGlobalMetaData_every?: InputMaybe<GlobalMetaDataWhereInput>;
  faviconGlobalMetaData_none?: InputMaybe<GlobalMetaDataWhereInput>;
  faviconGlobalMetaData_some?: InputMaybe<GlobalMetaDataWhereInput>;
  filePromotionDownload_every?: InputMaybe<PromotionDownloadWhereInput>;
  filePromotionDownload_none?: InputMaybe<PromotionDownloadWhereInput>;
  filePromotionDownload_some?: InputMaybe<PromotionDownloadWhereInput>;
  forAllRecipePagesSubCategoryKeyImage_every?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forAllRecipePagesSubCategoryKeyImage_none?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forAllRecipePagesSubCategoryKeyImage_some?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forRecipeCategoryPageSubCategoryKeyImage_every?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forRecipeCategoryPageSubCategoryKeyImage_none?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forRecipeCategoryPageSubCategoryKeyImage_some?: InputMaybe<SubCategoryKeyImageWhereInput>;
  foregroundIngredientImageProductCategoryPage_every?: InputMaybe<ProductCategoryPageWhereInput>;
  foregroundIngredientImageProductCategoryPage_none?: InputMaybe<ProductCategoryPageWhereInput>;
  foregroundIngredientImageProductCategoryPage_some?: InputMaybe<ProductCategoryPageWhereInput>;
  iconLeftFormSelectOption_every?: InputMaybe<FormSelectOptionWhereInput>;
  iconLeftFormSelectOption_none?: InputMaybe<FormSelectOptionWhereInput>;
  iconLeftFormSelectOption_some?: InputMaybe<FormSelectOptionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageGlobalMetaData_every?: InputMaybe<GlobalMetaDataWhereInput>;
  imageGlobalMetaData_none?: InputMaybe<GlobalMetaDataWhereInput>;
  imageGlobalMetaData_some?: InputMaybe<GlobalMetaDataWhereInput>;
  imagesMetaData_every?: InputMaybe<MetaDataWhereInput>;
  imagesMetaData_none?: InputMaybe<MetaDataWhereInput>;
  imagesMetaData_some?: InputMaybe<MetaDataWhereInput>;
  keyImageProductCategoryPage_every?: InputMaybe<ProductCategoryPageWhereInput>;
  keyImageProductCategoryPage_none?: InputMaybe<ProductCategoryPageWhereInput>;
  keyImageProductCategoryPage_some?: InputMaybe<ProductCategoryPageWhereInput>;
  lifestyleImageProduct_every?: InputMaybe<ProductWhereInput>;
  lifestyleImageProduct_none?: InputMaybe<ProductWhereInput>;
  lifestyleImageProduct_some?: InputMaybe<ProductWhereInput>;
  logoGlobalMetaData_every?: InputMaybe<GlobalMetaDataWhereInput>;
  logoGlobalMetaData_none?: InputMaybe<GlobalMetaDataWhereInput>;
  logoGlobalMetaData_some?: InputMaybe<GlobalMetaDataWhereInput>;
  lowerLeftCornerForm_every?: InputMaybe<FormWhereInput>;
  lowerLeftCornerForm_none?: InputMaybe<FormWhereInput>;
  lowerLeftCornerForm_some?: InputMaybe<FormWhereInput>;
  lowerRightCornerSpicesRating_every?: InputMaybe<RatingWhereInput>;
  lowerRightCornerSpicesRating_none?: InputMaybe<RatingWhereInput>;
  lowerRightCornerSpicesRating_some?: InputMaybe<RatingWhereInput>;
  mobileImageHeroBannerMasterbrand_every?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  mobileImageHeroBannerMasterbrand_none?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  mobileImageHeroBannerMasterbrand_some?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  mobileImageHeroBanner_every?: InputMaybe<HeroBannerWhereInput>;
  mobileImageHeroBanner_none?: InputMaybe<HeroBannerWhereInput>;
  mobileImageHeroBanner_some?: InputMaybe<HeroBannerWhereInput>;
  mobileImageHeroComponent_every?: InputMaybe<HeroComponentWhereInput>;
  mobileImageHeroComponent_none?: InputMaybe<HeroComponentWhereInput>;
  mobileImageHeroComponent_some?: InputMaybe<HeroComponentWhereInput>;
  productImageProduct_every?: InputMaybe<ProductWhereInput>;
  productImageProduct_none?: InputMaybe<ProductWhereInput>;
  productImageProduct_some?: InputMaybe<ProductWhereInput>;
  promoImageProductCategoryPage_every?: InputMaybe<ProductCategoryPageWhereInput>;
  promoImageProductCategoryPage_none?: InputMaybe<ProductCategoryPageWhereInput>;
  promoImageProductCategoryPage_some?: InputMaybe<ProductCategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slideAssetCarouselSlide_every?: InputMaybe<CarouselSlideWhereInput>;
  slideAssetCarouselSlide_none?: InputMaybe<CarouselSlideWhereInput>;
  slideAssetCarouselSlide_some?: InputMaybe<CarouselSlideWhereInput>;
  topRightAssetCarouselComponent_every?: InputMaybe<CarouselComponentWhereInput>;
  topRightAssetCarouselComponent_none?: InputMaybe<CarouselComponentWhereInput>;
  topRightAssetCarouselComponent_some?: InputMaybe<CarouselComponentWhereInput>;
  topRightImageAssetHeroComponent_every?: InputMaybe<HeroComponentWhereInput>;
  topRightImageAssetHeroComponent_none?: InputMaybe<HeroComponentWhereInput>;
  topRightImageAssetHeroComponent_some?: InputMaybe<HeroComponentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
  upperRightCornerForm_every?: InputMaybe<FormWhereInput>;
  upperRightCornerForm_none?: InputMaybe<FormWhereInput>;
  upperRightCornerForm_some?: InputMaybe<FormWhereInput>;
  upperRightCornerImageRating_every?: InputMaybe<RatingWhereInput>;
  upperRightCornerImageRating_none?: InputMaybe<RatingWhereInput>;
  upperRightCornerImageRating_some?: InputMaybe<RatingWhereInput>;
  videoFallbackHeroLoopAnimationComponent_every?: InputMaybe<HeroLoopAnimationComponentWhereInput>;
  videoFallbackHeroLoopAnimationComponent_none?: InputMaybe<HeroLoopAnimationComponentWhereInput>;
  videoFallbackHeroLoopAnimationComponent_some?: InputMaybe<HeroLoopAnimationComponentWhereInput>;
  videoHeroLoopAnimationComponent_every?: InputMaybe<HeroLoopAnimationComponentWhereInput>;
  videoHeroLoopAnimationComponent_none?: InputMaybe<HeroLoopAnimationComponentWhereInput>;
  videoHeroLoopAnimationComponent_some?: InputMaybe<HeroLoopAnimationComponentWhereInput>;
};

export enum AssetOrderByInput {
  altText_ASC = 'altText_ASC',
  altText_DESC = 'altText_DESC',
  caption_ASC = 'caption_ASC',
  caption_DESC = 'caption_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fileName_ASC = 'fileName_ASC',
  fileName_DESC = 'fileName_DESC',
  handle_ASC = 'handle_ASC',
  handle_DESC = 'handle_DESC',
  height_ASC = 'height_ASC',
  height_DESC = 'height_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  mimeType_ASC = 'mimeType_ASC',
  mimeType_DESC = 'mimeType_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  size_ASC = 'size_ASC',
  size_DESC = 'size_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  width_ASC = 'width_ASC',
  width_DESC = 'width_DESC'
}

/** Identifies documents */
export type AssetSingleRelationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

/** Transformations for Assets */
export type AssetTransformationInput = {
  document?: InputMaybe<DocumentTransformationInput>;
  image?: InputMaybe<ImageTransformationInput>;
  /** Pass true if you want to validate the passed transformation parameters */
  validateOptions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetUpdateInput = {
  /** altText input for default locale (en) */
  altText?: InputMaybe<Scalars['String']['input']>;
  appleTouchIconGlobalMetaData?: InputMaybe<GlobalMetaDataUpdateManyInlineInput>;
  assetAssetComponent?: InputMaybe<AssetComponentUpdateManyInlineInput>;
  audioFileAudioComponent?: InputMaybe<AudioComponentUpdateManyInlineInput>;
  backgroundImgCarouselComponent?: InputMaybe<CarouselComponentUpdateManyInlineInput>;
  backgroundIngredientImageProductCategoryPage?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  backgroundRating?: InputMaybe<RatingUpdateManyInlineInput>;
  bannerImageHeroBanner?: InputMaybe<HeroBannerUpdateManyInlineInput>;
  bannerImageHeroBannerMasterbrand?: InputMaybe<HeroBannerMasterbrandUpdateManyInlineInput>;
  bottomLeftAssetCarouselComponent?: InputMaybe<CarouselComponentUpdateManyInlineInput>;
  bottomLeftImageAssetHeroComponent?: InputMaybe<HeroComponentUpdateManyInlineInput>;
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  downloadableFileGenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateManyInlineInput>;
  faviconGlobalMetaData?: InputMaybe<GlobalMetaDataUpdateManyInlineInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  filePromotionDownload?: InputMaybe<PromotionDownloadUpdateManyInlineInput>;
  forAllRecipePagesSubCategoryKeyImage?: InputMaybe<SubCategoryKeyImageUpdateManyInlineInput>;
  forRecipeCategoryPageSubCategoryKeyImage?: InputMaybe<SubCategoryKeyImageUpdateManyInlineInput>;
  foregroundIngredientImageProductCategoryPage?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  iconLeftFormSelectOption?: InputMaybe<FormSelectOptionUpdateManyInlineInput>;
  imageGlobalMetaData?: InputMaybe<GlobalMetaDataUpdateManyInlineInput>;
  imageMultiStepFormStepNew?: InputMaybe<MultiStepPromotionFormStepUpdateManyInlineInput>;
  imagesMetaData?: InputMaybe<MetaDataUpdateManyInlineInput>;
  keyImageProductCategoryPage?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  lifestyleImageProduct?: InputMaybe<ProductUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<AssetUpdateLocalizationsInput>;
  logoGlobalMetaData?: InputMaybe<GlobalMetaDataUpdateManyInlineInput>;
  lowerLeftCornerForm?: InputMaybe<FormUpdateManyInlineInput>;
  lowerRightCornerSpicesRating?: InputMaybe<RatingUpdateManyInlineInput>;
  mobileImageHeroBanner?: InputMaybe<HeroBannerUpdateManyInlineInput>;
  mobileImageHeroBannerMasterbrand?: InputMaybe<HeroBannerMasterbrandUpdateManyInlineInput>;
  mobileImageHeroComponent?: InputMaybe<HeroComponentUpdateManyInlineInput>;
  productImageProduct?: InputMaybe<ProductUpdateManyInlineInput>;
  promoImageProductCategoryPage?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>;
  slideAssetCarouselSlide?: InputMaybe<CarouselSlideUpdateManyInlineInput>;
  topRightAssetCarouselComponent?: InputMaybe<CarouselComponentUpdateManyInlineInput>;
  topRightImageAssetHeroComponent?: InputMaybe<HeroComponentUpdateManyInlineInput>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
  upperRightCornerForm?: InputMaybe<FormUpdateManyInlineInput>;
  upperRightCornerImageRating?: InputMaybe<RatingUpdateManyInlineInput>;
  videoFallbackHeroLoopAnimationComponent?: InputMaybe<HeroLoopAnimationComponentUpdateManyInlineInput>;
  videoHeroLoopAnimationComponent?: InputMaybe<HeroLoopAnimationComponentUpdateManyInlineInput>;
};

export type AssetUpdateLocalizationDataInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateLocalizationInput = {
  data: AssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AssetUpsertLocalizationInput>>;
};

export type AssetUpdateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetConnectInput>>;
  /** Create and connect multiple Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
  /** Delete multiple Asset documents */
  delete?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Disconnect multiple Asset documents */
  disconnect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Asset documents */
  set?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Update multiple Asset documents */
  update?: InputMaybe<Array<AssetUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Asset documents */
  upsert?: InputMaybe<Array<AssetUpsertWithNestedWhereUniqueInput>>;
};

export type AssetUpdateManyInput = {
  /** altText input for default locale (en) */
  altText?: InputMaybe<Scalars['String']['input']>;
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<AssetUpdateManyLocalizationsInput>;
};

export type AssetUpdateManyLocalizationDataInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateManyLocalizationInput = {
  data: AssetUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateManyLocalizationInput>>;
};

export type AssetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AssetUpdateManyInput;
  /** Document search */
  where: AssetWhereInput;
};

export type AssetUpdateOneInlineInput = {
  /** Connect existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
  /** Delete currently connected Asset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Asset document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Asset document */
  update?: InputMaybe<AssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Asset document */
  upsert?: InputMaybe<AssetUpsertWithNestedWhereUniqueInput>;
};

export type AssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AssetUpdateInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** Asset Upload */
export type AssetUpload = {
  __typename?: 'AssetUpload';
  /** Asset Upload Error */
  error?: Maybe<AssetUploadError>;
  /** Expiry Timestamp */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Asset Request Data for upload */
  requestPostData?: Maybe<AssetUploadRequestPostData>;
  /** Asset Request Data for upload */
  status?: Maybe<AssetUploadStatus>;
};

/** Represents asset upload error */
export type AssetUploadError = {
  __typename?: 'AssetUploadError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Asset Upload Request Post Data */
export type AssetUploadRequestPostData = {
  __typename?: 'AssetUploadRequestPostData';
  /** The algorithm to use in the form field. This value should be passed in the `X-Amz-Algorithm` form field. */
  algorithm: Scalars['String']['output'];
  /** The credential to use in the form field. This value should be passed in the `X-Amz-Credential` form field. */
  credential: Scalars['String']['output'];
  /** The date the request was signed, formatted as YYYYMMDDTHHMMSSZ. This value should be passed in the `X-Amz-Date` header. */
  date: Scalars['String']['output'];
  /** The key to use in the form field. This value should be passed in the `Key` form field. */
  key: Scalars['String']['output'];
  /** The policy to use in the form field. This value should be passed in the `Policy` form field. */
  policy: Scalars['String']['output'];
  /** The security token to use in the form field. This field is optional only pass it if its not null. This value should be passed in the `X-Amz-Security-Token` form field if not null. */
  securityToken?: Maybe<Scalars['String']['output']>;
  /** The signature to use in the form field. This value should be passed in the `X-Amz-Signature` form field. */
  signature: Scalars['String']['output'];
  /** The URL to which the file should be uploaded with a POST request. */
  url: Scalars['String']['output'];
};

/** System Asset Upload Status */
export enum AssetUploadStatus {
  ASSET_CREATE_PENDING = 'ASSET_CREATE_PENDING',
  ASSET_ERROR_UPLOAD = 'ASSET_ERROR_UPLOAD',
  ASSET_UPDATE_PENDING = 'ASSET_UPDATE_PENDING',
  ASSET_UPLOAD_COMPLETE = 'ASSET_UPLOAD_COMPLETE'
}

/** Identifies documents */
export type AssetUploadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

/** Identifies documents */
export type AssetUploadWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

export type AssetUpsertInput = {
  /** Create document if it didn't exist */
  create: AssetCreateInput;
  /** Update document if it exists */
  update: AssetUpdateInput;
};

export type AssetUpsertLocalizationInput = {
  create: AssetCreateLocalizationDataInput;
  locale: Locale;
  update: AssetUpdateLocalizationDataInput;
};

export type AssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AssetUpsertInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AssetWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  altText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  altText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  altText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  altText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  altText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  altText_starts_with?: InputMaybe<Scalars['String']['input']>;
  appleTouchIconGlobalMetaData_every?: InputMaybe<GlobalMetaDataWhereInput>;
  appleTouchIconGlobalMetaData_none?: InputMaybe<GlobalMetaDataWhereInput>;
  appleTouchIconGlobalMetaData_some?: InputMaybe<GlobalMetaDataWhereInput>;
  assetAssetComponent_every?: InputMaybe<AssetComponentWhereInput>;
  assetAssetComponent_none?: InputMaybe<AssetComponentWhereInput>;
  assetAssetComponent_some?: InputMaybe<AssetComponentWhereInput>;
  audioFileAudioComponent_every?: InputMaybe<AudioComponentWhereInput>;
  audioFileAudioComponent_none?: InputMaybe<AudioComponentWhereInput>;
  audioFileAudioComponent_some?: InputMaybe<AudioComponentWhereInput>;
  backgroundImgCarouselComponent_every?: InputMaybe<CarouselComponentWhereInput>;
  backgroundImgCarouselComponent_none?: InputMaybe<CarouselComponentWhereInput>;
  backgroundImgCarouselComponent_some?: InputMaybe<CarouselComponentWhereInput>;
  backgroundIngredientImageProductCategoryPage_every?: InputMaybe<ProductCategoryPageWhereInput>;
  backgroundIngredientImageProductCategoryPage_none?: InputMaybe<ProductCategoryPageWhereInput>;
  backgroundIngredientImageProductCategoryPage_some?: InputMaybe<ProductCategoryPageWhereInput>;
  backgroundRating_every?: InputMaybe<RatingWhereInput>;
  backgroundRating_none?: InputMaybe<RatingWhereInput>;
  backgroundRating_some?: InputMaybe<RatingWhereInput>;
  bannerImageHeroBannerMasterbrand_every?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  bannerImageHeroBannerMasterbrand_none?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  bannerImageHeroBannerMasterbrand_some?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  bannerImageHeroBanner_every?: InputMaybe<HeroBannerWhereInput>;
  bannerImageHeroBanner_none?: InputMaybe<HeroBannerWhereInput>;
  bannerImageHeroBanner_some?: InputMaybe<HeroBannerWhereInput>;
  bottomLeftAssetCarouselComponent_every?: InputMaybe<CarouselComponentWhereInput>;
  bottomLeftAssetCarouselComponent_none?: InputMaybe<CarouselComponentWhereInput>;
  bottomLeftAssetCarouselComponent_some?: InputMaybe<CarouselComponentWhereInput>;
  bottomLeftImageAssetHeroComponent_every?: InputMaybe<HeroComponentWhereInput>;
  bottomLeftImageAssetHeroComponent_none?: InputMaybe<HeroComponentWhereInput>;
  bottomLeftImageAssetHeroComponent_some?: InputMaybe<HeroComponentWhereInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  downloadableFileGenericDownloadComponent_every?: InputMaybe<GenericDownloadComponentWhereInput>;
  downloadableFileGenericDownloadComponent_none?: InputMaybe<GenericDownloadComponentWhereInput>;
  downloadableFileGenericDownloadComponent_some?: InputMaybe<GenericDownloadComponentWhereInput>;
  faviconGlobalMetaData_every?: InputMaybe<GlobalMetaDataWhereInput>;
  faviconGlobalMetaData_none?: InputMaybe<GlobalMetaDataWhereInput>;
  faviconGlobalMetaData_some?: InputMaybe<GlobalMetaDataWhereInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fileName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fileName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fileName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fileName_starts_with?: InputMaybe<Scalars['String']['input']>;
  filePromotionDownload_every?: InputMaybe<PromotionDownloadWhereInput>;
  filePromotionDownload_none?: InputMaybe<PromotionDownloadWhereInput>;
  filePromotionDownload_some?: InputMaybe<PromotionDownloadWhereInput>;
  forAllRecipePagesSubCategoryKeyImage_every?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forAllRecipePagesSubCategoryKeyImage_none?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forAllRecipePagesSubCategoryKeyImage_some?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forRecipeCategoryPageSubCategoryKeyImage_every?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forRecipeCategoryPageSubCategoryKeyImage_none?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forRecipeCategoryPageSubCategoryKeyImage_some?: InputMaybe<SubCategoryKeyImageWhereInput>;
  foregroundIngredientImageProductCategoryPage_every?: InputMaybe<ProductCategoryPageWhereInput>;
  foregroundIngredientImageProductCategoryPage_none?: InputMaybe<ProductCategoryPageWhereInput>;
  foregroundIngredientImageProductCategoryPage_some?: InputMaybe<ProductCategoryPageWhereInput>;
  handle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  iconLeftFormSelectOption_every?: InputMaybe<FormSelectOptionWhereInput>;
  iconLeftFormSelectOption_none?: InputMaybe<FormSelectOptionWhereInput>;
  iconLeftFormSelectOption_some?: InputMaybe<FormSelectOptionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageGlobalMetaData_every?: InputMaybe<GlobalMetaDataWhereInput>;
  imageGlobalMetaData_none?: InputMaybe<GlobalMetaDataWhereInput>;
  imageGlobalMetaData_some?: InputMaybe<GlobalMetaDataWhereInput>;
  imagesMetaData_every?: InputMaybe<MetaDataWhereInput>;
  imagesMetaData_none?: InputMaybe<MetaDataWhereInput>;
  imagesMetaData_some?: InputMaybe<MetaDataWhereInput>;
  keyImageProductCategoryPage_every?: InputMaybe<ProductCategoryPageWhereInput>;
  keyImageProductCategoryPage_none?: InputMaybe<ProductCategoryPageWhereInput>;
  keyImageProductCategoryPage_some?: InputMaybe<ProductCategoryPageWhereInput>;
  lifestyleImageProduct_every?: InputMaybe<ProductWhereInput>;
  lifestyleImageProduct_none?: InputMaybe<ProductWhereInput>;
  lifestyleImageProduct_some?: InputMaybe<ProductWhereInput>;
  logoGlobalMetaData_every?: InputMaybe<GlobalMetaDataWhereInput>;
  logoGlobalMetaData_none?: InputMaybe<GlobalMetaDataWhereInput>;
  logoGlobalMetaData_some?: InputMaybe<GlobalMetaDataWhereInput>;
  lowerLeftCornerForm_every?: InputMaybe<FormWhereInput>;
  lowerLeftCornerForm_none?: InputMaybe<FormWhereInput>;
  lowerLeftCornerForm_some?: InputMaybe<FormWhereInput>;
  lowerRightCornerSpicesRating_every?: InputMaybe<RatingWhereInput>;
  lowerRightCornerSpicesRating_none?: InputMaybe<RatingWhereInput>;
  lowerRightCornerSpicesRating_some?: InputMaybe<RatingWhereInput>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  mimeType_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  mimeType_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  mimeType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  mimeType_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  mimeType_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  mimeType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  mimeType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  mimeType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  mimeType_starts_with?: InputMaybe<Scalars['String']['input']>;
  mobileImageHeroBannerMasterbrand_every?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  mobileImageHeroBannerMasterbrand_none?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  mobileImageHeroBannerMasterbrand_some?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  mobileImageHeroBanner_every?: InputMaybe<HeroBannerWhereInput>;
  mobileImageHeroBanner_none?: InputMaybe<HeroBannerWhereInput>;
  mobileImageHeroBanner_some?: InputMaybe<HeroBannerWhereInput>;
  mobileImageHeroComponent_every?: InputMaybe<HeroComponentWhereInput>;
  mobileImageHeroComponent_none?: InputMaybe<HeroComponentWhereInput>;
  mobileImageHeroComponent_some?: InputMaybe<HeroComponentWhereInput>;
  productImageProduct_every?: InputMaybe<ProductWhereInput>;
  productImageProduct_none?: InputMaybe<ProductWhereInput>;
  productImageProduct_some?: InputMaybe<ProductWhereInput>;
  promoImageProductCategoryPage_every?: InputMaybe<ProductCategoryPageWhereInput>;
  promoImageProductCategoryPage_none?: InputMaybe<ProductCategoryPageWhereInput>;
  promoImageProductCategoryPage_some?: InputMaybe<ProductCategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  size?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  slideAssetCarouselSlide_every?: InputMaybe<CarouselSlideWhereInput>;
  slideAssetCarouselSlide_none?: InputMaybe<CarouselSlideWhereInput>;
  slideAssetCarouselSlide_some?: InputMaybe<CarouselSlideWhereInput>;
  topRightAssetCarouselComponent_every?: InputMaybe<CarouselComponentWhereInput>;
  topRightAssetCarouselComponent_none?: InputMaybe<CarouselComponentWhereInput>;
  topRightAssetCarouselComponent_some?: InputMaybe<CarouselComponentWhereInput>;
  topRightImageAssetHeroComponent_every?: InputMaybe<HeroComponentWhereInput>;
  topRightImageAssetHeroComponent_none?: InputMaybe<HeroComponentWhereInput>;
  topRightImageAssetHeroComponent_some?: InputMaybe<HeroComponentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
  upperRightCornerForm_every?: InputMaybe<FormWhereInput>;
  upperRightCornerForm_none?: InputMaybe<FormWhereInput>;
  upperRightCornerForm_some?: InputMaybe<FormWhereInput>;
  upperRightCornerImageRating_every?: InputMaybe<RatingWhereInput>;
  upperRightCornerImageRating_none?: InputMaybe<RatingWhereInput>;
  upperRightCornerImageRating_some?: InputMaybe<RatingWhereInput>;
  videoFallbackHeroLoopAnimationComponent_every?: InputMaybe<HeroLoopAnimationComponentWhereInput>;
  videoFallbackHeroLoopAnimationComponent_none?: InputMaybe<HeroLoopAnimationComponentWhereInput>;
  videoFallbackHeroLoopAnimationComponent_some?: InputMaybe<HeroLoopAnimationComponentWhereInput>;
  videoHeroLoopAnimationComponent_every?: InputMaybe<HeroLoopAnimationComponentWhereInput>;
  videoHeroLoopAnimationComponent_none?: InputMaybe<HeroLoopAnimationComponentWhereInput>;
  videoHeroLoopAnimationComponent_some?: InputMaybe<HeroLoopAnimationComponentWhereInput>;
  width?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  width_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  width_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  width_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  width_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  width_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AssetWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AssetWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Asset record uniquely */
export type AssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AudioComponent = Entity & Node & {
  __typename?: 'AudioComponent';
  audioFile?: Maybe<Asset>;
  cmsTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<AudioComponent>;
  genericPages: Array<GenericPage>;
  /** List of AudioComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image: Array<AssetComponent>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<AudioComponent>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type AudioComponentAudioFileArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type AudioComponentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type AudioComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AudioComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type AudioComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type AudioComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type AudioComponentImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentWhereInput>;
};


export type AudioComponentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type AudioComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AudioComponentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type AudioComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AudioComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type AudioComponentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type AudioComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AudioComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AudioComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type AudioComponentConnection = {
  __typename?: 'AudioComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AudioComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AudioComponentCreateInput = {
  audioFile?: InputMaybe<AssetCreateOneInlineInput>;
  cmsTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  image?: InputMaybe<AssetComponentCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AudioComponentCreateLocalizationsInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** transcript input for default locale (en) */
  transcript?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AudioComponentCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AudioComponentCreateLocalizationInput = {
  /** Localization input */
  data: AudioComponentCreateLocalizationDataInput;
  locale: Locale;
};

export type AudioComponentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AudioComponentCreateLocalizationInput>>;
};

export type AudioComponentCreateManyInlineInput = {
  /** Connect multiple existing AudioComponent documents */
  connect?: InputMaybe<Array<AudioComponentWhereUniqueInput>>;
  /** Create and connect multiple existing AudioComponent documents */
  create?: InputMaybe<Array<AudioComponentCreateInput>>;
};

export type AudioComponentCreateOneInlineInput = {
  /** Connect one existing AudioComponent document */
  connect?: InputMaybe<AudioComponentWhereUniqueInput>;
  /** Create and connect one AudioComponent document */
  create?: InputMaybe<AudioComponentCreateInput>;
};

/** An edge in a connection. */
export type AudioComponentEdge = {
  __typename?: 'AudioComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AudioComponent;
};

/** Identifies documents */
export type AudioComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AudioComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AudioComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AudioComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  audioFile?: InputMaybe<AssetWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<AudioComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<AudioComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<AudioComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image_every?: InputMaybe<AssetComponentWhereInput>;
  image_none?: InputMaybe<AssetComponentWhereInput>;
  image_some?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AudioComponentOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  transcript_ASC = 'transcript_ASC',
  transcript_DESC = 'transcript_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AudioComponentUpdateInput = {
  audioFile?: InputMaybe<AssetUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  image?: InputMaybe<AssetComponentUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<AudioComponentUpdateLocalizationsInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** transcript input for default locale (en) */
  transcript?: InputMaybe<Scalars['String']['input']>;
};

export type AudioComponentUpdateLocalizationDataInput = {
  transcript?: InputMaybe<Scalars['String']['input']>;
};

export type AudioComponentUpdateLocalizationInput = {
  data: AudioComponentUpdateLocalizationDataInput;
  locale: Locale;
};

export type AudioComponentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AudioComponentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AudioComponentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AudioComponentUpsertLocalizationInput>>;
};

export type AudioComponentUpdateManyInlineInput = {
  /** Connect multiple existing AudioComponent documents */
  connect?: InputMaybe<Array<AudioComponentConnectInput>>;
  /** Create and connect multiple AudioComponent documents */
  create?: InputMaybe<Array<AudioComponentCreateInput>>;
  /** Delete multiple AudioComponent documents */
  delete?: InputMaybe<Array<AudioComponentWhereUniqueInput>>;
  /** Disconnect multiple AudioComponent documents */
  disconnect?: InputMaybe<Array<AudioComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AudioComponent documents */
  set?: InputMaybe<Array<AudioComponentWhereUniqueInput>>;
  /** Update multiple AudioComponent documents */
  update?: InputMaybe<Array<AudioComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AudioComponent documents */
  upsert?: InputMaybe<Array<AudioComponentUpsertWithNestedWhereUniqueInput>>;
};

export type AudioComponentUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<AudioComponentUpdateManyLocalizationsInput>;
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** transcript input for default locale (en) */
  transcript?: InputMaybe<Scalars['String']['input']>;
};

export type AudioComponentUpdateManyLocalizationDataInput = {
  transcript?: InputMaybe<Scalars['String']['input']>;
};

export type AudioComponentUpdateManyLocalizationInput = {
  data: AudioComponentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type AudioComponentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<AudioComponentUpdateManyLocalizationInput>>;
};

export type AudioComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AudioComponentUpdateManyInput;
  /** Document search */
  where: AudioComponentWhereInput;
};

export type AudioComponentUpdateOneInlineInput = {
  /** Connect existing AudioComponent document */
  connect?: InputMaybe<AudioComponentWhereUniqueInput>;
  /** Create and connect one AudioComponent document */
  create?: InputMaybe<AudioComponentCreateInput>;
  /** Delete currently connected AudioComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AudioComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AudioComponent document */
  update?: InputMaybe<AudioComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AudioComponent document */
  upsert?: InputMaybe<AudioComponentUpsertWithNestedWhereUniqueInput>;
};

export type AudioComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AudioComponentUpdateInput;
  /** Unique document search */
  where: AudioComponentWhereUniqueInput;
};

export type AudioComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: AudioComponentCreateInput;
  /** Update document if it exists */
  update: AudioComponentUpdateInput;
};

export type AudioComponentUpsertLocalizationInput = {
  create: AudioComponentCreateLocalizationDataInput;
  locale: Locale;
  update: AudioComponentUpdateLocalizationDataInput;
};

export type AudioComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AudioComponentUpsertInput;
  /** Unique document search */
  where: AudioComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AudioComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AudioComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AudioComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AudioComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AudioComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  audioFile?: InputMaybe<AssetWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<AudioComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<AudioComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<AudioComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image_every?: InputMaybe<AssetComponentWhereInput>;
  image_none?: InputMaybe<AssetComponentWhereInput>;
  image_some?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  transcript_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  transcript_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  transcript_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  transcript_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  transcript_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  transcript_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  transcript_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  transcript_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  transcript_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AudioComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AudioComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AudioComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AudioComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AudioComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AudioComponent record uniquely */
export type AudioComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AuthorableContentCard = Entity & Node & {
  __typename?: 'AuthorableContentCard';
  anchorNav?: Maybe<AnchorNavigation>;
  /** Body copy text */
  copy: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<AuthorableContentCard>;
  featuredContent?: Maybe<FeaturedContent>;
  genericGridAuthorables: Array<GenericGridAuthorable>;
  genericPages: Array<GenericPage>;
  /** List of AuthorableContentCard versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** the image to be shown */
  image?: Maybe<AssetComponent>;
  link?: Maybe<Link>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** Title of the card */
  name: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  /** subtitle for the content card */
  subtitle?: Maybe<Scalars['String']['output']>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Id of the video to be shown on click of the card */
  videoId?: Maybe<Scalars['String']['output']>;
};


export type AuthorableContentCardAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AuthorableContentCardCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AuthorableContentCardDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type AuthorableContentCardFeaturedContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AuthorableContentCardGenericGridAuthorablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericGridAuthorableWhereInput>;
};


export type AuthorableContentCardGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type AuthorableContentCardHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type AuthorableContentCardImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AuthorableContentCardLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AuthorableContentCardMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AuthorableContentCardPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AuthorableContentCardScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type AuthorableContentCardSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AuthorableContentCardTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AuthorableContentCardUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AuthorableContentCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AuthorableContentCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type AuthorableContentCardConnection = {
  __typename?: 'AuthorableContentCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AuthorableContentCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AuthorableContentCardCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  copy: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  featuredContent?: InputMaybe<FeaturedContentCreateOneInlineInput>;
  genericGridAuthorables?: InputMaybe<GenericGridAuthorableCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  image?: InputMaybe<AssetComponentCreateOneInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  name: Scalars['String']['input'];
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorableContentCardCreateManyInlineInput = {
  /** Connect multiple existing AuthorableContentCard documents */
  connect?: InputMaybe<Array<AuthorableContentCardWhereUniqueInput>>;
  /** Create and connect multiple existing AuthorableContentCard documents */
  create?: InputMaybe<Array<AuthorableContentCardCreateInput>>;
};

export type AuthorableContentCardCreateOneInlineInput = {
  /** Connect one existing AuthorableContentCard document */
  connect?: InputMaybe<AuthorableContentCardWhereUniqueInput>;
  /** Create and connect one AuthorableContentCard document */
  create?: InputMaybe<AuthorableContentCardCreateInput>;
};

/** An edge in a connection. */
export type AuthorableContentCardEdge = {
  __typename?: 'AuthorableContentCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AuthorableContentCard;
};

/** Identifies documents */
export type AuthorableContentCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AuthorableContentCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AuthorableContentCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AuthorableContentCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  copy?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  copy_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  copy_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  copy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  copy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  copy_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AuthorableContentCardWhereStageInput>;
  documentInStages_none?: InputMaybe<AuthorableContentCardWhereStageInput>;
  documentInStages_some?: InputMaybe<AuthorableContentCardWhereStageInput>;
  featuredContent?: InputMaybe<FeaturedContentWhereInput>;
  genericGridAuthorables_every?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorables_none?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorables_some?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoId_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum AuthorableContentCardOrderByInput {
  copy_ASC = 'copy_ASC',
  copy_DESC = 'copy_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subtitle_ASC = 'subtitle_ASC',
  subtitle_DESC = 'subtitle_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  videoId_ASC = 'videoId_ASC',
  videoId_DESC = 'videoId_DESC'
}

export type AuthorableContentCardUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  copy?: InputMaybe<Scalars['String']['input']>;
  featuredContent?: InputMaybe<FeaturedContentUpdateOneInlineInput>;
  genericGridAuthorables?: InputMaybe<GenericGridAuthorableUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  image?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorableContentCardUpdateManyInlineInput = {
  /** Connect multiple existing AuthorableContentCard documents */
  connect?: InputMaybe<Array<AuthorableContentCardConnectInput>>;
  /** Create and connect multiple AuthorableContentCard documents */
  create?: InputMaybe<Array<AuthorableContentCardCreateInput>>;
  /** Delete multiple AuthorableContentCard documents */
  delete?: InputMaybe<Array<AuthorableContentCardWhereUniqueInput>>;
  /** Disconnect multiple AuthorableContentCard documents */
  disconnect?: InputMaybe<Array<AuthorableContentCardWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AuthorableContentCard documents */
  set?: InputMaybe<Array<AuthorableContentCardWhereUniqueInput>>;
  /** Update multiple AuthorableContentCard documents */
  update?: InputMaybe<Array<AuthorableContentCardUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AuthorableContentCard documents */
  upsert?: InputMaybe<Array<AuthorableContentCardUpsertWithNestedWhereUniqueInput>>;
};

export type AuthorableContentCardUpdateManyInput = {
  copy?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  name?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorableContentCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AuthorableContentCardUpdateManyInput;
  /** Document search */
  where: AuthorableContentCardWhereInput;
};

export type AuthorableContentCardUpdateOneInlineInput = {
  /** Connect existing AuthorableContentCard document */
  connect?: InputMaybe<AuthorableContentCardWhereUniqueInput>;
  /** Create and connect one AuthorableContentCard document */
  create?: InputMaybe<AuthorableContentCardCreateInput>;
  /** Delete currently connected AuthorableContentCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AuthorableContentCard document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AuthorableContentCard document */
  update?: InputMaybe<AuthorableContentCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AuthorableContentCard document */
  upsert?: InputMaybe<AuthorableContentCardUpsertWithNestedWhereUniqueInput>;
};

export type AuthorableContentCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AuthorableContentCardUpdateInput;
  /** Unique document search */
  where: AuthorableContentCardWhereUniqueInput;
};

export type AuthorableContentCardUpsertInput = {
  /** Create document if it didn't exist */
  create: AuthorableContentCardCreateInput;
  /** Update document if it exists */
  update: AuthorableContentCardUpdateInput;
};

export type AuthorableContentCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AuthorableContentCardUpsertInput;
  /** Unique document search */
  where: AuthorableContentCardWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AuthorableContentCardWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AuthorableContentCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AuthorableContentCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AuthorableContentCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AuthorableContentCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  copy?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  copy_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  copy_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  copy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  copy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  copy_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AuthorableContentCardWhereStageInput>;
  documentInStages_none?: InputMaybe<AuthorableContentCardWhereStageInput>;
  documentInStages_some?: InputMaybe<AuthorableContentCardWhereStageInput>;
  featuredContent?: InputMaybe<FeaturedContentWhereInput>;
  genericGridAuthorables_every?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorables_none?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorables_some?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoId_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AuthorableContentCardWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AuthorableContentCardWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AuthorableContentCardWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AuthorableContentCardWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AuthorableContentCardWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AuthorableContentCard record uniquely */
export type AuthorableContentCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1 = Entity & Node & {
  __typename?: 'Banner1';
  anchorNav?: Maybe<AnchorNavigation>;
  /** For background image of banner */
  backgroundAsset?: Maybe<AssetComponent>;
  buttonColor: ButtonColor;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<Banner1>;
  genericPages: Array<GenericPage>;
  /** List of Banner1 versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  lowerLeftCorner?: Maybe<AssetComponent>;
  market: Markets;
  marketName?: Maybe<Market>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  superText?: Maybe<Scalars['String']['output']>;
  tabContent?: Maybe<TabContent>;
  /** title of the banner */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  upperRightCorner?: Maybe<AssetComponent>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1AnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1BackgroundAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1CreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1DocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1GenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1HistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1LinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1LowerLeftCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1MarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1ProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1ProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1ProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1PublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1RecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1RecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1RecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1ScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1SubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1TabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1UpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type Banner1UpperRightCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type Banner1ConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: Banner1WhereUniqueInput;
};

/** A connection to a list of items. */
export type Banner1Connection = {
  __typename?: 'Banner1Connection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<Banner1Edge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type Banner1CreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  backgroundAsset?: InputMaybe<AssetComponentCreateOneInlineInput>;
  buttonColor: ButtonColor;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  lowerLeftCorner?: InputMaybe<AssetComponentCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  upperRightCorner?: InputMaybe<AssetComponentCreateOneInlineInput>;
};

export type Banner1CreateManyInlineInput = {
  /** Connect multiple existing Banner1 documents */
  connect?: InputMaybe<Array<Banner1WhereUniqueInput>>;
  /** Create and connect multiple existing Banner1 documents */
  create?: InputMaybe<Array<Banner1CreateInput>>;
};

export type Banner1CreateOneInlineInput = {
  /** Connect one existing Banner1 document */
  connect?: InputMaybe<Banner1WhereUniqueInput>;
  /** Create and connect one Banner1 document */
  create?: InputMaybe<Banner1CreateInput>;
};

/** An edge in a connection. */
export type Banner1Edge = {
  __typename?: 'Banner1Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Banner1;
};

/** Identifies documents */
export type Banner1ManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<Banner1WhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<Banner1WhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<Banner1WhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundAsset?: InputMaybe<AssetComponentWhereInput>;
  buttonColor?: InputMaybe<ButtonColor>;
  /** All values that are contained in given list. */
  buttonColor_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonColor_not?: InputMaybe<ButtonColor>;
  /** All values that are not contained in given list. */
  buttonColor_not_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<Banner1WhereStageInput>;
  documentInStages_none?: InputMaybe<Banner1WhereStageInput>;
  documentInStages_some?: InputMaybe<Banner1WhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  lowerLeftCorner?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upperRightCorner?: InputMaybe<AssetComponentWhereInput>;
};

export enum Banner1OrderByInput {
  buttonColor_ASC = 'buttonColor_ASC',
  buttonColor_DESC = 'buttonColor_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type Banner1UpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  backgroundAsset?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  buttonColor?: InputMaybe<ButtonColor>;
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  lowerLeftCorner?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  upperRightCorner?: InputMaybe<AssetComponentUpdateOneInlineInput>;
};

export type Banner1UpdateManyInlineInput = {
  /** Connect multiple existing Banner1 documents */
  connect?: InputMaybe<Array<Banner1ConnectInput>>;
  /** Create and connect multiple Banner1 documents */
  create?: InputMaybe<Array<Banner1CreateInput>>;
  /** Delete multiple Banner1 documents */
  delete?: InputMaybe<Array<Banner1WhereUniqueInput>>;
  /** Disconnect multiple Banner1 documents */
  disconnect?: InputMaybe<Array<Banner1WhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Banner1 documents */
  set?: InputMaybe<Array<Banner1WhereUniqueInput>>;
  /** Update multiple Banner1 documents */
  update?: InputMaybe<Array<Banner1UpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Banner1 documents */
  upsert?: InputMaybe<Array<Banner1UpsertWithNestedWhereUniqueInput>>;
};

export type Banner1UpdateManyInput = {
  buttonColor?: InputMaybe<ButtonColor>;
  description?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Banner1UpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: Banner1UpdateManyInput;
  /** Document search */
  where: Banner1WhereInput;
};

export type Banner1UpdateOneInlineInput = {
  /** Connect existing Banner1 document */
  connect?: InputMaybe<Banner1WhereUniqueInput>;
  /** Create and connect one Banner1 document */
  create?: InputMaybe<Banner1CreateInput>;
  /** Delete currently connected Banner1 document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Banner1 document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Banner1 document */
  update?: InputMaybe<Banner1UpdateWithNestedWhereUniqueInput>;
  /** Upsert single Banner1 document */
  upsert?: InputMaybe<Banner1UpsertWithNestedWhereUniqueInput>;
};

export type Banner1UpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: Banner1UpdateInput;
  /** Unique document search */
  where: Banner1WhereUniqueInput;
};

export type Banner1UpsertInput = {
  /** Create document if it didn't exist */
  create: Banner1CreateInput;
  /** Update document if it exists */
  update: Banner1UpdateInput;
};

export type Banner1UpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: Banner1UpsertInput;
  /** Unique document search */
  where: Banner1WhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type Banner1WhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type Banner1WhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<Banner1WhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<Banner1WhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<Banner1WhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundAsset?: InputMaybe<AssetComponentWhereInput>;
  buttonColor?: InputMaybe<ButtonColor>;
  /** All values that are contained in given list. */
  buttonColor_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonColor_not?: InputMaybe<ButtonColor>;
  /** All values that are not contained in given list. */
  buttonColor_not_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<Banner1WhereStageInput>;
  documentInStages_none?: InputMaybe<Banner1WhereStageInput>;
  documentInStages_some?: InputMaybe<Banner1WhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  lowerLeftCorner?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upperRightCorner?: InputMaybe<AssetComponentWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type Banner1WhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<Banner1WhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<Banner1WhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<Banner1WhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<Banner1WhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Banner1 record uniquely */
export type Banner1WhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Banner2 with image and text and placement options */
export type Banner2 = Entity & Node & {
  __typename?: 'Banner2';
  anchorNav?: Maybe<AnchorNavigation>;
  /** For the main image of the banner */
  backgroundAsset?: Maybe<AssetComponent>;
  banner2CarouselComponents: Array<Banner2CarouselComponent>;
  buttonColor: ButtonColor;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<Banner2>;
  /** Whether the image should span the whole page or not */
  fullBleed?: Maybe<Scalars['Boolean']['output']>;
  genericPages: Array<GenericPage>;
  /** List of Banner2 versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Banner2>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** For the mobile image of the banner */
  mobileBackgroundAsset?: Maybe<AssetComponent>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  /** Superscript tag line */
  superText?: Maybe<Scalars['String']['output']>;
  tabContent?: Maybe<TabContent>;
  /** Choose left or right as an option */
  textAlignment?: Maybe<LeftRight>;
  /** Title of the banner */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Banner2 with image and text and placement options */
export type Banner2AnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner2 with image and text and placement options */
export type Banner2BackgroundAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner2 with image and text and placement options */
export type Banner2Banner2CarouselComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<Banner2CarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Banner2CarouselComponentWhereInput>;
};


/** Banner2 with image and text and placement options */
export type Banner2CreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Banner2 with image and text and placement options */
export type Banner2CreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner2 with image and text and placement options */
export type Banner2DocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Banner2 with image and text and placement options */
export type Banner2GenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Banner2 with image and text and placement options */
export type Banner2HistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Banner2 with image and text and placement options */
export type Banner2LinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner2 with image and text and placement options */
export type Banner2LocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Banner2 with image and text and placement options */
export type Banner2MarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner2 with image and text and placement options */
export type Banner2MobileBackgroundAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner2 with image and text and placement options */
export type Banner2ProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


/** Banner2 with image and text and placement options */
export type Banner2ProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


/** Banner2 with image and text and placement options */
export type Banner2ProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


/** Banner2 with image and text and placement options */
export type Banner2PublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Banner2 with image and text and placement options */
export type Banner2PublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner2 with image and text and placement options */
export type Banner2RecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


/** Banner2 with image and text and placement options */
export type Banner2RecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


/** Banner2 with image and text and placement options */
export type Banner2RecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


/** Banner2 with image and text and placement options */
export type Banner2ScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Banner2 with image and text and placement options */
export type Banner2SubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner2 with image and text and placement options */
export type Banner2TabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner2 with image and text and placement options */
export type Banner2UpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Banner2 with image and text and placement options */
export type Banner2UpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type Banner2CarouselComponent = Entity & Node & {
  __typename?: 'Banner2CarouselComponent';
  banner2: Array<Banner2>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Banner2CarouselComponent>;
  genericPages: Array<GenericPage>;
  /** List of Banner2CarouselComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type Banner2CarouselComponentBanner2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<Banner2OrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Banner2WhereInput>;
};


export type Banner2CarouselComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type Banner2CarouselComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type Banner2CarouselComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type Banner2CarouselComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type Banner2CarouselComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type Banner2CarouselComponentProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


export type Banner2CarouselComponentProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


export type Banner2CarouselComponentProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


export type Banner2CarouselComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type Banner2CarouselComponentRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type Banner2CarouselComponentRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


export type Banner2CarouselComponentRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


export type Banner2CarouselComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type Banner2CarouselComponentSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type Banner2CarouselComponentTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type Banner2CarouselComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type Banner2CarouselComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: Banner2CarouselComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type Banner2CarouselComponentConnection = {
  __typename?: 'Banner2CarouselComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<Banner2CarouselComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type Banner2CarouselComponentCreateInput = {
  banner2?: InputMaybe<Banner2CreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Banner2CarouselComponentCreateManyInlineInput = {
  /** Connect multiple existing Banner2CarouselComponent documents */
  connect?: InputMaybe<Array<Banner2CarouselComponentWhereUniqueInput>>;
  /** Create and connect multiple existing Banner2CarouselComponent documents */
  create?: InputMaybe<Array<Banner2CarouselComponentCreateInput>>;
};

export type Banner2CarouselComponentCreateOneInlineInput = {
  /** Connect one existing Banner2CarouselComponent document */
  connect?: InputMaybe<Banner2CarouselComponentWhereUniqueInput>;
  /** Create and connect one Banner2CarouselComponent document */
  create?: InputMaybe<Banner2CarouselComponentCreateInput>;
};

/** An edge in a connection. */
export type Banner2CarouselComponentEdge = {
  __typename?: 'Banner2CarouselComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Banner2CarouselComponent;
};

/** Identifies documents */
export type Banner2CarouselComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<Banner2CarouselComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<Banner2CarouselComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<Banner2CarouselComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  banner2_every?: InputMaybe<Banner2WhereInput>;
  banner2_none?: InputMaybe<Banner2WhereInput>;
  banner2_some?: InputMaybe<Banner2WhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<Banner2CarouselComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<Banner2CarouselComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<Banner2CarouselComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum Banner2CarouselComponentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type Banner2CarouselComponentUpdateInput = {
  banner2?: InputMaybe<Banner2UpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Banner2CarouselComponentUpdateManyInlineInput = {
  /** Connect multiple existing Banner2CarouselComponent documents */
  connect?: InputMaybe<Array<Banner2CarouselComponentConnectInput>>;
  /** Create and connect multiple Banner2CarouselComponent documents */
  create?: InputMaybe<Array<Banner2CarouselComponentCreateInput>>;
  /** Delete multiple Banner2CarouselComponent documents */
  delete?: InputMaybe<Array<Banner2CarouselComponentWhereUniqueInput>>;
  /** Disconnect multiple Banner2CarouselComponent documents */
  disconnect?: InputMaybe<Array<Banner2CarouselComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Banner2CarouselComponent documents */
  set?: InputMaybe<Array<Banner2CarouselComponentWhereUniqueInput>>;
  /** Update multiple Banner2CarouselComponent documents */
  update?: InputMaybe<Array<Banner2CarouselComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Banner2CarouselComponent documents */
  upsert?: InputMaybe<Array<Banner2CarouselComponentUpsertWithNestedWhereUniqueInput>>;
};

export type Banner2CarouselComponentUpdateManyInput = {
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Banner2CarouselComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: Banner2CarouselComponentUpdateManyInput;
  /** Document search */
  where: Banner2CarouselComponentWhereInput;
};

export type Banner2CarouselComponentUpdateOneInlineInput = {
  /** Connect existing Banner2CarouselComponent document */
  connect?: InputMaybe<Banner2CarouselComponentWhereUniqueInput>;
  /** Create and connect one Banner2CarouselComponent document */
  create?: InputMaybe<Banner2CarouselComponentCreateInput>;
  /** Delete currently connected Banner2CarouselComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Banner2CarouselComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Banner2CarouselComponent document */
  update?: InputMaybe<Banner2CarouselComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Banner2CarouselComponent document */
  upsert?: InputMaybe<Banner2CarouselComponentUpsertWithNestedWhereUniqueInput>;
};

export type Banner2CarouselComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: Banner2CarouselComponentUpdateInput;
  /** Unique document search */
  where: Banner2CarouselComponentWhereUniqueInput;
};

export type Banner2CarouselComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: Banner2CarouselComponentCreateInput;
  /** Update document if it exists */
  update: Banner2CarouselComponentUpdateInput;
};

export type Banner2CarouselComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: Banner2CarouselComponentUpsertInput;
  /** Unique document search */
  where: Banner2CarouselComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type Banner2CarouselComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type Banner2CarouselComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<Banner2CarouselComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<Banner2CarouselComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<Banner2CarouselComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  banner2_every?: InputMaybe<Banner2WhereInput>;
  banner2_none?: InputMaybe<Banner2WhereInput>;
  banner2_some?: InputMaybe<Banner2WhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<Banner2CarouselComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<Banner2CarouselComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<Banner2CarouselComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type Banner2CarouselComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<Banner2CarouselComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<Banner2CarouselComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<Banner2CarouselComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<Banner2CarouselComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Banner2CarouselComponent record uniquely */
export type Banner2CarouselComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Banner2ConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: Banner2WhereUniqueInput;
};

/** A connection to a list of items. */
export type Banner2Connection = {
  __typename?: 'Banner2Connection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<Banner2Edge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type Banner2CreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  backgroundAsset?: InputMaybe<AssetComponentCreateOneInlineInput>;
  banner2CarouselComponents?: InputMaybe<Banner2CarouselComponentCreateManyInlineInput>;
  buttonColor: ButtonColor;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fullBleed?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<Banner2CreateLocalizationsInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  mobileBackgroundAsset?: InputMaybe<AssetComponentCreateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  /** textAlignment input for default locale (en) */
  textAlignment?: InputMaybe<LeftRight>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Banner2CreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  textAlignment?: InputMaybe<LeftRight>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Banner2CreateLocalizationInput = {
  /** Localization input */
  data: Banner2CreateLocalizationDataInput;
  locale: Locale;
};

export type Banner2CreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<Banner2CreateLocalizationInput>>;
};

export type Banner2CreateManyInlineInput = {
  /** Connect multiple existing Banner2 documents */
  connect?: InputMaybe<Array<Banner2WhereUniqueInput>>;
  /** Create and connect multiple existing Banner2 documents */
  create?: InputMaybe<Array<Banner2CreateInput>>;
};

export type Banner2CreateOneInlineInput = {
  /** Connect one existing Banner2 document */
  connect?: InputMaybe<Banner2WhereUniqueInput>;
  /** Create and connect one Banner2 document */
  create?: InputMaybe<Banner2CreateInput>;
};

/** An edge in a connection. */
export type Banner2Edge = {
  __typename?: 'Banner2Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Banner2;
};

/** Identifies documents */
export type Banner2ManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<Banner2WhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<Banner2WhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<Banner2WhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundAsset?: InputMaybe<AssetComponentWhereInput>;
  banner2CarouselComponents_every?: InputMaybe<Banner2CarouselComponentWhereInput>;
  banner2CarouselComponents_none?: InputMaybe<Banner2CarouselComponentWhereInput>;
  banner2CarouselComponents_some?: InputMaybe<Banner2CarouselComponentWhereInput>;
  buttonColor?: InputMaybe<ButtonColor>;
  /** All values that are contained in given list. */
  buttonColor_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonColor_not?: InputMaybe<ButtonColor>;
  /** All values that are not contained in given list. */
  buttonColor_not_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<Banner2WhereStageInput>;
  documentInStages_none?: InputMaybe<Banner2WhereStageInput>;
  documentInStages_some?: InputMaybe<Banner2WhereStageInput>;
  fullBleed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  fullBleed_not?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  mobileBackgroundAsset?: InputMaybe<AssetComponentWhereInput>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum Banner2OrderByInput {
  buttonColor_ASC = 'buttonColor_ASC',
  buttonColor_DESC = 'buttonColor_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  fullBleed_ASC = 'fullBleed_ASC',
  fullBleed_DESC = 'fullBleed_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  textAlignment_ASC = 'textAlignment_ASC',
  textAlignment_DESC = 'textAlignment_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type Banner2UpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  backgroundAsset?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  banner2CarouselComponents?: InputMaybe<Banner2CarouselComponentUpdateManyInlineInput>;
  buttonColor?: InputMaybe<ButtonColor>;
  description?: InputMaybe<Scalars['String']['input']>;
  fullBleed?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<Banner2UpdateLocalizationsInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  mobileBackgroundAsset?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  /** textAlignment input for default locale (en) */
  textAlignment?: InputMaybe<LeftRight>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Banner2UpdateLocalizationDataInput = {
  textAlignment?: InputMaybe<LeftRight>;
};

export type Banner2UpdateLocalizationInput = {
  data: Banner2UpdateLocalizationDataInput;
  locale: Locale;
};

export type Banner2UpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<Banner2CreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<Banner2UpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<Banner2UpsertLocalizationInput>>;
};

export type Banner2UpdateManyInlineInput = {
  /** Connect multiple existing Banner2 documents */
  connect?: InputMaybe<Array<Banner2ConnectInput>>;
  /** Create and connect multiple Banner2 documents */
  create?: InputMaybe<Array<Banner2CreateInput>>;
  /** Delete multiple Banner2 documents */
  delete?: InputMaybe<Array<Banner2WhereUniqueInput>>;
  /** Disconnect multiple Banner2 documents */
  disconnect?: InputMaybe<Array<Banner2WhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Banner2 documents */
  set?: InputMaybe<Array<Banner2WhereUniqueInput>>;
  /** Update multiple Banner2 documents */
  update?: InputMaybe<Array<Banner2UpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Banner2 documents */
  upsert?: InputMaybe<Array<Banner2UpsertWithNestedWhereUniqueInput>>;
};

export type Banner2UpdateManyInput = {
  buttonColor?: InputMaybe<ButtonColor>;
  description?: InputMaybe<Scalars['String']['input']>;
  fullBleed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<Banner2UpdateManyLocalizationsInput>;
  market?: InputMaybe<Markets>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** textAlignment input for default locale (en) */
  textAlignment?: InputMaybe<LeftRight>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Banner2UpdateManyLocalizationDataInput = {
  textAlignment?: InputMaybe<LeftRight>;
};

export type Banner2UpdateManyLocalizationInput = {
  data: Banner2UpdateManyLocalizationDataInput;
  locale: Locale;
};

export type Banner2UpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<Banner2UpdateManyLocalizationInput>>;
};

export type Banner2UpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: Banner2UpdateManyInput;
  /** Document search */
  where: Banner2WhereInput;
};

export type Banner2UpdateOneInlineInput = {
  /** Connect existing Banner2 document */
  connect?: InputMaybe<Banner2WhereUniqueInput>;
  /** Create and connect one Banner2 document */
  create?: InputMaybe<Banner2CreateInput>;
  /** Delete currently connected Banner2 document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Banner2 document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Banner2 document */
  update?: InputMaybe<Banner2UpdateWithNestedWhereUniqueInput>;
  /** Upsert single Banner2 document */
  upsert?: InputMaybe<Banner2UpsertWithNestedWhereUniqueInput>;
};

export type Banner2UpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: Banner2UpdateInput;
  /** Unique document search */
  where: Banner2WhereUniqueInput;
};

export type Banner2UpsertInput = {
  /** Create document if it didn't exist */
  create: Banner2CreateInput;
  /** Update document if it exists */
  update: Banner2UpdateInput;
};

export type Banner2UpsertLocalizationInput = {
  create: Banner2CreateLocalizationDataInput;
  locale: Locale;
  update: Banner2UpdateLocalizationDataInput;
};

export type Banner2UpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: Banner2UpsertInput;
  /** Unique document search */
  where: Banner2WhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type Banner2WhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type Banner2WhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<Banner2WhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<Banner2WhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<Banner2WhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundAsset?: InputMaybe<AssetComponentWhereInput>;
  banner2CarouselComponents_every?: InputMaybe<Banner2CarouselComponentWhereInput>;
  banner2CarouselComponents_none?: InputMaybe<Banner2CarouselComponentWhereInput>;
  banner2CarouselComponents_some?: InputMaybe<Banner2CarouselComponentWhereInput>;
  buttonColor?: InputMaybe<ButtonColor>;
  /** All values that are contained in given list. */
  buttonColor_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonColor_not?: InputMaybe<ButtonColor>;
  /** All values that are not contained in given list. */
  buttonColor_not_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<Banner2WhereStageInput>;
  documentInStages_none?: InputMaybe<Banner2WhereStageInput>;
  documentInStages_some?: InputMaybe<Banner2WhereStageInput>;
  fullBleed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  fullBleed_not?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  mobileBackgroundAsset?: InputMaybe<AssetComponentWhereInput>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  textAlignment?: InputMaybe<LeftRight>;
  /** All values that are contained in given list. */
  textAlignment_in?: InputMaybe<Array<InputMaybe<LeftRight>>>;
  /** Any other value that exists and is not equal to the given value. */
  textAlignment_not?: InputMaybe<LeftRight>;
  /** All values that are not contained in given list. */
  textAlignment_not_in?: InputMaybe<Array<InputMaybe<LeftRight>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type Banner2WhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<Banner2WhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<Banner2WhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<Banner2WhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<Banner2WhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Banner2 record uniquely */
export type Banner2WhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum BannerHeight {
  Short = 'Short',
  Tall = 'Tall'
}

/** Type of banner */
export enum BannerType {
  alcohol_warning = 'alcohol_warning',
  recall_campaign = 'recall_campaign'
}

/** Colour of the video play button and text */
export enum BannerVideoPlayAndTextColour {
  Black = 'Black',
  Grey = 'Grey',
  White = 'White'
}

export type BatchPayload = {
  __typename?: 'BatchPayload';
  /** The number of nodes that have been affected by the Batch operation. */
  count: Scalars['Long']['output'];
};

export enum Brand {
  Alsa = 'Alsa',
  Bakkennl = 'Bakkennl',
  Cameo = 'Cameo',
  Chicagotown = 'Chicagotown',
  DGari = 'DGari',
  DrOetker = 'DrOetker',
  Koopmans = 'Koopmans',
  Mavalerio = 'Mavalerio',
  Rexal = 'Rexal',
  Wilton = 'Wilton'
}

/** Button colour for better contrast */
export enum ButtonColor {
  Dark = 'Dark',
  Light = 'Light'
}

export enum CampaignTypes {
  AdventCalendar = 'AdventCalendar',
  AnimatedGame = 'AnimatedGame',
  BattleOnePageQuizWithImages = 'BattleOnePageQuizWithImages',
  Branching = 'Branching',
  BranchingPersonalityTest = 'BranchingPersonalityTest',
  Checklist = 'Checklist',
  ChronoQuiz = 'ChronoQuiz',
  CoregistrationForm = 'CoregistrationForm',
  CumulativeQuiz = 'CumulativeQuiz',
  Form = 'Form',
  GuessTheWord = 'GuessTheWord',
  InstantWin = 'InstantWin',
  Jackpot = 'Jackpot',
  LandingPage = 'LandingPage',
  Memory = 'Memory',
  None = 'None',
  OnePagePersonalityTestWithImages = 'OnePagePersonalityTestWithImages',
  PersonalityTest = 'PersonalityTest',
  PhotoContestUpload = 'PhotoContestUpload',
  PhotoContestVote = 'PhotoContestVote',
  Poll = 'Poll',
  PollWithImages = 'PollWithImages',
  Prediction = 'Prediction',
  PromotionalPopUp = 'PromotionalPopUp',
  Puzzle = 'Puzzle',
  Quiz = 'Quiz',
  Slideshow = 'Slideshow',
  SlidingPuzzle = 'SlidingPuzzle',
  SuddenDeath = 'SuddenDeath',
  Survey = 'Survey',
  SwiperPersonalityTest = 'SwiperPersonalityTest',
  SwiperPoll = 'SwiperPoll',
  SwiperQuiz = 'SwiperQuiz',
  TeamSelector = 'TeamSelector',
  TwitterLiveRanking = 'TwitterLiveRanking',
  Unknown = 'Unknown',
  VideoContestUpload = 'VideoContestUpload',
  VideoContestVote = 'VideoContestVote',
  WheelOfFortune = 'WheelOfFortune',
  WritingCompetitionUpload = 'WritingCompetitionUpload',
  WritingCompetitionVote = 'WritingCompetitionVote'
}

/** Card Component */
export type CardComponent = Entity & Node & {
  __typename?: 'CardComponent';
  /** Id for the Recipe, Product or Article etc */
  cardId: Scalars['String']['output'];
  /** Variation of card. Example - recipe, product, article etc */
  cardVariation?: Maybe<CardVariation>;
  /** Category in which cards belongs. */
  category: Scalars['String']['output'];
  /** Card Category ID */
  categoryId: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Description on the card */
  description?: Maybe<Scalars['String']['output']>;
  difficulty?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<CardComponent>;
  /** List of CardComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image: Array<CardComponentImage>;
  link?: Maybe<Link>;
  /** Title on card link */
  linkTitle?: Maybe<Scalars['String']['output']>;
  market: Markets;
  marketName?: Maybe<Market>;
  navigation?: Maybe<Navigation>;
  /** Category to which card belongs. Example - Recipe, Products, Articles etc */
  parentCategory?: Maybe<Scalars['String']['output']>;
  /** Card Navigation  */
  parentPage?: Maybe<Scalars['String']['output']>;
  /** For Recipe preparation time */
  preparationTime?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Rating for the Recipe */
  rating?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subCategory?: Maybe<Scalars['String']['output']>;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  /** Display Title of the card */
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Url of the video */
  video?: Maybe<Scalars['String']['output']>;
};


/** Card Component */
export type CardComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Card Component */
export type CardComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Card Component */
export type CardComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Card Component */
export type CardComponentImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Card Component */
export type CardComponentLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Card Component */
export type CardComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Card Component */
export type CardComponentNavigationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Card Component */
export type CardComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Card Component */
export type CardComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Card Component */
export type CardComponentSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Card Component */
export type CardComponentTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Card Component */
export type CardComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CardComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CardComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type CardComponentConnection = {
  __typename?: 'CardComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CardComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CardComponentCreateInput = {
  cardId: Scalars['String']['input'];
  cardVariation?: InputMaybe<CardVariation>;
  category: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<CardComponentImageCreateManyInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  navigation?: InputMaybe<NavigationCreateOneInlineInput>;
  parentCategory?: InputMaybe<Scalars['String']['input']>;
  parentPage?: InputMaybe<Scalars['String']['input']>;
  preparationTime?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['String']['input']>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type CardComponentCreateManyInlineInput = {
  /** Connect multiple existing CardComponent documents */
  connect?: InputMaybe<Array<CardComponentWhereUniqueInput>>;
  /** Create and connect multiple existing CardComponent documents */
  create?: InputMaybe<Array<CardComponentCreateInput>>;
};

export type CardComponentCreateOneInlineInput = {
  /** Connect one existing CardComponent document */
  connect?: InputMaybe<CardComponentWhereUniqueInput>;
  /** Create and connect one CardComponent document */
  create?: InputMaybe<CardComponentCreateInput>;
};

/** An edge in a connection. */
export type CardComponentEdge = {
  __typename?: 'CardComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CardComponent;
};

export type CardComponentImage = AssetComponent;

export type CardComponentImageConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type CardComponentImageCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type CardComponentImageCreateManyInlineInput = {
  /** Connect multiple existing CardComponentImage documents */
  connect?: InputMaybe<Array<CardComponentImageWhereUniqueInput>>;
  /** Create and connect multiple existing CardComponentImage documents */
  create?: InputMaybe<Array<CardComponentImageCreateInput>>;
};

export type CardComponentImageCreateOneInlineInput = {
  /** Connect one existing CardComponentImage document */
  connect?: InputMaybe<CardComponentImageWhereUniqueInput>;
  /** Create and connect one CardComponentImage document */
  create?: InputMaybe<CardComponentImageCreateInput>;
};

export type CardComponentImageUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type CardComponentImageUpdateManyInlineInput = {
  /** Connect multiple existing CardComponentImage documents */
  connect?: InputMaybe<Array<CardComponentImageConnectInput>>;
  /** Create and connect multiple CardComponentImage documents */
  create?: InputMaybe<Array<CardComponentImageCreateInput>>;
  /** Delete multiple CardComponentImage documents */
  delete?: InputMaybe<Array<CardComponentImageWhereUniqueInput>>;
  /** Disconnect multiple CardComponentImage documents */
  disconnect?: InputMaybe<Array<CardComponentImageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CardComponentImage documents */
  set?: InputMaybe<Array<CardComponentImageWhereUniqueInput>>;
  /** Update multiple CardComponentImage documents */
  update?: InputMaybe<Array<CardComponentImageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CardComponentImage documents */
  upsert?: InputMaybe<Array<CardComponentImageUpsertWithNestedWhereUniqueInput>>;
};

export type CardComponentImageUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type CardComponentImageUpdateOneInlineInput = {
  /** Connect existing CardComponentImage document */
  connect?: InputMaybe<CardComponentImageWhereUniqueInput>;
  /** Create and connect one CardComponentImage document */
  create?: InputMaybe<CardComponentImageCreateInput>;
  /** Delete currently connected CardComponentImage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CardComponentImage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CardComponentImage document */
  update?: InputMaybe<CardComponentImageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CardComponentImage document */
  upsert?: InputMaybe<CardComponentImageUpsertWithNestedWhereUniqueInput>;
};

export type CardComponentImageUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type CardComponentImageUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type CardComponentImageWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type CardComponentImageWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

/** Identifies documents */
export type CardComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CardComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CardComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CardComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardId_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardVariation?: InputMaybe<CardVariation>;
  /** All values that are contained in given list. */
  cardVariation_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardVariation_not?: InputMaybe<CardVariation>;
  /** All values that are not contained in given list. */
  cardVariation_not_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  categoryId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  categoryId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  categoryId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  categoryId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  categoryId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  categoryId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  categoryId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  categoryId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  categoryId_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  category_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  category_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  category_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  category_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  category_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  category_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  difficulty_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  difficulty_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  difficulty_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  difficulty_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  difficulty_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  difficulty_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  difficulty_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  difficulty_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  difficulty_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CardComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<CardComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<CardComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  image_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  image_some?: InputMaybe<CardComponentImageWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  navigation?: InputMaybe<NavigationWhereInput>;
  parentCategory?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  parentCategory_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  parentCategory_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  parentCategory_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  parentCategory_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  parentCategory_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  parentCategory_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  parentCategory_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  parentCategory_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  parentCategory_starts_with?: InputMaybe<Scalars['String']['input']>;
  parentPage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  parentPage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  parentPage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  parentPage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  parentPage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  parentPage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  parentPage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  parentPage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  parentPage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  parentPage_starts_with?: InputMaybe<Scalars['String']['input']>;
  preparationTime?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  preparationTime_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  preparationTime_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  preparationTime_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  preparationTime_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  preparationTime_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  preparationTime_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  preparationTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  preparationTime_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  preparationTime_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  rating?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  rating_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  rating_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  rating_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  rating_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  rating_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  rating_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  rating_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  rating_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  rating_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subCategory_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subCategory_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subCategory_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subCategory_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subCategory_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subCategory_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subCategory_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subCategory_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subCategory_starts_with?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  video_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  video_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  video_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  video_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  video_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  video_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  video_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  video_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  video_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum CardComponentOrderByInput {
  cardId_ASC = 'cardId_ASC',
  cardId_DESC = 'cardId_DESC',
  cardVariation_ASC = 'cardVariation_ASC',
  cardVariation_DESC = 'cardVariation_DESC',
  categoryId_ASC = 'categoryId_ASC',
  categoryId_DESC = 'categoryId_DESC',
  category_ASC = 'category_ASC',
  category_DESC = 'category_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  difficulty_ASC = 'difficulty_ASC',
  difficulty_DESC = 'difficulty_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  linkTitle_ASC = 'linkTitle_ASC',
  linkTitle_DESC = 'linkTitle_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  parentCategory_ASC = 'parentCategory_ASC',
  parentCategory_DESC = 'parentCategory_DESC',
  parentPage_ASC = 'parentPage_ASC',
  parentPage_DESC = 'parentPage_DESC',
  preparationTime_ASC = 'preparationTime_ASC',
  preparationTime_DESC = 'preparationTime_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  rating_ASC = 'rating_ASC',
  rating_DESC = 'rating_DESC',
  subCategory_ASC = 'subCategory_ASC',
  subCategory_DESC = 'subCategory_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  video_ASC = 'video_ASC',
  video_DESC = 'video_DESC'
}

export type CardComponentUpdateInput = {
  cardId?: InputMaybe<Scalars['String']['input']>;
  cardVariation?: InputMaybe<CardVariation>;
  category?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<CardComponentImageUpdateManyInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  navigation?: InputMaybe<NavigationUpdateOneInlineInput>;
  parentCategory?: InputMaybe<Scalars['String']['input']>;
  parentPage?: InputMaybe<Scalars['String']['input']>;
  preparationTime?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['String']['input']>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type CardComponentUpdateManyInlineInput = {
  /** Connect multiple existing CardComponent documents */
  connect?: InputMaybe<Array<CardComponentConnectInput>>;
  /** Create and connect multiple CardComponent documents */
  create?: InputMaybe<Array<CardComponentCreateInput>>;
  /** Delete multiple CardComponent documents */
  delete?: InputMaybe<Array<CardComponentWhereUniqueInput>>;
  /** Disconnect multiple CardComponent documents */
  disconnect?: InputMaybe<Array<CardComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CardComponent documents */
  set?: InputMaybe<Array<CardComponentWhereUniqueInput>>;
  /** Update multiple CardComponent documents */
  update?: InputMaybe<Array<CardComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CardComponent documents */
  upsert?: InputMaybe<Array<CardComponentUpsertWithNestedWhereUniqueInput>>;
};

export type CardComponentUpdateManyInput = {
  cardVariation?: InputMaybe<CardVariation>;
  category?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  parentCategory?: InputMaybe<Scalars['String']['input']>;
  parentPage?: InputMaybe<Scalars['String']['input']>;
  preparationTime?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['String']['input']>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type CardComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CardComponentUpdateManyInput;
  /** Document search */
  where: CardComponentWhereInput;
};

export type CardComponentUpdateOneInlineInput = {
  /** Connect existing CardComponent document */
  connect?: InputMaybe<CardComponentWhereUniqueInput>;
  /** Create and connect one CardComponent document */
  create?: InputMaybe<CardComponentCreateInput>;
  /** Delete currently connected CardComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CardComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CardComponent document */
  update?: InputMaybe<CardComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CardComponent document */
  upsert?: InputMaybe<CardComponentUpsertWithNestedWhereUniqueInput>;
};

export type CardComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CardComponentUpdateInput;
  /** Unique document search */
  where: CardComponentWhereUniqueInput;
};

export type CardComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: CardComponentCreateInput;
  /** Update document if it exists */
  update: CardComponentUpdateInput;
};

export type CardComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CardComponentUpsertInput;
  /** Unique document search */
  where: CardComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CardComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CardComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CardComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CardComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CardComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardId_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardVariation?: InputMaybe<CardVariation>;
  /** All values that are contained in given list. */
  cardVariation_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardVariation_not?: InputMaybe<CardVariation>;
  /** All values that are not contained in given list. */
  cardVariation_not_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  categoryId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  categoryId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  categoryId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  categoryId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  categoryId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  categoryId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  categoryId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  categoryId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  categoryId_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  category_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  category_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  category_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  category_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  category_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  category_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  difficulty_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  difficulty_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  difficulty_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  difficulty_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  difficulty_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  difficulty_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  difficulty_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  difficulty_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  difficulty_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CardComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<CardComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<CardComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  image_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  image_some?: InputMaybe<CardComponentImageWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  navigation?: InputMaybe<NavigationWhereInput>;
  parentCategory?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  parentCategory_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  parentCategory_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  parentCategory_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  parentCategory_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  parentCategory_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  parentCategory_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  parentCategory_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  parentCategory_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  parentCategory_starts_with?: InputMaybe<Scalars['String']['input']>;
  parentPage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  parentPage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  parentPage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  parentPage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  parentPage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  parentPage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  parentPage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  parentPage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  parentPage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  parentPage_starts_with?: InputMaybe<Scalars['String']['input']>;
  preparationTime?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  preparationTime_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  preparationTime_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  preparationTime_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  preparationTime_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  preparationTime_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  preparationTime_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  preparationTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  preparationTime_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  preparationTime_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  rating?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  rating_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  rating_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  rating_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  rating_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  rating_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  rating_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  rating_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  rating_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  rating_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subCategory_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subCategory_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subCategory_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subCategory_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subCategory_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subCategory_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subCategory_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subCategory_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subCategory_starts_with?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  video_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  video_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  video_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  video_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  video_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  video_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  video_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  video_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  video_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CardComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CardComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CardComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CardComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CardComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CardComponent record uniquely */
export type CardComponentWhereUniqueInput = {
  cardId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Card Layout  */
export enum CardLayout {
  Carousel = 'Carousel',
  Grid = 'Grid'
}

/** Card Varistion */
export enum CardVariation {
  article = 'article',
  object = 'object',
  product = 'product',
  recipe = 'recipe',
  tipsAndTricks = 'tipsAndTricks',
  white = 'white'
}

export type CarouselComponent = Entity & Node & {
  __typename?: 'CarouselComponent';
  anchorNav?: Maybe<AnchorNavigation>;
  backgroundImg?: Maybe<Asset>;
  bottomLeftAsset?: Maybe<Asset>;
  carouselName: Scalars['String']['output'];
  carouselSlides: Array<CarouselSlide>;
  carouselType: CarouselType;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CarouselComponent>;
  genericPages: Array<GenericPage>;
  heading?: Maybe<Scalars['String']['output']>;
  /** List of CarouselComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** This is the number of slides a user can see per one carousel slide */
  slidesToShow?: Maybe<Scalars['Int']['output']>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  title?: Maybe<Scalars['String']['output']>;
  topRightAsset?: Maybe<Asset>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CarouselComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselComponentBackgroundImgArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CarouselComponentBottomLeftAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CarouselComponentCarouselSlidesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CarouselSlideOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselSlideWhereInput>;
};


export type CarouselComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CarouselComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type CarouselComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CarouselComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselComponentProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


export type CarouselComponentProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


export type CarouselComponentProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


export type CarouselComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselComponentRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type CarouselComponentRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


export type CarouselComponentRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


export type CarouselComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CarouselComponentSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselComponentTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselComponentTopRightAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CarouselComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CarouselComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CarouselComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type CarouselComponentConnection = {
  __typename?: 'CarouselComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CarouselComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CarouselComponentCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  backgroundImg?: InputMaybe<AssetCreateOneInlineInput>;
  bottomLeftAsset?: InputMaybe<AssetCreateOneInlineInput>;
  carouselName: Scalars['String']['input'];
  carouselSlides?: InputMaybe<CarouselSlideCreateManyInlineInput>;
  carouselType: CarouselType;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  slidesToShow?: InputMaybe<Scalars['Int']['input']>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  topRightAsset?: InputMaybe<AssetCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CarouselComponentCreateManyInlineInput = {
  /** Connect multiple existing CarouselComponent documents */
  connect?: InputMaybe<Array<CarouselComponentWhereUniqueInput>>;
  /** Create and connect multiple existing CarouselComponent documents */
  create?: InputMaybe<Array<CarouselComponentCreateInput>>;
};

export type CarouselComponentCreateOneInlineInput = {
  /** Connect one existing CarouselComponent document */
  connect?: InputMaybe<CarouselComponentWhereUniqueInput>;
  /** Create and connect one CarouselComponent document */
  create?: InputMaybe<CarouselComponentCreateInput>;
};

/** An edge in a connection. */
export type CarouselComponentEdge = {
  __typename?: 'CarouselComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CarouselComponent;
};

/** Identifies documents */
export type CarouselComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CarouselComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CarouselComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CarouselComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundImg?: InputMaybe<AssetWhereInput>;
  bottomLeftAsset?: InputMaybe<AssetWhereInput>;
  carouselName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  carouselName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  carouselName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  carouselName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  carouselName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  carouselName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  carouselName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  carouselName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  carouselName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  carouselName_starts_with?: InputMaybe<Scalars['String']['input']>;
  carouselSlides_every?: InputMaybe<CarouselSlideWhereInput>;
  carouselSlides_none?: InputMaybe<CarouselSlideWhereInput>;
  carouselSlides_some?: InputMaybe<CarouselSlideWhereInput>;
  carouselType?: InputMaybe<CarouselType>;
  /** All values that are contained in given list. */
  carouselType_in?: InputMaybe<Array<InputMaybe<CarouselType>>>;
  /** Any other value that exists and is not equal to the given value. */
  carouselType_not?: InputMaybe<CarouselType>;
  /** All values that are not contained in given list. */
  carouselType_not_in?: InputMaybe<Array<InputMaybe<CarouselType>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CarouselComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<CarouselComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<CarouselComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slidesToShow?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  slidesToShow_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  slidesToShow_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  slidesToShow_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  slidesToShow_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  slidesToShow_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  slidesToShow_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  slidesToShow_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  topRightAsset?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CarouselComponentOrderByInput {
  carouselName_ASC = 'carouselName_ASC',
  carouselName_DESC = 'carouselName_DESC',
  carouselType_ASC = 'carouselType_ASC',
  carouselType_DESC = 'carouselType_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slidesToShow_ASC = 'slidesToShow_ASC',
  slidesToShow_DESC = 'slidesToShow_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CarouselComponentUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  backgroundImg?: InputMaybe<AssetUpdateOneInlineInput>;
  bottomLeftAsset?: InputMaybe<AssetUpdateOneInlineInput>;
  carouselName?: InputMaybe<Scalars['String']['input']>;
  carouselSlides?: InputMaybe<CarouselSlideUpdateManyInlineInput>;
  carouselType?: InputMaybe<CarouselType>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  slidesToShow?: InputMaybe<Scalars['Int']['input']>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  topRightAsset?: InputMaybe<AssetUpdateOneInlineInput>;
};

export type CarouselComponentUpdateManyInlineInput = {
  /** Connect multiple existing CarouselComponent documents */
  connect?: InputMaybe<Array<CarouselComponentConnectInput>>;
  /** Create and connect multiple CarouselComponent documents */
  create?: InputMaybe<Array<CarouselComponentCreateInput>>;
  /** Delete multiple CarouselComponent documents */
  delete?: InputMaybe<Array<CarouselComponentWhereUniqueInput>>;
  /** Disconnect multiple CarouselComponent documents */
  disconnect?: InputMaybe<Array<CarouselComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CarouselComponent documents */
  set?: InputMaybe<Array<CarouselComponentWhereUniqueInput>>;
  /** Update multiple CarouselComponent documents */
  update?: InputMaybe<Array<CarouselComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CarouselComponent documents */
  upsert?: InputMaybe<Array<CarouselComponentUpsertWithNestedWhereUniqueInput>>;
};

export type CarouselComponentUpdateManyInput = {
  carouselName?: InputMaybe<Scalars['String']['input']>;
  carouselType?: InputMaybe<CarouselType>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  slidesToShow?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CarouselComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CarouselComponentUpdateManyInput;
  /** Document search */
  where: CarouselComponentWhereInput;
};

export type CarouselComponentUpdateOneInlineInput = {
  /** Connect existing CarouselComponent document */
  connect?: InputMaybe<CarouselComponentWhereUniqueInput>;
  /** Create and connect one CarouselComponent document */
  create?: InputMaybe<CarouselComponentCreateInput>;
  /** Delete currently connected CarouselComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CarouselComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CarouselComponent document */
  update?: InputMaybe<CarouselComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CarouselComponent document */
  upsert?: InputMaybe<CarouselComponentUpsertWithNestedWhereUniqueInput>;
};

export type CarouselComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CarouselComponentUpdateInput;
  /** Unique document search */
  where: CarouselComponentWhereUniqueInput;
};

export type CarouselComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: CarouselComponentCreateInput;
  /** Update document if it exists */
  update: CarouselComponentUpdateInput;
};

export type CarouselComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CarouselComponentUpsertInput;
  /** Unique document search */
  where: CarouselComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CarouselComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CarouselComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CarouselComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CarouselComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CarouselComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundImg?: InputMaybe<AssetWhereInput>;
  bottomLeftAsset?: InputMaybe<AssetWhereInput>;
  carouselName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  carouselName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  carouselName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  carouselName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  carouselName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  carouselName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  carouselName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  carouselName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  carouselName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  carouselName_starts_with?: InputMaybe<Scalars['String']['input']>;
  carouselSlides_every?: InputMaybe<CarouselSlideWhereInput>;
  carouselSlides_none?: InputMaybe<CarouselSlideWhereInput>;
  carouselSlides_some?: InputMaybe<CarouselSlideWhereInput>;
  carouselType?: InputMaybe<CarouselType>;
  /** All values that are contained in given list. */
  carouselType_in?: InputMaybe<Array<InputMaybe<CarouselType>>>;
  /** Any other value that exists and is not equal to the given value. */
  carouselType_not?: InputMaybe<CarouselType>;
  /** All values that are not contained in given list. */
  carouselType_not_in?: InputMaybe<Array<InputMaybe<CarouselType>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CarouselComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<CarouselComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<CarouselComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slidesToShow?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  slidesToShow_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  slidesToShow_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  slidesToShow_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  slidesToShow_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  slidesToShow_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  slidesToShow_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  slidesToShow_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  topRightAsset?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CarouselComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CarouselComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CarouselComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CarouselComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CarouselComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CarouselComponent record uniquely */
export type CarouselComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CarouselSlide = Entity & Node & {
  __typename?: 'CarouselSlide';
  caption?: Maybe<Scalars['String']['output']>;
  carouselComponent?: Maybe<CarouselComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CarouselSlide>;
  /** List of CarouselSlide versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slideAsset?: Maybe<Asset>;
  /** System stage field */
  stage: Stage;
  /** CMS Title */
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  videoId?: Maybe<Scalars['String']['output']>;
};


export type CarouselSlideCarouselComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselSlideCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselSlideDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CarouselSlideHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CarouselSlideMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselSlidePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselSlideScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CarouselSlideSlideAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CarouselSlideUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CarouselSlideConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CarouselSlideWhereUniqueInput;
};

/** A connection to a list of items. */
export type CarouselSlideConnection = {
  __typename?: 'CarouselSlideConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CarouselSlideEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CarouselSlideCreateInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  carouselComponent?: InputMaybe<CarouselComponentCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  slideAsset?: InputMaybe<AssetCreateOneInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type CarouselSlideCreateManyInlineInput = {
  /** Connect multiple existing CarouselSlide documents */
  connect?: InputMaybe<Array<CarouselSlideWhereUniqueInput>>;
  /** Create and connect multiple existing CarouselSlide documents */
  create?: InputMaybe<Array<CarouselSlideCreateInput>>;
};

export type CarouselSlideCreateOneInlineInput = {
  /** Connect one existing CarouselSlide document */
  connect?: InputMaybe<CarouselSlideWhereUniqueInput>;
  /** Create and connect one CarouselSlide document */
  create?: InputMaybe<CarouselSlideCreateInput>;
};

/** An edge in a connection. */
export type CarouselSlideEdge = {
  __typename?: 'CarouselSlideEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CarouselSlide;
};

/** Identifies documents */
export type CarouselSlideManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CarouselSlideWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CarouselSlideWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CarouselSlideWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  carouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CarouselSlideWhereStageInput>;
  documentInStages_none?: InputMaybe<CarouselSlideWhereStageInput>;
  documentInStages_some?: InputMaybe<CarouselSlideWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slideAsset?: InputMaybe<AssetWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoId_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum CarouselSlideOrderByInput {
  caption_ASC = 'caption_ASC',
  caption_DESC = 'caption_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  videoId_ASC = 'videoId_ASC',
  videoId_DESC = 'videoId_DESC'
}

export type CarouselSlideUpdateInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  carouselComponent?: InputMaybe<CarouselComponentUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  slideAsset?: InputMaybe<AssetUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type CarouselSlideUpdateManyInlineInput = {
  /** Connect multiple existing CarouselSlide documents */
  connect?: InputMaybe<Array<CarouselSlideConnectInput>>;
  /** Create and connect multiple CarouselSlide documents */
  create?: InputMaybe<Array<CarouselSlideCreateInput>>;
  /** Delete multiple CarouselSlide documents */
  delete?: InputMaybe<Array<CarouselSlideWhereUniqueInput>>;
  /** Disconnect multiple CarouselSlide documents */
  disconnect?: InputMaybe<Array<CarouselSlideWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CarouselSlide documents */
  set?: InputMaybe<Array<CarouselSlideWhereUniqueInput>>;
  /** Update multiple CarouselSlide documents */
  update?: InputMaybe<Array<CarouselSlideUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CarouselSlide documents */
  upsert?: InputMaybe<Array<CarouselSlideUpsertWithNestedWhereUniqueInput>>;
};

export type CarouselSlideUpdateManyInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type CarouselSlideUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CarouselSlideUpdateManyInput;
  /** Document search */
  where: CarouselSlideWhereInput;
};

export type CarouselSlideUpdateOneInlineInput = {
  /** Connect existing CarouselSlide document */
  connect?: InputMaybe<CarouselSlideWhereUniqueInput>;
  /** Create and connect one CarouselSlide document */
  create?: InputMaybe<CarouselSlideCreateInput>;
  /** Delete currently connected CarouselSlide document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CarouselSlide document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CarouselSlide document */
  update?: InputMaybe<CarouselSlideUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CarouselSlide document */
  upsert?: InputMaybe<CarouselSlideUpsertWithNestedWhereUniqueInput>;
};

export type CarouselSlideUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CarouselSlideUpdateInput;
  /** Unique document search */
  where: CarouselSlideWhereUniqueInput;
};

export type CarouselSlideUpsertInput = {
  /** Create document if it didn't exist */
  create: CarouselSlideCreateInput;
  /** Update document if it exists */
  update: CarouselSlideUpdateInput;
};

export type CarouselSlideUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CarouselSlideUpsertInput;
  /** Unique document search */
  where: CarouselSlideWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CarouselSlideWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CarouselSlideWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CarouselSlideWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CarouselSlideWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CarouselSlideWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  carouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CarouselSlideWhereStageInput>;
  documentInStages_none?: InputMaybe<CarouselSlideWhereStageInput>;
  documentInStages_some?: InputMaybe<CarouselSlideWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slideAsset?: InputMaybe<AssetWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoId_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CarouselSlideWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CarouselSlideWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CarouselSlideWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CarouselSlideWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CarouselSlideWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CarouselSlide record uniquely */
export type CarouselSlideWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum CarouselType {
  ImageVideo = 'ImageVideo',
  Products = 'Products',
  RecipeCards = 'RecipeCards'
}

export type CategoryCard = Entity & Node & {
  __typename?: 'CategoryCard';
  anchorNav?: Maybe<AnchorNavigation>;
  /** for images of category */
  assetComponent?: Maybe<AssetComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CategoryCard>;
  /** List of CategoryCard versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CategoryCardAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CategoryCardAssetComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CategoryCardCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CategoryCardDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CategoryCardHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CategoryCardMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CategoryCardPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CategoryCardScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CategoryCardUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CategoryCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CategoryCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CategoryCardConnection = {
  __typename?: 'CategoryCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CategoryCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CategoryCardCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  assetComponent?: InputMaybe<AssetComponentCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CategoryCardCreateManyInlineInput = {
  /** Connect multiple existing CategoryCard documents */
  connect?: InputMaybe<Array<CategoryCardWhereUniqueInput>>;
  /** Create and connect multiple existing CategoryCard documents */
  create?: InputMaybe<Array<CategoryCardCreateInput>>;
};

export type CategoryCardCreateOneInlineInput = {
  /** Connect one existing CategoryCard document */
  connect?: InputMaybe<CategoryCardWhereUniqueInput>;
  /** Create and connect one CategoryCard document */
  create?: InputMaybe<CategoryCardCreateInput>;
};

/** An edge in a connection. */
export type CategoryCardEdge = {
  __typename?: 'CategoryCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CategoryCard;
};

/** Identifies documents */
export type CategoryCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CategoryCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CategoryCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CategoryCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  assetComponent?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CategoryCardWhereStageInput>;
  documentInStages_none?: InputMaybe<CategoryCardWhereStageInput>;
  documentInStages_some?: InputMaybe<CategoryCardWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CategoryCardOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CategoryCardUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  assetComponent?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
};

export type CategoryCardUpdateManyInlineInput = {
  /** Connect multiple existing CategoryCard documents */
  connect?: InputMaybe<Array<CategoryCardConnectInput>>;
  /** Create and connect multiple CategoryCard documents */
  create?: InputMaybe<Array<CategoryCardCreateInput>>;
  /** Delete multiple CategoryCard documents */
  delete?: InputMaybe<Array<CategoryCardWhereUniqueInput>>;
  /** Disconnect multiple CategoryCard documents */
  disconnect?: InputMaybe<Array<CategoryCardWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CategoryCard documents */
  set?: InputMaybe<Array<CategoryCardWhereUniqueInput>>;
  /** Update multiple CategoryCard documents */
  update?: InputMaybe<Array<CategoryCardUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CategoryCard documents */
  upsert?: InputMaybe<Array<CategoryCardUpsertWithNestedWhereUniqueInput>>;
};

export type CategoryCardUpdateManyInput = {
  market?: InputMaybe<Markets>;
};

export type CategoryCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CategoryCardUpdateManyInput;
  /** Document search */
  where: CategoryCardWhereInput;
};

export type CategoryCardUpdateOneInlineInput = {
  /** Connect existing CategoryCard document */
  connect?: InputMaybe<CategoryCardWhereUniqueInput>;
  /** Create and connect one CategoryCard document */
  create?: InputMaybe<CategoryCardCreateInput>;
  /** Delete currently connected CategoryCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CategoryCard document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CategoryCard document */
  update?: InputMaybe<CategoryCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CategoryCard document */
  upsert?: InputMaybe<CategoryCardUpsertWithNestedWhereUniqueInput>;
};

export type CategoryCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CategoryCardUpdateInput;
  /** Unique document search */
  where: CategoryCardWhereUniqueInput;
};

export type CategoryCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CategoryCardCreateInput;
  /** Update document if it exists */
  update: CategoryCardUpdateInput;
};

export type CategoryCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CategoryCardUpsertInput;
  /** Unique document search */
  where: CategoryCardWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CategoryCardWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CategoryCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CategoryCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CategoryCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CategoryCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  assetComponent?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CategoryCardWhereStageInput>;
  documentInStages_none?: InputMaybe<CategoryCardWhereStageInput>;
  documentInStages_some?: InputMaybe<CategoryCardWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CategoryCardWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CategoryCardWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CategoryCardWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CategoryCardWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CategoryCardWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CategoryCard record uniquely */
export type CategoryCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Representing a color value comprising of HEX, RGBA and css color values */
export type Color = {
  __typename?: 'Color';
  css: Scalars['String']['output'];
  hex: Scalars['Hex']['output'];
  rgba: Rgba;
};

/** Accepts either HEX or RGBA color value. At least one of hex or rgba value should be passed. If both are passed RGBA is used. */
export type ColorInput = {
  hex?: InputMaybe<Scalars['Hex']['input']>;
  rgba?: InputMaybe<RgbaInput>;
};

/** Number of column */
export enum Column {
  three = 'three',
  two = 'two'
}

/** Type of column  */
export enum ColumnType {
  Full = 'Full',
  Half = 'Half',
  Multi_column = 'Multi_column'
}

export enum ComparisonOperators {
  GreaterThan = 'GreaterThan',
  GreaterThanAndEqual = 'GreaterThanAndEqual',
  LesserThan = 'LesserThan',
  LesserThanAndEqual = 'LesserThanAndEqual'
}

export type ConnectPositionInput = {
  /** Connect document after specified document */
  after?: InputMaybe<Scalars['ID']['input']>;
  /** Connect document before specified document */
  before?: InputMaybe<Scalars['ID']['input']>;
  /** Connect document at last position */
  end?: InputMaybe<Scalars['Boolean']['input']>;
  /** Connect document at first position */
  start?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Contact card */
export type ContactCard = Entity & Node & {
  __typename?: 'ContactCard';
  anchorNav?: Maybe<AnchorNavigation>;
  /** Title for CMS purposes only */
  cmsTitle: Scalars['String']['output'];
  contactCardContainer?: Maybe<ContactCardContainer>;
  /** Type of icon to display above the card */
  contactTypeIcon?: Maybe<ContactType>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<ContactCard>;
  /** Label for the first field */
  field1Label?: Maybe<Scalars['String']['output']>;
  /** Text for the first field */
  field1Text?: Maybe<Scalars['String']['output']>;
  /** Label for the second field */
  field2Label?: Maybe<Scalars['String']['output']>;
  /** Text for the second field */
  field2Text?: Maybe<Scalars['String']['output']>;
  /** List of ContactCard versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<ContactCard>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Title for the card */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Contact card */
export type ContactCardAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contact card */
export type ContactCardContactCardContainerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contact card */
export type ContactCardCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Contact card */
export type ContactCardCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contact card */
export type ContactCardDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Contact card */
export type ContactCardHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Contact card */
export type ContactCardLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contact card */
export type ContactCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Contact card */
export type ContactCardMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contact card */
export type ContactCardPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Contact card */
export type ContactCardPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contact card */
export type ContactCardScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Contact card */
export type ContactCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Contact card */
export type ContactCardUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ContactCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContactCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContactCardConnection = {
  __typename?: 'ContactCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContactCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Container for all the contact cards */
export type ContactCardContainer = Entity & Node & {
  __typename?: 'ContactCardContainer';
  anchorNav?: Maybe<AnchorNavigation>;
  cmsTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  data: Array<ContactCard>;
  /** Get the document in other stages */
  documentInStages: Array<ContactCardContainer>;
  genericPages: Array<GenericPage>;
  /** List of ContactCardContainer versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Container for all the contact cards */
export type ContactCardContainerAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Container for all the contact cards */
export type ContactCardContainerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Container for all the contact cards */
export type ContactCardContainerDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ContactCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContactCardWhereInput>;
};


/** Container for all the contact cards */
export type ContactCardContainerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Container for all the contact cards */
export type ContactCardContainerGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Container for all the contact cards */
export type ContactCardContainerHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Container for all the contact cards */
export type ContactCardContainerMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Container for all the contact cards */
export type ContactCardContainerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Container for all the contact cards */
export type ContactCardContainerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Container for all the contact cards */
export type ContactCardContainerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ContactCardContainerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContactCardContainerWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContactCardContainerConnection = {
  __typename?: 'ContactCardContainerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContactCardContainerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContactCardContainerCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cmsTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<ContactCardCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContactCardContainerCreateManyInlineInput = {
  /** Connect multiple existing ContactCardContainer documents */
  connect?: InputMaybe<Array<ContactCardContainerWhereUniqueInput>>;
  /** Create and connect multiple existing ContactCardContainer documents */
  create?: InputMaybe<Array<ContactCardContainerCreateInput>>;
};

export type ContactCardContainerCreateOneInlineInput = {
  /** Connect one existing ContactCardContainer document */
  connect?: InputMaybe<ContactCardContainerWhereUniqueInput>;
  /** Create and connect one ContactCardContainer document */
  create?: InputMaybe<ContactCardContainerCreateInput>;
};

/** An edge in a connection. */
export type ContactCardContainerEdge = {
  __typename?: 'ContactCardContainerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContactCardContainer;
};

/** Identifies documents */
export type ContactCardContainerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContactCardContainerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContactCardContainerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContactCardContainerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  data_every?: InputMaybe<ContactCardWhereInput>;
  data_none?: InputMaybe<ContactCardWhereInput>;
  data_some?: InputMaybe<ContactCardWhereInput>;
  documentInStages_every?: InputMaybe<ContactCardContainerWhereStageInput>;
  documentInStages_none?: InputMaybe<ContactCardContainerWhereStageInput>;
  documentInStages_some?: InputMaybe<ContactCardContainerWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ContactCardContainerOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ContactCardContainerUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<ContactCardUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
};

export type ContactCardContainerUpdateManyInlineInput = {
  /** Connect multiple existing ContactCardContainer documents */
  connect?: InputMaybe<Array<ContactCardContainerConnectInput>>;
  /** Create and connect multiple ContactCardContainer documents */
  create?: InputMaybe<Array<ContactCardContainerCreateInput>>;
  /** Delete multiple ContactCardContainer documents */
  delete?: InputMaybe<Array<ContactCardContainerWhereUniqueInput>>;
  /** Disconnect multiple ContactCardContainer documents */
  disconnect?: InputMaybe<Array<ContactCardContainerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ContactCardContainer documents */
  set?: InputMaybe<Array<ContactCardContainerWhereUniqueInput>>;
  /** Update multiple ContactCardContainer documents */
  update?: InputMaybe<Array<ContactCardContainerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ContactCardContainer documents */
  upsert?: InputMaybe<Array<ContactCardContainerUpsertWithNestedWhereUniqueInput>>;
};

export type ContactCardContainerUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
};

export type ContactCardContainerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContactCardContainerUpdateManyInput;
  /** Document search */
  where: ContactCardContainerWhereInput;
};

export type ContactCardContainerUpdateOneInlineInput = {
  /** Connect existing ContactCardContainer document */
  connect?: InputMaybe<ContactCardContainerWhereUniqueInput>;
  /** Create and connect one ContactCardContainer document */
  create?: InputMaybe<ContactCardContainerCreateInput>;
  /** Delete currently connected ContactCardContainer document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ContactCardContainer document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContactCardContainer document */
  update?: InputMaybe<ContactCardContainerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContactCardContainer document */
  upsert?: InputMaybe<ContactCardContainerUpsertWithNestedWhereUniqueInput>;
};

export type ContactCardContainerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContactCardContainerUpdateInput;
  /** Unique document search */
  where: ContactCardContainerWhereUniqueInput;
};

export type ContactCardContainerUpsertInput = {
  /** Create document if it didn't exist */
  create: ContactCardContainerCreateInput;
  /** Update document if it exists */
  update: ContactCardContainerUpdateInput;
};

export type ContactCardContainerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContactCardContainerUpsertInput;
  /** Unique document search */
  where: ContactCardContainerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ContactCardContainerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ContactCardContainerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContactCardContainerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContactCardContainerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContactCardContainerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  data_every?: InputMaybe<ContactCardWhereInput>;
  data_none?: InputMaybe<ContactCardWhereInput>;
  data_some?: InputMaybe<ContactCardWhereInput>;
  documentInStages_every?: InputMaybe<ContactCardContainerWhereStageInput>;
  documentInStages_none?: InputMaybe<ContactCardContainerWhereStageInput>;
  documentInStages_some?: InputMaybe<ContactCardContainerWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ContactCardContainerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContactCardContainerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContactCardContainerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContactCardContainerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ContactCardContainerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ContactCardContainer record uniquely */
export type ContactCardContainerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ContactCardCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cmsTitle: Scalars['String']['input'];
  contactCardContainer?: InputMaybe<ContactCardContainerCreateOneInlineInput>;
  /** contactTypeIcon input for default locale (en) */
  contactTypeIcon?: InputMaybe<ContactType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  field1Label?: InputMaybe<Scalars['String']['input']>;
  field1Text?: InputMaybe<Scalars['String']['input']>;
  field2Label?: InputMaybe<Scalars['String']['input']>;
  field2Text?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ContactCardCreateLocalizationsInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContactCardCreateLocalizationDataInput = {
  contactTypeIcon?: InputMaybe<ContactType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContactCardCreateLocalizationInput = {
  /** Localization input */
  data: ContactCardCreateLocalizationDataInput;
  locale: Locale;
};

export type ContactCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ContactCardCreateLocalizationInput>>;
};

export type ContactCardCreateManyInlineInput = {
  /** Connect multiple existing ContactCard documents */
  connect?: InputMaybe<Array<ContactCardWhereUniqueInput>>;
  /** Create and connect multiple existing ContactCard documents */
  create?: InputMaybe<Array<ContactCardCreateInput>>;
};

export type ContactCardCreateOneInlineInput = {
  /** Connect one existing ContactCard document */
  connect?: InputMaybe<ContactCardWhereUniqueInput>;
  /** Create and connect one ContactCard document */
  create?: InputMaybe<ContactCardCreateInput>;
};

/** An edge in a connection. */
export type ContactCardEdge = {
  __typename?: 'ContactCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContactCard;
};

/** Identifies documents */
export type ContactCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContactCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContactCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContactCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  contactCardContainer?: InputMaybe<ContactCardContainerWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ContactCardWhereStageInput>;
  documentInStages_none?: InputMaybe<ContactCardWhereStageInput>;
  documentInStages_some?: InputMaybe<ContactCardWhereStageInput>;
  field1Label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  field1Label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  field1Label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  field1Label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  field1Label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  field1Label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  field1Label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  field1Label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  field1Label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  field1Label_starts_with?: InputMaybe<Scalars['String']['input']>;
  field1Text?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  field1Text_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  field1Text_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  field1Text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  field1Text_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  field1Text_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  field1Text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  field1Text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  field1Text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  field1Text_starts_with?: InputMaybe<Scalars['String']['input']>;
  field2Label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  field2Label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  field2Label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  field2Label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  field2Label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  field2Label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  field2Label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  field2Label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  field2Label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  field2Label_starts_with?: InputMaybe<Scalars['String']['input']>;
  field2Text?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  field2Text_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  field2Text_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  field2Text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  field2Text_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  field2Text_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  field2Text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  field2Text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  field2Text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  field2Text_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ContactCardOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  contactTypeIcon_ASC = 'contactTypeIcon_ASC',
  contactTypeIcon_DESC = 'contactTypeIcon_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  field1Label_ASC = 'field1Label_ASC',
  field1Label_DESC = 'field1Label_DESC',
  field1Text_ASC = 'field1Text_ASC',
  field1Text_DESC = 'field1Text_DESC',
  field2Label_ASC = 'field2Label_ASC',
  field2Label_DESC = 'field2Label_DESC',
  field2Text_ASC = 'field2Text_ASC',
  field2Text_DESC = 'field2Text_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ContactCardUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  contactCardContainer?: InputMaybe<ContactCardContainerUpdateOneInlineInput>;
  /** contactTypeIcon input for default locale (en) */
  contactTypeIcon?: InputMaybe<ContactType>;
  field1Label?: InputMaybe<Scalars['String']['input']>;
  field1Text?: InputMaybe<Scalars['String']['input']>;
  field2Label?: InputMaybe<Scalars['String']['input']>;
  field2Text?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<ContactCardUpdateLocalizationsInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContactCardUpdateLocalizationDataInput = {
  contactTypeIcon?: InputMaybe<ContactType>;
};

export type ContactCardUpdateLocalizationInput = {
  data: ContactCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type ContactCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ContactCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<ContactCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<ContactCardUpsertLocalizationInput>>;
};

export type ContactCardUpdateManyInlineInput = {
  /** Connect multiple existing ContactCard documents */
  connect?: InputMaybe<Array<ContactCardConnectInput>>;
  /** Create and connect multiple ContactCard documents */
  create?: InputMaybe<Array<ContactCardCreateInput>>;
  /** Delete multiple ContactCard documents */
  delete?: InputMaybe<Array<ContactCardWhereUniqueInput>>;
  /** Disconnect multiple ContactCard documents */
  disconnect?: InputMaybe<Array<ContactCardWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ContactCard documents */
  set?: InputMaybe<Array<ContactCardWhereUniqueInput>>;
  /** Update multiple ContactCard documents */
  update?: InputMaybe<Array<ContactCardUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ContactCard documents */
  upsert?: InputMaybe<Array<ContactCardUpsertWithNestedWhereUniqueInput>>;
};

export type ContactCardUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** contactTypeIcon input for default locale (en) */
  contactTypeIcon?: InputMaybe<ContactType>;
  field1Label?: InputMaybe<Scalars['String']['input']>;
  field1Text?: InputMaybe<Scalars['String']['input']>;
  field2Label?: InputMaybe<Scalars['String']['input']>;
  field2Text?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<ContactCardUpdateManyLocalizationsInput>;
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContactCardUpdateManyLocalizationDataInput = {
  contactTypeIcon?: InputMaybe<ContactType>;
};

export type ContactCardUpdateManyLocalizationInput = {
  data: ContactCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type ContactCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ContactCardUpdateManyLocalizationInput>>;
};

export type ContactCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContactCardUpdateManyInput;
  /** Document search */
  where: ContactCardWhereInput;
};

export type ContactCardUpdateOneInlineInput = {
  /** Connect existing ContactCard document */
  connect?: InputMaybe<ContactCardWhereUniqueInput>;
  /** Create and connect one ContactCard document */
  create?: InputMaybe<ContactCardCreateInput>;
  /** Delete currently connected ContactCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ContactCard document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContactCard document */
  update?: InputMaybe<ContactCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContactCard document */
  upsert?: InputMaybe<ContactCardUpsertWithNestedWhereUniqueInput>;
};

export type ContactCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContactCardUpdateInput;
  /** Unique document search */
  where: ContactCardWhereUniqueInput;
};

export type ContactCardUpsertInput = {
  /** Create document if it didn't exist */
  create: ContactCardCreateInput;
  /** Update document if it exists */
  update: ContactCardUpdateInput;
};

export type ContactCardUpsertLocalizationInput = {
  create: ContactCardCreateLocalizationDataInput;
  locale: Locale;
  update: ContactCardUpdateLocalizationDataInput;
};

export type ContactCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContactCardUpsertInput;
  /** Unique document search */
  where: ContactCardWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ContactCardWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ContactCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContactCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContactCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContactCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  contactCardContainer?: InputMaybe<ContactCardContainerWhereInput>;
  contactTypeIcon?: InputMaybe<ContactType>;
  /** All values that are contained in given list. */
  contactTypeIcon_in?: InputMaybe<Array<InputMaybe<ContactType>>>;
  /** Any other value that exists and is not equal to the given value. */
  contactTypeIcon_not?: InputMaybe<ContactType>;
  /** All values that are not contained in given list. */
  contactTypeIcon_not_in?: InputMaybe<Array<InputMaybe<ContactType>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ContactCardWhereStageInput>;
  documentInStages_none?: InputMaybe<ContactCardWhereStageInput>;
  documentInStages_some?: InputMaybe<ContactCardWhereStageInput>;
  field1Label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  field1Label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  field1Label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  field1Label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  field1Label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  field1Label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  field1Label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  field1Label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  field1Label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  field1Label_starts_with?: InputMaybe<Scalars['String']['input']>;
  field1Text?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  field1Text_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  field1Text_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  field1Text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  field1Text_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  field1Text_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  field1Text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  field1Text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  field1Text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  field1Text_starts_with?: InputMaybe<Scalars['String']['input']>;
  field2Label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  field2Label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  field2Label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  field2Label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  field2Label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  field2Label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  field2Label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  field2Label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  field2Label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  field2Label_starts_with?: InputMaybe<Scalars['String']['input']>;
  field2Text?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  field2Text_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  field2Text_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  field2Text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  field2Text_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  field2Text_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  field2Text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  field2Text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  field2Text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  field2Text_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ContactCardWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContactCardWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContactCardWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContactCardWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ContactCardWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ContactCard record uniquely */
export type ContactCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Different ways of contacting */
export enum ContactType {
  Chat = 'Chat',
  Email = 'Email',
  Telephone = 'Telephone'
}

export enum ContentGrouping1 {
  About_Oetker = 'About_Oetker',
  Careers = 'Careers',
  Home = 'Home',
  Inspiration = 'Inspiration',
  Legal = 'Legal',
  Products = 'Products',
  Support = 'Support',
  Sustainability = 'Sustainability'
}

export enum ContentGrouping2 {
  Articles = 'Articles',
  Children = 'Children',
  Chocolate = 'Chocolate',
  Compliance = 'Compliance',
  Contact_us = 'Contact_us',
  Cookie_Policy = 'Cookie_Policy',
  FAQ = 'FAQ',
  Imprint = 'Imprint',
  Instagram_Recipes = 'Instagram_Recipes',
  Latest_Recipes = 'Latest_Recipes',
  Occasions = 'Occasions',
  Pizza = 'Pizza',
  Privacy_Policy = 'Privacy_Policy',
  Promotions = 'Promotions',
  Recipe_Booklets = 'Recipe_Booklets',
  Recipe_Videos = 'Recipe_Videos',
  Season = 'Season',
  TermsAndConditions = 'TermsAndConditions',
  TipsAndTricks = 'TipsAndTricks',
  Vanilla = 'Vanilla'
}

export enum Countries {
  AT = 'AT',
  AU = 'AU',
  BA = 'BA',
  BE = 'BE',
  BG = 'BG',
  BR = 'BR',
  CA = 'CA',
  CH = 'CH',
  CN = 'CN',
  CZ = 'CZ',
  DE = 'DE',
  DK = 'DK',
  ES = 'ES',
  FI = 'FI',
  FR = 'FR',
  HR = 'HR',
  HU = 'HU',
  IE = 'IE',
  IN = 'IN',
  IT = 'IT',
  LT = 'LT',
  LV = 'LV',
  MY = 'MY',
  NL = 'NL',
  NO = 'NO',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  RS = 'RS',
  SE = 'SE',
  SI = 'SI',
  SK = 'SK',
  TN = 'TN',
  TR = 'TR',
  UK = 'UK',
  US = 'US'
}

export type CountrySelectorFooter = Entity & Node & {
  __typename?: 'CountrySelectorFooter';
  countryLabel?: Maybe<Scalars['String']['output']>;
  /** List of country items  */
  countrySelectorList: Array<CountrySelectorItem>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CountrySelectorFooter>;
  /** List of CountrySelectorFooter versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  languageLabel?: Maybe<Scalars['String']['output']>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  textOnButton?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CountrySelectorFooterCountrySelectorListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CountrySelectorItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountrySelectorItemWhereInput>;
};


export type CountrySelectorFooterCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CountrySelectorFooterDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CountrySelectorFooterHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CountrySelectorFooterMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CountrySelectorFooterPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CountrySelectorFooterScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CountrySelectorFooterUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CountrySelectorFooterConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CountrySelectorFooterWhereUniqueInput;
};

/** A connection to a list of items. */
export type CountrySelectorFooterConnection = {
  __typename?: 'CountrySelectorFooterConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CountrySelectorFooterEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CountrySelectorFooterCreateInput = {
  countryLabel?: InputMaybe<Scalars['String']['input']>;
  countrySelectorList?: InputMaybe<CountrySelectorItemCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  languageLabel?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  textOnButton?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CountrySelectorFooterCreateManyInlineInput = {
  /** Connect multiple existing CountrySelectorFooter documents */
  connect?: InputMaybe<Array<CountrySelectorFooterWhereUniqueInput>>;
  /** Create and connect multiple existing CountrySelectorFooter documents */
  create?: InputMaybe<Array<CountrySelectorFooterCreateInput>>;
};

export type CountrySelectorFooterCreateOneInlineInput = {
  /** Connect one existing CountrySelectorFooter document */
  connect?: InputMaybe<CountrySelectorFooterWhereUniqueInput>;
  /** Create and connect one CountrySelectorFooter document */
  create?: InputMaybe<CountrySelectorFooterCreateInput>;
};

/** An edge in a connection. */
export type CountrySelectorFooterEdge = {
  __typename?: 'CountrySelectorFooterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CountrySelectorFooter;
};

/** Identifies documents */
export type CountrySelectorFooterManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CountrySelectorFooterWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CountrySelectorFooterWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CountrySelectorFooterWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  countryLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  countryLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  countryLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  countryLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  countryLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  countryLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  countryLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  countryLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  countryLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  countryLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  countrySelectorList_every?: InputMaybe<CountrySelectorItemWhereInput>;
  countrySelectorList_none?: InputMaybe<CountrySelectorItemWhereInput>;
  countrySelectorList_some?: InputMaybe<CountrySelectorItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CountrySelectorFooterWhereStageInput>;
  documentInStages_none?: InputMaybe<CountrySelectorFooterWhereStageInput>;
  documentInStages_some?: InputMaybe<CountrySelectorFooterWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  languageLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  languageLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  languageLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  languageLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  languageLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  languageLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  languageLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  languageLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  languageLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  languageLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  textOnButton?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  textOnButton_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  textOnButton_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  textOnButton_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  textOnButton_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  textOnButton_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  textOnButton_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  textOnButton_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  textOnButton_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  textOnButton_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CountrySelectorFooterOrderByInput {
  countryLabel_ASC = 'countryLabel_ASC',
  countryLabel_DESC = 'countryLabel_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  languageLabel_ASC = 'languageLabel_ASC',
  languageLabel_DESC = 'languageLabel_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  textOnButton_ASC = 'textOnButton_ASC',
  textOnButton_DESC = 'textOnButton_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CountrySelectorFooterUpdateInput = {
  countryLabel?: InputMaybe<Scalars['String']['input']>;
  countrySelectorList?: InputMaybe<CountrySelectorItemUpdateManyInlineInput>;
  languageLabel?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  textOnButton?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CountrySelectorFooterUpdateManyInlineInput = {
  /** Connect multiple existing CountrySelectorFooter documents */
  connect?: InputMaybe<Array<CountrySelectorFooterConnectInput>>;
  /** Create and connect multiple CountrySelectorFooter documents */
  create?: InputMaybe<Array<CountrySelectorFooterCreateInput>>;
  /** Delete multiple CountrySelectorFooter documents */
  delete?: InputMaybe<Array<CountrySelectorFooterWhereUniqueInput>>;
  /** Disconnect multiple CountrySelectorFooter documents */
  disconnect?: InputMaybe<Array<CountrySelectorFooterWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CountrySelectorFooter documents */
  set?: InputMaybe<Array<CountrySelectorFooterWhereUniqueInput>>;
  /** Update multiple CountrySelectorFooter documents */
  update?: InputMaybe<Array<CountrySelectorFooterUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CountrySelectorFooter documents */
  upsert?: InputMaybe<Array<CountrySelectorFooterUpsertWithNestedWhereUniqueInput>>;
};

export type CountrySelectorFooterUpdateManyInput = {
  countryLabel?: InputMaybe<Scalars['String']['input']>;
  languageLabel?: InputMaybe<Scalars['String']['input']>;
  textOnButton?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CountrySelectorFooterUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CountrySelectorFooterUpdateManyInput;
  /** Document search */
  where: CountrySelectorFooterWhereInput;
};

export type CountrySelectorFooterUpdateOneInlineInput = {
  /** Connect existing CountrySelectorFooter document */
  connect?: InputMaybe<CountrySelectorFooterWhereUniqueInput>;
  /** Create and connect one CountrySelectorFooter document */
  create?: InputMaybe<CountrySelectorFooterCreateInput>;
  /** Delete currently connected CountrySelectorFooter document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CountrySelectorFooter document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CountrySelectorFooter document */
  update?: InputMaybe<CountrySelectorFooterUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CountrySelectorFooter document */
  upsert?: InputMaybe<CountrySelectorFooterUpsertWithNestedWhereUniqueInput>;
};

export type CountrySelectorFooterUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CountrySelectorFooterUpdateInput;
  /** Unique document search */
  where: CountrySelectorFooterWhereUniqueInput;
};

export type CountrySelectorFooterUpsertInput = {
  /** Create document if it didn't exist */
  create: CountrySelectorFooterCreateInput;
  /** Update document if it exists */
  update: CountrySelectorFooterUpdateInput;
};

export type CountrySelectorFooterUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CountrySelectorFooterUpsertInput;
  /** Unique document search */
  where: CountrySelectorFooterWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CountrySelectorFooterWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CountrySelectorFooterWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CountrySelectorFooterWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CountrySelectorFooterWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CountrySelectorFooterWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  countryLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  countryLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  countryLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  countryLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  countryLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  countryLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  countryLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  countryLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  countryLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  countryLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  countrySelectorList_every?: InputMaybe<CountrySelectorItemWhereInput>;
  countrySelectorList_none?: InputMaybe<CountrySelectorItemWhereInput>;
  countrySelectorList_some?: InputMaybe<CountrySelectorItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CountrySelectorFooterWhereStageInput>;
  documentInStages_none?: InputMaybe<CountrySelectorFooterWhereStageInput>;
  documentInStages_some?: InputMaybe<CountrySelectorFooterWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  languageLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  languageLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  languageLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  languageLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  languageLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  languageLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  languageLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  languageLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  languageLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  languageLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  textOnButton?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  textOnButton_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  textOnButton_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  textOnButton_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  textOnButton_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  textOnButton_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  textOnButton_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  textOnButton_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  textOnButton_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  textOnButton_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CountrySelectorFooterWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CountrySelectorFooterWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CountrySelectorFooterWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CountrySelectorFooterWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CountrySelectorFooterWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CountrySelectorFooter record uniquely */
export type CountrySelectorFooterWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
};

/** Country Selector Country List */
export type CountrySelectorItem = Entity & Node & {
  __typename?: 'CountrySelectorItem';
  /** Country Name */
  country: Scalars['String']['output'];
  /** Country Name or Code which should be in English */
  countryCode: Scalars['String']['output'];
  /** Flag Icon */
  countryFlag?: Maybe<CountrySelectorItemCountryFlag>;
  countrySelectorFooter: Array<CountrySelectorFooter>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CountrySelectorItem>;
  /** List of CountrySelectorItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Language associated to the country */
  language: Array<CountrySelectorItemLanguage1>;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Country Selector Country List */
export type CountrySelectorItemCountryFlagArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Country Selector Country List */
export type CountrySelectorItemCountrySelectorFooterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CountrySelectorFooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountrySelectorFooterWhereInput>;
};


/** Country Selector Country List */
export type CountrySelectorItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Country Selector Country List */
export type CountrySelectorItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Country Selector Country List */
export type CountrySelectorItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Country Selector Country List */
export type CountrySelectorItemLanguageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Country Selector Country List */
export type CountrySelectorItemMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Country Selector Country List */
export type CountrySelectorItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Country Selector Country List */
export type CountrySelectorItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Country Selector Country List */
export type CountrySelectorItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CountrySelectorItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CountrySelectorItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type CountrySelectorItemConnection = {
  __typename?: 'CountrySelectorItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CountrySelectorItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CountrySelectorItemCountryFlag = AssetComponent;

export type CountrySelectorItemCountryFlagConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type CountrySelectorItemCountryFlagCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type CountrySelectorItemCountryFlagCreateManyInlineInput = {
  /** Connect multiple existing CountrySelectorItemCountryFlag documents */
  connect?: InputMaybe<Array<CountrySelectorItemCountryFlagWhereUniqueInput>>;
  /** Create and connect multiple existing CountrySelectorItemCountryFlag documents */
  create?: InputMaybe<Array<CountrySelectorItemCountryFlagCreateInput>>;
};

export type CountrySelectorItemCountryFlagCreateOneInlineInput = {
  /** Connect one existing CountrySelectorItemCountryFlag document */
  connect?: InputMaybe<CountrySelectorItemCountryFlagWhereUniqueInput>;
  /** Create and connect one CountrySelectorItemCountryFlag document */
  create?: InputMaybe<CountrySelectorItemCountryFlagCreateInput>;
};

export type CountrySelectorItemCountryFlagUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type CountrySelectorItemCountryFlagUpdateManyInlineInput = {
  /** Connect multiple existing CountrySelectorItemCountryFlag documents */
  connect?: InputMaybe<Array<CountrySelectorItemCountryFlagConnectInput>>;
  /** Create and connect multiple CountrySelectorItemCountryFlag documents */
  create?: InputMaybe<Array<CountrySelectorItemCountryFlagCreateInput>>;
  /** Delete multiple CountrySelectorItemCountryFlag documents */
  delete?: InputMaybe<Array<CountrySelectorItemCountryFlagWhereUniqueInput>>;
  /** Disconnect multiple CountrySelectorItemCountryFlag documents */
  disconnect?: InputMaybe<Array<CountrySelectorItemCountryFlagWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CountrySelectorItemCountryFlag documents */
  set?: InputMaybe<Array<CountrySelectorItemCountryFlagWhereUniqueInput>>;
  /** Update multiple CountrySelectorItemCountryFlag documents */
  update?: InputMaybe<Array<CountrySelectorItemCountryFlagUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CountrySelectorItemCountryFlag documents */
  upsert?: InputMaybe<Array<CountrySelectorItemCountryFlagUpsertWithNestedWhereUniqueInput>>;
};

export type CountrySelectorItemCountryFlagUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type CountrySelectorItemCountryFlagUpdateOneInlineInput = {
  /** Connect existing CountrySelectorItemCountryFlag document */
  connect?: InputMaybe<CountrySelectorItemCountryFlagWhereUniqueInput>;
  /** Create and connect one CountrySelectorItemCountryFlag document */
  create?: InputMaybe<CountrySelectorItemCountryFlagCreateInput>;
  /** Delete currently connected CountrySelectorItemCountryFlag document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CountrySelectorItemCountryFlag document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CountrySelectorItemCountryFlag document */
  update?: InputMaybe<CountrySelectorItemCountryFlagUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CountrySelectorItemCountryFlag document */
  upsert?: InputMaybe<CountrySelectorItemCountryFlagUpsertWithNestedWhereUniqueInput>;
};

export type CountrySelectorItemCountryFlagUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type CountrySelectorItemCountryFlagUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type CountrySelectorItemCountryFlagWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type CountrySelectorItemCountryFlagWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

export type CountrySelectorItemCreateInput = {
  country: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  countryFlag?: InputMaybe<CountrySelectorItemCountryFlagCreateOneInlineInput>;
  countrySelectorFooter?: InputMaybe<CountrySelectorFooterCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  language?: InputMaybe<CountrySelectorItemLanguage1CreateManyInlineInput>;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CountrySelectorItemCreateManyInlineInput = {
  /** Connect multiple existing CountrySelectorItem documents */
  connect?: InputMaybe<Array<CountrySelectorItemWhereUniqueInput>>;
  /** Create and connect multiple existing CountrySelectorItem documents */
  create?: InputMaybe<Array<CountrySelectorItemCreateInput>>;
};

export type CountrySelectorItemCreateOneInlineInput = {
  /** Connect one existing CountrySelectorItem document */
  connect?: InputMaybe<CountrySelectorItemWhereUniqueInput>;
  /** Create and connect one CountrySelectorItem document */
  create?: InputMaybe<CountrySelectorItemCreateInput>;
};

/** An edge in a connection. */
export type CountrySelectorItemEdge = {
  __typename?: 'CountrySelectorItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CountrySelectorItem;
};

export type CountrySelectorItemLanguage1 = Link;

export type CountrySelectorItemLanguage1ConnectInput = {
  Link?: InputMaybe<LinkConnectInput>;
};

export type CountrySelectorItemLanguage1CreateInput = {
  Link?: InputMaybe<LinkCreateInput>;
};

export type CountrySelectorItemLanguage1CreateManyInlineInput = {
  /** Connect multiple existing CountrySelectorItemLanguage1 documents */
  connect?: InputMaybe<Array<CountrySelectorItemLanguage1WhereUniqueInput>>;
  /** Create and connect multiple existing CountrySelectorItemLanguage1 documents */
  create?: InputMaybe<Array<CountrySelectorItemLanguage1CreateInput>>;
};

export type CountrySelectorItemLanguage1CreateOneInlineInput = {
  /** Connect one existing CountrySelectorItemLanguage1 document */
  connect?: InputMaybe<CountrySelectorItemLanguage1WhereUniqueInput>;
  /** Create and connect one CountrySelectorItemLanguage1 document */
  create?: InputMaybe<CountrySelectorItemLanguage1CreateInput>;
};

export type CountrySelectorItemLanguage1UpdateInput = {
  Link?: InputMaybe<LinkUpdateInput>;
};

export type CountrySelectorItemLanguage1UpdateManyInlineInput = {
  /** Connect multiple existing CountrySelectorItemLanguage1 documents */
  connect?: InputMaybe<Array<CountrySelectorItemLanguage1ConnectInput>>;
  /** Create and connect multiple CountrySelectorItemLanguage1 documents */
  create?: InputMaybe<Array<CountrySelectorItemLanguage1CreateInput>>;
  /** Delete multiple CountrySelectorItemLanguage1 documents */
  delete?: InputMaybe<Array<CountrySelectorItemLanguage1WhereUniqueInput>>;
  /** Disconnect multiple CountrySelectorItemLanguage1 documents */
  disconnect?: InputMaybe<Array<CountrySelectorItemLanguage1WhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CountrySelectorItemLanguage1 documents */
  set?: InputMaybe<Array<CountrySelectorItemLanguage1WhereUniqueInput>>;
  /** Update multiple CountrySelectorItemLanguage1 documents */
  update?: InputMaybe<Array<CountrySelectorItemLanguage1UpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CountrySelectorItemLanguage1 documents */
  upsert?: InputMaybe<Array<CountrySelectorItemLanguage1UpsertWithNestedWhereUniqueInput>>;
};

export type CountrySelectorItemLanguage1UpdateManyWithNestedWhereInput = {
  Link?: InputMaybe<LinkUpdateManyWithNestedWhereInput>;
};

export type CountrySelectorItemLanguage1UpdateOneInlineInput = {
  /** Connect existing CountrySelectorItemLanguage1 document */
  connect?: InputMaybe<CountrySelectorItemLanguage1WhereUniqueInput>;
  /** Create and connect one CountrySelectorItemLanguage1 document */
  create?: InputMaybe<CountrySelectorItemLanguage1CreateInput>;
  /** Delete currently connected CountrySelectorItemLanguage1 document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CountrySelectorItemLanguage1 document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CountrySelectorItemLanguage1 document */
  update?: InputMaybe<CountrySelectorItemLanguage1UpdateWithNestedWhereUniqueInput>;
  /** Upsert single CountrySelectorItemLanguage1 document */
  upsert?: InputMaybe<CountrySelectorItemLanguage1UpsertWithNestedWhereUniqueInput>;
};

export type CountrySelectorItemLanguage1UpdateWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
};

export type CountrySelectorItemLanguage1UpsertWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
};

export type CountrySelectorItemLanguage1WhereInput = {
  Link?: InputMaybe<LinkWhereInput>;
};

export type CountrySelectorItemLanguage1WhereUniqueInput = {
  Link?: InputMaybe<LinkWhereUniqueInput>;
};

/** Identifies documents */
export type CountrySelectorItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CountrySelectorItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CountrySelectorItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CountrySelectorItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  countryCode_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  countryCode_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  countryCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  countryCode_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  countryCode_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  countryCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  countryCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  countryCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  countryCode_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is connected to the given models */
  countryFlag?: InputMaybe<CountrySelectorItemCountryFlagWhereInput>;
  /** All values in which the union is empty */
  countryFlag_empty?: InputMaybe<Scalars['Boolean']['input']>;
  countrySelectorFooter_every?: InputMaybe<CountrySelectorFooterWhereInput>;
  countrySelectorFooter_none?: InputMaybe<CountrySelectorFooterWhereInput>;
  countrySelectorFooter_some?: InputMaybe<CountrySelectorFooterWhereInput>;
  /** All values containing the given string. */
  country_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  country_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  country_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  country_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  country_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  country_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  country_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  country_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  country_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CountrySelectorItemWhereStageInput>;
  documentInStages_none?: InputMaybe<CountrySelectorItemWhereStageInput>;
  documentInStages_some?: InputMaybe<CountrySelectorItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  language_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  language_some?: InputMaybe<CountrySelectorItemLanguage1WhereInput>;
  marketName?: InputMaybe<MarketWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CountrySelectorItemOrderByInput {
  countryCode_ASC = 'countryCode_ASC',
  countryCode_DESC = 'countryCode_DESC',
  country_ASC = 'country_ASC',
  country_DESC = 'country_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CountrySelectorItemUpdateInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryFlag?: InputMaybe<CountrySelectorItemCountryFlagUpdateOneInlineInput>;
  countrySelectorFooter?: InputMaybe<CountrySelectorFooterUpdateManyInlineInput>;
  language?: InputMaybe<CountrySelectorItemLanguage1UpdateManyInlineInput>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
};

export type CountrySelectorItemUpdateManyInlineInput = {
  /** Connect multiple existing CountrySelectorItem documents */
  connect?: InputMaybe<Array<CountrySelectorItemConnectInput>>;
  /** Create and connect multiple CountrySelectorItem documents */
  create?: InputMaybe<Array<CountrySelectorItemCreateInput>>;
  /** Delete multiple CountrySelectorItem documents */
  delete?: InputMaybe<Array<CountrySelectorItemWhereUniqueInput>>;
  /** Disconnect multiple CountrySelectorItem documents */
  disconnect?: InputMaybe<Array<CountrySelectorItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CountrySelectorItem documents */
  set?: InputMaybe<Array<CountrySelectorItemWhereUniqueInput>>;
  /** Update multiple CountrySelectorItem documents */
  update?: InputMaybe<Array<CountrySelectorItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CountrySelectorItem documents */
  upsert?: InputMaybe<Array<CountrySelectorItemUpsertWithNestedWhereUniqueInput>>;
};

export type CountrySelectorItemUpdateManyInput = {
  country?: InputMaybe<Scalars['String']['input']>;
};

export type CountrySelectorItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CountrySelectorItemUpdateManyInput;
  /** Document search */
  where: CountrySelectorItemWhereInput;
};

export type CountrySelectorItemUpdateOneInlineInput = {
  /** Connect existing CountrySelectorItem document */
  connect?: InputMaybe<CountrySelectorItemWhereUniqueInput>;
  /** Create and connect one CountrySelectorItem document */
  create?: InputMaybe<CountrySelectorItemCreateInput>;
  /** Delete currently connected CountrySelectorItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CountrySelectorItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CountrySelectorItem document */
  update?: InputMaybe<CountrySelectorItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CountrySelectorItem document */
  upsert?: InputMaybe<CountrySelectorItemUpsertWithNestedWhereUniqueInput>;
};

export type CountrySelectorItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CountrySelectorItemUpdateInput;
  /** Unique document search */
  where: CountrySelectorItemWhereUniqueInput;
};

export type CountrySelectorItemUpsertInput = {
  /** Create document if it didn't exist */
  create: CountrySelectorItemCreateInput;
  /** Update document if it exists */
  update: CountrySelectorItemUpdateInput;
};

export type CountrySelectorItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CountrySelectorItemUpsertInput;
  /** Unique document search */
  where: CountrySelectorItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CountrySelectorItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CountrySelectorItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CountrySelectorItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CountrySelectorItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CountrySelectorItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  countryCode_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  countryCode_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  countryCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  countryCode_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  countryCode_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  countryCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  countryCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  countryCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  countryCode_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is connected to the given models */
  countryFlag?: InputMaybe<CountrySelectorItemCountryFlagWhereInput>;
  /** All values in which the union is empty */
  countryFlag_empty?: InputMaybe<Scalars['Boolean']['input']>;
  countrySelectorFooter_every?: InputMaybe<CountrySelectorFooterWhereInput>;
  countrySelectorFooter_none?: InputMaybe<CountrySelectorFooterWhereInput>;
  countrySelectorFooter_some?: InputMaybe<CountrySelectorFooterWhereInput>;
  /** All values containing the given string. */
  country_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  country_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  country_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  country_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  country_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  country_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  country_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  country_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  country_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CountrySelectorItemWhereStageInput>;
  documentInStages_none?: InputMaybe<CountrySelectorItemWhereStageInput>;
  documentInStages_some?: InputMaybe<CountrySelectorItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  language_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  language_some?: InputMaybe<CountrySelectorItemLanguage1WhereInput>;
  marketName?: InputMaybe<MarketWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CountrySelectorItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CountrySelectorItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CountrySelectorItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CountrySelectorItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CountrySelectorItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CountrySelectorItem record uniquely */
export type CountrySelectorItemWhereUniqueInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum DbEnvironment {
  dev = 'dev',
  prod = 'prod'
}

/** This model can be used, for example, as a simple form on a website, app, database with several text fields already added. */
export type DemoModel = Entity & Node & {
  __typename?: 'DemoModel';
  content: DemoModelContentRichText;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<DemoModel>;
  /** List of DemoModel versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** This model can be used, for example, as a simple form on a website, app, database with several text fields already added. */
export type DemoModelCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** This model can be used, for example, as a simple form on a website, app, database with several text fields already added. */
export type DemoModelDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** This model can be used, for example, as a simple form on a website, app, database with several text fields already added. */
export type DemoModelHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** This model can be used, for example, as a simple form on a website, app, database with several text fields already added. */
export type DemoModelPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** This model can be used, for example, as a simple form on a website, app, database with several text fields already added. */
export type DemoModelScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** This model can be used, for example, as a simple form on a website, app, database with several text fields already added. */
export type DemoModelUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DemoModelConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DemoModelWhereUniqueInput;
};

/** A connection to a list of items. */
export type DemoModelConnection = {
  __typename?: 'DemoModelConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DemoModelEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DemoModelContentRichText = {
  __typename?: 'DemoModelContentRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<DemoModelContentRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type DemoModelContentRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type DemoModelContentRichTextEmbeddedTypes = Asset;

export type DemoModelCreateInput = {
  content: Scalars['RichTextAST']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug: Scalars['String']['input'];
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DemoModelCreateManyInlineInput = {
  /** Connect multiple existing DemoModel documents */
  connect?: InputMaybe<Array<DemoModelWhereUniqueInput>>;
  /** Create and connect multiple existing DemoModel documents */
  create?: InputMaybe<Array<DemoModelCreateInput>>;
};

export type DemoModelCreateOneInlineInput = {
  /** Connect one existing DemoModel document */
  connect?: InputMaybe<DemoModelWhereUniqueInput>;
  /** Create and connect one DemoModel document */
  create?: InputMaybe<DemoModelCreateInput>;
};

/** An edge in a connection. */
export type DemoModelEdge = {
  __typename?: 'DemoModelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DemoModel;
};

/** Identifies documents */
export type DemoModelManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DemoModelWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DemoModelWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DemoModelWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<DemoModelWhereStageInput>;
  documentInStages_none?: InputMaybe<DemoModelWhereStageInput>;
  documentInStages_some?: InputMaybe<DemoModelWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum DemoModelOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  subtitle_ASC = 'subtitle_ASC',
  subtitle_DESC = 'subtitle_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type DemoModelUpdateInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DemoModelUpdateManyInlineInput = {
  /** Connect multiple existing DemoModel documents */
  connect?: InputMaybe<Array<DemoModelConnectInput>>;
  /** Create and connect multiple DemoModel documents */
  create?: InputMaybe<Array<DemoModelCreateInput>>;
  /** Delete multiple DemoModel documents */
  delete?: InputMaybe<Array<DemoModelWhereUniqueInput>>;
  /** Disconnect multiple DemoModel documents */
  disconnect?: InputMaybe<Array<DemoModelWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing DemoModel documents */
  set?: InputMaybe<Array<DemoModelWhereUniqueInput>>;
  /** Update multiple DemoModel documents */
  update?: InputMaybe<Array<DemoModelUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple DemoModel documents */
  upsert?: InputMaybe<Array<DemoModelUpsertWithNestedWhereUniqueInput>>;
};

export type DemoModelUpdateManyInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DemoModelUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DemoModelUpdateManyInput;
  /** Document search */
  where: DemoModelWhereInput;
};

export type DemoModelUpdateOneInlineInput = {
  /** Connect existing DemoModel document */
  connect?: InputMaybe<DemoModelWhereUniqueInput>;
  /** Create and connect one DemoModel document */
  create?: InputMaybe<DemoModelCreateInput>;
  /** Delete currently connected DemoModel document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected DemoModel document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single DemoModel document */
  update?: InputMaybe<DemoModelUpdateWithNestedWhereUniqueInput>;
  /** Upsert single DemoModel document */
  upsert?: InputMaybe<DemoModelUpsertWithNestedWhereUniqueInput>;
};

export type DemoModelUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DemoModelUpdateInput;
  /** Unique document search */
  where: DemoModelWhereUniqueInput;
};

export type DemoModelUpsertInput = {
  /** Create document if it didn't exist */
  create: DemoModelCreateInput;
  /** Update document if it exists */
  update: DemoModelUpdateInput;
};

export type DemoModelUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DemoModelUpsertInput;
  /** Unique document search */
  where: DemoModelWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type DemoModelWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type DemoModelWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DemoModelWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DemoModelWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DemoModelWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<DemoModelWhereStageInput>;
  documentInStages_none?: InputMaybe<DemoModelWhereStageInput>;
  documentInStages_some?: InputMaybe<DemoModelWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type DemoModelWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DemoModelWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DemoModelWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DemoModelWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<DemoModelWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References DemoModel record uniquely */
export type DemoModelWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Dictionary model for storing localized text */
export type Dictionary = Entity & Node & {
  __typename?: 'Dictionary';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  dictionaryItems: Array<DictionaryItem>;
  /** CMS only title to identify the dictorionary */
  dictionaryTitle?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<Dictionary>;
  genericPage: Array<GenericPage>;
  /** List of Dictionary versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  marketName?: Maybe<Market>;
  product: Array<Product>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipe: Array<Recipe>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Dictionary model for storing localized text */
export type DictionaryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Dictionary model for storing localized text */
export type DictionaryDictionaryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<DictionaryItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DictionaryItemWhereInput>;
};


/** Dictionary model for storing localized text */
export type DictionaryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Dictionary model for storing localized text */
export type DictionaryGenericPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Dictionary model for storing localized text */
export type DictionaryHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Dictionary model for storing localized text */
export type DictionaryMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Dictionary model for storing localized text */
export type DictionaryProductArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductWhereInput>;
};


/** Dictionary model for storing localized text */
export type DictionaryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Dictionary model for storing localized text */
export type DictionaryRecipeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RecipeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeWhereInput>;
};


/** Dictionary model for storing localized text */
export type DictionaryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Dictionary model for storing localized text */
export type DictionaryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DictionaryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DictionaryWhereUniqueInput;
};

/** A connection to a list of items. */
export type DictionaryConnection = {
  __typename?: 'DictionaryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DictionaryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DictionaryCreateInput = {
  cktiele654itn01xqg7p96903?: InputMaybe<ProductDetailPageCreateManyInlineInput>;
  cktjtnwfe0j5q01zcac3d3j8s?: InputMaybe<TipsAndTricksDetailsPageCreateManyInlineInput>;
  cktvf9o1h1hfa01w50nrv83bt?: InputMaybe<SearchResultPageCreateManyInlineInput>;
  cku2qtdbw5nrp01yugt2q4v7n?: InputMaybe<FeaturedContentCreateManyInlineInput>;
  ckuezsmdk837b01xh3bezdg9w?: InputMaybe<SearchOverlayComponentCreateManyInlineInput>;
  ckumn1va03ixc01z6ezqq6pkh?: InputMaybe<GenericGridAuthorableCreateManyInlineInput>;
  ckvtdz8x204di01zbgxjnba1x?: InputMaybe<PopularSearchComponentCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionaryItems?: InputMaybe<DictionaryItemCreateManyInlineInput>;
  dictionaryTitle?: InputMaybe<Scalars['String']['input']>;
  genericPage?: InputMaybe<GenericPageCreateManyInlineInput>;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  product?: InputMaybe<ProductCreateManyInlineInput>;
  recipe?: InputMaybe<RecipeCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DictionaryCreateManyInlineInput = {
  /** Connect multiple existing Dictionary documents */
  connect?: InputMaybe<Array<DictionaryWhereUniqueInput>>;
  /** Create and connect multiple existing Dictionary documents */
  create?: InputMaybe<Array<DictionaryCreateInput>>;
};

export type DictionaryCreateOneInlineInput = {
  /** Connect one existing Dictionary document */
  connect?: InputMaybe<DictionaryWhereUniqueInput>;
  /** Create and connect one Dictionary document */
  create?: InputMaybe<DictionaryCreateInput>;
};

/** An edge in a connection. */
export type DictionaryEdge = {
  __typename?: 'DictionaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Dictionary;
};

/** Dictionary Item as key - value pair */
export type DictionaryItem = Entity & Node & {
  __typename?: 'DictionaryItem';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<DictionaryItem>;
  dynamicCardGrid?: Maybe<DynamicCardGrid>;
  genericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** List of DictionaryItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /**
   * Pattern for Key field is snake case of EN version.
   * For example text "For the cake" should have key "for_the_cake".
   */
  key: Scalars['String']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<DictionaryItem>;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  value: Scalars['String']['output'];
};


/** Dictionary Item as key - value pair */
export type DictionaryItemCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemDynamicCardGridArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemGenericCardCarouseComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DictionaryItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DictionaryItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type DictionaryItemConnection = {
  __typename?: 'DictionaryItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DictionaryItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DictionaryItemCreateInput = {
  cktlcv3n00xgd01xxdxlwh2gx?: InputMaybe<DictionaryCreateManyInlineInput>;
  cku89vu5s3l2n01yz3zzk0g46?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  cku89wje93jxy01zecpm81ktp?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  cku89xdru3kf901xhgrg66hx9?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  cku89y4hu3mrs01xnaieigi0q?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  clumbzsgh00r807um02qrcx6j?: InputMaybe<ProductLabelCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dynamicCardGrid?: InputMaybe<DynamicCardGridCreateOneInlineInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateOneInlineInput>;
  key: Scalars['String']['input'];
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<DictionaryItemCreateLocalizationsInput>;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** value input for default locale (en) */
  value: Scalars['String']['input'];
};

export type DictionaryItemCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
};

export type DictionaryItemCreateLocalizationInput = {
  /** Localization input */
  data: DictionaryItemCreateLocalizationDataInput;
  locale: Locale;
};

export type DictionaryItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<DictionaryItemCreateLocalizationInput>>;
};

export type DictionaryItemCreateManyInlineInput = {
  /** Connect multiple existing DictionaryItem documents */
  connect?: InputMaybe<Array<DictionaryItemWhereUniqueInput>>;
  /** Create and connect multiple existing DictionaryItem documents */
  create?: InputMaybe<Array<DictionaryItemCreateInput>>;
};

export type DictionaryItemCreateOneInlineInput = {
  /** Connect one existing DictionaryItem document */
  connect?: InputMaybe<DictionaryItemWhereUniqueInput>;
  /** Create and connect one DictionaryItem document */
  create?: InputMaybe<DictionaryItemCreateInput>;
};

/** An edge in a connection. */
export type DictionaryItemEdge = {
  __typename?: 'DictionaryItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DictionaryItem;
};

/** Identifies documents */
export type DictionaryItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DictionaryItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DictionaryItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DictionaryItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<DictionaryItemWhereStageInput>;
  documentInStages_none?: InputMaybe<DictionaryItemWhereStageInput>;
  documentInStages_some?: InputMaybe<DictionaryItemWhereStageInput>;
  dynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  marketName?: InputMaybe<MarketWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum DictionaryItemOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  key_ASC = 'key_ASC',
  key_DESC = 'key_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type DictionaryItemUpdateInput = {
  cktlcv3n00xgd01xxdxlwh2gx?: InputMaybe<DictionaryUpdateManyInlineInput>;
  cku89vu5s3l2n01yz3zzk0g46?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  cku89wje93jxy01zecpm81ktp?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  cku89xdru3kf901xhgrg66hx9?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  cku89y4hu3mrs01xnaieigi0q?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  clumbzsgh00r807um02qrcx6j?: InputMaybe<ProductLabelUpdateManyInlineInput>;
  dynamicCardGrid?: InputMaybe<DynamicCardGridUpdateOneInlineInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateOneInlineInput>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<DictionaryItemUpdateLocalizationsInput>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  /** value input for default locale (en) */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DictionaryItemUpdateLocalizationDataInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DictionaryItemUpdateLocalizationInput = {
  data: DictionaryItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type DictionaryItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<DictionaryItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<DictionaryItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<DictionaryItemUpsertLocalizationInput>>;
};

export type DictionaryItemUpdateManyInlineInput = {
  /** Connect multiple existing DictionaryItem documents */
  connect?: InputMaybe<Array<DictionaryItemConnectInput>>;
  /** Create and connect multiple DictionaryItem documents */
  create?: InputMaybe<Array<DictionaryItemCreateInput>>;
  /** Delete multiple DictionaryItem documents */
  delete?: InputMaybe<Array<DictionaryItemWhereUniqueInput>>;
  /** Disconnect multiple DictionaryItem documents */
  disconnect?: InputMaybe<Array<DictionaryItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing DictionaryItem documents */
  set?: InputMaybe<Array<DictionaryItemWhereUniqueInput>>;
  /** Update multiple DictionaryItem documents */
  update?: InputMaybe<Array<DictionaryItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple DictionaryItem documents */
  upsert?: InputMaybe<Array<DictionaryItemUpsertWithNestedWhereUniqueInput>>;
};

export type DictionaryItemUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<DictionaryItemUpdateManyLocalizationsInput>;
  /** value input for default locale (en) */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DictionaryItemUpdateManyLocalizationDataInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DictionaryItemUpdateManyLocalizationInput = {
  data: DictionaryItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type DictionaryItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<DictionaryItemUpdateManyLocalizationInput>>;
};

export type DictionaryItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DictionaryItemUpdateManyInput;
  /** Document search */
  where: DictionaryItemWhereInput;
};

export type DictionaryItemUpdateOneInlineInput = {
  /** Connect existing DictionaryItem document */
  connect?: InputMaybe<DictionaryItemWhereUniqueInput>;
  /** Create and connect one DictionaryItem document */
  create?: InputMaybe<DictionaryItemCreateInput>;
  /** Delete currently connected DictionaryItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected DictionaryItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single DictionaryItem document */
  update?: InputMaybe<DictionaryItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single DictionaryItem document */
  upsert?: InputMaybe<DictionaryItemUpsertWithNestedWhereUniqueInput>;
};

export type DictionaryItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DictionaryItemUpdateInput;
  /** Unique document search */
  where: DictionaryItemWhereUniqueInput;
};

export type DictionaryItemUpsertInput = {
  /** Create document if it didn't exist */
  create: DictionaryItemCreateInput;
  /** Update document if it exists */
  update: DictionaryItemUpdateInput;
};

export type DictionaryItemUpsertLocalizationInput = {
  create: DictionaryItemCreateLocalizationDataInput;
  locale: Locale;
  update: DictionaryItemUpdateLocalizationDataInput;
};

export type DictionaryItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DictionaryItemUpsertInput;
  /** Unique document search */
  where: DictionaryItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type DictionaryItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type DictionaryItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DictionaryItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DictionaryItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DictionaryItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<DictionaryItemWhereStageInput>;
  documentInStages_none?: InputMaybe<DictionaryItemWhereStageInput>;
  documentInStages_some?: InputMaybe<DictionaryItemWhereStageInput>;
  dynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  marketName?: InputMaybe<MarketWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  value?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  value_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type DictionaryItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DictionaryItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DictionaryItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DictionaryItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<DictionaryItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References DictionaryItem record uniquely */
export type DictionaryItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies documents */
export type DictionaryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DictionaryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DictionaryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DictionaryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaryItems_every?: InputMaybe<DictionaryItemWhereInput>;
  dictionaryItems_none?: InputMaybe<DictionaryItemWhereInput>;
  dictionaryItems_some?: InputMaybe<DictionaryItemWhereInput>;
  dictionaryTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dictionaryTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dictionaryTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dictionaryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dictionaryTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dictionaryTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dictionaryTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dictionaryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dictionaryTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dictionaryTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<DictionaryWhereStageInput>;
  documentInStages_none?: InputMaybe<DictionaryWhereStageInput>;
  documentInStages_some?: InputMaybe<DictionaryWhereStageInput>;
  genericPage_every?: InputMaybe<GenericPageWhereInput>;
  genericPage_none?: InputMaybe<GenericPageWhereInput>;
  genericPage_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  marketName?: InputMaybe<MarketWhereInput>;
  product_every?: InputMaybe<ProductWhereInput>;
  product_none?: InputMaybe<ProductWhereInput>;
  product_some?: InputMaybe<ProductWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipe_every?: InputMaybe<RecipeWhereInput>;
  recipe_none?: InputMaybe<RecipeWhereInput>;
  recipe_some?: InputMaybe<RecipeWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum DictionaryOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  dictionaryTitle_ASC = 'dictionaryTitle_ASC',
  dictionaryTitle_DESC = 'dictionaryTitle_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type DictionaryUpdateInput = {
  cktiele654itn01xqg7p96903?: InputMaybe<ProductDetailPageUpdateManyInlineInput>;
  cktjtnwfe0j5q01zcac3d3j8s?: InputMaybe<TipsAndTricksDetailsPageUpdateManyInlineInput>;
  cktvf9o1h1hfa01w50nrv83bt?: InputMaybe<SearchResultPageUpdateManyInlineInput>;
  cku2qtdbw5nrp01yugt2q4v7n?: InputMaybe<FeaturedContentUpdateManyInlineInput>;
  ckuezsmdk837b01xh3bezdg9w?: InputMaybe<SearchOverlayComponentUpdateManyInlineInput>;
  ckumn1va03ixc01z6ezqq6pkh?: InputMaybe<GenericGridAuthorableUpdateManyInlineInput>;
  ckvtdz8x204di01zbgxjnba1x?: InputMaybe<PopularSearchComponentUpdateManyInlineInput>;
  dictionaryItems?: InputMaybe<DictionaryItemUpdateManyInlineInput>;
  dictionaryTitle?: InputMaybe<Scalars['String']['input']>;
  genericPage?: InputMaybe<GenericPageUpdateManyInlineInput>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  product?: InputMaybe<ProductUpdateManyInlineInput>;
  recipe?: InputMaybe<RecipeUpdateManyInlineInput>;
};

export type DictionaryUpdateManyInlineInput = {
  /** Connect multiple existing Dictionary documents */
  connect?: InputMaybe<Array<DictionaryConnectInput>>;
  /** Create and connect multiple Dictionary documents */
  create?: InputMaybe<Array<DictionaryCreateInput>>;
  /** Delete multiple Dictionary documents */
  delete?: InputMaybe<Array<DictionaryWhereUniqueInput>>;
  /** Disconnect multiple Dictionary documents */
  disconnect?: InputMaybe<Array<DictionaryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Dictionary documents */
  set?: InputMaybe<Array<DictionaryWhereUniqueInput>>;
  /** Update multiple Dictionary documents */
  update?: InputMaybe<Array<DictionaryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Dictionary documents */
  upsert?: InputMaybe<Array<DictionaryUpsertWithNestedWhereUniqueInput>>;
};

export type DictionaryUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type DictionaryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DictionaryUpdateManyInput;
  /** Document search */
  where: DictionaryWhereInput;
};

export type DictionaryUpdateOneInlineInput = {
  /** Connect existing Dictionary document */
  connect?: InputMaybe<DictionaryWhereUniqueInput>;
  /** Create and connect one Dictionary document */
  create?: InputMaybe<DictionaryCreateInput>;
  /** Delete currently connected Dictionary document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Dictionary document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Dictionary document */
  update?: InputMaybe<DictionaryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Dictionary document */
  upsert?: InputMaybe<DictionaryUpsertWithNestedWhereUniqueInput>;
};

export type DictionaryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DictionaryUpdateInput;
  /** Unique document search */
  where: DictionaryWhereUniqueInput;
};

export type DictionaryUpsertInput = {
  /** Create document if it didn't exist */
  create: DictionaryCreateInput;
  /** Update document if it exists */
  update: DictionaryUpdateInput;
};

export type DictionaryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DictionaryUpsertInput;
  /** Unique document search */
  where: DictionaryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type DictionaryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type DictionaryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DictionaryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DictionaryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DictionaryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaryItems_every?: InputMaybe<DictionaryItemWhereInput>;
  dictionaryItems_none?: InputMaybe<DictionaryItemWhereInput>;
  dictionaryItems_some?: InputMaybe<DictionaryItemWhereInput>;
  dictionaryTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dictionaryTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dictionaryTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dictionaryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dictionaryTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dictionaryTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dictionaryTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dictionaryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dictionaryTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dictionaryTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<DictionaryWhereStageInput>;
  documentInStages_none?: InputMaybe<DictionaryWhereStageInput>;
  documentInStages_some?: InputMaybe<DictionaryWhereStageInput>;
  genericPage_every?: InputMaybe<GenericPageWhereInput>;
  genericPage_none?: InputMaybe<GenericPageWhereInput>;
  genericPage_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  marketName?: InputMaybe<MarketWhereInput>;
  product_every?: InputMaybe<ProductWhereInput>;
  product_none?: InputMaybe<ProductWhereInput>;
  product_some?: InputMaybe<ProductWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipe_every?: InputMaybe<RecipeWhereInput>;
  recipe_none?: InputMaybe<RecipeWhereInput>;
  recipe_some?: InputMaybe<RecipeWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type DictionaryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DictionaryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DictionaryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DictionaryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<DictionaryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Dictionary record uniquely */
export type DictionaryWhereUniqueInput = {
  dictionaryTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Postion  */
export enum DisplayPosition {
  Left = 'Left',
  Right = 'Right',
  Top = 'Top'
}

export enum DocumentFileTypes {
  /** Automatically selects the best format for the image based on the browser's capabilities. */
  autoImage = 'autoImage',
  avif = 'avif',
  bmp = 'bmp',
  gif = 'gif',
  heic = 'heic',
  jpg = 'jpg',
  png = 'png',
  svg = 'svg',
  tiff = 'tiff',
  webp = 'webp'
}

export type DocumentOutputInput = {
  /**
   * Transforms a document into a desired file type.
   * See this matrix for format support:
   *
   * JPG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * PNG:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * SVG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * WEBP:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * GIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * TIFF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * AVIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * PDF: 	autoImage, gif, jpg, png, webp, tiff
   *
   */
  format?: InputMaybe<DocumentFileTypes>;
};

/** Transformations for Documents */
export type DocumentTransformationInput = {
  /** Changes the output for the file. */
  output?: InputMaybe<DocumentOutputInput>;
};

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['Json']['output']>;
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  stage: Stage;
};

export type DownloadApp = Entity & Node & {
  __typename?: 'DownloadApp';
  appStoreComponent?: Maybe<AssetComponent>;
  appStoreLink?: Maybe<Link>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Description  */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<DownloadApp>;
  googlePlayAssetComponent?: Maybe<AssetComponent>;
  googlePlayLink?: Maybe<Link>;
  heading?: Maybe<Scalars['String']['output']>;
  /** List of DownloadApp versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type DownloadAppAppStoreComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DownloadAppAppStoreLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DownloadAppCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DownloadAppDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type DownloadAppGooglePlayAssetComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DownloadAppGooglePlayLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DownloadAppHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type DownloadAppMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DownloadAppProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


export type DownloadAppProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


export type DownloadAppProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


export type DownloadAppPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DownloadAppRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type DownloadAppRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


export type DownloadAppRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


export type DownloadAppScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type DownloadAppUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DownloadAppConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DownloadAppWhereUniqueInput;
};

/** A connection to a list of items. */
export type DownloadAppConnection = {
  __typename?: 'DownloadAppConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DownloadAppEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DownloadAppCreateInput = {
  appStoreComponent?: InputMaybe<AssetComponentCreateOneInlineInput>;
  appStoreLink?: InputMaybe<LinkCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  googlePlayAssetComponent?: InputMaybe<AssetComponentCreateOneInlineInput>;
  googlePlayLink?: InputMaybe<LinkCreateOneInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DownloadAppCreateManyInlineInput = {
  /** Connect multiple existing DownloadApp documents */
  connect?: InputMaybe<Array<DownloadAppWhereUniqueInput>>;
  /** Create and connect multiple existing DownloadApp documents */
  create?: InputMaybe<Array<DownloadAppCreateInput>>;
};

export type DownloadAppCreateOneInlineInput = {
  /** Connect one existing DownloadApp document */
  connect?: InputMaybe<DownloadAppWhereUniqueInput>;
  /** Create and connect one DownloadApp document */
  create?: InputMaybe<DownloadAppCreateInput>;
};

/** An edge in a connection. */
export type DownloadAppEdge = {
  __typename?: 'DownloadAppEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DownloadApp;
};

/** Identifies documents */
export type DownloadAppManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DownloadAppWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DownloadAppWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DownloadAppWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  appStoreComponent?: InputMaybe<AssetComponentWhereInput>;
  appStoreLink?: InputMaybe<LinkWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<DownloadAppWhereStageInput>;
  documentInStages_none?: InputMaybe<DownloadAppWhereStageInput>;
  documentInStages_some?: InputMaybe<DownloadAppWhereStageInput>;
  googlePlayAssetComponent?: InputMaybe<AssetComponentWhereInput>;
  googlePlayLink?: InputMaybe<LinkWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum DownloadAppOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type DownloadAppUpdateInput = {
  appStoreComponent?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  appStoreLink?: InputMaybe<LinkUpdateOneInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  googlePlayAssetComponent?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  googlePlayLink?: InputMaybe<LinkUpdateOneInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
};

export type DownloadAppUpdateManyInlineInput = {
  /** Connect multiple existing DownloadApp documents */
  connect?: InputMaybe<Array<DownloadAppConnectInput>>;
  /** Create and connect multiple DownloadApp documents */
  create?: InputMaybe<Array<DownloadAppCreateInput>>;
  /** Delete multiple DownloadApp documents */
  delete?: InputMaybe<Array<DownloadAppWhereUniqueInput>>;
  /** Disconnect multiple DownloadApp documents */
  disconnect?: InputMaybe<Array<DownloadAppWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing DownloadApp documents */
  set?: InputMaybe<Array<DownloadAppWhereUniqueInput>>;
  /** Update multiple DownloadApp documents */
  update?: InputMaybe<Array<DownloadAppUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple DownloadApp documents */
  upsert?: InputMaybe<Array<DownloadAppUpsertWithNestedWhereUniqueInput>>;
};

export type DownloadAppUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
};

export type DownloadAppUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DownloadAppUpdateManyInput;
  /** Document search */
  where: DownloadAppWhereInput;
};

export type DownloadAppUpdateOneInlineInput = {
  /** Connect existing DownloadApp document */
  connect?: InputMaybe<DownloadAppWhereUniqueInput>;
  /** Create and connect one DownloadApp document */
  create?: InputMaybe<DownloadAppCreateInput>;
  /** Delete currently connected DownloadApp document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected DownloadApp document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single DownloadApp document */
  update?: InputMaybe<DownloadAppUpdateWithNestedWhereUniqueInput>;
  /** Upsert single DownloadApp document */
  upsert?: InputMaybe<DownloadAppUpsertWithNestedWhereUniqueInput>;
};

export type DownloadAppUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DownloadAppUpdateInput;
  /** Unique document search */
  where: DownloadAppWhereUniqueInput;
};

export type DownloadAppUpsertInput = {
  /** Create document if it didn't exist */
  create: DownloadAppCreateInput;
  /** Update document if it exists */
  update: DownloadAppUpdateInput;
};

export type DownloadAppUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DownloadAppUpsertInput;
  /** Unique document search */
  where: DownloadAppWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type DownloadAppWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type DownloadAppWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DownloadAppWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DownloadAppWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DownloadAppWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  appStoreComponent?: InputMaybe<AssetComponentWhereInput>;
  appStoreLink?: InputMaybe<LinkWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<DownloadAppWhereStageInput>;
  documentInStages_none?: InputMaybe<DownloadAppWhereStageInput>;
  documentInStages_some?: InputMaybe<DownloadAppWhereStageInput>;
  googlePlayAssetComponent?: InputMaybe<AssetComponentWhereInput>;
  googlePlayLink?: InputMaybe<LinkWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type DownloadAppWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DownloadAppWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DownloadAppWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DownloadAppWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<DownloadAppWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References DownloadApp record uniquely */
export type DownloadAppWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DynamicCardGrid = Entity & Node & {
  __typename?: 'DynamicCardGrid';
  anchorNav?: Maybe<AnchorNavigation>;
  cardLinkLabel?: Maybe<Scalars['String']['output']>;
  cardVariation?: Maybe<CardVariation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  dictionaryItem: Array<DynamicCardGridDictionaryItem>;
  /** Get the document in other stages */
  documentInStages: Array<DynamicCardGrid>;
  extension?: Maybe<AlgoliaExtension>;
  formSuccessComponents: Array<FormSuccessComponent>;
  genericPages: Array<GenericPage>;
  gridCta?: Maybe<Link>;
  heading?: Maybe<Scalars['String']['output']>;
  /** List of DynamicCardGrid versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Implement ItemList mark up for this component with Microdata to enable recipe carousel view in Google search results. */
  recipeCarouselMarkUp: Scalars['Boolean']['output'];
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** Number of cards */
  showCards?: Maybe<Scalars['Int']['output']>;
  /** System stage field */
  stage: Stage;
  /** Sub Heading */
  subHeading?: Maybe<Scalars['String']['output']>;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type DynamicCardGridAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DynamicCardGridCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DynamicCardGridDictionaryItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type DynamicCardGridDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type DynamicCardGridExtensionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DynamicCardGridFormSuccessComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSuccessComponentWhereInput>;
};


export type DynamicCardGridGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type DynamicCardGridGridCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DynamicCardGridHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type DynamicCardGridMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DynamicCardGridProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


export type DynamicCardGridProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


export type DynamicCardGridProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


export type DynamicCardGridPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DynamicCardGridRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type DynamicCardGridRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


export type DynamicCardGridRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


export type DynamicCardGridScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type DynamicCardGridSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DynamicCardGridTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DynamicCardGridUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DynamicCardGridConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DynamicCardGridWhereUniqueInput;
};

/** A connection to a list of items. */
export type DynamicCardGridConnection = {
  __typename?: 'DynamicCardGridConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DynamicCardGridEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DynamicCardGridCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cardLinkLabel?: InputMaybe<Scalars['String']['input']>;
  cardVariation?: InputMaybe<CardVariation>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dictionaryItem?: InputMaybe<DynamicCardGridDictionaryItemCreateManyInlineInput>;
  extension?: InputMaybe<AlgoliaExtensionCreateOneInlineInput>;
  formSuccessComponents?: InputMaybe<FormSuccessComponentCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  gridCta?: InputMaybe<LinkCreateOneInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCarouselMarkUp: Scalars['Boolean']['input'];
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  showCards?: InputMaybe<Scalars['Int']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DynamicCardGridCreateManyInlineInput = {
  /** Connect multiple existing DynamicCardGrid documents */
  connect?: InputMaybe<Array<DynamicCardGridWhereUniqueInput>>;
  /** Create and connect multiple existing DynamicCardGrid documents */
  create?: InputMaybe<Array<DynamicCardGridCreateInput>>;
};

export type DynamicCardGridCreateOneInlineInput = {
  /** Connect one existing DynamicCardGrid document */
  connect?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  /** Create and connect one DynamicCardGrid document */
  create?: InputMaybe<DynamicCardGridCreateInput>;
};

export type DynamicCardGridDictionaryItem = DictionaryItem;

export type DynamicCardGridDictionaryItemConnectInput = {
  DictionaryItem?: InputMaybe<DictionaryItemConnectInput>;
};

export type DynamicCardGridDictionaryItemCreateInput = {
  DictionaryItem?: InputMaybe<DictionaryItemCreateInput>;
};

export type DynamicCardGridDictionaryItemCreateManyInlineInput = {
  /** Connect multiple existing DynamicCardGridDictionaryItem documents */
  connect?: InputMaybe<Array<DynamicCardGridDictionaryItemWhereUniqueInput>>;
  /** Create and connect multiple existing DynamicCardGridDictionaryItem documents */
  create?: InputMaybe<Array<DynamicCardGridDictionaryItemCreateInput>>;
};

export type DynamicCardGridDictionaryItemCreateOneInlineInput = {
  /** Connect one existing DynamicCardGridDictionaryItem document */
  connect?: InputMaybe<DynamicCardGridDictionaryItemWhereUniqueInput>;
  /** Create and connect one DynamicCardGridDictionaryItem document */
  create?: InputMaybe<DynamicCardGridDictionaryItemCreateInput>;
};

export type DynamicCardGridDictionaryItemUpdateInput = {
  DictionaryItem?: InputMaybe<DictionaryItemUpdateInput>;
};

export type DynamicCardGridDictionaryItemUpdateManyInlineInput = {
  /** Connect multiple existing DynamicCardGridDictionaryItem documents */
  connect?: InputMaybe<Array<DynamicCardGridDictionaryItemConnectInput>>;
  /** Create and connect multiple DynamicCardGridDictionaryItem documents */
  create?: InputMaybe<Array<DynamicCardGridDictionaryItemCreateInput>>;
  /** Delete multiple DynamicCardGridDictionaryItem documents */
  delete?: InputMaybe<Array<DynamicCardGridDictionaryItemWhereUniqueInput>>;
  /** Disconnect multiple DynamicCardGridDictionaryItem documents */
  disconnect?: InputMaybe<Array<DynamicCardGridDictionaryItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing DynamicCardGridDictionaryItem documents */
  set?: InputMaybe<Array<DynamicCardGridDictionaryItemWhereUniqueInput>>;
  /** Update multiple DynamicCardGridDictionaryItem documents */
  update?: InputMaybe<Array<DynamicCardGridDictionaryItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple DynamicCardGridDictionaryItem documents */
  upsert?: InputMaybe<Array<DynamicCardGridDictionaryItemUpsertWithNestedWhereUniqueInput>>;
};

export type DynamicCardGridDictionaryItemUpdateManyWithNestedWhereInput = {
  DictionaryItem?: InputMaybe<DictionaryItemUpdateManyWithNestedWhereInput>;
};

export type DynamicCardGridDictionaryItemUpdateOneInlineInput = {
  /** Connect existing DynamicCardGridDictionaryItem document */
  connect?: InputMaybe<DynamicCardGridDictionaryItemWhereUniqueInput>;
  /** Create and connect one DynamicCardGridDictionaryItem document */
  create?: InputMaybe<DynamicCardGridDictionaryItemCreateInput>;
  /** Delete currently connected DynamicCardGridDictionaryItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected DynamicCardGridDictionaryItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single DynamicCardGridDictionaryItem document */
  update?: InputMaybe<DynamicCardGridDictionaryItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single DynamicCardGridDictionaryItem document */
  upsert?: InputMaybe<DynamicCardGridDictionaryItemUpsertWithNestedWhereUniqueInput>;
};

export type DynamicCardGridDictionaryItemUpdateWithNestedWhereUniqueInput = {
  DictionaryItem?: InputMaybe<DictionaryItemUpdateWithNestedWhereUniqueInput>;
};

export type DynamicCardGridDictionaryItemUpsertWithNestedWhereUniqueInput = {
  DictionaryItem?: InputMaybe<DictionaryItemUpsertWithNestedWhereUniqueInput>;
};

export type DynamicCardGridDictionaryItemWhereInput = {
  DictionaryItem?: InputMaybe<DictionaryItemWhereInput>;
};

export type DynamicCardGridDictionaryItemWhereUniqueInput = {
  DictionaryItem?: InputMaybe<DictionaryItemWhereUniqueInput>;
};

/** An edge in a connection. */
export type DynamicCardGridEdge = {
  __typename?: 'DynamicCardGridEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DynamicCardGrid;
};

/** Identifies documents */
export type DynamicCardGridManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DynamicCardGridWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DynamicCardGridWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DynamicCardGridWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cardLinkLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardLinkLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardLinkLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardLinkLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardLinkLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardLinkLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardLinkLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardLinkLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardLinkLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardLinkLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardVariation?: InputMaybe<CardVariation>;
  /** All values that are contained in given list. */
  cardVariation_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardVariation_not?: InputMaybe<CardVariation>;
  /** All values that are not contained in given list. */
  cardVariation_not_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  dictionaryItem_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  dictionaryItem_some?: InputMaybe<DynamicCardGridDictionaryItemWhereInput>;
  documentInStages_every?: InputMaybe<DynamicCardGridWhereStageInput>;
  documentInStages_none?: InputMaybe<DynamicCardGridWhereStageInput>;
  documentInStages_some?: InputMaybe<DynamicCardGridWhereStageInput>;
  extension?: InputMaybe<AlgoliaExtensionWhereInput>;
  formSuccessComponents_every?: InputMaybe<FormSuccessComponentWhereInput>;
  formSuccessComponents_none?: InputMaybe<FormSuccessComponentWhereInput>;
  formSuccessComponents_some?: InputMaybe<FormSuccessComponentWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  gridCta?: InputMaybe<LinkWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCarouselMarkUp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  recipeCarouselMarkUp_not?: InputMaybe<Scalars['Boolean']['input']>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showCards?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  showCards_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  showCards_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  showCards_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  showCards_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  showCards_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showCards_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  showCards_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum DynamicCardGridOrderByInput {
  cardLinkLabel_ASC = 'cardLinkLabel_ASC',
  cardLinkLabel_DESC = 'cardLinkLabel_DESC',
  cardVariation_ASC = 'cardVariation_ASC',
  cardVariation_DESC = 'cardVariation_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  recipeCarouselMarkUp_ASC = 'recipeCarouselMarkUp_ASC',
  recipeCarouselMarkUp_DESC = 'recipeCarouselMarkUp_DESC',
  showCards_ASC = 'showCards_ASC',
  showCards_DESC = 'showCards_DESC',
  subHeading_ASC = 'subHeading_ASC',
  subHeading_DESC = 'subHeading_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type DynamicCardGridUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cardLinkLabel?: InputMaybe<Scalars['String']['input']>;
  cardVariation?: InputMaybe<CardVariation>;
  description?: InputMaybe<Scalars['String']['input']>;
  dictionaryItem?: InputMaybe<DynamicCardGridDictionaryItemUpdateManyInlineInput>;
  extension?: InputMaybe<AlgoliaExtensionUpdateOneInlineInput>;
  formSuccessComponents?: InputMaybe<FormSuccessComponentUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  gridCta?: InputMaybe<LinkUpdateOneInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCarouselMarkUp?: InputMaybe<Scalars['Boolean']['input']>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  showCards?: InputMaybe<Scalars['Int']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type DynamicCardGridUpdateManyInlineInput = {
  /** Connect multiple existing DynamicCardGrid documents */
  connect?: InputMaybe<Array<DynamicCardGridConnectInput>>;
  /** Create and connect multiple DynamicCardGrid documents */
  create?: InputMaybe<Array<DynamicCardGridCreateInput>>;
  /** Delete multiple DynamicCardGrid documents */
  delete?: InputMaybe<Array<DynamicCardGridWhereUniqueInput>>;
  /** Disconnect multiple DynamicCardGrid documents */
  disconnect?: InputMaybe<Array<DynamicCardGridWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing DynamicCardGrid documents */
  set?: InputMaybe<Array<DynamicCardGridWhereUniqueInput>>;
  /** Update multiple DynamicCardGrid documents */
  update?: InputMaybe<Array<DynamicCardGridUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple DynamicCardGrid documents */
  upsert?: InputMaybe<Array<DynamicCardGridUpsertWithNestedWhereUniqueInput>>;
};

export type DynamicCardGridUpdateManyInput = {
  cardLinkLabel?: InputMaybe<Scalars['String']['input']>;
  cardVariation?: InputMaybe<CardVariation>;
  description?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  recipeCarouselMarkUp?: InputMaybe<Scalars['Boolean']['input']>;
  showCards?: InputMaybe<Scalars['Int']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type DynamicCardGridUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DynamicCardGridUpdateManyInput;
  /** Document search */
  where: DynamicCardGridWhereInput;
};

export type DynamicCardGridUpdateOneInlineInput = {
  /** Connect existing DynamicCardGrid document */
  connect?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  /** Create and connect one DynamicCardGrid document */
  create?: InputMaybe<DynamicCardGridCreateInput>;
  /** Delete currently connected DynamicCardGrid document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected DynamicCardGrid document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single DynamicCardGrid document */
  update?: InputMaybe<DynamicCardGridUpdateWithNestedWhereUniqueInput>;
  /** Upsert single DynamicCardGrid document */
  upsert?: InputMaybe<DynamicCardGridUpsertWithNestedWhereUniqueInput>;
};

export type DynamicCardGridUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DynamicCardGridUpdateInput;
  /** Unique document search */
  where: DynamicCardGridWhereUniqueInput;
};

export type DynamicCardGridUpsertInput = {
  /** Create document if it didn't exist */
  create: DynamicCardGridCreateInput;
  /** Update document if it exists */
  update: DynamicCardGridUpdateInput;
};

export type DynamicCardGridUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DynamicCardGridUpsertInput;
  /** Unique document search */
  where: DynamicCardGridWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type DynamicCardGridWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type DynamicCardGridWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DynamicCardGridWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DynamicCardGridWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DynamicCardGridWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cardLinkLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardLinkLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardLinkLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardLinkLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardLinkLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardLinkLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardLinkLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardLinkLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardLinkLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardLinkLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardVariation?: InputMaybe<CardVariation>;
  /** All values that are contained in given list. */
  cardVariation_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardVariation_not?: InputMaybe<CardVariation>;
  /** All values that are not contained in given list. */
  cardVariation_not_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  dictionaryItem_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  dictionaryItem_some?: InputMaybe<DynamicCardGridDictionaryItemWhereInput>;
  documentInStages_every?: InputMaybe<DynamicCardGridWhereStageInput>;
  documentInStages_none?: InputMaybe<DynamicCardGridWhereStageInput>;
  documentInStages_some?: InputMaybe<DynamicCardGridWhereStageInput>;
  extension?: InputMaybe<AlgoliaExtensionWhereInput>;
  formSuccessComponents_every?: InputMaybe<FormSuccessComponentWhereInput>;
  formSuccessComponents_none?: InputMaybe<FormSuccessComponentWhereInput>;
  formSuccessComponents_some?: InputMaybe<FormSuccessComponentWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  gridCta?: InputMaybe<LinkWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCarouselMarkUp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  recipeCarouselMarkUp_not?: InputMaybe<Scalars['Boolean']['input']>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showCards?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  showCards_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  showCards_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  showCards_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  showCards_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  showCards_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showCards_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  showCards_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type DynamicCardGridWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DynamicCardGridWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DynamicCardGridWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DynamicCardGridWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<DynamicCardGridWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References DynamicCardGrid record uniquely */
export type DynamicCardGridWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** An object with an ID */
export type Entity = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

/** This enumeration holds all typenames that implement the Entity interface. Components and models implement the Entity interface. */
export enum EntityTypeName {
  /** Accordion */
  Accordion = 'Accordion',
  /** Accordion Item */
  AccordionItem = 'AccordionItem',
  AlgoliaExtension = 'AlgoliaExtension',
  /** this will be deprecated soon */
  AnchorNav = 'AnchorNav',
  /** used to author anchor navigations for each page */
  AnchorNavigation = 'AnchorNavigation',
  /** list of all anchor navigation lists that should appear on a page */
  AnchorNavigationList = 'AnchorNavigationList',
  /** Asset system model */
  Asset = 'Asset',
  /** Asset component to be used to create image pool of reusable assets across the application */
  AssetComponent = 'AssetComponent',
  AudioComponent = 'AudioComponent',
  AuthorableContentCard = 'AuthorableContentCard',
  /** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
  Banner1 = 'Banner1',
  /** Banner2 with image and text and placement options */
  Banner2 = 'Banner2',
  Banner2CarouselComponent = 'Banner2CarouselComponent',
  /** Card Component */
  CardComponent = 'CardComponent',
  CarouselComponent = 'CarouselComponent',
  CarouselSlide = 'CarouselSlide',
  CategoryCard = 'CategoryCard',
  /** Contact card */
  ContactCard = 'ContactCard',
  /** Container for all the contact cards */
  ContactCardContainer = 'ContactCardContainer',
  CountrySelectorFooter = 'CountrySelectorFooter',
  /** Country Selector Country List */
  CountrySelectorItem = 'CountrySelectorItem',
  /** This model can be used, for example, as a simple form on a website, app, database with several text fields already added. */
  DemoModel = 'DemoModel',
  /** Dictionary model for storing localized text */
  Dictionary = 'Dictionary',
  /** Dictionary Item as key - value pair */
  DictionaryItem = 'DictionaryItem',
  DownloadApp = 'DownloadApp',
  DynamicCardGrid = 'DynamicCardGrid',
  ErrorPage = 'ErrorPage',
  EvalancheFormComponent = 'EvalancheFormComponent',
  /** Title to be used to find the contents in the CMS */
  ExampleComponent = 'ExampleComponent',
  /** Featured content on a page in a prominent banner / carousel */
  FeaturedContent = 'FeaturedContent',
  FeaturedContentReference = 'FeaturedContentReference',
  /** Footer Navigation */
  FooterNavigation = 'FooterNavigation',
  /** Add seals or logos to footer */
  FooterSeal = 'FooterSeal',
  Form = 'Form',
  FormCheckbox = 'FormCheckbox',
  FormCheckboxCollection = 'FormCheckboxCollection',
  /** DO NOT USE THIS FIELD WHILE THIS MESSAGE IS STILL HERE - this is a new field that separates out Text and Date from the FormTextInput field, so we can have more control over both types. We are waiting for the code to be deployed to production, when this is done this field will be available for use. 02.05.2022 - Dan H / Harsha */
  FormDateInput = 'FormDateInput',
  FormEmailInput = 'FormEmailInput',
  FormError = 'FormError',
  FormFileUploader = 'FormFileUploader',
  FormList = 'FormList',
  FormListItem = 'FormListItem',
  FormNumberInput = 'FormNumberInput',
  FormOption = 'FormOption',
  FormPasswordInput = 'FormPasswordInput',
  FormPasswordInputWithConfirmation = 'FormPasswordInputWithConfirmation',
  FormRadioButton = 'FormRadioButton',
  FormRadioButtonCollection = 'FormRadioButtonCollection',
  FormSelectComponent = 'FormSelectComponent',
  FormSelectOption = 'FormSelectOption',
  FormSubmitButton = 'FormSubmitButton',
  FormSuccessComponent = 'FormSuccessComponent',
  FormTextInput = 'FormTextInput',
  FormTextareaInput = 'FormTextareaInput',
  GenericAccordion = 'GenericAccordion',
  GenericAccordionItem = 'GenericAccordionItem',
  GenericAccordionTopRated = 'GenericAccordionTopRated',
  GenericCardCarouseComponent = 'GenericCardCarouseComponent',
  /** documents that are available for download can be configured here, so that user can download them.  */
  GenericDownloadComponent = 'GenericDownloadComponent',
  GenericFollowUs = 'GenericFollowUs',
  /** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
  GenericGridAuthorable = 'GenericGridAuthorable',
  /** Authors can insert any HTML code in this component */
  GenericHtml = 'GenericHtml',
  GenericLine = 'GenericLine',
  GenericLink = 'GenericLink',
  GenericPage = 'GenericPage',
  GenericPromotionsOverview = 'GenericPromotionsOverview',
  GenericQualifio = 'GenericQualifio',
  GenericQualifioOverview = 'GenericQualifioOverview',
  /** A generic social share component that can be added on any required generic page */
  GenericSocialShare = 'GenericSocialShare',
  /** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
  GlobalMetaData = 'GlobalMetaData',
  /** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
  GlobalSearch = 'GlobalSearch',
  GridColumn = 'GridColumn',
  GridColumnComponent = 'GridColumnComponent',
  /** Hero Banners are chosen to be displayed in the Hero Carousel Component */
  HeroBanner = 'HeroBanner',
  /** Hero Banners are chosen to be displayed in the Hero Carousel Component */
  HeroBannerMasterbrand = 'HeroBannerMasterbrand',
  /** Carousel component for page hero's */
  HeroCarouselComponent = 'HeroCarouselComponent',
  /** Page header (can be a picture and in some pages even a video). */
  HeroComponent = 'HeroComponent',
  /** Hero component that displays a looping animation */
  HeroLoopAnimationComponent = 'HeroLoopAnimationComponent',
  /** Content type for adding an iframe to a page */
  Iframe = 'Iframe',
  ImageAndTextCard = 'ImageAndTextCard',
  /** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
  ImageCopy = 'ImageCopy',
  ImageCopyItem = 'ImageCopyItem',
  /** Introductory text for quick overview of the page */
  IntroText = 'IntroText',
  LeftColumn = 'LeftColumn',
  Link = 'Link',
  LongText = 'LongText',
  Market = 'Market',
  MarketUserConnection = 'MarketUserConnection',
  /** Page Meta Data Component used on every page for SEO */
  MetaData = 'MetaData',
  MobileOnlyMainNavigation = 'MobileOnlyMainNavigation',
  MultiStepPromotionForm = 'MultiStepPromotionForm',
  MultiStepPromotionFormCheckboxes = 'MultiStepPromotionFormCheckboxes',
  MultiStepPromotionFormRadio = 'MultiStepPromotionFormRadio',
  MultiStepPromotionFormStep = 'MultiStepPromotionFormStep',
  /** Contains a list of navigation items (e.g. Main navigation menu items) */
  Navigation = 'Navigation',
  NavigationItem = 'NavigationItem',
  NewsletterComponent = 'NewsletterComponent',
  NewsletterSubscriptions = 'NewsletterSubscriptions',
  NotificationBanner = 'NotificationBanner',
  PageFooter = 'PageFooter',
  PageHeader = 'PageHeader',
  PopularSearchComponent = 'PopularSearchComponent',
  /** Products imported by PIM Sync from Oetker PIM */
  Product = 'Product',
  ProductBanner = 'ProductBanner',
  ProductCategory = 'ProductCategory',
  /** Manual configuration for Product Category Pages */
  ProductCategoryPage = 'ProductCategoryPage',
  /** A global product template for configuring non PIM product data. */
  ProductDetailPage = 'ProductDetailPage',
  ProductHero = 'ProductHero',
  ProductLabel = 'ProductLabel',
  /** Product landing page made up product category pages */
  ProductLandingPage = 'ProductLandingPage',
  ProductSubcategoryPage = 'ProductSubcategoryPage',
  PromotionDownload = 'PromotionDownload',
  PromotionForm = 'PromotionForm',
  Question = 'Question',
  QuestionCheckbox = 'QuestionCheckbox',
  QuestionCheckboxCollection = 'QuestionCheckboxCollection',
  QuestionRadioButton = 'QuestionRadioButton',
  QuestionRadioButtonCollection = 'QuestionRadioButtonCollection',
  /** Ratings component used on the recipe details page. */
  Rating = 'Rating',
  /** A global recipe template for configuring non Recipe DB content */
  Recipe = 'Recipe',
  RecipeCategory = 'RecipeCategory',
  RecipeLandingPage = 'RecipeLandingPage',
  /** Create recipe subcategories via the Recipe UI extension to populate the UI */
  RecipeSubcategory = 'RecipeSubcategory',
  RecipesComparisonQueryComponent = 'RecipesComparisonQueryComponent',
  RecipesQueriesReference = 'RecipesQueriesReference',
  /** Used to query recipes with predefined list of ids and values */
  RecipesQueryComponent = 'RecipesQueryComponent',
  Redirect = 'Redirect',
  Rewrite = 'Rewrite',
  RightColumn = 'RightColumn',
  /** Scheduled Operation system model */
  ScheduledOperation = 'ScheduledOperation',
  /** Scheduled Release system model */
  ScheduledRelease = 'ScheduledRelease',
  SearchInput = 'SearchInput',
  SearchOverlayComponent = 'SearchOverlayComponent',
  SearchResultPage = 'SearchResultPage',
  /** Placeholder component which should be used in Page Components field of Multistep pages to Separate steps. */
  Separator = 'Separator',
  SingleStepPromotionForm = 'SingleStepPromotionForm',
  SocialMediaListComponent = 'SocialMediaListComponent',
  /** Empty spacer block  */
  Spacer = 'Spacer',
  SubCategoryKeyImage = 'SubCategoryKeyImage',
  /** A collection of tabs that can be rendered on screen. */
  SubTab = 'SubTab',
  /** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
  SubTabContent = 'SubTabContent',
  /** Banner for sustainability teaser information */
  SustainabilityBanner = 'SustainabilityBanner',
  /** Template to hold all the information for the sustainability section of the product pages */
  SustainabilityInfo = 'SustainabilityInfo',
  /** A collection of tabs that can be rendered on screen. */
  Tab = 'Tab',
  /** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
  TabContent = 'TabContent',
  Teaser = 'Teaser',
  TeaserPlaceholder = 'TeaserPlaceholder',
  TeaserSmall = 'TeaserSmall',
  TeaserSmallPlaceholder = 'TeaserSmallPlaceholder',
  TestComponentWithRecipeQuery = 'TestComponentWithRecipeQuery',
  TestTipsANdTricksInAMarket = 'TestTipsANdTricksInAMarket',
  /** Single text component that can be used to add rich text to a page */
  TextComponent = 'TextComponent',
  TipsAndTricksDetailsPage = 'TipsAndTricksDetailsPage',
  Title = 'Title',
  /** Twitter SEO Optimization object */
  TwitterSeo = 'TwitterSeo',
  /** User system model */
  User = 'User'
}

/** Allows to specify input to query models and components directly */
export type EntityWhereInput = {
  /** The ID of an object */
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Locale>;
  stage: Stage;
  /** The Type name of an object */
  typename: EntityTypeName;
};

export type ErrorPage = Entity & Node & {
  __typename?: 'ErrorPage';
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<ErrorPage>;
  errorType: ErrorType;
  /** List of ErrorPage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<AssetComponent>;
  link?: Maybe<Link>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ErrorPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ErrorPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ErrorPageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ErrorPageImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ErrorPageLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ErrorPageMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ErrorPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ErrorPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ErrorPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ErrorPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ErrorPageWhereUniqueInput;
};

/** A connection to a list of items. */
export type ErrorPageConnection = {
  __typename?: 'ErrorPageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ErrorPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ErrorPageCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  errorType: ErrorType;
  image?: InputMaybe<AssetComponentCreateOneInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ErrorPageCreateManyInlineInput = {
  /** Connect multiple existing ErrorPage documents */
  connect?: InputMaybe<Array<ErrorPageWhereUniqueInput>>;
  /** Create and connect multiple existing ErrorPage documents */
  create?: InputMaybe<Array<ErrorPageCreateInput>>;
};

export type ErrorPageCreateOneInlineInput = {
  /** Connect one existing ErrorPage document */
  connect?: InputMaybe<ErrorPageWhereUniqueInput>;
  /** Create and connect one ErrorPage document */
  create?: InputMaybe<ErrorPageCreateInput>;
};

/** An edge in a connection. */
export type ErrorPageEdge = {
  __typename?: 'ErrorPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErrorPage;
};

/** Identifies documents */
export type ErrorPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ErrorPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ErrorPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ErrorPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<ErrorPageWhereStageInput>;
  documentInStages_none?: InputMaybe<ErrorPageWhereStageInput>;
  documentInStages_some?: InputMaybe<ErrorPageWhereStageInput>;
  errorType?: InputMaybe<ErrorType>;
  /** All values that are contained in given list. */
  errorType_in?: InputMaybe<Array<InputMaybe<ErrorType>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorType_not?: InputMaybe<ErrorType>;
  /** All values that are not contained in given list. */
  errorType_not_in?: InputMaybe<Array<InputMaybe<ErrorType>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ErrorPageOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  errorType_ASC = 'errorType_ASC',
  errorType_DESC = 'errorType_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ErrorPageUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  errorType?: InputMaybe<ErrorType>;
  image?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ErrorPageUpdateManyInlineInput = {
  /** Connect multiple existing ErrorPage documents */
  connect?: InputMaybe<Array<ErrorPageConnectInput>>;
  /** Create and connect multiple ErrorPage documents */
  create?: InputMaybe<Array<ErrorPageCreateInput>>;
  /** Delete multiple ErrorPage documents */
  delete?: InputMaybe<Array<ErrorPageWhereUniqueInput>>;
  /** Disconnect multiple ErrorPage documents */
  disconnect?: InputMaybe<Array<ErrorPageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ErrorPage documents */
  set?: InputMaybe<Array<ErrorPageWhereUniqueInput>>;
  /** Update multiple ErrorPage documents */
  update?: InputMaybe<Array<ErrorPageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ErrorPage documents */
  upsert?: InputMaybe<Array<ErrorPageUpsertWithNestedWhereUniqueInput>>;
};

export type ErrorPageUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  errorType?: InputMaybe<ErrorType>;
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ErrorPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ErrorPageUpdateManyInput;
  /** Document search */
  where: ErrorPageWhereInput;
};

export type ErrorPageUpdateOneInlineInput = {
  /** Connect existing ErrorPage document */
  connect?: InputMaybe<ErrorPageWhereUniqueInput>;
  /** Create and connect one ErrorPage document */
  create?: InputMaybe<ErrorPageCreateInput>;
  /** Delete currently connected ErrorPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ErrorPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ErrorPage document */
  update?: InputMaybe<ErrorPageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ErrorPage document */
  upsert?: InputMaybe<ErrorPageUpsertWithNestedWhereUniqueInput>;
};

export type ErrorPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ErrorPageUpdateInput;
  /** Unique document search */
  where: ErrorPageWhereUniqueInput;
};

export type ErrorPageUpsertInput = {
  /** Create document if it didn't exist */
  create: ErrorPageCreateInput;
  /** Update document if it exists */
  update: ErrorPageUpdateInput;
};

export type ErrorPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ErrorPageUpsertInput;
  /** Unique document search */
  where: ErrorPageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ErrorPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ErrorPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ErrorPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ErrorPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ErrorPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<ErrorPageWhereStageInput>;
  documentInStages_none?: InputMaybe<ErrorPageWhereStageInput>;
  documentInStages_some?: InputMaybe<ErrorPageWhereStageInput>;
  errorType?: InputMaybe<ErrorType>;
  /** All values that are contained in given list. */
  errorType_in?: InputMaybe<Array<InputMaybe<ErrorType>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorType_not?: InputMaybe<ErrorType>;
  /** All values that are not contained in given list. */
  errorType_not_in?: InputMaybe<Array<InputMaybe<ErrorType>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ErrorPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ErrorPageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ErrorPageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ErrorPageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ErrorPageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ErrorPage record uniquely */
export type ErrorPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum ErrorType {
  error_404 = 'error_404',
  error_500 = 'error_500'
}

export type EvalancheFormComponent = Entity & Node & {
  __typename?: 'EvalancheFormComponent';
  accordionTitle?: Maybe<Scalars['String']['output']>;
  anchorNav?: Maybe<AnchorNavigation>;
  /** Whether the accordion items should be collapsed by default or not */
  collapsed?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<EvalancheFormComponent>;
  evalancheHost: Scalars['String']['output'];
  /** Fields that are shown at the bottom of the form outside any accordion. e.g. enter 2 to show the last 2 fields hanging outside of the accordion */
  fieldsAfterAccordion?: Maybe<Scalars['Int']['output']>;
  /** Enter the number of the field at which the form should start rendering fields within an accordion */
  fieldsBeforeAccordion?: Maybe<Scalars['Int']['output']>;
  formFileUploader?: Maybe<FormFileUploader>;
  formId: Scalars['String']['output'];
  genericPages: Array<GenericPage>;
  /** List of EvalancheFormComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  successMessage?: Maybe<Scalars['String']['output']>;
  successMessageDescription?: Maybe<Scalars['String']['output']>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type EvalancheFormComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type EvalancheFormComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type EvalancheFormComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type EvalancheFormComponentFormFileUploaderArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type EvalancheFormComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type EvalancheFormComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type EvalancheFormComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type EvalancheFormComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type EvalancheFormComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type EvalancheFormComponentSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type EvalancheFormComponentTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type EvalancheFormComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type EvalancheFormComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: EvalancheFormComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type EvalancheFormComponentConnection = {
  __typename?: 'EvalancheFormComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<EvalancheFormComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type EvalancheFormComponentCreateInput = {
  accordionTitle?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  evalancheHost: Scalars['String']['input'];
  fieldsAfterAccordion?: InputMaybe<Scalars['Int']['input']>;
  fieldsBeforeAccordion?: InputMaybe<Scalars['Int']['input']>;
  formFileUploader?: InputMaybe<FormFileUploaderCreateOneInlineInput>;
  formId: Scalars['String']['input'];
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  successMessage?: InputMaybe<Scalars['String']['input']>;
  successMessageDescription?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EvalancheFormComponentCreateManyInlineInput = {
  /** Connect multiple existing EvalancheFormComponent documents */
  connect?: InputMaybe<Array<EvalancheFormComponentWhereUniqueInput>>;
  /** Create and connect multiple existing EvalancheFormComponent documents */
  create?: InputMaybe<Array<EvalancheFormComponentCreateInput>>;
};

export type EvalancheFormComponentCreateOneInlineInput = {
  /** Connect one existing EvalancheFormComponent document */
  connect?: InputMaybe<EvalancheFormComponentWhereUniqueInput>;
  /** Create and connect one EvalancheFormComponent document */
  create?: InputMaybe<EvalancheFormComponentCreateInput>;
};

/** An edge in a connection. */
export type EvalancheFormComponentEdge = {
  __typename?: 'EvalancheFormComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EvalancheFormComponent;
};

/** Identifies documents */
export type EvalancheFormComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EvalancheFormComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EvalancheFormComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EvalancheFormComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordionTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  accordionTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  accordionTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  accordionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  accordionTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  accordionTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  accordionTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  accordionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  accordionTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  accordionTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  collapsed_not?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<EvalancheFormComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<EvalancheFormComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<EvalancheFormComponentWhereStageInput>;
  evalancheHost?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  evalancheHost_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  evalancheHost_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  evalancheHost_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  evalancheHost_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  evalancheHost_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  evalancheHost_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  evalancheHost_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  evalancheHost_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  evalancheHost_starts_with?: InputMaybe<Scalars['String']['input']>;
  fieldsAfterAccordion?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  fieldsAfterAccordion_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  fieldsAfterAccordion_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  fieldsAfterAccordion_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  fieldsAfterAccordion_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  fieldsAfterAccordion_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  fieldsAfterAccordion_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  fieldsAfterAccordion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fieldsBeforeAccordion?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  fieldsBeforeAccordion_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  fieldsBeforeAccordion_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  fieldsBeforeAccordion_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  fieldsBeforeAccordion_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  fieldsBeforeAccordion_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  fieldsBeforeAccordion_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  fieldsBeforeAccordion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  formFileUploader?: InputMaybe<FormFileUploaderWhereInput>;
  formId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  formId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  formId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  formId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  formId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  formId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  formId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  formId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  formId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  formId_starts_with?: InputMaybe<Scalars['String']['input']>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  successMessage?: InputMaybe<Scalars['String']['input']>;
  successMessageDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  successMessageDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  successMessageDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  successMessageDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  successMessageDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  successMessageDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  successMessageDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  successMessageDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  successMessageDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  successMessageDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  successMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  successMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  successMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  successMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  successMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  successMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  successMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  successMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  successMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum EvalancheFormComponentOrderByInput {
  accordionTitle_ASC = 'accordionTitle_ASC',
  accordionTitle_DESC = 'accordionTitle_DESC',
  collapsed_ASC = 'collapsed_ASC',
  collapsed_DESC = 'collapsed_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  evalancheHost_ASC = 'evalancheHost_ASC',
  evalancheHost_DESC = 'evalancheHost_DESC',
  fieldsAfterAccordion_ASC = 'fieldsAfterAccordion_ASC',
  fieldsAfterAccordion_DESC = 'fieldsAfterAccordion_DESC',
  fieldsBeforeAccordion_ASC = 'fieldsBeforeAccordion_ASC',
  fieldsBeforeAccordion_DESC = 'fieldsBeforeAccordion_DESC',
  formId_ASC = 'formId_ASC',
  formId_DESC = 'formId_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  successMessageDescription_ASC = 'successMessageDescription_ASC',
  successMessageDescription_DESC = 'successMessageDescription_DESC',
  successMessage_ASC = 'successMessage_ASC',
  successMessage_DESC = 'successMessage_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type EvalancheFormComponentUpdateInput = {
  accordionTitle?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  evalancheHost?: InputMaybe<Scalars['String']['input']>;
  fieldsAfterAccordion?: InputMaybe<Scalars['Int']['input']>;
  fieldsBeforeAccordion?: InputMaybe<Scalars['Int']['input']>;
  formFileUploader?: InputMaybe<FormFileUploaderUpdateOneInlineInput>;
  formId?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  successMessage?: InputMaybe<Scalars['String']['input']>;
  successMessageDescription?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type EvalancheFormComponentUpdateManyInlineInput = {
  /** Connect multiple existing EvalancheFormComponent documents */
  connect?: InputMaybe<Array<EvalancheFormComponentConnectInput>>;
  /** Create and connect multiple EvalancheFormComponent documents */
  create?: InputMaybe<Array<EvalancheFormComponentCreateInput>>;
  /** Delete multiple EvalancheFormComponent documents */
  delete?: InputMaybe<Array<EvalancheFormComponentWhereUniqueInput>>;
  /** Disconnect multiple EvalancheFormComponent documents */
  disconnect?: InputMaybe<Array<EvalancheFormComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing EvalancheFormComponent documents */
  set?: InputMaybe<Array<EvalancheFormComponentWhereUniqueInput>>;
  /** Update multiple EvalancheFormComponent documents */
  update?: InputMaybe<Array<EvalancheFormComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple EvalancheFormComponent documents */
  upsert?: InputMaybe<Array<EvalancheFormComponentUpsertWithNestedWhereUniqueInput>>;
};

export type EvalancheFormComponentUpdateManyInput = {
  accordionTitle?: InputMaybe<Scalars['String']['input']>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  evalancheHost?: InputMaybe<Scalars['String']['input']>;
  fieldsAfterAccordion?: InputMaybe<Scalars['Int']['input']>;
  fieldsBeforeAccordion?: InputMaybe<Scalars['Int']['input']>;
  formId?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  successMessage?: InputMaybe<Scalars['String']['input']>;
  successMessageDescription?: InputMaybe<Scalars['String']['input']>;
};

export type EvalancheFormComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: EvalancheFormComponentUpdateManyInput;
  /** Document search */
  where: EvalancheFormComponentWhereInput;
};

export type EvalancheFormComponentUpdateOneInlineInput = {
  /** Connect existing EvalancheFormComponent document */
  connect?: InputMaybe<EvalancheFormComponentWhereUniqueInput>;
  /** Create and connect one EvalancheFormComponent document */
  create?: InputMaybe<EvalancheFormComponentCreateInput>;
  /** Delete currently connected EvalancheFormComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected EvalancheFormComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single EvalancheFormComponent document */
  update?: InputMaybe<EvalancheFormComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single EvalancheFormComponent document */
  upsert?: InputMaybe<EvalancheFormComponentUpsertWithNestedWhereUniqueInput>;
};

export type EvalancheFormComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: EvalancheFormComponentUpdateInput;
  /** Unique document search */
  where: EvalancheFormComponentWhereUniqueInput;
};

export type EvalancheFormComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: EvalancheFormComponentCreateInput;
  /** Update document if it exists */
  update: EvalancheFormComponentUpdateInput;
};

export type EvalancheFormComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: EvalancheFormComponentUpsertInput;
  /** Unique document search */
  where: EvalancheFormComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type EvalancheFormComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type EvalancheFormComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EvalancheFormComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EvalancheFormComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EvalancheFormComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordionTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  accordionTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  accordionTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  accordionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  accordionTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  accordionTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  accordionTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  accordionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  accordionTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  accordionTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  collapsed_not?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<EvalancheFormComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<EvalancheFormComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<EvalancheFormComponentWhereStageInput>;
  evalancheHost?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  evalancheHost_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  evalancheHost_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  evalancheHost_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  evalancheHost_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  evalancheHost_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  evalancheHost_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  evalancheHost_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  evalancheHost_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  evalancheHost_starts_with?: InputMaybe<Scalars['String']['input']>;
  fieldsAfterAccordion?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  fieldsAfterAccordion_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  fieldsAfterAccordion_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  fieldsAfterAccordion_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  fieldsAfterAccordion_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  fieldsAfterAccordion_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  fieldsAfterAccordion_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  fieldsAfterAccordion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fieldsBeforeAccordion?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  fieldsBeforeAccordion_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  fieldsBeforeAccordion_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  fieldsBeforeAccordion_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  fieldsBeforeAccordion_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  fieldsBeforeAccordion_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  fieldsBeforeAccordion_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  fieldsBeforeAccordion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  formFileUploader?: InputMaybe<FormFileUploaderWhereInput>;
  formId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  formId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  formId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  formId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  formId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  formId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  formId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  formId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  formId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  formId_starts_with?: InputMaybe<Scalars['String']['input']>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  successMessage?: InputMaybe<Scalars['String']['input']>;
  successMessageDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  successMessageDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  successMessageDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  successMessageDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  successMessageDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  successMessageDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  successMessageDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  successMessageDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  successMessageDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  successMessageDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  successMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  successMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  successMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  successMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  successMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  successMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  successMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  successMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  successMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type EvalancheFormComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EvalancheFormComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EvalancheFormComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EvalancheFormComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<EvalancheFormComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References EvalancheFormComponent record uniquely */
export type EvalancheFormComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Title to be used to find the contents in the CMS */
export type ExampleComponent = Entity & Node & {
  __typename?: 'ExampleComponent';
  assetsComponents: Array<AssetComponent>;
  /** Title to be used to find the contents in the CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  customfieldextension?: Maybe<Scalars['String']['output']>;
  /** Description field for adding description text in the component */
  description?: Maybe<ExampleComponentDescriptionRichText>;
  /** Get the document in other stages */
  documentInStages: Array<ExampleComponent>;
  genericPages: Array<GenericPage>;
  /** List of ExampleComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Option to configure where the text and image is rendered for the component. */
  imageTextAlignment?: Maybe<ImageTextAlignment>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Title field for the title of the component */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentAssetsComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentWhereInput>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ExampleComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ExampleComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type ExampleComponentConnection = {
  __typename?: 'ExampleComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ExampleComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ExampleComponentCreateInput = {
  assetsComponents?: InputMaybe<AssetComponentCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customfieldextension?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  imageTextAlignment?: InputMaybe<ImageTextAlignment>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExampleComponentCreateManyInlineInput = {
  /** Connect multiple existing ExampleComponent documents */
  connect?: InputMaybe<Array<ExampleComponentWhereUniqueInput>>;
  /** Create and connect multiple existing ExampleComponent documents */
  create?: InputMaybe<Array<ExampleComponentCreateInput>>;
};

export type ExampleComponentCreateOneInlineInput = {
  /** Connect one existing ExampleComponent document */
  connect?: InputMaybe<ExampleComponentWhereUniqueInput>;
  /** Create and connect one ExampleComponent document */
  create?: InputMaybe<ExampleComponentCreateInput>;
};

export type ExampleComponentDescriptionRichText = {
  __typename?: 'ExampleComponentDescriptionRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<ExampleComponentDescriptionRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type ExampleComponentDescriptionRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ExampleComponentDescriptionRichTextEmbeddedTypes = Asset;

/** An edge in a connection. */
export type ExampleComponentEdge = {
  __typename?: 'ExampleComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ExampleComponent;
};

/** Identifies documents */
export type ExampleComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ExampleComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ExampleComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ExampleComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  customfieldextension?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  customfieldextension_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  customfieldextension_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  customfieldextension_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  customfieldextension_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  customfieldextension_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  customfieldextension_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  customfieldextension_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  customfieldextension_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  customfieldextension_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<ExampleComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<ExampleComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<ExampleComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageTextAlignment?: InputMaybe<ImageTextAlignment>;
  /** All values that are contained in given list. */
  imageTextAlignment_in?: InputMaybe<Array<InputMaybe<ImageTextAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageTextAlignment_not?: InputMaybe<ImageTextAlignment>;
  /** All values that are not contained in given list. */
  imageTextAlignment_not_in?: InputMaybe<Array<InputMaybe<ImageTextAlignment>>>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ExampleComponentOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  customfieldextension_ASC = 'customfieldextension_ASC',
  customfieldextension_DESC = 'customfieldextension_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  imageTextAlignment_ASC = 'imageTextAlignment_ASC',
  imageTextAlignment_DESC = 'imageTextAlignment_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ExampleComponentUpdateInput = {
  assetsComponents?: InputMaybe<AssetComponentUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  customfieldextension?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  imageTextAlignment?: InputMaybe<ImageTextAlignment>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ExampleComponentUpdateManyInlineInput = {
  /** Connect multiple existing ExampleComponent documents */
  connect?: InputMaybe<Array<ExampleComponentConnectInput>>;
  /** Create and connect multiple ExampleComponent documents */
  create?: InputMaybe<Array<ExampleComponentCreateInput>>;
  /** Delete multiple ExampleComponent documents */
  delete?: InputMaybe<Array<ExampleComponentWhereUniqueInput>>;
  /** Disconnect multiple ExampleComponent documents */
  disconnect?: InputMaybe<Array<ExampleComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ExampleComponent documents */
  set?: InputMaybe<Array<ExampleComponentWhereUniqueInput>>;
  /** Update multiple ExampleComponent documents */
  update?: InputMaybe<Array<ExampleComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ExampleComponent documents */
  upsert?: InputMaybe<Array<ExampleComponentUpsertWithNestedWhereUniqueInput>>;
};

export type ExampleComponentUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  customfieldextension?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  imageTextAlignment?: InputMaybe<ImageTextAlignment>;
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ExampleComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ExampleComponentUpdateManyInput;
  /** Document search */
  where: ExampleComponentWhereInput;
};

export type ExampleComponentUpdateOneInlineInput = {
  /** Connect existing ExampleComponent document */
  connect?: InputMaybe<ExampleComponentWhereUniqueInput>;
  /** Create and connect one ExampleComponent document */
  create?: InputMaybe<ExampleComponentCreateInput>;
  /** Delete currently connected ExampleComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ExampleComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ExampleComponent document */
  update?: InputMaybe<ExampleComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ExampleComponent document */
  upsert?: InputMaybe<ExampleComponentUpsertWithNestedWhereUniqueInput>;
};

export type ExampleComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ExampleComponentUpdateInput;
  /** Unique document search */
  where: ExampleComponentWhereUniqueInput;
};

export type ExampleComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: ExampleComponentCreateInput;
  /** Update document if it exists */
  update: ExampleComponentUpdateInput;
};

export type ExampleComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ExampleComponentUpsertInput;
  /** Unique document search */
  where: ExampleComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ExampleComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ExampleComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ExampleComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ExampleComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ExampleComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  customfieldextension?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  customfieldextension_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  customfieldextension_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  customfieldextension_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  customfieldextension_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  customfieldextension_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  customfieldextension_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  customfieldextension_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  customfieldextension_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  customfieldextension_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<ExampleComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<ExampleComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<ExampleComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageTextAlignment?: InputMaybe<ImageTextAlignment>;
  /** All values that are contained in given list. */
  imageTextAlignment_in?: InputMaybe<Array<InputMaybe<ImageTextAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageTextAlignment_not?: InputMaybe<ImageTextAlignment>;
  /** All values that are not contained in given list. */
  imageTextAlignment_not_in?: InputMaybe<Array<InputMaybe<ImageTextAlignment>>>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ExampleComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ExampleComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ExampleComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ExampleComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ExampleComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ExampleComponent record uniquely */
export type ExampleComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContent = Entity & Node & {
  __typename?: 'FeaturedContent';
  anchorNav?: Maybe<AnchorNavigation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** If your featured content includes featured recipe items, be sure to reference the Recipe Dictionary here. */
  dictionary?: Maybe<Dictionary>;
  /** Get the document in other stages */
  documentInStages: Array<FeaturedContent>;
  genericPages: Array<GenericPage>;
  /** List of FeaturedContent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Featured Card(s) to display */
  items: Array<FeaturedContentItems>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** Name for this featured content */
  name: Scalars['String']['output'];
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Appears above the title */
  superText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentDictionaryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FeaturedContentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FeaturedContentWhereUniqueInput;
};

/** A connection to a list of items. */
export type FeaturedContentConnection = {
  __typename?: 'FeaturedContentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FeaturedContentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FeaturedContentCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  ckuqzlfx11och01xqe7628qmm?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionary?: InputMaybe<DictionaryCreateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  items?: InputMaybe<FeaturedContentItemsCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  name: Scalars['String']['input'];
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FeaturedContentCreateManyInlineInput = {
  /** Connect multiple existing FeaturedContent documents */
  connect?: InputMaybe<Array<FeaturedContentWhereUniqueInput>>;
  /** Create and connect multiple existing FeaturedContent documents */
  create?: InputMaybe<Array<FeaturedContentCreateInput>>;
};

export type FeaturedContentCreateOneInlineInput = {
  /** Connect one existing FeaturedContent document */
  connect?: InputMaybe<FeaturedContentWhereUniqueInput>;
  /** Create and connect one FeaturedContent document */
  create?: InputMaybe<FeaturedContentCreateInput>;
};

/** An edge in a connection. */
export type FeaturedContentEdge = {
  __typename?: 'FeaturedContentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FeaturedContent;
};

export type FeaturedContentItems = AuthorableContentCard | FeaturedContentReference;

export type FeaturedContentItemsConnectInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardConnectInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceConnectInput>;
};

export type FeaturedContentItemsCreateInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardCreateInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceCreateInput>;
};

export type FeaturedContentItemsCreateManyInlineInput = {
  /** Connect multiple existing FeaturedContentItems documents */
  connect?: InputMaybe<Array<FeaturedContentItemsWhereUniqueInput>>;
  /** Create and connect multiple existing FeaturedContentItems documents */
  create?: InputMaybe<Array<FeaturedContentItemsCreateInput>>;
};

export type FeaturedContentItemsCreateOneInlineInput = {
  /** Connect one existing FeaturedContentItems document */
  connect?: InputMaybe<FeaturedContentItemsWhereUniqueInput>;
  /** Create and connect one FeaturedContentItems document */
  create?: InputMaybe<FeaturedContentItemsCreateInput>;
};

export type FeaturedContentItemsUpdateInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceUpdateInput>;
};

export type FeaturedContentItemsUpdateManyInlineInput = {
  /** Connect multiple existing FeaturedContentItems documents */
  connect?: InputMaybe<Array<FeaturedContentItemsConnectInput>>;
  /** Create and connect multiple FeaturedContentItems documents */
  create?: InputMaybe<Array<FeaturedContentItemsCreateInput>>;
  /** Delete multiple FeaturedContentItems documents */
  delete?: InputMaybe<Array<FeaturedContentItemsWhereUniqueInput>>;
  /** Disconnect multiple FeaturedContentItems documents */
  disconnect?: InputMaybe<Array<FeaturedContentItemsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FeaturedContentItems documents */
  set?: InputMaybe<Array<FeaturedContentItemsWhereUniqueInput>>;
  /** Update multiple FeaturedContentItems documents */
  update?: InputMaybe<Array<FeaturedContentItemsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FeaturedContentItems documents */
  upsert?: InputMaybe<Array<FeaturedContentItemsUpsertWithNestedWhereUniqueInput>>;
};

export type FeaturedContentItemsUpdateManyWithNestedWhereInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateManyWithNestedWhereInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceUpdateManyWithNestedWhereInput>;
};

export type FeaturedContentItemsUpdateOneInlineInput = {
  /** Connect existing FeaturedContentItems document */
  connect?: InputMaybe<FeaturedContentItemsWhereUniqueInput>;
  /** Create and connect one FeaturedContentItems document */
  create?: InputMaybe<FeaturedContentItemsCreateInput>;
  /** Delete currently connected FeaturedContentItems document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FeaturedContentItems document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FeaturedContentItems document */
  update?: InputMaybe<FeaturedContentItemsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FeaturedContentItems document */
  upsert?: InputMaybe<FeaturedContentItemsUpsertWithNestedWhereUniqueInput>;
};

export type FeaturedContentItemsUpdateWithNestedWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateWithNestedWhereUniqueInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceUpdateWithNestedWhereUniqueInput>;
};

export type FeaturedContentItemsUpsertWithNestedWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpsertWithNestedWhereUniqueInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceUpsertWithNestedWhereUniqueInput>;
};

export type FeaturedContentItemsWhereInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceWhereInput>;
};

export type FeaturedContentItemsWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereUniqueInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceWhereUniqueInput>;
};

/** Identifies documents */
export type FeaturedContentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FeaturedContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FeaturedContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FeaturedContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionary?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<FeaturedContentWhereStageInput>;
  documentInStages_none?: InputMaybe<FeaturedContentWhereStageInput>;
  documentInStages_some?: InputMaybe<FeaturedContentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  items_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  items_some?: InputMaybe<FeaturedContentItemsWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FeaturedContentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FeaturedContentReference = Entity & Node & {
  __typename?: 'FeaturedContentReference';
  articlePage?: Maybe<GenericPage>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FeaturedContentReference>;
  featuredContent?: Maybe<FeaturedContent>;
  genericGridAuthorables: Array<GenericGridAuthorable>;
  /** List of FeaturedContentReference versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeId?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  tipsAndTricksId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FeaturedContentReferenceArticlePageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FeaturedContentReferenceCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FeaturedContentReferenceDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FeaturedContentReferenceFeaturedContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FeaturedContentReferenceGenericGridAuthorablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericGridAuthorableWhereInput>;
};


export type FeaturedContentReferenceHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FeaturedContentReferenceMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FeaturedContentReferencePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FeaturedContentReferenceScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FeaturedContentReferenceUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FeaturedContentReferenceConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FeaturedContentReferenceWhereUniqueInput;
};

/** A connection to a list of items. */
export type FeaturedContentReferenceConnection = {
  __typename?: 'FeaturedContentReferenceConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FeaturedContentReferenceEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FeaturedContentReferenceCreateInput = {
  articlePage?: InputMaybe<GenericPageCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  featuredContent?: InputMaybe<FeaturedContentCreateOneInlineInput>;
  genericGridAuthorables?: InputMaybe<GenericGridAuthorableCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  recipeId?: InputMaybe<Scalars['String']['input']>;
  tipsAndTricksId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FeaturedContentReferenceCreateManyInlineInput = {
  /** Connect multiple existing FeaturedContentReference documents */
  connect?: InputMaybe<Array<FeaturedContentReferenceWhereUniqueInput>>;
  /** Create and connect multiple existing FeaturedContentReference documents */
  create?: InputMaybe<Array<FeaturedContentReferenceCreateInput>>;
};

export type FeaturedContentReferenceCreateOneInlineInput = {
  /** Connect one existing FeaturedContentReference document */
  connect?: InputMaybe<FeaturedContentReferenceWhereUniqueInput>;
  /** Create and connect one FeaturedContentReference document */
  create?: InputMaybe<FeaturedContentReferenceCreateInput>;
};

/** An edge in a connection. */
export type FeaturedContentReferenceEdge = {
  __typename?: 'FeaturedContentReferenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FeaturedContentReference;
};

/** Identifies documents */
export type FeaturedContentReferenceManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FeaturedContentReferenceWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FeaturedContentReferenceWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FeaturedContentReferenceWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articlePage?: InputMaybe<GenericPageWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FeaturedContentReferenceWhereStageInput>;
  documentInStages_none?: InputMaybe<FeaturedContentReferenceWhereStageInput>;
  documentInStages_some?: InputMaybe<FeaturedContentReferenceWhereStageInput>;
  featuredContent?: InputMaybe<FeaturedContentWhereInput>;
  genericGridAuthorables_every?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorables_none?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorables_some?: InputMaybe<GenericGridAuthorableWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  recipeId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  recipeId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  recipeId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  recipeId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  recipeId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  recipeId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  recipeId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  recipeId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  recipeId_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tipsAndTricksId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tipsAndTricksId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tipsAndTricksId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tipsAndTricksId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tipsAndTricksId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tipsAndTricksId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tipsAndTricksId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tipsAndTricksId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tipsAndTricksId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tipsAndTricksId_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FeaturedContentReferenceOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  recipeId_ASC = 'recipeId_ASC',
  recipeId_DESC = 'recipeId_DESC',
  tipsAndTricksId_ASC = 'tipsAndTricksId_ASC',
  tipsAndTricksId_DESC = 'tipsAndTricksId_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FeaturedContentReferenceUpdateInput = {
  articlePage?: InputMaybe<GenericPageUpdateOneInlineInput>;
  featuredContent?: InputMaybe<FeaturedContentUpdateOneInlineInput>;
  genericGridAuthorables?: InputMaybe<GenericGridAuthorableUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  recipeId?: InputMaybe<Scalars['String']['input']>;
  tipsAndTricksId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FeaturedContentReferenceUpdateManyInlineInput = {
  /** Connect multiple existing FeaturedContentReference documents */
  connect?: InputMaybe<Array<FeaturedContentReferenceConnectInput>>;
  /** Create and connect multiple FeaturedContentReference documents */
  create?: InputMaybe<Array<FeaturedContentReferenceCreateInput>>;
  /** Delete multiple FeaturedContentReference documents */
  delete?: InputMaybe<Array<FeaturedContentReferenceWhereUniqueInput>>;
  /** Disconnect multiple FeaturedContentReference documents */
  disconnect?: InputMaybe<Array<FeaturedContentReferenceWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FeaturedContentReference documents */
  set?: InputMaybe<Array<FeaturedContentReferenceWhereUniqueInput>>;
  /** Update multiple FeaturedContentReference documents */
  update?: InputMaybe<Array<FeaturedContentReferenceUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FeaturedContentReference documents */
  upsert?: InputMaybe<Array<FeaturedContentReferenceUpsertWithNestedWhereUniqueInput>>;
};

export type FeaturedContentReferenceUpdateManyInput = {
  market?: InputMaybe<Markets>;
  recipeId?: InputMaybe<Scalars['String']['input']>;
  tipsAndTricksId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FeaturedContentReferenceUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FeaturedContentReferenceUpdateManyInput;
  /** Document search */
  where: FeaturedContentReferenceWhereInput;
};

export type FeaturedContentReferenceUpdateOneInlineInput = {
  /** Connect existing FeaturedContentReference document */
  connect?: InputMaybe<FeaturedContentReferenceWhereUniqueInput>;
  /** Create and connect one FeaturedContentReference document */
  create?: InputMaybe<FeaturedContentReferenceCreateInput>;
  /** Delete currently connected FeaturedContentReference document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FeaturedContentReference document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FeaturedContentReference document */
  update?: InputMaybe<FeaturedContentReferenceUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FeaturedContentReference document */
  upsert?: InputMaybe<FeaturedContentReferenceUpsertWithNestedWhereUniqueInput>;
};

export type FeaturedContentReferenceUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FeaturedContentReferenceUpdateInput;
  /** Unique document search */
  where: FeaturedContentReferenceWhereUniqueInput;
};

export type FeaturedContentReferenceUpsertInput = {
  /** Create document if it didn't exist */
  create: FeaturedContentReferenceCreateInput;
  /** Update document if it exists */
  update: FeaturedContentReferenceUpdateInput;
};

export type FeaturedContentReferenceUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FeaturedContentReferenceUpsertInput;
  /** Unique document search */
  where: FeaturedContentReferenceWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FeaturedContentReferenceWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FeaturedContentReferenceWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FeaturedContentReferenceWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FeaturedContentReferenceWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FeaturedContentReferenceWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articlePage?: InputMaybe<GenericPageWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FeaturedContentReferenceWhereStageInput>;
  documentInStages_none?: InputMaybe<FeaturedContentReferenceWhereStageInput>;
  documentInStages_some?: InputMaybe<FeaturedContentReferenceWhereStageInput>;
  featuredContent?: InputMaybe<FeaturedContentWhereInput>;
  genericGridAuthorables_every?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorables_none?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorables_some?: InputMaybe<GenericGridAuthorableWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  recipeId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  recipeId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  recipeId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  recipeId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  recipeId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  recipeId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  recipeId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  recipeId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  recipeId_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tipsAndTricksId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tipsAndTricksId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tipsAndTricksId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tipsAndTricksId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tipsAndTricksId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tipsAndTricksId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tipsAndTricksId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tipsAndTricksId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tipsAndTricksId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tipsAndTricksId_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FeaturedContentReferenceWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FeaturedContentReferenceWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FeaturedContentReferenceWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FeaturedContentReferenceWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FeaturedContentReferenceWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FeaturedContentReference record uniquely */
export type FeaturedContentReferenceWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FeaturedContentUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  ckuqzlfx11och01xqe7628qmm?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  dictionary?: InputMaybe<DictionaryUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  items?: InputMaybe<FeaturedContentItemsUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FeaturedContentUpdateManyInlineInput = {
  /** Connect multiple existing FeaturedContent documents */
  connect?: InputMaybe<Array<FeaturedContentConnectInput>>;
  /** Create and connect multiple FeaturedContent documents */
  create?: InputMaybe<Array<FeaturedContentCreateInput>>;
  /** Delete multiple FeaturedContent documents */
  delete?: InputMaybe<Array<FeaturedContentWhereUniqueInput>>;
  /** Disconnect multiple FeaturedContent documents */
  disconnect?: InputMaybe<Array<FeaturedContentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FeaturedContent documents */
  set?: InputMaybe<Array<FeaturedContentWhereUniqueInput>>;
  /** Update multiple FeaturedContent documents */
  update?: InputMaybe<Array<FeaturedContentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FeaturedContent documents */
  upsert?: InputMaybe<Array<FeaturedContentUpsertWithNestedWhereUniqueInput>>;
};

export type FeaturedContentUpdateManyInput = {
  market?: InputMaybe<Markets>;
  name?: InputMaybe<Scalars['String']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FeaturedContentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FeaturedContentUpdateManyInput;
  /** Document search */
  where: FeaturedContentWhereInput;
};

export type FeaturedContentUpdateOneInlineInput = {
  /** Connect existing FeaturedContent document */
  connect?: InputMaybe<FeaturedContentWhereUniqueInput>;
  /** Create and connect one FeaturedContent document */
  create?: InputMaybe<FeaturedContentCreateInput>;
  /** Delete currently connected FeaturedContent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FeaturedContent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FeaturedContent document */
  update?: InputMaybe<FeaturedContentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FeaturedContent document */
  upsert?: InputMaybe<FeaturedContentUpsertWithNestedWhereUniqueInput>;
};

export type FeaturedContentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FeaturedContentUpdateInput;
  /** Unique document search */
  where: FeaturedContentWhereUniqueInput;
};

export type FeaturedContentUpsertInput = {
  /** Create document if it didn't exist */
  create: FeaturedContentCreateInput;
  /** Update document if it exists */
  update: FeaturedContentUpdateInput;
};

export type FeaturedContentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FeaturedContentUpsertInput;
  /** Unique document search */
  where: FeaturedContentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FeaturedContentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FeaturedContentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FeaturedContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FeaturedContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FeaturedContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionary?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<FeaturedContentWhereStageInput>;
  documentInStages_none?: InputMaybe<FeaturedContentWhereStageInput>;
  documentInStages_some?: InputMaybe<FeaturedContentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  items_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  items_some?: InputMaybe<FeaturedContentItemsWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FeaturedContentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FeaturedContentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FeaturedContentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FeaturedContentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FeaturedContentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FeaturedContent record uniquely */
export type FeaturedContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Navigation Type inside footer */
export enum FooterNav {
  LegalSection = 'LegalSection',
  MainNav = 'MainNav'
}

/** Footer Navigation */
export type FooterNavigation = Entity & Node & {
  __typename?: 'FooterNavigation';
  cmsTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FooterNavigation>;
  footerNavType: FooterNav;
  /** List of FooterNavigation versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Footer links */
  links: Array<FooterNavigationLinks>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** Select for Social Media in Navigation */
  socialMediaLink: Scalars['Boolean']['output'];
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Footer Navigation */
export type FooterNavigationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Footer Navigation */
export type FooterNavigationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Footer Navigation */
export type FooterNavigationHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Footer Navigation */
export type FooterNavigationLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Footer Navigation */
export type FooterNavigationMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Footer Navigation */
export type FooterNavigationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Footer Navigation */
export type FooterNavigationScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Footer Navigation */
export type FooterNavigationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FooterNavigationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FooterNavigationWhereUniqueInput;
};

/** A connection to a list of items. */
export type FooterNavigationConnection = {
  __typename?: 'FooterNavigationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FooterNavigationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FooterNavigationCreateInput = {
  cmsTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  footerNavType: FooterNav;
  links?: InputMaybe<FooterNavigationLinksCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  socialMediaLink: Scalars['Boolean']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FooterNavigationCreateManyInlineInput = {
  /** Connect multiple existing FooterNavigation documents */
  connect?: InputMaybe<Array<FooterNavigationWhereUniqueInput>>;
  /** Create and connect multiple existing FooterNavigation documents */
  create?: InputMaybe<Array<FooterNavigationCreateInput>>;
};

export type FooterNavigationCreateOneInlineInput = {
  /** Connect one existing FooterNavigation document */
  connect?: InputMaybe<FooterNavigationWhereUniqueInput>;
  /** Create and connect one FooterNavigation document */
  create?: InputMaybe<FooterNavigationCreateInput>;
};

/** An edge in a connection. */
export type FooterNavigationEdge = {
  __typename?: 'FooterNavigationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FooterNavigation;
};

export type FooterNavigationLinks = Link;

export type FooterNavigationLinksConnectInput = {
  Link?: InputMaybe<LinkConnectInput>;
};

export type FooterNavigationLinksCreateInput = {
  Link?: InputMaybe<LinkCreateInput>;
};

export type FooterNavigationLinksCreateManyInlineInput = {
  /** Connect multiple existing FooterNavigationLinks documents */
  connect?: InputMaybe<Array<FooterNavigationLinksWhereUniqueInput>>;
  /** Create and connect multiple existing FooterNavigationLinks documents */
  create?: InputMaybe<Array<FooterNavigationLinksCreateInput>>;
};

export type FooterNavigationLinksCreateOneInlineInput = {
  /** Connect one existing FooterNavigationLinks document */
  connect?: InputMaybe<FooterNavigationLinksWhereUniqueInput>;
  /** Create and connect one FooterNavigationLinks document */
  create?: InputMaybe<FooterNavigationLinksCreateInput>;
};

export type FooterNavigationLinksUpdateInput = {
  Link?: InputMaybe<LinkUpdateInput>;
};

export type FooterNavigationLinksUpdateManyInlineInput = {
  /** Connect multiple existing FooterNavigationLinks documents */
  connect?: InputMaybe<Array<FooterNavigationLinksConnectInput>>;
  /** Create and connect multiple FooterNavigationLinks documents */
  create?: InputMaybe<Array<FooterNavigationLinksCreateInput>>;
  /** Delete multiple FooterNavigationLinks documents */
  delete?: InputMaybe<Array<FooterNavigationLinksWhereUniqueInput>>;
  /** Disconnect multiple FooterNavigationLinks documents */
  disconnect?: InputMaybe<Array<FooterNavigationLinksWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FooterNavigationLinks documents */
  set?: InputMaybe<Array<FooterNavigationLinksWhereUniqueInput>>;
  /** Update multiple FooterNavigationLinks documents */
  update?: InputMaybe<Array<FooterNavigationLinksUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FooterNavigationLinks documents */
  upsert?: InputMaybe<Array<FooterNavigationLinksUpsertWithNestedWhereUniqueInput>>;
};

export type FooterNavigationLinksUpdateManyWithNestedWhereInput = {
  Link?: InputMaybe<LinkUpdateManyWithNestedWhereInput>;
};

export type FooterNavigationLinksUpdateOneInlineInput = {
  /** Connect existing FooterNavigationLinks document */
  connect?: InputMaybe<FooterNavigationLinksWhereUniqueInput>;
  /** Create and connect one FooterNavigationLinks document */
  create?: InputMaybe<FooterNavigationLinksCreateInput>;
  /** Delete currently connected FooterNavigationLinks document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FooterNavigationLinks document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FooterNavigationLinks document */
  update?: InputMaybe<FooterNavigationLinksUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FooterNavigationLinks document */
  upsert?: InputMaybe<FooterNavigationLinksUpsertWithNestedWhereUniqueInput>;
};

export type FooterNavigationLinksUpdateWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
};

export type FooterNavigationLinksUpsertWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
};

export type FooterNavigationLinksWhereInput = {
  Link?: InputMaybe<LinkWhereInput>;
};

export type FooterNavigationLinksWhereUniqueInput = {
  Link?: InputMaybe<LinkWhereUniqueInput>;
};

/** Identifies documents */
export type FooterNavigationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterNavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterNavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterNavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FooterNavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<FooterNavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<FooterNavigationWhereStageInput>;
  footerNavType?: InputMaybe<FooterNav>;
  /** All values that are contained in given list. */
  footerNavType_in?: InputMaybe<Array<InputMaybe<FooterNav>>>;
  /** Any other value that exists and is not equal to the given value. */
  footerNavType_not?: InputMaybe<FooterNav>;
  /** All values that are not contained in given list. */
  footerNavType_not_in?: InputMaybe<Array<InputMaybe<FooterNav>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  links_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  links_some?: InputMaybe<FooterNavigationLinksWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  socialMediaLink?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  socialMediaLink_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FooterNavigationOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  footerNavType_ASC = 'footerNavType_ASC',
  footerNavType_DESC = 'footerNavType_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  socialMediaLink_ASC = 'socialMediaLink_ASC',
  socialMediaLink_DESC = 'socialMediaLink_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FooterNavigationUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  footerNavType?: InputMaybe<FooterNav>;
  links?: InputMaybe<FooterNavigationLinksUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  socialMediaLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FooterNavigationUpdateManyInlineInput = {
  /** Connect multiple existing FooterNavigation documents */
  connect?: InputMaybe<Array<FooterNavigationConnectInput>>;
  /** Create and connect multiple FooterNavigation documents */
  create?: InputMaybe<Array<FooterNavigationCreateInput>>;
  /** Delete multiple FooterNavigation documents */
  delete?: InputMaybe<Array<FooterNavigationWhereUniqueInput>>;
  /** Disconnect multiple FooterNavigation documents */
  disconnect?: InputMaybe<Array<FooterNavigationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FooterNavigation documents */
  set?: InputMaybe<Array<FooterNavigationWhereUniqueInput>>;
  /** Update multiple FooterNavigation documents */
  update?: InputMaybe<Array<FooterNavigationUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FooterNavigation documents */
  upsert?: InputMaybe<Array<FooterNavigationUpsertWithNestedWhereUniqueInput>>;
};

export type FooterNavigationUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  footerNavType?: InputMaybe<FooterNav>;
  market?: InputMaybe<Markets>;
  socialMediaLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FooterNavigationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FooterNavigationUpdateManyInput;
  /** Document search */
  where: FooterNavigationWhereInput;
};

export type FooterNavigationUpdateOneInlineInput = {
  /** Connect existing FooterNavigation document */
  connect?: InputMaybe<FooterNavigationWhereUniqueInput>;
  /** Create and connect one FooterNavigation document */
  create?: InputMaybe<FooterNavigationCreateInput>;
  /** Delete currently connected FooterNavigation document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FooterNavigation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FooterNavigation document */
  update?: InputMaybe<FooterNavigationUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FooterNavigation document */
  upsert?: InputMaybe<FooterNavigationUpsertWithNestedWhereUniqueInput>;
};

export type FooterNavigationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FooterNavigationUpdateInput;
  /** Unique document search */
  where: FooterNavigationWhereUniqueInput;
};

export type FooterNavigationUpsertInput = {
  /** Create document if it didn't exist */
  create: FooterNavigationCreateInput;
  /** Update document if it exists */
  update: FooterNavigationUpdateInput;
};

export type FooterNavigationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FooterNavigationUpsertInput;
  /** Unique document search */
  where: FooterNavigationWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FooterNavigationWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FooterNavigationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterNavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterNavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterNavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FooterNavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<FooterNavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<FooterNavigationWhereStageInput>;
  footerNavType?: InputMaybe<FooterNav>;
  /** All values that are contained in given list. */
  footerNavType_in?: InputMaybe<Array<InputMaybe<FooterNav>>>;
  /** Any other value that exists and is not equal to the given value. */
  footerNavType_not?: InputMaybe<FooterNav>;
  /** All values that are not contained in given list. */
  footerNavType_not_in?: InputMaybe<Array<InputMaybe<FooterNav>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  links_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  links_some?: InputMaybe<FooterNavigationLinksWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  socialMediaLink?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  socialMediaLink_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FooterNavigationWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterNavigationWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterNavigationWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterNavigationWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FooterNavigationWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FooterNavigation record uniquely */
export type FooterNavigationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Add seals or logos to footer */
export type FooterSeal = Entity & Node & {
  __typename?: 'FooterSeal';
  assetsComponents?: Maybe<AssetComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FooterSeal>;
  /** List of FooterSeal versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Choose for which market */
  market: Markets;
  marketName?: Maybe<Market>;
  /** Name under seal / logo */
  name: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Url to the organization */
  url: Scalars['String']['output'];
};


/** Add seals or logos to footer */
export type FooterSealAssetsComponentsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Add seals or logos to footer */
export type FooterSealCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Add seals or logos to footer */
export type FooterSealDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Add seals or logos to footer */
export type FooterSealHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Add seals or logos to footer */
export type FooterSealMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Add seals or logos to footer */
export type FooterSealPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Add seals or logos to footer */
export type FooterSealScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Add seals or logos to footer */
export type FooterSealUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FooterSealConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FooterSealWhereUniqueInput;
};

/** A connection to a list of items. */
export type FooterSealConnection = {
  __typename?: 'FooterSealConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FooterSealEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FooterSealCreateInput = {
  assetsComponents?: InputMaybe<AssetComponentCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type FooterSealCreateManyInlineInput = {
  /** Connect multiple existing FooterSeal documents */
  connect?: InputMaybe<Array<FooterSealWhereUniqueInput>>;
  /** Create and connect multiple existing FooterSeal documents */
  create?: InputMaybe<Array<FooterSealCreateInput>>;
};

export type FooterSealCreateOneInlineInput = {
  /** Connect one existing FooterSeal document */
  connect?: InputMaybe<FooterSealWhereUniqueInput>;
  /** Create and connect one FooterSeal document */
  create?: InputMaybe<FooterSealCreateInput>;
};

/** An edge in a connection. */
export type FooterSealEdge = {
  __typename?: 'FooterSealEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FooterSeal;
};

/** Identifies documents */
export type FooterSealManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterSealWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterSealWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterSealWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetsComponents?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FooterSealWhereStageInput>;
  documentInStages_none?: InputMaybe<FooterSealWhereStageInput>;
  documentInStages_some?: InputMaybe<FooterSealWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum FooterSealOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC'
}

export type FooterSealUpdateInput = {
  assetsComponents?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FooterSealUpdateManyInlineInput = {
  /** Connect multiple existing FooterSeal documents */
  connect?: InputMaybe<Array<FooterSealConnectInput>>;
  /** Create and connect multiple FooterSeal documents */
  create?: InputMaybe<Array<FooterSealCreateInput>>;
  /** Delete multiple FooterSeal documents */
  delete?: InputMaybe<Array<FooterSealWhereUniqueInput>>;
  /** Disconnect multiple FooterSeal documents */
  disconnect?: InputMaybe<Array<FooterSealWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FooterSeal documents */
  set?: InputMaybe<Array<FooterSealWhereUniqueInput>>;
  /** Update multiple FooterSeal documents */
  update?: InputMaybe<Array<FooterSealUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FooterSeal documents */
  upsert?: InputMaybe<Array<FooterSealUpsertWithNestedWhereUniqueInput>>;
};

export type FooterSealUpdateManyInput = {
  market?: InputMaybe<Markets>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FooterSealUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FooterSealUpdateManyInput;
  /** Document search */
  where: FooterSealWhereInput;
};

export type FooterSealUpdateOneInlineInput = {
  /** Connect existing FooterSeal document */
  connect?: InputMaybe<FooterSealWhereUniqueInput>;
  /** Create and connect one FooterSeal document */
  create?: InputMaybe<FooterSealCreateInput>;
  /** Delete currently connected FooterSeal document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FooterSeal document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FooterSeal document */
  update?: InputMaybe<FooterSealUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FooterSeal document */
  upsert?: InputMaybe<FooterSealUpsertWithNestedWhereUniqueInput>;
};

export type FooterSealUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FooterSealUpdateInput;
  /** Unique document search */
  where: FooterSealWhereUniqueInput;
};

export type FooterSealUpsertInput = {
  /** Create document if it didn't exist */
  create: FooterSealCreateInput;
  /** Update document if it exists */
  update: FooterSealUpdateInput;
};

export type FooterSealUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FooterSealUpsertInput;
  /** Unique document search */
  where: FooterSealWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FooterSealWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FooterSealWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterSealWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterSealWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterSealWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetsComponents?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FooterSealWhereStageInput>;
  documentInStages_none?: InputMaybe<FooterSealWhereStageInput>;
  documentInStages_some?: InputMaybe<FooterSealWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FooterSealWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterSealWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterSealWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterSealWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FooterSealWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FooterSeal record uniquely */
export type FooterSealWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Form = Entity & Node & {
  __typename?: 'Form';
  anchorNav?: Maybe<AnchorNavigation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Form>;
  formErrors: Array<FormError>;
  formFields: Array<FormForm>;
  /** contains success message for the form to be displayed after successful submission */
  formSuccess?: Maybe<FormSuccessComponent>;
  /** Selects a pre-defined form type. */
  formType?: Maybe<FormTypes>;
  genericAccordionItem?: Maybe<GenericAccordionItem>;
  genericPages: Array<GenericPage>;
  /** List of Form versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  lowerLeftCorner?: Maybe<Asset>;
  market: Markets;
  marketName?: Maybe<Market>;
  newsletterComponent?: Maybe<NewsletterComponent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  upperRightCorner?: Maybe<Asset>;
};


export type FormAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormFormErrorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormErrorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormErrorWhereInput>;
};


export type FormFormFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FormFormSuccessArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormGenericAccordionItemArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type FormHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormLowerLeftCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type FormMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormNewsletterComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormUpperRightCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type FormCheckbox = Entity & Node & {
  __typename?: 'FormCheckbox';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormCheckbox>;
  /** Please use a one-word identifier for this field which will be used to identify it in the website code */
  fieldName?: Maybe<Scalars['String']['output']>;
  forms: Array<Form>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** List of FormCheckbox versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  longText?: Maybe<RichText>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Used in the CMS only, to identify entries. */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormCheckboxCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormCheckboxDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormCheckboxFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormCheckboxHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormCheckboxMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormCheckboxPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormCheckboxScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormCheckboxUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormCheckboxCollection = Entity & Node & {
  __typename?: 'FormCheckboxCollection';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormCheckboxCollection>;
  /** Single line tex */
  fieldName?: Maybe<Scalars['String']['output']>;
  formCheckboxes: Array<FormCheckbox>;
  forms: Array<Form>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** List of FormCheckboxCollection versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market?: Maybe<Markets>;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Single line text */
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Single line text */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormCheckboxCollectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormCheckboxCollectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormCheckboxCollectionFormCheckboxesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormCheckboxOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormCheckboxWhereInput>;
};


export type FormCheckboxCollectionFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormCheckboxCollectionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormCheckboxCollectionMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormCheckboxCollectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormCheckboxCollectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormCheckboxCollectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormCheckboxCollectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormCheckboxCollectionWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormCheckboxCollectionConnection = {
  __typename?: 'FormCheckboxCollectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormCheckboxCollectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormCheckboxCollectionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  formCheckboxes?: InputMaybe<FormCheckboxCreateManyInlineInput>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormCheckboxCollectionCreateManyInlineInput = {
  /** Connect multiple existing FormCheckboxCollection documents */
  connect?: InputMaybe<Array<FormCheckboxCollectionWhereUniqueInput>>;
  /** Create and connect multiple existing FormCheckboxCollection documents */
  create?: InputMaybe<Array<FormCheckboxCollectionCreateInput>>;
};

export type FormCheckboxCollectionCreateOneInlineInput = {
  /** Connect one existing FormCheckboxCollection document */
  connect?: InputMaybe<FormCheckboxCollectionWhereUniqueInput>;
  /** Create and connect one FormCheckboxCollection document */
  create?: InputMaybe<FormCheckboxCollectionCreateInput>;
};

/** An edge in a connection. */
export type FormCheckboxCollectionEdge = {
  __typename?: 'FormCheckboxCollectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormCheckboxCollection;
};

/** Identifies documents */
export type FormCheckboxCollectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormCheckboxCollectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormCheckboxCollectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormCheckboxCollectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormCheckboxCollectionWhereStageInput>;
  documentInStages_none?: InputMaybe<FormCheckboxCollectionWhereStageInput>;
  documentInStages_some?: InputMaybe<FormCheckboxCollectionWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  formCheckboxes_every?: InputMaybe<FormCheckboxWhereInput>;
  formCheckboxes_none?: InputMaybe<FormCheckboxWhereInput>;
  formCheckboxes_some?: InputMaybe<FormCheckboxWhereInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormCheckboxCollectionOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  hidden_ASC = 'hidden_ASC',
  hidden_DESC = 'hidden_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormCheckboxCollectionUpdateInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  formCheckboxes?: InputMaybe<FormCheckboxUpdateManyInlineInput>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormCheckboxCollectionUpdateManyInlineInput = {
  /** Connect multiple existing FormCheckboxCollection documents */
  connect?: InputMaybe<Array<FormCheckboxCollectionConnectInput>>;
  /** Create and connect multiple FormCheckboxCollection documents */
  create?: InputMaybe<Array<FormCheckboxCollectionCreateInput>>;
  /** Delete multiple FormCheckboxCollection documents */
  delete?: InputMaybe<Array<FormCheckboxCollectionWhereUniqueInput>>;
  /** Disconnect multiple FormCheckboxCollection documents */
  disconnect?: InputMaybe<Array<FormCheckboxCollectionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormCheckboxCollection documents */
  set?: InputMaybe<Array<FormCheckboxCollectionWhereUniqueInput>>;
  /** Update multiple FormCheckboxCollection documents */
  update?: InputMaybe<Array<FormCheckboxCollectionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormCheckboxCollection documents */
  upsert?: InputMaybe<Array<FormCheckboxCollectionUpsertWithNestedWhereUniqueInput>>;
};

export type FormCheckboxCollectionUpdateManyInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormCheckboxCollectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormCheckboxCollectionUpdateManyInput;
  /** Document search */
  where: FormCheckboxCollectionWhereInput;
};

export type FormCheckboxCollectionUpdateOneInlineInput = {
  /** Connect existing FormCheckboxCollection document */
  connect?: InputMaybe<FormCheckboxCollectionWhereUniqueInput>;
  /** Create and connect one FormCheckboxCollection document */
  create?: InputMaybe<FormCheckboxCollectionCreateInput>;
  /** Delete currently connected FormCheckboxCollection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormCheckboxCollection document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormCheckboxCollection document */
  update?: InputMaybe<FormCheckboxCollectionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormCheckboxCollection document */
  upsert?: InputMaybe<FormCheckboxCollectionUpsertWithNestedWhereUniqueInput>;
};

export type FormCheckboxCollectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormCheckboxCollectionUpdateInput;
  /** Unique document search */
  where: FormCheckboxCollectionWhereUniqueInput;
};

export type FormCheckboxCollectionUpsertInput = {
  /** Create document if it didn't exist */
  create: FormCheckboxCollectionCreateInput;
  /** Update document if it exists */
  update: FormCheckboxCollectionUpdateInput;
};

export type FormCheckboxCollectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormCheckboxCollectionUpsertInput;
  /** Unique document search */
  where: FormCheckboxCollectionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormCheckboxCollectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormCheckboxCollectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormCheckboxCollectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormCheckboxCollectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormCheckboxCollectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormCheckboxCollectionWhereStageInput>;
  documentInStages_none?: InputMaybe<FormCheckboxCollectionWhereStageInput>;
  documentInStages_some?: InputMaybe<FormCheckboxCollectionWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  formCheckboxes_every?: InputMaybe<FormCheckboxWhereInput>;
  formCheckboxes_none?: InputMaybe<FormCheckboxWhereInput>;
  formCheckboxes_some?: InputMaybe<FormCheckboxWhereInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormCheckboxCollectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormCheckboxCollectionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormCheckboxCollectionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormCheckboxCollectionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormCheckboxCollectionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormCheckboxCollection record uniquely */
export type FormCheckboxCollectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormCheckboxConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormCheckboxWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormCheckboxConnection = {
  __typename?: 'FormCheckboxConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormCheckboxEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormCheckboxCreateInput = {
  cl0ukk7au0zp801xtcwt37zmm?: InputMaybe<FormCheckboxCollectionCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  longText?: InputMaybe<Scalars['RichTextAST']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormCheckboxCreateManyInlineInput = {
  /** Connect multiple existing FormCheckbox documents */
  connect?: InputMaybe<Array<FormCheckboxWhereUniqueInput>>;
  /** Create and connect multiple existing FormCheckbox documents */
  create?: InputMaybe<Array<FormCheckboxCreateInput>>;
};

export type FormCheckboxCreateOneInlineInput = {
  /** Connect one existing FormCheckbox document */
  connect?: InputMaybe<FormCheckboxWhereUniqueInput>;
  /** Create and connect one FormCheckbox document */
  create?: InputMaybe<FormCheckboxCreateInput>;
};

/** An edge in a connection. */
export type FormCheckboxEdge = {
  __typename?: 'FormCheckboxEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormCheckbox;
};

/** Identifies documents */
export type FormCheckboxManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormCheckboxWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormCheckboxWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormCheckboxWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormCheckboxWhereStageInput>;
  documentInStages_none?: InputMaybe<FormCheckboxWhereStageInput>;
  documentInStages_some?: InputMaybe<FormCheckboxWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormCheckboxOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  hidden_ASC = 'hidden_ASC',
  hidden_DESC = 'hidden_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormCheckboxUpdateInput = {
  cl0ukk7au0zp801xtcwt37zmm?: InputMaybe<FormCheckboxCollectionUpdateManyInlineInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  longText?: InputMaybe<Scalars['RichTextAST']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormCheckboxUpdateManyInlineInput = {
  /** Connect multiple existing FormCheckbox documents */
  connect?: InputMaybe<Array<FormCheckboxConnectInput>>;
  /** Create and connect multiple FormCheckbox documents */
  create?: InputMaybe<Array<FormCheckboxCreateInput>>;
  /** Delete multiple FormCheckbox documents */
  delete?: InputMaybe<Array<FormCheckboxWhereUniqueInput>>;
  /** Disconnect multiple FormCheckbox documents */
  disconnect?: InputMaybe<Array<FormCheckboxWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormCheckbox documents */
  set?: InputMaybe<Array<FormCheckboxWhereUniqueInput>>;
  /** Update multiple FormCheckbox documents */
  update?: InputMaybe<Array<FormCheckboxUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormCheckbox documents */
  upsert?: InputMaybe<Array<FormCheckboxUpsertWithNestedWhereUniqueInput>>;
};

export type FormCheckboxUpdateManyInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  longText?: InputMaybe<Scalars['RichTextAST']['input']>;
  market?: InputMaybe<Markets>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormCheckboxUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormCheckboxUpdateManyInput;
  /** Document search */
  where: FormCheckboxWhereInput;
};

export type FormCheckboxUpdateOneInlineInput = {
  /** Connect existing FormCheckbox document */
  connect?: InputMaybe<FormCheckboxWhereUniqueInput>;
  /** Create and connect one FormCheckbox document */
  create?: InputMaybe<FormCheckboxCreateInput>;
  /** Delete currently connected FormCheckbox document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormCheckbox document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormCheckbox document */
  update?: InputMaybe<FormCheckboxUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormCheckbox document */
  upsert?: InputMaybe<FormCheckboxUpsertWithNestedWhereUniqueInput>;
};

export type FormCheckboxUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormCheckboxUpdateInput;
  /** Unique document search */
  where: FormCheckboxWhereUniqueInput;
};

export type FormCheckboxUpsertInput = {
  /** Create document if it didn't exist */
  create: FormCheckboxCreateInput;
  /** Update document if it exists */
  update: FormCheckboxUpdateInput;
};

export type FormCheckboxUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormCheckboxUpsertInput;
  /** Unique document search */
  where: FormCheckboxWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormCheckboxWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormCheckboxWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormCheckboxWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormCheckboxWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormCheckboxWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormCheckboxWhereStageInput>;
  documentInStages_none?: InputMaybe<FormCheckboxWhereStageInput>;
  documentInStages_some?: InputMaybe<FormCheckboxWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormCheckboxWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormCheckboxWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormCheckboxWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormCheckboxWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormCheckboxWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormCheckbox record uniquely */
export type FormCheckboxWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormConnection = {
  __typename?: 'FormConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  formErrors?: InputMaybe<FormErrorCreateManyInlineInput>;
  formFields?: InputMaybe<FormFormCreateManyInlineInput>;
  formSuccess?: InputMaybe<FormSuccessComponentCreateOneInlineInput>;
  formType?: InputMaybe<FormTypes>;
  genericAccordionItem?: InputMaybe<GenericAccordionItemCreateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  lowerLeftCorner?: InputMaybe<AssetCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  newsletterComponent?: InputMaybe<NewsletterComponentCreateOneInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  upperRightCorner?: InputMaybe<AssetCreateOneInlineInput>;
};

export type FormCreateManyInlineInput = {
  /** Connect multiple existing Form documents */
  connect?: InputMaybe<Array<FormWhereUniqueInput>>;
  /** Create and connect multiple existing Form documents */
  create?: InputMaybe<Array<FormCreateInput>>;
};

export type FormCreateOneInlineInput = {
  /** Connect one existing Form document */
  connect?: InputMaybe<FormWhereUniqueInput>;
  /** Create and connect one Form document */
  create?: InputMaybe<FormCreateInput>;
};

/** DO NOT USE THIS FIELD WHILE THIS MESSAGE IS STILL HERE - this is a new field that separates out Text and Date from the FormTextInput field, so we can have more control over both types. We are waiting for the code to be deployed to production, when this is done this field will be available for use. 02.05.2022 - Dan H / Harsha */
export type FormDateInput = Entity & Node & {
  __typename?: 'FormDateInput';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormDateInput>;
  /** A camel-case field name, eg. 'firstName', 'lastName' */
  fieldName?: Maybe<Scalars['String']['output']>;
  forms: Array<Form>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** List of FormDateInput versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Content to pre-fill the field. This value should have format YYYY-MM-DD, for example 2000-01-01 */
  initialValue?: Maybe<Scalars['String']['output']>;
  /** Message to display when the field input is invalid for whatever reason */
  invalidErrorMessage?: Maybe<Scalars['String']['output']>;
  /** label for the field */
  label?: Maybe<Scalars['String']['output']>;
  market: Markets;
  marketName?: Maybe<Market>;
  placeholderText?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Displays when form is submitted without this field, if field is required. */
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  /** Validation rules for date input component */
  salesForceValidationRules?: Maybe<ValidationRules>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** DO NOT USE THIS FIELD WHILE THIS MESSAGE IS STILL HERE - this is a new field that separates out Text and Date from the FormTextInput field, so we can have more control over both types. We are waiting for the code to be deployed to production, when this is done this field will be available for use. 02.05.2022 - Dan H / Harsha */
export type FormDateInputCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** DO NOT USE THIS FIELD WHILE THIS MESSAGE IS STILL HERE - this is a new field that separates out Text and Date from the FormTextInput field, so we can have more control over both types. We are waiting for the code to be deployed to production, when this is done this field will be available for use. 02.05.2022 - Dan H / Harsha */
export type FormDateInputDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** DO NOT USE THIS FIELD WHILE THIS MESSAGE IS STILL HERE - this is a new field that separates out Text and Date from the FormTextInput field, so we can have more control over both types. We are waiting for the code to be deployed to production, when this is done this field will be available for use. 02.05.2022 - Dan H / Harsha */
export type FormDateInputFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


/** DO NOT USE THIS FIELD WHILE THIS MESSAGE IS STILL HERE - this is a new field that separates out Text and Date from the FormTextInput field, so we can have more control over both types. We are waiting for the code to be deployed to production, when this is done this field will be available for use. 02.05.2022 - Dan H / Harsha */
export type FormDateInputHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** DO NOT USE THIS FIELD WHILE THIS MESSAGE IS STILL HERE - this is a new field that separates out Text and Date from the FormTextInput field, so we can have more control over both types. We are waiting for the code to be deployed to production, when this is done this field will be available for use. 02.05.2022 - Dan H / Harsha */
export type FormDateInputMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** DO NOT USE THIS FIELD WHILE THIS MESSAGE IS STILL HERE - this is a new field that separates out Text and Date from the FormTextInput field, so we can have more control over both types. We are waiting for the code to be deployed to production, when this is done this field will be available for use. 02.05.2022 - Dan H / Harsha */
export type FormDateInputPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** DO NOT USE THIS FIELD WHILE THIS MESSAGE IS STILL HERE - this is a new field that separates out Text and Date from the FormTextInput field, so we can have more control over both types. We are waiting for the code to be deployed to production, when this is done this field will be available for use. 02.05.2022 - Dan H / Harsha */
export type FormDateInputScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** DO NOT USE THIS FIELD WHILE THIS MESSAGE IS STILL HERE - this is a new field that separates out Text and Date from the FormTextInput field, so we can have more control over both types. We are waiting for the code to be deployed to production, when this is done this field will be available for use. 02.05.2022 - Dan H / Harsha */
export type FormDateInputUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormDateInputConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormDateInputWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormDateInputConnection = {
  __typename?: 'FormDateInputConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormDateInputEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormDateInputCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  invalidErrorMessage?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  salesForceValidationRules?: InputMaybe<ValidationRules>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormDateInputCreateManyInlineInput = {
  /** Connect multiple existing FormDateInput documents */
  connect?: InputMaybe<Array<FormDateInputWhereUniqueInput>>;
  /** Create and connect multiple existing FormDateInput documents */
  create?: InputMaybe<Array<FormDateInputCreateInput>>;
};

export type FormDateInputCreateOneInlineInput = {
  /** Connect one existing FormDateInput document */
  connect?: InputMaybe<FormDateInputWhereUniqueInput>;
  /** Create and connect one FormDateInput document */
  create?: InputMaybe<FormDateInputCreateInput>;
};

/** An edge in a connection. */
export type FormDateInputEdge = {
  __typename?: 'FormDateInputEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormDateInput;
};

/** Identifies documents */
export type FormDateInputManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormDateInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormDateInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormDateInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormDateInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormDateInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormDateInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  invalidErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  invalidErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  invalidErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  invalidErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  invalidErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  invalidErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  invalidErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  invalidErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  invalidErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  invalidErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholderText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholderText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholderText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholderText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholderText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholderText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholderText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholderText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholderText_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  salesForceValidationRules?: InputMaybe<ValidationRules>;
  /** All values that are contained in given list. */
  salesForceValidationRules_in?: InputMaybe<Array<InputMaybe<ValidationRules>>>;
  /** Any other value that exists and is not equal to the given value. */
  salesForceValidationRules_not?: InputMaybe<ValidationRules>;
  /** All values that are not contained in given list. */
  salesForceValidationRules_not_in?: InputMaybe<Array<InputMaybe<ValidationRules>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormDateInputOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  hidden_ASC = 'hidden_ASC',
  hidden_DESC = 'hidden_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  initialValue_ASC = 'initialValue_ASC',
  initialValue_DESC = 'initialValue_DESC',
  invalidErrorMessage_ASC = 'invalidErrorMessage_ASC',
  invalidErrorMessage_DESC = 'invalidErrorMessage_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  placeholderText_ASC = 'placeholderText_ASC',
  placeholderText_DESC = 'placeholderText_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  salesForceValidationRules_ASC = 'salesForceValidationRules_ASC',
  salesForceValidationRules_DESC = 'salesForceValidationRules_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormDateInputUpdateInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  invalidErrorMessage?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  salesForceValidationRules?: InputMaybe<ValidationRules>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormDateInputUpdateManyInlineInput = {
  /** Connect multiple existing FormDateInput documents */
  connect?: InputMaybe<Array<FormDateInputConnectInput>>;
  /** Create and connect multiple FormDateInput documents */
  create?: InputMaybe<Array<FormDateInputCreateInput>>;
  /** Delete multiple FormDateInput documents */
  delete?: InputMaybe<Array<FormDateInputWhereUniqueInput>>;
  /** Disconnect multiple FormDateInput documents */
  disconnect?: InputMaybe<Array<FormDateInputWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormDateInput documents */
  set?: InputMaybe<Array<FormDateInputWhereUniqueInput>>;
  /** Update multiple FormDateInput documents */
  update?: InputMaybe<Array<FormDateInputUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormDateInput documents */
  upsert?: InputMaybe<Array<FormDateInputUpsertWithNestedWhereUniqueInput>>;
};

export type FormDateInputUpdateManyInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  invalidErrorMessage?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  salesForceValidationRules?: InputMaybe<ValidationRules>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormDateInputUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormDateInputUpdateManyInput;
  /** Document search */
  where: FormDateInputWhereInput;
};

export type FormDateInputUpdateOneInlineInput = {
  /** Connect existing FormDateInput document */
  connect?: InputMaybe<FormDateInputWhereUniqueInput>;
  /** Create and connect one FormDateInput document */
  create?: InputMaybe<FormDateInputCreateInput>;
  /** Delete currently connected FormDateInput document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormDateInput document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormDateInput document */
  update?: InputMaybe<FormDateInputUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormDateInput document */
  upsert?: InputMaybe<FormDateInputUpsertWithNestedWhereUniqueInput>;
};

export type FormDateInputUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormDateInputUpdateInput;
  /** Unique document search */
  where: FormDateInputWhereUniqueInput;
};

export type FormDateInputUpsertInput = {
  /** Create document if it didn't exist */
  create: FormDateInputCreateInput;
  /** Update document if it exists */
  update: FormDateInputUpdateInput;
};

export type FormDateInputUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormDateInputUpsertInput;
  /** Unique document search */
  where: FormDateInputWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormDateInputWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormDateInputWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormDateInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormDateInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormDateInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormDateInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormDateInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormDateInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  invalidErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  invalidErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  invalidErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  invalidErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  invalidErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  invalidErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  invalidErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  invalidErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  invalidErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  invalidErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholderText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholderText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholderText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholderText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholderText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholderText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholderText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholderText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholderText_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  salesForceValidationRules?: InputMaybe<ValidationRules>;
  /** All values that are contained in given list. */
  salesForceValidationRules_in?: InputMaybe<Array<InputMaybe<ValidationRules>>>;
  /** Any other value that exists and is not equal to the given value. */
  salesForceValidationRules_not?: InputMaybe<ValidationRules>;
  /** All values that are not contained in given list. */
  salesForceValidationRules_not_in?: InputMaybe<Array<InputMaybe<ValidationRules>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormDateInputWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormDateInputWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormDateInputWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormDateInputWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormDateInputWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormDateInput record uniquely */
export type FormDateInputWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** An edge in a connection. */
export type FormEdge = {
  __typename?: 'FormEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Form;
};

export type FormEmailInput = Entity & Node & {
  __typename?: 'FormEmailInput';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormEmailInput>;
  /** A camel-case field name, eg. 'userEmail' */
  fieldName?: Maybe<Scalars['String']['output']>;
  forms: Array<Form>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** List of FormEmailInput versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Content to pre-fill the field with. */
  initialValue?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  market: Markets;
  marketName?: Maybe<Market>;
  placeholderText?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Displays when form is submitted without this field, if field is required. */
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Used for data-test attributes on the front-end. */
  testAttribute?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormEmailInputCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormEmailInputDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormEmailInputFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormEmailInputHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormEmailInputMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormEmailInputPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormEmailInputScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormEmailInputUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormEmailInputConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormEmailInputWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormEmailInputConnection = {
  __typename?: 'FormEmailInputConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormEmailInputEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormEmailInputCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  testAttribute?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormEmailInputCreateManyInlineInput = {
  /** Connect multiple existing FormEmailInput documents */
  connect?: InputMaybe<Array<FormEmailInputWhereUniqueInput>>;
  /** Create and connect multiple existing FormEmailInput documents */
  create?: InputMaybe<Array<FormEmailInputCreateInput>>;
};

export type FormEmailInputCreateOneInlineInput = {
  /** Connect one existing FormEmailInput document */
  connect?: InputMaybe<FormEmailInputWhereUniqueInput>;
  /** Create and connect one FormEmailInput document */
  create?: InputMaybe<FormEmailInputCreateInput>;
};

/** An edge in a connection. */
export type FormEmailInputEdge = {
  __typename?: 'FormEmailInputEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormEmailInput;
};

/** Identifies documents */
export type FormEmailInputManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormEmailInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormEmailInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormEmailInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormEmailInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormEmailInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormEmailInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholderText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholderText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholderText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholderText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholderText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholderText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholderText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholderText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholderText_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  testAttribute?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  testAttribute_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  testAttribute_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  testAttribute_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  testAttribute_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  testAttribute_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  testAttribute_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  testAttribute_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  testAttribute_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  testAttribute_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormEmailInputOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  hidden_ASC = 'hidden_ASC',
  hidden_DESC = 'hidden_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  initialValue_ASC = 'initialValue_ASC',
  initialValue_DESC = 'initialValue_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  placeholderText_ASC = 'placeholderText_ASC',
  placeholderText_DESC = 'placeholderText_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  testAttribute_ASC = 'testAttribute_ASC',
  testAttribute_DESC = 'testAttribute_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormEmailInputUpdateInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  testAttribute?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormEmailInputUpdateManyInlineInput = {
  /** Connect multiple existing FormEmailInput documents */
  connect?: InputMaybe<Array<FormEmailInputConnectInput>>;
  /** Create and connect multiple FormEmailInput documents */
  create?: InputMaybe<Array<FormEmailInputCreateInput>>;
  /** Delete multiple FormEmailInput documents */
  delete?: InputMaybe<Array<FormEmailInputWhereUniqueInput>>;
  /** Disconnect multiple FormEmailInput documents */
  disconnect?: InputMaybe<Array<FormEmailInputWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormEmailInput documents */
  set?: InputMaybe<Array<FormEmailInputWhereUniqueInput>>;
  /** Update multiple FormEmailInput documents */
  update?: InputMaybe<Array<FormEmailInputUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormEmailInput documents */
  upsert?: InputMaybe<Array<FormEmailInputUpsertWithNestedWhereUniqueInput>>;
};

export type FormEmailInputUpdateManyInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  testAttribute?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormEmailInputUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormEmailInputUpdateManyInput;
  /** Document search */
  where: FormEmailInputWhereInput;
};

export type FormEmailInputUpdateOneInlineInput = {
  /** Connect existing FormEmailInput document */
  connect?: InputMaybe<FormEmailInputWhereUniqueInput>;
  /** Create and connect one FormEmailInput document */
  create?: InputMaybe<FormEmailInputCreateInput>;
  /** Delete currently connected FormEmailInput document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormEmailInput document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormEmailInput document */
  update?: InputMaybe<FormEmailInputUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormEmailInput document */
  upsert?: InputMaybe<FormEmailInputUpsertWithNestedWhereUniqueInput>;
};

export type FormEmailInputUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormEmailInputUpdateInput;
  /** Unique document search */
  where: FormEmailInputWhereUniqueInput;
};

export type FormEmailInputUpsertInput = {
  /** Create document if it didn't exist */
  create: FormEmailInputCreateInput;
  /** Update document if it exists */
  update: FormEmailInputUpdateInput;
};

export type FormEmailInputUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormEmailInputUpsertInput;
  /** Unique document search */
  where: FormEmailInputWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormEmailInputWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormEmailInputWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormEmailInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormEmailInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormEmailInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormEmailInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormEmailInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormEmailInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholderText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholderText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholderText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholderText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholderText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholderText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholderText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholderText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholderText_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  testAttribute?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  testAttribute_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  testAttribute_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  testAttribute_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  testAttribute_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  testAttribute_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  testAttribute_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  testAttribute_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  testAttribute_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  testAttribute_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormEmailInputWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormEmailInputWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormEmailInputWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormEmailInputWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormEmailInputWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormEmailInput record uniquely */
export type FormEmailInputWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormError = Entity & Node & {
  __typename?: 'FormError';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormError>;
  errorCode?: Maybe<Scalars['Int']['output']>;
  forms: Array<Form>;
  /** List of FormError versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  message?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormErrorCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormErrorDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormErrorFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormErrorHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormErrorMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormErrorPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormErrorScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormErrorUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormErrorConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormErrorWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormErrorConnection = {
  __typename?: 'FormErrorConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormErrorEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormErrorCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorCode?: InputMaybe<Scalars['Int']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormErrorCreateManyInlineInput = {
  /** Connect multiple existing FormError documents */
  connect?: InputMaybe<Array<FormErrorWhereUniqueInput>>;
  /** Create and connect multiple existing FormError documents */
  create?: InputMaybe<Array<FormErrorCreateInput>>;
};

export type FormErrorCreateOneInlineInput = {
  /** Connect one existing FormError document */
  connect?: InputMaybe<FormErrorWhereUniqueInput>;
  /** Create and connect one FormError document */
  create?: InputMaybe<FormErrorCreateInput>;
};

/** An edge in a connection. */
export type FormErrorEdge = {
  __typename?: 'FormErrorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormError;
};

/** Identifies documents */
export type FormErrorManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormErrorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormErrorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormErrorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormErrorWhereStageInput>;
  documentInStages_none?: InputMaybe<FormErrorWhereStageInput>;
  documentInStages_some?: InputMaybe<FormErrorWhereStageInput>;
  errorCode?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  errorCode_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  errorCode_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  errorCode_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  errorCode_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  errorCode_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  errorCode_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  errorCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  message_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  message_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  message_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  message_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  message_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  message_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  message_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  message_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  message_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormErrorOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  errorCode_ASC = 'errorCode_ASC',
  errorCode_DESC = 'errorCode_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  message_ASC = 'message_ASC',
  message_DESC = 'message_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormErrorUpdateInput = {
  errorCode?: InputMaybe<Scalars['Int']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormErrorUpdateManyInlineInput = {
  /** Connect multiple existing FormError documents */
  connect?: InputMaybe<Array<FormErrorConnectInput>>;
  /** Create and connect multiple FormError documents */
  create?: InputMaybe<Array<FormErrorCreateInput>>;
  /** Delete multiple FormError documents */
  delete?: InputMaybe<Array<FormErrorWhereUniqueInput>>;
  /** Disconnect multiple FormError documents */
  disconnect?: InputMaybe<Array<FormErrorWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormError documents */
  set?: InputMaybe<Array<FormErrorWhereUniqueInput>>;
  /** Update multiple FormError documents */
  update?: InputMaybe<Array<FormErrorUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormError documents */
  upsert?: InputMaybe<Array<FormErrorUpsertWithNestedWhereUniqueInput>>;
};

export type FormErrorUpdateManyInput = {
  errorCode?: InputMaybe<Scalars['Int']['input']>;
  market?: InputMaybe<Markets>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormErrorUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormErrorUpdateManyInput;
  /** Document search */
  where: FormErrorWhereInput;
};

export type FormErrorUpdateOneInlineInput = {
  /** Connect existing FormError document */
  connect?: InputMaybe<FormErrorWhereUniqueInput>;
  /** Create and connect one FormError document */
  create?: InputMaybe<FormErrorCreateInput>;
  /** Delete currently connected FormError document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormError document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormError document */
  update?: InputMaybe<FormErrorUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormError document */
  upsert?: InputMaybe<FormErrorUpsertWithNestedWhereUniqueInput>;
};

export type FormErrorUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormErrorUpdateInput;
  /** Unique document search */
  where: FormErrorWhereUniqueInput;
};

export type FormErrorUpsertInput = {
  /** Create document if it didn't exist */
  create: FormErrorCreateInput;
  /** Update document if it exists */
  update: FormErrorUpdateInput;
};

export type FormErrorUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormErrorUpsertInput;
  /** Unique document search */
  where: FormErrorWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormErrorWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormErrorWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormErrorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormErrorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormErrorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormErrorWhereStageInput>;
  documentInStages_none?: InputMaybe<FormErrorWhereStageInput>;
  documentInStages_some?: InputMaybe<FormErrorWhereStageInput>;
  errorCode?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  errorCode_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  errorCode_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  errorCode_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  errorCode_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  errorCode_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  errorCode_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  errorCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  message_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  message_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  message_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  message_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  message_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  message_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  message_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  message_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  message_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormErrorWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormErrorWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormErrorWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormErrorWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormErrorWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormError record uniquely */
export type FormErrorWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormFileUploader = Entity & Node & {
  __typename?: 'FormFileUploader';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  deleteButton?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<FormFileUploader>;
  evalancheFormComponents: Array<EvalancheFormComponent>;
  /** A camel-case field name, eg. 'couponFile' */
  fieldName?: Maybe<Scalars['String']['output']>;
  forms: Array<Form>;
  /** List of FormFileUploader versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market?: Maybe<Markets>;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Error message displayed if this field is required and form is submitted without any uploaded file. */
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** Error message displayed when the file size exceeds the limit. */
  sizeErrorMessage?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** Message displayed when the file is uploaded successfully. */
  successMessage?: Maybe<Scalars['String']['output']>;
  /** Only used in the CMS to identify entries. */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  uploadButton?: Maybe<Scalars['String']['output']>;
};


export type FormFileUploaderCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormFileUploaderDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormFileUploaderEvalancheFormComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<EvalancheFormComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EvalancheFormComponentWhereInput>;
};


export type FormFileUploaderFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormFileUploaderHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormFileUploaderMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormFileUploaderPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormFileUploaderScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormFileUploaderUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormFileUploaderConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormFileUploaderWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormFileUploaderConnection = {
  __typename?: 'FormFileUploaderConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormFileUploaderEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormFileUploaderCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleteButton?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  evalancheFormComponents?: InputMaybe<EvalancheFormComponentCreateManyInlineInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  sizeErrorMessage?: InputMaybe<Scalars['String']['input']>;
  successMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uploadButton?: InputMaybe<Scalars['String']['input']>;
};

export type FormFileUploaderCreateManyInlineInput = {
  /** Connect multiple existing FormFileUploader documents */
  connect?: InputMaybe<Array<FormFileUploaderWhereUniqueInput>>;
  /** Create and connect multiple existing FormFileUploader documents */
  create?: InputMaybe<Array<FormFileUploaderCreateInput>>;
};

export type FormFileUploaderCreateOneInlineInput = {
  /** Connect one existing FormFileUploader document */
  connect?: InputMaybe<FormFileUploaderWhereUniqueInput>;
  /** Create and connect one FormFileUploader document */
  create?: InputMaybe<FormFileUploaderCreateInput>;
};

/** An edge in a connection. */
export type FormFileUploaderEdge = {
  __typename?: 'FormFileUploaderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormFileUploader;
};

/** Identifies documents */
export type FormFileUploaderManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormFileUploaderWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormFileUploaderWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormFileUploaderWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  deleteButton?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  deleteButton_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  deleteButton_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  deleteButton_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  deleteButton_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  deleteButton_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  deleteButton_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  deleteButton_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  deleteButton_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  deleteButton_starts_with?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<FormFileUploaderWhereStageInput>;
  documentInStages_none?: InputMaybe<FormFileUploaderWhereStageInput>;
  documentInStages_some?: InputMaybe<FormFileUploaderWhereStageInput>;
  evalancheFormComponents_every?: InputMaybe<EvalancheFormComponentWhereInput>;
  evalancheFormComponents_none?: InputMaybe<EvalancheFormComponentWhereInput>;
  evalancheFormComponents_some?: InputMaybe<EvalancheFormComponentWhereInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sizeErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sizeErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sizeErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sizeErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sizeErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sizeErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sizeErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sizeErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sizeErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sizeErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  successMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  successMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  successMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  successMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  successMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  successMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  successMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  successMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  successMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  successMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  uploadButton?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  uploadButton_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  uploadButton_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  uploadButton_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  uploadButton_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  uploadButton_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  uploadButton_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  uploadButton_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  uploadButton_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  uploadButton_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum FormFileUploaderOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  deleteButton_ASC = 'deleteButton_ASC',
  deleteButton_DESC = 'deleteButton_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  sizeErrorMessage_ASC = 'sizeErrorMessage_ASC',
  sizeErrorMessage_DESC = 'sizeErrorMessage_DESC',
  successMessage_ASC = 'successMessage_ASC',
  successMessage_DESC = 'successMessage_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  uploadButton_ASC = 'uploadButton_ASC',
  uploadButton_DESC = 'uploadButton_DESC'
}

export type FormFileUploaderUpdateInput = {
  deleteButton?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  evalancheFormComponents?: InputMaybe<EvalancheFormComponentUpdateManyInlineInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  sizeErrorMessage?: InputMaybe<Scalars['String']['input']>;
  successMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uploadButton?: InputMaybe<Scalars['String']['input']>;
};

export type FormFileUploaderUpdateManyInlineInput = {
  /** Connect multiple existing FormFileUploader documents */
  connect?: InputMaybe<Array<FormFileUploaderConnectInput>>;
  /** Create and connect multiple FormFileUploader documents */
  create?: InputMaybe<Array<FormFileUploaderCreateInput>>;
  /** Delete multiple FormFileUploader documents */
  delete?: InputMaybe<Array<FormFileUploaderWhereUniqueInput>>;
  /** Disconnect multiple FormFileUploader documents */
  disconnect?: InputMaybe<Array<FormFileUploaderWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormFileUploader documents */
  set?: InputMaybe<Array<FormFileUploaderWhereUniqueInput>>;
  /** Update multiple FormFileUploader documents */
  update?: InputMaybe<Array<FormFileUploaderUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormFileUploader documents */
  upsert?: InputMaybe<Array<FormFileUploaderUpsertWithNestedWhereUniqueInput>>;
};

export type FormFileUploaderUpdateManyInput = {
  deleteButton?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  sizeErrorMessage?: InputMaybe<Scalars['String']['input']>;
  successMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uploadButton?: InputMaybe<Scalars['String']['input']>;
};

export type FormFileUploaderUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormFileUploaderUpdateManyInput;
  /** Document search */
  where: FormFileUploaderWhereInput;
};

export type FormFileUploaderUpdateOneInlineInput = {
  /** Connect existing FormFileUploader document */
  connect?: InputMaybe<FormFileUploaderWhereUniqueInput>;
  /** Create and connect one FormFileUploader document */
  create?: InputMaybe<FormFileUploaderCreateInput>;
  /** Delete currently connected FormFileUploader document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormFileUploader document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormFileUploader document */
  update?: InputMaybe<FormFileUploaderUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormFileUploader document */
  upsert?: InputMaybe<FormFileUploaderUpsertWithNestedWhereUniqueInput>;
};

export type FormFileUploaderUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormFileUploaderUpdateInput;
  /** Unique document search */
  where: FormFileUploaderWhereUniqueInput;
};

export type FormFileUploaderUpsertInput = {
  /** Create document if it didn't exist */
  create: FormFileUploaderCreateInput;
  /** Update document if it exists */
  update: FormFileUploaderUpdateInput;
};

export type FormFileUploaderUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormFileUploaderUpsertInput;
  /** Unique document search */
  where: FormFileUploaderWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormFileUploaderWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormFileUploaderWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormFileUploaderWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormFileUploaderWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormFileUploaderWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  deleteButton?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  deleteButton_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  deleteButton_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  deleteButton_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  deleteButton_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  deleteButton_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  deleteButton_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  deleteButton_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  deleteButton_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  deleteButton_starts_with?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<FormFileUploaderWhereStageInput>;
  documentInStages_none?: InputMaybe<FormFileUploaderWhereStageInput>;
  documentInStages_some?: InputMaybe<FormFileUploaderWhereStageInput>;
  evalancheFormComponents_every?: InputMaybe<EvalancheFormComponentWhereInput>;
  evalancheFormComponents_none?: InputMaybe<EvalancheFormComponentWhereInput>;
  evalancheFormComponents_some?: InputMaybe<EvalancheFormComponentWhereInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sizeErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sizeErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sizeErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sizeErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sizeErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sizeErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sizeErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sizeErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sizeErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sizeErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  successMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  successMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  successMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  successMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  successMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  successMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  successMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  successMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  successMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  successMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  uploadButton?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  uploadButton_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  uploadButton_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  uploadButton_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  uploadButton_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  uploadButton_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  uploadButton_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  uploadButton_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  uploadButton_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  uploadButton_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormFileUploaderWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormFileUploaderWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormFileUploaderWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormFileUploaderWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormFileUploaderWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormFileUploader record uniquely */
export type FormFileUploaderWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormForm = FormCheckbox | FormCheckboxCollection | FormDateInput | FormEmailInput | FormFileUploader | FormList | FormNumberInput | FormPasswordInput | FormPasswordInputWithConfirmation | FormRadioButtonCollection | FormSelectComponent | FormSubmitButton | FormTextInput | FormTextareaInput | GenericAccordion | LongText;

export type FormFormConnectInput = {
  FormCheckbox?: InputMaybe<FormCheckboxConnectInput>;
  FormCheckboxCollection?: InputMaybe<FormCheckboxCollectionConnectInput>;
  FormDateInput?: InputMaybe<FormDateInputConnectInput>;
  FormEmailInput?: InputMaybe<FormEmailInputConnectInput>;
  FormFileUploader?: InputMaybe<FormFileUploaderConnectInput>;
  FormList?: InputMaybe<FormListConnectInput>;
  FormNumberInput?: InputMaybe<FormNumberInputConnectInput>;
  FormPasswordInput?: InputMaybe<FormPasswordInputConnectInput>;
  FormPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationConnectInput>;
  FormRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionConnectInput>;
  FormSelectComponent?: InputMaybe<FormSelectComponentConnectInput>;
  FormSubmitButton?: InputMaybe<FormSubmitButtonConnectInput>;
  FormTextInput?: InputMaybe<FormTextInputConnectInput>;
  FormTextareaInput?: InputMaybe<FormTextareaInputConnectInput>;
  GenericAccordion?: InputMaybe<GenericAccordionConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
};

export type FormFormCreateInput = {
  FormCheckbox?: InputMaybe<FormCheckboxCreateInput>;
  FormCheckboxCollection?: InputMaybe<FormCheckboxCollectionCreateInput>;
  FormDateInput?: InputMaybe<FormDateInputCreateInput>;
  FormEmailInput?: InputMaybe<FormEmailInputCreateInput>;
  FormFileUploader?: InputMaybe<FormFileUploaderCreateInput>;
  FormList?: InputMaybe<FormListCreateInput>;
  FormNumberInput?: InputMaybe<FormNumberInputCreateInput>;
  FormPasswordInput?: InputMaybe<FormPasswordInputCreateInput>;
  FormPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationCreateInput>;
  FormRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionCreateInput>;
  FormSelectComponent?: InputMaybe<FormSelectComponentCreateInput>;
  FormSubmitButton?: InputMaybe<FormSubmitButtonCreateInput>;
  FormTextInput?: InputMaybe<FormTextInputCreateInput>;
  FormTextareaInput?: InputMaybe<FormTextareaInputCreateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
};

export type FormFormCreateManyInlineInput = {
  /** Connect multiple existing FormForm documents */
  connect?: InputMaybe<Array<FormFormWhereUniqueInput>>;
  /** Create and connect multiple existing FormForm documents */
  create?: InputMaybe<Array<FormFormCreateInput>>;
};

export type FormFormCreateOneInlineInput = {
  /** Connect one existing FormForm document */
  connect?: InputMaybe<FormFormWhereUniqueInput>;
  /** Create and connect one FormForm document */
  create?: InputMaybe<FormFormCreateInput>;
};

export type FormFormUpdateInput = {
  FormCheckbox?: InputMaybe<FormCheckboxUpdateInput>;
  FormCheckboxCollection?: InputMaybe<FormCheckboxCollectionUpdateInput>;
  FormDateInput?: InputMaybe<FormDateInputUpdateInput>;
  FormEmailInput?: InputMaybe<FormEmailInputUpdateInput>;
  FormFileUploader?: InputMaybe<FormFileUploaderUpdateInput>;
  FormList?: InputMaybe<FormListUpdateInput>;
  FormNumberInput?: InputMaybe<FormNumberInputUpdateInput>;
  FormPasswordInput?: InputMaybe<FormPasswordInputUpdateInput>;
  FormPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationUpdateInput>;
  FormRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionUpdateInput>;
  FormSelectComponent?: InputMaybe<FormSelectComponentUpdateInput>;
  FormSubmitButton?: InputMaybe<FormSubmitButtonUpdateInput>;
  FormTextInput?: InputMaybe<FormTextInputUpdateInput>;
  FormTextareaInput?: InputMaybe<FormTextareaInputUpdateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
};

export type FormFormUpdateManyInlineInput = {
  /** Connect multiple existing FormForm documents */
  connect?: InputMaybe<Array<FormFormConnectInput>>;
  /** Create and connect multiple FormForm documents */
  create?: InputMaybe<Array<FormFormCreateInput>>;
  /** Delete multiple FormForm documents */
  delete?: InputMaybe<Array<FormFormWhereUniqueInput>>;
  /** Disconnect multiple FormForm documents */
  disconnect?: InputMaybe<Array<FormFormWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormForm documents */
  set?: InputMaybe<Array<FormFormWhereUniqueInput>>;
  /** Update multiple FormForm documents */
  update?: InputMaybe<Array<FormFormUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormForm documents */
  upsert?: InputMaybe<Array<FormFormUpsertWithNestedWhereUniqueInput>>;
};

export type FormFormUpdateManyWithNestedWhereInput = {
  FormCheckbox?: InputMaybe<FormCheckboxUpdateManyWithNestedWhereInput>;
  FormCheckboxCollection?: InputMaybe<FormCheckboxCollectionUpdateManyWithNestedWhereInput>;
  FormDateInput?: InputMaybe<FormDateInputUpdateManyWithNestedWhereInput>;
  FormEmailInput?: InputMaybe<FormEmailInputUpdateManyWithNestedWhereInput>;
  FormFileUploader?: InputMaybe<FormFileUploaderUpdateManyWithNestedWhereInput>;
  FormList?: InputMaybe<FormListUpdateManyWithNestedWhereInput>;
  FormNumberInput?: InputMaybe<FormNumberInputUpdateManyWithNestedWhereInput>;
  FormPasswordInput?: InputMaybe<FormPasswordInputUpdateManyWithNestedWhereInput>;
  FormPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationUpdateManyWithNestedWhereInput>;
  FormRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionUpdateManyWithNestedWhereInput>;
  FormSelectComponent?: InputMaybe<FormSelectComponentUpdateManyWithNestedWhereInput>;
  FormSubmitButton?: InputMaybe<FormSubmitButtonUpdateManyWithNestedWhereInput>;
  FormTextInput?: InputMaybe<FormTextInputUpdateManyWithNestedWhereInput>;
  FormTextareaInput?: InputMaybe<FormTextareaInputUpdateManyWithNestedWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
};

export type FormFormUpdateOneInlineInput = {
  /** Connect existing FormForm document */
  connect?: InputMaybe<FormFormWhereUniqueInput>;
  /** Create and connect one FormForm document */
  create?: InputMaybe<FormFormCreateInput>;
  /** Delete currently connected FormForm document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormForm document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormForm document */
  update?: InputMaybe<FormFormUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormForm document */
  upsert?: InputMaybe<FormFormUpsertWithNestedWhereUniqueInput>;
};

export type FormFormUpdateWithNestedWhereUniqueInput = {
  FormCheckbox?: InputMaybe<FormCheckboxUpdateWithNestedWhereUniqueInput>;
  FormCheckboxCollection?: InputMaybe<FormCheckboxCollectionUpdateWithNestedWhereUniqueInput>;
  FormDateInput?: InputMaybe<FormDateInputUpdateWithNestedWhereUniqueInput>;
  FormEmailInput?: InputMaybe<FormEmailInputUpdateWithNestedWhereUniqueInput>;
  FormFileUploader?: InputMaybe<FormFileUploaderUpdateWithNestedWhereUniqueInput>;
  FormList?: InputMaybe<FormListUpdateWithNestedWhereUniqueInput>;
  FormNumberInput?: InputMaybe<FormNumberInputUpdateWithNestedWhereUniqueInput>;
  FormPasswordInput?: InputMaybe<FormPasswordInputUpdateWithNestedWhereUniqueInput>;
  FormPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationUpdateWithNestedWhereUniqueInput>;
  FormRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionUpdateWithNestedWhereUniqueInput>;
  FormSelectComponent?: InputMaybe<FormSelectComponentUpdateWithNestedWhereUniqueInput>;
  FormSubmitButton?: InputMaybe<FormSubmitButtonUpdateWithNestedWhereUniqueInput>;
  FormTextInput?: InputMaybe<FormTextInputUpdateWithNestedWhereUniqueInput>;
  FormTextareaInput?: InputMaybe<FormTextareaInputUpdateWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
};

export type FormFormUpsertWithNestedWhereUniqueInput = {
  FormCheckbox?: InputMaybe<FormCheckboxUpsertWithNestedWhereUniqueInput>;
  FormCheckboxCollection?: InputMaybe<FormCheckboxCollectionUpsertWithNestedWhereUniqueInput>;
  FormDateInput?: InputMaybe<FormDateInputUpsertWithNestedWhereUniqueInput>;
  FormEmailInput?: InputMaybe<FormEmailInputUpsertWithNestedWhereUniqueInput>;
  FormFileUploader?: InputMaybe<FormFileUploaderUpsertWithNestedWhereUniqueInput>;
  FormList?: InputMaybe<FormListUpsertWithNestedWhereUniqueInput>;
  FormNumberInput?: InputMaybe<FormNumberInputUpsertWithNestedWhereUniqueInput>;
  FormPasswordInput?: InputMaybe<FormPasswordInputUpsertWithNestedWhereUniqueInput>;
  FormPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationUpsertWithNestedWhereUniqueInput>;
  FormRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionUpsertWithNestedWhereUniqueInput>;
  FormSelectComponent?: InputMaybe<FormSelectComponentUpsertWithNestedWhereUniqueInput>;
  FormSubmitButton?: InputMaybe<FormSubmitButtonUpsertWithNestedWhereUniqueInput>;
  FormTextInput?: InputMaybe<FormTextInputUpsertWithNestedWhereUniqueInput>;
  FormTextareaInput?: InputMaybe<FormTextareaInputUpsertWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
};

export type FormFormWhereInput = {
  FormCheckbox?: InputMaybe<FormCheckboxWhereInput>;
  FormCheckboxCollection?: InputMaybe<FormCheckboxCollectionWhereInput>;
  FormDateInput?: InputMaybe<FormDateInputWhereInput>;
  FormEmailInput?: InputMaybe<FormEmailInputWhereInput>;
  FormFileUploader?: InputMaybe<FormFileUploaderWhereInput>;
  FormList?: InputMaybe<FormListWhereInput>;
  FormNumberInput?: InputMaybe<FormNumberInputWhereInput>;
  FormPasswordInput?: InputMaybe<FormPasswordInputWhereInput>;
  FormPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationWhereInput>;
  FormRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  FormSelectComponent?: InputMaybe<FormSelectComponentWhereInput>;
  FormSubmitButton?: InputMaybe<FormSubmitButtonWhereInput>;
  FormTextInput?: InputMaybe<FormTextInputWhereInput>;
  FormTextareaInput?: InputMaybe<FormTextareaInputWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
};

export type FormFormWhereUniqueInput = {
  FormCheckbox?: InputMaybe<FormCheckboxWhereUniqueInput>;
  FormCheckboxCollection?: InputMaybe<FormCheckboxCollectionWhereUniqueInput>;
  FormDateInput?: InputMaybe<FormDateInputWhereUniqueInput>;
  FormEmailInput?: InputMaybe<FormEmailInputWhereUniqueInput>;
  FormFileUploader?: InputMaybe<FormFileUploaderWhereUniqueInput>;
  FormList?: InputMaybe<FormListWhereUniqueInput>;
  FormNumberInput?: InputMaybe<FormNumberInputWhereUniqueInput>;
  FormPasswordInput?: InputMaybe<FormPasswordInputWhereUniqueInput>;
  FormPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationWhereUniqueInput>;
  FormRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionWhereUniqueInput>;
  FormSelectComponent?: InputMaybe<FormSelectComponentWhereUniqueInput>;
  FormSubmitButton?: InputMaybe<FormSubmitButtonWhereUniqueInput>;
  FormTextInput?: InputMaybe<FormTextInputWhereUniqueInput>;
  FormTextareaInput?: InputMaybe<FormTextareaInputWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
};

export type FormList = Entity & Node & {
  __typename?: 'FormList';
  cmsTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormList>;
  fieldName?: Maybe<Scalars['String']['output']>;
  formListItems: Array<FormListItem>;
  forms: Array<Form>;
  /** List of FormList versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Hide list on front end */
  isHidden: Scalars['Boolean']['output'];
  market?: Maybe<Markets>;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** List title */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormListCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormListDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormListFormListItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormListItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormListItemWhereInput>;
};


export type FormListFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormListHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormListMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormListPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormListScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormListUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormListWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormListConnection = {
  __typename?: 'FormListConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormListEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormListCreateInput = {
  cmsTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  formListItems?: InputMaybe<FormListItemCreateManyInlineInput>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  isHidden: Scalars['Boolean']['input'];
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormListCreateManyInlineInput = {
  /** Connect multiple existing FormList documents */
  connect?: InputMaybe<Array<FormListWhereUniqueInput>>;
  /** Create and connect multiple existing FormList documents */
  create?: InputMaybe<Array<FormListCreateInput>>;
};

export type FormListCreateOneInlineInput = {
  /** Connect one existing FormList document */
  connect?: InputMaybe<FormListWhereUniqueInput>;
  /** Create and connect one FormList document */
  create?: InputMaybe<FormListCreateInput>;
};

/** An edge in a connection. */
export type FormListEdge = {
  __typename?: 'FormListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormList;
};

export type FormListItem = Entity & Node & {
  __typename?: 'FormListItem';
  /** List items checked by default */
  checked: Scalars['Boolean']['output'];
  /** Used in the CMS only, to identify entries. */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormListItem>;
  /** Please use a one-word identifier for this field which will be used to identify it in the website code */
  fieldName?: Maybe<Scalars['String']['output']>;
  formLists: Array<FormList>;
  /** List of FormListItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormListItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormListItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormListItemFormListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormListOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormListWhereInput>;
};


export type FormListItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormListItemMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormListItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormListItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormListItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormListItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormListItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormListItemConnection = {
  __typename?: 'FormListItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormListItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormListItemCreateInput = {
  checked: Scalars['Boolean']['input'];
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  formLists?: InputMaybe<FormListCreateManyInlineInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormListItemCreateManyInlineInput = {
  /** Connect multiple existing FormListItem documents */
  connect?: InputMaybe<Array<FormListItemWhereUniqueInput>>;
  /** Create and connect multiple existing FormListItem documents */
  create?: InputMaybe<Array<FormListItemCreateInput>>;
};

export type FormListItemCreateOneInlineInput = {
  /** Connect one existing FormListItem document */
  connect?: InputMaybe<FormListItemWhereUniqueInput>;
  /** Create and connect one FormListItem document */
  create?: InputMaybe<FormListItemCreateInput>;
};

/** An edge in a connection. */
export type FormListItemEdge = {
  __typename?: 'FormListItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormListItem;
};

/** Identifies documents */
export type FormListItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormListItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormListItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormListItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  checked_not?: InputMaybe<Scalars['Boolean']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormListItemWhereStageInput>;
  documentInStages_none?: InputMaybe<FormListItemWhereStageInput>;
  documentInStages_some?: InputMaybe<FormListItemWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  formLists_every?: InputMaybe<FormListWhereInput>;
  formLists_none?: InputMaybe<FormListWhereInput>;
  formLists_some?: InputMaybe<FormListWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormListItemOrderByInput {
  checked_ASC = 'checked_ASC',
  checked_DESC = 'checked_DESC',
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormListItemUpdateInput = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  formLists?: InputMaybe<FormListUpdateManyInlineInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormListItemUpdateManyInlineInput = {
  /** Connect multiple existing FormListItem documents */
  connect?: InputMaybe<Array<FormListItemConnectInput>>;
  /** Create and connect multiple FormListItem documents */
  create?: InputMaybe<Array<FormListItemCreateInput>>;
  /** Delete multiple FormListItem documents */
  delete?: InputMaybe<Array<FormListItemWhereUniqueInput>>;
  /** Disconnect multiple FormListItem documents */
  disconnect?: InputMaybe<Array<FormListItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormListItem documents */
  set?: InputMaybe<Array<FormListItemWhereUniqueInput>>;
  /** Update multiple FormListItem documents */
  update?: InputMaybe<Array<FormListItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormListItem documents */
  upsert?: InputMaybe<Array<FormListItemUpsertWithNestedWhereUniqueInput>>;
};

export type FormListItemUpdateManyInput = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormListItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormListItemUpdateManyInput;
  /** Document search */
  where: FormListItemWhereInput;
};

export type FormListItemUpdateOneInlineInput = {
  /** Connect existing FormListItem document */
  connect?: InputMaybe<FormListItemWhereUniqueInput>;
  /** Create and connect one FormListItem document */
  create?: InputMaybe<FormListItemCreateInput>;
  /** Delete currently connected FormListItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormListItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormListItem document */
  update?: InputMaybe<FormListItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormListItem document */
  upsert?: InputMaybe<FormListItemUpsertWithNestedWhereUniqueInput>;
};

export type FormListItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormListItemUpdateInput;
  /** Unique document search */
  where: FormListItemWhereUniqueInput;
};

export type FormListItemUpsertInput = {
  /** Create document if it didn't exist */
  create: FormListItemCreateInput;
  /** Update document if it exists */
  update: FormListItemUpdateInput;
};

export type FormListItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormListItemUpsertInput;
  /** Unique document search */
  where: FormListItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormListItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormListItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormListItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormListItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormListItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  checked_not?: InputMaybe<Scalars['Boolean']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormListItemWhereStageInput>;
  documentInStages_none?: InputMaybe<FormListItemWhereStageInput>;
  documentInStages_some?: InputMaybe<FormListItemWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  formLists_every?: InputMaybe<FormListWhereInput>;
  formLists_none?: InputMaybe<FormListWhereInput>;
  formLists_some?: InputMaybe<FormListWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormListItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormListItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormListItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormListItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormListItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormListItem record uniquely */
export type FormListItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type FormListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormListWhereStageInput>;
  documentInStages_none?: InputMaybe<FormListWhereStageInput>;
  documentInStages_some?: InputMaybe<FormListWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  formListItems_every?: InputMaybe<FormListItemWhereInput>;
  formListItems_none?: InputMaybe<FormListItemWhereInput>;
  formListItems_some?: InputMaybe<FormListItemWhereInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isHidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormListOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isHidden_ASC = 'isHidden_ASC',
  isHidden_DESC = 'isHidden_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormListUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  formListItems?: InputMaybe<FormListItemUpdateManyInlineInput>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormListUpdateManyInlineInput = {
  /** Connect multiple existing FormList documents */
  connect?: InputMaybe<Array<FormListConnectInput>>;
  /** Create and connect multiple FormList documents */
  create?: InputMaybe<Array<FormListCreateInput>>;
  /** Delete multiple FormList documents */
  delete?: InputMaybe<Array<FormListWhereUniqueInput>>;
  /** Disconnect multiple FormList documents */
  disconnect?: InputMaybe<Array<FormListWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormList documents */
  set?: InputMaybe<Array<FormListWhereUniqueInput>>;
  /** Update multiple FormList documents */
  update?: InputMaybe<Array<FormListUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormList documents */
  upsert?: InputMaybe<Array<FormListUpsertWithNestedWhereUniqueInput>>;
};

export type FormListUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormListUpdateManyInput;
  /** Document search */
  where: FormListWhereInput;
};

export type FormListUpdateOneInlineInput = {
  /** Connect existing FormList document */
  connect?: InputMaybe<FormListWhereUniqueInput>;
  /** Create and connect one FormList document */
  create?: InputMaybe<FormListCreateInput>;
  /** Delete currently connected FormList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormList document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormList document */
  update?: InputMaybe<FormListUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormList document */
  upsert?: InputMaybe<FormListUpsertWithNestedWhereUniqueInput>;
};

export type FormListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormListUpdateInput;
  /** Unique document search */
  where: FormListWhereUniqueInput;
};

export type FormListUpsertInput = {
  /** Create document if it didn't exist */
  create: FormListCreateInput;
  /** Update document if it exists */
  update: FormListUpdateInput;
};

export type FormListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormListUpsertInput;
  /** Unique document search */
  where: FormListWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormListWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormListWhereStageInput>;
  documentInStages_none?: InputMaybe<FormListWhereStageInput>;
  documentInStages_some?: InputMaybe<FormListWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  formListItems_every?: InputMaybe<FormListItemWhereInput>;
  formListItems_none?: InputMaybe<FormListItemWhereInput>;
  formListItems_some?: InputMaybe<FormListItemWhereInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isHidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormListWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormListWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormListWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormListWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormListWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormList record uniquely */
export type FormListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type FormManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormWhereStageInput>;
  documentInStages_none?: InputMaybe<FormWhereStageInput>;
  documentInStages_some?: InputMaybe<FormWhereStageInput>;
  formErrors_every?: InputMaybe<FormErrorWhereInput>;
  formErrors_none?: InputMaybe<FormErrorWhereInput>;
  formErrors_some?: InputMaybe<FormErrorWhereInput>;
  /** All values in which the union is empty */
  formFields_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  formFields_some?: InputMaybe<FormFormWhereInput>;
  formSuccess?: InputMaybe<FormSuccessComponentWhereInput>;
  formType?: InputMaybe<FormTypes>;
  /** All values that are contained in given list. */
  formType_in?: InputMaybe<Array<InputMaybe<FormTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  formType_not?: InputMaybe<FormTypes>;
  /** All values that are not contained in given list. */
  formType_not_in?: InputMaybe<Array<InputMaybe<FormTypes>>>;
  genericAccordionItem?: InputMaybe<GenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  lowerLeftCorner?: InputMaybe<AssetWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  newsletterComponent?: InputMaybe<NewsletterComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upperRightCorner?: InputMaybe<AssetWhereInput>;
};

export type FormNumberInput = Entity & Node & {
  __typename?: 'FormNumberInput';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormNumberInput>;
  /** A camel-case field name, eg. 'firstName', 'lastName' */
  fieldName?: Maybe<Scalars['String']['output']>;
  forms: Array<Form>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** List of FormNumberInput versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Content to pre-fill the field. */
  initialValue?: Maybe<Scalars['String']['output']>;
  /** label for the field */
  label?: Maybe<Scalars['String']['output']>;
  market: Markets;
  marketName?: Maybe<Market>;
  placeholderText?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Displays when form is submitted without this field, if field is required. */
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormNumberInputCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormNumberInputDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormNumberInputFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormNumberInputHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormNumberInputMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormNumberInputPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormNumberInputScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormNumberInputUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormNumberInputConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormNumberInputWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormNumberInputConnection = {
  __typename?: 'FormNumberInputConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormNumberInputEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormNumberInputCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormNumberInputCreateManyInlineInput = {
  /** Connect multiple existing FormNumberInput documents */
  connect?: InputMaybe<Array<FormNumberInputWhereUniqueInput>>;
  /** Create and connect multiple existing FormNumberInput documents */
  create?: InputMaybe<Array<FormNumberInputCreateInput>>;
};

export type FormNumberInputCreateOneInlineInput = {
  /** Connect one existing FormNumberInput document */
  connect?: InputMaybe<FormNumberInputWhereUniqueInput>;
  /** Create and connect one FormNumberInput document */
  create?: InputMaybe<FormNumberInputCreateInput>;
};

/** An edge in a connection. */
export type FormNumberInputEdge = {
  __typename?: 'FormNumberInputEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormNumberInput;
};

/** Identifies documents */
export type FormNumberInputManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormNumberInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormNumberInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormNumberInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormNumberInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormNumberInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormNumberInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholderText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholderText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholderText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholderText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholderText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholderText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholderText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholderText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholderText_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormNumberInputOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  hidden_ASC = 'hidden_ASC',
  hidden_DESC = 'hidden_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  initialValue_ASC = 'initialValue_ASC',
  initialValue_DESC = 'initialValue_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  placeholderText_ASC = 'placeholderText_ASC',
  placeholderText_DESC = 'placeholderText_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormNumberInputUpdateInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormNumberInputUpdateManyInlineInput = {
  /** Connect multiple existing FormNumberInput documents */
  connect?: InputMaybe<Array<FormNumberInputConnectInput>>;
  /** Create and connect multiple FormNumberInput documents */
  create?: InputMaybe<Array<FormNumberInputCreateInput>>;
  /** Delete multiple FormNumberInput documents */
  delete?: InputMaybe<Array<FormNumberInputWhereUniqueInput>>;
  /** Disconnect multiple FormNumberInput documents */
  disconnect?: InputMaybe<Array<FormNumberInputWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormNumberInput documents */
  set?: InputMaybe<Array<FormNumberInputWhereUniqueInput>>;
  /** Update multiple FormNumberInput documents */
  update?: InputMaybe<Array<FormNumberInputUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormNumberInput documents */
  upsert?: InputMaybe<Array<FormNumberInputUpsertWithNestedWhereUniqueInput>>;
};

export type FormNumberInputUpdateManyInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormNumberInputUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormNumberInputUpdateManyInput;
  /** Document search */
  where: FormNumberInputWhereInput;
};

export type FormNumberInputUpdateOneInlineInput = {
  /** Connect existing FormNumberInput document */
  connect?: InputMaybe<FormNumberInputWhereUniqueInput>;
  /** Create and connect one FormNumberInput document */
  create?: InputMaybe<FormNumberInputCreateInput>;
  /** Delete currently connected FormNumberInput document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormNumberInput document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormNumberInput document */
  update?: InputMaybe<FormNumberInputUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormNumberInput document */
  upsert?: InputMaybe<FormNumberInputUpsertWithNestedWhereUniqueInput>;
};

export type FormNumberInputUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormNumberInputUpdateInput;
  /** Unique document search */
  where: FormNumberInputWhereUniqueInput;
};

export type FormNumberInputUpsertInput = {
  /** Create document if it didn't exist */
  create: FormNumberInputCreateInput;
  /** Update document if it exists */
  update: FormNumberInputUpdateInput;
};

export type FormNumberInputUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormNumberInputUpsertInput;
  /** Unique document search */
  where: FormNumberInputWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormNumberInputWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormNumberInputWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormNumberInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormNumberInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormNumberInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormNumberInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormNumberInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormNumberInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholderText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholderText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholderText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholderText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholderText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholderText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholderText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholderText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholderText_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormNumberInputWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormNumberInputWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormNumberInputWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormNumberInputWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormNumberInputWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormNumberInput record uniquely */
export type FormNumberInputWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormOption = Entity & {
  __typename?: 'FormOption';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** is shown to the user */
  label: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** the value is sent to the backend */
  value: Scalars['String']['output'];
};

export type FormOptionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormOptionWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormOptionConnection = {
  __typename?: 'FormOptionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormOptionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormOptionCreateInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type FormOptionCreateManyInlineInput = {
  /** Create and connect multiple existing FormOption documents */
  create?: InputMaybe<Array<FormOptionCreateInput>>;
};

export type FormOptionCreateOneInlineInput = {
  /** Create and connect one FormOption document */
  create?: InputMaybe<FormOptionCreateInput>;
};

export type FormOptionCreateWithPositionInput = {
  /** Document to create */
  data: FormOptionCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type FormOptionEdge = {
  __typename?: 'FormOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormOption;
};

/** Identifies documents */
export type FormOptionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormOptionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormOptionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormOptionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  value_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum FormOptionOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type FormOptionParent = MultiStepPromotionFormCheckboxes | MultiStepPromotionFormRadio | NewsletterSubscriptions;

export type FormOptionParentConnectInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesConnectInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioConnectInput>;
  NewsletterSubscriptions?: InputMaybe<NewsletterSubscriptionsConnectInput>;
};

export type FormOptionParentCreateInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesCreateInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioCreateInput>;
  NewsletterSubscriptions?: InputMaybe<NewsletterSubscriptionsCreateInput>;
};

export type FormOptionParentCreateManyInlineInput = {
  /** Connect multiple existing FormOptionParent documents */
  connect?: InputMaybe<Array<FormOptionParentWhereUniqueInput>>;
  /** Create and connect multiple existing FormOptionParent documents */
  create?: InputMaybe<Array<FormOptionParentCreateInput>>;
};

export type FormOptionParentCreateOneInlineInput = {
  /** Connect one existing FormOptionParent document */
  connect?: InputMaybe<FormOptionParentWhereUniqueInput>;
  /** Create and connect one FormOptionParent document */
  create?: InputMaybe<FormOptionParentCreateInput>;
};

export type FormOptionParentUpdateInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesUpdateInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioUpdateInput>;
  NewsletterSubscriptions?: InputMaybe<NewsletterSubscriptionsUpdateInput>;
};

export type FormOptionParentUpdateManyInlineInput = {
  /** Connect multiple existing FormOptionParent documents */
  connect?: InputMaybe<Array<FormOptionParentConnectInput>>;
  /** Create and connect multiple FormOptionParent documents */
  create?: InputMaybe<Array<FormOptionParentCreateInput>>;
  /** Delete multiple FormOptionParent documents */
  delete?: InputMaybe<Array<FormOptionParentWhereUniqueInput>>;
  /** Disconnect multiple FormOptionParent documents */
  disconnect?: InputMaybe<Array<FormOptionParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormOptionParent documents */
  set?: InputMaybe<Array<FormOptionParentWhereUniqueInput>>;
  /** Update multiple FormOptionParent documents */
  update?: InputMaybe<Array<FormOptionParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormOptionParent documents */
  upsert?: InputMaybe<Array<FormOptionParentUpsertWithNestedWhereUniqueInput>>;
};

export type FormOptionParentUpdateManyWithNestedWhereInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesUpdateManyWithNestedWhereInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioUpdateManyWithNestedWhereInput>;
  NewsletterSubscriptions?: InputMaybe<NewsletterSubscriptionsUpdateManyWithNestedWhereInput>;
};

export type FormOptionParentUpdateOneInlineInput = {
  /** Connect existing FormOptionParent document */
  connect?: InputMaybe<FormOptionParentWhereUniqueInput>;
  /** Create and connect one FormOptionParent document */
  create?: InputMaybe<FormOptionParentCreateInput>;
  /** Delete currently connected FormOptionParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormOptionParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormOptionParent document */
  update?: InputMaybe<FormOptionParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormOptionParent document */
  upsert?: InputMaybe<FormOptionParentUpsertWithNestedWhereUniqueInput>;
};

export type FormOptionParentUpdateWithNestedWhereUniqueInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesUpdateWithNestedWhereUniqueInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioUpdateWithNestedWhereUniqueInput>;
  NewsletterSubscriptions?: InputMaybe<NewsletterSubscriptionsUpdateWithNestedWhereUniqueInput>;
};

export type FormOptionParentUpsertWithNestedWhereUniqueInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesUpsertWithNestedWhereUniqueInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioUpsertWithNestedWhereUniqueInput>;
  NewsletterSubscriptions?: InputMaybe<NewsletterSubscriptionsUpsertWithNestedWhereUniqueInput>;
};

export type FormOptionParentWhereInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesWhereInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioWhereInput>;
  NewsletterSubscriptions?: InputMaybe<NewsletterSubscriptionsWhereInput>;
};

export type FormOptionParentWhereUniqueInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesWhereUniqueInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioWhereUniqueInput>;
  NewsletterSubscriptions?: InputMaybe<NewsletterSubscriptionsWhereUniqueInput>;
};

export type FormOptionUpdateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FormOptionUpdateManyInlineInput = {
  /** Create and connect multiple FormOption component instances */
  create?: InputMaybe<Array<FormOptionCreateWithPositionInput>>;
  /** Delete multiple FormOption documents */
  delete?: InputMaybe<Array<FormOptionWhereUniqueInput>>;
  /** Update multiple FormOption component instances */
  update?: InputMaybe<Array<FormOptionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple FormOption component instances */
  upsert?: InputMaybe<Array<FormOptionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type FormOptionUpdateManyInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FormOptionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormOptionUpdateManyInput;
  /** Document search */
  where: FormOptionWhereInput;
};

export type FormOptionUpdateOneInlineInput = {
  /** Create and connect one FormOption document */
  create?: InputMaybe<FormOptionCreateInput>;
  /** Delete currently connected FormOption document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormOption document */
  update?: InputMaybe<FormOptionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormOption document */
  upsert?: InputMaybe<FormOptionUpsertWithNestedWhereUniqueInput>;
};

export type FormOptionUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<FormOptionUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: FormOptionWhereUniqueInput;
};

export type FormOptionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormOptionUpdateInput;
  /** Unique document search */
  where: FormOptionWhereUniqueInput;
};

export type FormOptionUpsertInput = {
  /** Create document if it didn't exist */
  create: FormOptionCreateInput;
  /** Update document if it exists */
  update: FormOptionUpdateInput;
};

export type FormOptionUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<FormOptionUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: FormOptionWhereUniqueInput;
};

export type FormOptionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormOptionUpsertInput;
  /** Unique document search */
  where: FormOptionWhereUniqueInput;
};

/** Identifies documents */
export type FormOptionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormOptionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormOptionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormOptionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  value_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References FormOption record uniquely */
export type FormOptionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum FormOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  formType_ASC = 'formType_ASC',
  formType_DESC = 'formType_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormPasswordInput = Entity & Node & {
  __typename?: 'FormPasswordInput';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormPasswordInput>;
  /** A camel-case field name, eg. 'passwordConfirmation' */
  fieldName?: Maybe<Scalars['String']['output']>;
  forms: Array<Form>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** List of FormPasswordInput versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Displays when form is submitted without this field, if field is required. */
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormPasswordInputCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormPasswordInputDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormPasswordInputFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormPasswordInputHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormPasswordInputMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormPasswordInputPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormPasswordInputScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormPasswordInputUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormPasswordInputConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormPasswordInputWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormPasswordInputConnection = {
  __typename?: 'FormPasswordInputConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormPasswordInputEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormPasswordInputCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormPasswordInputCreateManyInlineInput = {
  /** Connect multiple existing FormPasswordInput documents */
  connect?: InputMaybe<Array<FormPasswordInputWhereUniqueInput>>;
  /** Create and connect multiple existing FormPasswordInput documents */
  create?: InputMaybe<Array<FormPasswordInputCreateInput>>;
};

export type FormPasswordInputCreateOneInlineInput = {
  /** Connect one existing FormPasswordInput document */
  connect?: InputMaybe<FormPasswordInputWhereUniqueInput>;
  /** Create and connect one FormPasswordInput document */
  create?: InputMaybe<FormPasswordInputCreateInput>;
};

/** An edge in a connection. */
export type FormPasswordInputEdge = {
  __typename?: 'FormPasswordInputEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormPasswordInput;
};

/** Identifies documents */
export type FormPasswordInputManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormPasswordInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormPasswordInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormPasswordInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormPasswordInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormPasswordInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormPasswordInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormPasswordInputOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  hidden_ASC = 'hidden_ASC',
  hidden_DESC = 'hidden_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormPasswordInputUpdateInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormPasswordInputUpdateManyInlineInput = {
  /** Connect multiple existing FormPasswordInput documents */
  connect?: InputMaybe<Array<FormPasswordInputConnectInput>>;
  /** Create and connect multiple FormPasswordInput documents */
  create?: InputMaybe<Array<FormPasswordInputCreateInput>>;
  /** Delete multiple FormPasswordInput documents */
  delete?: InputMaybe<Array<FormPasswordInputWhereUniqueInput>>;
  /** Disconnect multiple FormPasswordInput documents */
  disconnect?: InputMaybe<Array<FormPasswordInputWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormPasswordInput documents */
  set?: InputMaybe<Array<FormPasswordInputWhereUniqueInput>>;
  /** Update multiple FormPasswordInput documents */
  update?: InputMaybe<Array<FormPasswordInputUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormPasswordInput documents */
  upsert?: InputMaybe<Array<FormPasswordInputUpsertWithNestedWhereUniqueInput>>;
};

export type FormPasswordInputUpdateManyInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormPasswordInputUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormPasswordInputUpdateManyInput;
  /** Document search */
  where: FormPasswordInputWhereInput;
};

export type FormPasswordInputUpdateOneInlineInput = {
  /** Connect existing FormPasswordInput document */
  connect?: InputMaybe<FormPasswordInputWhereUniqueInput>;
  /** Create and connect one FormPasswordInput document */
  create?: InputMaybe<FormPasswordInputCreateInput>;
  /** Delete currently connected FormPasswordInput document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormPasswordInput document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormPasswordInput document */
  update?: InputMaybe<FormPasswordInputUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormPasswordInput document */
  upsert?: InputMaybe<FormPasswordInputUpsertWithNestedWhereUniqueInput>;
};

export type FormPasswordInputUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormPasswordInputUpdateInput;
  /** Unique document search */
  where: FormPasswordInputWhereUniqueInput;
};

export type FormPasswordInputUpsertInput = {
  /** Create document if it didn't exist */
  create: FormPasswordInputCreateInput;
  /** Update document if it exists */
  update: FormPasswordInputUpdateInput;
};

export type FormPasswordInputUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormPasswordInputUpsertInput;
  /** Unique document search */
  where: FormPasswordInputWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormPasswordInputWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormPasswordInputWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormPasswordInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormPasswordInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormPasswordInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormPasswordInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormPasswordInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormPasswordInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormPasswordInputWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormPasswordInputWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormPasswordInputWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormPasswordInputWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormPasswordInputWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormPasswordInput record uniquely */
export type FormPasswordInputWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormPasswordInputWithConfirmation = Entity & Node & {
  __typename?: 'FormPasswordInputWithConfirmation';
  confirmationTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormPasswordInputWithConfirmation>;
  forms: Array<Form>;
  /** List of FormPasswordInputWithConfirmation versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormPasswordInputWithConfirmationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormPasswordInputWithConfirmationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormPasswordInputWithConfirmationFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormPasswordInputWithConfirmationHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormPasswordInputWithConfirmationMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormPasswordInputWithConfirmationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormPasswordInputWithConfirmationScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormPasswordInputWithConfirmationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormPasswordInputWithConfirmationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormPasswordInputWithConfirmationConnection = {
  __typename?: 'FormPasswordInputWithConfirmationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormPasswordInputWithConfirmationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormPasswordInputWithConfirmationCreateInput = {
  confirmationTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormPasswordInputWithConfirmationCreateManyInlineInput = {
  /** Connect multiple existing FormPasswordInputWithConfirmation documents */
  connect?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereUniqueInput>>;
  /** Create and connect multiple existing FormPasswordInputWithConfirmation documents */
  create?: InputMaybe<Array<FormPasswordInputWithConfirmationCreateInput>>;
};

export type FormPasswordInputWithConfirmationCreateOneInlineInput = {
  /** Connect one existing FormPasswordInputWithConfirmation document */
  connect?: InputMaybe<FormPasswordInputWithConfirmationWhereUniqueInput>;
  /** Create and connect one FormPasswordInputWithConfirmation document */
  create?: InputMaybe<FormPasswordInputWithConfirmationCreateInput>;
};

/** An edge in a connection. */
export type FormPasswordInputWithConfirmationEdge = {
  __typename?: 'FormPasswordInputWithConfirmationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormPasswordInputWithConfirmation;
};

/** Identifies documents */
export type FormPasswordInputWithConfirmationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  confirmationTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  confirmationTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  confirmationTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  confirmationTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  confirmationTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  confirmationTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  confirmationTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  confirmationTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  confirmationTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  confirmationTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormPasswordInputWithConfirmationWhereStageInput>;
  documentInStages_none?: InputMaybe<FormPasswordInputWithConfirmationWhereStageInput>;
  documentInStages_some?: InputMaybe<FormPasswordInputWithConfirmationWhereStageInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormPasswordInputWithConfirmationOrderByInput {
  confirmationTitle_ASC = 'confirmationTitle_ASC',
  confirmationTitle_DESC = 'confirmationTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormPasswordInputWithConfirmationUpdateInput = {
  confirmationTitle?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormPasswordInputWithConfirmationUpdateManyInlineInput = {
  /** Connect multiple existing FormPasswordInputWithConfirmation documents */
  connect?: InputMaybe<Array<FormPasswordInputWithConfirmationConnectInput>>;
  /** Create and connect multiple FormPasswordInputWithConfirmation documents */
  create?: InputMaybe<Array<FormPasswordInputWithConfirmationCreateInput>>;
  /** Delete multiple FormPasswordInputWithConfirmation documents */
  delete?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereUniqueInput>>;
  /** Disconnect multiple FormPasswordInputWithConfirmation documents */
  disconnect?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormPasswordInputWithConfirmation documents */
  set?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereUniqueInput>>;
  /** Update multiple FormPasswordInputWithConfirmation documents */
  update?: InputMaybe<Array<FormPasswordInputWithConfirmationUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormPasswordInputWithConfirmation documents */
  upsert?: InputMaybe<Array<FormPasswordInputWithConfirmationUpsertWithNestedWhereUniqueInput>>;
};

export type FormPasswordInputWithConfirmationUpdateManyInput = {
  confirmationTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormPasswordInputWithConfirmationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormPasswordInputWithConfirmationUpdateManyInput;
  /** Document search */
  where: FormPasswordInputWithConfirmationWhereInput;
};

export type FormPasswordInputWithConfirmationUpdateOneInlineInput = {
  /** Connect existing FormPasswordInputWithConfirmation document */
  connect?: InputMaybe<FormPasswordInputWithConfirmationWhereUniqueInput>;
  /** Create and connect one FormPasswordInputWithConfirmation document */
  create?: InputMaybe<FormPasswordInputWithConfirmationCreateInput>;
  /** Delete currently connected FormPasswordInputWithConfirmation document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormPasswordInputWithConfirmation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormPasswordInputWithConfirmation document */
  update?: InputMaybe<FormPasswordInputWithConfirmationUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormPasswordInputWithConfirmation document */
  upsert?: InputMaybe<FormPasswordInputWithConfirmationUpsertWithNestedWhereUniqueInput>;
};

export type FormPasswordInputWithConfirmationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormPasswordInputWithConfirmationUpdateInput;
  /** Unique document search */
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};

export type FormPasswordInputWithConfirmationUpsertInput = {
  /** Create document if it didn't exist */
  create: FormPasswordInputWithConfirmationCreateInput;
  /** Update document if it exists */
  update: FormPasswordInputWithConfirmationUpdateInput;
};

export type FormPasswordInputWithConfirmationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormPasswordInputWithConfirmationUpsertInput;
  /** Unique document search */
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormPasswordInputWithConfirmationWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormPasswordInputWithConfirmationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  confirmationTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  confirmationTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  confirmationTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  confirmationTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  confirmationTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  confirmationTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  confirmationTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  confirmationTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  confirmationTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  confirmationTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormPasswordInputWithConfirmationWhereStageInput>;
  documentInStages_none?: InputMaybe<FormPasswordInputWithConfirmationWhereStageInput>;
  documentInStages_some?: InputMaybe<FormPasswordInputWithConfirmationWhereStageInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormPasswordInputWithConfirmationWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormPasswordInputWithConfirmationWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormPasswordInputWithConfirmation record uniquely */
export type FormPasswordInputWithConfirmationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormRadioButton = Entity & Node & {
  __typename?: 'FormRadioButton';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormRadioButton>;
  formRadioButtonCollections: Array<FormRadioButtonCollection>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** List of FormRadioButton versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Label for the radio button, eg. 'Age 30-35' */
  label?: Maybe<Scalars['String']['output']>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** Option for the radio button value, eg. 'married', 'single' */
  option?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Used only in the CMS to identify fields. */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormRadioButtonCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormRadioButtonDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormRadioButtonFormRadioButtonCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormRadioButtonCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormRadioButtonCollectionWhereInput>;
};


export type FormRadioButtonHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormRadioButtonMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormRadioButtonPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormRadioButtonScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormRadioButtonUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormRadioButtonCollection = Entity & Node & {
  __typename?: 'FormRadioButtonCollection';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormRadioButtonCollection>;
  /** Eg. 'userAge', 'customerType' - an attribute the user select a value for */
  fieldName?: Maybe<Scalars['String']['output']>;
  formRadioButtons: Array<FormRadioButton>;
  forms: Array<Form>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** List of FormRadioButtonCollection versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormRadioButtonCollectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormRadioButtonCollectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormRadioButtonCollectionFormRadioButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormRadioButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormRadioButtonWhereInput>;
};


export type FormRadioButtonCollectionFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormRadioButtonCollectionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormRadioButtonCollectionMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormRadioButtonCollectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormRadioButtonCollectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormRadioButtonCollectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormRadioButtonCollectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormRadioButtonCollectionWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormRadioButtonCollectionConnection = {
  __typename?: 'FormRadioButtonCollectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormRadioButtonCollectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormRadioButtonCollectionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  formRadioButtons?: InputMaybe<FormRadioButtonCreateManyInlineInput>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormRadioButtonCollectionCreateManyInlineInput = {
  /** Connect multiple existing FormRadioButtonCollection documents */
  connect?: InputMaybe<Array<FormRadioButtonCollectionWhereUniqueInput>>;
  /** Create and connect multiple existing FormRadioButtonCollection documents */
  create?: InputMaybe<Array<FormRadioButtonCollectionCreateInput>>;
};

export type FormRadioButtonCollectionCreateOneInlineInput = {
  /** Connect one existing FormRadioButtonCollection document */
  connect?: InputMaybe<FormRadioButtonCollectionWhereUniqueInput>;
  /** Create and connect one FormRadioButtonCollection document */
  create?: InputMaybe<FormRadioButtonCollectionCreateInput>;
};

/** An edge in a connection. */
export type FormRadioButtonCollectionEdge = {
  __typename?: 'FormRadioButtonCollectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormRadioButtonCollection;
};

/** Identifies documents */
export type FormRadioButtonCollectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormRadioButtonCollectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormRadioButtonCollectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormRadioButtonCollectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormRadioButtonCollectionWhereStageInput>;
  documentInStages_none?: InputMaybe<FormRadioButtonCollectionWhereStageInput>;
  documentInStages_some?: InputMaybe<FormRadioButtonCollectionWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  formRadioButtons_every?: InputMaybe<FormRadioButtonWhereInput>;
  formRadioButtons_none?: InputMaybe<FormRadioButtonWhereInput>;
  formRadioButtons_some?: InputMaybe<FormRadioButtonWhereInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormRadioButtonCollectionOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  hidden_ASC = 'hidden_ASC',
  hidden_DESC = 'hidden_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormRadioButtonCollectionUpdateInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  formRadioButtons?: InputMaybe<FormRadioButtonUpdateManyInlineInput>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormRadioButtonCollectionUpdateManyInlineInput = {
  /** Connect multiple existing FormRadioButtonCollection documents */
  connect?: InputMaybe<Array<FormRadioButtonCollectionConnectInput>>;
  /** Create and connect multiple FormRadioButtonCollection documents */
  create?: InputMaybe<Array<FormRadioButtonCollectionCreateInput>>;
  /** Delete multiple FormRadioButtonCollection documents */
  delete?: InputMaybe<Array<FormRadioButtonCollectionWhereUniqueInput>>;
  /** Disconnect multiple FormRadioButtonCollection documents */
  disconnect?: InputMaybe<Array<FormRadioButtonCollectionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormRadioButtonCollection documents */
  set?: InputMaybe<Array<FormRadioButtonCollectionWhereUniqueInput>>;
  /** Update multiple FormRadioButtonCollection documents */
  update?: InputMaybe<Array<FormRadioButtonCollectionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormRadioButtonCollection documents */
  upsert?: InputMaybe<Array<FormRadioButtonCollectionUpsertWithNestedWhereUniqueInput>>;
};

export type FormRadioButtonCollectionUpdateManyInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormRadioButtonCollectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormRadioButtonCollectionUpdateManyInput;
  /** Document search */
  where: FormRadioButtonCollectionWhereInput;
};

export type FormRadioButtonCollectionUpdateOneInlineInput = {
  /** Connect existing FormRadioButtonCollection document */
  connect?: InputMaybe<FormRadioButtonCollectionWhereUniqueInput>;
  /** Create and connect one FormRadioButtonCollection document */
  create?: InputMaybe<FormRadioButtonCollectionCreateInput>;
  /** Delete currently connected FormRadioButtonCollection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormRadioButtonCollection document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormRadioButtonCollection document */
  update?: InputMaybe<FormRadioButtonCollectionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormRadioButtonCollection document */
  upsert?: InputMaybe<FormRadioButtonCollectionUpsertWithNestedWhereUniqueInput>;
};

export type FormRadioButtonCollectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormRadioButtonCollectionUpdateInput;
  /** Unique document search */
  where: FormRadioButtonCollectionWhereUniqueInput;
};

export type FormRadioButtonCollectionUpsertInput = {
  /** Create document if it didn't exist */
  create: FormRadioButtonCollectionCreateInput;
  /** Update document if it exists */
  update: FormRadioButtonCollectionUpdateInput;
};

export type FormRadioButtonCollectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormRadioButtonCollectionUpsertInput;
  /** Unique document search */
  where: FormRadioButtonCollectionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormRadioButtonCollectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormRadioButtonCollectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormRadioButtonCollectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormRadioButtonCollectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormRadioButtonCollectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormRadioButtonCollectionWhereStageInput>;
  documentInStages_none?: InputMaybe<FormRadioButtonCollectionWhereStageInput>;
  documentInStages_some?: InputMaybe<FormRadioButtonCollectionWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  formRadioButtons_every?: InputMaybe<FormRadioButtonWhereInput>;
  formRadioButtons_none?: InputMaybe<FormRadioButtonWhereInput>;
  formRadioButtons_some?: InputMaybe<FormRadioButtonWhereInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormRadioButtonCollectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormRadioButtonCollectionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormRadioButtonCollectionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormRadioButtonCollectionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormRadioButtonCollectionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormRadioButtonCollection record uniquely */
export type FormRadioButtonCollectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormRadioButtonConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormRadioButtonWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormRadioButtonConnection = {
  __typename?: 'FormRadioButtonConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormRadioButtonEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormRadioButtonCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  formRadioButtonCollections?: InputMaybe<FormRadioButtonCollectionCreateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  option?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormRadioButtonCreateManyInlineInput = {
  /** Connect multiple existing FormRadioButton documents */
  connect?: InputMaybe<Array<FormRadioButtonWhereUniqueInput>>;
  /** Create and connect multiple existing FormRadioButton documents */
  create?: InputMaybe<Array<FormRadioButtonCreateInput>>;
};

export type FormRadioButtonCreateOneInlineInput = {
  /** Connect one existing FormRadioButton document */
  connect?: InputMaybe<FormRadioButtonWhereUniqueInput>;
  /** Create and connect one FormRadioButton document */
  create?: InputMaybe<FormRadioButtonCreateInput>;
};

/** An edge in a connection. */
export type FormRadioButtonEdge = {
  __typename?: 'FormRadioButtonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormRadioButton;
};

/** Identifies documents */
export type FormRadioButtonManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormRadioButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormRadioButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormRadioButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormRadioButtonWhereStageInput>;
  documentInStages_none?: InputMaybe<FormRadioButtonWhereStageInput>;
  documentInStages_some?: InputMaybe<FormRadioButtonWhereStageInput>;
  formRadioButtonCollections_every?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  formRadioButtonCollections_none?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  formRadioButtonCollections_some?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  option?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  option_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  option_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  option_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  option_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  option_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  option_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  option_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  option_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  option_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormRadioButtonOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  hidden_ASC = 'hidden_ASC',
  hidden_DESC = 'hidden_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  option_ASC = 'option_ASC',
  option_DESC = 'option_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormRadioButtonUpdateInput = {
  formRadioButtonCollections?: InputMaybe<FormRadioButtonCollectionUpdateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  option?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormRadioButtonUpdateManyInlineInput = {
  /** Connect multiple existing FormRadioButton documents */
  connect?: InputMaybe<Array<FormRadioButtonConnectInput>>;
  /** Create and connect multiple FormRadioButton documents */
  create?: InputMaybe<Array<FormRadioButtonCreateInput>>;
  /** Delete multiple FormRadioButton documents */
  delete?: InputMaybe<Array<FormRadioButtonWhereUniqueInput>>;
  /** Disconnect multiple FormRadioButton documents */
  disconnect?: InputMaybe<Array<FormRadioButtonWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormRadioButton documents */
  set?: InputMaybe<Array<FormRadioButtonWhereUniqueInput>>;
  /** Update multiple FormRadioButton documents */
  update?: InputMaybe<Array<FormRadioButtonUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormRadioButton documents */
  upsert?: InputMaybe<Array<FormRadioButtonUpsertWithNestedWhereUniqueInput>>;
};

export type FormRadioButtonUpdateManyInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  option?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormRadioButtonUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormRadioButtonUpdateManyInput;
  /** Document search */
  where: FormRadioButtonWhereInput;
};

export type FormRadioButtonUpdateOneInlineInput = {
  /** Connect existing FormRadioButton document */
  connect?: InputMaybe<FormRadioButtonWhereUniqueInput>;
  /** Create and connect one FormRadioButton document */
  create?: InputMaybe<FormRadioButtonCreateInput>;
  /** Delete currently connected FormRadioButton document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormRadioButton document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormRadioButton document */
  update?: InputMaybe<FormRadioButtonUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormRadioButton document */
  upsert?: InputMaybe<FormRadioButtonUpsertWithNestedWhereUniqueInput>;
};

export type FormRadioButtonUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormRadioButtonUpdateInput;
  /** Unique document search */
  where: FormRadioButtonWhereUniqueInput;
};

export type FormRadioButtonUpsertInput = {
  /** Create document if it didn't exist */
  create: FormRadioButtonCreateInput;
  /** Update document if it exists */
  update: FormRadioButtonUpdateInput;
};

export type FormRadioButtonUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormRadioButtonUpsertInput;
  /** Unique document search */
  where: FormRadioButtonWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormRadioButtonWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormRadioButtonWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormRadioButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormRadioButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormRadioButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormRadioButtonWhereStageInput>;
  documentInStages_none?: InputMaybe<FormRadioButtonWhereStageInput>;
  documentInStages_some?: InputMaybe<FormRadioButtonWhereStageInput>;
  formRadioButtonCollections_every?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  formRadioButtonCollections_none?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  formRadioButtonCollections_some?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  option?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  option_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  option_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  option_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  option_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  option_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  option_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  option_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  option_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  option_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormRadioButtonWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormRadioButtonWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormRadioButtonWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormRadioButtonWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormRadioButtonWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormRadioButton record uniquely */
export type FormRadioButtonWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormSelectComponent = Entity & Node & {
  __typename?: 'FormSelectComponent';
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormSelectComponent>;
  fieldName?: Maybe<Scalars['String']['output']>;
  forms: Array<Form>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** List of FormSelectComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** This field is the initial value of the dropdown. If not defined, the default value is empty.  */
  initialValue?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** list of options to show when dropdown opens */
  options: Array<FormSelectOption>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  /** error message to show if field is required and user has not filled it */
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormSelectComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSelectComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormSelectComponentFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormSelectComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormSelectComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSelectComponentOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormSelectOptionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSelectOptionWhereInput>;
};


export type FormSelectComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSelectComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormSelectComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormSelectComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormSelectComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormSelectComponentConnection = {
  __typename?: 'FormSelectComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormSelectComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormSelectComponentCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  options?: InputMaybe<FormSelectOptionCreateManyInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormSelectComponentCreateManyInlineInput = {
  /** Connect multiple existing FormSelectComponent documents */
  connect?: InputMaybe<Array<FormSelectComponentWhereUniqueInput>>;
  /** Create and connect multiple existing FormSelectComponent documents */
  create?: InputMaybe<Array<FormSelectComponentCreateInput>>;
};

export type FormSelectComponentCreateOneInlineInput = {
  /** Connect one existing FormSelectComponent document */
  connect?: InputMaybe<FormSelectComponentWhereUniqueInput>;
  /** Create and connect one FormSelectComponent document */
  create?: InputMaybe<FormSelectComponentCreateInput>;
};

/** An edge in a connection. */
export type FormSelectComponentEdge = {
  __typename?: 'FormSelectComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormSelectComponent;
};

/** Identifies documents */
export type FormSelectComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSelectComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSelectComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSelectComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormSelectComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<FormSelectComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<FormSelectComponentWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  options_every?: InputMaybe<FormSelectOptionWhereInput>;
  options_none?: InputMaybe<FormSelectOptionWhereInput>;
  options_some?: InputMaybe<FormSelectOptionWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormSelectComponentOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  hidden_ASC = 'hidden_ASC',
  hidden_DESC = 'hidden_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  initialValue_ASC = 'initialValue_ASC',
  initialValue_DESC = 'initialValue_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormSelectComponentUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  options?: InputMaybe<FormSelectOptionUpdateManyInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
};

export type FormSelectComponentUpdateManyInlineInput = {
  /** Connect multiple existing FormSelectComponent documents */
  connect?: InputMaybe<Array<FormSelectComponentConnectInput>>;
  /** Create and connect multiple FormSelectComponent documents */
  create?: InputMaybe<Array<FormSelectComponentCreateInput>>;
  /** Delete multiple FormSelectComponent documents */
  delete?: InputMaybe<Array<FormSelectComponentWhereUniqueInput>>;
  /** Disconnect multiple FormSelectComponent documents */
  disconnect?: InputMaybe<Array<FormSelectComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormSelectComponent documents */
  set?: InputMaybe<Array<FormSelectComponentWhereUniqueInput>>;
  /** Update multiple FormSelectComponent documents */
  update?: InputMaybe<Array<FormSelectComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormSelectComponent documents */
  upsert?: InputMaybe<Array<FormSelectComponentUpsertWithNestedWhereUniqueInput>>;
};

export type FormSelectComponentUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
};

export type FormSelectComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormSelectComponentUpdateManyInput;
  /** Document search */
  where: FormSelectComponentWhereInput;
};

export type FormSelectComponentUpdateOneInlineInput = {
  /** Connect existing FormSelectComponent document */
  connect?: InputMaybe<FormSelectComponentWhereUniqueInput>;
  /** Create and connect one FormSelectComponent document */
  create?: InputMaybe<FormSelectComponentCreateInput>;
  /** Delete currently connected FormSelectComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormSelectComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormSelectComponent document */
  update?: InputMaybe<FormSelectComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormSelectComponent document */
  upsert?: InputMaybe<FormSelectComponentUpsertWithNestedWhereUniqueInput>;
};

export type FormSelectComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormSelectComponentUpdateInput;
  /** Unique document search */
  where: FormSelectComponentWhereUniqueInput;
};

export type FormSelectComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: FormSelectComponentCreateInput;
  /** Update document if it exists */
  update: FormSelectComponentUpdateInput;
};

export type FormSelectComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormSelectComponentUpsertInput;
  /** Unique document search */
  where: FormSelectComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormSelectComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormSelectComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSelectComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSelectComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSelectComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormSelectComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<FormSelectComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<FormSelectComponentWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  options_every?: InputMaybe<FormSelectOptionWhereInput>;
  options_none?: InputMaybe<FormSelectOptionWhereInput>;
  options_some?: InputMaybe<FormSelectOptionWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormSelectComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSelectComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSelectComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSelectComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormSelectComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormSelectComponent record uniquely */
export type FormSelectComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormSelectOption = Entity & Node & {
  __typename?: 'FormSelectOption';
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormSelectOption>;
  /** List of FormSelectOption versions */
  history: Array<Version>;
  /** asset for left icon to display in options */
  iconLeft?: Maybe<Asset>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** label or text which shows up on website */
  label: Scalars['String']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** value of the dropdown options */
  value: Scalars['String']['output'];
};


export type FormSelectOptionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSelectOptionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormSelectOptionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormSelectOptionIconLeftArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type FormSelectOptionMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSelectOptionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSelectOptionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormSelectOptionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormSelectOptionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormSelectOptionWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormSelectOptionConnection = {
  __typename?: 'FormSelectOptionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormSelectOptionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormSelectOptionCreateInput = {
  ckv0hh8fx0sk701zd8bw60y5h?: InputMaybe<FormSelectComponentCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  iconLeft?: InputMaybe<AssetCreateOneInlineInput>;
  label: Scalars['String']['input'];
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
};

export type FormSelectOptionCreateManyInlineInput = {
  /** Connect multiple existing FormSelectOption documents */
  connect?: InputMaybe<Array<FormSelectOptionWhereUniqueInput>>;
  /** Create and connect multiple existing FormSelectOption documents */
  create?: InputMaybe<Array<FormSelectOptionCreateInput>>;
};

export type FormSelectOptionCreateOneInlineInput = {
  /** Connect one existing FormSelectOption document */
  connect?: InputMaybe<FormSelectOptionWhereUniqueInput>;
  /** Create and connect one FormSelectOption document */
  create?: InputMaybe<FormSelectOptionCreateInput>;
};

/** An edge in a connection. */
export type FormSelectOptionEdge = {
  __typename?: 'FormSelectOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormSelectOption;
};

/** Identifies documents */
export type FormSelectOptionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSelectOptionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSelectOptionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSelectOptionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormSelectOptionWhereStageInput>;
  documentInStages_none?: InputMaybe<FormSelectOptionWhereStageInput>;
  documentInStages_some?: InputMaybe<FormSelectOptionWhereStageInput>;
  iconLeft?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  value?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  value_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum FormSelectOptionOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type FormSelectOptionUpdateInput = {
  ckv0hh8fx0sk701zd8bw60y5h?: InputMaybe<FormSelectComponentUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  iconLeft?: InputMaybe<AssetUpdateOneInlineInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FormSelectOptionUpdateManyInlineInput = {
  /** Connect multiple existing FormSelectOption documents */
  connect?: InputMaybe<Array<FormSelectOptionConnectInput>>;
  /** Create and connect multiple FormSelectOption documents */
  create?: InputMaybe<Array<FormSelectOptionCreateInput>>;
  /** Delete multiple FormSelectOption documents */
  delete?: InputMaybe<Array<FormSelectOptionWhereUniqueInput>>;
  /** Disconnect multiple FormSelectOption documents */
  disconnect?: InputMaybe<Array<FormSelectOptionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormSelectOption documents */
  set?: InputMaybe<Array<FormSelectOptionWhereUniqueInput>>;
  /** Update multiple FormSelectOption documents */
  update?: InputMaybe<Array<FormSelectOptionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormSelectOption documents */
  upsert?: InputMaybe<Array<FormSelectOptionUpsertWithNestedWhereUniqueInput>>;
};

export type FormSelectOptionUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FormSelectOptionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormSelectOptionUpdateManyInput;
  /** Document search */
  where: FormSelectOptionWhereInput;
};

export type FormSelectOptionUpdateOneInlineInput = {
  /** Connect existing FormSelectOption document */
  connect?: InputMaybe<FormSelectOptionWhereUniqueInput>;
  /** Create and connect one FormSelectOption document */
  create?: InputMaybe<FormSelectOptionCreateInput>;
  /** Delete currently connected FormSelectOption document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormSelectOption document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormSelectOption document */
  update?: InputMaybe<FormSelectOptionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormSelectOption document */
  upsert?: InputMaybe<FormSelectOptionUpsertWithNestedWhereUniqueInput>;
};

export type FormSelectOptionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormSelectOptionUpdateInput;
  /** Unique document search */
  where: FormSelectOptionWhereUniqueInput;
};

export type FormSelectOptionUpsertInput = {
  /** Create document if it didn't exist */
  create: FormSelectOptionCreateInput;
  /** Update document if it exists */
  update: FormSelectOptionUpdateInput;
};

export type FormSelectOptionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormSelectOptionUpsertInput;
  /** Unique document search */
  where: FormSelectOptionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormSelectOptionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormSelectOptionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSelectOptionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSelectOptionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSelectOptionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormSelectOptionWhereStageInput>;
  documentInStages_none?: InputMaybe<FormSelectOptionWhereStageInput>;
  documentInStages_some?: InputMaybe<FormSelectOptionWhereStageInput>;
  iconLeft?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  value?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  value_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormSelectOptionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSelectOptionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSelectOptionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSelectOptionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormSelectOptionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormSelectOption record uniquely */
export type FormSelectOptionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormSubmitButton = Entity & Node & {
  __typename?: 'FormSubmitButton';
  /** Used when the form is in a 'loading' state. */
  buttonLoadingText?: Maybe<Scalars['String']['output']>;
  buttonText?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormSubmitButton>;
  forms: Array<Form>;
  /** List of FormSubmitButton versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormSubmitButtonCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSubmitButtonDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormSubmitButtonFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormSubmitButtonHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormSubmitButtonMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSubmitButtonPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSubmitButtonScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormSubmitButtonUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormSubmitButtonConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormSubmitButtonWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormSubmitButtonConnection = {
  __typename?: 'FormSubmitButtonConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormSubmitButtonEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormSubmitButtonCreateInput = {
  buttonLoadingText?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormSubmitButtonCreateManyInlineInput = {
  /** Connect multiple existing FormSubmitButton documents */
  connect?: InputMaybe<Array<FormSubmitButtonWhereUniqueInput>>;
  /** Create and connect multiple existing FormSubmitButton documents */
  create?: InputMaybe<Array<FormSubmitButtonCreateInput>>;
};

export type FormSubmitButtonCreateOneInlineInput = {
  /** Connect one existing FormSubmitButton document */
  connect?: InputMaybe<FormSubmitButtonWhereUniqueInput>;
  /** Create and connect one FormSubmitButton document */
  create?: InputMaybe<FormSubmitButtonCreateInput>;
};

/** An edge in a connection. */
export type FormSubmitButtonEdge = {
  __typename?: 'FormSubmitButtonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormSubmitButton;
};

/** Identifies documents */
export type FormSubmitButtonManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSubmitButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSubmitButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSubmitButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttonLoadingText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  buttonLoadingText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  buttonLoadingText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  buttonLoadingText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonLoadingText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  buttonLoadingText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  buttonLoadingText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  buttonLoadingText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  buttonLoadingText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  buttonLoadingText_starts_with?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  buttonText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  buttonText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  buttonText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  buttonText_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormSubmitButtonWhereStageInput>;
  documentInStages_none?: InputMaybe<FormSubmitButtonWhereStageInput>;
  documentInStages_some?: InputMaybe<FormSubmitButtonWhereStageInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormSubmitButtonOrderByInput {
  buttonLoadingText_ASC = 'buttonLoadingText_ASC',
  buttonLoadingText_DESC = 'buttonLoadingText_DESC',
  buttonText_ASC = 'buttonText_ASC',
  buttonText_DESC = 'buttonText_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormSubmitButtonUpdateInput = {
  buttonLoadingText?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormSubmitButtonUpdateManyInlineInput = {
  /** Connect multiple existing FormSubmitButton documents */
  connect?: InputMaybe<Array<FormSubmitButtonConnectInput>>;
  /** Create and connect multiple FormSubmitButton documents */
  create?: InputMaybe<Array<FormSubmitButtonCreateInput>>;
  /** Delete multiple FormSubmitButton documents */
  delete?: InputMaybe<Array<FormSubmitButtonWhereUniqueInput>>;
  /** Disconnect multiple FormSubmitButton documents */
  disconnect?: InputMaybe<Array<FormSubmitButtonWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormSubmitButton documents */
  set?: InputMaybe<Array<FormSubmitButtonWhereUniqueInput>>;
  /** Update multiple FormSubmitButton documents */
  update?: InputMaybe<Array<FormSubmitButtonUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormSubmitButton documents */
  upsert?: InputMaybe<Array<FormSubmitButtonUpsertWithNestedWhereUniqueInput>>;
};

export type FormSubmitButtonUpdateManyInput = {
  buttonLoadingText?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormSubmitButtonUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormSubmitButtonUpdateManyInput;
  /** Document search */
  where: FormSubmitButtonWhereInput;
};

export type FormSubmitButtonUpdateOneInlineInput = {
  /** Connect existing FormSubmitButton document */
  connect?: InputMaybe<FormSubmitButtonWhereUniqueInput>;
  /** Create and connect one FormSubmitButton document */
  create?: InputMaybe<FormSubmitButtonCreateInput>;
  /** Delete currently connected FormSubmitButton document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormSubmitButton document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormSubmitButton document */
  update?: InputMaybe<FormSubmitButtonUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormSubmitButton document */
  upsert?: InputMaybe<FormSubmitButtonUpsertWithNestedWhereUniqueInput>;
};

export type FormSubmitButtonUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormSubmitButtonUpdateInput;
  /** Unique document search */
  where: FormSubmitButtonWhereUniqueInput;
};

export type FormSubmitButtonUpsertInput = {
  /** Create document if it didn't exist */
  create: FormSubmitButtonCreateInput;
  /** Update document if it exists */
  update: FormSubmitButtonUpdateInput;
};

export type FormSubmitButtonUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormSubmitButtonUpsertInput;
  /** Unique document search */
  where: FormSubmitButtonWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormSubmitButtonWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormSubmitButtonWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSubmitButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSubmitButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSubmitButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttonLoadingText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  buttonLoadingText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  buttonLoadingText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  buttonLoadingText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonLoadingText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  buttonLoadingText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  buttonLoadingText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  buttonLoadingText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  buttonLoadingText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  buttonLoadingText_starts_with?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  buttonText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  buttonText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  buttonText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  buttonText_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormSubmitButtonWhereStageInput>;
  documentInStages_none?: InputMaybe<FormSubmitButtonWhereStageInput>;
  documentInStages_some?: InputMaybe<FormSubmitButtonWhereStageInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormSubmitButtonWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSubmitButtonWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSubmitButtonWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSubmitButtonWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormSubmitButtonWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormSubmitButton record uniquely */
export type FormSubmitButtonWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormSuccessComponent = Entity & Node & {
  __typename?: 'FormSuccessComponent';
  /** title for use just in CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  components: Array<FormSuccessComponentComponents>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<FormSuccessComponent>;
  /** List of FormSuccessComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** success message */
  message: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormSuccessComponentComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FormSuccessComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSuccessComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormSuccessComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormSuccessComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSuccessComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSuccessComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormSuccessComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormSuccessComponentComponents = DynamicCardGrid | GenericCardCarouseComponent | GenericGridAuthorable;

export type FormSuccessComponentComponentsConnectInput = {
  DynamicCardGrid?: InputMaybe<DynamicCardGridConnectInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentConnectInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableConnectInput>;
};

export type FormSuccessComponentComponentsCreateInput = {
  DynamicCardGrid?: InputMaybe<DynamicCardGridCreateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableCreateInput>;
};

export type FormSuccessComponentComponentsCreateManyInlineInput = {
  /** Connect multiple existing FormSuccessComponentComponents documents */
  connect?: InputMaybe<Array<FormSuccessComponentComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing FormSuccessComponentComponents documents */
  create?: InputMaybe<Array<FormSuccessComponentComponentsCreateInput>>;
};

export type FormSuccessComponentComponentsCreateOneInlineInput = {
  /** Connect one existing FormSuccessComponentComponents document */
  connect?: InputMaybe<FormSuccessComponentComponentsWhereUniqueInput>;
  /** Create and connect one FormSuccessComponentComponents document */
  create?: InputMaybe<FormSuccessComponentComponentsCreateInput>;
};

export type FormSuccessComponentComponentsUpdateInput = {
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateInput>;
};

export type FormSuccessComponentComponentsUpdateManyInlineInput = {
  /** Connect multiple existing FormSuccessComponentComponents documents */
  connect?: InputMaybe<Array<FormSuccessComponentComponentsConnectInput>>;
  /** Create and connect multiple FormSuccessComponentComponents documents */
  create?: InputMaybe<Array<FormSuccessComponentComponentsCreateInput>>;
  /** Delete multiple FormSuccessComponentComponents documents */
  delete?: InputMaybe<Array<FormSuccessComponentComponentsWhereUniqueInput>>;
  /** Disconnect multiple FormSuccessComponentComponents documents */
  disconnect?: InputMaybe<Array<FormSuccessComponentComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormSuccessComponentComponents documents */
  set?: InputMaybe<Array<FormSuccessComponentComponentsWhereUniqueInput>>;
  /** Update multiple FormSuccessComponentComponents documents */
  update?: InputMaybe<Array<FormSuccessComponentComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormSuccessComponentComponents documents */
  upsert?: InputMaybe<Array<FormSuccessComponentComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type FormSuccessComponentComponentsUpdateManyWithNestedWhereInput = {
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateManyWithNestedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateManyWithNestedWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateManyWithNestedWhereInput>;
};

export type FormSuccessComponentComponentsUpdateOneInlineInput = {
  /** Connect existing FormSuccessComponentComponents document */
  connect?: InputMaybe<FormSuccessComponentComponentsWhereUniqueInput>;
  /** Create and connect one FormSuccessComponentComponents document */
  create?: InputMaybe<FormSuccessComponentComponentsCreateInput>;
  /** Delete currently connected FormSuccessComponentComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormSuccessComponentComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormSuccessComponentComponents document */
  update?: InputMaybe<FormSuccessComponentComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormSuccessComponentComponents document */
  upsert?: InputMaybe<FormSuccessComponentComponentsUpsertWithNestedWhereUniqueInput>;
};

export type FormSuccessComponentComponentsUpdateWithNestedWhereUniqueInput = {
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateWithNestedWhereUniqueInput>;
};

export type FormSuccessComponentComponentsUpsertWithNestedWhereUniqueInput = {
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpsertWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpsertWithNestedWhereUniqueInput>;
};

export type FormSuccessComponentComponentsWhereInput = {
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereInput>;
};

export type FormSuccessComponentComponentsWhereUniqueInput = {
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereUniqueInput>;
};

export type FormSuccessComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormSuccessComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormSuccessComponentConnection = {
  __typename?: 'FormSuccessComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormSuccessComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormSuccessComponentCreateInput = {
  ckv0mmd3m0xde01yz5nm65edw?: InputMaybe<FormCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  components?: InputMaybe<FormSuccessComponentComponentsCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  message: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormSuccessComponentCreateManyInlineInput = {
  /** Connect multiple existing FormSuccessComponent documents */
  connect?: InputMaybe<Array<FormSuccessComponentWhereUniqueInput>>;
  /** Create and connect multiple existing FormSuccessComponent documents */
  create?: InputMaybe<Array<FormSuccessComponentCreateInput>>;
};

export type FormSuccessComponentCreateOneInlineInput = {
  /** Connect one existing FormSuccessComponent document */
  connect?: InputMaybe<FormSuccessComponentWhereUniqueInput>;
  /** Create and connect one FormSuccessComponent document */
  create?: InputMaybe<FormSuccessComponentCreateInput>;
};

/** An edge in a connection. */
export type FormSuccessComponentEdge = {
  __typename?: 'FormSuccessComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormSuccessComponent;
};

/** Identifies documents */
export type FormSuccessComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSuccessComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSuccessComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSuccessComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  components_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  components_some?: InputMaybe<FormSuccessComponentComponentsWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<FormSuccessComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<FormSuccessComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<FormSuccessComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  message_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  message_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  message_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  message_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  message_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  message_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  message_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  message_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  message_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormSuccessComponentOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  message_ASC = 'message_ASC',
  message_DESC = 'message_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormSuccessComponentUpdateInput = {
  ckv0mmd3m0xde01yz5nm65edw?: InputMaybe<FormUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  components?: InputMaybe<FormSuccessComponentComponentsUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormSuccessComponentUpdateManyInlineInput = {
  /** Connect multiple existing FormSuccessComponent documents */
  connect?: InputMaybe<Array<FormSuccessComponentConnectInput>>;
  /** Create and connect multiple FormSuccessComponent documents */
  create?: InputMaybe<Array<FormSuccessComponentCreateInput>>;
  /** Delete multiple FormSuccessComponent documents */
  delete?: InputMaybe<Array<FormSuccessComponentWhereUniqueInput>>;
  /** Disconnect multiple FormSuccessComponent documents */
  disconnect?: InputMaybe<Array<FormSuccessComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormSuccessComponent documents */
  set?: InputMaybe<Array<FormSuccessComponentWhereUniqueInput>>;
  /** Update multiple FormSuccessComponent documents */
  update?: InputMaybe<Array<FormSuccessComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormSuccessComponent documents */
  upsert?: InputMaybe<Array<FormSuccessComponentUpsertWithNestedWhereUniqueInput>>;
};

export type FormSuccessComponentUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormSuccessComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormSuccessComponentUpdateManyInput;
  /** Document search */
  where: FormSuccessComponentWhereInput;
};

export type FormSuccessComponentUpdateOneInlineInput = {
  /** Connect existing FormSuccessComponent document */
  connect?: InputMaybe<FormSuccessComponentWhereUniqueInput>;
  /** Create and connect one FormSuccessComponent document */
  create?: InputMaybe<FormSuccessComponentCreateInput>;
  /** Delete currently connected FormSuccessComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormSuccessComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormSuccessComponent document */
  update?: InputMaybe<FormSuccessComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormSuccessComponent document */
  upsert?: InputMaybe<FormSuccessComponentUpsertWithNestedWhereUniqueInput>;
};

export type FormSuccessComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormSuccessComponentUpdateInput;
  /** Unique document search */
  where: FormSuccessComponentWhereUniqueInput;
};

export type FormSuccessComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: FormSuccessComponentCreateInput;
  /** Update document if it exists */
  update: FormSuccessComponentUpdateInput;
};

export type FormSuccessComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormSuccessComponentUpsertInput;
  /** Unique document search */
  where: FormSuccessComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormSuccessComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormSuccessComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSuccessComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSuccessComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSuccessComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  components_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  components_some?: InputMaybe<FormSuccessComponentComponentsWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<FormSuccessComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<FormSuccessComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<FormSuccessComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  message_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  message_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  message_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  message_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  message_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  message_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  message_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  message_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  message_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormSuccessComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSuccessComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSuccessComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSuccessComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormSuccessComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormSuccessComponent record uniquely */
export type FormSuccessComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormTextInput = Entity & Node & {
  __typename?: 'FormTextInput';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** ALWAYS SET TO FALSE. This field was originally set up to handle text and date input types. With new requirements on how those 2 types should be handled, there is now a separate Form Date Input Component which you should use instead of setting this field to 'true'. This field should be deleted/hidden once legacy Text Input fields that are for dates, have been switched to the new Form Date Input Component. */
  date?: Maybe<Scalars['Boolean']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<FormTextInput>;
  /** A camel-case field name, eg. 'firstName', 'lastName' */
  fieldName?: Maybe<Scalars['String']['output']>;
  forms: Array<Form>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** List of FormTextInput versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Content to pre-fill the field. */
  initialValue?: Maybe<Scalars['String']['output']>;
  /** Label shown on Website */
  label?: Maybe<Scalars['String']['output']>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** Please fill out. Otherwise the field can't be marekd as required */
  placeholderText?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Displays when form is submitted without this field, if field is required. */
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  /** Validation rules for input text field - could be used only with SalesForce form  */
  salesForceValidationRules?: Maybe<ValidationRules>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormTextInputCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormTextInputDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormTextInputFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormTextInputHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormTextInputMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormTextInputPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormTextInputScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormTextInputUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormTextInputConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormTextInputWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormTextInputConnection = {
  __typename?: 'FormTextInputConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormTextInputEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormTextInputCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['Boolean']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  salesForceValidationRules?: InputMaybe<ValidationRules>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormTextInputCreateManyInlineInput = {
  /** Connect multiple existing FormTextInput documents */
  connect?: InputMaybe<Array<FormTextInputWhereUniqueInput>>;
  /** Create and connect multiple existing FormTextInput documents */
  create?: InputMaybe<Array<FormTextInputCreateInput>>;
};

export type FormTextInputCreateOneInlineInput = {
  /** Connect one existing FormTextInput document */
  connect?: InputMaybe<FormTextInputWhereUniqueInput>;
  /** Create and connect one FormTextInput document */
  create?: InputMaybe<FormTextInputCreateInput>;
};

/** An edge in a connection. */
export type FormTextInputEdge = {
  __typename?: 'FormTextInputEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormTextInput;
};

/** Identifies documents */
export type FormTextInputManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormTextInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormTextInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormTextInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  date?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  date_not?: InputMaybe<Scalars['Boolean']['input']>;
  documentInStages_every?: InputMaybe<FormTextInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormTextInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormTextInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholderText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholderText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholderText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholderText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholderText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholderText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholderText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholderText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholderText_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  salesForceValidationRules?: InputMaybe<ValidationRules>;
  /** All values that are contained in given list. */
  salesForceValidationRules_in?: InputMaybe<Array<InputMaybe<ValidationRules>>>;
  /** Any other value that exists and is not equal to the given value. */
  salesForceValidationRules_not?: InputMaybe<ValidationRules>;
  /** All values that are not contained in given list. */
  salesForceValidationRules_not_in?: InputMaybe<Array<InputMaybe<ValidationRules>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormTextInputOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  date_ASC = 'date_ASC',
  date_DESC = 'date_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  hidden_ASC = 'hidden_ASC',
  hidden_DESC = 'hidden_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  initialValue_ASC = 'initialValue_ASC',
  initialValue_DESC = 'initialValue_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  placeholderText_ASC = 'placeholderText_ASC',
  placeholderText_DESC = 'placeholderText_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  salesForceValidationRules_ASC = 'salesForceValidationRules_ASC',
  salesForceValidationRules_DESC = 'salesForceValidationRules_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormTextInputUpdateInput = {
  date?: InputMaybe<Scalars['Boolean']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  salesForceValidationRules?: InputMaybe<ValidationRules>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormTextInputUpdateManyInlineInput = {
  /** Connect multiple existing FormTextInput documents */
  connect?: InputMaybe<Array<FormTextInputConnectInput>>;
  /** Create and connect multiple FormTextInput documents */
  create?: InputMaybe<Array<FormTextInputCreateInput>>;
  /** Delete multiple FormTextInput documents */
  delete?: InputMaybe<Array<FormTextInputWhereUniqueInput>>;
  /** Disconnect multiple FormTextInput documents */
  disconnect?: InputMaybe<Array<FormTextInputWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormTextInput documents */
  set?: InputMaybe<Array<FormTextInputWhereUniqueInput>>;
  /** Update multiple FormTextInput documents */
  update?: InputMaybe<Array<FormTextInputUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormTextInput documents */
  upsert?: InputMaybe<Array<FormTextInputUpsertWithNestedWhereUniqueInput>>;
};

export type FormTextInputUpdateManyInput = {
  date?: InputMaybe<Scalars['Boolean']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  salesForceValidationRules?: InputMaybe<ValidationRules>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormTextInputUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormTextInputUpdateManyInput;
  /** Document search */
  where: FormTextInputWhereInput;
};

export type FormTextInputUpdateOneInlineInput = {
  /** Connect existing FormTextInput document */
  connect?: InputMaybe<FormTextInputWhereUniqueInput>;
  /** Create and connect one FormTextInput document */
  create?: InputMaybe<FormTextInputCreateInput>;
  /** Delete currently connected FormTextInput document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormTextInput document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormTextInput document */
  update?: InputMaybe<FormTextInputUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormTextInput document */
  upsert?: InputMaybe<FormTextInputUpsertWithNestedWhereUniqueInput>;
};

export type FormTextInputUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormTextInputUpdateInput;
  /** Unique document search */
  where: FormTextInputWhereUniqueInput;
};

export type FormTextInputUpsertInput = {
  /** Create document if it didn't exist */
  create: FormTextInputCreateInput;
  /** Update document if it exists */
  update: FormTextInputUpdateInput;
};

export type FormTextInputUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormTextInputUpsertInput;
  /** Unique document search */
  where: FormTextInputWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormTextInputWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormTextInputWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormTextInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormTextInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormTextInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  date?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  date_not?: InputMaybe<Scalars['Boolean']['input']>;
  documentInStages_every?: InputMaybe<FormTextInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormTextInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormTextInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholderText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholderText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholderText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholderText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholderText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholderText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholderText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholderText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholderText_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  salesForceValidationRules?: InputMaybe<ValidationRules>;
  /** All values that are contained in given list. */
  salesForceValidationRules_in?: InputMaybe<Array<InputMaybe<ValidationRules>>>;
  /** Any other value that exists and is not equal to the given value. */
  salesForceValidationRules_not?: InputMaybe<ValidationRules>;
  /** All values that are not contained in given list. */
  salesForceValidationRules_not_in?: InputMaybe<Array<InputMaybe<ValidationRules>>>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormTextInputWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormTextInputWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormTextInputWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormTextInputWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormTextInputWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormTextInput record uniquely */
export type FormTextInputWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormTextareaInput = Entity & Node & {
  __typename?: 'FormTextareaInput';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormTextareaInput>;
  /** A camel-case field name, eg. 'userComment', 'contactMessage' */
  fieldName?: Maybe<Scalars['String']['output']>;
  forms: Array<Form>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** List of FormTextareaInput versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Content to pre-fill the field. */
  initialValue?: Maybe<Scalars['String']['output']>;
  /** label for this field */
  label?: Maybe<Scalars['String']['output']>;
  market: Markets;
  marketName?: Maybe<Market>;
  placeholderText?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Displays when form is submitted without this field, if field is required. */
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormTextareaInputCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormTextareaInputDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormTextareaInputFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormTextareaInputHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormTextareaInputMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormTextareaInputPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormTextareaInputScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormTextareaInputUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormTextareaInputConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormTextareaInputWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormTextareaInputConnection = {
  __typename?: 'FormTextareaInputConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormTextareaInputEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormTextareaInputCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormTextareaInputCreateManyInlineInput = {
  /** Connect multiple existing FormTextareaInput documents */
  connect?: InputMaybe<Array<FormTextareaInputWhereUniqueInput>>;
  /** Create and connect multiple existing FormTextareaInput documents */
  create?: InputMaybe<Array<FormTextareaInputCreateInput>>;
};

export type FormTextareaInputCreateOneInlineInput = {
  /** Connect one existing FormTextareaInput document */
  connect?: InputMaybe<FormTextareaInputWhereUniqueInput>;
  /** Create and connect one FormTextareaInput document */
  create?: InputMaybe<FormTextareaInputCreateInput>;
};

/** An edge in a connection. */
export type FormTextareaInputEdge = {
  __typename?: 'FormTextareaInputEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormTextareaInput;
};

/** Identifies documents */
export type FormTextareaInputManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormTextareaInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormTextareaInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormTextareaInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormTextareaInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormTextareaInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormTextareaInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholderText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholderText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholderText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholderText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholderText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholderText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholderText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholderText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholderText_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormTextareaInputOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  hidden_ASC = 'hidden_ASC',
  hidden_DESC = 'hidden_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  initialValue_ASC = 'initialValue_ASC',
  initialValue_DESC = 'initialValue_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  placeholderText_ASC = 'placeholderText_ASC',
  placeholderText_DESC = 'placeholderText_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormTextareaInputUpdateInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormTextareaInputUpdateManyInlineInput = {
  /** Connect multiple existing FormTextareaInput documents */
  connect?: InputMaybe<Array<FormTextareaInputConnectInput>>;
  /** Create and connect multiple FormTextareaInput documents */
  create?: InputMaybe<Array<FormTextareaInputCreateInput>>;
  /** Delete multiple FormTextareaInput documents */
  delete?: InputMaybe<Array<FormTextareaInputWhereUniqueInput>>;
  /** Disconnect multiple FormTextareaInput documents */
  disconnect?: InputMaybe<Array<FormTextareaInputWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormTextareaInput documents */
  set?: InputMaybe<Array<FormTextareaInputWhereUniqueInput>>;
  /** Update multiple FormTextareaInput documents */
  update?: InputMaybe<Array<FormTextareaInputUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormTextareaInput documents */
  upsert?: InputMaybe<Array<FormTextareaInputUpsertWithNestedWhereUniqueInput>>;
};

export type FormTextareaInputUpdateManyInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormTextareaInputUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormTextareaInputUpdateManyInput;
  /** Document search */
  where: FormTextareaInputWhereInput;
};

export type FormTextareaInputUpdateOneInlineInput = {
  /** Connect existing FormTextareaInput document */
  connect?: InputMaybe<FormTextareaInputWhereUniqueInput>;
  /** Create and connect one FormTextareaInput document */
  create?: InputMaybe<FormTextareaInputCreateInput>;
  /** Delete currently connected FormTextareaInput document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormTextareaInput document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormTextareaInput document */
  update?: InputMaybe<FormTextareaInputUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormTextareaInput document */
  upsert?: InputMaybe<FormTextareaInputUpsertWithNestedWhereUniqueInput>;
};

export type FormTextareaInputUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormTextareaInputUpdateInput;
  /** Unique document search */
  where: FormTextareaInputWhereUniqueInput;
};

export type FormTextareaInputUpsertInput = {
  /** Create document if it didn't exist */
  create: FormTextareaInputCreateInput;
  /** Update document if it exists */
  update: FormTextareaInputUpdateInput;
};

export type FormTextareaInputUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormTextareaInputUpsertInput;
  /** Unique document search */
  where: FormTextareaInputWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormTextareaInputWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormTextareaInputWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormTextareaInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormTextareaInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormTextareaInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormTextareaInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormTextareaInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormTextareaInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholderText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholderText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholderText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholderText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholderText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholderText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholderText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholderText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholderText_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormTextareaInputWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormTextareaInputWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormTextareaInputWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormTextareaInputWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormTextareaInputWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormTextareaInput record uniquely */
export type FormTextareaInputWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum FormTypes {
  contact = 'contact',
  login = 'login',
  newsletter = 'newsletter',
  promotion = 'promotion',
  signup = 'signup'
}

export type FormUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  formErrors?: InputMaybe<FormErrorUpdateManyInlineInput>;
  formFields?: InputMaybe<FormFormUpdateManyInlineInput>;
  formSuccess?: InputMaybe<FormSuccessComponentUpdateOneInlineInput>;
  formType?: InputMaybe<FormTypes>;
  genericAccordionItem?: InputMaybe<GenericAccordionItemUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  lowerLeftCorner?: InputMaybe<AssetUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  newsletterComponent?: InputMaybe<NewsletterComponentUpdateOneInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  upperRightCorner?: InputMaybe<AssetUpdateOneInlineInput>;
};

export type FormUpdateManyInlineInput = {
  /** Connect multiple existing Form documents */
  connect?: InputMaybe<Array<FormConnectInput>>;
  /** Create and connect multiple Form documents */
  create?: InputMaybe<Array<FormCreateInput>>;
  /** Delete multiple Form documents */
  delete?: InputMaybe<Array<FormWhereUniqueInput>>;
  /** Disconnect multiple Form documents */
  disconnect?: InputMaybe<Array<FormWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Form documents */
  set?: InputMaybe<Array<FormWhereUniqueInput>>;
  /** Update multiple Form documents */
  update?: InputMaybe<Array<FormUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Form documents */
  upsert?: InputMaybe<Array<FormUpsertWithNestedWhereUniqueInput>>;
};

export type FormUpdateManyInput = {
  formType?: InputMaybe<FormTypes>;
  market?: InputMaybe<Markets>;
};

export type FormUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormUpdateManyInput;
  /** Document search */
  where: FormWhereInput;
};

export type FormUpdateOneInlineInput = {
  /** Connect existing Form document */
  connect?: InputMaybe<FormWhereUniqueInput>;
  /** Create and connect one Form document */
  create?: InputMaybe<FormCreateInput>;
  /** Delete currently connected Form document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Form document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Form document */
  update?: InputMaybe<FormUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Form document */
  upsert?: InputMaybe<FormUpsertWithNestedWhereUniqueInput>;
};

export type FormUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormUpdateInput;
  /** Unique document search */
  where: FormWhereUniqueInput;
};

export type FormUpsertInput = {
  /** Create document if it didn't exist */
  create: FormCreateInput;
  /** Update document if it exists */
  update: FormUpdateInput;
};

export type FormUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormUpsertInput;
  /** Unique document search */
  where: FormWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormWhereStageInput>;
  documentInStages_none?: InputMaybe<FormWhereStageInput>;
  documentInStages_some?: InputMaybe<FormWhereStageInput>;
  formErrors_every?: InputMaybe<FormErrorWhereInput>;
  formErrors_none?: InputMaybe<FormErrorWhereInput>;
  formErrors_some?: InputMaybe<FormErrorWhereInput>;
  /** All values in which the union is empty */
  formFields_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  formFields_some?: InputMaybe<FormFormWhereInput>;
  formSuccess?: InputMaybe<FormSuccessComponentWhereInput>;
  formType?: InputMaybe<FormTypes>;
  /** All values that are contained in given list. */
  formType_in?: InputMaybe<Array<InputMaybe<FormTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  formType_not?: InputMaybe<FormTypes>;
  /** All values that are not contained in given list. */
  formType_not_in?: InputMaybe<Array<InputMaybe<FormTypes>>>;
  genericAccordionItem?: InputMaybe<GenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  lowerLeftCorner?: InputMaybe<AssetWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  newsletterComponent?: InputMaybe<NewsletterComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upperRightCorner?: InputMaybe<AssetWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Form record uniquely */
export type FormWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericAccordion = Entity & Node & {
  __typename?: 'GenericAccordion';
  anchorNav?: Maybe<AnchorNavigation>;
  cmsTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericAccordion>;
  forms: Array<Form>;
  genericAccordionItems: Array<GenericAccordionItem>;
  genericPages: Array<GenericPage>;
  /** List of GenericAccordion versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** Show numbers in each accordion item */
  numbered?: Maybe<Scalars['Boolean']['output']>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericAccordionAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericAccordionFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type GenericAccordionGenericAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericAccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionItemWhereInput>;
};


export type GenericAccordionGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GenericAccordionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericAccordionMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


export type GenericAccordionProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


export type GenericAccordionProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


export type GenericAccordionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type GenericAccordionRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


export type GenericAccordionRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


export type GenericAccordionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericAccordionSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericAccordionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericAccordionWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericAccordionConnection = {
  __typename?: 'GenericAccordionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericAccordionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericAccordionCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cmsTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  genericAccordionItems?: InputMaybe<GenericAccordionItemCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericAccordionCreateManyInlineInput = {
  /** Connect multiple existing GenericAccordion documents */
  connect?: InputMaybe<Array<GenericAccordionWhereUniqueInput>>;
  /** Create and connect multiple existing GenericAccordion documents */
  create?: InputMaybe<Array<GenericAccordionCreateInput>>;
};

export type GenericAccordionCreateOneInlineInput = {
  /** Connect one existing GenericAccordion document */
  connect?: InputMaybe<GenericAccordionWhereUniqueInput>;
  /** Create and connect one GenericAccordion document */
  create?: InputMaybe<GenericAccordionCreateInput>;
};

/** An edge in a connection. */
export type GenericAccordionEdge = {
  __typename?: 'GenericAccordionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericAccordion;
};

export type GenericAccordionItem = Entity & Node & {
  __typename?: 'GenericAccordionItem';
  alignment: AccordionContentAlignment;
  /** By default the accordion item is expanded, this field makes it collapsed. */
  collapsed?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericAccordionItem>;
  form: Array<GenericAccordionItemForm>;
  /** List of GenericAccordionItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<AssetComponent>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  text?: Maybe<GenericAccordionItemTextRichText>;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericAccordionItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericAccordionItemFormArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type GenericAccordionItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericAccordionItemImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionItemMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericAccordionItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericAccordionItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericAccordionItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericAccordionItemConnection = {
  __typename?: 'GenericAccordionItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericAccordionItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericAccordionItemCreateInput = {
  alignment: AccordionContentAlignment;
  ckruqw0gc09fh01zbgjqx7bca?: InputMaybe<GenericAccordionCreateManyInlineInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  form?: InputMaybe<GenericAccordionItemFormCreateManyInlineInput>;
  image?: InputMaybe<AssetComponentCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericAccordionItemCreateManyInlineInput = {
  /** Connect multiple existing GenericAccordionItem documents */
  connect?: InputMaybe<Array<GenericAccordionItemWhereUniqueInput>>;
  /** Create and connect multiple existing GenericAccordionItem documents */
  create?: InputMaybe<Array<GenericAccordionItemCreateInput>>;
};

export type GenericAccordionItemCreateOneInlineInput = {
  /** Connect one existing GenericAccordionItem document */
  connect?: InputMaybe<GenericAccordionItemWhereUniqueInput>;
  /** Create and connect one GenericAccordionItem document */
  create?: InputMaybe<GenericAccordionItemCreateInput>;
};

/** An edge in a connection. */
export type GenericAccordionItemEdge = {
  __typename?: 'GenericAccordionItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericAccordionItem;
};

export type GenericAccordionItemForm = Form;

export type GenericAccordionItemFormConnectInput = {
  Form?: InputMaybe<FormConnectInput>;
};

export type GenericAccordionItemFormCreateInput = {
  Form?: InputMaybe<FormCreateInput>;
};

export type GenericAccordionItemFormCreateManyInlineInput = {
  /** Connect multiple existing GenericAccordionItemForm documents */
  connect?: InputMaybe<Array<GenericAccordionItemFormWhereUniqueInput>>;
  /** Create and connect multiple existing GenericAccordionItemForm documents */
  create?: InputMaybe<Array<GenericAccordionItemFormCreateInput>>;
};

export type GenericAccordionItemFormCreateOneInlineInput = {
  /** Connect one existing GenericAccordionItemForm document */
  connect?: InputMaybe<GenericAccordionItemFormWhereUniqueInput>;
  /** Create and connect one GenericAccordionItemForm document */
  create?: InputMaybe<GenericAccordionItemFormCreateInput>;
};

export type GenericAccordionItemFormUpdateInput = {
  Form?: InputMaybe<FormUpdateInput>;
};

export type GenericAccordionItemFormUpdateManyInlineInput = {
  /** Connect multiple existing GenericAccordionItemForm documents */
  connect?: InputMaybe<Array<GenericAccordionItemFormConnectInput>>;
  /** Create and connect multiple GenericAccordionItemForm documents */
  create?: InputMaybe<Array<GenericAccordionItemFormCreateInput>>;
  /** Delete multiple GenericAccordionItemForm documents */
  delete?: InputMaybe<Array<GenericAccordionItemFormWhereUniqueInput>>;
  /** Disconnect multiple GenericAccordionItemForm documents */
  disconnect?: InputMaybe<Array<GenericAccordionItemFormWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericAccordionItemForm documents */
  set?: InputMaybe<Array<GenericAccordionItemFormWhereUniqueInput>>;
  /** Update multiple GenericAccordionItemForm documents */
  update?: InputMaybe<Array<GenericAccordionItemFormUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericAccordionItemForm documents */
  upsert?: InputMaybe<Array<GenericAccordionItemFormUpsertWithNestedWhereUniqueInput>>;
};

export type GenericAccordionItemFormUpdateManyWithNestedWhereInput = {
  Form?: InputMaybe<FormUpdateManyWithNestedWhereInput>;
};

export type GenericAccordionItemFormUpdateOneInlineInput = {
  /** Connect existing GenericAccordionItemForm document */
  connect?: InputMaybe<GenericAccordionItemFormWhereUniqueInput>;
  /** Create and connect one GenericAccordionItemForm document */
  create?: InputMaybe<GenericAccordionItemFormCreateInput>;
  /** Delete currently connected GenericAccordionItemForm document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericAccordionItemForm document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericAccordionItemForm document */
  update?: InputMaybe<GenericAccordionItemFormUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericAccordionItemForm document */
  upsert?: InputMaybe<GenericAccordionItemFormUpsertWithNestedWhereUniqueInput>;
};

export type GenericAccordionItemFormUpdateWithNestedWhereUniqueInput = {
  Form?: InputMaybe<FormUpdateWithNestedWhereUniqueInput>;
};

export type GenericAccordionItemFormUpsertWithNestedWhereUniqueInput = {
  Form?: InputMaybe<FormUpsertWithNestedWhereUniqueInput>;
};

export type GenericAccordionItemFormWhereInput = {
  Form?: InputMaybe<FormWhereInput>;
};

export type GenericAccordionItemFormWhereUniqueInput = {
  Form?: InputMaybe<FormWhereUniqueInput>;
};

/** Identifies documents */
export type GenericAccordionItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<AccordionContentAlignment>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<AccordionContentAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<AccordionContentAlignment>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<AccordionContentAlignment>>>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  collapsed_not?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericAccordionItemWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericAccordionItemWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericAccordionItemWhereStageInput>;
  /** All values in which the union is empty */
  form_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  form_some?: InputMaybe<GenericAccordionItemFormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericAccordionItemOrderByInput {
  alignment_ASC = 'alignment_ASC',
  alignment_DESC = 'alignment_DESC',
  collapsed_ASC = 'collapsed_ASC',
  collapsed_DESC = 'collapsed_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericAccordionItemTextRichText = {
  __typename?: 'GenericAccordionItemTextRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<GenericAccordionItemTextRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type GenericAccordionItemTextRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type GenericAccordionItemTextRichTextEmbeddedTypes = Asset;

export type GenericAccordionItemUpdateInput = {
  alignment?: InputMaybe<AccordionContentAlignment>;
  ckruqw0gc09fh01zbgjqx7bca?: InputMaybe<GenericAccordionUpdateManyInlineInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<GenericAccordionItemFormUpdateManyInlineInput>;
  image?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericAccordionItemUpdateManyInlineInput = {
  /** Connect multiple existing GenericAccordionItem documents */
  connect?: InputMaybe<Array<GenericAccordionItemConnectInput>>;
  /** Create and connect multiple GenericAccordionItem documents */
  create?: InputMaybe<Array<GenericAccordionItemCreateInput>>;
  /** Delete multiple GenericAccordionItem documents */
  delete?: InputMaybe<Array<GenericAccordionItemWhereUniqueInput>>;
  /** Disconnect multiple GenericAccordionItem documents */
  disconnect?: InputMaybe<Array<GenericAccordionItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericAccordionItem documents */
  set?: InputMaybe<Array<GenericAccordionItemWhereUniqueInput>>;
  /** Update multiple GenericAccordionItem documents */
  update?: InputMaybe<Array<GenericAccordionItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericAccordionItem documents */
  upsert?: InputMaybe<Array<GenericAccordionItemUpsertWithNestedWhereUniqueInput>>;
};

export type GenericAccordionItemUpdateManyInput = {
  alignment?: InputMaybe<AccordionContentAlignment>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericAccordionItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericAccordionItemUpdateManyInput;
  /** Document search */
  where: GenericAccordionItemWhereInput;
};

export type GenericAccordionItemUpdateOneInlineInput = {
  /** Connect existing GenericAccordionItem document */
  connect?: InputMaybe<GenericAccordionItemWhereUniqueInput>;
  /** Create and connect one GenericAccordionItem document */
  create?: InputMaybe<GenericAccordionItemCreateInput>;
  /** Delete currently connected GenericAccordionItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericAccordionItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericAccordionItem document */
  update?: InputMaybe<GenericAccordionItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericAccordionItem document */
  upsert?: InputMaybe<GenericAccordionItemUpsertWithNestedWhereUniqueInput>;
};

export type GenericAccordionItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericAccordionItemUpdateInput;
  /** Unique document search */
  where: GenericAccordionItemWhereUniqueInput;
};

export type GenericAccordionItemUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericAccordionItemCreateInput;
  /** Update document if it exists */
  update: GenericAccordionItemUpdateInput;
};

export type GenericAccordionItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericAccordionItemUpsertInput;
  /** Unique document search */
  where: GenericAccordionItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericAccordionItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericAccordionItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<AccordionContentAlignment>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<AccordionContentAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<AccordionContentAlignment>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<AccordionContentAlignment>>>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  collapsed_not?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericAccordionItemWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericAccordionItemWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericAccordionItemWhereStageInput>;
  /** All values in which the union is empty */
  form_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  form_some?: InputMaybe<GenericAccordionItemFormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericAccordionItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericAccordionItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericAccordionItem record uniquely */
export type GenericAccordionItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type GenericAccordionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericAccordionWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericAccordionWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericAccordionWhereStageInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  genericAccordionItems_every?: InputMaybe<GenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<GenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<GenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  numbered_not?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericAccordionOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  numbered_ASC = 'numbered_ASC',
  numbered_DESC = 'numbered_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericAccordionTopRated = Entity & Node & {
  __typename?: 'GenericAccordionTopRated';
  anchorNav?: Maybe<AnchorNavigation>;
  cmsTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericAccordionTopRated>;
  extension?: Maybe<AlgoliaExtension>;
  genericPages: Array<GenericPage>;
  /** List of GenericAccordionTopRated versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  productCategoryPages: Array<ProductCategoryPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  super?: Maybe<Scalars['String']['output']>;
  tabContent?: Maybe<TabContent>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericAccordionTopRatedAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionTopRatedCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionTopRatedDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericAccordionTopRatedExtensionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionTopRatedGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GenericAccordionTopRatedHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericAccordionTopRatedMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionTopRatedProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


export type GenericAccordionTopRatedProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


export type GenericAccordionTopRatedPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionTopRatedRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type GenericAccordionTopRatedRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


export type GenericAccordionTopRatedScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericAccordionTopRatedSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionTopRatedTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionTopRatedUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericAccordionTopRatedConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericAccordionTopRatedWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericAccordionTopRatedConnection = {
  __typename?: 'GenericAccordionTopRatedConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericAccordionTopRatedEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericAccordionTopRatedCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cmsTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  extension?: InputMaybe<AlgoliaExtensionCreateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  super?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericAccordionTopRatedCreateManyInlineInput = {
  /** Connect multiple existing GenericAccordionTopRated documents */
  connect?: InputMaybe<Array<GenericAccordionTopRatedWhereUniqueInput>>;
  /** Create and connect multiple existing GenericAccordionTopRated documents */
  create?: InputMaybe<Array<GenericAccordionTopRatedCreateInput>>;
};

export type GenericAccordionTopRatedCreateOneInlineInput = {
  /** Connect one existing GenericAccordionTopRated document */
  connect?: InputMaybe<GenericAccordionTopRatedWhereUniqueInput>;
  /** Create and connect one GenericAccordionTopRated document */
  create?: InputMaybe<GenericAccordionTopRatedCreateInput>;
};

/** An edge in a connection. */
export type GenericAccordionTopRatedEdge = {
  __typename?: 'GenericAccordionTopRatedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericAccordionTopRated;
};

/** Identifies documents */
export type GenericAccordionTopRatedManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionTopRatedWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionTopRatedWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionTopRatedWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericAccordionTopRatedWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericAccordionTopRatedWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericAccordionTopRatedWhereStageInput>;
  extension?: InputMaybe<AlgoliaExtensionWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  super?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  super_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  super_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  super_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  super_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  super_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  super_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  super_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  super_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  super_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericAccordionTopRatedOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  super_ASC = 'super_ASC',
  super_DESC = 'super_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericAccordionTopRatedUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<AlgoliaExtensionUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  super?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericAccordionTopRatedUpdateManyInlineInput = {
  /** Connect multiple existing GenericAccordionTopRated documents */
  connect?: InputMaybe<Array<GenericAccordionTopRatedConnectInput>>;
  /** Create and connect multiple GenericAccordionTopRated documents */
  create?: InputMaybe<Array<GenericAccordionTopRatedCreateInput>>;
  /** Delete multiple GenericAccordionTopRated documents */
  delete?: InputMaybe<Array<GenericAccordionTopRatedWhereUniqueInput>>;
  /** Disconnect multiple GenericAccordionTopRated documents */
  disconnect?: InputMaybe<Array<GenericAccordionTopRatedWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericAccordionTopRated documents */
  set?: InputMaybe<Array<GenericAccordionTopRatedWhereUniqueInput>>;
  /** Update multiple GenericAccordionTopRated documents */
  update?: InputMaybe<Array<GenericAccordionTopRatedUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericAccordionTopRated documents */
  upsert?: InputMaybe<Array<GenericAccordionTopRatedUpsertWithNestedWhereUniqueInput>>;
};

export type GenericAccordionTopRatedUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  super?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericAccordionTopRatedUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericAccordionTopRatedUpdateManyInput;
  /** Document search */
  where: GenericAccordionTopRatedWhereInput;
};

export type GenericAccordionTopRatedUpdateOneInlineInput = {
  /** Connect existing GenericAccordionTopRated document */
  connect?: InputMaybe<GenericAccordionTopRatedWhereUniqueInput>;
  /** Create and connect one GenericAccordionTopRated document */
  create?: InputMaybe<GenericAccordionTopRatedCreateInput>;
  /** Delete currently connected GenericAccordionTopRated document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericAccordionTopRated document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericAccordionTopRated document */
  update?: InputMaybe<GenericAccordionTopRatedUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericAccordionTopRated document */
  upsert?: InputMaybe<GenericAccordionTopRatedUpsertWithNestedWhereUniqueInput>;
};

export type GenericAccordionTopRatedUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericAccordionTopRatedUpdateInput;
  /** Unique document search */
  where: GenericAccordionTopRatedWhereUniqueInput;
};

export type GenericAccordionTopRatedUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericAccordionTopRatedCreateInput;
  /** Update document if it exists */
  update: GenericAccordionTopRatedUpdateInput;
};

export type GenericAccordionTopRatedUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericAccordionTopRatedUpsertInput;
  /** Unique document search */
  where: GenericAccordionTopRatedWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericAccordionTopRatedWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericAccordionTopRatedWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionTopRatedWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionTopRatedWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionTopRatedWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericAccordionTopRatedWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericAccordionTopRatedWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericAccordionTopRatedWhereStageInput>;
  extension?: InputMaybe<AlgoliaExtensionWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  super?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  super_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  super_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  super_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  super_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  super_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  super_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  super_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  super_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  super_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericAccordionTopRatedWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionTopRatedWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionTopRatedWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionTopRatedWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericAccordionTopRatedWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericAccordionTopRated record uniquely */
export type GenericAccordionTopRatedWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericAccordionUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  genericAccordionItems?: InputMaybe<GenericAccordionItemUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type GenericAccordionUpdateManyInlineInput = {
  /** Connect multiple existing GenericAccordion documents */
  connect?: InputMaybe<Array<GenericAccordionConnectInput>>;
  /** Create and connect multiple GenericAccordion documents */
  create?: InputMaybe<Array<GenericAccordionCreateInput>>;
  /** Delete multiple GenericAccordion documents */
  delete?: InputMaybe<Array<GenericAccordionWhereUniqueInput>>;
  /** Disconnect multiple GenericAccordion documents */
  disconnect?: InputMaybe<Array<GenericAccordionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericAccordion documents */
  set?: InputMaybe<Array<GenericAccordionWhereUniqueInput>>;
  /** Update multiple GenericAccordion documents */
  update?: InputMaybe<Array<GenericAccordionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericAccordion documents */
  upsert?: InputMaybe<Array<GenericAccordionUpsertWithNestedWhereUniqueInput>>;
};

export type GenericAccordionUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GenericAccordionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericAccordionUpdateManyInput;
  /** Document search */
  where: GenericAccordionWhereInput;
};

export type GenericAccordionUpdateOneInlineInput = {
  /** Connect existing GenericAccordion document */
  connect?: InputMaybe<GenericAccordionWhereUniqueInput>;
  /** Create and connect one GenericAccordion document */
  create?: InputMaybe<GenericAccordionCreateInput>;
  /** Delete currently connected GenericAccordion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericAccordion document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericAccordion document */
  update?: InputMaybe<GenericAccordionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericAccordion document */
  upsert?: InputMaybe<GenericAccordionUpsertWithNestedWhereUniqueInput>;
};

export type GenericAccordionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericAccordionUpdateInput;
  /** Unique document search */
  where: GenericAccordionWhereUniqueInput;
};

export type GenericAccordionUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericAccordionCreateInput;
  /** Update document if it exists */
  update: GenericAccordionUpdateInput;
};

export type GenericAccordionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericAccordionUpsertInput;
  /** Unique document search */
  where: GenericAccordionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericAccordionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericAccordionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericAccordionWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericAccordionWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericAccordionWhereStageInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  genericAccordionItems_every?: InputMaybe<GenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<GenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<GenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  numbered_not?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericAccordionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericAccordionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericAccordion record uniquely */
export type GenericAccordionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericCardCarouseComponent = Entity & Node & {
  __typename?: 'GenericCardCarouseComponent';
  anchorNav?: Maybe<AnchorNavigation>;
  articles: Array<GenericPage>;
  buttonColor: ButtonColor;
  /** Choose card variation  */
  cardVariation?: Maybe<CardVariation>;
  /** Background of the component. If Heading should be visible on Website, please remove background asset. */
  componentBackground: Array<GenericCardCarouseComponentComponentBackground>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  dictionaryItem: Array<GenericCardCarouseComponentDictionaryItem>;
  /** Get the document in other stages */
  documentInStages: Array<GenericCardCarouseComponent>;
  extension?: Maybe<AlgoliaExtension>;
  floatingObject: Array<GenericCardLayoutComponentFloatingObject>;
  formSuccessComponents: Array<FormSuccessComponent>;
  /** Link on the Generic Card Carousel Component. When providing a link to the CTA button next to the text copy, it will override the default search page links. If search pages are desired, only provide the copy for the button and leave the link field empty */
  genericCardCarouselCta?: Maybe<GenericCardCarouseComponentGenericCradCarouselCta>;
  genericPages: Array<GenericPage>;
  /** Main Heading of the component. Only appears if the field "Asset Component" is empty. */
  heading?: Maybe<Scalars['String']['output']>;
  /** List of GenericCardCarouseComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Unique Key Identifier  */
  key?: Maybe<Scalars['String']['output']>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** CTA directs to a search results page showing all articles */
  pointCtaToArticlesList?: Maybe<Scalars['Boolean']['output']>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  products: Array<Product>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Smaller sub heading above main Heading. */
  subHeading?: Maybe<Scalars['String']['output']>;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericCardCarouseComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericCardCarouseComponentArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GenericCardCarouseComponentComponentBackgroundArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type GenericCardCarouseComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericCardCarouseComponentDictionaryItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type GenericCardCarouseComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericCardCarouseComponentExtensionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericCardCarouseComponentFloatingObjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type GenericCardCarouseComponentFormSuccessComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSuccessComponentWhereInput>;
};


export type GenericCardCarouseComponentGenericCardCarouselCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericCardCarouseComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GenericCardCarouseComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericCardCarouseComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericCardCarouseComponentProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


export type GenericCardCarouseComponentProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


export type GenericCardCarouseComponentProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


export type GenericCardCarouseComponentProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductWhereInput>;
};


export type GenericCardCarouseComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericCardCarouseComponentRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type GenericCardCarouseComponentRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


export type GenericCardCarouseComponentRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


export type GenericCardCarouseComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericCardCarouseComponentSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericCardCarouseComponentTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericCardCarouseComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericCardCarouseComponentComponentBackground = AssetComponent;

export type GenericCardCarouseComponentComponentBackgroundConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type GenericCardCarouseComponentComponentBackgroundCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type GenericCardCarouseComponentComponentBackgroundCreateManyInlineInput = {
  /** Connect multiple existing GenericCardCarouseComponentComponentBackground documents */
  connect?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundWhereUniqueInput>>;
  /** Create and connect multiple existing GenericCardCarouseComponentComponentBackground documents */
  create?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundCreateInput>>;
};

export type GenericCardCarouseComponentComponentBackgroundCreateOneInlineInput = {
  /** Connect one existing GenericCardCarouseComponentComponentBackground document */
  connect?: InputMaybe<GenericCardCarouseComponentComponentBackgroundWhereUniqueInput>;
  /** Create and connect one GenericCardCarouseComponentComponentBackground document */
  create?: InputMaybe<GenericCardCarouseComponentComponentBackgroundCreateInput>;
};

export type GenericCardCarouseComponentComponentBackgroundUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type GenericCardCarouseComponentComponentBackgroundUpdateManyInlineInput = {
  /** Connect multiple existing GenericCardCarouseComponentComponentBackground documents */
  connect?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundConnectInput>>;
  /** Create and connect multiple GenericCardCarouseComponentComponentBackground documents */
  create?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundCreateInput>>;
  /** Delete multiple GenericCardCarouseComponentComponentBackground documents */
  delete?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundWhereUniqueInput>>;
  /** Disconnect multiple GenericCardCarouseComponentComponentBackground documents */
  disconnect?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericCardCarouseComponentComponentBackground documents */
  set?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundWhereUniqueInput>>;
  /** Update multiple GenericCardCarouseComponentComponentBackground documents */
  update?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericCardCarouseComponentComponentBackground documents */
  upsert?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundUpsertWithNestedWhereUniqueInput>>;
};

export type GenericCardCarouseComponentComponentBackgroundUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type GenericCardCarouseComponentComponentBackgroundUpdateOneInlineInput = {
  /** Connect existing GenericCardCarouseComponentComponentBackground document */
  connect?: InputMaybe<GenericCardCarouseComponentComponentBackgroundWhereUniqueInput>;
  /** Create and connect one GenericCardCarouseComponentComponentBackground document */
  create?: InputMaybe<GenericCardCarouseComponentComponentBackgroundCreateInput>;
  /** Delete currently connected GenericCardCarouseComponentComponentBackground document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericCardCarouseComponentComponentBackground document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericCardCarouseComponentComponentBackground document */
  update?: InputMaybe<GenericCardCarouseComponentComponentBackgroundUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericCardCarouseComponentComponentBackground document */
  upsert?: InputMaybe<GenericCardCarouseComponentComponentBackgroundUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentComponentBackgroundUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentComponentBackgroundUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentComponentBackgroundWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type GenericCardCarouseComponentComponentBackgroundWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

export type GenericCardCarouseComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericCardCarouseComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericCardCarouseComponentConnection = {
  __typename?: 'GenericCardCarouseComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericCardCarouseComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericCardCarouseComponentCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  articles?: InputMaybe<GenericPageCreateManyInlineInput>;
  buttonColor: ButtonColor;
  cardVariation?: InputMaybe<CardVariation>;
  ckttqmon70rdz01xo5a2dd8as?: InputMaybe<TipsAndTricksDetailsPageCreateManyInlineInput>;
  ckup9pd4t1rh801z61gst6ucm?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  componentBackground?: InputMaybe<GenericCardCarouseComponentComponentBackgroundCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionaryItem?: InputMaybe<GenericCardCarouseComponentDictionaryItemCreateManyInlineInput>;
  extension?: InputMaybe<AlgoliaExtensionCreateOneInlineInput>;
  floatingObject?: InputMaybe<GenericCardLayoutComponentFloatingObjectCreateManyInlineInput>;
  formSuccessComponents?: InputMaybe<FormSuccessComponentCreateManyInlineInput>;
  genericCardCarouselCta?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaCreateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  pointCtaToArticlesList?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  products?: InputMaybe<ProductCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericCardCarouseComponentCreateManyInlineInput = {
  /** Connect multiple existing GenericCardCarouseComponent documents */
  connect?: InputMaybe<Array<GenericCardCarouseComponentWhereUniqueInput>>;
  /** Create and connect multiple existing GenericCardCarouseComponent documents */
  create?: InputMaybe<Array<GenericCardCarouseComponentCreateInput>>;
};

export type GenericCardCarouseComponentCreateOneInlineInput = {
  /** Connect one existing GenericCardCarouseComponent document */
  connect?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  /** Create and connect one GenericCardCarouseComponent document */
  create?: InputMaybe<GenericCardCarouseComponentCreateInput>;
};

export type GenericCardCarouseComponentDictionaryItem = DictionaryItem;

export type GenericCardCarouseComponentDictionaryItemConnectInput = {
  DictionaryItem?: InputMaybe<DictionaryItemConnectInput>;
};

export type GenericCardCarouseComponentDictionaryItemCreateInput = {
  DictionaryItem?: InputMaybe<DictionaryItemCreateInput>;
};

export type GenericCardCarouseComponentDictionaryItemCreateManyInlineInput = {
  /** Connect multiple existing GenericCardCarouseComponentDictionaryItem documents */
  connect?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemWhereUniqueInput>>;
  /** Create and connect multiple existing GenericCardCarouseComponentDictionaryItem documents */
  create?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemCreateInput>>;
};

export type GenericCardCarouseComponentDictionaryItemCreateOneInlineInput = {
  /** Connect one existing GenericCardCarouseComponentDictionaryItem document */
  connect?: InputMaybe<GenericCardCarouseComponentDictionaryItemWhereUniqueInput>;
  /** Create and connect one GenericCardCarouseComponentDictionaryItem document */
  create?: InputMaybe<GenericCardCarouseComponentDictionaryItemCreateInput>;
};

export type GenericCardCarouseComponentDictionaryItemUpdateInput = {
  DictionaryItem?: InputMaybe<DictionaryItemUpdateInput>;
};

export type GenericCardCarouseComponentDictionaryItemUpdateManyInlineInput = {
  /** Connect multiple existing GenericCardCarouseComponentDictionaryItem documents */
  connect?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemConnectInput>>;
  /** Create and connect multiple GenericCardCarouseComponentDictionaryItem documents */
  create?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemCreateInput>>;
  /** Delete multiple GenericCardCarouseComponentDictionaryItem documents */
  delete?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemWhereUniqueInput>>;
  /** Disconnect multiple GenericCardCarouseComponentDictionaryItem documents */
  disconnect?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericCardCarouseComponentDictionaryItem documents */
  set?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemWhereUniqueInput>>;
  /** Update multiple GenericCardCarouseComponentDictionaryItem documents */
  update?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericCardCarouseComponentDictionaryItem documents */
  upsert?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemUpsertWithNestedWhereUniqueInput>>;
};

export type GenericCardCarouseComponentDictionaryItemUpdateManyWithNestedWhereInput = {
  DictionaryItem?: InputMaybe<DictionaryItemUpdateManyWithNestedWhereInput>;
};

export type GenericCardCarouseComponentDictionaryItemUpdateOneInlineInput = {
  /** Connect existing GenericCardCarouseComponentDictionaryItem document */
  connect?: InputMaybe<GenericCardCarouseComponentDictionaryItemWhereUniqueInput>;
  /** Create and connect one GenericCardCarouseComponentDictionaryItem document */
  create?: InputMaybe<GenericCardCarouseComponentDictionaryItemCreateInput>;
  /** Delete currently connected GenericCardCarouseComponentDictionaryItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericCardCarouseComponentDictionaryItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericCardCarouseComponentDictionaryItem document */
  update?: InputMaybe<GenericCardCarouseComponentDictionaryItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericCardCarouseComponentDictionaryItem document */
  upsert?: InputMaybe<GenericCardCarouseComponentDictionaryItemUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentDictionaryItemUpdateWithNestedWhereUniqueInput = {
  DictionaryItem?: InputMaybe<DictionaryItemUpdateWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentDictionaryItemUpsertWithNestedWhereUniqueInput = {
  DictionaryItem?: InputMaybe<DictionaryItemUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentDictionaryItemWhereInput = {
  DictionaryItem?: InputMaybe<DictionaryItemWhereInput>;
};

export type GenericCardCarouseComponentDictionaryItemWhereUniqueInput = {
  DictionaryItem?: InputMaybe<DictionaryItemWhereUniqueInput>;
};

/** An edge in a connection. */
export type GenericCardCarouseComponentEdge = {
  __typename?: 'GenericCardCarouseComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericCardCarouseComponent;
};

export type GenericCardCarouseComponentGenericCradCarouselCta = Link;

export type GenericCardCarouseComponentGenericCradCarouselCtaConnectInput = {
  Link?: InputMaybe<LinkConnectInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaCreateInput = {
  Link?: InputMaybe<LinkCreateInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaCreateManyInlineInput = {
  /** Connect multiple existing GenericCardCarouseComponentGenericCradCarouselCta documents */
  connect?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaWhereUniqueInput>>;
  /** Create and connect multiple existing GenericCardCarouseComponentGenericCradCarouselCta documents */
  create?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaCreateInput>>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaCreateOneInlineInput = {
  /** Connect one existing GenericCardCarouseComponentGenericCradCarouselCta document */
  connect?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaWhereUniqueInput>;
  /** Create and connect one GenericCardCarouseComponentGenericCradCarouselCta document */
  create?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaCreateInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaUpdateInput = {
  Link?: InputMaybe<LinkUpdateInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaUpdateManyInlineInput = {
  /** Connect multiple existing GenericCardCarouseComponentGenericCradCarouselCta documents */
  connect?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaConnectInput>>;
  /** Create and connect multiple GenericCardCarouseComponentGenericCradCarouselCta documents */
  create?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaCreateInput>>;
  /** Delete multiple GenericCardCarouseComponentGenericCradCarouselCta documents */
  delete?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaWhereUniqueInput>>;
  /** Disconnect multiple GenericCardCarouseComponentGenericCradCarouselCta documents */
  disconnect?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericCardCarouseComponentGenericCradCarouselCta documents */
  set?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaWhereUniqueInput>>;
  /** Update multiple GenericCardCarouseComponentGenericCradCarouselCta documents */
  update?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericCardCarouseComponentGenericCradCarouselCta documents */
  upsert?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaUpsertWithNestedWhereUniqueInput>>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaUpdateManyWithNestedWhereInput = {
  Link?: InputMaybe<LinkUpdateManyWithNestedWhereInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaUpdateOneInlineInput = {
  /** Connect existing GenericCardCarouseComponentGenericCradCarouselCta document */
  connect?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaWhereUniqueInput>;
  /** Create and connect one GenericCardCarouseComponentGenericCradCarouselCta document */
  create?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaCreateInput>;
  /** Delete currently connected GenericCardCarouseComponentGenericCradCarouselCta document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericCardCarouseComponentGenericCradCarouselCta document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericCardCarouseComponentGenericCradCarouselCta document */
  update?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericCardCarouseComponentGenericCradCarouselCta document */
  upsert?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaUpdateWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaUpsertWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaWhereInput = {
  Link?: InputMaybe<LinkWhereInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaWhereUniqueInput = {
  Link?: InputMaybe<LinkWhereUniqueInput>;
};

/** Identifies documents */
export type GenericCardCarouseComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericCardCarouseComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericCardCarouseComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericCardCarouseComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  articles_every?: InputMaybe<GenericPageWhereInput>;
  articles_none?: InputMaybe<GenericPageWhereInput>;
  articles_some?: InputMaybe<GenericPageWhereInput>;
  buttonColor?: InputMaybe<ButtonColor>;
  /** All values that are contained in given list. */
  buttonColor_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonColor_not?: InputMaybe<ButtonColor>;
  /** All values that are not contained in given list. */
  buttonColor_not_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  cardVariation?: InputMaybe<CardVariation>;
  /** All values that are contained in given list. */
  cardVariation_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardVariation_not?: InputMaybe<CardVariation>;
  /** All values that are not contained in given list. */
  cardVariation_not_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  /** All values in which the union is empty */
  componentBackground_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  componentBackground_some?: InputMaybe<GenericCardCarouseComponentComponentBackgroundWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  /** All values in which the union is empty */
  dictionaryItem_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  dictionaryItem_some?: InputMaybe<GenericCardCarouseComponentDictionaryItemWhereInput>;
  documentInStages_every?: InputMaybe<GenericCardCarouseComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericCardCarouseComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericCardCarouseComponentWhereStageInput>;
  extension?: InputMaybe<AlgoliaExtensionWhereInput>;
  /** All values in which the union is empty */
  floatingObject_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  floatingObject_some?: InputMaybe<GenericCardLayoutComponentFloatingObjectWhereInput>;
  formSuccessComponents_every?: InputMaybe<FormSuccessComponentWhereInput>;
  formSuccessComponents_none?: InputMaybe<FormSuccessComponentWhereInput>;
  formSuccessComponents_some?: InputMaybe<FormSuccessComponentWhereInput>;
  /** All values in which the union is connected to the given models */
  genericCardCarouselCta?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaWhereInput>;
  /** All values in which the union is empty */
  genericCardCarouselCta_empty?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  pointCtaToArticlesList?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  pointCtaToArticlesList_not?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  products_every?: InputMaybe<ProductWhereInput>;
  products_none?: InputMaybe<ProductWhereInput>;
  products_some?: InputMaybe<ProductWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericCardCarouseComponentOrderByInput {
  buttonColor_ASC = 'buttonColor_ASC',
  buttonColor_DESC = 'buttonColor_DESC',
  cardVariation_ASC = 'cardVariation_ASC',
  cardVariation_DESC = 'cardVariation_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  key_ASC = 'key_ASC',
  key_DESC = 'key_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  pointCtaToArticlesList_ASC = 'pointCtaToArticlesList_ASC',
  pointCtaToArticlesList_DESC = 'pointCtaToArticlesList_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subHeading_ASC = 'subHeading_ASC',
  subHeading_DESC = 'subHeading_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericCardCarouseComponentUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  articles?: InputMaybe<GenericPageUpdateManyInlineInput>;
  buttonColor?: InputMaybe<ButtonColor>;
  cardVariation?: InputMaybe<CardVariation>;
  ckttqmon70rdz01xo5a2dd8as?: InputMaybe<TipsAndTricksDetailsPageUpdateManyInlineInput>;
  ckup9pd4t1rh801z61gst6ucm?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  componentBackground?: InputMaybe<GenericCardCarouseComponentComponentBackgroundUpdateManyInlineInput>;
  dictionaryItem?: InputMaybe<GenericCardCarouseComponentDictionaryItemUpdateManyInlineInput>;
  extension?: InputMaybe<AlgoliaExtensionUpdateOneInlineInput>;
  floatingObject?: InputMaybe<GenericCardLayoutComponentFloatingObjectUpdateManyInlineInput>;
  formSuccessComponents?: InputMaybe<FormSuccessComponentUpdateManyInlineInput>;
  genericCardCarouselCta?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  pointCtaToArticlesList?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  products?: InputMaybe<ProductUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type GenericCardCarouseComponentUpdateManyInlineInput = {
  /** Connect multiple existing GenericCardCarouseComponent documents */
  connect?: InputMaybe<Array<GenericCardCarouseComponentConnectInput>>;
  /** Create and connect multiple GenericCardCarouseComponent documents */
  create?: InputMaybe<Array<GenericCardCarouseComponentCreateInput>>;
  /** Delete multiple GenericCardCarouseComponent documents */
  delete?: InputMaybe<Array<GenericCardCarouseComponentWhereUniqueInput>>;
  /** Disconnect multiple GenericCardCarouseComponent documents */
  disconnect?: InputMaybe<Array<GenericCardCarouseComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericCardCarouseComponent documents */
  set?: InputMaybe<Array<GenericCardCarouseComponentWhereUniqueInput>>;
  /** Update multiple GenericCardCarouseComponent documents */
  update?: InputMaybe<Array<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericCardCarouseComponent documents */
  upsert?: InputMaybe<Array<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>>;
};

export type GenericCardCarouseComponentUpdateManyInput = {
  buttonColor?: InputMaybe<ButtonColor>;
  cardVariation?: InputMaybe<CardVariation>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  pointCtaToArticlesList?: InputMaybe<Scalars['Boolean']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type GenericCardCarouseComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericCardCarouseComponentUpdateManyInput;
  /** Document search */
  where: GenericCardCarouseComponentWhereInput;
};

export type GenericCardCarouseComponentUpdateOneInlineInput = {
  /** Connect existing GenericCardCarouseComponent document */
  connect?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  /** Create and connect one GenericCardCarouseComponent document */
  create?: InputMaybe<GenericCardCarouseComponentCreateInput>;
  /** Delete currently connected GenericCardCarouseComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericCardCarouseComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericCardCarouseComponent document */
  update?: InputMaybe<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericCardCarouseComponent document */
  upsert?: InputMaybe<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericCardCarouseComponentUpdateInput;
  /** Unique document search */
  where: GenericCardCarouseComponentWhereUniqueInput;
};

export type GenericCardCarouseComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericCardCarouseComponentCreateInput;
  /** Update document if it exists */
  update: GenericCardCarouseComponentUpdateInput;
};

export type GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericCardCarouseComponentUpsertInput;
  /** Unique document search */
  where: GenericCardCarouseComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericCardCarouseComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericCardCarouseComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericCardCarouseComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericCardCarouseComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericCardCarouseComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  articles_every?: InputMaybe<GenericPageWhereInput>;
  articles_none?: InputMaybe<GenericPageWhereInput>;
  articles_some?: InputMaybe<GenericPageWhereInput>;
  buttonColor?: InputMaybe<ButtonColor>;
  /** All values that are contained in given list. */
  buttonColor_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonColor_not?: InputMaybe<ButtonColor>;
  /** All values that are not contained in given list. */
  buttonColor_not_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  cardVariation?: InputMaybe<CardVariation>;
  /** All values that are contained in given list. */
  cardVariation_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardVariation_not?: InputMaybe<CardVariation>;
  /** All values that are not contained in given list. */
  cardVariation_not_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  /** All values in which the union is empty */
  componentBackground_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  componentBackground_some?: InputMaybe<GenericCardCarouseComponentComponentBackgroundWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  /** All values in which the union is empty */
  dictionaryItem_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  dictionaryItem_some?: InputMaybe<GenericCardCarouseComponentDictionaryItemWhereInput>;
  documentInStages_every?: InputMaybe<GenericCardCarouseComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericCardCarouseComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericCardCarouseComponentWhereStageInput>;
  extension?: InputMaybe<AlgoliaExtensionWhereInput>;
  /** All values in which the union is empty */
  floatingObject_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  floatingObject_some?: InputMaybe<GenericCardLayoutComponentFloatingObjectWhereInput>;
  formSuccessComponents_every?: InputMaybe<FormSuccessComponentWhereInput>;
  formSuccessComponents_none?: InputMaybe<FormSuccessComponentWhereInput>;
  formSuccessComponents_some?: InputMaybe<FormSuccessComponentWhereInput>;
  /** All values in which the union is connected to the given models */
  genericCardCarouselCta?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaWhereInput>;
  /** All values in which the union is empty */
  genericCardCarouselCta_empty?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  pointCtaToArticlesList?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  pointCtaToArticlesList_not?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  products_every?: InputMaybe<ProductWhereInput>;
  products_none?: InputMaybe<ProductWhereInput>;
  products_some?: InputMaybe<ProductWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericCardCarouseComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericCardCarouseComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericCardCarouseComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericCardCarouseComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericCardCarouseComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericCardCarouseComponent record uniquely */
export type GenericCardCarouseComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type GenericCardLayoutComponentFloatingObject = AssetComponent;

export type GenericCardLayoutComponentFloatingObjectConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type GenericCardLayoutComponentFloatingObjectCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type GenericCardLayoutComponentFloatingObjectCreateManyInlineInput = {
  /** Connect multiple existing GenericCardLayoutComponentFloatingObject documents */
  connect?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectWhereUniqueInput>>;
  /** Create and connect multiple existing GenericCardLayoutComponentFloatingObject documents */
  create?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectCreateInput>>;
};

export type GenericCardLayoutComponentFloatingObjectCreateOneInlineInput = {
  /** Connect one existing GenericCardLayoutComponentFloatingObject document */
  connect?: InputMaybe<GenericCardLayoutComponentFloatingObjectWhereUniqueInput>;
  /** Create and connect one GenericCardLayoutComponentFloatingObject document */
  create?: InputMaybe<GenericCardLayoutComponentFloatingObjectCreateInput>;
};

export type GenericCardLayoutComponentFloatingObjectUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type GenericCardLayoutComponentFloatingObjectUpdateManyInlineInput = {
  /** Connect multiple existing GenericCardLayoutComponentFloatingObject documents */
  connect?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectConnectInput>>;
  /** Create and connect multiple GenericCardLayoutComponentFloatingObject documents */
  create?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectCreateInput>>;
  /** Delete multiple GenericCardLayoutComponentFloatingObject documents */
  delete?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectWhereUniqueInput>>;
  /** Disconnect multiple GenericCardLayoutComponentFloatingObject documents */
  disconnect?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericCardLayoutComponentFloatingObject documents */
  set?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectWhereUniqueInput>>;
  /** Update multiple GenericCardLayoutComponentFloatingObject documents */
  update?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericCardLayoutComponentFloatingObject documents */
  upsert?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectUpsertWithNestedWhereUniqueInput>>;
};

export type GenericCardLayoutComponentFloatingObjectUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type GenericCardLayoutComponentFloatingObjectUpdateOneInlineInput = {
  /** Connect existing GenericCardLayoutComponentFloatingObject document */
  connect?: InputMaybe<GenericCardLayoutComponentFloatingObjectWhereUniqueInput>;
  /** Create and connect one GenericCardLayoutComponentFloatingObject document */
  create?: InputMaybe<GenericCardLayoutComponentFloatingObjectCreateInput>;
  /** Delete currently connected GenericCardLayoutComponentFloatingObject document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericCardLayoutComponentFloatingObject document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericCardLayoutComponentFloatingObject document */
  update?: InputMaybe<GenericCardLayoutComponentFloatingObjectUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericCardLayoutComponentFloatingObject document */
  upsert?: InputMaybe<GenericCardLayoutComponentFloatingObjectUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardLayoutComponentFloatingObjectUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type GenericCardLayoutComponentFloatingObjectUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardLayoutComponentFloatingObjectWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type GenericCardLayoutComponentFloatingObjectWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponent = Entity & Node & {
  __typename?: 'GenericDownloadComponent';
  anchorNav?: Maybe<AnchorNavigation>;
  /** Image associated to the downloadable asset */
  assetComponent?: Maybe<AssetComponent>;
  /** main content of the component  */
  body: Scalars['String']['output'];
  /** just a name to identify a particular generic download component  */
  cmsTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericDownloadComponent>;
  /** A downloadable file that can be downloaded on click of download button in generic download component (file can be pdf or image) */
  downloadableFile: Asset;
  genericPages: Array<GenericPage>;
  /** List of GenericDownloadComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  /** A short single line introduction of the asset that is available for download */
  superText: Scalars['String']['output'];
  tabContent?: Maybe<TabContent>;
  /** A short headline about the content written in body of the component  */
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentAssetComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentDownloadableFileArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericDownloadComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericDownloadComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericDownloadComponentConnection = {
  __typename?: 'GenericDownloadComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericDownloadComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericDownloadComponentCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  assetComponent?: InputMaybe<AssetComponentCreateOneInlineInput>;
  body: Scalars['String']['input'];
  cmsTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadableFile: AssetCreateOneInlineInput;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  superText: Scalars['String']['input'];
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericDownloadComponentCreateManyInlineInput = {
  /** Connect multiple existing GenericDownloadComponent documents */
  connect?: InputMaybe<Array<GenericDownloadComponentWhereUniqueInput>>;
  /** Create and connect multiple existing GenericDownloadComponent documents */
  create?: InputMaybe<Array<GenericDownloadComponentCreateInput>>;
};

export type GenericDownloadComponentCreateOneInlineInput = {
  /** Connect one existing GenericDownloadComponent document */
  connect?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  /** Create and connect one GenericDownloadComponent document */
  create?: InputMaybe<GenericDownloadComponentCreateInput>;
};

/** An edge in a connection. */
export type GenericDownloadComponentEdge = {
  __typename?: 'GenericDownloadComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericDownloadComponent;
};

/** Identifies documents */
export type GenericDownloadComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericDownloadComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericDownloadComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericDownloadComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  assetComponent?: InputMaybe<AssetComponentWhereInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericDownloadComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericDownloadComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericDownloadComponentWhereStageInput>;
  downloadableFile?: InputMaybe<AssetWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericDownloadComponentOrderByInput {
  body_ASC = 'body_ASC',
  body_DESC = 'body_DESC',
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericDownloadComponentUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  assetComponent?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  downloadableFile?: InputMaybe<AssetUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericDownloadComponentUpdateManyInlineInput = {
  /** Connect multiple existing GenericDownloadComponent documents */
  connect?: InputMaybe<Array<GenericDownloadComponentConnectInput>>;
  /** Create and connect multiple GenericDownloadComponent documents */
  create?: InputMaybe<Array<GenericDownloadComponentCreateInput>>;
  /** Delete multiple GenericDownloadComponent documents */
  delete?: InputMaybe<Array<GenericDownloadComponentWhereUniqueInput>>;
  /** Disconnect multiple GenericDownloadComponent documents */
  disconnect?: InputMaybe<Array<GenericDownloadComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericDownloadComponent documents */
  set?: InputMaybe<Array<GenericDownloadComponentWhereUniqueInput>>;
  /** Update multiple GenericDownloadComponent documents */
  update?: InputMaybe<Array<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericDownloadComponent documents */
  upsert?: InputMaybe<Array<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>>;
};

export type GenericDownloadComponentUpdateManyInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericDownloadComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericDownloadComponentUpdateManyInput;
  /** Document search */
  where: GenericDownloadComponentWhereInput;
};

export type GenericDownloadComponentUpdateOneInlineInput = {
  /** Connect existing GenericDownloadComponent document */
  connect?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  /** Create and connect one GenericDownloadComponent document */
  create?: InputMaybe<GenericDownloadComponentCreateInput>;
  /** Delete currently connected GenericDownloadComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericDownloadComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericDownloadComponent document */
  update?: InputMaybe<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericDownloadComponent document */
  upsert?: InputMaybe<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>;
};

export type GenericDownloadComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericDownloadComponentUpdateInput;
  /** Unique document search */
  where: GenericDownloadComponentWhereUniqueInput;
};

export type GenericDownloadComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericDownloadComponentCreateInput;
  /** Update document if it exists */
  update: GenericDownloadComponentUpdateInput;
};

export type GenericDownloadComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericDownloadComponentUpsertInput;
  /** Unique document search */
  where: GenericDownloadComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericDownloadComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericDownloadComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericDownloadComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericDownloadComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericDownloadComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  assetComponent?: InputMaybe<AssetComponentWhereInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericDownloadComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericDownloadComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericDownloadComponentWhereStageInput>;
  downloadableFile?: InputMaybe<AssetWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericDownloadComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericDownloadComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericDownloadComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericDownloadComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericDownloadComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericDownloadComponent record uniquely */
export type GenericDownloadComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericFollowUs = Entity & Node & {
  __typename?: 'GenericFollowUs';
  anchorNav?: Maybe<AnchorNavigation>;
  backgroundImage?: Maybe<AssetComponent>;
  cmsTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericFollowUs>;
  foregroundImage?: Maybe<AssetComponent>;
  genericPages: Array<GenericPage>;
  /** List of GenericFollowUs versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  middlegroundImage?: Maybe<AssetComponent>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  socialMedia: Array<SocialMediaListComponent>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  super?: Maybe<Scalars['String']['output']>;
  tabContent?: Maybe<TabContent>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericFollowUsAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericFollowUsBackgroundImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericFollowUsCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericFollowUsDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericFollowUsForegroundImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericFollowUsGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GenericFollowUsHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericFollowUsMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericFollowUsMiddlegroundImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericFollowUsProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


export type GenericFollowUsProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


export type GenericFollowUsProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


export type GenericFollowUsPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericFollowUsRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type GenericFollowUsRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


export type GenericFollowUsRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


export type GenericFollowUsScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericFollowUsSocialMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SocialMediaListComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SocialMediaListComponentWhereInput>;
};


export type GenericFollowUsSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericFollowUsTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericFollowUsUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericFollowUsConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericFollowUsWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericFollowUsConnection = {
  __typename?: 'GenericFollowUsConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericFollowUsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericFollowUsCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  backgroundImage?: InputMaybe<AssetComponentCreateOneInlineInput>;
  cks7hpil20shj01yzh91s3tt2?: InputMaybe<RecipeCreateManyInlineInput>;
  cmsTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  foregroundImage?: InputMaybe<AssetComponentCreateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  middlegroundImage?: InputMaybe<AssetComponentCreateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  socialMedia?: InputMaybe<SocialMediaListComponentCreateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  super?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericFollowUsCreateManyInlineInput = {
  /** Connect multiple existing GenericFollowUs documents */
  connect?: InputMaybe<Array<GenericFollowUsWhereUniqueInput>>;
  /** Create and connect multiple existing GenericFollowUs documents */
  create?: InputMaybe<Array<GenericFollowUsCreateInput>>;
};

export type GenericFollowUsCreateOneInlineInput = {
  /** Connect one existing GenericFollowUs document */
  connect?: InputMaybe<GenericFollowUsWhereUniqueInput>;
  /** Create and connect one GenericFollowUs document */
  create?: InputMaybe<GenericFollowUsCreateInput>;
};

/** An edge in a connection. */
export type GenericFollowUsEdge = {
  __typename?: 'GenericFollowUsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericFollowUs;
};

/** Identifies documents */
export type GenericFollowUsManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericFollowUsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericFollowUsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericFollowUsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundImage?: InputMaybe<AssetComponentWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericFollowUsWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericFollowUsWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericFollowUsWhereStageInput>;
  foregroundImage?: InputMaybe<AssetComponentWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  middlegroundImage?: InputMaybe<AssetComponentWhereInput>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  socialMedia_every?: InputMaybe<SocialMediaListComponentWhereInput>;
  socialMedia_none?: InputMaybe<SocialMediaListComponentWhereInput>;
  socialMedia_some?: InputMaybe<SocialMediaListComponentWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  super?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  super_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  super_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  super_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  super_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  super_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  super_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  super_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  super_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  super_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericFollowUsOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  super_ASC = 'super_ASC',
  super_DESC = 'super_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericFollowUsUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  backgroundImage?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  cks7hpil20shj01yzh91s3tt2?: InputMaybe<RecipeUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  foregroundImage?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  middlegroundImage?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  socialMedia?: InputMaybe<SocialMediaListComponentUpdateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  super?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericFollowUsUpdateManyInlineInput = {
  /** Connect multiple existing GenericFollowUs documents */
  connect?: InputMaybe<Array<GenericFollowUsConnectInput>>;
  /** Create and connect multiple GenericFollowUs documents */
  create?: InputMaybe<Array<GenericFollowUsCreateInput>>;
  /** Delete multiple GenericFollowUs documents */
  delete?: InputMaybe<Array<GenericFollowUsWhereUniqueInput>>;
  /** Disconnect multiple GenericFollowUs documents */
  disconnect?: InputMaybe<Array<GenericFollowUsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericFollowUs documents */
  set?: InputMaybe<Array<GenericFollowUsWhereUniqueInput>>;
  /** Update multiple GenericFollowUs documents */
  update?: InputMaybe<Array<GenericFollowUsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericFollowUs documents */
  upsert?: InputMaybe<Array<GenericFollowUsUpsertWithNestedWhereUniqueInput>>;
};

export type GenericFollowUsUpdateManyInput = {
  super?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericFollowUsUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericFollowUsUpdateManyInput;
  /** Document search */
  where: GenericFollowUsWhereInput;
};

export type GenericFollowUsUpdateOneInlineInput = {
  /** Connect existing GenericFollowUs document */
  connect?: InputMaybe<GenericFollowUsWhereUniqueInput>;
  /** Create and connect one GenericFollowUs document */
  create?: InputMaybe<GenericFollowUsCreateInput>;
  /** Delete currently connected GenericFollowUs document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericFollowUs document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericFollowUs document */
  update?: InputMaybe<GenericFollowUsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericFollowUs document */
  upsert?: InputMaybe<GenericFollowUsUpsertWithNestedWhereUniqueInput>;
};

export type GenericFollowUsUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericFollowUsUpdateInput;
  /** Unique document search */
  where: GenericFollowUsWhereUniqueInput;
};

export type GenericFollowUsUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericFollowUsCreateInput;
  /** Update document if it exists */
  update: GenericFollowUsUpdateInput;
};

export type GenericFollowUsUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericFollowUsUpsertInput;
  /** Unique document search */
  where: GenericFollowUsWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericFollowUsWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericFollowUsWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericFollowUsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericFollowUsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericFollowUsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundImage?: InputMaybe<AssetComponentWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericFollowUsWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericFollowUsWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericFollowUsWhereStageInput>;
  foregroundImage?: InputMaybe<AssetComponentWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  middlegroundImage?: InputMaybe<AssetComponentWhereInput>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  socialMedia_every?: InputMaybe<SocialMediaListComponentWhereInput>;
  socialMedia_none?: InputMaybe<SocialMediaListComponentWhereInput>;
  socialMedia_some?: InputMaybe<SocialMediaListComponentWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  super?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  super_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  super_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  super_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  super_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  super_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  super_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  super_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  super_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  super_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericFollowUsWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericFollowUsWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericFollowUsWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericFollowUsWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericFollowUsWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericFollowUs record uniquely */
export type GenericFollowUsWhereUniqueInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
};

/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorable = Entity & Node & {
  __typename?: 'GenericGridAuthorable';
  cards: Array<GenericGridAuthorableCards>;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  dictionary?: Maybe<Dictionary>;
  /** Get the document in other stages */
  documentInStages: Array<GenericGridAuthorable>;
  formSuccessComponents: Array<FormSuccessComponent>;
  genericPages: Array<GenericPage>;
  /** List of GenericGridAuthorable versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Implement ItemList mark up for this component with Microdata to enable recipe carousel view in Google search results. */
  recipeCarouselMarkUp: Scalars['Boolean']['output'];
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  regularLayout?: Maybe<Scalars['Boolean']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Max character count 25 */
  superText?: Maybe<Scalars['String']['output']>;
  /** Max character count 40 */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableDictionaryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableFormSuccessComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSuccessComponentWhereInput>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorablePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericGridAuthorableCards = AuthorableContentCard | FeaturedContentReference;

export type GenericGridAuthorableCardsConnectInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardConnectInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceConnectInput>;
};

export type GenericGridAuthorableCardsCreateInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardCreateInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceCreateInput>;
};

export type GenericGridAuthorableCardsCreateManyInlineInput = {
  /** Connect multiple existing GenericGridAuthorableCards documents */
  connect?: InputMaybe<Array<GenericGridAuthorableCardsWhereUniqueInput>>;
  /** Create and connect multiple existing GenericGridAuthorableCards documents */
  create?: InputMaybe<Array<GenericGridAuthorableCardsCreateInput>>;
};

export type GenericGridAuthorableCardsCreateOneInlineInput = {
  /** Connect one existing GenericGridAuthorableCards document */
  connect?: InputMaybe<GenericGridAuthorableCardsWhereUniqueInput>;
  /** Create and connect one GenericGridAuthorableCards document */
  create?: InputMaybe<GenericGridAuthorableCardsCreateInput>;
};

export type GenericGridAuthorableCardsUpdateInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceUpdateInput>;
};

export type GenericGridAuthorableCardsUpdateManyInlineInput = {
  /** Connect multiple existing GenericGridAuthorableCards documents */
  connect?: InputMaybe<Array<GenericGridAuthorableCardsConnectInput>>;
  /** Create and connect multiple GenericGridAuthorableCards documents */
  create?: InputMaybe<Array<GenericGridAuthorableCardsCreateInput>>;
  /** Delete multiple GenericGridAuthorableCards documents */
  delete?: InputMaybe<Array<GenericGridAuthorableCardsWhereUniqueInput>>;
  /** Disconnect multiple GenericGridAuthorableCards documents */
  disconnect?: InputMaybe<Array<GenericGridAuthorableCardsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericGridAuthorableCards documents */
  set?: InputMaybe<Array<GenericGridAuthorableCardsWhereUniqueInput>>;
  /** Update multiple GenericGridAuthorableCards documents */
  update?: InputMaybe<Array<GenericGridAuthorableCardsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericGridAuthorableCards documents */
  upsert?: InputMaybe<Array<GenericGridAuthorableCardsUpsertWithNestedWhereUniqueInput>>;
};

export type GenericGridAuthorableCardsUpdateManyWithNestedWhereInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateManyWithNestedWhereInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceUpdateManyWithNestedWhereInput>;
};

export type GenericGridAuthorableCardsUpdateOneInlineInput = {
  /** Connect existing GenericGridAuthorableCards document */
  connect?: InputMaybe<GenericGridAuthorableCardsWhereUniqueInput>;
  /** Create and connect one GenericGridAuthorableCards document */
  create?: InputMaybe<GenericGridAuthorableCardsCreateInput>;
  /** Delete currently connected GenericGridAuthorableCards document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericGridAuthorableCards document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericGridAuthorableCards document */
  update?: InputMaybe<GenericGridAuthorableCardsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericGridAuthorableCards document */
  upsert?: InputMaybe<GenericGridAuthorableCardsUpsertWithNestedWhereUniqueInput>;
};

export type GenericGridAuthorableCardsUpdateWithNestedWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateWithNestedWhereUniqueInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceUpdateWithNestedWhereUniqueInput>;
};

export type GenericGridAuthorableCardsUpsertWithNestedWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpsertWithNestedWhereUniqueInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceUpsertWithNestedWhereUniqueInput>;
};

export type GenericGridAuthorableCardsWhereInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceWhereInput>;
};

export type GenericGridAuthorableCardsWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereUniqueInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceWhereUniqueInput>;
};

export type GenericGridAuthorableConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericGridAuthorableWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericGridAuthorableConnection = {
  __typename?: 'GenericGridAuthorableConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericGridAuthorableEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericGridAuthorableCreateInput = {
  cards?: InputMaybe<GenericGridAuthorableCardsCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionary?: InputMaybe<DictionaryCreateOneInlineInput>;
  formSuccessComponents?: InputMaybe<FormSuccessComponentCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCarouselMarkUp: Scalars['Boolean']['input'];
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  regularLayout?: InputMaybe<Scalars['Boolean']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericGridAuthorableCreateManyInlineInput = {
  /** Connect multiple existing GenericGridAuthorable documents */
  connect?: InputMaybe<Array<GenericGridAuthorableWhereUniqueInput>>;
  /** Create and connect multiple existing GenericGridAuthorable documents */
  create?: InputMaybe<Array<GenericGridAuthorableCreateInput>>;
};

export type GenericGridAuthorableCreateOneInlineInput = {
  /** Connect one existing GenericGridAuthorable document */
  connect?: InputMaybe<GenericGridAuthorableWhereUniqueInput>;
  /** Create and connect one GenericGridAuthorable document */
  create?: InputMaybe<GenericGridAuthorableCreateInput>;
};

/** An edge in a connection. */
export type GenericGridAuthorableEdge = {
  __typename?: 'GenericGridAuthorableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericGridAuthorable;
};

/** Identifies documents */
export type GenericGridAuthorableManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericGridAuthorableWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericGridAuthorableWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericGridAuthorableWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  cards_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  cards_some?: InputMaybe<GenericGridAuthorableCardsWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionary?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<GenericGridAuthorableWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericGridAuthorableWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericGridAuthorableWhereStageInput>;
  formSuccessComponents_every?: InputMaybe<FormSuccessComponentWhereInput>;
  formSuccessComponents_none?: InputMaybe<FormSuccessComponentWhereInput>;
  formSuccessComponents_some?: InputMaybe<FormSuccessComponentWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCarouselMarkUp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  recipeCarouselMarkUp_not?: InputMaybe<Scalars['Boolean']['input']>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  regularLayout?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  regularLayout_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericGridAuthorableOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  recipeCarouselMarkUp_ASC = 'recipeCarouselMarkUp_ASC',
  recipeCarouselMarkUp_DESC = 'recipeCarouselMarkUp_DESC',
  regularLayout_ASC = 'regularLayout_ASC',
  regularLayout_DESC = 'regularLayout_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericGridAuthorableUpdateInput = {
  cards?: InputMaybe<GenericGridAuthorableCardsUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  dictionary?: InputMaybe<DictionaryUpdateOneInlineInput>;
  formSuccessComponents?: InputMaybe<FormSuccessComponentUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCarouselMarkUp?: InputMaybe<Scalars['Boolean']['input']>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  regularLayout?: InputMaybe<Scalars['Boolean']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericGridAuthorableUpdateManyInlineInput = {
  /** Connect multiple existing GenericGridAuthorable documents */
  connect?: InputMaybe<Array<GenericGridAuthorableConnectInput>>;
  /** Create and connect multiple GenericGridAuthorable documents */
  create?: InputMaybe<Array<GenericGridAuthorableCreateInput>>;
  /** Delete multiple GenericGridAuthorable documents */
  delete?: InputMaybe<Array<GenericGridAuthorableWhereUniqueInput>>;
  /** Disconnect multiple GenericGridAuthorable documents */
  disconnect?: InputMaybe<Array<GenericGridAuthorableWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericGridAuthorable documents */
  set?: InputMaybe<Array<GenericGridAuthorableWhereUniqueInput>>;
  /** Update multiple GenericGridAuthorable documents */
  update?: InputMaybe<Array<GenericGridAuthorableUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericGridAuthorable documents */
  upsert?: InputMaybe<Array<GenericGridAuthorableUpsertWithNestedWhereUniqueInput>>;
};

export type GenericGridAuthorableUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  recipeCarouselMarkUp?: InputMaybe<Scalars['Boolean']['input']>;
  regularLayout?: InputMaybe<Scalars['Boolean']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericGridAuthorableUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericGridAuthorableUpdateManyInput;
  /** Document search */
  where: GenericGridAuthorableWhereInput;
};

export type GenericGridAuthorableUpdateOneInlineInput = {
  /** Connect existing GenericGridAuthorable document */
  connect?: InputMaybe<GenericGridAuthorableWhereUniqueInput>;
  /** Create and connect one GenericGridAuthorable document */
  create?: InputMaybe<GenericGridAuthorableCreateInput>;
  /** Delete currently connected GenericGridAuthorable document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericGridAuthorable document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericGridAuthorable document */
  update?: InputMaybe<GenericGridAuthorableUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericGridAuthorable document */
  upsert?: InputMaybe<GenericGridAuthorableUpsertWithNestedWhereUniqueInput>;
};

export type GenericGridAuthorableUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericGridAuthorableUpdateInput;
  /** Unique document search */
  where: GenericGridAuthorableWhereUniqueInput;
};

export type GenericGridAuthorableUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericGridAuthorableCreateInput;
  /** Update document if it exists */
  update: GenericGridAuthorableUpdateInput;
};

export type GenericGridAuthorableUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericGridAuthorableUpsertInput;
  /** Unique document search */
  where: GenericGridAuthorableWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericGridAuthorableWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericGridAuthorableWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericGridAuthorableWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericGridAuthorableWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericGridAuthorableWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  cards_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  cards_some?: InputMaybe<GenericGridAuthorableCardsWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionary?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<GenericGridAuthorableWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericGridAuthorableWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericGridAuthorableWhereStageInput>;
  formSuccessComponents_every?: InputMaybe<FormSuccessComponentWhereInput>;
  formSuccessComponents_none?: InputMaybe<FormSuccessComponentWhereInput>;
  formSuccessComponents_some?: InputMaybe<FormSuccessComponentWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCarouselMarkUp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  recipeCarouselMarkUp_not?: InputMaybe<Scalars['Boolean']['input']>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  regularLayout?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  regularLayout_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericGridAuthorableWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericGridAuthorableWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericGridAuthorableWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericGridAuthorableWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericGridAuthorableWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericGridAuthorable record uniquely */
export type GenericGridAuthorableWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Authors can insert any HTML code in this component */
export type GenericHtml = Entity & Node & {
  __typename?: 'GenericHtml';
  cmsTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericHtml>;
  genericPages: Array<GenericPage>;
  /** List of GenericHtml versions */
  history: Array<Version>;
  html: Scalars['String']['output'];
  /** The unique identifier */
  id: Scalars['ID']['output'];
  marketName?: Maybe<Market>;
  markets: Markets;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Authors can insert any HTML code in this component */
export type GenericHtmlCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Authors can insert any HTML code in this component */
export type GenericHtmlDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Authors can insert any HTML code in this component */
export type GenericHtmlGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Authors can insert any HTML code in this component */
export type GenericHtmlHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Authors can insert any HTML code in this component */
export type GenericHtmlMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Authors can insert any HTML code in this component */
export type GenericHtmlProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


/** Authors can insert any HTML code in this component */
export type GenericHtmlProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


/** Authors can insert any HTML code in this component */
export type GenericHtmlProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


/** Authors can insert any HTML code in this component */
export type GenericHtmlPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Authors can insert any HTML code in this component */
export type GenericHtmlRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


/** Authors can insert any HTML code in this component */
export type GenericHtmlRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


/** Authors can insert any HTML code in this component */
export type GenericHtmlRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


/** Authors can insert any HTML code in this component */
export type GenericHtmlScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Authors can insert any HTML code in this component */
export type GenericHtmlSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Authors can insert any HTML code in this component */
export type GenericHtmlTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Authors can insert any HTML code in this component */
export type GenericHtmlUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericHtmlConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericHtmlWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericHtmlConnection = {
  __typename?: 'GenericHtmlConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericHtmlEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericHtmlCreateInput = {
  cmsTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  html: Scalars['String']['input'];
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  markets: Markets;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericHtmlCreateManyInlineInput = {
  /** Connect multiple existing GenericHtml documents */
  connect?: InputMaybe<Array<GenericHtmlWhereUniqueInput>>;
  /** Create and connect multiple existing GenericHtml documents */
  create?: InputMaybe<Array<GenericHtmlCreateInput>>;
};

export type GenericHtmlCreateOneInlineInput = {
  /** Connect one existing GenericHtml document */
  connect?: InputMaybe<GenericHtmlWhereUniqueInput>;
  /** Create and connect one GenericHtml document */
  create?: InputMaybe<GenericHtmlCreateInput>;
};

/** An edge in a connection. */
export type GenericHtmlEdge = {
  __typename?: 'GenericHtmlEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericHtml;
};

/** Identifies documents */
export type GenericHtmlManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericHtmlWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericHtmlWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericHtmlWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericHtmlWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericHtmlWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericHtmlWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  html?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  html_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  html_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  html_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  html_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  html_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  html_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  html_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  html_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  html_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  marketName?: InputMaybe<MarketWhereInput>;
  markets?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  markets_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  markets_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  markets_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericHtmlOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  html_ASC = 'html_ASC',
  html_DESC = 'html_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  markets_ASC = 'markets_ASC',
  markets_DESC = 'markets_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericHtmlUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  html?: InputMaybe<Scalars['String']['input']>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  markets?: InputMaybe<Markets>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type GenericHtmlUpdateManyInlineInput = {
  /** Connect multiple existing GenericHtml documents */
  connect?: InputMaybe<Array<GenericHtmlConnectInput>>;
  /** Create and connect multiple GenericHtml documents */
  create?: InputMaybe<Array<GenericHtmlCreateInput>>;
  /** Delete multiple GenericHtml documents */
  delete?: InputMaybe<Array<GenericHtmlWhereUniqueInput>>;
  /** Disconnect multiple GenericHtml documents */
  disconnect?: InputMaybe<Array<GenericHtmlWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericHtml documents */
  set?: InputMaybe<Array<GenericHtmlWhereUniqueInput>>;
  /** Update multiple GenericHtml documents */
  update?: InputMaybe<Array<GenericHtmlUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericHtml documents */
  upsert?: InputMaybe<Array<GenericHtmlUpsertWithNestedWhereUniqueInput>>;
};

export type GenericHtmlUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  markets?: InputMaybe<Markets>;
};

export type GenericHtmlUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericHtmlUpdateManyInput;
  /** Document search */
  where: GenericHtmlWhereInput;
};

export type GenericHtmlUpdateOneInlineInput = {
  /** Connect existing GenericHtml document */
  connect?: InputMaybe<GenericHtmlWhereUniqueInput>;
  /** Create and connect one GenericHtml document */
  create?: InputMaybe<GenericHtmlCreateInput>;
  /** Delete currently connected GenericHtml document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericHtml document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericHtml document */
  update?: InputMaybe<GenericHtmlUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericHtml document */
  upsert?: InputMaybe<GenericHtmlUpsertWithNestedWhereUniqueInput>;
};

export type GenericHtmlUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericHtmlUpdateInput;
  /** Unique document search */
  where: GenericHtmlWhereUniqueInput;
};

export type GenericHtmlUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericHtmlCreateInput;
  /** Update document if it exists */
  update: GenericHtmlUpdateInput;
};

export type GenericHtmlUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericHtmlUpsertInput;
  /** Unique document search */
  where: GenericHtmlWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericHtmlWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericHtmlWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericHtmlWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericHtmlWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericHtmlWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericHtmlWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericHtmlWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericHtmlWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  html?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  html_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  html_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  html_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  html_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  html_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  html_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  html_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  html_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  html_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  marketName?: InputMaybe<MarketWhereInput>;
  markets?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  markets_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  markets_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  markets_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericHtmlWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericHtmlWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericHtmlWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericHtmlWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericHtmlWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericHtml record uniquely */
export type GenericHtmlWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericLine = Entity & Node & {
  __typename?: 'GenericLine';
  /** Title to be identified in the cms when searching content. */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericLine>;
  /** Add a line to a page by enabling this component */
  enableLine?: Maybe<Scalars['Boolean']['output']>;
  genericPages: Array<GenericPage>;
  /** List of GenericLine versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericLineCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericLineDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericLineGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GenericLineHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericLineMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericLinePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericLineScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericLineSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericLineTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericLineUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericLineConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericLineWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericLineConnection = {
  __typename?: 'GenericLineConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericLineEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericLineCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enableLine?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericLineCreateManyInlineInput = {
  /** Connect multiple existing GenericLine documents */
  connect?: InputMaybe<Array<GenericLineWhereUniqueInput>>;
  /** Create and connect multiple existing GenericLine documents */
  create?: InputMaybe<Array<GenericLineCreateInput>>;
};

export type GenericLineCreateOneInlineInput = {
  /** Connect one existing GenericLine document */
  connect?: InputMaybe<GenericLineWhereUniqueInput>;
  /** Create and connect one GenericLine document */
  create?: InputMaybe<GenericLineCreateInput>;
};

/** An edge in a connection. */
export type GenericLineEdge = {
  __typename?: 'GenericLineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericLine;
};

/** Identifies documents */
export type GenericLineManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericLineWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericLineWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericLineWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericLineWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericLineWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericLineWhereStageInput>;
  enableLine?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  enableLine_not?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericLineOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  enableLine_ASC = 'enableLine_ASC',
  enableLine_DESC = 'enableLine_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericLineUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  enableLine?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type GenericLineUpdateManyInlineInput = {
  /** Connect multiple existing GenericLine documents */
  connect?: InputMaybe<Array<GenericLineConnectInput>>;
  /** Create and connect multiple GenericLine documents */
  create?: InputMaybe<Array<GenericLineCreateInput>>;
  /** Delete multiple GenericLine documents */
  delete?: InputMaybe<Array<GenericLineWhereUniqueInput>>;
  /** Disconnect multiple GenericLine documents */
  disconnect?: InputMaybe<Array<GenericLineWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericLine documents */
  set?: InputMaybe<Array<GenericLineWhereUniqueInput>>;
  /** Update multiple GenericLine documents */
  update?: InputMaybe<Array<GenericLineUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericLine documents */
  upsert?: InputMaybe<Array<GenericLineUpsertWithNestedWhereUniqueInput>>;
};

export type GenericLineUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  enableLine?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
};

export type GenericLineUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericLineUpdateManyInput;
  /** Document search */
  where: GenericLineWhereInput;
};

export type GenericLineUpdateOneInlineInput = {
  /** Connect existing GenericLine document */
  connect?: InputMaybe<GenericLineWhereUniqueInput>;
  /** Create and connect one GenericLine document */
  create?: InputMaybe<GenericLineCreateInput>;
  /** Delete currently connected GenericLine document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericLine document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericLine document */
  update?: InputMaybe<GenericLineUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericLine document */
  upsert?: InputMaybe<GenericLineUpsertWithNestedWhereUniqueInput>;
};

export type GenericLineUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericLineUpdateInput;
  /** Unique document search */
  where: GenericLineWhereUniqueInput;
};

export type GenericLineUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericLineCreateInput;
  /** Update document if it exists */
  update: GenericLineUpdateInput;
};

export type GenericLineUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericLineUpsertInput;
  /** Unique document search */
  where: GenericLineWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericLineWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericLineWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericLineWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericLineWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericLineWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericLineWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericLineWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericLineWhereStageInput>;
  enableLine?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  enableLine_not?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericLineWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericLineWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericLineWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericLineWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericLineWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericLine record uniquely */
export type GenericLineWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericLink = Entity & Node & {
  __typename?: 'GenericLink';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericLink>;
  /** List of GenericLink versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericLinkCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericLinkDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericLinkHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericLinkMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericLinkPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericLinkScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericLinkUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericLinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericLinkWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericLinkConnection = {
  __typename?: 'GenericLinkConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericLinkEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericLinkCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  link: Scalars['String']['input'];
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericLinkCreateManyInlineInput = {
  /** Connect multiple existing GenericLink documents */
  connect?: InputMaybe<Array<GenericLinkWhereUniqueInput>>;
  /** Create and connect multiple existing GenericLink documents */
  create?: InputMaybe<Array<GenericLinkCreateInput>>;
};

export type GenericLinkCreateOneInlineInput = {
  /** Connect one existing GenericLink document */
  connect?: InputMaybe<GenericLinkWhereUniqueInput>;
  /** Create and connect one GenericLink document */
  create?: InputMaybe<GenericLinkCreateInput>;
};

/** An edge in a connection. */
export type GenericLinkEdge = {
  __typename?: 'GenericLinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericLink;
};

/** Identifies documents */
export type GenericLinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericLinkWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericLinkWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericLinkWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  link_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  link_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  link_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  link_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  link_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  link_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  link_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericLinkOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  link_ASC = 'link_ASC',
  link_DESC = 'link_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericLinkUpdateInput = {
  link?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
};

export type GenericLinkUpdateManyInlineInput = {
  /** Connect multiple existing GenericLink documents */
  connect?: InputMaybe<Array<GenericLinkConnectInput>>;
  /** Create and connect multiple GenericLink documents */
  create?: InputMaybe<Array<GenericLinkCreateInput>>;
  /** Delete multiple GenericLink documents */
  delete?: InputMaybe<Array<GenericLinkWhereUniqueInput>>;
  /** Disconnect multiple GenericLink documents */
  disconnect?: InputMaybe<Array<GenericLinkWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericLink documents */
  set?: InputMaybe<Array<GenericLinkWhereUniqueInput>>;
  /** Update multiple GenericLink documents */
  update?: InputMaybe<Array<GenericLinkUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericLink documents */
  upsert?: InputMaybe<Array<GenericLinkUpsertWithNestedWhereUniqueInput>>;
};

export type GenericLinkUpdateManyInput = {
  link?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
};

export type GenericLinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericLinkUpdateManyInput;
  /** Document search */
  where: GenericLinkWhereInput;
};

export type GenericLinkUpdateOneInlineInput = {
  /** Connect existing GenericLink document */
  connect?: InputMaybe<GenericLinkWhereUniqueInput>;
  /** Create and connect one GenericLink document */
  create?: InputMaybe<GenericLinkCreateInput>;
  /** Delete currently connected GenericLink document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericLink document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericLink document */
  update?: InputMaybe<GenericLinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericLink document */
  upsert?: InputMaybe<GenericLinkUpsertWithNestedWhereUniqueInput>;
};

export type GenericLinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericLinkUpdateInput;
  /** Unique document search */
  where: GenericLinkWhereUniqueInput;
};

export type GenericLinkUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericLinkCreateInput;
  /** Update document if it exists */
  update: GenericLinkUpdateInput;
};

export type GenericLinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericLinkUpsertInput;
  /** Unique document search */
  where: GenericLinkWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericLinkWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericLinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericLinkWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericLinkWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericLinkWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  link_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  link_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  link_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  link_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  link_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  link_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  link_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericLinkWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericLinkWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericLinkWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericLinkWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericLinkWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericLink record uniquely */
export type GenericLinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericPage = Entity & Node & {
  __typename?: 'GenericPage';
  /** Only applicable to type Product Promotion. Description for card which showing in Promotions Overview component. */
  cardDescription?: Maybe<Scalars['String']['output']>;
  /** Only applicable to type Product Promotion. Image for card which showing in Promotions Overview component. */
  cardImage?: Maybe<AssetComponent>;
  /** Only applicable to type Product Promotion. Title for card which showing in Promotions Overview component. */
  cardTitle?: Maybe<Scalars['String']['output']>;
  /** Content Grouping option to be selected to pass through to the dataLayer value (CG1) */
  contentGroupingTrackingValue?: Maybe<ContentGrouping1>;
  /** Content Grouping options to be selected to pass through to the dataLayer value  (CG2). Note: This field will only show in tracking if a CG1 value has been set. */
  contentGroupingTrackingValues?: Maybe<ContentGrouping2>;
  /** If you need to disable the cookie banner on a page, set this field to 'false'. For example, legal pages. Default value is true. */
  cookieBannerRequired?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  dictionary?: Maybe<Dictionary>;
  /** Get the document in other stages */
  documentInStages: Array<GenericPage>;
  /** Hide Navigation and only show Logo */
  hideNavigation?: Maybe<Scalars['Boolean']['output']>;
  /** List of GenericPage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  isArticle?: Maybe<Scalars['Boolean']['output']>;
  /** If true, the MasterBrands flag will contain link to the slug inserted above. IT SHOULD ONLY BE USED FOR CONTACT US PAGE. */
  isContactUsPage: Scalars['Boolean']['output'];
  link?: Maybe<Link>;
  links: Array<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<GenericPage>;
  market: Markets;
  marketName?: Maybe<Market>;
  metaData?: Maybe<MetaData>;
  /** No more than 50 components */
  pageComponents: Array<GenericPagePageComponents>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Only applicable to type Promotions. Select true to save the answer to each question in the backend. */
  savePromotionAnswers?: Maybe<Scalars['Boolean']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** Only applicable to type Product Promotion. */
  showInPromotionsOverview: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** Add a path here in combination with the page type to show the slug of the page at the specific sub path */
  subPath?: Maybe<Scalars['String']['output']>;
  subTabContent?: Maybe<SubTabContent>;
  teaserPlaceholders: Array<TeaserPlaceholder>;
  teaserSmallPlaceholders: Array<TeaserSmallPlaceholder>;
  /** Changes the colour of background and the colour of some elements. */
  theme?: Maybe<Themes>;
  title: Scalars['String']['output'];
  /** Type of the Generic page, which will affect where the page is rendered on the site. */
  type: GenericPagesTypes;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericPageCardImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericPageCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericPageDictionaryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericPageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericPageLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericPageLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


export type GenericPageLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type GenericPageMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericPageMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericPagePageComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type GenericPagePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericPageSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericPageTeaserPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserPlaceholderWhereInput>;
};


export type GenericPageTeaserSmallPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
};


export type GenericPageUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericPageWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericPageConnection = {
  __typename?: 'GenericPageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericPageCreateInput = {
  cardDescription?: InputMaybe<Scalars['String']['input']>;
  cardImage?: InputMaybe<AssetComponentCreateOneInlineInput>;
  cardTitle?: InputMaybe<Scalars['String']['input']>;
  ckuntpg4l4gcn01z67yt87trx?: InputMaybe<FeaturedContentReferenceCreateManyInlineInput>;
  ckv0ngnv50vy401xv0n2q3dhq?: InputMaybe<GenericCardCarouseComponentCreateManyInlineInput>;
  clziiapaq04w308uj45o42vdm?: InputMaybe<SingleStepPromotionFormCreateManyInlineInput>;
  contentGroupingTrackingValue?: InputMaybe<ContentGrouping1>;
  contentGroupingTrackingValues?: InputMaybe<ContentGrouping2>;
  cookieBannerRequired?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionary?: InputMaybe<DictionaryCreateOneInlineInput>;
  hideNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  isArticle?: InputMaybe<Scalars['Boolean']['input']>;
  isContactUsPage: Scalars['Boolean']['input'];
  link?: InputMaybe<LinkCreateOneInlineInput>;
  links?: InputMaybe<LinkCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<GenericPageCreateLocalizationsInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  metaData?: InputMaybe<MetaDataCreateOneInlineInput>;
  pageComponents?: InputMaybe<GenericPagePageComponentsCreateManyInlineInput>;
  savePromotionAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  showInPromotionsOverview: Scalars['Boolean']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  subPath?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderCreateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderCreateManyInlineInput>;
  /** theme input for default locale (en) */
  theme?: InputMaybe<Themes>;
  title: Scalars['String']['input'];
  type: GenericPagesTypes;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericPageCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  theme?: InputMaybe<Themes>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericPageCreateLocalizationInput = {
  /** Localization input */
  data: GenericPageCreateLocalizationDataInput;
  locale: Locale;
};

export type GenericPageCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<GenericPageCreateLocalizationInput>>;
};

export type GenericPageCreateManyInlineInput = {
  /** Connect multiple existing GenericPage documents */
  connect?: InputMaybe<Array<GenericPageWhereUniqueInput>>;
  /** Create and connect multiple existing GenericPage documents */
  create?: InputMaybe<Array<GenericPageCreateInput>>;
};

export type GenericPageCreateOneInlineInput = {
  /** Connect one existing GenericPage document */
  connect?: InputMaybe<GenericPageWhereUniqueInput>;
  /** Create and connect one GenericPage document */
  create?: InputMaybe<GenericPageCreateInput>;
};

/** An edge in a connection. */
export type GenericPageEdge = {
  __typename?: 'GenericPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericPage;
};

/** Identifies documents */
export type GenericPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardImage?: InputMaybe<AssetComponentWhereInput>;
  cardTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  contentGroupingTrackingValue?: InputMaybe<ContentGrouping1>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValue_in?: InputMaybe<Array<InputMaybe<ContentGrouping1>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValue_not?: InputMaybe<ContentGrouping1>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValue_not_in?: InputMaybe<Array<InputMaybe<ContentGrouping1>>>;
  contentGroupingTrackingValues?: InputMaybe<ContentGrouping2>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValues_in?: InputMaybe<Array<InputMaybe<ContentGrouping2>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValues_not?: InputMaybe<ContentGrouping2>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValues_not_in?: InputMaybe<Array<InputMaybe<ContentGrouping2>>>;
  cookieBannerRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  cookieBannerRequired_not?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionary?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<GenericPageWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericPageWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericPageWhereStageInput>;
  hideNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hideNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isArticle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isArticle_not?: InputMaybe<Scalars['Boolean']['input']>;
  isContactUsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isContactUsPage_not?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<GenericPagePageComponentsWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  savePromotionAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  savePromotionAnswers_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showInPromotionsOverview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showInPromotionsOverview_not?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  subPath?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subPath_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subPath_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subPath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subPath_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subPath_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subPath_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subPath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subPath_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subPath_starts_with?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GenericPagesTypes>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<GenericPagesTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<GenericPagesTypes>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<GenericPagesTypes>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericPageOrderByInput {
  cardDescription_ASC = 'cardDescription_ASC',
  cardDescription_DESC = 'cardDescription_DESC',
  cardTitle_ASC = 'cardTitle_ASC',
  cardTitle_DESC = 'cardTitle_DESC',
  contentGroupingTrackingValue_ASC = 'contentGroupingTrackingValue_ASC',
  contentGroupingTrackingValue_DESC = 'contentGroupingTrackingValue_DESC',
  contentGroupingTrackingValues_ASC = 'contentGroupingTrackingValues_ASC',
  contentGroupingTrackingValues_DESC = 'contentGroupingTrackingValues_DESC',
  cookieBannerRequired_ASC = 'cookieBannerRequired_ASC',
  cookieBannerRequired_DESC = 'cookieBannerRequired_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  hideNavigation_ASC = 'hideNavigation_ASC',
  hideNavigation_DESC = 'hideNavigation_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isArticle_ASC = 'isArticle_ASC',
  isArticle_DESC = 'isArticle_DESC',
  isContactUsPage_ASC = 'isContactUsPage_ASC',
  isContactUsPage_DESC = 'isContactUsPage_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  savePromotionAnswers_ASC = 'savePromotionAnswers_ASC',
  savePromotionAnswers_DESC = 'savePromotionAnswers_DESC',
  showInPromotionsOverview_ASC = 'showInPromotionsOverview_ASC',
  showInPromotionsOverview_DESC = 'showInPromotionsOverview_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  subPath_ASC = 'subPath_ASC',
  subPath_DESC = 'subPath_DESC',
  theme_ASC = 'theme_ASC',
  theme_DESC = 'theme_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericPagePageComponents = AnchorNav | AnchorNavigationList | AudioComponent | AuthorableContentCard | Banner1 | Banner2 | Banner2CarouselComponent | CarouselComponent | ContactCardContainer | DynamicCardGrid | EvalancheFormComponent | ExampleComponent | FeaturedContent | Form | GenericAccordion | GenericAccordionTopRated | GenericCardCarouseComponent | GenericDownloadComponent | GenericFollowUs | GenericGridAuthorable | GenericHtml | GenericLine | GenericPromotionsOverview | GenericQualifio | GenericQualifioOverview | GenericSocialShare | GlobalSearch | GridColumn | GridColumnComponent | HeroCarouselComponent | HeroComponent | HeroLoopAnimationComponent | Iframe | ImageCopy | IntroText | Link | LongText | MultiStepPromotionForm | NewsletterComponent | PageFooter | PageHeader | ProductBanner | Question | Separator | Spacer | Tab | TestComponentWithRecipeQuery;

export type GenericPagePageComponentsConnectInput = {
  AnchorNav?: InputMaybe<AnchorNavConnectInput>;
  AnchorNavigationList?: InputMaybe<AnchorNavigationListConnectInput>;
  AudioComponent?: InputMaybe<AudioComponentConnectInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardConnectInput>;
  Banner1?: InputMaybe<Banner1ConnectInput>;
  Banner2?: InputMaybe<Banner2ConnectInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentConnectInput>;
  CarouselComponent?: InputMaybe<CarouselComponentConnectInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerConnectInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridConnectInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentConnectInput>;
  ExampleComponent?: InputMaybe<ExampleComponentConnectInput>;
  FeaturedContent?: InputMaybe<FeaturedContentConnectInput>;
  Form?: InputMaybe<FormConnectInput>;
  GenericAccordion?: InputMaybe<GenericAccordionConnectInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedConnectInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentConnectInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentConnectInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsConnectInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableConnectInput>;
  GenericHtml?: InputMaybe<GenericHtmlConnectInput>;
  GenericLine?: InputMaybe<GenericLineConnectInput>;
  GenericPromotionsOverview?: InputMaybe<GenericPromotionsOverviewConnectInput>;
  GenericQualifio?: InputMaybe<GenericQualifioConnectInput>;
  GenericQualifioOverview?: InputMaybe<GenericQualifioOverviewConnectInput>;
  GenericSocialShare?: InputMaybe<GenericSocialShareConnectInput>;
  GlobalSearch?: InputMaybe<GlobalSearchConnectInput>;
  GridColumn?: InputMaybe<GridColumnConnectInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentConnectInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentConnectInput>;
  HeroComponent?: InputMaybe<HeroComponentConnectInput>;
  HeroLoopAnimationComponent?: InputMaybe<HeroLoopAnimationComponentConnectInput>;
  Iframe?: InputMaybe<IframeConnectInput>;
  ImageCopy?: InputMaybe<ImageCopyConnectInput>;
  IntroText?: InputMaybe<IntroTextConnectInput>;
  Link?: InputMaybe<LinkConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormConnectInput>;
  NewsletterComponent?: InputMaybe<NewsletterComponentConnectInput>;
  PageFooter?: InputMaybe<PageFooterConnectInput>;
  PageHeader?: InputMaybe<PageHeaderConnectInput>;
  ProductBanner?: InputMaybe<ProductBannerConnectInput>;
  Question?: InputMaybe<QuestionConnectInput>;
  Separator?: InputMaybe<SeparatorConnectInput>;
  Spacer?: InputMaybe<SpacerConnectInput>;
  Tab?: InputMaybe<TabConnectInput>;
  TestComponentWithRecipeQuery?: InputMaybe<TestComponentWithRecipeQueryConnectInput>;
};

export type GenericPagePageComponentsCreateInput = {
  AnchorNav?: InputMaybe<AnchorNavCreateInput>;
  AnchorNavigationList?: InputMaybe<AnchorNavigationListCreateInput>;
  AudioComponent?: InputMaybe<AudioComponentCreateInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardCreateInput>;
  Banner1?: InputMaybe<Banner1CreateInput>;
  Banner2?: InputMaybe<Banner2CreateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentCreateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentCreateInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerCreateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridCreateInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentCreateInput>;
  ExampleComponent?: InputMaybe<ExampleComponentCreateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentCreateInput>;
  Form?: InputMaybe<FormCreateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionCreateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedCreateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentCreateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsCreateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableCreateInput>;
  GenericHtml?: InputMaybe<GenericHtmlCreateInput>;
  GenericLine?: InputMaybe<GenericLineCreateInput>;
  GenericPromotionsOverview?: InputMaybe<GenericPromotionsOverviewCreateInput>;
  GenericQualifio?: InputMaybe<GenericQualifioCreateInput>;
  GenericQualifioOverview?: InputMaybe<GenericQualifioOverviewCreateInput>;
  GenericSocialShare?: InputMaybe<GenericSocialShareCreateInput>;
  GlobalSearch?: InputMaybe<GlobalSearchCreateInput>;
  GridColumn?: InputMaybe<GridColumnCreateInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentCreateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateInput>;
  HeroComponent?: InputMaybe<HeroComponentCreateInput>;
  HeroLoopAnimationComponent?: InputMaybe<HeroLoopAnimationComponentCreateInput>;
  Iframe?: InputMaybe<IframeCreateInput>;
  ImageCopy?: InputMaybe<ImageCopyCreateInput>;
  IntroText?: InputMaybe<IntroTextCreateInput>;
  Link?: InputMaybe<LinkCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormCreateInput>;
  NewsletterComponent?: InputMaybe<NewsletterComponentCreateInput>;
  PageFooter?: InputMaybe<PageFooterCreateInput>;
  PageHeader?: InputMaybe<PageHeaderCreateInput>;
  ProductBanner?: InputMaybe<ProductBannerCreateInput>;
  Question?: InputMaybe<QuestionCreateInput>;
  Separator?: InputMaybe<SeparatorCreateInput>;
  Spacer?: InputMaybe<SpacerCreateInput>;
  Tab?: InputMaybe<TabCreateInput>;
  TestComponentWithRecipeQuery?: InputMaybe<TestComponentWithRecipeQueryCreateInput>;
};

export type GenericPagePageComponentsCreateManyInlineInput = {
  /** Connect multiple existing GenericPagePageComponents documents */
  connect?: InputMaybe<Array<GenericPagePageComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing GenericPagePageComponents documents */
  create?: InputMaybe<Array<GenericPagePageComponentsCreateInput>>;
};

export type GenericPagePageComponentsCreateOneInlineInput = {
  /** Connect one existing GenericPagePageComponents document */
  connect?: InputMaybe<GenericPagePageComponentsWhereUniqueInput>;
  /** Create and connect one GenericPagePageComponents document */
  create?: InputMaybe<GenericPagePageComponentsCreateInput>;
};

export type GenericPagePageComponentsUpdateInput = {
  AnchorNav?: InputMaybe<AnchorNavUpdateInput>;
  AnchorNavigationList?: InputMaybe<AnchorNavigationListUpdateInput>;
  AudioComponent?: InputMaybe<AudioComponentUpdateInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateInput>;
  Banner1?: InputMaybe<Banner1UpdateInput>;
  Banner2?: InputMaybe<Banner2UpdateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerUpdateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateInput>;
  ExampleComponent?: InputMaybe<ExampleComponentUpdateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateInput>;
  Form?: InputMaybe<FormUpdateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateInput>;
  GenericLine?: InputMaybe<GenericLineUpdateInput>;
  GenericPromotionsOverview?: InputMaybe<GenericPromotionsOverviewUpdateInput>;
  GenericQualifio?: InputMaybe<GenericQualifioUpdateInput>;
  GenericQualifioOverview?: InputMaybe<GenericQualifioOverviewUpdateInput>;
  GenericSocialShare?: InputMaybe<GenericSocialShareUpdateInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateInput>;
  GridColumn?: InputMaybe<GridColumnUpdateInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentUpdateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateInput>;
  HeroComponent?: InputMaybe<HeroComponentUpdateInput>;
  HeroLoopAnimationComponent?: InputMaybe<HeroLoopAnimationComponentUpdateInput>;
  Iframe?: InputMaybe<IframeUpdateInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateInput>;
  IntroText?: InputMaybe<IntroTextUpdateInput>;
  Link?: InputMaybe<LinkUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormUpdateInput>;
  NewsletterComponent?: InputMaybe<NewsletterComponentUpdateInput>;
  PageFooter?: InputMaybe<PageFooterUpdateInput>;
  PageHeader?: InputMaybe<PageHeaderUpdateInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateInput>;
  Question?: InputMaybe<QuestionUpdateInput>;
  Separator?: InputMaybe<SeparatorUpdateInput>;
  Spacer?: InputMaybe<SpacerUpdateInput>;
  Tab?: InputMaybe<TabUpdateInput>;
  TestComponentWithRecipeQuery?: InputMaybe<TestComponentWithRecipeQueryUpdateInput>;
};

export type GenericPagePageComponentsUpdateManyInlineInput = {
  /** Connect multiple existing GenericPagePageComponents documents */
  connect?: InputMaybe<Array<GenericPagePageComponentsConnectInput>>;
  /** Create and connect multiple GenericPagePageComponents documents */
  create?: InputMaybe<Array<GenericPagePageComponentsCreateInput>>;
  /** Delete multiple GenericPagePageComponents documents */
  delete?: InputMaybe<Array<GenericPagePageComponentsWhereUniqueInput>>;
  /** Disconnect multiple GenericPagePageComponents documents */
  disconnect?: InputMaybe<Array<GenericPagePageComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericPagePageComponents documents */
  set?: InputMaybe<Array<GenericPagePageComponentsWhereUniqueInput>>;
  /** Update multiple GenericPagePageComponents documents */
  update?: InputMaybe<Array<GenericPagePageComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericPagePageComponents documents */
  upsert?: InputMaybe<Array<GenericPagePageComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type GenericPagePageComponentsUpdateManyWithNestedWhereInput = {
  AnchorNav?: InputMaybe<AnchorNavUpdateManyWithNestedWhereInput>;
  AnchorNavigationList?: InputMaybe<AnchorNavigationListUpdateManyWithNestedWhereInput>;
  AudioComponent?: InputMaybe<AudioComponentUpdateManyWithNestedWhereInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateManyWithNestedWhereInput>;
  Banner1?: InputMaybe<Banner1UpdateManyWithNestedWhereInput>;
  Banner2?: InputMaybe<Banner2UpdateManyWithNestedWhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateManyWithNestedWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateManyWithNestedWhereInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerUpdateManyWithNestedWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateManyWithNestedWhereInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateManyWithNestedWhereInput>;
  ExampleComponent?: InputMaybe<ExampleComponentUpdateManyWithNestedWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateManyWithNestedWhereInput>;
  Form?: InputMaybe<FormUpdateManyWithNestedWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateManyWithNestedWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateManyWithNestedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateManyWithNestedWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateManyWithNestedWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateManyWithNestedWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateManyWithNestedWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateManyWithNestedWhereInput>;
  GenericLine?: InputMaybe<GenericLineUpdateManyWithNestedWhereInput>;
  GenericPromotionsOverview?: InputMaybe<GenericPromotionsOverviewUpdateManyWithNestedWhereInput>;
  GenericQualifio?: InputMaybe<GenericQualifioUpdateManyWithNestedWhereInput>;
  GenericQualifioOverview?: InputMaybe<GenericQualifioOverviewUpdateManyWithNestedWhereInput>;
  GenericSocialShare?: InputMaybe<GenericSocialShareUpdateManyWithNestedWhereInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateManyWithNestedWhereInput>;
  GridColumn?: InputMaybe<GridColumnUpdateManyWithNestedWhereInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentUpdateManyWithNestedWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateManyWithNestedWhereInput>;
  HeroComponent?: InputMaybe<HeroComponentUpdateManyWithNestedWhereInput>;
  HeroLoopAnimationComponent?: InputMaybe<HeroLoopAnimationComponentUpdateManyWithNestedWhereInput>;
  Iframe?: InputMaybe<IframeUpdateManyWithNestedWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateManyWithNestedWhereInput>;
  IntroText?: InputMaybe<IntroTextUpdateManyWithNestedWhereInput>;
  Link?: InputMaybe<LinkUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormUpdateManyWithNestedWhereInput>;
  NewsletterComponent?: InputMaybe<NewsletterComponentUpdateManyWithNestedWhereInput>;
  PageFooter?: InputMaybe<PageFooterUpdateManyWithNestedWhereInput>;
  PageHeader?: InputMaybe<PageHeaderUpdateManyWithNestedWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateManyWithNestedWhereInput>;
  Question?: InputMaybe<QuestionUpdateManyWithNestedWhereInput>;
  Separator?: InputMaybe<SeparatorUpdateManyWithNestedWhereInput>;
  Spacer?: InputMaybe<SpacerUpdateManyWithNestedWhereInput>;
  Tab?: InputMaybe<TabUpdateManyWithNestedWhereInput>;
  TestComponentWithRecipeQuery?: InputMaybe<TestComponentWithRecipeQueryUpdateManyWithNestedWhereInput>;
};

export type GenericPagePageComponentsUpdateOneInlineInput = {
  /** Connect existing GenericPagePageComponents document */
  connect?: InputMaybe<GenericPagePageComponentsWhereUniqueInput>;
  /** Create and connect one GenericPagePageComponents document */
  create?: InputMaybe<GenericPagePageComponentsCreateInput>;
  /** Delete currently connected GenericPagePageComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericPagePageComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericPagePageComponents document */
  update?: InputMaybe<GenericPagePageComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericPagePageComponents document */
  upsert?: InputMaybe<GenericPagePageComponentsUpsertWithNestedWhereUniqueInput>;
};

export type GenericPagePageComponentsUpdateWithNestedWhereUniqueInput = {
  AnchorNav?: InputMaybe<AnchorNavUpdateWithNestedWhereUniqueInput>;
  AnchorNavigationList?: InputMaybe<AnchorNavigationListUpdateWithNestedWhereUniqueInput>;
  AudioComponent?: InputMaybe<AudioComponentUpdateWithNestedWhereUniqueInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpdateWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpdateWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateWithNestedWhereUniqueInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerUpdateWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateWithNestedWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateWithNestedWhereUniqueInput>;
  ExampleComponent?: InputMaybe<ExampleComponentUpdateWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateWithNestedWhereUniqueInput>;
  Form?: InputMaybe<FormUpdateWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateWithNestedWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineUpdateWithNestedWhereUniqueInput>;
  GenericPromotionsOverview?: InputMaybe<GenericPromotionsOverviewUpdateWithNestedWhereUniqueInput>;
  GenericQualifio?: InputMaybe<GenericQualifioUpdateWithNestedWhereUniqueInput>;
  GenericQualifioOverview?: InputMaybe<GenericQualifioOverviewUpdateWithNestedWhereUniqueInput>;
  GenericSocialShare?: InputMaybe<GenericSocialShareUpdateWithNestedWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateWithNestedWhereUniqueInput>;
  GridColumn?: InputMaybe<GridColumnUpdateWithNestedWhereUniqueInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentUpdateWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateWithNestedWhereUniqueInput>;
  HeroComponent?: InputMaybe<HeroComponentUpdateWithNestedWhereUniqueInput>;
  HeroLoopAnimationComponent?: InputMaybe<HeroLoopAnimationComponentUpdateWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpdateWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpdateWithNestedWhereUniqueInput>;
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormUpdateWithNestedWhereUniqueInput>;
  NewsletterComponent?: InputMaybe<NewsletterComponentUpdateWithNestedWhereUniqueInput>;
  PageFooter?: InputMaybe<PageFooterUpdateWithNestedWhereUniqueInput>;
  PageHeader?: InputMaybe<PageHeaderUpdateWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateWithNestedWhereUniqueInput>;
  Question?: InputMaybe<QuestionUpdateWithNestedWhereUniqueInput>;
  Separator?: InputMaybe<SeparatorUpdateWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpdateWithNestedWhereUniqueInput>;
  Tab?: InputMaybe<TabUpdateWithNestedWhereUniqueInput>;
  TestComponentWithRecipeQuery?: InputMaybe<TestComponentWithRecipeQueryUpdateWithNestedWhereUniqueInput>;
};

export type GenericPagePageComponentsUpsertWithNestedWhereUniqueInput = {
  AnchorNav?: InputMaybe<AnchorNavUpsertWithNestedWhereUniqueInput>;
  AnchorNavigationList?: InputMaybe<AnchorNavigationListUpsertWithNestedWhereUniqueInput>;
  AudioComponent?: InputMaybe<AudioComponentUpsertWithNestedWhereUniqueInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpsertWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpsertWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpsertWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpsertWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpsertWithNestedWhereUniqueInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerUpsertWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpsertWithNestedWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpsertWithNestedWhereUniqueInput>;
  ExampleComponent?: InputMaybe<ExampleComponentUpsertWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpsertWithNestedWhereUniqueInput>;
  Form?: InputMaybe<FormUpsertWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpsertWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpsertWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpsertWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpsertWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpsertWithNestedWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineUpsertWithNestedWhereUniqueInput>;
  GenericPromotionsOverview?: InputMaybe<GenericPromotionsOverviewUpsertWithNestedWhereUniqueInput>;
  GenericQualifio?: InputMaybe<GenericQualifioUpsertWithNestedWhereUniqueInput>;
  GenericQualifioOverview?: InputMaybe<GenericQualifioOverviewUpsertWithNestedWhereUniqueInput>;
  GenericSocialShare?: InputMaybe<GenericSocialShareUpsertWithNestedWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpsertWithNestedWhereUniqueInput>;
  GridColumn?: InputMaybe<GridColumnUpsertWithNestedWhereUniqueInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentUpsertWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpsertWithNestedWhereUniqueInput>;
  HeroComponent?: InputMaybe<HeroComponentUpsertWithNestedWhereUniqueInput>;
  HeroLoopAnimationComponent?: InputMaybe<HeroLoopAnimationComponentUpsertWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpsertWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpsertWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpsertWithNestedWhereUniqueInput>;
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormUpsertWithNestedWhereUniqueInput>;
  NewsletterComponent?: InputMaybe<NewsletterComponentUpsertWithNestedWhereUniqueInput>;
  PageFooter?: InputMaybe<PageFooterUpsertWithNestedWhereUniqueInput>;
  PageHeader?: InputMaybe<PageHeaderUpsertWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpsertWithNestedWhereUniqueInput>;
  Question?: InputMaybe<QuestionUpsertWithNestedWhereUniqueInput>;
  Separator?: InputMaybe<SeparatorUpsertWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpsertWithNestedWhereUniqueInput>;
  Tab?: InputMaybe<TabUpsertWithNestedWhereUniqueInput>;
  TestComponentWithRecipeQuery?: InputMaybe<TestComponentWithRecipeQueryUpsertWithNestedWhereUniqueInput>;
};

export type GenericPagePageComponentsWhereInput = {
  AnchorNav?: InputMaybe<AnchorNavWhereInput>;
  AnchorNavigationList?: InputMaybe<AnchorNavigationListWhereInput>;
  AudioComponent?: InputMaybe<AudioComponentWhereInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereInput>;
  Banner1?: InputMaybe<Banner1WhereInput>;
  Banner2?: InputMaybe<Banner2WhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentWhereInput>;
  ExampleComponent?: InputMaybe<ExampleComponentWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereInput>;
  Form?: InputMaybe<FormWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereInput>;
  GenericLine?: InputMaybe<GenericLineWhereInput>;
  GenericPromotionsOverview?: InputMaybe<GenericPromotionsOverviewWhereInput>;
  GenericQualifio?: InputMaybe<GenericQualifioWhereInput>;
  GenericQualifioOverview?: InputMaybe<GenericQualifioOverviewWhereInput>;
  GenericSocialShare?: InputMaybe<GenericSocialShareWhereInput>;
  GlobalSearch?: InputMaybe<GlobalSearchWhereInput>;
  GridColumn?: InputMaybe<GridColumnWhereInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  HeroComponent?: InputMaybe<HeroComponentWhereInput>;
  HeroLoopAnimationComponent?: InputMaybe<HeroLoopAnimationComponentWhereInput>;
  Iframe?: InputMaybe<IframeWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereInput>;
  IntroText?: InputMaybe<IntroTextWhereInput>;
  Link?: InputMaybe<LinkWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormWhereInput>;
  NewsletterComponent?: InputMaybe<NewsletterComponentWhereInput>;
  PageFooter?: InputMaybe<PageFooterWhereInput>;
  PageHeader?: InputMaybe<PageHeaderWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereInput>;
  Question?: InputMaybe<QuestionWhereInput>;
  Separator?: InputMaybe<SeparatorWhereInput>;
  Spacer?: InputMaybe<SpacerWhereInput>;
  Tab?: InputMaybe<TabWhereInput>;
  TestComponentWithRecipeQuery?: InputMaybe<TestComponentWithRecipeQueryWhereInput>;
};

export type GenericPagePageComponentsWhereUniqueInput = {
  AnchorNav?: InputMaybe<AnchorNavWhereUniqueInput>;
  AnchorNavigationList?: InputMaybe<AnchorNavigationListWhereUniqueInput>;
  AudioComponent?: InputMaybe<AudioComponentWhereUniqueInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1WhereUniqueInput>;
  Banner2?: InputMaybe<Banner2WhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereUniqueInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentWhereUniqueInput>;
  ExampleComponent?: InputMaybe<ExampleComponentWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereUniqueInput>;
  Form?: InputMaybe<FormWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineWhereUniqueInput>;
  GenericPromotionsOverview?: InputMaybe<GenericPromotionsOverviewWhereUniqueInput>;
  GenericQualifio?: InputMaybe<GenericQualifioWhereUniqueInput>;
  GenericQualifioOverview?: InputMaybe<GenericQualifioOverviewWhereUniqueInput>;
  GenericSocialShare?: InputMaybe<GenericSocialShareWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchWhereUniqueInput>;
  GridColumn?: InputMaybe<GridColumnWhereUniqueInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereUniqueInput>;
  HeroComponent?: InputMaybe<HeroComponentWhereUniqueInput>;
  HeroLoopAnimationComponent?: InputMaybe<HeroLoopAnimationComponentWhereUniqueInput>;
  Iframe?: InputMaybe<IframeWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextWhereUniqueInput>;
  Link?: InputMaybe<LinkWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormWhereUniqueInput>;
  NewsletterComponent?: InputMaybe<NewsletterComponentWhereUniqueInput>;
  PageFooter?: InputMaybe<PageFooterWhereUniqueInput>;
  PageHeader?: InputMaybe<PageHeaderWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereUniqueInput>;
  Question?: InputMaybe<QuestionWhereUniqueInput>;
  Separator?: InputMaybe<SeparatorWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerWhereUniqueInput>;
  Tab?: InputMaybe<TabWhereUniqueInput>;
  TestComponentWithRecipeQuery?: InputMaybe<TestComponentWithRecipeQueryWhereUniqueInput>;
};

export type GenericPageUpdateInput = {
  cardDescription?: InputMaybe<Scalars['String']['input']>;
  cardImage?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  cardTitle?: InputMaybe<Scalars['String']['input']>;
  ckuntpg4l4gcn01z67yt87trx?: InputMaybe<FeaturedContentReferenceUpdateManyInlineInput>;
  ckv0ngnv50vy401xv0n2q3dhq?: InputMaybe<GenericCardCarouseComponentUpdateManyInlineInput>;
  clziiapaq04w308uj45o42vdm?: InputMaybe<SingleStepPromotionFormUpdateManyInlineInput>;
  contentGroupingTrackingValue?: InputMaybe<ContentGrouping1>;
  contentGroupingTrackingValues?: InputMaybe<ContentGrouping2>;
  cookieBannerRequired?: InputMaybe<Scalars['Boolean']['input']>;
  dictionary?: InputMaybe<DictionaryUpdateOneInlineInput>;
  hideNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  isArticle?: InputMaybe<Scalars['Boolean']['input']>;
  isContactUsPage?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  links?: InputMaybe<LinkUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<GenericPageUpdateLocalizationsInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  metaData?: InputMaybe<MetaDataUpdateOneInlineInput>;
  pageComponents?: InputMaybe<GenericPagePageComponentsUpdateManyInlineInput>;
  savePromotionAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  showInPromotionsOverview?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subPath?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderUpdateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderUpdateManyInlineInput>;
  /** theme input for default locale (en) */
  theme?: InputMaybe<Themes>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GenericPagesTypes>;
};

export type GenericPageUpdateLocalizationDataInput = {
  theme?: InputMaybe<Themes>;
};

export type GenericPageUpdateLocalizationInput = {
  data: GenericPageUpdateLocalizationDataInput;
  locale: Locale;
};

export type GenericPageUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<GenericPageCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<GenericPageUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<GenericPageUpsertLocalizationInput>>;
};

export type GenericPageUpdateManyInlineInput = {
  /** Connect multiple existing GenericPage documents */
  connect?: InputMaybe<Array<GenericPageConnectInput>>;
  /** Create and connect multiple GenericPage documents */
  create?: InputMaybe<Array<GenericPageCreateInput>>;
  /** Delete multiple GenericPage documents */
  delete?: InputMaybe<Array<GenericPageWhereUniqueInput>>;
  /** Disconnect multiple GenericPage documents */
  disconnect?: InputMaybe<Array<GenericPageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericPage documents */
  set?: InputMaybe<Array<GenericPageWhereUniqueInput>>;
  /** Update multiple GenericPage documents */
  update?: InputMaybe<Array<GenericPageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericPage documents */
  upsert?: InputMaybe<Array<GenericPageUpsertWithNestedWhereUniqueInput>>;
};

export type GenericPageUpdateManyInput = {
  cardDescription?: InputMaybe<Scalars['String']['input']>;
  cardTitle?: InputMaybe<Scalars['String']['input']>;
  contentGroupingTrackingValue?: InputMaybe<ContentGrouping1>;
  contentGroupingTrackingValues?: InputMaybe<ContentGrouping2>;
  cookieBannerRequired?: InputMaybe<Scalars['Boolean']['input']>;
  hideNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  isArticle?: InputMaybe<Scalars['Boolean']['input']>;
  isContactUsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<GenericPageUpdateManyLocalizationsInput>;
  market?: InputMaybe<Markets>;
  savePromotionAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  showInPromotionsOverview?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subPath?: InputMaybe<Scalars['String']['input']>;
  /** theme input for default locale (en) */
  theme?: InputMaybe<Themes>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GenericPagesTypes>;
};

export type GenericPageUpdateManyLocalizationDataInput = {
  theme?: InputMaybe<Themes>;
};

export type GenericPageUpdateManyLocalizationInput = {
  data: GenericPageUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type GenericPageUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<GenericPageUpdateManyLocalizationInput>>;
};

export type GenericPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericPageUpdateManyInput;
  /** Document search */
  where: GenericPageWhereInput;
};

export type GenericPageUpdateOneInlineInput = {
  /** Connect existing GenericPage document */
  connect?: InputMaybe<GenericPageWhereUniqueInput>;
  /** Create and connect one GenericPage document */
  create?: InputMaybe<GenericPageCreateInput>;
  /** Delete currently connected GenericPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericPage document */
  update?: InputMaybe<GenericPageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericPage document */
  upsert?: InputMaybe<GenericPageUpsertWithNestedWhereUniqueInput>;
};

export type GenericPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericPageUpdateInput;
  /** Unique document search */
  where: GenericPageWhereUniqueInput;
};

export type GenericPageUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericPageCreateInput;
  /** Update document if it exists */
  update: GenericPageUpdateInput;
};

export type GenericPageUpsertLocalizationInput = {
  create: GenericPageCreateLocalizationDataInput;
  locale: Locale;
  update: GenericPageUpdateLocalizationDataInput;
};

export type GenericPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericPageUpsertInput;
  /** Unique document search */
  where: GenericPageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardImage?: InputMaybe<AssetComponentWhereInput>;
  cardTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  contentGroupingTrackingValue?: InputMaybe<ContentGrouping1>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValue_in?: InputMaybe<Array<InputMaybe<ContentGrouping1>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValue_not?: InputMaybe<ContentGrouping1>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValue_not_in?: InputMaybe<Array<InputMaybe<ContentGrouping1>>>;
  contentGroupingTrackingValues?: InputMaybe<ContentGrouping2>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValues_in?: InputMaybe<Array<InputMaybe<ContentGrouping2>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValues_not?: InputMaybe<ContentGrouping2>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValues_not_in?: InputMaybe<Array<InputMaybe<ContentGrouping2>>>;
  cookieBannerRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  cookieBannerRequired_not?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionary?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<GenericPageWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericPageWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericPageWhereStageInput>;
  hideNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hideNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isArticle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isArticle_not?: InputMaybe<Scalars['Boolean']['input']>;
  isContactUsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isContactUsPage_not?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<GenericPagePageComponentsWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  savePromotionAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  savePromotionAnswers_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showInPromotionsOverview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showInPromotionsOverview_not?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  subPath?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subPath_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subPath_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subPath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subPath_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subPath_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subPath_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subPath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subPath_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subPath_starts_with?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  theme?: InputMaybe<Themes>;
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<Themes>>>;
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<Themes>;
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<Themes>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GenericPagesTypes>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<GenericPagesTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<GenericPagesTypes>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<GenericPagesTypes>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericPageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericPageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericPageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericPageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericPage record uniquely */
export type GenericPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Type for generic page to determine where in the structure of the app it should render */
export enum GenericPagesTypes {
  About = 'About',
  Generic = 'Generic',
  ProductPromotion = 'ProductPromotion',
  Promotions = 'Promotions',
  Services = 'Services',
  Support = 'Support',
  inspiration = 'inspiration'
}

export type GenericPromotionsOverview = Entity & Node & {
  __typename?: 'GenericPromotionsOverview';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericPromotionsOverview>;
  genericPages: Array<GenericPage>;
  /** List of GenericPromotionsOverview versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericPromotionsOverviewCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericPromotionsOverviewDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericPromotionsOverviewGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GenericPromotionsOverviewHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericPromotionsOverviewMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericPromotionsOverviewPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericPromotionsOverviewScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericPromotionsOverviewUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericPromotionsOverviewConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericPromotionsOverviewWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericPromotionsOverviewConnection = {
  __typename?: 'GenericPromotionsOverviewConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericPromotionsOverviewEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericPromotionsOverviewCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericPromotionsOverviewCreateManyInlineInput = {
  /** Connect multiple existing GenericPromotionsOverview documents */
  connect?: InputMaybe<Array<GenericPromotionsOverviewWhereUniqueInput>>;
  /** Create and connect multiple existing GenericPromotionsOverview documents */
  create?: InputMaybe<Array<GenericPromotionsOverviewCreateInput>>;
};

export type GenericPromotionsOverviewCreateOneInlineInput = {
  /** Connect one existing GenericPromotionsOverview document */
  connect?: InputMaybe<GenericPromotionsOverviewWhereUniqueInput>;
  /** Create and connect one GenericPromotionsOverview document */
  create?: InputMaybe<GenericPromotionsOverviewCreateInput>;
};

/** An edge in a connection. */
export type GenericPromotionsOverviewEdge = {
  __typename?: 'GenericPromotionsOverviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericPromotionsOverview;
};

/** Identifies documents */
export type GenericPromotionsOverviewManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericPromotionsOverviewWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericPromotionsOverviewWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericPromotionsOverviewWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericPromotionsOverviewWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericPromotionsOverviewWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericPromotionsOverviewWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericPromotionsOverviewOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subTitle_ASC = 'subTitle_ASC',
  subTitle_DESC = 'subTitle_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericPromotionsOverviewUpdateInput = {
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericPromotionsOverviewUpdateManyInlineInput = {
  /** Connect multiple existing GenericPromotionsOverview documents */
  connect?: InputMaybe<Array<GenericPromotionsOverviewConnectInput>>;
  /** Create and connect multiple GenericPromotionsOverview documents */
  create?: InputMaybe<Array<GenericPromotionsOverviewCreateInput>>;
  /** Delete multiple GenericPromotionsOverview documents */
  delete?: InputMaybe<Array<GenericPromotionsOverviewWhereUniqueInput>>;
  /** Disconnect multiple GenericPromotionsOverview documents */
  disconnect?: InputMaybe<Array<GenericPromotionsOverviewWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericPromotionsOverview documents */
  set?: InputMaybe<Array<GenericPromotionsOverviewWhereUniqueInput>>;
  /** Update multiple GenericPromotionsOverview documents */
  update?: InputMaybe<Array<GenericPromotionsOverviewUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericPromotionsOverview documents */
  upsert?: InputMaybe<Array<GenericPromotionsOverviewUpsertWithNestedWhereUniqueInput>>;
};

export type GenericPromotionsOverviewUpdateManyInput = {
  market?: InputMaybe<Markets>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericPromotionsOverviewUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericPromotionsOverviewUpdateManyInput;
  /** Document search */
  where: GenericPromotionsOverviewWhereInput;
};

export type GenericPromotionsOverviewUpdateOneInlineInput = {
  /** Connect existing GenericPromotionsOverview document */
  connect?: InputMaybe<GenericPromotionsOverviewWhereUniqueInput>;
  /** Create and connect one GenericPromotionsOverview document */
  create?: InputMaybe<GenericPromotionsOverviewCreateInput>;
  /** Delete currently connected GenericPromotionsOverview document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericPromotionsOverview document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericPromotionsOverview document */
  update?: InputMaybe<GenericPromotionsOverviewUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericPromotionsOverview document */
  upsert?: InputMaybe<GenericPromotionsOverviewUpsertWithNestedWhereUniqueInput>;
};

export type GenericPromotionsOverviewUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericPromotionsOverviewUpdateInput;
  /** Unique document search */
  where: GenericPromotionsOverviewWhereUniqueInput;
};

export type GenericPromotionsOverviewUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericPromotionsOverviewCreateInput;
  /** Update document if it exists */
  update: GenericPromotionsOverviewUpdateInput;
};

export type GenericPromotionsOverviewUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericPromotionsOverviewUpsertInput;
  /** Unique document search */
  where: GenericPromotionsOverviewWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericPromotionsOverviewWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericPromotionsOverviewWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericPromotionsOverviewWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericPromotionsOverviewWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericPromotionsOverviewWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericPromotionsOverviewWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericPromotionsOverviewWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericPromotionsOverviewWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericPromotionsOverviewWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericPromotionsOverviewWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericPromotionsOverviewWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericPromotionsOverviewWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericPromotionsOverviewWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericPromotionsOverview record uniquely */
export type GenericPromotionsOverviewWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericQualifio = Entity & Node & {
  __typename?: 'GenericQualifio';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericQualifio>;
  genericPages: Array<GenericPage>;
  /** List of GenericQualifio versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  mainTitle?: Maybe<Scalars['String']['output']>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Add the Qualifio code snippet here. Make sure it contains a part starting with _qual_async.push */
  widgetCode: Scalars['String']['output'];
};


export type GenericQualifioCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericQualifioDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericQualifioGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GenericQualifioHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericQualifioMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericQualifioPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericQualifioScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericQualifioUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericQualifioConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericQualifioWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericQualifioConnection = {
  __typename?: 'GenericQualifioConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericQualifioEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericQualifioCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  mainTitle?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  widgetCode: Scalars['String']['input'];
};

export type GenericQualifioCreateManyInlineInput = {
  /** Connect multiple existing GenericQualifio documents */
  connect?: InputMaybe<Array<GenericQualifioWhereUniqueInput>>;
  /** Create and connect multiple existing GenericQualifio documents */
  create?: InputMaybe<Array<GenericQualifioCreateInput>>;
};

export type GenericQualifioCreateOneInlineInput = {
  /** Connect one existing GenericQualifio document */
  connect?: InputMaybe<GenericQualifioWhereUniqueInput>;
  /** Create and connect one GenericQualifio document */
  create?: InputMaybe<GenericQualifioCreateInput>;
};

/** An edge in a connection. */
export type GenericQualifioEdge = {
  __typename?: 'GenericQualifioEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericQualifio;
};

/** Identifies documents */
export type GenericQualifioManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericQualifioWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericQualifioWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericQualifioWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericQualifioWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericQualifioWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericQualifioWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  mainTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  mainTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  mainTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  mainTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  mainTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  mainTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  mainTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  mainTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  mainTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  mainTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  widgetCode?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  widgetCode_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  widgetCode_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  widgetCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  widgetCode_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  widgetCode_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  widgetCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  widgetCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  widgetCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  widgetCode_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum GenericQualifioOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  mainTitle_ASC = 'mainTitle_ASC',
  mainTitle_DESC = 'mainTitle_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  widgetCode_ASC = 'widgetCode_ASC',
  widgetCode_DESC = 'widgetCode_DESC'
}

export type GenericQualifioOverview = Entity & Node & {
  __typename?: 'GenericQualifioOverview';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericQualifioOverview>;
  genericPages: Array<GenericPage>;
  /** List of GenericQualifioOverview versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericQualifioOverviewCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericQualifioOverviewDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericQualifioOverviewGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GenericQualifioOverviewHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericQualifioOverviewMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericQualifioOverviewPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericQualifioOverviewScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericQualifioOverviewUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericQualifioOverviewConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericQualifioOverviewWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericQualifioOverviewConnection = {
  __typename?: 'GenericQualifioOverviewConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericQualifioOverviewEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericQualifioOverviewCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericQualifioOverviewCreateManyInlineInput = {
  /** Connect multiple existing GenericQualifioOverview documents */
  connect?: InputMaybe<Array<GenericQualifioOverviewWhereUniqueInput>>;
  /** Create and connect multiple existing GenericQualifioOverview documents */
  create?: InputMaybe<Array<GenericQualifioOverviewCreateInput>>;
};

export type GenericQualifioOverviewCreateOneInlineInput = {
  /** Connect one existing GenericQualifioOverview document */
  connect?: InputMaybe<GenericQualifioOverviewWhereUniqueInput>;
  /** Create and connect one GenericQualifioOverview document */
  create?: InputMaybe<GenericQualifioOverviewCreateInput>;
};

/** An edge in a connection. */
export type GenericQualifioOverviewEdge = {
  __typename?: 'GenericQualifioOverviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericQualifioOverview;
};

/** Identifies documents */
export type GenericQualifioOverviewManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericQualifioOverviewWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericQualifioOverviewWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericQualifioOverviewWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericQualifioOverviewWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericQualifioOverviewWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericQualifioOverviewWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericQualifioOverviewOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericQualifioOverviewUpdateInput = {
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericQualifioOverviewUpdateManyInlineInput = {
  /** Connect multiple existing GenericQualifioOverview documents */
  connect?: InputMaybe<Array<GenericQualifioOverviewConnectInput>>;
  /** Create and connect multiple GenericQualifioOverview documents */
  create?: InputMaybe<Array<GenericQualifioOverviewCreateInput>>;
  /** Delete multiple GenericQualifioOverview documents */
  delete?: InputMaybe<Array<GenericQualifioOverviewWhereUniqueInput>>;
  /** Disconnect multiple GenericQualifioOverview documents */
  disconnect?: InputMaybe<Array<GenericQualifioOverviewWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericQualifioOverview documents */
  set?: InputMaybe<Array<GenericQualifioOverviewWhereUniqueInput>>;
  /** Update multiple GenericQualifioOverview documents */
  update?: InputMaybe<Array<GenericQualifioOverviewUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericQualifioOverview documents */
  upsert?: InputMaybe<Array<GenericQualifioOverviewUpsertWithNestedWhereUniqueInput>>;
};

export type GenericQualifioOverviewUpdateManyInput = {
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericQualifioOverviewUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericQualifioOverviewUpdateManyInput;
  /** Document search */
  where: GenericQualifioOverviewWhereInput;
};

export type GenericQualifioOverviewUpdateOneInlineInput = {
  /** Connect existing GenericQualifioOverview document */
  connect?: InputMaybe<GenericQualifioOverviewWhereUniqueInput>;
  /** Create and connect one GenericQualifioOverview document */
  create?: InputMaybe<GenericQualifioOverviewCreateInput>;
  /** Delete currently connected GenericQualifioOverview document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericQualifioOverview document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericQualifioOverview document */
  update?: InputMaybe<GenericQualifioOverviewUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericQualifioOverview document */
  upsert?: InputMaybe<GenericQualifioOverviewUpsertWithNestedWhereUniqueInput>;
};

export type GenericQualifioOverviewUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericQualifioOverviewUpdateInput;
  /** Unique document search */
  where: GenericQualifioOverviewWhereUniqueInput;
};

export type GenericQualifioOverviewUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericQualifioOverviewCreateInput;
  /** Update document if it exists */
  update: GenericQualifioOverviewUpdateInput;
};

export type GenericQualifioOverviewUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericQualifioOverviewUpsertInput;
  /** Unique document search */
  where: GenericQualifioOverviewWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericQualifioOverviewWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericQualifioOverviewWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericQualifioOverviewWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericQualifioOverviewWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericQualifioOverviewWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericQualifioOverviewWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericQualifioOverviewWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericQualifioOverviewWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericQualifioOverviewWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericQualifioOverviewWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericQualifioOverviewWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericQualifioOverviewWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericQualifioOverviewWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericQualifioOverview record uniquely */
export type GenericQualifioOverviewWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericQualifioUpdateInput = {
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  mainTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  widgetCode?: InputMaybe<Scalars['String']['input']>;
};

export type GenericQualifioUpdateManyInlineInput = {
  /** Connect multiple existing GenericQualifio documents */
  connect?: InputMaybe<Array<GenericQualifioConnectInput>>;
  /** Create and connect multiple GenericQualifio documents */
  create?: InputMaybe<Array<GenericQualifioCreateInput>>;
  /** Delete multiple GenericQualifio documents */
  delete?: InputMaybe<Array<GenericQualifioWhereUniqueInput>>;
  /** Disconnect multiple GenericQualifio documents */
  disconnect?: InputMaybe<Array<GenericQualifioWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericQualifio documents */
  set?: InputMaybe<Array<GenericQualifioWhereUniqueInput>>;
  /** Update multiple GenericQualifio documents */
  update?: InputMaybe<Array<GenericQualifioUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericQualifio documents */
  upsert?: InputMaybe<Array<GenericQualifioUpsertWithNestedWhereUniqueInput>>;
};

export type GenericQualifioUpdateManyInput = {
  mainTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  widgetCode?: InputMaybe<Scalars['String']['input']>;
};

export type GenericQualifioUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericQualifioUpdateManyInput;
  /** Document search */
  where: GenericQualifioWhereInput;
};

export type GenericQualifioUpdateOneInlineInput = {
  /** Connect existing GenericQualifio document */
  connect?: InputMaybe<GenericQualifioWhereUniqueInput>;
  /** Create and connect one GenericQualifio document */
  create?: InputMaybe<GenericQualifioCreateInput>;
  /** Delete currently connected GenericQualifio document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericQualifio document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericQualifio document */
  update?: InputMaybe<GenericQualifioUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericQualifio document */
  upsert?: InputMaybe<GenericQualifioUpsertWithNestedWhereUniqueInput>;
};

export type GenericQualifioUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericQualifioUpdateInput;
  /** Unique document search */
  where: GenericQualifioWhereUniqueInput;
};

export type GenericQualifioUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericQualifioCreateInput;
  /** Update document if it exists */
  update: GenericQualifioUpdateInput;
};

export type GenericQualifioUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericQualifioUpsertInput;
  /** Unique document search */
  where: GenericQualifioWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericQualifioWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericQualifioWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericQualifioWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericQualifioWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericQualifioWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericQualifioWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericQualifioWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericQualifioWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  mainTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  mainTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  mainTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  mainTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  mainTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  mainTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  mainTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  mainTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  mainTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  mainTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  widgetCode?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  widgetCode_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  widgetCode_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  widgetCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  widgetCode_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  widgetCode_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  widgetCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  widgetCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  widgetCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  widgetCode_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericQualifioWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericQualifioWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericQualifioWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericQualifioWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericQualifioWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericQualifio record uniquely */
export type GenericQualifioWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** A generic social share component that can be added on any required generic page */
export type GenericSocialShare = Entity & Node & {
  __typename?: 'GenericSocialShare';
  buttonLabel: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericSocialShare>;
  genericPages: Array<GenericPage>;
  /** List of GenericSocialShare versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** This field will contain the list of social media items a particular generic social media component can have, different generic social sharing component can have different social media list */
  socialMediaList: Array<GenericSocialShareSocialMediaList>;
  /** System stage field */
  stage: Stage;
  /** Social share component name, that name can be different depending on the generic page or place this component will be used  */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** A generic social share component that can be added on any required generic page */
export type GenericSocialShareCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A generic social share component that can be added on any required generic page */
export type GenericSocialShareDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** A generic social share component that can be added on any required generic page */
export type GenericSocialShareGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** A generic social share component that can be added on any required generic page */
export type GenericSocialShareHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** A generic social share component that can be added on any required generic page */
export type GenericSocialShareMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A generic social share component that can be added on any required generic page */
export type GenericSocialSharePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A generic social share component that can be added on any required generic page */
export type GenericSocialShareScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** A generic social share component that can be added on any required generic page */
export type GenericSocialShareSocialMediaListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** A generic social share component that can be added on any required generic page */
export type GenericSocialShareUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericSocialShareConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericSocialShareWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericSocialShareConnection = {
  __typename?: 'GenericSocialShareConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericSocialShareEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericSocialShareCreateInput = {
  buttonLabel: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  socialMediaList?: InputMaybe<GenericSocialShareSocialMediaListCreateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericSocialShareCreateManyInlineInput = {
  /** Connect multiple existing GenericSocialShare documents */
  connect?: InputMaybe<Array<GenericSocialShareWhereUniqueInput>>;
  /** Create and connect multiple existing GenericSocialShare documents */
  create?: InputMaybe<Array<GenericSocialShareCreateInput>>;
};

export type GenericSocialShareCreateOneInlineInput = {
  /** Connect one existing GenericSocialShare document */
  connect?: InputMaybe<GenericSocialShareWhereUniqueInput>;
  /** Create and connect one GenericSocialShare document */
  create?: InputMaybe<GenericSocialShareCreateInput>;
};

/** An edge in a connection. */
export type GenericSocialShareEdge = {
  __typename?: 'GenericSocialShareEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericSocialShare;
};

/** Identifies documents */
export type GenericSocialShareManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericSocialShareWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericSocialShareWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericSocialShareWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  buttonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  buttonLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  buttonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  buttonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  buttonLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  buttonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  buttonLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  buttonLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericSocialShareWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericSocialShareWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericSocialShareWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values in which the union is empty */
  socialMediaList_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  socialMediaList_some?: InputMaybe<GenericSocialShareSocialMediaListWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericSocialShareOrderByInput {
  buttonLabel_ASC = 'buttonLabel_ASC',
  buttonLabel_DESC = 'buttonLabel_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericSocialShareSocialMediaList = SocialMediaListComponent;

export type GenericSocialShareSocialMediaListConnectInput = {
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentConnectInput>;
};

export type GenericSocialShareSocialMediaListCreateInput = {
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentCreateInput>;
};

export type GenericSocialShareSocialMediaListCreateManyInlineInput = {
  /** Connect multiple existing GenericSocialShareSocialMediaList documents */
  connect?: InputMaybe<Array<GenericSocialShareSocialMediaListWhereUniqueInput>>;
  /** Create and connect multiple existing GenericSocialShareSocialMediaList documents */
  create?: InputMaybe<Array<GenericSocialShareSocialMediaListCreateInput>>;
};

export type GenericSocialShareSocialMediaListCreateOneInlineInput = {
  /** Connect one existing GenericSocialShareSocialMediaList document */
  connect?: InputMaybe<GenericSocialShareSocialMediaListWhereUniqueInput>;
  /** Create and connect one GenericSocialShareSocialMediaList document */
  create?: InputMaybe<GenericSocialShareSocialMediaListCreateInput>;
};

export type GenericSocialShareSocialMediaListUpdateInput = {
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateInput>;
};

export type GenericSocialShareSocialMediaListUpdateManyInlineInput = {
  /** Connect multiple existing GenericSocialShareSocialMediaList documents */
  connect?: InputMaybe<Array<GenericSocialShareSocialMediaListConnectInput>>;
  /** Create and connect multiple GenericSocialShareSocialMediaList documents */
  create?: InputMaybe<Array<GenericSocialShareSocialMediaListCreateInput>>;
  /** Delete multiple GenericSocialShareSocialMediaList documents */
  delete?: InputMaybe<Array<GenericSocialShareSocialMediaListWhereUniqueInput>>;
  /** Disconnect multiple GenericSocialShareSocialMediaList documents */
  disconnect?: InputMaybe<Array<GenericSocialShareSocialMediaListWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericSocialShareSocialMediaList documents */
  set?: InputMaybe<Array<GenericSocialShareSocialMediaListWhereUniqueInput>>;
  /** Update multiple GenericSocialShareSocialMediaList documents */
  update?: InputMaybe<Array<GenericSocialShareSocialMediaListUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericSocialShareSocialMediaList documents */
  upsert?: InputMaybe<Array<GenericSocialShareSocialMediaListUpsertWithNestedWhereUniqueInput>>;
};

export type GenericSocialShareSocialMediaListUpdateManyWithNestedWhereInput = {
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateManyWithNestedWhereInput>;
};

export type GenericSocialShareSocialMediaListUpdateOneInlineInput = {
  /** Connect existing GenericSocialShareSocialMediaList document */
  connect?: InputMaybe<GenericSocialShareSocialMediaListWhereUniqueInput>;
  /** Create and connect one GenericSocialShareSocialMediaList document */
  create?: InputMaybe<GenericSocialShareSocialMediaListCreateInput>;
  /** Delete currently connected GenericSocialShareSocialMediaList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericSocialShareSocialMediaList document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericSocialShareSocialMediaList document */
  update?: InputMaybe<GenericSocialShareSocialMediaListUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericSocialShareSocialMediaList document */
  upsert?: InputMaybe<GenericSocialShareSocialMediaListUpsertWithNestedWhereUniqueInput>;
};

export type GenericSocialShareSocialMediaListUpdateWithNestedWhereUniqueInput = {
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateWithNestedWhereUniqueInput>;
};

export type GenericSocialShareSocialMediaListUpsertWithNestedWhereUniqueInput = {
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpsertWithNestedWhereUniqueInput>;
};

export type GenericSocialShareSocialMediaListWhereInput = {
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentWhereInput>;
};

export type GenericSocialShareSocialMediaListWhereUniqueInput = {
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentWhereUniqueInput>;
};

export type GenericSocialShareUpdateInput = {
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  socialMediaList?: InputMaybe<GenericSocialShareSocialMediaListUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericSocialShareUpdateManyInlineInput = {
  /** Connect multiple existing GenericSocialShare documents */
  connect?: InputMaybe<Array<GenericSocialShareConnectInput>>;
  /** Create and connect multiple GenericSocialShare documents */
  create?: InputMaybe<Array<GenericSocialShareCreateInput>>;
  /** Delete multiple GenericSocialShare documents */
  delete?: InputMaybe<Array<GenericSocialShareWhereUniqueInput>>;
  /** Disconnect multiple GenericSocialShare documents */
  disconnect?: InputMaybe<Array<GenericSocialShareWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericSocialShare documents */
  set?: InputMaybe<Array<GenericSocialShareWhereUniqueInput>>;
  /** Update multiple GenericSocialShare documents */
  update?: InputMaybe<Array<GenericSocialShareUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericSocialShare documents */
  upsert?: InputMaybe<Array<GenericSocialShareUpsertWithNestedWhereUniqueInput>>;
};

export type GenericSocialShareUpdateManyInput = {
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericSocialShareUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericSocialShareUpdateManyInput;
  /** Document search */
  where: GenericSocialShareWhereInput;
};

export type GenericSocialShareUpdateOneInlineInput = {
  /** Connect existing GenericSocialShare document */
  connect?: InputMaybe<GenericSocialShareWhereUniqueInput>;
  /** Create and connect one GenericSocialShare document */
  create?: InputMaybe<GenericSocialShareCreateInput>;
  /** Delete currently connected GenericSocialShare document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericSocialShare document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericSocialShare document */
  update?: InputMaybe<GenericSocialShareUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericSocialShare document */
  upsert?: InputMaybe<GenericSocialShareUpsertWithNestedWhereUniqueInput>;
};

export type GenericSocialShareUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericSocialShareUpdateInput;
  /** Unique document search */
  where: GenericSocialShareWhereUniqueInput;
};

export type GenericSocialShareUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericSocialShareCreateInput;
  /** Update document if it exists */
  update: GenericSocialShareUpdateInput;
};

export type GenericSocialShareUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericSocialShareUpsertInput;
  /** Unique document search */
  where: GenericSocialShareWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericSocialShareWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericSocialShareWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericSocialShareWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericSocialShareWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericSocialShareWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  buttonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  buttonLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  buttonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  buttonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  buttonLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  buttonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  buttonLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  buttonLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericSocialShareWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericSocialShareWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericSocialShareWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values in which the union is empty */
  socialMediaList_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  socialMediaList_some?: InputMaybe<GenericSocialShareSocialMediaListWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericSocialShareWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericSocialShareWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericSocialShareWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericSocialShareWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericSocialShareWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericSocialShare record uniquely */
export type GenericSocialShareWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaData = Entity & Node & {
  __typename?: 'GlobalMetaData';
  /** The icon should be either 180x180 or 192x192 pixels */
  appleTouchIcon?: Maybe<Asset>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Can be overridden on each page. */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<GlobalMetaData>;
  /** An ID of the FB app to share website insight with */
  facebookAppId?: Maybe<Scalars['String']['output']>;
  /** upload favicon, best 32x32 .ico */
  favicon?: Maybe<Asset>;
  /** List of GlobalMetaData versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<Asset>;
  logo?: Maybe<Asset>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  siteName: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /**
   * title template that will be added to the page title
   * e.g. title = page title and titleTemplate = Dr Oetker
   * the page full title will be: Dr Oetker | page title
   */
  titleTemplate?: Maybe<Scalars['String']['output']>;
  twitterSeo?: Maybe<TwitterSeo>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  url: Scalars['String']['output'];
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataAppleTouchIconArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataFaviconArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataTwitterSeoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GlobalMetaDataConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GlobalMetaDataWhereUniqueInput;
};

/** A connection to a list of items. */
export type GlobalMetaDataConnection = {
  __typename?: 'GlobalMetaDataConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GlobalMetaDataEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GlobalMetaDataCreateInput = {
  appleTouchIcon?: InputMaybe<AssetCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facebookAppId?: InputMaybe<Scalars['String']['input']>;
  favicon?: InputMaybe<AssetCreateOneInlineInput>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  logo?: InputMaybe<AssetCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  siteName: Scalars['String']['input'];
  titleTemplate?: InputMaybe<Scalars['String']['input']>;
  twitterSeo?: InputMaybe<TwitterSeoCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type GlobalMetaDataCreateManyInlineInput = {
  /** Connect multiple existing GlobalMetaData documents */
  connect?: InputMaybe<Array<GlobalMetaDataWhereUniqueInput>>;
  /** Create and connect multiple existing GlobalMetaData documents */
  create?: InputMaybe<Array<GlobalMetaDataCreateInput>>;
};

export type GlobalMetaDataCreateOneInlineInput = {
  /** Connect one existing GlobalMetaData document */
  connect?: InputMaybe<GlobalMetaDataWhereUniqueInput>;
  /** Create and connect one GlobalMetaData document */
  create?: InputMaybe<GlobalMetaDataCreateInput>;
};

/** An edge in a connection. */
export type GlobalMetaDataEdge = {
  __typename?: 'GlobalMetaDataEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GlobalMetaData;
};

/** Identifies documents */
export type GlobalMetaDataManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GlobalMetaDataWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GlobalMetaDataWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GlobalMetaDataWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  appleTouchIcon?: InputMaybe<AssetWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<GlobalMetaDataWhereStageInput>;
  documentInStages_none?: InputMaybe<GlobalMetaDataWhereStageInput>;
  documentInStages_some?: InputMaybe<GlobalMetaDataWhereStageInput>;
  facebookAppId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  facebookAppId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  facebookAppId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  facebookAppId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  facebookAppId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  facebookAppId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  facebookAppId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  facebookAppId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  facebookAppId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  facebookAppId_starts_with?: InputMaybe<Scalars['String']['input']>;
  favicon?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  logo?: InputMaybe<AssetWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  siteName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  siteName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  siteName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  siteName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  siteName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  siteName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  siteName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  siteName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  siteName_starts_with?: InputMaybe<Scalars['String']['input']>;
  titleTemplate?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  titleTemplate_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  titleTemplate_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  titleTemplate_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  titleTemplate_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  titleTemplate_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  titleTemplate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  titleTemplate_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  titleTemplate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  titleTemplate_starts_with?: InputMaybe<Scalars['String']['input']>;
  twitterSeo?: InputMaybe<TwitterSeoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum GlobalMetaDataOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  facebookAppId_ASC = 'facebookAppId_ASC',
  facebookAppId_DESC = 'facebookAppId_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  siteName_ASC = 'siteName_ASC',
  siteName_DESC = 'siteName_DESC',
  titleTemplate_ASC = 'titleTemplate_ASC',
  titleTemplate_DESC = 'titleTemplate_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC'
}

export type GlobalMetaDataUpdateInput = {
  appleTouchIcon?: InputMaybe<AssetUpdateOneInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  facebookAppId?: InputMaybe<Scalars['String']['input']>;
  favicon?: InputMaybe<AssetUpdateOneInlineInput>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  logo?: InputMaybe<AssetUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  titleTemplate?: InputMaybe<Scalars['String']['input']>;
  twitterSeo?: InputMaybe<TwitterSeoUpdateOneInlineInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalMetaDataUpdateManyInlineInput = {
  /** Connect multiple existing GlobalMetaData documents */
  connect?: InputMaybe<Array<GlobalMetaDataConnectInput>>;
  /** Create and connect multiple GlobalMetaData documents */
  create?: InputMaybe<Array<GlobalMetaDataCreateInput>>;
  /** Delete multiple GlobalMetaData documents */
  delete?: InputMaybe<Array<GlobalMetaDataWhereUniqueInput>>;
  /** Disconnect multiple GlobalMetaData documents */
  disconnect?: InputMaybe<Array<GlobalMetaDataWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GlobalMetaData documents */
  set?: InputMaybe<Array<GlobalMetaDataWhereUniqueInput>>;
  /** Update multiple GlobalMetaData documents */
  update?: InputMaybe<Array<GlobalMetaDataUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GlobalMetaData documents */
  upsert?: InputMaybe<Array<GlobalMetaDataUpsertWithNestedWhereUniqueInput>>;
};

export type GlobalMetaDataUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  facebookAppId?: InputMaybe<Scalars['String']['input']>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  titleTemplate?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalMetaDataUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GlobalMetaDataUpdateManyInput;
  /** Document search */
  where: GlobalMetaDataWhereInput;
};

export type GlobalMetaDataUpdateOneInlineInput = {
  /** Connect existing GlobalMetaData document */
  connect?: InputMaybe<GlobalMetaDataWhereUniqueInput>;
  /** Create and connect one GlobalMetaData document */
  create?: InputMaybe<GlobalMetaDataCreateInput>;
  /** Delete currently connected GlobalMetaData document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GlobalMetaData document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GlobalMetaData document */
  update?: InputMaybe<GlobalMetaDataUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GlobalMetaData document */
  upsert?: InputMaybe<GlobalMetaDataUpsertWithNestedWhereUniqueInput>;
};

export type GlobalMetaDataUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GlobalMetaDataUpdateInput;
  /** Unique document search */
  where: GlobalMetaDataWhereUniqueInput;
};

export type GlobalMetaDataUpsertInput = {
  /** Create document if it didn't exist */
  create: GlobalMetaDataCreateInput;
  /** Update document if it exists */
  update: GlobalMetaDataUpdateInput;
};

export type GlobalMetaDataUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GlobalMetaDataUpsertInput;
  /** Unique document search */
  where: GlobalMetaDataWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GlobalMetaDataWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GlobalMetaDataWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GlobalMetaDataWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GlobalMetaDataWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GlobalMetaDataWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  appleTouchIcon?: InputMaybe<AssetWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<GlobalMetaDataWhereStageInput>;
  documentInStages_none?: InputMaybe<GlobalMetaDataWhereStageInput>;
  documentInStages_some?: InputMaybe<GlobalMetaDataWhereStageInput>;
  facebookAppId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  facebookAppId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  facebookAppId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  facebookAppId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  facebookAppId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  facebookAppId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  facebookAppId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  facebookAppId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  facebookAppId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  facebookAppId_starts_with?: InputMaybe<Scalars['String']['input']>;
  favicon?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  logo?: InputMaybe<AssetWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  siteName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  siteName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  siteName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  siteName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  siteName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  siteName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  siteName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  siteName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  siteName_starts_with?: InputMaybe<Scalars['String']['input']>;
  titleTemplate?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  titleTemplate_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  titleTemplate_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  titleTemplate_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  titleTemplate_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  titleTemplate_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  titleTemplate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  titleTemplate_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  titleTemplate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  titleTemplate_starts_with?: InputMaybe<Scalars['String']['input']>;
  twitterSeo?: InputMaybe<TwitterSeoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GlobalMetaDataWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GlobalMetaDataWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GlobalMetaDataWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GlobalMetaDataWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GlobalMetaDataWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GlobalMetaData record uniquely */
export type GlobalMetaDataWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
};

/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearch = Entity & Node & {
  __typename?: 'GlobalSearch';
  /** For background image of Global Search banner */
  backgroundAsset?: Maybe<AssetComponent>;
  backgroundAssetMobile?: Maybe<AssetComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GlobalSearch>;
  genericPages: Array<GenericPage>;
  /** List of GlobalSearch versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  leftAsset?: Maybe<AssetComponent>;
  market: Markets;
  marketName?: Maybe<Market>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  rightAsset?: Maybe<AssetComponent>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  superText?: Maybe<Scalars['String']['output']>;
  /** title of the banner */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchBackgroundAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchBackgroundAssetMobileArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchLeftAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchRightAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Global Search component - global search from within a page to ensure that users can easily find the search and access all site pages and content */
export type GlobalSearchUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GlobalSearchConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GlobalSearchWhereUniqueInput;
};

/** A connection to a list of items. */
export type GlobalSearchConnection = {
  __typename?: 'GlobalSearchConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GlobalSearchEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GlobalSearchCreateInput = {
  backgroundAsset?: InputMaybe<AssetComponentCreateOneInlineInput>;
  backgroundAssetMobile?: InputMaybe<AssetComponentCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  leftAsset?: InputMaybe<AssetComponentCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  rightAsset?: InputMaybe<AssetComponentCreateOneInlineInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GlobalSearchCreateManyInlineInput = {
  /** Connect multiple existing GlobalSearch documents */
  connect?: InputMaybe<Array<GlobalSearchWhereUniqueInput>>;
  /** Create and connect multiple existing GlobalSearch documents */
  create?: InputMaybe<Array<GlobalSearchCreateInput>>;
};

export type GlobalSearchCreateOneInlineInput = {
  /** Connect one existing GlobalSearch document */
  connect?: InputMaybe<GlobalSearchWhereUniqueInput>;
  /** Create and connect one GlobalSearch document */
  create?: InputMaybe<GlobalSearchCreateInput>;
};

/** An edge in a connection. */
export type GlobalSearchEdge = {
  __typename?: 'GlobalSearchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GlobalSearch;
};

/** Identifies documents */
export type GlobalSearchManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GlobalSearchWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GlobalSearchWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GlobalSearchWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundAsset?: InputMaybe<AssetComponentWhereInput>;
  backgroundAssetMobile?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GlobalSearchWhereStageInput>;
  documentInStages_none?: InputMaybe<GlobalSearchWhereStageInput>;
  documentInStages_some?: InputMaybe<GlobalSearchWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  leftAsset?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  rightAsset?: InputMaybe<AssetComponentWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GlobalSearchOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GlobalSearchUpdateInput = {
  backgroundAsset?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  backgroundAssetMobile?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  leftAsset?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  rightAsset?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalSearchUpdateManyInlineInput = {
  /** Connect multiple existing GlobalSearch documents */
  connect?: InputMaybe<Array<GlobalSearchConnectInput>>;
  /** Create and connect multiple GlobalSearch documents */
  create?: InputMaybe<Array<GlobalSearchCreateInput>>;
  /** Delete multiple GlobalSearch documents */
  delete?: InputMaybe<Array<GlobalSearchWhereUniqueInput>>;
  /** Disconnect multiple GlobalSearch documents */
  disconnect?: InputMaybe<Array<GlobalSearchWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GlobalSearch documents */
  set?: InputMaybe<Array<GlobalSearchWhereUniqueInput>>;
  /** Update multiple GlobalSearch documents */
  update?: InputMaybe<Array<GlobalSearchUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GlobalSearch documents */
  upsert?: InputMaybe<Array<GlobalSearchUpsertWithNestedWhereUniqueInput>>;
};

export type GlobalSearchUpdateManyInput = {
  market?: InputMaybe<Markets>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalSearchUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GlobalSearchUpdateManyInput;
  /** Document search */
  where: GlobalSearchWhereInput;
};

export type GlobalSearchUpdateOneInlineInput = {
  /** Connect existing GlobalSearch document */
  connect?: InputMaybe<GlobalSearchWhereUniqueInput>;
  /** Create and connect one GlobalSearch document */
  create?: InputMaybe<GlobalSearchCreateInput>;
  /** Delete currently connected GlobalSearch document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GlobalSearch document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GlobalSearch document */
  update?: InputMaybe<GlobalSearchUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GlobalSearch document */
  upsert?: InputMaybe<GlobalSearchUpsertWithNestedWhereUniqueInput>;
};

export type GlobalSearchUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GlobalSearchUpdateInput;
  /** Unique document search */
  where: GlobalSearchWhereUniqueInput;
};

export type GlobalSearchUpsertInput = {
  /** Create document if it didn't exist */
  create: GlobalSearchCreateInput;
  /** Update document if it exists */
  update: GlobalSearchUpdateInput;
};

export type GlobalSearchUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GlobalSearchUpsertInput;
  /** Unique document search */
  where: GlobalSearchWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GlobalSearchWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GlobalSearchWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GlobalSearchWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GlobalSearchWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GlobalSearchWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundAsset?: InputMaybe<AssetComponentWhereInput>;
  backgroundAssetMobile?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GlobalSearchWhereStageInput>;
  documentInStages_none?: InputMaybe<GlobalSearchWhereStageInput>;
  documentInStages_some?: InputMaybe<GlobalSearchWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  leftAsset?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  rightAsset?: InputMaybe<AssetComponentWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GlobalSearchWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GlobalSearchWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GlobalSearchWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GlobalSearchWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GlobalSearchWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GlobalSearch record uniquely */
export type GlobalSearchWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GridColumn = Entity & Node & {
  __typename?: 'GridColumn';
  assetComponent?: Maybe<AssetComponent>;
  cardData: Array<ImageAndTextCard>;
  /** Column Per Grid */
  column?: Maybe<Column>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Description on the grid */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<GridColumn>;
  genericPages: Array<GenericPage>;
  /** Add metaball behind the object */
  gridMetaball: Scalars['Boolean']['output'];
  /** Heading of the grid */
  heading?: Maybe<Scalars['String']['output']>;
  /** List of GridColumn versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Sub Heading info */
  subHeading?: Maybe<Scalars['String']['output']>;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GridColumnAssetComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GridColumnCardDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ImageAndTextCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageAndTextCardWhereInput>;
};


export type GridColumnCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GridColumnDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GridColumnGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GridColumnHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GridColumnMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GridColumnPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GridColumnScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GridColumnSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GridColumnTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GridColumnUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GridColumnComponent = Entity & Node & {
  __typename?: 'GridColumnComponent';
  assetComponent?: Maybe<AssetComponent>;
  cardData: Array<ImageAndTextCard>;
  /** Column Per Grid */
  column?: Maybe<Column>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Description on the grid */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<GridColumnComponent>;
  genericPages: Array<GenericPage>;
  /** Add metaball behind the object */
  gridMetaball: Scalars['Boolean']['output'];
  /** Heading of the grid  */
  heading?: Maybe<Scalars['String']['output']>;
  /** List of GridColumnComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Sub Heading info */
  subHeading?: Maybe<Scalars['String']['output']>;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GridColumnComponentAssetComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GridColumnComponentCardDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ImageAndTextCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageAndTextCardWhereInput>;
};


export type GridColumnComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GridColumnComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GridColumnComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GridColumnComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GridColumnComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GridColumnComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GridColumnComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GridColumnComponentSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GridColumnComponentTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GridColumnComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GridColumnComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GridColumnComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type GridColumnComponentConnection = {
  __typename?: 'GridColumnComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GridColumnComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GridColumnComponentCreateInput = {
  assetComponent?: InputMaybe<AssetComponentCreateOneInlineInput>;
  cardData?: InputMaybe<ImageAndTextCardCreateManyInlineInput>;
  column?: InputMaybe<Column>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  gridMetaball: Scalars['Boolean']['input'];
  heading?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GridColumnComponentCreateManyInlineInput = {
  /** Connect multiple existing GridColumnComponent documents */
  connect?: InputMaybe<Array<GridColumnComponentWhereUniqueInput>>;
  /** Create and connect multiple existing GridColumnComponent documents */
  create?: InputMaybe<Array<GridColumnComponentCreateInput>>;
};

export type GridColumnComponentCreateOneInlineInput = {
  /** Connect one existing GridColumnComponent document */
  connect?: InputMaybe<GridColumnComponentWhereUniqueInput>;
  /** Create and connect one GridColumnComponent document */
  create?: InputMaybe<GridColumnComponentCreateInput>;
};

/** An edge in a connection. */
export type GridColumnComponentEdge = {
  __typename?: 'GridColumnComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GridColumnComponent;
};

/** Identifies documents */
export type GridColumnComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GridColumnComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GridColumnComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GridColumnComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetComponent?: InputMaybe<AssetComponentWhereInput>;
  cardData_every?: InputMaybe<ImageAndTextCardWhereInput>;
  cardData_none?: InputMaybe<ImageAndTextCardWhereInput>;
  cardData_some?: InputMaybe<ImageAndTextCardWhereInput>;
  column?: InputMaybe<Column>;
  /** All values that are contained in given list. */
  column_in?: InputMaybe<Array<InputMaybe<Column>>>;
  /** Any other value that exists and is not equal to the given value. */
  column_not?: InputMaybe<Column>;
  /** All values that are not contained in given list. */
  column_not_in?: InputMaybe<Array<InputMaybe<Column>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<GridColumnComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<GridColumnComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<GridColumnComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  gridMetaball?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  gridMetaball_not?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GridColumnComponentOrderByInput {
  column_ASC = 'column_ASC',
  column_DESC = 'column_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  gridMetaball_ASC = 'gridMetaball_ASC',
  gridMetaball_DESC = 'gridMetaball_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subHeading_ASC = 'subHeading_ASC',
  subHeading_DESC = 'subHeading_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GridColumnComponentUpdateInput = {
  assetComponent?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  cardData?: InputMaybe<ImageAndTextCardUpdateManyInlineInput>;
  column?: InputMaybe<Column>;
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  gridMetaball?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type GridColumnComponentUpdateManyInlineInput = {
  /** Connect multiple existing GridColumnComponent documents */
  connect?: InputMaybe<Array<GridColumnComponentConnectInput>>;
  /** Create and connect multiple GridColumnComponent documents */
  create?: InputMaybe<Array<GridColumnComponentCreateInput>>;
  /** Delete multiple GridColumnComponent documents */
  delete?: InputMaybe<Array<GridColumnComponentWhereUniqueInput>>;
  /** Disconnect multiple GridColumnComponent documents */
  disconnect?: InputMaybe<Array<GridColumnComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GridColumnComponent documents */
  set?: InputMaybe<Array<GridColumnComponentWhereUniqueInput>>;
  /** Update multiple GridColumnComponent documents */
  update?: InputMaybe<Array<GridColumnComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GridColumnComponent documents */
  upsert?: InputMaybe<Array<GridColumnComponentUpsertWithNestedWhereUniqueInput>>;
};

export type GridColumnComponentUpdateManyInput = {
  column?: InputMaybe<Column>;
  description?: InputMaybe<Scalars['String']['input']>;
  gridMetaball?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type GridColumnComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GridColumnComponentUpdateManyInput;
  /** Document search */
  where: GridColumnComponentWhereInput;
};

export type GridColumnComponentUpdateOneInlineInput = {
  /** Connect existing GridColumnComponent document */
  connect?: InputMaybe<GridColumnComponentWhereUniqueInput>;
  /** Create and connect one GridColumnComponent document */
  create?: InputMaybe<GridColumnComponentCreateInput>;
  /** Delete currently connected GridColumnComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GridColumnComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GridColumnComponent document */
  update?: InputMaybe<GridColumnComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GridColumnComponent document */
  upsert?: InputMaybe<GridColumnComponentUpsertWithNestedWhereUniqueInput>;
};

export type GridColumnComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GridColumnComponentUpdateInput;
  /** Unique document search */
  where: GridColumnComponentWhereUniqueInput;
};

export type GridColumnComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: GridColumnComponentCreateInput;
  /** Update document if it exists */
  update: GridColumnComponentUpdateInput;
};

export type GridColumnComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GridColumnComponentUpsertInput;
  /** Unique document search */
  where: GridColumnComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GridColumnComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GridColumnComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GridColumnComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GridColumnComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GridColumnComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetComponent?: InputMaybe<AssetComponentWhereInput>;
  cardData_every?: InputMaybe<ImageAndTextCardWhereInput>;
  cardData_none?: InputMaybe<ImageAndTextCardWhereInput>;
  cardData_some?: InputMaybe<ImageAndTextCardWhereInput>;
  column?: InputMaybe<Column>;
  /** All values that are contained in given list. */
  column_in?: InputMaybe<Array<InputMaybe<Column>>>;
  /** Any other value that exists and is not equal to the given value. */
  column_not?: InputMaybe<Column>;
  /** All values that are not contained in given list. */
  column_not_in?: InputMaybe<Array<InputMaybe<Column>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<GridColumnComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<GridColumnComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<GridColumnComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  gridMetaball?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  gridMetaball_not?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GridColumnComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GridColumnComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GridColumnComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GridColumnComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GridColumnComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GridColumnComponent record uniquely */
export type GridColumnComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GridColumnConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GridColumnWhereUniqueInput;
};

/** A connection to a list of items. */
export type GridColumnConnection = {
  __typename?: 'GridColumnConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GridColumnEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GridColumnCreateInput = {
  assetComponent?: InputMaybe<AssetComponentCreateOneInlineInput>;
  cardData?: InputMaybe<ImageAndTextCardCreateManyInlineInput>;
  column?: InputMaybe<Column>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  gridMetaball: Scalars['Boolean']['input'];
  heading?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GridColumnCreateManyInlineInput = {
  /** Connect multiple existing GridColumn documents */
  connect?: InputMaybe<Array<GridColumnWhereUniqueInput>>;
  /** Create and connect multiple existing GridColumn documents */
  create?: InputMaybe<Array<GridColumnCreateInput>>;
};

export type GridColumnCreateOneInlineInput = {
  /** Connect one existing GridColumn document */
  connect?: InputMaybe<GridColumnWhereUniqueInput>;
  /** Create and connect one GridColumn document */
  create?: InputMaybe<GridColumnCreateInput>;
};

/** An edge in a connection. */
export type GridColumnEdge = {
  __typename?: 'GridColumnEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GridColumn;
};

/** Identifies documents */
export type GridColumnManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GridColumnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GridColumnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GridColumnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetComponent?: InputMaybe<AssetComponentWhereInput>;
  cardData_every?: InputMaybe<ImageAndTextCardWhereInput>;
  cardData_none?: InputMaybe<ImageAndTextCardWhereInput>;
  cardData_some?: InputMaybe<ImageAndTextCardWhereInput>;
  column?: InputMaybe<Column>;
  /** All values that are contained in given list. */
  column_in?: InputMaybe<Array<InputMaybe<Column>>>;
  /** Any other value that exists and is not equal to the given value. */
  column_not?: InputMaybe<Column>;
  /** All values that are not contained in given list. */
  column_not_in?: InputMaybe<Array<InputMaybe<Column>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<GridColumnWhereStageInput>;
  documentInStages_none?: InputMaybe<GridColumnWhereStageInput>;
  documentInStages_some?: InputMaybe<GridColumnWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  gridMetaball?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  gridMetaball_not?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GridColumnOrderByInput {
  column_ASC = 'column_ASC',
  column_DESC = 'column_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  gridMetaball_ASC = 'gridMetaball_ASC',
  gridMetaball_DESC = 'gridMetaball_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subHeading_ASC = 'subHeading_ASC',
  subHeading_DESC = 'subHeading_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GridColumnUpdateInput = {
  assetComponent?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  cardData?: InputMaybe<ImageAndTextCardUpdateManyInlineInput>;
  column?: InputMaybe<Column>;
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  gridMetaball?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type GridColumnUpdateManyInlineInput = {
  /** Connect multiple existing GridColumn documents */
  connect?: InputMaybe<Array<GridColumnConnectInput>>;
  /** Create and connect multiple GridColumn documents */
  create?: InputMaybe<Array<GridColumnCreateInput>>;
  /** Delete multiple GridColumn documents */
  delete?: InputMaybe<Array<GridColumnWhereUniqueInput>>;
  /** Disconnect multiple GridColumn documents */
  disconnect?: InputMaybe<Array<GridColumnWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GridColumn documents */
  set?: InputMaybe<Array<GridColumnWhereUniqueInput>>;
  /** Update multiple GridColumn documents */
  update?: InputMaybe<Array<GridColumnUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GridColumn documents */
  upsert?: InputMaybe<Array<GridColumnUpsertWithNestedWhereUniqueInput>>;
};

export type GridColumnUpdateManyInput = {
  column?: InputMaybe<Column>;
  description?: InputMaybe<Scalars['String']['input']>;
  gridMetaball?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type GridColumnUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GridColumnUpdateManyInput;
  /** Document search */
  where: GridColumnWhereInput;
};

export type GridColumnUpdateOneInlineInput = {
  /** Connect existing GridColumn document */
  connect?: InputMaybe<GridColumnWhereUniqueInput>;
  /** Create and connect one GridColumn document */
  create?: InputMaybe<GridColumnCreateInput>;
  /** Delete currently connected GridColumn document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GridColumn document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GridColumn document */
  update?: InputMaybe<GridColumnUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GridColumn document */
  upsert?: InputMaybe<GridColumnUpsertWithNestedWhereUniqueInput>;
};

export type GridColumnUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GridColumnUpdateInput;
  /** Unique document search */
  where: GridColumnWhereUniqueInput;
};

export type GridColumnUpsertInput = {
  /** Create document if it didn't exist */
  create: GridColumnCreateInput;
  /** Update document if it exists */
  update: GridColumnUpdateInput;
};

export type GridColumnUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GridColumnUpsertInput;
  /** Unique document search */
  where: GridColumnWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GridColumnWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GridColumnWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GridColumnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GridColumnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GridColumnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetComponent?: InputMaybe<AssetComponentWhereInput>;
  cardData_every?: InputMaybe<ImageAndTextCardWhereInput>;
  cardData_none?: InputMaybe<ImageAndTextCardWhereInput>;
  cardData_some?: InputMaybe<ImageAndTextCardWhereInput>;
  column?: InputMaybe<Column>;
  /** All values that are contained in given list. */
  column_in?: InputMaybe<Array<InputMaybe<Column>>>;
  /** Any other value that exists and is not equal to the given value. */
  column_not?: InputMaybe<Column>;
  /** All values that are not contained in given list. */
  column_not_in?: InputMaybe<Array<InputMaybe<Column>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<GridColumnWhereStageInput>;
  documentInStages_none?: InputMaybe<GridColumnWhereStageInput>;
  documentInStages_some?: InputMaybe<GridColumnWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  gridMetaball?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  gridMetaball_not?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GridColumnWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GridColumnWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GridColumnWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GridColumnWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GridColumnWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GridColumn record uniquely */
export type GridColumnWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** HTML tag for intro text title */
export enum Headlines {
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4'
}

/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBanner = Entity & Node & {
  __typename?: 'HeroBanner';
  alignment?: Maybe<AlignmentTypes>;
  anchorNav?: Maybe<AnchorNavigation>;
  backgroundColour: BannerVideoPlayAndTextColour;
  bannerDescriptionText?: Maybe<Scalars['String']['output']>;
  bannerImage: Array<Asset>;
  bannerSize?: Maybe<BannerHeight>;
  bannerTitle?: Maybe<Scalars['String']['output']>;
  /** Youtube video ID. For example: "51lpiNjAzYc" */
  bannerVideoUrl?: Maybe<Scalars['String']['output']>;
  buttonColor: ButtonColor;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<HeroBanner>;
  heroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** List of HeroBanner versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** If a mobile specific image is not given for this field then the main image is used as a fallback. */
  mobileImage?: Maybe<Asset>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  superText?: Maybe<Scalars['String']['output']>;
  /** Color of title and subtitle on hero banner */
  textColor: HeroBannerTextColor;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  verticalAlignment?: Maybe<VerticalAlignment>;
  /** Middle will be set if no value given */
  verticalAlignmentMobile?: Maybe<VerticalAlignment>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerBannerImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerHeroCarouselComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerMobileImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HeroBannerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HeroBannerWhereUniqueInput;
};

/** A connection to a list of items. */
export type HeroBannerConnection = {
  __typename?: 'HeroBannerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HeroBannerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HeroBannerCreateInput = {
  alignment?: InputMaybe<AlignmentTypes>;
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  backgroundColour: BannerVideoPlayAndTextColour;
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<AssetCreateManyInlineInput>;
  bannerSize?: InputMaybe<BannerHeight>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  bannerVideoUrl?: InputMaybe<Scalars['String']['input']>;
  buttonColor: ButtonColor;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateOneInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  mobileImage?: InputMaybe<AssetCreateOneInlineInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  textColor: HeroBannerTextColor;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  verticalAlignmentMobile?: InputMaybe<VerticalAlignment>;
};

export type HeroBannerCreateManyInlineInput = {
  /** Connect multiple existing HeroBanner documents */
  connect?: InputMaybe<Array<HeroBannerWhereUniqueInput>>;
  /** Create and connect multiple existing HeroBanner documents */
  create?: InputMaybe<Array<HeroBannerCreateInput>>;
};

export type HeroBannerCreateOneInlineInput = {
  /** Connect one existing HeroBanner document */
  connect?: InputMaybe<HeroBannerWhereUniqueInput>;
  /** Create and connect one HeroBanner document */
  create?: InputMaybe<HeroBannerCreateInput>;
};

/** An edge in a connection. */
export type HeroBannerEdge = {
  __typename?: 'HeroBannerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HeroBanner;
};

/** Identifies documents */
export type HeroBannerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<AlignmentTypes>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<AlignmentTypes>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundColour?: InputMaybe<BannerVideoPlayAndTextColour>;
  /** All values that are contained in given list. */
  backgroundColour_in?: InputMaybe<Array<InputMaybe<BannerVideoPlayAndTextColour>>>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundColour_not?: InputMaybe<BannerVideoPlayAndTextColour>;
  /** All values that are not contained in given list. */
  backgroundColour_not_in?: InputMaybe<Array<InputMaybe<BannerVideoPlayAndTextColour>>>;
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerDescriptionText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerDescriptionText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerDescriptionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerDescriptionText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerDescriptionText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerDescriptionText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerDescriptionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerDescriptionText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerDescriptionText_starts_with?: InputMaybe<Scalars['String']['input']>;
  bannerImage_every?: InputMaybe<AssetWhereInput>;
  bannerImage_none?: InputMaybe<AssetWhereInput>;
  bannerImage_some?: InputMaybe<AssetWhereInput>;
  bannerSize?: InputMaybe<BannerHeight>;
  /** All values that are contained in given list. */
  bannerSize_in?: InputMaybe<Array<InputMaybe<BannerHeight>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerSize_not?: InputMaybe<BannerHeight>;
  /** All values that are not contained in given list. */
  bannerSize_not_in?: InputMaybe<Array<InputMaybe<BannerHeight>>>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  bannerVideoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerVideoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerVideoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerVideoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerVideoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerVideoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerVideoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerVideoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerVideoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerVideoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  buttonColor?: InputMaybe<ButtonColor>;
  /** All values that are contained in given list. */
  buttonColor_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonColor_not?: InputMaybe<ButtonColor>;
  /** All values that are not contained in given list. */
  buttonColor_not_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HeroBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<HeroBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<HeroBannerWhereStageInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<HeroBannerTextColor>;
  /** All values that are contained in given list. */
  textColor_in?: InputMaybe<Array<InputMaybe<HeroBannerTextColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  textColor_not?: InputMaybe<HeroBannerTextColor>;
  /** All values that are not contained in given list. */
  textColor_not_in?: InputMaybe<Array<InputMaybe<HeroBannerTextColor>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  verticalAlignmentMobile?: InputMaybe<VerticalAlignment>;
  /** All values that are contained in given list. */
  verticalAlignmentMobile_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  verticalAlignmentMobile_not?: InputMaybe<VerticalAlignment>;
  /** All values that are not contained in given list. */
  verticalAlignmentMobile_not_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** All values that are contained in given list. */
  verticalAlignment_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  verticalAlignment_not?: InputMaybe<VerticalAlignment>;
  /** All values that are not contained in given list. */
  verticalAlignment_not_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
};

/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerMasterbrand = Entity & Node & {
  __typename?: 'HeroBannerMasterbrand';
  alignment?: Maybe<AlignmentTypes>;
  anchorNav?: Maybe<AnchorNavigation>;
  backgroundColour: BannerVideoPlayAndTextColour;
  bannerDescriptionText?: Maybe<Scalars['String']['output']>;
  bannerImage: Array<Asset>;
  bannerSize: BannerHeight;
  bannerSubtitle: Scalars['String']['output'];
  bannerTitle?: Maybe<Scalars['String']['output']>;
  /** Youtube video ID. For example: "51lpiNjAzYc" */
  bannerVideoUrl?: Maybe<Scalars['String']['output']>;
  buttonColor: ButtonColor;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<HeroBannerMasterbrand>;
  heroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** List of HeroBannerMasterbrand versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** If a mobile specific image is not given for this field then the main image is used as a fallback. */
  mobileImage?: Maybe<Asset>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** Show dark overlay to make subtitle more contrast */
  showOverlay: Scalars['Boolean']['output'];
  /** System stage field */
  stage: Stage;
  superText?: Maybe<Scalars['String']['output']>;
  /** Color of title and description on hero banner */
  textColor: HeroBannerTextColor;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  verticalAlignment?: Maybe<VerticalAlignment>;
  /** Middle will be set if no value given */
  verticalAlignmentMobile?: Maybe<VerticalAlignment>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerMasterbrandAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerMasterbrandBannerImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerMasterbrandCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerMasterbrandDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerMasterbrandHeroCarouselComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerMasterbrandHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerMasterbrandLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerMasterbrandMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerMasterbrandMobileImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerMasterbrandPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerMasterbrandScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerMasterbrandUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HeroBannerMasterbrandConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HeroBannerMasterbrandWhereUniqueInput;
};

/** A connection to a list of items. */
export type HeroBannerMasterbrandConnection = {
  __typename?: 'HeroBannerMasterbrandConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HeroBannerMasterbrandEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HeroBannerMasterbrandCreateInput = {
  alignment?: InputMaybe<AlignmentTypes>;
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  backgroundColour: BannerVideoPlayAndTextColour;
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<AssetCreateManyInlineInput>;
  bannerSize: BannerHeight;
  bannerSubtitle: Scalars['String']['input'];
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  bannerVideoUrl?: InputMaybe<Scalars['String']['input']>;
  buttonColor: ButtonColor;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateOneInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  mobileImage?: InputMaybe<AssetCreateOneInlineInput>;
  showOverlay: Scalars['Boolean']['input'];
  superText?: InputMaybe<Scalars['String']['input']>;
  textColor: HeroBannerTextColor;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  verticalAlignmentMobile?: InputMaybe<VerticalAlignment>;
};

export type HeroBannerMasterbrandCreateManyInlineInput = {
  /** Connect multiple existing HeroBannerMasterbrand documents */
  connect?: InputMaybe<Array<HeroBannerMasterbrandWhereUniqueInput>>;
  /** Create and connect multiple existing HeroBannerMasterbrand documents */
  create?: InputMaybe<Array<HeroBannerMasterbrandCreateInput>>;
};

export type HeroBannerMasterbrandCreateOneInlineInput = {
  /** Connect one existing HeroBannerMasterbrand document */
  connect?: InputMaybe<HeroBannerMasterbrandWhereUniqueInput>;
  /** Create and connect one HeroBannerMasterbrand document */
  create?: InputMaybe<HeroBannerMasterbrandCreateInput>;
};

/** An edge in a connection. */
export type HeroBannerMasterbrandEdge = {
  __typename?: 'HeroBannerMasterbrandEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HeroBannerMasterbrand;
};

/** Identifies documents */
export type HeroBannerMasterbrandManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroBannerMasterbrandWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroBannerMasterbrandWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroBannerMasterbrandWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<AlignmentTypes>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<AlignmentTypes>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundColour?: InputMaybe<BannerVideoPlayAndTextColour>;
  /** All values that are contained in given list. */
  backgroundColour_in?: InputMaybe<Array<InputMaybe<BannerVideoPlayAndTextColour>>>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundColour_not?: InputMaybe<BannerVideoPlayAndTextColour>;
  /** All values that are not contained in given list. */
  backgroundColour_not_in?: InputMaybe<Array<InputMaybe<BannerVideoPlayAndTextColour>>>;
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerDescriptionText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerDescriptionText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerDescriptionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerDescriptionText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerDescriptionText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerDescriptionText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerDescriptionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerDescriptionText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerDescriptionText_starts_with?: InputMaybe<Scalars['String']['input']>;
  bannerImage_every?: InputMaybe<AssetWhereInput>;
  bannerImage_none?: InputMaybe<AssetWhereInput>;
  bannerImage_some?: InputMaybe<AssetWhereInput>;
  bannerSize?: InputMaybe<BannerHeight>;
  /** All values that are contained in given list. */
  bannerSize_in?: InputMaybe<Array<InputMaybe<BannerHeight>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerSize_not?: InputMaybe<BannerHeight>;
  /** All values that are not contained in given list. */
  bannerSize_not_in?: InputMaybe<Array<InputMaybe<BannerHeight>>>;
  bannerSubtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerSubtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerSubtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerSubtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerSubtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerSubtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerSubtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerSubtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerSubtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerSubtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  bannerVideoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerVideoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerVideoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerVideoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerVideoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerVideoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerVideoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerVideoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerVideoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerVideoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  buttonColor?: InputMaybe<ButtonColor>;
  /** All values that are contained in given list. */
  buttonColor_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonColor_not?: InputMaybe<ButtonColor>;
  /** All values that are not contained in given list. */
  buttonColor_not_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HeroBannerMasterbrandWhereStageInput>;
  documentInStages_none?: InputMaybe<HeroBannerMasterbrandWhereStageInput>;
  documentInStages_some?: InputMaybe<HeroBannerMasterbrandWhereStageInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showOverlay_not?: InputMaybe<Scalars['Boolean']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<HeroBannerTextColor>;
  /** All values that are contained in given list. */
  textColor_in?: InputMaybe<Array<InputMaybe<HeroBannerTextColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  textColor_not?: InputMaybe<HeroBannerTextColor>;
  /** All values that are not contained in given list. */
  textColor_not_in?: InputMaybe<Array<InputMaybe<HeroBannerTextColor>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  verticalAlignmentMobile?: InputMaybe<VerticalAlignment>;
  /** All values that are contained in given list. */
  verticalAlignmentMobile_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  verticalAlignmentMobile_not?: InputMaybe<VerticalAlignment>;
  /** All values that are not contained in given list. */
  verticalAlignmentMobile_not_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** All values that are contained in given list. */
  verticalAlignment_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  verticalAlignment_not?: InputMaybe<VerticalAlignment>;
  /** All values that are not contained in given list. */
  verticalAlignment_not_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
};

export enum HeroBannerMasterbrandOrderByInput {
  alignment_ASC = 'alignment_ASC',
  alignment_DESC = 'alignment_DESC',
  backgroundColour_ASC = 'backgroundColour_ASC',
  backgroundColour_DESC = 'backgroundColour_DESC',
  bannerDescriptionText_ASC = 'bannerDescriptionText_ASC',
  bannerDescriptionText_DESC = 'bannerDescriptionText_DESC',
  bannerSize_ASC = 'bannerSize_ASC',
  bannerSize_DESC = 'bannerSize_DESC',
  bannerSubtitle_ASC = 'bannerSubtitle_ASC',
  bannerSubtitle_DESC = 'bannerSubtitle_DESC',
  bannerTitle_ASC = 'bannerTitle_ASC',
  bannerTitle_DESC = 'bannerTitle_DESC',
  bannerVideoUrl_ASC = 'bannerVideoUrl_ASC',
  bannerVideoUrl_DESC = 'bannerVideoUrl_DESC',
  buttonColor_ASC = 'buttonColor_ASC',
  buttonColor_DESC = 'buttonColor_DESC',
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  showOverlay_ASC = 'showOverlay_ASC',
  showOverlay_DESC = 'showOverlay_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  textColor_ASC = 'textColor_ASC',
  textColor_DESC = 'textColor_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  verticalAlignmentMobile_ASC = 'verticalAlignmentMobile_ASC',
  verticalAlignmentMobile_DESC = 'verticalAlignmentMobile_DESC',
  verticalAlignment_ASC = 'verticalAlignment_ASC',
  verticalAlignment_DESC = 'verticalAlignment_DESC'
}

export type HeroBannerMasterbrandUpdateInput = {
  alignment?: InputMaybe<AlignmentTypes>;
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  backgroundColour?: InputMaybe<BannerVideoPlayAndTextColour>;
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<AssetUpdateManyInlineInput>;
  bannerSize?: InputMaybe<BannerHeight>;
  bannerSubtitle?: InputMaybe<Scalars['String']['input']>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  bannerVideoUrl?: InputMaybe<Scalars['String']['input']>;
  buttonColor?: InputMaybe<ButtonColor>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateOneInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  mobileImage?: InputMaybe<AssetUpdateOneInlineInput>;
  showOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<HeroBannerTextColor>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  verticalAlignmentMobile?: InputMaybe<VerticalAlignment>;
};

export type HeroBannerMasterbrandUpdateManyInlineInput = {
  /** Connect multiple existing HeroBannerMasterbrand documents */
  connect?: InputMaybe<Array<HeroBannerMasterbrandConnectInput>>;
  /** Create and connect multiple HeroBannerMasterbrand documents */
  create?: InputMaybe<Array<HeroBannerMasterbrandCreateInput>>;
  /** Delete multiple HeroBannerMasterbrand documents */
  delete?: InputMaybe<Array<HeroBannerMasterbrandWhereUniqueInput>>;
  /** Disconnect multiple HeroBannerMasterbrand documents */
  disconnect?: InputMaybe<Array<HeroBannerMasterbrandWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HeroBannerMasterbrand documents */
  set?: InputMaybe<Array<HeroBannerMasterbrandWhereUniqueInput>>;
  /** Update multiple HeroBannerMasterbrand documents */
  update?: InputMaybe<Array<HeroBannerMasterbrandUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HeroBannerMasterbrand documents */
  upsert?: InputMaybe<Array<HeroBannerMasterbrandUpsertWithNestedWhereUniqueInput>>;
};

export type HeroBannerMasterbrandUpdateManyInput = {
  alignment?: InputMaybe<AlignmentTypes>;
  backgroundColour?: InputMaybe<BannerVideoPlayAndTextColour>;
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  bannerSize?: InputMaybe<BannerHeight>;
  bannerSubtitle?: InputMaybe<Scalars['String']['input']>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  bannerVideoUrl?: InputMaybe<Scalars['String']['input']>;
  buttonColor?: InputMaybe<ButtonColor>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  showOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<HeroBannerTextColor>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  verticalAlignmentMobile?: InputMaybe<VerticalAlignment>;
};

export type HeroBannerMasterbrandUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeroBannerMasterbrandUpdateManyInput;
  /** Document search */
  where: HeroBannerMasterbrandWhereInput;
};

export type HeroBannerMasterbrandUpdateOneInlineInput = {
  /** Connect existing HeroBannerMasterbrand document */
  connect?: InputMaybe<HeroBannerMasterbrandWhereUniqueInput>;
  /** Create and connect one HeroBannerMasterbrand document */
  create?: InputMaybe<HeroBannerMasterbrandCreateInput>;
  /** Delete currently connected HeroBannerMasterbrand document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HeroBannerMasterbrand document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HeroBannerMasterbrand document */
  update?: InputMaybe<HeroBannerMasterbrandUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HeroBannerMasterbrand document */
  upsert?: InputMaybe<HeroBannerMasterbrandUpsertWithNestedWhereUniqueInput>;
};

export type HeroBannerMasterbrandUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeroBannerMasterbrandUpdateInput;
  /** Unique document search */
  where: HeroBannerMasterbrandWhereUniqueInput;
};

export type HeroBannerMasterbrandUpsertInput = {
  /** Create document if it didn't exist */
  create: HeroBannerMasterbrandCreateInput;
  /** Update document if it exists */
  update: HeroBannerMasterbrandUpdateInput;
};

export type HeroBannerMasterbrandUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeroBannerMasterbrandUpsertInput;
  /** Unique document search */
  where: HeroBannerMasterbrandWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type HeroBannerMasterbrandWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type HeroBannerMasterbrandWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroBannerMasterbrandWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroBannerMasterbrandWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroBannerMasterbrandWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<AlignmentTypes>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<AlignmentTypes>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundColour?: InputMaybe<BannerVideoPlayAndTextColour>;
  /** All values that are contained in given list. */
  backgroundColour_in?: InputMaybe<Array<InputMaybe<BannerVideoPlayAndTextColour>>>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundColour_not?: InputMaybe<BannerVideoPlayAndTextColour>;
  /** All values that are not contained in given list. */
  backgroundColour_not_in?: InputMaybe<Array<InputMaybe<BannerVideoPlayAndTextColour>>>;
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerDescriptionText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerDescriptionText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerDescriptionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerDescriptionText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerDescriptionText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerDescriptionText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerDescriptionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerDescriptionText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerDescriptionText_starts_with?: InputMaybe<Scalars['String']['input']>;
  bannerImage_every?: InputMaybe<AssetWhereInput>;
  bannerImage_none?: InputMaybe<AssetWhereInput>;
  bannerImage_some?: InputMaybe<AssetWhereInput>;
  bannerSize?: InputMaybe<BannerHeight>;
  /** All values that are contained in given list. */
  bannerSize_in?: InputMaybe<Array<InputMaybe<BannerHeight>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerSize_not?: InputMaybe<BannerHeight>;
  /** All values that are not contained in given list. */
  bannerSize_not_in?: InputMaybe<Array<InputMaybe<BannerHeight>>>;
  bannerSubtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerSubtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerSubtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerSubtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerSubtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerSubtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerSubtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerSubtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerSubtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerSubtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  bannerVideoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerVideoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerVideoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerVideoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerVideoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerVideoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerVideoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerVideoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerVideoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerVideoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  buttonColor?: InputMaybe<ButtonColor>;
  /** All values that are contained in given list. */
  buttonColor_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonColor_not?: InputMaybe<ButtonColor>;
  /** All values that are not contained in given list. */
  buttonColor_not_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HeroBannerMasterbrandWhereStageInput>;
  documentInStages_none?: InputMaybe<HeroBannerMasterbrandWhereStageInput>;
  documentInStages_some?: InputMaybe<HeroBannerMasterbrandWhereStageInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showOverlay_not?: InputMaybe<Scalars['Boolean']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<HeroBannerTextColor>;
  /** All values that are contained in given list. */
  textColor_in?: InputMaybe<Array<InputMaybe<HeroBannerTextColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  textColor_not?: InputMaybe<HeroBannerTextColor>;
  /** All values that are not contained in given list. */
  textColor_not_in?: InputMaybe<Array<InputMaybe<HeroBannerTextColor>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  verticalAlignmentMobile?: InputMaybe<VerticalAlignment>;
  /** All values that are contained in given list. */
  verticalAlignmentMobile_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  verticalAlignmentMobile_not?: InputMaybe<VerticalAlignment>;
  /** All values that are not contained in given list. */
  verticalAlignmentMobile_not_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** All values that are contained in given list. */
  verticalAlignment_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  verticalAlignment_not?: InputMaybe<VerticalAlignment>;
  /** All values that are not contained in given list. */
  verticalAlignment_not_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HeroBannerMasterbrandWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroBannerMasterbrandWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroBannerMasterbrandWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroBannerMasterbrandWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HeroBannerMasterbrandWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References HeroBannerMasterbrand record uniquely */
export type HeroBannerMasterbrandWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum HeroBannerOrderByInput {
  alignment_ASC = 'alignment_ASC',
  alignment_DESC = 'alignment_DESC',
  backgroundColour_ASC = 'backgroundColour_ASC',
  backgroundColour_DESC = 'backgroundColour_DESC',
  bannerDescriptionText_ASC = 'bannerDescriptionText_ASC',
  bannerDescriptionText_DESC = 'bannerDescriptionText_DESC',
  bannerSize_ASC = 'bannerSize_ASC',
  bannerSize_DESC = 'bannerSize_DESC',
  bannerTitle_ASC = 'bannerTitle_ASC',
  bannerTitle_DESC = 'bannerTitle_DESC',
  bannerVideoUrl_ASC = 'bannerVideoUrl_ASC',
  bannerVideoUrl_DESC = 'bannerVideoUrl_DESC',
  buttonColor_ASC = 'buttonColor_ASC',
  buttonColor_DESC = 'buttonColor_DESC',
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  textColor_ASC = 'textColor_ASC',
  textColor_DESC = 'textColor_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  verticalAlignmentMobile_ASC = 'verticalAlignmentMobile_ASC',
  verticalAlignmentMobile_DESC = 'verticalAlignmentMobile_DESC',
  verticalAlignment_ASC = 'verticalAlignment_ASC',
  verticalAlignment_DESC = 'verticalAlignment_DESC'
}

/** Color of title and subtitle on hero banner */
export enum HeroBannerTextColor {
  Black = 'Black',
  White = 'White'
}

export type HeroBannerUpdateInput = {
  alignment?: InputMaybe<AlignmentTypes>;
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  backgroundColour?: InputMaybe<BannerVideoPlayAndTextColour>;
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<AssetUpdateManyInlineInput>;
  bannerSize?: InputMaybe<BannerHeight>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  bannerVideoUrl?: InputMaybe<Scalars['String']['input']>;
  buttonColor?: InputMaybe<ButtonColor>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateOneInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  mobileImage?: InputMaybe<AssetUpdateOneInlineInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<HeroBannerTextColor>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  verticalAlignmentMobile?: InputMaybe<VerticalAlignment>;
};

export type HeroBannerUpdateManyInlineInput = {
  /** Connect multiple existing HeroBanner documents */
  connect?: InputMaybe<Array<HeroBannerConnectInput>>;
  /** Create and connect multiple HeroBanner documents */
  create?: InputMaybe<Array<HeroBannerCreateInput>>;
  /** Delete multiple HeroBanner documents */
  delete?: InputMaybe<Array<HeroBannerWhereUniqueInput>>;
  /** Disconnect multiple HeroBanner documents */
  disconnect?: InputMaybe<Array<HeroBannerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HeroBanner documents */
  set?: InputMaybe<Array<HeroBannerWhereUniqueInput>>;
  /** Update multiple HeroBanner documents */
  update?: InputMaybe<Array<HeroBannerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HeroBanner documents */
  upsert?: InputMaybe<Array<HeroBannerUpsertWithNestedWhereUniqueInput>>;
};

export type HeroBannerUpdateManyInput = {
  alignment?: InputMaybe<AlignmentTypes>;
  backgroundColour?: InputMaybe<BannerVideoPlayAndTextColour>;
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  bannerSize?: InputMaybe<BannerHeight>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  bannerVideoUrl?: InputMaybe<Scalars['String']['input']>;
  buttonColor?: InputMaybe<ButtonColor>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  superText?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<HeroBannerTextColor>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  verticalAlignmentMobile?: InputMaybe<VerticalAlignment>;
};

export type HeroBannerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeroBannerUpdateManyInput;
  /** Document search */
  where: HeroBannerWhereInput;
};

export type HeroBannerUpdateOneInlineInput = {
  /** Connect existing HeroBanner document */
  connect?: InputMaybe<HeroBannerWhereUniqueInput>;
  /** Create and connect one HeroBanner document */
  create?: InputMaybe<HeroBannerCreateInput>;
  /** Delete currently connected HeroBanner document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HeroBanner document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HeroBanner document */
  update?: InputMaybe<HeroBannerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HeroBanner document */
  upsert?: InputMaybe<HeroBannerUpsertWithNestedWhereUniqueInput>;
};

export type HeroBannerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeroBannerUpdateInput;
  /** Unique document search */
  where: HeroBannerWhereUniqueInput;
};

export type HeroBannerUpsertInput = {
  /** Create document if it didn't exist */
  create: HeroBannerCreateInput;
  /** Update document if it exists */
  update: HeroBannerUpdateInput;
};

export type HeroBannerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeroBannerUpsertInput;
  /** Unique document search */
  where: HeroBannerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type HeroBannerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type HeroBannerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<AlignmentTypes>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<AlignmentTypes>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundColour?: InputMaybe<BannerVideoPlayAndTextColour>;
  /** All values that are contained in given list. */
  backgroundColour_in?: InputMaybe<Array<InputMaybe<BannerVideoPlayAndTextColour>>>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundColour_not?: InputMaybe<BannerVideoPlayAndTextColour>;
  /** All values that are not contained in given list. */
  backgroundColour_not_in?: InputMaybe<Array<InputMaybe<BannerVideoPlayAndTextColour>>>;
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerDescriptionText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerDescriptionText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerDescriptionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerDescriptionText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerDescriptionText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerDescriptionText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerDescriptionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerDescriptionText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerDescriptionText_starts_with?: InputMaybe<Scalars['String']['input']>;
  bannerImage_every?: InputMaybe<AssetWhereInput>;
  bannerImage_none?: InputMaybe<AssetWhereInput>;
  bannerImage_some?: InputMaybe<AssetWhereInput>;
  bannerSize?: InputMaybe<BannerHeight>;
  /** All values that are contained in given list. */
  bannerSize_in?: InputMaybe<Array<InputMaybe<BannerHeight>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerSize_not?: InputMaybe<BannerHeight>;
  /** All values that are not contained in given list. */
  bannerSize_not_in?: InputMaybe<Array<InputMaybe<BannerHeight>>>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  bannerVideoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerVideoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerVideoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerVideoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerVideoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerVideoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerVideoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerVideoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerVideoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerVideoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  buttonColor?: InputMaybe<ButtonColor>;
  /** All values that are contained in given list. */
  buttonColor_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonColor_not?: InputMaybe<ButtonColor>;
  /** All values that are not contained in given list. */
  buttonColor_not_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HeroBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<HeroBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<HeroBannerWhereStageInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<HeroBannerTextColor>;
  /** All values that are contained in given list. */
  textColor_in?: InputMaybe<Array<InputMaybe<HeroBannerTextColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  textColor_not?: InputMaybe<HeroBannerTextColor>;
  /** All values that are not contained in given list. */
  textColor_not_in?: InputMaybe<Array<InputMaybe<HeroBannerTextColor>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  verticalAlignmentMobile?: InputMaybe<VerticalAlignment>;
  /** All values that are contained in given list. */
  verticalAlignmentMobile_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  verticalAlignmentMobile_not?: InputMaybe<VerticalAlignment>;
  /** All values that are not contained in given list. */
  verticalAlignmentMobile_not_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** All values that are contained in given list. */
  verticalAlignment_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  verticalAlignment_not?: InputMaybe<VerticalAlignment>;
  /** All values that are not contained in given list. */
  verticalAlignment_not_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HeroBannerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroBannerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroBannerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroBannerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HeroBannerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References HeroBanner record uniquely */
export type HeroBannerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Carousel component for page hero's */
export type HeroCarouselComponent = Entity & Node & {
  __typename?: 'HeroCarouselComponent';
  anchorNav?: Maybe<AnchorNavigation>;
  bannerMasterbrands: Array<HeroBannerMasterbrand>;
  banners: Array<HeroBanner>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<HeroCarouselComponent>;
  genericPages: Array<GenericPage>;
  /** List of HeroCarouselComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentBannerMasterbrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroBannerMasterbrandOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroBannerMasterbrandWhereInput>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentBannersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroBannerWhereInput>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HeroCarouselComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HeroCarouselComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type HeroCarouselComponentConnection = {
  __typename?: 'HeroCarouselComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HeroCarouselComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HeroCarouselComponentCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  bannerMasterbrands?: InputMaybe<HeroBannerMasterbrandCreateManyInlineInput>;
  banners?: InputMaybe<HeroBannerCreateManyInlineInput>;
  ckvkxlnl16n1h01y05wom2tey?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  ckvkxndcy6r6u01z00kbi509o?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  ckvkxqjk56jjz01wiaqty1471?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  ckvkxrn0y6gtl01xnaya2hj3r?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  ckvle5wmp02us01xk32hy4ozh?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HeroCarouselComponentCreateManyInlineInput = {
  /** Connect multiple existing HeroCarouselComponent documents */
  connect?: InputMaybe<Array<HeroCarouselComponentWhereUniqueInput>>;
  /** Create and connect multiple existing HeroCarouselComponent documents */
  create?: InputMaybe<Array<HeroCarouselComponentCreateInput>>;
};

export type HeroCarouselComponentCreateOneInlineInput = {
  /** Connect one existing HeroCarouselComponent document */
  connect?: InputMaybe<HeroCarouselComponentWhereUniqueInput>;
  /** Create and connect one HeroCarouselComponent document */
  create?: InputMaybe<HeroCarouselComponentCreateInput>;
};

/** An edge in a connection. */
export type HeroCarouselComponentEdge = {
  __typename?: 'HeroCarouselComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HeroCarouselComponent;
};

/** Identifies documents */
export type HeroCarouselComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroCarouselComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroCarouselComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroCarouselComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  bannerMasterbrands_every?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  bannerMasterbrands_none?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  bannerMasterbrands_some?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  banners_every?: InputMaybe<HeroBannerWhereInput>;
  banners_none?: InputMaybe<HeroBannerWhereInput>;
  banners_some?: InputMaybe<HeroBannerWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HeroCarouselComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<HeroCarouselComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<HeroCarouselComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum HeroCarouselComponentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type HeroCarouselComponentUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  bannerMasterbrands?: InputMaybe<HeroBannerMasterbrandUpdateManyInlineInput>;
  banners?: InputMaybe<HeroBannerUpdateManyInlineInput>;
  ckvkxlnl16n1h01y05wom2tey?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  ckvkxndcy6r6u01z00kbi509o?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  ckvkxqjk56jjz01wiaqty1471?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  ckvkxrn0y6gtl01xnaya2hj3r?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  ckvle5wmp02us01xk32hy4ozh?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HeroCarouselComponentUpdateManyInlineInput = {
  /** Connect multiple existing HeroCarouselComponent documents */
  connect?: InputMaybe<Array<HeroCarouselComponentConnectInput>>;
  /** Create and connect multiple HeroCarouselComponent documents */
  create?: InputMaybe<Array<HeroCarouselComponentCreateInput>>;
  /** Delete multiple HeroCarouselComponent documents */
  delete?: InputMaybe<Array<HeroCarouselComponentWhereUniqueInput>>;
  /** Disconnect multiple HeroCarouselComponent documents */
  disconnect?: InputMaybe<Array<HeroCarouselComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HeroCarouselComponent documents */
  set?: InputMaybe<Array<HeroCarouselComponentWhereUniqueInput>>;
  /** Update multiple HeroCarouselComponent documents */
  update?: InputMaybe<Array<HeroCarouselComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HeroCarouselComponent documents */
  upsert?: InputMaybe<Array<HeroCarouselComponentUpsertWithNestedWhereUniqueInput>>;
};

export type HeroCarouselComponentUpdateManyInput = {
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HeroCarouselComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeroCarouselComponentUpdateManyInput;
  /** Document search */
  where: HeroCarouselComponentWhereInput;
};

export type HeroCarouselComponentUpdateOneInlineInput = {
  /** Connect existing HeroCarouselComponent document */
  connect?: InputMaybe<HeroCarouselComponentWhereUniqueInput>;
  /** Create and connect one HeroCarouselComponent document */
  create?: InputMaybe<HeroCarouselComponentCreateInput>;
  /** Delete currently connected HeroCarouselComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HeroCarouselComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HeroCarouselComponent document */
  update?: InputMaybe<HeroCarouselComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HeroCarouselComponent document */
  upsert?: InputMaybe<HeroCarouselComponentUpsertWithNestedWhereUniqueInput>;
};

export type HeroCarouselComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeroCarouselComponentUpdateInput;
  /** Unique document search */
  where: HeroCarouselComponentWhereUniqueInput;
};

export type HeroCarouselComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: HeroCarouselComponentCreateInput;
  /** Update document if it exists */
  update: HeroCarouselComponentUpdateInput;
};

export type HeroCarouselComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeroCarouselComponentUpsertInput;
  /** Unique document search */
  where: HeroCarouselComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type HeroCarouselComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type HeroCarouselComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroCarouselComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroCarouselComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroCarouselComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  bannerMasterbrands_every?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  bannerMasterbrands_none?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  bannerMasterbrands_some?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  banners_every?: InputMaybe<HeroBannerWhereInput>;
  banners_none?: InputMaybe<HeroBannerWhereInput>;
  banners_some?: InputMaybe<HeroBannerWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HeroCarouselComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<HeroCarouselComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<HeroCarouselComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HeroCarouselComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroCarouselComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroCarouselComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroCarouselComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HeroCarouselComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References HeroCarouselComponent record uniquely */
export type HeroCarouselComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Page header (can be a picture and in some pages even a video). */
export type HeroComponent = Entity & Node & {
  __typename?: 'HeroComponent';
  /** set alignment for content - left / right / center */
  alignment?: Maybe<AlignmentTypes>;
  anchorNav?: Maybe<AnchorNavigation>;
  bottomLeftImageAsset?: Maybe<Asset>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /**
   * description text to be used by the hero component
   *
   *
   *
   *
   *
   *
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<HeroComponent>;
  genericPages: Array<GenericPage>;
  /** List of HeroComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  imageComponent?: Maybe<AssetComponent>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** add image to display for mobile/smaller screens */
  mobileImage?: Maybe<Asset>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  superText?: Maybe<Scalars['String']['output']>;
  /** Color of title, description and super text */
  textColor: HeroBannerTextColor;
  /** Title to be used by the hero component */
  title?: Maybe<Scalars['String']['output']>;
  topRightImageAsset?: Maybe<Asset>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Middle will be set if no value given */
  verticalAlignment?: Maybe<VerticalAlignment>;
  /** Middle will be set if no value given */
  verticalAlignmentMobile?: Maybe<VerticalAlignment>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentBottomLeftImageAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentImageComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentMobileImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentTopRightImageAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HeroComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HeroComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type HeroComponentConnection = {
  __typename?: 'HeroComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HeroComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HeroComponentCreateInput = {
  alignment?: InputMaybe<AlignmentTypes>;
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  bottomLeftImageAsset?: InputMaybe<AssetCreateOneInlineInput>;
  ckuqwkoe91gkt01xq7hz044xn?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  imageComponent?: InputMaybe<AssetComponentCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  mobileImage?: InputMaybe<AssetCreateOneInlineInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  textColor: HeroBannerTextColor;
  title?: InputMaybe<Scalars['String']['input']>;
  topRightImageAsset?: InputMaybe<AssetCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  verticalAlignmentMobile?: InputMaybe<VerticalAlignment>;
};

export type HeroComponentCreateManyInlineInput = {
  /** Connect multiple existing HeroComponent documents */
  connect?: InputMaybe<Array<HeroComponentWhereUniqueInput>>;
  /** Create and connect multiple existing HeroComponent documents */
  create?: InputMaybe<Array<HeroComponentCreateInput>>;
};

export type HeroComponentCreateOneInlineInput = {
  /** Connect one existing HeroComponent document */
  connect?: InputMaybe<HeroComponentWhereUniqueInput>;
  /** Create and connect one HeroComponent document */
  create?: InputMaybe<HeroComponentCreateInput>;
};

/** An edge in a connection. */
export type HeroComponentEdge = {
  __typename?: 'HeroComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HeroComponent;
};

/** Identifies documents */
export type HeroComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<AlignmentTypes>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<AlignmentTypes>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  bottomLeftImageAsset?: InputMaybe<AssetWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<HeroComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<HeroComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<HeroComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageComponent?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<HeroBannerTextColor>;
  /** All values that are contained in given list. */
  textColor_in?: InputMaybe<Array<InputMaybe<HeroBannerTextColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  textColor_not?: InputMaybe<HeroBannerTextColor>;
  /** All values that are not contained in given list. */
  textColor_not_in?: InputMaybe<Array<InputMaybe<HeroBannerTextColor>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  topRightImageAsset?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  verticalAlignmentMobile?: InputMaybe<VerticalAlignment>;
  /** All values that are contained in given list. */
  verticalAlignmentMobile_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  verticalAlignmentMobile_not?: InputMaybe<VerticalAlignment>;
  /** All values that are not contained in given list. */
  verticalAlignmentMobile_not_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** All values that are contained in given list. */
  verticalAlignment_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  verticalAlignment_not?: InputMaybe<VerticalAlignment>;
  /** All values that are not contained in given list. */
  verticalAlignment_not_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
};

export enum HeroComponentOrderByInput {
  alignment_ASC = 'alignment_ASC',
  alignment_DESC = 'alignment_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  textColor_ASC = 'textColor_ASC',
  textColor_DESC = 'textColor_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  verticalAlignmentMobile_ASC = 'verticalAlignmentMobile_ASC',
  verticalAlignmentMobile_DESC = 'verticalAlignmentMobile_DESC',
  verticalAlignment_ASC = 'verticalAlignment_ASC',
  verticalAlignment_DESC = 'verticalAlignment_DESC'
}

export type HeroComponentUpdateInput = {
  alignment?: InputMaybe<AlignmentTypes>;
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  bottomLeftImageAsset?: InputMaybe<AssetUpdateOneInlineInput>;
  ckuqwkoe91gkt01xq7hz044xn?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  imageComponent?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  mobileImage?: InputMaybe<AssetUpdateOneInlineInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<HeroBannerTextColor>;
  title?: InputMaybe<Scalars['String']['input']>;
  topRightImageAsset?: InputMaybe<AssetUpdateOneInlineInput>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  verticalAlignmentMobile?: InputMaybe<VerticalAlignment>;
};

export type HeroComponentUpdateManyInlineInput = {
  /** Connect multiple existing HeroComponent documents */
  connect?: InputMaybe<Array<HeroComponentConnectInput>>;
  /** Create and connect multiple HeroComponent documents */
  create?: InputMaybe<Array<HeroComponentCreateInput>>;
  /** Delete multiple HeroComponent documents */
  delete?: InputMaybe<Array<HeroComponentWhereUniqueInput>>;
  /** Disconnect multiple HeroComponent documents */
  disconnect?: InputMaybe<Array<HeroComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HeroComponent documents */
  set?: InputMaybe<Array<HeroComponentWhereUniqueInput>>;
  /** Update multiple HeroComponent documents */
  update?: InputMaybe<Array<HeroComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HeroComponent documents */
  upsert?: InputMaybe<Array<HeroComponentUpsertWithNestedWhereUniqueInput>>;
};

export type HeroComponentUpdateManyInput = {
  alignment?: InputMaybe<AlignmentTypes>;
  description?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  superText?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<HeroBannerTextColor>;
  title?: InputMaybe<Scalars['String']['input']>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  verticalAlignmentMobile?: InputMaybe<VerticalAlignment>;
};

export type HeroComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeroComponentUpdateManyInput;
  /** Document search */
  where: HeroComponentWhereInput;
};

export type HeroComponentUpdateOneInlineInput = {
  /** Connect existing HeroComponent document */
  connect?: InputMaybe<HeroComponentWhereUniqueInput>;
  /** Create and connect one HeroComponent document */
  create?: InputMaybe<HeroComponentCreateInput>;
  /** Delete currently connected HeroComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HeroComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HeroComponent document */
  update?: InputMaybe<HeroComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HeroComponent document */
  upsert?: InputMaybe<HeroComponentUpsertWithNestedWhereUniqueInput>;
};

export type HeroComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeroComponentUpdateInput;
  /** Unique document search */
  where: HeroComponentWhereUniqueInput;
};

export type HeroComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: HeroComponentCreateInput;
  /** Update document if it exists */
  update: HeroComponentUpdateInput;
};

export type HeroComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeroComponentUpsertInput;
  /** Unique document search */
  where: HeroComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type HeroComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type HeroComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<AlignmentTypes>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<AlignmentTypes>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  bottomLeftImageAsset?: InputMaybe<AssetWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<HeroComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<HeroComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<HeroComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageComponent?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<HeroBannerTextColor>;
  /** All values that are contained in given list. */
  textColor_in?: InputMaybe<Array<InputMaybe<HeroBannerTextColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  textColor_not?: InputMaybe<HeroBannerTextColor>;
  /** All values that are not contained in given list. */
  textColor_not_in?: InputMaybe<Array<InputMaybe<HeroBannerTextColor>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  topRightImageAsset?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  verticalAlignmentMobile?: InputMaybe<VerticalAlignment>;
  /** All values that are contained in given list. */
  verticalAlignmentMobile_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  verticalAlignmentMobile_not?: InputMaybe<VerticalAlignment>;
  /** All values that are not contained in given list. */
  verticalAlignmentMobile_not_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** All values that are contained in given list. */
  verticalAlignment_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  verticalAlignment_not?: InputMaybe<VerticalAlignment>;
  /** All values that are not contained in given list. */
  verticalAlignment_not_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HeroComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HeroComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References HeroComponent record uniquely */
export type HeroComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Hero component that displays a looping animation */
export type HeroLoopAnimationComponent = Entity & Node & {
  __typename?: 'HeroLoopAnimationComponent';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<HeroLoopAnimationComponent>;
  genericPages: Array<GenericPage>;
  /** List of HeroLoopAnimationComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /**
   * Video file in MP4 format.
   * (Format: mp4 | Aspect Ratio: 16/9 | Size (W x H): 1280 x 720 | Max file size: 1.5 MB)
   *
   * The component will only be shown on the page if the format and file size requirements are fulfilled.
   */
  videoSource1: Asset;
  /**
   * Video file in WebM format. (Optional, but recommended to provide one for performance reasons)
   * (Format: WebM |Aspect Ratio: 16/9  | Size (W x H): 1280 x 720 | Max file size: 1.5 MB)
   *
   * The component will only be shown on the page if the format and file size requirements are fulfilled.
   */
  videoSource2?: Maybe<Asset>;
};


/** Hero component that displays a looping animation */
export type HeroLoopAnimationComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero component that displays a looping animation */
export type HeroLoopAnimationComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Hero component that displays a looping animation */
export type HeroLoopAnimationComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Hero component that displays a looping animation */
export type HeroLoopAnimationComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Hero component that displays a looping animation */
export type HeroLoopAnimationComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero component that displays a looping animation */
export type HeroLoopAnimationComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Hero component that displays a looping animation */
export type HeroLoopAnimationComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero component that displays a looping animation */
export type HeroLoopAnimationComponentVideoSource1Args = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Hero component that displays a looping animation */
export type HeroLoopAnimationComponentVideoSource2Args = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type HeroLoopAnimationComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HeroLoopAnimationComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type HeroLoopAnimationComponentConnection = {
  __typename?: 'HeroLoopAnimationComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HeroLoopAnimationComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HeroLoopAnimationComponentCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoSource1: AssetCreateOneInlineInput;
  videoSource2?: InputMaybe<AssetCreateOneInlineInput>;
};

export type HeroLoopAnimationComponentCreateManyInlineInput = {
  /** Connect multiple existing HeroLoopAnimationComponent documents */
  connect?: InputMaybe<Array<HeroLoopAnimationComponentWhereUniqueInput>>;
  /** Create and connect multiple existing HeroLoopAnimationComponent documents */
  create?: InputMaybe<Array<HeroLoopAnimationComponentCreateInput>>;
};

export type HeroLoopAnimationComponentCreateOneInlineInput = {
  /** Connect one existing HeroLoopAnimationComponent document */
  connect?: InputMaybe<HeroLoopAnimationComponentWhereUniqueInput>;
  /** Create and connect one HeroLoopAnimationComponent document */
  create?: InputMaybe<HeroLoopAnimationComponentCreateInput>;
};

/** An edge in a connection. */
export type HeroLoopAnimationComponentEdge = {
  __typename?: 'HeroLoopAnimationComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HeroLoopAnimationComponent;
};

/** Identifies documents */
export type HeroLoopAnimationComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroLoopAnimationComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroLoopAnimationComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroLoopAnimationComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HeroLoopAnimationComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<HeroLoopAnimationComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<HeroLoopAnimationComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoSource1?: InputMaybe<AssetWhereInput>;
  videoSource2?: InputMaybe<AssetWhereInput>;
};

export enum HeroLoopAnimationComponentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type HeroLoopAnimationComponentUpdateInput = {
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  videoSource1?: InputMaybe<AssetUpdateOneInlineInput>;
  videoSource2?: InputMaybe<AssetUpdateOneInlineInput>;
};

export type HeroLoopAnimationComponentUpdateManyInlineInput = {
  /** Connect multiple existing HeroLoopAnimationComponent documents */
  connect?: InputMaybe<Array<HeroLoopAnimationComponentConnectInput>>;
  /** Create and connect multiple HeroLoopAnimationComponent documents */
  create?: InputMaybe<Array<HeroLoopAnimationComponentCreateInput>>;
  /** Delete multiple HeroLoopAnimationComponent documents */
  delete?: InputMaybe<Array<HeroLoopAnimationComponentWhereUniqueInput>>;
  /** Disconnect multiple HeroLoopAnimationComponent documents */
  disconnect?: InputMaybe<Array<HeroLoopAnimationComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HeroLoopAnimationComponent documents */
  set?: InputMaybe<Array<HeroLoopAnimationComponentWhereUniqueInput>>;
  /** Update multiple HeroLoopAnimationComponent documents */
  update?: InputMaybe<Array<HeroLoopAnimationComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HeroLoopAnimationComponent documents */
  upsert?: InputMaybe<Array<HeroLoopAnimationComponentUpsertWithNestedWhereUniqueInput>>;
};

export type HeroLoopAnimationComponentUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type HeroLoopAnimationComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeroLoopAnimationComponentUpdateManyInput;
  /** Document search */
  where: HeroLoopAnimationComponentWhereInput;
};

export type HeroLoopAnimationComponentUpdateOneInlineInput = {
  /** Connect existing HeroLoopAnimationComponent document */
  connect?: InputMaybe<HeroLoopAnimationComponentWhereUniqueInput>;
  /** Create and connect one HeroLoopAnimationComponent document */
  create?: InputMaybe<HeroLoopAnimationComponentCreateInput>;
  /** Delete currently connected HeroLoopAnimationComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HeroLoopAnimationComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HeroLoopAnimationComponent document */
  update?: InputMaybe<HeroLoopAnimationComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HeroLoopAnimationComponent document */
  upsert?: InputMaybe<HeroLoopAnimationComponentUpsertWithNestedWhereUniqueInput>;
};

export type HeroLoopAnimationComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeroLoopAnimationComponentUpdateInput;
  /** Unique document search */
  where: HeroLoopAnimationComponentWhereUniqueInput;
};

export type HeroLoopAnimationComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: HeroLoopAnimationComponentCreateInput;
  /** Update document if it exists */
  update: HeroLoopAnimationComponentUpdateInput;
};

export type HeroLoopAnimationComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeroLoopAnimationComponentUpsertInput;
  /** Unique document search */
  where: HeroLoopAnimationComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type HeroLoopAnimationComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type HeroLoopAnimationComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroLoopAnimationComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroLoopAnimationComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroLoopAnimationComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HeroLoopAnimationComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<HeroLoopAnimationComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<HeroLoopAnimationComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoSource1?: InputMaybe<AssetWhereInput>;
  videoSource2?: InputMaybe<AssetWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HeroLoopAnimationComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroLoopAnimationComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroLoopAnimationComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroLoopAnimationComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HeroLoopAnimationComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References HeroLoopAnimationComponent record uniquely */
export type HeroLoopAnimationComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** This field specifies the alignment of the iframe in the page */
export enum IFrameAlignment {
  center = 'center',
  left = 'left'
}

/** Content type for adding an iframe to a page */
export type Iframe = Entity & Node & {
  __typename?: 'Iframe';
  alignment?: Maybe<IFrameAlignment>;
  /** Title to be used within the cms for searching */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Iframe>;
  genericPages: Array<GenericPage>;
  /** List of Iframe versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Height of the iframe (please put a number and "px" behind) */
  iframeHeight: Scalars['String']['output'];
  /** The type of iframe to be rendered on the page */
  iframeType: IframeTypes;
  /** URL to be used to display in the iframe */
  iframeUrl: Scalars['String']['output'];
  /** Width for the iframe (please put a number and "px" behind) */
  iframeWidth: Scalars['String']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Content type for adding an iframe to a page */
export type IframeCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Content type for adding an iframe to a page */
export type IframeDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Content type for adding an iframe to a page */
export type IframeGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Content type for adding an iframe to a page */
export type IframeHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Content type for adding an iframe to a page */
export type IframeMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Content type for adding an iframe to a page */
export type IframeProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


/** Content type for adding an iframe to a page */
export type IframeProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


/** Content type for adding an iframe to a page */
export type IframeProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


/** Content type for adding an iframe to a page */
export type IframePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Content type for adding an iframe to a page */
export type IframeRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


/** Content type for adding an iframe to a page */
export type IframeRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


/** Content type for adding an iframe to a page */
export type IframeRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


/** Content type for adding an iframe to a page */
export type IframeScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Content type for adding an iframe to a page */
export type IframeSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Content type for adding an iframe to a page */
export type IframeTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Content type for adding an iframe to a page */
export type IframeUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type IframeConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: IframeWhereUniqueInput;
};

/** A connection to a list of items. */
export type IframeConnection = {
  __typename?: 'IframeConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<IframeEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type IframeCreateInput = {
  alignment?: InputMaybe<IFrameAlignment>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  iframeHeight: Scalars['String']['input'];
  iframeType: IframeTypes;
  iframeUrl: Scalars['String']['input'];
  iframeWidth: Scalars['String']['input'];
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IframeCreateManyInlineInput = {
  /** Connect multiple existing Iframe documents */
  connect?: InputMaybe<Array<IframeWhereUniqueInput>>;
  /** Create and connect multiple existing Iframe documents */
  create?: InputMaybe<Array<IframeCreateInput>>;
};

export type IframeCreateOneInlineInput = {
  /** Connect one existing Iframe document */
  connect?: InputMaybe<IframeWhereUniqueInput>;
  /** Create and connect one Iframe document */
  create?: InputMaybe<IframeCreateInput>;
};

/** An edge in a connection. */
export type IframeEdge = {
  __typename?: 'IframeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Iframe;
};

/** Identifies documents */
export type IframeManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<IframeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<IframeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<IframeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<IFrameAlignment>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<IFrameAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<IFrameAlignment>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<IFrameAlignment>>>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<IframeWhereStageInput>;
  documentInStages_none?: InputMaybe<IframeWhereStageInput>;
  documentInStages_some?: InputMaybe<IframeWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  iframeHeight?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  iframeHeight_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  iframeHeight_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  iframeHeight_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  iframeHeight_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  iframeHeight_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  iframeHeight_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  iframeHeight_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  iframeHeight_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  iframeHeight_starts_with?: InputMaybe<Scalars['String']['input']>;
  iframeType?: InputMaybe<IframeTypes>;
  /** All values that are contained in given list. */
  iframeType_in?: InputMaybe<Array<InputMaybe<IframeTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  iframeType_not?: InputMaybe<IframeTypes>;
  /** All values that are not contained in given list. */
  iframeType_not_in?: InputMaybe<Array<InputMaybe<IframeTypes>>>;
  iframeUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  iframeUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  iframeUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  iframeUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  iframeUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  iframeUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  iframeUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  iframeUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  iframeUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  iframeUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  iframeWidth?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  iframeWidth_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  iframeWidth_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  iframeWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  iframeWidth_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  iframeWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  iframeWidth_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  iframeWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  iframeWidth_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  iframeWidth_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum IframeOrderByInput {
  alignment_ASC = 'alignment_ASC',
  alignment_DESC = 'alignment_DESC',
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  iframeHeight_ASC = 'iframeHeight_ASC',
  iframeHeight_DESC = 'iframeHeight_DESC',
  iframeType_ASC = 'iframeType_ASC',
  iframeType_DESC = 'iframeType_DESC',
  iframeUrl_ASC = 'iframeUrl_ASC',
  iframeUrl_DESC = 'iframeUrl_DESC',
  iframeWidth_ASC = 'iframeWidth_ASC',
  iframeWidth_DESC = 'iframeWidth_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** The types of iframe */
export enum IframeTypes {
  fixed = 'fixed',
  responsive = 'responsive'
}

export type IframeUpdateInput = {
  alignment?: InputMaybe<IFrameAlignment>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  iframeHeight?: InputMaybe<Scalars['String']['input']>;
  iframeType?: InputMaybe<IframeTypes>;
  iframeUrl?: InputMaybe<Scalars['String']['input']>;
  iframeWidth?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type IframeUpdateManyInlineInput = {
  /** Connect multiple existing Iframe documents */
  connect?: InputMaybe<Array<IframeConnectInput>>;
  /** Create and connect multiple Iframe documents */
  create?: InputMaybe<Array<IframeCreateInput>>;
  /** Delete multiple Iframe documents */
  delete?: InputMaybe<Array<IframeWhereUniqueInput>>;
  /** Disconnect multiple Iframe documents */
  disconnect?: InputMaybe<Array<IframeWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Iframe documents */
  set?: InputMaybe<Array<IframeWhereUniqueInput>>;
  /** Update multiple Iframe documents */
  update?: InputMaybe<Array<IframeUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Iframe documents */
  upsert?: InputMaybe<Array<IframeUpsertWithNestedWhereUniqueInput>>;
};

export type IframeUpdateManyInput = {
  alignment?: InputMaybe<IFrameAlignment>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  iframeHeight?: InputMaybe<Scalars['String']['input']>;
  iframeType?: InputMaybe<IframeTypes>;
  iframeUrl?: InputMaybe<Scalars['String']['input']>;
  iframeWidth?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
};

export type IframeUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: IframeUpdateManyInput;
  /** Document search */
  where: IframeWhereInput;
};

export type IframeUpdateOneInlineInput = {
  /** Connect existing Iframe document */
  connect?: InputMaybe<IframeWhereUniqueInput>;
  /** Create and connect one Iframe document */
  create?: InputMaybe<IframeCreateInput>;
  /** Delete currently connected Iframe document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Iframe document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Iframe document */
  update?: InputMaybe<IframeUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Iframe document */
  upsert?: InputMaybe<IframeUpsertWithNestedWhereUniqueInput>;
};

export type IframeUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: IframeUpdateInput;
  /** Unique document search */
  where: IframeWhereUniqueInput;
};

export type IframeUpsertInput = {
  /** Create document if it didn't exist */
  create: IframeCreateInput;
  /** Update document if it exists */
  update: IframeUpdateInput;
};

export type IframeUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: IframeUpsertInput;
  /** Unique document search */
  where: IframeWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type IframeWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type IframeWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<IframeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<IframeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<IframeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<IFrameAlignment>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<IFrameAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<IFrameAlignment>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<IFrameAlignment>>>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<IframeWhereStageInput>;
  documentInStages_none?: InputMaybe<IframeWhereStageInput>;
  documentInStages_some?: InputMaybe<IframeWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  iframeHeight?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  iframeHeight_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  iframeHeight_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  iframeHeight_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  iframeHeight_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  iframeHeight_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  iframeHeight_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  iframeHeight_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  iframeHeight_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  iframeHeight_starts_with?: InputMaybe<Scalars['String']['input']>;
  iframeType?: InputMaybe<IframeTypes>;
  /** All values that are contained in given list. */
  iframeType_in?: InputMaybe<Array<InputMaybe<IframeTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  iframeType_not?: InputMaybe<IframeTypes>;
  /** All values that are not contained in given list. */
  iframeType_not_in?: InputMaybe<Array<InputMaybe<IframeTypes>>>;
  iframeUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  iframeUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  iframeUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  iframeUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  iframeUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  iframeUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  iframeUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  iframeUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  iframeUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  iframeUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  iframeWidth?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  iframeWidth_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  iframeWidth_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  iframeWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  iframeWidth_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  iframeWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  iframeWidth_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  iframeWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  iframeWidth_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  iframeWidth_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type IframeWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<IframeWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<IframeWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<IframeWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<IframeWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Iframe record uniquely */
export type IframeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ImageAndTextCard = Entity & Node & {
  __typename?: 'ImageAndTextCard';
  anchorNav?: Maybe<AnchorNavigation>;
  buttonLink?: Maybe<Link>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<ImageAndTextCard>;
  gridColumnComponent?: Maybe<GridColumnComponent>;
  /** List of ImageAndTextCard versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<AssetComponent>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** Another Variation of card with Metaball */
  metaBall?: Maybe<Scalars['Boolean']['output']>;
  /** Enter parent page slug for subcategory pages */
  parentPage?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Additional  Info text above main heading */
  subHeading?: Maybe<Scalars['String']['output']>;
  /** Heading of the card */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ImageAndTextCardAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageAndTextCardButtonLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageAndTextCardCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageAndTextCardDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ImageAndTextCardGridColumnComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageAndTextCardHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ImageAndTextCardImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageAndTextCardMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageAndTextCardPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageAndTextCardScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ImageAndTextCardUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ImageAndTextCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ImageAndTextCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type ImageAndTextCardConnection = {
  __typename?: 'ImageAndTextCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ImageAndTextCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ImageAndTextCardCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  buttonLink?: InputMaybe<LinkCreateOneInlineInput>;
  ckykdlegu01g201weavhqe2p4?: InputMaybe<GridColumnCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gridColumnComponent?: InputMaybe<GridColumnComponentCreateOneInlineInput>;
  image?: InputMaybe<AssetComponentCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  metaBall?: InputMaybe<Scalars['Boolean']['input']>;
  parentPage?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ImageAndTextCardCreateManyInlineInput = {
  /** Connect multiple existing ImageAndTextCard documents */
  connect?: InputMaybe<Array<ImageAndTextCardWhereUniqueInput>>;
  /** Create and connect multiple existing ImageAndTextCard documents */
  create?: InputMaybe<Array<ImageAndTextCardCreateInput>>;
};

export type ImageAndTextCardCreateOneInlineInput = {
  /** Connect one existing ImageAndTextCard document */
  connect?: InputMaybe<ImageAndTextCardWhereUniqueInput>;
  /** Create and connect one ImageAndTextCard document */
  create?: InputMaybe<ImageAndTextCardCreateInput>;
};

/** An edge in a connection. */
export type ImageAndTextCardEdge = {
  __typename?: 'ImageAndTextCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ImageAndTextCard;
};

/** Identifies documents */
export type ImageAndTextCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageAndTextCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageAndTextCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageAndTextCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  buttonLink?: InputMaybe<LinkWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<ImageAndTextCardWhereStageInput>;
  documentInStages_none?: InputMaybe<ImageAndTextCardWhereStageInput>;
  documentInStages_some?: InputMaybe<ImageAndTextCardWhereStageInput>;
  gridColumnComponent?: InputMaybe<GridColumnComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaBall?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  metaBall_not?: InputMaybe<Scalars['Boolean']['input']>;
  parentPage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  parentPage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  parentPage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  parentPage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  parentPage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  parentPage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  parentPage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  parentPage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  parentPage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  parentPage_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ImageAndTextCardOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  metaBall_ASC = 'metaBall_ASC',
  metaBall_DESC = 'metaBall_DESC',
  parentPage_ASC = 'parentPage_ASC',
  parentPage_DESC = 'parentPage_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subHeading_ASC = 'subHeading_ASC',
  subHeading_DESC = 'subHeading_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ImageAndTextCardUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  buttonLink?: InputMaybe<LinkUpdateOneInlineInput>;
  ckykdlegu01g201weavhqe2p4?: InputMaybe<GridColumnUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  gridColumnComponent?: InputMaybe<GridColumnComponentUpdateOneInlineInput>;
  image?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  metaBall?: InputMaybe<Scalars['Boolean']['input']>;
  parentPage?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ImageAndTextCardUpdateManyInlineInput = {
  /** Connect multiple existing ImageAndTextCard documents */
  connect?: InputMaybe<Array<ImageAndTextCardConnectInput>>;
  /** Create and connect multiple ImageAndTextCard documents */
  create?: InputMaybe<Array<ImageAndTextCardCreateInput>>;
  /** Delete multiple ImageAndTextCard documents */
  delete?: InputMaybe<Array<ImageAndTextCardWhereUniqueInput>>;
  /** Disconnect multiple ImageAndTextCard documents */
  disconnect?: InputMaybe<Array<ImageAndTextCardWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ImageAndTextCard documents */
  set?: InputMaybe<Array<ImageAndTextCardWhereUniqueInput>>;
  /** Update multiple ImageAndTextCard documents */
  update?: InputMaybe<Array<ImageAndTextCardUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ImageAndTextCard documents */
  upsert?: InputMaybe<Array<ImageAndTextCardUpsertWithNestedWhereUniqueInput>>;
};

export type ImageAndTextCardUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  metaBall?: InputMaybe<Scalars['Boolean']['input']>;
  parentPage?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ImageAndTextCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ImageAndTextCardUpdateManyInput;
  /** Document search */
  where: ImageAndTextCardWhereInput;
};

export type ImageAndTextCardUpdateOneInlineInput = {
  /** Connect existing ImageAndTextCard document */
  connect?: InputMaybe<ImageAndTextCardWhereUniqueInput>;
  /** Create and connect one ImageAndTextCard document */
  create?: InputMaybe<ImageAndTextCardCreateInput>;
  /** Delete currently connected ImageAndTextCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ImageAndTextCard document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageAndTextCard document */
  update?: InputMaybe<ImageAndTextCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageAndTextCard document */
  upsert?: InputMaybe<ImageAndTextCardUpsertWithNestedWhereUniqueInput>;
};

export type ImageAndTextCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ImageAndTextCardUpdateInput;
  /** Unique document search */
  where: ImageAndTextCardWhereUniqueInput;
};

export type ImageAndTextCardUpsertInput = {
  /** Create document if it didn't exist */
  create: ImageAndTextCardCreateInput;
  /** Update document if it exists */
  update: ImageAndTextCardUpdateInput;
};

export type ImageAndTextCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ImageAndTextCardUpsertInput;
  /** Unique document search */
  where: ImageAndTextCardWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ImageAndTextCardWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ImageAndTextCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageAndTextCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageAndTextCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageAndTextCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  buttonLink?: InputMaybe<LinkWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<ImageAndTextCardWhereStageInput>;
  documentInStages_none?: InputMaybe<ImageAndTextCardWhereStageInput>;
  documentInStages_some?: InputMaybe<ImageAndTextCardWhereStageInput>;
  gridColumnComponent?: InputMaybe<GridColumnComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaBall?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  metaBall_not?: InputMaybe<Scalars['Boolean']['input']>;
  parentPage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  parentPage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  parentPage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  parentPage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  parentPage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  parentPage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  parentPage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  parentPage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  parentPage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  parentPage_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ImageAndTextCardWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageAndTextCardWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageAndTextCardWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageAndTextCardWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ImageAndTextCardWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ImageAndTextCard record uniquely */
export type ImageAndTextCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ImageBlurInput = {
  /** The amount of blurring to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

/** Adds a border to the image. */
export type ImageBorderInput = {
  /** The background color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  background: Scalars['String']['input'];
  /** The color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  color: Scalars['String']['input'];
  /** The width of the border in pixels. The value must be an integer from 1 to 1000. */
  width: Scalars['Int']['input'];
};

export type ImageCompressInput = {
  /** Preserves the metadata of the image. */
  metadata: Scalars['Boolean']['input'];
};

/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopy = Entity & Node & {
  __typename?: 'ImageCopy';
  anchorNav?: Maybe<AnchorNavigation>;
  /** Bottom Left object Image */
  bottomLeftAsset?: Maybe<ImageCopyBottomLeftAsset>;
  /** Title to be used to find the contents in the CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<ImageCopy>;
  genericPages: Array<GenericPage>;
  /** List of ImageCopy versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Image copy items */
  imageCopyItem: Array<ImageCopyImageCopyItem>;
  market: Markets;
  marketName?: Maybe<Market>;
  productCategoryPages: Array<ProductCategoryPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  /** Top right object image */
  topRightAsset?: Maybe<ImageCopyTopRightAsset>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyBottomLeftAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyImageCopyItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopySubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyTopRightAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ImageCopyBottomLeftAsset = AssetComponent;

export type ImageCopyBottomLeftAssetConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type ImageCopyBottomLeftAssetCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type ImageCopyBottomLeftAssetCreateManyInlineInput = {
  /** Connect multiple existing ImageCopyBottomLeftAsset documents */
  connect?: InputMaybe<Array<ImageCopyBottomLeftAssetWhereUniqueInput>>;
  /** Create and connect multiple existing ImageCopyBottomLeftAsset documents */
  create?: InputMaybe<Array<ImageCopyBottomLeftAssetCreateInput>>;
};

export type ImageCopyBottomLeftAssetCreateOneInlineInput = {
  /** Connect one existing ImageCopyBottomLeftAsset document */
  connect?: InputMaybe<ImageCopyBottomLeftAssetWhereUniqueInput>;
  /** Create and connect one ImageCopyBottomLeftAsset document */
  create?: InputMaybe<ImageCopyBottomLeftAssetCreateInput>;
};

export type ImageCopyBottomLeftAssetUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type ImageCopyBottomLeftAssetUpdateManyInlineInput = {
  /** Connect multiple existing ImageCopyBottomLeftAsset documents */
  connect?: InputMaybe<Array<ImageCopyBottomLeftAssetConnectInput>>;
  /** Create and connect multiple ImageCopyBottomLeftAsset documents */
  create?: InputMaybe<Array<ImageCopyBottomLeftAssetCreateInput>>;
  /** Delete multiple ImageCopyBottomLeftAsset documents */
  delete?: InputMaybe<Array<ImageCopyBottomLeftAssetWhereUniqueInput>>;
  /** Disconnect multiple ImageCopyBottomLeftAsset documents */
  disconnect?: InputMaybe<Array<ImageCopyBottomLeftAssetWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ImageCopyBottomLeftAsset documents */
  set?: InputMaybe<Array<ImageCopyBottomLeftAssetWhereUniqueInput>>;
  /** Update multiple ImageCopyBottomLeftAsset documents */
  update?: InputMaybe<Array<ImageCopyBottomLeftAssetUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ImageCopyBottomLeftAsset documents */
  upsert?: InputMaybe<Array<ImageCopyBottomLeftAssetUpsertWithNestedWhereUniqueInput>>;
};

export type ImageCopyBottomLeftAssetUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type ImageCopyBottomLeftAssetUpdateOneInlineInput = {
  /** Connect existing ImageCopyBottomLeftAsset document */
  connect?: InputMaybe<ImageCopyBottomLeftAssetWhereUniqueInput>;
  /** Create and connect one ImageCopyBottomLeftAsset document */
  create?: InputMaybe<ImageCopyBottomLeftAssetCreateInput>;
  /** Delete currently connected ImageCopyBottomLeftAsset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ImageCopyBottomLeftAsset document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageCopyBottomLeftAsset document */
  update?: InputMaybe<ImageCopyBottomLeftAssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageCopyBottomLeftAsset document */
  upsert?: InputMaybe<ImageCopyBottomLeftAssetUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyBottomLeftAssetUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type ImageCopyBottomLeftAssetUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyBottomLeftAssetWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type ImageCopyBottomLeftAssetWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

export type ImageCopyConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ImageCopyWhereUniqueInput;
};

/** A connection to a list of items. */
export type ImageCopyConnection = {
  __typename?: 'ImageCopyConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ImageCopyEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ImageCopyCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  bottomLeftAsset?: InputMaybe<ImageCopyBottomLeftAssetCreateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  imageCopyItem?: InputMaybe<ImageCopyImageCopyItemCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  topRightAsset?: InputMaybe<ImageCopyTopRightAssetCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ImageCopyCreateManyInlineInput = {
  /** Connect multiple existing ImageCopy documents */
  connect?: InputMaybe<Array<ImageCopyWhereUniqueInput>>;
  /** Create and connect multiple existing ImageCopy documents */
  create?: InputMaybe<Array<ImageCopyCreateInput>>;
};

export type ImageCopyCreateOneInlineInput = {
  /** Connect one existing ImageCopy document */
  connect?: InputMaybe<ImageCopyWhereUniqueInput>;
  /** Create and connect one ImageCopy document */
  create?: InputMaybe<ImageCopyCreateInput>;
};

/** An edge in a connection. */
export type ImageCopyEdge = {
  __typename?: 'ImageCopyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ImageCopy;
};

export type ImageCopyImageCopyItem = ImageCopyItem;

export type ImageCopyImageCopyItemConnectInput = {
  ImageCopyItem?: InputMaybe<ImageCopyItemConnectInput>;
};

export type ImageCopyImageCopyItemCreateInput = {
  ImageCopyItem?: InputMaybe<ImageCopyItemCreateInput>;
};

export type ImageCopyImageCopyItemCreateManyInlineInput = {
  /** Connect multiple existing ImageCopyImageCopyItem documents */
  connect?: InputMaybe<Array<ImageCopyImageCopyItemWhereUniqueInput>>;
  /** Create and connect multiple existing ImageCopyImageCopyItem documents */
  create?: InputMaybe<Array<ImageCopyImageCopyItemCreateInput>>;
};

export type ImageCopyImageCopyItemCreateOneInlineInput = {
  /** Connect one existing ImageCopyImageCopyItem document */
  connect?: InputMaybe<ImageCopyImageCopyItemWhereUniqueInput>;
  /** Create and connect one ImageCopyImageCopyItem document */
  create?: InputMaybe<ImageCopyImageCopyItemCreateInput>;
};

export type ImageCopyImageCopyItemUpdateInput = {
  ImageCopyItem?: InputMaybe<ImageCopyItemUpdateInput>;
};

export type ImageCopyImageCopyItemUpdateManyInlineInput = {
  /** Connect multiple existing ImageCopyImageCopyItem documents */
  connect?: InputMaybe<Array<ImageCopyImageCopyItemConnectInput>>;
  /** Create and connect multiple ImageCopyImageCopyItem documents */
  create?: InputMaybe<Array<ImageCopyImageCopyItemCreateInput>>;
  /** Delete multiple ImageCopyImageCopyItem documents */
  delete?: InputMaybe<Array<ImageCopyImageCopyItemWhereUniqueInput>>;
  /** Disconnect multiple ImageCopyImageCopyItem documents */
  disconnect?: InputMaybe<Array<ImageCopyImageCopyItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ImageCopyImageCopyItem documents */
  set?: InputMaybe<Array<ImageCopyImageCopyItemWhereUniqueInput>>;
  /** Update multiple ImageCopyImageCopyItem documents */
  update?: InputMaybe<Array<ImageCopyImageCopyItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ImageCopyImageCopyItem documents */
  upsert?: InputMaybe<Array<ImageCopyImageCopyItemUpsertWithNestedWhereUniqueInput>>;
};

export type ImageCopyImageCopyItemUpdateManyWithNestedWhereInput = {
  ImageCopyItem?: InputMaybe<ImageCopyItemUpdateManyWithNestedWhereInput>;
};

export type ImageCopyImageCopyItemUpdateOneInlineInput = {
  /** Connect existing ImageCopyImageCopyItem document */
  connect?: InputMaybe<ImageCopyImageCopyItemWhereUniqueInput>;
  /** Create and connect one ImageCopyImageCopyItem document */
  create?: InputMaybe<ImageCopyImageCopyItemCreateInput>;
  /** Delete currently connected ImageCopyImageCopyItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ImageCopyImageCopyItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageCopyImageCopyItem document */
  update?: InputMaybe<ImageCopyImageCopyItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageCopyImageCopyItem document */
  upsert?: InputMaybe<ImageCopyImageCopyItemUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyImageCopyItemUpdateWithNestedWhereUniqueInput = {
  ImageCopyItem?: InputMaybe<ImageCopyItemUpdateWithNestedWhereUniqueInput>;
};

export type ImageCopyImageCopyItemUpsertWithNestedWhereUniqueInput = {
  ImageCopyItem?: InputMaybe<ImageCopyItemUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyImageCopyItemWhereInput = {
  ImageCopyItem?: InputMaybe<ImageCopyItemWhereInput>;
};

export type ImageCopyImageCopyItemWhereUniqueInput = {
  ImageCopyItem?: InputMaybe<ImageCopyItemWhereUniqueInput>;
};

export type ImageCopyItem = Entity & Node & {
  __typename?: 'ImageCopyItem';
  /** Description */
  addDescription: Scalars['Boolean']['output'];
  addImage?: Maybe<Scalars['Boolean']['output']>;
  /** Add Title */
  addTitle?: Maybe<Scalars['Boolean']['output']>;
  /** Add Video */
  addVideo?: Maybe<Scalars['Boolean']['output']>;
  /** Type of Column full, half or multi column  */
  columnType?: Maybe<ColumnType>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Description */
  description?: Maybe<RichText>;
  /** Get the document in other stages */
  documentInStages: Array<ImageCopyItem>;
  /** List of ImageCopyItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image: Array<ImageCopyItemImage>;
  imageCopy?: Maybe<ImageCopy>;
  /** Image Position */
  imagePosition?: Maybe<DisplayPosition>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** ID of Video */
  videoId?: Maybe<Scalars['String']['output']>;
  /** Video Postion */
  videoPosition?: Maybe<DisplayPosition>;
  /** Image to display on video */
  videoPosterImage?: Maybe<ImageCopyItemVideoPosterImage>;
};


export type ImageCopyItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageCopyItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ImageCopyItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ImageCopyItemImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageCopyItemImageCopyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageCopyItemMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageCopyItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageCopyItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ImageCopyItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageCopyItemVideoPosterImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ImageCopyItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ImageCopyItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type ImageCopyItemConnection = {
  __typename?: 'ImageCopyItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ImageCopyItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ImageCopyItemCreateInput = {
  addDescription: Scalars['Boolean']['input'];
  addImage?: InputMaybe<Scalars['Boolean']['input']>;
  addTitle?: InputMaybe<Scalars['Boolean']['input']>;
  addVideo?: InputMaybe<Scalars['Boolean']['input']>;
  columnType?: InputMaybe<ColumnType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  image?: InputMaybe<ImageCopyItemImageCreateManyInlineInput>;
  imageCopy?: InputMaybe<ImageCopyCreateOneInlineInput>;
  imagePosition?: InputMaybe<DisplayPosition>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  videoPosition?: InputMaybe<DisplayPosition>;
  videoPosterImage?: InputMaybe<ImageCopyItemVideoPosterImageCreateOneInlineInput>;
};

export type ImageCopyItemCreateManyInlineInput = {
  /** Connect multiple existing ImageCopyItem documents */
  connect?: InputMaybe<Array<ImageCopyItemWhereUniqueInput>>;
  /** Create and connect multiple existing ImageCopyItem documents */
  create?: InputMaybe<Array<ImageCopyItemCreateInput>>;
};

export type ImageCopyItemCreateOneInlineInput = {
  /** Connect one existing ImageCopyItem document */
  connect?: InputMaybe<ImageCopyItemWhereUniqueInput>;
  /** Create and connect one ImageCopyItem document */
  create?: InputMaybe<ImageCopyItemCreateInput>;
};

/** An edge in a connection. */
export type ImageCopyItemEdge = {
  __typename?: 'ImageCopyItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ImageCopyItem;
};

export type ImageCopyItemImage = AssetComponent;

export type ImageCopyItemImageConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type ImageCopyItemImageCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type ImageCopyItemImageCreateManyInlineInput = {
  /** Connect multiple existing ImageCopyItemImage documents */
  connect?: InputMaybe<Array<ImageCopyItemImageWhereUniqueInput>>;
  /** Create and connect multiple existing ImageCopyItemImage documents */
  create?: InputMaybe<Array<ImageCopyItemImageCreateInput>>;
};

export type ImageCopyItemImageCreateOneInlineInput = {
  /** Connect one existing ImageCopyItemImage document */
  connect?: InputMaybe<ImageCopyItemImageWhereUniqueInput>;
  /** Create and connect one ImageCopyItemImage document */
  create?: InputMaybe<ImageCopyItemImageCreateInput>;
};

export type ImageCopyItemImageUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type ImageCopyItemImageUpdateManyInlineInput = {
  /** Connect multiple existing ImageCopyItemImage documents */
  connect?: InputMaybe<Array<ImageCopyItemImageConnectInput>>;
  /** Create and connect multiple ImageCopyItemImage documents */
  create?: InputMaybe<Array<ImageCopyItemImageCreateInput>>;
  /** Delete multiple ImageCopyItemImage documents */
  delete?: InputMaybe<Array<ImageCopyItemImageWhereUniqueInput>>;
  /** Disconnect multiple ImageCopyItemImage documents */
  disconnect?: InputMaybe<Array<ImageCopyItemImageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ImageCopyItemImage documents */
  set?: InputMaybe<Array<ImageCopyItemImageWhereUniqueInput>>;
  /** Update multiple ImageCopyItemImage documents */
  update?: InputMaybe<Array<ImageCopyItemImageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ImageCopyItemImage documents */
  upsert?: InputMaybe<Array<ImageCopyItemImageUpsertWithNestedWhereUniqueInput>>;
};

export type ImageCopyItemImageUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type ImageCopyItemImageUpdateOneInlineInput = {
  /** Connect existing ImageCopyItemImage document */
  connect?: InputMaybe<ImageCopyItemImageWhereUniqueInput>;
  /** Create and connect one ImageCopyItemImage document */
  create?: InputMaybe<ImageCopyItemImageCreateInput>;
  /** Delete currently connected ImageCopyItemImage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ImageCopyItemImage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageCopyItemImage document */
  update?: InputMaybe<ImageCopyItemImageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageCopyItemImage document */
  upsert?: InputMaybe<ImageCopyItemImageUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyItemImageUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type ImageCopyItemImageUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyItemImageWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type ImageCopyItemImageWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

/** Identifies documents */
export type ImageCopyItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageCopyItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageCopyItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageCopyItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  addDescription?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  addDescription_not?: InputMaybe<Scalars['Boolean']['input']>;
  addImage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  addImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  addTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  addTitle_not?: InputMaybe<Scalars['Boolean']['input']>;
  addVideo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  addVideo_not?: InputMaybe<Scalars['Boolean']['input']>;
  columnType?: InputMaybe<ColumnType>;
  /** All values that are contained in given list. */
  columnType_in?: InputMaybe<Array<InputMaybe<ColumnType>>>;
  /** Any other value that exists and is not equal to the given value. */
  columnType_not?: InputMaybe<ColumnType>;
  /** All values that are not contained in given list. */
  columnType_not_in?: InputMaybe<Array<InputMaybe<ColumnType>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ImageCopyItemWhereStageInput>;
  documentInStages_none?: InputMaybe<ImageCopyItemWhereStageInput>;
  documentInStages_some?: InputMaybe<ImageCopyItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageCopy?: InputMaybe<ImageCopyWhereInput>;
  imagePosition?: InputMaybe<DisplayPosition>;
  /** All values that are contained in given list. */
  imagePosition_in?: InputMaybe<Array<InputMaybe<DisplayPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  imagePosition_not?: InputMaybe<DisplayPosition>;
  /** All values that are not contained in given list. */
  imagePosition_not_in?: InputMaybe<Array<InputMaybe<DisplayPosition>>>;
  /** All values in which the union is empty */
  image_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  image_some?: InputMaybe<ImageCopyItemImageWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoId_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoPosition?: InputMaybe<DisplayPosition>;
  /** All values that are contained in given list. */
  videoPosition_in?: InputMaybe<Array<InputMaybe<DisplayPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoPosition_not?: InputMaybe<DisplayPosition>;
  /** All values that are not contained in given list. */
  videoPosition_not_in?: InputMaybe<Array<InputMaybe<DisplayPosition>>>;
  /** All values in which the union is connected to the given models */
  videoPosterImage?: InputMaybe<ImageCopyItemVideoPosterImageWhereInput>;
  /** All values in which the union is empty */
  videoPosterImage_empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ImageCopyItemOrderByInput {
  addDescription_ASC = 'addDescription_ASC',
  addDescription_DESC = 'addDescription_DESC',
  addImage_ASC = 'addImage_ASC',
  addImage_DESC = 'addImage_DESC',
  addTitle_ASC = 'addTitle_ASC',
  addTitle_DESC = 'addTitle_DESC',
  addVideo_ASC = 'addVideo_ASC',
  addVideo_DESC = 'addVideo_DESC',
  columnType_ASC = 'columnType_ASC',
  columnType_DESC = 'columnType_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  imagePosition_ASC = 'imagePosition_ASC',
  imagePosition_DESC = 'imagePosition_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  videoId_ASC = 'videoId_ASC',
  videoId_DESC = 'videoId_DESC',
  videoPosition_ASC = 'videoPosition_ASC',
  videoPosition_DESC = 'videoPosition_DESC'
}

export type ImageCopyItemUpdateInput = {
  addDescription?: InputMaybe<Scalars['Boolean']['input']>;
  addImage?: InputMaybe<Scalars['Boolean']['input']>;
  addTitle?: InputMaybe<Scalars['Boolean']['input']>;
  addVideo?: InputMaybe<Scalars['Boolean']['input']>;
  columnType?: InputMaybe<ColumnType>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  image?: InputMaybe<ImageCopyItemImageUpdateManyInlineInput>;
  imageCopy?: InputMaybe<ImageCopyUpdateOneInlineInput>;
  imagePosition?: InputMaybe<DisplayPosition>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  videoPosition?: InputMaybe<DisplayPosition>;
  videoPosterImage?: InputMaybe<ImageCopyItemVideoPosterImageUpdateOneInlineInput>;
};

export type ImageCopyItemUpdateManyInlineInput = {
  /** Connect multiple existing ImageCopyItem documents */
  connect?: InputMaybe<Array<ImageCopyItemConnectInput>>;
  /** Create and connect multiple ImageCopyItem documents */
  create?: InputMaybe<Array<ImageCopyItemCreateInput>>;
  /** Delete multiple ImageCopyItem documents */
  delete?: InputMaybe<Array<ImageCopyItemWhereUniqueInput>>;
  /** Disconnect multiple ImageCopyItem documents */
  disconnect?: InputMaybe<Array<ImageCopyItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ImageCopyItem documents */
  set?: InputMaybe<Array<ImageCopyItemWhereUniqueInput>>;
  /** Update multiple ImageCopyItem documents */
  update?: InputMaybe<Array<ImageCopyItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ImageCopyItem documents */
  upsert?: InputMaybe<Array<ImageCopyItemUpsertWithNestedWhereUniqueInput>>;
};

export type ImageCopyItemUpdateManyInput = {
  addDescription?: InputMaybe<Scalars['Boolean']['input']>;
  addImage?: InputMaybe<Scalars['Boolean']['input']>;
  addTitle?: InputMaybe<Scalars['Boolean']['input']>;
  addVideo?: InputMaybe<Scalars['Boolean']['input']>;
  columnType?: InputMaybe<ColumnType>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  imagePosition?: InputMaybe<DisplayPosition>;
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  videoPosition?: InputMaybe<DisplayPosition>;
};

export type ImageCopyItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ImageCopyItemUpdateManyInput;
  /** Document search */
  where: ImageCopyItemWhereInput;
};

export type ImageCopyItemUpdateOneInlineInput = {
  /** Connect existing ImageCopyItem document */
  connect?: InputMaybe<ImageCopyItemWhereUniqueInput>;
  /** Create and connect one ImageCopyItem document */
  create?: InputMaybe<ImageCopyItemCreateInput>;
  /** Delete currently connected ImageCopyItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ImageCopyItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageCopyItem document */
  update?: InputMaybe<ImageCopyItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageCopyItem document */
  upsert?: InputMaybe<ImageCopyItemUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ImageCopyItemUpdateInput;
  /** Unique document search */
  where: ImageCopyItemWhereUniqueInput;
};

export type ImageCopyItemUpsertInput = {
  /** Create document if it didn't exist */
  create: ImageCopyItemCreateInput;
  /** Update document if it exists */
  update: ImageCopyItemUpdateInput;
};

export type ImageCopyItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ImageCopyItemUpsertInput;
  /** Unique document search */
  where: ImageCopyItemWhereUniqueInput;
};

export type ImageCopyItemVideoPosterImage = AssetComponent;

export type ImageCopyItemVideoPosterImageConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type ImageCopyItemVideoPosterImageCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type ImageCopyItemVideoPosterImageCreateManyInlineInput = {
  /** Connect multiple existing ImageCopyItemVideoPosterImage documents */
  connect?: InputMaybe<Array<ImageCopyItemVideoPosterImageWhereUniqueInput>>;
  /** Create and connect multiple existing ImageCopyItemVideoPosterImage documents */
  create?: InputMaybe<Array<ImageCopyItemVideoPosterImageCreateInput>>;
};

export type ImageCopyItemVideoPosterImageCreateOneInlineInput = {
  /** Connect one existing ImageCopyItemVideoPosterImage document */
  connect?: InputMaybe<ImageCopyItemVideoPosterImageWhereUniqueInput>;
  /** Create and connect one ImageCopyItemVideoPosterImage document */
  create?: InputMaybe<ImageCopyItemVideoPosterImageCreateInput>;
};

export type ImageCopyItemVideoPosterImageUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type ImageCopyItemVideoPosterImageUpdateManyInlineInput = {
  /** Connect multiple existing ImageCopyItemVideoPosterImage documents */
  connect?: InputMaybe<Array<ImageCopyItemVideoPosterImageConnectInput>>;
  /** Create and connect multiple ImageCopyItemVideoPosterImage documents */
  create?: InputMaybe<Array<ImageCopyItemVideoPosterImageCreateInput>>;
  /** Delete multiple ImageCopyItemVideoPosterImage documents */
  delete?: InputMaybe<Array<ImageCopyItemVideoPosterImageWhereUniqueInput>>;
  /** Disconnect multiple ImageCopyItemVideoPosterImage documents */
  disconnect?: InputMaybe<Array<ImageCopyItemVideoPosterImageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ImageCopyItemVideoPosterImage documents */
  set?: InputMaybe<Array<ImageCopyItemVideoPosterImageWhereUniqueInput>>;
  /** Update multiple ImageCopyItemVideoPosterImage documents */
  update?: InputMaybe<Array<ImageCopyItemVideoPosterImageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ImageCopyItemVideoPosterImage documents */
  upsert?: InputMaybe<Array<ImageCopyItemVideoPosterImageUpsertWithNestedWhereUniqueInput>>;
};

export type ImageCopyItemVideoPosterImageUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type ImageCopyItemVideoPosterImageUpdateOneInlineInput = {
  /** Connect existing ImageCopyItemVideoPosterImage document */
  connect?: InputMaybe<ImageCopyItemVideoPosterImageWhereUniqueInput>;
  /** Create and connect one ImageCopyItemVideoPosterImage document */
  create?: InputMaybe<ImageCopyItemVideoPosterImageCreateInput>;
  /** Delete currently connected ImageCopyItemVideoPosterImage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ImageCopyItemVideoPosterImage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageCopyItemVideoPosterImage document */
  update?: InputMaybe<ImageCopyItemVideoPosterImageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageCopyItemVideoPosterImage document */
  upsert?: InputMaybe<ImageCopyItemVideoPosterImageUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyItemVideoPosterImageUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type ImageCopyItemVideoPosterImageUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyItemVideoPosterImageWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type ImageCopyItemVideoPosterImageWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

/** This contains a set of filters that can be used to compare values internally */
export type ImageCopyItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ImageCopyItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageCopyItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageCopyItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageCopyItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  addDescription?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  addDescription_not?: InputMaybe<Scalars['Boolean']['input']>;
  addImage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  addImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  addTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  addTitle_not?: InputMaybe<Scalars['Boolean']['input']>;
  addVideo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  addVideo_not?: InputMaybe<Scalars['Boolean']['input']>;
  columnType?: InputMaybe<ColumnType>;
  /** All values that are contained in given list. */
  columnType_in?: InputMaybe<Array<InputMaybe<ColumnType>>>;
  /** Any other value that exists and is not equal to the given value. */
  columnType_not?: InputMaybe<ColumnType>;
  /** All values that are not contained in given list. */
  columnType_not_in?: InputMaybe<Array<InputMaybe<ColumnType>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ImageCopyItemWhereStageInput>;
  documentInStages_none?: InputMaybe<ImageCopyItemWhereStageInput>;
  documentInStages_some?: InputMaybe<ImageCopyItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageCopy?: InputMaybe<ImageCopyWhereInput>;
  imagePosition?: InputMaybe<DisplayPosition>;
  /** All values that are contained in given list. */
  imagePosition_in?: InputMaybe<Array<InputMaybe<DisplayPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  imagePosition_not?: InputMaybe<DisplayPosition>;
  /** All values that are not contained in given list. */
  imagePosition_not_in?: InputMaybe<Array<InputMaybe<DisplayPosition>>>;
  /** All values in which the union is empty */
  image_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  image_some?: InputMaybe<ImageCopyItemImageWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoId_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoPosition?: InputMaybe<DisplayPosition>;
  /** All values that are contained in given list. */
  videoPosition_in?: InputMaybe<Array<InputMaybe<DisplayPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoPosition_not?: InputMaybe<DisplayPosition>;
  /** All values that are not contained in given list. */
  videoPosition_not_in?: InputMaybe<Array<InputMaybe<DisplayPosition>>>;
  /** All values in which the union is connected to the given models */
  videoPosterImage?: InputMaybe<ImageCopyItemVideoPosterImageWhereInput>;
  /** All values in which the union is empty */
  videoPosterImage_empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ImageCopyItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageCopyItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageCopyItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageCopyItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ImageCopyItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ImageCopyItem record uniquely */
export type ImageCopyItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type ImageCopyManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageCopyWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageCopyWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageCopyWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  /** All values in which the union is connected to the given models */
  bottomLeftAsset?: InputMaybe<ImageCopyBottomLeftAssetWhereInput>;
  /** All values in which the union is empty */
  bottomLeftAsset_empty?: InputMaybe<Scalars['Boolean']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ImageCopyWhereStageInput>;
  documentInStages_none?: InputMaybe<ImageCopyWhereStageInput>;
  documentInStages_some?: InputMaybe<ImageCopyWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  imageCopyItem_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  imageCopyItem_some?: InputMaybe<ImageCopyImageCopyItemWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  /** All values in which the union is connected to the given models */
  topRightAsset?: InputMaybe<ImageCopyTopRightAssetWhereInput>;
  /** All values in which the union is empty */
  topRightAsset_empty?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ImageCopyOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ImageCopyTopRightAsset = AssetComponent;

export type ImageCopyTopRightAssetConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type ImageCopyTopRightAssetCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type ImageCopyTopRightAssetCreateManyInlineInput = {
  /** Connect multiple existing ImageCopyTopRightAsset documents */
  connect?: InputMaybe<Array<ImageCopyTopRightAssetWhereUniqueInput>>;
  /** Create and connect multiple existing ImageCopyTopRightAsset documents */
  create?: InputMaybe<Array<ImageCopyTopRightAssetCreateInput>>;
};

export type ImageCopyTopRightAssetCreateOneInlineInput = {
  /** Connect one existing ImageCopyTopRightAsset document */
  connect?: InputMaybe<ImageCopyTopRightAssetWhereUniqueInput>;
  /** Create and connect one ImageCopyTopRightAsset document */
  create?: InputMaybe<ImageCopyTopRightAssetCreateInput>;
};

export type ImageCopyTopRightAssetUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type ImageCopyTopRightAssetUpdateManyInlineInput = {
  /** Connect multiple existing ImageCopyTopRightAsset documents */
  connect?: InputMaybe<Array<ImageCopyTopRightAssetConnectInput>>;
  /** Create and connect multiple ImageCopyTopRightAsset documents */
  create?: InputMaybe<Array<ImageCopyTopRightAssetCreateInput>>;
  /** Delete multiple ImageCopyTopRightAsset documents */
  delete?: InputMaybe<Array<ImageCopyTopRightAssetWhereUniqueInput>>;
  /** Disconnect multiple ImageCopyTopRightAsset documents */
  disconnect?: InputMaybe<Array<ImageCopyTopRightAssetWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ImageCopyTopRightAsset documents */
  set?: InputMaybe<Array<ImageCopyTopRightAssetWhereUniqueInput>>;
  /** Update multiple ImageCopyTopRightAsset documents */
  update?: InputMaybe<Array<ImageCopyTopRightAssetUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ImageCopyTopRightAsset documents */
  upsert?: InputMaybe<Array<ImageCopyTopRightAssetUpsertWithNestedWhereUniqueInput>>;
};

export type ImageCopyTopRightAssetUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type ImageCopyTopRightAssetUpdateOneInlineInput = {
  /** Connect existing ImageCopyTopRightAsset document */
  connect?: InputMaybe<ImageCopyTopRightAssetWhereUniqueInput>;
  /** Create and connect one ImageCopyTopRightAsset document */
  create?: InputMaybe<ImageCopyTopRightAssetCreateInput>;
  /** Delete currently connected ImageCopyTopRightAsset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ImageCopyTopRightAsset document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageCopyTopRightAsset document */
  update?: InputMaybe<ImageCopyTopRightAssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageCopyTopRightAsset document */
  upsert?: InputMaybe<ImageCopyTopRightAssetUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyTopRightAssetUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type ImageCopyTopRightAssetUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyTopRightAssetWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type ImageCopyTopRightAssetWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

export type ImageCopyUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  bottomLeftAsset?: InputMaybe<ImageCopyBottomLeftAssetUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  imageCopyItem?: InputMaybe<ImageCopyImageCopyItemUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  topRightAsset?: InputMaybe<ImageCopyTopRightAssetUpdateOneInlineInput>;
};

export type ImageCopyUpdateManyInlineInput = {
  /** Connect multiple existing ImageCopy documents */
  connect?: InputMaybe<Array<ImageCopyConnectInput>>;
  /** Create and connect multiple ImageCopy documents */
  create?: InputMaybe<Array<ImageCopyCreateInput>>;
  /** Delete multiple ImageCopy documents */
  delete?: InputMaybe<Array<ImageCopyWhereUniqueInput>>;
  /** Disconnect multiple ImageCopy documents */
  disconnect?: InputMaybe<Array<ImageCopyWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ImageCopy documents */
  set?: InputMaybe<Array<ImageCopyWhereUniqueInput>>;
  /** Update multiple ImageCopy documents */
  update?: InputMaybe<Array<ImageCopyUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ImageCopy documents */
  upsert?: InputMaybe<Array<ImageCopyUpsertWithNestedWhereUniqueInput>>;
};

export type ImageCopyUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
};

export type ImageCopyUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ImageCopyUpdateManyInput;
  /** Document search */
  where: ImageCopyWhereInput;
};

export type ImageCopyUpdateOneInlineInput = {
  /** Connect existing ImageCopy document */
  connect?: InputMaybe<ImageCopyWhereUniqueInput>;
  /** Create and connect one ImageCopy document */
  create?: InputMaybe<ImageCopyCreateInput>;
  /** Delete currently connected ImageCopy document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ImageCopy document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageCopy document */
  update?: InputMaybe<ImageCopyUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageCopy document */
  upsert?: InputMaybe<ImageCopyUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ImageCopyUpdateInput;
  /** Unique document search */
  where: ImageCopyWhereUniqueInput;
};

export type ImageCopyUpsertInput = {
  /** Create document if it didn't exist */
  create: ImageCopyCreateInput;
  /** Update document if it exists */
  update: ImageCopyUpdateInput;
};

export type ImageCopyUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ImageCopyUpsertInput;
  /** Unique document search */
  where: ImageCopyWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ImageCopyWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ImageCopyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageCopyWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageCopyWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageCopyWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  /** All values in which the union is connected to the given models */
  bottomLeftAsset?: InputMaybe<ImageCopyBottomLeftAssetWhereInput>;
  /** All values in which the union is empty */
  bottomLeftAsset_empty?: InputMaybe<Scalars['Boolean']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ImageCopyWhereStageInput>;
  documentInStages_none?: InputMaybe<ImageCopyWhereStageInput>;
  documentInStages_some?: InputMaybe<ImageCopyWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  imageCopyItem_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  imageCopyItem_some?: InputMaybe<ImageCopyImageCopyItemWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  /** All values in which the union is connected to the given models */
  topRightAsset?: InputMaybe<ImageCopyTopRightAssetWhereInput>;
  /** All values in which the union is empty */
  topRightAsset_empty?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ImageCopyWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageCopyWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageCopyWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageCopyWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ImageCopyWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ImageCopy record uniquely */
export type ImageCopyWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Crops the image to the specified dimensions.
 * The starting points for X and Y coordinates are [0,0], aligning with the top-left corner of the image.
 * The width and height parameters determine the size in pixels of the cropping rectangle.
 * The output will include only the portion of the image within the designated crop area.
 */
export type ImageCropInput = {
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height: Scalars['Int']['input'];
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width: Scalars['Int']['input'];
  /** The x coordinate of the image. The value must be an integer from 0 to 10000. */
  x: Scalars['Int']['input'];
  /** The y coordinate of the image. The value must be an integer from 0 to 10000. */
  y: Scalars['Int']['input'];
};

export enum ImageFit {
  /** Resizes the image to fit within the specified parameters without distorting, cropping, or changing the aspect ratio. */
  clip = 'clip',
  /** Resizes the image to fit the specified parameters exactly by removing any parts of the image that don't fit within the boundaries. */
  crop = 'crop',
  /** Resizes the image to fit within the parameters, but as opposed to 'fit:clip' will not scale the image if the image is smaller than the output size. */
  max = 'max',
  /** Resizes the image to fit the specified parameters exactly by scaling the image to the desired size. The aspect ratio of the image is not respected and the image can be distorted using this method. */
  scale = 'scale'
}

export type ImageQualityInput = {
  /** The quality of the image. The value must be an integer from 1 to 100. */
  value: Scalars['Int']['input'];
};

export type ImageResizeInput = {
  /** The default value for the fit parameter is fit:clip. */
  fit?: InputMaybe<ImageFit>;
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageSharpenInput = {
  /** The amount of sharpening to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

/** Image Text Alignment options */
export enum ImageTextAlignment {
  ImageLeftTextRight = 'ImageLeftTextRight',
  ImageRightTextLeft = 'ImageRightTextLeft'
}

/** Transformations for Images */
export type ImageTransformationInput = {
  /** Blurs the image. */
  blur?: InputMaybe<ImageBlurInput>;
  /** Adds a border to the image. */
  border?: InputMaybe<ImageBorderInput>;
  /** Compresses the image. */
  compress?: InputMaybe<ImageCompressInput>;
  /** Crops the image to the specified dimensions. */
  crop?: InputMaybe<ImageCropInput>;
  /**
   * Changes the quality of the image. The value must be an integer from 1 to 100.
   * Only supported for the following formats jpeg, jpg, webp, gif, heif, tiff, avif.
   */
  quality?: InputMaybe<ImageQualityInput>;
  /** Resizes the image */
  resize?: InputMaybe<ImageResizeInput>;
  /** Sharpens the image. */
  sharpen?: InputMaybe<ImageSharpenInput>;
};

/** Introductory text for quick overview of the page */
export type IntroText = Entity & Node & {
  __typename?: 'IntroText';
  anchorNav?: Maybe<AnchorNavigation>;
  /** Title to be used to find the contents in the CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Description field for adding description text in the component */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<IntroText>;
  genericPages: Array<GenericPage>;
  /** List of IntroText versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** specifies in which component this intro text will be used */
  key?: Maybe<Scalars['String']['output']>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  /** Superscripted text that displays above the title */
  super?: Maybe<Scalars['String']['output']>;
  tabContent?: Maybe<TabContent>;
  /** Title field for the title of the component */
  title?: Maybe<Scalars['String']['output']>;
  titleTag?: Maybe<Headlines>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Introductory text for quick overview of the page */
export type IntroTextAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Introductory text for quick overview of the page */
export type IntroTextCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Introductory text for quick overview of the page */
export type IntroTextDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Introductory text for quick overview of the page */
export type IntroTextGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Introductory text for quick overview of the page */
export type IntroTextHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Introductory text for quick overview of the page */
export type IntroTextMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Introductory text for quick overview of the page */
export type IntroTextPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Introductory text for quick overview of the page */
export type IntroTextScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Introductory text for quick overview of the page */
export type IntroTextSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Introductory text for quick overview of the page */
export type IntroTextTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Introductory text for quick overview of the page */
export type IntroTextUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type IntroTextConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: IntroTextWhereUniqueInput;
};

/** A connection to a list of items. */
export type IntroTextConnection = {
  __typename?: 'IntroTextConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<IntroTextEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type IntroTextCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  ckviae3vk4ed101xnhjrr84xw?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  ckviaeyi84jkq01y06f8058yy?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  ckviapp764eno01xndi2h8ljo?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  ckviaqi0c4eor01xndn096wdu?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  ckvid2fqt4ct501wife6a2i6v?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  ckvid18gb4ghf01xne3nehjgn?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  key?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  super?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleTag?: InputMaybe<Headlines>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IntroTextCreateManyInlineInput = {
  /** Connect multiple existing IntroText documents */
  connect?: InputMaybe<Array<IntroTextWhereUniqueInput>>;
  /** Create and connect multiple existing IntroText documents */
  create?: InputMaybe<Array<IntroTextCreateInput>>;
};

export type IntroTextCreateOneInlineInput = {
  /** Connect one existing IntroText document */
  connect?: InputMaybe<IntroTextWhereUniqueInput>;
  /** Create and connect one IntroText document */
  create?: InputMaybe<IntroTextCreateInput>;
};

/** An edge in a connection. */
export type IntroTextEdge = {
  __typename?: 'IntroTextEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: IntroText;
};

/** Identifies documents */
export type IntroTextManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<IntroTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<IntroTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<IntroTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<IntroTextWhereStageInput>;
  documentInStages_none?: InputMaybe<IntroTextWhereStageInput>;
  documentInStages_some?: InputMaybe<IntroTextWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  super?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  super_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  super_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  super_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  super_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  super_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  super_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  super_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  super_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  super_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleTag?: InputMaybe<Headlines>;
  /** All values that are contained in given list. */
  titleTag_in?: InputMaybe<Array<InputMaybe<Headlines>>>;
  /** Any other value that exists and is not equal to the given value. */
  titleTag_not?: InputMaybe<Headlines>;
  /** All values that are not contained in given list. */
  titleTag_not_in?: InputMaybe<Array<InputMaybe<Headlines>>>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum IntroTextOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  key_ASC = 'key_ASC',
  key_DESC = 'key_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  super_ASC = 'super_ASC',
  super_DESC = 'super_DESC',
  titleTag_ASC = 'titleTag_ASC',
  titleTag_DESC = 'titleTag_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type IntroTextUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  ckviae3vk4ed101xnhjrr84xw?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  ckviaeyi84jkq01y06f8058yy?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  ckviapp764eno01xndi2h8ljo?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  ckviaqi0c4eor01xndn096wdu?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  ckvid2fqt4ct501wife6a2i6v?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  ckvid18gb4ghf01xne3nehjgn?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  key?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  super?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleTag?: InputMaybe<Headlines>;
};

export type IntroTextUpdateManyInlineInput = {
  /** Connect multiple existing IntroText documents */
  connect?: InputMaybe<Array<IntroTextConnectInput>>;
  /** Create and connect multiple IntroText documents */
  create?: InputMaybe<Array<IntroTextCreateInput>>;
  /** Delete multiple IntroText documents */
  delete?: InputMaybe<Array<IntroTextWhereUniqueInput>>;
  /** Disconnect multiple IntroText documents */
  disconnect?: InputMaybe<Array<IntroTextWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing IntroText documents */
  set?: InputMaybe<Array<IntroTextWhereUniqueInput>>;
  /** Update multiple IntroText documents */
  update?: InputMaybe<Array<IntroTextUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple IntroText documents */
  upsert?: InputMaybe<Array<IntroTextUpsertWithNestedWhereUniqueInput>>;
};

export type IntroTextUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  super?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleTag?: InputMaybe<Headlines>;
};

export type IntroTextUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: IntroTextUpdateManyInput;
  /** Document search */
  where: IntroTextWhereInput;
};

export type IntroTextUpdateOneInlineInput = {
  /** Connect existing IntroText document */
  connect?: InputMaybe<IntroTextWhereUniqueInput>;
  /** Create and connect one IntroText document */
  create?: InputMaybe<IntroTextCreateInput>;
  /** Delete currently connected IntroText document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected IntroText document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single IntroText document */
  update?: InputMaybe<IntroTextUpdateWithNestedWhereUniqueInput>;
  /** Upsert single IntroText document */
  upsert?: InputMaybe<IntroTextUpsertWithNestedWhereUniqueInput>;
};

export type IntroTextUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: IntroTextUpdateInput;
  /** Unique document search */
  where: IntroTextWhereUniqueInput;
};

export type IntroTextUpsertInput = {
  /** Create document if it didn't exist */
  create: IntroTextCreateInput;
  /** Update document if it exists */
  update: IntroTextUpdateInput;
};

export type IntroTextUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: IntroTextUpsertInput;
  /** Unique document search */
  where: IntroTextWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type IntroTextWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type IntroTextWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<IntroTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<IntroTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<IntroTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<IntroTextWhereStageInput>;
  documentInStages_none?: InputMaybe<IntroTextWhereStageInput>;
  documentInStages_some?: InputMaybe<IntroTextWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  super?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  super_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  super_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  super_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  super_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  super_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  super_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  super_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  super_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  super_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleTag?: InputMaybe<Headlines>;
  /** All values that are contained in given list. */
  titleTag_in?: InputMaybe<Array<InputMaybe<Headlines>>>;
  /** Any other value that exists and is not equal to the given value. */
  titleTag_not?: InputMaybe<Headlines>;
  /** All values that are not contained in given list. */
  titleTag_not_in?: InputMaybe<Array<InputMaybe<Headlines>>>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type IntroTextWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<IntroTextWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<IntroTextWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<IntroTextWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<IntroTextWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References IntroText record uniquely */
export type IntroTextWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum Languages {
  BG = 'BG',
  BR = 'BR',
  BS = 'BS',
  CS = 'CS',
  DA = 'DA',
  DE = 'DE',
  EN = 'EN',
  ES = 'ES',
  FI = 'FI',
  FR = 'FR',
  HR = 'HR',
  IT = 'IT',
  LT = 'LT',
  LV = 'LV',
  NL = 'NL',
  NO = 'NO',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  SK = 'SK',
  SL = 'SL',
  SR = 'SR',
  SV = 'SV',
  TR = 'TR'
}

export type LeftColumn = Entity & Node & {
  __typename?: 'LeftColumn';
  /** Asset Component for ImageCopy component */
  assetsComponents: Array<AssetComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Left column rich text */
  description?: Maybe<LeftColumnDescriptionRichText>;
  /** Get the document in other stages */
  documentInStages: Array<LeftColumn>;
  /** List of LeftColumn versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Left column title to the rich text */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Video url */
  video?: Maybe<Scalars['String']['output']>;
};


export type LeftColumnAssetsComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentWhereInput>;
};


export type LeftColumnCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LeftColumnDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type LeftColumnHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type LeftColumnMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LeftColumnPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LeftColumnScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type LeftColumnUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type LeftColumnConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: LeftColumnWhereUniqueInput;
};

/** A connection to a list of items. */
export type LeftColumnConnection = {
  __typename?: 'LeftColumnConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<LeftColumnEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LeftColumnCreateInput = {
  assetsComponents?: InputMaybe<AssetComponentCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type LeftColumnCreateManyInlineInput = {
  /** Connect multiple existing LeftColumn documents */
  connect?: InputMaybe<Array<LeftColumnWhereUniqueInput>>;
  /** Create and connect multiple existing LeftColumn documents */
  create?: InputMaybe<Array<LeftColumnCreateInput>>;
};

export type LeftColumnCreateOneInlineInput = {
  /** Connect one existing LeftColumn document */
  connect?: InputMaybe<LeftColumnWhereUniqueInput>;
  /** Create and connect one LeftColumn document */
  create?: InputMaybe<LeftColumnCreateInput>;
};

export type LeftColumnDescriptionRichText = {
  __typename?: 'LeftColumnDescriptionRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<LeftColumnDescriptionRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type LeftColumnDescriptionRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type LeftColumnDescriptionRichTextEmbeddedTypes = Asset;

/** An edge in a connection. */
export type LeftColumnEdge = {
  __typename?: 'LeftColumnEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LeftColumn;
};

/** Identifies documents */
export type LeftColumnManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LeftColumnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LeftColumnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LeftColumnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LeftColumnWhereStageInput>;
  documentInStages_none?: InputMaybe<LeftColumnWhereStageInput>;
  documentInStages_some?: InputMaybe<LeftColumnWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  video_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  video_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  video_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  video_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  video_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  video_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  video_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  video_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  video_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum LeftColumnOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  video_ASC = 'video_ASC',
  video_DESC = 'video_DESC'
}

export type LeftColumnUpdateInput = {
  assetsComponents?: InputMaybe<AssetComponentUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type LeftColumnUpdateManyInlineInput = {
  /** Connect multiple existing LeftColumn documents */
  connect?: InputMaybe<Array<LeftColumnConnectInput>>;
  /** Create and connect multiple LeftColumn documents */
  create?: InputMaybe<Array<LeftColumnCreateInput>>;
  /** Delete multiple LeftColumn documents */
  delete?: InputMaybe<Array<LeftColumnWhereUniqueInput>>;
  /** Disconnect multiple LeftColumn documents */
  disconnect?: InputMaybe<Array<LeftColumnWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing LeftColumn documents */
  set?: InputMaybe<Array<LeftColumnWhereUniqueInput>>;
  /** Update multiple LeftColumn documents */
  update?: InputMaybe<Array<LeftColumnUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple LeftColumn documents */
  upsert?: InputMaybe<Array<LeftColumnUpsertWithNestedWhereUniqueInput>>;
};

export type LeftColumnUpdateManyInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type LeftColumnUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: LeftColumnUpdateManyInput;
  /** Document search */
  where: LeftColumnWhereInput;
};

export type LeftColumnUpdateOneInlineInput = {
  /** Connect existing LeftColumn document */
  connect?: InputMaybe<LeftColumnWhereUniqueInput>;
  /** Create and connect one LeftColumn document */
  create?: InputMaybe<LeftColumnCreateInput>;
  /** Delete currently connected LeftColumn document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected LeftColumn document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single LeftColumn document */
  update?: InputMaybe<LeftColumnUpdateWithNestedWhereUniqueInput>;
  /** Upsert single LeftColumn document */
  upsert?: InputMaybe<LeftColumnUpsertWithNestedWhereUniqueInput>;
};

export type LeftColumnUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: LeftColumnUpdateInput;
  /** Unique document search */
  where: LeftColumnWhereUniqueInput;
};

export type LeftColumnUpsertInput = {
  /** Create document if it didn't exist */
  create: LeftColumnCreateInput;
  /** Update document if it exists */
  update: LeftColumnUpdateInput;
};

export type LeftColumnUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: LeftColumnUpsertInput;
  /** Unique document search */
  where: LeftColumnWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type LeftColumnWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type LeftColumnWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LeftColumnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LeftColumnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LeftColumnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LeftColumnWhereStageInput>;
  documentInStages_none?: InputMaybe<LeftColumnWhereStageInput>;
  documentInStages_some?: InputMaybe<LeftColumnWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  video_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  video_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  video_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  video_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  video_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  video_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  video_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  video_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  video_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type LeftColumnWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LeftColumnWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LeftColumnWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LeftColumnWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<LeftColumnWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References LeftColumn record uniquely */
export type LeftColumnWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum LeftRight {
  Left = 'Left',
  Right = 'Right'
}

export type Link = Entity & Node & {
  __typename?: 'Link';
  appStore?: Maybe<DownloadApp>;
  banner?: Maybe<HeroBanner>;
  countrySelectorItems: Array<CountrySelectorItem>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Link text */
  displayName: Scalars['String']['output'];
  /** Get the document in other stages */
  documentInStages: Array<Link>;
  footerNavigation?: Maybe<FooterNavigation>;
  genericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  genericPages: Array<GenericPage>;
  googlePlay?: Maybe<DownloadApp>;
  heroBannerMasterbrand?: Maybe<HeroBannerMasterbrand>;
  /** List of Link versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  imageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Links referencing pages within the CMS */
  internalLink?: Maybe<LinkInternalLinkMigrate>;
  /** Links referencing pages within the CMS ( Available for Header Navigations,  Footer, Banner1, Banner2, Hero Banners ) */
  internalLinkLegacy?: Maybe<LinkInernalLink>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** Navigation Text and link item */
  navigation?: Maybe<Navigation>;
  navigationItems: Array<NavigationItem>;
  openInNewTab: Scalars['Boolean']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  teaser: Array<Teaser>;
  teaserSmallComponents: Array<TeaserSmall>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** These are the links that sit outside the CMS. Use "/" before any link. Example : /recipes/f1bbcdcd0eb0331fc12579ab00260e4c */
  url?: Maybe<Scalars['String']['output']>;
};


export type LinkAppStoreArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkBannerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkCountrySelectorItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountrySelectorItemWhereInput>;
};


export type LinkCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type LinkFooterNavigationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkGenericCardCarouseComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type LinkGooglePlayArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkHeroBannerMasterbrandArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type LinkImageAndTextCardArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkInternalLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkInternalLinkLegacyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkNavigationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkNavigationItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationItemWhereInput>;
};


export type LinkPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type LinkSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkTeaserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TeaserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserWhereInput>;
};


export type LinkTeaserSmallComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TeaserSmallOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallWhereInput>;
};


export type LinkUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type LinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: LinkWhereUniqueInput;
};

/** A connection to a list of items. */
export type LinkConnection = {
  __typename?: 'LinkConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<LinkEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LinkCreateInput = {
  appStore?: InputMaybe<DownloadAppCreateOneInlineInput>;
  banner?: InputMaybe<HeroBannerCreateOneInlineInput>;
  ckruaszxz1vll01xz96vwfsha?: InputMaybe<Banner1CreateManyInlineInput>;
  ckrylru5d1v9f01z83lt98f6n?: InputMaybe<AnchorNavCreateManyInlineInput>;
  cks9cz40s1ygm01z3fqng99fs?: InputMaybe<Banner2CreateManyInlineInput>;
  ckseb3fdw4ip801z3hlfa5rcv?: InputMaybe<AuthorableContentCardCreateManyInlineInput>;
  cksogk5fk1tfq01xn4f3hcue8?: InputMaybe<DynamicCardGridCreateManyInlineInput>;
  cksu33ta65o9t01w95iqyaee9?: InputMaybe<SustainabilityBannerCreateManyInlineInput>;
  ckt8iwjdu2sub01xq6xz381j9?: InputMaybe<ContactCardCreateManyInlineInput>;
  ckuf783zo87n201xh3nwuhxjc?: InputMaybe<NotificationBannerCreateManyInlineInput>;
  ckul9jope2ssv01xq74r806ij?: InputMaybe<SearchOverlayComponentCreateManyInlineInput>;
  ckv9n4fu80pkx01xt6m6rbdmf?: InputMaybe<ProductBannerCreateManyInlineInput>;
  ckw4ovwz80p5301z8h3lncny1?: InputMaybe<ErrorPageCreateManyInlineInput>;
  ckwdc49fm559d01xq2zd1435n?: InputMaybe<NavigationItemCreateManyInlineInput>;
  ckx02hs6b0f5c01w814at7l74?: InputMaybe<CardComponentCreateManyInlineInput>;
  clyg1fcuk00vs07w2cj397d5n?: InputMaybe<MultiStepPromotionFormCreateManyInlineInput>;
  clzi9lusv016l08uj5mg7fb9e?: InputMaybe<SingleStepPromotionFormCreateManyInlineInput>;
  countrySelectorItems?: InputMaybe<CountrySelectorItemCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayName: Scalars['String']['input'];
  footerNavigation?: InputMaybe<FooterNavigationCreateOneInlineInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  googlePlay?: InputMaybe<DownloadAppCreateOneInlineInput>;
  heroBannerMasterbrand?: InputMaybe<HeroBannerMasterbrandCreateOneInlineInput>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardCreateOneInlineInput>;
  internalLink?: InputMaybe<LinkInternalLinkMigrateCreateOneInlineInput>;
  internalLinkLegacy?: InputMaybe<LinkInernalLinkCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  navigation?: InputMaybe<NavigationCreateOneInlineInput>;
  navigationItems?: InputMaybe<NavigationItemCreateManyInlineInput>;
  openInNewTab: Scalars['Boolean']['input'];
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  teaser?: InputMaybe<TeaserCreateManyInlineInput>;
  teaserSmallComponents?: InputMaybe<TeaserSmallCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LinkCreateManyInlineInput = {
  /** Connect multiple existing Link documents */
  connect?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Create and connect multiple existing Link documents */
  create?: InputMaybe<Array<LinkCreateInput>>;
};

export type LinkCreateOneInlineInput = {
  /** Connect one existing Link document */
  connect?: InputMaybe<LinkWhereUniqueInput>;
  /** Create and connect one Link document */
  create?: InputMaybe<LinkCreateInput>;
};

/** An edge in a connection. */
export type LinkEdge = {
  __typename?: 'LinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Link;
};

export type LinkInernalLink = GenericPage | ProductCategoryPage | ProductLandingPage | ProductSubcategoryPage | RecipeCategory | RecipeLandingPage | RecipeSubcategory;

export type LinkInernalLinkConnectInput = {
  GenericPage?: InputMaybe<GenericPageConnectInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageConnectInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageConnectInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageConnectInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryConnectInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageConnectInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryConnectInput>;
};

export type LinkInernalLinkCreateInput = {
  GenericPage?: InputMaybe<GenericPageCreateInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageCreateInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageCreateInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageCreateInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryCreateInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageCreateInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryCreateInput>;
};

export type LinkInernalLinkCreateManyInlineInput = {
  /** Connect multiple existing LinkInernalLink documents */
  connect?: InputMaybe<Array<LinkInernalLinkWhereUniqueInput>>;
  /** Create and connect multiple existing LinkInernalLink documents */
  create?: InputMaybe<Array<LinkInernalLinkCreateInput>>;
};

export type LinkInernalLinkCreateOneInlineInput = {
  /** Connect one existing LinkInernalLink document */
  connect?: InputMaybe<LinkInernalLinkWhereUniqueInput>;
  /** Create and connect one LinkInernalLink document */
  create?: InputMaybe<LinkInernalLinkCreateInput>;
};

export type LinkInernalLinkUpdateInput = {
  GenericPage?: InputMaybe<GenericPageUpdateInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageUpdateInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageUpdateInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpdateInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryUpdateInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageUpdateInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateInput>;
};

export type LinkInernalLinkUpdateManyInlineInput = {
  /** Connect multiple existing LinkInernalLink documents */
  connect?: InputMaybe<Array<LinkInernalLinkConnectInput>>;
  /** Create and connect multiple LinkInernalLink documents */
  create?: InputMaybe<Array<LinkInernalLinkCreateInput>>;
  /** Delete multiple LinkInernalLink documents */
  delete?: InputMaybe<Array<LinkInernalLinkWhereUniqueInput>>;
  /** Disconnect multiple LinkInernalLink documents */
  disconnect?: InputMaybe<Array<LinkInernalLinkWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing LinkInernalLink documents */
  set?: InputMaybe<Array<LinkInernalLinkWhereUniqueInput>>;
  /** Update multiple LinkInernalLink documents */
  update?: InputMaybe<Array<LinkInernalLinkUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple LinkInernalLink documents */
  upsert?: InputMaybe<Array<LinkInernalLinkUpsertWithNestedWhereUniqueInput>>;
};

export type LinkInernalLinkUpdateManyWithNestedWhereInput = {
  GenericPage?: InputMaybe<GenericPageUpdateManyWithNestedWhereInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageUpdateManyWithNestedWhereInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageUpdateManyWithNestedWhereInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpdateManyWithNestedWhereInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryUpdateManyWithNestedWhereInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageUpdateManyWithNestedWhereInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateManyWithNestedWhereInput>;
};

export type LinkInernalLinkUpdateOneInlineInput = {
  /** Connect existing LinkInernalLink document */
  connect?: InputMaybe<LinkInernalLinkWhereUniqueInput>;
  /** Create and connect one LinkInernalLink document */
  create?: InputMaybe<LinkInernalLinkCreateInput>;
  /** Delete currently connected LinkInernalLink document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected LinkInernalLink document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single LinkInernalLink document */
  update?: InputMaybe<LinkInernalLinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single LinkInernalLink document */
  upsert?: InputMaybe<LinkInernalLinkUpsertWithNestedWhereUniqueInput>;
};

export type LinkInernalLinkUpdateWithNestedWhereUniqueInput = {
  GenericPage?: InputMaybe<GenericPageUpdateWithNestedWhereUniqueInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageUpdateWithNestedWhereUniqueInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageUpdateWithNestedWhereUniqueInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpdateWithNestedWhereUniqueInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryUpdateWithNestedWhereUniqueInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageUpdateWithNestedWhereUniqueInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateWithNestedWhereUniqueInput>;
};

export type LinkInernalLinkUpsertWithNestedWhereUniqueInput = {
  GenericPage?: InputMaybe<GenericPageUpsertWithNestedWhereUniqueInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageUpsertWithNestedWhereUniqueInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageUpsertWithNestedWhereUniqueInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpsertWithNestedWhereUniqueInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryUpsertWithNestedWhereUniqueInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageUpsertWithNestedWhereUniqueInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpsertWithNestedWhereUniqueInput>;
};

export type LinkInernalLinkWhereInput = {
  GenericPage?: InputMaybe<GenericPageWhereInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageWhereInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageWhereInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageWhereInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryWhereInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageWhereInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryWhereInput>;
};

export type LinkInernalLinkWhereUniqueInput = {
  GenericPage?: InputMaybe<GenericPageWhereUniqueInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageWhereUniqueInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageWhereUniqueInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageWhereUniqueInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryWhereUniqueInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageWhereUniqueInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryWhereUniqueInput>;
};

export type LinkInternalLinkMigrate = GenericPage | ProductCategoryPage | ProductLandingPage | ProductSubcategoryPage | RecipeCategory | RecipeLandingPage | RecipeSubcategory;

export type LinkInternalLinkMigrateConnectInput = {
  GenericPage?: InputMaybe<GenericPageConnectInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageConnectInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageConnectInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageConnectInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryConnectInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageConnectInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryConnectInput>;
};

export type LinkInternalLinkMigrateCreateInput = {
  GenericPage?: InputMaybe<GenericPageCreateInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageCreateInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageCreateInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageCreateInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryCreateInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageCreateInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryCreateInput>;
};

export type LinkInternalLinkMigrateCreateManyInlineInput = {
  /** Connect multiple existing LinkInternalLinkMigrate documents */
  connect?: InputMaybe<Array<LinkInternalLinkMigrateWhereUniqueInput>>;
  /** Create and connect multiple existing LinkInternalLinkMigrate documents */
  create?: InputMaybe<Array<LinkInternalLinkMigrateCreateInput>>;
};

export type LinkInternalLinkMigrateCreateOneInlineInput = {
  /** Connect one existing LinkInternalLinkMigrate document */
  connect?: InputMaybe<LinkInternalLinkMigrateWhereUniqueInput>;
  /** Create and connect one LinkInternalLinkMigrate document */
  create?: InputMaybe<LinkInternalLinkMigrateCreateInput>;
};

export type LinkInternalLinkMigrateUpdateInput = {
  GenericPage?: InputMaybe<GenericPageUpdateInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageUpdateInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageUpdateInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpdateInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryUpdateInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageUpdateInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateInput>;
};

export type LinkInternalLinkMigrateUpdateManyInlineInput = {
  /** Connect multiple existing LinkInternalLinkMigrate documents */
  connect?: InputMaybe<Array<LinkInternalLinkMigrateConnectInput>>;
  /** Create and connect multiple LinkInternalLinkMigrate documents */
  create?: InputMaybe<Array<LinkInternalLinkMigrateCreateInput>>;
  /** Delete multiple LinkInternalLinkMigrate documents */
  delete?: InputMaybe<Array<LinkInternalLinkMigrateWhereUniqueInput>>;
  /** Disconnect multiple LinkInternalLinkMigrate documents */
  disconnect?: InputMaybe<Array<LinkInternalLinkMigrateWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing LinkInternalLinkMigrate documents */
  set?: InputMaybe<Array<LinkInternalLinkMigrateWhereUniqueInput>>;
  /** Update multiple LinkInternalLinkMigrate documents */
  update?: InputMaybe<Array<LinkInternalLinkMigrateUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple LinkInternalLinkMigrate documents */
  upsert?: InputMaybe<Array<LinkInternalLinkMigrateUpsertWithNestedWhereUniqueInput>>;
};

export type LinkInternalLinkMigrateUpdateManyWithNestedWhereInput = {
  GenericPage?: InputMaybe<GenericPageUpdateManyWithNestedWhereInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageUpdateManyWithNestedWhereInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageUpdateManyWithNestedWhereInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpdateManyWithNestedWhereInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryUpdateManyWithNestedWhereInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageUpdateManyWithNestedWhereInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateManyWithNestedWhereInput>;
};

export type LinkInternalLinkMigrateUpdateOneInlineInput = {
  /** Connect existing LinkInternalLinkMigrate document */
  connect?: InputMaybe<LinkInternalLinkMigrateWhereUniqueInput>;
  /** Create and connect one LinkInternalLinkMigrate document */
  create?: InputMaybe<LinkInternalLinkMigrateCreateInput>;
  /** Delete currently connected LinkInternalLinkMigrate document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected LinkInternalLinkMigrate document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single LinkInternalLinkMigrate document */
  update?: InputMaybe<LinkInternalLinkMigrateUpdateWithNestedWhereUniqueInput>;
  /** Upsert single LinkInternalLinkMigrate document */
  upsert?: InputMaybe<LinkInternalLinkMigrateUpsertWithNestedWhereUniqueInput>;
};

export type LinkInternalLinkMigrateUpdateWithNestedWhereUniqueInput = {
  GenericPage?: InputMaybe<GenericPageUpdateWithNestedWhereUniqueInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageUpdateWithNestedWhereUniqueInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageUpdateWithNestedWhereUniqueInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpdateWithNestedWhereUniqueInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryUpdateWithNestedWhereUniqueInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageUpdateWithNestedWhereUniqueInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateWithNestedWhereUniqueInput>;
};

export type LinkInternalLinkMigrateUpsertWithNestedWhereUniqueInput = {
  GenericPage?: InputMaybe<GenericPageUpsertWithNestedWhereUniqueInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageUpsertWithNestedWhereUniqueInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageUpsertWithNestedWhereUniqueInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpsertWithNestedWhereUniqueInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryUpsertWithNestedWhereUniqueInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageUpsertWithNestedWhereUniqueInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpsertWithNestedWhereUniqueInput>;
};

export type LinkInternalLinkMigrateWhereInput = {
  GenericPage?: InputMaybe<GenericPageWhereInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageWhereInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageWhereInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageWhereInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryWhereInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageWhereInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryWhereInput>;
};

export type LinkInternalLinkMigrateWhereUniqueInput = {
  GenericPage?: InputMaybe<GenericPageWhereUniqueInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageWhereUniqueInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageWhereUniqueInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageWhereUniqueInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryWhereUniqueInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageWhereUniqueInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryWhereUniqueInput>;
};

/** Identifies documents */
export type LinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  appStore?: InputMaybe<DownloadAppWhereInput>;
  banner?: InputMaybe<HeroBannerWhereInput>;
  countrySelectorItems_every?: InputMaybe<CountrySelectorItemWhereInput>;
  countrySelectorItems_none?: InputMaybe<CountrySelectorItemWhereInput>;
  countrySelectorItems_some?: InputMaybe<CountrySelectorItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  displayName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  displayName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  displayName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  displayName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  displayName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  displayName_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<LinkWhereStageInput>;
  documentInStages_none?: InputMaybe<LinkWhereStageInput>;
  documentInStages_some?: InputMaybe<LinkWhereStageInput>;
  footerNavigation?: InputMaybe<FooterNavigationWhereInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  googlePlay?: InputMaybe<DownloadAppWhereInput>;
  heroBannerMasterbrand?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardWhereInput>;
  /** All values in which the union is connected to the given models */
  internalLink?: InputMaybe<LinkInternalLinkMigrateWhereInput>;
  /** All values in which the union is connected to the given models */
  internalLinkLegacy?: InputMaybe<LinkInernalLinkWhereInput>;
  /** All values in which the union is empty */
  internalLinkLegacy_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** All values in which the union is empty */
  internalLink_empty?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  navigation?: InputMaybe<NavigationWhereInput>;
  navigationItems_every?: InputMaybe<NavigationItemWhereInput>;
  navigationItems_none?: InputMaybe<NavigationItemWhereInput>;
  navigationItems_some?: InputMaybe<NavigationItemWhereInput>;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  openInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  teaserSmallComponents_every?: InputMaybe<TeaserSmallWhereInput>;
  teaserSmallComponents_none?: InputMaybe<TeaserSmallWhereInput>;
  teaserSmallComponents_some?: InputMaybe<TeaserSmallWhereInput>;
  teaser_every?: InputMaybe<TeaserWhereInput>;
  teaser_none?: InputMaybe<TeaserWhereInput>;
  teaser_some?: InputMaybe<TeaserWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum LinkOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  displayName_ASC = 'displayName_ASC',
  displayName_DESC = 'displayName_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  openInNewTab_ASC = 'openInNewTab_ASC',
  openInNewTab_DESC = 'openInNewTab_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC'
}

export type LinkUpdateInput = {
  appStore?: InputMaybe<DownloadAppUpdateOneInlineInput>;
  banner?: InputMaybe<HeroBannerUpdateOneInlineInput>;
  ckruaszxz1vll01xz96vwfsha?: InputMaybe<Banner1UpdateManyInlineInput>;
  ckrylru5d1v9f01z83lt98f6n?: InputMaybe<AnchorNavUpdateManyInlineInput>;
  cks9cz40s1ygm01z3fqng99fs?: InputMaybe<Banner2UpdateManyInlineInput>;
  ckseb3fdw4ip801z3hlfa5rcv?: InputMaybe<AuthorableContentCardUpdateManyInlineInput>;
  cksogk5fk1tfq01xn4f3hcue8?: InputMaybe<DynamicCardGridUpdateManyInlineInput>;
  cksu33ta65o9t01w95iqyaee9?: InputMaybe<SustainabilityBannerUpdateManyInlineInput>;
  ckt8iwjdu2sub01xq6xz381j9?: InputMaybe<ContactCardUpdateManyInlineInput>;
  ckuf783zo87n201xh3nwuhxjc?: InputMaybe<NotificationBannerUpdateManyInlineInput>;
  ckul9jope2ssv01xq74r806ij?: InputMaybe<SearchOverlayComponentUpdateManyInlineInput>;
  ckv9n4fu80pkx01xt6m6rbdmf?: InputMaybe<ProductBannerUpdateManyInlineInput>;
  ckw4ovwz80p5301z8h3lncny1?: InputMaybe<ErrorPageUpdateManyInlineInput>;
  ckwdc49fm559d01xq2zd1435n?: InputMaybe<NavigationItemUpdateManyInlineInput>;
  ckx02hs6b0f5c01w814at7l74?: InputMaybe<CardComponentUpdateManyInlineInput>;
  clyg1fcuk00vs07w2cj397d5n?: InputMaybe<MultiStepPromotionFormUpdateManyInlineInput>;
  clzi9lusv016l08uj5mg7fb9e?: InputMaybe<SingleStepPromotionFormUpdateManyInlineInput>;
  countrySelectorItems?: InputMaybe<CountrySelectorItemUpdateManyInlineInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  footerNavigation?: InputMaybe<FooterNavigationUpdateOneInlineInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  googlePlay?: InputMaybe<DownloadAppUpdateOneInlineInput>;
  heroBannerMasterbrand?: InputMaybe<HeroBannerMasterbrandUpdateOneInlineInput>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardUpdateOneInlineInput>;
  internalLink?: InputMaybe<LinkInternalLinkMigrateUpdateOneInlineInput>;
  internalLinkLegacy?: InputMaybe<LinkInernalLinkUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  navigation?: InputMaybe<NavigationUpdateOneInlineInput>;
  navigationItems?: InputMaybe<NavigationItemUpdateManyInlineInput>;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  teaser?: InputMaybe<TeaserUpdateManyInlineInput>;
  teaserSmallComponents?: InputMaybe<TeaserSmallUpdateManyInlineInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LinkUpdateManyInlineInput = {
  /** Connect multiple existing Link documents */
  connect?: InputMaybe<Array<LinkConnectInput>>;
  /** Create and connect multiple Link documents */
  create?: InputMaybe<Array<LinkCreateInput>>;
  /** Delete multiple Link documents */
  delete?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Disconnect multiple Link documents */
  disconnect?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Link documents */
  set?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Update multiple Link documents */
  update?: InputMaybe<Array<LinkUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Link documents */
  upsert?: InputMaybe<Array<LinkUpsertWithNestedWhereUniqueInput>>;
};

export type LinkUpdateManyInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: LinkUpdateManyInput;
  /** Document search */
  where: LinkWhereInput;
};

export type LinkUpdateOneInlineInput = {
  /** Connect existing Link document */
  connect?: InputMaybe<LinkWhereUniqueInput>;
  /** Create and connect one Link document */
  create?: InputMaybe<LinkCreateInput>;
  /** Delete currently connected Link document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Link document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Link document */
  update?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Link document */
  upsert?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
};

export type LinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: LinkUpdateInput;
  /** Unique document search */
  where: LinkWhereUniqueInput;
};

export type LinkUpsertInput = {
  /** Create document if it didn't exist */
  create: LinkCreateInput;
  /** Update document if it exists */
  update: LinkUpdateInput;
};

export type LinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: LinkUpsertInput;
  /** Unique document search */
  where: LinkWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type LinkWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type LinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  appStore?: InputMaybe<DownloadAppWhereInput>;
  banner?: InputMaybe<HeroBannerWhereInput>;
  countrySelectorItems_every?: InputMaybe<CountrySelectorItemWhereInput>;
  countrySelectorItems_none?: InputMaybe<CountrySelectorItemWhereInput>;
  countrySelectorItems_some?: InputMaybe<CountrySelectorItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  displayName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  displayName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  displayName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  displayName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  displayName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  displayName_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<LinkWhereStageInput>;
  documentInStages_none?: InputMaybe<LinkWhereStageInput>;
  documentInStages_some?: InputMaybe<LinkWhereStageInput>;
  footerNavigation?: InputMaybe<FooterNavigationWhereInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  googlePlay?: InputMaybe<DownloadAppWhereInput>;
  heroBannerMasterbrand?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardWhereInput>;
  /** All values in which the union is connected to the given models */
  internalLink?: InputMaybe<LinkInternalLinkMigrateWhereInput>;
  /** All values in which the union is connected to the given models */
  internalLinkLegacy?: InputMaybe<LinkInernalLinkWhereInput>;
  /** All values in which the union is empty */
  internalLinkLegacy_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** All values in which the union is empty */
  internalLink_empty?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  navigation?: InputMaybe<NavigationWhereInput>;
  navigationItems_every?: InputMaybe<NavigationItemWhereInput>;
  navigationItems_none?: InputMaybe<NavigationItemWhereInput>;
  navigationItems_some?: InputMaybe<NavigationItemWhereInput>;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  openInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  teaserSmallComponents_every?: InputMaybe<TeaserSmallWhereInput>;
  teaserSmallComponents_none?: InputMaybe<TeaserSmallWhereInput>;
  teaserSmallComponents_some?: InputMaybe<TeaserSmallWhereInput>;
  teaser_every?: InputMaybe<TeaserWhereInput>;
  teaser_none?: InputMaybe<TeaserWhereInput>;
  teaser_some?: InputMaybe<TeaserWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type LinkWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<LinkWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Link record uniquely */
export type LinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Locale system enumeration */
export enum Locale {
  bg_BG = 'bg_BG',
  bs_BA = 'bs_BA',
  cs_CZ = 'cs_CZ',
  da_DK = 'da_DK',
  de_AT = 'de_AT',
  de_CH = 'de_CH',
  de_DE = 'de_DE',
  /** System locale */
  en = 'en',
  en_AU = 'en_AU',
  en_CA = 'en_CA',
  en_GB = 'en_GB',
  en_IE = 'en_IE',
  en_IN = 'en_IN',
  en_MY = 'en_MY',
  en_US = 'en_US',
  en_ZA = 'en_ZA',
  es_ES = 'es_ES',
  fi_FI = 'fi_FI',
  fr_BE = 'fr_BE',
  fr_CA = 'fr_CA',
  fr_CH = 'fr_CH',
  fr_FR = 'fr_FR',
  hr_HR = 'hr_HR',
  hu_HU = 'hu_HU',
  it_CH = 'it_CH',
  it_IT = 'it_IT',
  ja_JP = 'ja_JP',
  lt_LT = 'lt_LT',
  lv_LV = 'lv_LV',
  nl_BE = 'nl_BE',
  nl_NL = 'nl_NL',
  no_NO = 'no_NO',
  pl_PL = 'pl_PL',
  pt_BR = 'pt_BR',
  pt_PT = 'pt_PT',
  ro_RO = 'ro_RO',
  sk_SK = 'sk_SK',
  sl_SI = 'sl_SI',
  sr_RS = 'sr_RS',
  sv_SE = 'sv_SE',
  tr_TR = 'tr_TR',
  uk_UA = 'uk_UA',
  zh_CN = 'zh_CN'
}

export enum Locales {
  da_DK = 'da_DK',
  de_AT = 'de_AT',
  de_DE = 'de_DE',
  en = 'en',
  en_GB = 'en_GB',
  en_IN = 'en_IN',
  es_ES = 'es_ES',
  fr_FR = 'fr_FR',
  it_IT = 'it_IT',
  my_EN = 'my_EN',
  pl_PL = 'pl_PL',
  pt_PT = 'pt_PT',
  sv_SE = 'sv_SE'
}

/** Representing a geolocation point with latitude and longitude */
export type Location = {
  __typename?: 'Location';
  distance: Scalars['Float']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};


/** Representing a geolocation point with latitude and longitude */
export type LocationDistanceArgs = {
  from: LocationInput;
};

/** Input for a geolocation point with latitude and longitude */
export type LocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type LongText = Entity & Node & {
  __typename?: 'LongText';
  anchorNav?: Maybe<AnchorNavigation>;
  /** Title to be used to find the contents in the CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<LongText>;
  forms: Array<Form>;
  genericPages: Array<GenericPage>;
  /** List of LongText versions */
  history: Array<Version>;
  horizontalAlignment: AlignmentTypes;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Long rich text field */
  longText?: Maybe<LongTextLongTextRichText>;
  market: Markets;
  marketName?: Maybe<Market>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type LongTextAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LongTextCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LongTextDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type LongTextFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type LongTextGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type LongTextHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type LongTextMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LongTextProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


export type LongTextProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


export type LongTextProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


export type LongTextPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LongTextRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type LongTextRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


export type LongTextRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


export type LongTextScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type LongTextSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LongTextTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LongTextUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type LongTextConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: LongTextWhereUniqueInput;
};

/** A connection to a list of items. */
export type LongTextConnection = {
  __typename?: 'LongTextConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<LongTextEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LongTextCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cku89b4b03jkt01xh83paci95?: InputMaybe<RecipeCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  horizontalAlignment: AlignmentTypes;
  longText?: InputMaybe<Scalars['RichTextAST']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LongTextCreateManyInlineInput = {
  /** Connect multiple existing LongText documents */
  connect?: InputMaybe<Array<LongTextWhereUniqueInput>>;
  /** Create and connect multiple existing LongText documents */
  create?: InputMaybe<Array<LongTextCreateInput>>;
};

export type LongTextCreateOneInlineInput = {
  /** Connect one existing LongText document */
  connect?: InputMaybe<LongTextWhereUniqueInput>;
  /** Create and connect one LongText document */
  create?: InputMaybe<LongTextCreateInput>;
};

/** An edge in a connection. */
export type LongTextEdge = {
  __typename?: 'LongTextEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LongText;
};

export type LongTextLongTextRichText = {
  __typename?: 'LongTextLongTextRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<LongTextLongTextRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type LongTextLongTextRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type LongTextLongTextRichTextEmbeddedTypes = Asset;

/** Identifies documents */
export type LongTextManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LongTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LongTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LongTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LongTextWhereStageInput>;
  documentInStages_none?: InputMaybe<LongTextWhereStageInput>;
  documentInStages_some?: InputMaybe<LongTextWhereStageInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  horizontalAlignment?: InputMaybe<AlignmentTypes>;
  /** All values that are contained in given list. */
  horizontalAlignment_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  horizontalAlignment_not?: InputMaybe<AlignmentTypes>;
  /** All values that are not contained in given list. */
  horizontalAlignment_not_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum LongTextOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  horizontalAlignment_ASC = 'horizontalAlignment_ASC',
  horizontalAlignment_DESC = 'horizontalAlignment_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type LongTextUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cku89b4b03jkt01xh83paci95?: InputMaybe<RecipeUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  horizontalAlignment?: InputMaybe<AlignmentTypes>;
  longText?: InputMaybe<Scalars['RichTextAST']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type LongTextUpdateManyInlineInput = {
  /** Connect multiple existing LongText documents */
  connect?: InputMaybe<Array<LongTextConnectInput>>;
  /** Create and connect multiple LongText documents */
  create?: InputMaybe<Array<LongTextCreateInput>>;
  /** Delete multiple LongText documents */
  delete?: InputMaybe<Array<LongTextWhereUniqueInput>>;
  /** Disconnect multiple LongText documents */
  disconnect?: InputMaybe<Array<LongTextWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing LongText documents */
  set?: InputMaybe<Array<LongTextWhereUniqueInput>>;
  /** Update multiple LongText documents */
  update?: InputMaybe<Array<LongTextUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple LongText documents */
  upsert?: InputMaybe<Array<LongTextUpsertWithNestedWhereUniqueInput>>;
};

export type LongTextUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  horizontalAlignment?: InputMaybe<AlignmentTypes>;
  longText?: InputMaybe<Scalars['RichTextAST']['input']>;
  market?: InputMaybe<Markets>;
};

export type LongTextUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: LongTextUpdateManyInput;
  /** Document search */
  where: LongTextWhereInput;
};

export type LongTextUpdateOneInlineInput = {
  /** Connect existing LongText document */
  connect?: InputMaybe<LongTextWhereUniqueInput>;
  /** Create and connect one LongText document */
  create?: InputMaybe<LongTextCreateInput>;
  /** Delete currently connected LongText document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected LongText document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single LongText document */
  update?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  /** Upsert single LongText document */
  upsert?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
};

export type LongTextUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: LongTextUpdateInput;
  /** Unique document search */
  where: LongTextWhereUniqueInput;
};

export type LongTextUpsertInput = {
  /** Create document if it didn't exist */
  create: LongTextCreateInput;
  /** Update document if it exists */
  update: LongTextUpdateInput;
};

export type LongTextUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: LongTextUpsertInput;
  /** Unique document search */
  where: LongTextWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type LongTextWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type LongTextWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LongTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LongTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LongTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LongTextWhereStageInput>;
  documentInStages_none?: InputMaybe<LongTextWhereStageInput>;
  documentInStages_some?: InputMaybe<LongTextWhereStageInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  horizontalAlignment?: InputMaybe<AlignmentTypes>;
  /** All values that are contained in given list. */
  horizontalAlignment_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  horizontalAlignment_not?: InputMaybe<AlignmentTypes>;
  /** All values that are not contained in given list. */
  horizontalAlignment_not_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type LongTextWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LongTextWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LongTextWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LongTextWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<LongTextWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References LongText record uniquely */
export type LongTextWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Market = Entity & Node & {
  __typename?: 'Market';
  accordion: Array<Accordion>;
  accordionItem: Array<AccordionItem>;
  algoliaExtension: Array<AlgoliaExtension>;
  anchorNav: Array<AnchorNav>;
  anchorNavigationList: Array<AnchorNavigationList>;
  anchorNavigations: Array<AnchorNavigation>;
  assetComponent: Array<AssetComponent>;
  audioComponents: Array<AudioComponent>;
  authorableContentCard: Array<AuthorableContentCard>;
  banner1: Array<Banner1>;
  banner2: Array<Banner2>;
  banner2CarouselComponents: Array<Banner2CarouselComponent>;
  cardComponent: Array<CardComponent>;
  carouselComponent: Array<CarouselComponent>;
  carouselSlide: Array<CarouselSlide>;
  categoryCard: Array<CategoryCard>;
  contactCard: Array<ContactCard>;
  contactCardContainer: Array<ContactCardContainer>;
  countrySelectorFooter: Array<CountrySelectorFooter>;
  countrySelectorItem: Array<CountrySelectorItem>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  dictionary: Array<Dictionary>;
  dictionaryItem: Array<DictionaryItem>;
  /** Get the document in other stages */
  documentInStages: Array<Market>;
  downloadApp: Array<DownloadApp>;
  dynamicCardGrid: Array<DynamicCardGrid>;
  errorPage: Array<ErrorPage>;
  evalancheFormComponent: Array<EvalancheFormComponent>;
  exampleComponent: Array<ExampleComponent>;
  featuredContent: Array<FeaturedContent>;
  featuredContentReference: Array<FeaturedContentReference>;
  footerNavigation: Array<FooterNavigation>;
  form: Array<Form>;
  formCheckbox: Array<FormCheckbox>;
  formCheckboxCollection: Array<FormCheckboxCollection>;
  formDateInputs: Array<FormDateInput>;
  formEmailInput: Array<FormEmailInput>;
  formError: Array<FormError>;
  formFileUploader: Array<FormFileUploader>;
  formListItem: Array<FormListItem>;
  formLists: Array<FormList>;
  formNumberInputs: Array<FormNumberInput>;
  formPasswordInput: Array<FormPasswordInput>;
  formPasswordInputWithConfirmation: Array<FormPasswordInputWithConfirmation>;
  formRadioButton: Array<FormRadioButton>;
  formRadioButtonCollection: Array<FormRadioButtonCollection>;
  formSelectComponent: Array<FormSelectComponent>;
  formSelectOption: Array<FormSelectOption>;
  formSubmitButton: Array<FormSubmitButton>;
  formSuccessComponent: Array<FormSuccessComponent>;
  formTextInput: Array<FormTextInput>;
  formTextareaInput: Array<FormTextareaInput>;
  genericAccordion: Array<GenericAccordion>;
  genericAccordionItem: Array<GenericAccordionItem>;
  genericAccordionTopRated: Array<GenericAccordionTopRated>;
  genericCardCarouseComponent: Array<GenericCardCarouseComponent>;
  genericDownloadComponent: Array<GenericDownloadComponent>;
  genericFollowUs: Array<GenericFollowUs>;
  genericGridAuthorable: Array<GenericGridAuthorable>;
  genericHtmlComponents: Array<GenericHtml>;
  genericLine: Array<GenericLine>;
  genericLink: Array<GenericLink>;
  genericPage: Array<GenericPage>;
  genericPromotionsOverviews: Array<GenericPromotionsOverview>;
  genericQualifioOverviews: Array<GenericQualifioOverview>;
  genericQualifios: Array<GenericQualifio>;
  genericSocialShare: Array<GenericSocialShare>;
  globalMetaData: Array<GlobalMetaData>;
  globalSearches: Array<GlobalSearch>;
  gridColumnComponent: Array<GridColumnComponent>;
  gridColumns: Array<GridColumn>;
  heroBanner: Array<HeroBanner>;
  heroBannerMasterbrands: Array<HeroBannerMasterbrand>;
  heroCarouselComponent: Array<HeroCarouselComponent>;
  heroComponent: Array<HeroComponent>;
  /** List of Market versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  iframe: Array<Iframe>;
  imageAndTextCard: Array<ImageAndTextCard>;
  imageCopy: Array<ImageCopy>;
  imageCopyItem: Array<ImageCopyItem>;
  introText: Array<IntroText>;
  leftColumn: Array<LeftColumn>;
  link: Array<Link>;
  longText: Array<LongText>;
  marketDescription?: Maybe<Scalars['String']['output']>;
  marketLocaleId?: Maybe<Markets>;
  marketName?: Maybe<Scalars['String']['output']>;
  marketUserConnection?: Maybe<MarketUserConnection>;
  metaData: Array<MetaData>;
  mobileOnlyMainNavigation: Array<MobileOnlyMainNavigation>;
  navigation: Array<Navigation>;
  navigationItem: Array<NavigationItem>;
  newsletterComponents: Array<NewsletterComponent>;
  notificationBanner: Array<NotificationBanner>;
  pageFooter: Array<PageFooter>;
  pageHeader: Array<PageHeader>;
  popularSearchComponent: Array<PopularSearchComponent>;
  product: Array<Product>;
  productBanner: Array<ProductBanner>;
  productCategory: Array<ProductCategory>;
  productCategoryPage: Array<ProductCategoryPage>;
  productDetailPage: Array<ProductDetailPage>;
  productHero: Array<ProductHero>;
  productLandingPage: Array<ProductLandingPage>;
  productSubcategoryPage: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  question: Array<Question>;
  questionCheckbox: Array<QuestionCheckbox>;
  questionCheckboxCollection: Array<QuestionCheckboxCollection>;
  questionRadioButton: Array<QuestionRadioButton>;
  questionRadioButtonCollection: Array<QuestionRadioButtonCollection>;
  rating: Array<Rating>;
  recipe: Array<Recipe>;
  recipeCategory: Array<RecipeCategory>;
  recipeLandingPage: Array<RecipeLandingPage>;
  recipeSubcategory: Array<RecipeSubcategory>;
  recipesComparisonQueryComponent: Array<RecipesComparisonQueryComponent>;
  recipesQueriesReference: Array<RecipesQueriesReference>;
  recipesQueryComponent: Array<RecipesQueryComponent>;
  redirect: Array<Redirect>;
  rewrite: Array<Rewrite>;
  rightColumn: Array<RightColumn>;
  scheduledIn: Array<ScheduledOperation>;
  searchInput: Array<SearchInput>;
  searchOverlayComponent: Array<SearchOverlayComponent>;
  searchResultPage: Array<SearchResultPage>;
  separators: Array<Separator>;
  socialMediaListComponent: Array<SocialMediaListComponent>;
  spacer: Array<Spacer>;
  /** System stage field */
  stage: Stage;
  subCategoryKeyImage: Array<SubCategoryKeyImage>;
  subTab: Array<SubTab>;
  subTabContent: Array<SubTabContent>;
  sustainabilityBanner: Array<SustainabilityBanner>;
  sustainabilityInfo: Array<SustainabilityInfo>;
  tab: Array<Tab>;
  tabContent: Array<TabContent>;
  teaserPlaceholders: Array<TeaserPlaceholder>;
  teaserSmallComponents: Array<TeaserSmall>;
  teaserSmallPlaceholders: Array<TeaserSmallPlaceholder>;
  teasers: Array<Teaser>;
  testComponentWithRecipeQuery: Array<TestComponentWithRecipeQuery>;
  testTipsANdTricksInAMarket: Array<TestTipsANdTricksInAMarket>;
  textComponent: Array<TextComponent>;
  tipsAndTricksDetailsPage: Array<TipsAndTricksDetailsPage>;
  title: Array<Title>;
  twitterSeo: Array<TwitterSeo>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type MarketAccordionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionWhereInput>;
};


export type MarketAccordionItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionItemWhereInput>;
};


export type MarketAlgoliaExtensionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AlgoliaExtensionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AlgoliaExtensionWhereInput>;
};


export type MarketAnchorNavArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AnchorNavOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorNavWhereInput>;
};


export type MarketAnchorNavigationListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AnchorNavigationListOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorNavigationListWhereInput>;
};


export type MarketAnchorNavigationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AnchorNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorNavigationWhereInput>;
};


export type MarketAssetComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentWhereInput>;
};


export type MarketAudioComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AudioComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AudioComponentWhereInput>;
};


export type MarketAuthorableContentCardArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AuthorableContentCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuthorableContentCardWhereInput>;
};


export type MarketBanner1Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<Banner1OrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Banner1WhereInput>;
};


export type MarketBanner2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<Banner2OrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Banner2WhereInput>;
};


export type MarketBanner2CarouselComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<Banner2CarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Banner2CarouselComponentWhereInput>;
};


export type MarketCardComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CardComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardComponentWhereInput>;
};


export type MarketCarouselComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselComponentWhereInput>;
};


export type MarketCarouselSlideArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CarouselSlideOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselSlideWhereInput>;
};


export type MarketCategoryCardArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CategoryCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryCardWhereInput>;
};


export type MarketContactCardArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ContactCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContactCardWhereInput>;
};


export type MarketContactCardContainerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ContactCardContainerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContactCardContainerWhereInput>;
};


export type MarketCountrySelectorFooterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CountrySelectorFooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountrySelectorFooterWhereInput>;
};


export type MarketCountrySelectorItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CountrySelectorItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountrySelectorItemWhereInput>;
};


export type MarketCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MarketDictionaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<DictionaryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DictionaryWhereInput>;
};


export type MarketDictionaryItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<DictionaryItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DictionaryItemWhereInput>;
};


export type MarketDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type MarketDownloadAppArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<DownloadAppOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DownloadAppWhereInput>;
};


export type MarketDynamicCardGridArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<DynamicCardGridOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DynamicCardGridWhereInput>;
};


export type MarketErrorPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ErrorPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ErrorPageWhereInput>;
};


export type MarketEvalancheFormComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<EvalancheFormComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EvalancheFormComponentWhereInput>;
};


export type MarketExampleComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ExampleComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ExampleComponentWhereInput>;
};


export type MarketFeaturedContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FeaturedContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FeaturedContentWhereInput>;
};


export type MarketFeaturedContentReferenceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FeaturedContentReferenceOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FeaturedContentReferenceWhereInput>;
};


export type MarketFooterNavigationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FooterNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FooterNavigationWhereInput>;
};


export type MarketFormArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type MarketFormCheckboxArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormCheckboxOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormCheckboxWhereInput>;
};


export type MarketFormCheckboxCollectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormCheckboxCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormCheckboxCollectionWhereInput>;
};


export type MarketFormDateInputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormDateInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormDateInputWhereInput>;
};


export type MarketFormEmailInputArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormEmailInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormEmailInputWhereInput>;
};


export type MarketFormErrorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormErrorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormErrorWhereInput>;
};


export type MarketFormFileUploaderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormFileUploaderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormFileUploaderWhereInput>;
};


export type MarketFormListItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormListItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormListItemWhereInput>;
};


export type MarketFormListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormListOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormListWhereInput>;
};


export type MarketFormNumberInputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormNumberInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormNumberInputWhereInput>;
};


export type MarketFormPasswordInputArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormPasswordInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormPasswordInputWhereInput>;
};


export type MarketFormPasswordInputWithConfirmationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormPasswordInputWithConfirmationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormPasswordInputWithConfirmationWhereInput>;
};


export type MarketFormRadioButtonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormRadioButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormRadioButtonWhereInput>;
};


export type MarketFormRadioButtonCollectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormRadioButtonCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormRadioButtonCollectionWhereInput>;
};


export type MarketFormSelectComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormSelectComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSelectComponentWhereInput>;
};


export type MarketFormSelectOptionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormSelectOptionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSelectOptionWhereInput>;
};


export type MarketFormSubmitButtonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormSubmitButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSubmitButtonWhereInput>;
};


export type MarketFormSuccessComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormSuccessComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSuccessComponentWhereInput>;
};


export type MarketFormTextInputArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormTextInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormTextInputWhereInput>;
};


export type MarketFormTextareaInputArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormTextareaInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormTextareaInputWhereInput>;
};


export type MarketGenericAccordionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericAccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionWhereInput>;
};


export type MarketGenericAccordionItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericAccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionItemWhereInput>;
};


export type MarketGenericAccordionTopRatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericAccordionTopRatedOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionTopRatedWhereInput>;
};


export type MarketGenericCardCarouseComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericCardCarouseComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericCardCarouseComponentWhereInput>;
};


export type MarketGenericDownloadComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericDownloadComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericDownloadComponentWhereInput>;
};


export type MarketGenericFollowUsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericFollowUsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericFollowUsWhereInput>;
};


export type MarketGenericGridAuthorableArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericGridAuthorableOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericGridAuthorableWhereInput>;
};


export type MarketGenericHtmlComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericHtmlOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericHtmlWhereInput>;
};


export type MarketGenericLineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericLineOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericLineWhereInput>;
};


export type MarketGenericLinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericLinkWhereInput>;
};


export type MarketGenericPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type MarketGenericPromotionsOverviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericPromotionsOverviewOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPromotionsOverviewWhereInput>;
};


export type MarketGenericQualifioOverviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericQualifioOverviewOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericQualifioOverviewWhereInput>;
};


export type MarketGenericQualifiosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericQualifioOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericQualifioWhereInput>;
};


export type MarketGenericSocialShareArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericSocialShareOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericSocialShareWhereInput>;
};


export type MarketGlobalMetaDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GlobalMetaDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GlobalMetaDataWhereInput>;
};


export type MarketGlobalSearchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GlobalSearchOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GlobalSearchWhereInput>;
};


export type MarketGridColumnComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GridColumnComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GridColumnComponentWhereInput>;
};


export type MarketGridColumnsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GridColumnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GridColumnWhereInput>;
};


export type MarketHeroBannerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroBannerWhereInput>;
};


export type MarketHeroBannerMasterbrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroBannerMasterbrandOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroBannerMasterbrandWhereInput>;
};


export type MarketHeroCarouselComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroCarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroCarouselComponentWhereInput>;
};


export type MarketHeroComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroComponentWhereInput>;
};


export type MarketHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type MarketIframeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<IframeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IframeWhereInput>;
};


export type MarketImageAndTextCardArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ImageAndTextCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageAndTextCardWhereInput>;
};


export type MarketImageCopyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ImageCopyOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageCopyWhereInput>;
};


export type MarketImageCopyItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ImageCopyItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageCopyItemWhereInput>;
};


export type MarketIntroTextArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<IntroTextOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IntroTextWhereInput>;
};


export type MarketLeftColumnArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LeftColumnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LeftColumnWhereInput>;
};


export type MarketLinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


export type MarketLongTextArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LongTextOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LongTextWhereInput>;
};


export type MarketMarketUserConnectionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MarketMetaDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<MetaDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetaDataWhereInput>;
};


export type MarketMobileOnlyMainNavigationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<MobileOnlyMainNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MobileOnlyMainNavigationWhereInput>;
};


export type MarketNavigationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<NavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationWhereInput>;
};


export type MarketNavigationItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<NavigationItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationItemWhereInput>;
};


export type MarketNewsletterComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<NewsletterComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NewsletterComponentWhereInput>;
};


export type MarketNotificationBannerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<NotificationBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationBannerWhereInput>;
};


export type MarketPageFooterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PageFooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageFooterWhereInput>;
};


export type MarketPageHeaderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PageHeaderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageHeaderWhereInput>;
};


export type MarketPopularSearchComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PopularSearchComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PopularSearchComponentWhereInput>;
};


export type MarketProductArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductWhereInput>;
};


export type MarketProductBannerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductBannerWhereInput>;
};


export type MarketProductCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryWhereInput>;
};


export type MarketProductCategoryPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


export type MarketProductDetailPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductDetailPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductDetailPageWhereInput>;
};


export type MarketProductHeroArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductHeroOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductHeroWhereInput>;
};


export type MarketProductLandingPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductLandingPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


export type MarketProductSubcategoryPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductSubcategoryPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


export type MarketPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MarketQuestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<QuestionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionWhereInput>;
};


export type MarketQuestionCheckboxArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<QuestionCheckboxOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionCheckboxWhereInput>;
};


export type MarketQuestionCheckboxCollectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<QuestionCheckboxCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionCheckboxCollectionWhereInput>;
};


export type MarketQuestionRadioButtonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<QuestionRadioButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionRadioButtonWhereInput>;
};


export type MarketQuestionRadioButtonCollectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<QuestionRadioButtonCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionRadioButtonCollectionWhereInput>;
};


export type MarketRatingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RatingOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RatingWhereInput>;
};


export type MarketRecipeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RecipeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeWhereInput>;
};


export type MarketRecipeCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RecipeCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type MarketRecipeLandingPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RecipeLandingPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


export type MarketRecipeSubcategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RecipeSubcategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


export type MarketRecipesComparisonQueryComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RecipesComparisonQueryComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipesComparisonQueryComponentWhereInput>;
};


export type MarketRecipesQueriesReferenceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RecipesQueriesReferenceOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipesQueriesReferenceWhereInput>;
};


export type MarketRecipesQueryComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RecipesQueryComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipesQueryComponentWhereInput>;
};


export type MarketRedirectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RedirectOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RedirectWhereInput>;
};


export type MarketRewriteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RewriteOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RewriteWhereInput>;
};


export type MarketRightColumnArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RightColumnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RightColumnWhereInput>;
};


export type MarketScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type MarketSearchInputArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SearchInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SearchInputWhereInput>;
};


export type MarketSearchOverlayComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SearchOverlayComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SearchOverlayComponentWhereInput>;
};


export type MarketSearchResultPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SearchResultPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SearchResultPageWhereInput>;
};


export type MarketSeparatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SeparatorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SeparatorWhereInput>;
};


export type MarketSocialMediaListComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SocialMediaListComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SocialMediaListComponentWhereInput>;
};


export type MarketSpacerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SpacerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpacerWhereInput>;
};


export type MarketSubCategoryKeyImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SubCategoryKeyImageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubCategoryKeyImageWhereInput>;
};


export type MarketSubTabArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SubTabOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubTabWhereInput>;
};


export type MarketSubTabContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SubTabContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubTabContentWhereInput>;
};


export type MarketSustainabilityBannerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SustainabilityBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SustainabilityBannerWhereInput>;
};


export type MarketSustainabilityInfoArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SustainabilityInfoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SustainabilityInfoWhereInput>;
};


export type MarketTabArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TabOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabWhereInput>;
};


export type MarketTabContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TabContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabContentWhereInput>;
};


export type MarketTeaserPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TeaserPlaceholderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserPlaceholderWhereInput>;
};


export type MarketTeaserSmallComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TeaserSmallOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallWhereInput>;
};


export type MarketTeaserSmallPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TeaserSmallPlaceholderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
};


export type MarketTeasersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TeaserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserWhereInput>;
};


export type MarketTestComponentWithRecipeQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TestComponentWithRecipeQueryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TestComponentWithRecipeQueryWhereInput>;
};


export type MarketTestTipsANdTricksInAMarketArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TestTipsANdTricksInAMarketOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TestTipsANdTricksInAMarketWhereInput>;
};


export type MarketTextComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TextComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TextComponentWhereInput>;
};


export type MarketTipsAndTricksDetailsPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TipsAndTricksDetailsPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TipsAndTricksDetailsPageWhereInput>;
};


export type MarketTitleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TitleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TitleWhereInput>;
};


export type MarketTwitterSeoArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TwitterSeoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TwitterSeoWhereInput>;
};


export type MarketUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type MarketConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MarketWhereUniqueInput;
};

/** A connection to a list of items. */
export type MarketConnection = {
  __typename?: 'MarketConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MarketEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MarketCreateInput = {
  accordion?: InputMaybe<AccordionCreateManyInlineInput>;
  accordionItem?: InputMaybe<AccordionItemCreateManyInlineInput>;
  algoliaExtension?: InputMaybe<AlgoliaExtensionCreateManyInlineInput>;
  anchorNav?: InputMaybe<AnchorNavCreateManyInlineInput>;
  anchorNavigationList?: InputMaybe<AnchorNavigationListCreateManyInlineInput>;
  anchorNavigations?: InputMaybe<AnchorNavigationCreateManyInlineInput>;
  assetComponent?: InputMaybe<AssetComponentCreateManyInlineInput>;
  audioComponents?: InputMaybe<AudioComponentCreateManyInlineInput>;
  authorableContentCard?: InputMaybe<AuthorableContentCardCreateManyInlineInput>;
  banner1?: InputMaybe<Banner1CreateManyInlineInput>;
  banner2?: InputMaybe<Banner2CreateManyInlineInput>;
  banner2CarouselComponents?: InputMaybe<Banner2CarouselComponentCreateManyInlineInput>;
  cardComponent?: InputMaybe<CardComponentCreateManyInlineInput>;
  carouselComponent?: InputMaybe<CarouselComponentCreateManyInlineInput>;
  carouselSlide?: InputMaybe<CarouselSlideCreateManyInlineInput>;
  categoryCard?: InputMaybe<CategoryCardCreateManyInlineInput>;
  clf9n6aof157201t8cwdy4u85?: InputMaybe<FooterSealCreateManyInlineInput>;
  contactCard?: InputMaybe<ContactCardCreateManyInlineInput>;
  contactCardContainer?: InputMaybe<ContactCardContainerCreateManyInlineInput>;
  countrySelectorFooter?: InputMaybe<CountrySelectorFooterCreateManyInlineInput>;
  countrySelectorItem?: InputMaybe<CountrySelectorItemCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionary?: InputMaybe<DictionaryCreateManyInlineInput>;
  dictionaryItem?: InputMaybe<DictionaryItemCreateManyInlineInput>;
  downloadApp?: InputMaybe<DownloadAppCreateManyInlineInput>;
  dynamicCardGrid?: InputMaybe<DynamicCardGridCreateManyInlineInput>;
  errorPage?: InputMaybe<ErrorPageCreateManyInlineInput>;
  evalancheFormComponent?: InputMaybe<EvalancheFormComponentCreateManyInlineInput>;
  exampleComponent?: InputMaybe<ExampleComponentCreateManyInlineInput>;
  featuredContent?: InputMaybe<FeaturedContentCreateManyInlineInput>;
  featuredContentReference?: InputMaybe<FeaturedContentReferenceCreateManyInlineInput>;
  footerNavigation?: InputMaybe<FooterNavigationCreateManyInlineInput>;
  form?: InputMaybe<FormCreateManyInlineInput>;
  formCheckbox?: InputMaybe<FormCheckboxCreateManyInlineInput>;
  formCheckboxCollection?: InputMaybe<FormCheckboxCollectionCreateManyInlineInput>;
  formDateInputs?: InputMaybe<FormDateInputCreateManyInlineInput>;
  formEmailInput?: InputMaybe<FormEmailInputCreateManyInlineInput>;
  formError?: InputMaybe<FormErrorCreateManyInlineInput>;
  formFileUploader?: InputMaybe<FormFileUploaderCreateManyInlineInput>;
  formListItem?: InputMaybe<FormListItemCreateManyInlineInput>;
  formLists?: InputMaybe<FormListCreateManyInlineInput>;
  formNumberInputs?: InputMaybe<FormNumberInputCreateManyInlineInput>;
  formPasswordInput?: InputMaybe<FormPasswordInputCreateManyInlineInput>;
  formPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationCreateManyInlineInput>;
  formRadioButton?: InputMaybe<FormRadioButtonCreateManyInlineInput>;
  formRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionCreateManyInlineInput>;
  formSelectComponent?: InputMaybe<FormSelectComponentCreateManyInlineInput>;
  formSelectOption?: InputMaybe<FormSelectOptionCreateManyInlineInput>;
  formSubmitButton?: InputMaybe<FormSubmitButtonCreateManyInlineInput>;
  formSuccessComponent?: InputMaybe<FormSuccessComponentCreateManyInlineInput>;
  formTextInput?: InputMaybe<FormTextInputCreateManyInlineInput>;
  formTextareaInput?: InputMaybe<FormTextareaInputCreateManyInlineInput>;
  genericAccordion?: InputMaybe<GenericAccordionCreateManyInlineInput>;
  genericAccordionItem?: InputMaybe<GenericAccordionItemCreateManyInlineInput>;
  genericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedCreateManyInlineInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateManyInlineInput>;
  genericDownloadComponent?: InputMaybe<GenericDownloadComponentCreateManyInlineInput>;
  genericFollowUs?: InputMaybe<GenericFollowUsCreateManyInlineInput>;
  genericGridAuthorable?: InputMaybe<GenericGridAuthorableCreateManyInlineInput>;
  genericHtmlComponents?: InputMaybe<GenericHtmlCreateManyInlineInput>;
  genericLine?: InputMaybe<GenericLineCreateManyInlineInput>;
  genericLink?: InputMaybe<GenericLinkCreateManyInlineInput>;
  genericPage?: InputMaybe<GenericPageCreateManyInlineInput>;
  genericPromotionsOverviews?: InputMaybe<GenericPromotionsOverviewCreateManyInlineInput>;
  genericQualifioOverviews?: InputMaybe<GenericQualifioOverviewCreateManyInlineInput>;
  genericQualifios?: InputMaybe<GenericQualifioCreateManyInlineInput>;
  genericSocialShare?: InputMaybe<GenericSocialShareCreateManyInlineInput>;
  globalMetaData?: InputMaybe<GlobalMetaDataCreateManyInlineInput>;
  globalSearches?: InputMaybe<GlobalSearchCreateManyInlineInput>;
  gridColumnComponent?: InputMaybe<GridColumnComponentCreateManyInlineInput>;
  gridColumns?: InputMaybe<GridColumnCreateManyInlineInput>;
  heroBanner?: InputMaybe<HeroBannerCreateManyInlineInput>;
  heroBannerMasterbrands?: InputMaybe<HeroBannerMasterbrandCreateManyInlineInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateManyInlineInput>;
  heroComponent?: InputMaybe<HeroComponentCreateManyInlineInput>;
  iframe?: InputMaybe<IframeCreateManyInlineInput>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardCreateManyInlineInput>;
  imageCopy?: InputMaybe<ImageCopyCreateManyInlineInput>;
  imageCopyItem?: InputMaybe<ImageCopyItemCreateManyInlineInput>;
  introText?: InputMaybe<IntroTextCreateManyInlineInput>;
  leftColumn?: InputMaybe<LeftColumnCreateManyInlineInput>;
  link?: InputMaybe<LinkCreateManyInlineInput>;
  longText?: InputMaybe<LongTextCreateManyInlineInput>;
  marketDescription?: InputMaybe<Scalars['String']['input']>;
  marketLocaleId?: InputMaybe<Markets>;
  marketName?: InputMaybe<Scalars['String']['input']>;
  marketUserConnection?: InputMaybe<MarketUserConnectionCreateOneInlineInput>;
  metaData?: InputMaybe<MetaDataCreateManyInlineInput>;
  mobileOnlyMainNavigation?: InputMaybe<MobileOnlyMainNavigationCreateManyInlineInput>;
  navigation?: InputMaybe<NavigationCreateManyInlineInput>;
  navigationItem?: InputMaybe<NavigationItemCreateManyInlineInput>;
  newsletterComponents?: InputMaybe<NewsletterComponentCreateManyInlineInput>;
  notificationBanner?: InputMaybe<NotificationBannerCreateManyInlineInput>;
  pageFooter?: InputMaybe<PageFooterCreateManyInlineInput>;
  pageHeader?: InputMaybe<PageHeaderCreateManyInlineInput>;
  popularSearchComponent?: InputMaybe<PopularSearchComponentCreateManyInlineInput>;
  product?: InputMaybe<ProductCreateManyInlineInput>;
  productBanner?: InputMaybe<ProductBannerCreateManyInlineInput>;
  productCategory?: InputMaybe<ProductCategoryCreateManyInlineInput>;
  productCategoryPage?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productDetailPage?: InputMaybe<ProductDetailPageCreateManyInlineInput>;
  productHero?: InputMaybe<ProductHeroCreateManyInlineInput>;
  productLandingPage?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPage?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  question?: InputMaybe<QuestionCreateManyInlineInput>;
  questionCheckbox?: InputMaybe<QuestionCheckboxCreateManyInlineInput>;
  questionCheckboxCollection?: InputMaybe<QuestionCheckboxCollectionCreateManyInlineInput>;
  questionRadioButton?: InputMaybe<QuestionRadioButtonCreateManyInlineInput>;
  questionRadioButtonCollection?: InputMaybe<QuestionRadioButtonCollectionCreateManyInlineInput>;
  rating?: InputMaybe<RatingCreateManyInlineInput>;
  recipe?: InputMaybe<RecipeCreateManyInlineInput>;
  recipeCategory?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPage?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategory?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  recipesComparisonQueryComponent?: InputMaybe<RecipesComparisonQueryComponentCreateManyInlineInput>;
  recipesQueriesReference?: InputMaybe<RecipesQueriesReferenceCreateManyInlineInput>;
  recipesQueryComponent?: InputMaybe<RecipesQueryComponentCreateManyInlineInput>;
  redirect?: InputMaybe<RedirectCreateManyInlineInput>;
  rewrite?: InputMaybe<RewriteCreateManyInlineInput>;
  rightColumn?: InputMaybe<RightColumnCreateManyInlineInput>;
  searchInput?: InputMaybe<SearchInputCreateManyInlineInput>;
  searchOverlayComponent?: InputMaybe<SearchOverlayComponentCreateManyInlineInput>;
  searchResultPage?: InputMaybe<SearchResultPageCreateManyInlineInput>;
  separators?: InputMaybe<SeparatorCreateManyInlineInput>;
  socialMediaListComponent?: InputMaybe<SocialMediaListComponentCreateManyInlineInput>;
  spacer?: InputMaybe<SpacerCreateManyInlineInput>;
  subCategoryKeyImage?: InputMaybe<SubCategoryKeyImageCreateManyInlineInput>;
  subTab?: InputMaybe<SubTabCreateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateManyInlineInput>;
  sustainabilityBanner?: InputMaybe<SustainabilityBannerCreateManyInlineInput>;
  sustainabilityInfo?: InputMaybe<SustainabilityInfoCreateManyInlineInput>;
  tab?: InputMaybe<TabCreateManyInlineInput>;
  tabContent?: InputMaybe<TabContentCreateManyInlineInput>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderCreateManyInlineInput>;
  teaserSmallComponents?: InputMaybe<TeaserSmallCreateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderCreateManyInlineInput>;
  teasers?: InputMaybe<TeaserCreateManyInlineInput>;
  testComponentWithRecipeQuery?: InputMaybe<TestComponentWithRecipeQueryCreateManyInlineInput>;
  testTipsANdTricksInAMarket?: InputMaybe<TestTipsANdTricksInAMarketCreateManyInlineInput>;
  textComponent?: InputMaybe<TextComponentCreateManyInlineInput>;
  tipsAndTricksDetailsPage?: InputMaybe<TipsAndTricksDetailsPageCreateManyInlineInput>;
  title?: InputMaybe<TitleCreateManyInlineInput>;
  twitterSeo?: InputMaybe<TwitterSeoCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MarketCreateManyInlineInput = {
  /** Connect multiple existing Market documents */
  connect?: InputMaybe<Array<MarketWhereUniqueInput>>;
  /** Create and connect multiple existing Market documents */
  create?: InputMaybe<Array<MarketCreateInput>>;
};

export type MarketCreateOneInlineInput = {
  /** Connect one existing Market document */
  connect?: InputMaybe<MarketWhereUniqueInput>;
  /** Create and connect one Market document */
  create?: InputMaybe<MarketCreateInput>;
};

/** An edge in a connection. */
export type MarketEdge = {
  __typename?: 'MarketEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Market;
};

/** Identifies documents */
export type MarketManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MarketWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MarketWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MarketWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordionItem_every?: InputMaybe<AccordionItemWhereInput>;
  accordionItem_none?: InputMaybe<AccordionItemWhereInput>;
  accordionItem_some?: InputMaybe<AccordionItemWhereInput>;
  accordion_every?: InputMaybe<AccordionWhereInput>;
  accordion_none?: InputMaybe<AccordionWhereInput>;
  accordion_some?: InputMaybe<AccordionWhereInput>;
  algoliaExtension_every?: InputMaybe<AlgoliaExtensionWhereInput>;
  algoliaExtension_none?: InputMaybe<AlgoliaExtensionWhereInput>;
  algoliaExtension_some?: InputMaybe<AlgoliaExtensionWhereInput>;
  anchorNav_every?: InputMaybe<AnchorNavWhereInput>;
  anchorNav_none?: InputMaybe<AnchorNavWhereInput>;
  anchorNav_some?: InputMaybe<AnchorNavWhereInput>;
  anchorNavigationList_every?: InputMaybe<AnchorNavigationListWhereInput>;
  anchorNavigationList_none?: InputMaybe<AnchorNavigationListWhereInput>;
  anchorNavigationList_some?: InputMaybe<AnchorNavigationListWhereInput>;
  anchorNavigations_every?: InputMaybe<AnchorNavigationWhereInput>;
  anchorNavigations_none?: InputMaybe<AnchorNavigationWhereInput>;
  anchorNavigations_some?: InputMaybe<AnchorNavigationWhereInput>;
  assetComponent_every?: InputMaybe<AssetComponentWhereInput>;
  assetComponent_none?: InputMaybe<AssetComponentWhereInput>;
  assetComponent_some?: InputMaybe<AssetComponentWhereInput>;
  audioComponents_every?: InputMaybe<AudioComponentWhereInput>;
  audioComponents_none?: InputMaybe<AudioComponentWhereInput>;
  audioComponents_some?: InputMaybe<AudioComponentWhereInput>;
  authorableContentCard_every?: InputMaybe<AuthorableContentCardWhereInput>;
  authorableContentCard_none?: InputMaybe<AuthorableContentCardWhereInput>;
  authorableContentCard_some?: InputMaybe<AuthorableContentCardWhereInput>;
  banner1_every?: InputMaybe<Banner1WhereInput>;
  banner1_none?: InputMaybe<Banner1WhereInput>;
  banner1_some?: InputMaybe<Banner1WhereInput>;
  banner2CarouselComponents_every?: InputMaybe<Banner2CarouselComponentWhereInput>;
  banner2CarouselComponents_none?: InputMaybe<Banner2CarouselComponentWhereInput>;
  banner2CarouselComponents_some?: InputMaybe<Banner2CarouselComponentWhereInput>;
  banner2_every?: InputMaybe<Banner2WhereInput>;
  banner2_none?: InputMaybe<Banner2WhereInput>;
  banner2_some?: InputMaybe<Banner2WhereInput>;
  cardComponent_every?: InputMaybe<CardComponentWhereInput>;
  cardComponent_none?: InputMaybe<CardComponentWhereInput>;
  cardComponent_some?: InputMaybe<CardComponentWhereInput>;
  carouselComponent_every?: InputMaybe<CarouselComponentWhereInput>;
  carouselComponent_none?: InputMaybe<CarouselComponentWhereInput>;
  carouselComponent_some?: InputMaybe<CarouselComponentWhereInput>;
  carouselSlide_every?: InputMaybe<CarouselSlideWhereInput>;
  carouselSlide_none?: InputMaybe<CarouselSlideWhereInput>;
  carouselSlide_some?: InputMaybe<CarouselSlideWhereInput>;
  categoryCard_every?: InputMaybe<CategoryCardWhereInput>;
  categoryCard_none?: InputMaybe<CategoryCardWhereInput>;
  categoryCard_some?: InputMaybe<CategoryCardWhereInput>;
  contactCardContainer_every?: InputMaybe<ContactCardContainerWhereInput>;
  contactCardContainer_none?: InputMaybe<ContactCardContainerWhereInput>;
  contactCardContainer_some?: InputMaybe<ContactCardContainerWhereInput>;
  contactCard_every?: InputMaybe<ContactCardWhereInput>;
  contactCard_none?: InputMaybe<ContactCardWhereInput>;
  contactCard_some?: InputMaybe<ContactCardWhereInput>;
  countrySelectorFooter_every?: InputMaybe<CountrySelectorFooterWhereInput>;
  countrySelectorFooter_none?: InputMaybe<CountrySelectorFooterWhereInput>;
  countrySelectorFooter_some?: InputMaybe<CountrySelectorFooterWhereInput>;
  countrySelectorItem_every?: InputMaybe<CountrySelectorItemWhereInput>;
  countrySelectorItem_none?: InputMaybe<CountrySelectorItemWhereInput>;
  countrySelectorItem_some?: InputMaybe<CountrySelectorItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaryItem_every?: InputMaybe<DictionaryItemWhereInput>;
  dictionaryItem_none?: InputMaybe<DictionaryItemWhereInput>;
  dictionaryItem_some?: InputMaybe<DictionaryItemWhereInput>;
  dictionary_every?: InputMaybe<DictionaryWhereInput>;
  dictionary_none?: InputMaybe<DictionaryWhereInput>;
  dictionary_some?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<MarketWhereStageInput>;
  documentInStages_none?: InputMaybe<MarketWhereStageInput>;
  documentInStages_some?: InputMaybe<MarketWhereStageInput>;
  downloadApp_every?: InputMaybe<DownloadAppWhereInput>;
  downloadApp_none?: InputMaybe<DownloadAppWhereInput>;
  downloadApp_some?: InputMaybe<DownloadAppWhereInput>;
  dynamicCardGrid_every?: InputMaybe<DynamicCardGridWhereInput>;
  dynamicCardGrid_none?: InputMaybe<DynamicCardGridWhereInput>;
  dynamicCardGrid_some?: InputMaybe<DynamicCardGridWhereInput>;
  errorPage_every?: InputMaybe<ErrorPageWhereInput>;
  errorPage_none?: InputMaybe<ErrorPageWhereInput>;
  errorPage_some?: InputMaybe<ErrorPageWhereInput>;
  evalancheFormComponent_every?: InputMaybe<EvalancheFormComponentWhereInput>;
  evalancheFormComponent_none?: InputMaybe<EvalancheFormComponentWhereInput>;
  evalancheFormComponent_some?: InputMaybe<EvalancheFormComponentWhereInput>;
  exampleComponent_every?: InputMaybe<ExampleComponentWhereInput>;
  exampleComponent_none?: InputMaybe<ExampleComponentWhereInput>;
  exampleComponent_some?: InputMaybe<ExampleComponentWhereInput>;
  featuredContentReference_every?: InputMaybe<FeaturedContentReferenceWhereInput>;
  featuredContentReference_none?: InputMaybe<FeaturedContentReferenceWhereInput>;
  featuredContentReference_some?: InputMaybe<FeaturedContentReferenceWhereInput>;
  featuredContent_every?: InputMaybe<FeaturedContentWhereInput>;
  featuredContent_none?: InputMaybe<FeaturedContentWhereInput>;
  featuredContent_some?: InputMaybe<FeaturedContentWhereInput>;
  footerNavigation_every?: InputMaybe<FooterNavigationWhereInput>;
  footerNavigation_none?: InputMaybe<FooterNavigationWhereInput>;
  footerNavigation_some?: InputMaybe<FooterNavigationWhereInput>;
  formCheckboxCollection_every?: InputMaybe<FormCheckboxCollectionWhereInput>;
  formCheckboxCollection_none?: InputMaybe<FormCheckboxCollectionWhereInput>;
  formCheckboxCollection_some?: InputMaybe<FormCheckboxCollectionWhereInput>;
  formCheckbox_every?: InputMaybe<FormCheckboxWhereInput>;
  formCheckbox_none?: InputMaybe<FormCheckboxWhereInput>;
  formCheckbox_some?: InputMaybe<FormCheckboxWhereInput>;
  formDateInputs_every?: InputMaybe<FormDateInputWhereInput>;
  formDateInputs_none?: InputMaybe<FormDateInputWhereInput>;
  formDateInputs_some?: InputMaybe<FormDateInputWhereInput>;
  formEmailInput_every?: InputMaybe<FormEmailInputWhereInput>;
  formEmailInput_none?: InputMaybe<FormEmailInputWhereInput>;
  formEmailInput_some?: InputMaybe<FormEmailInputWhereInput>;
  formError_every?: InputMaybe<FormErrorWhereInput>;
  formError_none?: InputMaybe<FormErrorWhereInput>;
  formError_some?: InputMaybe<FormErrorWhereInput>;
  formFileUploader_every?: InputMaybe<FormFileUploaderWhereInput>;
  formFileUploader_none?: InputMaybe<FormFileUploaderWhereInput>;
  formFileUploader_some?: InputMaybe<FormFileUploaderWhereInput>;
  formListItem_every?: InputMaybe<FormListItemWhereInput>;
  formListItem_none?: InputMaybe<FormListItemWhereInput>;
  formListItem_some?: InputMaybe<FormListItemWhereInput>;
  formLists_every?: InputMaybe<FormListWhereInput>;
  formLists_none?: InputMaybe<FormListWhereInput>;
  formLists_some?: InputMaybe<FormListWhereInput>;
  formNumberInputs_every?: InputMaybe<FormNumberInputWhereInput>;
  formNumberInputs_none?: InputMaybe<FormNumberInputWhereInput>;
  formNumberInputs_some?: InputMaybe<FormNumberInputWhereInput>;
  formPasswordInputWithConfirmation_every?: InputMaybe<FormPasswordInputWithConfirmationWhereInput>;
  formPasswordInputWithConfirmation_none?: InputMaybe<FormPasswordInputWithConfirmationWhereInput>;
  formPasswordInputWithConfirmation_some?: InputMaybe<FormPasswordInputWithConfirmationWhereInput>;
  formPasswordInput_every?: InputMaybe<FormPasswordInputWhereInput>;
  formPasswordInput_none?: InputMaybe<FormPasswordInputWhereInput>;
  formPasswordInput_some?: InputMaybe<FormPasswordInputWhereInput>;
  formRadioButtonCollection_every?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  formRadioButtonCollection_none?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  formRadioButtonCollection_some?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  formRadioButton_every?: InputMaybe<FormRadioButtonWhereInput>;
  formRadioButton_none?: InputMaybe<FormRadioButtonWhereInput>;
  formRadioButton_some?: InputMaybe<FormRadioButtonWhereInput>;
  formSelectComponent_every?: InputMaybe<FormSelectComponentWhereInput>;
  formSelectComponent_none?: InputMaybe<FormSelectComponentWhereInput>;
  formSelectComponent_some?: InputMaybe<FormSelectComponentWhereInput>;
  formSelectOption_every?: InputMaybe<FormSelectOptionWhereInput>;
  formSelectOption_none?: InputMaybe<FormSelectOptionWhereInput>;
  formSelectOption_some?: InputMaybe<FormSelectOptionWhereInput>;
  formSubmitButton_every?: InputMaybe<FormSubmitButtonWhereInput>;
  formSubmitButton_none?: InputMaybe<FormSubmitButtonWhereInput>;
  formSubmitButton_some?: InputMaybe<FormSubmitButtonWhereInput>;
  formSuccessComponent_every?: InputMaybe<FormSuccessComponentWhereInput>;
  formSuccessComponent_none?: InputMaybe<FormSuccessComponentWhereInput>;
  formSuccessComponent_some?: InputMaybe<FormSuccessComponentWhereInput>;
  formTextInput_every?: InputMaybe<FormTextInputWhereInput>;
  formTextInput_none?: InputMaybe<FormTextInputWhereInput>;
  formTextInput_some?: InputMaybe<FormTextInputWhereInput>;
  formTextareaInput_every?: InputMaybe<FormTextareaInputWhereInput>;
  formTextareaInput_none?: InputMaybe<FormTextareaInputWhereInput>;
  formTextareaInput_some?: InputMaybe<FormTextareaInputWhereInput>;
  form_every?: InputMaybe<FormWhereInput>;
  form_none?: InputMaybe<FormWhereInput>;
  form_some?: InputMaybe<FormWhereInput>;
  genericAccordionItem_every?: InputMaybe<GenericAccordionItemWhereInput>;
  genericAccordionItem_none?: InputMaybe<GenericAccordionItemWhereInput>;
  genericAccordionItem_some?: InputMaybe<GenericAccordionItemWhereInput>;
  genericAccordionTopRated_every?: InputMaybe<GenericAccordionTopRatedWhereInput>;
  genericAccordionTopRated_none?: InputMaybe<GenericAccordionTopRatedWhereInput>;
  genericAccordionTopRated_some?: InputMaybe<GenericAccordionTopRatedWhereInput>;
  genericAccordion_every?: InputMaybe<GenericAccordionWhereInput>;
  genericAccordion_none?: InputMaybe<GenericAccordionWhereInput>;
  genericAccordion_some?: InputMaybe<GenericAccordionWhereInput>;
  genericCardCarouseComponent_every?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericCardCarouseComponent_none?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericCardCarouseComponent_some?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericDownloadComponent_every?: InputMaybe<GenericDownloadComponentWhereInput>;
  genericDownloadComponent_none?: InputMaybe<GenericDownloadComponentWhereInput>;
  genericDownloadComponent_some?: InputMaybe<GenericDownloadComponentWhereInput>;
  genericFollowUs_every?: InputMaybe<GenericFollowUsWhereInput>;
  genericFollowUs_none?: InputMaybe<GenericFollowUsWhereInput>;
  genericFollowUs_some?: InputMaybe<GenericFollowUsWhereInput>;
  genericGridAuthorable_every?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorable_none?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorable_some?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericHtmlComponents_every?: InputMaybe<GenericHtmlWhereInput>;
  genericHtmlComponents_none?: InputMaybe<GenericHtmlWhereInput>;
  genericHtmlComponents_some?: InputMaybe<GenericHtmlWhereInput>;
  genericLine_every?: InputMaybe<GenericLineWhereInput>;
  genericLine_none?: InputMaybe<GenericLineWhereInput>;
  genericLine_some?: InputMaybe<GenericLineWhereInput>;
  genericLink_every?: InputMaybe<GenericLinkWhereInput>;
  genericLink_none?: InputMaybe<GenericLinkWhereInput>;
  genericLink_some?: InputMaybe<GenericLinkWhereInput>;
  genericPage_every?: InputMaybe<GenericPageWhereInput>;
  genericPage_none?: InputMaybe<GenericPageWhereInput>;
  genericPage_some?: InputMaybe<GenericPageWhereInput>;
  genericPromotionsOverviews_every?: InputMaybe<GenericPromotionsOverviewWhereInput>;
  genericPromotionsOverviews_none?: InputMaybe<GenericPromotionsOverviewWhereInput>;
  genericPromotionsOverviews_some?: InputMaybe<GenericPromotionsOverviewWhereInput>;
  genericQualifioOverviews_every?: InputMaybe<GenericQualifioOverviewWhereInput>;
  genericQualifioOverviews_none?: InputMaybe<GenericQualifioOverviewWhereInput>;
  genericQualifioOverviews_some?: InputMaybe<GenericQualifioOverviewWhereInput>;
  genericQualifios_every?: InputMaybe<GenericQualifioWhereInput>;
  genericQualifios_none?: InputMaybe<GenericQualifioWhereInput>;
  genericQualifios_some?: InputMaybe<GenericQualifioWhereInput>;
  genericSocialShare_every?: InputMaybe<GenericSocialShareWhereInput>;
  genericSocialShare_none?: InputMaybe<GenericSocialShareWhereInput>;
  genericSocialShare_some?: InputMaybe<GenericSocialShareWhereInput>;
  globalMetaData_every?: InputMaybe<GlobalMetaDataWhereInput>;
  globalMetaData_none?: InputMaybe<GlobalMetaDataWhereInput>;
  globalMetaData_some?: InputMaybe<GlobalMetaDataWhereInput>;
  globalSearches_every?: InputMaybe<GlobalSearchWhereInput>;
  globalSearches_none?: InputMaybe<GlobalSearchWhereInput>;
  globalSearches_some?: InputMaybe<GlobalSearchWhereInput>;
  gridColumnComponent_every?: InputMaybe<GridColumnComponentWhereInput>;
  gridColumnComponent_none?: InputMaybe<GridColumnComponentWhereInput>;
  gridColumnComponent_some?: InputMaybe<GridColumnComponentWhereInput>;
  gridColumns_every?: InputMaybe<GridColumnWhereInput>;
  gridColumns_none?: InputMaybe<GridColumnWhereInput>;
  gridColumns_some?: InputMaybe<GridColumnWhereInput>;
  heroBannerMasterbrands_every?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  heroBannerMasterbrands_none?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  heroBannerMasterbrands_some?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  heroBanner_every?: InputMaybe<HeroBannerWhereInput>;
  heroBanner_none?: InputMaybe<HeroBannerWhereInput>;
  heroBanner_some?: InputMaybe<HeroBannerWhereInput>;
  heroCarouselComponent_every?: InputMaybe<HeroCarouselComponentWhereInput>;
  heroCarouselComponent_none?: InputMaybe<HeroCarouselComponentWhereInput>;
  heroCarouselComponent_some?: InputMaybe<HeroCarouselComponentWhereInput>;
  heroComponent_every?: InputMaybe<HeroComponentWhereInput>;
  heroComponent_none?: InputMaybe<HeroComponentWhereInput>;
  heroComponent_some?: InputMaybe<HeroComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  iframe_every?: InputMaybe<IframeWhereInput>;
  iframe_none?: InputMaybe<IframeWhereInput>;
  iframe_some?: InputMaybe<IframeWhereInput>;
  imageAndTextCard_every?: InputMaybe<ImageAndTextCardWhereInput>;
  imageAndTextCard_none?: InputMaybe<ImageAndTextCardWhereInput>;
  imageAndTextCard_some?: InputMaybe<ImageAndTextCardWhereInput>;
  imageCopyItem_every?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopyItem_none?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopyItem_some?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopy_every?: InputMaybe<ImageCopyWhereInput>;
  imageCopy_none?: InputMaybe<ImageCopyWhereInput>;
  imageCopy_some?: InputMaybe<ImageCopyWhereInput>;
  introText_every?: InputMaybe<IntroTextWhereInput>;
  introText_none?: InputMaybe<IntroTextWhereInput>;
  introText_some?: InputMaybe<IntroTextWhereInput>;
  leftColumn_every?: InputMaybe<LeftColumnWhereInput>;
  leftColumn_none?: InputMaybe<LeftColumnWhereInput>;
  leftColumn_some?: InputMaybe<LeftColumnWhereInput>;
  link_every?: InputMaybe<LinkWhereInput>;
  link_none?: InputMaybe<LinkWhereInput>;
  link_some?: InputMaybe<LinkWhereInput>;
  longText_every?: InputMaybe<LongTextWhereInput>;
  longText_none?: InputMaybe<LongTextWhereInput>;
  longText_some?: InputMaybe<LongTextWhereInput>;
  marketDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  marketDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  marketDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  marketDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  marketDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  marketDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  marketDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  marketDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  marketDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  marketDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  marketLocaleId?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  marketLocaleId_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  marketLocaleId_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  marketLocaleId_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  marketName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  marketName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  marketName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  marketName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  marketName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  marketName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  marketName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  marketName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  marketName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  marketName_starts_with?: InputMaybe<Scalars['String']['input']>;
  marketUserConnection?: InputMaybe<MarketUserConnectionWhereInput>;
  metaData_every?: InputMaybe<MetaDataWhereInput>;
  metaData_none?: InputMaybe<MetaDataWhereInput>;
  metaData_some?: InputMaybe<MetaDataWhereInput>;
  mobileOnlyMainNavigation_every?: InputMaybe<MobileOnlyMainNavigationWhereInput>;
  mobileOnlyMainNavigation_none?: InputMaybe<MobileOnlyMainNavigationWhereInput>;
  mobileOnlyMainNavigation_some?: InputMaybe<MobileOnlyMainNavigationWhereInput>;
  navigationItem_every?: InputMaybe<NavigationItemWhereInput>;
  navigationItem_none?: InputMaybe<NavigationItemWhereInput>;
  navigationItem_some?: InputMaybe<NavigationItemWhereInput>;
  navigation_every?: InputMaybe<NavigationWhereInput>;
  navigation_none?: InputMaybe<NavigationWhereInput>;
  navigation_some?: InputMaybe<NavigationWhereInput>;
  newsletterComponents_every?: InputMaybe<NewsletterComponentWhereInput>;
  newsletterComponents_none?: InputMaybe<NewsletterComponentWhereInput>;
  newsletterComponents_some?: InputMaybe<NewsletterComponentWhereInput>;
  notificationBanner_every?: InputMaybe<NotificationBannerWhereInput>;
  notificationBanner_none?: InputMaybe<NotificationBannerWhereInput>;
  notificationBanner_some?: InputMaybe<NotificationBannerWhereInput>;
  pageFooter_every?: InputMaybe<PageFooterWhereInput>;
  pageFooter_none?: InputMaybe<PageFooterWhereInput>;
  pageFooter_some?: InputMaybe<PageFooterWhereInput>;
  pageHeader_every?: InputMaybe<PageHeaderWhereInput>;
  pageHeader_none?: InputMaybe<PageHeaderWhereInput>;
  pageHeader_some?: InputMaybe<PageHeaderWhereInput>;
  popularSearchComponent_every?: InputMaybe<PopularSearchComponentWhereInput>;
  popularSearchComponent_none?: InputMaybe<PopularSearchComponentWhereInput>;
  popularSearchComponent_some?: InputMaybe<PopularSearchComponentWhereInput>;
  productBanner_every?: InputMaybe<ProductBannerWhereInput>;
  productBanner_none?: InputMaybe<ProductBannerWhereInput>;
  productBanner_some?: InputMaybe<ProductBannerWhereInput>;
  productCategoryPage_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPage_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPage_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategory_every?: InputMaybe<ProductCategoryWhereInput>;
  productCategory_none?: InputMaybe<ProductCategoryWhereInput>;
  productCategory_some?: InputMaybe<ProductCategoryWhereInput>;
  productDetailPage_every?: InputMaybe<ProductDetailPageWhereInput>;
  productDetailPage_none?: InputMaybe<ProductDetailPageWhereInput>;
  productDetailPage_some?: InputMaybe<ProductDetailPageWhereInput>;
  productHero_every?: InputMaybe<ProductHeroWhereInput>;
  productHero_none?: InputMaybe<ProductHeroWhereInput>;
  productHero_some?: InputMaybe<ProductHeroWhereInput>;
  productLandingPage_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPage_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPage_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPage_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPage_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPage_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  product_every?: InputMaybe<ProductWhereInput>;
  product_none?: InputMaybe<ProductWhereInput>;
  product_some?: InputMaybe<ProductWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  questionCheckboxCollection_every?: InputMaybe<QuestionCheckboxCollectionWhereInput>;
  questionCheckboxCollection_none?: InputMaybe<QuestionCheckboxCollectionWhereInput>;
  questionCheckboxCollection_some?: InputMaybe<QuestionCheckboxCollectionWhereInput>;
  questionCheckbox_every?: InputMaybe<QuestionCheckboxWhereInput>;
  questionCheckbox_none?: InputMaybe<QuestionCheckboxWhereInput>;
  questionCheckbox_some?: InputMaybe<QuestionCheckboxWhereInput>;
  questionRadioButtonCollection_every?: InputMaybe<QuestionRadioButtonCollectionWhereInput>;
  questionRadioButtonCollection_none?: InputMaybe<QuestionRadioButtonCollectionWhereInput>;
  questionRadioButtonCollection_some?: InputMaybe<QuestionRadioButtonCollectionWhereInput>;
  questionRadioButton_every?: InputMaybe<QuestionRadioButtonWhereInput>;
  questionRadioButton_none?: InputMaybe<QuestionRadioButtonWhereInput>;
  questionRadioButton_some?: InputMaybe<QuestionRadioButtonWhereInput>;
  question_every?: InputMaybe<QuestionWhereInput>;
  question_none?: InputMaybe<QuestionWhereInput>;
  question_some?: InputMaybe<QuestionWhereInput>;
  rating_every?: InputMaybe<RatingWhereInput>;
  rating_none?: InputMaybe<RatingWhereInput>;
  rating_some?: InputMaybe<RatingWhereInput>;
  recipeCategory_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategory_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategory_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPage_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPage_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPage_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategory_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategory_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategory_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipe_every?: InputMaybe<RecipeWhereInput>;
  recipe_none?: InputMaybe<RecipeWhereInput>;
  recipe_some?: InputMaybe<RecipeWhereInput>;
  recipesComparisonQueryComponent_every?: InputMaybe<RecipesComparisonQueryComponentWhereInput>;
  recipesComparisonQueryComponent_none?: InputMaybe<RecipesComparisonQueryComponentWhereInput>;
  recipesComparisonQueryComponent_some?: InputMaybe<RecipesComparisonQueryComponentWhereInput>;
  recipesQueriesReference_every?: InputMaybe<RecipesQueriesReferenceWhereInput>;
  recipesQueriesReference_none?: InputMaybe<RecipesQueriesReferenceWhereInput>;
  recipesQueriesReference_some?: InputMaybe<RecipesQueriesReferenceWhereInput>;
  recipesQueryComponent_every?: InputMaybe<RecipesQueryComponentWhereInput>;
  recipesQueryComponent_none?: InputMaybe<RecipesQueryComponentWhereInput>;
  recipesQueryComponent_some?: InputMaybe<RecipesQueryComponentWhereInput>;
  redirect_every?: InputMaybe<RedirectWhereInput>;
  redirect_none?: InputMaybe<RedirectWhereInput>;
  redirect_some?: InputMaybe<RedirectWhereInput>;
  rewrite_every?: InputMaybe<RewriteWhereInput>;
  rewrite_none?: InputMaybe<RewriteWhereInput>;
  rewrite_some?: InputMaybe<RewriteWhereInput>;
  rightColumn_every?: InputMaybe<RightColumnWhereInput>;
  rightColumn_none?: InputMaybe<RightColumnWhereInput>;
  rightColumn_some?: InputMaybe<RightColumnWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  searchInput_every?: InputMaybe<SearchInputWhereInput>;
  searchInput_none?: InputMaybe<SearchInputWhereInput>;
  searchInput_some?: InputMaybe<SearchInputWhereInput>;
  searchOverlayComponent_every?: InputMaybe<SearchOverlayComponentWhereInput>;
  searchOverlayComponent_none?: InputMaybe<SearchOverlayComponentWhereInput>;
  searchOverlayComponent_some?: InputMaybe<SearchOverlayComponentWhereInput>;
  searchResultPage_every?: InputMaybe<SearchResultPageWhereInput>;
  searchResultPage_none?: InputMaybe<SearchResultPageWhereInput>;
  searchResultPage_some?: InputMaybe<SearchResultPageWhereInput>;
  separators_every?: InputMaybe<SeparatorWhereInput>;
  separators_none?: InputMaybe<SeparatorWhereInput>;
  separators_some?: InputMaybe<SeparatorWhereInput>;
  socialMediaListComponent_every?: InputMaybe<SocialMediaListComponentWhereInput>;
  socialMediaListComponent_none?: InputMaybe<SocialMediaListComponentWhereInput>;
  socialMediaListComponent_some?: InputMaybe<SocialMediaListComponentWhereInput>;
  spacer_every?: InputMaybe<SpacerWhereInput>;
  spacer_none?: InputMaybe<SpacerWhereInput>;
  spacer_some?: InputMaybe<SpacerWhereInput>;
  subCategoryKeyImage_every?: InputMaybe<SubCategoryKeyImageWhereInput>;
  subCategoryKeyImage_none?: InputMaybe<SubCategoryKeyImageWhereInput>;
  subCategoryKeyImage_some?: InputMaybe<SubCategoryKeyImageWhereInput>;
  subTabContent_every?: InputMaybe<SubTabContentWhereInput>;
  subTabContent_none?: InputMaybe<SubTabContentWhereInput>;
  subTabContent_some?: InputMaybe<SubTabContentWhereInput>;
  subTab_every?: InputMaybe<SubTabWhereInput>;
  subTab_none?: InputMaybe<SubTabWhereInput>;
  subTab_some?: InputMaybe<SubTabWhereInput>;
  sustainabilityBanner_every?: InputMaybe<SustainabilityBannerWhereInput>;
  sustainabilityBanner_none?: InputMaybe<SustainabilityBannerWhereInput>;
  sustainabilityBanner_some?: InputMaybe<SustainabilityBannerWhereInput>;
  sustainabilityInfo_every?: InputMaybe<SustainabilityInfoWhereInput>;
  sustainabilityInfo_none?: InputMaybe<SustainabilityInfoWhereInput>;
  sustainabilityInfo_some?: InputMaybe<SustainabilityInfoWhereInput>;
  tabContent_every?: InputMaybe<TabContentWhereInput>;
  tabContent_none?: InputMaybe<TabContentWhereInput>;
  tabContent_some?: InputMaybe<TabContentWhereInput>;
  tab_every?: InputMaybe<TabWhereInput>;
  tab_none?: InputMaybe<TabWhereInput>;
  tab_some?: InputMaybe<TabWhereInput>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallComponents_every?: InputMaybe<TeaserSmallWhereInput>;
  teaserSmallComponents_none?: InputMaybe<TeaserSmallWhereInput>;
  teaserSmallComponents_some?: InputMaybe<TeaserSmallWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teasers_every?: InputMaybe<TeaserWhereInput>;
  teasers_none?: InputMaybe<TeaserWhereInput>;
  teasers_some?: InputMaybe<TeaserWhereInput>;
  testComponentWithRecipeQuery_every?: InputMaybe<TestComponentWithRecipeQueryWhereInput>;
  testComponentWithRecipeQuery_none?: InputMaybe<TestComponentWithRecipeQueryWhereInput>;
  testComponentWithRecipeQuery_some?: InputMaybe<TestComponentWithRecipeQueryWhereInput>;
  testTipsANdTricksInAMarket_every?: InputMaybe<TestTipsANdTricksInAMarketWhereInput>;
  testTipsANdTricksInAMarket_none?: InputMaybe<TestTipsANdTricksInAMarketWhereInput>;
  testTipsANdTricksInAMarket_some?: InputMaybe<TestTipsANdTricksInAMarketWhereInput>;
  textComponent_every?: InputMaybe<TextComponentWhereInput>;
  textComponent_none?: InputMaybe<TextComponentWhereInput>;
  textComponent_some?: InputMaybe<TextComponentWhereInput>;
  tipsAndTricksDetailsPage_every?: InputMaybe<TipsAndTricksDetailsPageWhereInput>;
  tipsAndTricksDetailsPage_none?: InputMaybe<TipsAndTricksDetailsPageWhereInput>;
  tipsAndTricksDetailsPage_some?: InputMaybe<TipsAndTricksDetailsPageWhereInput>;
  title_every?: InputMaybe<TitleWhereInput>;
  title_none?: InputMaybe<TitleWhereInput>;
  title_some?: InputMaybe<TitleWhereInput>;
  twitterSeo_every?: InputMaybe<TwitterSeoWhereInput>;
  twitterSeo_none?: InputMaybe<TwitterSeoWhereInput>;
  twitterSeo_some?: InputMaybe<TwitterSeoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum MarketOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  marketDescription_ASC = 'marketDescription_ASC',
  marketDescription_DESC = 'marketDescription_DESC',
  marketLocaleId_ASC = 'marketLocaleId_ASC',
  marketLocaleId_DESC = 'marketLocaleId_DESC',
  marketName_ASC = 'marketName_ASC',
  marketName_DESC = 'marketName_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type MarketUpdateInput = {
  accordion?: InputMaybe<AccordionUpdateManyInlineInput>;
  accordionItem?: InputMaybe<AccordionItemUpdateManyInlineInput>;
  algoliaExtension?: InputMaybe<AlgoliaExtensionUpdateManyInlineInput>;
  anchorNav?: InputMaybe<AnchorNavUpdateManyInlineInput>;
  anchorNavigationList?: InputMaybe<AnchorNavigationListUpdateManyInlineInput>;
  anchorNavigations?: InputMaybe<AnchorNavigationUpdateManyInlineInput>;
  assetComponent?: InputMaybe<AssetComponentUpdateManyInlineInput>;
  audioComponents?: InputMaybe<AudioComponentUpdateManyInlineInput>;
  authorableContentCard?: InputMaybe<AuthorableContentCardUpdateManyInlineInput>;
  banner1?: InputMaybe<Banner1UpdateManyInlineInput>;
  banner2?: InputMaybe<Banner2UpdateManyInlineInput>;
  banner2CarouselComponents?: InputMaybe<Banner2CarouselComponentUpdateManyInlineInput>;
  cardComponent?: InputMaybe<CardComponentUpdateManyInlineInput>;
  carouselComponent?: InputMaybe<CarouselComponentUpdateManyInlineInput>;
  carouselSlide?: InputMaybe<CarouselSlideUpdateManyInlineInput>;
  categoryCard?: InputMaybe<CategoryCardUpdateManyInlineInput>;
  clf9n6aof157201t8cwdy4u85?: InputMaybe<FooterSealUpdateManyInlineInput>;
  contactCard?: InputMaybe<ContactCardUpdateManyInlineInput>;
  contactCardContainer?: InputMaybe<ContactCardContainerUpdateManyInlineInput>;
  countrySelectorFooter?: InputMaybe<CountrySelectorFooterUpdateManyInlineInput>;
  countrySelectorItem?: InputMaybe<CountrySelectorItemUpdateManyInlineInput>;
  dictionary?: InputMaybe<DictionaryUpdateManyInlineInput>;
  dictionaryItem?: InputMaybe<DictionaryItemUpdateManyInlineInput>;
  downloadApp?: InputMaybe<DownloadAppUpdateManyInlineInput>;
  dynamicCardGrid?: InputMaybe<DynamicCardGridUpdateManyInlineInput>;
  errorPage?: InputMaybe<ErrorPageUpdateManyInlineInput>;
  evalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateManyInlineInput>;
  exampleComponent?: InputMaybe<ExampleComponentUpdateManyInlineInput>;
  featuredContent?: InputMaybe<FeaturedContentUpdateManyInlineInput>;
  featuredContentReference?: InputMaybe<FeaturedContentReferenceUpdateManyInlineInput>;
  footerNavigation?: InputMaybe<FooterNavigationUpdateManyInlineInput>;
  form?: InputMaybe<FormUpdateManyInlineInput>;
  formCheckbox?: InputMaybe<FormCheckboxUpdateManyInlineInput>;
  formCheckboxCollection?: InputMaybe<FormCheckboxCollectionUpdateManyInlineInput>;
  formDateInputs?: InputMaybe<FormDateInputUpdateManyInlineInput>;
  formEmailInput?: InputMaybe<FormEmailInputUpdateManyInlineInput>;
  formError?: InputMaybe<FormErrorUpdateManyInlineInput>;
  formFileUploader?: InputMaybe<FormFileUploaderUpdateManyInlineInput>;
  formListItem?: InputMaybe<FormListItemUpdateManyInlineInput>;
  formLists?: InputMaybe<FormListUpdateManyInlineInput>;
  formNumberInputs?: InputMaybe<FormNumberInputUpdateManyInlineInput>;
  formPasswordInput?: InputMaybe<FormPasswordInputUpdateManyInlineInput>;
  formPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationUpdateManyInlineInput>;
  formRadioButton?: InputMaybe<FormRadioButtonUpdateManyInlineInput>;
  formRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionUpdateManyInlineInput>;
  formSelectComponent?: InputMaybe<FormSelectComponentUpdateManyInlineInput>;
  formSelectOption?: InputMaybe<FormSelectOptionUpdateManyInlineInput>;
  formSubmitButton?: InputMaybe<FormSubmitButtonUpdateManyInlineInput>;
  formSuccessComponent?: InputMaybe<FormSuccessComponentUpdateManyInlineInput>;
  formTextInput?: InputMaybe<FormTextInputUpdateManyInlineInput>;
  formTextareaInput?: InputMaybe<FormTextareaInputUpdateManyInlineInput>;
  genericAccordion?: InputMaybe<GenericAccordionUpdateManyInlineInput>;
  genericAccordionItem?: InputMaybe<GenericAccordionItemUpdateManyInlineInput>;
  genericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateManyInlineInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateManyInlineInput>;
  genericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateManyInlineInput>;
  genericFollowUs?: InputMaybe<GenericFollowUsUpdateManyInlineInput>;
  genericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateManyInlineInput>;
  genericHtmlComponents?: InputMaybe<GenericHtmlUpdateManyInlineInput>;
  genericLine?: InputMaybe<GenericLineUpdateManyInlineInput>;
  genericLink?: InputMaybe<GenericLinkUpdateManyInlineInput>;
  genericPage?: InputMaybe<GenericPageUpdateManyInlineInput>;
  genericPromotionsOverviews?: InputMaybe<GenericPromotionsOverviewUpdateManyInlineInput>;
  genericQualifioOverviews?: InputMaybe<GenericQualifioOverviewUpdateManyInlineInput>;
  genericQualifios?: InputMaybe<GenericQualifioUpdateManyInlineInput>;
  genericSocialShare?: InputMaybe<GenericSocialShareUpdateManyInlineInput>;
  globalMetaData?: InputMaybe<GlobalMetaDataUpdateManyInlineInput>;
  globalSearches?: InputMaybe<GlobalSearchUpdateManyInlineInput>;
  gridColumnComponent?: InputMaybe<GridColumnComponentUpdateManyInlineInput>;
  gridColumns?: InputMaybe<GridColumnUpdateManyInlineInput>;
  heroBanner?: InputMaybe<HeroBannerUpdateManyInlineInput>;
  heroBannerMasterbrands?: InputMaybe<HeroBannerMasterbrandUpdateManyInlineInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateManyInlineInput>;
  heroComponent?: InputMaybe<HeroComponentUpdateManyInlineInput>;
  iframe?: InputMaybe<IframeUpdateManyInlineInput>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardUpdateManyInlineInput>;
  imageCopy?: InputMaybe<ImageCopyUpdateManyInlineInput>;
  imageCopyItem?: InputMaybe<ImageCopyItemUpdateManyInlineInput>;
  introText?: InputMaybe<IntroTextUpdateManyInlineInput>;
  leftColumn?: InputMaybe<LeftColumnUpdateManyInlineInput>;
  link?: InputMaybe<LinkUpdateManyInlineInput>;
  longText?: InputMaybe<LongTextUpdateManyInlineInput>;
  marketDescription?: InputMaybe<Scalars['String']['input']>;
  marketLocaleId?: InputMaybe<Markets>;
  marketName?: InputMaybe<Scalars['String']['input']>;
  marketUserConnection?: InputMaybe<MarketUserConnectionUpdateOneInlineInput>;
  metaData?: InputMaybe<MetaDataUpdateManyInlineInput>;
  mobileOnlyMainNavigation?: InputMaybe<MobileOnlyMainNavigationUpdateManyInlineInput>;
  navigation?: InputMaybe<NavigationUpdateManyInlineInput>;
  navigationItem?: InputMaybe<NavigationItemUpdateManyInlineInput>;
  newsletterComponents?: InputMaybe<NewsletterComponentUpdateManyInlineInput>;
  notificationBanner?: InputMaybe<NotificationBannerUpdateManyInlineInput>;
  pageFooter?: InputMaybe<PageFooterUpdateManyInlineInput>;
  pageHeader?: InputMaybe<PageHeaderUpdateManyInlineInput>;
  popularSearchComponent?: InputMaybe<PopularSearchComponentUpdateManyInlineInput>;
  product?: InputMaybe<ProductUpdateManyInlineInput>;
  productBanner?: InputMaybe<ProductBannerUpdateManyInlineInput>;
  productCategory?: InputMaybe<ProductCategoryUpdateManyInlineInput>;
  productCategoryPage?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productDetailPage?: InputMaybe<ProductDetailPageUpdateManyInlineInput>;
  productHero?: InputMaybe<ProductHeroUpdateManyInlineInput>;
  productLandingPage?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  question?: InputMaybe<QuestionUpdateManyInlineInput>;
  questionCheckbox?: InputMaybe<QuestionCheckboxUpdateManyInlineInput>;
  questionCheckboxCollection?: InputMaybe<QuestionCheckboxCollectionUpdateManyInlineInput>;
  questionRadioButton?: InputMaybe<QuestionRadioButtonUpdateManyInlineInput>;
  questionRadioButtonCollection?: InputMaybe<QuestionRadioButtonCollectionUpdateManyInlineInput>;
  rating?: InputMaybe<RatingUpdateManyInlineInput>;
  recipe?: InputMaybe<RecipeUpdateManyInlineInput>;
  recipeCategory?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPage?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  recipesComparisonQueryComponent?: InputMaybe<RecipesComparisonQueryComponentUpdateManyInlineInput>;
  recipesQueriesReference?: InputMaybe<RecipesQueriesReferenceUpdateManyInlineInput>;
  recipesQueryComponent?: InputMaybe<RecipesQueryComponentUpdateManyInlineInput>;
  redirect?: InputMaybe<RedirectUpdateManyInlineInput>;
  rewrite?: InputMaybe<RewriteUpdateManyInlineInput>;
  rightColumn?: InputMaybe<RightColumnUpdateManyInlineInput>;
  searchInput?: InputMaybe<SearchInputUpdateManyInlineInput>;
  searchOverlayComponent?: InputMaybe<SearchOverlayComponentUpdateManyInlineInput>;
  searchResultPage?: InputMaybe<SearchResultPageUpdateManyInlineInput>;
  separators?: InputMaybe<SeparatorUpdateManyInlineInput>;
  socialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateManyInlineInput>;
  spacer?: InputMaybe<SpacerUpdateManyInlineInput>;
  subCategoryKeyImage?: InputMaybe<SubCategoryKeyImageUpdateManyInlineInput>;
  subTab?: InputMaybe<SubTabUpdateManyInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateManyInlineInput>;
  sustainabilityBanner?: InputMaybe<SustainabilityBannerUpdateManyInlineInput>;
  sustainabilityInfo?: InputMaybe<SustainabilityInfoUpdateManyInlineInput>;
  tab?: InputMaybe<TabUpdateManyInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateManyInlineInput>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderUpdateManyInlineInput>;
  teaserSmallComponents?: InputMaybe<TeaserSmallUpdateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderUpdateManyInlineInput>;
  teasers?: InputMaybe<TeaserUpdateManyInlineInput>;
  testComponentWithRecipeQuery?: InputMaybe<TestComponentWithRecipeQueryUpdateManyInlineInput>;
  testTipsANdTricksInAMarket?: InputMaybe<TestTipsANdTricksInAMarketUpdateManyInlineInput>;
  textComponent?: InputMaybe<TextComponentUpdateManyInlineInput>;
  tipsAndTricksDetailsPage?: InputMaybe<TipsAndTricksDetailsPageUpdateManyInlineInput>;
  title?: InputMaybe<TitleUpdateManyInlineInput>;
  twitterSeo?: InputMaybe<TwitterSeoUpdateManyInlineInput>;
};

export type MarketUpdateManyInlineInput = {
  /** Connect multiple existing Market documents */
  connect?: InputMaybe<Array<MarketConnectInput>>;
  /** Create and connect multiple Market documents */
  create?: InputMaybe<Array<MarketCreateInput>>;
  /** Delete multiple Market documents */
  delete?: InputMaybe<Array<MarketWhereUniqueInput>>;
  /** Disconnect multiple Market documents */
  disconnect?: InputMaybe<Array<MarketWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Market documents */
  set?: InputMaybe<Array<MarketWhereUniqueInput>>;
  /** Update multiple Market documents */
  update?: InputMaybe<Array<MarketUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Market documents */
  upsert?: InputMaybe<Array<MarketUpsertWithNestedWhereUniqueInput>>;
};

export type MarketUpdateManyInput = {
  marketDescription?: InputMaybe<Scalars['String']['input']>;
  marketName?: InputMaybe<Scalars['String']['input']>;
};

export type MarketUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MarketUpdateManyInput;
  /** Document search */
  where: MarketWhereInput;
};

export type MarketUpdateOneInlineInput = {
  /** Connect existing Market document */
  connect?: InputMaybe<MarketWhereUniqueInput>;
  /** Create and connect one Market document */
  create?: InputMaybe<MarketCreateInput>;
  /** Delete currently connected Market document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Market document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Market document */
  update?: InputMaybe<MarketUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Market document */
  upsert?: InputMaybe<MarketUpsertWithNestedWhereUniqueInput>;
};

export type MarketUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MarketUpdateInput;
  /** Unique document search */
  where: MarketWhereUniqueInput;
};

export type MarketUpsertInput = {
  /** Create document if it didn't exist */
  create: MarketCreateInput;
  /** Update document if it exists */
  update: MarketUpdateInput;
};

export type MarketUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MarketUpsertInput;
  /** Unique document search */
  where: MarketWhereUniqueInput;
};

export type MarketUserConnection = Entity & Node & {
  __typename?: 'MarketUserConnection';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<MarketUserConnection>;
  /** List of MarketUserConnection versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  users: Array<User>;
};


export type MarketUserConnectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MarketUserConnectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type MarketUserConnectionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type MarketUserConnectionMarketArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MarketUserConnectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MarketUserConnectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type MarketUserConnectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MarketUserConnectionUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};

export type MarketUserConnectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MarketUserConnectionWhereUniqueInput;
};

/** A connection to a list of items. */
export type MarketUserConnectionConnection = {
  __typename?: 'MarketUserConnectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MarketUserConnectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MarketUserConnectionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market?: InputMaybe<MarketCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  users?: InputMaybe<UserCreateManyInlineInput>;
};

export type MarketUserConnectionCreateManyInlineInput = {
  /** Connect multiple existing MarketUserConnection documents */
  connect?: InputMaybe<Array<MarketUserConnectionWhereUniqueInput>>;
  /** Create and connect multiple existing MarketUserConnection documents */
  create?: InputMaybe<Array<MarketUserConnectionCreateInput>>;
};

export type MarketUserConnectionCreateOneInlineInput = {
  /** Connect one existing MarketUserConnection document */
  connect?: InputMaybe<MarketUserConnectionWhereUniqueInput>;
  /** Create and connect one MarketUserConnection document */
  create?: InputMaybe<MarketUserConnectionCreateInput>;
};

/** An edge in a connection. */
export type MarketUserConnectionEdge = {
  __typename?: 'MarketUserConnectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MarketUserConnection;
};

/** Identifies documents */
export type MarketUserConnectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MarketUserConnectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MarketUserConnectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MarketUserConnectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MarketUserConnectionWhereStageInput>;
  documentInStages_none?: InputMaybe<MarketUserConnectionWhereStageInput>;
  documentInStages_some?: InputMaybe<MarketUserConnectionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<MarketWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  users_every?: InputMaybe<UserWhereInput>;
  users_none?: InputMaybe<UserWhereInput>;
  users_some?: InputMaybe<UserWhereInput>;
};

export enum MarketUserConnectionOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type MarketUserConnectionUpdateInput = {
  market?: InputMaybe<MarketUpdateOneInlineInput>;
  users?: InputMaybe<UserUpdateManyInlineInput>;
};

export type MarketUserConnectionUpdateManyInlineInput = {
  /** Connect multiple existing MarketUserConnection documents */
  connect?: InputMaybe<Array<MarketUserConnectionConnectInput>>;
  /** Create and connect multiple MarketUserConnection documents */
  create?: InputMaybe<Array<MarketUserConnectionCreateInput>>;
  /** Delete multiple MarketUserConnection documents */
  delete?: InputMaybe<Array<MarketUserConnectionWhereUniqueInput>>;
  /** Disconnect multiple MarketUserConnection documents */
  disconnect?: InputMaybe<Array<MarketUserConnectionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing MarketUserConnection documents */
  set?: InputMaybe<Array<MarketUserConnectionWhereUniqueInput>>;
  /** Update multiple MarketUserConnection documents */
  update?: InputMaybe<Array<MarketUserConnectionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple MarketUserConnection documents */
  upsert?: InputMaybe<Array<MarketUserConnectionUpsertWithNestedWhereUniqueInput>>;
};

export type MarketUserConnectionUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type MarketUserConnectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MarketUserConnectionUpdateManyInput;
  /** Document search */
  where: MarketUserConnectionWhereInput;
};

export type MarketUserConnectionUpdateOneInlineInput = {
  /** Connect existing MarketUserConnection document */
  connect?: InputMaybe<MarketUserConnectionWhereUniqueInput>;
  /** Create and connect one MarketUserConnection document */
  create?: InputMaybe<MarketUserConnectionCreateInput>;
  /** Delete currently connected MarketUserConnection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected MarketUserConnection document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MarketUserConnection document */
  update?: InputMaybe<MarketUserConnectionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MarketUserConnection document */
  upsert?: InputMaybe<MarketUserConnectionUpsertWithNestedWhereUniqueInput>;
};

export type MarketUserConnectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MarketUserConnectionUpdateInput;
  /** Unique document search */
  where: MarketUserConnectionWhereUniqueInput;
};

export type MarketUserConnectionUpsertInput = {
  /** Create document if it didn't exist */
  create: MarketUserConnectionCreateInput;
  /** Update document if it exists */
  update: MarketUserConnectionUpdateInput;
};

export type MarketUserConnectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MarketUserConnectionUpsertInput;
  /** Unique document search */
  where: MarketUserConnectionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type MarketUserConnectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type MarketUserConnectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MarketUserConnectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MarketUserConnectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MarketUserConnectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MarketUserConnectionWhereStageInput>;
  documentInStages_none?: InputMaybe<MarketUserConnectionWhereStageInput>;
  documentInStages_some?: InputMaybe<MarketUserConnectionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<MarketWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  users_every?: InputMaybe<UserWhereInput>;
  users_none?: InputMaybe<UserWhereInput>;
  users_some?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type MarketUserConnectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MarketUserConnectionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MarketUserConnectionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MarketUserConnectionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<MarketUserConnectionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References MarketUserConnection record uniquely */
export type MarketUserConnectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** This contains a set of filters that can be used to compare values internally */
export type MarketWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type MarketWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MarketWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MarketWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MarketWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordionItem_every?: InputMaybe<AccordionItemWhereInput>;
  accordionItem_none?: InputMaybe<AccordionItemWhereInput>;
  accordionItem_some?: InputMaybe<AccordionItemWhereInput>;
  accordion_every?: InputMaybe<AccordionWhereInput>;
  accordion_none?: InputMaybe<AccordionWhereInput>;
  accordion_some?: InputMaybe<AccordionWhereInput>;
  algoliaExtension_every?: InputMaybe<AlgoliaExtensionWhereInput>;
  algoliaExtension_none?: InputMaybe<AlgoliaExtensionWhereInput>;
  algoliaExtension_some?: InputMaybe<AlgoliaExtensionWhereInput>;
  anchorNav_every?: InputMaybe<AnchorNavWhereInput>;
  anchorNav_none?: InputMaybe<AnchorNavWhereInput>;
  anchorNav_some?: InputMaybe<AnchorNavWhereInput>;
  anchorNavigationList_every?: InputMaybe<AnchorNavigationListWhereInput>;
  anchorNavigationList_none?: InputMaybe<AnchorNavigationListWhereInput>;
  anchorNavigationList_some?: InputMaybe<AnchorNavigationListWhereInput>;
  anchorNavigations_every?: InputMaybe<AnchorNavigationWhereInput>;
  anchorNavigations_none?: InputMaybe<AnchorNavigationWhereInput>;
  anchorNavigations_some?: InputMaybe<AnchorNavigationWhereInput>;
  assetComponent_every?: InputMaybe<AssetComponentWhereInput>;
  assetComponent_none?: InputMaybe<AssetComponentWhereInput>;
  assetComponent_some?: InputMaybe<AssetComponentWhereInput>;
  audioComponents_every?: InputMaybe<AudioComponentWhereInput>;
  audioComponents_none?: InputMaybe<AudioComponentWhereInput>;
  audioComponents_some?: InputMaybe<AudioComponentWhereInput>;
  authorableContentCard_every?: InputMaybe<AuthorableContentCardWhereInput>;
  authorableContentCard_none?: InputMaybe<AuthorableContentCardWhereInput>;
  authorableContentCard_some?: InputMaybe<AuthorableContentCardWhereInput>;
  banner1_every?: InputMaybe<Banner1WhereInput>;
  banner1_none?: InputMaybe<Banner1WhereInput>;
  banner1_some?: InputMaybe<Banner1WhereInput>;
  banner2CarouselComponents_every?: InputMaybe<Banner2CarouselComponentWhereInput>;
  banner2CarouselComponents_none?: InputMaybe<Banner2CarouselComponentWhereInput>;
  banner2CarouselComponents_some?: InputMaybe<Banner2CarouselComponentWhereInput>;
  banner2_every?: InputMaybe<Banner2WhereInput>;
  banner2_none?: InputMaybe<Banner2WhereInput>;
  banner2_some?: InputMaybe<Banner2WhereInput>;
  cardComponent_every?: InputMaybe<CardComponentWhereInput>;
  cardComponent_none?: InputMaybe<CardComponentWhereInput>;
  cardComponent_some?: InputMaybe<CardComponentWhereInput>;
  carouselComponent_every?: InputMaybe<CarouselComponentWhereInput>;
  carouselComponent_none?: InputMaybe<CarouselComponentWhereInput>;
  carouselComponent_some?: InputMaybe<CarouselComponentWhereInput>;
  carouselSlide_every?: InputMaybe<CarouselSlideWhereInput>;
  carouselSlide_none?: InputMaybe<CarouselSlideWhereInput>;
  carouselSlide_some?: InputMaybe<CarouselSlideWhereInput>;
  categoryCard_every?: InputMaybe<CategoryCardWhereInput>;
  categoryCard_none?: InputMaybe<CategoryCardWhereInput>;
  categoryCard_some?: InputMaybe<CategoryCardWhereInput>;
  contactCardContainer_every?: InputMaybe<ContactCardContainerWhereInput>;
  contactCardContainer_none?: InputMaybe<ContactCardContainerWhereInput>;
  contactCardContainer_some?: InputMaybe<ContactCardContainerWhereInput>;
  contactCard_every?: InputMaybe<ContactCardWhereInput>;
  contactCard_none?: InputMaybe<ContactCardWhereInput>;
  contactCard_some?: InputMaybe<ContactCardWhereInput>;
  countrySelectorFooter_every?: InputMaybe<CountrySelectorFooterWhereInput>;
  countrySelectorFooter_none?: InputMaybe<CountrySelectorFooterWhereInput>;
  countrySelectorFooter_some?: InputMaybe<CountrySelectorFooterWhereInput>;
  countrySelectorItem_every?: InputMaybe<CountrySelectorItemWhereInput>;
  countrySelectorItem_none?: InputMaybe<CountrySelectorItemWhereInput>;
  countrySelectorItem_some?: InputMaybe<CountrySelectorItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaryItem_every?: InputMaybe<DictionaryItemWhereInput>;
  dictionaryItem_none?: InputMaybe<DictionaryItemWhereInput>;
  dictionaryItem_some?: InputMaybe<DictionaryItemWhereInput>;
  dictionary_every?: InputMaybe<DictionaryWhereInput>;
  dictionary_none?: InputMaybe<DictionaryWhereInput>;
  dictionary_some?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<MarketWhereStageInput>;
  documentInStages_none?: InputMaybe<MarketWhereStageInput>;
  documentInStages_some?: InputMaybe<MarketWhereStageInput>;
  downloadApp_every?: InputMaybe<DownloadAppWhereInput>;
  downloadApp_none?: InputMaybe<DownloadAppWhereInput>;
  downloadApp_some?: InputMaybe<DownloadAppWhereInput>;
  dynamicCardGrid_every?: InputMaybe<DynamicCardGridWhereInput>;
  dynamicCardGrid_none?: InputMaybe<DynamicCardGridWhereInput>;
  dynamicCardGrid_some?: InputMaybe<DynamicCardGridWhereInput>;
  errorPage_every?: InputMaybe<ErrorPageWhereInput>;
  errorPage_none?: InputMaybe<ErrorPageWhereInput>;
  errorPage_some?: InputMaybe<ErrorPageWhereInput>;
  evalancheFormComponent_every?: InputMaybe<EvalancheFormComponentWhereInput>;
  evalancheFormComponent_none?: InputMaybe<EvalancheFormComponentWhereInput>;
  evalancheFormComponent_some?: InputMaybe<EvalancheFormComponentWhereInput>;
  exampleComponent_every?: InputMaybe<ExampleComponentWhereInput>;
  exampleComponent_none?: InputMaybe<ExampleComponentWhereInput>;
  exampleComponent_some?: InputMaybe<ExampleComponentWhereInput>;
  featuredContentReference_every?: InputMaybe<FeaturedContentReferenceWhereInput>;
  featuredContentReference_none?: InputMaybe<FeaturedContentReferenceWhereInput>;
  featuredContentReference_some?: InputMaybe<FeaturedContentReferenceWhereInput>;
  featuredContent_every?: InputMaybe<FeaturedContentWhereInput>;
  featuredContent_none?: InputMaybe<FeaturedContentWhereInput>;
  featuredContent_some?: InputMaybe<FeaturedContentWhereInput>;
  footerNavigation_every?: InputMaybe<FooterNavigationWhereInput>;
  footerNavigation_none?: InputMaybe<FooterNavigationWhereInput>;
  footerNavigation_some?: InputMaybe<FooterNavigationWhereInput>;
  formCheckboxCollection_every?: InputMaybe<FormCheckboxCollectionWhereInput>;
  formCheckboxCollection_none?: InputMaybe<FormCheckboxCollectionWhereInput>;
  formCheckboxCollection_some?: InputMaybe<FormCheckboxCollectionWhereInput>;
  formCheckbox_every?: InputMaybe<FormCheckboxWhereInput>;
  formCheckbox_none?: InputMaybe<FormCheckboxWhereInput>;
  formCheckbox_some?: InputMaybe<FormCheckboxWhereInput>;
  formDateInputs_every?: InputMaybe<FormDateInputWhereInput>;
  formDateInputs_none?: InputMaybe<FormDateInputWhereInput>;
  formDateInputs_some?: InputMaybe<FormDateInputWhereInput>;
  formEmailInput_every?: InputMaybe<FormEmailInputWhereInput>;
  formEmailInput_none?: InputMaybe<FormEmailInputWhereInput>;
  formEmailInput_some?: InputMaybe<FormEmailInputWhereInput>;
  formError_every?: InputMaybe<FormErrorWhereInput>;
  formError_none?: InputMaybe<FormErrorWhereInput>;
  formError_some?: InputMaybe<FormErrorWhereInput>;
  formFileUploader_every?: InputMaybe<FormFileUploaderWhereInput>;
  formFileUploader_none?: InputMaybe<FormFileUploaderWhereInput>;
  formFileUploader_some?: InputMaybe<FormFileUploaderWhereInput>;
  formListItem_every?: InputMaybe<FormListItemWhereInput>;
  formListItem_none?: InputMaybe<FormListItemWhereInput>;
  formListItem_some?: InputMaybe<FormListItemWhereInput>;
  formLists_every?: InputMaybe<FormListWhereInput>;
  formLists_none?: InputMaybe<FormListWhereInput>;
  formLists_some?: InputMaybe<FormListWhereInput>;
  formNumberInputs_every?: InputMaybe<FormNumberInputWhereInput>;
  formNumberInputs_none?: InputMaybe<FormNumberInputWhereInput>;
  formNumberInputs_some?: InputMaybe<FormNumberInputWhereInput>;
  formPasswordInputWithConfirmation_every?: InputMaybe<FormPasswordInputWithConfirmationWhereInput>;
  formPasswordInputWithConfirmation_none?: InputMaybe<FormPasswordInputWithConfirmationWhereInput>;
  formPasswordInputWithConfirmation_some?: InputMaybe<FormPasswordInputWithConfirmationWhereInput>;
  formPasswordInput_every?: InputMaybe<FormPasswordInputWhereInput>;
  formPasswordInput_none?: InputMaybe<FormPasswordInputWhereInput>;
  formPasswordInput_some?: InputMaybe<FormPasswordInputWhereInput>;
  formRadioButtonCollection_every?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  formRadioButtonCollection_none?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  formRadioButtonCollection_some?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  formRadioButton_every?: InputMaybe<FormRadioButtonWhereInput>;
  formRadioButton_none?: InputMaybe<FormRadioButtonWhereInput>;
  formRadioButton_some?: InputMaybe<FormRadioButtonWhereInput>;
  formSelectComponent_every?: InputMaybe<FormSelectComponentWhereInput>;
  formSelectComponent_none?: InputMaybe<FormSelectComponentWhereInput>;
  formSelectComponent_some?: InputMaybe<FormSelectComponentWhereInput>;
  formSelectOption_every?: InputMaybe<FormSelectOptionWhereInput>;
  formSelectOption_none?: InputMaybe<FormSelectOptionWhereInput>;
  formSelectOption_some?: InputMaybe<FormSelectOptionWhereInput>;
  formSubmitButton_every?: InputMaybe<FormSubmitButtonWhereInput>;
  formSubmitButton_none?: InputMaybe<FormSubmitButtonWhereInput>;
  formSubmitButton_some?: InputMaybe<FormSubmitButtonWhereInput>;
  formSuccessComponent_every?: InputMaybe<FormSuccessComponentWhereInput>;
  formSuccessComponent_none?: InputMaybe<FormSuccessComponentWhereInput>;
  formSuccessComponent_some?: InputMaybe<FormSuccessComponentWhereInput>;
  formTextInput_every?: InputMaybe<FormTextInputWhereInput>;
  formTextInput_none?: InputMaybe<FormTextInputWhereInput>;
  formTextInput_some?: InputMaybe<FormTextInputWhereInput>;
  formTextareaInput_every?: InputMaybe<FormTextareaInputWhereInput>;
  formTextareaInput_none?: InputMaybe<FormTextareaInputWhereInput>;
  formTextareaInput_some?: InputMaybe<FormTextareaInputWhereInput>;
  form_every?: InputMaybe<FormWhereInput>;
  form_none?: InputMaybe<FormWhereInput>;
  form_some?: InputMaybe<FormWhereInput>;
  genericAccordionItem_every?: InputMaybe<GenericAccordionItemWhereInput>;
  genericAccordionItem_none?: InputMaybe<GenericAccordionItemWhereInput>;
  genericAccordionItem_some?: InputMaybe<GenericAccordionItemWhereInput>;
  genericAccordionTopRated_every?: InputMaybe<GenericAccordionTopRatedWhereInput>;
  genericAccordionTopRated_none?: InputMaybe<GenericAccordionTopRatedWhereInput>;
  genericAccordionTopRated_some?: InputMaybe<GenericAccordionTopRatedWhereInput>;
  genericAccordion_every?: InputMaybe<GenericAccordionWhereInput>;
  genericAccordion_none?: InputMaybe<GenericAccordionWhereInput>;
  genericAccordion_some?: InputMaybe<GenericAccordionWhereInput>;
  genericCardCarouseComponent_every?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericCardCarouseComponent_none?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericCardCarouseComponent_some?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericDownloadComponent_every?: InputMaybe<GenericDownloadComponentWhereInput>;
  genericDownloadComponent_none?: InputMaybe<GenericDownloadComponentWhereInput>;
  genericDownloadComponent_some?: InputMaybe<GenericDownloadComponentWhereInput>;
  genericFollowUs_every?: InputMaybe<GenericFollowUsWhereInput>;
  genericFollowUs_none?: InputMaybe<GenericFollowUsWhereInput>;
  genericFollowUs_some?: InputMaybe<GenericFollowUsWhereInput>;
  genericGridAuthorable_every?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorable_none?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorable_some?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericHtmlComponents_every?: InputMaybe<GenericHtmlWhereInput>;
  genericHtmlComponents_none?: InputMaybe<GenericHtmlWhereInput>;
  genericHtmlComponents_some?: InputMaybe<GenericHtmlWhereInput>;
  genericLine_every?: InputMaybe<GenericLineWhereInput>;
  genericLine_none?: InputMaybe<GenericLineWhereInput>;
  genericLine_some?: InputMaybe<GenericLineWhereInput>;
  genericLink_every?: InputMaybe<GenericLinkWhereInput>;
  genericLink_none?: InputMaybe<GenericLinkWhereInput>;
  genericLink_some?: InputMaybe<GenericLinkWhereInput>;
  genericPage_every?: InputMaybe<GenericPageWhereInput>;
  genericPage_none?: InputMaybe<GenericPageWhereInput>;
  genericPage_some?: InputMaybe<GenericPageWhereInput>;
  genericPromotionsOverviews_every?: InputMaybe<GenericPromotionsOverviewWhereInput>;
  genericPromotionsOverviews_none?: InputMaybe<GenericPromotionsOverviewWhereInput>;
  genericPromotionsOverviews_some?: InputMaybe<GenericPromotionsOverviewWhereInput>;
  genericQualifioOverviews_every?: InputMaybe<GenericQualifioOverviewWhereInput>;
  genericQualifioOverviews_none?: InputMaybe<GenericQualifioOverviewWhereInput>;
  genericQualifioOverviews_some?: InputMaybe<GenericQualifioOverviewWhereInput>;
  genericQualifios_every?: InputMaybe<GenericQualifioWhereInput>;
  genericQualifios_none?: InputMaybe<GenericQualifioWhereInput>;
  genericQualifios_some?: InputMaybe<GenericQualifioWhereInput>;
  genericSocialShare_every?: InputMaybe<GenericSocialShareWhereInput>;
  genericSocialShare_none?: InputMaybe<GenericSocialShareWhereInput>;
  genericSocialShare_some?: InputMaybe<GenericSocialShareWhereInput>;
  globalMetaData_every?: InputMaybe<GlobalMetaDataWhereInput>;
  globalMetaData_none?: InputMaybe<GlobalMetaDataWhereInput>;
  globalMetaData_some?: InputMaybe<GlobalMetaDataWhereInput>;
  globalSearches_every?: InputMaybe<GlobalSearchWhereInput>;
  globalSearches_none?: InputMaybe<GlobalSearchWhereInput>;
  globalSearches_some?: InputMaybe<GlobalSearchWhereInput>;
  gridColumnComponent_every?: InputMaybe<GridColumnComponentWhereInput>;
  gridColumnComponent_none?: InputMaybe<GridColumnComponentWhereInput>;
  gridColumnComponent_some?: InputMaybe<GridColumnComponentWhereInput>;
  gridColumns_every?: InputMaybe<GridColumnWhereInput>;
  gridColumns_none?: InputMaybe<GridColumnWhereInput>;
  gridColumns_some?: InputMaybe<GridColumnWhereInput>;
  heroBannerMasterbrands_every?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  heroBannerMasterbrands_none?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  heroBannerMasterbrands_some?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  heroBanner_every?: InputMaybe<HeroBannerWhereInput>;
  heroBanner_none?: InputMaybe<HeroBannerWhereInput>;
  heroBanner_some?: InputMaybe<HeroBannerWhereInput>;
  heroCarouselComponent_every?: InputMaybe<HeroCarouselComponentWhereInput>;
  heroCarouselComponent_none?: InputMaybe<HeroCarouselComponentWhereInput>;
  heroCarouselComponent_some?: InputMaybe<HeroCarouselComponentWhereInput>;
  heroComponent_every?: InputMaybe<HeroComponentWhereInput>;
  heroComponent_none?: InputMaybe<HeroComponentWhereInput>;
  heroComponent_some?: InputMaybe<HeroComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  iframe_every?: InputMaybe<IframeWhereInput>;
  iframe_none?: InputMaybe<IframeWhereInput>;
  iframe_some?: InputMaybe<IframeWhereInput>;
  imageAndTextCard_every?: InputMaybe<ImageAndTextCardWhereInput>;
  imageAndTextCard_none?: InputMaybe<ImageAndTextCardWhereInput>;
  imageAndTextCard_some?: InputMaybe<ImageAndTextCardWhereInput>;
  imageCopyItem_every?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopyItem_none?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopyItem_some?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopy_every?: InputMaybe<ImageCopyWhereInput>;
  imageCopy_none?: InputMaybe<ImageCopyWhereInput>;
  imageCopy_some?: InputMaybe<ImageCopyWhereInput>;
  introText_every?: InputMaybe<IntroTextWhereInput>;
  introText_none?: InputMaybe<IntroTextWhereInput>;
  introText_some?: InputMaybe<IntroTextWhereInput>;
  leftColumn_every?: InputMaybe<LeftColumnWhereInput>;
  leftColumn_none?: InputMaybe<LeftColumnWhereInput>;
  leftColumn_some?: InputMaybe<LeftColumnWhereInput>;
  link_every?: InputMaybe<LinkWhereInput>;
  link_none?: InputMaybe<LinkWhereInput>;
  link_some?: InputMaybe<LinkWhereInput>;
  longText_every?: InputMaybe<LongTextWhereInput>;
  longText_none?: InputMaybe<LongTextWhereInput>;
  longText_some?: InputMaybe<LongTextWhereInput>;
  marketDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  marketDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  marketDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  marketDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  marketDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  marketDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  marketDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  marketDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  marketDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  marketDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  marketLocaleId?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  marketLocaleId_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  marketLocaleId_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  marketLocaleId_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  marketName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  marketName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  marketName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  marketName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  marketName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  marketName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  marketName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  marketName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  marketName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  marketName_starts_with?: InputMaybe<Scalars['String']['input']>;
  marketUserConnection?: InputMaybe<MarketUserConnectionWhereInput>;
  metaData_every?: InputMaybe<MetaDataWhereInput>;
  metaData_none?: InputMaybe<MetaDataWhereInput>;
  metaData_some?: InputMaybe<MetaDataWhereInput>;
  mobileOnlyMainNavigation_every?: InputMaybe<MobileOnlyMainNavigationWhereInput>;
  mobileOnlyMainNavigation_none?: InputMaybe<MobileOnlyMainNavigationWhereInput>;
  mobileOnlyMainNavigation_some?: InputMaybe<MobileOnlyMainNavigationWhereInput>;
  navigationItem_every?: InputMaybe<NavigationItemWhereInput>;
  navigationItem_none?: InputMaybe<NavigationItemWhereInput>;
  navigationItem_some?: InputMaybe<NavigationItemWhereInput>;
  navigation_every?: InputMaybe<NavigationWhereInput>;
  navigation_none?: InputMaybe<NavigationWhereInput>;
  navigation_some?: InputMaybe<NavigationWhereInput>;
  newsletterComponents_every?: InputMaybe<NewsletterComponentWhereInput>;
  newsletterComponents_none?: InputMaybe<NewsletterComponentWhereInput>;
  newsletterComponents_some?: InputMaybe<NewsletterComponentWhereInput>;
  notificationBanner_every?: InputMaybe<NotificationBannerWhereInput>;
  notificationBanner_none?: InputMaybe<NotificationBannerWhereInput>;
  notificationBanner_some?: InputMaybe<NotificationBannerWhereInput>;
  pageFooter_every?: InputMaybe<PageFooterWhereInput>;
  pageFooter_none?: InputMaybe<PageFooterWhereInput>;
  pageFooter_some?: InputMaybe<PageFooterWhereInput>;
  pageHeader_every?: InputMaybe<PageHeaderWhereInput>;
  pageHeader_none?: InputMaybe<PageHeaderWhereInput>;
  pageHeader_some?: InputMaybe<PageHeaderWhereInput>;
  popularSearchComponent_every?: InputMaybe<PopularSearchComponentWhereInput>;
  popularSearchComponent_none?: InputMaybe<PopularSearchComponentWhereInput>;
  popularSearchComponent_some?: InputMaybe<PopularSearchComponentWhereInput>;
  productBanner_every?: InputMaybe<ProductBannerWhereInput>;
  productBanner_none?: InputMaybe<ProductBannerWhereInput>;
  productBanner_some?: InputMaybe<ProductBannerWhereInput>;
  productCategoryPage_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPage_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPage_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategory_every?: InputMaybe<ProductCategoryWhereInput>;
  productCategory_none?: InputMaybe<ProductCategoryWhereInput>;
  productCategory_some?: InputMaybe<ProductCategoryWhereInput>;
  productDetailPage_every?: InputMaybe<ProductDetailPageWhereInput>;
  productDetailPage_none?: InputMaybe<ProductDetailPageWhereInput>;
  productDetailPage_some?: InputMaybe<ProductDetailPageWhereInput>;
  productHero_every?: InputMaybe<ProductHeroWhereInput>;
  productHero_none?: InputMaybe<ProductHeroWhereInput>;
  productHero_some?: InputMaybe<ProductHeroWhereInput>;
  productLandingPage_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPage_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPage_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPage_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPage_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPage_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  product_every?: InputMaybe<ProductWhereInput>;
  product_none?: InputMaybe<ProductWhereInput>;
  product_some?: InputMaybe<ProductWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  questionCheckboxCollection_every?: InputMaybe<QuestionCheckboxCollectionWhereInput>;
  questionCheckboxCollection_none?: InputMaybe<QuestionCheckboxCollectionWhereInput>;
  questionCheckboxCollection_some?: InputMaybe<QuestionCheckboxCollectionWhereInput>;
  questionCheckbox_every?: InputMaybe<QuestionCheckboxWhereInput>;
  questionCheckbox_none?: InputMaybe<QuestionCheckboxWhereInput>;
  questionCheckbox_some?: InputMaybe<QuestionCheckboxWhereInput>;
  questionRadioButtonCollection_every?: InputMaybe<QuestionRadioButtonCollectionWhereInput>;
  questionRadioButtonCollection_none?: InputMaybe<QuestionRadioButtonCollectionWhereInput>;
  questionRadioButtonCollection_some?: InputMaybe<QuestionRadioButtonCollectionWhereInput>;
  questionRadioButton_every?: InputMaybe<QuestionRadioButtonWhereInput>;
  questionRadioButton_none?: InputMaybe<QuestionRadioButtonWhereInput>;
  questionRadioButton_some?: InputMaybe<QuestionRadioButtonWhereInput>;
  question_every?: InputMaybe<QuestionWhereInput>;
  question_none?: InputMaybe<QuestionWhereInput>;
  question_some?: InputMaybe<QuestionWhereInput>;
  rating_every?: InputMaybe<RatingWhereInput>;
  rating_none?: InputMaybe<RatingWhereInput>;
  rating_some?: InputMaybe<RatingWhereInput>;
  recipeCategory_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategory_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategory_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPage_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPage_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPage_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategory_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategory_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategory_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipe_every?: InputMaybe<RecipeWhereInput>;
  recipe_none?: InputMaybe<RecipeWhereInput>;
  recipe_some?: InputMaybe<RecipeWhereInput>;
  recipesComparisonQueryComponent_every?: InputMaybe<RecipesComparisonQueryComponentWhereInput>;
  recipesComparisonQueryComponent_none?: InputMaybe<RecipesComparisonQueryComponentWhereInput>;
  recipesComparisonQueryComponent_some?: InputMaybe<RecipesComparisonQueryComponentWhereInput>;
  recipesQueriesReference_every?: InputMaybe<RecipesQueriesReferenceWhereInput>;
  recipesQueriesReference_none?: InputMaybe<RecipesQueriesReferenceWhereInput>;
  recipesQueriesReference_some?: InputMaybe<RecipesQueriesReferenceWhereInput>;
  recipesQueryComponent_every?: InputMaybe<RecipesQueryComponentWhereInput>;
  recipesQueryComponent_none?: InputMaybe<RecipesQueryComponentWhereInput>;
  recipesQueryComponent_some?: InputMaybe<RecipesQueryComponentWhereInput>;
  redirect_every?: InputMaybe<RedirectWhereInput>;
  redirect_none?: InputMaybe<RedirectWhereInput>;
  redirect_some?: InputMaybe<RedirectWhereInput>;
  rewrite_every?: InputMaybe<RewriteWhereInput>;
  rewrite_none?: InputMaybe<RewriteWhereInput>;
  rewrite_some?: InputMaybe<RewriteWhereInput>;
  rightColumn_every?: InputMaybe<RightColumnWhereInput>;
  rightColumn_none?: InputMaybe<RightColumnWhereInput>;
  rightColumn_some?: InputMaybe<RightColumnWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  searchInput_every?: InputMaybe<SearchInputWhereInput>;
  searchInput_none?: InputMaybe<SearchInputWhereInput>;
  searchInput_some?: InputMaybe<SearchInputWhereInput>;
  searchOverlayComponent_every?: InputMaybe<SearchOverlayComponentWhereInput>;
  searchOverlayComponent_none?: InputMaybe<SearchOverlayComponentWhereInput>;
  searchOverlayComponent_some?: InputMaybe<SearchOverlayComponentWhereInput>;
  searchResultPage_every?: InputMaybe<SearchResultPageWhereInput>;
  searchResultPage_none?: InputMaybe<SearchResultPageWhereInput>;
  searchResultPage_some?: InputMaybe<SearchResultPageWhereInput>;
  separators_every?: InputMaybe<SeparatorWhereInput>;
  separators_none?: InputMaybe<SeparatorWhereInput>;
  separators_some?: InputMaybe<SeparatorWhereInput>;
  socialMediaListComponent_every?: InputMaybe<SocialMediaListComponentWhereInput>;
  socialMediaListComponent_none?: InputMaybe<SocialMediaListComponentWhereInput>;
  socialMediaListComponent_some?: InputMaybe<SocialMediaListComponentWhereInput>;
  spacer_every?: InputMaybe<SpacerWhereInput>;
  spacer_none?: InputMaybe<SpacerWhereInput>;
  spacer_some?: InputMaybe<SpacerWhereInput>;
  subCategoryKeyImage_every?: InputMaybe<SubCategoryKeyImageWhereInput>;
  subCategoryKeyImage_none?: InputMaybe<SubCategoryKeyImageWhereInput>;
  subCategoryKeyImage_some?: InputMaybe<SubCategoryKeyImageWhereInput>;
  subTabContent_every?: InputMaybe<SubTabContentWhereInput>;
  subTabContent_none?: InputMaybe<SubTabContentWhereInput>;
  subTabContent_some?: InputMaybe<SubTabContentWhereInput>;
  subTab_every?: InputMaybe<SubTabWhereInput>;
  subTab_none?: InputMaybe<SubTabWhereInput>;
  subTab_some?: InputMaybe<SubTabWhereInput>;
  sustainabilityBanner_every?: InputMaybe<SustainabilityBannerWhereInput>;
  sustainabilityBanner_none?: InputMaybe<SustainabilityBannerWhereInput>;
  sustainabilityBanner_some?: InputMaybe<SustainabilityBannerWhereInput>;
  sustainabilityInfo_every?: InputMaybe<SustainabilityInfoWhereInput>;
  sustainabilityInfo_none?: InputMaybe<SustainabilityInfoWhereInput>;
  sustainabilityInfo_some?: InputMaybe<SustainabilityInfoWhereInput>;
  tabContent_every?: InputMaybe<TabContentWhereInput>;
  tabContent_none?: InputMaybe<TabContentWhereInput>;
  tabContent_some?: InputMaybe<TabContentWhereInput>;
  tab_every?: InputMaybe<TabWhereInput>;
  tab_none?: InputMaybe<TabWhereInput>;
  tab_some?: InputMaybe<TabWhereInput>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallComponents_every?: InputMaybe<TeaserSmallWhereInput>;
  teaserSmallComponents_none?: InputMaybe<TeaserSmallWhereInput>;
  teaserSmallComponents_some?: InputMaybe<TeaserSmallWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teasers_every?: InputMaybe<TeaserWhereInput>;
  teasers_none?: InputMaybe<TeaserWhereInput>;
  teasers_some?: InputMaybe<TeaserWhereInput>;
  testComponentWithRecipeQuery_every?: InputMaybe<TestComponentWithRecipeQueryWhereInput>;
  testComponentWithRecipeQuery_none?: InputMaybe<TestComponentWithRecipeQueryWhereInput>;
  testComponentWithRecipeQuery_some?: InputMaybe<TestComponentWithRecipeQueryWhereInput>;
  testTipsANdTricksInAMarket_every?: InputMaybe<TestTipsANdTricksInAMarketWhereInput>;
  testTipsANdTricksInAMarket_none?: InputMaybe<TestTipsANdTricksInAMarketWhereInput>;
  testTipsANdTricksInAMarket_some?: InputMaybe<TestTipsANdTricksInAMarketWhereInput>;
  textComponent_every?: InputMaybe<TextComponentWhereInput>;
  textComponent_none?: InputMaybe<TextComponentWhereInput>;
  textComponent_some?: InputMaybe<TextComponentWhereInput>;
  tipsAndTricksDetailsPage_every?: InputMaybe<TipsAndTricksDetailsPageWhereInput>;
  tipsAndTricksDetailsPage_none?: InputMaybe<TipsAndTricksDetailsPageWhereInput>;
  tipsAndTricksDetailsPage_some?: InputMaybe<TipsAndTricksDetailsPageWhereInput>;
  title_every?: InputMaybe<TitleWhereInput>;
  title_none?: InputMaybe<TitleWhereInput>;
  title_some?: InputMaybe<TitleWhereInput>;
  twitterSeo_every?: InputMaybe<TwitterSeoWhereInput>;
  twitterSeo_none?: InputMaybe<TwitterSeoWhereInput>;
  twitterSeo_some?: InputMaybe<TwitterSeoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type MarketWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MarketWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MarketWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MarketWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<MarketWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Market record uniquely */
export type MarketWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  marketLocaleId?: InputMaybe<Markets>;
};

/** list of markets where we have data */
export enum Markets {
  at = 'at',
  au = 'au',
  ba = 'ba',
  be_fr = 'be_fr',
  be_nl = 'be_nl',
  bg = 'bg',
  br = 'br',
  ca_en = 'ca_en',
  ca_fr = 'ca_fr',
  ch_de = 'ch_de',
  ch_fr = 'ch_fr',
  ch_it = 'ch_it',
  cn = 'cn',
  cz = 'cz',
  de = 'de',
  dk = 'dk',
  es = 'es',
  fi = 'fi',
  fr = 'fr',
  hr = 'hr',
  hu = 'hu',
  ie = 'ie',
  in = 'in',
  it = 'it',
  jp = 'jp',
  lt = 'lt',
  lv = 'lv',
  my = 'my',
  nl = 'nl',
  no = 'no',
  pl = 'pl',
  pt = 'pt',
  ro = 'ro',
  rs = 'rs',
  se = 'se',
  si = 'si',
  sk = 'sk',
  tasteland = 'tasteland',
  tr = 'tr',
  ua = 'ua',
  uk = 'uk',
  us = 'us',
  za = 'za'
}

/** Page Meta Data Component used on every page for SEO */
export type MetaData = Entity & Node & {
  __typename?: 'MetaData';
  anchorNav?: Maybe<AnchorNavigation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Page description for SEO. (e.g. Google Search results). It should be ~160 characters long and summarize the page content. Search engines show the meta description in search results! */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<MetaData>;
  genericPage?: Maybe<GenericPage>;
  /** List of MetaData versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  images: Array<Asset>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** Facebook specific. Optionally specify an open graph type - if you are unsure, leave this field blank. This will generally not need to be set. More information at https://developers.facebook.com/docs/reference/opengraph/ */
  openGraphType?: Maybe<Scalars['String']['output']>;
  /** The name of the page */
  pageName: Scalars['String']['output'];
  productCategoryPage?: Maybe<ProductCategoryPage>;
  productLandingPage?: Maybe<ProductLandingPage>;
  productSubcategoryPage?: Maybe<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipe?: Maybe<Recipe>;
  recipeCategory?: Maybe<RecipeCategory>;
  recipeLandingPage?: Maybe<RecipeLandingPage>;
  recipeSubcategory?: Maybe<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** DO NOT USE THIS FIELD, NO LONGER NEEDED, USE PAGE NAME INSTEAD. THIS FIELD WILL BE DELETED SHORTLY 24.11.21 DH */
  sectionName?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** Theme for the page. Default is the "Oetker" theme. please update for other themes when added */
  theme?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataGenericPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataProductCategoryPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataProductLandingPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataProductSubcategoryPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataRecipeArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataRecipeCategoryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataRecipeLandingPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataRecipeSubcategoryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type MetaDataConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MetaDataWhereUniqueInput;
};

/** A connection to a list of items. */
export type MetaDataConnection = {
  __typename?: 'MetaDataConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MetaDataEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MetaDataCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  genericPage?: InputMaybe<GenericPageCreateOneInlineInput>;
  images: AssetCreateManyInlineInput;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  openGraphType?: InputMaybe<Scalars['String']['input']>;
  pageName: Scalars['String']['input'];
  productCategoryPage?: InputMaybe<ProductCategoryPageCreateOneInlineInput>;
  productLandingPage?: InputMaybe<ProductLandingPageCreateOneInlineInput>;
  productSubcategoryPage?: InputMaybe<ProductSubcategoryPageCreateOneInlineInput>;
  recipe?: InputMaybe<RecipeCreateOneInlineInput>;
  recipeCategory?: InputMaybe<RecipeCategoryCreateOneInlineInput>;
  recipeLandingPage?: InputMaybe<RecipeLandingPageCreateOneInlineInput>;
  recipeSubcategory?: InputMaybe<RecipeSubcategoryCreateOneInlineInput>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MetaDataCreateManyInlineInput = {
  /** Connect multiple existing MetaData documents */
  connect?: InputMaybe<Array<MetaDataWhereUniqueInput>>;
  /** Create and connect multiple existing MetaData documents */
  create?: InputMaybe<Array<MetaDataCreateInput>>;
};

export type MetaDataCreateOneInlineInput = {
  /** Connect one existing MetaData document */
  connect?: InputMaybe<MetaDataWhereUniqueInput>;
  /** Create and connect one MetaData document */
  create?: InputMaybe<MetaDataCreateInput>;
};

/** An edge in a connection. */
export type MetaDataEdge = {
  __typename?: 'MetaDataEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MetaData;
};

/** Identifies documents */
export type MetaDataManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MetaDataWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MetaDataWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MetaDataWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<MetaDataWhereStageInput>;
  documentInStages_none?: InputMaybe<MetaDataWhereStageInput>;
  documentInStages_some?: InputMaybe<MetaDataWhereStageInput>;
  genericPage?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  images_every?: InputMaybe<AssetWhereInput>;
  images_none?: InputMaybe<AssetWhereInput>;
  images_some?: InputMaybe<AssetWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  openGraphType?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  openGraphType_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  openGraphType_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  openGraphType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  openGraphType_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  openGraphType_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  openGraphType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  openGraphType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  openGraphType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  openGraphType_starts_with?: InputMaybe<Scalars['String']['input']>;
  pageName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  pageName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  pageName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  pageName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  pageName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  pageName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  pageName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  pageName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  pageName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  pageName_starts_with?: InputMaybe<Scalars['String']['input']>;
  productCategoryPage?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPage?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPage?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipe?: InputMaybe<RecipeWhereInput>;
  recipeCategory?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPage?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategory?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sectionName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sectionName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sectionName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sectionName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sectionName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sectionName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sectionName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sectionName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sectionName_starts_with?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  theme_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  theme_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  theme_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  theme_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum MetaDataOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  openGraphType_ASC = 'openGraphType_ASC',
  openGraphType_DESC = 'openGraphType_DESC',
  pageName_ASC = 'pageName_ASC',
  pageName_DESC = 'pageName_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  sectionName_ASC = 'sectionName_ASC',
  sectionName_DESC = 'sectionName_DESC',
  theme_ASC = 'theme_ASC',
  theme_DESC = 'theme_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type MetaDataUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  genericPage?: InputMaybe<GenericPageUpdateOneInlineInput>;
  images?: InputMaybe<AssetUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  openGraphType?: InputMaybe<Scalars['String']['input']>;
  pageName?: InputMaybe<Scalars['String']['input']>;
  productCategoryPage?: InputMaybe<ProductCategoryPageUpdateOneInlineInput>;
  productLandingPage?: InputMaybe<ProductLandingPageUpdateOneInlineInput>;
  productSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpdateOneInlineInput>;
  recipe?: InputMaybe<RecipeUpdateOneInlineInput>;
  recipeCategory?: InputMaybe<RecipeCategoryUpdateOneInlineInput>;
  recipeLandingPage?: InputMaybe<RecipeLandingPageUpdateOneInlineInput>;
  recipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateOneInlineInput>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

export type MetaDataUpdateManyInlineInput = {
  /** Connect multiple existing MetaData documents */
  connect?: InputMaybe<Array<MetaDataConnectInput>>;
  /** Create and connect multiple MetaData documents */
  create?: InputMaybe<Array<MetaDataCreateInput>>;
  /** Delete multiple MetaData documents */
  delete?: InputMaybe<Array<MetaDataWhereUniqueInput>>;
  /** Disconnect multiple MetaData documents */
  disconnect?: InputMaybe<Array<MetaDataWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing MetaData documents */
  set?: InputMaybe<Array<MetaDataWhereUniqueInput>>;
  /** Update multiple MetaData documents */
  update?: InputMaybe<Array<MetaDataUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple MetaData documents */
  upsert?: InputMaybe<Array<MetaDataUpsertWithNestedWhereUniqueInput>>;
};

export type MetaDataUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  openGraphType?: InputMaybe<Scalars['String']['input']>;
  pageName?: InputMaybe<Scalars['String']['input']>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

export type MetaDataUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MetaDataUpdateManyInput;
  /** Document search */
  where: MetaDataWhereInput;
};

export type MetaDataUpdateOneInlineInput = {
  /** Connect existing MetaData document */
  connect?: InputMaybe<MetaDataWhereUniqueInput>;
  /** Create and connect one MetaData document */
  create?: InputMaybe<MetaDataCreateInput>;
  /** Delete currently connected MetaData document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected MetaData document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MetaData document */
  update?: InputMaybe<MetaDataUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MetaData document */
  upsert?: InputMaybe<MetaDataUpsertWithNestedWhereUniqueInput>;
};

export type MetaDataUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MetaDataUpdateInput;
  /** Unique document search */
  where: MetaDataWhereUniqueInput;
};

export type MetaDataUpsertInput = {
  /** Create document if it didn't exist */
  create: MetaDataCreateInput;
  /** Update document if it exists */
  update: MetaDataUpdateInput;
};

export type MetaDataUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MetaDataUpsertInput;
  /** Unique document search */
  where: MetaDataWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type MetaDataWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type MetaDataWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MetaDataWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MetaDataWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MetaDataWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<MetaDataWhereStageInput>;
  documentInStages_none?: InputMaybe<MetaDataWhereStageInput>;
  documentInStages_some?: InputMaybe<MetaDataWhereStageInput>;
  genericPage?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  images_every?: InputMaybe<AssetWhereInput>;
  images_none?: InputMaybe<AssetWhereInput>;
  images_some?: InputMaybe<AssetWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  openGraphType?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  openGraphType_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  openGraphType_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  openGraphType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  openGraphType_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  openGraphType_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  openGraphType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  openGraphType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  openGraphType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  openGraphType_starts_with?: InputMaybe<Scalars['String']['input']>;
  pageName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  pageName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  pageName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  pageName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  pageName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  pageName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  pageName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  pageName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  pageName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  pageName_starts_with?: InputMaybe<Scalars['String']['input']>;
  productCategoryPage?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPage?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPage?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipe?: InputMaybe<RecipeWhereInput>;
  recipeCategory?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPage?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategory?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sectionName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sectionName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sectionName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sectionName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sectionName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sectionName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sectionName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sectionName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sectionName_starts_with?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  theme_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  theme_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  theme_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  theme_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type MetaDataWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MetaDataWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MetaDataWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MetaDataWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<MetaDataWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References MetaData record uniquely */
export type MetaDataWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type MobileOnlyMainNavigation = Entity & Node & {
  __typename?: 'MobileOnlyMainNavigation';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<MobileOnlyMainNavigation>;
  /** List of MobileOnlyMainNavigation versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Unique Key  */
  key: Scalars['String']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** Mobile Primary Navigation Asset. The assets should be named either 'Foreground' or 'Background' in their CMS Asset Title field. Any deviation from those spellings and the images will not appear. */
  navigationAsset: Array<MobileOnlyMainNavigationNavigationAsset>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type MobileOnlyMainNavigationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MobileOnlyMainNavigationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type MobileOnlyMainNavigationHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type MobileOnlyMainNavigationMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MobileOnlyMainNavigationNavigationAssetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MobileOnlyMainNavigationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MobileOnlyMainNavigationScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type MobileOnlyMainNavigationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type MobileOnlyMainNavigationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MobileOnlyMainNavigationWhereUniqueInput;
};

/** A connection to a list of items. */
export type MobileOnlyMainNavigationConnection = {
  __typename?: 'MobileOnlyMainNavigationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MobileOnlyMainNavigationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MobileOnlyMainNavigationCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  key: Scalars['String']['input'];
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  navigationAsset?: InputMaybe<MobileOnlyMainNavigationNavigationAssetCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MobileOnlyMainNavigationCreateManyInlineInput = {
  /** Connect multiple existing MobileOnlyMainNavigation documents */
  connect?: InputMaybe<Array<MobileOnlyMainNavigationWhereUniqueInput>>;
  /** Create and connect multiple existing MobileOnlyMainNavigation documents */
  create?: InputMaybe<Array<MobileOnlyMainNavigationCreateInput>>;
};

export type MobileOnlyMainNavigationCreateOneInlineInput = {
  /** Connect one existing MobileOnlyMainNavigation document */
  connect?: InputMaybe<MobileOnlyMainNavigationWhereUniqueInput>;
  /** Create and connect one MobileOnlyMainNavigation document */
  create?: InputMaybe<MobileOnlyMainNavigationCreateInput>;
};

/** An edge in a connection. */
export type MobileOnlyMainNavigationEdge = {
  __typename?: 'MobileOnlyMainNavigationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MobileOnlyMainNavigation;
};

/** Identifies documents */
export type MobileOnlyMainNavigationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MobileOnlyMainNavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MobileOnlyMainNavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MobileOnlyMainNavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MobileOnlyMainNavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<MobileOnlyMainNavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<MobileOnlyMainNavigationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** All values in which the union is empty */
  navigationAsset_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  navigationAsset_some?: InputMaybe<MobileOnlyMainNavigationNavigationAssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type MobileOnlyMainNavigationNavigationAsset = AssetComponent;

export type MobileOnlyMainNavigationNavigationAssetConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type MobileOnlyMainNavigationNavigationAssetCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type MobileOnlyMainNavigationNavigationAssetCreateManyInlineInput = {
  /** Connect multiple existing MobileOnlyMainNavigationNavigationAsset documents */
  connect?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetWhereUniqueInput>>;
  /** Create and connect multiple existing MobileOnlyMainNavigationNavigationAsset documents */
  create?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetCreateInput>>;
};

export type MobileOnlyMainNavigationNavigationAssetCreateOneInlineInput = {
  /** Connect one existing MobileOnlyMainNavigationNavigationAsset document */
  connect?: InputMaybe<MobileOnlyMainNavigationNavigationAssetWhereUniqueInput>;
  /** Create and connect one MobileOnlyMainNavigationNavigationAsset document */
  create?: InputMaybe<MobileOnlyMainNavigationNavigationAssetCreateInput>;
};

export type MobileOnlyMainNavigationNavigationAssetUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type MobileOnlyMainNavigationNavigationAssetUpdateManyInlineInput = {
  /** Connect multiple existing MobileOnlyMainNavigationNavigationAsset documents */
  connect?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetConnectInput>>;
  /** Create and connect multiple MobileOnlyMainNavigationNavigationAsset documents */
  create?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetCreateInput>>;
  /** Delete multiple MobileOnlyMainNavigationNavigationAsset documents */
  delete?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetWhereUniqueInput>>;
  /** Disconnect multiple MobileOnlyMainNavigationNavigationAsset documents */
  disconnect?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing MobileOnlyMainNavigationNavigationAsset documents */
  set?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetWhereUniqueInput>>;
  /** Update multiple MobileOnlyMainNavigationNavigationAsset documents */
  update?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple MobileOnlyMainNavigationNavigationAsset documents */
  upsert?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetUpsertWithNestedWhereUniqueInput>>;
};

export type MobileOnlyMainNavigationNavigationAssetUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type MobileOnlyMainNavigationNavigationAssetUpdateOneInlineInput = {
  /** Connect existing MobileOnlyMainNavigationNavigationAsset document */
  connect?: InputMaybe<MobileOnlyMainNavigationNavigationAssetWhereUniqueInput>;
  /** Create and connect one MobileOnlyMainNavigationNavigationAsset document */
  create?: InputMaybe<MobileOnlyMainNavigationNavigationAssetCreateInput>;
  /** Delete currently connected MobileOnlyMainNavigationNavigationAsset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected MobileOnlyMainNavigationNavigationAsset document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MobileOnlyMainNavigationNavigationAsset document */
  update?: InputMaybe<MobileOnlyMainNavigationNavigationAssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MobileOnlyMainNavigationNavigationAsset document */
  upsert?: InputMaybe<MobileOnlyMainNavigationNavigationAssetUpsertWithNestedWhereUniqueInput>;
};

export type MobileOnlyMainNavigationNavigationAssetUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type MobileOnlyMainNavigationNavigationAssetUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type MobileOnlyMainNavigationNavigationAssetWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type MobileOnlyMainNavigationNavigationAssetWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

export enum MobileOnlyMainNavigationOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  key_ASC = 'key_ASC',
  key_DESC = 'key_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type MobileOnlyMainNavigationUpdateInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  navigationAsset?: InputMaybe<MobileOnlyMainNavigationNavigationAssetUpdateManyInlineInput>;
};

export type MobileOnlyMainNavigationUpdateManyInlineInput = {
  /** Connect multiple existing MobileOnlyMainNavigation documents */
  connect?: InputMaybe<Array<MobileOnlyMainNavigationConnectInput>>;
  /** Create and connect multiple MobileOnlyMainNavigation documents */
  create?: InputMaybe<Array<MobileOnlyMainNavigationCreateInput>>;
  /** Delete multiple MobileOnlyMainNavigation documents */
  delete?: InputMaybe<Array<MobileOnlyMainNavigationWhereUniqueInput>>;
  /** Disconnect multiple MobileOnlyMainNavigation documents */
  disconnect?: InputMaybe<Array<MobileOnlyMainNavigationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing MobileOnlyMainNavigation documents */
  set?: InputMaybe<Array<MobileOnlyMainNavigationWhereUniqueInput>>;
  /** Update multiple MobileOnlyMainNavigation documents */
  update?: InputMaybe<Array<MobileOnlyMainNavigationUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple MobileOnlyMainNavigation documents */
  upsert?: InputMaybe<Array<MobileOnlyMainNavigationUpsertWithNestedWhereUniqueInput>>;
};

export type MobileOnlyMainNavigationUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type MobileOnlyMainNavigationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MobileOnlyMainNavigationUpdateManyInput;
  /** Document search */
  where: MobileOnlyMainNavigationWhereInput;
};

export type MobileOnlyMainNavigationUpdateOneInlineInput = {
  /** Connect existing MobileOnlyMainNavigation document */
  connect?: InputMaybe<MobileOnlyMainNavigationWhereUniqueInput>;
  /** Create and connect one MobileOnlyMainNavigation document */
  create?: InputMaybe<MobileOnlyMainNavigationCreateInput>;
  /** Delete currently connected MobileOnlyMainNavigation document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected MobileOnlyMainNavigation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MobileOnlyMainNavigation document */
  update?: InputMaybe<MobileOnlyMainNavigationUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MobileOnlyMainNavigation document */
  upsert?: InputMaybe<MobileOnlyMainNavigationUpsertWithNestedWhereUniqueInput>;
};

export type MobileOnlyMainNavigationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MobileOnlyMainNavigationUpdateInput;
  /** Unique document search */
  where: MobileOnlyMainNavigationWhereUniqueInput;
};

export type MobileOnlyMainNavigationUpsertInput = {
  /** Create document if it didn't exist */
  create: MobileOnlyMainNavigationCreateInput;
  /** Update document if it exists */
  update: MobileOnlyMainNavigationUpdateInput;
};

export type MobileOnlyMainNavigationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MobileOnlyMainNavigationUpsertInput;
  /** Unique document search */
  where: MobileOnlyMainNavigationWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type MobileOnlyMainNavigationWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type MobileOnlyMainNavigationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MobileOnlyMainNavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MobileOnlyMainNavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MobileOnlyMainNavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MobileOnlyMainNavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<MobileOnlyMainNavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<MobileOnlyMainNavigationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** All values in which the union is empty */
  navigationAsset_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  navigationAsset_some?: InputMaybe<MobileOnlyMainNavigationNavigationAssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type MobileOnlyMainNavigationWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MobileOnlyMainNavigationWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MobileOnlyMainNavigationWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MobileOnlyMainNavigationWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<MobileOnlyMainNavigationWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References MobileOnlyMainNavigation record uniquely */
export type MobileOnlyMainNavigationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
};

export type MultiStepPromotionForm = Entity & Node & {
  __typename?: 'MultiStepPromotionForm';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<MultiStepPromotionForm>;
  /** Footerlinks are displayed at the bottom of the Multi Step Form Component. Can be used to add Links to e.g. "Terms of Conditions" etc. */
  footerLinks: Array<Link>;
  genericPages: Array<GenericPage>;
  /** List of MultiStepPromotionForm versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** Optional download component which is shown after the form was successfully submitted */
  promotionDownload?: Maybe<PromotionDownload>;
  promotionForm?: Maybe<PromotionForm>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** If set to true, only the download button will be shown and no from. It's still required to add a promotion form, so that tracking is working properly  */
  showOnlyDownloadButton?: Maybe<Scalars['Boolean']['output']>;
  /** System stage field */
  stage: Stage;
  /** Steps are displayed in the Frontend before the Promotion Form. */
  steps: Array<MultiStepPromotionFormStep>;
  /** The Title is only used to display the reference value in Hygraph. It is not visible to the User in the Frontend. */
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type MultiStepPromotionFormCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MultiStepPromotionFormDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type MultiStepPromotionFormFooterLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


export type MultiStepPromotionFormGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type MultiStepPromotionFormHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type MultiStepPromotionFormProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


export type MultiStepPromotionFormPromotionDownloadArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MultiStepPromotionFormPromotionFormArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MultiStepPromotionFormPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MultiStepPromotionFormScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type MultiStepPromotionFormStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<MultiStepPromotionFormStepOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MultiStepPromotionFormStepWhereInput>;
};


export type MultiStepPromotionFormUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type MultiStepPromotionFormCheckboxes = Entity & {
  __typename?: 'MultiStepPromotionFormCheckboxes';
  checkboxes: Array<FormOption>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** The Title is only used to be passed as "question" to Salesforce and is not visible to the User in the Frontend. */
  title: Scalars['String']['output'];
};


export type MultiStepPromotionFormCheckboxesCheckboxesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormOptionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormOptionWhereInput>;
};

export type MultiStepPromotionFormCheckboxesConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MultiStepPromotionFormCheckboxesWhereUniqueInput;
};

/** A connection to a list of items. */
export type MultiStepPromotionFormCheckboxesConnection = {
  __typename?: 'MultiStepPromotionFormCheckboxesConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MultiStepPromotionFormCheckboxesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MultiStepPromotionFormCheckboxesCreateInput = {
  checkboxes?: InputMaybe<FormOptionCreateManyInlineInput>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type MultiStepPromotionFormCheckboxesCreateManyInlineInput = {
  /** Create and connect multiple existing MultiStepPromotionFormCheckboxes documents */
  create?: InputMaybe<Array<MultiStepPromotionFormCheckboxesCreateInput>>;
};

export type MultiStepPromotionFormCheckboxesCreateOneInlineInput = {
  /** Create and connect one MultiStepPromotionFormCheckboxes document */
  create?: InputMaybe<MultiStepPromotionFormCheckboxesCreateInput>;
};

export type MultiStepPromotionFormCheckboxesCreateWithPositionInput = {
  /** Document to create */
  data: MultiStepPromotionFormCheckboxesCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type MultiStepPromotionFormCheckboxesEdge = {
  __typename?: 'MultiStepPromotionFormCheckboxesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MultiStepPromotionFormCheckboxes;
};

/** Identifies documents */
export type MultiStepPromotionFormCheckboxesManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MultiStepPromotionFormCheckboxesWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MultiStepPromotionFormCheckboxesWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MultiStepPromotionFormCheckboxesWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  checkboxes_every?: InputMaybe<FormOptionWhereInput>;
  checkboxes_none?: InputMaybe<FormOptionWhereInput>;
  checkboxes_some?: InputMaybe<FormOptionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum MultiStepPromotionFormCheckboxesOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC'
}

export type MultiStepPromotionFormCheckboxesParent = MultiStepPromotionFormStep;

export type MultiStepPromotionFormCheckboxesParentConnectInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepConnectInput>;
};

export type MultiStepPromotionFormCheckboxesParentCreateInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepCreateInput>;
};

export type MultiStepPromotionFormCheckboxesParentCreateManyInlineInput = {
  /** Create and connect multiple existing MultiStepPromotionFormCheckboxesParent documents */
  create?: InputMaybe<Array<MultiStepPromotionFormCheckboxesParentCreateInput>>;
};

export type MultiStepPromotionFormCheckboxesParentCreateOneInlineInput = {
  /** Create and connect one MultiStepPromotionFormCheckboxesParent document */
  create?: InputMaybe<MultiStepPromotionFormCheckboxesParentCreateInput>;
};

export type MultiStepPromotionFormCheckboxesParentCreateWithPositionInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepCreateWithPositionInput>;
};

export type MultiStepPromotionFormCheckboxesParentUpdateInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepUpdateInput>;
};

export type MultiStepPromotionFormCheckboxesParentUpdateManyInlineInput = {
  /** Create and connect multiple MultiStepPromotionFormCheckboxesParent component instances */
  create?: InputMaybe<Array<MultiStepPromotionFormCheckboxesParentCreateWithPositionInput>>;
  /** Delete multiple MultiStepPromotionFormCheckboxesParent documents */
  delete?: InputMaybe<Array<MultiStepPromotionFormCheckboxesParentWhereUniqueInput>>;
  /** Update multiple MultiStepPromotionFormCheckboxesParent component instances */
  update?: InputMaybe<Array<MultiStepPromotionFormCheckboxesParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple MultiStepPromotionFormCheckboxesParent component instances */
  upsert?: InputMaybe<Array<MultiStepPromotionFormCheckboxesParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type MultiStepPromotionFormCheckboxesParentUpdateManyWithNestedWhereInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepUpdateManyWithNestedWhereInput>;
};

export type MultiStepPromotionFormCheckboxesParentUpdateOneInlineInput = {
  /** Create and connect one MultiStepPromotionFormCheckboxesParent document */
  create?: InputMaybe<MultiStepPromotionFormCheckboxesParentCreateInput>;
  /** Delete currently connected MultiStepPromotionFormCheckboxesParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MultiStepPromotionFormCheckboxesParent document */
  update?: InputMaybe<MultiStepPromotionFormCheckboxesParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MultiStepPromotionFormCheckboxesParent document */
  upsert?: InputMaybe<MultiStepPromotionFormCheckboxesParentUpsertWithNestedWhereUniqueInput>;
};

export type MultiStepPromotionFormCheckboxesParentUpdateWithNestedWhereUniqueAndPositionInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type MultiStepPromotionFormCheckboxesParentUpdateWithNestedWhereUniqueInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepUpdateWithNestedWhereUniqueInput>;
};

export type MultiStepPromotionFormCheckboxesParentUpsertWithNestedWhereUniqueAndPositionInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type MultiStepPromotionFormCheckboxesParentUpsertWithNestedWhereUniqueInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepUpsertWithNestedWhereUniqueInput>;
};

export type MultiStepPromotionFormCheckboxesParentWhereInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepWhereInput>;
};

export type MultiStepPromotionFormCheckboxesParentWhereUniqueInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepWhereUniqueInput>;
};

export type MultiStepPromotionFormCheckboxesUpdateInput = {
  checkboxes?: InputMaybe<FormOptionUpdateManyInlineInput>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MultiStepPromotionFormCheckboxesUpdateManyInlineInput = {
  /** Create and connect multiple MultiStepPromotionFormCheckboxes component instances */
  create?: InputMaybe<Array<MultiStepPromotionFormCheckboxesCreateWithPositionInput>>;
  /** Delete multiple MultiStepPromotionFormCheckboxes documents */
  delete?: InputMaybe<Array<MultiStepPromotionFormCheckboxesWhereUniqueInput>>;
  /** Update multiple MultiStepPromotionFormCheckboxes component instances */
  update?: InputMaybe<Array<MultiStepPromotionFormCheckboxesUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple MultiStepPromotionFormCheckboxes component instances */
  upsert?: InputMaybe<Array<MultiStepPromotionFormCheckboxesUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type MultiStepPromotionFormCheckboxesUpdateManyInput = {
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MultiStepPromotionFormCheckboxesUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MultiStepPromotionFormCheckboxesUpdateManyInput;
  /** Document search */
  where: MultiStepPromotionFormCheckboxesWhereInput;
};

export type MultiStepPromotionFormCheckboxesUpdateOneInlineInput = {
  /** Create and connect one MultiStepPromotionFormCheckboxes document */
  create?: InputMaybe<MultiStepPromotionFormCheckboxesCreateInput>;
  /** Delete currently connected MultiStepPromotionFormCheckboxes document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MultiStepPromotionFormCheckboxes document */
  update?: InputMaybe<MultiStepPromotionFormCheckboxesUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MultiStepPromotionFormCheckboxes document */
  upsert?: InputMaybe<MultiStepPromotionFormCheckboxesUpsertWithNestedWhereUniqueInput>;
};

export type MultiStepPromotionFormCheckboxesUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<MultiStepPromotionFormCheckboxesUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: MultiStepPromotionFormCheckboxesWhereUniqueInput;
};

export type MultiStepPromotionFormCheckboxesUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MultiStepPromotionFormCheckboxesUpdateInput;
  /** Unique document search */
  where: MultiStepPromotionFormCheckboxesWhereUniqueInput;
};

export type MultiStepPromotionFormCheckboxesUpsertInput = {
  /** Create document if it didn't exist */
  create: MultiStepPromotionFormCheckboxesCreateInput;
  /** Update document if it exists */
  update: MultiStepPromotionFormCheckboxesUpdateInput;
};

export type MultiStepPromotionFormCheckboxesUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<MultiStepPromotionFormCheckboxesUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: MultiStepPromotionFormCheckboxesWhereUniqueInput;
};

export type MultiStepPromotionFormCheckboxesUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MultiStepPromotionFormCheckboxesUpsertInput;
  /** Unique document search */
  where: MultiStepPromotionFormCheckboxesWhereUniqueInput;
};

/** Identifies documents */
export type MultiStepPromotionFormCheckboxesWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MultiStepPromotionFormCheckboxesWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MultiStepPromotionFormCheckboxesWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MultiStepPromotionFormCheckboxesWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  checkboxes_every?: InputMaybe<FormOptionWhereInput>;
  checkboxes_none?: InputMaybe<FormOptionWhereInput>;
  checkboxes_some?: InputMaybe<FormOptionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References MultiStepPromotionFormCheckboxes record uniquely */
export type MultiStepPromotionFormCheckboxesWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type MultiStepPromotionFormConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MultiStepPromotionFormWhereUniqueInput;
};

/** A connection to a list of items. */
export type MultiStepPromotionFormConnection = {
  __typename?: 'MultiStepPromotionFormConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MultiStepPromotionFormEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MultiStepPromotionFormCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  footerLinks?: InputMaybe<LinkCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  promotionDownload?: InputMaybe<PromotionDownloadCreateOneInlineInput>;
  promotionForm?: InputMaybe<PromotionFormCreateOneInlineInput>;
  showOnlyDownloadButton?: InputMaybe<Scalars['Boolean']['input']>;
  steps?: InputMaybe<MultiStepPromotionFormStepCreateManyInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MultiStepPromotionFormCreateManyInlineInput = {
  /** Connect multiple existing MultiStepPromotionForm documents */
  connect?: InputMaybe<Array<MultiStepPromotionFormWhereUniqueInput>>;
  /** Create and connect multiple existing MultiStepPromotionForm documents */
  create?: InputMaybe<Array<MultiStepPromotionFormCreateInput>>;
};

export type MultiStepPromotionFormCreateOneInlineInput = {
  /** Connect one existing MultiStepPromotionForm document */
  connect?: InputMaybe<MultiStepPromotionFormWhereUniqueInput>;
  /** Create and connect one MultiStepPromotionForm document */
  create?: InputMaybe<MultiStepPromotionFormCreateInput>;
};

/** An edge in a connection. */
export type MultiStepPromotionFormEdge = {
  __typename?: 'MultiStepPromotionFormEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MultiStepPromotionForm;
};

/** Identifies documents */
export type MultiStepPromotionFormManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MultiStepPromotionFormWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MultiStepPromotionFormWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MultiStepPromotionFormWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MultiStepPromotionFormWhereStageInput>;
  documentInStages_none?: InputMaybe<MultiStepPromotionFormWhereStageInput>;
  documentInStages_some?: InputMaybe<MultiStepPromotionFormWhereStageInput>;
  footerLinks_every?: InputMaybe<LinkWhereInput>;
  footerLinks_none?: InputMaybe<LinkWhereInput>;
  footerLinks_some?: InputMaybe<LinkWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  promotionDownload?: InputMaybe<PromotionDownloadWhereInput>;
  promotionForm?: InputMaybe<PromotionFormWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showOnlyDownloadButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showOnlyDownloadButton_not?: InputMaybe<Scalars['Boolean']['input']>;
  steps_every?: InputMaybe<MultiStepPromotionFormStepWhereInput>;
  steps_none?: InputMaybe<MultiStepPromotionFormStepWhereInput>;
  steps_some?: InputMaybe<MultiStepPromotionFormStepWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum MultiStepPromotionFormOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  showOnlyDownloadButton_ASC = 'showOnlyDownloadButton_ASC',
  showOnlyDownloadButton_DESC = 'showOnlyDownloadButton_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type MultiStepPromotionFormRadio = Entity & {
  __typename?: 'MultiStepPromotionFormRadio';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  radios: Array<FormOption>;
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** The Title is only used to be passed as "question" to Salesforce and is not visible to the User in the Frontend. */
  title: Scalars['String']['output'];
};


export type MultiStepPromotionFormRadioRadiosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormOptionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormOptionWhereInput>;
};

export type MultiStepPromotionFormRadioConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MultiStepPromotionFormRadioWhereUniqueInput;
};

/** A connection to a list of items. */
export type MultiStepPromotionFormRadioConnection = {
  __typename?: 'MultiStepPromotionFormRadioConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MultiStepPromotionFormRadioEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MultiStepPromotionFormRadioCreateInput = {
  radios?: InputMaybe<FormOptionCreateManyInlineInput>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type MultiStepPromotionFormRadioCreateManyInlineInput = {
  /** Create and connect multiple existing MultiStepPromotionFormRadio documents */
  create?: InputMaybe<Array<MultiStepPromotionFormRadioCreateInput>>;
};

export type MultiStepPromotionFormRadioCreateOneInlineInput = {
  /** Create and connect one MultiStepPromotionFormRadio document */
  create?: InputMaybe<MultiStepPromotionFormRadioCreateInput>;
};

export type MultiStepPromotionFormRadioCreateWithPositionInput = {
  /** Document to create */
  data: MultiStepPromotionFormRadioCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type MultiStepPromotionFormRadioEdge = {
  __typename?: 'MultiStepPromotionFormRadioEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MultiStepPromotionFormRadio;
};

/** Identifies documents */
export type MultiStepPromotionFormRadioManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MultiStepPromotionFormRadioWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MultiStepPromotionFormRadioWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MultiStepPromotionFormRadioWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  radios_every?: InputMaybe<FormOptionWhereInput>;
  radios_none?: InputMaybe<FormOptionWhereInput>;
  radios_some?: InputMaybe<FormOptionWhereInput>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum MultiStepPromotionFormRadioOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC'
}

export type MultiStepPromotionFormRadioParent = MultiStepPromotionFormStep;

export type MultiStepPromotionFormRadioParentConnectInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepConnectInput>;
};

export type MultiStepPromotionFormRadioParentCreateInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepCreateInput>;
};

export type MultiStepPromotionFormRadioParentCreateManyInlineInput = {
  /** Create and connect multiple existing MultiStepPromotionFormRadioParent documents */
  create?: InputMaybe<Array<MultiStepPromotionFormRadioParentCreateInput>>;
};

export type MultiStepPromotionFormRadioParentCreateOneInlineInput = {
  /** Create and connect one MultiStepPromotionFormRadioParent document */
  create?: InputMaybe<MultiStepPromotionFormRadioParentCreateInput>;
};

export type MultiStepPromotionFormRadioParentCreateWithPositionInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepCreateWithPositionInput>;
};

export type MultiStepPromotionFormRadioParentUpdateInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepUpdateInput>;
};

export type MultiStepPromotionFormRadioParentUpdateManyInlineInput = {
  /** Create and connect multiple MultiStepPromotionFormRadioParent component instances */
  create?: InputMaybe<Array<MultiStepPromotionFormRadioParentCreateWithPositionInput>>;
  /** Delete multiple MultiStepPromotionFormRadioParent documents */
  delete?: InputMaybe<Array<MultiStepPromotionFormRadioParentWhereUniqueInput>>;
  /** Update multiple MultiStepPromotionFormRadioParent component instances */
  update?: InputMaybe<Array<MultiStepPromotionFormRadioParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple MultiStepPromotionFormRadioParent component instances */
  upsert?: InputMaybe<Array<MultiStepPromotionFormRadioParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type MultiStepPromotionFormRadioParentUpdateManyWithNestedWhereInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepUpdateManyWithNestedWhereInput>;
};

export type MultiStepPromotionFormRadioParentUpdateOneInlineInput = {
  /** Create and connect one MultiStepPromotionFormRadioParent document */
  create?: InputMaybe<MultiStepPromotionFormRadioParentCreateInput>;
  /** Delete currently connected MultiStepPromotionFormRadioParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MultiStepPromotionFormRadioParent document */
  update?: InputMaybe<MultiStepPromotionFormRadioParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MultiStepPromotionFormRadioParent document */
  upsert?: InputMaybe<MultiStepPromotionFormRadioParentUpsertWithNestedWhereUniqueInput>;
};

export type MultiStepPromotionFormRadioParentUpdateWithNestedWhereUniqueAndPositionInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type MultiStepPromotionFormRadioParentUpdateWithNestedWhereUniqueInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepUpdateWithNestedWhereUniqueInput>;
};

export type MultiStepPromotionFormRadioParentUpsertWithNestedWhereUniqueAndPositionInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type MultiStepPromotionFormRadioParentUpsertWithNestedWhereUniqueInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepUpsertWithNestedWhereUniqueInput>;
};

export type MultiStepPromotionFormRadioParentWhereInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepWhereInput>;
};

export type MultiStepPromotionFormRadioParentWhereUniqueInput = {
  MultiStepPromotionFormStep?: InputMaybe<MultiStepPromotionFormStepWhereUniqueInput>;
};

export type MultiStepPromotionFormRadioUpdateInput = {
  radios?: InputMaybe<FormOptionUpdateManyInlineInput>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MultiStepPromotionFormRadioUpdateManyInlineInput = {
  /** Create and connect multiple MultiStepPromotionFormRadio component instances */
  create?: InputMaybe<Array<MultiStepPromotionFormRadioCreateWithPositionInput>>;
  /** Delete multiple MultiStepPromotionFormRadio documents */
  delete?: InputMaybe<Array<MultiStepPromotionFormRadioWhereUniqueInput>>;
  /** Update multiple MultiStepPromotionFormRadio component instances */
  update?: InputMaybe<Array<MultiStepPromotionFormRadioUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple MultiStepPromotionFormRadio component instances */
  upsert?: InputMaybe<Array<MultiStepPromotionFormRadioUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type MultiStepPromotionFormRadioUpdateManyInput = {
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MultiStepPromotionFormRadioUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MultiStepPromotionFormRadioUpdateManyInput;
  /** Document search */
  where: MultiStepPromotionFormRadioWhereInput;
};

export type MultiStepPromotionFormRadioUpdateOneInlineInput = {
  /** Create and connect one MultiStepPromotionFormRadio document */
  create?: InputMaybe<MultiStepPromotionFormRadioCreateInput>;
  /** Delete currently connected MultiStepPromotionFormRadio document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MultiStepPromotionFormRadio document */
  update?: InputMaybe<MultiStepPromotionFormRadioUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MultiStepPromotionFormRadio document */
  upsert?: InputMaybe<MultiStepPromotionFormRadioUpsertWithNestedWhereUniqueInput>;
};

export type MultiStepPromotionFormRadioUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<MultiStepPromotionFormRadioUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: MultiStepPromotionFormRadioWhereUniqueInput;
};

export type MultiStepPromotionFormRadioUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MultiStepPromotionFormRadioUpdateInput;
  /** Unique document search */
  where: MultiStepPromotionFormRadioWhereUniqueInput;
};

export type MultiStepPromotionFormRadioUpsertInput = {
  /** Create document if it didn't exist */
  create: MultiStepPromotionFormRadioCreateInput;
  /** Update document if it exists */
  update: MultiStepPromotionFormRadioUpdateInput;
};

export type MultiStepPromotionFormRadioUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<MultiStepPromotionFormRadioUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: MultiStepPromotionFormRadioWhereUniqueInput;
};

export type MultiStepPromotionFormRadioUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MultiStepPromotionFormRadioUpsertInput;
  /** Unique document search */
  where: MultiStepPromotionFormRadioWhereUniqueInput;
};

/** Identifies documents */
export type MultiStepPromotionFormRadioWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MultiStepPromotionFormRadioWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MultiStepPromotionFormRadioWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MultiStepPromotionFormRadioWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  radios_every?: InputMaybe<FormOptionWhereInput>;
  radios_none?: InputMaybe<FormOptionWhereInput>;
  radios_some?: InputMaybe<FormOptionWhereInput>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References MultiStepPromotionFormRadio record uniquely */
export type MultiStepPromotionFormRadioWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type MultiStepPromotionFormStep = Entity & {
  __typename?: 'MultiStepPromotionFormStep';
  description?: Maybe<Scalars['String']['output']>;
  formField?: Maybe<MultiStepPromotionFormStepformFieldUnion>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** optimal size: 400x320 */
  image: Asset;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
};


export type MultiStepPromotionFormStepFormFieldArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MultiStepPromotionFormStepImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type MultiStepPromotionFormStepConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MultiStepPromotionFormStepWhereUniqueInput;
};

/** A connection to a list of items. */
export type MultiStepPromotionFormStepConnection = {
  __typename?: 'MultiStepPromotionFormStepConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MultiStepPromotionFormStepEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MultiStepPromotionFormStepCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  formField?: InputMaybe<MultiStepPromotionFormStepformFieldUnionCreateOneInlineInput>;
  image: AssetCreateOneInlineInput;
  title: Scalars['String']['input'];
};

export type MultiStepPromotionFormStepCreateManyInlineInput = {
  /** Create and connect multiple existing MultiStepPromotionFormStep documents */
  create?: InputMaybe<Array<MultiStepPromotionFormStepCreateInput>>;
};

export type MultiStepPromotionFormStepCreateOneInlineInput = {
  /** Create and connect one MultiStepPromotionFormStep document */
  create?: InputMaybe<MultiStepPromotionFormStepCreateInput>;
};

export type MultiStepPromotionFormStepCreateWithPositionInput = {
  /** Document to create */
  data: MultiStepPromotionFormStepCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type MultiStepPromotionFormStepEdge = {
  __typename?: 'MultiStepPromotionFormStepEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MultiStepPromotionFormStep;
};

/** Identifies documents */
export type MultiStepPromotionFormStepManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MultiStepPromotionFormStepWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MultiStepPromotionFormStepWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MultiStepPromotionFormStepWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the modular component is connected to the given models */
  formField?: InputMaybe<MultiStepPromotionFormStepformFieldUnionWhereInput>;
  /** All values in which the union is empty. */
  formField_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum MultiStepPromotionFormStepOrderByInput {
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC'
}

export type MultiStepPromotionFormStepParent = MultiStepPromotionForm;

export type MultiStepPromotionFormStepParentConnectInput = {
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormConnectInput>;
};

export type MultiStepPromotionFormStepParentCreateInput = {
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormCreateInput>;
};

export type MultiStepPromotionFormStepParentCreateManyInlineInput = {
  /** Connect multiple existing MultiStepPromotionFormStepParent documents */
  connect?: InputMaybe<Array<MultiStepPromotionFormStepParentWhereUniqueInput>>;
  /** Create and connect multiple existing MultiStepPromotionFormStepParent documents */
  create?: InputMaybe<Array<MultiStepPromotionFormStepParentCreateInput>>;
};

export type MultiStepPromotionFormStepParentCreateOneInlineInput = {
  /** Connect one existing MultiStepPromotionFormStepParent document */
  connect?: InputMaybe<MultiStepPromotionFormStepParentWhereUniqueInput>;
  /** Create and connect one MultiStepPromotionFormStepParent document */
  create?: InputMaybe<MultiStepPromotionFormStepParentCreateInput>;
};

export type MultiStepPromotionFormStepParentUpdateInput = {
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormUpdateInput>;
};

export type MultiStepPromotionFormStepParentUpdateManyInlineInput = {
  /** Connect multiple existing MultiStepPromotionFormStepParent documents */
  connect?: InputMaybe<Array<MultiStepPromotionFormStepParentConnectInput>>;
  /** Create and connect multiple MultiStepPromotionFormStepParent documents */
  create?: InputMaybe<Array<MultiStepPromotionFormStepParentCreateInput>>;
  /** Delete multiple MultiStepPromotionFormStepParent documents */
  delete?: InputMaybe<Array<MultiStepPromotionFormStepParentWhereUniqueInput>>;
  /** Disconnect multiple MultiStepPromotionFormStepParent documents */
  disconnect?: InputMaybe<Array<MultiStepPromotionFormStepParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing MultiStepPromotionFormStepParent documents */
  set?: InputMaybe<Array<MultiStepPromotionFormStepParentWhereUniqueInput>>;
  /** Update multiple MultiStepPromotionFormStepParent documents */
  update?: InputMaybe<Array<MultiStepPromotionFormStepParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple MultiStepPromotionFormStepParent documents */
  upsert?: InputMaybe<Array<MultiStepPromotionFormStepParentUpsertWithNestedWhereUniqueInput>>;
};

export type MultiStepPromotionFormStepParentUpdateManyWithNestedWhereInput = {
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormUpdateManyWithNestedWhereInput>;
};

export type MultiStepPromotionFormStepParentUpdateOneInlineInput = {
  /** Connect existing MultiStepPromotionFormStepParent document */
  connect?: InputMaybe<MultiStepPromotionFormStepParentWhereUniqueInput>;
  /** Create and connect one MultiStepPromotionFormStepParent document */
  create?: InputMaybe<MultiStepPromotionFormStepParentCreateInput>;
  /** Delete currently connected MultiStepPromotionFormStepParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected MultiStepPromotionFormStepParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MultiStepPromotionFormStepParent document */
  update?: InputMaybe<MultiStepPromotionFormStepParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MultiStepPromotionFormStepParent document */
  upsert?: InputMaybe<MultiStepPromotionFormStepParentUpsertWithNestedWhereUniqueInput>;
};

export type MultiStepPromotionFormStepParentUpdateWithNestedWhereUniqueInput = {
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormUpdateWithNestedWhereUniqueInput>;
};

export type MultiStepPromotionFormStepParentUpsertWithNestedWhereUniqueInput = {
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormUpsertWithNestedWhereUniqueInput>;
};

export type MultiStepPromotionFormStepParentWhereInput = {
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormWhereInput>;
};

export type MultiStepPromotionFormStepParentWhereUniqueInput = {
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormWhereUniqueInput>;
};

export type MultiStepPromotionFormStepUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  formField?: InputMaybe<MultiStepPromotionFormStepformFieldUnionUpdateOneInlineInput>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MultiStepPromotionFormStepUpdateManyInlineInput = {
  /** Create and connect multiple MultiStepPromotionFormStep component instances */
  create?: InputMaybe<Array<MultiStepPromotionFormStepCreateWithPositionInput>>;
  /** Delete multiple MultiStepPromotionFormStep documents */
  delete?: InputMaybe<Array<MultiStepPromotionFormStepWhereUniqueInput>>;
  /** Update multiple MultiStepPromotionFormStep component instances */
  update?: InputMaybe<Array<MultiStepPromotionFormStepUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple MultiStepPromotionFormStep component instances */
  upsert?: InputMaybe<Array<MultiStepPromotionFormStepUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type MultiStepPromotionFormStepUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MultiStepPromotionFormStepUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MultiStepPromotionFormStepUpdateManyInput;
  /** Document search */
  where: MultiStepPromotionFormStepWhereInput;
};

export type MultiStepPromotionFormStepUpdateOneInlineInput = {
  /** Create and connect one MultiStepPromotionFormStep document */
  create?: InputMaybe<MultiStepPromotionFormStepCreateInput>;
  /** Delete currently connected MultiStepPromotionFormStep document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MultiStepPromotionFormStep document */
  update?: InputMaybe<MultiStepPromotionFormStepUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MultiStepPromotionFormStep document */
  upsert?: InputMaybe<MultiStepPromotionFormStepUpsertWithNestedWhereUniqueInput>;
};

export type MultiStepPromotionFormStepUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<MultiStepPromotionFormStepUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: MultiStepPromotionFormStepWhereUniqueInput;
};

export type MultiStepPromotionFormStepUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MultiStepPromotionFormStepUpdateInput;
  /** Unique document search */
  where: MultiStepPromotionFormStepWhereUniqueInput;
};

export type MultiStepPromotionFormStepUpsertInput = {
  /** Create document if it didn't exist */
  create: MultiStepPromotionFormStepCreateInput;
  /** Update document if it exists */
  update: MultiStepPromotionFormStepUpdateInput;
};

export type MultiStepPromotionFormStepUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<MultiStepPromotionFormStepUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: MultiStepPromotionFormStepWhereUniqueInput;
};

export type MultiStepPromotionFormStepUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MultiStepPromotionFormStepUpsertInput;
  /** Unique document search */
  where: MultiStepPromotionFormStepWhereUniqueInput;
};

/** Identifies documents */
export type MultiStepPromotionFormStepWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MultiStepPromotionFormStepWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MultiStepPromotionFormStepWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MultiStepPromotionFormStepWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the modular component is connected to the given models */
  formField?: InputMaybe<MultiStepPromotionFormStepformFieldUnionWhereInput>;
  /** All values in which the union is empty. */
  formField_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References MultiStepPromotionFormStep record uniquely */
export type MultiStepPromotionFormStepWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type MultiStepPromotionFormStepformFieldUnion = MultiStepPromotionFormCheckboxes | MultiStepPromotionFormRadio;

export type MultiStepPromotionFormStepformFieldUnionConnectInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesConnectInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioConnectInput>;
};

export type MultiStepPromotionFormStepformFieldUnionCreateInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesCreateInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioCreateInput>;
};

export type MultiStepPromotionFormStepformFieldUnionCreateManyInlineInput = {
  /** Create and connect multiple existing MultiStepPromotionFormStepformFieldUnion documents */
  create?: InputMaybe<Array<MultiStepPromotionFormStepformFieldUnionCreateInput>>;
};

export type MultiStepPromotionFormStepformFieldUnionCreateOneInlineInput = {
  /** Create and connect one MultiStepPromotionFormStepformFieldUnion document */
  create?: InputMaybe<MultiStepPromotionFormStepformFieldUnionCreateInput>;
};

export type MultiStepPromotionFormStepformFieldUnionCreateWithPositionInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesCreateWithPositionInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioCreateWithPositionInput>;
};

export type MultiStepPromotionFormStepformFieldUnionUpdateInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesUpdateInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioUpdateInput>;
};

export type MultiStepPromotionFormStepformFieldUnionUpdateManyInlineInput = {
  /** Create and connect multiple MultiStepPromotionFormStepformFieldUnion component instances */
  create?: InputMaybe<Array<MultiStepPromotionFormStepformFieldUnionCreateWithPositionInput>>;
  /** Delete multiple MultiStepPromotionFormStepformFieldUnion documents */
  delete?: InputMaybe<Array<MultiStepPromotionFormStepformFieldUnionWhereUniqueInput>>;
  /** Update multiple MultiStepPromotionFormStepformFieldUnion component instances */
  update?: InputMaybe<Array<MultiStepPromotionFormStepformFieldUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple MultiStepPromotionFormStepformFieldUnion component instances */
  upsert?: InputMaybe<Array<MultiStepPromotionFormStepformFieldUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type MultiStepPromotionFormStepformFieldUnionUpdateManyWithNestedWhereInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesUpdateManyWithNestedWhereInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioUpdateManyWithNestedWhereInput>;
};

export type MultiStepPromotionFormStepformFieldUnionUpdateOneInlineInput = {
  /** Create and connect one MultiStepPromotionFormStepformFieldUnion document */
  create?: InputMaybe<MultiStepPromotionFormStepformFieldUnionCreateInput>;
  /** Delete currently connected MultiStepPromotionFormStepformFieldUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MultiStepPromotionFormStepformFieldUnion document */
  update?: InputMaybe<MultiStepPromotionFormStepformFieldUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MultiStepPromotionFormStepformFieldUnion document */
  upsert?: InputMaybe<MultiStepPromotionFormStepformFieldUnionUpsertWithNestedWhereUniqueInput>;
};

export type MultiStepPromotionFormStepformFieldUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesUpdateWithNestedWhereUniqueAndPositionInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type MultiStepPromotionFormStepformFieldUnionUpdateWithNestedWhereUniqueInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesUpdateWithNestedWhereUniqueInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioUpdateWithNestedWhereUniqueInput>;
};

export type MultiStepPromotionFormStepformFieldUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesUpsertWithNestedWhereUniqueAndPositionInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type MultiStepPromotionFormStepformFieldUnionUpsertWithNestedWhereUniqueInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesUpsertWithNestedWhereUniqueInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioUpsertWithNestedWhereUniqueInput>;
};

export type MultiStepPromotionFormStepformFieldUnionWhereInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesWhereInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioWhereInput>;
};

export type MultiStepPromotionFormStepformFieldUnionWhereUniqueInput = {
  MultiStepPromotionFormCheckboxes?: InputMaybe<MultiStepPromotionFormCheckboxesWhereUniqueInput>;
  MultiStepPromotionFormRadio?: InputMaybe<MultiStepPromotionFormRadioWhereUniqueInput>;
};

export type MultiStepPromotionFormUpdateInput = {
  footerLinks?: InputMaybe<LinkUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  promotionDownload?: InputMaybe<PromotionDownloadUpdateOneInlineInput>;
  promotionForm?: InputMaybe<PromotionFormUpdateOneInlineInput>;
  showOnlyDownloadButton?: InputMaybe<Scalars['Boolean']['input']>;
  steps?: InputMaybe<MultiStepPromotionFormStepUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MultiStepPromotionFormUpdateManyInlineInput = {
  /** Connect multiple existing MultiStepPromotionForm documents */
  connect?: InputMaybe<Array<MultiStepPromotionFormConnectInput>>;
  /** Create and connect multiple MultiStepPromotionForm documents */
  create?: InputMaybe<Array<MultiStepPromotionFormCreateInput>>;
  /** Delete multiple MultiStepPromotionForm documents */
  delete?: InputMaybe<Array<MultiStepPromotionFormWhereUniqueInput>>;
  /** Disconnect multiple MultiStepPromotionForm documents */
  disconnect?: InputMaybe<Array<MultiStepPromotionFormWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing MultiStepPromotionForm documents */
  set?: InputMaybe<Array<MultiStepPromotionFormWhereUniqueInput>>;
  /** Update multiple MultiStepPromotionForm documents */
  update?: InputMaybe<Array<MultiStepPromotionFormUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple MultiStepPromotionForm documents */
  upsert?: InputMaybe<Array<MultiStepPromotionFormUpsertWithNestedWhereUniqueInput>>;
};

export type MultiStepPromotionFormUpdateManyInput = {
  showOnlyDownloadButton?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MultiStepPromotionFormUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MultiStepPromotionFormUpdateManyInput;
  /** Document search */
  where: MultiStepPromotionFormWhereInput;
};

export type MultiStepPromotionFormUpdateOneInlineInput = {
  /** Connect existing MultiStepPromotionForm document */
  connect?: InputMaybe<MultiStepPromotionFormWhereUniqueInput>;
  /** Create and connect one MultiStepPromotionForm document */
  create?: InputMaybe<MultiStepPromotionFormCreateInput>;
  /** Delete currently connected MultiStepPromotionForm document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected MultiStepPromotionForm document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MultiStepPromotionForm document */
  update?: InputMaybe<MultiStepPromotionFormUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MultiStepPromotionForm document */
  upsert?: InputMaybe<MultiStepPromotionFormUpsertWithNestedWhereUniqueInput>;
};

export type MultiStepPromotionFormUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MultiStepPromotionFormUpdateInput;
  /** Unique document search */
  where: MultiStepPromotionFormWhereUniqueInput;
};

export type MultiStepPromotionFormUpsertInput = {
  /** Create document if it didn't exist */
  create: MultiStepPromotionFormCreateInput;
  /** Update document if it exists */
  update: MultiStepPromotionFormUpdateInput;
};

export type MultiStepPromotionFormUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MultiStepPromotionFormUpsertInput;
  /** Unique document search */
  where: MultiStepPromotionFormWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type MultiStepPromotionFormWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type MultiStepPromotionFormWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MultiStepPromotionFormWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MultiStepPromotionFormWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MultiStepPromotionFormWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MultiStepPromotionFormWhereStageInput>;
  documentInStages_none?: InputMaybe<MultiStepPromotionFormWhereStageInput>;
  documentInStages_some?: InputMaybe<MultiStepPromotionFormWhereStageInput>;
  footerLinks_every?: InputMaybe<LinkWhereInput>;
  footerLinks_none?: InputMaybe<LinkWhereInput>;
  footerLinks_some?: InputMaybe<LinkWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  promotionDownload?: InputMaybe<PromotionDownloadWhereInput>;
  promotionForm?: InputMaybe<PromotionFormWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showOnlyDownloadButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showOnlyDownloadButton_not?: InputMaybe<Scalars['Boolean']['input']>;
  steps_every?: InputMaybe<MultiStepPromotionFormStepWhereInput>;
  steps_none?: InputMaybe<MultiStepPromotionFormStepWhereInput>;
  steps_some?: InputMaybe<MultiStepPromotionFormStepWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type MultiStepPromotionFormWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MultiStepPromotionFormWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MultiStepPromotionFormWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MultiStepPromotionFormWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<MultiStepPromotionFormWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References MultiStepPromotionForm record uniquely */
export type MultiStepPromotionFormWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create one accordion */
  createAccordion?: Maybe<Accordion>;
  /** Create one accordionItem */
  createAccordionItem?: Maybe<AccordionItem>;
  /** Create one algoliaExtension */
  createAlgoliaExtension?: Maybe<AlgoliaExtension>;
  /** Create one anchorNav */
  createAnchorNav?: Maybe<AnchorNav>;
  /** Create one anchorNavigation */
  createAnchorNavigation?: Maybe<AnchorNavigation>;
  /** Create one anchorNavigationList */
  createAnchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Create an asset. Use the returned info to finish the creation process by uploading the asset. */
  createAsset?: Maybe<Asset>;
  /** Create one assetComponent */
  createAssetComponent?: Maybe<AssetComponent>;
  /** Create one audioComponent */
  createAudioComponent?: Maybe<AudioComponent>;
  /** Create one authorableContentCard */
  createAuthorableContentCard?: Maybe<AuthorableContentCard>;
  /** Create one banner1 */
  createBanner1?: Maybe<Banner1>;
  /** Create one banner2 */
  createBanner2?: Maybe<Banner2>;
  /** Create one banner2CarouselComponent */
  createBanner2CarouselComponent?: Maybe<Banner2CarouselComponent>;
  /** Create one cardComponent */
  createCardComponent?: Maybe<CardComponent>;
  /** Create one carouselComponent */
  createCarouselComponent?: Maybe<CarouselComponent>;
  /** Create one carouselSlide */
  createCarouselSlide?: Maybe<CarouselSlide>;
  /** Create one categoryCard */
  createCategoryCard?: Maybe<CategoryCard>;
  /** Create one contactCard */
  createContactCard?: Maybe<ContactCard>;
  /** Create one contactCardContainer */
  createContactCardContainer?: Maybe<ContactCardContainer>;
  /** Create one countrySelectorFooter */
  createCountrySelectorFooter?: Maybe<CountrySelectorFooter>;
  /** Create one countrySelectorItem */
  createCountrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Create one demoModel */
  createDemoModel?: Maybe<DemoModel>;
  /** Create one dictionary */
  createDictionary?: Maybe<Dictionary>;
  /** Create one dictionaryItem */
  createDictionaryItem?: Maybe<DictionaryItem>;
  /** Create one downloadApp */
  createDownloadApp?: Maybe<DownloadApp>;
  /** Create one dynamicCardGrid */
  createDynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Create one errorPage */
  createErrorPage?: Maybe<ErrorPage>;
  /** Create one evalancheFormComponent */
  createEvalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Create one exampleComponent */
  createExampleComponent?: Maybe<ExampleComponent>;
  /** Create one featuredContent */
  createFeaturedContent?: Maybe<FeaturedContent>;
  /** Create one featuredContentReference */
  createFeaturedContentReference?: Maybe<FeaturedContentReference>;
  /** Create one footerNavigation */
  createFooterNavigation?: Maybe<FooterNavigation>;
  /** Create one footerSeal */
  createFooterSeal?: Maybe<FooterSeal>;
  /** Create one form */
  createForm?: Maybe<Form>;
  /** Create one formCheckbox */
  createFormCheckbox?: Maybe<FormCheckbox>;
  /** Create one formCheckboxCollection */
  createFormCheckboxCollection?: Maybe<FormCheckboxCollection>;
  /** Create one formDateInput */
  createFormDateInput?: Maybe<FormDateInput>;
  /** Create one formEmailInput */
  createFormEmailInput?: Maybe<FormEmailInput>;
  /** Create one formError */
  createFormError?: Maybe<FormError>;
  /** Create one formFileUploader */
  createFormFileUploader?: Maybe<FormFileUploader>;
  /** Create one formList */
  createFormList?: Maybe<FormList>;
  /** Create one formListItem */
  createFormListItem?: Maybe<FormListItem>;
  /** Create one formNumberInput */
  createFormNumberInput?: Maybe<FormNumberInput>;
  /** Create one formPasswordInput */
  createFormPasswordInput?: Maybe<FormPasswordInput>;
  /** Create one formPasswordInputWithConfirmation */
  createFormPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Create one formRadioButton */
  createFormRadioButton?: Maybe<FormRadioButton>;
  /** Create one formRadioButtonCollection */
  createFormRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Create one formSelectComponent */
  createFormSelectComponent?: Maybe<FormSelectComponent>;
  /** Create one formSelectOption */
  createFormSelectOption?: Maybe<FormSelectOption>;
  /** Create one formSubmitButton */
  createFormSubmitButton?: Maybe<FormSubmitButton>;
  /** Create one formSuccessComponent */
  createFormSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Create one formTextInput */
  createFormTextInput?: Maybe<FormTextInput>;
  /** Create one formTextareaInput */
  createFormTextareaInput?: Maybe<FormTextareaInput>;
  /** Create one genericAccordion */
  createGenericAccordion?: Maybe<GenericAccordion>;
  /** Create one genericAccordionItem */
  createGenericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Create one genericAccordionTopRated */
  createGenericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Create one genericCardCarouseComponent */
  createGenericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Create one genericDownloadComponent */
  createGenericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Create one genericFollowUs */
  createGenericFollowUs?: Maybe<GenericFollowUs>;
  /** Create one genericGridAuthorable */
  createGenericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Create one genericHtml */
  createGenericHtml?: Maybe<GenericHtml>;
  /** Create one genericLine */
  createGenericLine?: Maybe<GenericLine>;
  /** Create one genericLink */
  createGenericLink?: Maybe<GenericLink>;
  /** Create one genericPage */
  createGenericPage?: Maybe<GenericPage>;
  /** Create one genericPromotionsOverview */
  createGenericPromotionsOverview?: Maybe<GenericPromotionsOverview>;
  /** Create one genericQualifio */
  createGenericQualifio?: Maybe<GenericQualifio>;
  /** Create one genericQualifioOverview */
  createGenericQualifioOverview?: Maybe<GenericQualifioOverview>;
  /** Create one genericSocialShare */
  createGenericSocialShare?: Maybe<GenericSocialShare>;
  /** Create one globalMetaData */
  createGlobalMetaData?: Maybe<GlobalMetaData>;
  /** Create one globalSearch */
  createGlobalSearch?: Maybe<GlobalSearch>;
  /** Create one gridColumn */
  createGridColumn?: Maybe<GridColumn>;
  /** Create one gridColumnComponent */
  createGridColumnComponent?: Maybe<GridColumnComponent>;
  /** Create one heroBanner */
  createHeroBanner?: Maybe<HeroBanner>;
  /** Create one heroBannerMasterbrand */
  createHeroBannerMasterbrand?: Maybe<HeroBannerMasterbrand>;
  /** Create one heroCarouselComponent */
  createHeroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Create one heroComponent */
  createHeroComponent?: Maybe<HeroComponent>;
  /** Create one heroLoopAnimationComponent */
  createHeroLoopAnimationComponent?: Maybe<HeroLoopAnimationComponent>;
  /** Create one iframe */
  createIframe?: Maybe<Iframe>;
  /** Create one imageAndTextCard */
  createImageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Create one imageCopy */
  createImageCopy?: Maybe<ImageCopy>;
  /** Create one imageCopyItem */
  createImageCopyItem?: Maybe<ImageCopyItem>;
  /** Create one introText */
  createIntroText?: Maybe<IntroText>;
  /** Create one leftColumn */
  createLeftColumn?: Maybe<LeftColumn>;
  /** Create one link */
  createLink?: Maybe<Link>;
  /** Create one longText */
  createLongText?: Maybe<LongText>;
  /** Create one market */
  createMarket?: Maybe<Market>;
  /** Create one marketUserConnection */
  createMarketUserConnection?: Maybe<MarketUserConnection>;
  /** Create one metaData */
  createMetaData?: Maybe<MetaData>;
  /** Create one mobileOnlyMainNavigation */
  createMobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Create one multiStepPromotionForm */
  createMultiStepPromotionForm?: Maybe<MultiStepPromotionForm>;
  /** Create one navigation */
  createNavigation?: Maybe<Navigation>;
  /** Create one navigationItem */
  createNavigationItem?: Maybe<NavigationItem>;
  /** Create one newsletterComponent */
  createNewsletterComponent?: Maybe<NewsletterComponent>;
  /** Create one newsletterSubscriptions */
  createNewsletterSubscriptions?: Maybe<NewsletterSubscriptions>;
  /** Create one notificationBanner */
  createNotificationBanner?: Maybe<NotificationBanner>;
  /** Create one pageFooter */
  createPageFooter?: Maybe<PageFooter>;
  /** Create one pageHeader */
  createPageHeader?: Maybe<PageHeader>;
  /** Create one popularSearchComponent */
  createPopularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Create one product */
  createProduct?: Maybe<Product>;
  /** Create one productBanner */
  createProductBanner?: Maybe<ProductBanner>;
  /** Create one productCategory */
  createProductCategory?: Maybe<ProductCategory>;
  /** Create one productCategoryPage */
  createProductCategoryPage?: Maybe<ProductCategoryPage>;
  /** Create one productDetailPage */
  createProductDetailPage?: Maybe<ProductDetailPage>;
  /** Create one productHero */
  createProductHero?: Maybe<ProductHero>;
  /** Create one productLabel */
  createProductLabel?: Maybe<ProductLabel>;
  /** Create one productLandingPage */
  createProductLandingPage?: Maybe<ProductLandingPage>;
  /** Create one productSubcategoryPage */
  createProductSubcategoryPage?: Maybe<ProductSubcategoryPage>;
  /** Create one promotionDownload */
  createPromotionDownload?: Maybe<PromotionDownload>;
  /** Create one promotionForm */
  createPromotionForm?: Maybe<PromotionForm>;
  /** Create one question */
  createQuestion?: Maybe<Question>;
  /** Create one questionCheckbox */
  createQuestionCheckbox?: Maybe<QuestionCheckbox>;
  /** Create one questionCheckboxCollection */
  createQuestionCheckboxCollection?: Maybe<QuestionCheckboxCollection>;
  /** Create one questionRadioButton */
  createQuestionRadioButton?: Maybe<QuestionRadioButton>;
  /** Create one questionRadioButtonCollection */
  createQuestionRadioButtonCollection?: Maybe<QuestionRadioButtonCollection>;
  /** Create one rating */
  createRating?: Maybe<Rating>;
  /** Create one recipe */
  createRecipe?: Maybe<Recipe>;
  /** Create one recipeCategory */
  createRecipeCategory?: Maybe<RecipeCategory>;
  /** Create one recipeLandingPage */
  createRecipeLandingPage?: Maybe<RecipeLandingPage>;
  /** Create one recipeSubcategory */
  createRecipeSubcategory?: Maybe<RecipeSubcategory>;
  /** Create one recipesComparisonQueryComponent */
  createRecipesComparisonQueryComponent?: Maybe<RecipesComparisonQueryComponent>;
  /** Create one recipesQueriesReference */
  createRecipesQueriesReference?: Maybe<RecipesQueriesReference>;
  /** Create one recipesQueryComponent */
  createRecipesQueryComponent?: Maybe<RecipesQueryComponent>;
  /** Create one redirect */
  createRedirect?: Maybe<Redirect>;
  /** Create one rewrite */
  createRewrite?: Maybe<Rewrite>;
  /** Create one rightColumn */
  createRightColumn?: Maybe<RightColumn>;
  /** Create one scheduledRelease */
  createScheduledRelease?: Maybe<ScheduledRelease>;
  /** Create one searchInput */
  createSearchInput?: Maybe<SearchInput>;
  /** Create one searchOverlayComponent */
  createSearchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Create one searchResultPage */
  createSearchResultPage?: Maybe<SearchResultPage>;
  /** Create one separator */
  createSeparator?: Maybe<Separator>;
  /** Create one singleStepPromotionForm */
  createSingleStepPromotionForm?: Maybe<SingleStepPromotionForm>;
  /** Create one socialMediaListComponent */
  createSocialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Create one spacer */
  createSpacer?: Maybe<Spacer>;
  /** Create one subCategoryKeyImage */
  createSubCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Create one subTab */
  createSubTab?: Maybe<SubTab>;
  /** Create one subTabContent */
  createSubTabContent?: Maybe<SubTabContent>;
  /** Create one sustainabilityBanner */
  createSustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Create one sustainabilityInfo */
  createSustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Create one tab */
  createTab?: Maybe<Tab>;
  /** Create one tabContent */
  createTabContent?: Maybe<TabContent>;
  /** Create one teaser */
  createTeaser?: Maybe<Teaser>;
  /** Create one teaserPlaceholder */
  createTeaserPlaceholder?: Maybe<TeaserPlaceholder>;
  /** Create one teaserSmall */
  createTeaserSmall?: Maybe<TeaserSmall>;
  /** Create one teaserSmallPlaceholder */
  createTeaserSmallPlaceholder?: Maybe<TeaserSmallPlaceholder>;
  /** Create one testComponentWithRecipeQuery */
  createTestComponentWithRecipeQuery?: Maybe<TestComponentWithRecipeQuery>;
  /** Create one testTipsANdTricksInAMarket */
  createTestTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Create one textComponent */
  createTextComponent?: Maybe<TextComponent>;
  /** Create one tipsAndTricksDetailsPage */
  createTipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Create one title */
  createTitle?: Maybe<Title>;
  /** Create one twitterSeo */
  createTwitterSeo?: Maybe<TwitterSeo>;
  /** Delete one accordion from _all_ existing stages. Returns deleted document. */
  deleteAccordion?: Maybe<Accordion>;
  /** Delete one accordionItem from _all_ existing stages. Returns deleted document. */
  deleteAccordionItem?: Maybe<AccordionItem>;
  /** Delete one algoliaExtension from _all_ existing stages. Returns deleted document. */
  deleteAlgoliaExtension?: Maybe<AlgoliaExtension>;
  /** Delete one anchorNav from _all_ existing stages. Returns deleted document. */
  deleteAnchorNav?: Maybe<AnchorNav>;
  /** Delete one anchorNavigation from _all_ existing stages. Returns deleted document. */
  deleteAnchorNavigation?: Maybe<AnchorNavigation>;
  /** Delete one anchorNavigationList from _all_ existing stages. Returns deleted document. */
  deleteAnchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Delete one asset from _all_ existing stages. Returns deleted document. */
  deleteAsset?: Maybe<Asset>;
  /** Delete one assetComponent from _all_ existing stages. Returns deleted document. */
  deleteAssetComponent?: Maybe<AssetComponent>;
  /** Delete one audioComponent from _all_ existing stages. Returns deleted document. */
  deleteAudioComponent?: Maybe<AudioComponent>;
  /** Delete one authorableContentCard from _all_ existing stages. Returns deleted document. */
  deleteAuthorableContentCard?: Maybe<AuthorableContentCard>;
  /** Delete one banner1 from _all_ existing stages. Returns deleted document. */
  deleteBanner1?: Maybe<Banner1>;
  /** Delete one banner2 from _all_ existing stages. Returns deleted document. */
  deleteBanner2?: Maybe<Banner2>;
  /** Delete one banner2CarouselComponent from _all_ existing stages. Returns deleted document. */
  deleteBanner2CarouselComponent?: Maybe<Banner2CarouselComponent>;
  /** Delete one cardComponent from _all_ existing stages. Returns deleted document. */
  deleteCardComponent?: Maybe<CardComponent>;
  /** Delete one carouselComponent from _all_ existing stages. Returns deleted document. */
  deleteCarouselComponent?: Maybe<CarouselComponent>;
  /** Delete one carouselSlide from _all_ existing stages. Returns deleted document. */
  deleteCarouselSlide?: Maybe<CarouselSlide>;
  /** Delete one categoryCard from _all_ existing stages. Returns deleted document. */
  deleteCategoryCard?: Maybe<CategoryCard>;
  /** Delete one contactCard from _all_ existing stages. Returns deleted document. */
  deleteContactCard?: Maybe<ContactCard>;
  /** Delete one contactCardContainer from _all_ existing stages. Returns deleted document. */
  deleteContactCardContainer?: Maybe<ContactCardContainer>;
  /** Delete one countrySelectorFooter from _all_ existing stages. Returns deleted document. */
  deleteCountrySelectorFooter?: Maybe<CountrySelectorFooter>;
  /** Delete one countrySelectorItem from _all_ existing stages. Returns deleted document. */
  deleteCountrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Delete one demoModel from _all_ existing stages. Returns deleted document. */
  deleteDemoModel?: Maybe<DemoModel>;
  /** Delete one dictionary from _all_ existing stages. Returns deleted document. */
  deleteDictionary?: Maybe<Dictionary>;
  /** Delete one dictionaryItem from _all_ existing stages. Returns deleted document. */
  deleteDictionaryItem?: Maybe<DictionaryItem>;
  /** Delete one downloadApp from _all_ existing stages. Returns deleted document. */
  deleteDownloadApp?: Maybe<DownloadApp>;
  /** Delete one dynamicCardGrid from _all_ existing stages. Returns deleted document. */
  deleteDynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Delete one errorPage from _all_ existing stages. Returns deleted document. */
  deleteErrorPage?: Maybe<ErrorPage>;
  /** Delete one evalancheFormComponent from _all_ existing stages. Returns deleted document. */
  deleteEvalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Delete one exampleComponent from _all_ existing stages. Returns deleted document. */
  deleteExampleComponent?: Maybe<ExampleComponent>;
  /** Delete one featuredContent from _all_ existing stages. Returns deleted document. */
  deleteFeaturedContent?: Maybe<FeaturedContent>;
  /** Delete one featuredContentReference from _all_ existing stages. Returns deleted document. */
  deleteFeaturedContentReference?: Maybe<FeaturedContentReference>;
  /** Delete one footerNavigation from _all_ existing stages. Returns deleted document. */
  deleteFooterNavigation?: Maybe<FooterNavigation>;
  /** Delete one footerSeal from _all_ existing stages. Returns deleted document. */
  deleteFooterSeal?: Maybe<FooterSeal>;
  /** Delete one form from _all_ existing stages. Returns deleted document. */
  deleteForm?: Maybe<Form>;
  /** Delete one formCheckbox from _all_ existing stages. Returns deleted document. */
  deleteFormCheckbox?: Maybe<FormCheckbox>;
  /** Delete one formCheckboxCollection from _all_ existing stages. Returns deleted document. */
  deleteFormCheckboxCollection?: Maybe<FormCheckboxCollection>;
  /** Delete one formDateInput from _all_ existing stages. Returns deleted document. */
  deleteFormDateInput?: Maybe<FormDateInput>;
  /** Delete one formEmailInput from _all_ existing stages. Returns deleted document. */
  deleteFormEmailInput?: Maybe<FormEmailInput>;
  /** Delete one formError from _all_ existing stages. Returns deleted document. */
  deleteFormError?: Maybe<FormError>;
  /** Delete one formFileUploader from _all_ existing stages. Returns deleted document. */
  deleteFormFileUploader?: Maybe<FormFileUploader>;
  /** Delete one formList from _all_ existing stages. Returns deleted document. */
  deleteFormList?: Maybe<FormList>;
  /** Delete one formListItem from _all_ existing stages. Returns deleted document. */
  deleteFormListItem?: Maybe<FormListItem>;
  /** Delete one formNumberInput from _all_ existing stages. Returns deleted document. */
  deleteFormNumberInput?: Maybe<FormNumberInput>;
  /** Delete one formPasswordInput from _all_ existing stages. Returns deleted document. */
  deleteFormPasswordInput?: Maybe<FormPasswordInput>;
  /** Delete one formPasswordInputWithConfirmation from _all_ existing stages. Returns deleted document. */
  deleteFormPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Delete one formRadioButton from _all_ existing stages. Returns deleted document. */
  deleteFormRadioButton?: Maybe<FormRadioButton>;
  /** Delete one formRadioButtonCollection from _all_ existing stages. Returns deleted document. */
  deleteFormRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Delete one formSelectComponent from _all_ existing stages. Returns deleted document. */
  deleteFormSelectComponent?: Maybe<FormSelectComponent>;
  /** Delete one formSelectOption from _all_ existing stages. Returns deleted document. */
  deleteFormSelectOption?: Maybe<FormSelectOption>;
  /** Delete one formSubmitButton from _all_ existing stages. Returns deleted document. */
  deleteFormSubmitButton?: Maybe<FormSubmitButton>;
  /** Delete one formSuccessComponent from _all_ existing stages. Returns deleted document. */
  deleteFormSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Delete one formTextInput from _all_ existing stages. Returns deleted document. */
  deleteFormTextInput?: Maybe<FormTextInput>;
  /** Delete one formTextareaInput from _all_ existing stages. Returns deleted document. */
  deleteFormTextareaInput?: Maybe<FormTextareaInput>;
  /** Delete one genericAccordion from _all_ existing stages. Returns deleted document. */
  deleteGenericAccordion?: Maybe<GenericAccordion>;
  /** Delete one genericAccordionItem from _all_ existing stages. Returns deleted document. */
  deleteGenericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Delete one genericAccordionTopRated from _all_ existing stages. Returns deleted document. */
  deleteGenericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Delete one genericCardCarouseComponent from _all_ existing stages. Returns deleted document. */
  deleteGenericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Delete one genericDownloadComponent from _all_ existing stages. Returns deleted document. */
  deleteGenericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Delete one genericFollowUs from _all_ existing stages. Returns deleted document. */
  deleteGenericFollowUs?: Maybe<GenericFollowUs>;
  /** Delete one genericGridAuthorable from _all_ existing stages. Returns deleted document. */
  deleteGenericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Delete one genericHtml from _all_ existing stages. Returns deleted document. */
  deleteGenericHtml?: Maybe<GenericHtml>;
  /** Delete one genericLine from _all_ existing stages. Returns deleted document. */
  deleteGenericLine?: Maybe<GenericLine>;
  /** Delete one genericLink from _all_ existing stages. Returns deleted document. */
  deleteGenericLink?: Maybe<GenericLink>;
  /** Delete one genericPage from _all_ existing stages. Returns deleted document. */
  deleteGenericPage?: Maybe<GenericPage>;
  /** Delete one genericPromotionsOverview from _all_ existing stages. Returns deleted document. */
  deleteGenericPromotionsOverview?: Maybe<GenericPromotionsOverview>;
  /** Delete one genericQualifio from _all_ existing stages. Returns deleted document. */
  deleteGenericQualifio?: Maybe<GenericQualifio>;
  /** Delete one genericQualifioOverview from _all_ existing stages. Returns deleted document. */
  deleteGenericQualifioOverview?: Maybe<GenericQualifioOverview>;
  /** Delete one genericSocialShare from _all_ existing stages. Returns deleted document. */
  deleteGenericSocialShare?: Maybe<GenericSocialShare>;
  /** Delete one globalMetaData from _all_ existing stages. Returns deleted document. */
  deleteGlobalMetaData?: Maybe<GlobalMetaData>;
  /** Delete one globalSearch from _all_ existing stages. Returns deleted document. */
  deleteGlobalSearch?: Maybe<GlobalSearch>;
  /** Delete one gridColumn from _all_ existing stages. Returns deleted document. */
  deleteGridColumn?: Maybe<GridColumn>;
  /** Delete one gridColumnComponent from _all_ existing stages. Returns deleted document. */
  deleteGridColumnComponent?: Maybe<GridColumnComponent>;
  /** Delete one heroBanner from _all_ existing stages. Returns deleted document. */
  deleteHeroBanner?: Maybe<HeroBanner>;
  /** Delete one heroBannerMasterbrand from _all_ existing stages. Returns deleted document. */
  deleteHeroBannerMasterbrand?: Maybe<HeroBannerMasterbrand>;
  /** Delete one heroCarouselComponent from _all_ existing stages. Returns deleted document. */
  deleteHeroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Delete one heroComponent from _all_ existing stages. Returns deleted document. */
  deleteHeroComponent?: Maybe<HeroComponent>;
  /** Delete one heroLoopAnimationComponent from _all_ existing stages. Returns deleted document. */
  deleteHeroLoopAnimationComponent?: Maybe<HeroLoopAnimationComponent>;
  /** Delete one iframe from _all_ existing stages. Returns deleted document. */
  deleteIframe?: Maybe<Iframe>;
  /** Delete one imageAndTextCard from _all_ existing stages. Returns deleted document. */
  deleteImageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Delete one imageCopy from _all_ existing stages. Returns deleted document. */
  deleteImageCopy?: Maybe<ImageCopy>;
  /** Delete one imageCopyItem from _all_ existing stages. Returns deleted document. */
  deleteImageCopyItem?: Maybe<ImageCopyItem>;
  /** Delete one introText from _all_ existing stages. Returns deleted document. */
  deleteIntroText?: Maybe<IntroText>;
  /** Delete one leftColumn from _all_ existing stages. Returns deleted document. */
  deleteLeftColumn?: Maybe<LeftColumn>;
  /** Delete one link from _all_ existing stages. Returns deleted document. */
  deleteLink?: Maybe<Link>;
  /** Delete one longText from _all_ existing stages. Returns deleted document. */
  deleteLongText?: Maybe<LongText>;
  /**
   * Delete many AccordionItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyAccordionItemsConnection)
   */
  deleteManyAccordionItems: BatchPayload;
  /** Delete many AccordionItem documents, return deleted documents */
  deleteManyAccordionItemsConnection: AccordionItemConnection;
  /**
   * Delete many Accordion documents
   * @deprecated Please use the new paginated many mutation (deleteManyAccordionsConnection)
   */
  deleteManyAccordions: BatchPayload;
  /** Delete many Accordion documents, return deleted documents */
  deleteManyAccordionsConnection: AccordionConnection;
  /**
   * Delete many AlgoliaExtension documents
   * @deprecated Please use the new paginated many mutation (deleteManyAlgoliaExtensionsConnection)
   */
  deleteManyAlgoliaExtensions: BatchPayload;
  /** Delete many AlgoliaExtension documents, return deleted documents */
  deleteManyAlgoliaExtensionsConnection: AlgoliaExtensionConnection;
  /**
   * Delete many AnchorNavigationList documents
   * @deprecated Please use the new paginated many mutation (deleteManyAnchorNavigationListsConnection)
   */
  deleteManyAnchorNavigationLists: BatchPayload;
  /** Delete many AnchorNavigationList documents, return deleted documents */
  deleteManyAnchorNavigationListsConnection: AnchorNavigationListConnection;
  /**
   * Delete many AnchorNavigation documents
   * @deprecated Please use the new paginated many mutation (deleteManyAnchorNavigationsConnection)
   */
  deleteManyAnchorNavigations: BatchPayload;
  /** Delete many AnchorNavigation documents, return deleted documents */
  deleteManyAnchorNavigationsConnection: AnchorNavigationConnection;
  /**
   * Delete many AnchorNav documents
   * @deprecated Please use the new paginated many mutation (deleteManyAnchorNavsConnection)
   */
  deleteManyAnchorNavs: BatchPayload;
  /** Delete many AnchorNav documents, return deleted documents */
  deleteManyAnchorNavsConnection: AnchorNavConnection;
  /**
   * Delete many Asset documents
   * @deprecated Please use the new paginated many mutation (deleteManyAssetsConnection)
   */
  deleteManyAssets: BatchPayload;
  /**
   * Delete many AssetComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyAssetsComponentsConnection)
   */
  deleteManyAssetsComponents: BatchPayload;
  /** Delete many AssetComponent documents, return deleted documents */
  deleteManyAssetsComponentsConnection: AssetComponentConnection;
  /** Delete many Asset documents, return deleted documents */
  deleteManyAssetsConnection: AssetConnection;
  /**
   * Delete many AudioComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyAudioComponentsConnection)
   */
  deleteManyAudioComponents: BatchPayload;
  /** Delete many AudioComponent documents, return deleted documents */
  deleteManyAudioComponentsConnection: AudioComponentConnection;
  /**
   * Delete many AuthorableContentCard documents
   * @deprecated Please use the new paginated many mutation (deleteManyAuthorableContentCardsConnection)
   */
  deleteManyAuthorableContentCards: BatchPayload;
  /** Delete many AuthorableContentCard documents, return deleted documents */
  deleteManyAuthorableContentCardsConnection: AuthorableContentCardConnection;
  /**
   * Delete many Banner1 documents
   * @deprecated Please use the new paginated many mutation (deleteManyBanner1sConnection)
   */
  deleteManyBanner1s: BatchPayload;
  /** Delete many Banner1 documents, return deleted documents */
  deleteManyBanner1sConnection: Banner1Connection;
  /**
   * Delete many Banner2CarouselComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyBanner2CarouselComponentsConnection)
   */
  deleteManyBanner2CarouselComponents: BatchPayload;
  /** Delete many Banner2CarouselComponent documents, return deleted documents */
  deleteManyBanner2CarouselComponentsConnection: Banner2CarouselComponentConnection;
  /**
   * Delete many Banner2 documents
   * @deprecated Please use the new paginated many mutation (deleteManyBanner2SConnection)
   */
  deleteManyBanner2S: BatchPayload;
  /** Delete many Banner2 documents, return deleted documents */
  deleteManyBanner2SConnection: Banner2Connection;
  /**
   * Delete many CardComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyCardComponentsConnection)
   */
  deleteManyCardComponents: BatchPayload;
  /** Delete many CardComponent documents, return deleted documents */
  deleteManyCardComponentsConnection: CardComponentConnection;
  /**
   * Delete many CarouselComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyCarouselComponentsConnection)
   */
  deleteManyCarouselComponents: BatchPayload;
  /** Delete many CarouselComponent documents, return deleted documents */
  deleteManyCarouselComponentsConnection: CarouselComponentConnection;
  /**
   * Delete many CarouselSlide documents
   * @deprecated Please use the new paginated many mutation (deleteManyCarouselSlidesConnection)
   */
  deleteManyCarouselSlides: BatchPayload;
  /** Delete many CarouselSlide documents, return deleted documents */
  deleteManyCarouselSlidesConnection: CarouselSlideConnection;
  /**
   * Delete many CategoryCard documents
   * @deprecated Please use the new paginated many mutation (deleteManyCategoryCardsConnection)
   */
  deleteManyCategoryCards: BatchPayload;
  /** Delete many CategoryCard documents, return deleted documents */
  deleteManyCategoryCardsConnection: CategoryCardConnection;
  /**
   * Delete many ContactCardContainer documents
   * @deprecated Please use the new paginated many mutation (deleteManyContactCardContainersConnection)
   */
  deleteManyContactCardContainers: BatchPayload;
  /** Delete many ContactCardContainer documents, return deleted documents */
  deleteManyContactCardContainersConnection: ContactCardContainerConnection;
  /**
   * Delete many ContactCard documents
   * @deprecated Please use the new paginated many mutation (deleteManyContactCardsConnection)
   */
  deleteManyContactCards: BatchPayload;
  /** Delete many ContactCard documents, return deleted documents */
  deleteManyContactCardsConnection: ContactCardConnection;
  /**
   * Delete many CountrySelectorFooter documents
   * @deprecated Please use the new paginated many mutation (deleteManyCountrySelectorFootersConnection)
   */
  deleteManyCountrySelectorFooters: BatchPayload;
  /** Delete many CountrySelectorFooter documents, return deleted documents */
  deleteManyCountrySelectorFootersConnection: CountrySelectorFooterConnection;
  /**
   * Delete many CountrySelectorItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyCountrySelectorItemsConnection)
   */
  deleteManyCountrySelectorItems: BatchPayload;
  /** Delete many CountrySelectorItem documents, return deleted documents */
  deleteManyCountrySelectorItemsConnection: CountrySelectorItemConnection;
  /**
   * Delete many DemoModel documents
   * @deprecated Please use the new paginated many mutation (deleteManyDemoModelsConnection)
   */
  deleteManyDemoModels: BatchPayload;
  /** Delete many DemoModel documents, return deleted documents */
  deleteManyDemoModelsConnection: DemoModelConnection;
  /**
   * Delete many Dictionary documents
   * @deprecated Please use the new paginated many mutation (deleteManyDictionariesConnection)
   */
  deleteManyDictionaries: BatchPayload;
  /** Delete many Dictionary documents, return deleted documents */
  deleteManyDictionariesConnection: DictionaryConnection;
  /**
   * Delete many DictionaryItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyDictionaryItemsConnection)
   */
  deleteManyDictionaryItems: BatchPayload;
  /** Delete many DictionaryItem documents, return deleted documents */
  deleteManyDictionaryItemsConnection: DictionaryItemConnection;
  /**
   * Delete many DownloadApp documents
   * @deprecated Please use the new paginated many mutation (deleteManyDownloadAppsConnection)
   */
  deleteManyDownloadApps: BatchPayload;
  /** Delete many DownloadApp documents, return deleted documents */
  deleteManyDownloadAppsConnection: DownloadAppConnection;
  /**
   * Delete many DynamicCardGrid documents
   * @deprecated Please use the new paginated many mutation (deleteManyDynamicCardGridsConnection)
   */
  deleteManyDynamicCardGrids: BatchPayload;
  /** Delete many DynamicCardGrid documents, return deleted documents */
  deleteManyDynamicCardGridsConnection: DynamicCardGridConnection;
  /**
   * Delete many ErrorPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyErrorPagesConnection)
   */
  deleteManyErrorPages: BatchPayload;
  /** Delete many ErrorPage documents, return deleted documents */
  deleteManyErrorPagesConnection: ErrorPageConnection;
  /**
   * Delete many EvalancheFormComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyEvalancheFormComponentsConnection)
   */
  deleteManyEvalancheFormComponents: BatchPayload;
  /** Delete many EvalancheFormComponent documents, return deleted documents */
  deleteManyEvalancheFormComponentsConnection: EvalancheFormComponentConnection;
  /**
   * Delete many ExampleComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyExampleComponentsConnection)
   */
  deleteManyExampleComponents: BatchPayload;
  /** Delete many ExampleComponent documents, return deleted documents */
  deleteManyExampleComponentsConnection: ExampleComponentConnection;
  /**
   * Delete many FeaturedContentReference documents
   * @deprecated Please use the new paginated many mutation (deleteManyFeaturedContentReferencesConnection)
   */
  deleteManyFeaturedContentReferences: BatchPayload;
  /** Delete many FeaturedContentReference documents, return deleted documents */
  deleteManyFeaturedContentReferencesConnection: FeaturedContentReferenceConnection;
  /**
   * Delete many FeaturedContent documents
   * @deprecated Please use the new paginated many mutation (deleteManyFeaturedContentsConnection)
   */
  deleteManyFeaturedContents: BatchPayload;
  /** Delete many FeaturedContent documents, return deleted documents */
  deleteManyFeaturedContentsConnection: FeaturedContentConnection;
  /**
   * Delete many FooterNavigation documents
   * @deprecated Please use the new paginated many mutation (deleteManyFooterNavigationsConnection)
   */
  deleteManyFooterNavigations: BatchPayload;
  /** Delete many FooterNavigation documents, return deleted documents */
  deleteManyFooterNavigationsConnection: FooterNavigationConnection;
  /**
   * Delete many FooterSeal documents
   * @deprecated Please use the new paginated many mutation (deleteManyFooterSealsConnection)
   */
  deleteManyFooterSeals: BatchPayload;
  /** Delete many FooterSeal documents, return deleted documents */
  deleteManyFooterSealsConnection: FooterSealConnection;
  /**
   * Delete many FormCheckboxCollection documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormCheckboxCollectionsConnection)
   */
  deleteManyFormCheckboxCollections: BatchPayload;
  /** Delete many FormCheckboxCollection documents, return deleted documents */
  deleteManyFormCheckboxCollectionsConnection: FormCheckboxCollectionConnection;
  /**
   * Delete many FormCheckbox documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormCheckboxesConnection)
   */
  deleteManyFormCheckboxes: BatchPayload;
  /** Delete many FormCheckbox documents, return deleted documents */
  deleteManyFormCheckboxesConnection: FormCheckboxConnection;
  /**
   * Delete many FormDateInput documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormDateInputsConnection)
   */
  deleteManyFormDateInputs: BatchPayload;
  /** Delete many FormDateInput documents, return deleted documents */
  deleteManyFormDateInputsConnection: FormDateInputConnection;
  /**
   * Delete many FormEmailInput documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormEmailInputsConnection)
   */
  deleteManyFormEmailInputs: BatchPayload;
  /** Delete many FormEmailInput documents, return deleted documents */
  deleteManyFormEmailInputsConnection: FormEmailInputConnection;
  /**
   * Delete many FormError documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormErrorsConnection)
   */
  deleteManyFormErrors: BatchPayload;
  /** Delete many FormError documents, return deleted documents */
  deleteManyFormErrorsConnection: FormErrorConnection;
  /**
   * Delete many FormFileUploader documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormFileUploadersConnection)
   */
  deleteManyFormFileUploaders: BatchPayload;
  /** Delete many FormFileUploader documents, return deleted documents */
  deleteManyFormFileUploadersConnection: FormFileUploaderConnection;
  /**
   * Delete many FormListItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormListItemsConnection)
   */
  deleteManyFormListItems: BatchPayload;
  /** Delete many FormListItem documents, return deleted documents */
  deleteManyFormListItemsConnection: FormListItemConnection;
  /**
   * Delete many FormList documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormListsConnection)
   */
  deleteManyFormLists: BatchPayload;
  /** Delete many FormList documents, return deleted documents */
  deleteManyFormListsConnection: FormListConnection;
  /**
   * Delete many FormNumberInput documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormNumberInputsConnection)
   */
  deleteManyFormNumberInputs: BatchPayload;
  /** Delete many FormNumberInput documents, return deleted documents */
  deleteManyFormNumberInputsConnection: FormNumberInputConnection;
  /**
   * Delete many FormPasswordInputWithConfirmation documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormPasswordInputWithConfirmationsConnection)
   */
  deleteManyFormPasswordInputWithConfirmations: BatchPayload;
  /** Delete many FormPasswordInputWithConfirmation documents, return deleted documents */
  deleteManyFormPasswordInputWithConfirmationsConnection: FormPasswordInputWithConfirmationConnection;
  /**
   * Delete many FormPasswordInput documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormPasswordInputsConnection)
   */
  deleteManyFormPasswordInputs: BatchPayload;
  /** Delete many FormPasswordInput documents, return deleted documents */
  deleteManyFormPasswordInputsConnection: FormPasswordInputConnection;
  /**
   * Delete many FormRadioButtonCollection documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormRadioButtonCollectionsConnection)
   */
  deleteManyFormRadioButtonCollections: BatchPayload;
  /** Delete many FormRadioButtonCollection documents, return deleted documents */
  deleteManyFormRadioButtonCollectionsConnection: FormRadioButtonCollectionConnection;
  /**
   * Delete many FormRadioButton documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormRadioButtonsConnection)
   */
  deleteManyFormRadioButtons: BatchPayload;
  /** Delete many FormRadioButton documents, return deleted documents */
  deleteManyFormRadioButtonsConnection: FormRadioButtonConnection;
  /**
   * Delete many FormSelectComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormSelectComponentsConnection)
   */
  deleteManyFormSelectComponents: BatchPayload;
  /** Delete many FormSelectComponent documents, return deleted documents */
  deleteManyFormSelectComponentsConnection: FormSelectComponentConnection;
  /**
   * Delete many FormSelectOption documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormSelectOptionsConnection)
   */
  deleteManyFormSelectOptions: BatchPayload;
  /** Delete many FormSelectOption documents, return deleted documents */
  deleteManyFormSelectOptionsConnection: FormSelectOptionConnection;
  /**
   * Delete many FormSubmitButton documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormSubmitButtonsConnection)
   */
  deleteManyFormSubmitButtons: BatchPayload;
  /** Delete many FormSubmitButton documents, return deleted documents */
  deleteManyFormSubmitButtonsConnection: FormSubmitButtonConnection;
  /**
   * Delete many FormSuccessComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormSuccessComponentsConnection)
   */
  deleteManyFormSuccessComponents: BatchPayload;
  /** Delete many FormSuccessComponent documents, return deleted documents */
  deleteManyFormSuccessComponentsConnection: FormSuccessComponentConnection;
  /**
   * Delete many FormTextInput documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormTextInputsConnection)
   */
  deleteManyFormTextInputs: BatchPayload;
  /** Delete many FormTextInput documents, return deleted documents */
  deleteManyFormTextInputsConnection: FormTextInputConnection;
  /**
   * Delete many FormTextareaInput documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormTextareaInputsConnection)
   */
  deleteManyFormTextareaInputs: BatchPayload;
  /** Delete many FormTextareaInput documents, return deleted documents */
  deleteManyFormTextareaInputsConnection: FormTextareaInputConnection;
  /**
   * Delete many Form documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormsConnection)
   */
  deleteManyForms: BatchPayload;
  /** Delete many Form documents, return deleted documents */
  deleteManyFormsConnection: FormConnection;
  /**
   * Delete many GenericAccordionItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericAccordionItemsConnection)
   */
  deleteManyGenericAccordionItems: BatchPayload;
  /** Delete many GenericAccordionItem documents, return deleted documents */
  deleteManyGenericAccordionItemsConnection: GenericAccordionItemConnection;
  /**
   * Delete many GenericAccordionTopRated documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericAccordionTopRatedsConnection)
   */
  deleteManyGenericAccordionTopRateds: BatchPayload;
  /** Delete many GenericAccordionTopRated documents, return deleted documents */
  deleteManyGenericAccordionTopRatedsConnection: GenericAccordionTopRatedConnection;
  /**
   * Delete many GenericAccordion documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericAccordionsConnection)
   */
  deleteManyGenericAccordions: BatchPayload;
  /** Delete many GenericAccordion documents, return deleted documents */
  deleteManyGenericAccordionsConnection: GenericAccordionConnection;
  /**
   * Delete many GenericCardCarouseComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericCardCarouseComponentsConnection)
   */
  deleteManyGenericCardCarouseComponents: BatchPayload;
  /** Delete many GenericCardCarouseComponent documents, return deleted documents */
  deleteManyGenericCardCarouseComponentsConnection: GenericCardCarouseComponentConnection;
  /**
   * Delete many GenericDownloadComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericDownloadComponentsConnection)
   */
  deleteManyGenericDownloadComponents: BatchPayload;
  /** Delete many GenericDownloadComponent documents, return deleted documents */
  deleteManyGenericDownloadComponentsConnection: GenericDownloadComponentConnection;
  /**
   * Delete many GenericFollowUs documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericFollowUsesConnection)
   */
  deleteManyGenericFollowUses: BatchPayload;
  /** Delete many GenericFollowUs documents, return deleted documents */
  deleteManyGenericFollowUsesConnection: GenericFollowUsConnection;
  /**
   * Delete many GenericGridAuthorable documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericGridAuthorablesConnection)
   */
  deleteManyGenericGridAuthorables: BatchPayload;
  /** Delete many GenericGridAuthorable documents, return deleted documents */
  deleteManyGenericGridAuthorablesConnection: GenericGridAuthorableConnection;
  /**
   * Delete many GenericHtml documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericHtmlsConnection)
   */
  deleteManyGenericHtmls: BatchPayload;
  /** Delete many GenericHtml documents, return deleted documents */
  deleteManyGenericHtmlsConnection: GenericHtmlConnection;
  /**
   * Delete many GenericLine documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericLinesConnection)
   */
  deleteManyGenericLines: BatchPayload;
  /** Delete many GenericLine documents, return deleted documents */
  deleteManyGenericLinesConnection: GenericLineConnection;
  /**
   * Delete many GenericLink documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericLinksConnection)
   */
  deleteManyGenericLinks: BatchPayload;
  /** Delete many GenericLink documents, return deleted documents */
  deleteManyGenericLinksConnection: GenericLinkConnection;
  /**
   * Delete many GenericPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericPagesConnection)
   */
  deleteManyGenericPages: BatchPayload;
  /** Delete many GenericPage documents, return deleted documents */
  deleteManyGenericPagesConnection: GenericPageConnection;
  /**
   * Delete many GenericPromotionsOverview documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericPromotionsOverviewsConnection)
   */
  deleteManyGenericPromotionsOverviews: BatchPayload;
  /** Delete many GenericPromotionsOverview documents, return deleted documents */
  deleteManyGenericPromotionsOverviewsConnection: GenericPromotionsOverviewConnection;
  /**
   * Delete many GenericQualifioOverview documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericQualifioOverviewsConnection)
   */
  deleteManyGenericQualifioOverviews: BatchPayload;
  /** Delete many GenericQualifioOverview documents, return deleted documents */
  deleteManyGenericQualifioOverviewsConnection: GenericQualifioOverviewConnection;
  /**
   * Delete many GenericQualifio documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericQualifiosConnection)
   */
  deleteManyGenericQualifios: BatchPayload;
  /** Delete many GenericQualifio documents, return deleted documents */
  deleteManyGenericQualifiosConnection: GenericQualifioConnection;
  /**
   * Delete many GenericSocialShare documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericSocialSharesConnection)
   */
  deleteManyGenericSocialShares: BatchPayload;
  /** Delete many GenericSocialShare documents, return deleted documents */
  deleteManyGenericSocialSharesConnection: GenericSocialShareConnection;
  /**
   * Delete many GlobalMetaData documents
   * @deprecated Please use the new paginated many mutation (deleteManyGlobalMetaDatasConnection)
   */
  deleteManyGlobalMetaDatas: BatchPayload;
  /** Delete many GlobalMetaData documents, return deleted documents */
  deleteManyGlobalMetaDatasConnection: GlobalMetaDataConnection;
  /**
   * Delete many GlobalSearch documents
   * @deprecated Please use the new paginated many mutation (deleteManyGlobalSearchesConnection)
   */
  deleteManyGlobalSearches: BatchPayload;
  /** Delete many GlobalSearch documents, return deleted documents */
  deleteManyGlobalSearchesConnection: GlobalSearchConnection;
  /**
   * Delete many GridColumnComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyGridColumnComponentsConnection)
   */
  deleteManyGridColumnComponents: BatchPayload;
  /** Delete many GridColumnComponent documents, return deleted documents */
  deleteManyGridColumnComponentsConnection: GridColumnComponentConnection;
  /**
   * Delete many GridColumn documents
   * @deprecated Please use the new paginated many mutation (deleteManyGridColumnsConnection)
   */
  deleteManyGridColumns: BatchPayload;
  /** Delete many GridColumn documents, return deleted documents */
  deleteManyGridColumnsConnection: GridColumnConnection;
  /**
   * Delete many HeroBannerMasterbrand documents
   * @deprecated Please use the new paginated many mutation (deleteManyHeroBannerMasterbrandsConnection)
   */
  deleteManyHeroBannerMasterbrands: BatchPayload;
  /** Delete many HeroBannerMasterbrand documents, return deleted documents */
  deleteManyHeroBannerMasterbrandsConnection: HeroBannerMasterbrandConnection;
  /**
   * Delete many HeroBanner documents
   * @deprecated Please use the new paginated many mutation (deleteManyHeroBannersConnection)
   */
  deleteManyHeroBanners: BatchPayload;
  /** Delete many HeroBanner documents, return deleted documents */
  deleteManyHeroBannersConnection: HeroBannerConnection;
  /**
   * Delete many HeroCarouselComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyHeroCarouselComponentsConnection)
   */
  deleteManyHeroCarouselComponents: BatchPayload;
  /** Delete many HeroCarouselComponent documents, return deleted documents */
  deleteManyHeroCarouselComponentsConnection: HeroCarouselComponentConnection;
  /**
   * Delete many HeroComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyHeroComponentsConnection)
   */
  deleteManyHeroComponents: BatchPayload;
  /** Delete many HeroComponent documents, return deleted documents */
  deleteManyHeroComponentsConnection: HeroComponentConnection;
  /**
   * Delete many HeroLoopAnimationComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyHeroLoopAnimationComponentsConnection)
   */
  deleteManyHeroLoopAnimationComponents: BatchPayload;
  /** Delete many HeroLoopAnimationComponent documents, return deleted documents */
  deleteManyHeroLoopAnimationComponentsConnection: HeroLoopAnimationComponentConnection;
  /**
   * Delete many Iframe documents
   * @deprecated Please use the new paginated many mutation (deleteManyIframesConnection)
   */
  deleteManyIframes: BatchPayload;
  /** Delete many Iframe documents, return deleted documents */
  deleteManyIframesConnection: IframeConnection;
  /**
   * Delete many ImageAndTextCard documents
   * @deprecated Please use the new paginated many mutation (deleteManyImageAndTextCardsConnection)
   */
  deleteManyImageAndTextCards: BatchPayload;
  /** Delete many ImageAndTextCard documents, return deleted documents */
  deleteManyImageAndTextCardsConnection: ImageAndTextCardConnection;
  /**
   * Delete many ImageCopy documents
   * @deprecated Please use the new paginated many mutation (deleteManyImageCopiesConnection)
   */
  deleteManyImageCopies: BatchPayload;
  /** Delete many ImageCopy documents, return deleted documents */
  deleteManyImageCopiesConnection: ImageCopyConnection;
  /**
   * Delete many ImageCopyItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyImageCopyItemsConnection)
   */
  deleteManyImageCopyItems: BatchPayload;
  /** Delete many ImageCopyItem documents, return deleted documents */
  deleteManyImageCopyItemsConnection: ImageCopyItemConnection;
  /**
   * Delete many IntroText documents
   * @deprecated Please use the new paginated many mutation (deleteManyIntroTextsConnection)
   */
  deleteManyIntroTexts: BatchPayload;
  /** Delete many IntroText documents, return deleted documents */
  deleteManyIntroTextsConnection: IntroTextConnection;
  /**
   * Delete many LeftColumn documents
   * @deprecated Please use the new paginated many mutation (deleteManyLeftColumnsConnection)
   */
  deleteManyLeftColumns: BatchPayload;
  /** Delete many LeftColumn documents, return deleted documents */
  deleteManyLeftColumnsConnection: LeftColumnConnection;
  /**
   * Delete many Link documents
   * @deprecated Please use the new paginated many mutation (deleteManyLinksConnection)
   */
  deleteManyLinks: BatchPayload;
  /** Delete many Link documents, return deleted documents */
  deleteManyLinksConnection: LinkConnection;
  /**
   * Delete many LongText documents
   * @deprecated Please use the new paginated many mutation (deleteManyLongTextsConnection)
   */
  deleteManyLongTexts: BatchPayload;
  /** Delete many LongText documents, return deleted documents */
  deleteManyLongTextsConnection: LongTextConnection;
  /**
   * Delete many MarketUserConnection documents
   * @deprecated Please use the new paginated many mutation (deleteManyMarketUserConnectionsConnection)
   */
  deleteManyMarketUserConnections: BatchPayload;
  /** Delete many MarketUserConnection documents, return deleted documents */
  deleteManyMarketUserConnectionsConnection: MarketUserConnectionConnection;
  /**
   * Delete many Market documents
   * @deprecated Please use the new paginated many mutation (deleteManyMarketsConnection)
   */
  deleteManyMarkets: BatchPayload;
  /** Delete many Market documents, return deleted documents */
  deleteManyMarketsConnection: MarketConnection;
  /**
   * Delete many MetaData documents
   * @deprecated Please use the new paginated many mutation (deleteManyMetaDatasConnection)
   */
  deleteManyMetaDatas: BatchPayload;
  /** Delete many MetaData documents, return deleted documents */
  deleteManyMetaDatasConnection: MetaDataConnection;
  /**
   * Delete many MobileOnlyMainNavigation documents
   * @deprecated Please use the new paginated many mutation (deleteManyMobileOnlyMainNavigationsConnection)
   */
  deleteManyMobileOnlyMainNavigations: BatchPayload;
  /** Delete many MobileOnlyMainNavigation documents, return deleted documents */
  deleteManyMobileOnlyMainNavigationsConnection: MobileOnlyMainNavigationConnection;
  /**
   * Delete many MultiStepPromotionForm documents
   * @deprecated Please use the new paginated many mutation (deleteManyMultiStepPromotionFormsConnection)
   */
  deleteManyMultiStepPromotionForms: BatchPayload;
  /** Delete many MultiStepPromotionForm documents, return deleted documents */
  deleteManyMultiStepPromotionFormsConnection: MultiStepPromotionFormConnection;
  /**
   * Delete many NavigationItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyNavigationItemsConnection)
   */
  deleteManyNavigationItems: BatchPayload;
  /** Delete many NavigationItem documents, return deleted documents */
  deleteManyNavigationItemsConnection: NavigationItemConnection;
  /**
   * Delete many Navigation documents
   * @deprecated Please use the new paginated many mutation (deleteManyNavigationsConnection)
   */
  deleteManyNavigations: BatchPayload;
  /** Delete many Navigation documents, return deleted documents */
  deleteManyNavigationsConnection: NavigationConnection;
  /**
   * Delete many NewsletterComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyNewsletterComponentsConnection)
   */
  deleteManyNewsletterComponents: BatchPayload;
  /** Delete many NewsletterComponent documents, return deleted documents */
  deleteManyNewsletterComponentsConnection: NewsletterComponentConnection;
  /**
   * Delete many NewsletterSubscriptions documents
   * @deprecated Please use the new paginated many mutation (deleteManyNewsletterSubscriptionsPluralConnection)
   */
  deleteManyNewsletterSubscriptionsPlural: BatchPayload;
  /** Delete many NewsletterSubscriptions documents, return deleted documents */
  deleteManyNewsletterSubscriptionsPluralConnection: NewsletterSubscriptionsConnection;
  /**
   * Delete many NotificationBanner documents
   * @deprecated Please use the new paginated many mutation (deleteManyNotificationBannersConnection)
   */
  deleteManyNotificationBanners: BatchPayload;
  /** Delete many NotificationBanner documents, return deleted documents */
  deleteManyNotificationBannersConnection: NotificationBannerConnection;
  /**
   * Delete many PageFooter documents
   * @deprecated Please use the new paginated many mutation (deleteManyPageFootersConnection)
   */
  deleteManyPageFooters: BatchPayload;
  /** Delete many PageFooter documents, return deleted documents */
  deleteManyPageFootersConnection: PageFooterConnection;
  /**
   * Delete many PageHeader documents
   * @deprecated Please use the new paginated many mutation (deleteManyPageHeadersConnection)
   */
  deleteManyPageHeaders: BatchPayload;
  /** Delete many PageHeader documents, return deleted documents */
  deleteManyPageHeadersConnection: PageHeaderConnection;
  /**
   * Delete many PopularSearchComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyPopularSearchComponentsConnection)
   */
  deleteManyPopularSearchComponents: BatchPayload;
  /** Delete many PopularSearchComponent documents, return deleted documents */
  deleteManyPopularSearchComponentsConnection: PopularSearchComponentConnection;
  /**
   * Delete many ProductBanner documents
   * @deprecated Please use the new paginated many mutation (deleteManyProductBannersConnection)
   */
  deleteManyProductBanners: BatchPayload;
  /** Delete many ProductBanner documents, return deleted documents */
  deleteManyProductBannersConnection: ProductBannerConnection;
  /**
   * Delete many ProductCategory documents
   * @deprecated Please use the new paginated many mutation (deleteManyProductCategoriesConnection)
   */
  deleteManyProductCategories: BatchPayload;
  /** Delete many ProductCategory documents, return deleted documents */
  deleteManyProductCategoriesConnection: ProductCategoryConnection;
  /**
   * Delete many ProductCategoryPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyProductCategoryPagesConnection)
   */
  deleteManyProductCategoryPages: BatchPayload;
  /** Delete many ProductCategoryPage documents, return deleted documents */
  deleteManyProductCategoryPagesConnection: ProductCategoryPageConnection;
  /**
   * Delete many ProductDetailPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyProductDetailPagesConnection)
   */
  deleteManyProductDetailPages: BatchPayload;
  /** Delete many ProductDetailPage documents, return deleted documents */
  deleteManyProductDetailPagesConnection: ProductDetailPageConnection;
  /**
   * Delete many ProductHero documents
   * @deprecated Please use the new paginated many mutation (deleteManyProductHeroesConnection)
   */
  deleteManyProductHeroes: BatchPayload;
  /** Delete many ProductHero documents, return deleted documents */
  deleteManyProductHeroesConnection: ProductHeroConnection;
  /**
   * Delete many ProductLabel documents
   * @deprecated Please use the new paginated many mutation (deleteManyProductLabelsConnection)
   */
  deleteManyProductLabels: BatchPayload;
  /** Delete many ProductLabel documents, return deleted documents */
  deleteManyProductLabelsConnection: ProductLabelConnection;
  /**
   * Delete many ProductLandingPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyProductLandingPagesConnection)
   */
  deleteManyProductLandingPages: BatchPayload;
  /** Delete many ProductLandingPage documents, return deleted documents */
  deleteManyProductLandingPagesConnection: ProductLandingPageConnection;
  /**
   * Delete many ProductSubcategoryPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyProductSubcategoryPagesConnection)
   */
  deleteManyProductSubcategoryPages: BatchPayload;
  /** Delete many ProductSubcategoryPage documents, return deleted documents */
  deleteManyProductSubcategoryPagesConnection: ProductSubcategoryPageConnection;
  /**
   * Delete many Product documents
   * @deprecated Please use the new paginated many mutation (deleteManyProductsConnection)
   */
  deleteManyProducts: BatchPayload;
  /** Delete many Product documents, return deleted documents */
  deleteManyProductsConnection: ProductConnection;
  /**
   * Delete many PromotionDownload documents
   * @deprecated Please use the new paginated many mutation (deleteManyPromotionDownloadsConnection)
   */
  deleteManyPromotionDownloads: BatchPayload;
  /** Delete many PromotionDownload documents, return deleted documents */
  deleteManyPromotionDownloadsConnection: PromotionDownloadConnection;
  /**
   * Delete many PromotionForm documents
   * @deprecated Please use the new paginated many mutation (deleteManyPromotionFormsConnection)
   */
  deleteManyPromotionForms: BatchPayload;
  /** Delete many PromotionForm documents, return deleted documents */
  deleteManyPromotionFormsConnection: PromotionFormConnection;
  /**
   * Delete many QuestionCheckboxCollection documents
   * @deprecated Please use the new paginated many mutation (deleteManyQuestionCheckboxCollectionsConnection)
   */
  deleteManyQuestionCheckboxCollections: BatchPayload;
  /** Delete many QuestionCheckboxCollection documents, return deleted documents */
  deleteManyQuestionCheckboxCollectionsConnection: QuestionCheckboxCollectionConnection;
  /**
   * Delete many QuestionCheckbox documents
   * @deprecated Please use the new paginated many mutation (deleteManyQuestionCheckboxesConnection)
   */
  deleteManyQuestionCheckboxes: BatchPayload;
  /** Delete many QuestionCheckbox documents, return deleted documents */
  deleteManyQuestionCheckboxesConnection: QuestionCheckboxConnection;
  /**
   * Delete many QuestionRadioButtonCollection documents
   * @deprecated Please use the new paginated many mutation (deleteManyQuestionRadioButtonCollectionsConnection)
   */
  deleteManyQuestionRadioButtonCollections: BatchPayload;
  /** Delete many QuestionRadioButtonCollection documents, return deleted documents */
  deleteManyQuestionRadioButtonCollectionsConnection: QuestionRadioButtonCollectionConnection;
  /**
   * Delete many QuestionRadioButton documents
   * @deprecated Please use the new paginated many mutation (deleteManyQuestionRadioButtonsConnection)
   */
  deleteManyQuestionRadioButtons: BatchPayload;
  /** Delete many QuestionRadioButton documents, return deleted documents */
  deleteManyQuestionRadioButtonsConnection: QuestionRadioButtonConnection;
  /**
   * Delete many Question documents
   * @deprecated Please use the new paginated many mutation (deleteManyQuestionsConnection)
   */
  deleteManyQuestions: BatchPayload;
  /** Delete many Question documents, return deleted documents */
  deleteManyQuestionsConnection: QuestionConnection;
  /**
   * Delete many Rating documents
   * @deprecated Please use the new paginated many mutation (deleteManyRatingsConnection)
   */
  deleteManyRatings: BatchPayload;
  /** Delete many Rating documents, return deleted documents */
  deleteManyRatingsConnection: RatingConnection;
  /**
   * Delete many RecipeCategory documents
   * @deprecated Please use the new paginated many mutation (deleteManyRecipeCategoriesConnection)
   */
  deleteManyRecipeCategories: BatchPayload;
  /** Delete many RecipeCategory documents, return deleted documents */
  deleteManyRecipeCategoriesConnection: RecipeCategoryConnection;
  /**
   * Delete many RecipeLandingPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyRecipeLandingPagesConnection)
   */
  deleteManyRecipeLandingPages: BatchPayload;
  /** Delete many RecipeLandingPage documents, return deleted documents */
  deleteManyRecipeLandingPagesConnection: RecipeLandingPageConnection;
  /**
   * Delete many RecipeSubcategory documents
   * @deprecated Please use the new paginated many mutation (deleteManyRecipeSubcategoriesConnection)
   */
  deleteManyRecipeSubcategories: BatchPayload;
  /** Delete many RecipeSubcategory documents, return deleted documents */
  deleteManyRecipeSubcategoriesConnection: RecipeSubcategoryConnection;
  /**
   * Delete many Recipe documents
   * @deprecated Please use the new paginated many mutation (deleteManyRecipesConnection)
   */
  deleteManyRecipes: BatchPayload;
  /**
   * Delete many RecipesComparisonQueryComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyRecipesComparisonQueryComponentsConnection)
   */
  deleteManyRecipesComparisonQueryComponents: BatchPayload;
  /** Delete many RecipesComparisonQueryComponent documents, return deleted documents */
  deleteManyRecipesComparisonQueryComponentsConnection: RecipesComparisonQueryComponentConnection;
  /** Delete many Recipe documents, return deleted documents */
  deleteManyRecipesConnection: RecipeConnection;
  /**
   * Delete many RecipesQueriesReference documents
   * @deprecated Please use the new paginated many mutation (deleteManyRecipesQueriesReferencesConnection)
   */
  deleteManyRecipesQueriesReferences: BatchPayload;
  /** Delete many RecipesQueriesReference documents, return deleted documents */
  deleteManyRecipesQueriesReferencesConnection: RecipesQueriesReferenceConnection;
  /**
   * Delete many RecipesQueryComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyRecipesQueryComponentsConnection)
   */
  deleteManyRecipesQueryComponents: BatchPayload;
  /** Delete many RecipesQueryComponent documents, return deleted documents */
  deleteManyRecipesQueryComponentsConnection: RecipesQueryComponentConnection;
  /**
   * Delete many Redirect documents
   * @deprecated Please use the new paginated many mutation (deleteManyRedirectsConnection)
   */
  deleteManyRedirects: BatchPayload;
  /** Delete many Redirect documents, return deleted documents */
  deleteManyRedirectsConnection: RedirectConnection;
  /**
   * Delete many Rewrite documents
   * @deprecated Please use the new paginated many mutation (deleteManyRewritesConnection)
   */
  deleteManyRewrites: BatchPayload;
  /** Delete many Rewrite documents, return deleted documents */
  deleteManyRewritesConnection: RewriteConnection;
  /**
   * Delete many RightColumn documents
   * @deprecated Please use the new paginated many mutation (deleteManyRightColumnsConnection)
   */
  deleteManyRightColumns: BatchPayload;
  /** Delete many RightColumn documents, return deleted documents */
  deleteManyRightColumnsConnection: RightColumnConnection;
  /**
   * Delete many SearchInput documents
   * @deprecated Please use the new paginated many mutation (deleteManySearchInputsConnection)
   */
  deleteManySearchInputs: BatchPayload;
  /** Delete many SearchInput documents, return deleted documents */
  deleteManySearchInputsConnection: SearchInputConnection;
  /**
   * Delete many SearchOverlayComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManySearchOverlayComponentsConnection)
   */
  deleteManySearchOverlayComponents: BatchPayload;
  /** Delete many SearchOverlayComponent documents, return deleted documents */
  deleteManySearchOverlayComponentsConnection: SearchOverlayComponentConnection;
  /**
   * Delete many SearchResultPage documents
   * @deprecated Please use the new paginated many mutation (deleteManySearchResultPagesConnection)
   */
  deleteManySearchResultPages: BatchPayload;
  /** Delete many SearchResultPage documents, return deleted documents */
  deleteManySearchResultPagesConnection: SearchResultPageConnection;
  /**
   * Delete many Separator documents
   * @deprecated Please use the new paginated many mutation (deleteManySeparatorsConnection)
   */
  deleteManySeparators: BatchPayload;
  /** Delete many Separator documents, return deleted documents */
  deleteManySeparatorsConnection: SeparatorConnection;
  /**
   * Delete many SingleStepPromotionForm documents
   * @deprecated Please use the new paginated many mutation (deleteManySingleStepPromotionFormsConnection)
   */
  deleteManySingleStepPromotionForms: BatchPayload;
  /** Delete many SingleStepPromotionForm documents, return deleted documents */
  deleteManySingleStepPromotionFormsConnection: SingleStepPromotionFormConnection;
  /**
   * Delete many SocialMediaListComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManySocialMediaListComponentsConnection)
   */
  deleteManySocialMediaListComponents: BatchPayload;
  /** Delete many SocialMediaListComponent documents, return deleted documents */
  deleteManySocialMediaListComponentsConnection: SocialMediaListComponentConnection;
  /**
   * Delete many Spacer documents
   * @deprecated Please use the new paginated many mutation (deleteManySpacersConnection)
   */
  deleteManySpacers: BatchPayload;
  /** Delete many Spacer documents, return deleted documents */
  deleteManySpacersConnection: SpacerConnection;
  /**
   * Delete many SubCategoryKeyImage documents
   * @deprecated Please use the new paginated many mutation (deleteManySubCategoryKeyImagesConnection)
   */
  deleteManySubCategoryKeyImages: BatchPayload;
  /** Delete many SubCategoryKeyImage documents, return deleted documents */
  deleteManySubCategoryKeyImagesConnection: SubCategoryKeyImageConnection;
  /**
   * Delete many SubTab documents
   * @deprecated Please use the new paginated many mutation (deleteManySubTabsConnection)
   */
  deleteManySubTabs: BatchPayload;
  /** Delete many SubTab documents, return deleted documents */
  deleteManySubTabsConnection: SubTabConnection;
  /**
   * Delete many SubTabContent documents
   * @deprecated Please use the new paginated many mutation (deleteManySubTabsContentConnection)
   */
  deleteManySubTabsContent: BatchPayload;
  /** Delete many SubTabContent documents, return deleted documents */
  deleteManySubTabsContentConnection: SubTabContentConnection;
  /**
   * Delete many SustainabilityBanner documents
   * @deprecated Please use the new paginated many mutation (deleteManySustainabilityBannersConnection)
   */
  deleteManySustainabilityBanners: BatchPayload;
  /** Delete many SustainabilityBanner documents, return deleted documents */
  deleteManySustainabilityBannersConnection: SustainabilityBannerConnection;
  /**
   * Delete many SustainabilityInfo documents
   * @deprecated Please use the new paginated many mutation (deleteManySustainabilityInfosConnection)
   */
  deleteManySustainabilityInfos: BatchPayload;
  /** Delete many SustainabilityInfo documents, return deleted documents */
  deleteManySustainabilityInfosConnection: SustainabilityInfoConnection;
  /**
   * Delete many TabContent documents
   * @deprecated Please use the new paginated many mutation (deleteManyTabContentsConnection)
   */
  deleteManyTabContents: BatchPayload;
  /** Delete many TabContent documents, return deleted documents */
  deleteManyTabContentsConnection: TabContentConnection;
  /**
   * Delete many Tab documents
   * @deprecated Please use the new paginated many mutation (deleteManyTabsConnection)
   */
  deleteManyTabs: BatchPayload;
  /** Delete many Tab documents, return deleted documents */
  deleteManyTabsConnection: TabConnection;
  /**
   * Delete many TeaserPlaceholder documents
   * @deprecated Please use the new paginated many mutation (deleteManyTeaserPlaceholdersConnection)
   */
  deleteManyTeaserPlaceholders: BatchPayload;
  /** Delete many TeaserPlaceholder documents, return deleted documents */
  deleteManyTeaserPlaceholdersConnection: TeaserPlaceholderConnection;
  /**
   * Delete many TeaserSmallPlaceholder documents
   * @deprecated Please use the new paginated many mutation (deleteManyTeaserSmallPlaceholdersConnection)
   */
  deleteManyTeaserSmallPlaceholders: BatchPayload;
  /** Delete many TeaserSmallPlaceholder documents, return deleted documents */
  deleteManyTeaserSmallPlaceholdersConnection: TeaserSmallPlaceholderConnection;
  /**
   * Delete many TeaserSmall documents
   * @deprecated Please use the new paginated many mutation (deleteManyTeaserSmallsConnection)
   */
  deleteManyTeaserSmalls: BatchPayload;
  /** Delete many TeaserSmall documents, return deleted documents */
  deleteManyTeaserSmallsConnection: TeaserSmallConnection;
  /**
   * Delete many Teaser documents
   * @deprecated Please use the new paginated many mutation (deleteManyTeasersConnection)
   */
  deleteManyTeasers: BatchPayload;
  /** Delete many Teaser documents, return deleted documents */
  deleteManyTeasersConnection: TeaserConnection;
  /**
   * Delete many TestComponentWithRecipeQuery documents
   * @deprecated Please use the new paginated many mutation (deleteManyTestComponentWithRecipeQueriesConnection)
   */
  deleteManyTestComponentWithRecipeQueries: BatchPayload;
  /** Delete many TestComponentWithRecipeQuery documents, return deleted documents */
  deleteManyTestComponentWithRecipeQueriesConnection: TestComponentWithRecipeQueryConnection;
  /**
   * Delete many TestTipsANdTricksInAMarket documents
   * @deprecated Please use the new paginated many mutation (deleteManyTestTipsANdTricksInAMarketsConnection)
   */
  deleteManyTestTipsANdTricksInAMarkets: BatchPayload;
  /** Delete many TestTipsANdTricksInAMarket documents, return deleted documents */
  deleteManyTestTipsANdTricksInAMarketsConnection: TestTipsANdTricksInAMarketConnection;
  /**
   * Delete many TextComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyTextComponentsConnection)
   */
  deleteManyTextComponents: BatchPayload;
  /** Delete many TextComponent documents, return deleted documents */
  deleteManyTextComponentsConnection: TextComponentConnection;
  /**
   * Delete many TipsAndTricksDetailsPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyTipsAndTricksDetailsPagesConnection)
   */
  deleteManyTipsAndTricksDetailsPages: BatchPayload;
  /** Delete many TipsAndTricksDetailsPage documents, return deleted documents */
  deleteManyTipsAndTricksDetailsPagesConnection: TipsAndTricksDetailsPageConnection;
  /**
   * Delete many Title documents
   * @deprecated Please use the new paginated many mutation (deleteManyTitlesConnection)
   */
  deleteManyTitles: BatchPayload;
  /** Delete many Title documents, return deleted documents */
  deleteManyTitlesConnection: TitleConnection;
  /**
   * Delete many TwitterSeo documents
   * @deprecated Please use the new paginated many mutation (deleteManyTwitterSeosConnection)
   */
  deleteManyTwitterSeos: BatchPayload;
  /** Delete many TwitterSeo documents, return deleted documents */
  deleteManyTwitterSeosConnection: TwitterSeoConnection;
  /** Delete one market from _all_ existing stages. Returns deleted document. */
  deleteMarket?: Maybe<Market>;
  /** Delete one marketUserConnection from _all_ existing stages. Returns deleted document. */
  deleteMarketUserConnection?: Maybe<MarketUserConnection>;
  /** Delete one metaData from _all_ existing stages. Returns deleted document. */
  deleteMetaData?: Maybe<MetaData>;
  /** Delete one mobileOnlyMainNavigation from _all_ existing stages. Returns deleted document. */
  deleteMobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Delete one multiStepPromotionForm from _all_ existing stages. Returns deleted document. */
  deleteMultiStepPromotionForm?: Maybe<MultiStepPromotionForm>;
  /** Delete one navigation from _all_ existing stages. Returns deleted document. */
  deleteNavigation?: Maybe<Navigation>;
  /** Delete one navigationItem from _all_ existing stages. Returns deleted document. */
  deleteNavigationItem?: Maybe<NavigationItem>;
  /** Delete one newsletterComponent from _all_ existing stages. Returns deleted document. */
  deleteNewsletterComponent?: Maybe<NewsletterComponent>;
  /** Delete one newsletterSubscriptions from _all_ existing stages. Returns deleted document. */
  deleteNewsletterSubscriptions?: Maybe<NewsletterSubscriptions>;
  /** Delete one notificationBanner from _all_ existing stages. Returns deleted document. */
  deleteNotificationBanner?: Maybe<NotificationBanner>;
  /** Delete one pageFooter from _all_ existing stages. Returns deleted document. */
  deletePageFooter?: Maybe<PageFooter>;
  /** Delete one pageHeader from _all_ existing stages. Returns deleted document. */
  deletePageHeader?: Maybe<PageHeader>;
  /** Delete one popularSearchComponent from _all_ existing stages. Returns deleted document. */
  deletePopularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Delete one product from _all_ existing stages. Returns deleted document. */
  deleteProduct?: Maybe<Product>;
  /** Delete one productBanner from _all_ existing stages. Returns deleted document. */
  deleteProductBanner?: Maybe<ProductBanner>;
  /** Delete one productCategory from _all_ existing stages. Returns deleted document. */
  deleteProductCategory?: Maybe<ProductCategory>;
  /** Delete one productCategoryPage from _all_ existing stages. Returns deleted document. */
  deleteProductCategoryPage?: Maybe<ProductCategoryPage>;
  /** Delete one productDetailPage from _all_ existing stages. Returns deleted document. */
  deleteProductDetailPage?: Maybe<ProductDetailPage>;
  /** Delete one productHero from _all_ existing stages. Returns deleted document. */
  deleteProductHero?: Maybe<ProductHero>;
  /** Delete one productLabel from _all_ existing stages. Returns deleted document. */
  deleteProductLabel?: Maybe<ProductLabel>;
  /** Delete one productLandingPage from _all_ existing stages. Returns deleted document. */
  deleteProductLandingPage?: Maybe<ProductLandingPage>;
  /** Delete one productSubcategoryPage from _all_ existing stages. Returns deleted document. */
  deleteProductSubcategoryPage?: Maybe<ProductSubcategoryPage>;
  /** Delete one promotionDownload from _all_ existing stages. Returns deleted document. */
  deletePromotionDownload?: Maybe<PromotionDownload>;
  /** Delete one promotionForm from _all_ existing stages. Returns deleted document. */
  deletePromotionForm?: Maybe<PromotionForm>;
  /** Delete one question from _all_ existing stages. Returns deleted document. */
  deleteQuestion?: Maybe<Question>;
  /** Delete one questionCheckbox from _all_ existing stages. Returns deleted document. */
  deleteQuestionCheckbox?: Maybe<QuestionCheckbox>;
  /** Delete one questionCheckboxCollection from _all_ existing stages. Returns deleted document. */
  deleteQuestionCheckboxCollection?: Maybe<QuestionCheckboxCollection>;
  /** Delete one questionRadioButton from _all_ existing stages. Returns deleted document. */
  deleteQuestionRadioButton?: Maybe<QuestionRadioButton>;
  /** Delete one questionRadioButtonCollection from _all_ existing stages. Returns deleted document. */
  deleteQuestionRadioButtonCollection?: Maybe<QuestionRadioButtonCollection>;
  /** Delete one rating from _all_ existing stages. Returns deleted document. */
  deleteRating?: Maybe<Rating>;
  /** Delete one recipe from _all_ existing stages. Returns deleted document. */
  deleteRecipe?: Maybe<Recipe>;
  /** Delete one recipeCategory from _all_ existing stages. Returns deleted document. */
  deleteRecipeCategory?: Maybe<RecipeCategory>;
  /** Delete one recipeLandingPage from _all_ existing stages. Returns deleted document. */
  deleteRecipeLandingPage?: Maybe<RecipeLandingPage>;
  /** Delete one recipeSubcategory from _all_ existing stages. Returns deleted document. */
  deleteRecipeSubcategory?: Maybe<RecipeSubcategory>;
  /** Delete one recipesComparisonQueryComponent from _all_ existing stages. Returns deleted document. */
  deleteRecipesComparisonQueryComponent?: Maybe<RecipesComparisonQueryComponent>;
  /** Delete one recipesQueriesReference from _all_ existing stages. Returns deleted document. */
  deleteRecipesQueriesReference?: Maybe<RecipesQueriesReference>;
  /** Delete one recipesQueryComponent from _all_ existing stages. Returns deleted document. */
  deleteRecipesQueryComponent?: Maybe<RecipesQueryComponent>;
  /** Delete one redirect from _all_ existing stages. Returns deleted document. */
  deleteRedirect?: Maybe<Redirect>;
  /** Delete one rewrite from _all_ existing stages. Returns deleted document. */
  deleteRewrite?: Maybe<Rewrite>;
  /** Delete one rightColumn from _all_ existing stages. Returns deleted document. */
  deleteRightColumn?: Maybe<RightColumn>;
  /** Delete and return scheduled operation */
  deleteScheduledOperation?: Maybe<ScheduledOperation>;
  /** Delete one scheduledRelease from _all_ existing stages. Returns deleted document. */
  deleteScheduledRelease?: Maybe<ScheduledRelease>;
  /** Delete one searchInput from _all_ existing stages. Returns deleted document. */
  deleteSearchInput?: Maybe<SearchInput>;
  /** Delete one searchOverlayComponent from _all_ existing stages. Returns deleted document. */
  deleteSearchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Delete one searchResultPage from _all_ existing stages. Returns deleted document. */
  deleteSearchResultPage?: Maybe<SearchResultPage>;
  /** Delete one separator from _all_ existing stages. Returns deleted document. */
  deleteSeparator?: Maybe<Separator>;
  /** Delete one singleStepPromotionForm from _all_ existing stages. Returns deleted document. */
  deleteSingleStepPromotionForm?: Maybe<SingleStepPromotionForm>;
  /** Delete one socialMediaListComponent from _all_ existing stages. Returns deleted document. */
  deleteSocialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Delete one spacer from _all_ existing stages. Returns deleted document. */
  deleteSpacer?: Maybe<Spacer>;
  /** Delete one subCategoryKeyImage from _all_ existing stages. Returns deleted document. */
  deleteSubCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Delete one subTab from _all_ existing stages. Returns deleted document. */
  deleteSubTab?: Maybe<SubTab>;
  /** Delete one subTabContent from _all_ existing stages. Returns deleted document. */
  deleteSubTabContent?: Maybe<SubTabContent>;
  /** Delete one sustainabilityBanner from _all_ existing stages. Returns deleted document. */
  deleteSustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Delete one sustainabilityInfo from _all_ existing stages. Returns deleted document. */
  deleteSustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Delete one tab from _all_ existing stages. Returns deleted document. */
  deleteTab?: Maybe<Tab>;
  /** Delete one tabContent from _all_ existing stages. Returns deleted document. */
  deleteTabContent?: Maybe<TabContent>;
  /** Delete one teaser from _all_ existing stages. Returns deleted document. */
  deleteTeaser?: Maybe<Teaser>;
  /** Delete one teaserPlaceholder from _all_ existing stages. Returns deleted document. */
  deleteTeaserPlaceholder?: Maybe<TeaserPlaceholder>;
  /** Delete one teaserSmall from _all_ existing stages. Returns deleted document. */
  deleteTeaserSmall?: Maybe<TeaserSmall>;
  /** Delete one teaserSmallPlaceholder from _all_ existing stages. Returns deleted document. */
  deleteTeaserSmallPlaceholder?: Maybe<TeaserSmallPlaceholder>;
  /** Delete one testComponentWithRecipeQuery from _all_ existing stages. Returns deleted document. */
  deleteTestComponentWithRecipeQuery?: Maybe<TestComponentWithRecipeQuery>;
  /** Delete one testTipsANdTricksInAMarket from _all_ existing stages. Returns deleted document. */
  deleteTestTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Delete one textComponent from _all_ existing stages. Returns deleted document. */
  deleteTextComponent?: Maybe<TextComponent>;
  /** Delete one tipsAndTricksDetailsPage from _all_ existing stages. Returns deleted document. */
  deleteTipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Delete one title from _all_ existing stages. Returns deleted document. */
  deleteTitle?: Maybe<Title>;
  /** Delete one twitterSeo from _all_ existing stages. Returns deleted document. */
  deleteTwitterSeo?: Maybe<TwitterSeo>;
  /** Publish one accordion */
  publishAccordion?: Maybe<Accordion>;
  /** Publish one accordionItem */
  publishAccordionItem?: Maybe<AccordionItem>;
  /** Publish one algoliaExtension */
  publishAlgoliaExtension?: Maybe<AlgoliaExtension>;
  /** Publish one anchorNav */
  publishAnchorNav?: Maybe<AnchorNav>;
  /** Publish one anchorNavigation */
  publishAnchorNavigation?: Maybe<AnchorNavigation>;
  /** Publish one anchorNavigationList */
  publishAnchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Publish one asset */
  publishAsset?: Maybe<Asset>;
  /** Publish one assetComponent */
  publishAssetComponent?: Maybe<AssetComponent>;
  /** Publish one audioComponent */
  publishAudioComponent?: Maybe<AudioComponent>;
  /** Publish one authorableContentCard */
  publishAuthorableContentCard?: Maybe<AuthorableContentCard>;
  /** Publish one banner1 */
  publishBanner1?: Maybe<Banner1>;
  /** Publish one banner2 */
  publishBanner2?: Maybe<Banner2>;
  /** Publish one banner2CarouselComponent */
  publishBanner2CarouselComponent?: Maybe<Banner2CarouselComponent>;
  /** Publish one cardComponent */
  publishCardComponent?: Maybe<CardComponent>;
  /** Publish one carouselComponent */
  publishCarouselComponent?: Maybe<CarouselComponent>;
  /** Publish one carouselSlide */
  publishCarouselSlide?: Maybe<CarouselSlide>;
  /** Publish one categoryCard */
  publishCategoryCard?: Maybe<CategoryCard>;
  /** Publish one contactCard */
  publishContactCard?: Maybe<ContactCard>;
  /** Publish one contactCardContainer */
  publishContactCardContainer?: Maybe<ContactCardContainer>;
  /** Publish one countrySelectorFooter */
  publishCountrySelectorFooter?: Maybe<CountrySelectorFooter>;
  /** Publish one countrySelectorItem */
  publishCountrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Publish one demoModel */
  publishDemoModel?: Maybe<DemoModel>;
  /** Publish one dictionary */
  publishDictionary?: Maybe<Dictionary>;
  /** Publish one dictionaryItem */
  publishDictionaryItem?: Maybe<DictionaryItem>;
  /** Publish one downloadApp */
  publishDownloadApp?: Maybe<DownloadApp>;
  /** Publish one dynamicCardGrid */
  publishDynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Publish one errorPage */
  publishErrorPage?: Maybe<ErrorPage>;
  /** Publish one evalancheFormComponent */
  publishEvalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Publish one exampleComponent */
  publishExampleComponent?: Maybe<ExampleComponent>;
  /** Publish one featuredContent */
  publishFeaturedContent?: Maybe<FeaturedContent>;
  /** Publish one featuredContentReference */
  publishFeaturedContentReference?: Maybe<FeaturedContentReference>;
  /** Publish one footerNavigation */
  publishFooterNavigation?: Maybe<FooterNavigation>;
  /** Publish one footerSeal */
  publishFooterSeal?: Maybe<FooterSeal>;
  /** Publish one form */
  publishForm?: Maybe<Form>;
  /** Publish one formCheckbox */
  publishFormCheckbox?: Maybe<FormCheckbox>;
  /** Publish one formCheckboxCollection */
  publishFormCheckboxCollection?: Maybe<FormCheckboxCollection>;
  /** Publish one formDateInput */
  publishFormDateInput?: Maybe<FormDateInput>;
  /** Publish one formEmailInput */
  publishFormEmailInput?: Maybe<FormEmailInput>;
  /** Publish one formError */
  publishFormError?: Maybe<FormError>;
  /** Publish one formFileUploader */
  publishFormFileUploader?: Maybe<FormFileUploader>;
  /** Publish one formList */
  publishFormList?: Maybe<FormList>;
  /** Publish one formListItem */
  publishFormListItem?: Maybe<FormListItem>;
  /** Publish one formNumberInput */
  publishFormNumberInput?: Maybe<FormNumberInput>;
  /** Publish one formPasswordInput */
  publishFormPasswordInput?: Maybe<FormPasswordInput>;
  /** Publish one formPasswordInputWithConfirmation */
  publishFormPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Publish one formRadioButton */
  publishFormRadioButton?: Maybe<FormRadioButton>;
  /** Publish one formRadioButtonCollection */
  publishFormRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Publish one formSelectComponent */
  publishFormSelectComponent?: Maybe<FormSelectComponent>;
  /** Publish one formSelectOption */
  publishFormSelectOption?: Maybe<FormSelectOption>;
  /** Publish one formSubmitButton */
  publishFormSubmitButton?: Maybe<FormSubmitButton>;
  /** Publish one formSuccessComponent */
  publishFormSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Publish one formTextInput */
  publishFormTextInput?: Maybe<FormTextInput>;
  /** Publish one formTextareaInput */
  publishFormTextareaInput?: Maybe<FormTextareaInput>;
  /** Publish one genericAccordion */
  publishGenericAccordion?: Maybe<GenericAccordion>;
  /** Publish one genericAccordionItem */
  publishGenericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Publish one genericAccordionTopRated */
  publishGenericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Publish one genericCardCarouseComponent */
  publishGenericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Publish one genericDownloadComponent */
  publishGenericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Publish one genericFollowUs */
  publishGenericFollowUs?: Maybe<GenericFollowUs>;
  /** Publish one genericGridAuthorable */
  publishGenericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Publish one genericHtml */
  publishGenericHtml?: Maybe<GenericHtml>;
  /** Publish one genericLine */
  publishGenericLine?: Maybe<GenericLine>;
  /** Publish one genericLink */
  publishGenericLink?: Maybe<GenericLink>;
  /** Publish one genericPage */
  publishGenericPage?: Maybe<GenericPage>;
  /** Publish one genericPromotionsOverview */
  publishGenericPromotionsOverview?: Maybe<GenericPromotionsOverview>;
  /** Publish one genericQualifio */
  publishGenericQualifio?: Maybe<GenericQualifio>;
  /** Publish one genericQualifioOverview */
  publishGenericQualifioOverview?: Maybe<GenericQualifioOverview>;
  /** Publish one genericSocialShare */
  publishGenericSocialShare?: Maybe<GenericSocialShare>;
  /** Publish one globalMetaData */
  publishGlobalMetaData?: Maybe<GlobalMetaData>;
  /** Publish one globalSearch */
  publishGlobalSearch?: Maybe<GlobalSearch>;
  /** Publish one gridColumn */
  publishGridColumn?: Maybe<GridColumn>;
  /** Publish one gridColumnComponent */
  publishGridColumnComponent?: Maybe<GridColumnComponent>;
  /** Publish one heroBanner */
  publishHeroBanner?: Maybe<HeroBanner>;
  /** Publish one heroBannerMasterbrand */
  publishHeroBannerMasterbrand?: Maybe<HeroBannerMasterbrand>;
  /** Publish one heroCarouselComponent */
  publishHeroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Publish one heroComponent */
  publishHeroComponent?: Maybe<HeroComponent>;
  /** Publish one heroLoopAnimationComponent */
  publishHeroLoopAnimationComponent?: Maybe<HeroLoopAnimationComponent>;
  /** Publish one iframe */
  publishIframe?: Maybe<Iframe>;
  /** Publish one imageAndTextCard */
  publishImageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Publish one imageCopy */
  publishImageCopy?: Maybe<ImageCopy>;
  /** Publish one imageCopyItem */
  publishImageCopyItem?: Maybe<ImageCopyItem>;
  /** Publish one introText */
  publishIntroText?: Maybe<IntroText>;
  /** Publish one leftColumn */
  publishLeftColumn?: Maybe<LeftColumn>;
  /** Publish one link */
  publishLink?: Maybe<Link>;
  /** Publish one longText */
  publishLongText?: Maybe<LongText>;
  /**
   * Publish many AccordionItem documents
   * @deprecated Please use the new paginated many mutation (publishManyAccordionItemsConnection)
   */
  publishManyAccordionItems: BatchPayload;
  /** Publish many AccordionItem documents */
  publishManyAccordionItemsConnection: AccordionItemConnection;
  /**
   * Publish many Accordion documents
   * @deprecated Please use the new paginated many mutation (publishManyAccordionsConnection)
   */
  publishManyAccordions: BatchPayload;
  /** Publish many Accordion documents */
  publishManyAccordionsConnection: AccordionConnection;
  /**
   * Publish many AlgoliaExtension documents
   * @deprecated Please use the new paginated many mutation (publishManyAlgoliaExtensionsConnection)
   */
  publishManyAlgoliaExtensions: BatchPayload;
  /** Publish many AlgoliaExtension documents */
  publishManyAlgoliaExtensionsConnection: AlgoliaExtensionConnection;
  /**
   * Publish many AnchorNavigationList documents
   * @deprecated Please use the new paginated many mutation (publishManyAnchorNavigationListsConnection)
   */
  publishManyAnchorNavigationLists: BatchPayload;
  /** Publish many AnchorNavigationList documents */
  publishManyAnchorNavigationListsConnection: AnchorNavigationListConnection;
  /**
   * Publish many AnchorNavigation documents
   * @deprecated Please use the new paginated many mutation (publishManyAnchorNavigationsConnection)
   */
  publishManyAnchorNavigations: BatchPayload;
  /** Publish many AnchorNavigation documents */
  publishManyAnchorNavigationsConnection: AnchorNavigationConnection;
  /**
   * Publish many AnchorNav documents
   * @deprecated Please use the new paginated many mutation (publishManyAnchorNavsConnection)
   */
  publishManyAnchorNavs: BatchPayload;
  /** Publish many AnchorNav documents */
  publishManyAnchorNavsConnection: AnchorNavConnection;
  /**
   * Publish many Asset documents
   * @deprecated Please use the new paginated many mutation (publishManyAssetsConnection)
   */
  publishManyAssets: BatchPayload;
  /**
   * Publish many AssetComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyAssetsComponentsConnection)
   */
  publishManyAssetsComponents: BatchPayload;
  /** Publish many AssetComponent documents */
  publishManyAssetsComponentsConnection: AssetComponentConnection;
  /** Publish many Asset documents */
  publishManyAssetsConnection: AssetConnection;
  /**
   * Publish many AudioComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyAudioComponentsConnection)
   */
  publishManyAudioComponents: BatchPayload;
  /** Publish many AudioComponent documents */
  publishManyAudioComponentsConnection: AudioComponentConnection;
  /**
   * Publish many AuthorableContentCard documents
   * @deprecated Please use the new paginated many mutation (publishManyAuthorableContentCardsConnection)
   */
  publishManyAuthorableContentCards: BatchPayload;
  /** Publish many AuthorableContentCard documents */
  publishManyAuthorableContentCardsConnection: AuthorableContentCardConnection;
  /**
   * Publish many Banner1 documents
   * @deprecated Please use the new paginated many mutation (publishManyBanner1sConnection)
   */
  publishManyBanner1s: BatchPayload;
  /** Publish many Banner1 documents */
  publishManyBanner1sConnection: Banner1Connection;
  /**
   * Publish many Banner2CarouselComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyBanner2CarouselComponentsConnection)
   */
  publishManyBanner2CarouselComponents: BatchPayload;
  /** Publish many Banner2CarouselComponent documents */
  publishManyBanner2CarouselComponentsConnection: Banner2CarouselComponentConnection;
  /**
   * Publish many Banner2 documents
   * @deprecated Please use the new paginated many mutation (publishManyBanner2SConnection)
   */
  publishManyBanner2S: BatchPayload;
  /** Publish many Banner2 documents */
  publishManyBanner2SConnection: Banner2Connection;
  /**
   * Publish many CardComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyCardComponentsConnection)
   */
  publishManyCardComponents: BatchPayload;
  /** Publish many CardComponent documents */
  publishManyCardComponentsConnection: CardComponentConnection;
  /**
   * Publish many CarouselComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyCarouselComponentsConnection)
   */
  publishManyCarouselComponents: BatchPayload;
  /** Publish many CarouselComponent documents */
  publishManyCarouselComponentsConnection: CarouselComponentConnection;
  /**
   * Publish many CarouselSlide documents
   * @deprecated Please use the new paginated many mutation (publishManyCarouselSlidesConnection)
   */
  publishManyCarouselSlides: BatchPayload;
  /** Publish many CarouselSlide documents */
  publishManyCarouselSlidesConnection: CarouselSlideConnection;
  /**
   * Publish many CategoryCard documents
   * @deprecated Please use the new paginated many mutation (publishManyCategoryCardsConnection)
   */
  publishManyCategoryCards: BatchPayload;
  /** Publish many CategoryCard documents */
  publishManyCategoryCardsConnection: CategoryCardConnection;
  /**
   * Publish many ContactCardContainer documents
   * @deprecated Please use the new paginated many mutation (publishManyContactCardContainersConnection)
   */
  publishManyContactCardContainers: BatchPayload;
  /** Publish many ContactCardContainer documents */
  publishManyContactCardContainersConnection: ContactCardContainerConnection;
  /**
   * Publish many ContactCard documents
   * @deprecated Please use the new paginated many mutation (publishManyContactCardsConnection)
   */
  publishManyContactCards: BatchPayload;
  /** Publish many ContactCard documents */
  publishManyContactCardsConnection: ContactCardConnection;
  /**
   * Publish many CountrySelectorFooter documents
   * @deprecated Please use the new paginated many mutation (publishManyCountrySelectorFootersConnection)
   */
  publishManyCountrySelectorFooters: BatchPayload;
  /** Publish many CountrySelectorFooter documents */
  publishManyCountrySelectorFootersConnection: CountrySelectorFooterConnection;
  /**
   * Publish many CountrySelectorItem documents
   * @deprecated Please use the new paginated many mutation (publishManyCountrySelectorItemsConnection)
   */
  publishManyCountrySelectorItems: BatchPayload;
  /** Publish many CountrySelectorItem documents */
  publishManyCountrySelectorItemsConnection: CountrySelectorItemConnection;
  /**
   * Publish many DemoModel documents
   * @deprecated Please use the new paginated many mutation (publishManyDemoModelsConnection)
   */
  publishManyDemoModels: BatchPayload;
  /** Publish many DemoModel documents */
  publishManyDemoModelsConnection: DemoModelConnection;
  /**
   * Publish many Dictionary documents
   * @deprecated Please use the new paginated many mutation (publishManyDictionariesConnection)
   */
  publishManyDictionaries: BatchPayload;
  /** Publish many Dictionary documents */
  publishManyDictionariesConnection: DictionaryConnection;
  /**
   * Publish many DictionaryItem documents
   * @deprecated Please use the new paginated many mutation (publishManyDictionaryItemsConnection)
   */
  publishManyDictionaryItems: BatchPayload;
  /** Publish many DictionaryItem documents */
  publishManyDictionaryItemsConnection: DictionaryItemConnection;
  /**
   * Publish many DownloadApp documents
   * @deprecated Please use the new paginated many mutation (publishManyDownloadAppsConnection)
   */
  publishManyDownloadApps: BatchPayload;
  /** Publish many DownloadApp documents */
  publishManyDownloadAppsConnection: DownloadAppConnection;
  /**
   * Publish many DynamicCardGrid documents
   * @deprecated Please use the new paginated many mutation (publishManyDynamicCardGridsConnection)
   */
  publishManyDynamicCardGrids: BatchPayload;
  /** Publish many DynamicCardGrid documents */
  publishManyDynamicCardGridsConnection: DynamicCardGridConnection;
  /**
   * Publish many ErrorPage documents
   * @deprecated Please use the new paginated many mutation (publishManyErrorPagesConnection)
   */
  publishManyErrorPages: BatchPayload;
  /** Publish many ErrorPage documents */
  publishManyErrorPagesConnection: ErrorPageConnection;
  /**
   * Publish many EvalancheFormComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyEvalancheFormComponentsConnection)
   */
  publishManyEvalancheFormComponents: BatchPayload;
  /** Publish many EvalancheFormComponent documents */
  publishManyEvalancheFormComponentsConnection: EvalancheFormComponentConnection;
  /**
   * Publish many ExampleComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyExampleComponentsConnection)
   */
  publishManyExampleComponents: BatchPayload;
  /** Publish many ExampleComponent documents */
  publishManyExampleComponentsConnection: ExampleComponentConnection;
  /**
   * Publish many FeaturedContentReference documents
   * @deprecated Please use the new paginated many mutation (publishManyFeaturedContentReferencesConnection)
   */
  publishManyFeaturedContentReferences: BatchPayload;
  /** Publish many FeaturedContentReference documents */
  publishManyFeaturedContentReferencesConnection: FeaturedContentReferenceConnection;
  /**
   * Publish many FeaturedContent documents
   * @deprecated Please use the new paginated many mutation (publishManyFeaturedContentsConnection)
   */
  publishManyFeaturedContents: BatchPayload;
  /** Publish many FeaturedContent documents */
  publishManyFeaturedContentsConnection: FeaturedContentConnection;
  /**
   * Publish many FooterNavigation documents
   * @deprecated Please use the new paginated many mutation (publishManyFooterNavigationsConnection)
   */
  publishManyFooterNavigations: BatchPayload;
  /** Publish many FooterNavigation documents */
  publishManyFooterNavigationsConnection: FooterNavigationConnection;
  /**
   * Publish many FooterSeal documents
   * @deprecated Please use the new paginated many mutation (publishManyFooterSealsConnection)
   */
  publishManyFooterSeals: BatchPayload;
  /** Publish many FooterSeal documents */
  publishManyFooterSealsConnection: FooterSealConnection;
  /**
   * Publish many FormCheckboxCollection documents
   * @deprecated Please use the new paginated many mutation (publishManyFormCheckboxCollectionsConnection)
   */
  publishManyFormCheckboxCollections: BatchPayload;
  /** Publish many FormCheckboxCollection documents */
  publishManyFormCheckboxCollectionsConnection: FormCheckboxCollectionConnection;
  /**
   * Publish many FormCheckbox documents
   * @deprecated Please use the new paginated many mutation (publishManyFormCheckboxesConnection)
   */
  publishManyFormCheckboxes: BatchPayload;
  /** Publish many FormCheckbox documents */
  publishManyFormCheckboxesConnection: FormCheckboxConnection;
  /**
   * Publish many FormDateInput documents
   * @deprecated Please use the new paginated many mutation (publishManyFormDateInputsConnection)
   */
  publishManyFormDateInputs: BatchPayload;
  /** Publish many FormDateInput documents */
  publishManyFormDateInputsConnection: FormDateInputConnection;
  /**
   * Publish many FormEmailInput documents
   * @deprecated Please use the new paginated many mutation (publishManyFormEmailInputsConnection)
   */
  publishManyFormEmailInputs: BatchPayload;
  /** Publish many FormEmailInput documents */
  publishManyFormEmailInputsConnection: FormEmailInputConnection;
  /**
   * Publish many FormError documents
   * @deprecated Please use the new paginated many mutation (publishManyFormErrorsConnection)
   */
  publishManyFormErrors: BatchPayload;
  /** Publish many FormError documents */
  publishManyFormErrorsConnection: FormErrorConnection;
  /**
   * Publish many FormFileUploader documents
   * @deprecated Please use the new paginated many mutation (publishManyFormFileUploadersConnection)
   */
  publishManyFormFileUploaders: BatchPayload;
  /** Publish many FormFileUploader documents */
  publishManyFormFileUploadersConnection: FormFileUploaderConnection;
  /**
   * Publish many FormListItem documents
   * @deprecated Please use the new paginated many mutation (publishManyFormListItemsConnection)
   */
  publishManyFormListItems: BatchPayload;
  /** Publish many FormListItem documents */
  publishManyFormListItemsConnection: FormListItemConnection;
  /**
   * Publish many FormList documents
   * @deprecated Please use the new paginated many mutation (publishManyFormListsConnection)
   */
  publishManyFormLists: BatchPayload;
  /** Publish many FormList documents */
  publishManyFormListsConnection: FormListConnection;
  /**
   * Publish many FormNumberInput documents
   * @deprecated Please use the new paginated many mutation (publishManyFormNumberInputsConnection)
   */
  publishManyFormNumberInputs: BatchPayload;
  /** Publish many FormNumberInput documents */
  publishManyFormNumberInputsConnection: FormNumberInputConnection;
  /**
   * Publish many FormPasswordInputWithConfirmation documents
   * @deprecated Please use the new paginated many mutation (publishManyFormPasswordInputWithConfirmationsConnection)
   */
  publishManyFormPasswordInputWithConfirmations: BatchPayload;
  /** Publish many FormPasswordInputWithConfirmation documents */
  publishManyFormPasswordInputWithConfirmationsConnection: FormPasswordInputWithConfirmationConnection;
  /**
   * Publish many FormPasswordInput documents
   * @deprecated Please use the new paginated many mutation (publishManyFormPasswordInputsConnection)
   */
  publishManyFormPasswordInputs: BatchPayload;
  /** Publish many FormPasswordInput documents */
  publishManyFormPasswordInputsConnection: FormPasswordInputConnection;
  /**
   * Publish many FormRadioButtonCollection documents
   * @deprecated Please use the new paginated many mutation (publishManyFormRadioButtonCollectionsConnection)
   */
  publishManyFormRadioButtonCollections: BatchPayload;
  /** Publish many FormRadioButtonCollection documents */
  publishManyFormRadioButtonCollectionsConnection: FormRadioButtonCollectionConnection;
  /**
   * Publish many FormRadioButton documents
   * @deprecated Please use the new paginated many mutation (publishManyFormRadioButtonsConnection)
   */
  publishManyFormRadioButtons: BatchPayload;
  /** Publish many FormRadioButton documents */
  publishManyFormRadioButtonsConnection: FormRadioButtonConnection;
  /**
   * Publish many FormSelectComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyFormSelectComponentsConnection)
   */
  publishManyFormSelectComponents: BatchPayload;
  /** Publish many FormSelectComponent documents */
  publishManyFormSelectComponentsConnection: FormSelectComponentConnection;
  /**
   * Publish many FormSelectOption documents
   * @deprecated Please use the new paginated many mutation (publishManyFormSelectOptionsConnection)
   */
  publishManyFormSelectOptions: BatchPayload;
  /** Publish many FormSelectOption documents */
  publishManyFormSelectOptionsConnection: FormSelectOptionConnection;
  /**
   * Publish many FormSubmitButton documents
   * @deprecated Please use the new paginated many mutation (publishManyFormSubmitButtonsConnection)
   */
  publishManyFormSubmitButtons: BatchPayload;
  /** Publish many FormSubmitButton documents */
  publishManyFormSubmitButtonsConnection: FormSubmitButtonConnection;
  /**
   * Publish many FormSuccessComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyFormSuccessComponentsConnection)
   */
  publishManyFormSuccessComponents: BatchPayload;
  /** Publish many FormSuccessComponent documents */
  publishManyFormSuccessComponentsConnection: FormSuccessComponentConnection;
  /**
   * Publish many FormTextInput documents
   * @deprecated Please use the new paginated many mutation (publishManyFormTextInputsConnection)
   */
  publishManyFormTextInputs: BatchPayload;
  /** Publish many FormTextInput documents */
  publishManyFormTextInputsConnection: FormTextInputConnection;
  /**
   * Publish many FormTextareaInput documents
   * @deprecated Please use the new paginated many mutation (publishManyFormTextareaInputsConnection)
   */
  publishManyFormTextareaInputs: BatchPayload;
  /** Publish many FormTextareaInput documents */
  publishManyFormTextareaInputsConnection: FormTextareaInputConnection;
  /**
   * Publish many Form documents
   * @deprecated Please use the new paginated many mutation (publishManyFormsConnection)
   */
  publishManyForms: BatchPayload;
  /** Publish many Form documents */
  publishManyFormsConnection: FormConnection;
  /**
   * Publish many GenericAccordionItem documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericAccordionItemsConnection)
   */
  publishManyGenericAccordionItems: BatchPayload;
  /** Publish many GenericAccordionItem documents */
  publishManyGenericAccordionItemsConnection: GenericAccordionItemConnection;
  /**
   * Publish many GenericAccordionTopRated documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericAccordionTopRatedsConnection)
   */
  publishManyGenericAccordionTopRateds: BatchPayload;
  /** Publish many GenericAccordionTopRated documents */
  publishManyGenericAccordionTopRatedsConnection: GenericAccordionTopRatedConnection;
  /**
   * Publish many GenericAccordion documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericAccordionsConnection)
   */
  publishManyGenericAccordions: BatchPayload;
  /** Publish many GenericAccordion documents */
  publishManyGenericAccordionsConnection: GenericAccordionConnection;
  /**
   * Publish many GenericCardCarouseComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericCardCarouseComponentsConnection)
   */
  publishManyGenericCardCarouseComponents: BatchPayload;
  /** Publish many GenericCardCarouseComponent documents */
  publishManyGenericCardCarouseComponentsConnection: GenericCardCarouseComponentConnection;
  /**
   * Publish many GenericDownloadComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericDownloadComponentsConnection)
   */
  publishManyGenericDownloadComponents: BatchPayload;
  /** Publish many GenericDownloadComponent documents */
  publishManyGenericDownloadComponentsConnection: GenericDownloadComponentConnection;
  /**
   * Publish many GenericFollowUs documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericFollowUsesConnection)
   */
  publishManyGenericFollowUses: BatchPayload;
  /** Publish many GenericFollowUs documents */
  publishManyGenericFollowUsesConnection: GenericFollowUsConnection;
  /**
   * Publish many GenericGridAuthorable documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericGridAuthorablesConnection)
   */
  publishManyGenericGridAuthorables: BatchPayload;
  /** Publish many GenericGridAuthorable documents */
  publishManyGenericGridAuthorablesConnection: GenericGridAuthorableConnection;
  /**
   * Publish many GenericHtml documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericHtmlsConnection)
   */
  publishManyGenericHtmls: BatchPayload;
  /** Publish many GenericHtml documents */
  publishManyGenericHtmlsConnection: GenericHtmlConnection;
  /**
   * Publish many GenericLine documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericLinesConnection)
   */
  publishManyGenericLines: BatchPayload;
  /** Publish many GenericLine documents */
  publishManyGenericLinesConnection: GenericLineConnection;
  /**
   * Publish many GenericLink documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericLinksConnection)
   */
  publishManyGenericLinks: BatchPayload;
  /** Publish many GenericLink documents */
  publishManyGenericLinksConnection: GenericLinkConnection;
  /**
   * Publish many GenericPage documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericPagesConnection)
   */
  publishManyGenericPages: BatchPayload;
  /** Publish many GenericPage documents */
  publishManyGenericPagesConnection: GenericPageConnection;
  /**
   * Publish many GenericPromotionsOverview documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericPromotionsOverviewsConnection)
   */
  publishManyGenericPromotionsOverviews: BatchPayload;
  /** Publish many GenericPromotionsOverview documents */
  publishManyGenericPromotionsOverviewsConnection: GenericPromotionsOverviewConnection;
  /**
   * Publish many GenericQualifioOverview documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericQualifioOverviewsConnection)
   */
  publishManyGenericQualifioOverviews: BatchPayload;
  /** Publish many GenericQualifioOverview documents */
  publishManyGenericQualifioOverviewsConnection: GenericQualifioOverviewConnection;
  /**
   * Publish many GenericQualifio documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericQualifiosConnection)
   */
  publishManyGenericQualifios: BatchPayload;
  /** Publish many GenericQualifio documents */
  publishManyGenericQualifiosConnection: GenericQualifioConnection;
  /**
   * Publish many GenericSocialShare documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericSocialSharesConnection)
   */
  publishManyGenericSocialShares: BatchPayload;
  /** Publish many GenericSocialShare documents */
  publishManyGenericSocialSharesConnection: GenericSocialShareConnection;
  /**
   * Publish many GlobalMetaData documents
   * @deprecated Please use the new paginated many mutation (publishManyGlobalMetaDatasConnection)
   */
  publishManyGlobalMetaDatas: BatchPayload;
  /** Publish many GlobalMetaData documents */
  publishManyGlobalMetaDatasConnection: GlobalMetaDataConnection;
  /**
   * Publish many GlobalSearch documents
   * @deprecated Please use the new paginated many mutation (publishManyGlobalSearchesConnection)
   */
  publishManyGlobalSearches: BatchPayload;
  /** Publish many GlobalSearch documents */
  publishManyGlobalSearchesConnection: GlobalSearchConnection;
  /**
   * Publish many GridColumnComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyGridColumnComponentsConnection)
   */
  publishManyGridColumnComponents: BatchPayload;
  /** Publish many GridColumnComponent documents */
  publishManyGridColumnComponentsConnection: GridColumnComponentConnection;
  /**
   * Publish many GridColumn documents
   * @deprecated Please use the new paginated many mutation (publishManyGridColumnsConnection)
   */
  publishManyGridColumns: BatchPayload;
  /** Publish many GridColumn documents */
  publishManyGridColumnsConnection: GridColumnConnection;
  /**
   * Publish many HeroBannerMasterbrand documents
   * @deprecated Please use the new paginated many mutation (publishManyHeroBannerMasterbrandsConnection)
   */
  publishManyHeroBannerMasterbrands: BatchPayload;
  /** Publish many HeroBannerMasterbrand documents */
  publishManyHeroBannerMasterbrandsConnection: HeroBannerMasterbrandConnection;
  /**
   * Publish many HeroBanner documents
   * @deprecated Please use the new paginated many mutation (publishManyHeroBannersConnection)
   */
  publishManyHeroBanners: BatchPayload;
  /** Publish many HeroBanner documents */
  publishManyHeroBannersConnection: HeroBannerConnection;
  /**
   * Publish many HeroCarouselComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyHeroCarouselComponentsConnection)
   */
  publishManyHeroCarouselComponents: BatchPayload;
  /** Publish many HeroCarouselComponent documents */
  publishManyHeroCarouselComponentsConnection: HeroCarouselComponentConnection;
  /**
   * Publish many HeroComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyHeroComponentsConnection)
   */
  publishManyHeroComponents: BatchPayload;
  /** Publish many HeroComponent documents */
  publishManyHeroComponentsConnection: HeroComponentConnection;
  /**
   * Publish many HeroLoopAnimationComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyHeroLoopAnimationComponentsConnection)
   */
  publishManyHeroLoopAnimationComponents: BatchPayload;
  /** Publish many HeroLoopAnimationComponent documents */
  publishManyHeroLoopAnimationComponentsConnection: HeroLoopAnimationComponentConnection;
  /**
   * Publish many Iframe documents
   * @deprecated Please use the new paginated many mutation (publishManyIframesConnection)
   */
  publishManyIframes: BatchPayload;
  /** Publish many Iframe documents */
  publishManyIframesConnection: IframeConnection;
  /**
   * Publish many ImageAndTextCard documents
   * @deprecated Please use the new paginated many mutation (publishManyImageAndTextCardsConnection)
   */
  publishManyImageAndTextCards: BatchPayload;
  /** Publish many ImageAndTextCard documents */
  publishManyImageAndTextCardsConnection: ImageAndTextCardConnection;
  /**
   * Publish many ImageCopy documents
   * @deprecated Please use the new paginated many mutation (publishManyImageCopiesConnection)
   */
  publishManyImageCopies: BatchPayload;
  /** Publish many ImageCopy documents */
  publishManyImageCopiesConnection: ImageCopyConnection;
  /**
   * Publish many ImageCopyItem documents
   * @deprecated Please use the new paginated many mutation (publishManyImageCopyItemsConnection)
   */
  publishManyImageCopyItems: BatchPayload;
  /** Publish many ImageCopyItem documents */
  publishManyImageCopyItemsConnection: ImageCopyItemConnection;
  /**
   * Publish many IntroText documents
   * @deprecated Please use the new paginated many mutation (publishManyIntroTextsConnection)
   */
  publishManyIntroTexts: BatchPayload;
  /** Publish many IntroText documents */
  publishManyIntroTextsConnection: IntroTextConnection;
  /**
   * Publish many LeftColumn documents
   * @deprecated Please use the new paginated many mutation (publishManyLeftColumnsConnection)
   */
  publishManyLeftColumns: BatchPayload;
  /** Publish many LeftColumn documents */
  publishManyLeftColumnsConnection: LeftColumnConnection;
  /**
   * Publish many Link documents
   * @deprecated Please use the new paginated many mutation (publishManyLinksConnection)
   */
  publishManyLinks: BatchPayload;
  /** Publish many Link documents */
  publishManyLinksConnection: LinkConnection;
  /**
   * Publish many LongText documents
   * @deprecated Please use the new paginated many mutation (publishManyLongTextsConnection)
   */
  publishManyLongTexts: BatchPayload;
  /** Publish many LongText documents */
  publishManyLongTextsConnection: LongTextConnection;
  /**
   * Publish many MarketUserConnection documents
   * @deprecated Please use the new paginated many mutation (publishManyMarketUserConnectionsConnection)
   */
  publishManyMarketUserConnections: BatchPayload;
  /** Publish many MarketUserConnection documents */
  publishManyMarketUserConnectionsConnection: MarketUserConnectionConnection;
  /**
   * Publish many Market documents
   * @deprecated Please use the new paginated many mutation (publishManyMarketsConnection)
   */
  publishManyMarkets: BatchPayload;
  /** Publish many Market documents */
  publishManyMarketsConnection: MarketConnection;
  /**
   * Publish many MetaData documents
   * @deprecated Please use the new paginated many mutation (publishManyMetaDatasConnection)
   */
  publishManyMetaDatas: BatchPayload;
  /** Publish many MetaData documents */
  publishManyMetaDatasConnection: MetaDataConnection;
  /**
   * Publish many MobileOnlyMainNavigation documents
   * @deprecated Please use the new paginated many mutation (publishManyMobileOnlyMainNavigationsConnection)
   */
  publishManyMobileOnlyMainNavigations: BatchPayload;
  /** Publish many MobileOnlyMainNavigation documents */
  publishManyMobileOnlyMainNavigationsConnection: MobileOnlyMainNavigationConnection;
  /**
   * Publish many MultiStepPromotionForm documents
   * @deprecated Please use the new paginated many mutation (publishManyMultiStepPromotionFormsConnection)
   */
  publishManyMultiStepPromotionForms: BatchPayload;
  /** Publish many MultiStepPromotionForm documents */
  publishManyMultiStepPromotionFormsConnection: MultiStepPromotionFormConnection;
  /**
   * Publish many NavigationItem documents
   * @deprecated Please use the new paginated many mutation (publishManyNavigationItemsConnection)
   */
  publishManyNavigationItems: BatchPayload;
  /** Publish many NavigationItem documents */
  publishManyNavigationItemsConnection: NavigationItemConnection;
  /**
   * Publish many Navigation documents
   * @deprecated Please use the new paginated many mutation (publishManyNavigationsConnection)
   */
  publishManyNavigations: BatchPayload;
  /** Publish many Navigation documents */
  publishManyNavigationsConnection: NavigationConnection;
  /**
   * Publish many NewsletterComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyNewsletterComponentsConnection)
   */
  publishManyNewsletterComponents: BatchPayload;
  /** Publish many NewsletterComponent documents */
  publishManyNewsletterComponentsConnection: NewsletterComponentConnection;
  /**
   * Publish many NewsletterSubscriptions documents
   * @deprecated Please use the new paginated many mutation (publishManyNewsletterSubscriptionsPluralConnection)
   */
  publishManyNewsletterSubscriptionsPlural: BatchPayload;
  /** Publish many NewsletterSubscriptions documents */
  publishManyNewsletterSubscriptionsPluralConnection: NewsletterSubscriptionsConnection;
  /**
   * Publish many NotificationBanner documents
   * @deprecated Please use the new paginated many mutation (publishManyNotificationBannersConnection)
   */
  publishManyNotificationBanners: BatchPayload;
  /** Publish many NotificationBanner documents */
  publishManyNotificationBannersConnection: NotificationBannerConnection;
  /**
   * Publish many PageFooter documents
   * @deprecated Please use the new paginated many mutation (publishManyPageFootersConnection)
   */
  publishManyPageFooters: BatchPayload;
  /** Publish many PageFooter documents */
  publishManyPageFootersConnection: PageFooterConnection;
  /**
   * Publish many PageHeader documents
   * @deprecated Please use the new paginated many mutation (publishManyPageHeadersConnection)
   */
  publishManyPageHeaders: BatchPayload;
  /** Publish many PageHeader documents */
  publishManyPageHeadersConnection: PageHeaderConnection;
  /**
   * Publish many PopularSearchComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyPopularSearchComponentsConnection)
   */
  publishManyPopularSearchComponents: BatchPayload;
  /** Publish many PopularSearchComponent documents */
  publishManyPopularSearchComponentsConnection: PopularSearchComponentConnection;
  /**
   * Publish many ProductBanner documents
   * @deprecated Please use the new paginated many mutation (publishManyProductBannersConnection)
   */
  publishManyProductBanners: BatchPayload;
  /** Publish many ProductBanner documents */
  publishManyProductBannersConnection: ProductBannerConnection;
  /**
   * Publish many ProductCategory documents
   * @deprecated Please use the new paginated many mutation (publishManyProductCategoriesConnection)
   */
  publishManyProductCategories: BatchPayload;
  /** Publish many ProductCategory documents */
  publishManyProductCategoriesConnection: ProductCategoryConnection;
  /**
   * Publish many ProductCategoryPage documents
   * @deprecated Please use the new paginated many mutation (publishManyProductCategoryPagesConnection)
   */
  publishManyProductCategoryPages: BatchPayload;
  /** Publish many ProductCategoryPage documents */
  publishManyProductCategoryPagesConnection: ProductCategoryPageConnection;
  /**
   * Publish many ProductDetailPage documents
   * @deprecated Please use the new paginated many mutation (publishManyProductDetailPagesConnection)
   */
  publishManyProductDetailPages: BatchPayload;
  /** Publish many ProductDetailPage documents */
  publishManyProductDetailPagesConnection: ProductDetailPageConnection;
  /**
   * Publish many ProductHero documents
   * @deprecated Please use the new paginated many mutation (publishManyProductHeroesConnection)
   */
  publishManyProductHeroes: BatchPayload;
  /** Publish many ProductHero documents */
  publishManyProductHeroesConnection: ProductHeroConnection;
  /**
   * Publish many ProductLabel documents
   * @deprecated Please use the new paginated many mutation (publishManyProductLabelsConnection)
   */
  publishManyProductLabels: BatchPayload;
  /** Publish many ProductLabel documents */
  publishManyProductLabelsConnection: ProductLabelConnection;
  /**
   * Publish many ProductLandingPage documents
   * @deprecated Please use the new paginated many mutation (publishManyProductLandingPagesConnection)
   */
  publishManyProductLandingPages: BatchPayload;
  /** Publish many ProductLandingPage documents */
  publishManyProductLandingPagesConnection: ProductLandingPageConnection;
  /**
   * Publish many ProductSubcategoryPage documents
   * @deprecated Please use the new paginated many mutation (publishManyProductSubcategoryPagesConnection)
   */
  publishManyProductSubcategoryPages: BatchPayload;
  /** Publish many ProductSubcategoryPage documents */
  publishManyProductSubcategoryPagesConnection: ProductSubcategoryPageConnection;
  /**
   * Publish many Product documents
   * @deprecated Please use the new paginated many mutation (publishManyProductsConnection)
   */
  publishManyProducts: BatchPayload;
  /** Publish many Product documents */
  publishManyProductsConnection: ProductConnection;
  /**
   * Publish many PromotionDownload documents
   * @deprecated Please use the new paginated many mutation (publishManyPromotionDownloadsConnection)
   */
  publishManyPromotionDownloads: BatchPayload;
  /** Publish many PromotionDownload documents */
  publishManyPromotionDownloadsConnection: PromotionDownloadConnection;
  /**
   * Publish many PromotionForm documents
   * @deprecated Please use the new paginated many mutation (publishManyPromotionFormsConnection)
   */
  publishManyPromotionForms: BatchPayload;
  /** Publish many PromotionForm documents */
  publishManyPromotionFormsConnection: PromotionFormConnection;
  /**
   * Publish many QuestionCheckboxCollection documents
   * @deprecated Please use the new paginated many mutation (publishManyQuestionCheckboxCollectionsConnection)
   */
  publishManyQuestionCheckboxCollections: BatchPayload;
  /** Publish many QuestionCheckboxCollection documents */
  publishManyQuestionCheckboxCollectionsConnection: QuestionCheckboxCollectionConnection;
  /**
   * Publish many QuestionCheckbox documents
   * @deprecated Please use the new paginated many mutation (publishManyQuestionCheckboxesConnection)
   */
  publishManyQuestionCheckboxes: BatchPayload;
  /** Publish many QuestionCheckbox documents */
  publishManyQuestionCheckboxesConnection: QuestionCheckboxConnection;
  /**
   * Publish many QuestionRadioButtonCollection documents
   * @deprecated Please use the new paginated many mutation (publishManyQuestionRadioButtonCollectionsConnection)
   */
  publishManyQuestionRadioButtonCollections: BatchPayload;
  /** Publish many QuestionRadioButtonCollection documents */
  publishManyQuestionRadioButtonCollectionsConnection: QuestionRadioButtonCollectionConnection;
  /**
   * Publish many QuestionRadioButton documents
   * @deprecated Please use the new paginated many mutation (publishManyQuestionRadioButtonsConnection)
   */
  publishManyQuestionRadioButtons: BatchPayload;
  /** Publish many QuestionRadioButton documents */
  publishManyQuestionRadioButtonsConnection: QuestionRadioButtonConnection;
  /**
   * Publish many Question documents
   * @deprecated Please use the new paginated many mutation (publishManyQuestionsConnection)
   */
  publishManyQuestions: BatchPayload;
  /** Publish many Question documents */
  publishManyQuestionsConnection: QuestionConnection;
  /**
   * Publish many Rating documents
   * @deprecated Please use the new paginated many mutation (publishManyRatingsConnection)
   */
  publishManyRatings: BatchPayload;
  /** Publish many Rating documents */
  publishManyRatingsConnection: RatingConnection;
  /**
   * Publish many RecipeCategory documents
   * @deprecated Please use the new paginated many mutation (publishManyRecipeCategoriesConnection)
   */
  publishManyRecipeCategories: BatchPayload;
  /** Publish many RecipeCategory documents */
  publishManyRecipeCategoriesConnection: RecipeCategoryConnection;
  /**
   * Publish many RecipeLandingPage documents
   * @deprecated Please use the new paginated many mutation (publishManyRecipeLandingPagesConnection)
   */
  publishManyRecipeLandingPages: BatchPayload;
  /** Publish many RecipeLandingPage documents */
  publishManyRecipeLandingPagesConnection: RecipeLandingPageConnection;
  /**
   * Publish many RecipeSubcategory documents
   * @deprecated Please use the new paginated many mutation (publishManyRecipeSubcategoriesConnection)
   */
  publishManyRecipeSubcategories: BatchPayload;
  /** Publish many RecipeSubcategory documents */
  publishManyRecipeSubcategoriesConnection: RecipeSubcategoryConnection;
  /**
   * Publish many Recipe documents
   * @deprecated Please use the new paginated many mutation (publishManyRecipesConnection)
   */
  publishManyRecipes: BatchPayload;
  /**
   * Publish many RecipesComparisonQueryComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyRecipesComparisonQueryComponentsConnection)
   */
  publishManyRecipesComparisonQueryComponents: BatchPayload;
  /** Publish many RecipesComparisonQueryComponent documents */
  publishManyRecipesComparisonQueryComponentsConnection: RecipesComparisonQueryComponentConnection;
  /** Publish many Recipe documents */
  publishManyRecipesConnection: RecipeConnection;
  /**
   * Publish many RecipesQueriesReference documents
   * @deprecated Please use the new paginated many mutation (publishManyRecipesQueriesReferencesConnection)
   */
  publishManyRecipesQueriesReferences: BatchPayload;
  /** Publish many RecipesQueriesReference documents */
  publishManyRecipesQueriesReferencesConnection: RecipesQueriesReferenceConnection;
  /**
   * Publish many RecipesQueryComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyRecipesQueryComponentsConnection)
   */
  publishManyRecipesQueryComponents: BatchPayload;
  /** Publish many RecipesQueryComponent documents */
  publishManyRecipesQueryComponentsConnection: RecipesQueryComponentConnection;
  /**
   * Publish many Redirect documents
   * @deprecated Please use the new paginated many mutation (publishManyRedirectsConnection)
   */
  publishManyRedirects: BatchPayload;
  /** Publish many Redirect documents */
  publishManyRedirectsConnection: RedirectConnection;
  /**
   * Publish many Rewrite documents
   * @deprecated Please use the new paginated many mutation (publishManyRewritesConnection)
   */
  publishManyRewrites: BatchPayload;
  /** Publish many Rewrite documents */
  publishManyRewritesConnection: RewriteConnection;
  /**
   * Publish many RightColumn documents
   * @deprecated Please use the new paginated many mutation (publishManyRightColumnsConnection)
   */
  publishManyRightColumns: BatchPayload;
  /** Publish many RightColumn documents */
  publishManyRightColumnsConnection: RightColumnConnection;
  /**
   * Publish many SearchInput documents
   * @deprecated Please use the new paginated many mutation (publishManySearchInputsConnection)
   */
  publishManySearchInputs: BatchPayload;
  /** Publish many SearchInput documents */
  publishManySearchInputsConnection: SearchInputConnection;
  /**
   * Publish many SearchOverlayComponent documents
   * @deprecated Please use the new paginated many mutation (publishManySearchOverlayComponentsConnection)
   */
  publishManySearchOverlayComponents: BatchPayload;
  /** Publish many SearchOverlayComponent documents */
  publishManySearchOverlayComponentsConnection: SearchOverlayComponentConnection;
  /**
   * Publish many SearchResultPage documents
   * @deprecated Please use the new paginated many mutation (publishManySearchResultPagesConnection)
   */
  publishManySearchResultPages: BatchPayload;
  /** Publish many SearchResultPage documents */
  publishManySearchResultPagesConnection: SearchResultPageConnection;
  /**
   * Publish many Separator documents
   * @deprecated Please use the new paginated many mutation (publishManySeparatorsConnection)
   */
  publishManySeparators: BatchPayload;
  /** Publish many Separator documents */
  publishManySeparatorsConnection: SeparatorConnection;
  /**
   * Publish many SingleStepPromotionForm documents
   * @deprecated Please use the new paginated many mutation (publishManySingleStepPromotionFormsConnection)
   */
  publishManySingleStepPromotionForms: BatchPayload;
  /** Publish many SingleStepPromotionForm documents */
  publishManySingleStepPromotionFormsConnection: SingleStepPromotionFormConnection;
  /**
   * Publish many SocialMediaListComponent documents
   * @deprecated Please use the new paginated many mutation (publishManySocialMediaListComponentsConnection)
   */
  publishManySocialMediaListComponents: BatchPayload;
  /** Publish many SocialMediaListComponent documents */
  publishManySocialMediaListComponentsConnection: SocialMediaListComponentConnection;
  /**
   * Publish many Spacer documents
   * @deprecated Please use the new paginated many mutation (publishManySpacersConnection)
   */
  publishManySpacers: BatchPayload;
  /** Publish many Spacer documents */
  publishManySpacersConnection: SpacerConnection;
  /**
   * Publish many SubCategoryKeyImage documents
   * @deprecated Please use the new paginated many mutation (publishManySubCategoryKeyImagesConnection)
   */
  publishManySubCategoryKeyImages: BatchPayload;
  /** Publish many SubCategoryKeyImage documents */
  publishManySubCategoryKeyImagesConnection: SubCategoryKeyImageConnection;
  /**
   * Publish many SubTab documents
   * @deprecated Please use the new paginated many mutation (publishManySubTabsConnection)
   */
  publishManySubTabs: BatchPayload;
  /** Publish many SubTab documents */
  publishManySubTabsConnection: SubTabConnection;
  /**
   * Publish many SubTabContent documents
   * @deprecated Please use the new paginated many mutation (publishManySubTabsContentConnection)
   */
  publishManySubTabsContent: BatchPayload;
  /** Publish many SubTabContent documents */
  publishManySubTabsContentConnection: SubTabContentConnection;
  /**
   * Publish many SustainabilityBanner documents
   * @deprecated Please use the new paginated many mutation (publishManySustainabilityBannersConnection)
   */
  publishManySustainabilityBanners: BatchPayload;
  /** Publish many SustainabilityBanner documents */
  publishManySustainabilityBannersConnection: SustainabilityBannerConnection;
  /**
   * Publish many SustainabilityInfo documents
   * @deprecated Please use the new paginated many mutation (publishManySustainabilityInfosConnection)
   */
  publishManySustainabilityInfos: BatchPayload;
  /** Publish many SustainabilityInfo documents */
  publishManySustainabilityInfosConnection: SustainabilityInfoConnection;
  /**
   * Publish many TabContent documents
   * @deprecated Please use the new paginated many mutation (publishManyTabContentsConnection)
   */
  publishManyTabContents: BatchPayload;
  /** Publish many TabContent documents */
  publishManyTabContentsConnection: TabContentConnection;
  /**
   * Publish many Tab documents
   * @deprecated Please use the new paginated many mutation (publishManyTabsConnection)
   */
  publishManyTabs: BatchPayload;
  /** Publish many Tab documents */
  publishManyTabsConnection: TabConnection;
  /**
   * Publish many TeaserPlaceholder documents
   * @deprecated Please use the new paginated many mutation (publishManyTeaserPlaceholdersConnection)
   */
  publishManyTeaserPlaceholders: BatchPayload;
  /** Publish many TeaserPlaceholder documents */
  publishManyTeaserPlaceholdersConnection: TeaserPlaceholderConnection;
  /**
   * Publish many TeaserSmallPlaceholder documents
   * @deprecated Please use the new paginated many mutation (publishManyTeaserSmallPlaceholdersConnection)
   */
  publishManyTeaserSmallPlaceholders: BatchPayload;
  /** Publish many TeaserSmallPlaceholder documents */
  publishManyTeaserSmallPlaceholdersConnection: TeaserSmallPlaceholderConnection;
  /**
   * Publish many TeaserSmall documents
   * @deprecated Please use the new paginated many mutation (publishManyTeaserSmallsConnection)
   */
  publishManyTeaserSmalls: BatchPayload;
  /** Publish many TeaserSmall documents */
  publishManyTeaserSmallsConnection: TeaserSmallConnection;
  /**
   * Publish many Teaser documents
   * @deprecated Please use the new paginated many mutation (publishManyTeasersConnection)
   */
  publishManyTeasers: BatchPayload;
  /** Publish many Teaser documents */
  publishManyTeasersConnection: TeaserConnection;
  /**
   * Publish many TestComponentWithRecipeQuery documents
   * @deprecated Please use the new paginated many mutation (publishManyTestComponentWithRecipeQueriesConnection)
   */
  publishManyTestComponentWithRecipeQueries: BatchPayload;
  /** Publish many TestComponentWithRecipeQuery documents */
  publishManyTestComponentWithRecipeQueriesConnection: TestComponentWithRecipeQueryConnection;
  /**
   * Publish many TestTipsANdTricksInAMarket documents
   * @deprecated Please use the new paginated many mutation (publishManyTestTipsANdTricksInAMarketsConnection)
   */
  publishManyTestTipsANdTricksInAMarkets: BatchPayload;
  /** Publish many TestTipsANdTricksInAMarket documents */
  publishManyTestTipsANdTricksInAMarketsConnection: TestTipsANdTricksInAMarketConnection;
  /**
   * Publish many TextComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyTextComponentsConnection)
   */
  publishManyTextComponents: BatchPayload;
  /** Publish many TextComponent documents */
  publishManyTextComponentsConnection: TextComponentConnection;
  /**
   * Publish many TipsAndTricksDetailsPage documents
   * @deprecated Please use the new paginated many mutation (publishManyTipsAndTricksDetailsPagesConnection)
   */
  publishManyTipsAndTricksDetailsPages: BatchPayload;
  /** Publish many TipsAndTricksDetailsPage documents */
  publishManyTipsAndTricksDetailsPagesConnection: TipsAndTricksDetailsPageConnection;
  /**
   * Publish many Title documents
   * @deprecated Please use the new paginated many mutation (publishManyTitlesConnection)
   */
  publishManyTitles: BatchPayload;
  /** Publish many Title documents */
  publishManyTitlesConnection: TitleConnection;
  /**
   * Publish many TwitterSeo documents
   * @deprecated Please use the new paginated many mutation (publishManyTwitterSeosConnection)
   */
  publishManyTwitterSeos: BatchPayload;
  /** Publish many TwitterSeo documents */
  publishManyTwitterSeosConnection: TwitterSeoConnection;
  /** Publish one market */
  publishMarket?: Maybe<Market>;
  /** Publish one marketUserConnection */
  publishMarketUserConnection?: Maybe<MarketUserConnection>;
  /** Publish one metaData */
  publishMetaData?: Maybe<MetaData>;
  /** Publish one mobileOnlyMainNavigation */
  publishMobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Publish one multiStepPromotionForm */
  publishMultiStepPromotionForm?: Maybe<MultiStepPromotionForm>;
  /** Publish one navigation */
  publishNavigation?: Maybe<Navigation>;
  /** Publish one navigationItem */
  publishNavigationItem?: Maybe<NavigationItem>;
  /** Publish one newsletterComponent */
  publishNewsletterComponent?: Maybe<NewsletterComponent>;
  /** Publish one newsletterSubscriptions */
  publishNewsletterSubscriptions?: Maybe<NewsletterSubscriptions>;
  /** Publish one notificationBanner */
  publishNotificationBanner?: Maybe<NotificationBanner>;
  /** Publish one pageFooter */
  publishPageFooter?: Maybe<PageFooter>;
  /** Publish one pageHeader */
  publishPageHeader?: Maybe<PageHeader>;
  /** Publish one popularSearchComponent */
  publishPopularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Publish one product */
  publishProduct?: Maybe<Product>;
  /** Publish one productBanner */
  publishProductBanner?: Maybe<ProductBanner>;
  /** Publish one productCategory */
  publishProductCategory?: Maybe<ProductCategory>;
  /** Publish one productCategoryPage */
  publishProductCategoryPage?: Maybe<ProductCategoryPage>;
  /** Publish one productDetailPage */
  publishProductDetailPage?: Maybe<ProductDetailPage>;
  /** Publish one productHero */
  publishProductHero?: Maybe<ProductHero>;
  /** Publish one productLabel */
  publishProductLabel?: Maybe<ProductLabel>;
  /** Publish one productLandingPage */
  publishProductLandingPage?: Maybe<ProductLandingPage>;
  /** Publish one productSubcategoryPage */
  publishProductSubcategoryPage?: Maybe<ProductSubcategoryPage>;
  /** Publish one promotionDownload */
  publishPromotionDownload?: Maybe<PromotionDownload>;
  /** Publish one promotionForm */
  publishPromotionForm?: Maybe<PromotionForm>;
  /** Publish one question */
  publishQuestion?: Maybe<Question>;
  /** Publish one questionCheckbox */
  publishQuestionCheckbox?: Maybe<QuestionCheckbox>;
  /** Publish one questionCheckboxCollection */
  publishQuestionCheckboxCollection?: Maybe<QuestionCheckboxCollection>;
  /** Publish one questionRadioButton */
  publishQuestionRadioButton?: Maybe<QuestionRadioButton>;
  /** Publish one questionRadioButtonCollection */
  publishQuestionRadioButtonCollection?: Maybe<QuestionRadioButtonCollection>;
  /** Publish one rating */
  publishRating?: Maybe<Rating>;
  /** Publish one recipe */
  publishRecipe?: Maybe<Recipe>;
  /** Publish one recipeCategory */
  publishRecipeCategory?: Maybe<RecipeCategory>;
  /** Publish one recipeLandingPage */
  publishRecipeLandingPage?: Maybe<RecipeLandingPage>;
  /** Publish one recipeSubcategory */
  publishRecipeSubcategory?: Maybe<RecipeSubcategory>;
  /** Publish one recipesComparisonQueryComponent */
  publishRecipesComparisonQueryComponent?: Maybe<RecipesComparisonQueryComponent>;
  /** Publish one recipesQueriesReference */
  publishRecipesQueriesReference?: Maybe<RecipesQueriesReference>;
  /** Publish one recipesQueryComponent */
  publishRecipesQueryComponent?: Maybe<RecipesQueryComponent>;
  /** Publish one redirect */
  publishRedirect?: Maybe<Redirect>;
  /** Publish one rewrite */
  publishRewrite?: Maybe<Rewrite>;
  /** Publish one rightColumn */
  publishRightColumn?: Maybe<RightColumn>;
  /** Publish one searchInput */
  publishSearchInput?: Maybe<SearchInput>;
  /** Publish one searchOverlayComponent */
  publishSearchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Publish one searchResultPage */
  publishSearchResultPage?: Maybe<SearchResultPage>;
  /** Publish one separator */
  publishSeparator?: Maybe<Separator>;
  /** Publish one singleStepPromotionForm */
  publishSingleStepPromotionForm?: Maybe<SingleStepPromotionForm>;
  /** Publish one socialMediaListComponent */
  publishSocialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Publish one spacer */
  publishSpacer?: Maybe<Spacer>;
  /** Publish one subCategoryKeyImage */
  publishSubCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Publish one subTab */
  publishSubTab?: Maybe<SubTab>;
  /** Publish one subTabContent */
  publishSubTabContent?: Maybe<SubTabContent>;
  /** Publish one sustainabilityBanner */
  publishSustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Publish one sustainabilityInfo */
  publishSustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Publish one tab */
  publishTab?: Maybe<Tab>;
  /** Publish one tabContent */
  publishTabContent?: Maybe<TabContent>;
  /** Publish one teaser */
  publishTeaser?: Maybe<Teaser>;
  /** Publish one teaserPlaceholder */
  publishTeaserPlaceholder?: Maybe<TeaserPlaceholder>;
  /** Publish one teaserSmall */
  publishTeaserSmall?: Maybe<TeaserSmall>;
  /** Publish one teaserSmallPlaceholder */
  publishTeaserSmallPlaceholder?: Maybe<TeaserSmallPlaceholder>;
  /** Publish one testComponentWithRecipeQuery */
  publishTestComponentWithRecipeQuery?: Maybe<TestComponentWithRecipeQuery>;
  /** Publish one testTipsANdTricksInAMarket */
  publishTestTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Publish one textComponent */
  publishTextComponent?: Maybe<TextComponent>;
  /** Publish one tipsAndTricksDetailsPage */
  publishTipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Publish one title */
  publishTitle?: Maybe<Title>;
  /** Publish one twitterSeo */
  publishTwitterSeo?: Maybe<TwitterSeo>;
  /** Schedule to publish one accordion */
  schedulePublishAccordion?: Maybe<Accordion>;
  /** Schedule to publish one accordionItem */
  schedulePublishAccordionItem?: Maybe<AccordionItem>;
  /** Schedule to publish one algoliaExtension */
  schedulePublishAlgoliaExtension?: Maybe<AlgoliaExtension>;
  /** Schedule to publish one anchorNav */
  schedulePublishAnchorNav?: Maybe<AnchorNav>;
  /** Schedule to publish one anchorNavigation */
  schedulePublishAnchorNavigation?: Maybe<AnchorNavigation>;
  /** Schedule to publish one anchorNavigationList */
  schedulePublishAnchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Schedule to publish one asset */
  schedulePublishAsset?: Maybe<Asset>;
  /** Schedule to publish one assetComponent */
  schedulePublishAssetComponent?: Maybe<AssetComponent>;
  /** Schedule to publish one audioComponent */
  schedulePublishAudioComponent?: Maybe<AudioComponent>;
  /** Schedule to publish one authorableContentCard */
  schedulePublishAuthorableContentCard?: Maybe<AuthorableContentCard>;
  /** Schedule to publish one banner1 */
  schedulePublishBanner1?: Maybe<Banner1>;
  /** Schedule to publish one banner2 */
  schedulePublishBanner2?: Maybe<Banner2>;
  /** Schedule to publish one banner2CarouselComponent */
  schedulePublishBanner2CarouselComponent?: Maybe<Banner2CarouselComponent>;
  /** Schedule to publish one cardComponent */
  schedulePublishCardComponent?: Maybe<CardComponent>;
  /** Schedule to publish one carouselComponent */
  schedulePublishCarouselComponent?: Maybe<CarouselComponent>;
  /** Schedule to publish one carouselSlide */
  schedulePublishCarouselSlide?: Maybe<CarouselSlide>;
  /** Schedule to publish one categoryCard */
  schedulePublishCategoryCard?: Maybe<CategoryCard>;
  /** Schedule to publish one contactCard */
  schedulePublishContactCard?: Maybe<ContactCard>;
  /** Schedule to publish one contactCardContainer */
  schedulePublishContactCardContainer?: Maybe<ContactCardContainer>;
  /** Schedule to publish one countrySelectorFooter */
  schedulePublishCountrySelectorFooter?: Maybe<CountrySelectorFooter>;
  /** Schedule to publish one countrySelectorItem */
  schedulePublishCountrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Schedule to publish one demoModel */
  schedulePublishDemoModel?: Maybe<DemoModel>;
  /** Schedule to publish one dictionary */
  schedulePublishDictionary?: Maybe<Dictionary>;
  /** Schedule to publish one dictionaryItem */
  schedulePublishDictionaryItem?: Maybe<DictionaryItem>;
  /** Schedule to publish one downloadApp */
  schedulePublishDownloadApp?: Maybe<DownloadApp>;
  /** Schedule to publish one dynamicCardGrid */
  schedulePublishDynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Schedule to publish one errorPage */
  schedulePublishErrorPage?: Maybe<ErrorPage>;
  /** Schedule to publish one evalancheFormComponent */
  schedulePublishEvalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Schedule to publish one exampleComponent */
  schedulePublishExampleComponent?: Maybe<ExampleComponent>;
  /** Schedule to publish one featuredContent */
  schedulePublishFeaturedContent?: Maybe<FeaturedContent>;
  /** Schedule to publish one featuredContentReference */
  schedulePublishFeaturedContentReference?: Maybe<FeaturedContentReference>;
  /** Schedule to publish one footerNavigation */
  schedulePublishFooterNavigation?: Maybe<FooterNavigation>;
  /** Schedule to publish one footerSeal */
  schedulePublishFooterSeal?: Maybe<FooterSeal>;
  /** Schedule to publish one form */
  schedulePublishForm?: Maybe<Form>;
  /** Schedule to publish one formCheckbox */
  schedulePublishFormCheckbox?: Maybe<FormCheckbox>;
  /** Schedule to publish one formCheckboxCollection */
  schedulePublishFormCheckboxCollection?: Maybe<FormCheckboxCollection>;
  /** Schedule to publish one formDateInput */
  schedulePublishFormDateInput?: Maybe<FormDateInput>;
  /** Schedule to publish one formEmailInput */
  schedulePublishFormEmailInput?: Maybe<FormEmailInput>;
  /** Schedule to publish one formError */
  schedulePublishFormError?: Maybe<FormError>;
  /** Schedule to publish one formFileUploader */
  schedulePublishFormFileUploader?: Maybe<FormFileUploader>;
  /** Schedule to publish one formList */
  schedulePublishFormList?: Maybe<FormList>;
  /** Schedule to publish one formListItem */
  schedulePublishFormListItem?: Maybe<FormListItem>;
  /** Schedule to publish one formNumberInput */
  schedulePublishFormNumberInput?: Maybe<FormNumberInput>;
  /** Schedule to publish one formPasswordInput */
  schedulePublishFormPasswordInput?: Maybe<FormPasswordInput>;
  /** Schedule to publish one formPasswordInputWithConfirmation */
  schedulePublishFormPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Schedule to publish one formRadioButton */
  schedulePublishFormRadioButton?: Maybe<FormRadioButton>;
  /** Schedule to publish one formRadioButtonCollection */
  schedulePublishFormRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Schedule to publish one formSelectComponent */
  schedulePublishFormSelectComponent?: Maybe<FormSelectComponent>;
  /** Schedule to publish one formSelectOption */
  schedulePublishFormSelectOption?: Maybe<FormSelectOption>;
  /** Schedule to publish one formSubmitButton */
  schedulePublishFormSubmitButton?: Maybe<FormSubmitButton>;
  /** Schedule to publish one formSuccessComponent */
  schedulePublishFormSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Schedule to publish one formTextInput */
  schedulePublishFormTextInput?: Maybe<FormTextInput>;
  /** Schedule to publish one formTextareaInput */
  schedulePublishFormTextareaInput?: Maybe<FormTextareaInput>;
  /** Schedule to publish one genericAccordion */
  schedulePublishGenericAccordion?: Maybe<GenericAccordion>;
  /** Schedule to publish one genericAccordionItem */
  schedulePublishGenericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Schedule to publish one genericAccordionTopRated */
  schedulePublishGenericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Schedule to publish one genericCardCarouseComponent */
  schedulePublishGenericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Schedule to publish one genericDownloadComponent */
  schedulePublishGenericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Schedule to publish one genericFollowUs */
  schedulePublishGenericFollowUs?: Maybe<GenericFollowUs>;
  /** Schedule to publish one genericGridAuthorable */
  schedulePublishGenericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Schedule to publish one genericHtml */
  schedulePublishGenericHtml?: Maybe<GenericHtml>;
  /** Schedule to publish one genericLine */
  schedulePublishGenericLine?: Maybe<GenericLine>;
  /** Schedule to publish one genericLink */
  schedulePublishGenericLink?: Maybe<GenericLink>;
  /** Schedule to publish one genericPage */
  schedulePublishGenericPage?: Maybe<GenericPage>;
  /** Schedule to publish one genericPromotionsOverview */
  schedulePublishGenericPromotionsOverview?: Maybe<GenericPromotionsOverview>;
  /** Schedule to publish one genericQualifio */
  schedulePublishGenericQualifio?: Maybe<GenericQualifio>;
  /** Schedule to publish one genericQualifioOverview */
  schedulePublishGenericQualifioOverview?: Maybe<GenericQualifioOverview>;
  /** Schedule to publish one genericSocialShare */
  schedulePublishGenericSocialShare?: Maybe<GenericSocialShare>;
  /** Schedule to publish one globalMetaData */
  schedulePublishGlobalMetaData?: Maybe<GlobalMetaData>;
  /** Schedule to publish one globalSearch */
  schedulePublishGlobalSearch?: Maybe<GlobalSearch>;
  /** Schedule to publish one gridColumn */
  schedulePublishGridColumn?: Maybe<GridColumn>;
  /** Schedule to publish one gridColumnComponent */
  schedulePublishGridColumnComponent?: Maybe<GridColumnComponent>;
  /** Schedule to publish one heroBanner */
  schedulePublishHeroBanner?: Maybe<HeroBanner>;
  /** Schedule to publish one heroBannerMasterbrand */
  schedulePublishHeroBannerMasterbrand?: Maybe<HeroBannerMasterbrand>;
  /** Schedule to publish one heroCarouselComponent */
  schedulePublishHeroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Schedule to publish one heroComponent */
  schedulePublishHeroComponent?: Maybe<HeroComponent>;
  /** Schedule to publish one heroLoopAnimationComponent */
  schedulePublishHeroLoopAnimationComponent?: Maybe<HeroLoopAnimationComponent>;
  /** Schedule to publish one iframe */
  schedulePublishIframe?: Maybe<Iframe>;
  /** Schedule to publish one imageAndTextCard */
  schedulePublishImageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Schedule to publish one imageCopy */
  schedulePublishImageCopy?: Maybe<ImageCopy>;
  /** Schedule to publish one imageCopyItem */
  schedulePublishImageCopyItem?: Maybe<ImageCopyItem>;
  /** Schedule to publish one introText */
  schedulePublishIntroText?: Maybe<IntroText>;
  /** Schedule to publish one leftColumn */
  schedulePublishLeftColumn?: Maybe<LeftColumn>;
  /** Schedule to publish one link */
  schedulePublishLink?: Maybe<Link>;
  /** Schedule to publish one longText */
  schedulePublishLongText?: Maybe<LongText>;
  /** Schedule to publish one market */
  schedulePublishMarket?: Maybe<Market>;
  /** Schedule to publish one marketUserConnection */
  schedulePublishMarketUserConnection?: Maybe<MarketUserConnection>;
  /** Schedule to publish one metaData */
  schedulePublishMetaData?: Maybe<MetaData>;
  /** Schedule to publish one mobileOnlyMainNavigation */
  schedulePublishMobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Schedule to publish one multiStepPromotionForm */
  schedulePublishMultiStepPromotionForm?: Maybe<MultiStepPromotionForm>;
  /** Schedule to publish one navigation */
  schedulePublishNavigation?: Maybe<Navigation>;
  /** Schedule to publish one navigationItem */
  schedulePublishNavigationItem?: Maybe<NavigationItem>;
  /** Schedule to publish one newsletterComponent */
  schedulePublishNewsletterComponent?: Maybe<NewsletterComponent>;
  /** Schedule to publish one newsletterSubscriptions */
  schedulePublishNewsletterSubscriptions?: Maybe<NewsletterSubscriptions>;
  /** Schedule to publish one notificationBanner */
  schedulePublishNotificationBanner?: Maybe<NotificationBanner>;
  /** Schedule to publish one pageFooter */
  schedulePublishPageFooter?: Maybe<PageFooter>;
  /** Schedule to publish one pageHeader */
  schedulePublishPageHeader?: Maybe<PageHeader>;
  /** Schedule to publish one popularSearchComponent */
  schedulePublishPopularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Schedule to publish one product */
  schedulePublishProduct?: Maybe<Product>;
  /** Schedule to publish one productBanner */
  schedulePublishProductBanner?: Maybe<ProductBanner>;
  /** Schedule to publish one productCategory */
  schedulePublishProductCategory?: Maybe<ProductCategory>;
  /** Schedule to publish one productCategoryPage */
  schedulePublishProductCategoryPage?: Maybe<ProductCategoryPage>;
  /** Schedule to publish one productDetailPage */
  schedulePublishProductDetailPage?: Maybe<ProductDetailPage>;
  /** Schedule to publish one productHero */
  schedulePublishProductHero?: Maybe<ProductHero>;
  /** Schedule to publish one productLabel */
  schedulePublishProductLabel?: Maybe<ProductLabel>;
  /** Schedule to publish one productLandingPage */
  schedulePublishProductLandingPage?: Maybe<ProductLandingPage>;
  /** Schedule to publish one productSubcategoryPage */
  schedulePublishProductSubcategoryPage?: Maybe<ProductSubcategoryPage>;
  /** Schedule to publish one promotionDownload */
  schedulePublishPromotionDownload?: Maybe<PromotionDownload>;
  /** Schedule to publish one promotionForm */
  schedulePublishPromotionForm?: Maybe<PromotionForm>;
  /** Schedule to publish one question */
  schedulePublishQuestion?: Maybe<Question>;
  /** Schedule to publish one questionCheckbox */
  schedulePublishQuestionCheckbox?: Maybe<QuestionCheckbox>;
  /** Schedule to publish one questionCheckboxCollection */
  schedulePublishQuestionCheckboxCollection?: Maybe<QuestionCheckboxCollection>;
  /** Schedule to publish one questionRadioButton */
  schedulePublishQuestionRadioButton?: Maybe<QuestionRadioButton>;
  /** Schedule to publish one questionRadioButtonCollection */
  schedulePublishQuestionRadioButtonCollection?: Maybe<QuestionRadioButtonCollection>;
  /** Schedule to publish one rating */
  schedulePublishRating?: Maybe<Rating>;
  /** Schedule to publish one recipe */
  schedulePublishRecipe?: Maybe<Recipe>;
  /** Schedule to publish one recipeCategory */
  schedulePublishRecipeCategory?: Maybe<RecipeCategory>;
  /** Schedule to publish one recipeLandingPage */
  schedulePublishRecipeLandingPage?: Maybe<RecipeLandingPage>;
  /** Schedule to publish one recipeSubcategory */
  schedulePublishRecipeSubcategory?: Maybe<RecipeSubcategory>;
  /** Schedule to publish one recipesComparisonQueryComponent */
  schedulePublishRecipesComparisonQueryComponent?: Maybe<RecipesComparisonQueryComponent>;
  /** Schedule to publish one recipesQueriesReference */
  schedulePublishRecipesQueriesReference?: Maybe<RecipesQueriesReference>;
  /** Schedule to publish one recipesQueryComponent */
  schedulePublishRecipesQueryComponent?: Maybe<RecipesQueryComponent>;
  /** Schedule to publish one redirect */
  schedulePublishRedirect?: Maybe<Redirect>;
  /** Schedule to publish one rewrite */
  schedulePublishRewrite?: Maybe<Rewrite>;
  /** Schedule to publish one rightColumn */
  schedulePublishRightColumn?: Maybe<RightColumn>;
  /** Schedule to publish one searchInput */
  schedulePublishSearchInput?: Maybe<SearchInput>;
  /** Schedule to publish one searchOverlayComponent */
  schedulePublishSearchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Schedule to publish one searchResultPage */
  schedulePublishSearchResultPage?: Maybe<SearchResultPage>;
  /** Schedule to publish one separator */
  schedulePublishSeparator?: Maybe<Separator>;
  /** Schedule to publish one singleStepPromotionForm */
  schedulePublishSingleStepPromotionForm?: Maybe<SingleStepPromotionForm>;
  /** Schedule to publish one socialMediaListComponent */
  schedulePublishSocialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Schedule to publish one spacer */
  schedulePublishSpacer?: Maybe<Spacer>;
  /** Schedule to publish one subCategoryKeyImage */
  schedulePublishSubCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Schedule to publish one subTab */
  schedulePublishSubTab?: Maybe<SubTab>;
  /** Schedule to publish one subTabContent */
  schedulePublishSubTabContent?: Maybe<SubTabContent>;
  /** Schedule to publish one sustainabilityBanner */
  schedulePublishSustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Schedule to publish one sustainabilityInfo */
  schedulePublishSustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Schedule to publish one tab */
  schedulePublishTab?: Maybe<Tab>;
  /** Schedule to publish one tabContent */
  schedulePublishTabContent?: Maybe<TabContent>;
  /** Schedule to publish one teaser */
  schedulePublishTeaser?: Maybe<Teaser>;
  /** Schedule to publish one teaserPlaceholder */
  schedulePublishTeaserPlaceholder?: Maybe<TeaserPlaceholder>;
  /** Schedule to publish one teaserSmall */
  schedulePublishTeaserSmall?: Maybe<TeaserSmall>;
  /** Schedule to publish one teaserSmallPlaceholder */
  schedulePublishTeaserSmallPlaceholder?: Maybe<TeaserSmallPlaceholder>;
  /** Schedule to publish one testComponentWithRecipeQuery */
  schedulePublishTestComponentWithRecipeQuery?: Maybe<TestComponentWithRecipeQuery>;
  /** Schedule to publish one testTipsANdTricksInAMarket */
  schedulePublishTestTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Schedule to publish one textComponent */
  schedulePublishTextComponent?: Maybe<TextComponent>;
  /** Schedule to publish one tipsAndTricksDetailsPage */
  schedulePublishTipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Schedule to publish one title */
  schedulePublishTitle?: Maybe<Title>;
  /** Schedule to publish one twitterSeo */
  schedulePublishTwitterSeo?: Maybe<TwitterSeo>;
  /** Unpublish one accordion from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAccordion?: Maybe<Accordion>;
  /** Unpublish one accordionItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAccordionItem?: Maybe<AccordionItem>;
  /** Unpublish one algoliaExtension from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAlgoliaExtension?: Maybe<AlgoliaExtension>;
  /** Unpublish one anchorNav from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAnchorNav?: Maybe<AnchorNav>;
  /** Unpublish one anchorNavigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAnchorNavigation?: Maybe<AnchorNavigation>;
  /** Unpublish one anchorNavigationList from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAnchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAsset?: Maybe<Asset>;
  /** Unpublish one assetComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAssetComponent?: Maybe<AssetComponent>;
  /** Unpublish one audioComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAudioComponent?: Maybe<AudioComponent>;
  /** Unpublish one authorableContentCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAuthorableContentCard?: Maybe<AuthorableContentCard>;
  /** Unpublish one banner1 from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishBanner1?: Maybe<Banner1>;
  /** Unpublish one banner2 from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishBanner2?: Maybe<Banner2>;
  /** Unpublish one banner2CarouselComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishBanner2CarouselComponent?: Maybe<Banner2CarouselComponent>;
  /** Unpublish one cardComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCardComponent?: Maybe<CardComponent>;
  /** Unpublish one carouselComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCarouselComponent?: Maybe<CarouselComponent>;
  /** Unpublish one carouselSlide from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCarouselSlide?: Maybe<CarouselSlide>;
  /** Unpublish one categoryCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCategoryCard?: Maybe<CategoryCard>;
  /** Unpublish one contactCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishContactCard?: Maybe<ContactCard>;
  /** Unpublish one contactCardContainer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishContactCardContainer?: Maybe<ContactCardContainer>;
  /** Unpublish one countrySelectorFooter from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCountrySelectorFooter?: Maybe<CountrySelectorFooter>;
  /** Unpublish one countrySelectorItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCountrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Unpublish one demoModel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishDemoModel?: Maybe<DemoModel>;
  /** Unpublish one dictionary from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishDictionary?: Maybe<Dictionary>;
  /** Unpublish one dictionaryItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishDictionaryItem?: Maybe<DictionaryItem>;
  /** Unpublish one downloadApp from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishDownloadApp?: Maybe<DownloadApp>;
  /** Unpublish one dynamicCardGrid from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishDynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Unpublish one errorPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishErrorPage?: Maybe<ErrorPage>;
  /** Unpublish one evalancheFormComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishEvalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Unpublish one exampleComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishExampleComponent?: Maybe<ExampleComponent>;
  /** Unpublish one featuredContent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFeaturedContent?: Maybe<FeaturedContent>;
  /** Unpublish one featuredContentReference from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFeaturedContentReference?: Maybe<FeaturedContentReference>;
  /** Unpublish one footerNavigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFooterNavigation?: Maybe<FooterNavigation>;
  /** Unpublish one footerSeal from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFooterSeal?: Maybe<FooterSeal>;
  /** Unpublish one form from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishForm?: Maybe<Form>;
  /** Unpublish one formCheckbox from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormCheckbox?: Maybe<FormCheckbox>;
  /** Unpublish one formCheckboxCollection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormCheckboxCollection?: Maybe<FormCheckboxCollection>;
  /** Unpublish one formDateInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormDateInput?: Maybe<FormDateInput>;
  /** Unpublish one formEmailInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormEmailInput?: Maybe<FormEmailInput>;
  /** Unpublish one formError from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormError?: Maybe<FormError>;
  /** Unpublish one formFileUploader from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormFileUploader?: Maybe<FormFileUploader>;
  /** Unpublish one formList from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormList?: Maybe<FormList>;
  /** Unpublish one formListItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormListItem?: Maybe<FormListItem>;
  /** Unpublish one formNumberInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormNumberInput?: Maybe<FormNumberInput>;
  /** Unpublish one formPasswordInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormPasswordInput?: Maybe<FormPasswordInput>;
  /** Unpublish one formPasswordInputWithConfirmation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Unpublish one formRadioButton from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormRadioButton?: Maybe<FormRadioButton>;
  /** Unpublish one formRadioButtonCollection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Unpublish one formSelectComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormSelectComponent?: Maybe<FormSelectComponent>;
  /** Unpublish one formSelectOption from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormSelectOption?: Maybe<FormSelectOption>;
  /** Unpublish one formSubmitButton from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormSubmitButton?: Maybe<FormSubmitButton>;
  /** Unpublish one formSuccessComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Unpublish one formTextInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormTextInput?: Maybe<FormTextInput>;
  /** Unpublish one formTextareaInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormTextareaInput?: Maybe<FormTextareaInput>;
  /** Unpublish one genericAccordion from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericAccordion?: Maybe<GenericAccordion>;
  /** Unpublish one genericAccordionItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Unpublish one genericAccordionTopRated from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Unpublish one genericCardCarouseComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Unpublish one genericDownloadComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Unpublish one genericFollowUs from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericFollowUs?: Maybe<GenericFollowUs>;
  /** Unpublish one genericGridAuthorable from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Unpublish one genericHtml from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericHtml?: Maybe<GenericHtml>;
  /** Unpublish one genericLine from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericLine?: Maybe<GenericLine>;
  /** Unpublish one genericLink from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericLink?: Maybe<GenericLink>;
  /** Unpublish one genericPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericPage?: Maybe<GenericPage>;
  /** Unpublish one genericPromotionsOverview from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericPromotionsOverview?: Maybe<GenericPromotionsOverview>;
  /** Unpublish one genericQualifio from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericQualifio?: Maybe<GenericQualifio>;
  /** Unpublish one genericQualifioOverview from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericQualifioOverview?: Maybe<GenericQualifioOverview>;
  /** Unpublish one genericSocialShare from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericSocialShare?: Maybe<GenericSocialShare>;
  /** Unpublish one globalMetaData from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGlobalMetaData?: Maybe<GlobalMetaData>;
  /** Unpublish one globalSearch from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGlobalSearch?: Maybe<GlobalSearch>;
  /** Unpublish one gridColumn from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGridColumn?: Maybe<GridColumn>;
  /** Unpublish one gridColumnComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGridColumnComponent?: Maybe<GridColumnComponent>;
  /** Unpublish one heroBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishHeroBanner?: Maybe<HeroBanner>;
  /** Unpublish one heroBannerMasterbrand from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishHeroBannerMasterbrand?: Maybe<HeroBannerMasterbrand>;
  /** Unpublish one heroCarouselComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishHeroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Unpublish one heroComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishHeroComponent?: Maybe<HeroComponent>;
  /** Unpublish one heroLoopAnimationComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishHeroLoopAnimationComponent?: Maybe<HeroLoopAnimationComponent>;
  /** Unpublish one iframe from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishIframe?: Maybe<Iframe>;
  /** Unpublish one imageAndTextCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishImageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Unpublish one imageCopy from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishImageCopy?: Maybe<ImageCopy>;
  /** Unpublish one imageCopyItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishImageCopyItem?: Maybe<ImageCopyItem>;
  /** Unpublish one introText from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishIntroText?: Maybe<IntroText>;
  /** Unpublish one leftColumn from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishLeftColumn?: Maybe<LeftColumn>;
  /** Unpublish one link from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishLink?: Maybe<Link>;
  /** Unpublish one longText from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishLongText?: Maybe<LongText>;
  /** Unpublish one market from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishMarket?: Maybe<Market>;
  /** Unpublish one marketUserConnection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishMarketUserConnection?: Maybe<MarketUserConnection>;
  /** Unpublish one metaData from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishMetaData?: Maybe<MetaData>;
  /** Unpublish one mobileOnlyMainNavigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishMobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Unpublish one multiStepPromotionForm from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishMultiStepPromotionForm?: Maybe<MultiStepPromotionForm>;
  /** Unpublish one navigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishNavigation?: Maybe<Navigation>;
  /** Unpublish one navigationItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishNavigationItem?: Maybe<NavigationItem>;
  /** Unpublish one newsletterComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishNewsletterComponent?: Maybe<NewsletterComponent>;
  /** Unpublish one newsletterSubscriptions from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishNewsletterSubscriptions?: Maybe<NewsletterSubscriptions>;
  /** Unpublish one notificationBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishNotificationBanner?: Maybe<NotificationBanner>;
  /** Unpublish one pageFooter from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPageFooter?: Maybe<PageFooter>;
  /** Unpublish one pageHeader from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPageHeader?: Maybe<PageHeader>;
  /** Unpublish one popularSearchComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPopularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Unpublish one product from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishProduct?: Maybe<Product>;
  /** Unpublish one productBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishProductBanner?: Maybe<ProductBanner>;
  /** Unpublish one productCategory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishProductCategory?: Maybe<ProductCategory>;
  /** Unpublish one productCategoryPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishProductCategoryPage?: Maybe<ProductCategoryPage>;
  /** Unpublish one productDetailPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishProductDetailPage?: Maybe<ProductDetailPage>;
  /** Unpublish one productHero from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishProductHero?: Maybe<ProductHero>;
  /** Unpublish one productLabel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishProductLabel?: Maybe<ProductLabel>;
  /** Unpublish one productLandingPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishProductLandingPage?: Maybe<ProductLandingPage>;
  /** Unpublish one productSubcategoryPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishProductSubcategoryPage?: Maybe<ProductSubcategoryPage>;
  /** Unpublish one promotionDownload from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPromotionDownload?: Maybe<PromotionDownload>;
  /** Unpublish one promotionForm from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPromotionForm?: Maybe<PromotionForm>;
  /** Unpublish one question from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishQuestion?: Maybe<Question>;
  /** Unpublish one questionCheckbox from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishQuestionCheckbox?: Maybe<QuestionCheckbox>;
  /** Unpublish one questionCheckboxCollection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishQuestionCheckboxCollection?: Maybe<QuestionCheckboxCollection>;
  /** Unpublish one questionRadioButton from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishQuestionRadioButton?: Maybe<QuestionRadioButton>;
  /** Unpublish one questionRadioButtonCollection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishQuestionRadioButtonCollection?: Maybe<QuestionRadioButtonCollection>;
  /** Unpublish one rating from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRating?: Maybe<Rating>;
  /** Unpublish one recipe from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRecipe?: Maybe<Recipe>;
  /** Unpublish one recipeCategory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRecipeCategory?: Maybe<RecipeCategory>;
  /** Unpublish one recipeLandingPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRecipeLandingPage?: Maybe<RecipeLandingPage>;
  /** Unpublish one recipeSubcategory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRecipeSubcategory?: Maybe<RecipeSubcategory>;
  /** Unpublish one recipesComparisonQueryComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRecipesComparisonQueryComponent?: Maybe<RecipesComparisonQueryComponent>;
  /** Unpublish one recipesQueriesReference from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRecipesQueriesReference?: Maybe<RecipesQueriesReference>;
  /** Unpublish one recipesQueryComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRecipesQueryComponent?: Maybe<RecipesQueryComponent>;
  /** Unpublish one redirect from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRedirect?: Maybe<Redirect>;
  /** Unpublish one rewrite from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRewrite?: Maybe<Rewrite>;
  /** Unpublish one rightColumn from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRightColumn?: Maybe<RightColumn>;
  /** Unpublish one searchInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSearchInput?: Maybe<SearchInput>;
  /** Unpublish one searchOverlayComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSearchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Unpublish one searchResultPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSearchResultPage?: Maybe<SearchResultPage>;
  /** Unpublish one separator from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSeparator?: Maybe<Separator>;
  /** Unpublish one singleStepPromotionForm from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSingleStepPromotionForm?: Maybe<SingleStepPromotionForm>;
  /** Unpublish one socialMediaListComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSocialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Unpublish one spacer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSpacer?: Maybe<Spacer>;
  /** Unpublish one subCategoryKeyImage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSubCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Unpublish one subTab from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSubTab?: Maybe<SubTab>;
  /** Unpublish one subTabContent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSubTabContent?: Maybe<SubTabContent>;
  /** Unpublish one sustainabilityBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Unpublish one sustainabilityInfo from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Unpublish one tab from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTab?: Maybe<Tab>;
  /** Unpublish one tabContent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTabContent?: Maybe<TabContent>;
  /** Unpublish one teaser from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTeaser?: Maybe<Teaser>;
  /** Unpublish one teaserPlaceholder from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTeaserPlaceholder?: Maybe<TeaserPlaceholder>;
  /** Unpublish one teaserSmall from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTeaserSmall?: Maybe<TeaserSmall>;
  /** Unpublish one teaserSmallPlaceholder from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTeaserSmallPlaceholder?: Maybe<TeaserSmallPlaceholder>;
  /** Unpublish one testComponentWithRecipeQuery from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTestComponentWithRecipeQuery?: Maybe<TestComponentWithRecipeQuery>;
  /** Unpublish one testTipsANdTricksInAMarket from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTestTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Unpublish one textComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTextComponent?: Maybe<TextComponent>;
  /** Unpublish one tipsAndTricksDetailsPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Unpublish one title from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTitle?: Maybe<Title>;
  /** Unpublish one twitterSeo from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTwitterSeo?: Maybe<TwitterSeo>;
  /** Unpublish one accordion from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAccordion?: Maybe<Accordion>;
  /** Unpublish one accordionItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAccordionItem?: Maybe<AccordionItem>;
  /** Unpublish one algoliaExtension from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAlgoliaExtension?: Maybe<AlgoliaExtension>;
  /** Unpublish one anchorNav from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAnchorNav?: Maybe<AnchorNav>;
  /** Unpublish one anchorNavigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAnchorNavigation?: Maybe<AnchorNavigation>;
  /** Unpublish one anchorNavigationList from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAnchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAsset?: Maybe<Asset>;
  /** Unpublish one assetComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAssetComponent?: Maybe<AssetComponent>;
  /** Unpublish one audioComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAudioComponent?: Maybe<AudioComponent>;
  /** Unpublish one authorableContentCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAuthorableContentCard?: Maybe<AuthorableContentCard>;
  /** Unpublish one banner1 from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishBanner1?: Maybe<Banner1>;
  /** Unpublish one banner2 from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishBanner2?: Maybe<Banner2>;
  /** Unpublish one banner2CarouselComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishBanner2CarouselComponent?: Maybe<Banner2CarouselComponent>;
  /** Unpublish one cardComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCardComponent?: Maybe<CardComponent>;
  /** Unpublish one carouselComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCarouselComponent?: Maybe<CarouselComponent>;
  /** Unpublish one carouselSlide from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCarouselSlide?: Maybe<CarouselSlide>;
  /** Unpublish one categoryCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCategoryCard?: Maybe<CategoryCard>;
  /** Unpublish one contactCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishContactCard?: Maybe<ContactCard>;
  /** Unpublish one contactCardContainer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishContactCardContainer?: Maybe<ContactCardContainer>;
  /** Unpublish one countrySelectorFooter from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCountrySelectorFooter?: Maybe<CountrySelectorFooter>;
  /** Unpublish one countrySelectorItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCountrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Unpublish one demoModel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishDemoModel?: Maybe<DemoModel>;
  /** Unpublish one dictionary from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishDictionary?: Maybe<Dictionary>;
  /** Unpublish one dictionaryItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishDictionaryItem?: Maybe<DictionaryItem>;
  /** Unpublish one downloadApp from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishDownloadApp?: Maybe<DownloadApp>;
  /** Unpublish one dynamicCardGrid from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishDynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Unpublish one errorPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishErrorPage?: Maybe<ErrorPage>;
  /** Unpublish one evalancheFormComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishEvalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Unpublish one exampleComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishExampleComponent?: Maybe<ExampleComponent>;
  /** Unpublish one featuredContent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFeaturedContent?: Maybe<FeaturedContent>;
  /** Unpublish one featuredContentReference from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFeaturedContentReference?: Maybe<FeaturedContentReference>;
  /** Unpublish one footerNavigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFooterNavigation?: Maybe<FooterNavigation>;
  /** Unpublish one footerSeal from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFooterSeal?: Maybe<FooterSeal>;
  /** Unpublish one form from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishForm?: Maybe<Form>;
  /** Unpublish one formCheckbox from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormCheckbox?: Maybe<FormCheckbox>;
  /** Unpublish one formCheckboxCollection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormCheckboxCollection?: Maybe<FormCheckboxCollection>;
  /** Unpublish one formDateInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormDateInput?: Maybe<FormDateInput>;
  /** Unpublish one formEmailInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormEmailInput?: Maybe<FormEmailInput>;
  /** Unpublish one formError from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormError?: Maybe<FormError>;
  /** Unpublish one formFileUploader from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormFileUploader?: Maybe<FormFileUploader>;
  /** Unpublish one formList from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormList?: Maybe<FormList>;
  /** Unpublish one formListItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormListItem?: Maybe<FormListItem>;
  /** Unpublish one formNumberInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormNumberInput?: Maybe<FormNumberInput>;
  /** Unpublish one formPasswordInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormPasswordInput?: Maybe<FormPasswordInput>;
  /** Unpublish one formPasswordInputWithConfirmation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Unpublish one formRadioButton from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormRadioButton?: Maybe<FormRadioButton>;
  /** Unpublish one formRadioButtonCollection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Unpublish one formSelectComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormSelectComponent?: Maybe<FormSelectComponent>;
  /** Unpublish one formSelectOption from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormSelectOption?: Maybe<FormSelectOption>;
  /** Unpublish one formSubmitButton from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormSubmitButton?: Maybe<FormSubmitButton>;
  /** Unpublish one formSuccessComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Unpublish one formTextInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormTextInput?: Maybe<FormTextInput>;
  /** Unpublish one formTextareaInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormTextareaInput?: Maybe<FormTextareaInput>;
  /** Unpublish one genericAccordion from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericAccordion?: Maybe<GenericAccordion>;
  /** Unpublish one genericAccordionItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Unpublish one genericAccordionTopRated from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Unpublish one genericCardCarouseComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Unpublish one genericDownloadComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Unpublish one genericFollowUs from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericFollowUs?: Maybe<GenericFollowUs>;
  /** Unpublish one genericGridAuthorable from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Unpublish one genericHtml from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericHtml?: Maybe<GenericHtml>;
  /** Unpublish one genericLine from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericLine?: Maybe<GenericLine>;
  /** Unpublish one genericLink from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericLink?: Maybe<GenericLink>;
  /** Unpublish one genericPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericPage?: Maybe<GenericPage>;
  /** Unpublish one genericPromotionsOverview from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericPromotionsOverview?: Maybe<GenericPromotionsOverview>;
  /** Unpublish one genericQualifio from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericQualifio?: Maybe<GenericQualifio>;
  /** Unpublish one genericQualifioOverview from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericQualifioOverview?: Maybe<GenericQualifioOverview>;
  /** Unpublish one genericSocialShare from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericSocialShare?: Maybe<GenericSocialShare>;
  /** Unpublish one globalMetaData from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGlobalMetaData?: Maybe<GlobalMetaData>;
  /** Unpublish one globalSearch from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGlobalSearch?: Maybe<GlobalSearch>;
  /** Unpublish one gridColumn from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGridColumn?: Maybe<GridColumn>;
  /** Unpublish one gridColumnComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGridColumnComponent?: Maybe<GridColumnComponent>;
  /** Unpublish one heroBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishHeroBanner?: Maybe<HeroBanner>;
  /** Unpublish one heroBannerMasterbrand from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishHeroBannerMasterbrand?: Maybe<HeroBannerMasterbrand>;
  /** Unpublish one heroCarouselComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishHeroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Unpublish one heroComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishHeroComponent?: Maybe<HeroComponent>;
  /** Unpublish one heroLoopAnimationComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishHeroLoopAnimationComponent?: Maybe<HeroLoopAnimationComponent>;
  /** Unpublish one iframe from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishIframe?: Maybe<Iframe>;
  /** Unpublish one imageAndTextCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishImageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Unpublish one imageCopy from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishImageCopy?: Maybe<ImageCopy>;
  /** Unpublish one imageCopyItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishImageCopyItem?: Maybe<ImageCopyItem>;
  /** Unpublish one introText from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishIntroText?: Maybe<IntroText>;
  /** Unpublish one leftColumn from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishLeftColumn?: Maybe<LeftColumn>;
  /** Unpublish one link from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishLink?: Maybe<Link>;
  /** Unpublish one longText from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishLongText?: Maybe<LongText>;
  /**
   * Unpublish many AccordionItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAccordionItemsConnection)
   */
  unpublishManyAccordionItems: BatchPayload;
  /** Find many AccordionItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAccordionItemsConnection: AccordionItemConnection;
  /**
   * Unpublish many Accordion documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAccordionsConnection)
   */
  unpublishManyAccordions: BatchPayload;
  /** Find many Accordion documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAccordionsConnection: AccordionConnection;
  /**
   * Unpublish many AlgoliaExtension documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAlgoliaExtensionsConnection)
   */
  unpublishManyAlgoliaExtensions: BatchPayload;
  /** Find many AlgoliaExtension documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAlgoliaExtensionsConnection: AlgoliaExtensionConnection;
  /**
   * Unpublish many AnchorNavigationList documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAnchorNavigationListsConnection)
   */
  unpublishManyAnchorNavigationLists: BatchPayload;
  /** Find many AnchorNavigationList documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAnchorNavigationListsConnection: AnchorNavigationListConnection;
  /**
   * Unpublish many AnchorNavigation documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAnchorNavigationsConnection)
   */
  unpublishManyAnchorNavigations: BatchPayload;
  /** Find many AnchorNavigation documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAnchorNavigationsConnection: AnchorNavigationConnection;
  /**
   * Unpublish many AnchorNav documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAnchorNavsConnection)
   */
  unpublishManyAnchorNavs: BatchPayload;
  /** Find many AnchorNav documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAnchorNavsConnection: AnchorNavConnection;
  /**
   * Unpublish many Asset documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAssetsConnection)
   */
  unpublishManyAssets: BatchPayload;
  /**
   * Unpublish many AssetComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAssetsComponentsConnection)
   */
  unpublishManyAssetsComponents: BatchPayload;
  /** Find many AssetComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAssetsComponentsConnection: AssetComponentConnection;
  /** Find many Asset documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAssetsConnection: AssetConnection;
  /**
   * Unpublish many AudioComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAudioComponentsConnection)
   */
  unpublishManyAudioComponents: BatchPayload;
  /** Find many AudioComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAudioComponentsConnection: AudioComponentConnection;
  /**
   * Unpublish many AuthorableContentCard documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAuthorableContentCardsConnection)
   */
  unpublishManyAuthorableContentCards: BatchPayload;
  /** Find many AuthorableContentCard documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAuthorableContentCardsConnection: AuthorableContentCardConnection;
  /**
   * Unpublish many Banner1 documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBanner1sConnection)
   */
  unpublishManyBanner1s: BatchPayload;
  /** Find many Banner1 documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBanner1sConnection: Banner1Connection;
  /**
   * Unpublish many Banner2CarouselComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBanner2CarouselComponentsConnection)
   */
  unpublishManyBanner2CarouselComponents: BatchPayload;
  /** Find many Banner2CarouselComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBanner2CarouselComponentsConnection: Banner2CarouselComponentConnection;
  /**
   * Unpublish many Banner2 documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBanner2SConnection)
   */
  unpublishManyBanner2S: BatchPayload;
  /** Find many Banner2 documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBanner2SConnection: Banner2Connection;
  /**
   * Unpublish many CardComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCardComponentsConnection)
   */
  unpublishManyCardComponents: BatchPayload;
  /** Find many CardComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCardComponentsConnection: CardComponentConnection;
  /**
   * Unpublish many CarouselComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCarouselComponentsConnection)
   */
  unpublishManyCarouselComponents: BatchPayload;
  /** Find many CarouselComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCarouselComponentsConnection: CarouselComponentConnection;
  /**
   * Unpublish many CarouselSlide documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCarouselSlidesConnection)
   */
  unpublishManyCarouselSlides: BatchPayload;
  /** Find many CarouselSlide documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCarouselSlidesConnection: CarouselSlideConnection;
  /**
   * Unpublish many CategoryCard documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCategoryCardsConnection)
   */
  unpublishManyCategoryCards: BatchPayload;
  /** Find many CategoryCard documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCategoryCardsConnection: CategoryCardConnection;
  /**
   * Unpublish many ContactCardContainer documents
   * @deprecated Please use the new paginated many mutation (unpublishManyContactCardContainersConnection)
   */
  unpublishManyContactCardContainers: BatchPayload;
  /** Find many ContactCardContainer documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyContactCardContainersConnection: ContactCardContainerConnection;
  /**
   * Unpublish many ContactCard documents
   * @deprecated Please use the new paginated many mutation (unpublishManyContactCardsConnection)
   */
  unpublishManyContactCards: BatchPayload;
  /** Find many ContactCard documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyContactCardsConnection: ContactCardConnection;
  /**
   * Unpublish many CountrySelectorFooter documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCountrySelectorFootersConnection)
   */
  unpublishManyCountrySelectorFooters: BatchPayload;
  /** Find many CountrySelectorFooter documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCountrySelectorFootersConnection: CountrySelectorFooterConnection;
  /**
   * Unpublish many CountrySelectorItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCountrySelectorItemsConnection)
   */
  unpublishManyCountrySelectorItems: BatchPayload;
  /** Find many CountrySelectorItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCountrySelectorItemsConnection: CountrySelectorItemConnection;
  /**
   * Unpublish many DemoModel documents
   * @deprecated Please use the new paginated many mutation (unpublishManyDemoModelsConnection)
   */
  unpublishManyDemoModels: BatchPayload;
  /** Find many DemoModel documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyDemoModelsConnection: DemoModelConnection;
  /**
   * Unpublish many Dictionary documents
   * @deprecated Please use the new paginated many mutation (unpublishManyDictionariesConnection)
   */
  unpublishManyDictionaries: BatchPayload;
  /** Find many Dictionary documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyDictionariesConnection: DictionaryConnection;
  /**
   * Unpublish many DictionaryItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyDictionaryItemsConnection)
   */
  unpublishManyDictionaryItems: BatchPayload;
  /** Find many DictionaryItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyDictionaryItemsConnection: DictionaryItemConnection;
  /**
   * Unpublish many DownloadApp documents
   * @deprecated Please use the new paginated many mutation (unpublishManyDownloadAppsConnection)
   */
  unpublishManyDownloadApps: BatchPayload;
  /** Find many DownloadApp documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyDownloadAppsConnection: DownloadAppConnection;
  /**
   * Unpublish many DynamicCardGrid documents
   * @deprecated Please use the new paginated many mutation (unpublishManyDynamicCardGridsConnection)
   */
  unpublishManyDynamicCardGrids: BatchPayload;
  /** Find many DynamicCardGrid documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyDynamicCardGridsConnection: DynamicCardGridConnection;
  /**
   * Unpublish many ErrorPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyErrorPagesConnection)
   */
  unpublishManyErrorPages: BatchPayload;
  /** Find many ErrorPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyErrorPagesConnection: ErrorPageConnection;
  /**
   * Unpublish many EvalancheFormComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyEvalancheFormComponentsConnection)
   */
  unpublishManyEvalancheFormComponents: BatchPayload;
  /** Find many EvalancheFormComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyEvalancheFormComponentsConnection: EvalancheFormComponentConnection;
  /**
   * Unpublish many ExampleComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyExampleComponentsConnection)
   */
  unpublishManyExampleComponents: BatchPayload;
  /** Find many ExampleComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyExampleComponentsConnection: ExampleComponentConnection;
  /**
   * Unpublish many FeaturedContentReference documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFeaturedContentReferencesConnection)
   */
  unpublishManyFeaturedContentReferences: BatchPayload;
  /** Find many FeaturedContentReference documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFeaturedContentReferencesConnection: FeaturedContentReferenceConnection;
  /**
   * Unpublish many FeaturedContent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFeaturedContentsConnection)
   */
  unpublishManyFeaturedContents: BatchPayload;
  /** Find many FeaturedContent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFeaturedContentsConnection: FeaturedContentConnection;
  /**
   * Unpublish many FooterNavigation documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFooterNavigationsConnection)
   */
  unpublishManyFooterNavigations: BatchPayload;
  /** Find many FooterNavigation documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFooterNavigationsConnection: FooterNavigationConnection;
  /**
   * Unpublish many FooterSeal documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFooterSealsConnection)
   */
  unpublishManyFooterSeals: BatchPayload;
  /** Find many FooterSeal documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFooterSealsConnection: FooterSealConnection;
  /**
   * Unpublish many FormCheckboxCollection documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormCheckboxCollectionsConnection)
   */
  unpublishManyFormCheckboxCollections: BatchPayload;
  /** Find many FormCheckboxCollection documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormCheckboxCollectionsConnection: FormCheckboxCollectionConnection;
  /**
   * Unpublish many FormCheckbox documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormCheckboxesConnection)
   */
  unpublishManyFormCheckboxes: BatchPayload;
  /** Find many FormCheckbox documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormCheckboxesConnection: FormCheckboxConnection;
  /**
   * Unpublish many FormDateInput documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormDateInputsConnection)
   */
  unpublishManyFormDateInputs: BatchPayload;
  /** Find many FormDateInput documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormDateInputsConnection: FormDateInputConnection;
  /**
   * Unpublish many FormEmailInput documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormEmailInputsConnection)
   */
  unpublishManyFormEmailInputs: BatchPayload;
  /** Find many FormEmailInput documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormEmailInputsConnection: FormEmailInputConnection;
  /**
   * Unpublish many FormError documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormErrorsConnection)
   */
  unpublishManyFormErrors: BatchPayload;
  /** Find many FormError documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormErrorsConnection: FormErrorConnection;
  /**
   * Unpublish many FormFileUploader documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormFileUploadersConnection)
   */
  unpublishManyFormFileUploaders: BatchPayload;
  /** Find many FormFileUploader documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormFileUploadersConnection: FormFileUploaderConnection;
  /**
   * Unpublish many FormListItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormListItemsConnection)
   */
  unpublishManyFormListItems: BatchPayload;
  /** Find many FormListItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormListItemsConnection: FormListItemConnection;
  /**
   * Unpublish many FormList documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormListsConnection)
   */
  unpublishManyFormLists: BatchPayload;
  /** Find many FormList documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormListsConnection: FormListConnection;
  /**
   * Unpublish many FormNumberInput documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormNumberInputsConnection)
   */
  unpublishManyFormNumberInputs: BatchPayload;
  /** Find many FormNumberInput documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormNumberInputsConnection: FormNumberInputConnection;
  /**
   * Unpublish many FormPasswordInputWithConfirmation documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormPasswordInputWithConfirmationsConnection)
   */
  unpublishManyFormPasswordInputWithConfirmations: BatchPayload;
  /** Find many FormPasswordInputWithConfirmation documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormPasswordInputWithConfirmationsConnection: FormPasswordInputWithConfirmationConnection;
  /**
   * Unpublish many FormPasswordInput documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormPasswordInputsConnection)
   */
  unpublishManyFormPasswordInputs: BatchPayload;
  /** Find many FormPasswordInput documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormPasswordInputsConnection: FormPasswordInputConnection;
  /**
   * Unpublish many FormRadioButtonCollection documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormRadioButtonCollectionsConnection)
   */
  unpublishManyFormRadioButtonCollections: BatchPayload;
  /** Find many FormRadioButtonCollection documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormRadioButtonCollectionsConnection: FormRadioButtonCollectionConnection;
  /**
   * Unpublish many FormRadioButton documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormRadioButtonsConnection)
   */
  unpublishManyFormRadioButtons: BatchPayload;
  /** Find many FormRadioButton documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormRadioButtonsConnection: FormRadioButtonConnection;
  /**
   * Unpublish many FormSelectComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormSelectComponentsConnection)
   */
  unpublishManyFormSelectComponents: BatchPayload;
  /** Find many FormSelectComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormSelectComponentsConnection: FormSelectComponentConnection;
  /**
   * Unpublish many FormSelectOption documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormSelectOptionsConnection)
   */
  unpublishManyFormSelectOptions: BatchPayload;
  /** Find many FormSelectOption documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormSelectOptionsConnection: FormSelectOptionConnection;
  /**
   * Unpublish many FormSubmitButton documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormSubmitButtonsConnection)
   */
  unpublishManyFormSubmitButtons: BatchPayload;
  /** Find many FormSubmitButton documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormSubmitButtonsConnection: FormSubmitButtonConnection;
  /**
   * Unpublish many FormSuccessComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormSuccessComponentsConnection)
   */
  unpublishManyFormSuccessComponents: BatchPayload;
  /** Find many FormSuccessComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormSuccessComponentsConnection: FormSuccessComponentConnection;
  /**
   * Unpublish many FormTextInput documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormTextInputsConnection)
   */
  unpublishManyFormTextInputs: BatchPayload;
  /** Find many FormTextInput documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormTextInputsConnection: FormTextInputConnection;
  /**
   * Unpublish many FormTextareaInput documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormTextareaInputsConnection)
   */
  unpublishManyFormTextareaInputs: BatchPayload;
  /** Find many FormTextareaInput documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormTextareaInputsConnection: FormTextareaInputConnection;
  /**
   * Unpublish many Form documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormsConnection)
   */
  unpublishManyForms: BatchPayload;
  /** Find many Form documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormsConnection: FormConnection;
  /**
   * Unpublish many GenericAccordionItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericAccordionItemsConnection)
   */
  unpublishManyGenericAccordionItems: BatchPayload;
  /** Find many GenericAccordionItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericAccordionItemsConnection: GenericAccordionItemConnection;
  /**
   * Unpublish many GenericAccordionTopRated documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericAccordionTopRatedsConnection)
   */
  unpublishManyGenericAccordionTopRateds: BatchPayload;
  /** Find many GenericAccordionTopRated documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericAccordionTopRatedsConnection: GenericAccordionTopRatedConnection;
  /**
   * Unpublish many GenericAccordion documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericAccordionsConnection)
   */
  unpublishManyGenericAccordions: BatchPayload;
  /** Find many GenericAccordion documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericAccordionsConnection: GenericAccordionConnection;
  /**
   * Unpublish many GenericCardCarouseComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericCardCarouseComponentsConnection)
   */
  unpublishManyGenericCardCarouseComponents: BatchPayload;
  /** Find many GenericCardCarouseComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericCardCarouseComponentsConnection: GenericCardCarouseComponentConnection;
  /**
   * Unpublish many GenericDownloadComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericDownloadComponentsConnection)
   */
  unpublishManyGenericDownloadComponents: BatchPayload;
  /** Find many GenericDownloadComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericDownloadComponentsConnection: GenericDownloadComponentConnection;
  /**
   * Unpublish many GenericFollowUs documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericFollowUsesConnection)
   */
  unpublishManyGenericFollowUses: BatchPayload;
  /** Find many GenericFollowUs documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericFollowUsesConnection: GenericFollowUsConnection;
  /**
   * Unpublish many GenericGridAuthorable documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericGridAuthorablesConnection)
   */
  unpublishManyGenericGridAuthorables: BatchPayload;
  /** Find many GenericGridAuthorable documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericGridAuthorablesConnection: GenericGridAuthorableConnection;
  /**
   * Unpublish many GenericHtml documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericHtmlsConnection)
   */
  unpublishManyGenericHtmls: BatchPayload;
  /** Find many GenericHtml documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericHtmlsConnection: GenericHtmlConnection;
  /**
   * Unpublish many GenericLine documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericLinesConnection)
   */
  unpublishManyGenericLines: BatchPayload;
  /** Find many GenericLine documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericLinesConnection: GenericLineConnection;
  /**
   * Unpublish many GenericLink documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericLinksConnection)
   */
  unpublishManyGenericLinks: BatchPayload;
  /** Find many GenericLink documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericLinksConnection: GenericLinkConnection;
  /**
   * Unpublish many GenericPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericPagesConnection)
   */
  unpublishManyGenericPages: BatchPayload;
  /** Find many GenericPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericPagesConnection: GenericPageConnection;
  /**
   * Unpublish many GenericPromotionsOverview documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericPromotionsOverviewsConnection)
   */
  unpublishManyGenericPromotionsOverviews: BatchPayload;
  /** Find many GenericPromotionsOverview documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericPromotionsOverviewsConnection: GenericPromotionsOverviewConnection;
  /**
   * Unpublish many GenericQualifioOverview documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericQualifioOverviewsConnection)
   */
  unpublishManyGenericQualifioOverviews: BatchPayload;
  /** Find many GenericQualifioOverview documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericQualifioOverviewsConnection: GenericQualifioOverviewConnection;
  /**
   * Unpublish many GenericQualifio documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericQualifiosConnection)
   */
  unpublishManyGenericQualifios: BatchPayload;
  /** Find many GenericQualifio documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericQualifiosConnection: GenericQualifioConnection;
  /**
   * Unpublish many GenericSocialShare documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericSocialSharesConnection)
   */
  unpublishManyGenericSocialShares: BatchPayload;
  /** Find many GenericSocialShare documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericSocialSharesConnection: GenericSocialShareConnection;
  /**
   * Unpublish many GlobalMetaData documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGlobalMetaDatasConnection)
   */
  unpublishManyGlobalMetaDatas: BatchPayload;
  /** Find many GlobalMetaData documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGlobalMetaDatasConnection: GlobalMetaDataConnection;
  /**
   * Unpublish many GlobalSearch documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGlobalSearchesConnection)
   */
  unpublishManyGlobalSearches: BatchPayload;
  /** Find many GlobalSearch documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGlobalSearchesConnection: GlobalSearchConnection;
  /**
   * Unpublish many GridColumnComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGridColumnComponentsConnection)
   */
  unpublishManyGridColumnComponents: BatchPayload;
  /** Find many GridColumnComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGridColumnComponentsConnection: GridColumnComponentConnection;
  /**
   * Unpublish many GridColumn documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGridColumnsConnection)
   */
  unpublishManyGridColumns: BatchPayload;
  /** Find many GridColumn documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGridColumnsConnection: GridColumnConnection;
  /**
   * Unpublish many HeroBannerMasterbrand documents
   * @deprecated Please use the new paginated many mutation (unpublishManyHeroBannerMasterbrandsConnection)
   */
  unpublishManyHeroBannerMasterbrands: BatchPayload;
  /** Find many HeroBannerMasterbrand documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyHeroBannerMasterbrandsConnection: HeroBannerMasterbrandConnection;
  /**
   * Unpublish many HeroBanner documents
   * @deprecated Please use the new paginated many mutation (unpublishManyHeroBannersConnection)
   */
  unpublishManyHeroBanners: BatchPayload;
  /** Find many HeroBanner documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyHeroBannersConnection: HeroBannerConnection;
  /**
   * Unpublish many HeroCarouselComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyHeroCarouselComponentsConnection)
   */
  unpublishManyHeroCarouselComponents: BatchPayload;
  /** Find many HeroCarouselComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyHeroCarouselComponentsConnection: HeroCarouselComponentConnection;
  /**
   * Unpublish many HeroComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyHeroComponentsConnection)
   */
  unpublishManyHeroComponents: BatchPayload;
  /** Find many HeroComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyHeroComponentsConnection: HeroComponentConnection;
  /**
   * Unpublish many HeroLoopAnimationComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyHeroLoopAnimationComponentsConnection)
   */
  unpublishManyHeroLoopAnimationComponents: BatchPayload;
  /** Find many HeroLoopAnimationComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyHeroLoopAnimationComponentsConnection: HeroLoopAnimationComponentConnection;
  /**
   * Unpublish many Iframe documents
   * @deprecated Please use the new paginated many mutation (unpublishManyIframesConnection)
   */
  unpublishManyIframes: BatchPayload;
  /** Find many Iframe documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyIframesConnection: IframeConnection;
  /**
   * Unpublish many ImageAndTextCard documents
   * @deprecated Please use the new paginated many mutation (unpublishManyImageAndTextCardsConnection)
   */
  unpublishManyImageAndTextCards: BatchPayload;
  /** Find many ImageAndTextCard documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyImageAndTextCardsConnection: ImageAndTextCardConnection;
  /**
   * Unpublish many ImageCopy documents
   * @deprecated Please use the new paginated many mutation (unpublishManyImageCopiesConnection)
   */
  unpublishManyImageCopies: BatchPayload;
  /** Find many ImageCopy documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyImageCopiesConnection: ImageCopyConnection;
  /**
   * Unpublish many ImageCopyItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyImageCopyItemsConnection)
   */
  unpublishManyImageCopyItems: BatchPayload;
  /** Find many ImageCopyItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyImageCopyItemsConnection: ImageCopyItemConnection;
  /**
   * Unpublish many IntroText documents
   * @deprecated Please use the new paginated many mutation (unpublishManyIntroTextsConnection)
   */
  unpublishManyIntroTexts: BatchPayload;
  /** Find many IntroText documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyIntroTextsConnection: IntroTextConnection;
  /**
   * Unpublish many LeftColumn documents
   * @deprecated Please use the new paginated many mutation (unpublishManyLeftColumnsConnection)
   */
  unpublishManyLeftColumns: BatchPayload;
  /** Find many LeftColumn documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyLeftColumnsConnection: LeftColumnConnection;
  /**
   * Unpublish many Link documents
   * @deprecated Please use the new paginated many mutation (unpublishManyLinksConnection)
   */
  unpublishManyLinks: BatchPayload;
  /** Find many Link documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyLinksConnection: LinkConnection;
  /**
   * Unpublish many LongText documents
   * @deprecated Please use the new paginated many mutation (unpublishManyLongTextsConnection)
   */
  unpublishManyLongTexts: BatchPayload;
  /** Find many LongText documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyLongTextsConnection: LongTextConnection;
  /**
   * Unpublish many MarketUserConnection documents
   * @deprecated Please use the new paginated many mutation (unpublishManyMarketUserConnectionsConnection)
   */
  unpublishManyMarketUserConnections: BatchPayload;
  /** Find many MarketUserConnection documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyMarketUserConnectionsConnection: MarketUserConnectionConnection;
  /**
   * Unpublish many Market documents
   * @deprecated Please use the new paginated many mutation (unpublishManyMarketsConnection)
   */
  unpublishManyMarkets: BatchPayload;
  /** Find many Market documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyMarketsConnection: MarketConnection;
  /**
   * Unpublish many MetaData documents
   * @deprecated Please use the new paginated many mutation (unpublishManyMetaDatasConnection)
   */
  unpublishManyMetaDatas: BatchPayload;
  /** Find many MetaData documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyMetaDatasConnection: MetaDataConnection;
  /**
   * Unpublish many MobileOnlyMainNavigation documents
   * @deprecated Please use the new paginated many mutation (unpublishManyMobileOnlyMainNavigationsConnection)
   */
  unpublishManyMobileOnlyMainNavigations: BatchPayload;
  /** Find many MobileOnlyMainNavigation documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyMobileOnlyMainNavigationsConnection: MobileOnlyMainNavigationConnection;
  /**
   * Unpublish many MultiStepPromotionForm documents
   * @deprecated Please use the new paginated many mutation (unpublishManyMultiStepPromotionFormsConnection)
   */
  unpublishManyMultiStepPromotionForms: BatchPayload;
  /** Find many MultiStepPromotionForm documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyMultiStepPromotionFormsConnection: MultiStepPromotionFormConnection;
  /**
   * Unpublish many NavigationItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyNavigationItemsConnection)
   */
  unpublishManyNavigationItems: BatchPayload;
  /** Find many NavigationItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyNavigationItemsConnection: NavigationItemConnection;
  /**
   * Unpublish many Navigation documents
   * @deprecated Please use the new paginated many mutation (unpublishManyNavigationsConnection)
   */
  unpublishManyNavigations: BatchPayload;
  /** Find many Navigation documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyNavigationsConnection: NavigationConnection;
  /**
   * Unpublish many NewsletterComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyNewsletterComponentsConnection)
   */
  unpublishManyNewsletterComponents: BatchPayload;
  /** Find many NewsletterComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyNewsletterComponentsConnection: NewsletterComponentConnection;
  /**
   * Unpublish many NewsletterSubscriptions documents
   * @deprecated Please use the new paginated many mutation (unpublishManyNewsletterSubscriptionsPluralConnection)
   */
  unpublishManyNewsletterSubscriptionsPlural: BatchPayload;
  /** Find many NewsletterSubscriptions documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyNewsletterSubscriptionsPluralConnection: NewsletterSubscriptionsConnection;
  /**
   * Unpublish many NotificationBanner documents
   * @deprecated Please use the new paginated many mutation (unpublishManyNotificationBannersConnection)
   */
  unpublishManyNotificationBanners: BatchPayload;
  /** Find many NotificationBanner documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyNotificationBannersConnection: NotificationBannerConnection;
  /**
   * Unpublish many PageFooter documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPageFootersConnection)
   */
  unpublishManyPageFooters: BatchPayload;
  /** Find many PageFooter documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPageFootersConnection: PageFooterConnection;
  /**
   * Unpublish many PageHeader documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPageHeadersConnection)
   */
  unpublishManyPageHeaders: BatchPayload;
  /** Find many PageHeader documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPageHeadersConnection: PageHeaderConnection;
  /**
   * Unpublish many PopularSearchComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPopularSearchComponentsConnection)
   */
  unpublishManyPopularSearchComponents: BatchPayload;
  /** Find many PopularSearchComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPopularSearchComponentsConnection: PopularSearchComponentConnection;
  /**
   * Unpublish many ProductBanner documents
   * @deprecated Please use the new paginated many mutation (unpublishManyProductBannersConnection)
   */
  unpublishManyProductBanners: BatchPayload;
  /** Find many ProductBanner documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyProductBannersConnection: ProductBannerConnection;
  /**
   * Unpublish many ProductCategory documents
   * @deprecated Please use the new paginated many mutation (unpublishManyProductCategoriesConnection)
   */
  unpublishManyProductCategories: BatchPayload;
  /** Find many ProductCategory documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyProductCategoriesConnection: ProductCategoryConnection;
  /**
   * Unpublish many ProductCategoryPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyProductCategoryPagesConnection)
   */
  unpublishManyProductCategoryPages: BatchPayload;
  /** Find many ProductCategoryPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyProductCategoryPagesConnection: ProductCategoryPageConnection;
  /**
   * Unpublish many ProductDetailPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyProductDetailPagesConnection)
   */
  unpublishManyProductDetailPages: BatchPayload;
  /** Find many ProductDetailPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyProductDetailPagesConnection: ProductDetailPageConnection;
  /**
   * Unpublish many ProductHero documents
   * @deprecated Please use the new paginated many mutation (unpublishManyProductHeroesConnection)
   */
  unpublishManyProductHeroes: BatchPayload;
  /** Find many ProductHero documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyProductHeroesConnection: ProductHeroConnection;
  /**
   * Unpublish many ProductLabel documents
   * @deprecated Please use the new paginated many mutation (unpublishManyProductLabelsConnection)
   */
  unpublishManyProductLabels: BatchPayload;
  /** Find many ProductLabel documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyProductLabelsConnection: ProductLabelConnection;
  /**
   * Unpublish many ProductLandingPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyProductLandingPagesConnection)
   */
  unpublishManyProductLandingPages: BatchPayload;
  /** Find many ProductLandingPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyProductLandingPagesConnection: ProductLandingPageConnection;
  /**
   * Unpublish many ProductSubcategoryPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyProductSubcategoryPagesConnection)
   */
  unpublishManyProductSubcategoryPages: BatchPayload;
  /** Find many ProductSubcategoryPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyProductSubcategoryPagesConnection: ProductSubcategoryPageConnection;
  /**
   * Unpublish many Product documents
   * @deprecated Please use the new paginated many mutation (unpublishManyProductsConnection)
   */
  unpublishManyProducts: BatchPayload;
  /** Find many Product documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyProductsConnection: ProductConnection;
  /**
   * Unpublish many PromotionDownload documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPromotionDownloadsConnection)
   */
  unpublishManyPromotionDownloads: BatchPayload;
  /** Find many PromotionDownload documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPromotionDownloadsConnection: PromotionDownloadConnection;
  /**
   * Unpublish many PromotionForm documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPromotionFormsConnection)
   */
  unpublishManyPromotionForms: BatchPayload;
  /** Find many PromotionForm documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPromotionFormsConnection: PromotionFormConnection;
  /**
   * Unpublish many QuestionCheckboxCollection documents
   * @deprecated Please use the new paginated many mutation (unpublishManyQuestionCheckboxCollectionsConnection)
   */
  unpublishManyQuestionCheckboxCollections: BatchPayload;
  /** Find many QuestionCheckboxCollection documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyQuestionCheckboxCollectionsConnection: QuestionCheckboxCollectionConnection;
  /**
   * Unpublish many QuestionCheckbox documents
   * @deprecated Please use the new paginated many mutation (unpublishManyQuestionCheckboxesConnection)
   */
  unpublishManyQuestionCheckboxes: BatchPayload;
  /** Find many QuestionCheckbox documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyQuestionCheckboxesConnection: QuestionCheckboxConnection;
  /**
   * Unpublish many QuestionRadioButtonCollection documents
   * @deprecated Please use the new paginated many mutation (unpublishManyQuestionRadioButtonCollectionsConnection)
   */
  unpublishManyQuestionRadioButtonCollections: BatchPayload;
  /** Find many QuestionRadioButtonCollection documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyQuestionRadioButtonCollectionsConnection: QuestionRadioButtonCollectionConnection;
  /**
   * Unpublish many QuestionRadioButton documents
   * @deprecated Please use the new paginated many mutation (unpublishManyQuestionRadioButtonsConnection)
   */
  unpublishManyQuestionRadioButtons: BatchPayload;
  /** Find many QuestionRadioButton documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyQuestionRadioButtonsConnection: QuestionRadioButtonConnection;
  /**
   * Unpublish many Question documents
   * @deprecated Please use the new paginated many mutation (unpublishManyQuestionsConnection)
   */
  unpublishManyQuestions: BatchPayload;
  /** Find many Question documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyQuestionsConnection: QuestionConnection;
  /**
   * Unpublish many Rating documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRatingsConnection)
   */
  unpublishManyRatings: BatchPayload;
  /** Find many Rating documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRatingsConnection: RatingConnection;
  /**
   * Unpublish many RecipeCategory documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRecipeCategoriesConnection)
   */
  unpublishManyRecipeCategories: BatchPayload;
  /** Find many RecipeCategory documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRecipeCategoriesConnection: RecipeCategoryConnection;
  /**
   * Unpublish many RecipeLandingPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRecipeLandingPagesConnection)
   */
  unpublishManyRecipeLandingPages: BatchPayload;
  /** Find many RecipeLandingPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRecipeLandingPagesConnection: RecipeLandingPageConnection;
  /**
   * Unpublish many RecipeSubcategory documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRecipeSubcategoriesConnection)
   */
  unpublishManyRecipeSubcategories: BatchPayload;
  /** Find many RecipeSubcategory documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRecipeSubcategoriesConnection: RecipeSubcategoryConnection;
  /**
   * Unpublish many Recipe documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRecipesConnection)
   */
  unpublishManyRecipes: BatchPayload;
  /**
   * Unpublish many RecipesComparisonQueryComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRecipesComparisonQueryComponentsConnection)
   */
  unpublishManyRecipesComparisonQueryComponents: BatchPayload;
  /** Find many RecipesComparisonQueryComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRecipesComparisonQueryComponentsConnection: RecipesComparisonQueryComponentConnection;
  /** Find many Recipe documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRecipesConnection: RecipeConnection;
  /**
   * Unpublish many RecipesQueriesReference documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRecipesQueriesReferencesConnection)
   */
  unpublishManyRecipesQueriesReferences: BatchPayload;
  /** Find many RecipesQueriesReference documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRecipesQueriesReferencesConnection: RecipesQueriesReferenceConnection;
  /**
   * Unpublish many RecipesQueryComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRecipesQueryComponentsConnection)
   */
  unpublishManyRecipesQueryComponents: BatchPayload;
  /** Find many RecipesQueryComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRecipesQueryComponentsConnection: RecipesQueryComponentConnection;
  /**
   * Unpublish many Redirect documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRedirectsConnection)
   */
  unpublishManyRedirects: BatchPayload;
  /** Find many Redirect documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRedirectsConnection: RedirectConnection;
  /**
   * Unpublish many Rewrite documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRewritesConnection)
   */
  unpublishManyRewrites: BatchPayload;
  /** Find many Rewrite documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRewritesConnection: RewriteConnection;
  /**
   * Unpublish many RightColumn documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRightColumnsConnection)
   */
  unpublishManyRightColumns: BatchPayload;
  /** Find many RightColumn documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRightColumnsConnection: RightColumnConnection;
  /**
   * Unpublish many SearchInput documents
   * @deprecated Please use the new paginated many mutation (unpublishManySearchInputsConnection)
   */
  unpublishManySearchInputs: BatchPayload;
  /** Find many SearchInput documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySearchInputsConnection: SearchInputConnection;
  /**
   * Unpublish many SearchOverlayComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManySearchOverlayComponentsConnection)
   */
  unpublishManySearchOverlayComponents: BatchPayload;
  /** Find many SearchOverlayComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySearchOverlayComponentsConnection: SearchOverlayComponentConnection;
  /**
   * Unpublish many SearchResultPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManySearchResultPagesConnection)
   */
  unpublishManySearchResultPages: BatchPayload;
  /** Find many SearchResultPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySearchResultPagesConnection: SearchResultPageConnection;
  /**
   * Unpublish many Separator documents
   * @deprecated Please use the new paginated many mutation (unpublishManySeparatorsConnection)
   */
  unpublishManySeparators: BatchPayload;
  /** Find many Separator documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySeparatorsConnection: SeparatorConnection;
  /**
   * Unpublish many SingleStepPromotionForm documents
   * @deprecated Please use the new paginated many mutation (unpublishManySingleStepPromotionFormsConnection)
   */
  unpublishManySingleStepPromotionForms: BatchPayload;
  /** Find many SingleStepPromotionForm documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySingleStepPromotionFormsConnection: SingleStepPromotionFormConnection;
  /**
   * Unpublish many SocialMediaListComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManySocialMediaListComponentsConnection)
   */
  unpublishManySocialMediaListComponents: BatchPayload;
  /** Find many SocialMediaListComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySocialMediaListComponentsConnection: SocialMediaListComponentConnection;
  /**
   * Unpublish many Spacer documents
   * @deprecated Please use the new paginated many mutation (unpublishManySpacersConnection)
   */
  unpublishManySpacers: BatchPayload;
  /** Find many Spacer documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySpacersConnection: SpacerConnection;
  /**
   * Unpublish many SubCategoryKeyImage documents
   * @deprecated Please use the new paginated many mutation (unpublishManySubCategoryKeyImagesConnection)
   */
  unpublishManySubCategoryKeyImages: BatchPayload;
  /** Find many SubCategoryKeyImage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySubCategoryKeyImagesConnection: SubCategoryKeyImageConnection;
  /**
   * Unpublish many SubTab documents
   * @deprecated Please use the new paginated many mutation (unpublishManySubTabsConnection)
   */
  unpublishManySubTabs: BatchPayload;
  /** Find many SubTab documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySubTabsConnection: SubTabConnection;
  /**
   * Unpublish many SubTabContent documents
   * @deprecated Please use the new paginated many mutation (unpublishManySubTabsContentConnection)
   */
  unpublishManySubTabsContent: BatchPayload;
  /** Find many SubTabContent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySubTabsContentConnection: SubTabContentConnection;
  /**
   * Unpublish many SustainabilityBanner documents
   * @deprecated Please use the new paginated many mutation (unpublishManySustainabilityBannersConnection)
   */
  unpublishManySustainabilityBanners: BatchPayload;
  /** Find many SustainabilityBanner documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySustainabilityBannersConnection: SustainabilityBannerConnection;
  /**
   * Unpublish many SustainabilityInfo documents
   * @deprecated Please use the new paginated many mutation (unpublishManySustainabilityInfosConnection)
   */
  unpublishManySustainabilityInfos: BatchPayload;
  /** Find many SustainabilityInfo documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySustainabilityInfosConnection: SustainabilityInfoConnection;
  /**
   * Unpublish many TabContent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTabContentsConnection)
   */
  unpublishManyTabContents: BatchPayload;
  /** Find many TabContent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTabContentsConnection: TabContentConnection;
  /**
   * Unpublish many Tab documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTabsConnection)
   */
  unpublishManyTabs: BatchPayload;
  /** Find many Tab documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTabsConnection: TabConnection;
  /**
   * Unpublish many TeaserPlaceholder documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTeaserPlaceholdersConnection)
   */
  unpublishManyTeaserPlaceholders: BatchPayload;
  /** Find many TeaserPlaceholder documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTeaserPlaceholdersConnection: TeaserPlaceholderConnection;
  /**
   * Unpublish many TeaserSmallPlaceholder documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTeaserSmallPlaceholdersConnection)
   */
  unpublishManyTeaserSmallPlaceholders: BatchPayload;
  /** Find many TeaserSmallPlaceholder documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTeaserSmallPlaceholdersConnection: TeaserSmallPlaceholderConnection;
  /**
   * Unpublish many TeaserSmall documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTeaserSmallsConnection)
   */
  unpublishManyTeaserSmalls: BatchPayload;
  /** Find many TeaserSmall documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTeaserSmallsConnection: TeaserSmallConnection;
  /**
   * Unpublish many Teaser documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTeasersConnection)
   */
  unpublishManyTeasers: BatchPayload;
  /** Find many Teaser documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTeasersConnection: TeaserConnection;
  /**
   * Unpublish many TestComponentWithRecipeQuery documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTestComponentWithRecipeQueriesConnection)
   */
  unpublishManyTestComponentWithRecipeQueries: BatchPayload;
  /** Find many TestComponentWithRecipeQuery documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTestComponentWithRecipeQueriesConnection: TestComponentWithRecipeQueryConnection;
  /**
   * Unpublish many TestTipsANdTricksInAMarket documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTestTipsANdTricksInAMarketsConnection)
   */
  unpublishManyTestTipsANdTricksInAMarkets: BatchPayload;
  /** Find many TestTipsANdTricksInAMarket documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTestTipsANdTricksInAMarketsConnection: TestTipsANdTricksInAMarketConnection;
  /**
   * Unpublish many TextComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTextComponentsConnection)
   */
  unpublishManyTextComponents: BatchPayload;
  /** Find many TextComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTextComponentsConnection: TextComponentConnection;
  /**
   * Unpublish many TipsAndTricksDetailsPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTipsAndTricksDetailsPagesConnection)
   */
  unpublishManyTipsAndTricksDetailsPages: BatchPayload;
  /** Find many TipsAndTricksDetailsPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTipsAndTricksDetailsPagesConnection: TipsAndTricksDetailsPageConnection;
  /**
   * Unpublish many Title documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTitlesConnection)
   */
  unpublishManyTitles: BatchPayload;
  /** Find many Title documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTitlesConnection: TitleConnection;
  /**
   * Unpublish many TwitterSeo documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTwitterSeosConnection)
   */
  unpublishManyTwitterSeos: BatchPayload;
  /** Find many TwitterSeo documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTwitterSeosConnection: TwitterSeoConnection;
  /** Unpublish one market from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishMarket?: Maybe<Market>;
  /** Unpublish one marketUserConnection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishMarketUserConnection?: Maybe<MarketUserConnection>;
  /** Unpublish one metaData from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishMetaData?: Maybe<MetaData>;
  /** Unpublish one mobileOnlyMainNavigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishMobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Unpublish one multiStepPromotionForm from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishMultiStepPromotionForm?: Maybe<MultiStepPromotionForm>;
  /** Unpublish one navigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishNavigation?: Maybe<Navigation>;
  /** Unpublish one navigationItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishNavigationItem?: Maybe<NavigationItem>;
  /** Unpublish one newsletterComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishNewsletterComponent?: Maybe<NewsletterComponent>;
  /** Unpublish one newsletterSubscriptions from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishNewsletterSubscriptions?: Maybe<NewsletterSubscriptions>;
  /** Unpublish one notificationBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishNotificationBanner?: Maybe<NotificationBanner>;
  /** Unpublish one pageFooter from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPageFooter?: Maybe<PageFooter>;
  /** Unpublish one pageHeader from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPageHeader?: Maybe<PageHeader>;
  /** Unpublish one popularSearchComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPopularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Unpublish one product from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishProduct?: Maybe<Product>;
  /** Unpublish one productBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishProductBanner?: Maybe<ProductBanner>;
  /** Unpublish one productCategory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishProductCategory?: Maybe<ProductCategory>;
  /** Unpublish one productCategoryPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishProductCategoryPage?: Maybe<ProductCategoryPage>;
  /** Unpublish one productDetailPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishProductDetailPage?: Maybe<ProductDetailPage>;
  /** Unpublish one productHero from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishProductHero?: Maybe<ProductHero>;
  /** Unpublish one productLabel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishProductLabel?: Maybe<ProductLabel>;
  /** Unpublish one productLandingPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishProductLandingPage?: Maybe<ProductLandingPage>;
  /** Unpublish one productSubcategoryPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishProductSubcategoryPage?: Maybe<ProductSubcategoryPage>;
  /** Unpublish one promotionDownload from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPromotionDownload?: Maybe<PromotionDownload>;
  /** Unpublish one promotionForm from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPromotionForm?: Maybe<PromotionForm>;
  /** Unpublish one question from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishQuestion?: Maybe<Question>;
  /** Unpublish one questionCheckbox from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishQuestionCheckbox?: Maybe<QuestionCheckbox>;
  /** Unpublish one questionCheckboxCollection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishQuestionCheckboxCollection?: Maybe<QuestionCheckboxCollection>;
  /** Unpublish one questionRadioButton from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishQuestionRadioButton?: Maybe<QuestionRadioButton>;
  /** Unpublish one questionRadioButtonCollection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishQuestionRadioButtonCollection?: Maybe<QuestionRadioButtonCollection>;
  /** Unpublish one rating from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRating?: Maybe<Rating>;
  /** Unpublish one recipe from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRecipe?: Maybe<Recipe>;
  /** Unpublish one recipeCategory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRecipeCategory?: Maybe<RecipeCategory>;
  /** Unpublish one recipeLandingPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRecipeLandingPage?: Maybe<RecipeLandingPage>;
  /** Unpublish one recipeSubcategory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRecipeSubcategory?: Maybe<RecipeSubcategory>;
  /** Unpublish one recipesComparisonQueryComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRecipesComparisonQueryComponent?: Maybe<RecipesComparisonQueryComponent>;
  /** Unpublish one recipesQueriesReference from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRecipesQueriesReference?: Maybe<RecipesQueriesReference>;
  /** Unpublish one recipesQueryComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRecipesQueryComponent?: Maybe<RecipesQueryComponent>;
  /** Unpublish one redirect from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRedirect?: Maybe<Redirect>;
  /** Unpublish one rewrite from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRewrite?: Maybe<Rewrite>;
  /** Unpublish one rightColumn from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRightColumn?: Maybe<RightColumn>;
  /** Unpublish one searchInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSearchInput?: Maybe<SearchInput>;
  /** Unpublish one searchOverlayComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSearchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Unpublish one searchResultPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSearchResultPage?: Maybe<SearchResultPage>;
  /** Unpublish one separator from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSeparator?: Maybe<Separator>;
  /** Unpublish one singleStepPromotionForm from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSingleStepPromotionForm?: Maybe<SingleStepPromotionForm>;
  /** Unpublish one socialMediaListComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSocialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Unpublish one spacer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSpacer?: Maybe<Spacer>;
  /** Unpublish one subCategoryKeyImage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSubCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Unpublish one subTab from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSubTab?: Maybe<SubTab>;
  /** Unpublish one subTabContent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSubTabContent?: Maybe<SubTabContent>;
  /** Unpublish one sustainabilityBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Unpublish one sustainabilityInfo from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Unpublish one tab from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTab?: Maybe<Tab>;
  /** Unpublish one tabContent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTabContent?: Maybe<TabContent>;
  /** Unpublish one teaser from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTeaser?: Maybe<Teaser>;
  /** Unpublish one teaserPlaceholder from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTeaserPlaceholder?: Maybe<TeaserPlaceholder>;
  /** Unpublish one teaserSmall from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTeaserSmall?: Maybe<TeaserSmall>;
  /** Unpublish one teaserSmallPlaceholder from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTeaserSmallPlaceholder?: Maybe<TeaserSmallPlaceholder>;
  /** Unpublish one testComponentWithRecipeQuery from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTestComponentWithRecipeQuery?: Maybe<TestComponentWithRecipeQuery>;
  /** Unpublish one testTipsANdTricksInAMarket from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTestTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Unpublish one textComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTextComponent?: Maybe<TextComponent>;
  /** Unpublish one tipsAndTricksDetailsPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Unpublish one title from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTitle?: Maybe<Title>;
  /** Unpublish one twitterSeo from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTwitterSeo?: Maybe<TwitterSeo>;
  /** Update one accordion */
  updateAccordion?: Maybe<Accordion>;
  /** Update one accordionItem */
  updateAccordionItem?: Maybe<AccordionItem>;
  /** Update one algoliaExtension */
  updateAlgoliaExtension?: Maybe<AlgoliaExtension>;
  /** Update one anchorNav */
  updateAnchorNav?: Maybe<AnchorNav>;
  /** Update one anchorNavigation */
  updateAnchorNavigation?: Maybe<AnchorNavigation>;
  /** Update one anchorNavigationList */
  updateAnchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Update one asset */
  updateAsset?: Maybe<Asset>;
  /** Update one assetComponent */
  updateAssetComponent?: Maybe<AssetComponent>;
  /** Update one audioComponent */
  updateAudioComponent?: Maybe<AudioComponent>;
  /** Update one authorableContentCard */
  updateAuthorableContentCard?: Maybe<AuthorableContentCard>;
  /** Update one banner1 */
  updateBanner1?: Maybe<Banner1>;
  /** Update one banner2 */
  updateBanner2?: Maybe<Banner2>;
  /** Update one banner2CarouselComponent */
  updateBanner2CarouselComponent?: Maybe<Banner2CarouselComponent>;
  /** Update one cardComponent */
  updateCardComponent?: Maybe<CardComponent>;
  /** Update one carouselComponent */
  updateCarouselComponent?: Maybe<CarouselComponent>;
  /** Update one carouselSlide */
  updateCarouselSlide?: Maybe<CarouselSlide>;
  /** Update one categoryCard */
  updateCategoryCard?: Maybe<CategoryCard>;
  /** Update one contactCard */
  updateContactCard?: Maybe<ContactCard>;
  /** Update one contactCardContainer */
  updateContactCardContainer?: Maybe<ContactCardContainer>;
  /** Update one countrySelectorFooter */
  updateCountrySelectorFooter?: Maybe<CountrySelectorFooter>;
  /** Update one countrySelectorItem */
  updateCountrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Update one demoModel */
  updateDemoModel?: Maybe<DemoModel>;
  /** Update one dictionary */
  updateDictionary?: Maybe<Dictionary>;
  /** Update one dictionaryItem */
  updateDictionaryItem?: Maybe<DictionaryItem>;
  /** Update one downloadApp */
  updateDownloadApp?: Maybe<DownloadApp>;
  /** Update one dynamicCardGrid */
  updateDynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Update one errorPage */
  updateErrorPage?: Maybe<ErrorPage>;
  /** Update one evalancheFormComponent */
  updateEvalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Update one exampleComponent */
  updateExampleComponent?: Maybe<ExampleComponent>;
  /** Update one featuredContent */
  updateFeaturedContent?: Maybe<FeaturedContent>;
  /** Update one featuredContentReference */
  updateFeaturedContentReference?: Maybe<FeaturedContentReference>;
  /** Update one footerNavigation */
  updateFooterNavigation?: Maybe<FooterNavigation>;
  /** Update one footerSeal */
  updateFooterSeal?: Maybe<FooterSeal>;
  /** Update one form */
  updateForm?: Maybe<Form>;
  /** Update one formCheckbox */
  updateFormCheckbox?: Maybe<FormCheckbox>;
  /** Update one formCheckboxCollection */
  updateFormCheckboxCollection?: Maybe<FormCheckboxCollection>;
  /** Update one formDateInput */
  updateFormDateInput?: Maybe<FormDateInput>;
  /** Update one formEmailInput */
  updateFormEmailInput?: Maybe<FormEmailInput>;
  /** Update one formError */
  updateFormError?: Maybe<FormError>;
  /** Update one formFileUploader */
  updateFormFileUploader?: Maybe<FormFileUploader>;
  /** Update one formList */
  updateFormList?: Maybe<FormList>;
  /** Update one formListItem */
  updateFormListItem?: Maybe<FormListItem>;
  /** Update one formNumberInput */
  updateFormNumberInput?: Maybe<FormNumberInput>;
  /** Update one formPasswordInput */
  updateFormPasswordInput?: Maybe<FormPasswordInput>;
  /** Update one formPasswordInputWithConfirmation */
  updateFormPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Update one formRadioButton */
  updateFormRadioButton?: Maybe<FormRadioButton>;
  /** Update one formRadioButtonCollection */
  updateFormRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Update one formSelectComponent */
  updateFormSelectComponent?: Maybe<FormSelectComponent>;
  /** Update one formSelectOption */
  updateFormSelectOption?: Maybe<FormSelectOption>;
  /** Update one formSubmitButton */
  updateFormSubmitButton?: Maybe<FormSubmitButton>;
  /** Update one formSuccessComponent */
  updateFormSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Update one formTextInput */
  updateFormTextInput?: Maybe<FormTextInput>;
  /** Update one formTextareaInput */
  updateFormTextareaInput?: Maybe<FormTextareaInput>;
  /** Update one genericAccordion */
  updateGenericAccordion?: Maybe<GenericAccordion>;
  /** Update one genericAccordionItem */
  updateGenericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Update one genericAccordionTopRated */
  updateGenericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Update one genericCardCarouseComponent */
  updateGenericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Update one genericDownloadComponent */
  updateGenericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Update one genericFollowUs */
  updateGenericFollowUs?: Maybe<GenericFollowUs>;
  /** Update one genericGridAuthorable */
  updateGenericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Update one genericHtml */
  updateGenericHtml?: Maybe<GenericHtml>;
  /** Update one genericLine */
  updateGenericLine?: Maybe<GenericLine>;
  /** Update one genericLink */
  updateGenericLink?: Maybe<GenericLink>;
  /** Update one genericPage */
  updateGenericPage?: Maybe<GenericPage>;
  /** Update one genericPromotionsOverview */
  updateGenericPromotionsOverview?: Maybe<GenericPromotionsOverview>;
  /** Update one genericQualifio */
  updateGenericQualifio?: Maybe<GenericQualifio>;
  /** Update one genericQualifioOverview */
  updateGenericQualifioOverview?: Maybe<GenericQualifioOverview>;
  /** Update one genericSocialShare */
  updateGenericSocialShare?: Maybe<GenericSocialShare>;
  /** Update one globalMetaData */
  updateGlobalMetaData?: Maybe<GlobalMetaData>;
  /** Update one globalSearch */
  updateGlobalSearch?: Maybe<GlobalSearch>;
  /** Update one gridColumn */
  updateGridColumn?: Maybe<GridColumn>;
  /** Update one gridColumnComponent */
  updateGridColumnComponent?: Maybe<GridColumnComponent>;
  /** Update one heroBanner */
  updateHeroBanner?: Maybe<HeroBanner>;
  /** Update one heroBannerMasterbrand */
  updateHeroBannerMasterbrand?: Maybe<HeroBannerMasterbrand>;
  /** Update one heroCarouselComponent */
  updateHeroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Update one heroComponent */
  updateHeroComponent?: Maybe<HeroComponent>;
  /** Update one heroLoopAnimationComponent */
  updateHeroLoopAnimationComponent?: Maybe<HeroLoopAnimationComponent>;
  /** Update one iframe */
  updateIframe?: Maybe<Iframe>;
  /** Update one imageAndTextCard */
  updateImageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Update one imageCopy */
  updateImageCopy?: Maybe<ImageCopy>;
  /** Update one imageCopyItem */
  updateImageCopyItem?: Maybe<ImageCopyItem>;
  /** Update one introText */
  updateIntroText?: Maybe<IntroText>;
  /** Update one leftColumn */
  updateLeftColumn?: Maybe<LeftColumn>;
  /** Update one link */
  updateLink?: Maybe<Link>;
  /** Update one longText */
  updateLongText?: Maybe<LongText>;
  /**
   * Update many accordionItems
   * @deprecated Please use the new paginated many mutation (updateManyAccordionItemsConnection)
   */
  updateManyAccordionItems: BatchPayload;
  /** Update many AccordionItem documents */
  updateManyAccordionItemsConnection: AccordionItemConnection;
  /**
   * Update many accordions
   * @deprecated Please use the new paginated many mutation (updateManyAccordionsConnection)
   */
  updateManyAccordions: BatchPayload;
  /** Update many Accordion documents */
  updateManyAccordionsConnection: AccordionConnection;
  /**
   * Update many algoliaExtensions
   * @deprecated Please use the new paginated many mutation (updateManyAlgoliaExtensionsConnection)
   */
  updateManyAlgoliaExtensions: BatchPayload;
  /** Update many AlgoliaExtension documents */
  updateManyAlgoliaExtensionsConnection: AlgoliaExtensionConnection;
  /**
   * Update many anchorNavigationLists
   * @deprecated Please use the new paginated many mutation (updateManyAnchorNavigationListsConnection)
   */
  updateManyAnchorNavigationLists: BatchPayload;
  /** Update many AnchorNavigationList documents */
  updateManyAnchorNavigationListsConnection: AnchorNavigationListConnection;
  /**
   * Update many anchorNavigations
   * @deprecated Please use the new paginated many mutation (updateManyAnchorNavigationsConnection)
   */
  updateManyAnchorNavigations: BatchPayload;
  /** Update many AnchorNavigation documents */
  updateManyAnchorNavigationsConnection: AnchorNavigationConnection;
  /**
   * Update many anchorNavs
   * @deprecated Please use the new paginated many mutation (updateManyAnchorNavsConnection)
   */
  updateManyAnchorNavs: BatchPayload;
  /** Update many AnchorNav documents */
  updateManyAnchorNavsConnection: AnchorNavConnection;
  /**
   * Update many assets
   * @deprecated Please use the new paginated many mutation (updateManyAssetsConnection)
   */
  updateManyAssets: BatchPayload;
  /**
   * Update many assetsComponents
   * @deprecated Please use the new paginated many mutation (updateManyAssetsComponentsConnection)
   */
  updateManyAssetsComponents: BatchPayload;
  /** Update many AssetComponent documents */
  updateManyAssetsComponentsConnection: AssetComponentConnection;
  /** Update many Asset documents */
  updateManyAssetsConnection: AssetConnection;
  /**
   * Update many audioComponents
   * @deprecated Please use the new paginated many mutation (updateManyAudioComponentsConnection)
   */
  updateManyAudioComponents: BatchPayload;
  /** Update many AudioComponent documents */
  updateManyAudioComponentsConnection: AudioComponentConnection;
  /**
   * Update many authorableContentCards
   * @deprecated Please use the new paginated many mutation (updateManyAuthorableContentCardsConnection)
   */
  updateManyAuthorableContentCards: BatchPayload;
  /** Update many AuthorableContentCard documents */
  updateManyAuthorableContentCardsConnection: AuthorableContentCardConnection;
  /**
   * Update many banner1s
   * @deprecated Please use the new paginated many mutation (updateManyBanner1sConnection)
   */
  updateManyBanner1s: BatchPayload;
  /** Update many Banner1 documents */
  updateManyBanner1sConnection: Banner1Connection;
  /**
   * Update many banner2CarouselComponents
   * @deprecated Please use the new paginated many mutation (updateManyBanner2CarouselComponentsConnection)
   */
  updateManyBanner2CarouselComponents: BatchPayload;
  /** Update many Banner2CarouselComponent documents */
  updateManyBanner2CarouselComponentsConnection: Banner2CarouselComponentConnection;
  /**
   * Update many banner2S
   * @deprecated Please use the new paginated many mutation (updateManyBanner2SConnection)
   */
  updateManyBanner2S: BatchPayload;
  /** Update many Banner2 documents */
  updateManyBanner2SConnection: Banner2Connection;
  /**
   * Update many cardComponents
   * @deprecated Please use the new paginated many mutation (updateManyCardComponentsConnection)
   */
  updateManyCardComponents: BatchPayload;
  /** Update many CardComponent documents */
  updateManyCardComponentsConnection: CardComponentConnection;
  /**
   * Update many carouselComponents
   * @deprecated Please use the new paginated many mutation (updateManyCarouselComponentsConnection)
   */
  updateManyCarouselComponents: BatchPayload;
  /** Update many CarouselComponent documents */
  updateManyCarouselComponentsConnection: CarouselComponentConnection;
  /**
   * Update many carouselSlides
   * @deprecated Please use the new paginated many mutation (updateManyCarouselSlidesConnection)
   */
  updateManyCarouselSlides: BatchPayload;
  /** Update many CarouselSlide documents */
  updateManyCarouselSlidesConnection: CarouselSlideConnection;
  /**
   * Update many categoryCards
   * @deprecated Please use the new paginated many mutation (updateManyCategoryCardsConnection)
   */
  updateManyCategoryCards: BatchPayload;
  /** Update many CategoryCard documents */
  updateManyCategoryCardsConnection: CategoryCardConnection;
  /**
   * Update many contactCardContainers
   * @deprecated Please use the new paginated many mutation (updateManyContactCardContainersConnection)
   */
  updateManyContactCardContainers: BatchPayload;
  /** Update many ContactCardContainer documents */
  updateManyContactCardContainersConnection: ContactCardContainerConnection;
  /**
   * Update many contactCards
   * @deprecated Please use the new paginated many mutation (updateManyContactCardsConnection)
   */
  updateManyContactCards: BatchPayload;
  /** Update many ContactCard documents */
  updateManyContactCardsConnection: ContactCardConnection;
  /**
   * Update many countrySelectorFooters
   * @deprecated Please use the new paginated many mutation (updateManyCountrySelectorFootersConnection)
   */
  updateManyCountrySelectorFooters: BatchPayload;
  /** Update many CountrySelectorFooter documents */
  updateManyCountrySelectorFootersConnection: CountrySelectorFooterConnection;
  /**
   * Update many countrySelectorItems
   * @deprecated Please use the new paginated many mutation (updateManyCountrySelectorItemsConnection)
   */
  updateManyCountrySelectorItems: BatchPayload;
  /** Update many CountrySelectorItem documents */
  updateManyCountrySelectorItemsConnection: CountrySelectorItemConnection;
  /**
   * Update many demoModels
   * @deprecated Please use the new paginated many mutation (updateManyDemoModelsConnection)
   */
  updateManyDemoModels: BatchPayload;
  /** Update many DemoModel documents */
  updateManyDemoModelsConnection: DemoModelConnection;
  /**
   * Update many dictionaries
   * @deprecated Please use the new paginated many mutation (updateManyDictionariesConnection)
   */
  updateManyDictionaries: BatchPayload;
  /** Update many Dictionary documents */
  updateManyDictionariesConnection: DictionaryConnection;
  /**
   * Update many dictionaryItems
   * @deprecated Please use the new paginated many mutation (updateManyDictionaryItemsConnection)
   */
  updateManyDictionaryItems: BatchPayload;
  /** Update many DictionaryItem documents */
  updateManyDictionaryItemsConnection: DictionaryItemConnection;
  /**
   * Update many downloadApps
   * @deprecated Please use the new paginated many mutation (updateManyDownloadAppsConnection)
   */
  updateManyDownloadApps: BatchPayload;
  /** Update many DownloadApp documents */
  updateManyDownloadAppsConnection: DownloadAppConnection;
  /**
   * Update many dynamicCardGrids
   * @deprecated Please use the new paginated many mutation (updateManyDynamicCardGridsConnection)
   */
  updateManyDynamicCardGrids: BatchPayload;
  /** Update many DynamicCardGrid documents */
  updateManyDynamicCardGridsConnection: DynamicCardGridConnection;
  /**
   * Update many errorPages
   * @deprecated Please use the new paginated many mutation (updateManyErrorPagesConnection)
   */
  updateManyErrorPages: BatchPayload;
  /** Update many ErrorPage documents */
  updateManyErrorPagesConnection: ErrorPageConnection;
  /**
   * Update many evalancheFormComponents
   * @deprecated Please use the new paginated many mutation (updateManyEvalancheFormComponentsConnection)
   */
  updateManyEvalancheFormComponents: BatchPayload;
  /** Update many EvalancheFormComponent documents */
  updateManyEvalancheFormComponentsConnection: EvalancheFormComponentConnection;
  /**
   * Update many exampleComponents
   * @deprecated Please use the new paginated many mutation (updateManyExampleComponentsConnection)
   */
  updateManyExampleComponents: BatchPayload;
  /** Update many ExampleComponent documents */
  updateManyExampleComponentsConnection: ExampleComponentConnection;
  /**
   * Update many featuredContentReferences
   * @deprecated Please use the new paginated many mutation (updateManyFeaturedContentReferencesConnection)
   */
  updateManyFeaturedContentReferences: BatchPayload;
  /** Update many FeaturedContentReference documents */
  updateManyFeaturedContentReferencesConnection: FeaturedContentReferenceConnection;
  /**
   * Update many featuredContents
   * @deprecated Please use the new paginated many mutation (updateManyFeaturedContentsConnection)
   */
  updateManyFeaturedContents: BatchPayload;
  /** Update many FeaturedContent documents */
  updateManyFeaturedContentsConnection: FeaturedContentConnection;
  /**
   * Update many footerNavigations
   * @deprecated Please use the new paginated many mutation (updateManyFooterNavigationsConnection)
   */
  updateManyFooterNavigations: BatchPayload;
  /** Update many FooterNavigation documents */
  updateManyFooterNavigationsConnection: FooterNavigationConnection;
  /**
   * Update many footerSeals
   * @deprecated Please use the new paginated many mutation (updateManyFooterSealsConnection)
   */
  updateManyFooterSeals: BatchPayload;
  /** Update many FooterSeal documents */
  updateManyFooterSealsConnection: FooterSealConnection;
  /**
   * Update many formCheckboxCollections
   * @deprecated Please use the new paginated many mutation (updateManyFormCheckboxCollectionsConnection)
   */
  updateManyFormCheckboxCollections: BatchPayload;
  /** Update many FormCheckboxCollection documents */
  updateManyFormCheckboxCollectionsConnection: FormCheckboxCollectionConnection;
  /**
   * Update many formCheckboxes
   * @deprecated Please use the new paginated many mutation (updateManyFormCheckboxesConnection)
   */
  updateManyFormCheckboxes: BatchPayload;
  /** Update many FormCheckbox documents */
  updateManyFormCheckboxesConnection: FormCheckboxConnection;
  /**
   * Update many formDateInputs
   * @deprecated Please use the new paginated many mutation (updateManyFormDateInputsConnection)
   */
  updateManyFormDateInputs: BatchPayload;
  /** Update many FormDateInput documents */
  updateManyFormDateInputsConnection: FormDateInputConnection;
  /**
   * Update many formEmailInputs
   * @deprecated Please use the new paginated many mutation (updateManyFormEmailInputsConnection)
   */
  updateManyFormEmailInputs: BatchPayload;
  /** Update many FormEmailInput documents */
  updateManyFormEmailInputsConnection: FormEmailInputConnection;
  /**
   * Update many formErrors
   * @deprecated Please use the new paginated many mutation (updateManyFormErrorsConnection)
   */
  updateManyFormErrors: BatchPayload;
  /** Update many FormError documents */
  updateManyFormErrorsConnection: FormErrorConnection;
  /**
   * Update many formFileUploaders
   * @deprecated Please use the new paginated many mutation (updateManyFormFileUploadersConnection)
   */
  updateManyFormFileUploaders: BatchPayload;
  /** Update many FormFileUploader documents */
  updateManyFormFileUploadersConnection: FormFileUploaderConnection;
  /**
   * Update many formListItems
   * @deprecated Please use the new paginated many mutation (updateManyFormListItemsConnection)
   */
  updateManyFormListItems: BatchPayload;
  /** Update many FormListItem documents */
  updateManyFormListItemsConnection: FormListItemConnection;
  /**
   * Update many formLists
   * @deprecated Please use the new paginated many mutation (updateManyFormListsConnection)
   */
  updateManyFormLists: BatchPayload;
  /** Update many FormList documents */
  updateManyFormListsConnection: FormListConnection;
  /**
   * Update many formNumberInputs
   * @deprecated Please use the new paginated many mutation (updateManyFormNumberInputsConnection)
   */
  updateManyFormNumberInputs: BatchPayload;
  /** Update many FormNumberInput documents */
  updateManyFormNumberInputsConnection: FormNumberInputConnection;
  /**
   * Update many formPasswordInputWithConfirmations
   * @deprecated Please use the new paginated many mutation (updateManyFormPasswordInputWithConfirmationsConnection)
   */
  updateManyFormPasswordInputWithConfirmations: BatchPayload;
  /** Update many FormPasswordInputWithConfirmation documents */
  updateManyFormPasswordInputWithConfirmationsConnection: FormPasswordInputWithConfirmationConnection;
  /**
   * Update many formPasswordInputs
   * @deprecated Please use the new paginated many mutation (updateManyFormPasswordInputsConnection)
   */
  updateManyFormPasswordInputs: BatchPayload;
  /** Update many FormPasswordInput documents */
  updateManyFormPasswordInputsConnection: FormPasswordInputConnection;
  /**
   * Update many formRadioButtonCollections
   * @deprecated Please use the new paginated many mutation (updateManyFormRadioButtonCollectionsConnection)
   */
  updateManyFormRadioButtonCollections: BatchPayload;
  /** Update many FormRadioButtonCollection documents */
  updateManyFormRadioButtonCollectionsConnection: FormRadioButtonCollectionConnection;
  /**
   * Update many formRadioButtons
   * @deprecated Please use the new paginated many mutation (updateManyFormRadioButtonsConnection)
   */
  updateManyFormRadioButtons: BatchPayload;
  /** Update many FormRadioButton documents */
  updateManyFormRadioButtonsConnection: FormRadioButtonConnection;
  /**
   * Update many formSelectComponents
   * @deprecated Please use the new paginated many mutation (updateManyFormSelectComponentsConnection)
   */
  updateManyFormSelectComponents: BatchPayload;
  /** Update many FormSelectComponent documents */
  updateManyFormSelectComponentsConnection: FormSelectComponentConnection;
  /**
   * Update many formSelectOptions
   * @deprecated Please use the new paginated many mutation (updateManyFormSelectOptionsConnection)
   */
  updateManyFormSelectOptions: BatchPayload;
  /** Update many FormSelectOption documents */
  updateManyFormSelectOptionsConnection: FormSelectOptionConnection;
  /**
   * Update many formSubmitButtons
   * @deprecated Please use the new paginated many mutation (updateManyFormSubmitButtonsConnection)
   */
  updateManyFormSubmitButtons: BatchPayload;
  /** Update many FormSubmitButton documents */
  updateManyFormSubmitButtonsConnection: FormSubmitButtonConnection;
  /**
   * Update many formSuccessComponents
   * @deprecated Please use the new paginated many mutation (updateManyFormSuccessComponentsConnection)
   */
  updateManyFormSuccessComponents: BatchPayload;
  /** Update many FormSuccessComponent documents */
  updateManyFormSuccessComponentsConnection: FormSuccessComponentConnection;
  /**
   * Update many formTextInputs
   * @deprecated Please use the new paginated many mutation (updateManyFormTextInputsConnection)
   */
  updateManyFormTextInputs: BatchPayload;
  /** Update many FormTextInput documents */
  updateManyFormTextInputsConnection: FormTextInputConnection;
  /**
   * Update many formTextareaInputs
   * @deprecated Please use the new paginated many mutation (updateManyFormTextareaInputsConnection)
   */
  updateManyFormTextareaInputs: BatchPayload;
  /** Update many FormTextareaInput documents */
  updateManyFormTextareaInputsConnection: FormTextareaInputConnection;
  /**
   * Update many forms
   * @deprecated Please use the new paginated many mutation (updateManyFormsConnection)
   */
  updateManyForms: BatchPayload;
  /** Update many Form documents */
  updateManyFormsConnection: FormConnection;
  /**
   * Update many genericAccordionItems
   * @deprecated Please use the new paginated many mutation (updateManyGenericAccordionItemsConnection)
   */
  updateManyGenericAccordionItems: BatchPayload;
  /** Update many GenericAccordionItem documents */
  updateManyGenericAccordionItemsConnection: GenericAccordionItemConnection;
  /**
   * Update many genericAccordionTopRateds
   * @deprecated Please use the new paginated many mutation (updateManyGenericAccordionTopRatedsConnection)
   */
  updateManyGenericAccordionTopRateds: BatchPayload;
  /** Update many GenericAccordionTopRated documents */
  updateManyGenericAccordionTopRatedsConnection: GenericAccordionTopRatedConnection;
  /**
   * Update many genericAccordions
   * @deprecated Please use the new paginated many mutation (updateManyGenericAccordionsConnection)
   */
  updateManyGenericAccordions: BatchPayload;
  /** Update many GenericAccordion documents */
  updateManyGenericAccordionsConnection: GenericAccordionConnection;
  /**
   * Update many genericCardCarouseComponents
   * @deprecated Please use the new paginated many mutation (updateManyGenericCardCarouseComponentsConnection)
   */
  updateManyGenericCardCarouseComponents: BatchPayload;
  /** Update many GenericCardCarouseComponent documents */
  updateManyGenericCardCarouseComponentsConnection: GenericCardCarouseComponentConnection;
  /**
   * Update many genericDownloadComponents
   * @deprecated Please use the new paginated many mutation (updateManyGenericDownloadComponentsConnection)
   */
  updateManyGenericDownloadComponents: BatchPayload;
  /** Update many GenericDownloadComponent documents */
  updateManyGenericDownloadComponentsConnection: GenericDownloadComponentConnection;
  /**
   * Update many genericFollowUses
   * @deprecated Please use the new paginated many mutation (updateManyGenericFollowUsesConnection)
   */
  updateManyGenericFollowUses: BatchPayload;
  /** Update many GenericFollowUs documents */
  updateManyGenericFollowUsesConnection: GenericFollowUsConnection;
  /**
   * Update many genericGridAuthorables
   * @deprecated Please use the new paginated many mutation (updateManyGenericGridAuthorablesConnection)
   */
  updateManyGenericGridAuthorables: BatchPayload;
  /** Update many GenericGridAuthorable documents */
  updateManyGenericGridAuthorablesConnection: GenericGridAuthorableConnection;
  /**
   * Update many genericHtmls
   * @deprecated Please use the new paginated many mutation (updateManyGenericHtmlsConnection)
   */
  updateManyGenericHtmls: BatchPayload;
  /** Update many GenericHtml documents */
  updateManyGenericHtmlsConnection: GenericHtmlConnection;
  /**
   * Update many genericLines
   * @deprecated Please use the new paginated many mutation (updateManyGenericLinesConnection)
   */
  updateManyGenericLines: BatchPayload;
  /** Update many GenericLine documents */
  updateManyGenericLinesConnection: GenericLineConnection;
  /**
   * Update many genericLinks
   * @deprecated Please use the new paginated many mutation (updateManyGenericLinksConnection)
   */
  updateManyGenericLinks: BatchPayload;
  /** Update many GenericLink documents */
  updateManyGenericLinksConnection: GenericLinkConnection;
  /**
   * Update many genericPages
   * @deprecated Please use the new paginated many mutation (updateManyGenericPagesConnection)
   */
  updateManyGenericPages: BatchPayload;
  /** Update many GenericPage documents */
  updateManyGenericPagesConnection: GenericPageConnection;
  /**
   * Update many genericPromotionsOverviews
   * @deprecated Please use the new paginated many mutation (updateManyGenericPromotionsOverviewsConnection)
   */
  updateManyGenericPromotionsOverviews: BatchPayload;
  /** Update many GenericPromotionsOverview documents */
  updateManyGenericPromotionsOverviewsConnection: GenericPromotionsOverviewConnection;
  /**
   * Update many genericQualifioOverviews
   * @deprecated Please use the new paginated many mutation (updateManyGenericQualifioOverviewsConnection)
   */
  updateManyGenericQualifioOverviews: BatchPayload;
  /** Update many GenericQualifioOverview documents */
  updateManyGenericQualifioOverviewsConnection: GenericQualifioOverviewConnection;
  /**
   * Update many genericQualifios
   * @deprecated Please use the new paginated many mutation (updateManyGenericQualifiosConnection)
   */
  updateManyGenericQualifios: BatchPayload;
  /** Update many GenericQualifio documents */
  updateManyGenericQualifiosConnection: GenericQualifioConnection;
  /**
   * Update many genericSocialShares
   * @deprecated Please use the new paginated many mutation (updateManyGenericSocialSharesConnection)
   */
  updateManyGenericSocialShares: BatchPayload;
  /** Update many GenericSocialShare documents */
  updateManyGenericSocialSharesConnection: GenericSocialShareConnection;
  /**
   * Update many globalMetaDatas
   * @deprecated Please use the new paginated many mutation (updateManyGlobalMetaDatasConnection)
   */
  updateManyGlobalMetaDatas: BatchPayload;
  /** Update many GlobalMetaData documents */
  updateManyGlobalMetaDatasConnection: GlobalMetaDataConnection;
  /**
   * Update many globalSearches
   * @deprecated Please use the new paginated many mutation (updateManyGlobalSearchesConnection)
   */
  updateManyGlobalSearches: BatchPayload;
  /** Update many GlobalSearch documents */
  updateManyGlobalSearchesConnection: GlobalSearchConnection;
  /**
   * Update many gridColumnComponents
   * @deprecated Please use the new paginated many mutation (updateManyGridColumnComponentsConnection)
   */
  updateManyGridColumnComponents: BatchPayload;
  /** Update many GridColumnComponent documents */
  updateManyGridColumnComponentsConnection: GridColumnComponentConnection;
  /**
   * Update many gridColumns
   * @deprecated Please use the new paginated many mutation (updateManyGridColumnsConnection)
   */
  updateManyGridColumns: BatchPayload;
  /** Update many GridColumn documents */
  updateManyGridColumnsConnection: GridColumnConnection;
  /**
   * Update many heroBannerMasterbrands
   * @deprecated Please use the new paginated many mutation (updateManyHeroBannerMasterbrandsConnection)
   */
  updateManyHeroBannerMasterbrands: BatchPayload;
  /** Update many HeroBannerMasterbrand documents */
  updateManyHeroBannerMasterbrandsConnection: HeroBannerMasterbrandConnection;
  /**
   * Update many heroBanners
   * @deprecated Please use the new paginated many mutation (updateManyHeroBannersConnection)
   */
  updateManyHeroBanners: BatchPayload;
  /** Update many HeroBanner documents */
  updateManyHeroBannersConnection: HeroBannerConnection;
  /**
   * Update many heroCarouselComponents
   * @deprecated Please use the new paginated many mutation (updateManyHeroCarouselComponentsConnection)
   */
  updateManyHeroCarouselComponents: BatchPayload;
  /** Update many HeroCarouselComponent documents */
  updateManyHeroCarouselComponentsConnection: HeroCarouselComponentConnection;
  /**
   * Update many heroComponents
   * @deprecated Please use the new paginated many mutation (updateManyHeroComponentsConnection)
   */
  updateManyHeroComponents: BatchPayload;
  /** Update many HeroComponent documents */
  updateManyHeroComponentsConnection: HeroComponentConnection;
  /**
   * Update many heroLoopAnimationComponents
   * @deprecated Please use the new paginated many mutation (updateManyHeroLoopAnimationComponentsConnection)
   */
  updateManyHeroLoopAnimationComponents: BatchPayload;
  /** Update many HeroLoopAnimationComponent documents */
  updateManyHeroLoopAnimationComponentsConnection: HeroLoopAnimationComponentConnection;
  /**
   * Update many iframes
   * @deprecated Please use the new paginated many mutation (updateManyIframesConnection)
   */
  updateManyIframes: BatchPayload;
  /** Update many Iframe documents */
  updateManyIframesConnection: IframeConnection;
  /**
   * Update many imageAndTextCards
   * @deprecated Please use the new paginated many mutation (updateManyImageAndTextCardsConnection)
   */
  updateManyImageAndTextCards: BatchPayload;
  /** Update many ImageAndTextCard documents */
  updateManyImageAndTextCardsConnection: ImageAndTextCardConnection;
  /**
   * Update many imageCopies
   * @deprecated Please use the new paginated many mutation (updateManyImageCopiesConnection)
   */
  updateManyImageCopies: BatchPayload;
  /** Update many ImageCopy documents */
  updateManyImageCopiesConnection: ImageCopyConnection;
  /**
   * Update many imageCopyItems
   * @deprecated Please use the new paginated many mutation (updateManyImageCopyItemsConnection)
   */
  updateManyImageCopyItems: BatchPayload;
  /** Update many ImageCopyItem documents */
  updateManyImageCopyItemsConnection: ImageCopyItemConnection;
  /**
   * Update many introTexts
   * @deprecated Please use the new paginated many mutation (updateManyIntroTextsConnection)
   */
  updateManyIntroTexts: BatchPayload;
  /** Update many IntroText documents */
  updateManyIntroTextsConnection: IntroTextConnection;
  /**
   * Update many leftColumns
   * @deprecated Please use the new paginated many mutation (updateManyLeftColumnsConnection)
   */
  updateManyLeftColumns: BatchPayload;
  /** Update many LeftColumn documents */
  updateManyLeftColumnsConnection: LeftColumnConnection;
  /**
   * Update many links
   * @deprecated Please use the new paginated many mutation (updateManyLinksConnection)
   */
  updateManyLinks: BatchPayload;
  /** Update many Link documents */
  updateManyLinksConnection: LinkConnection;
  /**
   * Update many longTexts
   * @deprecated Please use the new paginated many mutation (updateManyLongTextsConnection)
   */
  updateManyLongTexts: BatchPayload;
  /** Update many LongText documents */
  updateManyLongTextsConnection: LongTextConnection;
  /**
   * Update many marketUserConnections
   * @deprecated Please use the new paginated many mutation (updateManyMarketUserConnectionsConnection)
   */
  updateManyMarketUserConnections: BatchPayload;
  /** Update many MarketUserConnection documents */
  updateManyMarketUserConnectionsConnection: MarketUserConnectionConnection;
  /**
   * Update many markets
   * @deprecated Please use the new paginated many mutation (updateManyMarketsConnection)
   */
  updateManyMarkets: BatchPayload;
  /** Update many Market documents */
  updateManyMarketsConnection: MarketConnection;
  /**
   * Update many metaDatas
   * @deprecated Please use the new paginated many mutation (updateManyMetaDatasConnection)
   */
  updateManyMetaDatas: BatchPayload;
  /** Update many MetaData documents */
  updateManyMetaDatasConnection: MetaDataConnection;
  /**
   * Update many mobileOnlyMainNavigations
   * @deprecated Please use the new paginated many mutation (updateManyMobileOnlyMainNavigationsConnection)
   */
  updateManyMobileOnlyMainNavigations: BatchPayload;
  /** Update many MobileOnlyMainNavigation documents */
  updateManyMobileOnlyMainNavigationsConnection: MobileOnlyMainNavigationConnection;
  /**
   * Update many multiStepPromotionForms
   * @deprecated Please use the new paginated many mutation (updateManyMultiStepPromotionFormsConnection)
   */
  updateManyMultiStepPromotionForms: BatchPayload;
  /** Update many MultiStepPromotionForm documents */
  updateManyMultiStepPromotionFormsConnection: MultiStepPromotionFormConnection;
  /**
   * Update many navigationItems
   * @deprecated Please use the new paginated many mutation (updateManyNavigationItemsConnection)
   */
  updateManyNavigationItems: BatchPayload;
  /** Update many NavigationItem documents */
  updateManyNavigationItemsConnection: NavigationItemConnection;
  /**
   * Update many navigations
   * @deprecated Please use the new paginated many mutation (updateManyNavigationsConnection)
   */
  updateManyNavigations: BatchPayload;
  /** Update many Navigation documents */
  updateManyNavigationsConnection: NavigationConnection;
  /**
   * Update many newsletterComponents
   * @deprecated Please use the new paginated many mutation (updateManyNewsletterComponentsConnection)
   */
  updateManyNewsletterComponents: BatchPayload;
  /** Update many NewsletterComponent documents */
  updateManyNewsletterComponentsConnection: NewsletterComponentConnection;
  /**
   * Update many newsletterSubscriptionsPlural
   * @deprecated Please use the new paginated many mutation (updateManyNewsletterSubscriptionsPluralConnection)
   */
  updateManyNewsletterSubscriptionsPlural: BatchPayload;
  /** Update many NewsletterSubscriptions documents */
  updateManyNewsletterSubscriptionsPluralConnection: NewsletterSubscriptionsConnection;
  /**
   * Update many notificationBanners
   * @deprecated Please use the new paginated many mutation (updateManyNotificationBannersConnection)
   */
  updateManyNotificationBanners: BatchPayload;
  /** Update many NotificationBanner documents */
  updateManyNotificationBannersConnection: NotificationBannerConnection;
  /**
   * Update many pageFooters
   * @deprecated Please use the new paginated many mutation (updateManyPageFootersConnection)
   */
  updateManyPageFooters: BatchPayload;
  /** Update many PageFooter documents */
  updateManyPageFootersConnection: PageFooterConnection;
  /**
   * Update many pageHeaders
   * @deprecated Please use the new paginated many mutation (updateManyPageHeadersConnection)
   */
  updateManyPageHeaders: BatchPayload;
  /** Update many PageHeader documents */
  updateManyPageHeadersConnection: PageHeaderConnection;
  /**
   * Update many popularSearchComponents
   * @deprecated Please use the new paginated many mutation (updateManyPopularSearchComponentsConnection)
   */
  updateManyPopularSearchComponents: BatchPayload;
  /** Update many PopularSearchComponent documents */
  updateManyPopularSearchComponentsConnection: PopularSearchComponentConnection;
  /**
   * Update many productBanners
   * @deprecated Please use the new paginated many mutation (updateManyProductBannersConnection)
   */
  updateManyProductBanners: BatchPayload;
  /** Update many ProductBanner documents */
  updateManyProductBannersConnection: ProductBannerConnection;
  /**
   * Update many productCategories
   * @deprecated Please use the new paginated many mutation (updateManyProductCategoriesConnection)
   */
  updateManyProductCategories: BatchPayload;
  /** Update many ProductCategory documents */
  updateManyProductCategoriesConnection: ProductCategoryConnection;
  /**
   * Update many productCategoryPages
   * @deprecated Please use the new paginated many mutation (updateManyProductCategoryPagesConnection)
   */
  updateManyProductCategoryPages: BatchPayload;
  /** Update many ProductCategoryPage documents */
  updateManyProductCategoryPagesConnection: ProductCategoryPageConnection;
  /**
   * Update many productDetailPages
   * @deprecated Please use the new paginated many mutation (updateManyProductDetailPagesConnection)
   */
  updateManyProductDetailPages: BatchPayload;
  /** Update many ProductDetailPage documents */
  updateManyProductDetailPagesConnection: ProductDetailPageConnection;
  /**
   * Update many productHeroes
   * @deprecated Please use the new paginated many mutation (updateManyProductHeroesConnection)
   */
  updateManyProductHeroes: BatchPayload;
  /** Update many ProductHero documents */
  updateManyProductHeroesConnection: ProductHeroConnection;
  /**
   * Update many productLabels
   * @deprecated Please use the new paginated many mutation (updateManyProductLabelsConnection)
   */
  updateManyProductLabels: BatchPayload;
  /** Update many ProductLabel documents */
  updateManyProductLabelsConnection: ProductLabelConnection;
  /**
   * Update many productLandingPages
   * @deprecated Please use the new paginated many mutation (updateManyProductLandingPagesConnection)
   */
  updateManyProductLandingPages: BatchPayload;
  /** Update many ProductLandingPage documents */
  updateManyProductLandingPagesConnection: ProductLandingPageConnection;
  /**
   * Update many productSubcategoryPages
   * @deprecated Please use the new paginated many mutation (updateManyProductSubcategoryPagesConnection)
   */
  updateManyProductSubcategoryPages: BatchPayload;
  /** Update many ProductSubcategoryPage documents */
  updateManyProductSubcategoryPagesConnection: ProductSubcategoryPageConnection;
  /**
   * Update many products
   * @deprecated Please use the new paginated many mutation (updateManyProductsConnection)
   */
  updateManyProducts: BatchPayload;
  /** Update many Product documents */
  updateManyProductsConnection: ProductConnection;
  /**
   * Update many promotionDownloads
   * @deprecated Please use the new paginated many mutation (updateManyPromotionDownloadsConnection)
   */
  updateManyPromotionDownloads: BatchPayload;
  /** Update many PromotionDownload documents */
  updateManyPromotionDownloadsConnection: PromotionDownloadConnection;
  /**
   * Update many promotionForms
   * @deprecated Please use the new paginated many mutation (updateManyPromotionFormsConnection)
   */
  updateManyPromotionForms: BatchPayload;
  /** Update many PromotionForm documents */
  updateManyPromotionFormsConnection: PromotionFormConnection;
  /**
   * Update many questionCheckboxCollections
   * @deprecated Please use the new paginated many mutation (updateManyQuestionCheckboxCollectionsConnection)
   */
  updateManyQuestionCheckboxCollections: BatchPayload;
  /** Update many QuestionCheckboxCollection documents */
  updateManyQuestionCheckboxCollectionsConnection: QuestionCheckboxCollectionConnection;
  /**
   * Update many questionCheckboxes
   * @deprecated Please use the new paginated many mutation (updateManyQuestionCheckboxesConnection)
   */
  updateManyQuestionCheckboxes: BatchPayload;
  /** Update many QuestionCheckbox documents */
  updateManyQuestionCheckboxesConnection: QuestionCheckboxConnection;
  /**
   * Update many questionRadioButtonCollections
   * @deprecated Please use the new paginated many mutation (updateManyQuestionRadioButtonCollectionsConnection)
   */
  updateManyQuestionRadioButtonCollections: BatchPayload;
  /** Update many QuestionRadioButtonCollection documents */
  updateManyQuestionRadioButtonCollectionsConnection: QuestionRadioButtonCollectionConnection;
  /**
   * Update many questionRadioButtons
   * @deprecated Please use the new paginated many mutation (updateManyQuestionRadioButtonsConnection)
   */
  updateManyQuestionRadioButtons: BatchPayload;
  /** Update many QuestionRadioButton documents */
  updateManyQuestionRadioButtonsConnection: QuestionRadioButtonConnection;
  /**
   * Update many questions
   * @deprecated Please use the new paginated many mutation (updateManyQuestionsConnection)
   */
  updateManyQuestions: BatchPayload;
  /** Update many Question documents */
  updateManyQuestionsConnection: QuestionConnection;
  /**
   * Update many ratings
   * @deprecated Please use the new paginated many mutation (updateManyRatingsConnection)
   */
  updateManyRatings: BatchPayload;
  /** Update many Rating documents */
  updateManyRatingsConnection: RatingConnection;
  /**
   * Update many recipeCategories
   * @deprecated Please use the new paginated many mutation (updateManyRecipeCategoriesConnection)
   */
  updateManyRecipeCategories: BatchPayload;
  /** Update many RecipeCategory documents */
  updateManyRecipeCategoriesConnection: RecipeCategoryConnection;
  /**
   * Update many recipeLandingPages
   * @deprecated Please use the new paginated many mutation (updateManyRecipeLandingPagesConnection)
   */
  updateManyRecipeLandingPages: BatchPayload;
  /** Update many RecipeLandingPage documents */
  updateManyRecipeLandingPagesConnection: RecipeLandingPageConnection;
  /**
   * Update many recipeSubcategories
   * @deprecated Please use the new paginated many mutation (updateManyRecipeSubcategoriesConnection)
   */
  updateManyRecipeSubcategories: BatchPayload;
  /** Update many RecipeSubcategory documents */
  updateManyRecipeSubcategoriesConnection: RecipeSubcategoryConnection;
  /**
   * Update many recipes
   * @deprecated Please use the new paginated many mutation (updateManyRecipesConnection)
   */
  updateManyRecipes: BatchPayload;
  /**
   * Update many recipesComparisonQueryComponents
   * @deprecated Please use the new paginated many mutation (updateManyRecipesComparisonQueryComponentsConnection)
   */
  updateManyRecipesComparisonQueryComponents: BatchPayload;
  /** Update many RecipesComparisonQueryComponent documents */
  updateManyRecipesComparisonQueryComponentsConnection: RecipesComparisonQueryComponentConnection;
  /** Update many Recipe documents */
  updateManyRecipesConnection: RecipeConnection;
  /**
   * Update many recipesQueriesReferences
   * @deprecated Please use the new paginated many mutation (updateManyRecipesQueriesReferencesConnection)
   */
  updateManyRecipesQueriesReferences: BatchPayload;
  /** Update many RecipesQueriesReference documents */
  updateManyRecipesQueriesReferencesConnection: RecipesQueriesReferenceConnection;
  /**
   * Update many recipesQueryComponents
   * @deprecated Please use the new paginated many mutation (updateManyRecipesQueryComponentsConnection)
   */
  updateManyRecipesQueryComponents: BatchPayload;
  /** Update many RecipesQueryComponent documents */
  updateManyRecipesQueryComponentsConnection: RecipesQueryComponentConnection;
  /**
   * Update many redirects
   * @deprecated Please use the new paginated many mutation (updateManyRedirectsConnection)
   */
  updateManyRedirects: BatchPayload;
  /** Update many Redirect documents */
  updateManyRedirectsConnection: RedirectConnection;
  /**
   * Update many rewrites
   * @deprecated Please use the new paginated many mutation (updateManyRewritesConnection)
   */
  updateManyRewrites: BatchPayload;
  /** Update many Rewrite documents */
  updateManyRewritesConnection: RewriteConnection;
  /**
   * Update many rightColumns
   * @deprecated Please use the new paginated many mutation (updateManyRightColumnsConnection)
   */
  updateManyRightColumns: BatchPayload;
  /** Update many RightColumn documents */
  updateManyRightColumnsConnection: RightColumnConnection;
  /**
   * Update many searchInputs
   * @deprecated Please use the new paginated many mutation (updateManySearchInputsConnection)
   */
  updateManySearchInputs: BatchPayload;
  /** Update many SearchInput documents */
  updateManySearchInputsConnection: SearchInputConnection;
  /**
   * Update many searchOverlayComponents
   * @deprecated Please use the new paginated many mutation (updateManySearchOverlayComponentsConnection)
   */
  updateManySearchOverlayComponents: BatchPayload;
  /** Update many SearchOverlayComponent documents */
  updateManySearchOverlayComponentsConnection: SearchOverlayComponentConnection;
  /**
   * Update many searchResultPages
   * @deprecated Please use the new paginated many mutation (updateManySearchResultPagesConnection)
   */
  updateManySearchResultPages: BatchPayload;
  /** Update many SearchResultPage documents */
  updateManySearchResultPagesConnection: SearchResultPageConnection;
  /**
   * Update many separators
   * @deprecated Please use the new paginated many mutation (updateManySeparatorsConnection)
   */
  updateManySeparators: BatchPayload;
  /** Update many Separator documents */
  updateManySeparatorsConnection: SeparatorConnection;
  /**
   * Update many singleStepPromotionForms
   * @deprecated Please use the new paginated many mutation (updateManySingleStepPromotionFormsConnection)
   */
  updateManySingleStepPromotionForms: BatchPayload;
  /** Update many SingleStepPromotionForm documents */
  updateManySingleStepPromotionFormsConnection: SingleStepPromotionFormConnection;
  /**
   * Update many socialMediaListComponents
   * @deprecated Please use the new paginated many mutation (updateManySocialMediaListComponentsConnection)
   */
  updateManySocialMediaListComponents: BatchPayload;
  /** Update many SocialMediaListComponent documents */
  updateManySocialMediaListComponentsConnection: SocialMediaListComponentConnection;
  /**
   * Update many spacers
   * @deprecated Please use the new paginated many mutation (updateManySpacersConnection)
   */
  updateManySpacers: BatchPayload;
  /** Update many Spacer documents */
  updateManySpacersConnection: SpacerConnection;
  /**
   * Update many subCategoryKeyImages
   * @deprecated Please use the new paginated many mutation (updateManySubCategoryKeyImagesConnection)
   */
  updateManySubCategoryKeyImages: BatchPayload;
  /** Update many SubCategoryKeyImage documents */
  updateManySubCategoryKeyImagesConnection: SubCategoryKeyImageConnection;
  /**
   * Update many subTabs
   * @deprecated Please use the new paginated many mutation (updateManySubTabsConnection)
   */
  updateManySubTabs: BatchPayload;
  /** Update many SubTab documents */
  updateManySubTabsConnection: SubTabConnection;
  /**
   * Update many subTabsContent
   * @deprecated Please use the new paginated many mutation (updateManySubTabsContentConnection)
   */
  updateManySubTabsContent: BatchPayload;
  /** Update many SubTabContent documents */
  updateManySubTabsContentConnection: SubTabContentConnection;
  /**
   * Update many sustainabilityBanners
   * @deprecated Please use the new paginated many mutation (updateManySustainabilityBannersConnection)
   */
  updateManySustainabilityBanners: BatchPayload;
  /** Update many SustainabilityBanner documents */
  updateManySustainabilityBannersConnection: SustainabilityBannerConnection;
  /**
   * Update many sustainabilityInfos
   * @deprecated Please use the new paginated many mutation (updateManySustainabilityInfosConnection)
   */
  updateManySustainabilityInfos: BatchPayload;
  /** Update many SustainabilityInfo documents */
  updateManySustainabilityInfosConnection: SustainabilityInfoConnection;
  /**
   * Update many tabContents
   * @deprecated Please use the new paginated many mutation (updateManyTabContentsConnection)
   */
  updateManyTabContents: BatchPayload;
  /** Update many TabContent documents */
  updateManyTabContentsConnection: TabContentConnection;
  /**
   * Update many tabs
   * @deprecated Please use the new paginated many mutation (updateManyTabsConnection)
   */
  updateManyTabs: BatchPayload;
  /** Update many Tab documents */
  updateManyTabsConnection: TabConnection;
  /**
   * Update many teaserPlaceholders
   * @deprecated Please use the new paginated many mutation (updateManyTeaserPlaceholdersConnection)
   */
  updateManyTeaserPlaceholders: BatchPayload;
  /** Update many TeaserPlaceholder documents */
  updateManyTeaserPlaceholdersConnection: TeaserPlaceholderConnection;
  /**
   * Update many teaserSmallPlaceholders
   * @deprecated Please use the new paginated many mutation (updateManyTeaserSmallPlaceholdersConnection)
   */
  updateManyTeaserSmallPlaceholders: BatchPayload;
  /** Update many TeaserSmallPlaceholder documents */
  updateManyTeaserSmallPlaceholdersConnection: TeaserSmallPlaceholderConnection;
  /**
   * Update many teaserSmalls
   * @deprecated Please use the new paginated many mutation (updateManyTeaserSmallsConnection)
   */
  updateManyTeaserSmalls: BatchPayload;
  /** Update many TeaserSmall documents */
  updateManyTeaserSmallsConnection: TeaserSmallConnection;
  /**
   * Update many teasers
   * @deprecated Please use the new paginated many mutation (updateManyTeasersConnection)
   */
  updateManyTeasers: BatchPayload;
  /** Update many Teaser documents */
  updateManyTeasersConnection: TeaserConnection;
  /**
   * Update many testComponentWithRecipeQueries
   * @deprecated Please use the new paginated many mutation (updateManyTestComponentWithRecipeQueriesConnection)
   */
  updateManyTestComponentWithRecipeQueries: BatchPayload;
  /** Update many TestComponentWithRecipeQuery documents */
  updateManyTestComponentWithRecipeQueriesConnection: TestComponentWithRecipeQueryConnection;
  /**
   * Update many testTipsANdTricksInAMarkets
   * @deprecated Please use the new paginated many mutation (updateManyTestTipsANdTricksInAMarketsConnection)
   */
  updateManyTestTipsANdTricksInAMarkets: BatchPayload;
  /** Update many TestTipsANdTricksInAMarket documents */
  updateManyTestTipsANdTricksInAMarketsConnection: TestTipsANdTricksInAMarketConnection;
  /**
   * Update many textComponents
   * @deprecated Please use the new paginated many mutation (updateManyTextComponentsConnection)
   */
  updateManyTextComponents: BatchPayload;
  /** Update many TextComponent documents */
  updateManyTextComponentsConnection: TextComponentConnection;
  /**
   * Update many tipsAndTricksDetailsPages
   * @deprecated Please use the new paginated many mutation (updateManyTipsAndTricksDetailsPagesConnection)
   */
  updateManyTipsAndTricksDetailsPages: BatchPayload;
  /** Update many TipsAndTricksDetailsPage documents */
  updateManyTipsAndTricksDetailsPagesConnection: TipsAndTricksDetailsPageConnection;
  /**
   * Update many titles
   * @deprecated Please use the new paginated many mutation (updateManyTitlesConnection)
   */
  updateManyTitles: BatchPayload;
  /** Update many Title documents */
  updateManyTitlesConnection: TitleConnection;
  /**
   * Update many twitterSeos
   * @deprecated Please use the new paginated many mutation (updateManyTwitterSeosConnection)
   */
  updateManyTwitterSeos: BatchPayload;
  /** Update many TwitterSeo documents */
  updateManyTwitterSeosConnection: TwitterSeoConnection;
  /** Update one market */
  updateMarket?: Maybe<Market>;
  /** Update one marketUserConnection */
  updateMarketUserConnection?: Maybe<MarketUserConnection>;
  /** Update one metaData */
  updateMetaData?: Maybe<MetaData>;
  /** Update one mobileOnlyMainNavigation */
  updateMobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Update one multiStepPromotionForm */
  updateMultiStepPromotionForm?: Maybe<MultiStepPromotionForm>;
  /** Update one navigation */
  updateNavigation?: Maybe<Navigation>;
  /** Update one navigationItem */
  updateNavigationItem?: Maybe<NavigationItem>;
  /** Update one newsletterComponent */
  updateNewsletterComponent?: Maybe<NewsletterComponent>;
  /** Update one newsletterSubscriptions */
  updateNewsletterSubscriptions?: Maybe<NewsletterSubscriptions>;
  /** Update one notificationBanner */
  updateNotificationBanner?: Maybe<NotificationBanner>;
  /** Update one pageFooter */
  updatePageFooter?: Maybe<PageFooter>;
  /** Update one pageHeader */
  updatePageHeader?: Maybe<PageHeader>;
  /** Update one popularSearchComponent */
  updatePopularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Update one product */
  updateProduct?: Maybe<Product>;
  /** Update one productBanner */
  updateProductBanner?: Maybe<ProductBanner>;
  /** Update one productCategory */
  updateProductCategory?: Maybe<ProductCategory>;
  /** Update one productCategoryPage */
  updateProductCategoryPage?: Maybe<ProductCategoryPage>;
  /** Update one productDetailPage */
  updateProductDetailPage?: Maybe<ProductDetailPage>;
  /** Update one productHero */
  updateProductHero?: Maybe<ProductHero>;
  /** Update one productLabel */
  updateProductLabel?: Maybe<ProductLabel>;
  /** Update one productLandingPage */
  updateProductLandingPage?: Maybe<ProductLandingPage>;
  /** Update one productSubcategoryPage */
  updateProductSubcategoryPage?: Maybe<ProductSubcategoryPage>;
  /** Update one promotionDownload */
  updatePromotionDownload?: Maybe<PromotionDownload>;
  /** Update one promotionForm */
  updatePromotionForm?: Maybe<PromotionForm>;
  /** Update one question */
  updateQuestion?: Maybe<Question>;
  /** Update one questionCheckbox */
  updateQuestionCheckbox?: Maybe<QuestionCheckbox>;
  /** Update one questionCheckboxCollection */
  updateQuestionCheckboxCollection?: Maybe<QuestionCheckboxCollection>;
  /** Update one questionRadioButton */
  updateQuestionRadioButton?: Maybe<QuestionRadioButton>;
  /** Update one questionRadioButtonCollection */
  updateQuestionRadioButtonCollection?: Maybe<QuestionRadioButtonCollection>;
  /** Update one rating */
  updateRating?: Maybe<Rating>;
  /** Update one recipe */
  updateRecipe?: Maybe<Recipe>;
  /** Update one recipeCategory */
  updateRecipeCategory?: Maybe<RecipeCategory>;
  /** Update one recipeLandingPage */
  updateRecipeLandingPage?: Maybe<RecipeLandingPage>;
  /** Update one recipeSubcategory */
  updateRecipeSubcategory?: Maybe<RecipeSubcategory>;
  /** Update one recipesComparisonQueryComponent */
  updateRecipesComparisonQueryComponent?: Maybe<RecipesComparisonQueryComponent>;
  /** Update one recipesQueriesReference */
  updateRecipesQueriesReference?: Maybe<RecipesQueriesReference>;
  /** Update one recipesQueryComponent */
  updateRecipesQueryComponent?: Maybe<RecipesQueryComponent>;
  /** Update one redirect */
  updateRedirect?: Maybe<Redirect>;
  /** Update one rewrite */
  updateRewrite?: Maybe<Rewrite>;
  /** Update one rightColumn */
  updateRightColumn?: Maybe<RightColumn>;
  /** Update one scheduledRelease */
  updateScheduledRelease?: Maybe<ScheduledRelease>;
  /** Update one searchInput */
  updateSearchInput?: Maybe<SearchInput>;
  /** Update one searchOverlayComponent */
  updateSearchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Update one searchResultPage */
  updateSearchResultPage?: Maybe<SearchResultPage>;
  /** Update one separator */
  updateSeparator?: Maybe<Separator>;
  /** Update one singleStepPromotionForm */
  updateSingleStepPromotionForm?: Maybe<SingleStepPromotionForm>;
  /** Update one socialMediaListComponent */
  updateSocialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Update one spacer */
  updateSpacer?: Maybe<Spacer>;
  /** Update one subCategoryKeyImage */
  updateSubCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Update one subTab */
  updateSubTab?: Maybe<SubTab>;
  /** Update one subTabContent */
  updateSubTabContent?: Maybe<SubTabContent>;
  /** Update one sustainabilityBanner */
  updateSustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Update one sustainabilityInfo */
  updateSustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Update one tab */
  updateTab?: Maybe<Tab>;
  /** Update one tabContent */
  updateTabContent?: Maybe<TabContent>;
  /** Update one teaser */
  updateTeaser?: Maybe<Teaser>;
  /** Update one teaserPlaceholder */
  updateTeaserPlaceholder?: Maybe<TeaserPlaceholder>;
  /** Update one teaserSmall */
  updateTeaserSmall?: Maybe<TeaserSmall>;
  /** Update one teaserSmallPlaceholder */
  updateTeaserSmallPlaceholder?: Maybe<TeaserSmallPlaceholder>;
  /** Update one testComponentWithRecipeQuery */
  updateTestComponentWithRecipeQuery?: Maybe<TestComponentWithRecipeQuery>;
  /** Update one testTipsANdTricksInAMarket */
  updateTestTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Update one textComponent */
  updateTextComponent?: Maybe<TextComponent>;
  /** Update one tipsAndTricksDetailsPage */
  updateTipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Update one title */
  updateTitle?: Maybe<Title>;
  /** Update one twitterSeo */
  updateTwitterSeo?: Maybe<TwitterSeo>;
  /** Upsert one accordion */
  upsertAccordion?: Maybe<Accordion>;
  /** Upsert one accordionItem */
  upsertAccordionItem?: Maybe<AccordionItem>;
  /** Upsert one algoliaExtension */
  upsertAlgoliaExtension?: Maybe<AlgoliaExtension>;
  /** Upsert one anchorNav */
  upsertAnchorNav?: Maybe<AnchorNav>;
  /** Upsert one anchorNavigation */
  upsertAnchorNavigation?: Maybe<AnchorNavigation>;
  /** Upsert one anchorNavigationList */
  upsertAnchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Upsert one asset */
  upsertAsset?: Maybe<Asset>;
  /** Upsert one assetComponent */
  upsertAssetComponent?: Maybe<AssetComponent>;
  /** Upsert one audioComponent */
  upsertAudioComponent?: Maybe<AudioComponent>;
  /** Upsert one authorableContentCard */
  upsertAuthorableContentCard?: Maybe<AuthorableContentCard>;
  /** Upsert one banner1 */
  upsertBanner1?: Maybe<Banner1>;
  /** Upsert one banner2 */
  upsertBanner2?: Maybe<Banner2>;
  /** Upsert one banner2CarouselComponent */
  upsertBanner2CarouselComponent?: Maybe<Banner2CarouselComponent>;
  /** Upsert one cardComponent */
  upsertCardComponent?: Maybe<CardComponent>;
  /** Upsert one carouselComponent */
  upsertCarouselComponent?: Maybe<CarouselComponent>;
  /** Upsert one carouselSlide */
  upsertCarouselSlide?: Maybe<CarouselSlide>;
  /** Upsert one categoryCard */
  upsertCategoryCard?: Maybe<CategoryCard>;
  /** Upsert one contactCard */
  upsertContactCard?: Maybe<ContactCard>;
  /** Upsert one contactCardContainer */
  upsertContactCardContainer?: Maybe<ContactCardContainer>;
  /** Upsert one countrySelectorFooter */
  upsertCountrySelectorFooter?: Maybe<CountrySelectorFooter>;
  /** Upsert one countrySelectorItem */
  upsertCountrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Upsert one demoModel */
  upsertDemoModel?: Maybe<DemoModel>;
  /** Upsert one dictionary */
  upsertDictionary?: Maybe<Dictionary>;
  /** Upsert one dictionaryItem */
  upsertDictionaryItem?: Maybe<DictionaryItem>;
  /** Upsert one downloadApp */
  upsertDownloadApp?: Maybe<DownloadApp>;
  /** Upsert one dynamicCardGrid */
  upsertDynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Upsert one errorPage */
  upsertErrorPage?: Maybe<ErrorPage>;
  /** Upsert one evalancheFormComponent */
  upsertEvalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Upsert one exampleComponent */
  upsertExampleComponent?: Maybe<ExampleComponent>;
  /** Upsert one featuredContent */
  upsertFeaturedContent?: Maybe<FeaturedContent>;
  /** Upsert one featuredContentReference */
  upsertFeaturedContentReference?: Maybe<FeaturedContentReference>;
  /** Upsert one footerNavigation */
  upsertFooterNavigation?: Maybe<FooterNavigation>;
  /** Upsert one footerSeal */
  upsertFooterSeal?: Maybe<FooterSeal>;
  /** Upsert one form */
  upsertForm?: Maybe<Form>;
  /** Upsert one formCheckbox */
  upsertFormCheckbox?: Maybe<FormCheckbox>;
  /** Upsert one formCheckboxCollection */
  upsertFormCheckboxCollection?: Maybe<FormCheckboxCollection>;
  /** Upsert one formDateInput */
  upsertFormDateInput?: Maybe<FormDateInput>;
  /** Upsert one formEmailInput */
  upsertFormEmailInput?: Maybe<FormEmailInput>;
  /** Upsert one formError */
  upsertFormError?: Maybe<FormError>;
  /** Upsert one formFileUploader */
  upsertFormFileUploader?: Maybe<FormFileUploader>;
  /** Upsert one formList */
  upsertFormList?: Maybe<FormList>;
  /** Upsert one formListItem */
  upsertFormListItem?: Maybe<FormListItem>;
  /** Upsert one formNumberInput */
  upsertFormNumberInput?: Maybe<FormNumberInput>;
  /** Upsert one formPasswordInput */
  upsertFormPasswordInput?: Maybe<FormPasswordInput>;
  /** Upsert one formPasswordInputWithConfirmation */
  upsertFormPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Upsert one formRadioButton */
  upsertFormRadioButton?: Maybe<FormRadioButton>;
  /** Upsert one formRadioButtonCollection */
  upsertFormRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Upsert one formSelectComponent */
  upsertFormSelectComponent?: Maybe<FormSelectComponent>;
  /** Upsert one formSelectOption */
  upsertFormSelectOption?: Maybe<FormSelectOption>;
  /** Upsert one formSubmitButton */
  upsertFormSubmitButton?: Maybe<FormSubmitButton>;
  /** Upsert one formSuccessComponent */
  upsertFormSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Upsert one formTextInput */
  upsertFormTextInput?: Maybe<FormTextInput>;
  /** Upsert one formTextareaInput */
  upsertFormTextareaInput?: Maybe<FormTextareaInput>;
  /** Upsert one genericAccordion */
  upsertGenericAccordion?: Maybe<GenericAccordion>;
  /** Upsert one genericAccordionItem */
  upsertGenericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Upsert one genericAccordionTopRated */
  upsertGenericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Upsert one genericCardCarouseComponent */
  upsertGenericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Upsert one genericDownloadComponent */
  upsertGenericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Upsert one genericFollowUs */
  upsertGenericFollowUs?: Maybe<GenericFollowUs>;
  /** Upsert one genericGridAuthorable */
  upsertGenericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Upsert one genericHtml */
  upsertGenericHtml?: Maybe<GenericHtml>;
  /** Upsert one genericLine */
  upsertGenericLine?: Maybe<GenericLine>;
  /** Upsert one genericLink */
  upsertGenericLink?: Maybe<GenericLink>;
  /** Upsert one genericPage */
  upsertGenericPage?: Maybe<GenericPage>;
  /** Upsert one genericPromotionsOverview */
  upsertGenericPromotionsOverview?: Maybe<GenericPromotionsOverview>;
  /** Upsert one genericQualifio */
  upsertGenericQualifio?: Maybe<GenericQualifio>;
  /** Upsert one genericQualifioOverview */
  upsertGenericQualifioOverview?: Maybe<GenericQualifioOverview>;
  /** Upsert one genericSocialShare */
  upsertGenericSocialShare?: Maybe<GenericSocialShare>;
  /** Upsert one globalMetaData */
  upsertGlobalMetaData?: Maybe<GlobalMetaData>;
  /** Upsert one globalSearch */
  upsertGlobalSearch?: Maybe<GlobalSearch>;
  /** Upsert one gridColumn */
  upsertGridColumn?: Maybe<GridColumn>;
  /** Upsert one gridColumnComponent */
  upsertGridColumnComponent?: Maybe<GridColumnComponent>;
  /** Upsert one heroBanner */
  upsertHeroBanner?: Maybe<HeroBanner>;
  /** Upsert one heroBannerMasterbrand */
  upsertHeroBannerMasterbrand?: Maybe<HeroBannerMasterbrand>;
  /** Upsert one heroCarouselComponent */
  upsertHeroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Upsert one heroComponent */
  upsertHeroComponent?: Maybe<HeroComponent>;
  /** Upsert one heroLoopAnimationComponent */
  upsertHeroLoopAnimationComponent?: Maybe<HeroLoopAnimationComponent>;
  /** Upsert one iframe */
  upsertIframe?: Maybe<Iframe>;
  /** Upsert one imageAndTextCard */
  upsertImageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Upsert one imageCopy */
  upsertImageCopy?: Maybe<ImageCopy>;
  /** Upsert one imageCopyItem */
  upsertImageCopyItem?: Maybe<ImageCopyItem>;
  /** Upsert one introText */
  upsertIntroText?: Maybe<IntroText>;
  /** Upsert one leftColumn */
  upsertLeftColumn?: Maybe<LeftColumn>;
  /** Upsert one link */
  upsertLink?: Maybe<Link>;
  /** Upsert one longText */
  upsertLongText?: Maybe<LongText>;
  /** Upsert one market */
  upsertMarket?: Maybe<Market>;
  /** Upsert one marketUserConnection */
  upsertMarketUserConnection?: Maybe<MarketUserConnection>;
  /** Upsert one metaData */
  upsertMetaData?: Maybe<MetaData>;
  /** Upsert one mobileOnlyMainNavigation */
  upsertMobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Upsert one multiStepPromotionForm */
  upsertMultiStepPromotionForm?: Maybe<MultiStepPromotionForm>;
  /** Upsert one navigation */
  upsertNavigation?: Maybe<Navigation>;
  /** Upsert one navigationItem */
  upsertNavigationItem?: Maybe<NavigationItem>;
  /** Upsert one newsletterComponent */
  upsertNewsletterComponent?: Maybe<NewsletterComponent>;
  /** Upsert one newsletterSubscriptions */
  upsertNewsletterSubscriptions?: Maybe<NewsletterSubscriptions>;
  /** Upsert one notificationBanner */
  upsertNotificationBanner?: Maybe<NotificationBanner>;
  /** Upsert one pageFooter */
  upsertPageFooter?: Maybe<PageFooter>;
  /** Upsert one pageHeader */
  upsertPageHeader?: Maybe<PageHeader>;
  /** Upsert one popularSearchComponent */
  upsertPopularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Upsert one product */
  upsertProduct?: Maybe<Product>;
  /** Upsert one productBanner */
  upsertProductBanner?: Maybe<ProductBanner>;
  /** Upsert one productCategory */
  upsertProductCategory?: Maybe<ProductCategory>;
  /** Upsert one productCategoryPage */
  upsertProductCategoryPage?: Maybe<ProductCategoryPage>;
  /** Upsert one productDetailPage */
  upsertProductDetailPage?: Maybe<ProductDetailPage>;
  /** Upsert one productHero */
  upsertProductHero?: Maybe<ProductHero>;
  /** Upsert one productLabel */
  upsertProductLabel?: Maybe<ProductLabel>;
  /** Upsert one productLandingPage */
  upsertProductLandingPage?: Maybe<ProductLandingPage>;
  /** Upsert one productSubcategoryPage */
  upsertProductSubcategoryPage?: Maybe<ProductSubcategoryPage>;
  /** Upsert one promotionDownload */
  upsertPromotionDownload?: Maybe<PromotionDownload>;
  /** Upsert one promotionForm */
  upsertPromotionForm?: Maybe<PromotionForm>;
  /** Upsert one question */
  upsertQuestion?: Maybe<Question>;
  /** Upsert one questionCheckbox */
  upsertQuestionCheckbox?: Maybe<QuestionCheckbox>;
  /** Upsert one questionCheckboxCollection */
  upsertQuestionCheckboxCollection?: Maybe<QuestionCheckboxCollection>;
  /** Upsert one questionRadioButton */
  upsertQuestionRadioButton?: Maybe<QuestionRadioButton>;
  /** Upsert one questionRadioButtonCollection */
  upsertQuestionRadioButtonCollection?: Maybe<QuestionRadioButtonCollection>;
  /** Upsert one rating */
  upsertRating?: Maybe<Rating>;
  /** Upsert one recipe */
  upsertRecipe?: Maybe<Recipe>;
  /** Upsert one recipeCategory */
  upsertRecipeCategory?: Maybe<RecipeCategory>;
  /** Upsert one recipeLandingPage */
  upsertRecipeLandingPage?: Maybe<RecipeLandingPage>;
  /** Upsert one recipeSubcategory */
  upsertRecipeSubcategory?: Maybe<RecipeSubcategory>;
  /** Upsert one recipesComparisonQueryComponent */
  upsertRecipesComparisonQueryComponent?: Maybe<RecipesComparisonQueryComponent>;
  /** Upsert one recipesQueriesReference */
  upsertRecipesQueriesReference?: Maybe<RecipesQueriesReference>;
  /** Upsert one recipesQueryComponent */
  upsertRecipesQueryComponent?: Maybe<RecipesQueryComponent>;
  /** Upsert one redirect */
  upsertRedirect?: Maybe<Redirect>;
  /** Upsert one rewrite */
  upsertRewrite?: Maybe<Rewrite>;
  /** Upsert one rightColumn */
  upsertRightColumn?: Maybe<RightColumn>;
  /** Upsert one searchInput */
  upsertSearchInput?: Maybe<SearchInput>;
  /** Upsert one searchOverlayComponent */
  upsertSearchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Upsert one searchResultPage */
  upsertSearchResultPage?: Maybe<SearchResultPage>;
  /** Upsert one separator */
  upsertSeparator?: Maybe<Separator>;
  /** Upsert one singleStepPromotionForm */
  upsertSingleStepPromotionForm?: Maybe<SingleStepPromotionForm>;
  /** Upsert one socialMediaListComponent */
  upsertSocialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Upsert one spacer */
  upsertSpacer?: Maybe<Spacer>;
  /** Upsert one subCategoryKeyImage */
  upsertSubCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Upsert one subTab */
  upsertSubTab?: Maybe<SubTab>;
  /** Upsert one subTabContent */
  upsertSubTabContent?: Maybe<SubTabContent>;
  /** Upsert one sustainabilityBanner */
  upsertSustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Upsert one sustainabilityInfo */
  upsertSustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Upsert one tab */
  upsertTab?: Maybe<Tab>;
  /** Upsert one tabContent */
  upsertTabContent?: Maybe<TabContent>;
  /** Upsert one teaser */
  upsertTeaser?: Maybe<Teaser>;
  /** Upsert one teaserPlaceholder */
  upsertTeaserPlaceholder?: Maybe<TeaserPlaceholder>;
  /** Upsert one teaserSmall */
  upsertTeaserSmall?: Maybe<TeaserSmall>;
  /** Upsert one teaserSmallPlaceholder */
  upsertTeaserSmallPlaceholder?: Maybe<TeaserSmallPlaceholder>;
  /** Upsert one testComponentWithRecipeQuery */
  upsertTestComponentWithRecipeQuery?: Maybe<TestComponentWithRecipeQuery>;
  /** Upsert one testTipsANdTricksInAMarket */
  upsertTestTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Upsert one textComponent */
  upsertTextComponent?: Maybe<TextComponent>;
  /** Upsert one tipsAndTricksDetailsPage */
  upsertTipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Upsert one title */
  upsertTitle?: Maybe<Title>;
  /** Upsert one twitterSeo */
  upsertTwitterSeo?: Maybe<TwitterSeo>;
};


export type MutationCreateAccordionArgs = {
  data: AccordionCreateInput;
};


export type MutationCreateAccordionItemArgs = {
  data: AccordionItemCreateInput;
};


export type MutationCreateAlgoliaExtensionArgs = {
  data: AlgoliaExtensionCreateInput;
};


export type MutationCreateAnchorNavArgs = {
  data: AnchorNavCreateInput;
};


export type MutationCreateAnchorNavigationArgs = {
  data: AnchorNavigationCreateInput;
};


export type MutationCreateAnchorNavigationListArgs = {
  data: AnchorNavigationListCreateInput;
};


export type MutationCreateAssetArgs = {
  data: AssetCreateInput;
};


export type MutationCreateAssetComponentArgs = {
  data: AssetComponentCreateInput;
};


export type MutationCreateAudioComponentArgs = {
  data: AudioComponentCreateInput;
};


export type MutationCreateAuthorableContentCardArgs = {
  data: AuthorableContentCardCreateInput;
};


export type MutationCreateBanner1Args = {
  data: Banner1CreateInput;
};


export type MutationCreateBanner2Args = {
  data: Banner2CreateInput;
};


export type MutationCreateBanner2CarouselComponentArgs = {
  data: Banner2CarouselComponentCreateInput;
};


export type MutationCreateCardComponentArgs = {
  data: CardComponentCreateInput;
};


export type MutationCreateCarouselComponentArgs = {
  data: CarouselComponentCreateInput;
};


export type MutationCreateCarouselSlideArgs = {
  data: CarouselSlideCreateInput;
};


export type MutationCreateCategoryCardArgs = {
  data: CategoryCardCreateInput;
};


export type MutationCreateContactCardArgs = {
  data: ContactCardCreateInput;
};


export type MutationCreateContactCardContainerArgs = {
  data: ContactCardContainerCreateInput;
};


export type MutationCreateCountrySelectorFooterArgs = {
  data: CountrySelectorFooterCreateInput;
};


export type MutationCreateCountrySelectorItemArgs = {
  data: CountrySelectorItemCreateInput;
};


export type MutationCreateDemoModelArgs = {
  data: DemoModelCreateInput;
};


export type MutationCreateDictionaryArgs = {
  data: DictionaryCreateInput;
};


export type MutationCreateDictionaryItemArgs = {
  data: DictionaryItemCreateInput;
};


export type MutationCreateDownloadAppArgs = {
  data: DownloadAppCreateInput;
};


export type MutationCreateDynamicCardGridArgs = {
  data: DynamicCardGridCreateInput;
};


export type MutationCreateErrorPageArgs = {
  data: ErrorPageCreateInput;
};


export type MutationCreateEvalancheFormComponentArgs = {
  data: EvalancheFormComponentCreateInput;
};


export type MutationCreateExampleComponentArgs = {
  data: ExampleComponentCreateInput;
};


export type MutationCreateFeaturedContentArgs = {
  data: FeaturedContentCreateInput;
};


export type MutationCreateFeaturedContentReferenceArgs = {
  data: FeaturedContentReferenceCreateInput;
};


export type MutationCreateFooterNavigationArgs = {
  data: FooterNavigationCreateInput;
};


export type MutationCreateFooterSealArgs = {
  data: FooterSealCreateInput;
};


export type MutationCreateFormArgs = {
  data: FormCreateInput;
};


export type MutationCreateFormCheckboxArgs = {
  data: FormCheckboxCreateInput;
};


export type MutationCreateFormCheckboxCollectionArgs = {
  data: FormCheckboxCollectionCreateInput;
};


export type MutationCreateFormDateInputArgs = {
  data: FormDateInputCreateInput;
};


export type MutationCreateFormEmailInputArgs = {
  data: FormEmailInputCreateInput;
};


export type MutationCreateFormErrorArgs = {
  data: FormErrorCreateInput;
};


export type MutationCreateFormFileUploaderArgs = {
  data: FormFileUploaderCreateInput;
};


export type MutationCreateFormListArgs = {
  data: FormListCreateInput;
};


export type MutationCreateFormListItemArgs = {
  data: FormListItemCreateInput;
};


export type MutationCreateFormNumberInputArgs = {
  data: FormNumberInputCreateInput;
};


export type MutationCreateFormPasswordInputArgs = {
  data: FormPasswordInputCreateInput;
};


export type MutationCreateFormPasswordInputWithConfirmationArgs = {
  data: FormPasswordInputWithConfirmationCreateInput;
};


export type MutationCreateFormRadioButtonArgs = {
  data: FormRadioButtonCreateInput;
};


export type MutationCreateFormRadioButtonCollectionArgs = {
  data: FormRadioButtonCollectionCreateInput;
};


export type MutationCreateFormSelectComponentArgs = {
  data: FormSelectComponentCreateInput;
};


export type MutationCreateFormSelectOptionArgs = {
  data: FormSelectOptionCreateInput;
};


export type MutationCreateFormSubmitButtonArgs = {
  data: FormSubmitButtonCreateInput;
};


export type MutationCreateFormSuccessComponentArgs = {
  data: FormSuccessComponentCreateInput;
};


export type MutationCreateFormTextInputArgs = {
  data: FormTextInputCreateInput;
};


export type MutationCreateFormTextareaInputArgs = {
  data: FormTextareaInputCreateInput;
};


export type MutationCreateGenericAccordionArgs = {
  data: GenericAccordionCreateInput;
};


export type MutationCreateGenericAccordionItemArgs = {
  data: GenericAccordionItemCreateInput;
};


export type MutationCreateGenericAccordionTopRatedArgs = {
  data: GenericAccordionTopRatedCreateInput;
};


export type MutationCreateGenericCardCarouseComponentArgs = {
  data: GenericCardCarouseComponentCreateInput;
};


export type MutationCreateGenericDownloadComponentArgs = {
  data: GenericDownloadComponentCreateInput;
};


export type MutationCreateGenericFollowUsArgs = {
  data: GenericFollowUsCreateInput;
};


export type MutationCreateGenericGridAuthorableArgs = {
  data: GenericGridAuthorableCreateInput;
};


export type MutationCreateGenericHtmlArgs = {
  data: GenericHtmlCreateInput;
};


export type MutationCreateGenericLineArgs = {
  data: GenericLineCreateInput;
};


export type MutationCreateGenericLinkArgs = {
  data: GenericLinkCreateInput;
};


export type MutationCreateGenericPageArgs = {
  data: GenericPageCreateInput;
};


export type MutationCreateGenericPromotionsOverviewArgs = {
  data: GenericPromotionsOverviewCreateInput;
};


export type MutationCreateGenericQualifioArgs = {
  data: GenericQualifioCreateInput;
};


export type MutationCreateGenericQualifioOverviewArgs = {
  data: GenericQualifioOverviewCreateInput;
};


export type MutationCreateGenericSocialShareArgs = {
  data: GenericSocialShareCreateInput;
};


export type MutationCreateGlobalMetaDataArgs = {
  data: GlobalMetaDataCreateInput;
};


export type MutationCreateGlobalSearchArgs = {
  data: GlobalSearchCreateInput;
};


export type MutationCreateGridColumnArgs = {
  data: GridColumnCreateInput;
};


export type MutationCreateGridColumnComponentArgs = {
  data: GridColumnComponentCreateInput;
};


export type MutationCreateHeroBannerArgs = {
  data: HeroBannerCreateInput;
};


export type MutationCreateHeroBannerMasterbrandArgs = {
  data: HeroBannerMasterbrandCreateInput;
};


export type MutationCreateHeroCarouselComponentArgs = {
  data: HeroCarouselComponentCreateInput;
};


export type MutationCreateHeroComponentArgs = {
  data: HeroComponentCreateInput;
};


export type MutationCreateHeroLoopAnimationComponentArgs = {
  data: HeroLoopAnimationComponentCreateInput;
};


export type MutationCreateIframeArgs = {
  data: IframeCreateInput;
};


export type MutationCreateImageAndTextCardArgs = {
  data: ImageAndTextCardCreateInput;
};


export type MutationCreateImageCopyArgs = {
  data: ImageCopyCreateInput;
};


export type MutationCreateImageCopyItemArgs = {
  data: ImageCopyItemCreateInput;
};


export type MutationCreateIntroTextArgs = {
  data: IntroTextCreateInput;
};


export type MutationCreateLeftColumnArgs = {
  data: LeftColumnCreateInput;
};


export type MutationCreateLinkArgs = {
  data: LinkCreateInput;
};


export type MutationCreateLongTextArgs = {
  data: LongTextCreateInput;
};


export type MutationCreateMarketArgs = {
  data: MarketCreateInput;
};


export type MutationCreateMarketUserConnectionArgs = {
  data: MarketUserConnectionCreateInput;
};


export type MutationCreateMetaDataArgs = {
  data: MetaDataCreateInput;
};


export type MutationCreateMobileOnlyMainNavigationArgs = {
  data: MobileOnlyMainNavigationCreateInput;
};


export type MutationCreateMultiStepPromotionFormArgs = {
  data: MultiStepPromotionFormCreateInput;
};


export type MutationCreateNavigationArgs = {
  data: NavigationCreateInput;
};


export type MutationCreateNavigationItemArgs = {
  data: NavigationItemCreateInput;
};


export type MutationCreateNewsletterComponentArgs = {
  data: NewsletterComponentCreateInput;
};


export type MutationCreateNewsletterSubscriptionsArgs = {
  data: NewsletterSubscriptionsCreateInput;
};


export type MutationCreateNotificationBannerArgs = {
  data: NotificationBannerCreateInput;
};


export type MutationCreatePageFooterArgs = {
  data: PageFooterCreateInput;
};


export type MutationCreatePageHeaderArgs = {
  data: PageHeaderCreateInput;
};


export type MutationCreatePopularSearchComponentArgs = {
  data: PopularSearchComponentCreateInput;
};


export type MutationCreateProductArgs = {
  data: ProductCreateInput;
};


export type MutationCreateProductBannerArgs = {
  data: ProductBannerCreateInput;
};


export type MutationCreateProductCategoryArgs = {
  data: ProductCategoryCreateInput;
};


export type MutationCreateProductCategoryPageArgs = {
  data: ProductCategoryPageCreateInput;
};


export type MutationCreateProductDetailPageArgs = {
  data: ProductDetailPageCreateInput;
};


export type MutationCreateProductHeroArgs = {
  data: ProductHeroCreateInput;
};


export type MutationCreateProductLabelArgs = {
  data: ProductLabelCreateInput;
};


export type MutationCreateProductLandingPageArgs = {
  data: ProductLandingPageCreateInput;
};


export type MutationCreateProductSubcategoryPageArgs = {
  data: ProductSubcategoryPageCreateInput;
};


export type MutationCreatePromotionDownloadArgs = {
  data: PromotionDownloadCreateInput;
};


export type MutationCreatePromotionFormArgs = {
  data: PromotionFormCreateInput;
};


export type MutationCreateQuestionArgs = {
  data: QuestionCreateInput;
};


export type MutationCreateQuestionCheckboxArgs = {
  data: QuestionCheckboxCreateInput;
};


export type MutationCreateQuestionCheckboxCollectionArgs = {
  data: QuestionCheckboxCollectionCreateInput;
};


export type MutationCreateQuestionRadioButtonArgs = {
  data: QuestionRadioButtonCreateInput;
};


export type MutationCreateQuestionRadioButtonCollectionArgs = {
  data: QuestionRadioButtonCollectionCreateInput;
};


export type MutationCreateRatingArgs = {
  data: RatingCreateInput;
};


export type MutationCreateRecipeArgs = {
  data: RecipeCreateInput;
};


export type MutationCreateRecipeCategoryArgs = {
  data: RecipeCategoryCreateInput;
};


export type MutationCreateRecipeLandingPageArgs = {
  data: RecipeLandingPageCreateInput;
};


export type MutationCreateRecipeSubcategoryArgs = {
  data: RecipeSubcategoryCreateInput;
};


export type MutationCreateRecipesComparisonQueryComponentArgs = {
  data: RecipesComparisonQueryComponentCreateInput;
};


export type MutationCreateRecipesQueriesReferenceArgs = {
  data: RecipesQueriesReferenceCreateInput;
};


export type MutationCreateRecipesQueryComponentArgs = {
  data: RecipesQueryComponentCreateInput;
};


export type MutationCreateRedirectArgs = {
  data: RedirectCreateInput;
};


export type MutationCreateRewriteArgs = {
  data: RewriteCreateInput;
};


export type MutationCreateRightColumnArgs = {
  data: RightColumnCreateInput;
};


export type MutationCreateScheduledReleaseArgs = {
  data: ScheduledReleaseCreateInput;
};


export type MutationCreateSearchInputArgs = {
  data: SearchInputCreateInput;
};


export type MutationCreateSearchOverlayComponentArgs = {
  data: SearchOverlayComponentCreateInput;
};


export type MutationCreateSearchResultPageArgs = {
  data: SearchResultPageCreateInput;
};


export type MutationCreateSeparatorArgs = {
  data: SeparatorCreateInput;
};


export type MutationCreateSingleStepPromotionFormArgs = {
  data: SingleStepPromotionFormCreateInput;
};


export type MutationCreateSocialMediaListComponentArgs = {
  data: SocialMediaListComponentCreateInput;
};


export type MutationCreateSpacerArgs = {
  data: SpacerCreateInput;
};


export type MutationCreateSubCategoryKeyImageArgs = {
  data: SubCategoryKeyImageCreateInput;
};


export type MutationCreateSubTabArgs = {
  data: SubTabCreateInput;
};


export type MutationCreateSubTabContentArgs = {
  data: SubTabContentCreateInput;
};


export type MutationCreateSustainabilityBannerArgs = {
  data: SustainabilityBannerCreateInput;
};


export type MutationCreateSustainabilityInfoArgs = {
  data: SustainabilityInfoCreateInput;
};


export type MutationCreateTabArgs = {
  data: TabCreateInput;
};


export type MutationCreateTabContentArgs = {
  data: TabContentCreateInput;
};


export type MutationCreateTeaserArgs = {
  data: TeaserCreateInput;
};


export type MutationCreateTeaserPlaceholderArgs = {
  data: TeaserPlaceholderCreateInput;
};


export type MutationCreateTeaserSmallArgs = {
  data: TeaserSmallCreateInput;
};


export type MutationCreateTeaserSmallPlaceholderArgs = {
  data: TeaserSmallPlaceholderCreateInput;
};


export type MutationCreateTestComponentWithRecipeQueryArgs = {
  data: TestComponentWithRecipeQueryCreateInput;
};


export type MutationCreateTestTipsANdTricksInAMarketArgs = {
  data: TestTipsANdTricksInAMarketCreateInput;
};


export type MutationCreateTextComponentArgs = {
  data: TextComponentCreateInput;
};


export type MutationCreateTipsAndTricksDetailsPageArgs = {
  data: TipsAndTricksDetailsPageCreateInput;
};


export type MutationCreateTitleArgs = {
  data: TitleCreateInput;
};


export type MutationCreateTwitterSeoArgs = {
  data: TwitterSeoCreateInput;
};


export type MutationDeleteAccordionArgs = {
  where: AccordionWhereUniqueInput;
};


export type MutationDeleteAccordionItemArgs = {
  where: AccordionItemWhereUniqueInput;
};


export type MutationDeleteAlgoliaExtensionArgs = {
  where: AlgoliaExtensionWhereUniqueInput;
};


export type MutationDeleteAnchorNavArgs = {
  where: AnchorNavWhereUniqueInput;
};


export type MutationDeleteAnchorNavigationArgs = {
  where: AnchorNavigationWhereUniqueInput;
};


export type MutationDeleteAnchorNavigationListArgs = {
  where: AnchorNavigationListWhereUniqueInput;
};


export type MutationDeleteAssetArgs = {
  where: AssetWhereUniqueInput;
};


export type MutationDeleteAssetComponentArgs = {
  where: AssetComponentWhereUniqueInput;
};


export type MutationDeleteAudioComponentArgs = {
  where: AudioComponentWhereUniqueInput;
};


export type MutationDeleteAuthorableContentCardArgs = {
  where: AuthorableContentCardWhereUniqueInput;
};


export type MutationDeleteBanner1Args = {
  where: Banner1WhereUniqueInput;
};


export type MutationDeleteBanner2Args = {
  where: Banner2WhereUniqueInput;
};


export type MutationDeleteBanner2CarouselComponentArgs = {
  where: Banner2CarouselComponentWhereUniqueInput;
};


export type MutationDeleteCardComponentArgs = {
  where: CardComponentWhereUniqueInput;
};


export type MutationDeleteCarouselComponentArgs = {
  where: CarouselComponentWhereUniqueInput;
};


export type MutationDeleteCarouselSlideArgs = {
  where: CarouselSlideWhereUniqueInput;
};


export type MutationDeleteCategoryCardArgs = {
  where: CategoryCardWhereUniqueInput;
};


export type MutationDeleteContactCardArgs = {
  where: ContactCardWhereUniqueInput;
};


export type MutationDeleteContactCardContainerArgs = {
  where: ContactCardContainerWhereUniqueInput;
};


export type MutationDeleteCountrySelectorFooterArgs = {
  where: CountrySelectorFooterWhereUniqueInput;
};


export type MutationDeleteCountrySelectorItemArgs = {
  where: CountrySelectorItemWhereUniqueInput;
};


export type MutationDeleteDemoModelArgs = {
  where: DemoModelWhereUniqueInput;
};


export type MutationDeleteDictionaryArgs = {
  where: DictionaryWhereUniqueInput;
};


export type MutationDeleteDictionaryItemArgs = {
  where: DictionaryItemWhereUniqueInput;
};


export type MutationDeleteDownloadAppArgs = {
  where: DownloadAppWhereUniqueInput;
};


export type MutationDeleteDynamicCardGridArgs = {
  where: DynamicCardGridWhereUniqueInput;
};


export type MutationDeleteErrorPageArgs = {
  where: ErrorPageWhereUniqueInput;
};


export type MutationDeleteEvalancheFormComponentArgs = {
  where: EvalancheFormComponentWhereUniqueInput;
};


export type MutationDeleteExampleComponentArgs = {
  where: ExampleComponentWhereUniqueInput;
};


export type MutationDeleteFeaturedContentArgs = {
  where: FeaturedContentWhereUniqueInput;
};


export type MutationDeleteFeaturedContentReferenceArgs = {
  where: FeaturedContentReferenceWhereUniqueInput;
};


export type MutationDeleteFooterNavigationArgs = {
  where: FooterNavigationWhereUniqueInput;
};


export type MutationDeleteFooterSealArgs = {
  where: FooterSealWhereUniqueInput;
};


export type MutationDeleteFormArgs = {
  where: FormWhereUniqueInput;
};


export type MutationDeleteFormCheckboxArgs = {
  where: FormCheckboxWhereUniqueInput;
};


export type MutationDeleteFormCheckboxCollectionArgs = {
  where: FormCheckboxCollectionWhereUniqueInput;
};


export type MutationDeleteFormDateInputArgs = {
  where: FormDateInputWhereUniqueInput;
};


export type MutationDeleteFormEmailInputArgs = {
  where: FormEmailInputWhereUniqueInput;
};


export type MutationDeleteFormErrorArgs = {
  where: FormErrorWhereUniqueInput;
};


export type MutationDeleteFormFileUploaderArgs = {
  where: FormFileUploaderWhereUniqueInput;
};


export type MutationDeleteFormListArgs = {
  where: FormListWhereUniqueInput;
};


export type MutationDeleteFormListItemArgs = {
  where: FormListItemWhereUniqueInput;
};


export type MutationDeleteFormNumberInputArgs = {
  where: FormNumberInputWhereUniqueInput;
};


export type MutationDeleteFormPasswordInputArgs = {
  where: FormPasswordInputWhereUniqueInput;
};


export type MutationDeleteFormPasswordInputWithConfirmationArgs = {
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};


export type MutationDeleteFormRadioButtonArgs = {
  where: FormRadioButtonWhereUniqueInput;
};


export type MutationDeleteFormRadioButtonCollectionArgs = {
  where: FormRadioButtonCollectionWhereUniqueInput;
};


export type MutationDeleteFormSelectComponentArgs = {
  where: FormSelectComponentWhereUniqueInput;
};


export type MutationDeleteFormSelectOptionArgs = {
  where: FormSelectOptionWhereUniqueInput;
};


export type MutationDeleteFormSubmitButtonArgs = {
  where: FormSubmitButtonWhereUniqueInput;
};


export type MutationDeleteFormSuccessComponentArgs = {
  where: FormSuccessComponentWhereUniqueInput;
};


export type MutationDeleteFormTextInputArgs = {
  where: FormTextInputWhereUniqueInput;
};


export type MutationDeleteFormTextareaInputArgs = {
  where: FormTextareaInputWhereUniqueInput;
};


export type MutationDeleteGenericAccordionArgs = {
  where: GenericAccordionWhereUniqueInput;
};


export type MutationDeleteGenericAccordionItemArgs = {
  where: GenericAccordionItemWhereUniqueInput;
};


export type MutationDeleteGenericAccordionTopRatedArgs = {
  where: GenericAccordionTopRatedWhereUniqueInput;
};


export type MutationDeleteGenericCardCarouseComponentArgs = {
  where: GenericCardCarouseComponentWhereUniqueInput;
};


export type MutationDeleteGenericDownloadComponentArgs = {
  where: GenericDownloadComponentWhereUniqueInput;
};


export type MutationDeleteGenericFollowUsArgs = {
  where: GenericFollowUsWhereUniqueInput;
};


export type MutationDeleteGenericGridAuthorableArgs = {
  where: GenericGridAuthorableWhereUniqueInput;
};


export type MutationDeleteGenericHtmlArgs = {
  where: GenericHtmlWhereUniqueInput;
};


export type MutationDeleteGenericLineArgs = {
  where: GenericLineWhereUniqueInput;
};


export type MutationDeleteGenericLinkArgs = {
  where: GenericLinkWhereUniqueInput;
};


export type MutationDeleteGenericPageArgs = {
  where: GenericPageWhereUniqueInput;
};


export type MutationDeleteGenericPromotionsOverviewArgs = {
  where: GenericPromotionsOverviewWhereUniqueInput;
};


export type MutationDeleteGenericQualifioArgs = {
  where: GenericQualifioWhereUniqueInput;
};


export type MutationDeleteGenericQualifioOverviewArgs = {
  where: GenericQualifioOverviewWhereUniqueInput;
};


export type MutationDeleteGenericSocialShareArgs = {
  where: GenericSocialShareWhereUniqueInput;
};


export type MutationDeleteGlobalMetaDataArgs = {
  where: GlobalMetaDataWhereUniqueInput;
};


export type MutationDeleteGlobalSearchArgs = {
  where: GlobalSearchWhereUniqueInput;
};


export type MutationDeleteGridColumnArgs = {
  where: GridColumnWhereUniqueInput;
};


export type MutationDeleteGridColumnComponentArgs = {
  where: GridColumnComponentWhereUniqueInput;
};


export type MutationDeleteHeroBannerArgs = {
  where: HeroBannerWhereUniqueInput;
};


export type MutationDeleteHeroBannerMasterbrandArgs = {
  where: HeroBannerMasterbrandWhereUniqueInput;
};


export type MutationDeleteHeroCarouselComponentArgs = {
  where: HeroCarouselComponentWhereUniqueInput;
};


export type MutationDeleteHeroComponentArgs = {
  where: HeroComponentWhereUniqueInput;
};


export type MutationDeleteHeroLoopAnimationComponentArgs = {
  where: HeroLoopAnimationComponentWhereUniqueInput;
};


export type MutationDeleteIframeArgs = {
  where: IframeWhereUniqueInput;
};


export type MutationDeleteImageAndTextCardArgs = {
  where: ImageAndTextCardWhereUniqueInput;
};


export type MutationDeleteImageCopyArgs = {
  where: ImageCopyWhereUniqueInput;
};


export type MutationDeleteImageCopyItemArgs = {
  where: ImageCopyItemWhereUniqueInput;
};


export type MutationDeleteIntroTextArgs = {
  where: IntroTextWhereUniqueInput;
};


export type MutationDeleteLeftColumnArgs = {
  where: LeftColumnWhereUniqueInput;
};


export type MutationDeleteLinkArgs = {
  where: LinkWhereUniqueInput;
};


export type MutationDeleteLongTextArgs = {
  where: LongTextWhereUniqueInput;
};


export type MutationDeleteManyAccordionItemsArgs = {
  where?: InputMaybe<AccordionItemManyWhereInput>;
};


export type MutationDeleteManyAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionItemManyWhereInput>;
};


export type MutationDeleteManyAccordionsArgs = {
  where?: InputMaybe<AccordionManyWhereInput>;
};


export type MutationDeleteManyAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionManyWhereInput>;
};


export type MutationDeleteManyAlgoliaExtensionsArgs = {
  where?: InputMaybe<AlgoliaExtensionManyWhereInput>;
};


export type MutationDeleteManyAlgoliaExtensionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AlgoliaExtensionManyWhereInput>;
};


export type MutationDeleteManyAnchorNavigationListsArgs = {
  where?: InputMaybe<AnchorNavigationListManyWhereInput>;
};


export type MutationDeleteManyAnchorNavigationListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorNavigationListManyWhereInput>;
};


export type MutationDeleteManyAnchorNavigationsArgs = {
  where?: InputMaybe<AnchorNavigationManyWhereInput>;
};


export type MutationDeleteManyAnchorNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorNavigationManyWhereInput>;
};


export type MutationDeleteManyAnchorNavsArgs = {
  where?: InputMaybe<AnchorNavManyWhereInput>;
};


export type MutationDeleteManyAnchorNavsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorNavManyWhereInput>;
};


export type MutationDeleteManyAssetsArgs = {
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationDeleteManyAssetsComponentsArgs = {
  where?: InputMaybe<AssetComponentManyWhereInput>;
};


export type MutationDeleteManyAssetsComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentManyWhereInput>;
};


export type MutationDeleteManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationDeleteManyAudioComponentsArgs = {
  where?: InputMaybe<AudioComponentManyWhereInput>;
};


export type MutationDeleteManyAudioComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AudioComponentManyWhereInput>;
};


export type MutationDeleteManyAuthorableContentCardsArgs = {
  where?: InputMaybe<AuthorableContentCardManyWhereInput>;
};


export type MutationDeleteManyAuthorableContentCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuthorableContentCardManyWhereInput>;
};


export type MutationDeleteManyBanner1sArgs = {
  where?: InputMaybe<Banner1ManyWhereInput>;
};


export type MutationDeleteManyBanner1sConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Banner1ManyWhereInput>;
};


export type MutationDeleteManyBanner2CarouselComponentsArgs = {
  where?: InputMaybe<Banner2CarouselComponentManyWhereInput>;
};


export type MutationDeleteManyBanner2CarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Banner2CarouselComponentManyWhereInput>;
};


export type MutationDeleteManyBanner2SArgs = {
  where?: InputMaybe<Banner2ManyWhereInput>;
};


export type MutationDeleteManyBanner2SConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Banner2ManyWhereInput>;
};


export type MutationDeleteManyCardComponentsArgs = {
  where?: InputMaybe<CardComponentManyWhereInput>;
};


export type MutationDeleteManyCardComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardComponentManyWhereInput>;
};


export type MutationDeleteManyCarouselComponentsArgs = {
  where?: InputMaybe<CarouselComponentManyWhereInput>;
};


export type MutationDeleteManyCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselComponentManyWhereInput>;
};


export type MutationDeleteManyCarouselSlidesArgs = {
  where?: InputMaybe<CarouselSlideManyWhereInput>;
};


export type MutationDeleteManyCarouselSlidesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselSlideManyWhereInput>;
};


export type MutationDeleteManyCategoryCardsArgs = {
  where?: InputMaybe<CategoryCardManyWhereInput>;
};


export type MutationDeleteManyCategoryCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryCardManyWhereInput>;
};


export type MutationDeleteManyContactCardContainersArgs = {
  where?: InputMaybe<ContactCardContainerManyWhereInput>;
};


export type MutationDeleteManyContactCardContainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContactCardContainerManyWhereInput>;
};


export type MutationDeleteManyContactCardsArgs = {
  where?: InputMaybe<ContactCardManyWhereInput>;
};


export type MutationDeleteManyContactCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContactCardManyWhereInput>;
};


export type MutationDeleteManyCountrySelectorFootersArgs = {
  where?: InputMaybe<CountrySelectorFooterManyWhereInput>;
};


export type MutationDeleteManyCountrySelectorFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountrySelectorFooterManyWhereInput>;
};


export type MutationDeleteManyCountrySelectorItemsArgs = {
  where?: InputMaybe<CountrySelectorItemManyWhereInput>;
};


export type MutationDeleteManyCountrySelectorItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountrySelectorItemManyWhereInput>;
};


export type MutationDeleteManyDemoModelsArgs = {
  where?: InputMaybe<DemoModelManyWhereInput>;
};


export type MutationDeleteManyDemoModelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DemoModelManyWhereInput>;
};


export type MutationDeleteManyDictionariesArgs = {
  where?: InputMaybe<DictionaryManyWhereInput>;
};


export type MutationDeleteManyDictionariesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DictionaryManyWhereInput>;
};


export type MutationDeleteManyDictionaryItemsArgs = {
  where?: InputMaybe<DictionaryItemManyWhereInput>;
};


export type MutationDeleteManyDictionaryItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DictionaryItemManyWhereInput>;
};


export type MutationDeleteManyDownloadAppsArgs = {
  where?: InputMaybe<DownloadAppManyWhereInput>;
};


export type MutationDeleteManyDownloadAppsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DownloadAppManyWhereInput>;
};


export type MutationDeleteManyDynamicCardGridsArgs = {
  where?: InputMaybe<DynamicCardGridManyWhereInput>;
};


export type MutationDeleteManyDynamicCardGridsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DynamicCardGridManyWhereInput>;
};


export type MutationDeleteManyErrorPagesArgs = {
  where?: InputMaybe<ErrorPageManyWhereInput>;
};


export type MutationDeleteManyErrorPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ErrorPageManyWhereInput>;
};


export type MutationDeleteManyEvalancheFormComponentsArgs = {
  where?: InputMaybe<EvalancheFormComponentManyWhereInput>;
};


export type MutationDeleteManyEvalancheFormComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EvalancheFormComponentManyWhereInput>;
};


export type MutationDeleteManyExampleComponentsArgs = {
  where?: InputMaybe<ExampleComponentManyWhereInput>;
};


export type MutationDeleteManyExampleComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ExampleComponentManyWhereInput>;
};


export type MutationDeleteManyFeaturedContentReferencesArgs = {
  where?: InputMaybe<FeaturedContentReferenceManyWhereInput>;
};


export type MutationDeleteManyFeaturedContentReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FeaturedContentReferenceManyWhereInput>;
};


export type MutationDeleteManyFeaturedContentsArgs = {
  where?: InputMaybe<FeaturedContentManyWhereInput>;
};


export type MutationDeleteManyFeaturedContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FeaturedContentManyWhereInput>;
};


export type MutationDeleteManyFooterNavigationsArgs = {
  where?: InputMaybe<FooterNavigationManyWhereInput>;
};


export type MutationDeleteManyFooterNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FooterNavigationManyWhereInput>;
};


export type MutationDeleteManyFooterSealsArgs = {
  where?: InputMaybe<FooterSealManyWhereInput>;
};


export type MutationDeleteManyFooterSealsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FooterSealManyWhereInput>;
};


export type MutationDeleteManyFormCheckboxCollectionsArgs = {
  where?: InputMaybe<FormCheckboxCollectionManyWhereInput>;
};


export type MutationDeleteManyFormCheckboxCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormCheckboxCollectionManyWhereInput>;
};


export type MutationDeleteManyFormCheckboxesArgs = {
  where?: InputMaybe<FormCheckboxManyWhereInput>;
};


export type MutationDeleteManyFormCheckboxesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormCheckboxManyWhereInput>;
};


export type MutationDeleteManyFormDateInputsArgs = {
  where?: InputMaybe<FormDateInputManyWhereInput>;
};


export type MutationDeleteManyFormDateInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormDateInputManyWhereInput>;
};


export type MutationDeleteManyFormEmailInputsArgs = {
  where?: InputMaybe<FormEmailInputManyWhereInput>;
};


export type MutationDeleteManyFormEmailInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormEmailInputManyWhereInput>;
};


export type MutationDeleteManyFormErrorsArgs = {
  where?: InputMaybe<FormErrorManyWhereInput>;
};


export type MutationDeleteManyFormErrorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormErrorManyWhereInput>;
};


export type MutationDeleteManyFormFileUploadersArgs = {
  where?: InputMaybe<FormFileUploaderManyWhereInput>;
};


export type MutationDeleteManyFormFileUploadersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormFileUploaderManyWhereInput>;
};


export type MutationDeleteManyFormListItemsArgs = {
  where?: InputMaybe<FormListItemManyWhereInput>;
};


export type MutationDeleteManyFormListItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormListItemManyWhereInput>;
};


export type MutationDeleteManyFormListsArgs = {
  where?: InputMaybe<FormListManyWhereInput>;
};


export type MutationDeleteManyFormListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormListManyWhereInput>;
};


export type MutationDeleteManyFormNumberInputsArgs = {
  where?: InputMaybe<FormNumberInputManyWhereInput>;
};


export type MutationDeleteManyFormNumberInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormNumberInputManyWhereInput>;
};


export type MutationDeleteManyFormPasswordInputWithConfirmationsArgs = {
  where?: InputMaybe<FormPasswordInputWithConfirmationManyWhereInput>;
};


export type MutationDeleteManyFormPasswordInputWithConfirmationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormPasswordInputWithConfirmationManyWhereInput>;
};


export type MutationDeleteManyFormPasswordInputsArgs = {
  where?: InputMaybe<FormPasswordInputManyWhereInput>;
};


export type MutationDeleteManyFormPasswordInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormPasswordInputManyWhereInput>;
};


export type MutationDeleteManyFormRadioButtonCollectionsArgs = {
  where?: InputMaybe<FormRadioButtonCollectionManyWhereInput>;
};


export type MutationDeleteManyFormRadioButtonCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormRadioButtonCollectionManyWhereInput>;
};


export type MutationDeleteManyFormRadioButtonsArgs = {
  where?: InputMaybe<FormRadioButtonManyWhereInput>;
};


export type MutationDeleteManyFormRadioButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormRadioButtonManyWhereInput>;
};


export type MutationDeleteManyFormSelectComponentsArgs = {
  where?: InputMaybe<FormSelectComponentManyWhereInput>;
};


export type MutationDeleteManyFormSelectComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSelectComponentManyWhereInput>;
};


export type MutationDeleteManyFormSelectOptionsArgs = {
  where?: InputMaybe<FormSelectOptionManyWhereInput>;
};


export type MutationDeleteManyFormSelectOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSelectOptionManyWhereInput>;
};


export type MutationDeleteManyFormSubmitButtonsArgs = {
  where?: InputMaybe<FormSubmitButtonManyWhereInput>;
};


export type MutationDeleteManyFormSubmitButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSubmitButtonManyWhereInput>;
};


export type MutationDeleteManyFormSuccessComponentsArgs = {
  where?: InputMaybe<FormSuccessComponentManyWhereInput>;
};


export type MutationDeleteManyFormSuccessComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSuccessComponentManyWhereInput>;
};


export type MutationDeleteManyFormTextInputsArgs = {
  where?: InputMaybe<FormTextInputManyWhereInput>;
};


export type MutationDeleteManyFormTextInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormTextInputManyWhereInput>;
};


export type MutationDeleteManyFormTextareaInputsArgs = {
  where?: InputMaybe<FormTextareaInputManyWhereInput>;
};


export type MutationDeleteManyFormTextareaInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormTextareaInputManyWhereInput>;
};


export type MutationDeleteManyFormsArgs = {
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationDeleteManyFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationDeleteManyGenericAccordionItemsArgs = {
  where?: InputMaybe<GenericAccordionItemManyWhereInput>;
};


export type MutationDeleteManyGenericAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionItemManyWhereInput>;
};


export type MutationDeleteManyGenericAccordionTopRatedsArgs = {
  where?: InputMaybe<GenericAccordionTopRatedManyWhereInput>;
};


export type MutationDeleteManyGenericAccordionTopRatedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionTopRatedManyWhereInput>;
};


export type MutationDeleteManyGenericAccordionsArgs = {
  where?: InputMaybe<GenericAccordionManyWhereInput>;
};


export type MutationDeleteManyGenericAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionManyWhereInput>;
};


export type MutationDeleteManyGenericCardCarouseComponentsArgs = {
  where?: InputMaybe<GenericCardCarouseComponentManyWhereInput>;
};


export type MutationDeleteManyGenericCardCarouseComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericCardCarouseComponentManyWhereInput>;
};


export type MutationDeleteManyGenericDownloadComponentsArgs = {
  where?: InputMaybe<GenericDownloadComponentManyWhereInput>;
};


export type MutationDeleteManyGenericDownloadComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericDownloadComponentManyWhereInput>;
};


export type MutationDeleteManyGenericFollowUsesArgs = {
  where?: InputMaybe<GenericFollowUsManyWhereInput>;
};


export type MutationDeleteManyGenericFollowUsesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericFollowUsManyWhereInput>;
};


export type MutationDeleteManyGenericGridAuthorablesArgs = {
  where?: InputMaybe<GenericGridAuthorableManyWhereInput>;
};


export type MutationDeleteManyGenericGridAuthorablesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericGridAuthorableManyWhereInput>;
};


export type MutationDeleteManyGenericHtmlsArgs = {
  where?: InputMaybe<GenericHtmlManyWhereInput>;
};


export type MutationDeleteManyGenericHtmlsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericHtmlManyWhereInput>;
};


export type MutationDeleteManyGenericLinesArgs = {
  where?: InputMaybe<GenericLineManyWhereInput>;
};


export type MutationDeleteManyGenericLinesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericLineManyWhereInput>;
};


export type MutationDeleteManyGenericLinksArgs = {
  where?: InputMaybe<GenericLinkManyWhereInput>;
};


export type MutationDeleteManyGenericLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericLinkManyWhereInput>;
};


export type MutationDeleteManyGenericPagesArgs = {
  where?: InputMaybe<GenericPageManyWhereInput>;
};


export type MutationDeleteManyGenericPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageManyWhereInput>;
};


export type MutationDeleteManyGenericPromotionsOverviewsArgs = {
  where?: InputMaybe<GenericPromotionsOverviewManyWhereInput>;
};


export type MutationDeleteManyGenericPromotionsOverviewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPromotionsOverviewManyWhereInput>;
};


export type MutationDeleteManyGenericQualifioOverviewsArgs = {
  where?: InputMaybe<GenericQualifioOverviewManyWhereInput>;
};


export type MutationDeleteManyGenericQualifioOverviewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericQualifioOverviewManyWhereInput>;
};


export type MutationDeleteManyGenericQualifiosArgs = {
  where?: InputMaybe<GenericQualifioManyWhereInput>;
};


export type MutationDeleteManyGenericQualifiosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericQualifioManyWhereInput>;
};


export type MutationDeleteManyGenericSocialSharesArgs = {
  where?: InputMaybe<GenericSocialShareManyWhereInput>;
};


export type MutationDeleteManyGenericSocialSharesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericSocialShareManyWhereInput>;
};


export type MutationDeleteManyGlobalMetaDatasArgs = {
  where?: InputMaybe<GlobalMetaDataManyWhereInput>;
};


export type MutationDeleteManyGlobalMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GlobalMetaDataManyWhereInput>;
};


export type MutationDeleteManyGlobalSearchesArgs = {
  where?: InputMaybe<GlobalSearchManyWhereInput>;
};


export type MutationDeleteManyGlobalSearchesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GlobalSearchManyWhereInput>;
};


export type MutationDeleteManyGridColumnComponentsArgs = {
  where?: InputMaybe<GridColumnComponentManyWhereInput>;
};


export type MutationDeleteManyGridColumnComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GridColumnComponentManyWhereInput>;
};


export type MutationDeleteManyGridColumnsArgs = {
  where?: InputMaybe<GridColumnManyWhereInput>;
};


export type MutationDeleteManyGridColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GridColumnManyWhereInput>;
};


export type MutationDeleteManyHeroBannerMasterbrandsArgs = {
  where?: InputMaybe<HeroBannerMasterbrandManyWhereInput>;
};


export type MutationDeleteManyHeroBannerMasterbrandsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroBannerMasterbrandManyWhereInput>;
};


export type MutationDeleteManyHeroBannersArgs = {
  where?: InputMaybe<HeroBannerManyWhereInput>;
};


export type MutationDeleteManyHeroBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroBannerManyWhereInput>;
};


export type MutationDeleteManyHeroCarouselComponentsArgs = {
  where?: InputMaybe<HeroCarouselComponentManyWhereInput>;
};


export type MutationDeleteManyHeroCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroCarouselComponentManyWhereInput>;
};


export type MutationDeleteManyHeroComponentsArgs = {
  where?: InputMaybe<HeroComponentManyWhereInput>;
};


export type MutationDeleteManyHeroComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroComponentManyWhereInput>;
};


export type MutationDeleteManyHeroLoopAnimationComponentsArgs = {
  where?: InputMaybe<HeroLoopAnimationComponentManyWhereInput>;
};


export type MutationDeleteManyHeroLoopAnimationComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroLoopAnimationComponentManyWhereInput>;
};


export type MutationDeleteManyIframesArgs = {
  where?: InputMaybe<IframeManyWhereInput>;
};


export type MutationDeleteManyIframesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IframeManyWhereInput>;
};


export type MutationDeleteManyImageAndTextCardsArgs = {
  where?: InputMaybe<ImageAndTextCardManyWhereInput>;
};


export type MutationDeleteManyImageAndTextCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageAndTextCardManyWhereInput>;
};


export type MutationDeleteManyImageCopiesArgs = {
  where?: InputMaybe<ImageCopyManyWhereInput>;
};


export type MutationDeleteManyImageCopiesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageCopyManyWhereInput>;
};


export type MutationDeleteManyImageCopyItemsArgs = {
  where?: InputMaybe<ImageCopyItemManyWhereInput>;
};


export type MutationDeleteManyImageCopyItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageCopyItemManyWhereInput>;
};


export type MutationDeleteManyIntroTextsArgs = {
  where?: InputMaybe<IntroTextManyWhereInput>;
};


export type MutationDeleteManyIntroTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IntroTextManyWhereInput>;
};


export type MutationDeleteManyLeftColumnsArgs = {
  where?: InputMaybe<LeftColumnManyWhereInput>;
};


export type MutationDeleteManyLeftColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LeftColumnManyWhereInput>;
};


export type MutationDeleteManyLinksArgs = {
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationDeleteManyLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationDeleteManyLongTextsArgs = {
  where?: InputMaybe<LongTextManyWhereInput>;
};


export type MutationDeleteManyLongTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LongTextManyWhereInput>;
};


export type MutationDeleteManyMarketUserConnectionsArgs = {
  where?: InputMaybe<MarketUserConnectionManyWhereInput>;
};


export type MutationDeleteManyMarketUserConnectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MarketUserConnectionManyWhereInput>;
};


export type MutationDeleteManyMarketsArgs = {
  where?: InputMaybe<MarketManyWhereInput>;
};


export type MutationDeleteManyMarketsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MarketManyWhereInput>;
};


export type MutationDeleteManyMetaDatasArgs = {
  where?: InputMaybe<MetaDataManyWhereInput>;
};


export type MutationDeleteManyMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetaDataManyWhereInput>;
};


export type MutationDeleteManyMobileOnlyMainNavigationsArgs = {
  where?: InputMaybe<MobileOnlyMainNavigationManyWhereInput>;
};


export type MutationDeleteManyMobileOnlyMainNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MobileOnlyMainNavigationManyWhereInput>;
};


export type MutationDeleteManyMultiStepPromotionFormsArgs = {
  where?: InputMaybe<MultiStepPromotionFormManyWhereInput>;
};


export type MutationDeleteManyMultiStepPromotionFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MultiStepPromotionFormManyWhereInput>;
};


export type MutationDeleteManyNavigationItemsArgs = {
  where?: InputMaybe<NavigationItemManyWhereInput>;
};


export type MutationDeleteManyNavigationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationItemManyWhereInput>;
};


export type MutationDeleteManyNavigationsArgs = {
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationDeleteManyNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationDeleteManyNewsletterComponentsArgs = {
  where?: InputMaybe<NewsletterComponentManyWhereInput>;
};


export type MutationDeleteManyNewsletterComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NewsletterComponentManyWhereInput>;
};


export type MutationDeleteManyNewsletterSubscriptionsPluralArgs = {
  where?: InputMaybe<NewsletterSubscriptionsManyWhereInput>;
};


export type MutationDeleteManyNewsletterSubscriptionsPluralConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NewsletterSubscriptionsManyWhereInput>;
};


export type MutationDeleteManyNotificationBannersArgs = {
  where?: InputMaybe<NotificationBannerManyWhereInput>;
};


export type MutationDeleteManyNotificationBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationBannerManyWhereInput>;
};


export type MutationDeleteManyPageFootersArgs = {
  where?: InputMaybe<PageFooterManyWhereInput>;
};


export type MutationDeleteManyPageFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageFooterManyWhereInput>;
};


export type MutationDeleteManyPageHeadersArgs = {
  where?: InputMaybe<PageHeaderManyWhereInput>;
};


export type MutationDeleteManyPageHeadersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageHeaderManyWhereInput>;
};


export type MutationDeleteManyPopularSearchComponentsArgs = {
  where?: InputMaybe<PopularSearchComponentManyWhereInput>;
};


export type MutationDeleteManyPopularSearchComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PopularSearchComponentManyWhereInput>;
};


export type MutationDeleteManyProductBannersArgs = {
  where?: InputMaybe<ProductBannerManyWhereInput>;
};


export type MutationDeleteManyProductBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductBannerManyWhereInput>;
};


export type MutationDeleteManyProductCategoriesArgs = {
  where?: InputMaybe<ProductCategoryManyWhereInput>;
};


export type MutationDeleteManyProductCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryManyWhereInput>;
};


export type MutationDeleteManyProductCategoryPagesArgs = {
  where?: InputMaybe<ProductCategoryPageManyWhereInput>;
};


export type MutationDeleteManyProductCategoryPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageManyWhereInput>;
};


export type MutationDeleteManyProductDetailPagesArgs = {
  where?: InputMaybe<ProductDetailPageManyWhereInput>;
};


export type MutationDeleteManyProductDetailPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductDetailPageManyWhereInput>;
};


export type MutationDeleteManyProductHeroesArgs = {
  where?: InputMaybe<ProductHeroManyWhereInput>;
};


export type MutationDeleteManyProductHeroesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductHeroManyWhereInput>;
};


export type MutationDeleteManyProductLabelsArgs = {
  where?: InputMaybe<ProductLabelManyWhereInput>;
};


export type MutationDeleteManyProductLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLabelManyWhereInput>;
};


export type MutationDeleteManyProductLandingPagesArgs = {
  where?: InputMaybe<ProductLandingPageManyWhereInput>;
};


export type MutationDeleteManyProductLandingPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageManyWhereInput>;
};


export type MutationDeleteManyProductSubcategoryPagesArgs = {
  where?: InputMaybe<ProductSubcategoryPageManyWhereInput>;
};


export type MutationDeleteManyProductSubcategoryPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageManyWhereInput>;
};


export type MutationDeleteManyProductsArgs = {
  where?: InputMaybe<ProductManyWhereInput>;
};


export type MutationDeleteManyProductsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductManyWhereInput>;
};


export type MutationDeleteManyPromotionDownloadsArgs = {
  where?: InputMaybe<PromotionDownloadManyWhereInput>;
};


export type MutationDeleteManyPromotionDownloadsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PromotionDownloadManyWhereInput>;
};


export type MutationDeleteManyPromotionFormsArgs = {
  where?: InputMaybe<PromotionFormManyWhereInput>;
};


export type MutationDeleteManyPromotionFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PromotionFormManyWhereInput>;
};


export type MutationDeleteManyQuestionCheckboxCollectionsArgs = {
  where?: InputMaybe<QuestionCheckboxCollectionManyWhereInput>;
};


export type MutationDeleteManyQuestionCheckboxCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionCheckboxCollectionManyWhereInput>;
};


export type MutationDeleteManyQuestionCheckboxesArgs = {
  where?: InputMaybe<QuestionCheckboxManyWhereInput>;
};


export type MutationDeleteManyQuestionCheckboxesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionCheckboxManyWhereInput>;
};


export type MutationDeleteManyQuestionRadioButtonCollectionsArgs = {
  where?: InputMaybe<QuestionRadioButtonCollectionManyWhereInput>;
};


export type MutationDeleteManyQuestionRadioButtonCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionRadioButtonCollectionManyWhereInput>;
};


export type MutationDeleteManyQuestionRadioButtonsArgs = {
  where?: InputMaybe<QuestionRadioButtonManyWhereInput>;
};


export type MutationDeleteManyQuestionRadioButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionRadioButtonManyWhereInput>;
};


export type MutationDeleteManyQuestionsArgs = {
  where?: InputMaybe<QuestionManyWhereInput>;
};


export type MutationDeleteManyQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionManyWhereInput>;
};


export type MutationDeleteManyRatingsArgs = {
  where?: InputMaybe<RatingManyWhereInput>;
};


export type MutationDeleteManyRatingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RatingManyWhereInput>;
};


export type MutationDeleteManyRecipeCategoriesArgs = {
  where?: InputMaybe<RecipeCategoryManyWhereInput>;
};


export type MutationDeleteManyRecipeCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryManyWhereInput>;
};


export type MutationDeleteManyRecipeLandingPagesArgs = {
  where?: InputMaybe<RecipeLandingPageManyWhereInput>;
};


export type MutationDeleteManyRecipeLandingPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageManyWhereInput>;
};


export type MutationDeleteManyRecipeSubcategoriesArgs = {
  where?: InputMaybe<RecipeSubcategoryManyWhereInput>;
};


export type MutationDeleteManyRecipeSubcategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryManyWhereInput>;
};


export type MutationDeleteManyRecipesArgs = {
  where?: InputMaybe<RecipeManyWhereInput>;
};


export type MutationDeleteManyRecipesComparisonQueryComponentsArgs = {
  where?: InputMaybe<RecipesComparisonQueryComponentManyWhereInput>;
};


export type MutationDeleteManyRecipesComparisonQueryComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipesComparisonQueryComponentManyWhereInput>;
};


export type MutationDeleteManyRecipesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeManyWhereInput>;
};


export type MutationDeleteManyRecipesQueriesReferencesArgs = {
  where?: InputMaybe<RecipesQueriesReferenceManyWhereInput>;
};


export type MutationDeleteManyRecipesQueriesReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipesQueriesReferenceManyWhereInput>;
};


export type MutationDeleteManyRecipesQueryComponentsArgs = {
  where?: InputMaybe<RecipesQueryComponentManyWhereInput>;
};


export type MutationDeleteManyRecipesQueryComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipesQueryComponentManyWhereInput>;
};


export type MutationDeleteManyRedirectsArgs = {
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationDeleteManyRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationDeleteManyRewritesArgs = {
  where?: InputMaybe<RewriteManyWhereInput>;
};


export type MutationDeleteManyRewritesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RewriteManyWhereInput>;
};


export type MutationDeleteManyRightColumnsArgs = {
  where?: InputMaybe<RightColumnManyWhereInput>;
};


export type MutationDeleteManyRightColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RightColumnManyWhereInput>;
};


export type MutationDeleteManySearchInputsArgs = {
  where?: InputMaybe<SearchInputManyWhereInput>;
};


export type MutationDeleteManySearchInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SearchInputManyWhereInput>;
};


export type MutationDeleteManySearchOverlayComponentsArgs = {
  where?: InputMaybe<SearchOverlayComponentManyWhereInput>;
};


export type MutationDeleteManySearchOverlayComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SearchOverlayComponentManyWhereInput>;
};


export type MutationDeleteManySearchResultPagesArgs = {
  where?: InputMaybe<SearchResultPageManyWhereInput>;
};


export type MutationDeleteManySearchResultPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SearchResultPageManyWhereInput>;
};


export type MutationDeleteManySeparatorsArgs = {
  where?: InputMaybe<SeparatorManyWhereInput>;
};


export type MutationDeleteManySeparatorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SeparatorManyWhereInput>;
};


export type MutationDeleteManySingleStepPromotionFormsArgs = {
  where?: InputMaybe<SingleStepPromotionFormManyWhereInput>;
};


export type MutationDeleteManySingleStepPromotionFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SingleStepPromotionFormManyWhereInput>;
};


export type MutationDeleteManySocialMediaListComponentsArgs = {
  where?: InputMaybe<SocialMediaListComponentManyWhereInput>;
};


export type MutationDeleteManySocialMediaListComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SocialMediaListComponentManyWhereInput>;
};


export type MutationDeleteManySpacersArgs = {
  where?: InputMaybe<SpacerManyWhereInput>;
};


export type MutationDeleteManySpacersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpacerManyWhereInput>;
};


export type MutationDeleteManySubCategoryKeyImagesArgs = {
  where?: InputMaybe<SubCategoryKeyImageManyWhereInput>;
};


export type MutationDeleteManySubCategoryKeyImagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubCategoryKeyImageManyWhereInput>;
};


export type MutationDeleteManySubTabsArgs = {
  where?: InputMaybe<SubTabManyWhereInput>;
};


export type MutationDeleteManySubTabsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubTabManyWhereInput>;
};


export type MutationDeleteManySubTabsContentArgs = {
  where?: InputMaybe<SubTabContentManyWhereInput>;
};


export type MutationDeleteManySubTabsContentConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubTabContentManyWhereInput>;
};


export type MutationDeleteManySustainabilityBannersArgs = {
  where?: InputMaybe<SustainabilityBannerManyWhereInput>;
};


export type MutationDeleteManySustainabilityBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SustainabilityBannerManyWhereInput>;
};


export type MutationDeleteManySustainabilityInfosArgs = {
  where?: InputMaybe<SustainabilityInfoManyWhereInput>;
};


export type MutationDeleteManySustainabilityInfosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SustainabilityInfoManyWhereInput>;
};


export type MutationDeleteManyTabContentsArgs = {
  where?: InputMaybe<TabContentManyWhereInput>;
};


export type MutationDeleteManyTabContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabContentManyWhereInput>;
};


export type MutationDeleteManyTabsArgs = {
  where?: InputMaybe<TabManyWhereInput>;
};


export type MutationDeleteManyTabsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabManyWhereInput>;
};


export type MutationDeleteManyTeaserPlaceholdersArgs = {
  where?: InputMaybe<TeaserPlaceholderManyWhereInput>;
};


export type MutationDeleteManyTeaserPlaceholdersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserPlaceholderManyWhereInput>;
};


export type MutationDeleteManyTeaserSmallPlaceholdersArgs = {
  where?: InputMaybe<TeaserSmallPlaceholderManyWhereInput>;
};


export type MutationDeleteManyTeaserSmallPlaceholdersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallPlaceholderManyWhereInput>;
};


export type MutationDeleteManyTeaserSmallsArgs = {
  where?: InputMaybe<TeaserSmallManyWhereInput>;
};


export type MutationDeleteManyTeaserSmallsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallManyWhereInput>;
};


export type MutationDeleteManyTeasersArgs = {
  where?: InputMaybe<TeaserManyWhereInput>;
};


export type MutationDeleteManyTeasersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserManyWhereInput>;
};


export type MutationDeleteManyTestComponentWithRecipeQueriesArgs = {
  where?: InputMaybe<TestComponentWithRecipeQueryManyWhereInput>;
};


export type MutationDeleteManyTestComponentWithRecipeQueriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TestComponentWithRecipeQueryManyWhereInput>;
};


export type MutationDeleteManyTestTipsANdTricksInAMarketsArgs = {
  where?: InputMaybe<TestTipsANdTricksInAMarketManyWhereInput>;
};


export type MutationDeleteManyTestTipsANdTricksInAMarketsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TestTipsANdTricksInAMarketManyWhereInput>;
};


export type MutationDeleteManyTextComponentsArgs = {
  where?: InputMaybe<TextComponentManyWhereInput>;
};


export type MutationDeleteManyTextComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TextComponentManyWhereInput>;
};


export type MutationDeleteManyTipsAndTricksDetailsPagesArgs = {
  where?: InputMaybe<TipsAndTricksDetailsPageManyWhereInput>;
};


export type MutationDeleteManyTipsAndTricksDetailsPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TipsAndTricksDetailsPageManyWhereInput>;
};


export type MutationDeleteManyTitlesArgs = {
  where?: InputMaybe<TitleManyWhereInput>;
};


export type MutationDeleteManyTitlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TitleManyWhereInput>;
};


export type MutationDeleteManyTwitterSeosArgs = {
  where?: InputMaybe<TwitterSeoManyWhereInput>;
};


export type MutationDeleteManyTwitterSeosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TwitterSeoManyWhereInput>;
};


export type MutationDeleteMarketArgs = {
  where: MarketWhereUniqueInput;
};


export type MutationDeleteMarketUserConnectionArgs = {
  where: MarketUserConnectionWhereUniqueInput;
};


export type MutationDeleteMetaDataArgs = {
  where: MetaDataWhereUniqueInput;
};


export type MutationDeleteMobileOnlyMainNavigationArgs = {
  where: MobileOnlyMainNavigationWhereUniqueInput;
};


export type MutationDeleteMultiStepPromotionFormArgs = {
  where: MultiStepPromotionFormWhereUniqueInput;
};


export type MutationDeleteNavigationArgs = {
  where: NavigationWhereUniqueInput;
};


export type MutationDeleteNavigationItemArgs = {
  where: NavigationItemWhereUniqueInput;
};


export type MutationDeleteNewsletterComponentArgs = {
  where: NewsletterComponentWhereUniqueInput;
};


export type MutationDeleteNewsletterSubscriptionsArgs = {
  where: NewsletterSubscriptionsWhereUniqueInput;
};


export type MutationDeleteNotificationBannerArgs = {
  where: NotificationBannerWhereUniqueInput;
};


export type MutationDeletePageFooterArgs = {
  where: PageFooterWhereUniqueInput;
};


export type MutationDeletePageHeaderArgs = {
  where: PageHeaderWhereUniqueInput;
};


export type MutationDeletePopularSearchComponentArgs = {
  where: PopularSearchComponentWhereUniqueInput;
};


export type MutationDeleteProductArgs = {
  where: ProductWhereUniqueInput;
};


export type MutationDeleteProductBannerArgs = {
  where: ProductBannerWhereUniqueInput;
};


export type MutationDeleteProductCategoryArgs = {
  where: ProductCategoryWhereUniqueInput;
};


export type MutationDeleteProductCategoryPageArgs = {
  where: ProductCategoryPageWhereUniqueInput;
};


export type MutationDeleteProductDetailPageArgs = {
  where: ProductDetailPageWhereUniqueInput;
};


export type MutationDeleteProductHeroArgs = {
  where: ProductHeroWhereUniqueInput;
};


export type MutationDeleteProductLabelArgs = {
  where: ProductLabelWhereUniqueInput;
};


export type MutationDeleteProductLandingPageArgs = {
  where: ProductLandingPageWhereUniqueInput;
};


export type MutationDeleteProductSubcategoryPageArgs = {
  where: ProductSubcategoryPageWhereUniqueInput;
};


export type MutationDeletePromotionDownloadArgs = {
  where: PromotionDownloadWhereUniqueInput;
};


export type MutationDeletePromotionFormArgs = {
  where: PromotionFormWhereUniqueInput;
};


export type MutationDeleteQuestionArgs = {
  where: QuestionWhereUniqueInput;
};


export type MutationDeleteQuestionCheckboxArgs = {
  where: QuestionCheckboxWhereUniqueInput;
};


export type MutationDeleteQuestionCheckboxCollectionArgs = {
  where: QuestionCheckboxCollectionWhereUniqueInput;
};


export type MutationDeleteQuestionRadioButtonArgs = {
  where: QuestionRadioButtonWhereUniqueInput;
};


export type MutationDeleteQuestionRadioButtonCollectionArgs = {
  where: QuestionRadioButtonCollectionWhereUniqueInput;
};


export type MutationDeleteRatingArgs = {
  where: RatingWhereUniqueInput;
};


export type MutationDeleteRecipeArgs = {
  where: RecipeWhereUniqueInput;
};


export type MutationDeleteRecipeCategoryArgs = {
  where: RecipeCategoryWhereUniqueInput;
};


export type MutationDeleteRecipeLandingPageArgs = {
  where: RecipeLandingPageWhereUniqueInput;
};


export type MutationDeleteRecipeSubcategoryArgs = {
  where: RecipeSubcategoryWhereUniqueInput;
};


export type MutationDeleteRecipesComparisonQueryComponentArgs = {
  where: RecipesComparisonQueryComponentWhereUniqueInput;
};


export type MutationDeleteRecipesQueriesReferenceArgs = {
  where: RecipesQueriesReferenceWhereUniqueInput;
};


export type MutationDeleteRecipesQueryComponentArgs = {
  where: RecipesQueryComponentWhereUniqueInput;
};


export type MutationDeleteRedirectArgs = {
  where: RedirectWhereUniqueInput;
};


export type MutationDeleteRewriteArgs = {
  where: RewriteWhereUniqueInput;
};


export type MutationDeleteRightColumnArgs = {
  where: RightColumnWhereUniqueInput;
};


export type MutationDeleteScheduledOperationArgs = {
  where: ScheduledOperationWhereUniqueInput;
};


export type MutationDeleteScheduledReleaseArgs = {
  where: ScheduledReleaseWhereUniqueInput;
};


export type MutationDeleteSearchInputArgs = {
  where: SearchInputWhereUniqueInput;
};


export type MutationDeleteSearchOverlayComponentArgs = {
  where: SearchOverlayComponentWhereUniqueInput;
};


export type MutationDeleteSearchResultPageArgs = {
  where: SearchResultPageWhereUniqueInput;
};


export type MutationDeleteSeparatorArgs = {
  where: SeparatorWhereUniqueInput;
};


export type MutationDeleteSingleStepPromotionFormArgs = {
  where: SingleStepPromotionFormWhereUniqueInput;
};


export type MutationDeleteSocialMediaListComponentArgs = {
  where: SocialMediaListComponentWhereUniqueInput;
};


export type MutationDeleteSpacerArgs = {
  where: SpacerWhereUniqueInput;
};


export type MutationDeleteSubCategoryKeyImageArgs = {
  where: SubCategoryKeyImageWhereUniqueInput;
};


export type MutationDeleteSubTabArgs = {
  where: SubTabWhereUniqueInput;
};


export type MutationDeleteSubTabContentArgs = {
  where: SubTabContentWhereUniqueInput;
};


export type MutationDeleteSustainabilityBannerArgs = {
  where: SustainabilityBannerWhereUniqueInput;
};


export type MutationDeleteSustainabilityInfoArgs = {
  where: SustainabilityInfoWhereUniqueInput;
};


export type MutationDeleteTabArgs = {
  where: TabWhereUniqueInput;
};


export type MutationDeleteTabContentArgs = {
  where: TabContentWhereUniqueInput;
};


export type MutationDeleteTeaserArgs = {
  where: TeaserWhereUniqueInput;
};


export type MutationDeleteTeaserPlaceholderArgs = {
  where: TeaserPlaceholderWhereUniqueInput;
};


export type MutationDeleteTeaserSmallArgs = {
  where: TeaserSmallWhereUniqueInput;
};


export type MutationDeleteTeaserSmallPlaceholderArgs = {
  where: TeaserSmallPlaceholderWhereUniqueInput;
};


export type MutationDeleteTestComponentWithRecipeQueryArgs = {
  where: TestComponentWithRecipeQueryWhereUniqueInput;
};


export type MutationDeleteTestTipsANdTricksInAMarketArgs = {
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};


export type MutationDeleteTextComponentArgs = {
  where: TextComponentWhereUniqueInput;
};


export type MutationDeleteTipsAndTricksDetailsPageArgs = {
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};


export type MutationDeleteTitleArgs = {
  where: TitleWhereUniqueInput;
};


export type MutationDeleteTwitterSeoArgs = {
  where: TwitterSeoWhereUniqueInput;
};


export type MutationPublishAccordionArgs = {
  to?: Array<Stage>;
  where: AccordionWhereUniqueInput;
};


export type MutationPublishAccordionItemArgs = {
  to?: Array<Stage>;
  where: AccordionItemWhereUniqueInput;
};


export type MutationPublishAlgoliaExtensionArgs = {
  to?: Array<Stage>;
  where: AlgoliaExtensionWhereUniqueInput;
};


export type MutationPublishAnchorNavArgs = {
  to?: Array<Stage>;
  where: AnchorNavWhereUniqueInput;
};


export type MutationPublishAnchorNavigationArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: AnchorNavigationWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishAnchorNavigationListArgs = {
  to?: Array<Stage>;
  where: AnchorNavigationListWhereUniqueInput;
};


export type MutationPublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishAssetComponentArgs = {
  to?: Array<Stage>;
  where: AssetComponentWhereUniqueInput;
};


export type MutationPublishAudioComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: AudioComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishAuthorableContentCardArgs = {
  to?: Array<Stage>;
  where: AuthorableContentCardWhereUniqueInput;
};


export type MutationPublishBanner1Args = {
  to?: Array<Stage>;
  where: Banner1WhereUniqueInput;
};


export type MutationPublishBanner2Args = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: Banner2WhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishBanner2CarouselComponentArgs = {
  to?: Array<Stage>;
  where: Banner2CarouselComponentWhereUniqueInput;
};


export type MutationPublishCardComponentArgs = {
  to?: Array<Stage>;
  where: CardComponentWhereUniqueInput;
};


export type MutationPublishCarouselComponentArgs = {
  to?: Array<Stage>;
  where: CarouselComponentWhereUniqueInput;
};


export type MutationPublishCarouselSlideArgs = {
  to?: Array<Stage>;
  where: CarouselSlideWhereUniqueInput;
};


export type MutationPublishCategoryCardArgs = {
  to?: Array<Stage>;
  where: CategoryCardWhereUniqueInput;
};


export type MutationPublishContactCardArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: ContactCardWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishContactCardContainerArgs = {
  to?: Array<Stage>;
  where: ContactCardContainerWhereUniqueInput;
};


export type MutationPublishCountrySelectorFooterArgs = {
  to?: Array<Stage>;
  where: CountrySelectorFooterWhereUniqueInput;
};


export type MutationPublishCountrySelectorItemArgs = {
  to?: Array<Stage>;
  where: CountrySelectorItemWhereUniqueInput;
};


export type MutationPublishDemoModelArgs = {
  to?: Array<Stage>;
  where: DemoModelWhereUniqueInput;
};


export type MutationPublishDictionaryArgs = {
  to?: Array<Stage>;
  where: DictionaryWhereUniqueInput;
};


export type MutationPublishDictionaryItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: DictionaryItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishDownloadAppArgs = {
  to?: Array<Stage>;
  where: DownloadAppWhereUniqueInput;
};


export type MutationPublishDynamicCardGridArgs = {
  to?: Array<Stage>;
  where: DynamicCardGridWhereUniqueInput;
};


export type MutationPublishErrorPageArgs = {
  to?: Array<Stage>;
  where: ErrorPageWhereUniqueInput;
};


export type MutationPublishEvalancheFormComponentArgs = {
  to?: Array<Stage>;
  where: EvalancheFormComponentWhereUniqueInput;
};


export type MutationPublishExampleComponentArgs = {
  to?: Array<Stage>;
  where: ExampleComponentWhereUniqueInput;
};


export type MutationPublishFeaturedContentArgs = {
  to?: Array<Stage>;
  where: FeaturedContentWhereUniqueInput;
};


export type MutationPublishFeaturedContentReferenceArgs = {
  to?: Array<Stage>;
  where: FeaturedContentReferenceWhereUniqueInput;
};


export type MutationPublishFooterNavigationArgs = {
  to?: Array<Stage>;
  where: FooterNavigationWhereUniqueInput;
};


export type MutationPublishFooterSealArgs = {
  to?: Array<Stage>;
  where: FooterSealWhereUniqueInput;
};


export type MutationPublishFormArgs = {
  to?: Array<Stage>;
  where: FormWhereUniqueInput;
};


export type MutationPublishFormCheckboxArgs = {
  to?: Array<Stage>;
  where: FormCheckboxWhereUniqueInput;
};


export type MutationPublishFormCheckboxCollectionArgs = {
  to?: Array<Stage>;
  where: FormCheckboxCollectionWhereUniqueInput;
};


export type MutationPublishFormDateInputArgs = {
  to?: Array<Stage>;
  where: FormDateInputWhereUniqueInput;
};


export type MutationPublishFormEmailInputArgs = {
  to?: Array<Stage>;
  where: FormEmailInputWhereUniqueInput;
};


export type MutationPublishFormErrorArgs = {
  to?: Array<Stage>;
  where: FormErrorWhereUniqueInput;
};


export type MutationPublishFormFileUploaderArgs = {
  to?: Array<Stage>;
  where: FormFileUploaderWhereUniqueInput;
};


export type MutationPublishFormListArgs = {
  to?: Array<Stage>;
  where: FormListWhereUniqueInput;
};


export type MutationPublishFormListItemArgs = {
  to?: Array<Stage>;
  where: FormListItemWhereUniqueInput;
};


export type MutationPublishFormNumberInputArgs = {
  to?: Array<Stage>;
  where: FormNumberInputWhereUniqueInput;
};


export type MutationPublishFormPasswordInputArgs = {
  to?: Array<Stage>;
  where: FormPasswordInputWhereUniqueInput;
};


export type MutationPublishFormPasswordInputWithConfirmationArgs = {
  to?: Array<Stage>;
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};


export type MutationPublishFormRadioButtonArgs = {
  to?: Array<Stage>;
  where: FormRadioButtonWhereUniqueInput;
};


export type MutationPublishFormRadioButtonCollectionArgs = {
  to?: Array<Stage>;
  where: FormRadioButtonCollectionWhereUniqueInput;
};


export type MutationPublishFormSelectComponentArgs = {
  to?: Array<Stage>;
  where: FormSelectComponentWhereUniqueInput;
};


export type MutationPublishFormSelectOptionArgs = {
  to?: Array<Stage>;
  where: FormSelectOptionWhereUniqueInput;
};


export type MutationPublishFormSubmitButtonArgs = {
  to?: Array<Stage>;
  where: FormSubmitButtonWhereUniqueInput;
};


export type MutationPublishFormSuccessComponentArgs = {
  to?: Array<Stage>;
  where: FormSuccessComponentWhereUniqueInput;
};


export type MutationPublishFormTextInputArgs = {
  to?: Array<Stage>;
  where: FormTextInputWhereUniqueInput;
};


export type MutationPublishFormTextareaInputArgs = {
  to?: Array<Stage>;
  where: FormTextareaInputWhereUniqueInput;
};


export type MutationPublishGenericAccordionArgs = {
  to?: Array<Stage>;
  where: GenericAccordionWhereUniqueInput;
};


export type MutationPublishGenericAccordionItemArgs = {
  to?: Array<Stage>;
  where: GenericAccordionItemWhereUniqueInput;
};


export type MutationPublishGenericAccordionTopRatedArgs = {
  to?: Array<Stage>;
  where: GenericAccordionTopRatedWhereUniqueInput;
};


export type MutationPublishGenericCardCarouseComponentArgs = {
  to?: Array<Stage>;
  where: GenericCardCarouseComponentWhereUniqueInput;
};


export type MutationPublishGenericDownloadComponentArgs = {
  to?: Array<Stage>;
  where: GenericDownloadComponentWhereUniqueInput;
};


export type MutationPublishGenericFollowUsArgs = {
  to?: Array<Stage>;
  where: GenericFollowUsWhereUniqueInput;
};


export type MutationPublishGenericGridAuthorableArgs = {
  to?: Array<Stage>;
  where: GenericGridAuthorableWhereUniqueInput;
};


export type MutationPublishGenericHtmlArgs = {
  to?: Array<Stage>;
  where: GenericHtmlWhereUniqueInput;
};


export type MutationPublishGenericLineArgs = {
  to?: Array<Stage>;
  where: GenericLineWhereUniqueInput;
};


export type MutationPublishGenericLinkArgs = {
  to?: Array<Stage>;
  where: GenericLinkWhereUniqueInput;
};


export type MutationPublishGenericPageArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: GenericPageWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishGenericPromotionsOverviewArgs = {
  to?: Array<Stage>;
  where: GenericPromotionsOverviewWhereUniqueInput;
};


export type MutationPublishGenericQualifioArgs = {
  to?: Array<Stage>;
  where: GenericQualifioWhereUniqueInput;
};


export type MutationPublishGenericQualifioOverviewArgs = {
  to?: Array<Stage>;
  where: GenericQualifioOverviewWhereUniqueInput;
};


export type MutationPublishGenericSocialShareArgs = {
  to?: Array<Stage>;
  where: GenericSocialShareWhereUniqueInput;
};


export type MutationPublishGlobalMetaDataArgs = {
  to?: Array<Stage>;
  where: GlobalMetaDataWhereUniqueInput;
};


export type MutationPublishGlobalSearchArgs = {
  to?: Array<Stage>;
  where: GlobalSearchWhereUniqueInput;
};


export type MutationPublishGridColumnArgs = {
  to?: Array<Stage>;
  where: GridColumnWhereUniqueInput;
};


export type MutationPublishGridColumnComponentArgs = {
  to?: Array<Stage>;
  where: GridColumnComponentWhereUniqueInput;
};


export type MutationPublishHeroBannerArgs = {
  to?: Array<Stage>;
  where: HeroBannerWhereUniqueInput;
};


export type MutationPublishHeroBannerMasterbrandArgs = {
  to?: Array<Stage>;
  where: HeroBannerMasterbrandWhereUniqueInput;
};


export type MutationPublishHeroCarouselComponentArgs = {
  to?: Array<Stage>;
  where: HeroCarouselComponentWhereUniqueInput;
};


export type MutationPublishHeroComponentArgs = {
  to?: Array<Stage>;
  where: HeroComponentWhereUniqueInput;
};


export type MutationPublishHeroLoopAnimationComponentArgs = {
  to?: Array<Stage>;
  where: HeroLoopAnimationComponentWhereUniqueInput;
};


export type MutationPublishIframeArgs = {
  to?: Array<Stage>;
  where: IframeWhereUniqueInput;
};


export type MutationPublishImageAndTextCardArgs = {
  to?: Array<Stage>;
  where: ImageAndTextCardWhereUniqueInput;
};


export type MutationPublishImageCopyArgs = {
  to?: Array<Stage>;
  where: ImageCopyWhereUniqueInput;
};


export type MutationPublishImageCopyItemArgs = {
  to?: Array<Stage>;
  where: ImageCopyItemWhereUniqueInput;
};


export type MutationPublishIntroTextArgs = {
  to?: Array<Stage>;
  where: IntroTextWhereUniqueInput;
};


export type MutationPublishLeftColumnArgs = {
  to?: Array<Stage>;
  where: LeftColumnWhereUniqueInput;
};


export type MutationPublishLinkArgs = {
  to?: Array<Stage>;
  where: LinkWhereUniqueInput;
};


export type MutationPublishLongTextArgs = {
  to?: Array<Stage>;
  where: LongTextWhereUniqueInput;
};


export type MutationPublishManyAccordionItemsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AccordionItemManyWhereInput>;
};


export type MutationPublishManyAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AccordionItemManyWhereInput>;
};


export type MutationPublishManyAccordionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AccordionManyWhereInput>;
};


export type MutationPublishManyAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AccordionManyWhereInput>;
};


export type MutationPublishManyAlgoliaExtensionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AlgoliaExtensionManyWhereInput>;
};


export type MutationPublishManyAlgoliaExtensionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AlgoliaExtensionManyWhereInput>;
};


export type MutationPublishManyAnchorNavigationListsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AnchorNavigationListManyWhereInput>;
};


export type MutationPublishManyAnchorNavigationListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AnchorNavigationListManyWhereInput>;
};


export type MutationPublishManyAnchorNavigationsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AnchorNavigationManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAnchorNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AnchorNavigationManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAnchorNavsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AnchorNavManyWhereInput>;
};


export type MutationPublishManyAnchorNavsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AnchorNavManyWhereInput>;
};


export type MutationPublishManyAssetsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAssetsComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AssetComponentManyWhereInput>;
};


export type MutationPublishManyAssetsComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetComponentManyWhereInput>;
};


export type MutationPublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAudioComponentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AudioComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAudioComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AudioComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAuthorableContentCardsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AuthorableContentCardManyWhereInput>;
};


export type MutationPublishManyAuthorableContentCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AuthorableContentCardManyWhereInput>;
};


export type MutationPublishManyBanner1sArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<Banner1ManyWhereInput>;
};


export type MutationPublishManyBanner1sConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<Banner1ManyWhereInput>;
};


export type MutationPublishManyBanner2CarouselComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<Banner2CarouselComponentManyWhereInput>;
};


export type MutationPublishManyBanner2CarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<Banner2CarouselComponentManyWhereInput>;
};


export type MutationPublishManyBanner2SArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<Banner2ManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyBanner2SConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<Banner2ManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCardComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CardComponentManyWhereInput>;
};


export type MutationPublishManyCardComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CardComponentManyWhereInput>;
};


export type MutationPublishManyCarouselComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CarouselComponentManyWhereInput>;
};


export type MutationPublishManyCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CarouselComponentManyWhereInput>;
};


export type MutationPublishManyCarouselSlidesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CarouselSlideManyWhereInput>;
};


export type MutationPublishManyCarouselSlidesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CarouselSlideManyWhereInput>;
};


export type MutationPublishManyCategoryCardsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CategoryCardManyWhereInput>;
};


export type MutationPublishManyCategoryCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CategoryCardManyWhereInput>;
};


export type MutationPublishManyContactCardContainersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ContactCardContainerManyWhereInput>;
};


export type MutationPublishManyContactCardContainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ContactCardContainerManyWhereInput>;
};


export type MutationPublishManyContactCardsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ContactCardManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyContactCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ContactCardManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCountrySelectorFootersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CountrySelectorFooterManyWhereInput>;
};


export type MutationPublishManyCountrySelectorFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CountrySelectorFooterManyWhereInput>;
};


export type MutationPublishManyCountrySelectorItemsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CountrySelectorItemManyWhereInput>;
};


export type MutationPublishManyCountrySelectorItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CountrySelectorItemManyWhereInput>;
};


export type MutationPublishManyDemoModelsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<DemoModelManyWhereInput>;
};


export type MutationPublishManyDemoModelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<DemoModelManyWhereInput>;
};


export type MutationPublishManyDictionariesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<DictionaryManyWhereInput>;
};


export type MutationPublishManyDictionariesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<DictionaryManyWhereInput>;
};


export type MutationPublishManyDictionaryItemsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<DictionaryItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyDictionaryItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<DictionaryItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyDownloadAppsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<DownloadAppManyWhereInput>;
};


export type MutationPublishManyDownloadAppsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<DownloadAppManyWhereInput>;
};


export type MutationPublishManyDynamicCardGridsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<DynamicCardGridManyWhereInput>;
};


export type MutationPublishManyDynamicCardGridsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<DynamicCardGridManyWhereInput>;
};


export type MutationPublishManyErrorPagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ErrorPageManyWhereInput>;
};


export type MutationPublishManyErrorPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ErrorPageManyWhereInput>;
};


export type MutationPublishManyEvalancheFormComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<EvalancheFormComponentManyWhereInput>;
};


export type MutationPublishManyEvalancheFormComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<EvalancheFormComponentManyWhereInput>;
};


export type MutationPublishManyExampleComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ExampleComponentManyWhereInput>;
};


export type MutationPublishManyExampleComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ExampleComponentManyWhereInput>;
};


export type MutationPublishManyFeaturedContentReferencesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FeaturedContentReferenceManyWhereInput>;
};


export type MutationPublishManyFeaturedContentReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FeaturedContentReferenceManyWhereInput>;
};


export type MutationPublishManyFeaturedContentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FeaturedContentManyWhereInput>;
};


export type MutationPublishManyFeaturedContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FeaturedContentManyWhereInput>;
};


export type MutationPublishManyFooterNavigationsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FooterNavigationManyWhereInput>;
};


export type MutationPublishManyFooterNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FooterNavigationManyWhereInput>;
};


export type MutationPublishManyFooterSealsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FooterSealManyWhereInput>;
};


export type MutationPublishManyFooterSealsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FooterSealManyWhereInput>;
};


export type MutationPublishManyFormCheckboxCollectionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormCheckboxCollectionManyWhereInput>;
};


export type MutationPublishManyFormCheckboxCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormCheckboxCollectionManyWhereInput>;
};


export type MutationPublishManyFormCheckboxesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormCheckboxManyWhereInput>;
};


export type MutationPublishManyFormCheckboxesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormCheckboxManyWhereInput>;
};


export type MutationPublishManyFormDateInputsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormDateInputManyWhereInput>;
};


export type MutationPublishManyFormDateInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormDateInputManyWhereInput>;
};


export type MutationPublishManyFormEmailInputsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormEmailInputManyWhereInput>;
};


export type MutationPublishManyFormEmailInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormEmailInputManyWhereInput>;
};


export type MutationPublishManyFormErrorsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormErrorManyWhereInput>;
};


export type MutationPublishManyFormErrorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormErrorManyWhereInput>;
};


export type MutationPublishManyFormFileUploadersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormFileUploaderManyWhereInput>;
};


export type MutationPublishManyFormFileUploadersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormFileUploaderManyWhereInput>;
};


export type MutationPublishManyFormListItemsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormListItemManyWhereInput>;
};


export type MutationPublishManyFormListItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormListItemManyWhereInput>;
};


export type MutationPublishManyFormListsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormListManyWhereInput>;
};


export type MutationPublishManyFormListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormListManyWhereInput>;
};


export type MutationPublishManyFormNumberInputsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormNumberInputManyWhereInput>;
};


export type MutationPublishManyFormNumberInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormNumberInputManyWhereInput>;
};


export type MutationPublishManyFormPasswordInputWithConfirmationsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormPasswordInputWithConfirmationManyWhereInput>;
};


export type MutationPublishManyFormPasswordInputWithConfirmationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormPasswordInputWithConfirmationManyWhereInput>;
};


export type MutationPublishManyFormPasswordInputsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormPasswordInputManyWhereInput>;
};


export type MutationPublishManyFormPasswordInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormPasswordInputManyWhereInput>;
};


export type MutationPublishManyFormRadioButtonCollectionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormRadioButtonCollectionManyWhereInput>;
};


export type MutationPublishManyFormRadioButtonCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormRadioButtonCollectionManyWhereInput>;
};


export type MutationPublishManyFormRadioButtonsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormRadioButtonManyWhereInput>;
};


export type MutationPublishManyFormRadioButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormRadioButtonManyWhereInput>;
};


export type MutationPublishManyFormSelectComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormSelectComponentManyWhereInput>;
};


export type MutationPublishManyFormSelectComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormSelectComponentManyWhereInput>;
};


export type MutationPublishManyFormSelectOptionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormSelectOptionManyWhereInput>;
};


export type MutationPublishManyFormSelectOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormSelectOptionManyWhereInput>;
};


export type MutationPublishManyFormSubmitButtonsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormSubmitButtonManyWhereInput>;
};


export type MutationPublishManyFormSubmitButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormSubmitButtonManyWhereInput>;
};


export type MutationPublishManyFormSuccessComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormSuccessComponentManyWhereInput>;
};


export type MutationPublishManyFormSuccessComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormSuccessComponentManyWhereInput>;
};


export type MutationPublishManyFormTextInputsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormTextInputManyWhereInput>;
};


export type MutationPublishManyFormTextInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormTextInputManyWhereInput>;
};


export type MutationPublishManyFormTextareaInputsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormTextareaInputManyWhereInput>;
};


export type MutationPublishManyFormTextareaInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormTextareaInputManyWhereInput>;
};


export type MutationPublishManyFormsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationPublishManyFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationPublishManyGenericAccordionItemsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GenericAccordionItemManyWhereInput>;
};


export type MutationPublishManyGenericAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericAccordionItemManyWhereInput>;
};


export type MutationPublishManyGenericAccordionTopRatedsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GenericAccordionTopRatedManyWhereInput>;
};


export type MutationPublishManyGenericAccordionTopRatedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericAccordionTopRatedManyWhereInput>;
};


export type MutationPublishManyGenericAccordionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GenericAccordionManyWhereInput>;
};


export type MutationPublishManyGenericAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericAccordionManyWhereInput>;
};


export type MutationPublishManyGenericCardCarouseComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GenericCardCarouseComponentManyWhereInput>;
};


export type MutationPublishManyGenericCardCarouseComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericCardCarouseComponentManyWhereInput>;
};


export type MutationPublishManyGenericDownloadComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GenericDownloadComponentManyWhereInput>;
};


export type MutationPublishManyGenericDownloadComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericDownloadComponentManyWhereInput>;
};


export type MutationPublishManyGenericFollowUsesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GenericFollowUsManyWhereInput>;
};


export type MutationPublishManyGenericFollowUsesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericFollowUsManyWhereInput>;
};


export type MutationPublishManyGenericGridAuthorablesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GenericGridAuthorableManyWhereInput>;
};


export type MutationPublishManyGenericGridAuthorablesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericGridAuthorableManyWhereInput>;
};


export type MutationPublishManyGenericHtmlsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GenericHtmlManyWhereInput>;
};


export type MutationPublishManyGenericHtmlsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericHtmlManyWhereInput>;
};


export type MutationPublishManyGenericLinesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GenericLineManyWhereInput>;
};


export type MutationPublishManyGenericLinesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericLineManyWhereInput>;
};


export type MutationPublishManyGenericLinksArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GenericLinkManyWhereInput>;
};


export type MutationPublishManyGenericLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericLinkManyWhereInput>;
};


export type MutationPublishManyGenericPagesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericPageManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyGenericPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericPageManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyGenericPromotionsOverviewsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GenericPromotionsOverviewManyWhereInput>;
};


export type MutationPublishManyGenericPromotionsOverviewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericPromotionsOverviewManyWhereInput>;
};


export type MutationPublishManyGenericQualifioOverviewsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GenericQualifioOverviewManyWhereInput>;
};


export type MutationPublishManyGenericQualifioOverviewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericQualifioOverviewManyWhereInput>;
};


export type MutationPublishManyGenericQualifiosArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GenericQualifioManyWhereInput>;
};


export type MutationPublishManyGenericQualifiosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericQualifioManyWhereInput>;
};


export type MutationPublishManyGenericSocialSharesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GenericSocialShareManyWhereInput>;
};


export type MutationPublishManyGenericSocialSharesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericSocialShareManyWhereInput>;
};


export type MutationPublishManyGlobalMetaDatasArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GlobalMetaDataManyWhereInput>;
};


export type MutationPublishManyGlobalMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GlobalMetaDataManyWhereInput>;
};


export type MutationPublishManyGlobalSearchesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GlobalSearchManyWhereInput>;
};


export type MutationPublishManyGlobalSearchesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GlobalSearchManyWhereInput>;
};


export type MutationPublishManyGridColumnComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GridColumnComponentManyWhereInput>;
};


export type MutationPublishManyGridColumnComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GridColumnComponentManyWhereInput>;
};


export type MutationPublishManyGridColumnsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GridColumnManyWhereInput>;
};


export type MutationPublishManyGridColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GridColumnManyWhereInput>;
};


export type MutationPublishManyHeroBannerMasterbrandsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<HeroBannerMasterbrandManyWhereInput>;
};


export type MutationPublishManyHeroBannerMasterbrandsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<HeroBannerMasterbrandManyWhereInput>;
};


export type MutationPublishManyHeroBannersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<HeroBannerManyWhereInput>;
};


export type MutationPublishManyHeroBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<HeroBannerManyWhereInput>;
};


export type MutationPublishManyHeroCarouselComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<HeroCarouselComponentManyWhereInput>;
};


export type MutationPublishManyHeroCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<HeroCarouselComponentManyWhereInput>;
};


export type MutationPublishManyHeroComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<HeroComponentManyWhereInput>;
};


export type MutationPublishManyHeroComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<HeroComponentManyWhereInput>;
};


export type MutationPublishManyHeroLoopAnimationComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<HeroLoopAnimationComponentManyWhereInput>;
};


export type MutationPublishManyHeroLoopAnimationComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<HeroLoopAnimationComponentManyWhereInput>;
};


export type MutationPublishManyIframesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<IframeManyWhereInput>;
};


export type MutationPublishManyIframesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<IframeManyWhereInput>;
};


export type MutationPublishManyImageAndTextCardsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ImageAndTextCardManyWhereInput>;
};


export type MutationPublishManyImageAndTextCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ImageAndTextCardManyWhereInput>;
};


export type MutationPublishManyImageCopiesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ImageCopyManyWhereInput>;
};


export type MutationPublishManyImageCopiesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ImageCopyManyWhereInput>;
};


export type MutationPublishManyImageCopyItemsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ImageCopyItemManyWhereInput>;
};


export type MutationPublishManyImageCopyItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ImageCopyItemManyWhereInput>;
};


export type MutationPublishManyIntroTextsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<IntroTextManyWhereInput>;
};


export type MutationPublishManyIntroTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<IntroTextManyWhereInput>;
};


export type MutationPublishManyLeftColumnsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<LeftColumnManyWhereInput>;
};


export type MutationPublishManyLeftColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<LeftColumnManyWhereInput>;
};


export type MutationPublishManyLinksArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationPublishManyLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationPublishManyLongTextsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<LongTextManyWhereInput>;
};


export type MutationPublishManyLongTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<LongTextManyWhereInput>;
};


export type MutationPublishManyMarketUserConnectionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<MarketUserConnectionManyWhereInput>;
};


export type MutationPublishManyMarketUserConnectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<MarketUserConnectionManyWhereInput>;
};


export type MutationPublishManyMarketsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<MarketManyWhereInput>;
};


export type MutationPublishManyMarketsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<MarketManyWhereInput>;
};


export type MutationPublishManyMetaDatasArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<MetaDataManyWhereInput>;
};


export type MutationPublishManyMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<MetaDataManyWhereInput>;
};


export type MutationPublishManyMobileOnlyMainNavigationsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<MobileOnlyMainNavigationManyWhereInput>;
};


export type MutationPublishManyMobileOnlyMainNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<MobileOnlyMainNavigationManyWhereInput>;
};


export type MutationPublishManyMultiStepPromotionFormsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<MultiStepPromotionFormManyWhereInput>;
};


export type MutationPublishManyMultiStepPromotionFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<MultiStepPromotionFormManyWhereInput>;
};


export type MutationPublishManyNavigationItemsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<NavigationItemManyWhereInput>;
};


export type MutationPublishManyNavigationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<NavigationItemManyWhereInput>;
};


export type MutationPublishManyNavigationsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationPublishManyNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationPublishManyNewsletterComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<NewsletterComponentManyWhereInput>;
};


export type MutationPublishManyNewsletterComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<NewsletterComponentManyWhereInput>;
};


export type MutationPublishManyNewsletterSubscriptionsPluralArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<NewsletterSubscriptionsManyWhereInput>;
};


export type MutationPublishManyNewsletterSubscriptionsPluralConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<NewsletterSubscriptionsManyWhereInput>;
};


export type MutationPublishManyNotificationBannersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<NotificationBannerManyWhereInput>;
};


export type MutationPublishManyNotificationBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<NotificationBannerManyWhereInput>;
};


export type MutationPublishManyPageFootersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<PageFooterManyWhereInput>;
};


export type MutationPublishManyPageFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PageFooterManyWhereInput>;
};


export type MutationPublishManyPageHeadersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<PageHeaderManyWhereInput>;
};


export type MutationPublishManyPageHeadersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PageHeaderManyWhereInput>;
};


export type MutationPublishManyPopularSearchComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<PopularSearchComponentManyWhereInput>;
};


export type MutationPublishManyPopularSearchComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PopularSearchComponentManyWhereInput>;
};


export type MutationPublishManyProductBannersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ProductBannerManyWhereInput>;
};


export type MutationPublishManyProductBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ProductBannerManyWhereInput>;
};


export type MutationPublishManyProductCategoriesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ProductCategoryManyWhereInput>;
};


export type MutationPublishManyProductCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ProductCategoryManyWhereInput>;
};


export type MutationPublishManyProductCategoryPagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ProductCategoryPageManyWhereInput>;
};


export type MutationPublishManyProductCategoryPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ProductCategoryPageManyWhereInput>;
};


export type MutationPublishManyProductDetailPagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ProductDetailPageManyWhereInput>;
};


export type MutationPublishManyProductDetailPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ProductDetailPageManyWhereInput>;
};


export type MutationPublishManyProductHeroesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ProductHeroManyWhereInput>;
};


export type MutationPublishManyProductHeroesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ProductHeroManyWhereInput>;
};


export type MutationPublishManyProductLabelsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ProductLabelManyWhereInput>;
};


export type MutationPublishManyProductLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ProductLabelManyWhereInput>;
};


export type MutationPublishManyProductLandingPagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ProductLandingPageManyWhereInput>;
};


export type MutationPublishManyProductLandingPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ProductLandingPageManyWhereInput>;
};


export type MutationPublishManyProductSubcategoryPagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ProductSubcategoryPageManyWhereInput>;
};


export type MutationPublishManyProductSubcategoryPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ProductSubcategoryPageManyWhereInput>;
};


export type MutationPublishManyProductsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ProductManyWhereInput>;
};


export type MutationPublishManyProductsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ProductManyWhereInput>;
};


export type MutationPublishManyPromotionDownloadsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PromotionDownloadManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyPromotionDownloadsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PromotionDownloadManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyPromotionFormsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<PromotionFormManyWhereInput>;
};


export type MutationPublishManyPromotionFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PromotionFormManyWhereInput>;
};


export type MutationPublishManyQuestionCheckboxCollectionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<QuestionCheckboxCollectionManyWhereInput>;
};


export type MutationPublishManyQuestionCheckboxCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<QuestionCheckboxCollectionManyWhereInput>;
};


export type MutationPublishManyQuestionCheckboxesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<QuestionCheckboxManyWhereInput>;
};


export type MutationPublishManyQuestionCheckboxesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<QuestionCheckboxManyWhereInput>;
};


export type MutationPublishManyQuestionRadioButtonCollectionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<QuestionRadioButtonCollectionManyWhereInput>;
};


export type MutationPublishManyQuestionRadioButtonCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<QuestionRadioButtonCollectionManyWhereInput>;
};


export type MutationPublishManyQuestionRadioButtonsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<QuestionRadioButtonManyWhereInput>;
};


export type MutationPublishManyQuestionRadioButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<QuestionRadioButtonManyWhereInput>;
};


export type MutationPublishManyQuestionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<QuestionManyWhereInput>;
};


export type MutationPublishManyQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<QuestionManyWhereInput>;
};


export type MutationPublishManyRatingsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<RatingManyWhereInput>;
};


export type MutationPublishManyRatingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RatingManyWhereInput>;
};


export type MutationPublishManyRecipeCategoriesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<RecipeCategoryManyWhereInput>;
};


export type MutationPublishManyRecipeCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RecipeCategoryManyWhereInput>;
};


export type MutationPublishManyRecipeLandingPagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<RecipeLandingPageManyWhereInput>;
};


export type MutationPublishManyRecipeLandingPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RecipeLandingPageManyWhereInput>;
};


export type MutationPublishManyRecipeSubcategoriesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<RecipeSubcategoryManyWhereInput>;
};


export type MutationPublishManyRecipeSubcategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RecipeSubcategoryManyWhereInput>;
};


export type MutationPublishManyRecipesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<RecipeManyWhereInput>;
};


export type MutationPublishManyRecipesComparisonQueryComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<RecipesComparisonQueryComponentManyWhereInput>;
};


export type MutationPublishManyRecipesComparisonQueryComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RecipesComparisonQueryComponentManyWhereInput>;
};


export type MutationPublishManyRecipesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RecipeManyWhereInput>;
};


export type MutationPublishManyRecipesQueriesReferencesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<RecipesQueriesReferenceManyWhereInput>;
};


export type MutationPublishManyRecipesQueriesReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RecipesQueriesReferenceManyWhereInput>;
};


export type MutationPublishManyRecipesQueryComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<RecipesQueryComponentManyWhereInput>;
};


export type MutationPublishManyRecipesQueryComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RecipesQueryComponentManyWhereInput>;
};


export type MutationPublishManyRedirectsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationPublishManyRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationPublishManyRewritesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RewriteManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyRewritesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RewriteManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyRightColumnsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<RightColumnManyWhereInput>;
};


export type MutationPublishManyRightColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RightColumnManyWhereInput>;
};


export type MutationPublishManySearchInputsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SearchInputManyWhereInput>;
};


export type MutationPublishManySearchInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SearchInputManyWhereInput>;
};


export type MutationPublishManySearchOverlayComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SearchOverlayComponentManyWhereInput>;
};


export type MutationPublishManySearchOverlayComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SearchOverlayComponentManyWhereInput>;
};


export type MutationPublishManySearchResultPagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SearchResultPageManyWhereInput>;
};


export type MutationPublishManySearchResultPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SearchResultPageManyWhereInput>;
};


export type MutationPublishManySeparatorsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SeparatorManyWhereInput>;
};


export type MutationPublishManySeparatorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SeparatorManyWhereInput>;
};


export type MutationPublishManySingleStepPromotionFormsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SingleStepPromotionFormManyWhereInput>;
};


export type MutationPublishManySingleStepPromotionFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SingleStepPromotionFormManyWhereInput>;
};


export type MutationPublishManySocialMediaListComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SocialMediaListComponentManyWhereInput>;
};


export type MutationPublishManySocialMediaListComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SocialMediaListComponentManyWhereInput>;
};


export type MutationPublishManySpacersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SpacerManyWhereInput>;
};


export type MutationPublishManySpacersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SpacerManyWhereInput>;
};


export type MutationPublishManySubCategoryKeyImagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SubCategoryKeyImageManyWhereInput>;
};


export type MutationPublishManySubCategoryKeyImagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SubCategoryKeyImageManyWhereInput>;
};


export type MutationPublishManySubTabsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SubTabManyWhereInput>;
};


export type MutationPublishManySubTabsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SubTabManyWhereInput>;
};


export type MutationPublishManySubTabsContentArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SubTabContentManyWhereInput>;
};


export type MutationPublishManySubTabsContentConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SubTabContentManyWhereInput>;
};


export type MutationPublishManySustainabilityBannersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SustainabilityBannerManyWhereInput>;
};


export type MutationPublishManySustainabilityBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SustainabilityBannerManyWhereInput>;
};


export type MutationPublishManySustainabilityInfosArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SustainabilityInfoManyWhereInput>;
};


export type MutationPublishManySustainabilityInfosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SustainabilityInfoManyWhereInput>;
};


export type MutationPublishManyTabContentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TabContentManyWhereInput>;
};


export type MutationPublishManyTabContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TabContentManyWhereInput>;
};


export type MutationPublishManyTabsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TabManyWhereInput>;
};


export type MutationPublishManyTabsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TabManyWhereInput>;
};


export type MutationPublishManyTeaserPlaceholdersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TeaserPlaceholderManyWhereInput>;
};


export type MutationPublishManyTeaserPlaceholdersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TeaserPlaceholderManyWhereInput>;
};


export type MutationPublishManyTeaserSmallPlaceholdersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TeaserSmallPlaceholderManyWhereInput>;
};


export type MutationPublishManyTeaserSmallPlaceholdersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TeaserSmallPlaceholderManyWhereInput>;
};


export type MutationPublishManyTeaserSmallsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TeaserSmallManyWhereInput>;
};


export type MutationPublishManyTeaserSmallsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TeaserSmallManyWhereInput>;
};


export type MutationPublishManyTeasersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TeaserManyWhereInput>;
};


export type MutationPublishManyTeasersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TeaserManyWhereInput>;
};


export type MutationPublishManyTestComponentWithRecipeQueriesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TestComponentWithRecipeQueryManyWhereInput>;
};


export type MutationPublishManyTestComponentWithRecipeQueriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TestComponentWithRecipeQueryManyWhereInput>;
};


export type MutationPublishManyTestTipsANdTricksInAMarketsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TestTipsANdTricksInAMarketManyWhereInput>;
};


export type MutationPublishManyTestTipsANdTricksInAMarketsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TestTipsANdTricksInAMarketManyWhereInput>;
};


export type MutationPublishManyTextComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TextComponentManyWhereInput>;
};


export type MutationPublishManyTextComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TextComponentManyWhereInput>;
};


export type MutationPublishManyTipsAndTricksDetailsPagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TipsAndTricksDetailsPageManyWhereInput>;
};


export type MutationPublishManyTipsAndTricksDetailsPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TipsAndTricksDetailsPageManyWhereInput>;
};


export type MutationPublishManyTitlesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TitleManyWhereInput>;
};


export type MutationPublishManyTitlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TitleManyWhereInput>;
};


export type MutationPublishManyTwitterSeosArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TwitterSeoManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyTwitterSeosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TwitterSeoManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishMarketArgs = {
  to?: Array<Stage>;
  where: MarketWhereUniqueInput;
};


export type MutationPublishMarketUserConnectionArgs = {
  to?: Array<Stage>;
  where: MarketUserConnectionWhereUniqueInput;
};


export type MutationPublishMetaDataArgs = {
  to?: Array<Stage>;
  where: MetaDataWhereUniqueInput;
};


export type MutationPublishMobileOnlyMainNavigationArgs = {
  to?: Array<Stage>;
  where: MobileOnlyMainNavigationWhereUniqueInput;
};


export type MutationPublishMultiStepPromotionFormArgs = {
  to?: Array<Stage>;
  where: MultiStepPromotionFormWhereUniqueInput;
};


export type MutationPublishNavigationArgs = {
  to?: Array<Stage>;
  where: NavigationWhereUniqueInput;
};


export type MutationPublishNavigationItemArgs = {
  to?: Array<Stage>;
  where: NavigationItemWhereUniqueInput;
};


export type MutationPublishNewsletterComponentArgs = {
  to?: Array<Stage>;
  where: NewsletterComponentWhereUniqueInput;
};


export type MutationPublishNewsletterSubscriptionsArgs = {
  to?: Array<Stage>;
  where: NewsletterSubscriptionsWhereUniqueInput;
};


export type MutationPublishNotificationBannerArgs = {
  to?: Array<Stage>;
  where: NotificationBannerWhereUniqueInput;
};


export type MutationPublishPageFooterArgs = {
  to?: Array<Stage>;
  where: PageFooterWhereUniqueInput;
};


export type MutationPublishPageHeaderArgs = {
  to?: Array<Stage>;
  where: PageHeaderWhereUniqueInput;
};


export type MutationPublishPopularSearchComponentArgs = {
  to?: Array<Stage>;
  where: PopularSearchComponentWhereUniqueInput;
};


export type MutationPublishProductArgs = {
  to?: Array<Stage>;
  where: ProductWhereUniqueInput;
};


export type MutationPublishProductBannerArgs = {
  to?: Array<Stage>;
  where: ProductBannerWhereUniqueInput;
};


export type MutationPublishProductCategoryArgs = {
  to?: Array<Stage>;
  where: ProductCategoryWhereUniqueInput;
};


export type MutationPublishProductCategoryPageArgs = {
  to?: Array<Stage>;
  where: ProductCategoryPageWhereUniqueInput;
};


export type MutationPublishProductDetailPageArgs = {
  to?: Array<Stage>;
  where: ProductDetailPageWhereUniqueInput;
};


export type MutationPublishProductHeroArgs = {
  to?: Array<Stage>;
  where: ProductHeroWhereUniqueInput;
};


export type MutationPublishProductLabelArgs = {
  to?: Array<Stage>;
  where: ProductLabelWhereUniqueInput;
};


export type MutationPublishProductLandingPageArgs = {
  to?: Array<Stage>;
  where: ProductLandingPageWhereUniqueInput;
};


export type MutationPublishProductSubcategoryPageArgs = {
  to?: Array<Stage>;
  where: ProductSubcategoryPageWhereUniqueInput;
};


export type MutationPublishPromotionDownloadArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: PromotionDownloadWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishPromotionFormArgs = {
  to?: Array<Stage>;
  where: PromotionFormWhereUniqueInput;
};


export type MutationPublishQuestionArgs = {
  to?: Array<Stage>;
  where: QuestionWhereUniqueInput;
};


export type MutationPublishQuestionCheckboxArgs = {
  to?: Array<Stage>;
  where: QuestionCheckboxWhereUniqueInput;
};


export type MutationPublishQuestionCheckboxCollectionArgs = {
  to?: Array<Stage>;
  where: QuestionCheckboxCollectionWhereUniqueInput;
};


export type MutationPublishQuestionRadioButtonArgs = {
  to?: Array<Stage>;
  where: QuestionRadioButtonWhereUniqueInput;
};


export type MutationPublishQuestionRadioButtonCollectionArgs = {
  to?: Array<Stage>;
  where: QuestionRadioButtonCollectionWhereUniqueInput;
};


export type MutationPublishRatingArgs = {
  to?: Array<Stage>;
  where: RatingWhereUniqueInput;
};


export type MutationPublishRecipeArgs = {
  to?: Array<Stage>;
  where: RecipeWhereUniqueInput;
};


export type MutationPublishRecipeCategoryArgs = {
  to?: Array<Stage>;
  where: RecipeCategoryWhereUniqueInput;
};


export type MutationPublishRecipeLandingPageArgs = {
  to?: Array<Stage>;
  where: RecipeLandingPageWhereUniqueInput;
};


export type MutationPublishRecipeSubcategoryArgs = {
  to?: Array<Stage>;
  where: RecipeSubcategoryWhereUniqueInput;
};


export type MutationPublishRecipesComparisonQueryComponentArgs = {
  to?: Array<Stage>;
  where: RecipesComparisonQueryComponentWhereUniqueInput;
};


export type MutationPublishRecipesQueriesReferenceArgs = {
  to?: Array<Stage>;
  where: RecipesQueriesReferenceWhereUniqueInput;
};


export type MutationPublishRecipesQueryComponentArgs = {
  to?: Array<Stage>;
  where: RecipesQueryComponentWhereUniqueInput;
};


export type MutationPublishRedirectArgs = {
  to?: Array<Stage>;
  where: RedirectWhereUniqueInput;
};


export type MutationPublishRewriteArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: RewriteWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishRightColumnArgs = {
  to?: Array<Stage>;
  where: RightColumnWhereUniqueInput;
};


export type MutationPublishSearchInputArgs = {
  to?: Array<Stage>;
  where: SearchInputWhereUniqueInput;
};


export type MutationPublishSearchOverlayComponentArgs = {
  to?: Array<Stage>;
  where: SearchOverlayComponentWhereUniqueInput;
};


export type MutationPublishSearchResultPageArgs = {
  to?: Array<Stage>;
  where: SearchResultPageWhereUniqueInput;
};


export type MutationPublishSeparatorArgs = {
  to?: Array<Stage>;
  where: SeparatorWhereUniqueInput;
};


export type MutationPublishSingleStepPromotionFormArgs = {
  to?: Array<Stage>;
  where: SingleStepPromotionFormWhereUniqueInput;
};


export type MutationPublishSocialMediaListComponentArgs = {
  to?: Array<Stage>;
  where: SocialMediaListComponentWhereUniqueInput;
};


export type MutationPublishSpacerArgs = {
  to?: Array<Stage>;
  where: SpacerWhereUniqueInput;
};


export type MutationPublishSubCategoryKeyImageArgs = {
  to?: Array<Stage>;
  where: SubCategoryKeyImageWhereUniqueInput;
};


export type MutationPublishSubTabArgs = {
  to?: Array<Stage>;
  where: SubTabWhereUniqueInput;
};


export type MutationPublishSubTabContentArgs = {
  to?: Array<Stage>;
  where: SubTabContentWhereUniqueInput;
};


export type MutationPublishSustainabilityBannerArgs = {
  to?: Array<Stage>;
  where: SustainabilityBannerWhereUniqueInput;
};


export type MutationPublishSustainabilityInfoArgs = {
  to?: Array<Stage>;
  where: SustainabilityInfoWhereUniqueInput;
};


export type MutationPublishTabArgs = {
  to?: Array<Stage>;
  where: TabWhereUniqueInput;
};


export type MutationPublishTabContentArgs = {
  to?: Array<Stage>;
  where: TabContentWhereUniqueInput;
};


export type MutationPublishTeaserArgs = {
  to?: Array<Stage>;
  where: TeaserWhereUniqueInput;
};


export type MutationPublishTeaserPlaceholderArgs = {
  to?: Array<Stage>;
  where: TeaserPlaceholderWhereUniqueInput;
};


export type MutationPublishTeaserSmallArgs = {
  to?: Array<Stage>;
  where: TeaserSmallWhereUniqueInput;
};


export type MutationPublishTeaserSmallPlaceholderArgs = {
  to?: Array<Stage>;
  where: TeaserSmallPlaceholderWhereUniqueInput;
};


export type MutationPublishTestComponentWithRecipeQueryArgs = {
  to?: Array<Stage>;
  where: TestComponentWithRecipeQueryWhereUniqueInput;
};


export type MutationPublishTestTipsANdTricksInAMarketArgs = {
  to?: Array<Stage>;
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};


export type MutationPublishTextComponentArgs = {
  to?: Array<Stage>;
  where: TextComponentWhereUniqueInput;
};


export type MutationPublishTipsAndTricksDetailsPageArgs = {
  to?: Array<Stage>;
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};


export type MutationPublishTitleArgs = {
  to?: Array<Stage>;
  where: TitleWhereUniqueInput;
};


export type MutationPublishTwitterSeoArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: TwitterSeoWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishAccordionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AccordionWhereUniqueInput;
};


export type MutationSchedulePublishAccordionItemArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AccordionItemWhereUniqueInput;
};


export type MutationSchedulePublishAlgoliaExtensionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AlgoliaExtensionWhereUniqueInput;
};


export type MutationSchedulePublishAnchorNavArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AnchorNavWhereUniqueInput;
};


export type MutationSchedulePublishAnchorNavigationArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AnchorNavigationWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishAnchorNavigationListArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AnchorNavigationListWhereUniqueInput;
};


export type MutationSchedulePublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishAssetComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AssetComponentWhereUniqueInput;
};


export type MutationSchedulePublishAudioComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AudioComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishAuthorableContentCardArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AuthorableContentCardWhereUniqueInput;
};


export type MutationSchedulePublishBanner1Args = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: Banner1WhereUniqueInput;
};


export type MutationSchedulePublishBanner2Args = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: Banner2WhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishBanner2CarouselComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: Banner2CarouselComponentWhereUniqueInput;
};


export type MutationSchedulePublishCardComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CardComponentWhereUniqueInput;
};


export type MutationSchedulePublishCarouselComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CarouselComponentWhereUniqueInput;
};


export type MutationSchedulePublishCarouselSlideArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CarouselSlideWhereUniqueInput;
};


export type MutationSchedulePublishCategoryCardArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CategoryCardWhereUniqueInput;
};


export type MutationSchedulePublishContactCardArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ContactCardWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishContactCardContainerArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ContactCardContainerWhereUniqueInput;
};


export type MutationSchedulePublishCountrySelectorFooterArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CountrySelectorFooterWhereUniqueInput;
};


export type MutationSchedulePublishCountrySelectorItemArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CountrySelectorItemWhereUniqueInput;
};


export type MutationSchedulePublishDemoModelArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: DemoModelWhereUniqueInput;
};


export type MutationSchedulePublishDictionaryArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: DictionaryWhereUniqueInput;
};


export type MutationSchedulePublishDictionaryItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: DictionaryItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishDownloadAppArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: DownloadAppWhereUniqueInput;
};


export type MutationSchedulePublishDynamicCardGridArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: DynamicCardGridWhereUniqueInput;
};


export type MutationSchedulePublishErrorPageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ErrorPageWhereUniqueInput;
};


export type MutationSchedulePublishEvalancheFormComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: EvalancheFormComponentWhereUniqueInput;
};


export type MutationSchedulePublishExampleComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ExampleComponentWhereUniqueInput;
};


export type MutationSchedulePublishFeaturedContentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FeaturedContentWhereUniqueInput;
};


export type MutationSchedulePublishFeaturedContentReferenceArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FeaturedContentReferenceWhereUniqueInput;
};


export type MutationSchedulePublishFooterNavigationArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FooterNavigationWhereUniqueInput;
};


export type MutationSchedulePublishFooterSealArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FooterSealWhereUniqueInput;
};


export type MutationSchedulePublishFormArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormWhereUniqueInput;
};


export type MutationSchedulePublishFormCheckboxArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormCheckboxWhereUniqueInput;
};


export type MutationSchedulePublishFormCheckboxCollectionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormCheckboxCollectionWhereUniqueInput;
};


export type MutationSchedulePublishFormDateInputArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormDateInputWhereUniqueInput;
};


export type MutationSchedulePublishFormEmailInputArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormEmailInputWhereUniqueInput;
};


export type MutationSchedulePublishFormErrorArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormErrorWhereUniqueInput;
};


export type MutationSchedulePublishFormFileUploaderArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormFileUploaderWhereUniqueInput;
};


export type MutationSchedulePublishFormListArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormListWhereUniqueInput;
};


export type MutationSchedulePublishFormListItemArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormListItemWhereUniqueInput;
};


export type MutationSchedulePublishFormNumberInputArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormNumberInputWhereUniqueInput;
};


export type MutationSchedulePublishFormPasswordInputArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormPasswordInputWhereUniqueInput;
};


export type MutationSchedulePublishFormPasswordInputWithConfirmationArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};


export type MutationSchedulePublishFormRadioButtonArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormRadioButtonWhereUniqueInput;
};


export type MutationSchedulePublishFormRadioButtonCollectionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormRadioButtonCollectionWhereUniqueInput;
};


export type MutationSchedulePublishFormSelectComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormSelectComponentWhereUniqueInput;
};


export type MutationSchedulePublishFormSelectOptionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormSelectOptionWhereUniqueInput;
};


export type MutationSchedulePublishFormSubmitButtonArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormSubmitButtonWhereUniqueInput;
};


export type MutationSchedulePublishFormSuccessComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormSuccessComponentWhereUniqueInput;
};


export type MutationSchedulePublishFormTextInputArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormTextInputWhereUniqueInput;
};


export type MutationSchedulePublishFormTextareaInputArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormTextareaInputWhereUniqueInput;
};


export type MutationSchedulePublishGenericAccordionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericAccordionWhereUniqueInput;
};


export type MutationSchedulePublishGenericAccordionItemArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericAccordionItemWhereUniqueInput;
};


export type MutationSchedulePublishGenericAccordionTopRatedArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericAccordionTopRatedWhereUniqueInput;
};


export type MutationSchedulePublishGenericCardCarouseComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericCardCarouseComponentWhereUniqueInput;
};


export type MutationSchedulePublishGenericDownloadComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericDownloadComponentWhereUniqueInput;
};


export type MutationSchedulePublishGenericFollowUsArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericFollowUsWhereUniqueInput;
};


export type MutationSchedulePublishGenericGridAuthorableArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericGridAuthorableWhereUniqueInput;
};


export type MutationSchedulePublishGenericHtmlArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericHtmlWhereUniqueInput;
};


export type MutationSchedulePublishGenericLineArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericLineWhereUniqueInput;
};


export type MutationSchedulePublishGenericLinkArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericLinkWhereUniqueInput;
};


export type MutationSchedulePublishGenericPageArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericPageWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishGenericPromotionsOverviewArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericPromotionsOverviewWhereUniqueInput;
};


export type MutationSchedulePublishGenericQualifioArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericQualifioWhereUniqueInput;
};


export type MutationSchedulePublishGenericQualifioOverviewArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericQualifioOverviewWhereUniqueInput;
};


export type MutationSchedulePublishGenericSocialShareArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericSocialShareWhereUniqueInput;
};


export type MutationSchedulePublishGlobalMetaDataArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GlobalMetaDataWhereUniqueInput;
};


export type MutationSchedulePublishGlobalSearchArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GlobalSearchWhereUniqueInput;
};


export type MutationSchedulePublishGridColumnArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GridColumnWhereUniqueInput;
};


export type MutationSchedulePublishGridColumnComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GridColumnComponentWhereUniqueInput;
};


export type MutationSchedulePublishHeroBannerArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: HeroBannerWhereUniqueInput;
};


export type MutationSchedulePublishHeroBannerMasterbrandArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: HeroBannerMasterbrandWhereUniqueInput;
};


export type MutationSchedulePublishHeroCarouselComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: HeroCarouselComponentWhereUniqueInput;
};


export type MutationSchedulePublishHeroComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: HeroComponentWhereUniqueInput;
};


export type MutationSchedulePublishHeroLoopAnimationComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: HeroLoopAnimationComponentWhereUniqueInput;
};


export type MutationSchedulePublishIframeArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: IframeWhereUniqueInput;
};


export type MutationSchedulePublishImageAndTextCardArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ImageAndTextCardWhereUniqueInput;
};


export type MutationSchedulePublishImageCopyArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ImageCopyWhereUniqueInput;
};


export type MutationSchedulePublishImageCopyItemArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ImageCopyItemWhereUniqueInput;
};


export type MutationSchedulePublishIntroTextArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: IntroTextWhereUniqueInput;
};


export type MutationSchedulePublishLeftColumnArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: LeftColumnWhereUniqueInput;
};


export type MutationSchedulePublishLinkArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: LinkWhereUniqueInput;
};


export type MutationSchedulePublishLongTextArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: LongTextWhereUniqueInput;
};


export type MutationSchedulePublishMarketArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: MarketWhereUniqueInput;
};


export type MutationSchedulePublishMarketUserConnectionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: MarketUserConnectionWhereUniqueInput;
};


export type MutationSchedulePublishMetaDataArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: MetaDataWhereUniqueInput;
};


export type MutationSchedulePublishMobileOnlyMainNavigationArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: MobileOnlyMainNavigationWhereUniqueInput;
};


export type MutationSchedulePublishMultiStepPromotionFormArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: MultiStepPromotionFormWhereUniqueInput;
};


export type MutationSchedulePublishNavigationArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: NavigationWhereUniqueInput;
};


export type MutationSchedulePublishNavigationItemArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: NavigationItemWhereUniqueInput;
};


export type MutationSchedulePublishNewsletterComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: NewsletterComponentWhereUniqueInput;
};


export type MutationSchedulePublishNewsletterSubscriptionsArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: NewsletterSubscriptionsWhereUniqueInput;
};


export type MutationSchedulePublishNotificationBannerArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: NotificationBannerWhereUniqueInput;
};


export type MutationSchedulePublishPageFooterArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: PageFooterWhereUniqueInput;
};


export type MutationSchedulePublishPageHeaderArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: PageHeaderWhereUniqueInput;
};


export type MutationSchedulePublishPopularSearchComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: PopularSearchComponentWhereUniqueInput;
};


export type MutationSchedulePublishProductArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ProductWhereUniqueInput;
};


export type MutationSchedulePublishProductBannerArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ProductBannerWhereUniqueInput;
};


export type MutationSchedulePublishProductCategoryArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ProductCategoryWhereUniqueInput;
};


export type MutationSchedulePublishProductCategoryPageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ProductCategoryPageWhereUniqueInput;
};


export type MutationSchedulePublishProductDetailPageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ProductDetailPageWhereUniqueInput;
};


export type MutationSchedulePublishProductHeroArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ProductHeroWhereUniqueInput;
};


export type MutationSchedulePublishProductLabelArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ProductLabelWhereUniqueInput;
};


export type MutationSchedulePublishProductLandingPageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ProductLandingPageWhereUniqueInput;
};


export type MutationSchedulePublishProductSubcategoryPageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ProductSubcategoryPageWhereUniqueInput;
};


export type MutationSchedulePublishPromotionDownloadArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: PromotionDownloadWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishPromotionFormArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: PromotionFormWhereUniqueInput;
};


export type MutationSchedulePublishQuestionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: QuestionWhereUniqueInput;
};


export type MutationSchedulePublishQuestionCheckboxArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: QuestionCheckboxWhereUniqueInput;
};


export type MutationSchedulePublishQuestionCheckboxCollectionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: QuestionCheckboxCollectionWhereUniqueInput;
};


export type MutationSchedulePublishQuestionRadioButtonArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: QuestionRadioButtonWhereUniqueInput;
};


export type MutationSchedulePublishQuestionRadioButtonCollectionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: QuestionRadioButtonCollectionWhereUniqueInput;
};


export type MutationSchedulePublishRatingArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: RatingWhereUniqueInput;
};


export type MutationSchedulePublishRecipeArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: RecipeWhereUniqueInput;
};


export type MutationSchedulePublishRecipeCategoryArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: RecipeCategoryWhereUniqueInput;
};


export type MutationSchedulePublishRecipeLandingPageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: RecipeLandingPageWhereUniqueInput;
};


export type MutationSchedulePublishRecipeSubcategoryArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: RecipeSubcategoryWhereUniqueInput;
};


export type MutationSchedulePublishRecipesComparisonQueryComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: RecipesComparisonQueryComponentWhereUniqueInput;
};


export type MutationSchedulePublishRecipesQueriesReferenceArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: RecipesQueriesReferenceWhereUniqueInput;
};


export type MutationSchedulePublishRecipesQueryComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: RecipesQueryComponentWhereUniqueInput;
};


export type MutationSchedulePublishRedirectArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: RedirectWhereUniqueInput;
};


export type MutationSchedulePublishRewriteArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: RewriteWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishRightColumnArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: RightColumnWhereUniqueInput;
};


export type MutationSchedulePublishSearchInputArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SearchInputWhereUniqueInput;
};


export type MutationSchedulePublishSearchOverlayComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SearchOverlayComponentWhereUniqueInput;
};


export type MutationSchedulePublishSearchResultPageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SearchResultPageWhereUniqueInput;
};


export type MutationSchedulePublishSeparatorArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SeparatorWhereUniqueInput;
};


export type MutationSchedulePublishSingleStepPromotionFormArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SingleStepPromotionFormWhereUniqueInput;
};


export type MutationSchedulePublishSocialMediaListComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SocialMediaListComponentWhereUniqueInput;
};


export type MutationSchedulePublishSpacerArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SpacerWhereUniqueInput;
};


export type MutationSchedulePublishSubCategoryKeyImageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SubCategoryKeyImageWhereUniqueInput;
};


export type MutationSchedulePublishSubTabArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SubTabWhereUniqueInput;
};


export type MutationSchedulePublishSubTabContentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SubTabContentWhereUniqueInput;
};


export type MutationSchedulePublishSustainabilityBannerArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SustainabilityBannerWhereUniqueInput;
};


export type MutationSchedulePublishSustainabilityInfoArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SustainabilityInfoWhereUniqueInput;
};


export type MutationSchedulePublishTabArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TabWhereUniqueInput;
};


export type MutationSchedulePublishTabContentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TabContentWhereUniqueInput;
};


export type MutationSchedulePublishTeaserArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TeaserWhereUniqueInput;
};


export type MutationSchedulePublishTeaserPlaceholderArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TeaserPlaceholderWhereUniqueInput;
};


export type MutationSchedulePublishTeaserSmallArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TeaserSmallWhereUniqueInput;
};


export type MutationSchedulePublishTeaserSmallPlaceholderArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TeaserSmallPlaceholderWhereUniqueInput;
};


export type MutationSchedulePublishTestComponentWithRecipeQueryArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TestComponentWithRecipeQueryWhereUniqueInput;
};


export type MutationSchedulePublishTestTipsANdTricksInAMarketArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};


export type MutationSchedulePublishTextComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TextComponentWhereUniqueInput;
};


export type MutationSchedulePublishTipsAndTricksDetailsPageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};


export type MutationSchedulePublishTitleArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TitleWhereUniqueInput;
};


export type MutationSchedulePublishTwitterSeoArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TwitterSeoWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationScheduleUnpublishAccordionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: AccordionWhereUniqueInput;
};


export type MutationScheduleUnpublishAccordionItemArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: AccordionItemWhereUniqueInput;
};


export type MutationScheduleUnpublishAlgoliaExtensionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: AlgoliaExtensionWhereUniqueInput;
};


export type MutationScheduleUnpublishAnchorNavArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: AnchorNavWhereUniqueInput;
};


export type MutationScheduleUnpublishAnchorNavigationArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AnchorNavigationWhereUniqueInput;
};


export type MutationScheduleUnpublishAnchorNavigationListArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: AnchorNavigationListWhereUniqueInput;
};


export type MutationScheduleUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AssetWhereUniqueInput;
};


export type MutationScheduleUnpublishAssetComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: AssetComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishAudioComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AudioComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishAuthorableContentCardArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: AuthorableContentCardWhereUniqueInput;
};


export type MutationScheduleUnpublishBanner1Args = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: Banner1WhereUniqueInput;
};


export type MutationScheduleUnpublishBanner2Args = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: Banner2WhereUniqueInput;
};


export type MutationScheduleUnpublishBanner2CarouselComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: Banner2CarouselComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishCardComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CardComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishCarouselComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CarouselComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishCarouselSlideArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CarouselSlideWhereUniqueInput;
};


export type MutationScheduleUnpublishCategoryCardArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CategoryCardWhereUniqueInput;
};


export type MutationScheduleUnpublishContactCardArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: ContactCardWhereUniqueInput;
};


export type MutationScheduleUnpublishContactCardContainerArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ContactCardContainerWhereUniqueInput;
};


export type MutationScheduleUnpublishCountrySelectorFooterArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CountrySelectorFooterWhereUniqueInput;
};


export type MutationScheduleUnpublishCountrySelectorItemArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CountrySelectorItemWhereUniqueInput;
};


export type MutationScheduleUnpublishDemoModelArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: DemoModelWhereUniqueInput;
};


export type MutationScheduleUnpublishDictionaryArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: DictionaryWhereUniqueInput;
};


export type MutationScheduleUnpublishDictionaryItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: DictionaryItemWhereUniqueInput;
};


export type MutationScheduleUnpublishDownloadAppArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: DownloadAppWhereUniqueInput;
};


export type MutationScheduleUnpublishDynamicCardGridArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: DynamicCardGridWhereUniqueInput;
};


export type MutationScheduleUnpublishErrorPageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ErrorPageWhereUniqueInput;
};


export type MutationScheduleUnpublishEvalancheFormComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: EvalancheFormComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishExampleComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ExampleComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishFeaturedContentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FeaturedContentWhereUniqueInput;
};


export type MutationScheduleUnpublishFeaturedContentReferenceArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FeaturedContentReferenceWhereUniqueInput;
};


export type MutationScheduleUnpublishFooterNavigationArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FooterNavigationWhereUniqueInput;
};


export type MutationScheduleUnpublishFooterSealArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FooterSealWhereUniqueInput;
};


export type MutationScheduleUnpublishFormArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormWhereUniqueInput;
};


export type MutationScheduleUnpublishFormCheckboxArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormCheckboxWhereUniqueInput;
};


export type MutationScheduleUnpublishFormCheckboxCollectionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormCheckboxCollectionWhereUniqueInput;
};


export type MutationScheduleUnpublishFormDateInputArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormDateInputWhereUniqueInput;
};


export type MutationScheduleUnpublishFormEmailInputArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormEmailInputWhereUniqueInput;
};


export type MutationScheduleUnpublishFormErrorArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormErrorWhereUniqueInput;
};


export type MutationScheduleUnpublishFormFileUploaderArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormFileUploaderWhereUniqueInput;
};


export type MutationScheduleUnpublishFormListArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormListWhereUniqueInput;
};


export type MutationScheduleUnpublishFormListItemArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormListItemWhereUniqueInput;
};


export type MutationScheduleUnpublishFormNumberInputArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormNumberInputWhereUniqueInput;
};


export type MutationScheduleUnpublishFormPasswordInputArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormPasswordInputWhereUniqueInput;
};


export type MutationScheduleUnpublishFormPasswordInputWithConfirmationArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};


export type MutationScheduleUnpublishFormRadioButtonArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormRadioButtonWhereUniqueInput;
};


export type MutationScheduleUnpublishFormRadioButtonCollectionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormRadioButtonCollectionWhereUniqueInput;
};


export type MutationScheduleUnpublishFormSelectComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormSelectComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishFormSelectOptionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormSelectOptionWhereUniqueInput;
};


export type MutationScheduleUnpublishFormSubmitButtonArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormSubmitButtonWhereUniqueInput;
};


export type MutationScheduleUnpublishFormSuccessComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormSuccessComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishFormTextInputArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormTextInputWhereUniqueInput;
};


export type MutationScheduleUnpublishFormTextareaInputArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormTextareaInputWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericAccordionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GenericAccordionWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericAccordionItemArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GenericAccordionItemWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericAccordionTopRatedArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GenericAccordionTopRatedWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericCardCarouseComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GenericCardCarouseComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericDownloadComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GenericDownloadComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericFollowUsArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GenericFollowUsWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericGridAuthorableArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GenericGridAuthorableWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericHtmlArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GenericHtmlWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericLineArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GenericLineWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericLinkArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GenericLinkWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericPageArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GenericPageWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericPromotionsOverviewArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GenericPromotionsOverviewWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericQualifioArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GenericQualifioWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericQualifioOverviewArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GenericQualifioOverviewWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericSocialShareArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GenericSocialShareWhereUniqueInput;
};


export type MutationScheduleUnpublishGlobalMetaDataArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GlobalMetaDataWhereUniqueInput;
};


export type MutationScheduleUnpublishGlobalSearchArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GlobalSearchWhereUniqueInput;
};


export type MutationScheduleUnpublishGridColumnArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GridColumnWhereUniqueInput;
};


export type MutationScheduleUnpublishGridColumnComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GridColumnComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishHeroBannerArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: HeroBannerWhereUniqueInput;
};


export type MutationScheduleUnpublishHeroBannerMasterbrandArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: HeroBannerMasterbrandWhereUniqueInput;
};


export type MutationScheduleUnpublishHeroCarouselComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: HeroCarouselComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishHeroComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: HeroComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishHeroLoopAnimationComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: HeroLoopAnimationComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishIframeArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: IframeWhereUniqueInput;
};


export type MutationScheduleUnpublishImageAndTextCardArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ImageAndTextCardWhereUniqueInput;
};


export type MutationScheduleUnpublishImageCopyArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ImageCopyWhereUniqueInput;
};


export type MutationScheduleUnpublishImageCopyItemArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ImageCopyItemWhereUniqueInput;
};


export type MutationScheduleUnpublishIntroTextArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: IntroTextWhereUniqueInput;
};


export type MutationScheduleUnpublishLeftColumnArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: LeftColumnWhereUniqueInput;
};


export type MutationScheduleUnpublishLinkArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: LinkWhereUniqueInput;
};


export type MutationScheduleUnpublishLongTextArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: LongTextWhereUniqueInput;
};


export type MutationScheduleUnpublishMarketArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: MarketWhereUniqueInput;
};


export type MutationScheduleUnpublishMarketUserConnectionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: MarketUserConnectionWhereUniqueInput;
};


export type MutationScheduleUnpublishMetaDataArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: MetaDataWhereUniqueInput;
};


export type MutationScheduleUnpublishMobileOnlyMainNavigationArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: MobileOnlyMainNavigationWhereUniqueInput;
};


export type MutationScheduleUnpublishMultiStepPromotionFormArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: MultiStepPromotionFormWhereUniqueInput;
};


export type MutationScheduleUnpublishNavigationArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: NavigationWhereUniqueInput;
};


export type MutationScheduleUnpublishNavigationItemArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: NavigationItemWhereUniqueInput;
};


export type MutationScheduleUnpublishNewsletterComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: NewsletterComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishNewsletterSubscriptionsArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: NewsletterSubscriptionsWhereUniqueInput;
};


export type MutationScheduleUnpublishNotificationBannerArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: NotificationBannerWhereUniqueInput;
};


export type MutationScheduleUnpublishPageFooterArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: PageFooterWhereUniqueInput;
};


export type MutationScheduleUnpublishPageHeaderArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: PageHeaderWhereUniqueInput;
};


export type MutationScheduleUnpublishPopularSearchComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: PopularSearchComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishProductArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ProductWhereUniqueInput;
};


export type MutationScheduleUnpublishProductBannerArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ProductBannerWhereUniqueInput;
};


export type MutationScheduleUnpublishProductCategoryArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ProductCategoryWhereUniqueInput;
};


export type MutationScheduleUnpublishProductCategoryPageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ProductCategoryPageWhereUniqueInput;
};


export type MutationScheduleUnpublishProductDetailPageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ProductDetailPageWhereUniqueInput;
};


export type MutationScheduleUnpublishProductHeroArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ProductHeroWhereUniqueInput;
};


export type MutationScheduleUnpublishProductLabelArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ProductLabelWhereUniqueInput;
};


export type MutationScheduleUnpublishProductLandingPageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ProductLandingPageWhereUniqueInput;
};


export type MutationScheduleUnpublishProductSubcategoryPageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ProductSubcategoryPageWhereUniqueInput;
};


export type MutationScheduleUnpublishPromotionDownloadArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: PromotionDownloadWhereUniqueInput;
};


export type MutationScheduleUnpublishPromotionFormArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: PromotionFormWhereUniqueInput;
};


export type MutationScheduleUnpublishQuestionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: QuestionWhereUniqueInput;
};


export type MutationScheduleUnpublishQuestionCheckboxArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: QuestionCheckboxWhereUniqueInput;
};


export type MutationScheduleUnpublishQuestionCheckboxCollectionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: QuestionCheckboxCollectionWhereUniqueInput;
};


export type MutationScheduleUnpublishQuestionRadioButtonArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: QuestionRadioButtonWhereUniqueInput;
};


export type MutationScheduleUnpublishQuestionRadioButtonCollectionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: QuestionRadioButtonCollectionWhereUniqueInput;
};


export type MutationScheduleUnpublishRatingArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: RatingWhereUniqueInput;
};


export type MutationScheduleUnpublishRecipeArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: RecipeWhereUniqueInput;
};


export type MutationScheduleUnpublishRecipeCategoryArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: RecipeCategoryWhereUniqueInput;
};


export type MutationScheduleUnpublishRecipeLandingPageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: RecipeLandingPageWhereUniqueInput;
};


export type MutationScheduleUnpublishRecipeSubcategoryArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: RecipeSubcategoryWhereUniqueInput;
};


export type MutationScheduleUnpublishRecipesComparisonQueryComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: RecipesComparisonQueryComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishRecipesQueriesReferenceArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: RecipesQueriesReferenceWhereUniqueInput;
};


export type MutationScheduleUnpublishRecipesQueryComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: RecipesQueryComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishRedirectArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: RedirectWhereUniqueInput;
};


export type MutationScheduleUnpublishRewriteArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: RewriteWhereUniqueInput;
};


export type MutationScheduleUnpublishRightColumnArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: RightColumnWhereUniqueInput;
};


export type MutationScheduleUnpublishSearchInputArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SearchInputWhereUniqueInput;
};


export type MutationScheduleUnpublishSearchOverlayComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SearchOverlayComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishSearchResultPageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SearchResultPageWhereUniqueInput;
};


export type MutationScheduleUnpublishSeparatorArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SeparatorWhereUniqueInput;
};


export type MutationScheduleUnpublishSingleStepPromotionFormArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SingleStepPromotionFormWhereUniqueInput;
};


export type MutationScheduleUnpublishSocialMediaListComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SocialMediaListComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishSpacerArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SpacerWhereUniqueInput;
};


export type MutationScheduleUnpublishSubCategoryKeyImageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SubCategoryKeyImageWhereUniqueInput;
};


export type MutationScheduleUnpublishSubTabArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SubTabWhereUniqueInput;
};


export type MutationScheduleUnpublishSubTabContentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SubTabContentWhereUniqueInput;
};


export type MutationScheduleUnpublishSustainabilityBannerArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SustainabilityBannerWhereUniqueInput;
};


export type MutationScheduleUnpublishSustainabilityInfoArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SustainabilityInfoWhereUniqueInput;
};


export type MutationScheduleUnpublishTabArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TabWhereUniqueInput;
};


export type MutationScheduleUnpublishTabContentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TabContentWhereUniqueInput;
};


export type MutationScheduleUnpublishTeaserArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TeaserWhereUniqueInput;
};


export type MutationScheduleUnpublishTeaserPlaceholderArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TeaserPlaceholderWhereUniqueInput;
};


export type MutationScheduleUnpublishTeaserSmallArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TeaserSmallWhereUniqueInput;
};


export type MutationScheduleUnpublishTeaserSmallPlaceholderArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TeaserSmallPlaceholderWhereUniqueInput;
};


export type MutationScheduleUnpublishTestComponentWithRecipeQueryArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TestComponentWithRecipeQueryWhereUniqueInput;
};


export type MutationScheduleUnpublishTestTipsANdTricksInAMarketArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};


export type MutationScheduleUnpublishTextComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TextComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishTipsAndTricksDetailsPageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};


export type MutationScheduleUnpublishTitleArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TitleWhereUniqueInput;
};


export type MutationScheduleUnpublishTwitterSeoArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: TwitterSeoWhereUniqueInput;
};


export type MutationUnpublishAccordionArgs = {
  from?: Array<Stage>;
  where: AccordionWhereUniqueInput;
};


export type MutationUnpublishAccordionItemArgs = {
  from?: Array<Stage>;
  where: AccordionItemWhereUniqueInput;
};


export type MutationUnpublishAlgoliaExtensionArgs = {
  from?: Array<Stage>;
  where: AlgoliaExtensionWhereUniqueInput;
};


export type MutationUnpublishAnchorNavArgs = {
  from?: Array<Stage>;
  where: AnchorNavWhereUniqueInput;
};


export type MutationUnpublishAnchorNavigationArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AnchorNavigationWhereUniqueInput;
};


export type MutationUnpublishAnchorNavigationListArgs = {
  from?: Array<Stage>;
  where: AnchorNavigationListWhereUniqueInput;
};


export type MutationUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AssetWhereUniqueInput;
};


export type MutationUnpublishAssetComponentArgs = {
  from?: Array<Stage>;
  where: AssetComponentWhereUniqueInput;
};


export type MutationUnpublishAudioComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AudioComponentWhereUniqueInput;
};


export type MutationUnpublishAuthorableContentCardArgs = {
  from?: Array<Stage>;
  where: AuthorableContentCardWhereUniqueInput;
};


export type MutationUnpublishBanner1Args = {
  from?: Array<Stage>;
  where: Banner1WhereUniqueInput;
};


export type MutationUnpublishBanner2Args = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: Banner2WhereUniqueInput;
};


export type MutationUnpublishBanner2CarouselComponentArgs = {
  from?: Array<Stage>;
  where: Banner2CarouselComponentWhereUniqueInput;
};


export type MutationUnpublishCardComponentArgs = {
  from?: Array<Stage>;
  where: CardComponentWhereUniqueInput;
};


export type MutationUnpublishCarouselComponentArgs = {
  from?: Array<Stage>;
  where: CarouselComponentWhereUniqueInput;
};


export type MutationUnpublishCarouselSlideArgs = {
  from?: Array<Stage>;
  where: CarouselSlideWhereUniqueInput;
};


export type MutationUnpublishCategoryCardArgs = {
  from?: Array<Stage>;
  where: CategoryCardWhereUniqueInput;
};


export type MutationUnpublishContactCardArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: ContactCardWhereUniqueInput;
};


export type MutationUnpublishContactCardContainerArgs = {
  from?: Array<Stage>;
  where: ContactCardContainerWhereUniqueInput;
};


export type MutationUnpublishCountrySelectorFooterArgs = {
  from?: Array<Stage>;
  where: CountrySelectorFooterWhereUniqueInput;
};


export type MutationUnpublishCountrySelectorItemArgs = {
  from?: Array<Stage>;
  where: CountrySelectorItemWhereUniqueInput;
};


export type MutationUnpublishDemoModelArgs = {
  from?: Array<Stage>;
  where: DemoModelWhereUniqueInput;
};


export type MutationUnpublishDictionaryArgs = {
  from?: Array<Stage>;
  where: DictionaryWhereUniqueInput;
};


export type MutationUnpublishDictionaryItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: DictionaryItemWhereUniqueInput;
};


export type MutationUnpublishDownloadAppArgs = {
  from?: Array<Stage>;
  where: DownloadAppWhereUniqueInput;
};


export type MutationUnpublishDynamicCardGridArgs = {
  from?: Array<Stage>;
  where: DynamicCardGridWhereUniqueInput;
};


export type MutationUnpublishErrorPageArgs = {
  from?: Array<Stage>;
  where: ErrorPageWhereUniqueInput;
};


export type MutationUnpublishEvalancheFormComponentArgs = {
  from?: Array<Stage>;
  where: EvalancheFormComponentWhereUniqueInput;
};


export type MutationUnpublishExampleComponentArgs = {
  from?: Array<Stage>;
  where: ExampleComponentWhereUniqueInput;
};


export type MutationUnpublishFeaturedContentArgs = {
  from?: Array<Stage>;
  where: FeaturedContentWhereUniqueInput;
};


export type MutationUnpublishFeaturedContentReferenceArgs = {
  from?: Array<Stage>;
  where: FeaturedContentReferenceWhereUniqueInput;
};


export type MutationUnpublishFooterNavigationArgs = {
  from?: Array<Stage>;
  where: FooterNavigationWhereUniqueInput;
};


export type MutationUnpublishFooterSealArgs = {
  from?: Array<Stage>;
  where: FooterSealWhereUniqueInput;
};


export type MutationUnpublishFormArgs = {
  from?: Array<Stage>;
  where: FormWhereUniqueInput;
};


export type MutationUnpublishFormCheckboxArgs = {
  from?: Array<Stage>;
  where: FormCheckboxWhereUniqueInput;
};


export type MutationUnpublishFormCheckboxCollectionArgs = {
  from?: Array<Stage>;
  where: FormCheckboxCollectionWhereUniqueInput;
};


export type MutationUnpublishFormDateInputArgs = {
  from?: Array<Stage>;
  where: FormDateInputWhereUniqueInput;
};


export type MutationUnpublishFormEmailInputArgs = {
  from?: Array<Stage>;
  where: FormEmailInputWhereUniqueInput;
};


export type MutationUnpublishFormErrorArgs = {
  from?: Array<Stage>;
  where: FormErrorWhereUniqueInput;
};


export type MutationUnpublishFormFileUploaderArgs = {
  from?: Array<Stage>;
  where: FormFileUploaderWhereUniqueInput;
};


export type MutationUnpublishFormListArgs = {
  from?: Array<Stage>;
  where: FormListWhereUniqueInput;
};


export type MutationUnpublishFormListItemArgs = {
  from?: Array<Stage>;
  where: FormListItemWhereUniqueInput;
};


export type MutationUnpublishFormNumberInputArgs = {
  from?: Array<Stage>;
  where: FormNumberInputWhereUniqueInput;
};


export type MutationUnpublishFormPasswordInputArgs = {
  from?: Array<Stage>;
  where: FormPasswordInputWhereUniqueInput;
};


export type MutationUnpublishFormPasswordInputWithConfirmationArgs = {
  from?: Array<Stage>;
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};


export type MutationUnpublishFormRadioButtonArgs = {
  from?: Array<Stage>;
  where: FormRadioButtonWhereUniqueInput;
};


export type MutationUnpublishFormRadioButtonCollectionArgs = {
  from?: Array<Stage>;
  where: FormRadioButtonCollectionWhereUniqueInput;
};


export type MutationUnpublishFormSelectComponentArgs = {
  from?: Array<Stage>;
  where: FormSelectComponentWhereUniqueInput;
};


export type MutationUnpublishFormSelectOptionArgs = {
  from?: Array<Stage>;
  where: FormSelectOptionWhereUniqueInput;
};


export type MutationUnpublishFormSubmitButtonArgs = {
  from?: Array<Stage>;
  where: FormSubmitButtonWhereUniqueInput;
};


export type MutationUnpublishFormSuccessComponentArgs = {
  from?: Array<Stage>;
  where: FormSuccessComponentWhereUniqueInput;
};


export type MutationUnpublishFormTextInputArgs = {
  from?: Array<Stage>;
  where: FormTextInputWhereUniqueInput;
};


export type MutationUnpublishFormTextareaInputArgs = {
  from?: Array<Stage>;
  where: FormTextareaInputWhereUniqueInput;
};


export type MutationUnpublishGenericAccordionArgs = {
  from?: Array<Stage>;
  where: GenericAccordionWhereUniqueInput;
};


export type MutationUnpublishGenericAccordionItemArgs = {
  from?: Array<Stage>;
  where: GenericAccordionItemWhereUniqueInput;
};


export type MutationUnpublishGenericAccordionTopRatedArgs = {
  from?: Array<Stage>;
  where: GenericAccordionTopRatedWhereUniqueInput;
};


export type MutationUnpublishGenericCardCarouseComponentArgs = {
  from?: Array<Stage>;
  where: GenericCardCarouseComponentWhereUniqueInput;
};


export type MutationUnpublishGenericDownloadComponentArgs = {
  from?: Array<Stage>;
  where: GenericDownloadComponentWhereUniqueInput;
};


export type MutationUnpublishGenericFollowUsArgs = {
  from?: Array<Stage>;
  where: GenericFollowUsWhereUniqueInput;
};


export type MutationUnpublishGenericGridAuthorableArgs = {
  from?: Array<Stage>;
  where: GenericGridAuthorableWhereUniqueInput;
};


export type MutationUnpublishGenericHtmlArgs = {
  from?: Array<Stage>;
  where: GenericHtmlWhereUniqueInput;
};


export type MutationUnpublishGenericLineArgs = {
  from?: Array<Stage>;
  where: GenericLineWhereUniqueInput;
};


export type MutationUnpublishGenericLinkArgs = {
  from?: Array<Stage>;
  where: GenericLinkWhereUniqueInput;
};


export type MutationUnpublishGenericPageArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GenericPageWhereUniqueInput;
};


export type MutationUnpublishGenericPromotionsOverviewArgs = {
  from?: Array<Stage>;
  where: GenericPromotionsOverviewWhereUniqueInput;
};


export type MutationUnpublishGenericQualifioArgs = {
  from?: Array<Stage>;
  where: GenericQualifioWhereUniqueInput;
};


export type MutationUnpublishGenericQualifioOverviewArgs = {
  from?: Array<Stage>;
  where: GenericQualifioOverviewWhereUniqueInput;
};


export type MutationUnpublishGenericSocialShareArgs = {
  from?: Array<Stage>;
  where: GenericSocialShareWhereUniqueInput;
};


export type MutationUnpublishGlobalMetaDataArgs = {
  from?: Array<Stage>;
  where: GlobalMetaDataWhereUniqueInput;
};


export type MutationUnpublishGlobalSearchArgs = {
  from?: Array<Stage>;
  where: GlobalSearchWhereUniqueInput;
};


export type MutationUnpublishGridColumnArgs = {
  from?: Array<Stage>;
  where: GridColumnWhereUniqueInput;
};


export type MutationUnpublishGridColumnComponentArgs = {
  from?: Array<Stage>;
  where: GridColumnComponentWhereUniqueInput;
};


export type MutationUnpublishHeroBannerArgs = {
  from?: Array<Stage>;
  where: HeroBannerWhereUniqueInput;
};


export type MutationUnpublishHeroBannerMasterbrandArgs = {
  from?: Array<Stage>;
  where: HeroBannerMasterbrandWhereUniqueInput;
};


export type MutationUnpublishHeroCarouselComponentArgs = {
  from?: Array<Stage>;
  where: HeroCarouselComponentWhereUniqueInput;
};


export type MutationUnpublishHeroComponentArgs = {
  from?: Array<Stage>;
  where: HeroComponentWhereUniqueInput;
};


export type MutationUnpublishHeroLoopAnimationComponentArgs = {
  from?: Array<Stage>;
  where: HeroLoopAnimationComponentWhereUniqueInput;
};


export type MutationUnpublishIframeArgs = {
  from?: Array<Stage>;
  where: IframeWhereUniqueInput;
};


export type MutationUnpublishImageAndTextCardArgs = {
  from?: Array<Stage>;
  where: ImageAndTextCardWhereUniqueInput;
};


export type MutationUnpublishImageCopyArgs = {
  from?: Array<Stage>;
  where: ImageCopyWhereUniqueInput;
};


export type MutationUnpublishImageCopyItemArgs = {
  from?: Array<Stage>;
  where: ImageCopyItemWhereUniqueInput;
};


export type MutationUnpublishIntroTextArgs = {
  from?: Array<Stage>;
  where: IntroTextWhereUniqueInput;
};


export type MutationUnpublishLeftColumnArgs = {
  from?: Array<Stage>;
  where: LeftColumnWhereUniqueInput;
};


export type MutationUnpublishLinkArgs = {
  from?: Array<Stage>;
  where: LinkWhereUniqueInput;
};


export type MutationUnpublishLongTextArgs = {
  from?: Array<Stage>;
  where: LongTextWhereUniqueInput;
};


export type MutationUnpublishManyAccordionItemsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AccordionItemManyWhereInput>;
};


export type MutationUnpublishManyAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AccordionItemManyWhereInput>;
};


export type MutationUnpublishManyAccordionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AccordionManyWhereInput>;
};


export type MutationUnpublishManyAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AccordionManyWhereInput>;
};


export type MutationUnpublishManyAlgoliaExtensionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AlgoliaExtensionManyWhereInput>;
};


export type MutationUnpublishManyAlgoliaExtensionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AlgoliaExtensionManyWhereInput>;
};


export type MutationUnpublishManyAnchorNavigationListsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AnchorNavigationListManyWhereInput>;
};


export type MutationUnpublishManyAnchorNavigationListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AnchorNavigationListManyWhereInput>;
};


export type MutationUnpublishManyAnchorNavigationsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnchorNavigationManyWhereInput>;
};


export type MutationUnpublishManyAnchorNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnchorNavigationManyWhereInput>;
};


export type MutationUnpublishManyAnchorNavsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AnchorNavManyWhereInput>;
};


export type MutationUnpublishManyAnchorNavsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AnchorNavManyWhereInput>;
};


export type MutationUnpublishManyAssetsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUnpublishManyAssetsComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AssetComponentManyWhereInput>;
};


export type MutationUnpublishManyAssetsComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AssetComponentManyWhereInput>;
};


export type MutationUnpublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUnpublishManyAudioComponentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AudioComponentManyWhereInput>;
};


export type MutationUnpublishManyAudioComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AudioComponentManyWhereInput>;
};


export type MutationUnpublishManyAuthorableContentCardsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AuthorableContentCardManyWhereInput>;
};


export type MutationUnpublishManyAuthorableContentCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AuthorableContentCardManyWhereInput>;
};


export type MutationUnpublishManyBanner1sArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<Banner1ManyWhereInput>;
};


export type MutationUnpublishManyBanner1sConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<Banner1ManyWhereInput>;
};


export type MutationUnpublishManyBanner2CarouselComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<Banner2CarouselComponentManyWhereInput>;
};


export type MutationUnpublishManyBanner2CarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<Banner2CarouselComponentManyWhereInput>;
};


export type MutationUnpublishManyBanner2SArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Banner2ManyWhereInput>;
};


export type MutationUnpublishManyBanner2SConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Banner2ManyWhereInput>;
};


export type MutationUnpublishManyCardComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CardComponentManyWhereInput>;
};


export type MutationUnpublishManyCardComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CardComponentManyWhereInput>;
};


export type MutationUnpublishManyCarouselComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CarouselComponentManyWhereInput>;
};


export type MutationUnpublishManyCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CarouselComponentManyWhereInput>;
};


export type MutationUnpublishManyCarouselSlidesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CarouselSlideManyWhereInput>;
};


export type MutationUnpublishManyCarouselSlidesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CarouselSlideManyWhereInput>;
};


export type MutationUnpublishManyCategoryCardsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CategoryCardManyWhereInput>;
};


export type MutationUnpublishManyCategoryCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CategoryCardManyWhereInput>;
};


export type MutationUnpublishManyContactCardContainersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ContactCardContainerManyWhereInput>;
};


export type MutationUnpublishManyContactCardContainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ContactCardContainerManyWhereInput>;
};


export type MutationUnpublishManyContactCardsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContactCardManyWhereInput>;
};


export type MutationUnpublishManyContactCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContactCardManyWhereInput>;
};


export type MutationUnpublishManyCountrySelectorFootersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CountrySelectorFooterManyWhereInput>;
};


export type MutationUnpublishManyCountrySelectorFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CountrySelectorFooterManyWhereInput>;
};


export type MutationUnpublishManyCountrySelectorItemsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CountrySelectorItemManyWhereInput>;
};


export type MutationUnpublishManyCountrySelectorItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CountrySelectorItemManyWhereInput>;
};


export type MutationUnpublishManyDemoModelsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<DemoModelManyWhereInput>;
};


export type MutationUnpublishManyDemoModelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<DemoModelManyWhereInput>;
};


export type MutationUnpublishManyDictionariesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<DictionaryManyWhereInput>;
};


export type MutationUnpublishManyDictionariesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<DictionaryManyWhereInput>;
};


export type MutationUnpublishManyDictionaryItemsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DictionaryItemManyWhereInput>;
};


export type MutationUnpublishManyDictionaryItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DictionaryItemManyWhereInput>;
};


export type MutationUnpublishManyDownloadAppsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<DownloadAppManyWhereInput>;
};


export type MutationUnpublishManyDownloadAppsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<DownloadAppManyWhereInput>;
};


export type MutationUnpublishManyDynamicCardGridsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<DynamicCardGridManyWhereInput>;
};


export type MutationUnpublishManyDynamicCardGridsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<DynamicCardGridManyWhereInput>;
};


export type MutationUnpublishManyErrorPagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ErrorPageManyWhereInput>;
};


export type MutationUnpublishManyErrorPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ErrorPageManyWhereInput>;
};


export type MutationUnpublishManyEvalancheFormComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<EvalancheFormComponentManyWhereInput>;
};


export type MutationUnpublishManyEvalancheFormComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<EvalancheFormComponentManyWhereInput>;
};


export type MutationUnpublishManyExampleComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ExampleComponentManyWhereInput>;
};


export type MutationUnpublishManyExampleComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ExampleComponentManyWhereInput>;
};


export type MutationUnpublishManyFeaturedContentReferencesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FeaturedContentReferenceManyWhereInput>;
};


export type MutationUnpublishManyFeaturedContentReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FeaturedContentReferenceManyWhereInput>;
};


export type MutationUnpublishManyFeaturedContentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FeaturedContentManyWhereInput>;
};


export type MutationUnpublishManyFeaturedContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FeaturedContentManyWhereInput>;
};


export type MutationUnpublishManyFooterNavigationsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FooterNavigationManyWhereInput>;
};


export type MutationUnpublishManyFooterNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FooterNavigationManyWhereInput>;
};


export type MutationUnpublishManyFooterSealsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FooterSealManyWhereInput>;
};


export type MutationUnpublishManyFooterSealsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FooterSealManyWhereInput>;
};


export type MutationUnpublishManyFormCheckboxCollectionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormCheckboxCollectionManyWhereInput>;
};


export type MutationUnpublishManyFormCheckboxCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormCheckboxCollectionManyWhereInput>;
};


export type MutationUnpublishManyFormCheckboxesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormCheckboxManyWhereInput>;
};


export type MutationUnpublishManyFormCheckboxesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormCheckboxManyWhereInput>;
};


export type MutationUnpublishManyFormDateInputsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormDateInputManyWhereInput>;
};


export type MutationUnpublishManyFormDateInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormDateInputManyWhereInput>;
};


export type MutationUnpublishManyFormEmailInputsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormEmailInputManyWhereInput>;
};


export type MutationUnpublishManyFormEmailInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormEmailInputManyWhereInput>;
};


export type MutationUnpublishManyFormErrorsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormErrorManyWhereInput>;
};


export type MutationUnpublishManyFormErrorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormErrorManyWhereInput>;
};


export type MutationUnpublishManyFormFileUploadersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormFileUploaderManyWhereInput>;
};


export type MutationUnpublishManyFormFileUploadersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormFileUploaderManyWhereInput>;
};


export type MutationUnpublishManyFormListItemsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormListItemManyWhereInput>;
};


export type MutationUnpublishManyFormListItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormListItemManyWhereInput>;
};


export type MutationUnpublishManyFormListsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormListManyWhereInput>;
};


export type MutationUnpublishManyFormListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormListManyWhereInput>;
};


export type MutationUnpublishManyFormNumberInputsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormNumberInputManyWhereInput>;
};


export type MutationUnpublishManyFormNumberInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormNumberInputManyWhereInput>;
};


export type MutationUnpublishManyFormPasswordInputWithConfirmationsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormPasswordInputWithConfirmationManyWhereInput>;
};


export type MutationUnpublishManyFormPasswordInputWithConfirmationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormPasswordInputWithConfirmationManyWhereInput>;
};


export type MutationUnpublishManyFormPasswordInputsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormPasswordInputManyWhereInput>;
};


export type MutationUnpublishManyFormPasswordInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormPasswordInputManyWhereInput>;
};


export type MutationUnpublishManyFormRadioButtonCollectionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormRadioButtonCollectionManyWhereInput>;
};


export type MutationUnpublishManyFormRadioButtonCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormRadioButtonCollectionManyWhereInput>;
};


export type MutationUnpublishManyFormRadioButtonsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormRadioButtonManyWhereInput>;
};


export type MutationUnpublishManyFormRadioButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormRadioButtonManyWhereInput>;
};


export type MutationUnpublishManyFormSelectComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormSelectComponentManyWhereInput>;
};


export type MutationUnpublishManyFormSelectComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormSelectComponentManyWhereInput>;
};


export type MutationUnpublishManyFormSelectOptionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormSelectOptionManyWhereInput>;
};


export type MutationUnpublishManyFormSelectOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormSelectOptionManyWhereInput>;
};


export type MutationUnpublishManyFormSubmitButtonsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormSubmitButtonManyWhereInput>;
};


export type MutationUnpublishManyFormSubmitButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormSubmitButtonManyWhereInput>;
};


export type MutationUnpublishManyFormSuccessComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormSuccessComponentManyWhereInput>;
};


export type MutationUnpublishManyFormSuccessComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormSuccessComponentManyWhereInput>;
};


export type MutationUnpublishManyFormTextInputsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormTextInputManyWhereInput>;
};


export type MutationUnpublishManyFormTextInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormTextInputManyWhereInput>;
};


export type MutationUnpublishManyFormTextareaInputsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormTextareaInputManyWhereInput>;
};


export type MutationUnpublishManyFormTextareaInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormTextareaInputManyWhereInput>;
};


export type MutationUnpublishManyFormsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationUnpublishManyFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationUnpublishManyGenericAccordionItemsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GenericAccordionItemManyWhereInput>;
};


export type MutationUnpublishManyGenericAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GenericAccordionItemManyWhereInput>;
};


export type MutationUnpublishManyGenericAccordionTopRatedsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GenericAccordionTopRatedManyWhereInput>;
};


export type MutationUnpublishManyGenericAccordionTopRatedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GenericAccordionTopRatedManyWhereInput>;
};


export type MutationUnpublishManyGenericAccordionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GenericAccordionManyWhereInput>;
};


export type MutationUnpublishManyGenericAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GenericAccordionManyWhereInput>;
};


export type MutationUnpublishManyGenericCardCarouseComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GenericCardCarouseComponentManyWhereInput>;
};


export type MutationUnpublishManyGenericCardCarouseComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GenericCardCarouseComponentManyWhereInput>;
};


export type MutationUnpublishManyGenericDownloadComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GenericDownloadComponentManyWhereInput>;
};


export type MutationUnpublishManyGenericDownloadComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GenericDownloadComponentManyWhereInput>;
};


export type MutationUnpublishManyGenericFollowUsesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GenericFollowUsManyWhereInput>;
};


export type MutationUnpublishManyGenericFollowUsesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GenericFollowUsManyWhereInput>;
};


export type MutationUnpublishManyGenericGridAuthorablesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GenericGridAuthorableManyWhereInput>;
};


export type MutationUnpublishManyGenericGridAuthorablesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GenericGridAuthorableManyWhereInput>;
};


export type MutationUnpublishManyGenericHtmlsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GenericHtmlManyWhereInput>;
};


export type MutationUnpublishManyGenericHtmlsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GenericHtmlManyWhereInput>;
};


export type MutationUnpublishManyGenericLinesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GenericLineManyWhereInput>;
};


export type MutationUnpublishManyGenericLinesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GenericLineManyWhereInput>;
};


export type MutationUnpublishManyGenericLinksArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GenericLinkManyWhereInput>;
};


export type MutationUnpublishManyGenericLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GenericLinkManyWhereInput>;
};


export type MutationUnpublishManyGenericPagesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericPageManyWhereInput>;
};


export type MutationUnpublishManyGenericPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericPageManyWhereInput>;
};


export type MutationUnpublishManyGenericPromotionsOverviewsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GenericPromotionsOverviewManyWhereInput>;
};


export type MutationUnpublishManyGenericPromotionsOverviewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GenericPromotionsOverviewManyWhereInput>;
};


export type MutationUnpublishManyGenericQualifioOverviewsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GenericQualifioOverviewManyWhereInput>;
};


export type MutationUnpublishManyGenericQualifioOverviewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GenericQualifioOverviewManyWhereInput>;
};


export type MutationUnpublishManyGenericQualifiosArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GenericQualifioManyWhereInput>;
};


export type MutationUnpublishManyGenericQualifiosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GenericQualifioManyWhereInput>;
};


export type MutationUnpublishManyGenericSocialSharesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GenericSocialShareManyWhereInput>;
};


export type MutationUnpublishManyGenericSocialSharesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GenericSocialShareManyWhereInput>;
};


export type MutationUnpublishManyGlobalMetaDatasArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GlobalMetaDataManyWhereInput>;
};


export type MutationUnpublishManyGlobalMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GlobalMetaDataManyWhereInput>;
};


export type MutationUnpublishManyGlobalSearchesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GlobalSearchManyWhereInput>;
};


export type MutationUnpublishManyGlobalSearchesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GlobalSearchManyWhereInput>;
};


export type MutationUnpublishManyGridColumnComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GridColumnComponentManyWhereInput>;
};


export type MutationUnpublishManyGridColumnComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GridColumnComponentManyWhereInput>;
};


export type MutationUnpublishManyGridColumnsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GridColumnManyWhereInput>;
};


export type MutationUnpublishManyGridColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GridColumnManyWhereInput>;
};


export type MutationUnpublishManyHeroBannerMasterbrandsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<HeroBannerMasterbrandManyWhereInput>;
};


export type MutationUnpublishManyHeroBannerMasterbrandsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<HeroBannerMasterbrandManyWhereInput>;
};


export type MutationUnpublishManyHeroBannersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<HeroBannerManyWhereInput>;
};


export type MutationUnpublishManyHeroBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<HeroBannerManyWhereInput>;
};


export type MutationUnpublishManyHeroCarouselComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<HeroCarouselComponentManyWhereInput>;
};


export type MutationUnpublishManyHeroCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<HeroCarouselComponentManyWhereInput>;
};


export type MutationUnpublishManyHeroComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<HeroComponentManyWhereInput>;
};


export type MutationUnpublishManyHeroComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<HeroComponentManyWhereInput>;
};


export type MutationUnpublishManyHeroLoopAnimationComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<HeroLoopAnimationComponentManyWhereInput>;
};


export type MutationUnpublishManyHeroLoopAnimationComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<HeroLoopAnimationComponentManyWhereInput>;
};


export type MutationUnpublishManyIframesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<IframeManyWhereInput>;
};


export type MutationUnpublishManyIframesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<IframeManyWhereInput>;
};


export type MutationUnpublishManyImageAndTextCardsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ImageAndTextCardManyWhereInput>;
};


export type MutationUnpublishManyImageAndTextCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ImageAndTextCardManyWhereInput>;
};


export type MutationUnpublishManyImageCopiesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ImageCopyManyWhereInput>;
};


export type MutationUnpublishManyImageCopiesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ImageCopyManyWhereInput>;
};


export type MutationUnpublishManyImageCopyItemsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ImageCopyItemManyWhereInput>;
};


export type MutationUnpublishManyImageCopyItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ImageCopyItemManyWhereInput>;
};


export type MutationUnpublishManyIntroTextsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<IntroTextManyWhereInput>;
};


export type MutationUnpublishManyIntroTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<IntroTextManyWhereInput>;
};


export type MutationUnpublishManyLeftColumnsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<LeftColumnManyWhereInput>;
};


export type MutationUnpublishManyLeftColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<LeftColumnManyWhereInput>;
};


export type MutationUnpublishManyLinksArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationUnpublishManyLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationUnpublishManyLongTextsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<LongTextManyWhereInput>;
};


export type MutationUnpublishManyLongTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<LongTextManyWhereInput>;
};


export type MutationUnpublishManyMarketUserConnectionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<MarketUserConnectionManyWhereInput>;
};


export type MutationUnpublishManyMarketUserConnectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<MarketUserConnectionManyWhereInput>;
};


export type MutationUnpublishManyMarketsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<MarketManyWhereInput>;
};


export type MutationUnpublishManyMarketsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<MarketManyWhereInput>;
};


export type MutationUnpublishManyMetaDatasArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<MetaDataManyWhereInput>;
};


export type MutationUnpublishManyMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<MetaDataManyWhereInput>;
};


export type MutationUnpublishManyMobileOnlyMainNavigationsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<MobileOnlyMainNavigationManyWhereInput>;
};


export type MutationUnpublishManyMobileOnlyMainNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<MobileOnlyMainNavigationManyWhereInput>;
};


export type MutationUnpublishManyMultiStepPromotionFormsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<MultiStepPromotionFormManyWhereInput>;
};


export type MutationUnpublishManyMultiStepPromotionFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<MultiStepPromotionFormManyWhereInput>;
};


export type MutationUnpublishManyNavigationItemsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<NavigationItemManyWhereInput>;
};


export type MutationUnpublishManyNavigationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<NavigationItemManyWhereInput>;
};


export type MutationUnpublishManyNavigationsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationUnpublishManyNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationUnpublishManyNewsletterComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<NewsletterComponentManyWhereInput>;
};


export type MutationUnpublishManyNewsletterComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<NewsletterComponentManyWhereInput>;
};


export type MutationUnpublishManyNewsletterSubscriptionsPluralArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<NewsletterSubscriptionsManyWhereInput>;
};


export type MutationUnpublishManyNewsletterSubscriptionsPluralConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<NewsletterSubscriptionsManyWhereInput>;
};


export type MutationUnpublishManyNotificationBannersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<NotificationBannerManyWhereInput>;
};


export type MutationUnpublishManyNotificationBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<NotificationBannerManyWhereInput>;
};


export type MutationUnpublishManyPageFootersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<PageFooterManyWhereInput>;
};


export type MutationUnpublishManyPageFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<PageFooterManyWhereInput>;
};


export type MutationUnpublishManyPageHeadersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<PageHeaderManyWhereInput>;
};


export type MutationUnpublishManyPageHeadersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<PageHeaderManyWhereInput>;
};


export type MutationUnpublishManyPopularSearchComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<PopularSearchComponentManyWhereInput>;
};


export type MutationUnpublishManyPopularSearchComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<PopularSearchComponentManyWhereInput>;
};


export type MutationUnpublishManyProductBannersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ProductBannerManyWhereInput>;
};


export type MutationUnpublishManyProductBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ProductBannerManyWhereInput>;
};


export type MutationUnpublishManyProductCategoriesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ProductCategoryManyWhereInput>;
};


export type MutationUnpublishManyProductCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ProductCategoryManyWhereInput>;
};


export type MutationUnpublishManyProductCategoryPagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ProductCategoryPageManyWhereInput>;
};


export type MutationUnpublishManyProductCategoryPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ProductCategoryPageManyWhereInput>;
};


export type MutationUnpublishManyProductDetailPagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ProductDetailPageManyWhereInput>;
};


export type MutationUnpublishManyProductDetailPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ProductDetailPageManyWhereInput>;
};


export type MutationUnpublishManyProductHeroesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ProductHeroManyWhereInput>;
};


export type MutationUnpublishManyProductHeroesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ProductHeroManyWhereInput>;
};


export type MutationUnpublishManyProductLabelsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ProductLabelManyWhereInput>;
};


export type MutationUnpublishManyProductLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ProductLabelManyWhereInput>;
};


export type MutationUnpublishManyProductLandingPagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ProductLandingPageManyWhereInput>;
};


export type MutationUnpublishManyProductLandingPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ProductLandingPageManyWhereInput>;
};


export type MutationUnpublishManyProductSubcategoryPagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ProductSubcategoryPageManyWhereInput>;
};


export type MutationUnpublishManyProductSubcategoryPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ProductSubcategoryPageManyWhereInput>;
};


export type MutationUnpublishManyProductsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ProductManyWhereInput>;
};


export type MutationUnpublishManyProductsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ProductManyWhereInput>;
};


export type MutationUnpublishManyPromotionDownloadsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PromotionDownloadManyWhereInput>;
};


export type MutationUnpublishManyPromotionDownloadsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PromotionDownloadManyWhereInput>;
};


export type MutationUnpublishManyPromotionFormsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<PromotionFormManyWhereInput>;
};


export type MutationUnpublishManyPromotionFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<PromotionFormManyWhereInput>;
};


export type MutationUnpublishManyQuestionCheckboxCollectionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<QuestionCheckboxCollectionManyWhereInput>;
};


export type MutationUnpublishManyQuestionCheckboxCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<QuestionCheckboxCollectionManyWhereInput>;
};


export type MutationUnpublishManyQuestionCheckboxesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<QuestionCheckboxManyWhereInput>;
};


export type MutationUnpublishManyQuestionCheckboxesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<QuestionCheckboxManyWhereInput>;
};


export type MutationUnpublishManyQuestionRadioButtonCollectionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<QuestionRadioButtonCollectionManyWhereInput>;
};


export type MutationUnpublishManyQuestionRadioButtonCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<QuestionRadioButtonCollectionManyWhereInput>;
};


export type MutationUnpublishManyQuestionRadioButtonsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<QuestionRadioButtonManyWhereInput>;
};


export type MutationUnpublishManyQuestionRadioButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<QuestionRadioButtonManyWhereInput>;
};


export type MutationUnpublishManyQuestionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<QuestionManyWhereInput>;
};


export type MutationUnpublishManyQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<QuestionManyWhereInput>;
};


export type MutationUnpublishManyRatingsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<RatingManyWhereInput>;
};


export type MutationUnpublishManyRatingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<RatingManyWhereInput>;
};


export type MutationUnpublishManyRecipeCategoriesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<RecipeCategoryManyWhereInput>;
};


export type MutationUnpublishManyRecipeCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<RecipeCategoryManyWhereInput>;
};


export type MutationUnpublishManyRecipeLandingPagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<RecipeLandingPageManyWhereInput>;
};


export type MutationUnpublishManyRecipeLandingPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<RecipeLandingPageManyWhereInput>;
};


export type MutationUnpublishManyRecipeSubcategoriesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<RecipeSubcategoryManyWhereInput>;
};


export type MutationUnpublishManyRecipeSubcategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<RecipeSubcategoryManyWhereInput>;
};


export type MutationUnpublishManyRecipesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<RecipeManyWhereInput>;
};


export type MutationUnpublishManyRecipesComparisonQueryComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<RecipesComparisonQueryComponentManyWhereInput>;
};


export type MutationUnpublishManyRecipesComparisonQueryComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<RecipesComparisonQueryComponentManyWhereInput>;
};


export type MutationUnpublishManyRecipesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<RecipeManyWhereInput>;
};


export type MutationUnpublishManyRecipesQueriesReferencesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<RecipesQueriesReferenceManyWhereInput>;
};


export type MutationUnpublishManyRecipesQueriesReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<RecipesQueriesReferenceManyWhereInput>;
};


export type MutationUnpublishManyRecipesQueryComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<RecipesQueryComponentManyWhereInput>;
};


export type MutationUnpublishManyRecipesQueryComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<RecipesQueryComponentManyWhereInput>;
};


export type MutationUnpublishManyRedirectsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationUnpublishManyRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationUnpublishManyRewritesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RewriteManyWhereInput>;
};


export type MutationUnpublishManyRewritesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RewriteManyWhereInput>;
};


export type MutationUnpublishManyRightColumnsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<RightColumnManyWhereInput>;
};


export type MutationUnpublishManyRightColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<RightColumnManyWhereInput>;
};


export type MutationUnpublishManySearchInputsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SearchInputManyWhereInput>;
};


export type MutationUnpublishManySearchInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SearchInputManyWhereInput>;
};


export type MutationUnpublishManySearchOverlayComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SearchOverlayComponentManyWhereInput>;
};


export type MutationUnpublishManySearchOverlayComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SearchOverlayComponentManyWhereInput>;
};


export type MutationUnpublishManySearchResultPagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SearchResultPageManyWhereInput>;
};


export type MutationUnpublishManySearchResultPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SearchResultPageManyWhereInput>;
};


export type MutationUnpublishManySeparatorsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SeparatorManyWhereInput>;
};


export type MutationUnpublishManySeparatorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SeparatorManyWhereInput>;
};


export type MutationUnpublishManySingleStepPromotionFormsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SingleStepPromotionFormManyWhereInput>;
};


export type MutationUnpublishManySingleStepPromotionFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SingleStepPromotionFormManyWhereInput>;
};


export type MutationUnpublishManySocialMediaListComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SocialMediaListComponentManyWhereInput>;
};


export type MutationUnpublishManySocialMediaListComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SocialMediaListComponentManyWhereInput>;
};


export type MutationUnpublishManySpacersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SpacerManyWhereInput>;
};


export type MutationUnpublishManySpacersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SpacerManyWhereInput>;
};


export type MutationUnpublishManySubCategoryKeyImagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SubCategoryKeyImageManyWhereInput>;
};


export type MutationUnpublishManySubCategoryKeyImagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SubCategoryKeyImageManyWhereInput>;
};


export type MutationUnpublishManySubTabsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SubTabManyWhereInput>;
};


export type MutationUnpublishManySubTabsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SubTabManyWhereInput>;
};


export type MutationUnpublishManySubTabsContentArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SubTabContentManyWhereInput>;
};


export type MutationUnpublishManySubTabsContentConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SubTabContentManyWhereInput>;
};


export type MutationUnpublishManySustainabilityBannersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SustainabilityBannerManyWhereInput>;
};


export type MutationUnpublishManySustainabilityBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SustainabilityBannerManyWhereInput>;
};


export type MutationUnpublishManySustainabilityInfosArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SustainabilityInfoManyWhereInput>;
};


export type MutationUnpublishManySustainabilityInfosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SustainabilityInfoManyWhereInput>;
};


export type MutationUnpublishManyTabContentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TabContentManyWhereInput>;
};


export type MutationUnpublishManyTabContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TabContentManyWhereInput>;
};


export type MutationUnpublishManyTabsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TabManyWhereInput>;
};


export type MutationUnpublishManyTabsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TabManyWhereInput>;
};


export type MutationUnpublishManyTeaserPlaceholdersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TeaserPlaceholderManyWhereInput>;
};


export type MutationUnpublishManyTeaserPlaceholdersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TeaserPlaceholderManyWhereInput>;
};


export type MutationUnpublishManyTeaserSmallPlaceholdersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TeaserSmallPlaceholderManyWhereInput>;
};


export type MutationUnpublishManyTeaserSmallPlaceholdersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TeaserSmallPlaceholderManyWhereInput>;
};


export type MutationUnpublishManyTeaserSmallsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TeaserSmallManyWhereInput>;
};


export type MutationUnpublishManyTeaserSmallsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TeaserSmallManyWhereInput>;
};


export type MutationUnpublishManyTeasersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TeaserManyWhereInput>;
};


export type MutationUnpublishManyTeasersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TeaserManyWhereInput>;
};


export type MutationUnpublishManyTestComponentWithRecipeQueriesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TestComponentWithRecipeQueryManyWhereInput>;
};


export type MutationUnpublishManyTestComponentWithRecipeQueriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TestComponentWithRecipeQueryManyWhereInput>;
};


export type MutationUnpublishManyTestTipsANdTricksInAMarketsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TestTipsANdTricksInAMarketManyWhereInput>;
};


export type MutationUnpublishManyTestTipsANdTricksInAMarketsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TestTipsANdTricksInAMarketManyWhereInput>;
};


export type MutationUnpublishManyTextComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TextComponentManyWhereInput>;
};


export type MutationUnpublishManyTextComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TextComponentManyWhereInput>;
};


export type MutationUnpublishManyTipsAndTricksDetailsPagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TipsAndTricksDetailsPageManyWhereInput>;
};


export type MutationUnpublishManyTipsAndTricksDetailsPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TipsAndTricksDetailsPageManyWhereInput>;
};


export type MutationUnpublishManyTitlesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TitleManyWhereInput>;
};


export type MutationUnpublishManyTitlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TitleManyWhereInput>;
};


export type MutationUnpublishManyTwitterSeosArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TwitterSeoManyWhereInput>;
};


export type MutationUnpublishManyTwitterSeosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TwitterSeoManyWhereInput>;
};


export type MutationUnpublishMarketArgs = {
  from?: Array<Stage>;
  where: MarketWhereUniqueInput;
};


export type MutationUnpublishMarketUserConnectionArgs = {
  from?: Array<Stage>;
  where: MarketUserConnectionWhereUniqueInput;
};


export type MutationUnpublishMetaDataArgs = {
  from?: Array<Stage>;
  where: MetaDataWhereUniqueInput;
};


export type MutationUnpublishMobileOnlyMainNavigationArgs = {
  from?: Array<Stage>;
  where: MobileOnlyMainNavigationWhereUniqueInput;
};


export type MutationUnpublishMultiStepPromotionFormArgs = {
  from?: Array<Stage>;
  where: MultiStepPromotionFormWhereUniqueInput;
};


export type MutationUnpublishNavigationArgs = {
  from?: Array<Stage>;
  where: NavigationWhereUniqueInput;
};


export type MutationUnpublishNavigationItemArgs = {
  from?: Array<Stage>;
  where: NavigationItemWhereUniqueInput;
};


export type MutationUnpublishNewsletterComponentArgs = {
  from?: Array<Stage>;
  where: NewsletterComponentWhereUniqueInput;
};


export type MutationUnpublishNewsletterSubscriptionsArgs = {
  from?: Array<Stage>;
  where: NewsletterSubscriptionsWhereUniqueInput;
};


export type MutationUnpublishNotificationBannerArgs = {
  from?: Array<Stage>;
  where: NotificationBannerWhereUniqueInput;
};


export type MutationUnpublishPageFooterArgs = {
  from?: Array<Stage>;
  where: PageFooterWhereUniqueInput;
};


export type MutationUnpublishPageHeaderArgs = {
  from?: Array<Stage>;
  where: PageHeaderWhereUniqueInput;
};


export type MutationUnpublishPopularSearchComponentArgs = {
  from?: Array<Stage>;
  where: PopularSearchComponentWhereUniqueInput;
};


export type MutationUnpublishProductArgs = {
  from?: Array<Stage>;
  where: ProductWhereUniqueInput;
};


export type MutationUnpublishProductBannerArgs = {
  from?: Array<Stage>;
  where: ProductBannerWhereUniqueInput;
};


export type MutationUnpublishProductCategoryArgs = {
  from?: Array<Stage>;
  where: ProductCategoryWhereUniqueInput;
};


export type MutationUnpublishProductCategoryPageArgs = {
  from?: Array<Stage>;
  where: ProductCategoryPageWhereUniqueInput;
};


export type MutationUnpublishProductDetailPageArgs = {
  from?: Array<Stage>;
  where: ProductDetailPageWhereUniqueInput;
};


export type MutationUnpublishProductHeroArgs = {
  from?: Array<Stage>;
  where: ProductHeroWhereUniqueInput;
};


export type MutationUnpublishProductLabelArgs = {
  from?: Array<Stage>;
  where: ProductLabelWhereUniqueInput;
};


export type MutationUnpublishProductLandingPageArgs = {
  from?: Array<Stage>;
  where: ProductLandingPageWhereUniqueInput;
};


export type MutationUnpublishProductSubcategoryPageArgs = {
  from?: Array<Stage>;
  where: ProductSubcategoryPageWhereUniqueInput;
};


export type MutationUnpublishPromotionDownloadArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: PromotionDownloadWhereUniqueInput;
};


export type MutationUnpublishPromotionFormArgs = {
  from?: Array<Stage>;
  where: PromotionFormWhereUniqueInput;
};


export type MutationUnpublishQuestionArgs = {
  from?: Array<Stage>;
  where: QuestionWhereUniqueInput;
};


export type MutationUnpublishQuestionCheckboxArgs = {
  from?: Array<Stage>;
  where: QuestionCheckboxWhereUniqueInput;
};


export type MutationUnpublishQuestionCheckboxCollectionArgs = {
  from?: Array<Stage>;
  where: QuestionCheckboxCollectionWhereUniqueInput;
};


export type MutationUnpublishQuestionRadioButtonArgs = {
  from?: Array<Stage>;
  where: QuestionRadioButtonWhereUniqueInput;
};


export type MutationUnpublishQuestionRadioButtonCollectionArgs = {
  from?: Array<Stage>;
  where: QuestionRadioButtonCollectionWhereUniqueInput;
};


export type MutationUnpublishRatingArgs = {
  from?: Array<Stage>;
  where: RatingWhereUniqueInput;
};


export type MutationUnpublishRecipeArgs = {
  from?: Array<Stage>;
  where: RecipeWhereUniqueInput;
};


export type MutationUnpublishRecipeCategoryArgs = {
  from?: Array<Stage>;
  where: RecipeCategoryWhereUniqueInput;
};


export type MutationUnpublishRecipeLandingPageArgs = {
  from?: Array<Stage>;
  where: RecipeLandingPageWhereUniqueInput;
};


export type MutationUnpublishRecipeSubcategoryArgs = {
  from?: Array<Stage>;
  where: RecipeSubcategoryWhereUniqueInput;
};


export type MutationUnpublishRecipesComparisonQueryComponentArgs = {
  from?: Array<Stage>;
  where: RecipesComparisonQueryComponentWhereUniqueInput;
};


export type MutationUnpublishRecipesQueriesReferenceArgs = {
  from?: Array<Stage>;
  where: RecipesQueriesReferenceWhereUniqueInput;
};


export type MutationUnpublishRecipesQueryComponentArgs = {
  from?: Array<Stage>;
  where: RecipesQueryComponentWhereUniqueInput;
};


export type MutationUnpublishRedirectArgs = {
  from?: Array<Stage>;
  where: RedirectWhereUniqueInput;
};


export type MutationUnpublishRewriteArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: RewriteWhereUniqueInput;
};


export type MutationUnpublishRightColumnArgs = {
  from?: Array<Stage>;
  where: RightColumnWhereUniqueInput;
};


export type MutationUnpublishSearchInputArgs = {
  from?: Array<Stage>;
  where: SearchInputWhereUniqueInput;
};


export type MutationUnpublishSearchOverlayComponentArgs = {
  from?: Array<Stage>;
  where: SearchOverlayComponentWhereUniqueInput;
};


export type MutationUnpublishSearchResultPageArgs = {
  from?: Array<Stage>;
  where: SearchResultPageWhereUniqueInput;
};


export type MutationUnpublishSeparatorArgs = {
  from?: Array<Stage>;
  where: SeparatorWhereUniqueInput;
};


export type MutationUnpublishSingleStepPromotionFormArgs = {
  from?: Array<Stage>;
  where: SingleStepPromotionFormWhereUniqueInput;
};


export type MutationUnpublishSocialMediaListComponentArgs = {
  from?: Array<Stage>;
  where: SocialMediaListComponentWhereUniqueInput;
};


export type MutationUnpublishSpacerArgs = {
  from?: Array<Stage>;
  where: SpacerWhereUniqueInput;
};


export type MutationUnpublishSubCategoryKeyImageArgs = {
  from?: Array<Stage>;
  where: SubCategoryKeyImageWhereUniqueInput;
};


export type MutationUnpublishSubTabArgs = {
  from?: Array<Stage>;
  where: SubTabWhereUniqueInput;
};


export type MutationUnpublishSubTabContentArgs = {
  from?: Array<Stage>;
  where: SubTabContentWhereUniqueInput;
};


export type MutationUnpublishSustainabilityBannerArgs = {
  from?: Array<Stage>;
  where: SustainabilityBannerWhereUniqueInput;
};


export type MutationUnpublishSustainabilityInfoArgs = {
  from?: Array<Stage>;
  where: SustainabilityInfoWhereUniqueInput;
};


export type MutationUnpublishTabArgs = {
  from?: Array<Stage>;
  where: TabWhereUniqueInput;
};


export type MutationUnpublishTabContentArgs = {
  from?: Array<Stage>;
  where: TabContentWhereUniqueInput;
};


export type MutationUnpublishTeaserArgs = {
  from?: Array<Stage>;
  where: TeaserWhereUniqueInput;
};


export type MutationUnpublishTeaserPlaceholderArgs = {
  from?: Array<Stage>;
  where: TeaserPlaceholderWhereUniqueInput;
};


export type MutationUnpublishTeaserSmallArgs = {
  from?: Array<Stage>;
  where: TeaserSmallWhereUniqueInput;
};


export type MutationUnpublishTeaserSmallPlaceholderArgs = {
  from?: Array<Stage>;
  where: TeaserSmallPlaceholderWhereUniqueInput;
};


export type MutationUnpublishTestComponentWithRecipeQueryArgs = {
  from?: Array<Stage>;
  where: TestComponentWithRecipeQueryWhereUniqueInput;
};


export type MutationUnpublishTestTipsANdTricksInAMarketArgs = {
  from?: Array<Stage>;
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};


export type MutationUnpublishTextComponentArgs = {
  from?: Array<Stage>;
  where: TextComponentWhereUniqueInput;
};


export type MutationUnpublishTipsAndTricksDetailsPageArgs = {
  from?: Array<Stage>;
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};


export type MutationUnpublishTitleArgs = {
  from?: Array<Stage>;
  where: TitleWhereUniqueInput;
};


export type MutationUnpublishTwitterSeoArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: TwitterSeoWhereUniqueInput;
};


export type MutationUpdateAccordionArgs = {
  data: AccordionUpdateInput;
  where: AccordionWhereUniqueInput;
};


export type MutationUpdateAccordionItemArgs = {
  data: AccordionItemUpdateInput;
  where: AccordionItemWhereUniqueInput;
};


export type MutationUpdateAlgoliaExtensionArgs = {
  data: AlgoliaExtensionUpdateInput;
  where: AlgoliaExtensionWhereUniqueInput;
};


export type MutationUpdateAnchorNavArgs = {
  data: AnchorNavUpdateInput;
  where: AnchorNavWhereUniqueInput;
};


export type MutationUpdateAnchorNavigationArgs = {
  data: AnchorNavigationUpdateInput;
  where: AnchorNavigationWhereUniqueInput;
};


export type MutationUpdateAnchorNavigationListArgs = {
  data: AnchorNavigationListUpdateInput;
  where: AnchorNavigationListWhereUniqueInput;
};


export type MutationUpdateAssetArgs = {
  data: AssetUpdateInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpdateAssetComponentArgs = {
  data: AssetComponentUpdateInput;
  where: AssetComponentWhereUniqueInput;
};


export type MutationUpdateAudioComponentArgs = {
  data: AudioComponentUpdateInput;
  where: AudioComponentWhereUniqueInput;
};


export type MutationUpdateAuthorableContentCardArgs = {
  data: AuthorableContentCardUpdateInput;
  where: AuthorableContentCardWhereUniqueInput;
};


export type MutationUpdateBanner1Args = {
  data: Banner1UpdateInput;
  where: Banner1WhereUniqueInput;
};


export type MutationUpdateBanner2Args = {
  data: Banner2UpdateInput;
  where: Banner2WhereUniqueInput;
};


export type MutationUpdateBanner2CarouselComponentArgs = {
  data: Banner2CarouselComponentUpdateInput;
  where: Banner2CarouselComponentWhereUniqueInput;
};


export type MutationUpdateCardComponentArgs = {
  data: CardComponentUpdateInput;
  where: CardComponentWhereUniqueInput;
};


export type MutationUpdateCarouselComponentArgs = {
  data: CarouselComponentUpdateInput;
  where: CarouselComponentWhereUniqueInput;
};


export type MutationUpdateCarouselSlideArgs = {
  data: CarouselSlideUpdateInput;
  where: CarouselSlideWhereUniqueInput;
};


export type MutationUpdateCategoryCardArgs = {
  data: CategoryCardUpdateInput;
  where: CategoryCardWhereUniqueInput;
};


export type MutationUpdateContactCardArgs = {
  data: ContactCardUpdateInput;
  where: ContactCardWhereUniqueInput;
};


export type MutationUpdateContactCardContainerArgs = {
  data: ContactCardContainerUpdateInput;
  where: ContactCardContainerWhereUniqueInput;
};


export type MutationUpdateCountrySelectorFooterArgs = {
  data: CountrySelectorFooterUpdateInput;
  where: CountrySelectorFooterWhereUniqueInput;
};


export type MutationUpdateCountrySelectorItemArgs = {
  data: CountrySelectorItemUpdateInput;
  where: CountrySelectorItemWhereUniqueInput;
};


export type MutationUpdateDemoModelArgs = {
  data: DemoModelUpdateInput;
  where: DemoModelWhereUniqueInput;
};


export type MutationUpdateDictionaryArgs = {
  data: DictionaryUpdateInput;
  where: DictionaryWhereUniqueInput;
};


export type MutationUpdateDictionaryItemArgs = {
  data: DictionaryItemUpdateInput;
  where: DictionaryItemWhereUniqueInput;
};


export type MutationUpdateDownloadAppArgs = {
  data: DownloadAppUpdateInput;
  where: DownloadAppWhereUniqueInput;
};


export type MutationUpdateDynamicCardGridArgs = {
  data: DynamicCardGridUpdateInput;
  where: DynamicCardGridWhereUniqueInput;
};


export type MutationUpdateErrorPageArgs = {
  data: ErrorPageUpdateInput;
  where: ErrorPageWhereUniqueInput;
};


export type MutationUpdateEvalancheFormComponentArgs = {
  data: EvalancheFormComponentUpdateInput;
  where: EvalancheFormComponentWhereUniqueInput;
};


export type MutationUpdateExampleComponentArgs = {
  data: ExampleComponentUpdateInput;
  where: ExampleComponentWhereUniqueInput;
};


export type MutationUpdateFeaturedContentArgs = {
  data: FeaturedContentUpdateInput;
  where: FeaturedContentWhereUniqueInput;
};


export type MutationUpdateFeaturedContentReferenceArgs = {
  data: FeaturedContentReferenceUpdateInput;
  where: FeaturedContentReferenceWhereUniqueInput;
};


export type MutationUpdateFooterNavigationArgs = {
  data: FooterNavigationUpdateInput;
  where: FooterNavigationWhereUniqueInput;
};


export type MutationUpdateFooterSealArgs = {
  data: FooterSealUpdateInput;
  where: FooterSealWhereUniqueInput;
};


export type MutationUpdateFormArgs = {
  data: FormUpdateInput;
  where: FormWhereUniqueInput;
};


export type MutationUpdateFormCheckboxArgs = {
  data: FormCheckboxUpdateInput;
  where: FormCheckboxWhereUniqueInput;
};


export type MutationUpdateFormCheckboxCollectionArgs = {
  data: FormCheckboxCollectionUpdateInput;
  where: FormCheckboxCollectionWhereUniqueInput;
};


export type MutationUpdateFormDateInputArgs = {
  data: FormDateInputUpdateInput;
  where: FormDateInputWhereUniqueInput;
};


export type MutationUpdateFormEmailInputArgs = {
  data: FormEmailInputUpdateInput;
  where: FormEmailInputWhereUniqueInput;
};


export type MutationUpdateFormErrorArgs = {
  data: FormErrorUpdateInput;
  where: FormErrorWhereUniqueInput;
};


export type MutationUpdateFormFileUploaderArgs = {
  data: FormFileUploaderUpdateInput;
  where: FormFileUploaderWhereUniqueInput;
};


export type MutationUpdateFormListArgs = {
  data: FormListUpdateInput;
  where: FormListWhereUniqueInput;
};


export type MutationUpdateFormListItemArgs = {
  data: FormListItemUpdateInput;
  where: FormListItemWhereUniqueInput;
};


export type MutationUpdateFormNumberInputArgs = {
  data: FormNumberInputUpdateInput;
  where: FormNumberInputWhereUniqueInput;
};


export type MutationUpdateFormPasswordInputArgs = {
  data: FormPasswordInputUpdateInput;
  where: FormPasswordInputWhereUniqueInput;
};


export type MutationUpdateFormPasswordInputWithConfirmationArgs = {
  data: FormPasswordInputWithConfirmationUpdateInput;
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};


export type MutationUpdateFormRadioButtonArgs = {
  data: FormRadioButtonUpdateInput;
  where: FormRadioButtonWhereUniqueInput;
};


export type MutationUpdateFormRadioButtonCollectionArgs = {
  data: FormRadioButtonCollectionUpdateInput;
  where: FormRadioButtonCollectionWhereUniqueInput;
};


export type MutationUpdateFormSelectComponentArgs = {
  data: FormSelectComponentUpdateInput;
  where: FormSelectComponentWhereUniqueInput;
};


export type MutationUpdateFormSelectOptionArgs = {
  data: FormSelectOptionUpdateInput;
  where: FormSelectOptionWhereUniqueInput;
};


export type MutationUpdateFormSubmitButtonArgs = {
  data: FormSubmitButtonUpdateInput;
  where: FormSubmitButtonWhereUniqueInput;
};


export type MutationUpdateFormSuccessComponentArgs = {
  data: FormSuccessComponentUpdateInput;
  where: FormSuccessComponentWhereUniqueInput;
};


export type MutationUpdateFormTextInputArgs = {
  data: FormTextInputUpdateInput;
  where: FormTextInputWhereUniqueInput;
};


export type MutationUpdateFormTextareaInputArgs = {
  data: FormTextareaInputUpdateInput;
  where: FormTextareaInputWhereUniqueInput;
};


export type MutationUpdateGenericAccordionArgs = {
  data: GenericAccordionUpdateInput;
  where: GenericAccordionWhereUniqueInput;
};


export type MutationUpdateGenericAccordionItemArgs = {
  data: GenericAccordionItemUpdateInput;
  where: GenericAccordionItemWhereUniqueInput;
};


export type MutationUpdateGenericAccordionTopRatedArgs = {
  data: GenericAccordionTopRatedUpdateInput;
  where: GenericAccordionTopRatedWhereUniqueInput;
};


export type MutationUpdateGenericCardCarouseComponentArgs = {
  data: GenericCardCarouseComponentUpdateInput;
  where: GenericCardCarouseComponentWhereUniqueInput;
};


export type MutationUpdateGenericDownloadComponentArgs = {
  data: GenericDownloadComponentUpdateInput;
  where: GenericDownloadComponentWhereUniqueInput;
};


export type MutationUpdateGenericFollowUsArgs = {
  data: GenericFollowUsUpdateInput;
  where: GenericFollowUsWhereUniqueInput;
};


export type MutationUpdateGenericGridAuthorableArgs = {
  data: GenericGridAuthorableUpdateInput;
  where: GenericGridAuthorableWhereUniqueInput;
};


export type MutationUpdateGenericHtmlArgs = {
  data: GenericHtmlUpdateInput;
  where: GenericHtmlWhereUniqueInput;
};


export type MutationUpdateGenericLineArgs = {
  data: GenericLineUpdateInput;
  where: GenericLineWhereUniqueInput;
};


export type MutationUpdateGenericLinkArgs = {
  data: GenericLinkUpdateInput;
  where: GenericLinkWhereUniqueInput;
};


export type MutationUpdateGenericPageArgs = {
  data: GenericPageUpdateInput;
  where: GenericPageWhereUniqueInput;
};


export type MutationUpdateGenericPromotionsOverviewArgs = {
  data: GenericPromotionsOverviewUpdateInput;
  where: GenericPromotionsOverviewWhereUniqueInput;
};


export type MutationUpdateGenericQualifioArgs = {
  data: GenericQualifioUpdateInput;
  where: GenericQualifioWhereUniqueInput;
};


export type MutationUpdateGenericQualifioOverviewArgs = {
  data: GenericQualifioOverviewUpdateInput;
  where: GenericQualifioOverviewWhereUniqueInput;
};


export type MutationUpdateGenericSocialShareArgs = {
  data: GenericSocialShareUpdateInput;
  where: GenericSocialShareWhereUniqueInput;
};


export type MutationUpdateGlobalMetaDataArgs = {
  data: GlobalMetaDataUpdateInput;
  where: GlobalMetaDataWhereUniqueInput;
};


export type MutationUpdateGlobalSearchArgs = {
  data: GlobalSearchUpdateInput;
  where: GlobalSearchWhereUniqueInput;
};


export type MutationUpdateGridColumnArgs = {
  data: GridColumnUpdateInput;
  where: GridColumnWhereUniqueInput;
};


export type MutationUpdateGridColumnComponentArgs = {
  data: GridColumnComponentUpdateInput;
  where: GridColumnComponentWhereUniqueInput;
};


export type MutationUpdateHeroBannerArgs = {
  data: HeroBannerUpdateInput;
  where: HeroBannerWhereUniqueInput;
};


export type MutationUpdateHeroBannerMasterbrandArgs = {
  data: HeroBannerMasterbrandUpdateInput;
  where: HeroBannerMasterbrandWhereUniqueInput;
};


export type MutationUpdateHeroCarouselComponentArgs = {
  data: HeroCarouselComponentUpdateInput;
  where: HeroCarouselComponentWhereUniqueInput;
};


export type MutationUpdateHeroComponentArgs = {
  data: HeroComponentUpdateInput;
  where: HeroComponentWhereUniqueInput;
};


export type MutationUpdateHeroLoopAnimationComponentArgs = {
  data: HeroLoopAnimationComponentUpdateInput;
  where: HeroLoopAnimationComponentWhereUniqueInput;
};


export type MutationUpdateIframeArgs = {
  data: IframeUpdateInput;
  where: IframeWhereUniqueInput;
};


export type MutationUpdateImageAndTextCardArgs = {
  data: ImageAndTextCardUpdateInput;
  where: ImageAndTextCardWhereUniqueInput;
};


export type MutationUpdateImageCopyArgs = {
  data: ImageCopyUpdateInput;
  where: ImageCopyWhereUniqueInput;
};


export type MutationUpdateImageCopyItemArgs = {
  data: ImageCopyItemUpdateInput;
  where: ImageCopyItemWhereUniqueInput;
};


export type MutationUpdateIntroTextArgs = {
  data: IntroTextUpdateInput;
  where: IntroTextWhereUniqueInput;
};


export type MutationUpdateLeftColumnArgs = {
  data: LeftColumnUpdateInput;
  where: LeftColumnWhereUniqueInput;
};


export type MutationUpdateLinkArgs = {
  data: LinkUpdateInput;
  where: LinkWhereUniqueInput;
};


export type MutationUpdateLongTextArgs = {
  data: LongTextUpdateInput;
  where: LongTextWhereUniqueInput;
};


export type MutationUpdateManyAccordionItemsArgs = {
  data: AccordionItemUpdateManyInput;
  where?: InputMaybe<AccordionItemManyWhereInput>;
};


export type MutationUpdateManyAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AccordionItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionItemManyWhereInput>;
};


export type MutationUpdateManyAccordionsArgs = {
  data: AccordionUpdateManyInput;
  where?: InputMaybe<AccordionManyWhereInput>;
};


export type MutationUpdateManyAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AccordionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionManyWhereInput>;
};


export type MutationUpdateManyAlgoliaExtensionsArgs = {
  data: AlgoliaExtensionUpdateManyInput;
  where?: InputMaybe<AlgoliaExtensionManyWhereInput>;
};


export type MutationUpdateManyAlgoliaExtensionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AlgoliaExtensionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AlgoliaExtensionManyWhereInput>;
};


export type MutationUpdateManyAnchorNavigationListsArgs = {
  data: AnchorNavigationListUpdateManyInput;
  where?: InputMaybe<AnchorNavigationListManyWhereInput>;
};


export type MutationUpdateManyAnchorNavigationListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AnchorNavigationListUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorNavigationListManyWhereInput>;
};


export type MutationUpdateManyAnchorNavigationsArgs = {
  data: AnchorNavigationUpdateManyInput;
  where?: InputMaybe<AnchorNavigationManyWhereInput>;
};


export type MutationUpdateManyAnchorNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AnchorNavigationUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorNavigationManyWhereInput>;
};


export type MutationUpdateManyAnchorNavsArgs = {
  data: AnchorNavUpdateManyInput;
  where?: InputMaybe<AnchorNavManyWhereInput>;
};


export type MutationUpdateManyAnchorNavsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AnchorNavUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorNavManyWhereInput>;
};


export type MutationUpdateManyAssetsArgs = {
  data: AssetUpdateManyInput;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUpdateManyAssetsComponentsArgs = {
  data: AssetComponentUpdateManyInput;
  where?: InputMaybe<AssetComponentManyWhereInput>;
};


export type MutationUpdateManyAssetsComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AssetComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentManyWhereInput>;
};


export type MutationUpdateManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AssetUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUpdateManyAudioComponentsArgs = {
  data: AudioComponentUpdateManyInput;
  where?: InputMaybe<AudioComponentManyWhereInput>;
};


export type MutationUpdateManyAudioComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AudioComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AudioComponentManyWhereInput>;
};


export type MutationUpdateManyAuthorableContentCardsArgs = {
  data: AuthorableContentCardUpdateManyInput;
  where?: InputMaybe<AuthorableContentCardManyWhereInput>;
};


export type MutationUpdateManyAuthorableContentCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AuthorableContentCardUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuthorableContentCardManyWhereInput>;
};


export type MutationUpdateManyBanner1sArgs = {
  data: Banner1UpdateManyInput;
  where?: InputMaybe<Banner1ManyWhereInput>;
};


export type MutationUpdateManyBanner1sConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: Banner1UpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Banner1ManyWhereInput>;
};


export type MutationUpdateManyBanner2CarouselComponentsArgs = {
  data: Banner2CarouselComponentUpdateManyInput;
  where?: InputMaybe<Banner2CarouselComponentManyWhereInput>;
};


export type MutationUpdateManyBanner2CarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: Banner2CarouselComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Banner2CarouselComponentManyWhereInput>;
};


export type MutationUpdateManyBanner2SArgs = {
  data: Banner2UpdateManyInput;
  where?: InputMaybe<Banner2ManyWhereInput>;
};


export type MutationUpdateManyBanner2SConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: Banner2UpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Banner2ManyWhereInput>;
};


export type MutationUpdateManyCardComponentsArgs = {
  data: CardComponentUpdateManyInput;
  where?: InputMaybe<CardComponentManyWhereInput>;
};


export type MutationUpdateManyCardComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CardComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardComponentManyWhereInput>;
};


export type MutationUpdateManyCarouselComponentsArgs = {
  data: CarouselComponentUpdateManyInput;
  where?: InputMaybe<CarouselComponentManyWhereInput>;
};


export type MutationUpdateManyCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CarouselComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselComponentManyWhereInput>;
};


export type MutationUpdateManyCarouselSlidesArgs = {
  data: CarouselSlideUpdateManyInput;
  where?: InputMaybe<CarouselSlideManyWhereInput>;
};


export type MutationUpdateManyCarouselSlidesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CarouselSlideUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselSlideManyWhereInput>;
};


export type MutationUpdateManyCategoryCardsArgs = {
  data: CategoryCardUpdateManyInput;
  where?: InputMaybe<CategoryCardManyWhereInput>;
};


export type MutationUpdateManyCategoryCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CategoryCardUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryCardManyWhereInput>;
};


export type MutationUpdateManyContactCardContainersArgs = {
  data: ContactCardContainerUpdateManyInput;
  where?: InputMaybe<ContactCardContainerManyWhereInput>;
};


export type MutationUpdateManyContactCardContainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ContactCardContainerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContactCardContainerManyWhereInput>;
};


export type MutationUpdateManyContactCardsArgs = {
  data: ContactCardUpdateManyInput;
  where?: InputMaybe<ContactCardManyWhereInput>;
};


export type MutationUpdateManyContactCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ContactCardUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContactCardManyWhereInput>;
};


export type MutationUpdateManyCountrySelectorFootersArgs = {
  data: CountrySelectorFooterUpdateManyInput;
  where?: InputMaybe<CountrySelectorFooterManyWhereInput>;
};


export type MutationUpdateManyCountrySelectorFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CountrySelectorFooterUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountrySelectorFooterManyWhereInput>;
};


export type MutationUpdateManyCountrySelectorItemsArgs = {
  data: CountrySelectorItemUpdateManyInput;
  where?: InputMaybe<CountrySelectorItemManyWhereInput>;
};


export type MutationUpdateManyCountrySelectorItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CountrySelectorItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountrySelectorItemManyWhereInput>;
};


export type MutationUpdateManyDemoModelsArgs = {
  data: DemoModelUpdateManyInput;
  where?: InputMaybe<DemoModelManyWhereInput>;
};


export type MutationUpdateManyDemoModelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: DemoModelUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DemoModelManyWhereInput>;
};


export type MutationUpdateManyDictionariesArgs = {
  data: DictionaryUpdateManyInput;
  where?: InputMaybe<DictionaryManyWhereInput>;
};


export type MutationUpdateManyDictionariesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: DictionaryUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DictionaryManyWhereInput>;
};


export type MutationUpdateManyDictionaryItemsArgs = {
  data: DictionaryItemUpdateManyInput;
  where?: InputMaybe<DictionaryItemManyWhereInput>;
};


export type MutationUpdateManyDictionaryItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: DictionaryItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DictionaryItemManyWhereInput>;
};


export type MutationUpdateManyDownloadAppsArgs = {
  data: DownloadAppUpdateManyInput;
  where?: InputMaybe<DownloadAppManyWhereInput>;
};


export type MutationUpdateManyDownloadAppsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: DownloadAppUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DownloadAppManyWhereInput>;
};


export type MutationUpdateManyDynamicCardGridsArgs = {
  data: DynamicCardGridUpdateManyInput;
  where?: InputMaybe<DynamicCardGridManyWhereInput>;
};


export type MutationUpdateManyDynamicCardGridsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: DynamicCardGridUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DynamicCardGridManyWhereInput>;
};


export type MutationUpdateManyErrorPagesArgs = {
  data: ErrorPageUpdateManyInput;
  where?: InputMaybe<ErrorPageManyWhereInput>;
};


export type MutationUpdateManyErrorPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ErrorPageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ErrorPageManyWhereInput>;
};


export type MutationUpdateManyEvalancheFormComponentsArgs = {
  data: EvalancheFormComponentUpdateManyInput;
  where?: InputMaybe<EvalancheFormComponentManyWhereInput>;
};


export type MutationUpdateManyEvalancheFormComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: EvalancheFormComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EvalancheFormComponentManyWhereInput>;
};


export type MutationUpdateManyExampleComponentsArgs = {
  data: ExampleComponentUpdateManyInput;
  where?: InputMaybe<ExampleComponentManyWhereInput>;
};


export type MutationUpdateManyExampleComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ExampleComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ExampleComponentManyWhereInput>;
};


export type MutationUpdateManyFeaturedContentReferencesArgs = {
  data: FeaturedContentReferenceUpdateManyInput;
  where?: InputMaybe<FeaturedContentReferenceManyWhereInput>;
};


export type MutationUpdateManyFeaturedContentReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FeaturedContentReferenceUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FeaturedContentReferenceManyWhereInput>;
};


export type MutationUpdateManyFeaturedContentsArgs = {
  data: FeaturedContentUpdateManyInput;
  where?: InputMaybe<FeaturedContentManyWhereInput>;
};


export type MutationUpdateManyFeaturedContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FeaturedContentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FeaturedContentManyWhereInput>;
};


export type MutationUpdateManyFooterNavigationsArgs = {
  data: FooterNavigationUpdateManyInput;
  where?: InputMaybe<FooterNavigationManyWhereInput>;
};


export type MutationUpdateManyFooterNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FooterNavigationUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FooterNavigationManyWhereInput>;
};


export type MutationUpdateManyFooterSealsArgs = {
  data: FooterSealUpdateManyInput;
  where?: InputMaybe<FooterSealManyWhereInput>;
};


export type MutationUpdateManyFooterSealsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FooterSealUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FooterSealManyWhereInput>;
};


export type MutationUpdateManyFormCheckboxCollectionsArgs = {
  data: FormCheckboxCollectionUpdateManyInput;
  where?: InputMaybe<FormCheckboxCollectionManyWhereInput>;
};


export type MutationUpdateManyFormCheckboxCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormCheckboxCollectionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormCheckboxCollectionManyWhereInput>;
};


export type MutationUpdateManyFormCheckboxesArgs = {
  data: FormCheckboxUpdateManyInput;
  where?: InputMaybe<FormCheckboxManyWhereInput>;
};


export type MutationUpdateManyFormCheckboxesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormCheckboxUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormCheckboxManyWhereInput>;
};


export type MutationUpdateManyFormDateInputsArgs = {
  data: FormDateInputUpdateManyInput;
  where?: InputMaybe<FormDateInputManyWhereInput>;
};


export type MutationUpdateManyFormDateInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormDateInputUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormDateInputManyWhereInput>;
};


export type MutationUpdateManyFormEmailInputsArgs = {
  data: FormEmailInputUpdateManyInput;
  where?: InputMaybe<FormEmailInputManyWhereInput>;
};


export type MutationUpdateManyFormEmailInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormEmailInputUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormEmailInputManyWhereInput>;
};


export type MutationUpdateManyFormErrorsArgs = {
  data: FormErrorUpdateManyInput;
  where?: InputMaybe<FormErrorManyWhereInput>;
};


export type MutationUpdateManyFormErrorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormErrorUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormErrorManyWhereInput>;
};


export type MutationUpdateManyFormFileUploadersArgs = {
  data: FormFileUploaderUpdateManyInput;
  where?: InputMaybe<FormFileUploaderManyWhereInput>;
};


export type MutationUpdateManyFormFileUploadersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormFileUploaderUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormFileUploaderManyWhereInput>;
};


export type MutationUpdateManyFormListItemsArgs = {
  data: FormListItemUpdateManyInput;
  where?: InputMaybe<FormListItemManyWhereInput>;
};


export type MutationUpdateManyFormListItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormListItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormListItemManyWhereInput>;
};


export type MutationUpdateManyFormListsArgs = {
  data: FormListUpdateManyInput;
  where?: InputMaybe<FormListManyWhereInput>;
};


export type MutationUpdateManyFormListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormListUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormListManyWhereInput>;
};


export type MutationUpdateManyFormNumberInputsArgs = {
  data: FormNumberInputUpdateManyInput;
  where?: InputMaybe<FormNumberInputManyWhereInput>;
};


export type MutationUpdateManyFormNumberInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormNumberInputUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormNumberInputManyWhereInput>;
};


export type MutationUpdateManyFormPasswordInputWithConfirmationsArgs = {
  data: FormPasswordInputWithConfirmationUpdateManyInput;
  where?: InputMaybe<FormPasswordInputWithConfirmationManyWhereInput>;
};


export type MutationUpdateManyFormPasswordInputWithConfirmationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormPasswordInputWithConfirmationUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormPasswordInputWithConfirmationManyWhereInput>;
};


export type MutationUpdateManyFormPasswordInputsArgs = {
  data: FormPasswordInputUpdateManyInput;
  where?: InputMaybe<FormPasswordInputManyWhereInput>;
};


export type MutationUpdateManyFormPasswordInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormPasswordInputUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormPasswordInputManyWhereInput>;
};


export type MutationUpdateManyFormRadioButtonCollectionsArgs = {
  data: FormRadioButtonCollectionUpdateManyInput;
  where?: InputMaybe<FormRadioButtonCollectionManyWhereInput>;
};


export type MutationUpdateManyFormRadioButtonCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormRadioButtonCollectionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormRadioButtonCollectionManyWhereInput>;
};


export type MutationUpdateManyFormRadioButtonsArgs = {
  data: FormRadioButtonUpdateManyInput;
  where?: InputMaybe<FormRadioButtonManyWhereInput>;
};


export type MutationUpdateManyFormRadioButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormRadioButtonUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormRadioButtonManyWhereInput>;
};


export type MutationUpdateManyFormSelectComponentsArgs = {
  data: FormSelectComponentUpdateManyInput;
  where?: InputMaybe<FormSelectComponentManyWhereInput>;
};


export type MutationUpdateManyFormSelectComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormSelectComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSelectComponentManyWhereInput>;
};


export type MutationUpdateManyFormSelectOptionsArgs = {
  data: FormSelectOptionUpdateManyInput;
  where?: InputMaybe<FormSelectOptionManyWhereInput>;
};


export type MutationUpdateManyFormSelectOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormSelectOptionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSelectOptionManyWhereInput>;
};


export type MutationUpdateManyFormSubmitButtonsArgs = {
  data: FormSubmitButtonUpdateManyInput;
  where?: InputMaybe<FormSubmitButtonManyWhereInput>;
};


export type MutationUpdateManyFormSubmitButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormSubmitButtonUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSubmitButtonManyWhereInput>;
};


export type MutationUpdateManyFormSuccessComponentsArgs = {
  data: FormSuccessComponentUpdateManyInput;
  where?: InputMaybe<FormSuccessComponentManyWhereInput>;
};


export type MutationUpdateManyFormSuccessComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormSuccessComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSuccessComponentManyWhereInput>;
};


export type MutationUpdateManyFormTextInputsArgs = {
  data: FormTextInputUpdateManyInput;
  where?: InputMaybe<FormTextInputManyWhereInput>;
};


export type MutationUpdateManyFormTextInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormTextInputUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormTextInputManyWhereInput>;
};


export type MutationUpdateManyFormTextareaInputsArgs = {
  data: FormTextareaInputUpdateManyInput;
  where?: InputMaybe<FormTextareaInputManyWhereInput>;
};


export type MutationUpdateManyFormTextareaInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormTextareaInputUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormTextareaInputManyWhereInput>;
};


export type MutationUpdateManyFormsArgs = {
  data: FormUpdateManyInput;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationUpdateManyFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationUpdateManyGenericAccordionItemsArgs = {
  data: GenericAccordionItemUpdateManyInput;
  where?: InputMaybe<GenericAccordionItemManyWhereInput>;
};


export type MutationUpdateManyGenericAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericAccordionItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionItemManyWhereInput>;
};


export type MutationUpdateManyGenericAccordionTopRatedsArgs = {
  data: GenericAccordionTopRatedUpdateManyInput;
  where?: InputMaybe<GenericAccordionTopRatedManyWhereInput>;
};


export type MutationUpdateManyGenericAccordionTopRatedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericAccordionTopRatedUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionTopRatedManyWhereInput>;
};


export type MutationUpdateManyGenericAccordionsArgs = {
  data: GenericAccordionUpdateManyInput;
  where?: InputMaybe<GenericAccordionManyWhereInput>;
};


export type MutationUpdateManyGenericAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericAccordionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionManyWhereInput>;
};


export type MutationUpdateManyGenericCardCarouseComponentsArgs = {
  data: GenericCardCarouseComponentUpdateManyInput;
  where?: InputMaybe<GenericCardCarouseComponentManyWhereInput>;
};


export type MutationUpdateManyGenericCardCarouseComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericCardCarouseComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericCardCarouseComponentManyWhereInput>;
};


export type MutationUpdateManyGenericDownloadComponentsArgs = {
  data: GenericDownloadComponentUpdateManyInput;
  where?: InputMaybe<GenericDownloadComponentManyWhereInput>;
};


export type MutationUpdateManyGenericDownloadComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericDownloadComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericDownloadComponentManyWhereInput>;
};


export type MutationUpdateManyGenericFollowUsesArgs = {
  data: GenericFollowUsUpdateManyInput;
  where?: InputMaybe<GenericFollowUsManyWhereInput>;
};


export type MutationUpdateManyGenericFollowUsesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericFollowUsUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericFollowUsManyWhereInput>;
};


export type MutationUpdateManyGenericGridAuthorablesArgs = {
  data: GenericGridAuthorableUpdateManyInput;
  where?: InputMaybe<GenericGridAuthorableManyWhereInput>;
};


export type MutationUpdateManyGenericGridAuthorablesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericGridAuthorableUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericGridAuthorableManyWhereInput>;
};


export type MutationUpdateManyGenericHtmlsArgs = {
  data: GenericHtmlUpdateManyInput;
  where?: InputMaybe<GenericHtmlManyWhereInput>;
};


export type MutationUpdateManyGenericHtmlsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericHtmlUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericHtmlManyWhereInput>;
};


export type MutationUpdateManyGenericLinesArgs = {
  data: GenericLineUpdateManyInput;
  where?: InputMaybe<GenericLineManyWhereInput>;
};


export type MutationUpdateManyGenericLinesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericLineUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericLineManyWhereInput>;
};


export type MutationUpdateManyGenericLinksArgs = {
  data: GenericLinkUpdateManyInput;
  where?: InputMaybe<GenericLinkManyWhereInput>;
};


export type MutationUpdateManyGenericLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericLinkUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericLinkManyWhereInput>;
};


export type MutationUpdateManyGenericPagesArgs = {
  data: GenericPageUpdateManyInput;
  where?: InputMaybe<GenericPageManyWhereInput>;
};


export type MutationUpdateManyGenericPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericPageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageManyWhereInput>;
};


export type MutationUpdateManyGenericPromotionsOverviewsArgs = {
  data: GenericPromotionsOverviewUpdateManyInput;
  where?: InputMaybe<GenericPromotionsOverviewManyWhereInput>;
};


export type MutationUpdateManyGenericPromotionsOverviewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericPromotionsOverviewUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPromotionsOverviewManyWhereInput>;
};


export type MutationUpdateManyGenericQualifioOverviewsArgs = {
  data: GenericQualifioOverviewUpdateManyInput;
  where?: InputMaybe<GenericQualifioOverviewManyWhereInput>;
};


export type MutationUpdateManyGenericQualifioOverviewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericQualifioOverviewUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericQualifioOverviewManyWhereInput>;
};


export type MutationUpdateManyGenericQualifiosArgs = {
  data: GenericQualifioUpdateManyInput;
  where?: InputMaybe<GenericQualifioManyWhereInput>;
};


export type MutationUpdateManyGenericQualifiosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericQualifioUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericQualifioManyWhereInput>;
};


export type MutationUpdateManyGenericSocialSharesArgs = {
  data: GenericSocialShareUpdateManyInput;
  where?: InputMaybe<GenericSocialShareManyWhereInput>;
};


export type MutationUpdateManyGenericSocialSharesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericSocialShareUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericSocialShareManyWhereInput>;
};


export type MutationUpdateManyGlobalMetaDatasArgs = {
  data: GlobalMetaDataUpdateManyInput;
  where?: InputMaybe<GlobalMetaDataManyWhereInput>;
};


export type MutationUpdateManyGlobalMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GlobalMetaDataUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GlobalMetaDataManyWhereInput>;
};


export type MutationUpdateManyGlobalSearchesArgs = {
  data: GlobalSearchUpdateManyInput;
  where?: InputMaybe<GlobalSearchManyWhereInput>;
};


export type MutationUpdateManyGlobalSearchesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GlobalSearchUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GlobalSearchManyWhereInput>;
};


export type MutationUpdateManyGridColumnComponentsArgs = {
  data: GridColumnComponentUpdateManyInput;
  where?: InputMaybe<GridColumnComponentManyWhereInput>;
};


export type MutationUpdateManyGridColumnComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GridColumnComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GridColumnComponentManyWhereInput>;
};


export type MutationUpdateManyGridColumnsArgs = {
  data: GridColumnUpdateManyInput;
  where?: InputMaybe<GridColumnManyWhereInput>;
};


export type MutationUpdateManyGridColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GridColumnUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GridColumnManyWhereInput>;
};


export type MutationUpdateManyHeroBannerMasterbrandsArgs = {
  data: HeroBannerMasterbrandUpdateManyInput;
  where?: InputMaybe<HeroBannerMasterbrandManyWhereInput>;
};


export type MutationUpdateManyHeroBannerMasterbrandsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: HeroBannerMasterbrandUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroBannerMasterbrandManyWhereInput>;
};


export type MutationUpdateManyHeroBannersArgs = {
  data: HeroBannerUpdateManyInput;
  where?: InputMaybe<HeroBannerManyWhereInput>;
};


export type MutationUpdateManyHeroBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: HeroBannerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroBannerManyWhereInput>;
};


export type MutationUpdateManyHeroCarouselComponentsArgs = {
  data: HeroCarouselComponentUpdateManyInput;
  where?: InputMaybe<HeroCarouselComponentManyWhereInput>;
};


export type MutationUpdateManyHeroCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: HeroCarouselComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroCarouselComponentManyWhereInput>;
};


export type MutationUpdateManyHeroComponentsArgs = {
  data: HeroComponentUpdateManyInput;
  where?: InputMaybe<HeroComponentManyWhereInput>;
};


export type MutationUpdateManyHeroComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: HeroComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroComponentManyWhereInput>;
};


export type MutationUpdateManyHeroLoopAnimationComponentsArgs = {
  data: HeroLoopAnimationComponentUpdateManyInput;
  where?: InputMaybe<HeroLoopAnimationComponentManyWhereInput>;
};


export type MutationUpdateManyHeroLoopAnimationComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: HeroLoopAnimationComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroLoopAnimationComponentManyWhereInput>;
};


export type MutationUpdateManyIframesArgs = {
  data: IframeUpdateManyInput;
  where?: InputMaybe<IframeManyWhereInput>;
};


export type MutationUpdateManyIframesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: IframeUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IframeManyWhereInput>;
};


export type MutationUpdateManyImageAndTextCardsArgs = {
  data: ImageAndTextCardUpdateManyInput;
  where?: InputMaybe<ImageAndTextCardManyWhereInput>;
};


export type MutationUpdateManyImageAndTextCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ImageAndTextCardUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageAndTextCardManyWhereInput>;
};


export type MutationUpdateManyImageCopiesArgs = {
  data: ImageCopyUpdateManyInput;
  where?: InputMaybe<ImageCopyManyWhereInput>;
};


export type MutationUpdateManyImageCopiesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ImageCopyUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageCopyManyWhereInput>;
};


export type MutationUpdateManyImageCopyItemsArgs = {
  data: ImageCopyItemUpdateManyInput;
  where?: InputMaybe<ImageCopyItemManyWhereInput>;
};


export type MutationUpdateManyImageCopyItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ImageCopyItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageCopyItemManyWhereInput>;
};


export type MutationUpdateManyIntroTextsArgs = {
  data: IntroTextUpdateManyInput;
  where?: InputMaybe<IntroTextManyWhereInput>;
};


export type MutationUpdateManyIntroTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: IntroTextUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IntroTextManyWhereInput>;
};


export type MutationUpdateManyLeftColumnsArgs = {
  data: LeftColumnUpdateManyInput;
  where?: InputMaybe<LeftColumnManyWhereInput>;
};


export type MutationUpdateManyLeftColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: LeftColumnUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LeftColumnManyWhereInput>;
};


export type MutationUpdateManyLinksArgs = {
  data: LinkUpdateManyInput;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationUpdateManyLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: LinkUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationUpdateManyLongTextsArgs = {
  data: LongTextUpdateManyInput;
  where?: InputMaybe<LongTextManyWhereInput>;
};


export type MutationUpdateManyLongTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: LongTextUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LongTextManyWhereInput>;
};


export type MutationUpdateManyMarketUserConnectionsArgs = {
  data: MarketUserConnectionUpdateManyInput;
  where?: InputMaybe<MarketUserConnectionManyWhereInput>;
};


export type MutationUpdateManyMarketUserConnectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: MarketUserConnectionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MarketUserConnectionManyWhereInput>;
};


export type MutationUpdateManyMarketsArgs = {
  data: MarketUpdateManyInput;
  where?: InputMaybe<MarketManyWhereInput>;
};


export type MutationUpdateManyMarketsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: MarketUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MarketManyWhereInput>;
};


export type MutationUpdateManyMetaDatasArgs = {
  data: MetaDataUpdateManyInput;
  where?: InputMaybe<MetaDataManyWhereInput>;
};


export type MutationUpdateManyMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: MetaDataUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetaDataManyWhereInput>;
};


export type MutationUpdateManyMobileOnlyMainNavigationsArgs = {
  data: MobileOnlyMainNavigationUpdateManyInput;
  where?: InputMaybe<MobileOnlyMainNavigationManyWhereInput>;
};


export type MutationUpdateManyMobileOnlyMainNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: MobileOnlyMainNavigationUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MobileOnlyMainNavigationManyWhereInput>;
};


export type MutationUpdateManyMultiStepPromotionFormsArgs = {
  data: MultiStepPromotionFormUpdateManyInput;
  where?: InputMaybe<MultiStepPromotionFormManyWhereInput>;
};


export type MutationUpdateManyMultiStepPromotionFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: MultiStepPromotionFormUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MultiStepPromotionFormManyWhereInput>;
};


export type MutationUpdateManyNavigationItemsArgs = {
  data: NavigationItemUpdateManyInput;
  where?: InputMaybe<NavigationItemManyWhereInput>;
};


export type MutationUpdateManyNavigationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: NavigationItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationItemManyWhereInput>;
};


export type MutationUpdateManyNavigationsArgs = {
  data: NavigationUpdateManyInput;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationUpdateManyNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: NavigationUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationUpdateManyNewsletterComponentsArgs = {
  data: NewsletterComponentUpdateManyInput;
  where?: InputMaybe<NewsletterComponentManyWhereInput>;
};


export type MutationUpdateManyNewsletterComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: NewsletterComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NewsletterComponentManyWhereInput>;
};


export type MutationUpdateManyNewsletterSubscriptionsPluralArgs = {
  data: NewsletterSubscriptionsUpdateManyInput;
  where?: InputMaybe<NewsletterSubscriptionsManyWhereInput>;
};


export type MutationUpdateManyNewsletterSubscriptionsPluralConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: NewsletterSubscriptionsUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NewsletterSubscriptionsManyWhereInput>;
};


export type MutationUpdateManyNotificationBannersArgs = {
  data: NotificationBannerUpdateManyInput;
  where?: InputMaybe<NotificationBannerManyWhereInput>;
};


export type MutationUpdateManyNotificationBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: NotificationBannerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationBannerManyWhereInput>;
};


export type MutationUpdateManyPageFootersArgs = {
  data: PageFooterUpdateManyInput;
  where?: InputMaybe<PageFooterManyWhereInput>;
};


export type MutationUpdateManyPageFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: PageFooterUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageFooterManyWhereInput>;
};


export type MutationUpdateManyPageHeadersArgs = {
  data: PageHeaderUpdateManyInput;
  where?: InputMaybe<PageHeaderManyWhereInput>;
};


export type MutationUpdateManyPageHeadersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: PageHeaderUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageHeaderManyWhereInput>;
};


export type MutationUpdateManyPopularSearchComponentsArgs = {
  data: PopularSearchComponentUpdateManyInput;
  where?: InputMaybe<PopularSearchComponentManyWhereInput>;
};


export type MutationUpdateManyPopularSearchComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: PopularSearchComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PopularSearchComponentManyWhereInput>;
};


export type MutationUpdateManyProductBannersArgs = {
  data: ProductBannerUpdateManyInput;
  where?: InputMaybe<ProductBannerManyWhereInput>;
};


export type MutationUpdateManyProductBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ProductBannerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductBannerManyWhereInput>;
};


export type MutationUpdateManyProductCategoriesArgs = {
  data: ProductCategoryUpdateManyInput;
  where?: InputMaybe<ProductCategoryManyWhereInput>;
};


export type MutationUpdateManyProductCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ProductCategoryUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryManyWhereInput>;
};


export type MutationUpdateManyProductCategoryPagesArgs = {
  data: ProductCategoryPageUpdateManyInput;
  where?: InputMaybe<ProductCategoryPageManyWhereInput>;
};


export type MutationUpdateManyProductCategoryPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ProductCategoryPageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageManyWhereInput>;
};


export type MutationUpdateManyProductDetailPagesArgs = {
  data: ProductDetailPageUpdateManyInput;
  where?: InputMaybe<ProductDetailPageManyWhereInput>;
};


export type MutationUpdateManyProductDetailPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ProductDetailPageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductDetailPageManyWhereInput>;
};


export type MutationUpdateManyProductHeroesArgs = {
  data: ProductHeroUpdateManyInput;
  where?: InputMaybe<ProductHeroManyWhereInput>;
};


export type MutationUpdateManyProductHeroesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ProductHeroUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductHeroManyWhereInput>;
};


export type MutationUpdateManyProductLabelsArgs = {
  data: ProductLabelUpdateManyInput;
  where?: InputMaybe<ProductLabelManyWhereInput>;
};


export type MutationUpdateManyProductLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ProductLabelUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLabelManyWhereInput>;
};


export type MutationUpdateManyProductLandingPagesArgs = {
  data: ProductLandingPageUpdateManyInput;
  where?: InputMaybe<ProductLandingPageManyWhereInput>;
};


export type MutationUpdateManyProductLandingPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ProductLandingPageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageManyWhereInput>;
};


export type MutationUpdateManyProductSubcategoryPagesArgs = {
  data: ProductSubcategoryPageUpdateManyInput;
  where?: InputMaybe<ProductSubcategoryPageManyWhereInput>;
};


export type MutationUpdateManyProductSubcategoryPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ProductSubcategoryPageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageManyWhereInput>;
};


export type MutationUpdateManyProductsArgs = {
  data: ProductUpdateManyInput;
  where?: InputMaybe<ProductManyWhereInput>;
};


export type MutationUpdateManyProductsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ProductUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductManyWhereInput>;
};


export type MutationUpdateManyPromotionDownloadsArgs = {
  data: PromotionDownloadUpdateManyInput;
  where?: InputMaybe<PromotionDownloadManyWhereInput>;
};


export type MutationUpdateManyPromotionDownloadsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: PromotionDownloadUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PromotionDownloadManyWhereInput>;
};


export type MutationUpdateManyPromotionFormsArgs = {
  data: PromotionFormUpdateManyInput;
  where?: InputMaybe<PromotionFormManyWhereInput>;
};


export type MutationUpdateManyPromotionFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: PromotionFormUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PromotionFormManyWhereInput>;
};


export type MutationUpdateManyQuestionCheckboxCollectionsArgs = {
  data: QuestionCheckboxCollectionUpdateManyInput;
  where?: InputMaybe<QuestionCheckboxCollectionManyWhereInput>;
};


export type MutationUpdateManyQuestionCheckboxCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: QuestionCheckboxCollectionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionCheckboxCollectionManyWhereInput>;
};


export type MutationUpdateManyQuestionCheckboxesArgs = {
  data: QuestionCheckboxUpdateManyInput;
  where?: InputMaybe<QuestionCheckboxManyWhereInput>;
};


export type MutationUpdateManyQuestionCheckboxesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: QuestionCheckboxUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionCheckboxManyWhereInput>;
};


export type MutationUpdateManyQuestionRadioButtonCollectionsArgs = {
  data: QuestionRadioButtonCollectionUpdateManyInput;
  where?: InputMaybe<QuestionRadioButtonCollectionManyWhereInput>;
};


export type MutationUpdateManyQuestionRadioButtonCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: QuestionRadioButtonCollectionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionRadioButtonCollectionManyWhereInput>;
};


export type MutationUpdateManyQuestionRadioButtonsArgs = {
  data: QuestionRadioButtonUpdateManyInput;
  where?: InputMaybe<QuestionRadioButtonManyWhereInput>;
};


export type MutationUpdateManyQuestionRadioButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: QuestionRadioButtonUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionRadioButtonManyWhereInput>;
};


export type MutationUpdateManyQuestionsArgs = {
  data: QuestionUpdateManyInput;
  where?: InputMaybe<QuestionManyWhereInput>;
};


export type MutationUpdateManyQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: QuestionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionManyWhereInput>;
};


export type MutationUpdateManyRatingsArgs = {
  data: RatingUpdateManyInput;
  where?: InputMaybe<RatingManyWhereInput>;
};


export type MutationUpdateManyRatingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: RatingUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RatingManyWhereInput>;
};


export type MutationUpdateManyRecipeCategoriesArgs = {
  data: RecipeCategoryUpdateManyInput;
  where?: InputMaybe<RecipeCategoryManyWhereInput>;
};


export type MutationUpdateManyRecipeCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: RecipeCategoryUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryManyWhereInput>;
};


export type MutationUpdateManyRecipeLandingPagesArgs = {
  data: RecipeLandingPageUpdateManyInput;
  where?: InputMaybe<RecipeLandingPageManyWhereInput>;
};


export type MutationUpdateManyRecipeLandingPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: RecipeLandingPageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageManyWhereInput>;
};


export type MutationUpdateManyRecipeSubcategoriesArgs = {
  data: RecipeSubcategoryUpdateManyInput;
  where?: InputMaybe<RecipeSubcategoryManyWhereInput>;
};


export type MutationUpdateManyRecipeSubcategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: RecipeSubcategoryUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryManyWhereInput>;
};


export type MutationUpdateManyRecipesArgs = {
  data: RecipeUpdateManyInput;
  where?: InputMaybe<RecipeManyWhereInput>;
};


export type MutationUpdateManyRecipesComparisonQueryComponentsArgs = {
  data: RecipesComparisonQueryComponentUpdateManyInput;
  where?: InputMaybe<RecipesComparisonQueryComponentManyWhereInput>;
};


export type MutationUpdateManyRecipesComparisonQueryComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: RecipesComparisonQueryComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipesComparisonQueryComponentManyWhereInput>;
};


export type MutationUpdateManyRecipesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: RecipeUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeManyWhereInput>;
};


export type MutationUpdateManyRecipesQueriesReferencesArgs = {
  data: RecipesQueriesReferenceUpdateManyInput;
  where?: InputMaybe<RecipesQueriesReferenceManyWhereInput>;
};


export type MutationUpdateManyRecipesQueriesReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: RecipesQueriesReferenceUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipesQueriesReferenceManyWhereInput>;
};


export type MutationUpdateManyRecipesQueryComponentsArgs = {
  data: RecipesQueryComponentUpdateManyInput;
  where?: InputMaybe<RecipesQueryComponentManyWhereInput>;
};


export type MutationUpdateManyRecipesQueryComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: RecipesQueryComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipesQueryComponentManyWhereInput>;
};


export type MutationUpdateManyRedirectsArgs = {
  data: RedirectUpdateManyInput;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationUpdateManyRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: RedirectUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationUpdateManyRewritesArgs = {
  data: RewriteUpdateManyInput;
  where?: InputMaybe<RewriteManyWhereInput>;
};


export type MutationUpdateManyRewritesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: RewriteUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RewriteManyWhereInput>;
};


export type MutationUpdateManyRightColumnsArgs = {
  data: RightColumnUpdateManyInput;
  where?: InputMaybe<RightColumnManyWhereInput>;
};


export type MutationUpdateManyRightColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: RightColumnUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RightColumnManyWhereInput>;
};


export type MutationUpdateManySearchInputsArgs = {
  data: SearchInputUpdateManyInput;
  where?: InputMaybe<SearchInputManyWhereInput>;
};


export type MutationUpdateManySearchInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SearchInputUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SearchInputManyWhereInput>;
};


export type MutationUpdateManySearchOverlayComponentsArgs = {
  data: SearchOverlayComponentUpdateManyInput;
  where?: InputMaybe<SearchOverlayComponentManyWhereInput>;
};


export type MutationUpdateManySearchOverlayComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SearchOverlayComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SearchOverlayComponentManyWhereInput>;
};


export type MutationUpdateManySearchResultPagesArgs = {
  data: SearchResultPageUpdateManyInput;
  where?: InputMaybe<SearchResultPageManyWhereInput>;
};


export type MutationUpdateManySearchResultPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SearchResultPageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SearchResultPageManyWhereInput>;
};


export type MutationUpdateManySeparatorsArgs = {
  data: SeparatorUpdateManyInput;
  where?: InputMaybe<SeparatorManyWhereInput>;
};


export type MutationUpdateManySeparatorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SeparatorUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SeparatorManyWhereInput>;
};


export type MutationUpdateManySingleStepPromotionFormsArgs = {
  data: SingleStepPromotionFormUpdateManyInput;
  where?: InputMaybe<SingleStepPromotionFormManyWhereInput>;
};


export type MutationUpdateManySingleStepPromotionFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SingleStepPromotionFormUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SingleStepPromotionFormManyWhereInput>;
};


export type MutationUpdateManySocialMediaListComponentsArgs = {
  data: SocialMediaListComponentUpdateManyInput;
  where?: InputMaybe<SocialMediaListComponentManyWhereInput>;
};


export type MutationUpdateManySocialMediaListComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SocialMediaListComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SocialMediaListComponentManyWhereInput>;
};


export type MutationUpdateManySpacersArgs = {
  data: SpacerUpdateManyInput;
  where?: InputMaybe<SpacerManyWhereInput>;
};


export type MutationUpdateManySpacersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SpacerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpacerManyWhereInput>;
};


export type MutationUpdateManySubCategoryKeyImagesArgs = {
  data: SubCategoryKeyImageUpdateManyInput;
  where?: InputMaybe<SubCategoryKeyImageManyWhereInput>;
};


export type MutationUpdateManySubCategoryKeyImagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SubCategoryKeyImageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubCategoryKeyImageManyWhereInput>;
};


export type MutationUpdateManySubTabsArgs = {
  data: SubTabUpdateManyInput;
  where?: InputMaybe<SubTabManyWhereInput>;
};


export type MutationUpdateManySubTabsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SubTabUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubTabManyWhereInput>;
};


export type MutationUpdateManySubTabsContentArgs = {
  data: SubTabContentUpdateManyInput;
  where?: InputMaybe<SubTabContentManyWhereInput>;
};


export type MutationUpdateManySubTabsContentConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SubTabContentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubTabContentManyWhereInput>;
};


export type MutationUpdateManySustainabilityBannersArgs = {
  data: SustainabilityBannerUpdateManyInput;
  where?: InputMaybe<SustainabilityBannerManyWhereInput>;
};


export type MutationUpdateManySustainabilityBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SustainabilityBannerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SustainabilityBannerManyWhereInput>;
};


export type MutationUpdateManySustainabilityInfosArgs = {
  data: SustainabilityInfoUpdateManyInput;
  where?: InputMaybe<SustainabilityInfoManyWhereInput>;
};


export type MutationUpdateManySustainabilityInfosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SustainabilityInfoUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SustainabilityInfoManyWhereInput>;
};


export type MutationUpdateManyTabContentsArgs = {
  data: TabContentUpdateManyInput;
  where?: InputMaybe<TabContentManyWhereInput>;
};


export type MutationUpdateManyTabContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TabContentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabContentManyWhereInput>;
};


export type MutationUpdateManyTabsArgs = {
  data: TabUpdateManyInput;
  where?: InputMaybe<TabManyWhereInput>;
};


export type MutationUpdateManyTabsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TabUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabManyWhereInput>;
};


export type MutationUpdateManyTeaserPlaceholdersArgs = {
  data: TeaserPlaceholderUpdateManyInput;
  where?: InputMaybe<TeaserPlaceholderManyWhereInput>;
};


export type MutationUpdateManyTeaserPlaceholdersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TeaserPlaceholderUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserPlaceholderManyWhereInput>;
};


export type MutationUpdateManyTeaserSmallPlaceholdersArgs = {
  data: TeaserSmallPlaceholderUpdateManyInput;
  where?: InputMaybe<TeaserSmallPlaceholderManyWhereInput>;
};


export type MutationUpdateManyTeaserSmallPlaceholdersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TeaserSmallPlaceholderUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallPlaceholderManyWhereInput>;
};


export type MutationUpdateManyTeaserSmallsArgs = {
  data: TeaserSmallUpdateManyInput;
  where?: InputMaybe<TeaserSmallManyWhereInput>;
};


export type MutationUpdateManyTeaserSmallsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TeaserSmallUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallManyWhereInput>;
};


export type MutationUpdateManyTeasersArgs = {
  data: TeaserUpdateManyInput;
  where?: InputMaybe<TeaserManyWhereInput>;
};


export type MutationUpdateManyTeasersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TeaserUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserManyWhereInput>;
};


export type MutationUpdateManyTestComponentWithRecipeQueriesArgs = {
  data: TestComponentWithRecipeQueryUpdateManyInput;
  where?: InputMaybe<TestComponentWithRecipeQueryManyWhereInput>;
};


export type MutationUpdateManyTestComponentWithRecipeQueriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TestComponentWithRecipeQueryUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TestComponentWithRecipeQueryManyWhereInput>;
};


export type MutationUpdateManyTestTipsANdTricksInAMarketsArgs = {
  data: TestTipsANdTricksInAMarketUpdateManyInput;
  where?: InputMaybe<TestTipsANdTricksInAMarketManyWhereInput>;
};


export type MutationUpdateManyTestTipsANdTricksInAMarketsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TestTipsANdTricksInAMarketUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TestTipsANdTricksInAMarketManyWhereInput>;
};


export type MutationUpdateManyTextComponentsArgs = {
  data: TextComponentUpdateManyInput;
  where?: InputMaybe<TextComponentManyWhereInput>;
};


export type MutationUpdateManyTextComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TextComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TextComponentManyWhereInput>;
};


export type MutationUpdateManyTipsAndTricksDetailsPagesArgs = {
  data: TipsAndTricksDetailsPageUpdateManyInput;
  where?: InputMaybe<TipsAndTricksDetailsPageManyWhereInput>;
};


export type MutationUpdateManyTipsAndTricksDetailsPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TipsAndTricksDetailsPageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TipsAndTricksDetailsPageManyWhereInput>;
};


export type MutationUpdateManyTitlesArgs = {
  data: TitleUpdateManyInput;
  where?: InputMaybe<TitleManyWhereInput>;
};


export type MutationUpdateManyTitlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TitleUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TitleManyWhereInput>;
};


export type MutationUpdateManyTwitterSeosArgs = {
  data: TwitterSeoUpdateManyInput;
  where?: InputMaybe<TwitterSeoManyWhereInput>;
};


export type MutationUpdateManyTwitterSeosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TwitterSeoUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TwitterSeoManyWhereInput>;
};


export type MutationUpdateMarketArgs = {
  data: MarketUpdateInput;
  where: MarketWhereUniqueInput;
};


export type MutationUpdateMarketUserConnectionArgs = {
  data: MarketUserConnectionUpdateInput;
  where: MarketUserConnectionWhereUniqueInput;
};


export type MutationUpdateMetaDataArgs = {
  data: MetaDataUpdateInput;
  where: MetaDataWhereUniqueInput;
};


export type MutationUpdateMobileOnlyMainNavigationArgs = {
  data: MobileOnlyMainNavigationUpdateInput;
  where: MobileOnlyMainNavigationWhereUniqueInput;
};


export type MutationUpdateMultiStepPromotionFormArgs = {
  data: MultiStepPromotionFormUpdateInput;
  where: MultiStepPromotionFormWhereUniqueInput;
};


export type MutationUpdateNavigationArgs = {
  data: NavigationUpdateInput;
  where: NavigationWhereUniqueInput;
};


export type MutationUpdateNavigationItemArgs = {
  data: NavigationItemUpdateInput;
  where: NavigationItemWhereUniqueInput;
};


export type MutationUpdateNewsletterComponentArgs = {
  data: NewsletterComponentUpdateInput;
  where: NewsletterComponentWhereUniqueInput;
};


export type MutationUpdateNewsletterSubscriptionsArgs = {
  data: NewsletterSubscriptionsUpdateInput;
  where: NewsletterSubscriptionsWhereUniqueInput;
};


export type MutationUpdateNotificationBannerArgs = {
  data: NotificationBannerUpdateInput;
  where: NotificationBannerWhereUniqueInput;
};


export type MutationUpdatePageFooterArgs = {
  data: PageFooterUpdateInput;
  where: PageFooterWhereUniqueInput;
};


export type MutationUpdatePageHeaderArgs = {
  data: PageHeaderUpdateInput;
  where: PageHeaderWhereUniqueInput;
};


export type MutationUpdatePopularSearchComponentArgs = {
  data: PopularSearchComponentUpdateInput;
  where: PopularSearchComponentWhereUniqueInput;
};


export type MutationUpdateProductArgs = {
  data: ProductUpdateInput;
  where: ProductWhereUniqueInput;
};


export type MutationUpdateProductBannerArgs = {
  data: ProductBannerUpdateInput;
  where: ProductBannerWhereUniqueInput;
};


export type MutationUpdateProductCategoryArgs = {
  data: ProductCategoryUpdateInput;
  where: ProductCategoryWhereUniqueInput;
};


export type MutationUpdateProductCategoryPageArgs = {
  data: ProductCategoryPageUpdateInput;
  where: ProductCategoryPageWhereUniqueInput;
};


export type MutationUpdateProductDetailPageArgs = {
  data: ProductDetailPageUpdateInput;
  where: ProductDetailPageWhereUniqueInput;
};


export type MutationUpdateProductHeroArgs = {
  data: ProductHeroUpdateInput;
  where: ProductHeroWhereUniqueInput;
};


export type MutationUpdateProductLabelArgs = {
  data: ProductLabelUpdateInput;
  where: ProductLabelWhereUniqueInput;
};


export type MutationUpdateProductLandingPageArgs = {
  data: ProductLandingPageUpdateInput;
  where: ProductLandingPageWhereUniqueInput;
};


export type MutationUpdateProductSubcategoryPageArgs = {
  data: ProductSubcategoryPageUpdateInput;
  where: ProductSubcategoryPageWhereUniqueInput;
};


export type MutationUpdatePromotionDownloadArgs = {
  data: PromotionDownloadUpdateInput;
  where: PromotionDownloadWhereUniqueInput;
};


export type MutationUpdatePromotionFormArgs = {
  data: PromotionFormUpdateInput;
  where: PromotionFormWhereUniqueInput;
};


export type MutationUpdateQuestionArgs = {
  data: QuestionUpdateInput;
  where: QuestionWhereUniqueInput;
};


export type MutationUpdateQuestionCheckboxArgs = {
  data: QuestionCheckboxUpdateInput;
  where: QuestionCheckboxWhereUniqueInput;
};


export type MutationUpdateQuestionCheckboxCollectionArgs = {
  data: QuestionCheckboxCollectionUpdateInput;
  where: QuestionCheckboxCollectionWhereUniqueInput;
};


export type MutationUpdateQuestionRadioButtonArgs = {
  data: QuestionRadioButtonUpdateInput;
  where: QuestionRadioButtonWhereUniqueInput;
};


export type MutationUpdateQuestionRadioButtonCollectionArgs = {
  data: QuestionRadioButtonCollectionUpdateInput;
  where: QuestionRadioButtonCollectionWhereUniqueInput;
};


export type MutationUpdateRatingArgs = {
  data: RatingUpdateInput;
  where: RatingWhereUniqueInput;
};


export type MutationUpdateRecipeArgs = {
  data: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};


export type MutationUpdateRecipeCategoryArgs = {
  data: RecipeCategoryUpdateInput;
  where: RecipeCategoryWhereUniqueInput;
};


export type MutationUpdateRecipeLandingPageArgs = {
  data: RecipeLandingPageUpdateInput;
  where: RecipeLandingPageWhereUniqueInput;
};


export type MutationUpdateRecipeSubcategoryArgs = {
  data: RecipeSubcategoryUpdateInput;
  where: RecipeSubcategoryWhereUniqueInput;
};


export type MutationUpdateRecipesComparisonQueryComponentArgs = {
  data: RecipesComparisonQueryComponentUpdateInput;
  where: RecipesComparisonQueryComponentWhereUniqueInput;
};


export type MutationUpdateRecipesQueriesReferenceArgs = {
  data: RecipesQueriesReferenceUpdateInput;
  where: RecipesQueriesReferenceWhereUniqueInput;
};


export type MutationUpdateRecipesQueryComponentArgs = {
  data: RecipesQueryComponentUpdateInput;
  where: RecipesQueryComponentWhereUniqueInput;
};


export type MutationUpdateRedirectArgs = {
  data: RedirectUpdateInput;
  where: RedirectWhereUniqueInput;
};


export type MutationUpdateRewriteArgs = {
  data: RewriteUpdateInput;
  where: RewriteWhereUniqueInput;
};


export type MutationUpdateRightColumnArgs = {
  data: RightColumnUpdateInput;
  where: RightColumnWhereUniqueInput;
};


export type MutationUpdateScheduledReleaseArgs = {
  data: ScheduledReleaseUpdateInput;
  where: ScheduledReleaseWhereUniqueInput;
};


export type MutationUpdateSearchInputArgs = {
  data: SearchInputUpdateInput;
  where: SearchInputWhereUniqueInput;
};


export type MutationUpdateSearchOverlayComponentArgs = {
  data: SearchOverlayComponentUpdateInput;
  where: SearchOverlayComponentWhereUniqueInput;
};


export type MutationUpdateSearchResultPageArgs = {
  data: SearchResultPageUpdateInput;
  where: SearchResultPageWhereUniqueInput;
};


export type MutationUpdateSeparatorArgs = {
  data: SeparatorUpdateInput;
  where: SeparatorWhereUniqueInput;
};


export type MutationUpdateSingleStepPromotionFormArgs = {
  data: SingleStepPromotionFormUpdateInput;
  where: SingleStepPromotionFormWhereUniqueInput;
};


export type MutationUpdateSocialMediaListComponentArgs = {
  data: SocialMediaListComponentUpdateInput;
  where: SocialMediaListComponentWhereUniqueInput;
};


export type MutationUpdateSpacerArgs = {
  data: SpacerUpdateInput;
  where: SpacerWhereUniqueInput;
};


export type MutationUpdateSubCategoryKeyImageArgs = {
  data: SubCategoryKeyImageUpdateInput;
  where: SubCategoryKeyImageWhereUniqueInput;
};


export type MutationUpdateSubTabArgs = {
  data: SubTabUpdateInput;
  where: SubTabWhereUniqueInput;
};


export type MutationUpdateSubTabContentArgs = {
  data: SubTabContentUpdateInput;
  where: SubTabContentWhereUniqueInput;
};


export type MutationUpdateSustainabilityBannerArgs = {
  data: SustainabilityBannerUpdateInput;
  where: SustainabilityBannerWhereUniqueInput;
};


export type MutationUpdateSustainabilityInfoArgs = {
  data: SustainabilityInfoUpdateInput;
  where: SustainabilityInfoWhereUniqueInput;
};


export type MutationUpdateTabArgs = {
  data: TabUpdateInput;
  where: TabWhereUniqueInput;
};


export type MutationUpdateTabContentArgs = {
  data: TabContentUpdateInput;
  where: TabContentWhereUniqueInput;
};


export type MutationUpdateTeaserArgs = {
  data: TeaserUpdateInput;
  where: TeaserWhereUniqueInput;
};


export type MutationUpdateTeaserPlaceholderArgs = {
  data: TeaserPlaceholderUpdateInput;
  where: TeaserPlaceholderWhereUniqueInput;
};


export type MutationUpdateTeaserSmallArgs = {
  data: TeaserSmallUpdateInput;
  where: TeaserSmallWhereUniqueInput;
};


export type MutationUpdateTeaserSmallPlaceholderArgs = {
  data: TeaserSmallPlaceholderUpdateInput;
  where: TeaserSmallPlaceholderWhereUniqueInput;
};


export type MutationUpdateTestComponentWithRecipeQueryArgs = {
  data: TestComponentWithRecipeQueryUpdateInput;
  where: TestComponentWithRecipeQueryWhereUniqueInput;
};


export type MutationUpdateTestTipsANdTricksInAMarketArgs = {
  data: TestTipsANdTricksInAMarketUpdateInput;
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};


export type MutationUpdateTextComponentArgs = {
  data: TextComponentUpdateInput;
  where: TextComponentWhereUniqueInput;
};


export type MutationUpdateTipsAndTricksDetailsPageArgs = {
  data: TipsAndTricksDetailsPageUpdateInput;
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};


export type MutationUpdateTitleArgs = {
  data: TitleUpdateInput;
  where: TitleWhereUniqueInput;
};


export type MutationUpdateTwitterSeoArgs = {
  data: TwitterSeoUpdateInput;
  where: TwitterSeoWhereUniqueInput;
};


export type MutationUpsertAccordionArgs = {
  upsert: AccordionUpsertInput;
  where: AccordionWhereUniqueInput;
};


export type MutationUpsertAccordionItemArgs = {
  upsert: AccordionItemUpsertInput;
  where: AccordionItemWhereUniqueInput;
};


export type MutationUpsertAlgoliaExtensionArgs = {
  upsert: AlgoliaExtensionUpsertInput;
  where: AlgoliaExtensionWhereUniqueInput;
};


export type MutationUpsertAnchorNavArgs = {
  upsert: AnchorNavUpsertInput;
  where: AnchorNavWhereUniqueInput;
};


export type MutationUpsertAnchorNavigationArgs = {
  upsert: AnchorNavigationUpsertInput;
  where: AnchorNavigationWhereUniqueInput;
};


export type MutationUpsertAnchorNavigationListArgs = {
  upsert: AnchorNavigationListUpsertInput;
  where: AnchorNavigationListWhereUniqueInput;
};


export type MutationUpsertAssetArgs = {
  upsert: AssetUpsertInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpsertAssetComponentArgs = {
  upsert: AssetComponentUpsertInput;
  where: AssetComponentWhereUniqueInput;
};


export type MutationUpsertAudioComponentArgs = {
  upsert: AudioComponentUpsertInput;
  where: AudioComponentWhereUniqueInput;
};


export type MutationUpsertAuthorableContentCardArgs = {
  upsert: AuthorableContentCardUpsertInput;
  where: AuthorableContentCardWhereUniqueInput;
};


export type MutationUpsertBanner1Args = {
  upsert: Banner1UpsertInput;
  where: Banner1WhereUniqueInput;
};


export type MutationUpsertBanner2Args = {
  upsert: Banner2UpsertInput;
  where: Banner2WhereUniqueInput;
};


export type MutationUpsertBanner2CarouselComponentArgs = {
  upsert: Banner2CarouselComponentUpsertInput;
  where: Banner2CarouselComponentWhereUniqueInput;
};


export type MutationUpsertCardComponentArgs = {
  upsert: CardComponentUpsertInput;
  where: CardComponentWhereUniqueInput;
};


export type MutationUpsertCarouselComponentArgs = {
  upsert: CarouselComponentUpsertInput;
  where: CarouselComponentWhereUniqueInput;
};


export type MutationUpsertCarouselSlideArgs = {
  upsert: CarouselSlideUpsertInput;
  where: CarouselSlideWhereUniqueInput;
};


export type MutationUpsertCategoryCardArgs = {
  upsert: CategoryCardUpsertInput;
  where: CategoryCardWhereUniqueInput;
};


export type MutationUpsertContactCardArgs = {
  upsert: ContactCardUpsertInput;
  where: ContactCardWhereUniqueInput;
};


export type MutationUpsertContactCardContainerArgs = {
  upsert: ContactCardContainerUpsertInput;
  where: ContactCardContainerWhereUniqueInput;
};


export type MutationUpsertCountrySelectorFooterArgs = {
  upsert: CountrySelectorFooterUpsertInput;
  where: CountrySelectorFooterWhereUniqueInput;
};


export type MutationUpsertCountrySelectorItemArgs = {
  upsert: CountrySelectorItemUpsertInput;
  where: CountrySelectorItemWhereUniqueInput;
};


export type MutationUpsertDemoModelArgs = {
  upsert: DemoModelUpsertInput;
  where: DemoModelWhereUniqueInput;
};


export type MutationUpsertDictionaryArgs = {
  upsert: DictionaryUpsertInput;
  where: DictionaryWhereUniqueInput;
};


export type MutationUpsertDictionaryItemArgs = {
  upsert: DictionaryItemUpsertInput;
  where: DictionaryItemWhereUniqueInput;
};


export type MutationUpsertDownloadAppArgs = {
  upsert: DownloadAppUpsertInput;
  where: DownloadAppWhereUniqueInput;
};


export type MutationUpsertDynamicCardGridArgs = {
  upsert: DynamicCardGridUpsertInput;
  where: DynamicCardGridWhereUniqueInput;
};


export type MutationUpsertErrorPageArgs = {
  upsert: ErrorPageUpsertInput;
  where: ErrorPageWhereUniqueInput;
};


export type MutationUpsertEvalancheFormComponentArgs = {
  upsert: EvalancheFormComponentUpsertInput;
  where: EvalancheFormComponentWhereUniqueInput;
};


export type MutationUpsertExampleComponentArgs = {
  upsert: ExampleComponentUpsertInput;
  where: ExampleComponentWhereUniqueInput;
};


export type MutationUpsertFeaturedContentArgs = {
  upsert: FeaturedContentUpsertInput;
  where: FeaturedContentWhereUniqueInput;
};


export type MutationUpsertFeaturedContentReferenceArgs = {
  upsert: FeaturedContentReferenceUpsertInput;
  where: FeaturedContentReferenceWhereUniqueInput;
};


export type MutationUpsertFooterNavigationArgs = {
  upsert: FooterNavigationUpsertInput;
  where: FooterNavigationWhereUniqueInput;
};


export type MutationUpsertFooterSealArgs = {
  upsert: FooterSealUpsertInput;
  where: FooterSealWhereUniqueInput;
};


export type MutationUpsertFormArgs = {
  upsert: FormUpsertInput;
  where: FormWhereUniqueInput;
};


export type MutationUpsertFormCheckboxArgs = {
  upsert: FormCheckboxUpsertInput;
  where: FormCheckboxWhereUniqueInput;
};


export type MutationUpsertFormCheckboxCollectionArgs = {
  upsert: FormCheckboxCollectionUpsertInput;
  where: FormCheckboxCollectionWhereUniqueInput;
};


export type MutationUpsertFormDateInputArgs = {
  upsert: FormDateInputUpsertInput;
  where: FormDateInputWhereUniqueInput;
};


export type MutationUpsertFormEmailInputArgs = {
  upsert: FormEmailInputUpsertInput;
  where: FormEmailInputWhereUniqueInput;
};


export type MutationUpsertFormErrorArgs = {
  upsert: FormErrorUpsertInput;
  where: FormErrorWhereUniqueInput;
};


export type MutationUpsertFormFileUploaderArgs = {
  upsert: FormFileUploaderUpsertInput;
  where: FormFileUploaderWhereUniqueInput;
};


export type MutationUpsertFormListArgs = {
  upsert: FormListUpsertInput;
  where: FormListWhereUniqueInput;
};


export type MutationUpsertFormListItemArgs = {
  upsert: FormListItemUpsertInput;
  where: FormListItemWhereUniqueInput;
};


export type MutationUpsertFormNumberInputArgs = {
  upsert: FormNumberInputUpsertInput;
  where: FormNumberInputWhereUniqueInput;
};


export type MutationUpsertFormPasswordInputArgs = {
  upsert: FormPasswordInputUpsertInput;
  where: FormPasswordInputWhereUniqueInput;
};


export type MutationUpsertFormPasswordInputWithConfirmationArgs = {
  upsert: FormPasswordInputWithConfirmationUpsertInput;
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};


export type MutationUpsertFormRadioButtonArgs = {
  upsert: FormRadioButtonUpsertInput;
  where: FormRadioButtonWhereUniqueInput;
};


export type MutationUpsertFormRadioButtonCollectionArgs = {
  upsert: FormRadioButtonCollectionUpsertInput;
  where: FormRadioButtonCollectionWhereUniqueInput;
};


export type MutationUpsertFormSelectComponentArgs = {
  upsert: FormSelectComponentUpsertInput;
  where: FormSelectComponentWhereUniqueInput;
};


export type MutationUpsertFormSelectOptionArgs = {
  upsert: FormSelectOptionUpsertInput;
  where: FormSelectOptionWhereUniqueInput;
};


export type MutationUpsertFormSubmitButtonArgs = {
  upsert: FormSubmitButtonUpsertInput;
  where: FormSubmitButtonWhereUniqueInput;
};


export type MutationUpsertFormSuccessComponentArgs = {
  upsert: FormSuccessComponentUpsertInput;
  where: FormSuccessComponentWhereUniqueInput;
};


export type MutationUpsertFormTextInputArgs = {
  upsert: FormTextInputUpsertInput;
  where: FormTextInputWhereUniqueInput;
};


export type MutationUpsertFormTextareaInputArgs = {
  upsert: FormTextareaInputUpsertInput;
  where: FormTextareaInputWhereUniqueInput;
};


export type MutationUpsertGenericAccordionArgs = {
  upsert: GenericAccordionUpsertInput;
  where: GenericAccordionWhereUniqueInput;
};


export type MutationUpsertGenericAccordionItemArgs = {
  upsert: GenericAccordionItemUpsertInput;
  where: GenericAccordionItemWhereUniqueInput;
};


export type MutationUpsertGenericAccordionTopRatedArgs = {
  upsert: GenericAccordionTopRatedUpsertInput;
  where: GenericAccordionTopRatedWhereUniqueInput;
};


export type MutationUpsertGenericCardCarouseComponentArgs = {
  upsert: GenericCardCarouseComponentUpsertInput;
  where: GenericCardCarouseComponentWhereUniqueInput;
};


export type MutationUpsertGenericDownloadComponentArgs = {
  upsert: GenericDownloadComponentUpsertInput;
  where: GenericDownloadComponentWhereUniqueInput;
};


export type MutationUpsertGenericFollowUsArgs = {
  upsert: GenericFollowUsUpsertInput;
  where: GenericFollowUsWhereUniqueInput;
};


export type MutationUpsertGenericGridAuthorableArgs = {
  upsert: GenericGridAuthorableUpsertInput;
  where: GenericGridAuthorableWhereUniqueInput;
};


export type MutationUpsertGenericHtmlArgs = {
  upsert: GenericHtmlUpsertInput;
  where: GenericHtmlWhereUniqueInput;
};


export type MutationUpsertGenericLineArgs = {
  upsert: GenericLineUpsertInput;
  where: GenericLineWhereUniqueInput;
};


export type MutationUpsertGenericLinkArgs = {
  upsert: GenericLinkUpsertInput;
  where: GenericLinkWhereUniqueInput;
};


export type MutationUpsertGenericPageArgs = {
  upsert: GenericPageUpsertInput;
  where: GenericPageWhereUniqueInput;
};


export type MutationUpsertGenericPromotionsOverviewArgs = {
  upsert: GenericPromotionsOverviewUpsertInput;
  where: GenericPromotionsOverviewWhereUniqueInput;
};


export type MutationUpsertGenericQualifioArgs = {
  upsert: GenericQualifioUpsertInput;
  where: GenericQualifioWhereUniqueInput;
};


export type MutationUpsertGenericQualifioOverviewArgs = {
  upsert: GenericQualifioOverviewUpsertInput;
  where: GenericQualifioOverviewWhereUniqueInput;
};


export type MutationUpsertGenericSocialShareArgs = {
  upsert: GenericSocialShareUpsertInput;
  where: GenericSocialShareWhereUniqueInput;
};


export type MutationUpsertGlobalMetaDataArgs = {
  upsert: GlobalMetaDataUpsertInput;
  where: GlobalMetaDataWhereUniqueInput;
};


export type MutationUpsertGlobalSearchArgs = {
  upsert: GlobalSearchUpsertInput;
  where: GlobalSearchWhereUniqueInput;
};


export type MutationUpsertGridColumnArgs = {
  upsert: GridColumnUpsertInput;
  where: GridColumnWhereUniqueInput;
};


export type MutationUpsertGridColumnComponentArgs = {
  upsert: GridColumnComponentUpsertInput;
  where: GridColumnComponentWhereUniqueInput;
};


export type MutationUpsertHeroBannerArgs = {
  upsert: HeroBannerUpsertInput;
  where: HeroBannerWhereUniqueInput;
};


export type MutationUpsertHeroBannerMasterbrandArgs = {
  upsert: HeroBannerMasterbrandUpsertInput;
  where: HeroBannerMasterbrandWhereUniqueInput;
};


export type MutationUpsertHeroCarouselComponentArgs = {
  upsert: HeroCarouselComponentUpsertInput;
  where: HeroCarouselComponentWhereUniqueInput;
};


export type MutationUpsertHeroComponentArgs = {
  upsert: HeroComponentUpsertInput;
  where: HeroComponentWhereUniqueInput;
};


export type MutationUpsertHeroLoopAnimationComponentArgs = {
  upsert: HeroLoopAnimationComponentUpsertInput;
  where: HeroLoopAnimationComponentWhereUniqueInput;
};


export type MutationUpsertIframeArgs = {
  upsert: IframeUpsertInput;
  where: IframeWhereUniqueInput;
};


export type MutationUpsertImageAndTextCardArgs = {
  upsert: ImageAndTextCardUpsertInput;
  where: ImageAndTextCardWhereUniqueInput;
};


export type MutationUpsertImageCopyArgs = {
  upsert: ImageCopyUpsertInput;
  where: ImageCopyWhereUniqueInput;
};


export type MutationUpsertImageCopyItemArgs = {
  upsert: ImageCopyItemUpsertInput;
  where: ImageCopyItemWhereUniqueInput;
};


export type MutationUpsertIntroTextArgs = {
  upsert: IntroTextUpsertInput;
  where: IntroTextWhereUniqueInput;
};


export type MutationUpsertLeftColumnArgs = {
  upsert: LeftColumnUpsertInput;
  where: LeftColumnWhereUniqueInput;
};


export type MutationUpsertLinkArgs = {
  upsert: LinkUpsertInput;
  where: LinkWhereUniqueInput;
};


export type MutationUpsertLongTextArgs = {
  upsert: LongTextUpsertInput;
  where: LongTextWhereUniqueInput;
};


export type MutationUpsertMarketArgs = {
  upsert: MarketUpsertInput;
  where: MarketWhereUniqueInput;
};


export type MutationUpsertMarketUserConnectionArgs = {
  upsert: MarketUserConnectionUpsertInput;
  where: MarketUserConnectionWhereUniqueInput;
};


export type MutationUpsertMetaDataArgs = {
  upsert: MetaDataUpsertInput;
  where: MetaDataWhereUniqueInput;
};


export type MutationUpsertMobileOnlyMainNavigationArgs = {
  upsert: MobileOnlyMainNavigationUpsertInput;
  where: MobileOnlyMainNavigationWhereUniqueInput;
};


export type MutationUpsertMultiStepPromotionFormArgs = {
  upsert: MultiStepPromotionFormUpsertInput;
  where: MultiStepPromotionFormWhereUniqueInput;
};


export type MutationUpsertNavigationArgs = {
  upsert: NavigationUpsertInput;
  where: NavigationWhereUniqueInput;
};


export type MutationUpsertNavigationItemArgs = {
  upsert: NavigationItemUpsertInput;
  where: NavigationItemWhereUniqueInput;
};


export type MutationUpsertNewsletterComponentArgs = {
  upsert: NewsletterComponentUpsertInput;
  where: NewsletterComponentWhereUniqueInput;
};


export type MutationUpsertNewsletterSubscriptionsArgs = {
  upsert: NewsletterSubscriptionsUpsertInput;
  where: NewsletterSubscriptionsWhereUniqueInput;
};


export type MutationUpsertNotificationBannerArgs = {
  upsert: NotificationBannerUpsertInput;
  where: NotificationBannerWhereUniqueInput;
};


export type MutationUpsertPageFooterArgs = {
  upsert: PageFooterUpsertInput;
  where: PageFooterWhereUniqueInput;
};


export type MutationUpsertPageHeaderArgs = {
  upsert: PageHeaderUpsertInput;
  where: PageHeaderWhereUniqueInput;
};


export type MutationUpsertPopularSearchComponentArgs = {
  upsert: PopularSearchComponentUpsertInput;
  where: PopularSearchComponentWhereUniqueInput;
};


export type MutationUpsertProductArgs = {
  upsert: ProductUpsertInput;
  where: ProductWhereUniqueInput;
};


export type MutationUpsertProductBannerArgs = {
  upsert: ProductBannerUpsertInput;
  where: ProductBannerWhereUniqueInput;
};


export type MutationUpsertProductCategoryArgs = {
  upsert: ProductCategoryUpsertInput;
  where: ProductCategoryWhereUniqueInput;
};


export type MutationUpsertProductCategoryPageArgs = {
  upsert: ProductCategoryPageUpsertInput;
  where: ProductCategoryPageWhereUniqueInput;
};


export type MutationUpsertProductDetailPageArgs = {
  upsert: ProductDetailPageUpsertInput;
  where: ProductDetailPageWhereUniqueInput;
};


export type MutationUpsertProductHeroArgs = {
  upsert: ProductHeroUpsertInput;
  where: ProductHeroWhereUniqueInput;
};


export type MutationUpsertProductLabelArgs = {
  upsert: ProductLabelUpsertInput;
  where: ProductLabelWhereUniqueInput;
};


export type MutationUpsertProductLandingPageArgs = {
  upsert: ProductLandingPageUpsertInput;
  where: ProductLandingPageWhereUniqueInput;
};


export type MutationUpsertProductSubcategoryPageArgs = {
  upsert: ProductSubcategoryPageUpsertInput;
  where: ProductSubcategoryPageWhereUniqueInput;
};


export type MutationUpsertPromotionDownloadArgs = {
  upsert: PromotionDownloadUpsertInput;
  where: PromotionDownloadWhereUniqueInput;
};


export type MutationUpsertPromotionFormArgs = {
  upsert: PromotionFormUpsertInput;
  where: PromotionFormWhereUniqueInput;
};


export type MutationUpsertQuestionArgs = {
  upsert: QuestionUpsertInput;
  where: QuestionWhereUniqueInput;
};


export type MutationUpsertQuestionCheckboxArgs = {
  upsert: QuestionCheckboxUpsertInput;
  where: QuestionCheckboxWhereUniqueInput;
};


export type MutationUpsertQuestionCheckboxCollectionArgs = {
  upsert: QuestionCheckboxCollectionUpsertInput;
  where: QuestionCheckboxCollectionWhereUniqueInput;
};


export type MutationUpsertQuestionRadioButtonArgs = {
  upsert: QuestionRadioButtonUpsertInput;
  where: QuestionRadioButtonWhereUniqueInput;
};


export type MutationUpsertQuestionRadioButtonCollectionArgs = {
  upsert: QuestionRadioButtonCollectionUpsertInput;
  where: QuestionRadioButtonCollectionWhereUniqueInput;
};


export type MutationUpsertRatingArgs = {
  upsert: RatingUpsertInput;
  where: RatingWhereUniqueInput;
};


export type MutationUpsertRecipeArgs = {
  upsert: RecipeUpsertInput;
  where: RecipeWhereUniqueInput;
};


export type MutationUpsertRecipeCategoryArgs = {
  upsert: RecipeCategoryUpsertInput;
  where: RecipeCategoryWhereUniqueInput;
};


export type MutationUpsertRecipeLandingPageArgs = {
  upsert: RecipeLandingPageUpsertInput;
  where: RecipeLandingPageWhereUniqueInput;
};


export type MutationUpsertRecipeSubcategoryArgs = {
  upsert: RecipeSubcategoryUpsertInput;
  where: RecipeSubcategoryWhereUniqueInput;
};


export type MutationUpsertRecipesComparisonQueryComponentArgs = {
  upsert: RecipesComparisonQueryComponentUpsertInput;
  where: RecipesComparisonQueryComponentWhereUniqueInput;
};


export type MutationUpsertRecipesQueriesReferenceArgs = {
  upsert: RecipesQueriesReferenceUpsertInput;
  where: RecipesQueriesReferenceWhereUniqueInput;
};


export type MutationUpsertRecipesQueryComponentArgs = {
  upsert: RecipesQueryComponentUpsertInput;
  where: RecipesQueryComponentWhereUniqueInput;
};


export type MutationUpsertRedirectArgs = {
  upsert: RedirectUpsertInput;
  where: RedirectWhereUniqueInput;
};


export type MutationUpsertRewriteArgs = {
  upsert: RewriteUpsertInput;
  where: RewriteWhereUniqueInput;
};


export type MutationUpsertRightColumnArgs = {
  upsert: RightColumnUpsertInput;
  where: RightColumnWhereUniqueInput;
};


export type MutationUpsertSearchInputArgs = {
  upsert: SearchInputUpsertInput;
  where: SearchInputWhereUniqueInput;
};


export type MutationUpsertSearchOverlayComponentArgs = {
  upsert: SearchOverlayComponentUpsertInput;
  where: SearchOverlayComponentWhereUniqueInput;
};


export type MutationUpsertSearchResultPageArgs = {
  upsert: SearchResultPageUpsertInput;
  where: SearchResultPageWhereUniqueInput;
};


export type MutationUpsertSeparatorArgs = {
  upsert: SeparatorUpsertInput;
  where: SeparatorWhereUniqueInput;
};


export type MutationUpsertSingleStepPromotionFormArgs = {
  upsert: SingleStepPromotionFormUpsertInput;
  where: SingleStepPromotionFormWhereUniqueInput;
};


export type MutationUpsertSocialMediaListComponentArgs = {
  upsert: SocialMediaListComponentUpsertInput;
  where: SocialMediaListComponentWhereUniqueInput;
};


export type MutationUpsertSpacerArgs = {
  upsert: SpacerUpsertInput;
  where: SpacerWhereUniqueInput;
};


export type MutationUpsertSubCategoryKeyImageArgs = {
  upsert: SubCategoryKeyImageUpsertInput;
  where: SubCategoryKeyImageWhereUniqueInput;
};


export type MutationUpsertSubTabArgs = {
  upsert: SubTabUpsertInput;
  where: SubTabWhereUniqueInput;
};


export type MutationUpsertSubTabContentArgs = {
  upsert: SubTabContentUpsertInput;
  where: SubTabContentWhereUniqueInput;
};


export type MutationUpsertSustainabilityBannerArgs = {
  upsert: SustainabilityBannerUpsertInput;
  where: SustainabilityBannerWhereUniqueInput;
};


export type MutationUpsertSustainabilityInfoArgs = {
  upsert: SustainabilityInfoUpsertInput;
  where: SustainabilityInfoWhereUniqueInput;
};


export type MutationUpsertTabArgs = {
  upsert: TabUpsertInput;
  where: TabWhereUniqueInput;
};


export type MutationUpsertTabContentArgs = {
  upsert: TabContentUpsertInput;
  where: TabContentWhereUniqueInput;
};


export type MutationUpsertTeaserArgs = {
  upsert: TeaserUpsertInput;
  where: TeaserWhereUniqueInput;
};


export type MutationUpsertTeaserPlaceholderArgs = {
  upsert: TeaserPlaceholderUpsertInput;
  where: TeaserPlaceholderWhereUniqueInput;
};


export type MutationUpsertTeaserSmallArgs = {
  upsert: TeaserSmallUpsertInput;
  where: TeaserSmallWhereUniqueInput;
};


export type MutationUpsertTeaserSmallPlaceholderArgs = {
  upsert: TeaserSmallPlaceholderUpsertInput;
  where: TeaserSmallPlaceholderWhereUniqueInput;
};


export type MutationUpsertTestComponentWithRecipeQueryArgs = {
  upsert: TestComponentWithRecipeQueryUpsertInput;
  where: TestComponentWithRecipeQueryWhereUniqueInput;
};


export type MutationUpsertTestTipsANdTricksInAMarketArgs = {
  upsert: TestTipsANdTricksInAMarketUpsertInput;
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};


export type MutationUpsertTextComponentArgs = {
  upsert: TextComponentUpsertInput;
  where: TextComponentWhereUniqueInput;
};


export type MutationUpsertTipsAndTricksDetailsPageArgs = {
  upsert: TipsAndTricksDetailsPageUpsertInput;
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};


export type MutationUpsertTitleArgs = {
  upsert: TitleUpsertInput;
  where: TitleWhereUniqueInput;
};


export type MutationUpsertTwitterSeoArgs = {
  upsert: TwitterSeoUpsertInput;
  where: TwitterSeoWhereUniqueInput;
};

export type NavLinkComponent = Accordion | AuthorableContentCard | Banner1 | Banner2 | CarouselComponent | CategoryCard | ContactCard | ContactCardContainer | DynamicCardGrid | EvalancheFormComponent | FeaturedContent | Form | GenericAccordion | GenericAccordionTopRated | GenericCardCarouseComponent | GenericDownloadComponent | GenericFollowUs | HeroBanner | HeroBannerMasterbrand | HeroCarouselComponent | HeroComponent | ImageAndTextCard | ImageCopy | IntroText | LongText | MetaData | PopularSearchComponent | ProductBanner | ProductHero | Rating | RecipeSubcategory | RecipesQueriesReference | Redirect | SearchInput | SocialMediaListComponent | SustainabilityBanner | Title;

export type NavLinkComponentConnectInput = {
  Accordion?: InputMaybe<AccordionConnectInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardConnectInput>;
  Banner1?: InputMaybe<Banner1ConnectInput>;
  Banner2?: InputMaybe<Banner2ConnectInput>;
  CarouselComponent?: InputMaybe<CarouselComponentConnectInput>;
  CategoryCard?: InputMaybe<CategoryCardConnectInput>;
  ContactCard?: InputMaybe<ContactCardConnectInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerConnectInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridConnectInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentConnectInput>;
  FeaturedContent?: InputMaybe<FeaturedContentConnectInput>;
  Form?: InputMaybe<FormConnectInput>;
  GenericAccordion?: InputMaybe<GenericAccordionConnectInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedConnectInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentConnectInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentConnectInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsConnectInput>;
  HeroBanner?: InputMaybe<HeroBannerConnectInput>;
  HeroBannerMasterbrand?: InputMaybe<HeroBannerMasterbrandConnectInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentConnectInput>;
  HeroComponent?: InputMaybe<HeroComponentConnectInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardConnectInput>;
  ImageCopy?: InputMaybe<ImageCopyConnectInput>;
  IntroText?: InputMaybe<IntroTextConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
  MetaData?: InputMaybe<MetaDataConnectInput>;
  PopularSearchComponent?: InputMaybe<PopularSearchComponentConnectInput>;
  ProductBanner?: InputMaybe<ProductBannerConnectInput>;
  ProductHero?: InputMaybe<ProductHeroConnectInput>;
  Rating?: InputMaybe<RatingConnectInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryConnectInput>;
  RecipesQueriesReference?: InputMaybe<RecipesQueriesReferenceConnectInput>;
  Redirect?: InputMaybe<RedirectConnectInput>;
  SearchInput?: InputMaybe<SearchInputConnectInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentConnectInput>;
  SustainabilityBanner?: InputMaybe<SustainabilityBannerConnectInput>;
  Title?: InputMaybe<TitleConnectInput>;
};

export type NavLinkComponentCreateInput = {
  Accordion?: InputMaybe<AccordionCreateInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardCreateInput>;
  Banner1?: InputMaybe<Banner1CreateInput>;
  Banner2?: InputMaybe<Banner2CreateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentCreateInput>;
  CategoryCard?: InputMaybe<CategoryCardCreateInput>;
  ContactCard?: InputMaybe<ContactCardCreateInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerCreateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridCreateInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentCreateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentCreateInput>;
  Form?: InputMaybe<FormCreateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionCreateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedCreateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentCreateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsCreateInput>;
  HeroBanner?: InputMaybe<HeroBannerCreateInput>;
  HeroBannerMasterbrand?: InputMaybe<HeroBannerMasterbrandCreateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateInput>;
  HeroComponent?: InputMaybe<HeroComponentCreateInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardCreateInput>;
  ImageCopy?: InputMaybe<ImageCopyCreateInput>;
  IntroText?: InputMaybe<IntroTextCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
  MetaData?: InputMaybe<MetaDataCreateInput>;
  PopularSearchComponent?: InputMaybe<PopularSearchComponentCreateInput>;
  ProductBanner?: InputMaybe<ProductBannerCreateInput>;
  ProductHero?: InputMaybe<ProductHeroCreateInput>;
  Rating?: InputMaybe<RatingCreateInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryCreateInput>;
  RecipesQueriesReference?: InputMaybe<RecipesQueriesReferenceCreateInput>;
  Redirect?: InputMaybe<RedirectCreateInput>;
  SearchInput?: InputMaybe<SearchInputCreateInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentCreateInput>;
  SustainabilityBanner?: InputMaybe<SustainabilityBannerCreateInput>;
  Title?: InputMaybe<TitleCreateInput>;
};

export type NavLinkComponentCreateManyInlineInput = {
  /** Connect multiple existing NavLinkComponent documents */
  connect?: InputMaybe<Array<NavLinkComponentWhereUniqueInput>>;
  /** Create and connect multiple existing NavLinkComponent documents */
  create?: InputMaybe<Array<NavLinkComponentCreateInput>>;
};

export type NavLinkComponentCreateOneInlineInput = {
  /** Connect one existing NavLinkComponent document */
  connect?: InputMaybe<NavLinkComponentWhereUniqueInput>;
  /** Create and connect one NavLinkComponent document */
  create?: InputMaybe<NavLinkComponentCreateInput>;
};

export type NavLinkComponentUpdateInput = {
  Accordion?: InputMaybe<AccordionUpdateInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateInput>;
  Banner1?: InputMaybe<Banner1UpdateInput>;
  Banner2?: InputMaybe<Banner2UpdateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateInput>;
  CategoryCard?: InputMaybe<CategoryCardUpdateInput>;
  ContactCard?: InputMaybe<ContactCardUpdateInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerUpdateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateInput>;
  Form?: InputMaybe<FormUpdateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateInput>;
  HeroBanner?: InputMaybe<HeroBannerUpdateInput>;
  HeroBannerMasterbrand?: InputMaybe<HeroBannerMasterbrandUpdateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateInput>;
  HeroComponent?: InputMaybe<HeroComponentUpdateInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardUpdateInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateInput>;
  IntroText?: InputMaybe<IntroTextUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
  MetaData?: InputMaybe<MetaDataUpdateInput>;
  PopularSearchComponent?: InputMaybe<PopularSearchComponentUpdateInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateInput>;
  ProductHero?: InputMaybe<ProductHeroUpdateInput>;
  Rating?: InputMaybe<RatingUpdateInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateInput>;
  RecipesQueriesReference?: InputMaybe<RecipesQueriesReferenceUpdateInput>;
  Redirect?: InputMaybe<RedirectUpdateInput>;
  SearchInput?: InputMaybe<SearchInputUpdateInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateInput>;
  SustainabilityBanner?: InputMaybe<SustainabilityBannerUpdateInput>;
  Title?: InputMaybe<TitleUpdateInput>;
};

export type NavLinkComponentUpdateManyInlineInput = {
  /** Connect multiple existing NavLinkComponent documents */
  connect?: InputMaybe<Array<NavLinkComponentConnectInput>>;
  /** Create and connect multiple NavLinkComponent documents */
  create?: InputMaybe<Array<NavLinkComponentCreateInput>>;
  /** Delete multiple NavLinkComponent documents */
  delete?: InputMaybe<Array<NavLinkComponentWhereUniqueInput>>;
  /** Disconnect multiple NavLinkComponent documents */
  disconnect?: InputMaybe<Array<NavLinkComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NavLinkComponent documents */
  set?: InputMaybe<Array<NavLinkComponentWhereUniqueInput>>;
  /** Update multiple NavLinkComponent documents */
  update?: InputMaybe<Array<NavLinkComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NavLinkComponent documents */
  upsert?: InputMaybe<Array<NavLinkComponentUpsertWithNestedWhereUniqueInput>>;
};

export type NavLinkComponentUpdateManyWithNestedWhereInput = {
  Accordion?: InputMaybe<AccordionUpdateManyWithNestedWhereInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateManyWithNestedWhereInput>;
  Banner1?: InputMaybe<Banner1UpdateManyWithNestedWhereInput>;
  Banner2?: InputMaybe<Banner2UpdateManyWithNestedWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateManyWithNestedWhereInput>;
  CategoryCard?: InputMaybe<CategoryCardUpdateManyWithNestedWhereInput>;
  ContactCard?: InputMaybe<ContactCardUpdateManyWithNestedWhereInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerUpdateManyWithNestedWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateManyWithNestedWhereInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateManyWithNestedWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateManyWithNestedWhereInput>;
  Form?: InputMaybe<FormUpdateManyWithNestedWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateManyWithNestedWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateManyWithNestedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateManyWithNestedWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateManyWithNestedWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateManyWithNestedWhereInput>;
  HeroBanner?: InputMaybe<HeroBannerUpdateManyWithNestedWhereInput>;
  HeroBannerMasterbrand?: InputMaybe<HeroBannerMasterbrandUpdateManyWithNestedWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateManyWithNestedWhereInput>;
  HeroComponent?: InputMaybe<HeroComponentUpdateManyWithNestedWhereInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardUpdateManyWithNestedWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateManyWithNestedWhereInput>;
  IntroText?: InputMaybe<IntroTextUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
  MetaData?: InputMaybe<MetaDataUpdateManyWithNestedWhereInput>;
  PopularSearchComponent?: InputMaybe<PopularSearchComponentUpdateManyWithNestedWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateManyWithNestedWhereInput>;
  ProductHero?: InputMaybe<ProductHeroUpdateManyWithNestedWhereInput>;
  Rating?: InputMaybe<RatingUpdateManyWithNestedWhereInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateManyWithNestedWhereInput>;
  RecipesQueriesReference?: InputMaybe<RecipesQueriesReferenceUpdateManyWithNestedWhereInput>;
  Redirect?: InputMaybe<RedirectUpdateManyWithNestedWhereInput>;
  SearchInput?: InputMaybe<SearchInputUpdateManyWithNestedWhereInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateManyWithNestedWhereInput>;
  SustainabilityBanner?: InputMaybe<SustainabilityBannerUpdateManyWithNestedWhereInput>;
  Title?: InputMaybe<TitleUpdateManyWithNestedWhereInput>;
};

export type NavLinkComponentUpdateOneInlineInput = {
  /** Connect existing NavLinkComponent document */
  connect?: InputMaybe<NavLinkComponentWhereUniqueInput>;
  /** Create and connect one NavLinkComponent document */
  create?: InputMaybe<NavLinkComponentCreateInput>;
  /** Delete currently connected NavLinkComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NavLinkComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NavLinkComponent document */
  update?: InputMaybe<NavLinkComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NavLinkComponent document */
  upsert?: InputMaybe<NavLinkComponentUpsertWithNestedWhereUniqueInput>;
};

export type NavLinkComponentUpdateWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpdateWithNestedWhereUniqueInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpdateWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpdateWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateWithNestedWhereUniqueInput>;
  CategoryCard?: InputMaybe<CategoryCardUpdateWithNestedWhereUniqueInput>;
  ContactCard?: InputMaybe<ContactCardUpdateWithNestedWhereUniqueInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerUpdateWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateWithNestedWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateWithNestedWhereUniqueInput>;
  Form?: InputMaybe<FormUpdateWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateWithNestedWhereUniqueInput>;
  HeroBanner?: InputMaybe<HeroBannerUpdateWithNestedWhereUniqueInput>;
  HeroBannerMasterbrand?: InputMaybe<HeroBannerMasterbrandUpdateWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateWithNestedWhereUniqueInput>;
  HeroComponent?: InputMaybe<HeroComponentUpdateWithNestedWhereUniqueInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardUpdateWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  MetaData?: InputMaybe<MetaDataUpdateWithNestedWhereUniqueInput>;
  PopularSearchComponent?: InputMaybe<PopularSearchComponentUpdateWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateWithNestedWhereUniqueInput>;
  ProductHero?: InputMaybe<ProductHeroUpdateWithNestedWhereUniqueInput>;
  Rating?: InputMaybe<RatingUpdateWithNestedWhereUniqueInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateWithNestedWhereUniqueInput>;
  RecipesQueriesReference?: InputMaybe<RecipesQueriesReferenceUpdateWithNestedWhereUniqueInput>;
  Redirect?: InputMaybe<RedirectUpdateWithNestedWhereUniqueInput>;
  SearchInput?: InputMaybe<SearchInputUpdateWithNestedWhereUniqueInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateWithNestedWhereUniqueInput>;
  SustainabilityBanner?: InputMaybe<SustainabilityBannerUpdateWithNestedWhereUniqueInput>;
  Title?: InputMaybe<TitleUpdateWithNestedWhereUniqueInput>;
};

export type NavLinkComponentUpsertWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpsertWithNestedWhereUniqueInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpsertWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpsertWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpsertWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpsertWithNestedWhereUniqueInput>;
  CategoryCard?: InputMaybe<CategoryCardUpsertWithNestedWhereUniqueInput>;
  ContactCard?: InputMaybe<ContactCardUpsertWithNestedWhereUniqueInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerUpsertWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpsertWithNestedWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpsertWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpsertWithNestedWhereUniqueInput>;
  Form?: InputMaybe<FormUpsertWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpsertWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpsertWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpsertWithNestedWhereUniqueInput>;
  HeroBanner?: InputMaybe<HeroBannerUpsertWithNestedWhereUniqueInput>;
  HeroBannerMasterbrand?: InputMaybe<HeroBannerMasterbrandUpsertWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpsertWithNestedWhereUniqueInput>;
  HeroComponent?: InputMaybe<HeroComponentUpsertWithNestedWhereUniqueInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardUpsertWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpsertWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
  MetaData?: InputMaybe<MetaDataUpsertWithNestedWhereUniqueInput>;
  PopularSearchComponent?: InputMaybe<PopularSearchComponentUpsertWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpsertWithNestedWhereUniqueInput>;
  ProductHero?: InputMaybe<ProductHeroUpsertWithNestedWhereUniqueInput>;
  Rating?: InputMaybe<RatingUpsertWithNestedWhereUniqueInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpsertWithNestedWhereUniqueInput>;
  RecipesQueriesReference?: InputMaybe<RecipesQueriesReferenceUpsertWithNestedWhereUniqueInput>;
  Redirect?: InputMaybe<RedirectUpsertWithNestedWhereUniqueInput>;
  SearchInput?: InputMaybe<SearchInputUpsertWithNestedWhereUniqueInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpsertWithNestedWhereUniqueInput>;
  SustainabilityBanner?: InputMaybe<SustainabilityBannerUpsertWithNestedWhereUniqueInput>;
  Title?: InputMaybe<TitleUpsertWithNestedWhereUniqueInput>;
};

export type NavLinkComponentWhereInput = {
  Accordion?: InputMaybe<AccordionWhereInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereInput>;
  Banner1?: InputMaybe<Banner1WhereInput>;
  Banner2?: InputMaybe<Banner2WhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  CategoryCard?: InputMaybe<CategoryCardWhereInput>;
  ContactCard?: InputMaybe<ContactCardWhereInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereInput>;
  Form?: InputMaybe<FormWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereInput>;
  HeroBanner?: InputMaybe<HeroBannerWhereInput>;
  HeroBannerMasterbrand?: InputMaybe<HeroBannerMasterbrandWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  HeroComponent?: InputMaybe<HeroComponentWhereInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereInput>;
  IntroText?: InputMaybe<IntroTextWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
  MetaData?: InputMaybe<MetaDataWhereInput>;
  PopularSearchComponent?: InputMaybe<PopularSearchComponentWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereInput>;
  ProductHero?: InputMaybe<ProductHeroWhereInput>;
  Rating?: InputMaybe<RatingWhereInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryWhereInput>;
  RecipesQueriesReference?: InputMaybe<RecipesQueriesReferenceWhereInput>;
  Redirect?: InputMaybe<RedirectWhereInput>;
  SearchInput?: InputMaybe<SearchInputWhereInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentWhereInput>;
  SustainabilityBanner?: InputMaybe<SustainabilityBannerWhereInput>;
  Title?: InputMaybe<TitleWhereInput>;
};

export type NavLinkComponentWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionWhereUniqueInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1WhereUniqueInput>;
  Banner2?: InputMaybe<Banner2WhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereUniqueInput>;
  CategoryCard?: InputMaybe<CategoryCardWhereUniqueInput>;
  ContactCard?: InputMaybe<ContactCardWhereUniqueInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereUniqueInput>;
  Form?: InputMaybe<FormWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereUniqueInput>;
  HeroBanner?: InputMaybe<HeroBannerWhereUniqueInput>;
  HeroBannerMasterbrand?: InputMaybe<HeroBannerMasterbrandWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereUniqueInput>;
  HeroComponent?: InputMaybe<HeroComponentWhereUniqueInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
  MetaData?: InputMaybe<MetaDataWhereUniqueInput>;
  PopularSearchComponent?: InputMaybe<PopularSearchComponentWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereUniqueInput>;
  ProductHero?: InputMaybe<ProductHeroWhereUniqueInput>;
  Rating?: InputMaybe<RatingWhereUniqueInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryWhereUniqueInput>;
  RecipesQueriesReference?: InputMaybe<RecipesQueriesReferenceWhereUniqueInput>;
  Redirect?: InputMaybe<RedirectWhereUniqueInput>;
  SearchInput?: InputMaybe<SearchInputWhereUniqueInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentWhereUniqueInput>;
  SustainabilityBanner?: InputMaybe<SustainabilityBannerWhereUniqueInput>;
  Title?: InputMaybe<TitleWhereUniqueInput>;
};

/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type Navigation = Entity & Node & {
  __typename?: 'Navigation';
  /** Title Above the card component */
  cardComponentTitle?: Maybe<Scalars['String']['output']>;
  cardItemtId?: Maybe<Scalars['String']['output']>;
  /** Header Nav Category */
  category: Array<NavigationCategory>;
  /** Title is used to display on website */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Navigation>;
  /** List of Navigation versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Unique key for each header navigation. Should be "More" to show items in mobile navigation on main overlay.  */
  key: Scalars['String']['output'];
  /** Define link for navigation text and link */
  links: Array<Link>;
  market: Markets;
  marketName?: Maybe<Market>;
  navCard?: Maybe<NavigationNavCard>;
  /** Header Primary Navigation url */
  navUrl?: Maybe<Scalars['String']['output']>;
  /** If only one asset is provided this will default to the foreground image and no background image will display. If there are multiple assets provided, the first image is for the background and the second is for the foreground */
  navigation_images: Array<NavigationNavigation_Images>;
  /** Specifies where on the page the navigation will be displayed */
  positon: NavigationTypes;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationNavCardArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationNavigation_ImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type NavigationCategory = NavigationItem;

export type NavigationCategoryConnectInput = {
  NavigationItem?: InputMaybe<NavigationItemConnectInput>;
};

export type NavigationCategoryCreateInput = {
  NavigationItem?: InputMaybe<NavigationItemCreateInput>;
};

export type NavigationCategoryCreateManyInlineInput = {
  /** Connect multiple existing NavigationCategory documents */
  connect?: InputMaybe<Array<NavigationCategoryWhereUniqueInput>>;
  /** Create and connect multiple existing NavigationCategory documents */
  create?: InputMaybe<Array<NavigationCategoryCreateInput>>;
};

export type NavigationCategoryCreateOneInlineInput = {
  /** Connect one existing NavigationCategory document */
  connect?: InputMaybe<NavigationCategoryWhereUniqueInput>;
  /** Create and connect one NavigationCategory document */
  create?: InputMaybe<NavigationCategoryCreateInput>;
};

export type NavigationCategoryUpdateInput = {
  NavigationItem?: InputMaybe<NavigationItemUpdateInput>;
};

export type NavigationCategoryUpdateManyInlineInput = {
  /** Connect multiple existing NavigationCategory documents */
  connect?: InputMaybe<Array<NavigationCategoryConnectInput>>;
  /** Create and connect multiple NavigationCategory documents */
  create?: InputMaybe<Array<NavigationCategoryCreateInput>>;
  /** Delete multiple NavigationCategory documents */
  delete?: InputMaybe<Array<NavigationCategoryWhereUniqueInput>>;
  /** Disconnect multiple NavigationCategory documents */
  disconnect?: InputMaybe<Array<NavigationCategoryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NavigationCategory documents */
  set?: InputMaybe<Array<NavigationCategoryWhereUniqueInput>>;
  /** Update multiple NavigationCategory documents */
  update?: InputMaybe<Array<NavigationCategoryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NavigationCategory documents */
  upsert?: InputMaybe<Array<NavigationCategoryUpsertWithNestedWhereUniqueInput>>;
};

export type NavigationCategoryUpdateManyWithNestedWhereInput = {
  NavigationItem?: InputMaybe<NavigationItemUpdateManyWithNestedWhereInput>;
};

export type NavigationCategoryUpdateOneInlineInput = {
  /** Connect existing NavigationCategory document */
  connect?: InputMaybe<NavigationCategoryWhereUniqueInput>;
  /** Create and connect one NavigationCategory document */
  create?: InputMaybe<NavigationCategoryCreateInput>;
  /** Delete currently connected NavigationCategory document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NavigationCategory document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NavigationCategory document */
  update?: InputMaybe<NavigationCategoryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NavigationCategory document */
  upsert?: InputMaybe<NavigationCategoryUpsertWithNestedWhereUniqueInput>;
};

export type NavigationCategoryUpdateWithNestedWhereUniqueInput = {
  NavigationItem?: InputMaybe<NavigationItemUpdateWithNestedWhereUniqueInput>;
};

export type NavigationCategoryUpsertWithNestedWhereUniqueInput = {
  NavigationItem?: InputMaybe<NavigationItemUpsertWithNestedWhereUniqueInput>;
};

export type NavigationCategoryWhereInput = {
  NavigationItem?: InputMaybe<NavigationItemWhereInput>;
};

export type NavigationCategoryWhereUniqueInput = {
  NavigationItem?: InputMaybe<NavigationItemWhereUniqueInput>;
};

export type NavigationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: NavigationWhereUniqueInput;
};

/** A connection to a list of items. */
export type NavigationConnection = {
  __typename?: 'NavigationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<NavigationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type NavigationCreateInput = {
  cardComponentTitle?: InputMaybe<Scalars['String']['input']>;
  cardItemtId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<NavigationCategoryCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  key: Scalars['String']['input'];
  links?: InputMaybe<LinkCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  navCard?: InputMaybe<NavigationNavCardCreateOneInlineInput>;
  navUrl?: InputMaybe<Scalars['String']['input']>;
  navigation_images?: InputMaybe<NavigationNavigation_ImagesCreateManyInlineInput>;
  positon: NavigationTypes;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NavigationCreateManyInlineInput = {
  /** Connect multiple existing Navigation documents */
  connect?: InputMaybe<Array<NavigationWhereUniqueInput>>;
  /** Create and connect multiple existing Navigation documents */
  create?: InputMaybe<Array<NavigationCreateInput>>;
};

export type NavigationCreateOneInlineInput = {
  /** Connect one existing Navigation document */
  connect?: InputMaybe<NavigationWhereUniqueInput>;
  /** Create and connect one Navigation document */
  create?: InputMaybe<NavigationCreateInput>;
};

/** An edge in a connection. */
export type NavigationEdge = {
  __typename?: 'NavigationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Navigation;
};

export type NavigationItem = Entity & Node & {
  __typename?: 'NavigationItem';
  /** Category Links (secondary link) */
  category_link?: Maybe<Link>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<NavigationItem>;
  /** List of NavigationItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  navigation?: Maybe<Navigation>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Navigation Sub Category  */
  subCategory: Array<NavigationItemSubCategory>;
  /** Link to the page this navigation item refers to */
  targetLink?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Tracking Secondary Navigation */
  trackingSecondaryNavigation?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type NavigationItemCategory_LinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NavigationItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NavigationItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type NavigationItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type NavigationItemMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NavigationItemNavigationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NavigationItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NavigationItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type NavigationItemSubCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type NavigationItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type NavigationItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: NavigationItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type NavigationItemConnection = {
  __typename?: 'NavigationItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<NavigationItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type NavigationItemCreateInput = {
  category_link?: InputMaybe<LinkCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  navigation?: InputMaybe<NavigationCreateOneInlineInput>;
  subCategory?: InputMaybe<NavigationItemSubCategoryCreateManyInlineInput>;
  targetLink?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  trackingSecondaryNavigation?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NavigationItemCreateManyInlineInput = {
  /** Connect multiple existing NavigationItem documents */
  connect?: InputMaybe<Array<NavigationItemWhereUniqueInput>>;
  /** Create and connect multiple existing NavigationItem documents */
  create?: InputMaybe<Array<NavigationItemCreateInput>>;
};

export type NavigationItemCreateOneInlineInput = {
  /** Connect one existing NavigationItem document */
  connect?: InputMaybe<NavigationItemWhereUniqueInput>;
  /** Create and connect one NavigationItem document */
  create?: InputMaybe<NavigationItemCreateInput>;
};

/** An edge in a connection. */
export type NavigationItemEdge = {
  __typename?: 'NavigationItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: NavigationItem;
};

/** Identifies documents */
export type NavigationItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  category_link?: InputMaybe<LinkWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<NavigationItemWhereStageInput>;
  documentInStages_none?: InputMaybe<NavigationItemWhereStageInput>;
  documentInStages_some?: InputMaybe<NavigationItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  navigation?: InputMaybe<NavigationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values in which the union is empty */
  subCategory_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  subCategory_some?: InputMaybe<NavigationItemSubCategoryWhereInput>;
  targetLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  targetLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  targetLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  targetLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  targetLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  targetLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  targetLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  targetLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  targetLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  targetLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  trackingSecondaryNavigation?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  trackingSecondaryNavigation_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  trackingSecondaryNavigation_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  trackingSecondaryNavigation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  trackingSecondaryNavigation_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  trackingSecondaryNavigation_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  trackingSecondaryNavigation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  trackingSecondaryNavigation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  trackingSecondaryNavigation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  trackingSecondaryNavigation_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum NavigationItemOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  targetLink_ASC = 'targetLink_ASC',
  targetLink_DESC = 'targetLink_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  trackingSecondaryNavigation_ASC = 'trackingSecondaryNavigation_ASC',
  trackingSecondaryNavigation_DESC = 'trackingSecondaryNavigation_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type NavigationItemSubCategory = Link;

export type NavigationItemSubCategoryConnectInput = {
  Link?: InputMaybe<LinkConnectInput>;
};

export type NavigationItemSubCategoryCreateInput = {
  Link?: InputMaybe<LinkCreateInput>;
};

export type NavigationItemSubCategoryCreateManyInlineInput = {
  /** Connect multiple existing NavigationItemSubCategory documents */
  connect?: InputMaybe<Array<NavigationItemSubCategoryWhereUniqueInput>>;
  /** Create and connect multiple existing NavigationItemSubCategory documents */
  create?: InputMaybe<Array<NavigationItemSubCategoryCreateInput>>;
};

export type NavigationItemSubCategoryCreateOneInlineInput = {
  /** Connect one existing NavigationItemSubCategory document */
  connect?: InputMaybe<NavigationItemSubCategoryWhereUniqueInput>;
  /** Create and connect one NavigationItemSubCategory document */
  create?: InputMaybe<NavigationItemSubCategoryCreateInput>;
};

export type NavigationItemSubCategoryUpdateInput = {
  Link?: InputMaybe<LinkUpdateInput>;
};

export type NavigationItemSubCategoryUpdateManyInlineInput = {
  /** Connect multiple existing NavigationItemSubCategory documents */
  connect?: InputMaybe<Array<NavigationItemSubCategoryConnectInput>>;
  /** Create and connect multiple NavigationItemSubCategory documents */
  create?: InputMaybe<Array<NavigationItemSubCategoryCreateInput>>;
  /** Delete multiple NavigationItemSubCategory documents */
  delete?: InputMaybe<Array<NavigationItemSubCategoryWhereUniqueInput>>;
  /** Disconnect multiple NavigationItemSubCategory documents */
  disconnect?: InputMaybe<Array<NavigationItemSubCategoryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NavigationItemSubCategory documents */
  set?: InputMaybe<Array<NavigationItemSubCategoryWhereUniqueInput>>;
  /** Update multiple NavigationItemSubCategory documents */
  update?: InputMaybe<Array<NavigationItemSubCategoryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NavigationItemSubCategory documents */
  upsert?: InputMaybe<Array<NavigationItemSubCategoryUpsertWithNestedWhereUniqueInput>>;
};

export type NavigationItemSubCategoryUpdateManyWithNestedWhereInput = {
  Link?: InputMaybe<LinkUpdateManyWithNestedWhereInput>;
};

export type NavigationItemSubCategoryUpdateOneInlineInput = {
  /** Connect existing NavigationItemSubCategory document */
  connect?: InputMaybe<NavigationItemSubCategoryWhereUniqueInput>;
  /** Create and connect one NavigationItemSubCategory document */
  create?: InputMaybe<NavigationItemSubCategoryCreateInput>;
  /** Delete currently connected NavigationItemSubCategory document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NavigationItemSubCategory document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NavigationItemSubCategory document */
  update?: InputMaybe<NavigationItemSubCategoryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NavigationItemSubCategory document */
  upsert?: InputMaybe<NavigationItemSubCategoryUpsertWithNestedWhereUniqueInput>;
};

export type NavigationItemSubCategoryUpdateWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
};

export type NavigationItemSubCategoryUpsertWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
};

export type NavigationItemSubCategoryWhereInput = {
  Link?: InputMaybe<LinkWhereInput>;
};

export type NavigationItemSubCategoryWhereUniqueInput = {
  Link?: InputMaybe<LinkWhereUniqueInput>;
};

export type NavigationItemUpdateInput = {
  category_link?: InputMaybe<LinkUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  navigation?: InputMaybe<NavigationUpdateOneInlineInput>;
  subCategory?: InputMaybe<NavigationItemSubCategoryUpdateManyInlineInput>;
  targetLink?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  trackingSecondaryNavigation?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationItemUpdateManyInlineInput = {
  /** Connect multiple existing NavigationItem documents */
  connect?: InputMaybe<Array<NavigationItemConnectInput>>;
  /** Create and connect multiple NavigationItem documents */
  create?: InputMaybe<Array<NavigationItemCreateInput>>;
  /** Delete multiple NavigationItem documents */
  delete?: InputMaybe<Array<NavigationItemWhereUniqueInput>>;
  /** Disconnect multiple NavigationItem documents */
  disconnect?: InputMaybe<Array<NavigationItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NavigationItem documents */
  set?: InputMaybe<Array<NavigationItemWhereUniqueInput>>;
  /** Update multiple NavigationItem documents */
  update?: InputMaybe<Array<NavigationItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NavigationItem documents */
  upsert?: InputMaybe<Array<NavigationItemUpsertWithNestedWhereUniqueInput>>;
};

export type NavigationItemUpdateManyInput = {
  market?: InputMaybe<Markets>;
  targetLink?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  trackingSecondaryNavigation?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: NavigationItemUpdateManyInput;
  /** Document search */
  where: NavigationItemWhereInput;
};

export type NavigationItemUpdateOneInlineInput = {
  /** Connect existing NavigationItem document */
  connect?: InputMaybe<NavigationItemWhereUniqueInput>;
  /** Create and connect one NavigationItem document */
  create?: InputMaybe<NavigationItemCreateInput>;
  /** Delete currently connected NavigationItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NavigationItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NavigationItem document */
  update?: InputMaybe<NavigationItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NavigationItem document */
  upsert?: InputMaybe<NavigationItemUpsertWithNestedWhereUniqueInput>;
};

export type NavigationItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: NavigationItemUpdateInput;
  /** Unique document search */
  where: NavigationItemWhereUniqueInput;
};

export type NavigationItemUpsertInput = {
  /** Create document if it didn't exist */
  create: NavigationItemCreateInput;
  /** Update document if it exists */
  update: NavigationItemUpdateInput;
};

export type NavigationItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: NavigationItemUpsertInput;
  /** Unique document search */
  where: NavigationItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type NavigationItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type NavigationItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  category_link?: InputMaybe<LinkWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<NavigationItemWhereStageInput>;
  documentInStages_none?: InputMaybe<NavigationItemWhereStageInput>;
  documentInStages_some?: InputMaybe<NavigationItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  navigation?: InputMaybe<NavigationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values in which the union is empty */
  subCategory_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  subCategory_some?: InputMaybe<NavigationItemSubCategoryWhereInput>;
  targetLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  targetLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  targetLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  targetLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  targetLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  targetLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  targetLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  targetLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  targetLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  targetLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  trackingSecondaryNavigation?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  trackingSecondaryNavigation_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  trackingSecondaryNavigation_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  trackingSecondaryNavigation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  trackingSecondaryNavigation_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  trackingSecondaryNavigation_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  trackingSecondaryNavigation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  trackingSecondaryNavigation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  trackingSecondaryNavigation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  trackingSecondaryNavigation_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type NavigationItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<NavigationItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References NavigationItem record uniquely */
export type NavigationItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type NavigationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardComponentTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardComponentTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardComponentTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardComponentTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardComponentTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardComponentTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardComponentTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardComponentTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardComponentTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardComponentTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardItemtId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardItemtId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardItemtId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardItemtId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardItemtId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardItemtId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardItemtId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardItemtId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardItemtId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardItemtId_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  category_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  category_some?: InputMaybe<NavigationCategoryWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<NavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<NavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<NavigationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** All values in which the union is connected to the given models */
  navCard?: InputMaybe<NavigationNavCardWhereInput>;
  /** All values in which the union is empty */
  navCard_empty?: InputMaybe<Scalars['Boolean']['input']>;
  navUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  navUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  navUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  navUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  navUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  navUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  navUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  navUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  navUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  navUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  navigation_images_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  navigation_images_some?: InputMaybe<NavigationNavigation_ImagesWhereInput>;
  positon?: InputMaybe<NavigationTypes>;
  /** All values that are contained in given list. */
  positon_in?: InputMaybe<Array<InputMaybe<NavigationTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  positon_not?: InputMaybe<NavigationTypes>;
  /** All values that are not contained in given list. */
  positon_not_in?: InputMaybe<Array<InputMaybe<NavigationTypes>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type NavigationNavCard = CardComponent;

export type NavigationNavCardConnectInput = {
  CardComponent?: InputMaybe<CardComponentConnectInput>;
};

export type NavigationNavCardCreateInput = {
  CardComponent?: InputMaybe<CardComponentCreateInput>;
};

export type NavigationNavCardCreateManyInlineInput = {
  /** Connect multiple existing NavigationNavCard documents */
  connect?: InputMaybe<Array<NavigationNavCardWhereUniqueInput>>;
  /** Create and connect multiple existing NavigationNavCard documents */
  create?: InputMaybe<Array<NavigationNavCardCreateInput>>;
};

export type NavigationNavCardCreateOneInlineInput = {
  /** Connect one existing NavigationNavCard document */
  connect?: InputMaybe<NavigationNavCardWhereUniqueInput>;
  /** Create and connect one NavigationNavCard document */
  create?: InputMaybe<NavigationNavCardCreateInput>;
};

export type NavigationNavCardUpdateInput = {
  CardComponent?: InputMaybe<CardComponentUpdateInput>;
};

export type NavigationNavCardUpdateManyInlineInput = {
  /** Connect multiple existing NavigationNavCard documents */
  connect?: InputMaybe<Array<NavigationNavCardConnectInput>>;
  /** Create and connect multiple NavigationNavCard documents */
  create?: InputMaybe<Array<NavigationNavCardCreateInput>>;
  /** Delete multiple NavigationNavCard documents */
  delete?: InputMaybe<Array<NavigationNavCardWhereUniqueInput>>;
  /** Disconnect multiple NavigationNavCard documents */
  disconnect?: InputMaybe<Array<NavigationNavCardWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NavigationNavCard documents */
  set?: InputMaybe<Array<NavigationNavCardWhereUniqueInput>>;
  /** Update multiple NavigationNavCard documents */
  update?: InputMaybe<Array<NavigationNavCardUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NavigationNavCard documents */
  upsert?: InputMaybe<Array<NavigationNavCardUpsertWithNestedWhereUniqueInput>>;
};

export type NavigationNavCardUpdateManyWithNestedWhereInput = {
  CardComponent?: InputMaybe<CardComponentUpdateManyWithNestedWhereInput>;
};

export type NavigationNavCardUpdateOneInlineInput = {
  /** Connect existing NavigationNavCard document */
  connect?: InputMaybe<NavigationNavCardWhereUniqueInput>;
  /** Create and connect one NavigationNavCard document */
  create?: InputMaybe<NavigationNavCardCreateInput>;
  /** Delete currently connected NavigationNavCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NavigationNavCard document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NavigationNavCard document */
  update?: InputMaybe<NavigationNavCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NavigationNavCard document */
  upsert?: InputMaybe<NavigationNavCardUpsertWithNestedWhereUniqueInput>;
};

export type NavigationNavCardUpdateWithNestedWhereUniqueInput = {
  CardComponent?: InputMaybe<CardComponentUpdateWithNestedWhereUniqueInput>;
};

export type NavigationNavCardUpsertWithNestedWhereUniqueInput = {
  CardComponent?: InputMaybe<CardComponentUpsertWithNestedWhereUniqueInput>;
};

export type NavigationNavCardWhereInput = {
  CardComponent?: InputMaybe<CardComponentWhereInput>;
};

export type NavigationNavCardWhereUniqueInput = {
  CardComponent?: InputMaybe<CardComponentWhereUniqueInput>;
};

export type NavigationNavigation_Images = AssetComponent;

export type NavigationNavigation_ImagesConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type NavigationNavigation_ImagesCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type NavigationNavigation_ImagesCreateManyInlineInput = {
  /** Connect multiple existing NavigationNavigation_images documents */
  connect?: InputMaybe<Array<NavigationNavigation_ImagesWhereUniqueInput>>;
  /** Create and connect multiple existing NavigationNavigation_images documents */
  create?: InputMaybe<Array<NavigationNavigation_ImagesCreateInput>>;
};

export type NavigationNavigation_ImagesCreateOneInlineInput = {
  /** Connect one existing NavigationNavigation_images document */
  connect?: InputMaybe<NavigationNavigation_ImagesWhereUniqueInput>;
  /** Create and connect one NavigationNavigation_images document */
  create?: InputMaybe<NavigationNavigation_ImagesCreateInput>;
};

export type NavigationNavigation_ImagesUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type NavigationNavigation_ImagesUpdateManyInlineInput = {
  /** Connect multiple existing NavigationNavigation_images documents */
  connect?: InputMaybe<Array<NavigationNavigation_ImagesConnectInput>>;
  /** Create and connect multiple NavigationNavigation_images documents */
  create?: InputMaybe<Array<NavigationNavigation_ImagesCreateInput>>;
  /** Delete multiple NavigationNavigation_images documents */
  delete?: InputMaybe<Array<NavigationNavigation_ImagesWhereUniqueInput>>;
  /** Disconnect multiple NavigationNavigation_images documents */
  disconnect?: InputMaybe<Array<NavigationNavigation_ImagesWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NavigationNavigation_images documents */
  set?: InputMaybe<Array<NavigationNavigation_ImagesWhereUniqueInput>>;
  /** Update multiple NavigationNavigation_images documents */
  update?: InputMaybe<Array<NavigationNavigation_ImagesUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NavigationNavigation_images documents */
  upsert?: InputMaybe<Array<NavigationNavigation_ImagesUpsertWithNestedWhereUniqueInput>>;
};

export type NavigationNavigation_ImagesUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type NavigationNavigation_ImagesUpdateOneInlineInput = {
  /** Connect existing NavigationNavigation_images document */
  connect?: InputMaybe<NavigationNavigation_ImagesWhereUniqueInput>;
  /** Create and connect one NavigationNavigation_images document */
  create?: InputMaybe<NavigationNavigation_ImagesCreateInput>;
  /** Delete currently connected NavigationNavigation_images document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NavigationNavigation_images document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NavigationNavigation_images document */
  update?: InputMaybe<NavigationNavigation_ImagesUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NavigationNavigation_images document */
  upsert?: InputMaybe<NavigationNavigation_ImagesUpsertWithNestedWhereUniqueInput>;
};

export type NavigationNavigation_ImagesUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type NavigationNavigation_ImagesUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type NavigationNavigation_ImagesWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type NavigationNavigation_ImagesWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

export enum NavigationOrderByInput {
  cardComponentTitle_ASC = 'cardComponentTitle_ASC',
  cardComponentTitle_DESC = 'cardComponentTitle_DESC',
  cardItemtId_ASC = 'cardItemtId_ASC',
  cardItemtId_DESC = 'cardItemtId_DESC',
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  key_ASC = 'key_ASC',
  key_DESC = 'key_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  navUrl_ASC = 'navUrl_ASC',
  navUrl_DESC = 'navUrl_DESC',
  positon_ASC = 'positon_ASC',
  positon_DESC = 'positon_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Specifies where on the page the navigation will be displayed */
export enum NavigationTypes {
  Footer = 'Footer',
  Main = 'Main'
}

export type NavigationUpdateInput = {
  cardComponentTitle?: InputMaybe<Scalars['String']['input']>;
  cardItemtId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<NavigationCategoryUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<LinkUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  navCard?: InputMaybe<NavigationNavCardUpdateOneInlineInput>;
  navUrl?: InputMaybe<Scalars['String']['input']>;
  navigation_images?: InputMaybe<NavigationNavigation_ImagesUpdateManyInlineInput>;
  positon?: InputMaybe<NavigationTypes>;
};

export type NavigationUpdateManyInlineInput = {
  /** Connect multiple existing Navigation documents */
  connect?: InputMaybe<Array<NavigationConnectInput>>;
  /** Create and connect multiple Navigation documents */
  create?: InputMaybe<Array<NavigationCreateInput>>;
  /** Delete multiple Navigation documents */
  delete?: InputMaybe<Array<NavigationWhereUniqueInput>>;
  /** Disconnect multiple Navigation documents */
  disconnect?: InputMaybe<Array<NavigationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Navigation documents */
  set?: InputMaybe<Array<NavigationWhereUniqueInput>>;
  /** Update multiple Navigation documents */
  update?: InputMaybe<Array<NavigationUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Navigation documents */
  upsert?: InputMaybe<Array<NavigationUpsertWithNestedWhereUniqueInput>>;
};

export type NavigationUpdateManyInput = {
  cardComponentTitle?: InputMaybe<Scalars['String']['input']>;
  cardItemtId?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  navUrl?: InputMaybe<Scalars['String']['input']>;
  positon?: InputMaybe<NavigationTypes>;
};

export type NavigationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: NavigationUpdateManyInput;
  /** Document search */
  where: NavigationWhereInput;
};

export type NavigationUpdateOneInlineInput = {
  /** Connect existing Navigation document */
  connect?: InputMaybe<NavigationWhereUniqueInput>;
  /** Create and connect one Navigation document */
  create?: InputMaybe<NavigationCreateInput>;
  /** Delete currently connected Navigation document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Navigation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Navigation document */
  update?: InputMaybe<NavigationUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Navigation document */
  upsert?: InputMaybe<NavigationUpsertWithNestedWhereUniqueInput>;
};

export type NavigationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: NavigationUpdateInput;
  /** Unique document search */
  where: NavigationWhereUniqueInput;
};

export type NavigationUpsertInput = {
  /** Create document if it didn't exist */
  create: NavigationCreateInput;
  /** Update document if it exists */
  update: NavigationUpdateInput;
};

export type NavigationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: NavigationUpsertInput;
  /** Unique document search */
  where: NavigationWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type NavigationWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type NavigationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardComponentTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardComponentTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardComponentTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardComponentTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardComponentTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardComponentTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardComponentTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardComponentTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardComponentTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardComponentTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardItemtId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardItemtId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardItemtId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardItemtId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardItemtId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardItemtId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardItemtId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardItemtId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardItemtId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardItemtId_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  category_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  category_some?: InputMaybe<NavigationCategoryWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<NavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<NavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<NavigationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** All values in which the union is connected to the given models */
  navCard?: InputMaybe<NavigationNavCardWhereInput>;
  /** All values in which the union is empty */
  navCard_empty?: InputMaybe<Scalars['Boolean']['input']>;
  navUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  navUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  navUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  navUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  navUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  navUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  navUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  navUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  navUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  navUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  navigation_images_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  navigation_images_some?: InputMaybe<NavigationNavigation_ImagesWhereInput>;
  positon?: InputMaybe<NavigationTypes>;
  /** All values that are contained in given list. */
  positon_in?: InputMaybe<Array<InputMaybe<NavigationTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  positon_not?: InputMaybe<NavigationTypes>;
  /** All values that are not contained in given list. */
  positon_not_in?: InputMaybe<Array<InputMaybe<NavigationTypes>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type NavigationWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<NavigationWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Navigation record uniquely */
export type NavigationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type NewsletterComponent = Entity & Node & {
  __typename?: 'NewsletterComponent';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Multi line text */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<NewsletterComponent>;
  formNewsletter: Array<NewsletterComponentFormNewsletter>;
  genericPages: Array<GenericPage>;
  /** List of NewsletterComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market?: Maybe<Markets>;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Single line text */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type NewsletterComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NewsletterComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type NewsletterComponentFormNewsletterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type NewsletterComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type NewsletterComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type NewsletterComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NewsletterComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NewsletterComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type NewsletterComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type NewsletterComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: NewsletterComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type NewsletterComponentConnection = {
  __typename?: 'NewsletterComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<NewsletterComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type NewsletterComponentCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  formNewsletter?: InputMaybe<NewsletterComponentFormNewsletterCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NewsletterComponentCreateManyInlineInput = {
  /** Connect multiple existing NewsletterComponent documents */
  connect?: InputMaybe<Array<NewsletterComponentWhereUniqueInput>>;
  /** Create and connect multiple existing NewsletterComponent documents */
  create?: InputMaybe<Array<NewsletterComponentCreateInput>>;
};

export type NewsletterComponentCreateOneInlineInput = {
  /** Connect one existing NewsletterComponent document */
  connect?: InputMaybe<NewsletterComponentWhereUniqueInput>;
  /** Create and connect one NewsletterComponent document */
  create?: InputMaybe<NewsletterComponentCreateInput>;
};

/** An edge in a connection. */
export type NewsletterComponentEdge = {
  __typename?: 'NewsletterComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: NewsletterComponent;
};

export type NewsletterComponentFormNewsletter = Form;

export type NewsletterComponentFormNewsletterConnectInput = {
  Form?: InputMaybe<FormConnectInput>;
};

export type NewsletterComponentFormNewsletterCreateInput = {
  Form?: InputMaybe<FormCreateInput>;
};

export type NewsletterComponentFormNewsletterCreateManyInlineInput = {
  /** Connect multiple existing NewsletterComponentFormNewsletter documents */
  connect?: InputMaybe<Array<NewsletterComponentFormNewsletterWhereUniqueInput>>;
  /** Create and connect multiple existing NewsletterComponentFormNewsletter documents */
  create?: InputMaybe<Array<NewsletterComponentFormNewsletterCreateInput>>;
};

export type NewsletterComponentFormNewsletterCreateOneInlineInput = {
  /** Connect one existing NewsletterComponentFormNewsletter document */
  connect?: InputMaybe<NewsletterComponentFormNewsletterWhereUniqueInput>;
  /** Create and connect one NewsletterComponentFormNewsletter document */
  create?: InputMaybe<NewsletterComponentFormNewsletterCreateInput>;
};

export type NewsletterComponentFormNewsletterUpdateInput = {
  Form?: InputMaybe<FormUpdateInput>;
};

export type NewsletterComponentFormNewsletterUpdateManyInlineInput = {
  /** Connect multiple existing NewsletterComponentFormNewsletter documents */
  connect?: InputMaybe<Array<NewsletterComponentFormNewsletterConnectInput>>;
  /** Create and connect multiple NewsletterComponentFormNewsletter documents */
  create?: InputMaybe<Array<NewsletterComponentFormNewsletterCreateInput>>;
  /** Delete multiple NewsletterComponentFormNewsletter documents */
  delete?: InputMaybe<Array<NewsletterComponentFormNewsletterWhereUniqueInput>>;
  /** Disconnect multiple NewsletterComponentFormNewsletter documents */
  disconnect?: InputMaybe<Array<NewsletterComponentFormNewsletterWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NewsletterComponentFormNewsletter documents */
  set?: InputMaybe<Array<NewsletterComponentFormNewsletterWhereUniqueInput>>;
  /** Update multiple NewsletterComponentFormNewsletter documents */
  update?: InputMaybe<Array<NewsletterComponentFormNewsletterUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NewsletterComponentFormNewsletter documents */
  upsert?: InputMaybe<Array<NewsletterComponentFormNewsletterUpsertWithNestedWhereUniqueInput>>;
};

export type NewsletterComponentFormNewsletterUpdateManyWithNestedWhereInput = {
  Form?: InputMaybe<FormUpdateManyWithNestedWhereInput>;
};

export type NewsletterComponentFormNewsletterUpdateOneInlineInput = {
  /** Connect existing NewsletterComponentFormNewsletter document */
  connect?: InputMaybe<NewsletterComponentFormNewsletterWhereUniqueInput>;
  /** Create and connect one NewsletterComponentFormNewsletter document */
  create?: InputMaybe<NewsletterComponentFormNewsletterCreateInput>;
  /** Delete currently connected NewsletterComponentFormNewsletter document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NewsletterComponentFormNewsletter document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NewsletterComponentFormNewsletter document */
  update?: InputMaybe<NewsletterComponentFormNewsletterUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NewsletterComponentFormNewsletter document */
  upsert?: InputMaybe<NewsletterComponentFormNewsletterUpsertWithNestedWhereUniqueInput>;
};

export type NewsletterComponentFormNewsletterUpdateWithNestedWhereUniqueInput = {
  Form?: InputMaybe<FormUpdateWithNestedWhereUniqueInput>;
};

export type NewsletterComponentFormNewsletterUpsertWithNestedWhereUniqueInput = {
  Form?: InputMaybe<FormUpsertWithNestedWhereUniqueInput>;
};

export type NewsletterComponentFormNewsletterWhereInput = {
  Form?: InputMaybe<FormWhereInput>;
};

export type NewsletterComponentFormNewsletterWhereUniqueInput = {
  Form?: InputMaybe<FormWhereUniqueInput>;
};

/** Identifies documents */
export type NewsletterComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NewsletterComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NewsletterComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NewsletterComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<NewsletterComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<NewsletterComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<NewsletterComponentWhereStageInput>;
  /** All values in which the union is empty */
  formNewsletter_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  formNewsletter_some?: InputMaybe<NewsletterComponentFormNewsletterWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum NewsletterComponentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type NewsletterComponentUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  formNewsletter?: InputMaybe<NewsletterComponentFormNewsletterUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NewsletterComponentUpdateManyInlineInput = {
  /** Connect multiple existing NewsletterComponent documents */
  connect?: InputMaybe<Array<NewsletterComponentConnectInput>>;
  /** Create and connect multiple NewsletterComponent documents */
  create?: InputMaybe<Array<NewsletterComponentCreateInput>>;
  /** Delete multiple NewsletterComponent documents */
  delete?: InputMaybe<Array<NewsletterComponentWhereUniqueInput>>;
  /** Disconnect multiple NewsletterComponent documents */
  disconnect?: InputMaybe<Array<NewsletterComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NewsletterComponent documents */
  set?: InputMaybe<Array<NewsletterComponentWhereUniqueInput>>;
  /** Update multiple NewsletterComponent documents */
  update?: InputMaybe<Array<NewsletterComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NewsletterComponent documents */
  upsert?: InputMaybe<Array<NewsletterComponentUpsertWithNestedWhereUniqueInput>>;
};

export type NewsletterComponentUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NewsletterComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: NewsletterComponentUpdateManyInput;
  /** Document search */
  where: NewsletterComponentWhereInput;
};

export type NewsletterComponentUpdateOneInlineInput = {
  /** Connect existing NewsletterComponent document */
  connect?: InputMaybe<NewsletterComponentWhereUniqueInput>;
  /** Create and connect one NewsletterComponent document */
  create?: InputMaybe<NewsletterComponentCreateInput>;
  /** Delete currently connected NewsletterComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NewsletterComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NewsletterComponent document */
  update?: InputMaybe<NewsletterComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NewsletterComponent document */
  upsert?: InputMaybe<NewsletterComponentUpsertWithNestedWhereUniqueInput>;
};

export type NewsletterComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: NewsletterComponentUpdateInput;
  /** Unique document search */
  where: NewsletterComponentWhereUniqueInput;
};

export type NewsletterComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: NewsletterComponentCreateInput;
  /** Update document if it exists */
  update: NewsletterComponentUpdateInput;
};

export type NewsletterComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: NewsletterComponentUpsertInput;
  /** Unique document search */
  where: NewsletterComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type NewsletterComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type NewsletterComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NewsletterComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NewsletterComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NewsletterComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<NewsletterComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<NewsletterComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<NewsletterComponentWhereStageInput>;
  /** All values in which the union is empty */
  formNewsletter_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  formNewsletter_some?: InputMaybe<NewsletterComponentFormNewsletterWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type NewsletterComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NewsletterComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NewsletterComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NewsletterComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<NewsletterComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References NewsletterComponent record uniquely */
export type NewsletterComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type NewsletterSubscriptions = Entity & Node & {
  __typename?: 'NewsletterSubscriptions';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<NewsletterSubscriptions>;
  /** List of NewsletterSubscriptions versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subscriptions: Array<FormOption>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type NewsletterSubscriptionsCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NewsletterSubscriptionsDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type NewsletterSubscriptionsHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type NewsletterSubscriptionsPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NewsletterSubscriptionsScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type NewsletterSubscriptionsSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormOptionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormOptionWhereInput>;
};


export type NewsletterSubscriptionsUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type NewsletterSubscriptionsConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: NewsletterSubscriptionsWhereUniqueInput;
};

/** A connection to a list of items. */
export type NewsletterSubscriptionsConnection = {
  __typename?: 'NewsletterSubscriptionsConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<NewsletterSubscriptionsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type NewsletterSubscriptionsCreateInput = {
  clz6t0iet01wg07taesbkbcby?: InputMaybe<PromotionFormCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  subscriptions?: InputMaybe<FormOptionCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NewsletterSubscriptionsCreateManyInlineInput = {
  /** Connect multiple existing NewsletterSubscriptions documents */
  connect?: InputMaybe<Array<NewsletterSubscriptionsWhereUniqueInput>>;
  /** Create and connect multiple existing NewsletterSubscriptions documents */
  create?: InputMaybe<Array<NewsletterSubscriptionsCreateInput>>;
};

export type NewsletterSubscriptionsCreateOneInlineInput = {
  /** Connect one existing NewsletterSubscriptions document */
  connect?: InputMaybe<NewsletterSubscriptionsWhereUniqueInput>;
  /** Create and connect one NewsletterSubscriptions document */
  create?: InputMaybe<NewsletterSubscriptionsCreateInput>;
};

/** An edge in a connection. */
export type NewsletterSubscriptionsEdge = {
  __typename?: 'NewsletterSubscriptionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: NewsletterSubscriptions;
};

/** Identifies documents */
export type NewsletterSubscriptionsManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NewsletterSubscriptionsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NewsletterSubscriptionsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NewsletterSubscriptionsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<NewsletterSubscriptionsWhereStageInput>;
  documentInStages_none?: InputMaybe<NewsletterSubscriptionsWhereStageInput>;
  documentInStages_some?: InputMaybe<NewsletterSubscriptionsWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subscriptions_every?: InputMaybe<FormOptionWhereInput>;
  subscriptions_none?: InputMaybe<FormOptionWhereInput>;
  subscriptions_some?: InputMaybe<FormOptionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum NewsletterSubscriptionsOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type NewsletterSubscriptionsUpdateInput = {
  clz6t0iet01wg07taesbkbcby?: InputMaybe<PromotionFormUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  subscriptions?: InputMaybe<FormOptionUpdateManyInlineInput>;
};

export type NewsletterSubscriptionsUpdateManyInlineInput = {
  /** Connect multiple existing NewsletterSubscriptions documents */
  connect?: InputMaybe<Array<NewsletterSubscriptionsConnectInput>>;
  /** Create and connect multiple NewsletterSubscriptions documents */
  create?: InputMaybe<Array<NewsletterSubscriptionsCreateInput>>;
  /** Delete multiple NewsletterSubscriptions documents */
  delete?: InputMaybe<Array<NewsletterSubscriptionsWhereUniqueInput>>;
  /** Disconnect multiple NewsletterSubscriptions documents */
  disconnect?: InputMaybe<Array<NewsletterSubscriptionsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NewsletterSubscriptions documents */
  set?: InputMaybe<Array<NewsletterSubscriptionsWhereUniqueInput>>;
  /** Update multiple NewsletterSubscriptions documents */
  update?: InputMaybe<Array<NewsletterSubscriptionsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NewsletterSubscriptions documents */
  upsert?: InputMaybe<Array<NewsletterSubscriptionsUpsertWithNestedWhereUniqueInput>>;
};

export type NewsletterSubscriptionsUpdateManyInput = {
  market?: InputMaybe<Markets>;
};

export type NewsletterSubscriptionsUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: NewsletterSubscriptionsUpdateManyInput;
  /** Document search */
  where: NewsletterSubscriptionsWhereInput;
};

export type NewsletterSubscriptionsUpdateOneInlineInput = {
  /** Connect existing NewsletterSubscriptions document */
  connect?: InputMaybe<NewsletterSubscriptionsWhereUniqueInput>;
  /** Create and connect one NewsletterSubscriptions document */
  create?: InputMaybe<NewsletterSubscriptionsCreateInput>;
  /** Delete currently connected NewsletterSubscriptions document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NewsletterSubscriptions document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NewsletterSubscriptions document */
  update?: InputMaybe<NewsletterSubscriptionsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NewsletterSubscriptions document */
  upsert?: InputMaybe<NewsletterSubscriptionsUpsertWithNestedWhereUniqueInput>;
};

export type NewsletterSubscriptionsUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: NewsletterSubscriptionsUpdateInput;
  /** Unique document search */
  where: NewsletterSubscriptionsWhereUniqueInput;
};

export type NewsletterSubscriptionsUpsertInput = {
  /** Create document if it didn't exist */
  create: NewsletterSubscriptionsCreateInput;
  /** Update document if it exists */
  update: NewsletterSubscriptionsUpdateInput;
};

export type NewsletterSubscriptionsUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: NewsletterSubscriptionsUpsertInput;
  /** Unique document search */
  where: NewsletterSubscriptionsWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type NewsletterSubscriptionsWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type NewsletterSubscriptionsWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NewsletterSubscriptionsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NewsletterSubscriptionsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NewsletterSubscriptionsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<NewsletterSubscriptionsWhereStageInput>;
  documentInStages_none?: InputMaybe<NewsletterSubscriptionsWhereStageInput>;
  documentInStages_some?: InputMaybe<NewsletterSubscriptionsWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subscriptions_every?: InputMaybe<FormOptionWhereInput>;
  subscriptions_none?: InputMaybe<FormOptionWhereInput>;
  subscriptions_some?: InputMaybe<FormOptionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type NewsletterSubscriptionsWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NewsletterSubscriptionsWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NewsletterSubscriptionsWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NewsletterSubscriptionsWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<NewsletterSubscriptionsWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References NewsletterSubscriptions record uniquely */
export type NewsletterSubscriptionsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

export type NotificationBanner = Entity & Node & {
  __typename?: 'NotificationBanner';
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Choose the type of banner. When "recall_campaign" is chosen, the banner will show up red. */
  bannerType?: Maybe<BannerType>;
  /** Label given to this content model, only seen from within the CMS */
  cmsTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<NotificationBanner>;
  /** List of NotificationBanner versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type NotificationBannerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NotificationBannerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type NotificationBannerHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type NotificationBannerLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NotificationBannerMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NotificationBannerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NotificationBannerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type NotificationBannerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type NotificationBannerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: NotificationBannerWhereUniqueInput;
};

/** A connection to a list of items. */
export type NotificationBannerConnection = {
  __typename?: 'NotificationBannerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<NotificationBannerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type NotificationBannerCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bannerType?: InputMaybe<BannerType>;
  cmsTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationBannerCreateManyInlineInput = {
  /** Connect multiple existing NotificationBanner documents */
  connect?: InputMaybe<Array<NotificationBannerWhereUniqueInput>>;
  /** Create and connect multiple existing NotificationBanner documents */
  create?: InputMaybe<Array<NotificationBannerCreateInput>>;
};

export type NotificationBannerCreateOneInlineInput = {
  /** Connect one existing NotificationBanner document */
  connect?: InputMaybe<NotificationBannerWhereUniqueInput>;
  /** Create and connect one NotificationBanner document */
  create?: InputMaybe<NotificationBannerCreateInput>;
};

/** An edge in a connection. */
export type NotificationBannerEdge = {
  __typename?: 'NotificationBannerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: NotificationBanner;
};

/** Identifies documents */
export type NotificationBannerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NotificationBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NotificationBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NotificationBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  active_not?: InputMaybe<Scalars['Boolean']['input']>;
  bannerType?: InputMaybe<BannerType>;
  /** All values that are contained in given list. */
  bannerType_in?: InputMaybe<Array<InputMaybe<BannerType>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerType_not?: InputMaybe<BannerType>;
  /** All values that are not contained in given list. */
  bannerType_not_in?: InputMaybe<Array<InputMaybe<BannerType>>>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<NotificationBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<NotificationBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<NotificationBannerWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum NotificationBannerOrderByInput {
  active_ASC = 'active_ASC',
  active_DESC = 'active_DESC',
  bannerType_ASC = 'bannerType_ASC',
  bannerType_DESC = 'bannerType_DESC',
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type NotificationBannerUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bannerType?: InputMaybe<BannerType>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationBannerUpdateManyInlineInput = {
  /** Connect multiple existing NotificationBanner documents */
  connect?: InputMaybe<Array<NotificationBannerConnectInput>>;
  /** Create and connect multiple NotificationBanner documents */
  create?: InputMaybe<Array<NotificationBannerCreateInput>>;
  /** Delete multiple NotificationBanner documents */
  delete?: InputMaybe<Array<NotificationBannerWhereUniqueInput>>;
  /** Disconnect multiple NotificationBanner documents */
  disconnect?: InputMaybe<Array<NotificationBannerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NotificationBanner documents */
  set?: InputMaybe<Array<NotificationBannerWhereUniqueInput>>;
  /** Update multiple NotificationBanner documents */
  update?: InputMaybe<Array<NotificationBannerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NotificationBanner documents */
  upsert?: InputMaybe<Array<NotificationBannerUpsertWithNestedWhereUniqueInput>>;
};

export type NotificationBannerUpdateManyInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bannerType?: InputMaybe<BannerType>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationBannerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: NotificationBannerUpdateManyInput;
  /** Document search */
  where: NotificationBannerWhereInput;
};

export type NotificationBannerUpdateOneInlineInput = {
  /** Connect existing NotificationBanner document */
  connect?: InputMaybe<NotificationBannerWhereUniqueInput>;
  /** Create and connect one NotificationBanner document */
  create?: InputMaybe<NotificationBannerCreateInput>;
  /** Delete currently connected NotificationBanner document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NotificationBanner document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NotificationBanner document */
  update?: InputMaybe<NotificationBannerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NotificationBanner document */
  upsert?: InputMaybe<NotificationBannerUpsertWithNestedWhereUniqueInput>;
};

export type NotificationBannerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: NotificationBannerUpdateInput;
  /** Unique document search */
  where: NotificationBannerWhereUniqueInput;
};

export type NotificationBannerUpsertInput = {
  /** Create document if it didn't exist */
  create: NotificationBannerCreateInput;
  /** Update document if it exists */
  update: NotificationBannerUpdateInput;
};

export type NotificationBannerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: NotificationBannerUpsertInput;
  /** Unique document search */
  where: NotificationBannerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type NotificationBannerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type NotificationBannerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NotificationBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NotificationBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NotificationBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  active_not?: InputMaybe<Scalars['Boolean']['input']>;
  bannerType?: InputMaybe<BannerType>;
  /** All values that are contained in given list. */
  bannerType_in?: InputMaybe<Array<InputMaybe<BannerType>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerType_not?: InputMaybe<BannerType>;
  /** All values that are not contained in given list. */
  bannerType_not_in?: InputMaybe<Array<InputMaybe<BannerType>>>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<NotificationBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<NotificationBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<NotificationBannerWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type NotificationBannerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NotificationBannerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NotificationBannerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NotificationBannerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<NotificationBannerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References NotificationBanner record uniquely */
export type NotificationBannerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PageFooter = Entity & Node & {
  __typename?: 'PageFooter';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<PageFooter>;
  /** Here can you add an image which will be visible over the footer, It will appear over the newsletter component if shown. */
  footerImage?: Maybe<AssetComponent>;
  genericPages: Array<GenericPage>;
  /** List of PageFooter versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type PageFooterCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageFooterDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type PageFooterFooterImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageFooterGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type PageFooterHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type PageFooterMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageFooterPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageFooterScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PageFooterUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PageFooterConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PageFooterWhereUniqueInput;
};

/** A connection to a list of items. */
export type PageFooterConnection = {
  __typename?: 'PageFooterConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PageFooterEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PageFooterCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  footerImage?: InputMaybe<AssetComponentCreateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PageFooterCreateManyInlineInput = {
  /** Connect multiple existing PageFooter documents */
  connect?: InputMaybe<Array<PageFooterWhereUniqueInput>>;
  /** Create and connect multiple existing PageFooter documents */
  create?: InputMaybe<Array<PageFooterCreateInput>>;
};

export type PageFooterCreateOneInlineInput = {
  /** Connect one existing PageFooter document */
  connect?: InputMaybe<PageFooterWhereUniqueInput>;
  /** Create and connect one PageFooter document */
  create?: InputMaybe<PageFooterCreateInput>;
};

/** An edge in a connection. */
export type PageFooterEdge = {
  __typename?: 'PageFooterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PageFooter;
};

/** Identifies documents */
export type PageFooterManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageFooterWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageFooterWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageFooterWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PageFooterWhereStageInput>;
  documentInStages_none?: InputMaybe<PageFooterWhereStageInput>;
  documentInStages_some?: InputMaybe<PageFooterWhereStageInput>;
  footerImage?: InputMaybe<AssetComponentWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PageFooterOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type PageFooterUpdateInput = {
  footerImage?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageFooterUpdateManyInlineInput = {
  /** Connect multiple existing PageFooter documents */
  connect?: InputMaybe<Array<PageFooterConnectInput>>;
  /** Create and connect multiple PageFooter documents */
  create?: InputMaybe<Array<PageFooterCreateInput>>;
  /** Delete multiple PageFooter documents */
  delete?: InputMaybe<Array<PageFooterWhereUniqueInput>>;
  /** Disconnect multiple PageFooter documents */
  disconnect?: InputMaybe<Array<PageFooterWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PageFooter documents */
  set?: InputMaybe<Array<PageFooterWhereUniqueInput>>;
  /** Update multiple PageFooter documents */
  update?: InputMaybe<Array<PageFooterUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PageFooter documents */
  upsert?: InputMaybe<Array<PageFooterUpsertWithNestedWhereUniqueInput>>;
};

export type PageFooterUpdateManyInput = {
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageFooterUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PageFooterUpdateManyInput;
  /** Document search */
  where: PageFooterWhereInput;
};

export type PageFooterUpdateOneInlineInput = {
  /** Connect existing PageFooter document */
  connect?: InputMaybe<PageFooterWhereUniqueInput>;
  /** Create and connect one PageFooter document */
  create?: InputMaybe<PageFooterCreateInput>;
  /** Delete currently connected PageFooter document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected PageFooter document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PageFooter document */
  update?: InputMaybe<PageFooterUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PageFooter document */
  upsert?: InputMaybe<PageFooterUpsertWithNestedWhereUniqueInput>;
};

export type PageFooterUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PageFooterUpdateInput;
  /** Unique document search */
  where: PageFooterWhereUniqueInput;
};

export type PageFooterUpsertInput = {
  /** Create document if it didn't exist */
  create: PageFooterCreateInput;
  /** Update document if it exists */
  update: PageFooterUpdateInput;
};

export type PageFooterUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PageFooterUpsertInput;
  /** Unique document search */
  where: PageFooterWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PageFooterWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PageFooterWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageFooterWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageFooterWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageFooterWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PageFooterWhereStageInput>;
  documentInStages_none?: InputMaybe<PageFooterWhereStageInput>;
  documentInStages_some?: InputMaybe<PageFooterWhereStageInput>;
  footerImage?: InputMaybe<AssetComponentWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PageFooterWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageFooterWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageFooterWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageFooterWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PageFooterWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References PageFooter record uniquely */
export type PageFooterWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PageHeader = Entity & Node & {
  __typename?: 'PageHeader';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<PageHeader>;
  genericPages: Array<GenericPage>;
  /** List of PageHeader versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type PageHeaderCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageHeaderDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type PageHeaderGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type PageHeaderHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type PageHeaderMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageHeaderPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageHeaderScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PageHeaderUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PageHeaderConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PageHeaderWhereUniqueInput;
};

/** A connection to a list of items. */
export type PageHeaderConnection = {
  __typename?: 'PageHeaderConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PageHeaderEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PageHeaderCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PageHeaderCreateManyInlineInput = {
  /** Connect multiple existing PageHeader documents */
  connect?: InputMaybe<Array<PageHeaderWhereUniqueInput>>;
  /** Create and connect multiple existing PageHeader documents */
  create?: InputMaybe<Array<PageHeaderCreateInput>>;
};

export type PageHeaderCreateOneInlineInput = {
  /** Connect one existing PageHeader document */
  connect?: InputMaybe<PageHeaderWhereUniqueInput>;
  /** Create and connect one PageHeader document */
  create?: InputMaybe<PageHeaderCreateInput>;
};

/** An edge in a connection. */
export type PageHeaderEdge = {
  __typename?: 'PageHeaderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PageHeader;
};

/** Identifies documents */
export type PageHeaderManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageHeaderWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageHeaderWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageHeaderWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PageHeaderWhereStageInput>;
  documentInStages_none?: InputMaybe<PageHeaderWhereStageInput>;
  documentInStages_some?: InputMaybe<PageHeaderWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PageHeaderOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type PageHeaderUpdateInput = {
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageHeaderUpdateManyInlineInput = {
  /** Connect multiple existing PageHeader documents */
  connect?: InputMaybe<Array<PageHeaderConnectInput>>;
  /** Create and connect multiple PageHeader documents */
  create?: InputMaybe<Array<PageHeaderCreateInput>>;
  /** Delete multiple PageHeader documents */
  delete?: InputMaybe<Array<PageHeaderWhereUniqueInput>>;
  /** Disconnect multiple PageHeader documents */
  disconnect?: InputMaybe<Array<PageHeaderWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PageHeader documents */
  set?: InputMaybe<Array<PageHeaderWhereUniqueInput>>;
  /** Update multiple PageHeader documents */
  update?: InputMaybe<Array<PageHeaderUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PageHeader documents */
  upsert?: InputMaybe<Array<PageHeaderUpsertWithNestedWhereUniqueInput>>;
};

export type PageHeaderUpdateManyInput = {
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageHeaderUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PageHeaderUpdateManyInput;
  /** Document search */
  where: PageHeaderWhereInput;
};

export type PageHeaderUpdateOneInlineInput = {
  /** Connect existing PageHeader document */
  connect?: InputMaybe<PageHeaderWhereUniqueInput>;
  /** Create and connect one PageHeader document */
  create?: InputMaybe<PageHeaderCreateInput>;
  /** Delete currently connected PageHeader document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected PageHeader document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PageHeader document */
  update?: InputMaybe<PageHeaderUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PageHeader document */
  upsert?: InputMaybe<PageHeaderUpsertWithNestedWhereUniqueInput>;
};

export type PageHeaderUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PageHeaderUpdateInput;
  /** Unique document search */
  where: PageHeaderWhereUniqueInput;
};

export type PageHeaderUpsertInput = {
  /** Create document if it didn't exist */
  create: PageHeaderCreateInput;
  /** Update document if it exists */
  update: PageHeaderUpdateInput;
};

export type PageHeaderUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PageHeaderUpsertInput;
  /** Unique document search */
  where: PageHeaderWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PageHeaderWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PageHeaderWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageHeaderWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageHeaderWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageHeaderWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PageHeaderWhereStageInput>;
  documentInStages_none?: InputMaybe<PageHeaderWhereStageInput>;
  documentInStages_some?: InputMaybe<PageHeaderWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PageHeaderWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageHeaderWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageHeaderWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageHeaderWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PageHeaderWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References PageHeader record uniquely */
export type PageHeaderWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Number of items in the current page. */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PopularSearchComponent = Entity & Node & {
  __typename?: 'PopularSearchComponent';
  anchorNav?: Maybe<AnchorNavigation>;
  assetsComponents: Array<AssetComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  dictionary?: Maybe<Dictionary>;
  /** Get the document in other stages */
  documentInStages: Array<PopularSearchComponent>;
  /** Title of the component */
  heading?: Maybe<Scalars['String']['output']>;
  /** List of PopularSearchComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Algolia Indices  */
  indices?: Maybe<Scalars['String']['output']>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Super text of the component */
  subHeading?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type PopularSearchComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PopularSearchComponentAssetsComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentWhereInput>;
};


export type PopularSearchComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PopularSearchComponentDictionaryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PopularSearchComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type PopularSearchComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type PopularSearchComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PopularSearchComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PopularSearchComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PopularSearchComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PopularSearchComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PopularSearchComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type PopularSearchComponentConnection = {
  __typename?: 'PopularSearchComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PopularSearchComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PopularSearchComponentCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  assetsComponents?: InputMaybe<AssetComponentCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionary?: InputMaybe<DictionaryCreateOneInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  indices?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PopularSearchComponentCreateManyInlineInput = {
  /** Connect multiple existing PopularSearchComponent documents */
  connect?: InputMaybe<Array<PopularSearchComponentWhereUniqueInput>>;
  /** Create and connect multiple existing PopularSearchComponent documents */
  create?: InputMaybe<Array<PopularSearchComponentCreateInput>>;
};

export type PopularSearchComponentCreateOneInlineInput = {
  /** Connect one existing PopularSearchComponent document */
  connect?: InputMaybe<PopularSearchComponentWhereUniqueInput>;
  /** Create and connect one PopularSearchComponent document */
  create?: InputMaybe<PopularSearchComponentCreateInput>;
};

/** An edge in a connection. */
export type PopularSearchComponentEdge = {
  __typename?: 'PopularSearchComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PopularSearchComponent;
};

/** Identifies documents */
export type PopularSearchComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PopularSearchComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PopularSearchComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PopularSearchComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionary?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<PopularSearchComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<PopularSearchComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<PopularSearchComponentWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  indices?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  indices_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  indices_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  indices_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  indices_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  indices_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  indices_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  indices_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  indices_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  indices_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PopularSearchComponentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  indices_ASC = 'indices_ASC',
  indices_DESC = 'indices_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subHeading_ASC = 'subHeading_ASC',
  subHeading_DESC = 'subHeading_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type PopularSearchComponentUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  assetsComponents?: InputMaybe<AssetComponentUpdateManyInlineInput>;
  dictionary?: InputMaybe<DictionaryUpdateOneInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  indices?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type PopularSearchComponentUpdateManyInlineInput = {
  /** Connect multiple existing PopularSearchComponent documents */
  connect?: InputMaybe<Array<PopularSearchComponentConnectInput>>;
  /** Create and connect multiple PopularSearchComponent documents */
  create?: InputMaybe<Array<PopularSearchComponentCreateInput>>;
  /** Delete multiple PopularSearchComponent documents */
  delete?: InputMaybe<Array<PopularSearchComponentWhereUniqueInput>>;
  /** Disconnect multiple PopularSearchComponent documents */
  disconnect?: InputMaybe<Array<PopularSearchComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PopularSearchComponent documents */
  set?: InputMaybe<Array<PopularSearchComponentWhereUniqueInput>>;
  /** Update multiple PopularSearchComponent documents */
  update?: InputMaybe<Array<PopularSearchComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PopularSearchComponent documents */
  upsert?: InputMaybe<Array<PopularSearchComponentUpsertWithNestedWhereUniqueInput>>;
};

export type PopularSearchComponentUpdateManyInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  indices?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type PopularSearchComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PopularSearchComponentUpdateManyInput;
  /** Document search */
  where: PopularSearchComponentWhereInput;
};

export type PopularSearchComponentUpdateOneInlineInput = {
  /** Connect existing PopularSearchComponent document */
  connect?: InputMaybe<PopularSearchComponentWhereUniqueInput>;
  /** Create and connect one PopularSearchComponent document */
  create?: InputMaybe<PopularSearchComponentCreateInput>;
  /** Delete currently connected PopularSearchComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected PopularSearchComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PopularSearchComponent document */
  update?: InputMaybe<PopularSearchComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PopularSearchComponent document */
  upsert?: InputMaybe<PopularSearchComponentUpsertWithNestedWhereUniqueInput>;
};

export type PopularSearchComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PopularSearchComponentUpdateInput;
  /** Unique document search */
  where: PopularSearchComponentWhereUniqueInput;
};

export type PopularSearchComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: PopularSearchComponentCreateInput;
  /** Update document if it exists */
  update: PopularSearchComponentUpdateInput;
};

export type PopularSearchComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PopularSearchComponentUpsertInput;
  /** Unique document search */
  where: PopularSearchComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PopularSearchComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PopularSearchComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PopularSearchComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PopularSearchComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PopularSearchComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionary?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<PopularSearchComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<PopularSearchComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<PopularSearchComponentWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  indices?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  indices_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  indices_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  indices_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  indices_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  indices_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  indices_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  indices_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  indices_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  indices_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PopularSearchComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PopularSearchComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PopularSearchComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PopularSearchComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PopularSearchComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References PopularSearchComponent record uniquely */
export type PopularSearchComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
};

/** Products imported by PIM Sync from Oetker PIM */
export type Product = Entity & Node & {
  __typename?: 'Product';
  allergens: Array<Scalars['String']['output']>;
  categories: Array<ProductCategory>;
  cookingTips: Array<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  dictionary?: Maybe<Dictionary>;
  /** Get the document in other stages */
  documentInStages: Array<Product>;
  fillingQuantity?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  /** List of Product versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  ingredients?: Maybe<Scalars['String']['output']>;
  lastUpdatedInPim?: Maybe<Scalars['String']['output']>;
  lifestyleImage?: Maybe<Asset>;
  market?: Maybe<Scalars['String']['output']>;
  marketName?: Maybe<Market>;
  marketSlugId?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Scalars['String']['output']>;
  nutriScore?: Maybe<Scalars['String']['output']>;
  nutrientInformation?: Maybe<Scalars['String']['output']>;
  /** Packaging Information */
  packagingInformation?: Maybe<Scalars['String']['output']>;
  preparationInstructions?: Maybe<Scalars['String']['output']>;
  productBanner: Array<ProductBanner>;
  /** productDescription */
  productDescription: Scalars['String']['output'];
  productDietList: Array<Scalars['String']['output']>;
  /** Id used in PIM-SYNC */
  productId?: Maybe<Scalars['String']['output']>;
  productImage?: Maybe<Asset>;
  productLabels: Array<ProductLabel>;
  /** Online Shopping product Page URL */
  productPageURL?: Maybe<Scalars['String']['output']>;
  /** productTitle */
  productTitle: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** Url friendly name shown in the url bar of a browser */
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Products imported by PIM Sync from Oetker PIM */
export type ProductCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryWhereInput>;
};


/** Products imported by PIM Sync from Oetker PIM */
export type ProductCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Products imported by PIM Sync from Oetker PIM */
export type ProductDictionaryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Products imported by PIM Sync from Oetker PIM */
export type ProductDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Products imported by PIM Sync from Oetker PIM */
export type ProductHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Products imported by PIM Sync from Oetker PIM */
export type ProductLifestyleImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Products imported by PIM Sync from Oetker PIM */
export type ProductMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Products imported by PIM Sync from Oetker PIM */
export type ProductProductBannerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductBannerWhereInput>;
};


/** Products imported by PIM Sync from Oetker PIM */
export type ProductProductImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Products imported by PIM Sync from Oetker PIM */
export type ProductProductLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductLabelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLabelWhereInput>;
};


/** Products imported by PIM Sync from Oetker PIM */
export type ProductPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Products imported by PIM Sync from Oetker PIM */
export type ProductScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Products imported by PIM Sync from Oetker PIM */
export type ProductUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductBanner = Entity & Node & {
  __typename?: 'ProductBanner';
  anchorNav?: Maybe<AnchorNavigation>;
  backgroundImage?: Maybe<AssetComponent>;
  buttonColor: ButtonColor;
  category?: Maybe<Scalars['String']['output']>;
  cmsTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<ProductBanner>;
  genericPages: Array<GenericPage>;
  /** List of ProductBanner versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  market: Markets;
  marketName?: Maybe<Market>;
  product?: Maybe<Product>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  staticMetaball?: Maybe<AssetComponent>;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  toolImage?: Maybe<AssetComponent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ProductBannerAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductBannerBackgroundImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductBannerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductBannerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ProductBannerGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type ProductBannerHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ProductBannerLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductBannerMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductBannerProductArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductBannerProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


export type ProductBannerProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


export type ProductBannerProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


export type ProductBannerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductBannerRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type ProductBannerRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


export type ProductBannerRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


export type ProductBannerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ProductBannerStaticMetaballArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductBannerSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductBannerTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductBannerToolImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductBannerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductBannerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ProductBannerWhereUniqueInput;
};

/** A connection to a list of items. */
export type ProductBannerConnection = {
  __typename?: 'ProductBannerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ProductBannerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ProductBannerCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  backgroundImage?: InputMaybe<AssetComponentCreateOneInlineInput>;
  buttonColor: ButtonColor;
  category?: InputMaybe<Scalars['String']['input']>;
  cksrelkah3uup01yu2fmd8c5p?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  cmsTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  product?: InputMaybe<ProductCreateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  staticMetaball?: InputMaybe<AssetComponentCreateOneInlineInput>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  toolImage?: InputMaybe<AssetComponentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductBannerCreateManyInlineInput = {
  /** Connect multiple existing ProductBanner documents */
  connect?: InputMaybe<Array<ProductBannerWhereUniqueInput>>;
  /** Create and connect multiple existing ProductBanner documents */
  create?: InputMaybe<Array<ProductBannerCreateInput>>;
};

export type ProductBannerCreateOneInlineInput = {
  /** Connect one existing ProductBanner document */
  connect?: InputMaybe<ProductBannerWhereUniqueInput>;
  /** Create and connect one ProductBanner document */
  create?: InputMaybe<ProductBannerCreateInput>;
};

/** An edge in a connection. */
export type ProductBannerEdge = {
  __typename?: 'ProductBannerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductBanner;
};

/** Identifies documents */
export type ProductBannerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundImage?: InputMaybe<AssetComponentWhereInput>;
  buttonColor?: InputMaybe<ButtonColor>;
  /** All values that are contained in given list. */
  buttonColor_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonColor_not?: InputMaybe<ButtonColor>;
  /** All values that are not contained in given list. */
  buttonColor_not_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  category_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  category_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  category_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  category_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  category_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  category_starts_with?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<ProductBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductBannerWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  product?: InputMaybe<ProductWhereInput>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  staticMetaball?: InputMaybe<AssetComponentWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  toolImage?: InputMaybe<AssetComponentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ProductBannerOrderByInput {
  buttonColor_ASC = 'buttonColor_ASC',
  buttonColor_DESC = 'buttonColor_DESC',
  category_ASC = 'category_ASC',
  category_DESC = 'category_DESC',
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ProductBannerUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  backgroundImage?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  buttonColor?: InputMaybe<ButtonColor>;
  category?: InputMaybe<Scalars['String']['input']>;
  cksrelkah3uup01yu2fmd8c5p?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  product?: InputMaybe<ProductUpdateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  staticMetaball?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  toolImage?: InputMaybe<AssetComponentUpdateOneInlineInput>;
};

export type ProductBannerUpdateManyInlineInput = {
  /** Connect multiple existing ProductBanner documents */
  connect?: InputMaybe<Array<ProductBannerConnectInput>>;
  /** Create and connect multiple ProductBanner documents */
  create?: InputMaybe<Array<ProductBannerCreateInput>>;
  /** Delete multiple ProductBanner documents */
  delete?: InputMaybe<Array<ProductBannerWhereUniqueInput>>;
  /** Disconnect multiple ProductBanner documents */
  disconnect?: InputMaybe<Array<ProductBannerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ProductBanner documents */
  set?: InputMaybe<Array<ProductBannerWhereUniqueInput>>;
  /** Update multiple ProductBanner documents */
  update?: InputMaybe<Array<ProductBannerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ProductBanner documents */
  upsert?: InputMaybe<Array<ProductBannerUpsertWithNestedWhereUniqueInput>>;
};

export type ProductBannerUpdateManyInput = {
  buttonColor?: InputMaybe<ButtonColor>;
  category?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
};

export type ProductBannerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ProductBannerUpdateManyInput;
  /** Document search */
  where: ProductBannerWhereInput;
};

export type ProductBannerUpdateOneInlineInput = {
  /** Connect existing ProductBanner document */
  connect?: InputMaybe<ProductBannerWhereUniqueInput>;
  /** Create and connect one ProductBanner document */
  create?: InputMaybe<ProductBannerCreateInput>;
  /** Delete currently connected ProductBanner document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ProductBanner document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ProductBanner document */
  update?: InputMaybe<ProductBannerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProductBanner document */
  upsert?: InputMaybe<ProductBannerUpsertWithNestedWhereUniqueInput>;
};

export type ProductBannerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ProductBannerUpdateInput;
  /** Unique document search */
  where: ProductBannerWhereUniqueInput;
};

export type ProductBannerUpsertInput = {
  /** Create document if it didn't exist */
  create: ProductBannerCreateInput;
  /** Update document if it exists */
  update: ProductBannerUpdateInput;
};

export type ProductBannerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ProductBannerUpsertInput;
  /** Unique document search */
  where: ProductBannerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ProductBannerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ProductBannerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundImage?: InputMaybe<AssetComponentWhereInput>;
  buttonColor?: InputMaybe<ButtonColor>;
  /** All values that are contained in given list. */
  buttonColor_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonColor_not?: InputMaybe<ButtonColor>;
  /** All values that are not contained in given list. */
  buttonColor_not_in?: InputMaybe<Array<InputMaybe<ButtonColor>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  category_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  category_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  category_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  category_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  category_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  category_starts_with?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<ProductBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductBannerWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  product?: InputMaybe<ProductWhereInput>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  staticMetaball?: InputMaybe<AssetComponentWhereInput>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  toolImage?: InputMaybe<AssetComponentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ProductBannerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductBannerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductBannerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductBannerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ProductBannerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ProductBanner record uniquely */
export type ProductBannerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductCategory = Entity & Node & {
  __typename?: 'ProductCategory';
  categoryId?: Maybe<Scalars['String']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<ProductCategory>;
  /** List of ProductCategory versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market?: Maybe<Scalars['String']['output']>;
  marketName?: Maybe<Market>;
  marketSlug?: Maybe<Scalars['String']['output']>;
  parentCategory?: Maybe<ProductCategory>;
  productCategoryPage?: Maybe<ProductCategoryPage>;
  productSubcategoryPage?: Maybe<ProductSubcategoryPage>;
  products: Array<Product>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  subcategories: Array<ProductCategory>;
  subcategoryPage?: Maybe<ProductSubcategoryPage>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ProductCategoryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductCategoryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ProductCategoryHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ProductCategoryMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductCategoryParentCategoryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductCategoryProductCategoryPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductCategoryProductSubcategoryPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductCategoryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductWhereInput>;
};


export type ProductCategoryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductCategoryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ProductCategorySubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryWhereInput>;
};


export type ProductCategorySubcategoryPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductCategoryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductCategoryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ProductCategoryWhereUniqueInput;
};

/** A connection to a list of items. */
export type ProductCategoryConnection = {
  __typename?: 'ProductCategoryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ProductCategoryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ProductCategoryCreateInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  cl3bhkqqb2cef01z2bgem5soi?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  cl52bg7jy24ug01t82w15hd8w?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  marketSlug?: InputMaybe<Scalars['String']['input']>;
  parentCategory?: InputMaybe<ProductCategoryCreateOneInlineInput>;
  productCategoryPage?: InputMaybe<ProductCategoryPageCreateOneInlineInput>;
  productSubcategoryPage?: InputMaybe<ProductSubcategoryPageCreateOneInlineInput>;
  products?: InputMaybe<ProductCreateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subcategories?: InputMaybe<ProductCategoryCreateManyInlineInput>;
  subcategoryPage?: InputMaybe<ProductSubcategoryPageCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductCategoryCreateManyInlineInput = {
  /** Connect multiple existing ProductCategory documents */
  connect?: InputMaybe<Array<ProductCategoryWhereUniqueInput>>;
  /** Create and connect multiple existing ProductCategory documents */
  create?: InputMaybe<Array<ProductCategoryCreateInput>>;
};

export type ProductCategoryCreateOneInlineInput = {
  /** Connect one existing ProductCategory document */
  connect?: InputMaybe<ProductCategoryWhereUniqueInput>;
  /** Create and connect one ProductCategory document */
  create?: InputMaybe<ProductCategoryCreateInput>;
};

/** An edge in a connection. */
export type ProductCategoryEdge = {
  __typename?: 'ProductCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductCategory;
};

/** Identifies documents */
export type ProductCategoryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  categoryId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  categoryId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  categoryId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  categoryId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  categoryId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  categoryId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  categoryId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  categoryId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  categoryId_starts_with?: InputMaybe<Scalars['String']['input']>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  categoryName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  categoryName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  categoryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  categoryName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  categoryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  categoryName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  categoryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  categoryName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  categoryName_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ProductCategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductCategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductCategoryWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  marketName?: InputMaybe<MarketWhereInput>;
  marketSlug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  marketSlug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  marketSlug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  marketSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  marketSlug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  marketSlug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  marketSlug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  marketSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  marketSlug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  marketSlug_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  market_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  market_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  market_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  market_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  market_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  market_starts_with?: InputMaybe<Scalars['String']['input']>;
  parentCategory?: InputMaybe<ProductCategoryWhereInput>;
  productCategoryPage?: InputMaybe<ProductCategoryPageWhereInput>;
  productSubcategoryPage?: InputMaybe<ProductSubcategoryPageWhereInput>;
  products_every?: InputMaybe<ProductWhereInput>;
  products_none?: InputMaybe<ProductWhereInput>;
  products_some?: InputMaybe<ProductWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  subcategories_every?: InputMaybe<ProductCategoryWhereInput>;
  subcategories_none?: InputMaybe<ProductCategoryWhereInput>;
  subcategories_some?: InputMaybe<ProductCategoryWhereInput>;
  subcategoryPage?: InputMaybe<ProductSubcategoryPageWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ProductCategoryOrderByInput {
  categoryId_ASC = 'categoryId_ASC',
  categoryId_DESC = 'categoryId_DESC',
  categoryName_ASC = 'categoryName_ASC',
  categoryName_DESC = 'categoryName_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  marketSlug_ASC = 'marketSlug_ASC',
  marketSlug_DESC = 'marketSlug_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Manual configuration for Product Category Pages */
export type ProductCategoryPage = Entity & Node & {
  __typename?: 'ProductCategoryPage';
  /** Image asset for the background ingredient in the product details hero. */
  backgroundIngredientImage?: Maybe<Asset>;
  /** Title to use for referencing inside of the CMS not usually used in code */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Used to add the English tracking value to be used in the tracking calls */
  dictionaryItem?: Maybe<DictionaryItem>;
  /** Get the document in other stages */
  documentInStages: Array<ProductCategoryPage>;
  /** Image asset for the foreground ingredient in the product details hero. */
  foregroundIngredientImage?: Maybe<Asset>;
  heroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** List of ProductCategoryPage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Color for the secondary blob in the product details hero. */
  ingredientAccentColor?: Maybe<Color>;
  introText?: Maybe<IntroText>;
  /** Image for use on the category & subcategory component that displays on the all products page (transparent background) */
  keyImage?: Maybe<Asset>;
  link?: Maybe<Link>;
  links: Array<Link>;
  market: Markets;
  marketName?: Maybe<Market>;
  metaData?: Maybe<MetaData>;
  /** No more than 50 components */
  pageComponents: Array<ProductCategoryPagePageComponents>;
  /** Reference a product banner  */
  productBanner?: Maybe<ProductBanner>;
  /** Don't use! OLD! */
  productCategories: Array<ProductCategory>;
  productCategory: Array<ProductCategory>;
  /** The name of the Product Category that you want to associate product sub categories too */
  productCategoryName?: Maybe<Scalars['String']['output']>;
  /** Title for the product grid on the product category page. */
  productGridTitle: Scalars['String']['output'];
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  productSubcategorySuper?: Maybe<Scalars['String']['output']>;
  productSubcategoryTitle?: Maybe<Scalars['String']['output']>;
  /** Image for use on category / subcategory component if no subcategories exist  */
  promoImage?: Maybe<Asset>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** The URL slug for the Product Category page */
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  teaserPlaceholders: Array<TeaserPlaceholder>;
  teaserSmallPlaceholders: Array<TeaserSmallPlaceholder>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageBackgroundIngredientImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageDictionaryItemArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageForegroundIngredientImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageHeroCarouselComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageIntroTextArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageKeyImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPagePageComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageProductBannerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageProductCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryWhereInput>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageProductCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryWhereInput>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductSubcategoryPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPagePromoImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageTeaserPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserPlaceholderWhereInput>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageTeaserSmallPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
};


/** Manual configuration for Product Category Pages */
export type ProductCategoryPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductCategoryPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ProductCategoryPageWhereUniqueInput;
};

/** A connection to a list of items. */
export type ProductCategoryPageConnection = {
  __typename?: 'ProductCategoryPageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ProductCategoryPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ProductCategoryPageCreateInput = {
  backgroundIngredientImage?: InputMaybe<AssetCreateOneInlineInput>;
  cksrqqql543uh01w9e6ukcyt5?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionaryItem?: InputMaybe<DictionaryItemCreateOneInlineInput>;
  foregroundIngredientImage?: InputMaybe<AssetCreateOneInlineInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateOneInlineInput>;
  ingredientAccentColor?: InputMaybe<ColorInput>;
  introText?: InputMaybe<IntroTextCreateOneInlineInput>;
  keyImage?: InputMaybe<AssetCreateOneInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  links?: InputMaybe<LinkCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  metaData?: InputMaybe<MetaDataCreateOneInlineInput>;
  pageComponents?: InputMaybe<ProductCategoryPagePageComponentsCreateManyInlineInput>;
  productBanner?: InputMaybe<ProductBannerCreateOneInlineInput>;
  productCategories?: InputMaybe<ProductCategoryCreateManyInlineInput>;
  productCategory?: InputMaybe<ProductCategoryCreateManyInlineInput>;
  productCategoryName?: InputMaybe<Scalars['String']['input']>;
  productGridTitle: Scalars['String']['input'];
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  productSubcategorySuper?: InputMaybe<Scalars['String']['input']>;
  productSubcategoryTitle?: InputMaybe<Scalars['String']['input']>;
  promoImage?: InputMaybe<AssetCreateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderCreateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductCategoryPageCreateManyInlineInput = {
  /** Connect multiple existing ProductCategoryPage documents */
  connect?: InputMaybe<Array<ProductCategoryPageWhereUniqueInput>>;
  /** Create and connect multiple existing ProductCategoryPage documents */
  create?: InputMaybe<Array<ProductCategoryPageCreateInput>>;
};

export type ProductCategoryPageCreateOneInlineInput = {
  /** Connect one existing ProductCategoryPage document */
  connect?: InputMaybe<ProductCategoryPageWhereUniqueInput>;
  /** Create and connect one ProductCategoryPage document */
  create?: InputMaybe<ProductCategoryPageCreateInput>;
};

/** An edge in a connection. */
export type ProductCategoryPageEdge = {
  __typename?: 'ProductCategoryPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductCategoryPage;
};

/** Identifies documents */
export type ProductCategoryPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductCategoryPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductCategoryPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductCategoryPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundIngredientImage?: InputMaybe<AssetWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaryItem?: InputMaybe<DictionaryItemWhereInput>;
  documentInStages_every?: InputMaybe<ProductCategoryPageWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductCategoryPageWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductCategoryPageWhereStageInput>;
  foregroundIngredientImage?: InputMaybe<AssetWhereInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introText?: InputMaybe<IntroTextWhereInput>;
  keyImage?: InputMaybe<AssetWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<ProductCategoryPagePageComponentsWhereInput>;
  productBanner?: InputMaybe<ProductBannerWhereInput>;
  productCategories_every?: InputMaybe<ProductCategoryWhereInput>;
  productCategories_none?: InputMaybe<ProductCategoryWhereInput>;
  productCategories_some?: InputMaybe<ProductCategoryWhereInput>;
  productCategoryName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productCategoryName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productCategoryName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productCategoryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productCategoryName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productCategoryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productCategoryName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productCategoryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productCategoryName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productCategoryName_starts_with?: InputMaybe<Scalars['String']['input']>;
  productCategory_every?: InputMaybe<ProductCategoryWhereInput>;
  productCategory_none?: InputMaybe<ProductCategoryWhereInput>;
  productCategory_some?: InputMaybe<ProductCategoryWhereInput>;
  productGridTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productGridTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productGridTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productGridTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productGridTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productGridTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productGridTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productGridTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productGridTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productGridTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategorySuper?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productSubcategorySuper_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productSubcategorySuper_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productSubcategorySuper_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productSubcategorySuper_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productSubcategorySuper_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productSubcategorySuper_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productSubcategorySuper_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productSubcategorySuper_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productSubcategorySuper_starts_with?: InputMaybe<Scalars['String']['input']>;
  productSubcategoryTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productSubcategoryTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productSubcategoryTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productSubcategoryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productSubcategoryTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productSubcategoryTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productSubcategoryTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productSubcategoryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productSubcategoryTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productSubcategoryTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  promoImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ProductCategoryPageOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  productCategoryName_ASC = 'productCategoryName_ASC',
  productCategoryName_DESC = 'productCategoryName_DESC',
  productGridTitle_ASC = 'productGridTitle_ASC',
  productGridTitle_DESC = 'productGridTitle_DESC',
  productSubcategorySuper_ASC = 'productSubcategorySuper_ASC',
  productSubcategorySuper_DESC = 'productSubcategorySuper_DESC',
  productSubcategoryTitle_ASC = 'productSubcategoryTitle_ASC',
  productSubcategoryTitle_DESC = 'productSubcategoryTitle_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ProductCategoryPagePageComponents = Accordion | Banner1 | Banner2 | Banner2CarouselComponent | CarouselComponent | DownloadApp | DynamicCardGrid | FeaturedContent | GenericAccordion | GenericAccordionTopRated | GenericCardCarouseComponent | GenericDownloadComponent | GenericFollowUs | GenericGridAuthorable | GenericHtml | GlobalSearch | HeroCarouselComponent | Iframe | ImageCopy | LongText | ProductBanner | Spacer;

export type ProductCategoryPagePageComponentsConnectInput = {
  Accordion?: InputMaybe<AccordionConnectInput>;
  Banner1?: InputMaybe<Banner1ConnectInput>;
  Banner2?: InputMaybe<Banner2ConnectInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentConnectInput>;
  CarouselComponent?: InputMaybe<CarouselComponentConnectInput>;
  DownloadApp?: InputMaybe<DownloadAppConnectInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridConnectInput>;
  FeaturedContent?: InputMaybe<FeaturedContentConnectInput>;
  GenericAccordion?: InputMaybe<GenericAccordionConnectInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedConnectInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentConnectInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentConnectInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsConnectInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableConnectInput>;
  GenericHtml?: InputMaybe<GenericHtmlConnectInput>;
  GlobalSearch?: InputMaybe<GlobalSearchConnectInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentConnectInput>;
  Iframe?: InputMaybe<IframeConnectInput>;
  ImageCopy?: InputMaybe<ImageCopyConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
  ProductBanner?: InputMaybe<ProductBannerConnectInput>;
  Spacer?: InputMaybe<SpacerConnectInput>;
};

export type ProductCategoryPagePageComponentsCreateInput = {
  Accordion?: InputMaybe<AccordionCreateInput>;
  Banner1?: InputMaybe<Banner1CreateInput>;
  Banner2?: InputMaybe<Banner2CreateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentCreateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentCreateInput>;
  DownloadApp?: InputMaybe<DownloadAppCreateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridCreateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentCreateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionCreateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedCreateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentCreateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsCreateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableCreateInput>;
  GenericHtml?: InputMaybe<GenericHtmlCreateInput>;
  GlobalSearch?: InputMaybe<GlobalSearchCreateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateInput>;
  Iframe?: InputMaybe<IframeCreateInput>;
  ImageCopy?: InputMaybe<ImageCopyCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
  ProductBanner?: InputMaybe<ProductBannerCreateInput>;
  Spacer?: InputMaybe<SpacerCreateInput>;
};

export type ProductCategoryPagePageComponentsCreateManyInlineInput = {
  /** Connect multiple existing ProductCategoryPagePageComponents documents */
  connect?: InputMaybe<Array<ProductCategoryPagePageComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing ProductCategoryPagePageComponents documents */
  create?: InputMaybe<Array<ProductCategoryPagePageComponentsCreateInput>>;
};

export type ProductCategoryPagePageComponentsCreateOneInlineInput = {
  /** Connect one existing ProductCategoryPagePageComponents document */
  connect?: InputMaybe<ProductCategoryPagePageComponentsWhereUniqueInput>;
  /** Create and connect one ProductCategoryPagePageComponents document */
  create?: InputMaybe<ProductCategoryPagePageComponentsCreateInput>;
};

export type ProductCategoryPagePageComponentsUpdateInput = {
  Accordion?: InputMaybe<AccordionUpdateInput>;
  Banner1?: InputMaybe<Banner1UpdateInput>;
  Banner2?: InputMaybe<Banner2UpdateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateInput>;
  Iframe?: InputMaybe<IframeUpdateInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateInput>;
  Spacer?: InputMaybe<SpacerUpdateInput>;
};

export type ProductCategoryPagePageComponentsUpdateManyInlineInput = {
  /** Connect multiple existing ProductCategoryPagePageComponents documents */
  connect?: InputMaybe<Array<ProductCategoryPagePageComponentsConnectInput>>;
  /** Create and connect multiple ProductCategoryPagePageComponents documents */
  create?: InputMaybe<Array<ProductCategoryPagePageComponentsCreateInput>>;
  /** Delete multiple ProductCategoryPagePageComponents documents */
  delete?: InputMaybe<Array<ProductCategoryPagePageComponentsWhereUniqueInput>>;
  /** Disconnect multiple ProductCategoryPagePageComponents documents */
  disconnect?: InputMaybe<Array<ProductCategoryPagePageComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ProductCategoryPagePageComponents documents */
  set?: InputMaybe<Array<ProductCategoryPagePageComponentsWhereUniqueInput>>;
  /** Update multiple ProductCategoryPagePageComponents documents */
  update?: InputMaybe<Array<ProductCategoryPagePageComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ProductCategoryPagePageComponents documents */
  upsert?: InputMaybe<Array<ProductCategoryPagePageComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type ProductCategoryPagePageComponentsUpdateManyWithNestedWhereInput = {
  Accordion?: InputMaybe<AccordionUpdateManyWithNestedWhereInput>;
  Banner1?: InputMaybe<Banner1UpdateManyWithNestedWhereInput>;
  Banner2?: InputMaybe<Banner2UpdateManyWithNestedWhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateManyWithNestedWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateManyWithNestedWhereInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateManyWithNestedWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateManyWithNestedWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateManyWithNestedWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateManyWithNestedWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateManyWithNestedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateManyWithNestedWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateManyWithNestedWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateManyWithNestedWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateManyWithNestedWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateManyWithNestedWhereInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateManyWithNestedWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateManyWithNestedWhereInput>;
  Iframe?: InputMaybe<IframeUpdateManyWithNestedWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateManyWithNestedWhereInput>;
  Spacer?: InputMaybe<SpacerUpdateManyWithNestedWhereInput>;
};

export type ProductCategoryPagePageComponentsUpdateOneInlineInput = {
  /** Connect existing ProductCategoryPagePageComponents document */
  connect?: InputMaybe<ProductCategoryPagePageComponentsWhereUniqueInput>;
  /** Create and connect one ProductCategoryPagePageComponents document */
  create?: InputMaybe<ProductCategoryPagePageComponentsCreateInput>;
  /** Delete currently connected ProductCategoryPagePageComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ProductCategoryPagePageComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ProductCategoryPagePageComponents document */
  update?: InputMaybe<ProductCategoryPagePageComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProductCategoryPagePageComponents document */
  upsert?: InputMaybe<ProductCategoryPagePageComponentsUpsertWithNestedWhereUniqueInput>;
};

export type ProductCategoryPagePageComponentsUpdateWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpdateWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpdateWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpdateWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateWithNestedWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateWithNestedWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpdateWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpdateWithNestedWhereUniqueInput>;
};

export type ProductCategoryPagePageComponentsUpsertWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpsertWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpsertWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpsertWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpsertWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpsertWithNestedWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppUpsertWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpsertWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpsertWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpsertWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpsertWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpsertWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpsertWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpsertWithNestedWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpsertWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpsertWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpsertWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpsertWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpsertWithNestedWhereUniqueInput>;
};

export type ProductCategoryPagePageComponentsWhereInput = {
  Accordion?: InputMaybe<AccordionWhereInput>;
  Banner1?: InputMaybe<Banner1WhereInput>;
  Banner2?: InputMaybe<Banner2WhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  DownloadApp?: InputMaybe<DownloadAppWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereInput>;
  GlobalSearch?: InputMaybe<GlobalSearchWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  Iframe?: InputMaybe<IframeWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereInput>;
  Spacer?: InputMaybe<SpacerWhereInput>;
};

export type ProductCategoryPagePageComponentsWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1WhereUniqueInput>;
  Banner2?: InputMaybe<Banner2WhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereUniqueInput>;
  Iframe?: InputMaybe<IframeWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerWhereUniqueInput>;
};

export type ProductCategoryPageUpdateInput = {
  backgroundIngredientImage?: InputMaybe<AssetUpdateOneInlineInput>;
  cksrqqql543uh01w9e6ukcyt5?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  dictionaryItem?: InputMaybe<DictionaryItemUpdateOneInlineInput>;
  foregroundIngredientImage?: InputMaybe<AssetUpdateOneInlineInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateOneInlineInput>;
  ingredientAccentColor?: InputMaybe<ColorInput>;
  introText?: InputMaybe<IntroTextUpdateOneInlineInput>;
  keyImage?: InputMaybe<AssetUpdateOneInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  links?: InputMaybe<LinkUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  metaData?: InputMaybe<MetaDataUpdateOneInlineInput>;
  pageComponents?: InputMaybe<ProductCategoryPagePageComponentsUpdateManyInlineInput>;
  productBanner?: InputMaybe<ProductBannerUpdateOneInlineInput>;
  productCategories?: InputMaybe<ProductCategoryUpdateManyInlineInput>;
  productCategory?: InputMaybe<ProductCategoryUpdateManyInlineInput>;
  productCategoryName?: InputMaybe<Scalars['String']['input']>;
  productGridTitle?: InputMaybe<Scalars['String']['input']>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  productSubcategorySuper?: InputMaybe<Scalars['String']['input']>;
  productSubcategoryTitle?: InputMaybe<Scalars['String']['input']>;
  promoImage?: InputMaybe<AssetUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderUpdateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderUpdateManyInlineInput>;
};

export type ProductCategoryPageUpdateManyInlineInput = {
  /** Connect multiple existing ProductCategoryPage documents */
  connect?: InputMaybe<Array<ProductCategoryPageConnectInput>>;
  /** Create and connect multiple ProductCategoryPage documents */
  create?: InputMaybe<Array<ProductCategoryPageCreateInput>>;
  /** Delete multiple ProductCategoryPage documents */
  delete?: InputMaybe<Array<ProductCategoryPageWhereUniqueInput>>;
  /** Disconnect multiple ProductCategoryPage documents */
  disconnect?: InputMaybe<Array<ProductCategoryPageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ProductCategoryPage documents */
  set?: InputMaybe<Array<ProductCategoryPageWhereUniqueInput>>;
  /** Update multiple ProductCategoryPage documents */
  update?: InputMaybe<Array<ProductCategoryPageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ProductCategoryPage documents */
  upsert?: InputMaybe<Array<ProductCategoryPageUpsertWithNestedWhereUniqueInput>>;
};

export type ProductCategoryPageUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  ingredientAccentColor?: InputMaybe<ColorInput>;
  market?: InputMaybe<Markets>;
  productCategoryName?: InputMaybe<Scalars['String']['input']>;
  productGridTitle?: InputMaybe<Scalars['String']['input']>;
  productSubcategorySuper?: InputMaybe<Scalars['String']['input']>;
  productSubcategoryTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ProductCategoryPageUpdateManyInput;
  /** Document search */
  where: ProductCategoryPageWhereInput;
};

export type ProductCategoryPageUpdateOneInlineInput = {
  /** Connect existing ProductCategoryPage document */
  connect?: InputMaybe<ProductCategoryPageWhereUniqueInput>;
  /** Create and connect one ProductCategoryPage document */
  create?: InputMaybe<ProductCategoryPageCreateInput>;
  /** Delete currently connected ProductCategoryPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ProductCategoryPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ProductCategoryPage document */
  update?: InputMaybe<ProductCategoryPageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProductCategoryPage document */
  upsert?: InputMaybe<ProductCategoryPageUpsertWithNestedWhereUniqueInput>;
};

export type ProductCategoryPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ProductCategoryPageUpdateInput;
  /** Unique document search */
  where: ProductCategoryPageWhereUniqueInput;
};

export type ProductCategoryPageUpsertInput = {
  /** Create document if it didn't exist */
  create: ProductCategoryPageCreateInput;
  /** Update document if it exists */
  update: ProductCategoryPageUpdateInput;
};

export type ProductCategoryPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ProductCategoryPageUpsertInput;
  /** Unique document search */
  where: ProductCategoryPageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ProductCategoryPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ProductCategoryPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductCategoryPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductCategoryPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductCategoryPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundIngredientImage?: InputMaybe<AssetWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaryItem?: InputMaybe<DictionaryItemWhereInput>;
  documentInStages_every?: InputMaybe<ProductCategoryPageWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductCategoryPageWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductCategoryPageWhereStageInput>;
  foregroundIngredientImage?: InputMaybe<AssetWhereInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introText?: InputMaybe<IntroTextWhereInput>;
  keyImage?: InputMaybe<AssetWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<ProductCategoryPagePageComponentsWhereInput>;
  productBanner?: InputMaybe<ProductBannerWhereInput>;
  productCategories_every?: InputMaybe<ProductCategoryWhereInput>;
  productCategories_none?: InputMaybe<ProductCategoryWhereInput>;
  productCategories_some?: InputMaybe<ProductCategoryWhereInput>;
  productCategoryName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productCategoryName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productCategoryName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productCategoryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productCategoryName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productCategoryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productCategoryName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productCategoryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productCategoryName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productCategoryName_starts_with?: InputMaybe<Scalars['String']['input']>;
  productCategory_every?: InputMaybe<ProductCategoryWhereInput>;
  productCategory_none?: InputMaybe<ProductCategoryWhereInput>;
  productCategory_some?: InputMaybe<ProductCategoryWhereInput>;
  productGridTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productGridTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productGridTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productGridTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productGridTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productGridTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productGridTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productGridTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productGridTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productGridTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategorySuper?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productSubcategorySuper_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productSubcategorySuper_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productSubcategorySuper_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productSubcategorySuper_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productSubcategorySuper_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productSubcategorySuper_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productSubcategorySuper_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productSubcategorySuper_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productSubcategorySuper_starts_with?: InputMaybe<Scalars['String']['input']>;
  productSubcategoryTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productSubcategoryTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productSubcategoryTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productSubcategoryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productSubcategoryTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productSubcategoryTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productSubcategoryTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productSubcategoryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productSubcategoryTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productSubcategoryTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  promoImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ProductCategoryPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductCategoryPageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductCategoryPageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductCategoryPageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ProductCategoryPageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ProductCategoryPage record uniquely */
export type ProductCategoryPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductCategoryUpdateInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  cl3bhkqqb2cef01z2bgem5soi?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  cl52bg7jy24ug01t82w15hd8w?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  market?: InputMaybe<Scalars['String']['input']>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  marketSlug?: InputMaybe<Scalars['String']['input']>;
  parentCategory?: InputMaybe<ProductCategoryUpdateOneInlineInput>;
  productCategoryPage?: InputMaybe<ProductCategoryPageUpdateOneInlineInput>;
  productSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpdateOneInlineInput>;
  products?: InputMaybe<ProductUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subcategories?: InputMaybe<ProductCategoryUpdateManyInlineInput>;
  subcategoryPage?: InputMaybe<ProductSubcategoryPageUpdateOneInlineInput>;
};

export type ProductCategoryUpdateManyInlineInput = {
  /** Connect multiple existing ProductCategory documents */
  connect?: InputMaybe<Array<ProductCategoryConnectInput>>;
  /** Create and connect multiple ProductCategory documents */
  create?: InputMaybe<Array<ProductCategoryCreateInput>>;
  /** Delete multiple ProductCategory documents */
  delete?: InputMaybe<Array<ProductCategoryWhereUniqueInput>>;
  /** Disconnect multiple ProductCategory documents */
  disconnect?: InputMaybe<Array<ProductCategoryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ProductCategory documents */
  set?: InputMaybe<Array<ProductCategoryWhereUniqueInput>>;
  /** Update multiple ProductCategory documents */
  update?: InputMaybe<Array<ProductCategoryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ProductCategory documents */
  upsert?: InputMaybe<Array<ProductCategoryUpsertWithNestedWhereUniqueInput>>;
};

export type ProductCategoryUpdateManyInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ProductCategoryUpdateManyInput;
  /** Document search */
  where: ProductCategoryWhereInput;
};

export type ProductCategoryUpdateOneInlineInput = {
  /** Connect existing ProductCategory document */
  connect?: InputMaybe<ProductCategoryWhereUniqueInput>;
  /** Create and connect one ProductCategory document */
  create?: InputMaybe<ProductCategoryCreateInput>;
  /** Delete currently connected ProductCategory document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ProductCategory document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ProductCategory document */
  update?: InputMaybe<ProductCategoryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProductCategory document */
  upsert?: InputMaybe<ProductCategoryUpsertWithNestedWhereUniqueInput>;
};

export type ProductCategoryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ProductCategoryUpdateInput;
  /** Unique document search */
  where: ProductCategoryWhereUniqueInput;
};

export type ProductCategoryUpsertInput = {
  /** Create document if it didn't exist */
  create: ProductCategoryCreateInput;
  /** Update document if it exists */
  update: ProductCategoryUpdateInput;
};

export type ProductCategoryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ProductCategoryUpsertInput;
  /** Unique document search */
  where: ProductCategoryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ProductCategoryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ProductCategoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  categoryId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  categoryId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  categoryId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  categoryId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  categoryId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  categoryId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  categoryId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  categoryId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  categoryId_starts_with?: InputMaybe<Scalars['String']['input']>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  categoryName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  categoryName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  categoryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  categoryName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  categoryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  categoryName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  categoryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  categoryName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  categoryName_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ProductCategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductCategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductCategoryWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  marketName?: InputMaybe<MarketWhereInput>;
  marketSlug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  marketSlug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  marketSlug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  marketSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  marketSlug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  marketSlug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  marketSlug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  marketSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  marketSlug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  marketSlug_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  market_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  market_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  market_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  market_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  market_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  market_starts_with?: InputMaybe<Scalars['String']['input']>;
  parentCategory?: InputMaybe<ProductCategoryWhereInput>;
  productCategoryPage?: InputMaybe<ProductCategoryPageWhereInput>;
  productSubcategoryPage?: InputMaybe<ProductSubcategoryPageWhereInput>;
  products_every?: InputMaybe<ProductWhereInput>;
  products_none?: InputMaybe<ProductWhereInput>;
  products_some?: InputMaybe<ProductWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  subcategories_every?: InputMaybe<ProductCategoryWhereInput>;
  subcategories_none?: InputMaybe<ProductCategoryWhereInput>;
  subcategories_some?: InputMaybe<ProductCategoryWhereInput>;
  subcategoryPage?: InputMaybe<ProductSubcategoryPageWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ProductCategoryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductCategoryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductCategoryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductCategoryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ProductCategoryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ProductCategory record uniquely */
export type ProductCategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  marketSlug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ProductWhereUniqueInput;
};

/** A connection to a list of items. */
export type ProductConnection = {
  __typename?: 'ProductConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ProductEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ProductCreateInput = {
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  categories?: InputMaybe<ProductCategoryCreateManyInlineInput>;
  ckwaqzt7o2k0m01w3h369ggpu?: InputMaybe<GenericCardCarouseComponentCreateManyInlineInput>;
  cookingTips?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionary?: InputMaybe<DictionaryCreateOneInlineInput>;
  fillingQuantity?: InputMaybe<Scalars['String']['input']>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  ingredients?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedInPim?: InputMaybe<Scalars['String']['input']>;
  lifestyleImage?: InputMaybe<AssetCreateOneInlineInput>;
  market?: InputMaybe<Scalars['String']['input']>;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  marketSlugId?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeywords?: InputMaybe<Scalars['String']['input']>;
  nutriScore?: InputMaybe<Scalars['String']['input']>;
  nutrientInformation?: InputMaybe<Scalars['String']['input']>;
  packagingInformation?: InputMaybe<Scalars['String']['input']>;
  preparationInstructions?: InputMaybe<Scalars['String']['input']>;
  productBanner?: InputMaybe<ProductBannerCreateManyInlineInput>;
  productDescription: Scalars['String']['input'];
  productDietList?: InputMaybe<Array<Scalars['String']['input']>>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productImage?: InputMaybe<AssetCreateOneInlineInput>;
  productLabels?: InputMaybe<ProductLabelCreateManyInlineInput>;
  productPageURL?: InputMaybe<Scalars['String']['input']>;
  productTitle: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductCreateManyInlineInput = {
  /** Connect multiple existing Product documents */
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  /** Create and connect multiple existing Product documents */
  create?: InputMaybe<Array<ProductCreateInput>>;
};

export type ProductCreateOneInlineInput = {
  /** Connect one existing Product document */
  connect?: InputMaybe<ProductWhereUniqueInput>;
  /** Create and connect one Product document */
  create?: InputMaybe<ProductCreateInput>;
};

/** A global product template for configuring non PIM product data. */
export type ProductDetailPage = Entity & Node & {
  __typename?: 'ProductDetailPage';
  /** This title is not displayed on the website; it is only used to identify this item within CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<ProductDetailPage>;
  /** List of ProductDetailPage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  isActiveIngredients: Scalars['Boolean']['output'];
  isActiveNutrition: Scalars['Boolean']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** Nutri Score popup appears once user click on Learn more link next to Nutri Score image */
  nutriScorePopupDescription?: Maybe<RichText>;
  /** Nutri Score popup appears once user click on Learn more link next to Nutri Score image */
  nutriScorePopupTitle?: Maybe<Scalars['String']['output']>;
  /** Product Hero Assets */
  productHero?: Maybe<ProductHero>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  teaserPlaceholders: Array<TeaserPlaceholder>;
  teaserSmallPlaceholders: Array<TeaserSmallPlaceholder>;
  /** Titles for all the section on the product page. This data is not part of the imported PIM Product. */
  titles?: Maybe<Dictionary>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** A global product template for configuring non PIM product data. */
export type ProductDetailPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A global product template for configuring non PIM product data. */
export type ProductDetailPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** A global product template for configuring non PIM product data. */
export type ProductDetailPageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** A global product template for configuring non PIM product data. */
export type ProductDetailPageMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A global product template for configuring non PIM product data. */
export type ProductDetailPageProductHeroArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A global product template for configuring non PIM product data. */
export type ProductDetailPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A global product template for configuring non PIM product data. */
export type ProductDetailPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** A global product template for configuring non PIM product data. */
export type ProductDetailPageTeaserPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserPlaceholderWhereInput>;
};


/** A global product template for configuring non PIM product data. */
export type ProductDetailPageTeaserSmallPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
};


/** A global product template for configuring non PIM product data. */
export type ProductDetailPageTitlesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A global product template for configuring non PIM product data. */
export type ProductDetailPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductDetailPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ProductDetailPageWhereUniqueInput;
};

/** A connection to a list of items. */
export type ProductDetailPageConnection = {
  __typename?: 'ProductDetailPageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ProductDetailPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ProductDetailPageCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  isActiveIngredients: Scalars['Boolean']['input'];
  isActiveNutrition: Scalars['Boolean']['input'];
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  nutriScorePopupDescription?: InputMaybe<Scalars['RichTextAST']['input']>;
  nutriScorePopupTitle?: InputMaybe<Scalars['String']['input']>;
  productHero?: InputMaybe<ProductHeroCreateOneInlineInput>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderCreateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderCreateManyInlineInput>;
  titles?: InputMaybe<DictionaryCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductDetailPageCreateManyInlineInput = {
  /** Connect multiple existing ProductDetailPage documents */
  connect?: InputMaybe<Array<ProductDetailPageWhereUniqueInput>>;
  /** Create and connect multiple existing ProductDetailPage documents */
  create?: InputMaybe<Array<ProductDetailPageCreateInput>>;
};

export type ProductDetailPageCreateOneInlineInput = {
  /** Connect one existing ProductDetailPage document */
  connect?: InputMaybe<ProductDetailPageWhereUniqueInput>;
  /** Create and connect one ProductDetailPage document */
  create?: InputMaybe<ProductDetailPageCreateInput>;
};

/** An edge in a connection. */
export type ProductDetailPageEdge = {
  __typename?: 'ProductDetailPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductDetailPage;
};

/** Identifies documents */
export type ProductDetailPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductDetailPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductDetailPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductDetailPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ProductDetailPageWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductDetailPageWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductDetailPageWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActiveIngredients?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActiveIngredients_not?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNutrition?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActiveNutrition_not?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  nutriScorePopupTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  nutriScorePopupTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  nutriScorePopupTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  nutriScorePopupTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  nutriScorePopupTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  nutriScorePopupTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  nutriScorePopupTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  nutriScorePopupTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  nutriScorePopupTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  nutriScorePopupTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  productHero?: InputMaybe<ProductHeroWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  titles?: InputMaybe<DictionaryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ProductDetailPageOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isActiveIngredients_ASC = 'isActiveIngredients_ASC',
  isActiveIngredients_DESC = 'isActiveIngredients_DESC',
  isActiveNutrition_ASC = 'isActiveNutrition_ASC',
  isActiveNutrition_DESC = 'isActiveNutrition_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  nutriScorePopupTitle_ASC = 'nutriScorePopupTitle_ASC',
  nutriScorePopupTitle_DESC = 'nutriScorePopupTitle_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ProductDetailPageUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  isActiveIngredients?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNutrition?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  nutriScorePopupDescription?: InputMaybe<Scalars['RichTextAST']['input']>;
  nutriScorePopupTitle?: InputMaybe<Scalars['String']['input']>;
  productHero?: InputMaybe<ProductHeroUpdateOneInlineInput>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderUpdateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderUpdateManyInlineInput>;
  titles?: InputMaybe<DictionaryUpdateOneInlineInput>;
};

export type ProductDetailPageUpdateManyInlineInput = {
  /** Connect multiple existing ProductDetailPage documents */
  connect?: InputMaybe<Array<ProductDetailPageConnectInput>>;
  /** Create and connect multiple ProductDetailPage documents */
  create?: InputMaybe<Array<ProductDetailPageCreateInput>>;
  /** Delete multiple ProductDetailPage documents */
  delete?: InputMaybe<Array<ProductDetailPageWhereUniqueInput>>;
  /** Disconnect multiple ProductDetailPage documents */
  disconnect?: InputMaybe<Array<ProductDetailPageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ProductDetailPage documents */
  set?: InputMaybe<Array<ProductDetailPageWhereUniqueInput>>;
  /** Update multiple ProductDetailPage documents */
  update?: InputMaybe<Array<ProductDetailPageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ProductDetailPage documents */
  upsert?: InputMaybe<Array<ProductDetailPageUpsertWithNestedWhereUniqueInput>>;
};

export type ProductDetailPageUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  isActiveIngredients?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNutrition?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  nutriScorePopupDescription?: InputMaybe<Scalars['RichTextAST']['input']>;
  nutriScorePopupTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ProductDetailPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ProductDetailPageUpdateManyInput;
  /** Document search */
  where: ProductDetailPageWhereInput;
};

export type ProductDetailPageUpdateOneInlineInput = {
  /** Connect existing ProductDetailPage document */
  connect?: InputMaybe<ProductDetailPageWhereUniqueInput>;
  /** Create and connect one ProductDetailPage document */
  create?: InputMaybe<ProductDetailPageCreateInput>;
  /** Delete currently connected ProductDetailPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ProductDetailPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ProductDetailPage document */
  update?: InputMaybe<ProductDetailPageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProductDetailPage document */
  upsert?: InputMaybe<ProductDetailPageUpsertWithNestedWhereUniqueInput>;
};

export type ProductDetailPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ProductDetailPageUpdateInput;
  /** Unique document search */
  where: ProductDetailPageWhereUniqueInput;
};

export type ProductDetailPageUpsertInput = {
  /** Create document if it didn't exist */
  create: ProductDetailPageCreateInput;
  /** Update document if it exists */
  update: ProductDetailPageUpdateInput;
};

export type ProductDetailPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ProductDetailPageUpsertInput;
  /** Unique document search */
  where: ProductDetailPageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ProductDetailPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ProductDetailPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductDetailPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductDetailPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductDetailPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ProductDetailPageWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductDetailPageWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductDetailPageWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActiveIngredients?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActiveIngredients_not?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNutrition?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActiveNutrition_not?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  nutriScorePopupTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  nutriScorePopupTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  nutriScorePopupTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  nutriScorePopupTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  nutriScorePopupTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  nutriScorePopupTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  nutriScorePopupTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  nutriScorePopupTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  nutriScorePopupTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  nutriScorePopupTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  productHero?: InputMaybe<ProductHeroWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  titles?: InputMaybe<DictionaryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ProductDetailPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductDetailPageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductDetailPageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductDetailPageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ProductDetailPageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ProductDetailPage record uniquely */
export type ProductDetailPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** An edge in a connection. */
export type ProductEdge = {
  __typename?: 'ProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Product;
};

export type ProductHero = Entity & Node & {
  __typename?: 'ProductHero';
  anchorNav?: Maybe<AnchorNavigation>;
  /** Background Image for hero blob. Please note, the supplied image should be more or less square. */
  blobBackgroundTexture?: Maybe<AssetComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<ProductHero>;
  /** List of ProductHero versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Background Image for hero cooking tip section. Please note, the supplied image should be more or less square. */
  tipSectionBackground?: Maybe<AssetComponent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ProductHeroAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductHeroBlobBackgroundTextureArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductHeroCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductHeroDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ProductHeroHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ProductHeroMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductHeroPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductHeroScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ProductHeroTipSectionBackgroundArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductHeroUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductHeroConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ProductHeroWhereUniqueInput;
};

/** A connection to a list of items. */
export type ProductHeroConnection = {
  __typename?: 'ProductHeroConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ProductHeroEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ProductHeroCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  blobBackgroundTexture?: InputMaybe<AssetComponentCreateOneInlineInput>;
  cktieiwlv4j6r01xq7au58c1p?: InputMaybe<ProductDetailPageCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  tipSectionBackground?: InputMaybe<AssetComponentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductHeroCreateManyInlineInput = {
  /** Connect multiple existing ProductHero documents */
  connect?: InputMaybe<Array<ProductHeroWhereUniqueInput>>;
  /** Create and connect multiple existing ProductHero documents */
  create?: InputMaybe<Array<ProductHeroCreateInput>>;
};

export type ProductHeroCreateOneInlineInput = {
  /** Connect one existing ProductHero document */
  connect?: InputMaybe<ProductHeroWhereUniqueInput>;
  /** Create and connect one ProductHero document */
  create?: InputMaybe<ProductHeroCreateInput>;
};

/** An edge in a connection. */
export type ProductHeroEdge = {
  __typename?: 'ProductHeroEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductHero;
};

/** Identifies documents */
export type ProductHeroManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductHeroWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductHeroWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductHeroWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  blobBackgroundTexture?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ProductHeroWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductHeroWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductHeroWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tipSectionBackground?: InputMaybe<AssetComponentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ProductHeroOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ProductHeroUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  blobBackgroundTexture?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  cktieiwlv4j6r01xq7au58c1p?: InputMaybe<ProductDetailPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  tipSectionBackground?: InputMaybe<AssetComponentUpdateOneInlineInput>;
};

export type ProductHeroUpdateManyInlineInput = {
  /** Connect multiple existing ProductHero documents */
  connect?: InputMaybe<Array<ProductHeroConnectInput>>;
  /** Create and connect multiple ProductHero documents */
  create?: InputMaybe<Array<ProductHeroCreateInput>>;
  /** Delete multiple ProductHero documents */
  delete?: InputMaybe<Array<ProductHeroWhereUniqueInput>>;
  /** Disconnect multiple ProductHero documents */
  disconnect?: InputMaybe<Array<ProductHeroWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ProductHero documents */
  set?: InputMaybe<Array<ProductHeroWhereUniqueInput>>;
  /** Update multiple ProductHero documents */
  update?: InputMaybe<Array<ProductHeroUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ProductHero documents */
  upsert?: InputMaybe<Array<ProductHeroUpsertWithNestedWhereUniqueInput>>;
};

export type ProductHeroUpdateManyInput = {
  market?: InputMaybe<Markets>;
};

export type ProductHeroUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ProductHeroUpdateManyInput;
  /** Document search */
  where: ProductHeroWhereInput;
};

export type ProductHeroUpdateOneInlineInput = {
  /** Connect existing ProductHero document */
  connect?: InputMaybe<ProductHeroWhereUniqueInput>;
  /** Create and connect one ProductHero document */
  create?: InputMaybe<ProductHeroCreateInput>;
  /** Delete currently connected ProductHero document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ProductHero document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ProductHero document */
  update?: InputMaybe<ProductHeroUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProductHero document */
  upsert?: InputMaybe<ProductHeroUpsertWithNestedWhereUniqueInput>;
};

export type ProductHeroUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ProductHeroUpdateInput;
  /** Unique document search */
  where: ProductHeroWhereUniqueInput;
};

export type ProductHeroUpsertInput = {
  /** Create document if it didn't exist */
  create: ProductHeroCreateInput;
  /** Update document if it exists */
  update: ProductHeroUpdateInput;
};

export type ProductHeroUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ProductHeroUpsertInput;
  /** Unique document search */
  where: ProductHeroWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ProductHeroWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ProductHeroWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductHeroWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductHeroWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductHeroWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  blobBackgroundTexture?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ProductHeroWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductHeroWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductHeroWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tipSectionBackground?: InputMaybe<AssetComponentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ProductHeroWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductHeroWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductHeroWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductHeroWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ProductHeroWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ProductHero record uniquely */
export type ProductHeroWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductLabel = Entity & Node & {
  __typename?: 'ProductLabel';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<ProductLabel>;
  /** List of ProductLabel versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  translations?: Maybe<DictionaryItem>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ProductLabelCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductLabelDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ProductLabelHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ProductLabelPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductLabelScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ProductLabelTranslationsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductLabelUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductLabelConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ProductLabelWhereUniqueInput;
};

/** A connection to a list of items. */
export type ProductLabelConnection = {
  __typename?: 'ProductLabelConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ProductLabelEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ProductLabelCreateInput = {
  clu71ti3r00ks07un7cs7bf76?: InputMaybe<ProductCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  identifier: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  translations?: InputMaybe<DictionaryItemCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductLabelCreateManyInlineInput = {
  /** Connect multiple existing ProductLabel documents */
  connect?: InputMaybe<Array<ProductLabelWhereUniqueInput>>;
  /** Create and connect multiple existing ProductLabel documents */
  create?: InputMaybe<Array<ProductLabelCreateInput>>;
};

export type ProductLabelCreateOneInlineInput = {
  /** Connect one existing ProductLabel document */
  connect?: InputMaybe<ProductLabelWhereUniqueInput>;
  /** Create and connect one ProductLabel document */
  create?: InputMaybe<ProductLabelCreateInput>;
};

/** An edge in a connection. */
export type ProductLabelEdge = {
  __typename?: 'ProductLabelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductLabel;
};

/** Identifies documents */
export type ProductLabelManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductLabelWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductLabelWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductLabelWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ProductLabelWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductLabelWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductLabelWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  identifier_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  identifier_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  identifier_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  identifier_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  identifier_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  identifier_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  identifier_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  identifier_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  identifier_starts_with?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  imageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  imageUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  imageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  imageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  imageUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  imageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  imageUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  imageUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  translations?: InputMaybe<DictionaryItemWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ProductLabelOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  identifier_ASC = 'identifier_ASC',
  identifier_DESC = 'identifier_DESC',
  imageUrl_ASC = 'imageUrl_ASC',
  imageUrl_DESC = 'imageUrl_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ProductLabelUpdateInput = {
  clu71ti3r00ks07un7cs7bf76?: InputMaybe<ProductUpdateManyInlineInput>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<DictionaryItemUpdateOneInlineInput>;
};

export type ProductLabelUpdateManyInlineInput = {
  /** Connect multiple existing ProductLabel documents */
  connect?: InputMaybe<Array<ProductLabelConnectInput>>;
  /** Create and connect multiple ProductLabel documents */
  create?: InputMaybe<Array<ProductLabelCreateInput>>;
  /** Delete multiple ProductLabel documents */
  delete?: InputMaybe<Array<ProductLabelWhereUniqueInput>>;
  /** Disconnect multiple ProductLabel documents */
  disconnect?: InputMaybe<Array<ProductLabelWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ProductLabel documents */
  set?: InputMaybe<Array<ProductLabelWhereUniqueInput>>;
  /** Update multiple ProductLabel documents */
  update?: InputMaybe<Array<ProductLabelUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ProductLabel documents */
  upsert?: InputMaybe<Array<ProductLabelUpsertWithNestedWhereUniqueInput>>;
};

export type ProductLabelUpdateManyInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ProductLabelUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ProductLabelUpdateManyInput;
  /** Document search */
  where: ProductLabelWhereInput;
};

export type ProductLabelUpdateOneInlineInput = {
  /** Connect existing ProductLabel document */
  connect?: InputMaybe<ProductLabelWhereUniqueInput>;
  /** Create and connect one ProductLabel document */
  create?: InputMaybe<ProductLabelCreateInput>;
  /** Delete currently connected ProductLabel document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ProductLabel document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ProductLabel document */
  update?: InputMaybe<ProductLabelUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProductLabel document */
  upsert?: InputMaybe<ProductLabelUpsertWithNestedWhereUniqueInput>;
};

export type ProductLabelUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ProductLabelUpdateInput;
  /** Unique document search */
  where: ProductLabelWhereUniqueInput;
};

export type ProductLabelUpsertInput = {
  /** Create document if it didn't exist */
  create: ProductLabelCreateInput;
  /** Update document if it exists */
  update: ProductLabelUpdateInput;
};

export type ProductLabelUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ProductLabelUpsertInput;
  /** Unique document search */
  where: ProductLabelWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ProductLabelWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ProductLabelWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductLabelWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductLabelWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductLabelWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ProductLabelWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductLabelWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductLabelWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  identifier_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  identifier_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  identifier_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  identifier_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  identifier_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  identifier_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  identifier_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  identifier_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  identifier_starts_with?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  imageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  imageUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  imageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  imageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  imageUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  imageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  imageUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  imageUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  translations?: InputMaybe<DictionaryItemWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ProductLabelWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductLabelWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductLabelWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductLabelWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ProductLabelWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ProductLabel record uniquely */
export type ProductLabelWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};

/** Product landing page made up product category pages */
export type ProductLandingPage = Entity & Node & {
  __typename?: 'ProductLandingPage';
  anchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Used for filtering and searching inside of the CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<ProductLandingPage>;
  featuredContent?: Maybe<FeaturedContent>;
  genericCardCarouselComponent?: Maybe<GenericCardCarouseComponent>;
  heroComponent?: Maybe<HeroComponent>;
  /** List of ProductLandingPage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  introText?: Maybe<IntroText>;
  link?: Maybe<Link>;
  links: Array<Link>;
  market: Markets;
  marketName?: Maybe<Market>;
  metaData?: Maybe<MetaData>;
  /** No more than 50 components */
  pageComponents: Array<ProductLandingPagePageComponents>;
  /** Product Category Pages to be referenced on the product landing page */
  productCategoryPages: Array<ProductCategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** URL Slug for the product landing page */
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  teaserPlaceholders: Array<TeaserPlaceholder>;
  teaserSmallPlaceholders: Array<TeaserSmallPlaceholder>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Product landing page made up product category pages */
export type ProductLandingPageAnchorNavigationListArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Product landing page made up product category pages */
export type ProductLandingPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Product landing page made up product category pages */
export type ProductLandingPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Product landing page made up product category pages */
export type ProductLandingPageFeaturedContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Product landing page made up product category pages */
export type ProductLandingPageGenericCardCarouselComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Product landing page made up product category pages */
export type ProductLandingPageHeroComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Product landing page made up product category pages */
export type ProductLandingPageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Product landing page made up product category pages */
export type ProductLandingPageIntroTextArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Product landing page made up product category pages */
export type ProductLandingPageLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Product landing page made up product category pages */
export type ProductLandingPageLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


/** Product landing page made up product category pages */
export type ProductLandingPageMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Product landing page made up product category pages */
export type ProductLandingPageMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Product landing page made up product category pages */
export type ProductLandingPagePageComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Product landing page made up product category pages */
export type ProductLandingPageProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


/** Product landing page made up product category pages */
export type ProductLandingPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Product landing page made up product category pages */
export type ProductLandingPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Product landing page made up product category pages */
export type ProductLandingPageTeaserPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserPlaceholderWhereInput>;
};


/** Product landing page made up product category pages */
export type ProductLandingPageTeaserSmallPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
};


/** Product landing page made up product category pages */
export type ProductLandingPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductLandingPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ProductLandingPageWhereUniqueInput;
};

/** A connection to a list of items. */
export type ProductLandingPageConnection = {
  __typename?: 'ProductLandingPageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ProductLandingPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ProductLandingPageCreateInput = {
  anchorNavigationList?: InputMaybe<AnchorNavigationListCreateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  featuredContent?: InputMaybe<FeaturedContentCreateOneInlineInput>;
  genericCardCarouselComponent?: InputMaybe<GenericCardCarouseComponentCreateOneInlineInput>;
  heroComponent?: InputMaybe<HeroComponentCreateOneInlineInput>;
  introText?: InputMaybe<IntroTextCreateOneInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  links?: InputMaybe<LinkCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  metaData?: InputMaybe<MetaDataCreateOneInlineInput>;
  pageComponents?: InputMaybe<ProductLandingPagePageComponentsCreateManyInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderCreateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductLandingPageCreateManyInlineInput = {
  /** Connect multiple existing ProductLandingPage documents */
  connect?: InputMaybe<Array<ProductLandingPageWhereUniqueInput>>;
  /** Create and connect multiple existing ProductLandingPage documents */
  create?: InputMaybe<Array<ProductLandingPageCreateInput>>;
};

export type ProductLandingPageCreateOneInlineInput = {
  /** Connect one existing ProductLandingPage document */
  connect?: InputMaybe<ProductLandingPageWhereUniqueInput>;
  /** Create and connect one ProductLandingPage document */
  create?: InputMaybe<ProductLandingPageCreateInput>;
};

/** An edge in a connection. */
export type ProductLandingPageEdge = {
  __typename?: 'ProductLandingPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductLandingPage;
};

/** Identifies documents */
export type ProductLandingPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductLandingPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductLandingPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductLandingPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNavigationList?: InputMaybe<AnchorNavigationListWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ProductLandingPageWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductLandingPageWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductLandingPageWhereStageInput>;
  featuredContent?: InputMaybe<FeaturedContentWhereInput>;
  genericCardCarouselComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  heroComponent?: InputMaybe<HeroComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introText?: InputMaybe<IntroTextWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<ProductLandingPagePageComponentsWhereInput>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ProductLandingPageOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ProductLandingPagePageComponents = Accordion | Banner1 | Banner2 | Banner2CarouselComponent | CarouselComponent | DownloadApp | DynamicCardGrid | FeaturedContent | GenericAccordion | GenericCardCarouseComponent | GenericDownloadComponent | GenericFollowUs | GenericGridAuthorable | GenericHtml | GlobalSearch | HeroCarouselComponent | Iframe | LongText | ProductBanner | Spacer;

export type ProductLandingPagePageComponentsConnectInput = {
  Accordion?: InputMaybe<AccordionConnectInput>;
  Banner1?: InputMaybe<Banner1ConnectInput>;
  Banner2?: InputMaybe<Banner2ConnectInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentConnectInput>;
  CarouselComponent?: InputMaybe<CarouselComponentConnectInput>;
  DownloadApp?: InputMaybe<DownloadAppConnectInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridConnectInput>;
  FeaturedContent?: InputMaybe<FeaturedContentConnectInput>;
  GenericAccordion?: InputMaybe<GenericAccordionConnectInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentConnectInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentConnectInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsConnectInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableConnectInput>;
  GenericHtml?: InputMaybe<GenericHtmlConnectInput>;
  GlobalSearch?: InputMaybe<GlobalSearchConnectInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentConnectInput>;
  Iframe?: InputMaybe<IframeConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
  ProductBanner?: InputMaybe<ProductBannerConnectInput>;
  Spacer?: InputMaybe<SpacerConnectInput>;
};

export type ProductLandingPagePageComponentsCreateInput = {
  Accordion?: InputMaybe<AccordionCreateInput>;
  Banner1?: InputMaybe<Banner1CreateInput>;
  Banner2?: InputMaybe<Banner2CreateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentCreateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentCreateInput>;
  DownloadApp?: InputMaybe<DownloadAppCreateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridCreateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentCreateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionCreateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentCreateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsCreateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableCreateInput>;
  GenericHtml?: InputMaybe<GenericHtmlCreateInput>;
  GlobalSearch?: InputMaybe<GlobalSearchCreateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateInput>;
  Iframe?: InputMaybe<IframeCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
  ProductBanner?: InputMaybe<ProductBannerCreateInput>;
  Spacer?: InputMaybe<SpacerCreateInput>;
};

export type ProductLandingPagePageComponentsCreateManyInlineInput = {
  /** Connect multiple existing ProductLandingPagePageComponents documents */
  connect?: InputMaybe<Array<ProductLandingPagePageComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing ProductLandingPagePageComponents documents */
  create?: InputMaybe<Array<ProductLandingPagePageComponentsCreateInput>>;
};

export type ProductLandingPagePageComponentsCreateOneInlineInput = {
  /** Connect one existing ProductLandingPagePageComponents document */
  connect?: InputMaybe<ProductLandingPagePageComponentsWhereUniqueInput>;
  /** Create and connect one ProductLandingPagePageComponents document */
  create?: InputMaybe<ProductLandingPagePageComponentsCreateInput>;
};

export type ProductLandingPagePageComponentsUpdateInput = {
  Accordion?: InputMaybe<AccordionUpdateInput>;
  Banner1?: InputMaybe<Banner1UpdateInput>;
  Banner2?: InputMaybe<Banner2UpdateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateInput>;
  Iframe?: InputMaybe<IframeUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateInput>;
  Spacer?: InputMaybe<SpacerUpdateInput>;
};

export type ProductLandingPagePageComponentsUpdateManyInlineInput = {
  /** Connect multiple existing ProductLandingPagePageComponents documents */
  connect?: InputMaybe<Array<ProductLandingPagePageComponentsConnectInput>>;
  /** Create and connect multiple ProductLandingPagePageComponents documents */
  create?: InputMaybe<Array<ProductLandingPagePageComponentsCreateInput>>;
  /** Delete multiple ProductLandingPagePageComponents documents */
  delete?: InputMaybe<Array<ProductLandingPagePageComponentsWhereUniqueInput>>;
  /** Disconnect multiple ProductLandingPagePageComponents documents */
  disconnect?: InputMaybe<Array<ProductLandingPagePageComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ProductLandingPagePageComponents documents */
  set?: InputMaybe<Array<ProductLandingPagePageComponentsWhereUniqueInput>>;
  /** Update multiple ProductLandingPagePageComponents documents */
  update?: InputMaybe<Array<ProductLandingPagePageComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ProductLandingPagePageComponents documents */
  upsert?: InputMaybe<Array<ProductLandingPagePageComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type ProductLandingPagePageComponentsUpdateManyWithNestedWhereInput = {
  Accordion?: InputMaybe<AccordionUpdateManyWithNestedWhereInput>;
  Banner1?: InputMaybe<Banner1UpdateManyWithNestedWhereInput>;
  Banner2?: InputMaybe<Banner2UpdateManyWithNestedWhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateManyWithNestedWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateManyWithNestedWhereInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateManyWithNestedWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateManyWithNestedWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateManyWithNestedWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateManyWithNestedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateManyWithNestedWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateManyWithNestedWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateManyWithNestedWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateManyWithNestedWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateManyWithNestedWhereInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateManyWithNestedWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateManyWithNestedWhereInput>;
  Iframe?: InputMaybe<IframeUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateManyWithNestedWhereInput>;
  Spacer?: InputMaybe<SpacerUpdateManyWithNestedWhereInput>;
};

export type ProductLandingPagePageComponentsUpdateOneInlineInput = {
  /** Connect existing ProductLandingPagePageComponents document */
  connect?: InputMaybe<ProductLandingPagePageComponentsWhereUniqueInput>;
  /** Create and connect one ProductLandingPagePageComponents document */
  create?: InputMaybe<ProductLandingPagePageComponentsCreateInput>;
  /** Delete currently connected ProductLandingPagePageComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ProductLandingPagePageComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ProductLandingPagePageComponents document */
  update?: InputMaybe<ProductLandingPagePageComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProductLandingPagePageComponents document */
  upsert?: InputMaybe<ProductLandingPagePageComponentsUpsertWithNestedWhereUniqueInput>;
};

export type ProductLandingPagePageComponentsUpdateWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpdateWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpdateWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpdateWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateWithNestedWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateWithNestedWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpdateWithNestedWhereUniqueInput>;
};

export type ProductLandingPagePageComponentsUpsertWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpsertWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpsertWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpsertWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpsertWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpsertWithNestedWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppUpsertWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpsertWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpsertWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpsertWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpsertWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpsertWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpsertWithNestedWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpsertWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpsertWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpsertWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpsertWithNestedWhereUniqueInput>;
};

export type ProductLandingPagePageComponentsWhereInput = {
  Accordion?: InputMaybe<AccordionWhereInput>;
  Banner1?: InputMaybe<Banner1WhereInput>;
  Banner2?: InputMaybe<Banner2WhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  DownloadApp?: InputMaybe<DownloadAppWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereInput>;
  GlobalSearch?: InputMaybe<GlobalSearchWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  Iframe?: InputMaybe<IframeWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereInput>;
  Spacer?: InputMaybe<SpacerWhereInput>;
};

export type ProductLandingPagePageComponentsWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1WhereUniqueInput>;
  Banner2?: InputMaybe<Banner2WhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereUniqueInput>;
  Iframe?: InputMaybe<IframeWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerWhereUniqueInput>;
};

export type ProductLandingPageUpdateInput = {
  anchorNavigationList?: InputMaybe<AnchorNavigationListUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  featuredContent?: InputMaybe<FeaturedContentUpdateOneInlineInput>;
  genericCardCarouselComponent?: InputMaybe<GenericCardCarouseComponentUpdateOneInlineInput>;
  heroComponent?: InputMaybe<HeroComponentUpdateOneInlineInput>;
  introText?: InputMaybe<IntroTextUpdateOneInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  links?: InputMaybe<LinkUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  metaData?: InputMaybe<MetaDataUpdateOneInlineInput>;
  pageComponents?: InputMaybe<ProductLandingPagePageComponentsUpdateManyInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderUpdateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderUpdateManyInlineInput>;
};

export type ProductLandingPageUpdateManyInlineInput = {
  /** Connect multiple existing ProductLandingPage documents */
  connect?: InputMaybe<Array<ProductLandingPageConnectInput>>;
  /** Create and connect multiple ProductLandingPage documents */
  create?: InputMaybe<Array<ProductLandingPageCreateInput>>;
  /** Delete multiple ProductLandingPage documents */
  delete?: InputMaybe<Array<ProductLandingPageWhereUniqueInput>>;
  /** Disconnect multiple ProductLandingPage documents */
  disconnect?: InputMaybe<Array<ProductLandingPageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ProductLandingPage documents */
  set?: InputMaybe<Array<ProductLandingPageWhereUniqueInput>>;
  /** Update multiple ProductLandingPage documents */
  update?: InputMaybe<Array<ProductLandingPageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ProductLandingPage documents */
  upsert?: InputMaybe<Array<ProductLandingPageUpsertWithNestedWhereUniqueInput>>;
};

export type ProductLandingPageUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductLandingPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ProductLandingPageUpdateManyInput;
  /** Document search */
  where: ProductLandingPageWhereInput;
};

export type ProductLandingPageUpdateOneInlineInput = {
  /** Connect existing ProductLandingPage document */
  connect?: InputMaybe<ProductLandingPageWhereUniqueInput>;
  /** Create and connect one ProductLandingPage document */
  create?: InputMaybe<ProductLandingPageCreateInput>;
  /** Delete currently connected ProductLandingPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ProductLandingPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ProductLandingPage document */
  update?: InputMaybe<ProductLandingPageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProductLandingPage document */
  upsert?: InputMaybe<ProductLandingPageUpsertWithNestedWhereUniqueInput>;
};

export type ProductLandingPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ProductLandingPageUpdateInput;
  /** Unique document search */
  where: ProductLandingPageWhereUniqueInput;
};

export type ProductLandingPageUpsertInput = {
  /** Create document if it didn't exist */
  create: ProductLandingPageCreateInput;
  /** Update document if it exists */
  update: ProductLandingPageUpdateInput;
};

export type ProductLandingPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ProductLandingPageUpsertInput;
  /** Unique document search */
  where: ProductLandingPageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ProductLandingPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ProductLandingPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductLandingPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductLandingPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductLandingPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNavigationList?: InputMaybe<AnchorNavigationListWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ProductLandingPageWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductLandingPageWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductLandingPageWhereStageInput>;
  featuredContent?: InputMaybe<FeaturedContentWhereInput>;
  genericCardCarouselComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  heroComponent?: InputMaybe<HeroComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introText?: InputMaybe<IntroTextWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<ProductLandingPagePageComponentsWhereInput>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ProductLandingPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductLandingPageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductLandingPageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductLandingPageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ProductLandingPageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ProductLandingPage record uniquely */
export type ProductLandingPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
};

/** Identifies documents */
export type ProductManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  allergens_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  allergens_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  allergens_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  allergens_not?: InputMaybe<Array<Scalars['String']['input']>>;
  categories_every?: InputMaybe<ProductCategoryWhereInput>;
  categories_none?: InputMaybe<ProductCategoryWhereInput>;
  categories_some?: InputMaybe<ProductCategoryWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  cookingTips?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  cookingTips_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  cookingTips_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  cookingTips_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  cookingTips_not?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionary?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<ProductWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductWhereStageInput>;
  fillingQuantity?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fillingQuantity_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fillingQuantity_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fillingQuantity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fillingQuantity_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fillingQuantity_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fillingQuantity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fillingQuantity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fillingQuantity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fillingQuantity_starts_with?: InputMaybe<Scalars['String']['input']>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  gtin_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  gtin_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  gtin_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  gtin_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  gtin_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  gtin_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  gtin_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  gtin_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  gtin_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  ingredients?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ingredients_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ingredients_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ingredients_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ingredients_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ingredients_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ingredients_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ingredients_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ingredients_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ingredients_starts_with?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedInPim?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  lastUpdatedInPim_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  lastUpdatedInPim_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  lastUpdatedInPim_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  lastUpdatedInPim_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  lastUpdatedInPim_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  lastUpdatedInPim_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  lastUpdatedInPim_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  lastUpdatedInPim_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  lastUpdatedInPim_starts_with?: InputMaybe<Scalars['String']['input']>;
  lifestyleImage?: InputMaybe<AssetWhereInput>;
  market?: InputMaybe<Scalars['String']['input']>;
  marketName?: InputMaybe<MarketWhereInput>;
  marketSlugId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  marketSlugId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  marketSlugId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  marketSlugId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  marketSlugId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  marketSlugId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  marketSlugId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  marketSlugId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  marketSlugId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  marketSlugId_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  market_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  market_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  market_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  market_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  market_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  market_starts_with?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  metaDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  metaDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  metaDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  metaDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  metaKeywords?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  metaKeywords_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  metaKeywords_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  metaKeywords_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  metaKeywords_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  metaKeywords_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  metaKeywords_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  metaKeywords_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  metaKeywords_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  metaKeywords_starts_with?: InputMaybe<Scalars['String']['input']>;
  nutriScore?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  nutriScore_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  nutriScore_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  nutriScore_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  nutriScore_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  nutriScore_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  nutriScore_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  nutriScore_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  nutriScore_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  nutriScore_starts_with?: InputMaybe<Scalars['String']['input']>;
  nutrientInformation?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  nutrientInformation_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  nutrientInformation_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  nutrientInformation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  nutrientInformation_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  nutrientInformation_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  nutrientInformation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  nutrientInformation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  nutrientInformation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  nutrientInformation_starts_with?: InputMaybe<Scalars['String']['input']>;
  packagingInformation?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  packagingInformation_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  packagingInformation_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  packagingInformation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  packagingInformation_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  packagingInformation_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  packagingInformation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  packagingInformation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  packagingInformation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  packagingInformation_starts_with?: InputMaybe<Scalars['String']['input']>;
  preparationInstructions?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  preparationInstructions_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  preparationInstructions_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  preparationInstructions_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  preparationInstructions_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  preparationInstructions_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  preparationInstructions_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  preparationInstructions_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  preparationInstructions_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  preparationInstructions_starts_with?: InputMaybe<Scalars['String']['input']>;
  productBanner_every?: InputMaybe<ProductBannerWhereInput>;
  productBanner_none?: InputMaybe<ProductBannerWhereInput>;
  productBanner_some?: InputMaybe<ProductBannerWhereInput>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  productDietList?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  productDietList_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  productDietList_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  productDietList_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  productDietList_not?: InputMaybe<Array<Scalars['String']['input']>>;
  productId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productId_starts_with?: InputMaybe<Scalars['String']['input']>;
  productImage?: InputMaybe<AssetWhereInput>;
  productLabels_every?: InputMaybe<ProductLabelWhereInput>;
  productLabels_none?: InputMaybe<ProductLabelWhereInput>;
  productLabels_some?: InputMaybe<ProductLabelWhereInput>;
  productPageURL?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productPageURL_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productPageURL_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productPageURL_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productPageURL_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productPageURL_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productPageURL_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productPageURL_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productPageURL_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productPageURL_starts_with?: InputMaybe<Scalars['String']['input']>;
  productTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ProductOrderByInput {
  allergens_ASC = 'allergens_ASC',
  allergens_DESC = 'allergens_DESC',
  cookingTips_ASC = 'cookingTips_ASC',
  cookingTips_DESC = 'cookingTips_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fillingQuantity_ASC = 'fillingQuantity_ASC',
  fillingQuantity_DESC = 'fillingQuantity_DESC',
  gtin_ASC = 'gtin_ASC',
  gtin_DESC = 'gtin_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  ingredients_ASC = 'ingredients_ASC',
  ingredients_DESC = 'ingredients_DESC',
  lastUpdatedInPim_ASC = 'lastUpdatedInPim_ASC',
  lastUpdatedInPim_DESC = 'lastUpdatedInPim_DESC',
  marketSlugId_ASC = 'marketSlugId_ASC',
  marketSlugId_DESC = 'marketSlugId_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  metaDescription_ASC = 'metaDescription_ASC',
  metaDescription_DESC = 'metaDescription_DESC',
  metaKeywords_ASC = 'metaKeywords_ASC',
  metaKeywords_DESC = 'metaKeywords_DESC',
  nutriScore_ASC = 'nutriScore_ASC',
  nutriScore_DESC = 'nutriScore_DESC',
  nutrientInformation_ASC = 'nutrientInformation_ASC',
  nutrientInformation_DESC = 'nutrientInformation_DESC',
  packagingInformation_ASC = 'packagingInformation_ASC',
  packagingInformation_DESC = 'packagingInformation_DESC',
  preparationInstructions_ASC = 'preparationInstructions_ASC',
  preparationInstructions_DESC = 'preparationInstructions_DESC',
  productDescription_ASC = 'productDescription_ASC',
  productDescription_DESC = 'productDescription_DESC',
  productDietList_ASC = 'productDietList_ASC',
  productDietList_DESC = 'productDietList_DESC',
  productId_ASC = 'productId_ASC',
  productId_DESC = 'productId_DESC',
  productPageURL_ASC = 'productPageURL_ASC',
  productPageURL_DESC = 'productPageURL_DESC',
  productTitle_ASC = 'productTitle_ASC',
  productTitle_DESC = 'productTitle_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ProductSubcategoryPage = Entity & Node & {
  __typename?: 'ProductSubcategoryPage';
  cmsName?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Used to add the English tracking value to be used in the tracking calls */
  dictionaryItem?: Maybe<DictionaryItem>;
  /** Get the document in other stages */
  documentInStages: Array<ProductSubcategoryPage>;
  heroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** List of ProductSubcategoryPage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  introText?: Maybe<IntroText>;
  /** cut out product packshot shown on categoy page */
  keyImage?: Maybe<AssetComponent>;
  /** Image which shown on sub brand component, on mobiles  */
  keyImageMobile?: Maybe<AssetComponent>;
  link?: Maybe<Link>;
  links: Array<Link>;
  logo?: Maybe<AssetComponent>;
  market: Markets;
  marketName?: Maybe<Market>;
  metaData?: Maybe<MetaData>;
  /** No more than 50 components */
  pageComponents: Array<ProductSubcategoryPagePageComponents>;
  pimProductCategories: Array<ProductCategory>;
  primarySubBrandColor?: Maybe<Color>;
  /** Don't use! OLD! */
  productCategories: Array<ProductCategory>;
  productCategory?: Maybe<ProductCategory>;
  productCategoryPage?: Maybe<ProductCategoryPage>;
  productGridTitle?: Maybe<Scalars['String']['output']>;
  productSubcategoryPage?: Maybe<ProductSubcategoryPage>;
  /** teaser image shown on all products page */
  promoImage?: Maybe<AssetComponent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  secondarySubBrandColor?: Maybe<Color>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** If you select false, page with all products connected to this subcategory will be excluded from robots.txt */
  shouldBeIndexed: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  subBrand?: Maybe<Scalars['Boolean']['output']>;
  /** Super text shown on sub sub component = */
  subSubCategorySuper?: Maybe<Scalars['String']['output']>;
  /** Title shown on sub sub category component */
  subSubCategoryTitle?: Maybe<Scalars['String']['output']>;
  subSubcategoryPages: Array<ProductSubcategoryPage>;
  subcategoryPageName?: Maybe<Scalars['String']['output']>;
  teaserPlaceholders: Array<TeaserPlaceholder>;
  teaserSmallPlaceholders: Array<TeaserSmallPlaceholder>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ProductSubcategoryPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductSubcategoryPageDictionaryItemArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductSubcategoryPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ProductSubcategoryPageHeroCarouselComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductSubcategoryPageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ProductSubcategoryPageIntroTextArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductSubcategoryPageKeyImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductSubcategoryPageKeyImageMobileArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductSubcategoryPageLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductSubcategoryPageLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


export type ProductSubcategoryPageLogoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductSubcategoryPageMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductSubcategoryPageMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductSubcategoryPagePageComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductSubcategoryPagePimProductCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryWhereInput>;
};


export type ProductSubcategoryPageProductCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryWhereInput>;
};


export type ProductSubcategoryPageProductCategoryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductSubcategoryPageProductCategoryPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductSubcategoryPageProductSubcategoryPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductSubcategoryPagePromoImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductSubcategoryPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductSubcategoryPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ProductSubcategoryPageSubSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ProductSubcategoryPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


export type ProductSubcategoryPageTeaserPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserPlaceholderWhereInput>;
};


export type ProductSubcategoryPageTeaserSmallPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
};


export type ProductSubcategoryPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductSubcategoryPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ProductSubcategoryPageWhereUniqueInput;
};

/** A connection to a list of items. */
export type ProductSubcategoryPageConnection = {
  __typename?: 'ProductSubcategoryPageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ProductSubcategoryPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ProductSubcategoryPageCreateInput = {
  cmsName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionaryItem?: InputMaybe<DictionaryItemCreateOneInlineInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateOneInlineInput>;
  introText?: InputMaybe<IntroTextCreateOneInlineInput>;
  keyImage?: InputMaybe<AssetComponentCreateOneInlineInput>;
  keyImageMobile?: InputMaybe<AssetComponentCreateOneInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  links?: InputMaybe<LinkCreateManyInlineInput>;
  logo?: InputMaybe<AssetComponentCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  metaData?: InputMaybe<MetaDataCreateOneInlineInput>;
  pageComponents?: InputMaybe<ProductSubcategoryPagePageComponentsCreateManyInlineInput>;
  pimProductCategories?: InputMaybe<ProductCategoryCreateManyInlineInput>;
  primarySubBrandColor?: InputMaybe<ColorInput>;
  productCategories?: InputMaybe<ProductCategoryCreateManyInlineInput>;
  productCategory?: InputMaybe<ProductCategoryCreateOneInlineInput>;
  productCategoryPage?: InputMaybe<ProductCategoryPageCreateOneInlineInput>;
  productGridTitle?: InputMaybe<Scalars['String']['input']>;
  productSubcategoryPage?: InputMaybe<ProductSubcategoryPageCreateOneInlineInput>;
  promoImage?: InputMaybe<AssetComponentCreateOneInlineInput>;
  secondarySubBrandColor?: InputMaybe<ColorInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  shouldBeIndexed: Scalars['Boolean']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  subBrand?: InputMaybe<Scalars['Boolean']['input']>;
  subSubCategorySuper?: InputMaybe<Scalars['String']['input']>;
  subSubCategoryTitle?: InputMaybe<Scalars['String']['input']>;
  subSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  subcategoryPageName?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderCreateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductSubcategoryPageCreateManyInlineInput = {
  /** Connect multiple existing ProductSubcategoryPage documents */
  connect?: InputMaybe<Array<ProductSubcategoryPageWhereUniqueInput>>;
  /** Create and connect multiple existing ProductSubcategoryPage documents */
  create?: InputMaybe<Array<ProductSubcategoryPageCreateInput>>;
};

export type ProductSubcategoryPageCreateOneInlineInput = {
  /** Connect one existing ProductSubcategoryPage document */
  connect?: InputMaybe<ProductSubcategoryPageWhereUniqueInput>;
  /** Create and connect one ProductSubcategoryPage document */
  create?: InputMaybe<ProductSubcategoryPageCreateInput>;
};

/** An edge in a connection. */
export type ProductSubcategoryPageEdge = {
  __typename?: 'ProductSubcategoryPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductSubcategoryPage;
};

/** Identifies documents */
export type ProductSubcategoryPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductSubcategoryPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductSubcategoryPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductSubcategoryPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsName_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaryItem?: InputMaybe<DictionaryItemWhereInput>;
  documentInStages_every?: InputMaybe<ProductSubcategoryPageWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductSubcategoryPageWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductSubcategoryPageWhereStageInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introText?: InputMaybe<IntroTextWhereInput>;
  keyImage?: InputMaybe<AssetComponentWhereInput>;
  keyImageMobile?: InputMaybe<AssetComponentWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  logo?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<ProductSubcategoryPagePageComponentsWhereInput>;
  pimProductCategories_every?: InputMaybe<ProductCategoryWhereInput>;
  pimProductCategories_none?: InputMaybe<ProductCategoryWhereInput>;
  pimProductCategories_some?: InputMaybe<ProductCategoryWhereInput>;
  productCategories_every?: InputMaybe<ProductCategoryWhereInput>;
  productCategories_none?: InputMaybe<ProductCategoryWhereInput>;
  productCategories_some?: InputMaybe<ProductCategoryWhereInput>;
  productCategory?: InputMaybe<ProductCategoryWhereInput>;
  productCategoryPage?: InputMaybe<ProductCategoryPageWhereInput>;
  productGridTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productGridTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productGridTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productGridTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productGridTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productGridTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productGridTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productGridTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productGridTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productGridTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  productSubcategoryPage?: InputMaybe<ProductSubcategoryPageWhereInput>;
  promoImage?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shortDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shortDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  shouldBeIndexed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  shouldBeIndexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  subBrand?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  subBrand_not?: InputMaybe<Scalars['Boolean']['input']>;
  subSubCategorySuper?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subSubCategorySuper_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subSubCategorySuper_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subSubCategorySuper_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subSubCategorySuper_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subSubCategorySuper_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subSubCategorySuper_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subSubCategorySuper_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subSubCategorySuper_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subSubCategorySuper_starts_with?: InputMaybe<Scalars['String']['input']>;
  subSubCategoryTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subSubCategoryTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subSubCategoryTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subSubCategoryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subSubCategoryTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subSubCategoryTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subSubCategoryTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subSubCategoryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subSubCategoryTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subSubCategoryTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  subSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  subSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  subSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  subcategoryPageName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subcategoryPageName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subcategoryPageName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subcategoryPageName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subcategoryPageName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subcategoryPageName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subcategoryPageName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subcategoryPageName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subcategoryPageName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subcategoryPageName_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ProductSubcategoryPageOrderByInput {
  cmsName_ASC = 'cmsName_ASC',
  cmsName_DESC = 'cmsName_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  productGridTitle_ASC = 'productGridTitle_ASC',
  productGridTitle_DESC = 'productGridTitle_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  shortDescription_ASC = 'shortDescription_ASC',
  shortDescription_DESC = 'shortDescription_DESC',
  shouldBeIndexed_ASC = 'shouldBeIndexed_ASC',
  shouldBeIndexed_DESC = 'shouldBeIndexed_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  subBrand_ASC = 'subBrand_ASC',
  subBrand_DESC = 'subBrand_DESC',
  subSubCategorySuper_ASC = 'subSubCategorySuper_ASC',
  subSubCategorySuper_DESC = 'subSubCategorySuper_DESC',
  subSubCategoryTitle_ASC = 'subSubCategoryTitle_ASC',
  subSubCategoryTitle_DESC = 'subSubCategoryTitle_DESC',
  subcategoryPageName_ASC = 'subcategoryPageName_ASC',
  subcategoryPageName_DESC = 'subcategoryPageName_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ProductSubcategoryPagePageComponents = Accordion | Banner1 | Banner2 | Banner2CarouselComponent | CarouselComponent | DownloadApp | DynamicCardGrid | FeaturedContent | GenericAccordion | GenericAccordionTopRated | GenericCardCarouseComponent | GenericDownloadComponent | GenericFollowUs | GenericGridAuthorable | GenericHtml | GlobalSearch | HeroCarouselComponent | Iframe | ImageCopy | LongText | MultiStepPromotionForm | ProductBanner | Spacer;

export type ProductSubcategoryPagePageComponentsConnectInput = {
  Accordion?: InputMaybe<AccordionConnectInput>;
  Banner1?: InputMaybe<Banner1ConnectInput>;
  Banner2?: InputMaybe<Banner2ConnectInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentConnectInput>;
  CarouselComponent?: InputMaybe<CarouselComponentConnectInput>;
  DownloadApp?: InputMaybe<DownloadAppConnectInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridConnectInput>;
  FeaturedContent?: InputMaybe<FeaturedContentConnectInput>;
  GenericAccordion?: InputMaybe<GenericAccordionConnectInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedConnectInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentConnectInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentConnectInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsConnectInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableConnectInput>;
  GenericHtml?: InputMaybe<GenericHtmlConnectInput>;
  GlobalSearch?: InputMaybe<GlobalSearchConnectInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentConnectInput>;
  Iframe?: InputMaybe<IframeConnectInput>;
  ImageCopy?: InputMaybe<ImageCopyConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormConnectInput>;
  ProductBanner?: InputMaybe<ProductBannerConnectInput>;
  Spacer?: InputMaybe<SpacerConnectInput>;
};

export type ProductSubcategoryPagePageComponentsCreateInput = {
  Accordion?: InputMaybe<AccordionCreateInput>;
  Banner1?: InputMaybe<Banner1CreateInput>;
  Banner2?: InputMaybe<Banner2CreateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentCreateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentCreateInput>;
  DownloadApp?: InputMaybe<DownloadAppCreateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridCreateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentCreateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionCreateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedCreateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentCreateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsCreateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableCreateInput>;
  GenericHtml?: InputMaybe<GenericHtmlCreateInput>;
  GlobalSearch?: InputMaybe<GlobalSearchCreateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateInput>;
  Iframe?: InputMaybe<IframeCreateInput>;
  ImageCopy?: InputMaybe<ImageCopyCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormCreateInput>;
  ProductBanner?: InputMaybe<ProductBannerCreateInput>;
  Spacer?: InputMaybe<SpacerCreateInput>;
};

export type ProductSubcategoryPagePageComponentsCreateManyInlineInput = {
  /** Connect multiple existing ProductSubcategoryPagePageComponents documents */
  connect?: InputMaybe<Array<ProductSubcategoryPagePageComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing ProductSubcategoryPagePageComponents documents */
  create?: InputMaybe<Array<ProductSubcategoryPagePageComponentsCreateInput>>;
};

export type ProductSubcategoryPagePageComponentsCreateOneInlineInput = {
  /** Connect one existing ProductSubcategoryPagePageComponents document */
  connect?: InputMaybe<ProductSubcategoryPagePageComponentsWhereUniqueInput>;
  /** Create and connect one ProductSubcategoryPagePageComponents document */
  create?: InputMaybe<ProductSubcategoryPagePageComponentsCreateInput>;
};

export type ProductSubcategoryPagePageComponentsUpdateInput = {
  Accordion?: InputMaybe<AccordionUpdateInput>;
  Banner1?: InputMaybe<Banner1UpdateInput>;
  Banner2?: InputMaybe<Banner2UpdateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateInput>;
  Iframe?: InputMaybe<IframeUpdateInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormUpdateInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateInput>;
  Spacer?: InputMaybe<SpacerUpdateInput>;
};

export type ProductSubcategoryPagePageComponentsUpdateManyInlineInput = {
  /** Connect multiple existing ProductSubcategoryPagePageComponents documents */
  connect?: InputMaybe<Array<ProductSubcategoryPagePageComponentsConnectInput>>;
  /** Create and connect multiple ProductSubcategoryPagePageComponents documents */
  create?: InputMaybe<Array<ProductSubcategoryPagePageComponentsCreateInput>>;
  /** Delete multiple ProductSubcategoryPagePageComponents documents */
  delete?: InputMaybe<Array<ProductSubcategoryPagePageComponentsWhereUniqueInput>>;
  /** Disconnect multiple ProductSubcategoryPagePageComponents documents */
  disconnect?: InputMaybe<Array<ProductSubcategoryPagePageComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ProductSubcategoryPagePageComponents documents */
  set?: InputMaybe<Array<ProductSubcategoryPagePageComponentsWhereUniqueInput>>;
  /** Update multiple ProductSubcategoryPagePageComponents documents */
  update?: InputMaybe<Array<ProductSubcategoryPagePageComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ProductSubcategoryPagePageComponents documents */
  upsert?: InputMaybe<Array<ProductSubcategoryPagePageComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type ProductSubcategoryPagePageComponentsUpdateManyWithNestedWhereInput = {
  Accordion?: InputMaybe<AccordionUpdateManyWithNestedWhereInput>;
  Banner1?: InputMaybe<Banner1UpdateManyWithNestedWhereInput>;
  Banner2?: InputMaybe<Banner2UpdateManyWithNestedWhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateManyWithNestedWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateManyWithNestedWhereInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateManyWithNestedWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateManyWithNestedWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateManyWithNestedWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateManyWithNestedWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateManyWithNestedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateManyWithNestedWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateManyWithNestedWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateManyWithNestedWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateManyWithNestedWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateManyWithNestedWhereInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateManyWithNestedWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateManyWithNestedWhereInput>;
  Iframe?: InputMaybe<IframeUpdateManyWithNestedWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormUpdateManyWithNestedWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateManyWithNestedWhereInput>;
  Spacer?: InputMaybe<SpacerUpdateManyWithNestedWhereInput>;
};

export type ProductSubcategoryPagePageComponentsUpdateOneInlineInput = {
  /** Connect existing ProductSubcategoryPagePageComponents document */
  connect?: InputMaybe<ProductSubcategoryPagePageComponentsWhereUniqueInput>;
  /** Create and connect one ProductSubcategoryPagePageComponents document */
  create?: InputMaybe<ProductSubcategoryPagePageComponentsCreateInput>;
  /** Delete currently connected ProductSubcategoryPagePageComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ProductSubcategoryPagePageComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ProductSubcategoryPagePageComponents document */
  update?: InputMaybe<ProductSubcategoryPagePageComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProductSubcategoryPagePageComponents document */
  upsert?: InputMaybe<ProductSubcategoryPagePageComponentsUpsertWithNestedWhereUniqueInput>;
};

export type ProductSubcategoryPagePageComponentsUpdateWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpdateWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpdateWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpdateWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateWithNestedWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateWithNestedWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpdateWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormUpdateWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpdateWithNestedWhereUniqueInput>;
};

export type ProductSubcategoryPagePageComponentsUpsertWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpsertWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpsertWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpsertWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpsertWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpsertWithNestedWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppUpsertWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpsertWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpsertWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpsertWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpsertWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpsertWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpsertWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpsertWithNestedWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpsertWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpsertWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpsertWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormUpsertWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpsertWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpsertWithNestedWhereUniqueInput>;
};

export type ProductSubcategoryPagePageComponentsWhereInput = {
  Accordion?: InputMaybe<AccordionWhereInput>;
  Banner1?: InputMaybe<Banner1WhereInput>;
  Banner2?: InputMaybe<Banner2WhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  DownloadApp?: InputMaybe<DownloadAppWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereInput>;
  GlobalSearch?: InputMaybe<GlobalSearchWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  Iframe?: InputMaybe<IframeWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereInput>;
  Spacer?: InputMaybe<SpacerWhereInput>;
};

export type ProductSubcategoryPagePageComponentsWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1WhereUniqueInput>;
  Banner2?: InputMaybe<Banner2WhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereUniqueInput>;
  Iframe?: InputMaybe<IframeWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
  MultiStepPromotionForm?: InputMaybe<MultiStepPromotionFormWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerWhereUniqueInput>;
};

export type ProductSubcategoryPageUpdateInput = {
  cmsName?: InputMaybe<Scalars['String']['input']>;
  dictionaryItem?: InputMaybe<DictionaryItemUpdateOneInlineInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateOneInlineInput>;
  introText?: InputMaybe<IntroTextUpdateOneInlineInput>;
  keyImage?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  keyImageMobile?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  links?: InputMaybe<LinkUpdateManyInlineInput>;
  logo?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  metaData?: InputMaybe<MetaDataUpdateOneInlineInput>;
  pageComponents?: InputMaybe<ProductSubcategoryPagePageComponentsUpdateManyInlineInput>;
  pimProductCategories?: InputMaybe<ProductCategoryUpdateManyInlineInput>;
  primarySubBrandColor?: InputMaybe<ColorInput>;
  productCategories?: InputMaybe<ProductCategoryUpdateManyInlineInput>;
  productCategory?: InputMaybe<ProductCategoryUpdateOneInlineInput>;
  productCategoryPage?: InputMaybe<ProductCategoryPageUpdateOneInlineInput>;
  productGridTitle?: InputMaybe<Scalars['String']['input']>;
  productSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpdateOneInlineInput>;
  promoImage?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  secondarySubBrandColor?: InputMaybe<ColorInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  shouldBeIndexed?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subBrand?: InputMaybe<Scalars['Boolean']['input']>;
  subSubCategorySuper?: InputMaybe<Scalars['String']['input']>;
  subSubCategoryTitle?: InputMaybe<Scalars['String']['input']>;
  subSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  subcategoryPageName?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderUpdateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderUpdateManyInlineInput>;
};

export type ProductSubcategoryPageUpdateManyInlineInput = {
  /** Connect multiple existing ProductSubcategoryPage documents */
  connect?: InputMaybe<Array<ProductSubcategoryPageConnectInput>>;
  /** Create and connect multiple ProductSubcategoryPage documents */
  create?: InputMaybe<Array<ProductSubcategoryPageCreateInput>>;
  /** Delete multiple ProductSubcategoryPage documents */
  delete?: InputMaybe<Array<ProductSubcategoryPageWhereUniqueInput>>;
  /** Disconnect multiple ProductSubcategoryPage documents */
  disconnect?: InputMaybe<Array<ProductSubcategoryPageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ProductSubcategoryPage documents */
  set?: InputMaybe<Array<ProductSubcategoryPageWhereUniqueInput>>;
  /** Update multiple ProductSubcategoryPage documents */
  update?: InputMaybe<Array<ProductSubcategoryPageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ProductSubcategoryPage documents */
  upsert?: InputMaybe<Array<ProductSubcategoryPageUpsertWithNestedWhereUniqueInput>>;
};

export type ProductSubcategoryPageUpdateManyInput = {
  cmsName?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  primarySubBrandColor?: InputMaybe<ColorInput>;
  productGridTitle?: InputMaybe<Scalars['String']['input']>;
  secondarySubBrandColor?: InputMaybe<ColorInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  shouldBeIndexed?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subBrand?: InputMaybe<Scalars['Boolean']['input']>;
  subSubCategorySuper?: InputMaybe<Scalars['String']['input']>;
  subSubCategoryTitle?: InputMaybe<Scalars['String']['input']>;
  subcategoryPageName?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSubcategoryPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ProductSubcategoryPageUpdateManyInput;
  /** Document search */
  where: ProductSubcategoryPageWhereInput;
};

export type ProductSubcategoryPageUpdateOneInlineInput = {
  /** Connect existing ProductSubcategoryPage document */
  connect?: InputMaybe<ProductSubcategoryPageWhereUniqueInput>;
  /** Create and connect one ProductSubcategoryPage document */
  create?: InputMaybe<ProductSubcategoryPageCreateInput>;
  /** Delete currently connected ProductSubcategoryPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ProductSubcategoryPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ProductSubcategoryPage document */
  update?: InputMaybe<ProductSubcategoryPageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProductSubcategoryPage document */
  upsert?: InputMaybe<ProductSubcategoryPageUpsertWithNestedWhereUniqueInput>;
};

export type ProductSubcategoryPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ProductSubcategoryPageUpdateInput;
  /** Unique document search */
  where: ProductSubcategoryPageWhereUniqueInput;
};

export type ProductSubcategoryPageUpsertInput = {
  /** Create document if it didn't exist */
  create: ProductSubcategoryPageCreateInput;
  /** Update document if it exists */
  update: ProductSubcategoryPageUpdateInput;
};

export type ProductSubcategoryPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ProductSubcategoryPageUpsertInput;
  /** Unique document search */
  where: ProductSubcategoryPageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ProductSubcategoryPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ProductSubcategoryPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductSubcategoryPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductSubcategoryPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductSubcategoryPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsName_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaryItem?: InputMaybe<DictionaryItemWhereInput>;
  documentInStages_every?: InputMaybe<ProductSubcategoryPageWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductSubcategoryPageWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductSubcategoryPageWhereStageInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introText?: InputMaybe<IntroTextWhereInput>;
  keyImage?: InputMaybe<AssetComponentWhereInput>;
  keyImageMobile?: InputMaybe<AssetComponentWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  logo?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<ProductSubcategoryPagePageComponentsWhereInput>;
  pimProductCategories_every?: InputMaybe<ProductCategoryWhereInput>;
  pimProductCategories_none?: InputMaybe<ProductCategoryWhereInput>;
  pimProductCategories_some?: InputMaybe<ProductCategoryWhereInput>;
  productCategories_every?: InputMaybe<ProductCategoryWhereInput>;
  productCategories_none?: InputMaybe<ProductCategoryWhereInput>;
  productCategories_some?: InputMaybe<ProductCategoryWhereInput>;
  productCategory?: InputMaybe<ProductCategoryWhereInput>;
  productCategoryPage?: InputMaybe<ProductCategoryPageWhereInput>;
  productGridTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productGridTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productGridTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productGridTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productGridTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productGridTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productGridTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productGridTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productGridTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productGridTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  productSubcategoryPage?: InputMaybe<ProductSubcategoryPageWhereInput>;
  promoImage?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shortDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shortDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  shouldBeIndexed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  shouldBeIndexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  subBrand?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  subBrand_not?: InputMaybe<Scalars['Boolean']['input']>;
  subSubCategorySuper?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subSubCategorySuper_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subSubCategorySuper_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subSubCategorySuper_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subSubCategorySuper_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subSubCategorySuper_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subSubCategorySuper_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subSubCategorySuper_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subSubCategorySuper_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subSubCategorySuper_starts_with?: InputMaybe<Scalars['String']['input']>;
  subSubCategoryTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subSubCategoryTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subSubCategoryTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subSubCategoryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subSubCategoryTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subSubCategoryTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subSubCategoryTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subSubCategoryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subSubCategoryTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subSubCategoryTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  subSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  subSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  subSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  subcategoryPageName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subcategoryPageName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subcategoryPageName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subcategoryPageName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subcategoryPageName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subcategoryPageName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subcategoryPageName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subcategoryPageName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subcategoryPageName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subcategoryPageName_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ProductSubcategoryPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductSubcategoryPageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductSubcategoryPageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductSubcategoryPageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ProductSubcategoryPageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ProductSubcategoryPage record uniquely */
export type ProductSubcategoryPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductUpdateInput = {
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  categories?: InputMaybe<ProductCategoryUpdateManyInlineInput>;
  ckwaqzt7o2k0m01w3h369ggpu?: InputMaybe<GenericCardCarouseComponentUpdateManyInlineInput>;
  cookingTips?: InputMaybe<Array<Scalars['String']['input']>>;
  dictionary?: InputMaybe<DictionaryUpdateOneInlineInput>;
  fillingQuantity?: InputMaybe<Scalars['String']['input']>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  ingredients?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedInPim?: InputMaybe<Scalars['String']['input']>;
  lifestyleImage?: InputMaybe<AssetUpdateOneInlineInput>;
  market?: InputMaybe<Scalars['String']['input']>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  marketSlugId?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeywords?: InputMaybe<Scalars['String']['input']>;
  nutriScore?: InputMaybe<Scalars['String']['input']>;
  nutrientInformation?: InputMaybe<Scalars['String']['input']>;
  packagingInformation?: InputMaybe<Scalars['String']['input']>;
  preparationInstructions?: InputMaybe<Scalars['String']['input']>;
  productBanner?: InputMaybe<ProductBannerUpdateManyInlineInput>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  productDietList?: InputMaybe<Array<Scalars['String']['input']>>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productImage?: InputMaybe<AssetUpdateOneInlineInput>;
  productLabels?: InputMaybe<ProductLabelUpdateManyInlineInput>;
  productPageURL?: InputMaybe<Scalars['String']['input']>;
  productTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductUpdateManyInlineInput = {
  /** Connect multiple existing Product documents */
  connect?: InputMaybe<Array<ProductConnectInput>>;
  /** Create and connect multiple Product documents */
  create?: InputMaybe<Array<ProductCreateInput>>;
  /** Delete multiple Product documents */
  delete?: InputMaybe<Array<ProductWhereUniqueInput>>;
  /** Disconnect multiple Product documents */
  disconnect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Product documents */
  set?: InputMaybe<Array<ProductWhereUniqueInput>>;
  /** Update multiple Product documents */
  update?: InputMaybe<Array<ProductUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Product documents */
  upsert?: InputMaybe<Array<ProductUpsertWithNestedWhereUniqueInput>>;
};

export type ProductUpdateManyInput = {
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  cookingTips?: InputMaybe<Array<Scalars['String']['input']>>;
  fillingQuantity?: InputMaybe<Scalars['String']['input']>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  ingredients?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedInPim?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeywords?: InputMaybe<Scalars['String']['input']>;
  nutriScore?: InputMaybe<Scalars['String']['input']>;
  nutrientInformation?: InputMaybe<Scalars['String']['input']>;
  packagingInformation?: InputMaybe<Scalars['String']['input']>;
  preparationInstructions?: InputMaybe<Scalars['String']['input']>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  productDietList?: InputMaybe<Array<Scalars['String']['input']>>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productPageURL?: InputMaybe<Scalars['String']['input']>;
  productTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ProductUpdateManyInput;
  /** Document search */
  where: ProductWhereInput;
};

export type ProductUpdateOneInlineInput = {
  /** Connect existing Product document */
  connect?: InputMaybe<ProductWhereUniqueInput>;
  /** Create and connect one Product document */
  create?: InputMaybe<ProductCreateInput>;
  /** Delete currently connected Product document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Product document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Product document */
  update?: InputMaybe<ProductUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Product document */
  upsert?: InputMaybe<ProductUpsertWithNestedWhereUniqueInput>;
};

export type ProductUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ProductUpdateInput;
  /** Unique document search */
  where: ProductWhereUniqueInput;
};

export type ProductUpsertInput = {
  /** Create document if it didn't exist */
  create: ProductCreateInput;
  /** Update document if it exists */
  update: ProductUpdateInput;
};

export type ProductUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ProductUpsertInput;
  /** Unique document search */
  where: ProductWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ProductWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ProductWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  allergens_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  allergens_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  allergens_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  allergens_not?: InputMaybe<Array<Scalars['String']['input']>>;
  categories_every?: InputMaybe<ProductCategoryWhereInput>;
  categories_none?: InputMaybe<ProductCategoryWhereInput>;
  categories_some?: InputMaybe<ProductCategoryWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  cookingTips?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  cookingTips_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  cookingTips_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  cookingTips_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  cookingTips_not?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionary?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<ProductWhereStageInput>;
  documentInStages_none?: InputMaybe<ProductWhereStageInput>;
  documentInStages_some?: InputMaybe<ProductWhereStageInput>;
  fillingQuantity?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fillingQuantity_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fillingQuantity_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fillingQuantity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fillingQuantity_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fillingQuantity_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fillingQuantity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fillingQuantity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fillingQuantity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fillingQuantity_starts_with?: InputMaybe<Scalars['String']['input']>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  gtin_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  gtin_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  gtin_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  gtin_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  gtin_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  gtin_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  gtin_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  gtin_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  gtin_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  ingredients?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ingredients_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ingredients_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ingredients_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ingredients_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ingredients_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ingredients_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ingredients_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ingredients_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ingredients_starts_with?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedInPim?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  lastUpdatedInPim_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  lastUpdatedInPim_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  lastUpdatedInPim_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  lastUpdatedInPim_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  lastUpdatedInPim_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  lastUpdatedInPim_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  lastUpdatedInPim_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  lastUpdatedInPim_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  lastUpdatedInPim_starts_with?: InputMaybe<Scalars['String']['input']>;
  lifestyleImage?: InputMaybe<AssetWhereInput>;
  market?: InputMaybe<Scalars['String']['input']>;
  marketName?: InputMaybe<MarketWhereInput>;
  marketSlugId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  marketSlugId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  marketSlugId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  marketSlugId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  marketSlugId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  marketSlugId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  marketSlugId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  marketSlugId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  marketSlugId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  marketSlugId_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  market_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  market_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  market_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  market_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  market_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  market_starts_with?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  metaDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  metaDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  metaDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  metaDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  metaKeywords?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  metaKeywords_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  metaKeywords_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  metaKeywords_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  metaKeywords_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  metaKeywords_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  metaKeywords_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  metaKeywords_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  metaKeywords_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  metaKeywords_starts_with?: InputMaybe<Scalars['String']['input']>;
  nutriScore?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  nutriScore_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  nutriScore_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  nutriScore_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  nutriScore_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  nutriScore_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  nutriScore_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  nutriScore_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  nutriScore_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  nutriScore_starts_with?: InputMaybe<Scalars['String']['input']>;
  nutrientInformation?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  nutrientInformation_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  nutrientInformation_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  nutrientInformation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  nutrientInformation_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  nutrientInformation_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  nutrientInformation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  nutrientInformation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  nutrientInformation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  nutrientInformation_starts_with?: InputMaybe<Scalars['String']['input']>;
  packagingInformation?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  packagingInformation_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  packagingInformation_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  packagingInformation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  packagingInformation_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  packagingInformation_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  packagingInformation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  packagingInformation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  packagingInformation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  packagingInformation_starts_with?: InputMaybe<Scalars['String']['input']>;
  preparationInstructions?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  preparationInstructions_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  preparationInstructions_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  preparationInstructions_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  preparationInstructions_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  preparationInstructions_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  preparationInstructions_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  preparationInstructions_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  preparationInstructions_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  preparationInstructions_starts_with?: InputMaybe<Scalars['String']['input']>;
  productBanner_every?: InputMaybe<ProductBannerWhereInput>;
  productBanner_none?: InputMaybe<ProductBannerWhereInput>;
  productBanner_some?: InputMaybe<ProductBannerWhereInput>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  productDietList?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  productDietList_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  productDietList_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  productDietList_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  productDietList_not?: InputMaybe<Array<Scalars['String']['input']>>;
  productId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productId_starts_with?: InputMaybe<Scalars['String']['input']>;
  productImage?: InputMaybe<AssetWhereInput>;
  productLabels_every?: InputMaybe<ProductLabelWhereInput>;
  productLabels_none?: InputMaybe<ProductLabelWhereInput>;
  productLabels_some?: InputMaybe<ProductLabelWhereInput>;
  productPageURL?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productPageURL_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productPageURL_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productPageURL_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productPageURL_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productPageURL_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productPageURL_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productPageURL_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productPageURL_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productPageURL_starts_with?: InputMaybe<Scalars['String']['input']>;
  productTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  productTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  productTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  productTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  productTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  productTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  productTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  productTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  productTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  productTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ProductWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ProductWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Product record uniquely */
export type ProductWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  marketSlugId?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionDownload = Entity & Node & {
  __typename?: 'PromotionDownload';
  buttonText: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<PromotionDownload>;
  file: Asset;
  /** List of PromotionDownload versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<PromotionDownload>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type PromotionDownloadCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type PromotionDownloadCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PromotionDownloadDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type PromotionDownloadFileArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type PromotionDownloadHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type PromotionDownloadLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type PromotionDownloadPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type PromotionDownloadPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PromotionDownloadScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PromotionDownloadUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type PromotionDownloadUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PromotionDownloadConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PromotionDownloadWhereUniqueInput;
};

/** A connection to a list of items. */
export type PromotionDownloadConnection = {
  __typename?: 'PromotionDownloadConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PromotionDownloadEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PromotionDownloadCreateInput = {
  /** buttonText input for default locale (en) */
  buttonText: Scalars['String']['input'];
  clzi9zl1901pc08uj8ifa731j?: InputMaybe<MultiStepPromotionFormCreateManyInlineInput>;
  clzik8n6m05bz08ujgkf393o8?: InputMaybe<SingleStepPromotionFormCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  file: AssetCreateOneInlineInput;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<PromotionDownloadCreateLocalizationsInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PromotionDownloadCreateLocalizationDataInput = {
  buttonText: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PromotionDownloadCreateLocalizationInput = {
  /** Localization input */
  data: PromotionDownloadCreateLocalizationDataInput;
  locale: Locale;
};

export type PromotionDownloadCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<PromotionDownloadCreateLocalizationInput>>;
};

export type PromotionDownloadCreateManyInlineInput = {
  /** Connect multiple existing PromotionDownload documents */
  connect?: InputMaybe<Array<PromotionDownloadWhereUniqueInput>>;
  /** Create and connect multiple existing PromotionDownload documents */
  create?: InputMaybe<Array<PromotionDownloadCreateInput>>;
};

export type PromotionDownloadCreateOneInlineInput = {
  /** Connect one existing PromotionDownload document */
  connect?: InputMaybe<PromotionDownloadWhereUniqueInput>;
  /** Create and connect one PromotionDownload document */
  create?: InputMaybe<PromotionDownloadCreateInput>;
};

/** An edge in a connection. */
export type PromotionDownloadEdge = {
  __typename?: 'PromotionDownloadEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PromotionDownload;
};

/** Identifies documents */
export type PromotionDownloadManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PromotionDownloadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PromotionDownloadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PromotionDownloadWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PromotionDownloadWhereStageInput>;
  documentInStages_none?: InputMaybe<PromotionDownloadWhereStageInput>;
  documentInStages_some?: InputMaybe<PromotionDownloadWhereStageInput>;
  file?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PromotionDownloadOrderByInput {
  buttonText_ASC = 'buttonText_ASC',
  buttonText_DESC = 'buttonText_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type PromotionDownloadUpdateInput = {
  /** buttonText input for default locale (en) */
  buttonText?: InputMaybe<Scalars['String']['input']>;
  clzi9zl1901pc08uj8ifa731j?: InputMaybe<MultiStepPromotionFormUpdateManyInlineInput>;
  clzik8n6m05bz08ujgkf393o8?: InputMaybe<SingleStepPromotionFormUpdateManyInlineInput>;
  file?: InputMaybe<AssetUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<PromotionDownloadUpdateLocalizationsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionDownloadUpdateLocalizationDataInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionDownloadUpdateLocalizationInput = {
  data: PromotionDownloadUpdateLocalizationDataInput;
  locale: Locale;
};

export type PromotionDownloadUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<PromotionDownloadCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<PromotionDownloadUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<PromotionDownloadUpsertLocalizationInput>>;
};

export type PromotionDownloadUpdateManyInlineInput = {
  /** Connect multiple existing PromotionDownload documents */
  connect?: InputMaybe<Array<PromotionDownloadConnectInput>>;
  /** Create and connect multiple PromotionDownload documents */
  create?: InputMaybe<Array<PromotionDownloadCreateInput>>;
  /** Delete multiple PromotionDownload documents */
  delete?: InputMaybe<Array<PromotionDownloadWhereUniqueInput>>;
  /** Disconnect multiple PromotionDownload documents */
  disconnect?: InputMaybe<Array<PromotionDownloadWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PromotionDownload documents */
  set?: InputMaybe<Array<PromotionDownloadWhereUniqueInput>>;
  /** Update multiple PromotionDownload documents */
  update?: InputMaybe<Array<PromotionDownloadUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PromotionDownload documents */
  upsert?: InputMaybe<Array<PromotionDownloadUpsertWithNestedWhereUniqueInput>>;
};

export type PromotionDownloadUpdateManyInput = {
  /** buttonText input for default locale (en) */
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<PromotionDownloadUpdateManyLocalizationsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionDownloadUpdateManyLocalizationDataInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionDownloadUpdateManyLocalizationInput = {
  data: PromotionDownloadUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type PromotionDownloadUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<PromotionDownloadUpdateManyLocalizationInput>>;
};

export type PromotionDownloadUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PromotionDownloadUpdateManyInput;
  /** Document search */
  where: PromotionDownloadWhereInput;
};

export type PromotionDownloadUpdateOneInlineInput = {
  /** Connect existing PromotionDownload document */
  connect?: InputMaybe<PromotionDownloadWhereUniqueInput>;
  /** Create and connect one PromotionDownload document */
  create?: InputMaybe<PromotionDownloadCreateInput>;
  /** Delete currently connected PromotionDownload document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected PromotionDownload document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PromotionDownload document */
  update?: InputMaybe<PromotionDownloadUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PromotionDownload document */
  upsert?: InputMaybe<PromotionDownloadUpsertWithNestedWhereUniqueInput>;
};

export type PromotionDownloadUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PromotionDownloadUpdateInput;
  /** Unique document search */
  where: PromotionDownloadWhereUniqueInput;
};

export type PromotionDownloadUpsertInput = {
  /** Create document if it didn't exist */
  create: PromotionDownloadCreateInput;
  /** Update document if it exists */
  update: PromotionDownloadUpdateInput;
};

export type PromotionDownloadUpsertLocalizationInput = {
  create: PromotionDownloadCreateLocalizationDataInput;
  locale: Locale;
  update: PromotionDownloadUpdateLocalizationDataInput;
};

export type PromotionDownloadUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PromotionDownloadUpsertInput;
  /** Unique document search */
  where: PromotionDownloadWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PromotionDownloadWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PromotionDownloadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PromotionDownloadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PromotionDownloadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PromotionDownloadWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  buttonText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  buttonText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  buttonText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  buttonText_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PromotionDownloadWhereStageInput>;
  documentInStages_none?: InputMaybe<PromotionDownloadWhereStageInput>;
  documentInStages_some?: InputMaybe<PromotionDownloadWhereStageInput>;
  file?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PromotionDownloadWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PromotionDownloadWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PromotionDownloadWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PromotionDownloadWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PromotionDownloadWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References PromotionDownload record uniquely */
export type PromotionDownloadWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PromotionForm = Entity & Node & {
  __typename?: 'PromotionForm';
  brand: Brand;
  campaignType?: Maybe<CampaignTypes>;
  countryCode: Countries;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<PromotionForm>;
  endDate: Scalars['Date']['output'];
  externalToolId?: Maybe<Scalars['String']['output']>;
  /** List of PromotionForm versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Please use the MarTech naming convention tool to create the Promotion ID since other ID's will not be tracked. */
  internationalPromotionId: Scalars['String']['output'];
  language: Languages;
  legalCheckboxRequired?: Maybe<Scalars['Boolean']['output']>;
  legalText?: Maybe<RichText>;
  newsletterSubscriptions?: Maybe<NewsletterSubscriptions>;
  promotionType?: Maybe<PromotionType>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  showAddressField?: Maybe<Scalars['Boolean']['output']>;
  showBirthdateField?: Maybe<Scalars['Boolean']['output']>;
  showGenderField?: Maybe<Scalars['Boolean']['output']>;
  showHomeNumberField?: Maybe<Scalars['Boolean']['output']>;
  showLegalCheckbox?: Maybe<Scalars['Boolean']['output']>;
  showMobileNumberField?: Maybe<Scalars['Boolean']['output']>;
  showSalutationField?: Maybe<Scalars['Boolean']['output']>;
  /** System stage field */
  stage: Stage;
  startDate: Scalars['Date']['output'];
  submitButtonText: Scalars['String']['output'];
  submitSuccessDescription?: Maybe<Scalars['String']['output']>;
  submitSuccessTitle: Scalars['String']['output'];
  /** The Title is shown as the last Step Title above the Promotion Form. */
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type PromotionFormCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PromotionFormDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type PromotionFormHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type PromotionFormNewsletterSubscriptionsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PromotionFormPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PromotionFormScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PromotionFormUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PromotionFormConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PromotionFormWhereUniqueInput;
};

/** A connection to a list of items. */
export type PromotionFormConnection = {
  __typename?: 'PromotionFormConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PromotionFormEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PromotionFormCreateInput = {
  brand: Brand;
  campaignType?: InputMaybe<CampaignTypes>;
  clz6tkmn302os07ta4v9zauca?: InputMaybe<MultiStepPromotionFormCreateManyInlineInput>;
  clzi9iqep011j08uj7pbpa68l?: InputMaybe<SingleStepPromotionFormCreateManyInlineInput>;
  countryCode: Countries;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  externalToolId?: InputMaybe<Scalars['String']['input']>;
  internationalPromotionId: Scalars['String']['input'];
  language: Languages;
  legalCheckboxRequired?: InputMaybe<Scalars['Boolean']['input']>;
  legalText?: InputMaybe<Scalars['RichTextAST']['input']>;
  newsletterSubscriptions?: InputMaybe<NewsletterSubscriptionsCreateOneInlineInput>;
  promotionType?: InputMaybe<PromotionType>;
  showAddressField?: InputMaybe<Scalars['Boolean']['input']>;
  showBirthdateField?: InputMaybe<Scalars['Boolean']['input']>;
  showGenderField?: InputMaybe<Scalars['Boolean']['input']>;
  showHomeNumberField?: InputMaybe<Scalars['Boolean']['input']>;
  showLegalCheckbox?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileNumberField?: InputMaybe<Scalars['Boolean']['input']>;
  showSalutationField?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['Date']['input'];
  submitButtonText: Scalars['String']['input'];
  submitSuccessDescription?: InputMaybe<Scalars['String']['input']>;
  submitSuccessTitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PromotionFormCreateManyInlineInput = {
  /** Connect multiple existing PromotionForm documents */
  connect?: InputMaybe<Array<PromotionFormWhereUniqueInput>>;
  /** Create and connect multiple existing PromotionForm documents */
  create?: InputMaybe<Array<PromotionFormCreateInput>>;
};

export type PromotionFormCreateOneInlineInput = {
  /** Connect one existing PromotionForm document */
  connect?: InputMaybe<PromotionFormWhereUniqueInput>;
  /** Create and connect one PromotionForm document */
  create?: InputMaybe<PromotionFormCreateInput>;
};

/** An edge in a connection. */
export type PromotionFormEdge = {
  __typename?: 'PromotionFormEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PromotionForm;
};

/** Identifies documents */
export type PromotionFormManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PromotionFormWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PromotionFormWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PromotionFormWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Brand>;
  /** All values that are contained in given list. */
  brand_in?: InputMaybe<Array<InputMaybe<Brand>>>;
  /** Any other value that exists and is not equal to the given value. */
  brand_not?: InputMaybe<Brand>;
  /** All values that are not contained in given list. */
  brand_not_in?: InputMaybe<Array<InputMaybe<Brand>>>;
  campaignType?: InputMaybe<CampaignTypes>;
  /** All values that are contained in given list. */
  campaignType_in?: InputMaybe<Array<InputMaybe<CampaignTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  campaignType_not?: InputMaybe<CampaignTypes>;
  /** All values that are not contained in given list. */
  campaignType_not_in?: InputMaybe<Array<InputMaybe<CampaignTypes>>>;
  countryCode?: InputMaybe<Countries>;
  /** All values that are contained in given list. */
  countryCode_in?: InputMaybe<Array<InputMaybe<Countries>>>;
  /** Any other value that exists and is not equal to the given value. */
  countryCode_not?: InputMaybe<Countries>;
  /** All values that are not contained in given list. */
  countryCode_not_in?: InputMaybe<Array<InputMaybe<Countries>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<PromotionFormWhereStageInput>;
  documentInStages_none?: InputMaybe<PromotionFormWhereStageInput>;
  documentInStages_some?: InputMaybe<PromotionFormWhereStageInput>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  endDate_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  endDate_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  endDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  endDate_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  endDate_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  endDate_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  externalToolId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  externalToolId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  externalToolId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  externalToolId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  externalToolId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  externalToolId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  externalToolId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  externalToolId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  externalToolId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  externalToolId_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internationalPromotionId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internationalPromotionId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internationalPromotionId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internationalPromotionId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internationalPromotionId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internationalPromotionId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internationalPromotionId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internationalPromotionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internationalPromotionId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internationalPromotionId_starts_with?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Languages>;
  /** All values that are contained in given list. */
  language_in?: InputMaybe<Array<InputMaybe<Languages>>>;
  /** Any other value that exists and is not equal to the given value. */
  language_not?: InputMaybe<Languages>;
  /** All values that are not contained in given list. */
  language_not_in?: InputMaybe<Array<InputMaybe<Languages>>>;
  legalCheckboxRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  legalCheckboxRequired_not?: InputMaybe<Scalars['Boolean']['input']>;
  newsletterSubscriptions?: InputMaybe<NewsletterSubscriptionsWhereInput>;
  promotionType?: InputMaybe<PromotionType>;
  /** All values that are contained in given list. */
  promotionType_in?: InputMaybe<Array<InputMaybe<PromotionType>>>;
  /** Any other value that exists and is not equal to the given value. */
  promotionType_not?: InputMaybe<PromotionType>;
  /** All values that are not contained in given list. */
  promotionType_not_in?: InputMaybe<Array<InputMaybe<PromotionType>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showAddressField?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showAddressField_not?: InputMaybe<Scalars['Boolean']['input']>;
  showBirthdateField?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showBirthdateField_not?: InputMaybe<Scalars['Boolean']['input']>;
  showGenderField?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showGenderField_not?: InputMaybe<Scalars['Boolean']['input']>;
  showHomeNumberField?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showHomeNumberField_not?: InputMaybe<Scalars['Boolean']['input']>;
  showLegalCheckbox?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showLegalCheckbox_not?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileNumberField?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showMobileNumberField_not?: InputMaybe<Scalars['Boolean']['input']>;
  showSalutationField?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showSalutationField_not?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  startDate_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  startDate_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  startDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  startDate_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  startDate_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  startDate_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  submitButtonText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  submitButtonText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  submitButtonText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  submitButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  submitButtonText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  submitButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  submitButtonText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  submitButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  submitButtonText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  submitButtonText_starts_with?: InputMaybe<Scalars['String']['input']>;
  submitSuccessDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  submitSuccessDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  submitSuccessDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  submitSuccessDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  submitSuccessDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  submitSuccessDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  submitSuccessDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  submitSuccessDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  submitSuccessDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  submitSuccessDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  submitSuccessTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  submitSuccessTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  submitSuccessTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  submitSuccessTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  submitSuccessTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  submitSuccessTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  submitSuccessTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  submitSuccessTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  submitSuccessTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  submitSuccessTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PromotionFormOrderByInput {
  brand_ASC = 'brand_ASC',
  brand_DESC = 'brand_DESC',
  campaignType_ASC = 'campaignType_ASC',
  campaignType_DESC = 'campaignType_DESC',
  countryCode_ASC = 'countryCode_ASC',
  countryCode_DESC = 'countryCode_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  endDate_ASC = 'endDate_ASC',
  endDate_DESC = 'endDate_DESC',
  externalToolId_ASC = 'externalToolId_ASC',
  externalToolId_DESC = 'externalToolId_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  internationalPromotionId_ASC = 'internationalPromotionId_ASC',
  internationalPromotionId_DESC = 'internationalPromotionId_DESC',
  language_ASC = 'language_ASC',
  language_DESC = 'language_DESC',
  legalCheckboxRequired_ASC = 'legalCheckboxRequired_ASC',
  legalCheckboxRequired_DESC = 'legalCheckboxRequired_DESC',
  promotionType_ASC = 'promotionType_ASC',
  promotionType_DESC = 'promotionType_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  showAddressField_ASC = 'showAddressField_ASC',
  showAddressField_DESC = 'showAddressField_DESC',
  showBirthdateField_ASC = 'showBirthdateField_ASC',
  showBirthdateField_DESC = 'showBirthdateField_DESC',
  showGenderField_ASC = 'showGenderField_ASC',
  showGenderField_DESC = 'showGenderField_DESC',
  showHomeNumberField_ASC = 'showHomeNumberField_ASC',
  showHomeNumberField_DESC = 'showHomeNumberField_DESC',
  showLegalCheckbox_ASC = 'showLegalCheckbox_ASC',
  showLegalCheckbox_DESC = 'showLegalCheckbox_DESC',
  showMobileNumberField_ASC = 'showMobileNumberField_ASC',
  showMobileNumberField_DESC = 'showMobileNumberField_DESC',
  showSalutationField_ASC = 'showSalutationField_ASC',
  showSalutationField_DESC = 'showSalutationField_DESC',
  startDate_ASC = 'startDate_ASC',
  startDate_DESC = 'startDate_DESC',
  submitButtonText_ASC = 'submitButtonText_ASC',
  submitButtonText_DESC = 'submitButtonText_DESC',
  submitSuccessDescription_ASC = 'submitSuccessDescription_ASC',
  submitSuccessDescription_DESC = 'submitSuccessDescription_DESC',
  submitSuccessTitle_ASC = 'submitSuccessTitle_ASC',
  submitSuccessTitle_DESC = 'submitSuccessTitle_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type PromotionFormUpdateInput = {
  brand?: InputMaybe<Brand>;
  campaignType?: InputMaybe<CampaignTypes>;
  clz6tkmn302os07ta4v9zauca?: InputMaybe<MultiStepPromotionFormUpdateManyInlineInput>;
  clzi9iqep011j08uj7pbpa68l?: InputMaybe<SingleStepPromotionFormUpdateManyInlineInput>;
  countryCode?: InputMaybe<Countries>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  externalToolId?: InputMaybe<Scalars['String']['input']>;
  internationalPromotionId?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Languages>;
  legalCheckboxRequired?: InputMaybe<Scalars['Boolean']['input']>;
  legalText?: InputMaybe<Scalars['RichTextAST']['input']>;
  newsletterSubscriptions?: InputMaybe<NewsletterSubscriptionsUpdateOneInlineInput>;
  promotionType?: InputMaybe<PromotionType>;
  showAddressField?: InputMaybe<Scalars['Boolean']['input']>;
  showBirthdateField?: InputMaybe<Scalars['Boolean']['input']>;
  showGenderField?: InputMaybe<Scalars['Boolean']['input']>;
  showHomeNumberField?: InputMaybe<Scalars['Boolean']['input']>;
  showLegalCheckbox?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileNumberField?: InputMaybe<Scalars['Boolean']['input']>;
  showSalutationField?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  submitButtonText?: InputMaybe<Scalars['String']['input']>;
  submitSuccessDescription?: InputMaybe<Scalars['String']['input']>;
  submitSuccessTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionFormUpdateManyInlineInput = {
  /** Connect multiple existing PromotionForm documents */
  connect?: InputMaybe<Array<PromotionFormConnectInput>>;
  /** Create and connect multiple PromotionForm documents */
  create?: InputMaybe<Array<PromotionFormCreateInput>>;
  /** Delete multiple PromotionForm documents */
  delete?: InputMaybe<Array<PromotionFormWhereUniqueInput>>;
  /** Disconnect multiple PromotionForm documents */
  disconnect?: InputMaybe<Array<PromotionFormWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PromotionForm documents */
  set?: InputMaybe<Array<PromotionFormWhereUniqueInput>>;
  /** Update multiple PromotionForm documents */
  update?: InputMaybe<Array<PromotionFormUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PromotionForm documents */
  upsert?: InputMaybe<Array<PromotionFormUpsertWithNestedWhereUniqueInput>>;
};

export type PromotionFormUpdateManyInput = {
  brand?: InputMaybe<Brand>;
  campaignType?: InputMaybe<CampaignTypes>;
  countryCode?: InputMaybe<Countries>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  externalToolId?: InputMaybe<Scalars['String']['input']>;
  internationalPromotionId?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Languages>;
  legalCheckboxRequired?: InputMaybe<Scalars['Boolean']['input']>;
  legalText?: InputMaybe<Scalars['RichTextAST']['input']>;
  promotionType?: InputMaybe<PromotionType>;
  showAddressField?: InputMaybe<Scalars['Boolean']['input']>;
  showBirthdateField?: InputMaybe<Scalars['Boolean']['input']>;
  showGenderField?: InputMaybe<Scalars['Boolean']['input']>;
  showHomeNumberField?: InputMaybe<Scalars['Boolean']['input']>;
  showLegalCheckbox?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileNumberField?: InputMaybe<Scalars['Boolean']['input']>;
  showSalutationField?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  submitButtonText?: InputMaybe<Scalars['String']['input']>;
  submitSuccessDescription?: InputMaybe<Scalars['String']['input']>;
  submitSuccessTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionFormUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PromotionFormUpdateManyInput;
  /** Document search */
  where: PromotionFormWhereInput;
};

export type PromotionFormUpdateOneInlineInput = {
  /** Connect existing PromotionForm document */
  connect?: InputMaybe<PromotionFormWhereUniqueInput>;
  /** Create and connect one PromotionForm document */
  create?: InputMaybe<PromotionFormCreateInput>;
  /** Delete currently connected PromotionForm document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected PromotionForm document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PromotionForm document */
  update?: InputMaybe<PromotionFormUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PromotionForm document */
  upsert?: InputMaybe<PromotionFormUpsertWithNestedWhereUniqueInput>;
};

export type PromotionFormUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PromotionFormUpdateInput;
  /** Unique document search */
  where: PromotionFormWhereUniqueInput;
};

export type PromotionFormUpsertInput = {
  /** Create document if it didn't exist */
  create: PromotionFormCreateInput;
  /** Update document if it exists */
  update: PromotionFormUpdateInput;
};

export type PromotionFormUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PromotionFormUpsertInput;
  /** Unique document search */
  where: PromotionFormWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PromotionFormWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PromotionFormWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PromotionFormWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PromotionFormWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PromotionFormWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Brand>;
  /** All values that are contained in given list. */
  brand_in?: InputMaybe<Array<InputMaybe<Brand>>>;
  /** Any other value that exists and is not equal to the given value. */
  brand_not?: InputMaybe<Brand>;
  /** All values that are not contained in given list. */
  brand_not_in?: InputMaybe<Array<InputMaybe<Brand>>>;
  campaignType?: InputMaybe<CampaignTypes>;
  /** All values that are contained in given list. */
  campaignType_in?: InputMaybe<Array<InputMaybe<CampaignTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  campaignType_not?: InputMaybe<CampaignTypes>;
  /** All values that are not contained in given list. */
  campaignType_not_in?: InputMaybe<Array<InputMaybe<CampaignTypes>>>;
  countryCode?: InputMaybe<Countries>;
  /** All values that are contained in given list. */
  countryCode_in?: InputMaybe<Array<InputMaybe<Countries>>>;
  /** Any other value that exists and is not equal to the given value. */
  countryCode_not?: InputMaybe<Countries>;
  /** All values that are not contained in given list. */
  countryCode_not_in?: InputMaybe<Array<InputMaybe<Countries>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<PromotionFormWhereStageInput>;
  documentInStages_none?: InputMaybe<PromotionFormWhereStageInput>;
  documentInStages_some?: InputMaybe<PromotionFormWhereStageInput>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  endDate_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  endDate_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  endDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  endDate_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  endDate_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  endDate_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  externalToolId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  externalToolId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  externalToolId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  externalToolId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  externalToolId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  externalToolId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  externalToolId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  externalToolId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  externalToolId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  externalToolId_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internationalPromotionId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internationalPromotionId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internationalPromotionId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internationalPromotionId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internationalPromotionId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internationalPromotionId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internationalPromotionId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internationalPromotionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internationalPromotionId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internationalPromotionId_starts_with?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Languages>;
  /** All values that are contained in given list. */
  language_in?: InputMaybe<Array<InputMaybe<Languages>>>;
  /** Any other value that exists and is not equal to the given value. */
  language_not?: InputMaybe<Languages>;
  /** All values that are not contained in given list. */
  language_not_in?: InputMaybe<Array<InputMaybe<Languages>>>;
  legalCheckboxRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  legalCheckboxRequired_not?: InputMaybe<Scalars['Boolean']['input']>;
  newsletterSubscriptions?: InputMaybe<NewsletterSubscriptionsWhereInput>;
  promotionType?: InputMaybe<PromotionType>;
  /** All values that are contained in given list. */
  promotionType_in?: InputMaybe<Array<InputMaybe<PromotionType>>>;
  /** Any other value that exists and is not equal to the given value. */
  promotionType_not?: InputMaybe<PromotionType>;
  /** All values that are not contained in given list. */
  promotionType_not_in?: InputMaybe<Array<InputMaybe<PromotionType>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showAddressField?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showAddressField_not?: InputMaybe<Scalars['Boolean']['input']>;
  showBirthdateField?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showBirthdateField_not?: InputMaybe<Scalars['Boolean']['input']>;
  showGenderField?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showGenderField_not?: InputMaybe<Scalars['Boolean']['input']>;
  showHomeNumberField?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showHomeNumberField_not?: InputMaybe<Scalars['Boolean']['input']>;
  showLegalCheckbox?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showLegalCheckbox_not?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileNumberField?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showMobileNumberField_not?: InputMaybe<Scalars['Boolean']['input']>;
  showSalutationField?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showSalutationField_not?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  startDate_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  startDate_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  startDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  startDate_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  startDate_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  startDate_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  submitButtonText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  submitButtonText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  submitButtonText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  submitButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  submitButtonText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  submitButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  submitButtonText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  submitButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  submitButtonText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  submitButtonText_starts_with?: InputMaybe<Scalars['String']['input']>;
  submitSuccessDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  submitSuccessDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  submitSuccessDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  submitSuccessDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  submitSuccessDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  submitSuccessDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  submitSuccessDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  submitSuccessDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  submitSuccessDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  submitSuccessDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  submitSuccessTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  submitSuccessTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  submitSuccessTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  submitSuccessTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  submitSuccessTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  submitSuccessTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  submitSuccessTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  submitSuccessTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  submitSuccessTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  submitSuccessTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PromotionFormWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PromotionFormWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PromotionFormWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PromotionFormWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PromotionFormWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References PromotionForm record uniquely */
export type PromotionFormWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum PromotionType {
  CashbackAction = 'CashbackAction',
  Coupon = 'Coupon',
  CreatingAwareness = 'CreatingAwareness',
  DataEnrichment = 'DataEnrichment',
  Game = 'Game',
  GiveAway = 'GiveAway',
  Questionnaire = 'Questionnaire',
  Raffle = 'Raffle',
  Referral = 'Referral',
  SocialMediaContest = 'SocialMediaContest',
  TesterCampaign = 'TesterCampaign'
}

export type PublishLocaleInput = {
  /** Locales to publish */
  locale: Locale;
  /** Stages to publish selected locales to */
  stages: Array<Stage>;
};

export type Query = {
  __typename?: 'Query';
  /** Retrieve a single accordion */
  accordion?: Maybe<Accordion>;
  /** Retrieve a single accordionItem */
  accordionItem?: Maybe<AccordionItem>;
  /** Retrieve document version */
  accordionItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple accordionItems */
  accordionItems: Array<AccordionItem>;
  /** Retrieve multiple accordionItems using the Relay connection interface */
  accordionItemsConnection: AccordionItemConnection;
  /** Retrieve document version */
  accordionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple accordions */
  accordions: Array<Accordion>;
  /** Retrieve multiple accordions using the Relay connection interface */
  accordionsConnection: AccordionConnection;
  /** Retrieve a single algoliaExtension */
  algoliaExtension?: Maybe<AlgoliaExtension>;
  /** Retrieve document version */
  algoliaExtensionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple algoliaExtensions */
  algoliaExtensions: Array<AlgoliaExtension>;
  /** Retrieve multiple algoliaExtensions using the Relay connection interface */
  algoliaExtensionsConnection: AlgoliaExtensionConnection;
  /** Retrieve a single anchorNav */
  anchorNav?: Maybe<AnchorNav>;
  /** Retrieve document version */
  anchorNavVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single anchorNavigation */
  anchorNavigation?: Maybe<AnchorNavigation>;
  /** Retrieve a single anchorNavigationList */
  anchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Retrieve document version */
  anchorNavigationListVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple anchorNavigationLists */
  anchorNavigationLists: Array<AnchorNavigationList>;
  /** Retrieve multiple anchorNavigationLists using the Relay connection interface */
  anchorNavigationListsConnection: AnchorNavigationListConnection;
  /** Retrieve document version */
  anchorNavigationVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple anchorNavigations */
  anchorNavigations: Array<AnchorNavigation>;
  /** Retrieve multiple anchorNavigations using the Relay connection interface */
  anchorNavigationsConnection: AnchorNavigationConnection;
  /** Retrieve multiple anchorNavs */
  anchorNavs: Array<AnchorNav>;
  /** Retrieve multiple anchorNavs using the Relay connection interface */
  anchorNavsConnection: AnchorNavConnection;
  /** Retrieve a single asset */
  asset?: Maybe<Asset>;
  /** Retrieve a single assetComponent */
  assetComponent?: Maybe<AssetComponent>;
  /** Retrieve document version */
  assetComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve document version */
  assetVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple assets */
  assets: Array<Asset>;
  /** Retrieve multiple assetsComponents */
  assetsComponents: Array<AssetComponent>;
  /** Retrieve multiple assetsComponents using the Relay connection interface */
  assetsComponentsConnection: AssetComponentConnection;
  /** Retrieve multiple assets using the Relay connection interface */
  assetsConnection: AssetConnection;
  /** Retrieve a single audioComponent */
  audioComponent?: Maybe<AudioComponent>;
  /** Retrieve document version */
  audioComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple audioComponents */
  audioComponents: Array<AudioComponent>;
  /** Retrieve multiple audioComponents using the Relay connection interface */
  audioComponentsConnection: AudioComponentConnection;
  /** Retrieve a single authorableContentCard */
  authorableContentCard?: Maybe<AuthorableContentCard>;
  /** Retrieve document version */
  authorableContentCardVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple authorableContentCards */
  authorableContentCards: Array<AuthorableContentCard>;
  /** Retrieve multiple authorableContentCards using the Relay connection interface */
  authorableContentCardsConnection: AuthorableContentCardConnection;
  /** Retrieve a single banner1 */
  banner1?: Maybe<Banner1>;
  /** Retrieve document version */
  banner1Version?: Maybe<DocumentVersion>;
  /** Retrieve multiple banner1s */
  banner1s: Array<Banner1>;
  /** Retrieve multiple banner1s using the Relay connection interface */
  banner1sConnection: Banner1Connection;
  /** Retrieve a single banner2 */
  banner2?: Maybe<Banner2>;
  /** Retrieve a single banner2CarouselComponent */
  banner2CarouselComponent?: Maybe<Banner2CarouselComponent>;
  /** Retrieve document version */
  banner2CarouselComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple banner2CarouselComponents */
  banner2CarouselComponents: Array<Banner2CarouselComponent>;
  /** Retrieve multiple banner2CarouselComponents using the Relay connection interface */
  banner2CarouselComponentsConnection: Banner2CarouselComponentConnection;
  /** Retrieve multiple banner2S */
  banner2S: Array<Banner2>;
  /** Retrieve multiple banner2S using the Relay connection interface */
  banner2SConnection: Banner2Connection;
  /** Retrieve document version */
  banner2Version?: Maybe<DocumentVersion>;
  /** Retrieve a single cardComponent */
  cardComponent?: Maybe<CardComponent>;
  /** Retrieve document version */
  cardComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cardComponents */
  cardComponents: Array<CardComponent>;
  /** Retrieve multiple cardComponents using the Relay connection interface */
  cardComponentsConnection: CardComponentConnection;
  /** Retrieve a single carouselComponent */
  carouselComponent?: Maybe<CarouselComponent>;
  /** Retrieve document version */
  carouselComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple carouselComponents */
  carouselComponents: Array<CarouselComponent>;
  /** Retrieve multiple carouselComponents using the Relay connection interface */
  carouselComponentsConnection: CarouselComponentConnection;
  /** Retrieve a single carouselSlide */
  carouselSlide?: Maybe<CarouselSlide>;
  /** Retrieve document version */
  carouselSlideVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple carouselSlides */
  carouselSlides: Array<CarouselSlide>;
  /** Retrieve multiple carouselSlides using the Relay connection interface */
  carouselSlidesConnection: CarouselSlideConnection;
  /** Retrieve a single categoryCard */
  categoryCard?: Maybe<CategoryCard>;
  /** Retrieve document version */
  categoryCardVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple categoryCards */
  categoryCards: Array<CategoryCard>;
  /** Retrieve multiple categoryCards using the Relay connection interface */
  categoryCardsConnection: CategoryCardConnection;
  /** Retrieve a single contactCard */
  contactCard?: Maybe<ContactCard>;
  /** Retrieve a single contactCardContainer */
  contactCardContainer?: Maybe<ContactCardContainer>;
  /** Retrieve document version */
  contactCardContainerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple contactCardContainers */
  contactCardContainers: Array<ContactCardContainer>;
  /** Retrieve multiple contactCardContainers using the Relay connection interface */
  contactCardContainersConnection: ContactCardContainerConnection;
  /** Retrieve document version */
  contactCardVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple contactCards */
  contactCards: Array<ContactCard>;
  /** Retrieve multiple contactCards using the Relay connection interface */
  contactCardsConnection: ContactCardConnection;
  /** Retrieve a single countrySelectorFooter */
  countrySelectorFooter?: Maybe<CountrySelectorFooter>;
  /** Retrieve document version */
  countrySelectorFooterVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple countrySelectorFooters */
  countrySelectorFooters: Array<CountrySelectorFooter>;
  /** Retrieve multiple countrySelectorFooters using the Relay connection interface */
  countrySelectorFootersConnection: CountrySelectorFooterConnection;
  /** Retrieve a single countrySelectorItem */
  countrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Retrieve document version */
  countrySelectorItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple countrySelectorItems */
  countrySelectorItems: Array<CountrySelectorItem>;
  /** Retrieve multiple countrySelectorItems using the Relay connection interface */
  countrySelectorItemsConnection: CountrySelectorItemConnection;
  /** Retrieve a single demoModel */
  demoModel?: Maybe<DemoModel>;
  /** Retrieve document version */
  demoModelVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple demoModels */
  demoModels: Array<DemoModel>;
  /** Retrieve multiple demoModels using the Relay connection interface */
  demoModelsConnection: DemoModelConnection;
  /** Retrieve multiple dictionaries */
  dictionaries: Array<Dictionary>;
  /** Retrieve multiple dictionaries using the Relay connection interface */
  dictionariesConnection: DictionaryConnection;
  /** Retrieve a single dictionary */
  dictionary?: Maybe<Dictionary>;
  /** Retrieve a single dictionaryItem */
  dictionaryItem?: Maybe<DictionaryItem>;
  /** Retrieve document version */
  dictionaryItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple dictionaryItems */
  dictionaryItems: Array<DictionaryItem>;
  /** Retrieve multiple dictionaryItems using the Relay connection interface */
  dictionaryItemsConnection: DictionaryItemConnection;
  /** Retrieve document version */
  dictionaryVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single downloadApp */
  downloadApp?: Maybe<DownloadApp>;
  /** Retrieve document version */
  downloadAppVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple downloadApps */
  downloadApps: Array<DownloadApp>;
  /** Retrieve multiple downloadApps using the Relay connection interface */
  downloadAppsConnection: DownloadAppConnection;
  /** Retrieve a single dynamicCardGrid */
  dynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Retrieve document version */
  dynamicCardGridVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple dynamicCardGrids */
  dynamicCardGrids: Array<DynamicCardGrid>;
  /** Retrieve multiple dynamicCardGrids using the Relay connection interface */
  dynamicCardGridsConnection: DynamicCardGridConnection;
  /** Fetches an object given its ID */
  entities?: Maybe<Array<Entity>>;
  /** Retrieve a single errorPage */
  errorPage?: Maybe<ErrorPage>;
  /** Retrieve document version */
  errorPageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple errorPages */
  errorPages: Array<ErrorPage>;
  /** Retrieve multiple errorPages using the Relay connection interface */
  errorPagesConnection: ErrorPageConnection;
  /** Retrieve a single evalancheFormComponent */
  evalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Retrieve document version */
  evalancheFormComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple evalancheFormComponents */
  evalancheFormComponents: Array<EvalancheFormComponent>;
  /** Retrieve multiple evalancheFormComponents using the Relay connection interface */
  evalancheFormComponentsConnection: EvalancheFormComponentConnection;
  /** Retrieve a single exampleComponent */
  exampleComponent?: Maybe<ExampleComponent>;
  /** Retrieve document version */
  exampleComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple exampleComponents */
  exampleComponents: Array<ExampleComponent>;
  /** Retrieve multiple exampleComponents using the Relay connection interface */
  exampleComponentsConnection: ExampleComponentConnection;
  /** Retrieve a single featuredContent */
  featuredContent?: Maybe<FeaturedContent>;
  /** Retrieve a single featuredContentReference */
  featuredContentReference?: Maybe<FeaturedContentReference>;
  /** Retrieve document version */
  featuredContentReferenceVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple featuredContentReferences */
  featuredContentReferences: Array<FeaturedContentReference>;
  /** Retrieve multiple featuredContentReferences using the Relay connection interface */
  featuredContentReferencesConnection: FeaturedContentReferenceConnection;
  /** Retrieve document version */
  featuredContentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple featuredContents */
  featuredContents: Array<FeaturedContent>;
  /** Retrieve multiple featuredContents using the Relay connection interface */
  featuredContentsConnection: FeaturedContentConnection;
  /** Retrieve a single footerNavigation */
  footerNavigation?: Maybe<FooterNavigation>;
  /** Retrieve document version */
  footerNavigationVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple footerNavigations */
  footerNavigations: Array<FooterNavigation>;
  /** Retrieve multiple footerNavigations using the Relay connection interface */
  footerNavigationsConnection: FooterNavigationConnection;
  /** Retrieve a single footerSeal */
  footerSeal?: Maybe<FooterSeal>;
  /** Retrieve document version */
  footerSealVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple footerSeals */
  footerSeals: Array<FooterSeal>;
  /** Retrieve multiple footerSeals using the Relay connection interface */
  footerSealsConnection: FooterSealConnection;
  /** Retrieve a single form */
  form?: Maybe<Form>;
  /** Retrieve a single formCheckbox */
  formCheckbox?: Maybe<FormCheckbox>;
  /** Retrieve a single formCheckboxCollection */
  formCheckboxCollection?: Maybe<FormCheckboxCollection>;
  /** Retrieve document version */
  formCheckboxCollectionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formCheckboxCollections */
  formCheckboxCollections: Array<FormCheckboxCollection>;
  /** Retrieve multiple formCheckboxCollections using the Relay connection interface */
  formCheckboxCollectionsConnection: FormCheckboxCollectionConnection;
  /** Retrieve document version */
  formCheckboxVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formCheckboxes */
  formCheckboxes: Array<FormCheckbox>;
  /** Retrieve multiple formCheckboxes using the Relay connection interface */
  formCheckboxesConnection: FormCheckboxConnection;
  /** Retrieve a single formDateInput */
  formDateInput?: Maybe<FormDateInput>;
  /** Retrieve document version */
  formDateInputVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formDateInputs */
  formDateInputs: Array<FormDateInput>;
  /** Retrieve multiple formDateInputs using the Relay connection interface */
  formDateInputsConnection: FormDateInputConnection;
  /** Retrieve a single formEmailInput */
  formEmailInput?: Maybe<FormEmailInput>;
  /** Retrieve document version */
  formEmailInputVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formEmailInputs */
  formEmailInputs: Array<FormEmailInput>;
  /** Retrieve multiple formEmailInputs using the Relay connection interface */
  formEmailInputsConnection: FormEmailInputConnection;
  /** Retrieve a single formError */
  formError?: Maybe<FormError>;
  /** Retrieve document version */
  formErrorVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formErrors */
  formErrors: Array<FormError>;
  /** Retrieve multiple formErrors using the Relay connection interface */
  formErrorsConnection: FormErrorConnection;
  /** Retrieve a single formFileUploader */
  formFileUploader?: Maybe<FormFileUploader>;
  /** Retrieve document version */
  formFileUploaderVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formFileUploaders */
  formFileUploaders: Array<FormFileUploader>;
  /** Retrieve multiple formFileUploaders using the Relay connection interface */
  formFileUploadersConnection: FormFileUploaderConnection;
  /** Retrieve a single formList */
  formList?: Maybe<FormList>;
  /** Retrieve a single formListItem */
  formListItem?: Maybe<FormListItem>;
  /** Retrieve document version */
  formListItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formListItems */
  formListItems: Array<FormListItem>;
  /** Retrieve multiple formListItems using the Relay connection interface */
  formListItemsConnection: FormListItemConnection;
  /** Retrieve document version */
  formListVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formLists */
  formLists: Array<FormList>;
  /** Retrieve multiple formLists using the Relay connection interface */
  formListsConnection: FormListConnection;
  /** Retrieve a single formNumberInput */
  formNumberInput?: Maybe<FormNumberInput>;
  /** Retrieve document version */
  formNumberInputVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formNumberInputs */
  formNumberInputs: Array<FormNumberInput>;
  /** Retrieve multiple formNumberInputs using the Relay connection interface */
  formNumberInputsConnection: FormNumberInputConnection;
  /** Retrieve a single formPasswordInput */
  formPasswordInput?: Maybe<FormPasswordInput>;
  /** Retrieve document version */
  formPasswordInputVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single formPasswordInputWithConfirmation */
  formPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Retrieve document version */
  formPasswordInputWithConfirmationVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formPasswordInputWithConfirmations */
  formPasswordInputWithConfirmations: Array<FormPasswordInputWithConfirmation>;
  /** Retrieve multiple formPasswordInputWithConfirmations using the Relay connection interface */
  formPasswordInputWithConfirmationsConnection: FormPasswordInputWithConfirmationConnection;
  /** Retrieve multiple formPasswordInputs */
  formPasswordInputs: Array<FormPasswordInput>;
  /** Retrieve multiple formPasswordInputs using the Relay connection interface */
  formPasswordInputsConnection: FormPasswordInputConnection;
  /** Retrieve a single formRadioButton */
  formRadioButton?: Maybe<FormRadioButton>;
  /** Retrieve a single formRadioButtonCollection */
  formRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Retrieve document version */
  formRadioButtonCollectionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formRadioButtonCollections */
  formRadioButtonCollections: Array<FormRadioButtonCollection>;
  /** Retrieve multiple formRadioButtonCollections using the Relay connection interface */
  formRadioButtonCollectionsConnection: FormRadioButtonCollectionConnection;
  /** Retrieve document version */
  formRadioButtonVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formRadioButtons */
  formRadioButtons: Array<FormRadioButton>;
  /** Retrieve multiple formRadioButtons using the Relay connection interface */
  formRadioButtonsConnection: FormRadioButtonConnection;
  /** Retrieve a single formSelectComponent */
  formSelectComponent?: Maybe<FormSelectComponent>;
  /** Retrieve document version */
  formSelectComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formSelectComponents */
  formSelectComponents: Array<FormSelectComponent>;
  /** Retrieve multiple formSelectComponents using the Relay connection interface */
  formSelectComponentsConnection: FormSelectComponentConnection;
  /** Retrieve a single formSelectOption */
  formSelectOption?: Maybe<FormSelectOption>;
  /** Retrieve document version */
  formSelectOptionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formSelectOptions */
  formSelectOptions: Array<FormSelectOption>;
  /** Retrieve multiple formSelectOptions using the Relay connection interface */
  formSelectOptionsConnection: FormSelectOptionConnection;
  /** Retrieve a single formSubmitButton */
  formSubmitButton?: Maybe<FormSubmitButton>;
  /** Retrieve document version */
  formSubmitButtonVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formSubmitButtons */
  formSubmitButtons: Array<FormSubmitButton>;
  /** Retrieve multiple formSubmitButtons using the Relay connection interface */
  formSubmitButtonsConnection: FormSubmitButtonConnection;
  /** Retrieve a single formSuccessComponent */
  formSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Retrieve document version */
  formSuccessComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formSuccessComponents */
  formSuccessComponents: Array<FormSuccessComponent>;
  /** Retrieve multiple formSuccessComponents using the Relay connection interface */
  formSuccessComponentsConnection: FormSuccessComponentConnection;
  /** Retrieve a single formTextInput */
  formTextInput?: Maybe<FormTextInput>;
  /** Retrieve document version */
  formTextInputVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formTextInputs */
  formTextInputs: Array<FormTextInput>;
  /** Retrieve multiple formTextInputs using the Relay connection interface */
  formTextInputsConnection: FormTextInputConnection;
  /** Retrieve a single formTextareaInput */
  formTextareaInput?: Maybe<FormTextareaInput>;
  /** Retrieve document version */
  formTextareaInputVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formTextareaInputs */
  formTextareaInputs: Array<FormTextareaInput>;
  /** Retrieve multiple formTextareaInputs using the Relay connection interface */
  formTextareaInputsConnection: FormTextareaInputConnection;
  /** Retrieve document version */
  formVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple forms */
  forms: Array<Form>;
  /** Retrieve multiple forms using the Relay connection interface */
  formsConnection: FormConnection;
  /** Retrieve a single genericAccordion */
  genericAccordion?: Maybe<GenericAccordion>;
  /** Retrieve a single genericAccordionItem */
  genericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Retrieve document version */
  genericAccordionItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericAccordionItems */
  genericAccordionItems: Array<GenericAccordionItem>;
  /** Retrieve multiple genericAccordionItems using the Relay connection interface */
  genericAccordionItemsConnection: GenericAccordionItemConnection;
  /** Retrieve a single genericAccordionTopRated */
  genericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Retrieve document version */
  genericAccordionTopRatedVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericAccordionTopRateds */
  genericAccordionTopRateds: Array<GenericAccordionTopRated>;
  /** Retrieve multiple genericAccordionTopRateds using the Relay connection interface */
  genericAccordionTopRatedsConnection: GenericAccordionTopRatedConnection;
  /** Retrieve document version */
  genericAccordionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericAccordions */
  genericAccordions: Array<GenericAccordion>;
  /** Retrieve multiple genericAccordions using the Relay connection interface */
  genericAccordionsConnection: GenericAccordionConnection;
  /** Retrieve a single genericCardCarouseComponent */
  genericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Retrieve document version */
  genericCardCarouseComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericCardCarouseComponents */
  genericCardCarouseComponents: Array<GenericCardCarouseComponent>;
  /** Retrieve multiple genericCardCarouseComponents using the Relay connection interface */
  genericCardCarouseComponentsConnection: GenericCardCarouseComponentConnection;
  /** Retrieve a single genericDownloadComponent */
  genericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Retrieve document version */
  genericDownloadComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericDownloadComponents */
  genericDownloadComponents: Array<GenericDownloadComponent>;
  /** Retrieve multiple genericDownloadComponents using the Relay connection interface */
  genericDownloadComponentsConnection: GenericDownloadComponentConnection;
  /** Retrieve a single genericFollowUs */
  genericFollowUs?: Maybe<GenericFollowUs>;
  /** Retrieve document version */
  genericFollowUsVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericFollowUses */
  genericFollowUses: Array<GenericFollowUs>;
  /** Retrieve multiple genericFollowUses using the Relay connection interface */
  genericFollowUsesConnection: GenericFollowUsConnection;
  /** Retrieve a single genericGridAuthorable */
  genericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Retrieve document version */
  genericGridAuthorableVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericGridAuthorables */
  genericGridAuthorables: Array<GenericGridAuthorable>;
  /** Retrieve multiple genericGridAuthorables using the Relay connection interface */
  genericGridAuthorablesConnection: GenericGridAuthorableConnection;
  /** Retrieve a single genericHtml */
  genericHtml?: Maybe<GenericHtml>;
  /** Retrieve document version */
  genericHtmlVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericHtmls */
  genericHtmls: Array<GenericHtml>;
  /** Retrieve multiple genericHtmls using the Relay connection interface */
  genericHtmlsConnection: GenericHtmlConnection;
  /** Retrieve a single genericLine */
  genericLine?: Maybe<GenericLine>;
  /** Retrieve document version */
  genericLineVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericLines */
  genericLines: Array<GenericLine>;
  /** Retrieve multiple genericLines using the Relay connection interface */
  genericLinesConnection: GenericLineConnection;
  /** Retrieve a single genericLink */
  genericLink?: Maybe<GenericLink>;
  /** Retrieve document version */
  genericLinkVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericLinks */
  genericLinks: Array<GenericLink>;
  /** Retrieve multiple genericLinks using the Relay connection interface */
  genericLinksConnection: GenericLinkConnection;
  /** Retrieve a single genericPage */
  genericPage?: Maybe<GenericPage>;
  /** Retrieve document version */
  genericPageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericPages */
  genericPages: Array<GenericPage>;
  /** Retrieve multiple genericPages using the Relay connection interface */
  genericPagesConnection: GenericPageConnection;
  /** Retrieve a single genericPromotionsOverview */
  genericPromotionsOverview?: Maybe<GenericPromotionsOverview>;
  /** Retrieve document version */
  genericPromotionsOverviewVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericPromotionsOverviews */
  genericPromotionsOverviews: Array<GenericPromotionsOverview>;
  /** Retrieve multiple genericPromotionsOverviews using the Relay connection interface */
  genericPromotionsOverviewsConnection: GenericPromotionsOverviewConnection;
  /** Retrieve a single genericQualifio */
  genericQualifio?: Maybe<GenericQualifio>;
  /** Retrieve a single genericQualifioOverview */
  genericQualifioOverview?: Maybe<GenericQualifioOverview>;
  /** Retrieve document version */
  genericQualifioOverviewVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericQualifioOverviews */
  genericQualifioOverviews: Array<GenericQualifioOverview>;
  /** Retrieve multiple genericQualifioOverviews using the Relay connection interface */
  genericQualifioOverviewsConnection: GenericQualifioOverviewConnection;
  /** Retrieve document version */
  genericQualifioVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericQualifios */
  genericQualifios: Array<GenericQualifio>;
  /** Retrieve multiple genericQualifios using the Relay connection interface */
  genericQualifiosConnection: GenericQualifioConnection;
  /** Retrieve a single genericSocialShare */
  genericSocialShare?: Maybe<GenericSocialShare>;
  /** Retrieve document version */
  genericSocialShareVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericSocialShares */
  genericSocialShares: Array<GenericSocialShare>;
  /** Retrieve multiple genericSocialShares using the Relay connection interface */
  genericSocialSharesConnection: GenericSocialShareConnection;
  /** Retrieve a single globalMetaData */
  globalMetaData?: Maybe<GlobalMetaData>;
  /** Retrieve document version */
  globalMetaDataVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple globalMetaDatas */
  globalMetaDatas: Array<GlobalMetaData>;
  /** Retrieve multiple globalMetaDatas using the Relay connection interface */
  globalMetaDatasConnection: GlobalMetaDataConnection;
  /** Retrieve a single globalSearch */
  globalSearch?: Maybe<GlobalSearch>;
  /** Retrieve document version */
  globalSearchVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple globalSearches */
  globalSearches: Array<GlobalSearch>;
  /** Retrieve multiple globalSearches using the Relay connection interface */
  globalSearchesConnection: GlobalSearchConnection;
  /** Retrieve a single gridColumn */
  gridColumn?: Maybe<GridColumn>;
  /** Retrieve a single gridColumnComponent */
  gridColumnComponent?: Maybe<GridColumnComponent>;
  /** Retrieve document version */
  gridColumnComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple gridColumnComponents */
  gridColumnComponents: Array<GridColumnComponent>;
  /** Retrieve multiple gridColumnComponents using the Relay connection interface */
  gridColumnComponentsConnection: GridColumnComponentConnection;
  /** Retrieve document version */
  gridColumnVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple gridColumns */
  gridColumns: Array<GridColumn>;
  /** Retrieve multiple gridColumns using the Relay connection interface */
  gridColumnsConnection: GridColumnConnection;
  /** Retrieve a single heroBanner */
  heroBanner?: Maybe<HeroBanner>;
  /** Retrieve a single heroBannerMasterbrand */
  heroBannerMasterbrand?: Maybe<HeroBannerMasterbrand>;
  /** Retrieve document version */
  heroBannerMasterbrandVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple heroBannerMasterbrands */
  heroBannerMasterbrands: Array<HeroBannerMasterbrand>;
  /** Retrieve multiple heroBannerMasterbrands using the Relay connection interface */
  heroBannerMasterbrandsConnection: HeroBannerMasterbrandConnection;
  /** Retrieve document version */
  heroBannerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple heroBanners */
  heroBanners: Array<HeroBanner>;
  /** Retrieve multiple heroBanners using the Relay connection interface */
  heroBannersConnection: HeroBannerConnection;
  /** Retrieve a single heroCarouselComponent */
  heroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Retrieve document version */
  heroCarouselComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple heroCarouselComponents */
  heroCarouselComponents: Array<HeroCarouselComponent>;
  /** Retrieve multiple heroCarouselComponents using the Relay connection interface */
  heroCarouselComponentsConnection: HeroCarouselComponentConnection;
  /** Retrieve a single heroComponent */
  heroComponent?: Maybe<HeroComponent>;
  /** Retrieve document version */
  heroComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple heroComponents */
  heroComponents: Array<HeroComponent>;
  /** Retrieve multiple heroComponents using the Relay connection interface */
  heroComponentsConnection: HeroComponentConnection;
  /** Retrieve a single heroLoopAnimationComponent */
  heroLoopAnimationComponent?: Maybe<HeroLoopAnimationComponent>;
  /** Retrieve document version */
  heroLoopAnimationComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple heroLoopAnimationComponents */
  heroLoopAnimationComponents: Array<HeroLoopAnimationComponent>;
  /** Retrieve multiple heroLoopAnimationComponents using the Relay connection interface */
  heroLoopAnimationComponentsConnection: HeroLoopAnimationComponentConnection;
  /** Retrieve a single iframe */
  iframe?: Maybe<Iframe>;
  /** Retrieve document version */
  iframeVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple iframes */
  iframes: Array<Iframe>;
  /** Retrieve multiple iframes using the Relay connection interface */
  iframesConnection: IframeConnection;
  /** Retrieve a single imageAndTextCard */
  imageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Retrieve document version */
  imageAndTextCardVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple imageAndTextCards */
  imageAndTextCards: Array<ImageAndTextCard>;
  /** Retrieve multiple imageAndTextCards using the Relay connection interface */
  imageAndTextCardsConnection: ImageAndTextCardConnection;
  /** Retrieve multiple imageCopies */
  imageCopies: Array<ImageCopy>;
  /** Retrieve multiple imageCopies using the Relay connection interface */
  imageCopiesConnection: ImageCopyConnection;
  /** Retrieve a single imageCopy */
  imageCopy?: Maybe<ImageCopy>;
  /** Retrieve a single imageCopyItem */
  imageCopyItem?: Maybe<ImageCopyItem>;
  /** Retrieve document version */
  imageCopyItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple imageCopyItems */
  imageCopyItems: Array<ImageCopyItem>;
  /** Retrieve multiple imageCopyItems using the Relay connection interface */
  imageCopyItemsConnection: ImageCopyItemConnection;
  /** Retrieve document version */
  imageCopyVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single introText */
  introText?: Maybe<IntroText>;
  /** Retrieve document version */
  introTextVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple introTexts */
  introTexts: Array<IntroText>;
  /** Retrieve multiple introTexts using the Relay connection interface */
  introTextsConnection: IntroTextConnection;
  /** Retrieve a single leftColumn */
  leftColumn?: Maybe<LeftColumn>;
  /** Retrieve document version */
  leftColumnVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple leftColumns */
  leftColumns: Array<LeftColumn>;
  /** Retrieve multiple leftColumns using the Relay connection interface */
  leftColumnsConnection: LeftColumnConnection;
  /** Retrieve a single link */
  link?: Maybe<Link>;
  /** Retrieve document version */
  linkVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple links */
  links: Array<Link>;
  /** Retrieve multiple links using the Relay connection interface */
  linksConnection: LinkConnection;
  /** Retrieve a single longText */
  longText?: Maybe<LongText>;
  /** Retrieve document version */
  longTextVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple longTexts */
  longTexts: Array<LongText>;
  /** Retrieve multiple longTexts using the Relay connection interface */
  longTextsConnection: LongTextConnection;
  /** Retrieve a single market */
  market?: Maybe<Market>;
  /** Retrieve a single marketUserConnection */
  marketUserConnection?: Maybe<MarketUserConnection>;
  /** Retrieve document version */
  marketUserConnectionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple marketUserConnections */
  marketUserConnections: Array<MarketUserConnection>;
  /** Retrieve multiple marketUserConnections using the Relay connection interface */
  marketUserConnectionsConnection: MarketUserConnectionConnection;
  /** Retrieve document version */
  marketVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple markets */
  markets: Array<Market>;
  /** Retrieve multiple markets using the Relay connection interface */
  marketsConnection: MarketConnection;
  /** Retrieve a single metaData */
  metaData?: Maybe<MetaData>;
  /** Retrieve document version */
  metaDataVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple metaDatas */
  metaDatas: Array<MetaData>;
  /** Retrieve multiple metaDatas using the Relay connection interface */
  metaDatasConnection: MetaDataConnection;
  /** Retrieve a single mobileOnlyMainNavigation */
  mobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Retrieve document version */
  mobileOnlyMainNavigationVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple mobileOnlyMainNavigations */
  mobileOnlyMainNavigations: Array<MobileOnlyMainNavigation>;
  /** Retrieve multiple mobileOnlyMainNavigations using the Relay connection interface */
  mobileOnlyMainNavigationsConnection: MobileOnlyMainNavigationConnection;
  /** Retrieve a single multiStepPromotionForm */
  multiStepPromotionForm?: Maybe<MultiStepPromotionForm>;
  /** Retrieve document version */
  multiStepPromotionFormVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple multiStepPromotionForms */
  multiStepPromotionForms: Array<MultiStepPromotionForm>;
  /** Retrieve multiple multiStepPromotionForms using the Relay connection interface */
  multiStepPromotionFormsConnection: MultiStepPromotionFormConnection;
  /** Retrieve a single navigation */
  navigation?: Maybe<Navigation>;
  /** Retrieve a single navigationItem */
  navigationItem?: Maybe<NavigationItem>;
  /** Retrieve document version */
  navigationItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple navigationItems */
  navigationItems: Array<NavigationItem>;
  /** Retrieve multiple navigationItems using the Relay connection interface */
  navigationItemsConnection: NavigationItemConnection;
  /** Retrieve document version */
  navigationVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple navigations */
  navigations: Array<Navigation>;
  /** Retrieve multiple navigations using the Relay connection interface */
  navigationsConnection: NavigationConnection;
  /** Retrieve a single newsletterComponent */
  newsletterComponent?: Maybe<NewsletterComponent>;
  /** Retrieve document version */
  newsletterComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple newsletterComponents */
  newsletterComponents: Array<NewsletterComponent>;
  /** Retrieve multiple newsletterComponents using the Relay connection interface */
  newsletterComponentsConnection: NewsletterComponentConnection;
  /** Retrieve a single newsletterSubscriptions */
  newsletterSubscriptions?: Maybe<NewsletterSubscriptions>;
  /** Retrieve multiple newsletterSubscriptionsPlural */
  newsletterSubscriptionsPlural: Array<NewsletterSubscriptions>;
  /** Retrieve multiple newsletterSubscriptionsPlural using the Relay connection interface */
  newsletterSubscriptionsPluralConnection: NewsletterSubscriptionsConnection;
  /** Retrieve document version */
  newsletterSubscriptionsVersion?: Maybe<DocumentVersion>;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  /** Retrieve a single notificationBanner */
  notificationBanner?: Maybe<NotificationBanner>;
  /** Retrieve document version */
  notificationBannerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple notificationBanners */
  notificationBanners: Array<NotificationBanner>;
  /** Retrieve multiple notificationBanners using the Relay connection interface */
  notificationBannersConnection: NotificationBannerConnection;
  /** Retrieve a single pageFooter */
  pageFooter?: Maybe<PageFooter>;
  /** Retrieve document version */
  pageFooterVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple pageFooters */
  pageFooters: Array<PageFooter>;
  /** Retrieve multiple pageFooters using the Relay connection interface */
  pageFootersConnection: PageFooterConnection;
  /** Retrieve a single pageHeader */
  pageHeader?: Maybe<PageHeader>;
  /** Retrieve document version */
  pageHeaderVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple pageHeaders */
  pageHeaders: Array<PageHeader>;
  /** Retrieve multiple pageHeaders using the Relay connection interface */
  pageHeadersConnection: PageHeaderConnection;
  /** Retrieve a single popularSearchComponent */
  popularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Retrieve document version */
  popularSearchComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple popularSearchComponents */
  popularSearchComponents: Array<PopularSearchComponent>;
  /** Retrieve multiple popularSearchComponents using the Relay connection interface */
  popularSearchComponentsConnection: PopularSearchComponentConnection;
  /** Retrieve a single product */
  product?: Maybe<Product>;
  /** Retrieve a single productBanner */
  productBanner?: Maybe<ProductBanner>;
  /** Retrieve document version */
  productBannerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple productBanners */
  productBanners: Array<ProductBanner>;
  /** Retrieve multiple productBanners using the Relay connection interface */
  productBannersConnection: ProductBannerConnection;
  /** Retrieve multiple productCategories */
  productCategories: Array<ProductCategory>;
  /** Retrieve multiple productCategories using the Relay connection interface */
  productCategoriesConnection: ProductCategoryConnection;
  /** Retrieve a single productCategory */
  productCategory?: Maybe<ProductCategory>;
  /** Retrieve a single productCategoryPage */
  productCategoryPage?: Maybe<ProductCategoryPage>;
  /** Retrieve document version */
  productCategoryPageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple productCategoryPages */
  productCategoryPages: Array<ProductCategoryPage>;
  /** Retrieve multiple productCategoryPages using the Relay connection interface */
  productCategoryPagesConnection: ProductCategoryPageConnection;
  /** Retrieve document version */
  productCategoryVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single productDetailPage */
  productDetailPage?: Maybe<ProductDetailPage>;
  /** Retrieve document version */
  productDetailPageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple productDetailPages */
  productDetailPages: Array<ProductDetailPage>;
  /** Retrieve multiple productDetailPages using the Relay connection interface */
  productDetailPagesConnection: ProductDetailPageConnection;
  /** Retrieve a single productHero */
  productHero?: Maybe<ProductHero>;
  /** Retrieve document version */
  productHeroVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple productHeroes */
  productHeroes: Array<ProductHero>;
  /** Retrieve multiple productHeroes using the Relay connection interface */
  productHeroesConnection: ProductHeroConnection;
  /** Retrieve a single productLabel */
  productLabel?: Maybe<ProductLabel>;
  /** Retrieve document version */
  productLabelVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple productLabels */
  productLabels: Array<ProductLabel>;
  /** Retrieve multiple productLabels using the Relay connection interface */
  productLabelsConnection: ProductLabelConnection;
  /** Retrieve a single productLandingPage */
  productLandingPage?: Maybe<ProductLandingPage>;
  /** Retrieve document version */
  productLandingPageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple productLandingPages */
  productLandingPages: Array<ProductLandingPage>;
  /** Retrieve multiple productLandingPages using the Relay connection interface */
  productLandingPagesConnection: ProductLandingPageConnection;
  /** Retrieve a single productSubcategoryPage */
  productSubcategoryPage?: Maybe<ProductSubcategoryPage>;
  /** Retrieve document version */
  productSubcategoryPageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple productSubcategoryPages */
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** Retrieve multiple productSubcategoryPages using the Relay connection interface */
  productSubcategoryPagesConnection: ProductSubcategoryPageConnection;
  /** Retrieve document version */
  productVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple products */
  products: Array<Product>;
  /** Retrieve multiple products using the Relay connection interface */
  productsConnection: ProductConnection;
  /** Retrieve a single promotionDownload */
  promotionDownload?: Maybe<PromotionDownload>;
  /** Retrieve document version */
  promotionDownloadVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple promotionDownloads */
  promotionDownloads: Array<PromotionDownload>;
  /** Retrieve multiple promotionDownloads using the Relay connection interface */
  promotionDownloadsConnection: PromotionDownloadConnection;
  /** Retrieve a single promotionForm */
  promotionForm?: Maybe<PromotionForm>;
  /** Retrieve document version */
  promotionFormVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple promotionForms */
  promotionForms: Array<PromotionForm>;
  /** Retrieve multiple promotionForms using the Relay connection interface */
  promotionFormsConnection: PromotionFormConnection;
  /** Retrieve a single question */
  question?: Maybe<Question>;
  /** Retrieve a single questionCheckbox */
  questionCheckbox?: Maybe<QuestionCheckbox>;
  /** Retrieve a single questionCheckboxCollection */
  questionCheckboxCollection?: Maybe<QuestionCheckboxCollection>;
  /** Retrieve document version */
  questionCheckboxCollectionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple questionCheckboxCollections */
  questionCheckboxCollections: Array<QuestionCheckboxCollection>;
  /** Retrieve multiple questionCheckboxCollections using the Relay connection interface */
  questionCheckboxCollectionsConnection: QuestionCheckboxCollectionConnection;
  /** Retrieve document version */
  questionCheckboxVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple questionCheckboxes */
  questionCheckboxes: Array<QuestionCheckbox>;
  /** Retrieve multiple questionCheckboxes using the Relay connection interface */
  questionCheckboxesConnection: QuestionCheckboxConnection;
  /** Retrieve a single questionRadioButton */
  questionRadioButton?: Maybe<QuestionRadioButton>;
  /** Retrieve a single questionRadioButtonCollection */
  questionRadioButtonCollection?: Maybe<QuestionRadioButtonCollection>;
  /** Retrieve document version */
  questionRadioButtonCollectionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple questionRadioButtonCollections */
  questionRadioButtonCollections: Array<QuestionRadioButtonCollection>;
  /** Retrieve multiple questionRadioButtonCollections using the Relay connection interface */
  questionRadioButtonCollectionsConnection: QuestionRadioButtonCollectionConnection;
  /** Retrieve document version */
  questionRadioButtonVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple questionRadioButtons */
  questionRadioButtons: Array<QuestionRadioButton>;
  /** Retrieve multiple questionRadioButtons using the Relay connection interface */
  questionRadioButtonsConnection: QuestionRadioButtonConnection;
  /** Retrieve document version */
  questionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple questions */
  questions: Array<Question>;
  /** Retrieve multiple questions using the Relay connection interface */
  questionsConnection: QuestionConnection;
  /** Retrieve a single rating */
  rating?: Maybe<Rating>;
  /** Retrieve document version */
  ratingVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple ratings */
  ratings: Array<Rating>;
  /** Retrieve multiple ratings using the Relay connection interface */
  ratingsConnection: RatingConnection;
  /** Retrieve a single recipe */
  recipe?: Maybe<Recipe>;
  /** Retrieve multiple recipeCategories */
  recipeCategories: Array<RecipeCategory>;
  /** Retrieve multiple recipeCategories using the Relay connection interface */
  recipeCategoriesConnection: RecipeCategoryConnection;
  /** Retrieve a single recipeCategory */
  recipeCategory?: Maybe<RecipeCategory>;
  /** Retrieve document version */
  recipeCategoryVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single recipeLandingPage */
  recipeLandingPage?: Maybe<RecipeLandingPage>;
  /** Retrieve document version */
  recipeLandingPageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple recipeLandingPages */
  recipeLandingPages: Array<RecipeLandingPage>;
  /** Retrieve multiple recipeLandingPages using the Relay connection interface */
  recipeLandingPagesConnection: RecipeLandingPageConnection;
  /** Retrieve multiple recipeSubcategories */
  recipeSubcategories: Array<RecipeSubcategory>;
  /** Retrieve multiple recipeSubcategories using the Relay connection interface */
  recipeSubcategoriesConnection: RecipeSubcategoryConnection;
  /** Retrieve a single recipeSubcategory */
  recipeSubcategory?: Maybe<RecipeSubcategory>;
  /** Retrieve document version */
  recipeSubcategoryVersion?: Maybe<DocumentVersion>;
  /** Retrieve document version */
  recipeVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple recipes */
  recipes: Array<Recipe>;
  /** Retrieve a single recipesComparisonQueryComponent */
  recipesComparisonQueryComponent?: Maybe<RecipesComparisonQueryComponent>;
  /** Retrieve document version */
  recipesComparisonQueryComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple recipesComparisonQueryComponents */
  recipesComparisonQueryComponents: Array<RecipesComparisonQueryComponent>;
  /** Retrieve multiple recipesComparisonQueryComponents using the Relay connection interface */
  recipesComparisonQueryComponentsConnection: RecipesComparisonQueryComponentConnection;
  /** Retrieve multiple recipes using the Relay connection interface */
  recipesConnection: RecipeConnection;
  /** Retrieve a single recipesQueriesReference */
  recipesQueriesReference?: Maybe<RecipesQueriesReference>;
  /** Retrieve document version */
  recipesQueriesReferenceVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple recipesQueriesReferences */
  recipesQueriesReferences: Array<RecipesQueriesReference>;
  /** Retrieve multiple recipesQueriesReferences using the Relay connection interface */
  recipesQueriesReferencesConnection: RecipesQueriesReferenceConnection;
  /** Retrieve a single recipesQueryComponent */
  recipesQueryComponent?: Maybe<RecipesQueryComponent>;
  /** Retrieve document version */
  recipesQueryComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple recipesQueryComponents */
  recipesQueryComponents: Array<RecipesQueryComponent>;
  /** Retrieve multiple recipesQueryComponents using the Relay connection interface */
  recipesQueryComponentsConnection: RecipesQueryComponentConnection;
  /** Retrieve a single redirect */
  redirect?: Maybe<Redirect>;
  /** Retrieve document version */
  redirectVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple redirects */
  redirects: Array<Redirect>;
  /** Retrieve multiple redirects using the Relay connection interface */
  redirectsConnection: RedirectConnection;
  /** Retrieve a single rewrite */
  rewrite?: Maybe<Rewrite>;
  /** Retrieve document version */
  rewriteVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple rewrites */
  rewrites: Array<Rewrite>;
  /** Retrieve multiple rewrites using the Relay connection interface */
  rewritesConnection: RewriteConnection;
  /** Retrieve a single rightColumn */
  rightColumn?: Maybe<RightColumn>;
  /** Retrieve document version */
  rightColumnVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple rightColumns */
  rightColumns: Array<RightColumn>;
  /** Retrieve multiple rightColumns using the Relay connection interface */
  rightColumnsConnection: RightColumnConnection;
  /** Retrieve a single scheduledOperation */
  scheduledOperation?: Maybe<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations */
  scheduledOperations: Array<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations using the Relay connection interface */
  scheduledOperationsConnection: ScheduledOperationConnection;
  /** Retrieve a single scheduledRelease */
  scheduledRelease?: Maybe<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases */
  scheduledReleases: Array<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases using the Relay connection interface */
  scheduledReleasesConnection: ScheduledReleaseConnection;
  /** Retrieve a single searchInput */
  searchInput?: Maybe<SearchInput>;
  /** Retrieve document version */
  searchInputVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple searchInputs */
  searchInputs: Array<SearchInput>;
  /** Retrieve multiple searchInputs using the Relay connection interface */
  searchInputsConnection: SearchInputConnection;
  /** Retrieve a single searchOverlayComponent */
  searchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Retrieve document version */
  searchOverlayComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple searchOverlayComponents */
  searchOverlayComponents: Array<SearchOverlayComponent>;
  /** Retrieve multiple searchOverlayComponents using the Relay connection interface */
  searchOverlayComponentsConnection: SearchOverlayComponentConnection;
  /** Retrieve a single searchResultPage */
  searchResultPage?: Maybe<SearchResultPage>;
  /** Retrieve document version */
  searchResultPageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple searchResultPages */
  searchResultPages: Array<SearchResultPage>;
  /** Retrieve multiple searchResultPages using the Relay connection interface */
  searchResultPagesConnection: SearchResultPageConnection;
  /** Retrieve a single separator */
  separator?: Maybe<Separator>;
  /** Retrieve document version */
  separatorVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple separators */
  separators: Array<Separator>;
  /** Retrieve multiple separators using the Relay connection interface */
  separatorsConnection: SeparatorConnection;
  /** Retrieve a single singleStepPromotionForm */
  singleStepPromotionForm?: Maybe<SingleStepPromotionForm>;
  /** Retrieve document version */
  singleStepPromotionFormVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple singleStepPromotionForms */
  singleStepPromotionForms: Array<SingleStepPromotionForm>;
  /** Retrieve multiple singleStepPromotionForms using the Relay connection interface */
  singleStepPromotionFormsConnection: SingleStepPromotionFormConnection;
  /** Retrieve a single socialMediaListComponent */
  socialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Retrieve document version */
  socialMediaListComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple socialMediaListComponents */
  socialMediaListComponents: Array<SocialMediaListComponent>;
  /** Retrieve multiple socialMediaListComponents using the Relay connection interface */
  socialMediaListComponentsConnection: SocialMediaListComponentConnection;
  /** Retrieve a single spacer */
  spacer?: Maybe<Spacer>;
  /** Retrieve document version */
  spacerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple spacers */
  spacers: Array<Spacer>;
  /** Retrieve multiple spacers using the Relay connection interface */
  spacersConnection: SpacerConnection;
  /** Retrieve a single subCategoryKeyImage */
  subCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Retrieve document version */
  subCategoryKeyImageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple subCategoryKeyImages */
  subCategoryKeyImages: Array<SubCategoryKeyImage>;
  /** Retrieve multiple subCategoryKeyImages using the Relay connection interface */
  subCategoryKeyImagesConnection: SubCategoryKeyImageConnection;
  /** Retrieve a single subTab */
  subTab?: Maybe<SubTab>;
  /** Retrieve a single subTabContent */
  subTabContent?: Maybe<SubTabContent>;
  /** Retrieve document version */
  subTabContentVersion?: Maybe<DocumentVersion>;
  /** Retrieve document version */
  subTabVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple subTabs */
  subTabs: Array<SubTab>;
  /** Retrieve multiple subTabs using the Relay connection interface */
  subTabsConnection: SubTabConnection;
  /** Retrieve multiple subTabsContent */
  subTabsContent: Array<SubTabContent>;
  /** Retrieve multiple subTabsContent using the Relay connection interface */
  subTabsContentConnection: SubTabContentConnection;
  /** Retrieve a single sustainabilityBanner */
  sustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Retrieve document version */
  sustainabilityBannerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple sustainabilityBanners */
  sustainabilityBanners: Array<SustainabilityBanner>;
  /** Retrieve multiple sustainabilityBanners using the Relay connection interface */
  sustainabilityBannersConnection: SustainabilityBannerConnection;
  /** Retrieve a single sustainabilityInfo */
  sustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Retrieve document version */
  sustainabilityInfoVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple sustainabilityInfos */
  sustainabilityInfos: Array<SustainabilityInfo>;
  /** Retrieve multiple sustainabilityInfos using the Relay connection interface */
  sustainabilityInfosConnection: SustainabilityInfoConnection;
  /** Retrieve a single tab */
  tab?: Maybe<Tab>;
  /** Retrieve a single tabContent */
  tabContent?: Maybe<TabContent>;
  /** Retrieve document version */
  tabContentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple tabContents */
  tabContents: Array<TabContent>;
  /** Retrieve multiple tabContents using the Relay connection interface */
  tabContentsConnection: TabContentConnection;
  /** Retrieve document version */
  tabVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple tabs */
  tabs: Array<Tab>;
  /** Retrieve multiple tabs using the Relay connection interface */
  tabsConnection: TabConnection;
  /** Retrieve a single teaser */
  teaser?: Maybe<Teaser>;
  /** Retrieve a single teaserPlaceholder */
  teaserPlaceholder?: Maybe<TeaserPlaceholder>;
  /** Retrieve document version */
  teaserPlaceholderVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple teaserPlaceholders */
  teaserPlaceholders: Array<TeaserPlaceholder>;
  /** Retrieve multiple teaserPlaceholders using the Relay connection interface */
  teaserPlaceholdersConnection: TeaserPlaceholderConnection;
  /** Retrieve a single teaserSmall */
  teaserSmall?: Maybe<TeaserSmall>;
  /** Retrieve a single teaserSmallPlaceholder */
  teaserSmallPlaceholder?: Maybe<TeaserSmallPlaceholder>;
  /** Retrieve document version */
  teaserSmallPlaceholderVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple teaserSmallPlaceholders */
  teaserSmallPlaceholders: Array<TeaserSmallPlaceholder>;
  /** Retrieve multiple teaserSmallPlaceholders using the Relay connection interface */
  teaserSmallPlaceholdersConnection: TeaserSmallPlaceholderConnection;
  /** Retrieve document version */
  teaserSmallVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple teaserSmalls */
  teaserSmalls: Array<TeaserSmall>;
  /** Retrieve multiple teaserSmalls using the Relay connection interface */
  teaserSmallsConnection: TeaserSmallConnection;
  /** Retrieve document version */
  teaserVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple teasers */
  teasers: Array<Teaser>;
  /** Retrieve multiple teasers using the Relay connection interface */
  teasersConnection: TeaserConnection;
  /** Retrieve multiple testComponentWithRecipeQueries */
  testComponentWithRecipeQueries: Array<TestComponentWithRecipeQuery>;
  /** Retrieve multiple testComponentWithRecipeQueries using the Relay connection interface */
  testComponentWithRecipeQueriesConnection: TestComponentWithRecipeQueryConnection;
  /** Retrieve a single testComponentWithRecipeQuery */
  testComponentWithRecipeQuery?: Maybe<TestComponentWithRecipeQuery>;
  /** Retrieve document version */
  testComponentWithRecipeQueryVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single testTipsANdTricksInAMarket */
  testTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Retrieve document version */
  testTipsANdTricksInAMarketVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple testTipsANdTricksInAMarkets */
  testTipsANdTricksInAMarkets: Array<TestTipsANdTricksInAMarket>;
  /** Retrieve multiple testTipsANdTricksInAMarkets using the Relay connection interface */
  testTipsANdTricksInAMarketsConnection: TestTipsANdTricksInAMarketConnection;
  /** Retrieve a single textComponent */
  textComponent?: Maybe<TextComponent>;
  /** Retrieve document version */
  textComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple textComponents */
  textComponents: Array<TextComponent>;
  /** Retrieve multiple textComponents using the Relay connection interface */
  textComponentsConnection: TextComponentConnection;
  /** Retrieve a single tipsAndTricksDetailsPage */
  tipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Retrieve document version */
  tipsAndTricksDetailsPageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple tipsAndTricksDetailsPages */
  tipsAndTricksDetailsPages: Array<TipsAndTricksDetailsPage>;
  /** Retrieve multiple tipsAndTricksDetailsPages using the Relay connection interface */
  tipsAndTricksDetailsPagesConnection: TipsAndTricksDetailsPageConnection;
  /** Retrieve a single title */
  title?: Maybe<Title>;
  /** Retrieve document version */
  titleVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple titles */
  titles: Array<Title>;
  /** Retrieve multiple titles using the Relay connection interface */
  titlesConnection: TitleConnection;
  /** Retrieve a single twitterSeo */
  twitterSeo?: Maybe<TwitterSeo>;
  /** Retrieve document version */
  twitterSeoVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple twitterSeos */
  twitterSeos: Array<TwitterSeo>;
  /** Retrieve multiple twitterSeos using the Relay connection interface */
  twitterSeosConnection: TwitterSeoConnection;
  /** Retrieve a single user */
  user?: Maybe<User>;
  /** Retrieve multiple users */
  users: Array<User>;
  /** Retrieve multiple users using the Relay connection interface */
  usersConnection: UserConnection;
};


export type QueryAccordionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AccordionWhereUniqueInput;
};


export type QueryAccordionItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AccordionItemWhereUniqueInput;
};


export type QueryAccordionItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AccordionItemWhereInput>;
};


export type QueryAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AccordionItemWhereInput>;
};


export type QueryAccordionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAccordionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AccordionWhereInput>;
};


export type QueryAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AccordionWhereInput>;
};


export type QueryAlgoliaExtensionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AlgoliaExtensionWhereUniqueInput;
};


export type QueryAlgoliaExtensionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAlgoliaExtensionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AlgoliaExtensionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AlgoliaExtensionWhereInput>;
};


export type QueryAlgoliaExtensionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AlgoliaExtensionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AlgoliaExtensionWhereInput>;
};


export type QueryAnchorNavArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AnchorNavWhereUniqueInput;
};


export type QueryAnchorNavVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAnchorNavigationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AnchorNavigationWhereUniqueInput;
};


export type QueryAnchorNavigationListArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AnchorNavigationListWhereUniqueInput;
};


export type QueryAnchorNavigationListVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAnchorNavigationListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AnchorNavigationListOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AnchorNavigationListWhereInput>;
};


export type QueryAnchorNavigationListsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AnchorNavigationListOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AnchorNavigationListWhereInput>;
};


export type QueryAnchorNavigationVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAnchorNavigationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AnchorNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AnchorNavigationWhereInput>;
};


export type QueryAnchorNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AnchorNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AnchorNavigationWhereInput>;
};


export type QueryAnchorNavsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AnchorNavOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AnchorNavWhereInput>;
};


export type QueryAnchorNavsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AnchorNavOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AnchorNavWhereInput>;
};


export type QueryAssetArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AssetWhereUniqueInput;
};


export type QueryAssetComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AssetComponentWhereUniqueInput;
};


export type QueryAssetComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAssetVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryAssetsComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetComponentWhereInput>;
};


export type QueryAssetsComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetComponentWhereInput>;
};


export type QueryAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryAudioComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AudioComponentWhereUniqueInput;
};


export type QueryAudioComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAudioComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AudioComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AudioComponentWhereInput>;
};


export type QueryAudioComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AudioComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AudioComponentWhereInput>;
};


export type QueryAuthorableContentCardArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AuthorableContentCardWhereUniqueInput;
};


export type QueryAuthorableContentCardVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAuthorableContentCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AuthorableContentCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AuthorableContentCardWhereInput>;
};


export type QueryAuthorableContentCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AuthorableContentCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AuthorableContentCardWhereInput>;
};


export type QueryBanner1Args = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: Banner1WhereUniqueInput;
};


export type QueryBanner1VersionArgs = {
  where: VersionWhereInput;
};


export type QueryBanner1sArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<Banner1OrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<Banner1WhereInput>;
};


export type QueryBanner1sConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<Banner1OrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<Banner1WhereInput>;
};


export type QueryBanner2Args = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: Banner2WhereUniqueInput;
};


export type QueryBanner2CarouselComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: Banner2CarouselComponentWhereUniqueInput;
};


export type QueryBanner2CarouselComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryBanner2CarouselComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<Banner2CarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<Banner2CarouselComponentWhereInput>;
};


export type QueryBanner2CarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<Banner2CarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<Banner2CarouselComponentWhereInput>;
};


export type QueryBanner2SArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<Banner2OrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<Banner2WhereInput>;
};


export type QueryBanner2SConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<Banner2OrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<Banner2WhereInput>;
};


export type QueryBanner2VersionArgs = {
  where: VersionWhereInput;
};


export type QueryCardComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CardComponentWhereUniqueInput;
};


export type QueryCardComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCardComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CardComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CardComponentWhereInput>;
};


export type QueryCardComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CardComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CardComponentWhereInput>;
};


export type QueryCarouselComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CarouselComponentWhereUniqueInput;
};


export type QueryCarouselComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCarouselComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CarouselComponentWhereInput>;
};


export type QueryCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CarouselComponentWhereInput>;
};


export type QueryCarouselSlideArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CarouselSlideWhereUniqueInput;
};


export type QueryCarouselSlideVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCarouselSlidesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CarouselSlideOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CarouselSlideWhereInput>;
};


export type QueryCarouselSlidesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CarouselSlideOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CarouselSlideWhereInput>;
};


export type QueryCategoryCardArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CategoryCardWhereUniqueInput;
};


export type QueryCategoryCardVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCategoryCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CategoryCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CategoryCardWhereInput>;
};


export type QueryCategoryCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CategoryCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CategoryCardWhereInput>;
};


export type QueryContactCardArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ContactCardWhereUniqueInput;
};


export type QueryContactCardContainerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ContactCardContainerWhereUniqueInput;
};


export type QueryContactCardContainerVersionArgs = {
  where: VersionWhereInput;
};


export type QueryContactCardContainersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContactCardContainerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContactCardContainerWhereInput>;
};


export type QueryContactCardContainersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContactCardContainerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContactCardContainerWhereInput>;
};


export type QueryContactCardVersionArgs = {
  where: VersionWhereInput;
};


export type QueryContactCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContactCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContactCardWhereInput>;
};


export type QueryContactCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContactCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContactCardWhereInput>;
};


export type QueryCountrySelectorFooterArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CountrySelectorFooterWhereUniqueInput;
};


export type QueryCountrySelectorFooterVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCountrySelectorFootersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CountrySelectorFooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CountrySelectorFooterWhereInput>;
};


export type QueryCountrySelectorFootersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CountrySelectorFooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CountrySelectorFooterWhereInput>;
};


export type QueryCountrySelectorItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CountrySelectorItemWhereUniqueInput;
};


export type QueryCountrySelectorItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCountrySelectorItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CountrySelectorItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CountrySelectorItemWhereInput>;
};


export type QueryCountrySelectorItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CountrySelectorItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CountrySelectorItemWhereInput>;
};


export type QueryDemoModelArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: DemoModelWhereUniqueInput;
};


export type QueryDemoModelVersionArgs = {
  where: VersionWhereInput;
};


export type QueryDemoModelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DemoModelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DemoModelWhereInput>;
};


export type QueryDemoModelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DemoModelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DemoModelWhereInput>;
};


export type QueryDictionariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DictionaryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DictionaryWhereInput>;
};


export type QueryDictionariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DictionaryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DictionaryWhereInput>;
};


export type QueryDictionaryArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: DictionaryWhereUniqueInput;
};


export type QueryDictionaryItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: DictionaryItemWhereUniqueInput;
};


export type QueryDictionaryItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryDictionaryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DictionaryItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DictionaryItemWhereInput>;
};


export type QueryDictionaryItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DictionaryItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DictionaryItemWhereInput>;
};


export type QueryDictionaryVersionArgs = {
  where: VersionWhereInput;
};


export type QueryDownloadAppArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: DownloadAppWhereUniqueInput;
};


export type QueryDownloadAppVersionArgs = {
  where: VersionWhereInput;
};


export type QueryDownloadAppsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DownloadAppOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DownloadAppWhereInput>;
};


export type QueryDownloadAppsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DownloadAppOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DownloadAppWhereInput>;
};


export type QueryDynamicCardGridArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: DynamicCardGridWhereUniqueInput;
};


export type QueryDynamicCardGridVersionArgs = {
  where: VersionWhereInput;
};


export type QueryDynamicCardGridsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DynamicCardGridOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DynamicCardGridWhereInput>;
};


export type QueryDynamicCardGridsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DynamicCardGridOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DynamicCardGridWhereInput>;
};


export type QueryEntitiesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  where: Array<EntityWhereInput>;
};


export type QueryErrorPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ErrorPageWhereUniqueInput;
};


export type QueryErrorPageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryErrorPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ErrorPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ErrorPageWhereInput>;
};


export type QueryErrorPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ErrorPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ErrorPageWhereInput>;
};


export type QueryEvalancheFormComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: EvalancheFormComponentWhereUniqueInput;
};


export type QueryEvalancheFormComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryEvalancheFormComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<EvalancheFormComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<EvalancheFormComponentWhereInput>;
};


export type QueryEvalancheFormComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<EvalancheFormComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<EvalancheFormComponentWhereInput>;
};


export type QueryExampleComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ExampleComponentWhereUniqueInput;
};


export type QueryExampleComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryExampleComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ExampleComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ExampleComponentWhereInput>;
};


export type QueryExampleComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ExampleComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ExampleComponentWhereInput>;
};


export type QueryFeaturedContentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FeaturedContentWhereUniqueInput;
};


export type QueryFeaturedContentReferenceArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FeaturedContentReferenceWhereUniqueInput;
};


export type QueryFeaturedContentReferenceVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFeaturedContentReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FeaturedContentReferenceOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FeaturedContentReferenceWhereInput>;
};


export type QueryFeaturedContentReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FeaturedContentReferenceOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FeaturedContentReferenceWhereInput>;
};


export type QueryFeaturedContentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFeaturedContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FeaturedContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FeaturedContentWhereInput>;
};


export type QueryFeaturedContentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FeaturedContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FeaturedContentWhereInput>;
};


export type QueryFooterNavigationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FooterNavigationWhereUniqueInput;
};


export type QueryFooterNavigationVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFooterNavigationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FooterNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FooterNavigationWhereInput>;
};


export type QueryFooterNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FooterNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FooterNavigationWhereInput>;
};


export type QueryFooterSealArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FooterSealWhereUniqueInput;
};


export type QueryFooterSealVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFooterSealsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FooterSealOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FooterSealWhereInput>;
};


export type QueryFooterSealsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FooterSealOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FooterSealWhereInput>;
};


export type QueryFormArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormWhereUniqueInput;
};


export type QueryFormCheckboxArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormCheckboxWhereUniqueInput;
};


export type QueryFormCheckboxCollectionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormCheckboxCollectionWhereUniqueInput;
};


export type QueryFormCheckboxCollectionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormCheckboxCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormCheckboxCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormCheckboxCollectionWhereInput>;
};


export type QueryFormCheckboxCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormCheckboxCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormCheckboxCollectionWhereInput>;
};


export type QueryFormCheckboxVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormCheckboxesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormCheckboxOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormCheckboxWhereInput>;
};


export type QueryFormCheckboxesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormCheckboxOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormCheckboxWhereInput>;
};


export type QueryFormDateInputArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormDateInputWhereUniqueInput;
};


export type QueryFormDateInputVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormDateInputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormDateInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormDateInputWhereInput>;
};


export type QueryFormDateInputsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormDateInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormDateInputWhereInput>;
};


export type QueryFormEmailInputArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormEmailInputWhereUniqueInput;
};


export type QueryFormEmailInputVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormEmailInputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormEmailInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormEmailInputWhereInput>;
};


export type QueryFormEmailInputsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormEmailInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormEmailInputWhereInput>;
};


export type QueryFormErrorArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormErrorWhereUniqueInput;
};


export type QueryFormErrorVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormErrorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormErrorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormErrorWhereInput>;
};


export type QueryFormErrorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormErrorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormErrorWhereInput>;
};


export type QueryFormFileUploaderArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormFileUploaderWhereUniqueInput;
};


export type QueryFormFileUploaderVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormFileUploadersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormFileUploaderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormFileUploaderWhereInput>;
};


export type QueryFormFileUploadersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormFileUploaderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormFileUploaderWhereInput>;
};


export type QueryFormListArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormListWhereUniqueInput;
};


export type QueryFormListItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormListItemWhereUniqueInput;
};


export type QueryFormListItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormListItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormListItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormListItemWhereInput>;
};


export type QueryFormListItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormListItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormListItemWhereInput>;
};


export type QueryFormListVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormListOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormListWhereInput>;
};


export type QueryFormListsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormListOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormListWhereInput>;
};


export type QueryFormNumberInputArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormNumberInputWhereUniqueInput;
};


export type QueryFormNumberInputVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormNumberInputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormNumberInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormNumberInputWhereInput>;
};


export type QueryFormNumberInputsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormNumberInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormNumberInputWhereInput>;
};


export type QueryFormPasswordInputArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormPasswordInputWhereUniqueInput;
};


export type QueryFormPasswordInputVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormPasswordInputWithConfirmationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};


export type QueryFormPasswordInputWithConfirmationVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormPasswordInputWithConfirmationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormPasswordInputWithConfirmationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormPasswordInputWithConfirmationWhereInput>;
};


export type QueryFormPasswordInputWithConfirmationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormPasswordInputWithConfirmationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormPasswordInputWithConfirmationWhereInput>;
};


export type QueryFormPasswordInputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormPasswordInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormPasswordInputWhereInput>;
};


export type QueryFormPasswordInputsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormPasswordInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormPasswordInputWhereInput>;
};


export type QueryFormRadioButtonArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormRadioButtonWhereUniqueInput;
};


export type QueryFormRadioButtonCollectionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormRadioButtonCollectionWhereUniqueInput;
};


export type QueryFormRadioButtonCollectionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormRadioButtonCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormRadioButtonCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormRadioButtonCollectionWhereInput>;
};


export type QueryFormRadioButtonCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormRadioButtonCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormRadioButtonCollectionWhereInput>;
};


export type QueryFormRadioButtonVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormRadioButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormRadioButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormRadioButtonWhereInput>;
};


export type QueryFormRadioButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormRadioButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormRadioButtonWhereInput>;
};


export type QueryFormSelectComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormSelectComponentWhereUniqueInput;
};


export type QueryFormSelectComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormSelectComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormSelectComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormSelectComponentWhereInput>;
};


export type QueryFormSelectComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormSelectComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormSelectComponentWhereInput>;
};


export type QueryFormSelectOptionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormSelectOptionWhereUniqueInput;
};


export type QueryFormSelectOptionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormSelectOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormSelectOptionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormSelectOptionWhereInput>;
};


export type QueryFormSelectOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormSelectOptionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormSelectOptionWhereInput>;
};


export type QueryFormSubmitButtonArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormSubmitButtonWhereUniqueInput;
};


export type QueryFormSubmitButtonVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormSubmitButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormSubmitButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormSubmitButtonWhereInput>;
};


export type QueryFormSubmitButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormSubmitButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormSubmitButtonWhereInput>;
};


export type QueryFormSuccessComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormSuccessComponentWhereUniqueInput;
};


export type QueryFormSuccessComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormSuccessComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormSuccessComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormSuccessComponentWhereInput>;
};


export type QueryFormSuccessComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormSuccessComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormSuccessComponentWhereInput>;
};


export type QueryFormTextInputArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormTextInputWhereUniqueInput;
};


export type QueryFormTextInputVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormTextInputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormTextInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormTextInputWhereInput>;
};


export type QueryFormTextInputsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormTextInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormTextInputWhereInput>;
};


export type QueryFormTextareaInputArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormTextareaInputWhereUniqueInput;
};


export type QueryFormTextareaInputVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormTextareaInputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormTextareaInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormTextareaInputWhereInput>;
};


export type QueryFormTextareaInputsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormTextareaInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormTextareaInputWhereInput>;
};


export type QueryFormVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormWhereInput>;
};


export type QueryFormsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormWhereInput>;
};


export type QueryGenericAccordionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericAccordionWhereUniqueInput;
};


export type QueryGenericAccordionItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericAccordionItemWhereUniqueInput;
};


export type QueryGenericAccordionItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericAccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericAccordionItemWhereInput>;
};


export type QueryGenericAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericAccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericAccordionItemWhereInput>;
};


export type QueryGenericAccordionTopRatedArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericAccordionTopRatedWhereUniqueInput;
};


export type QueryGenericAccordionTopRatedVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericAccordionTopRatedsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericAccordionTopRatedOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericAccordionTopRatedWhereInput>;
};


export type QueryGenericAccordionTopRatedsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericAccordionTopRatedOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericAccordionTopRatedWhereInput>;
};


export type QueryGenericAccordionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericAccordionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericAccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericAccordionWhereInput>;
};


export type QueryGenericAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericAccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericAccordionWhereInput>;
};


export type QueryGenericCardCarouseComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericCardCarouseComponentWhereUniqueInput;
};


export type QueryGenericCardCarouseComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericCardCarouseComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericCardCarouseComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericCardCarouseComponentWhereInput>;
};


export type QueryGenericCardCarouseComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericCardCarouseComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericCardCarouseComponentWhereInput>;
};


export type QueryGenericDownloadComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericDownloadComponentWhereUniqueInput;
};


export type QueryGenericDownloadComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericDownloadComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericDownloadComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericDownloadComponentWhereInput>;
};


export type QueryGenericDownloadComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericDownloadComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericDownloadComponentWhereInput>;
};


export type QueryGenericFollowUsArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericFollowUsWhereUniqueInput;
};


export type QueryGenericFollowUsVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericFollowUsesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericFollowUsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericFollowUsWhereInput>;
};


export type QueryGenericFollowUsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericFollowUsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericFollowUsWhereInput>;
};


export type QueryGenericGridAuthorableArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericGridAuthorableWhereUniqueInput;
};


export type QueryGenericGridAuthorableVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericGridAuthorablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericGridAuthorableOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericGridAuthorableWhereInput>;
};


export type QueryGenericGridAuthorablesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericGridAuthorableOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericGridAuthorableWhereInput>;
};


export type QueryGenericHtmlArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericHtmlWhereUniqueInput;
};


export type QueryGenericHtmlVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericHtmlsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericHtmlOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericHtmlWhereInput>;
};


export type QueryGenericHtmlsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericHtmlOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericHtmlWhereInput>;
};


export type QueryGenericLineArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericLineWhereUniqueInput;
};


export type QueryGenericLineVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericLineOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericLineWhereInput>;
};


export type QueryGenericLinesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericLineOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericLineWhereInput>;
};


export type QueryGenericLinkArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericLinkWhereUniqueInput;
};


export type QueryGenericLinkVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericLinkWhereInput>;
};


export type QueryGenericLinksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericLinkWhereInput>;
};


export type QueryGenericPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericPageWhereUniqueInput;
};


export type QueryGenericPageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type QueryGenericPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type QueryGenericPromotionsOverviewArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericPromotionsOverviewWhereUniqueInput;
};


export type QueryGenericPromotionsOverviewVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericPromotionsOverviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericPromotionsOverviewOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericPromotionsOverviewWhereInput>;
};


export type QueryGenericPromotionsOverviewsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericPromotionsOverviewOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericPromotionsOverviewWhereInput>;
};


export type QueryGenericQualifioArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericQualifioWhereUniqueInput;
};


export type QueryGenericQualifioOverviewArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericQualifioOverviewWhereUniqueInput;
};


export type QueryGenericQualifioOverviewVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericQualifioOverviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericQualifioOverviewOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericQualifioOverviewWhereInput>;
};


export type QueryGenericQualifioOverviewsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericQualifioOverviewOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericQualifioOverviewWhereInput>;
};


export type QueryGenericQualifioVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericQualifiosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericQualifioOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericQualifioWhereInput>;
};


export type QueryGenericQualifiosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericQualifioOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericQualifioWhereInput>;
};


export type QueryGenericSocialShareArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericSocialShareWhereUniqueInput;
};


export type QueryGenericSocialShareVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericSocialSharesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericSocialShareOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericSocialShareWhereInput>;
};


export type QueryGenericSocialSharesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericSocialShareOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericSocialShareWhereInput>;
};


export type QueryGlobalMetaDataArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GlobalMetaDataWhereUniqueInput;
};


export type QueryGlobalMetaDataVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGlobalMetaDatasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GlobalMetaDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GlobalMetaDataWhereInput>;
};


export type QueryGlobalMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GlobalMetaDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GlobalMetaDataWhereInput>;
};


export type QueryGlobalSearchArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GlobalSearchWhereUniqueInput;
};


export type QueryGlobalSearchVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGlobalSearchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GlobalSearchOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GlobalSearchWhereInput>;
};


export type QueryGlobalSearchesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GlobalSearchOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GlobalSearchWhereInput>;
};


export type QueryGridColumnArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GridColumnWhereUniqueInput;
};


export type QueryGridColumnComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GridColumnComponentWhereUniqueInput;
};


export type QueryGridColumnComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGridColumnComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GridColumnComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GridColumnComponentWhereInput>;
};


export type QueryGridColumnComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GridColumnComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GridColumnComponentWhereInput>;
};


export type QueryGridColumnVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGridColumnsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GridColumnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GridColumnWhereInput>;
};


export type QueryGridColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GridColumnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GridColumnWhereInput>;
};


export type QueryHeroBannerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: HeroBannerWhereUniqueInput;
};


export type QueryHeroBannerMasterbrandArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: HeroBannerMasterbrandWhereUniqueInput;
};


export type QueryHeroBannerMasterbrandVersionArgs = {
  where: VersionWhereInput;
};


export type QueryHeroBannerMasterbrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeroBannerMasterbrandOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HeroBannerMasterbrandWhereInput>;
};


export type QueryHeroBannerMasterbrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeroBannerMasterbrandOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HeroBannerMasterbrandWhereInput>;
};


export type QueryHeroBannerVersionArgs = {
  where: VersionWhereInput;
};


export type QueryHeroBannersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeroBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HeroBannerWhereInput>;
};


export type QueryHeroBannersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeroBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HeroBannerWhereInput>;
};


export type QueryHeroCarouselComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: HeroCarouselComponentWhereUniqueInput;
};


export type QueryHeroCarouselComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryHeroCarouselComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeroCarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HeroCarouselComponentWhereInput>;
};


export type QueryHeroCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeroCarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HeroCarouselComponentWhereInput>;
};


export type QueryHeroComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: HeroComponentWhereUniqueInput;
};


export type QueryHeroComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryHeroComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeroComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HeroComponentWhereInput>;
};


export type QueryHeroComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeroComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HeroComponentWhereInput>;
};


export type QueryHeroLoopAnimationComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: HeroLoopAnimationComponentWhereUniqueInput;
};


export type QueryHeroLoopAnimationComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryHeroLoopAnimationComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeroLoopAnimationComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HeroLoopAnimationComponentWhereInput>;
};


export type QueryHeroLoopAnimationComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeroLoopAnimationComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HeroLoopAnimationComponentWhereInput>;
};


export type QueryIframeArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: IframeWhereUniqueInput;
};


export type QueryIframeVersionArgs = {
  where: VersionWhereInput;
};


export type QueryIframesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<IframeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<IframeWhereInput>;
};


export type QueryIframesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<IframeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<IframeWhereInput>;
};


export type QueryImageAndTextCardArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ImageAndTextCardWhereUniqueInput;
};


export type QueryImageAndTextCardVersionArgs = {
  where: VersionWhereInput;
};


export type QueryImageAndTextCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ImageAndTextCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ImageAndTextCardWhereInput>;
};


export type QueryImageAndTextCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ImageAndTextCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ImageAndTextCardWhereInput>;
};


export type QueryImageCopiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ImageCopyOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ImageCopyWhereInput>;
};


export type QueryImageCopiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ImageCopyOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ImageCopyWhereInput>;
};


export type QueryImageCopyArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ImageCopyWhereUniqueInput;
};


export type QueryImageCopyItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ImageCopyItemWhereUniqueInput;
};


export type QueryImageCopyItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryImageCopyItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ImageCopyItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ImageCopyItemWhereInput>;
};


export type QueryImageCopyItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ImageCopyItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ImageCopyItemWhereInput>;
};


export type QueryImageCopyVersionArgs = {
  where: VersionWhereInput;
};


export type QueryIntroTextArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: IntroTextWhereUniqueInput;
};


export type QueryIntroTextVersionArgs = {
  where: VersionWhereInput;
};


export type QueryIntroTextsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<IntroTextOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<IntroTextWhereInput>;
};


export type QueryIntroTextsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<IntroTextOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<IntroTextWhereInput>;
};


export type QueryLeftColumnArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: LeftColumnWhereUniqueInput;
};


export type QueryLeftColumnVersionArgs = {
  where: VersionWhereInput;
};


export type QueryLeftColumnsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LeftColumnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LeftColumnWhereInput>;
};


export type QueryLeftColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LeftColumnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LeftColumnWhereInput>;
};


export type QueryLinkArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: LinkWhereUniqueInput;
};


export type QueryLinkVersionArgs = {
  where: VersionWhereInput;
};


export type QueryLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LinkWhereInput>;
};


export type QueryLinksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LinkWhereInput>;
};


export type QueryLongTextArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: LongTextWhereUniqueInput;
};


export type QueryLongTextVersionArgs = {
  where: VersionWhereInput;
};


export type QueryLongTextsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LongTextOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LongTextWhereInput>;
};


export type QueryLongTextsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LongTextOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LongTextWhereInput>;
};


export type QueryMarketArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: MarketWhereUniqueInput;
};


export type QueryMarketUserConnectionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: MarketUserConnectionWhereUniqueInput;
};


export type QueryMarketUserConnectionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryMarketUserConnectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MarketUserConnectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MarketUserConnectionWhereInput>;
};


export type QueryMarketUserConnectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MarketUserConnectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MarketUserConnectionWhereInput>;
};


export type QueryMarketVersionArgs = {
  where: VersionWhereInput;
};


export type QueryMarketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MarketOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MarketWhereInput>;
};


export type QueryMarketsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MarketOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MarketWhereInput>;
};


export type QueryMetaDataArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: MetaDataWhereUniqueInput;
};


export type QueryMetaDataVersionArgs = {
  where: VersionWhereInput;
};


export type QueryMetaDatasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MetaDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MetaDataWhereInput>;
};


export type QueryMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MetaDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MetaDataWhereInput>;
};


export type QueryMobileOnlyMainNavigationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: MobileOnlyMainNavigationWhereUniqueInput;
};


export type QueryMobileOnlyMainNavigationVersionArgs = {
  where: VersionWhereInput;
};


export type QueryMobileOnlyMainNavigationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MobileOnlyMainNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MobileOnlyMainNavigationWhereInput>;
};


export type QueryMobileOnlyMainNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MobileOnlyMainNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MobileOnlyMainNavigationWhereInput>;
};


export type QueryMultiStepPromotionFormArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: MultiStepPromotionFormWhereUniqueInput;
};


export type QueryMultiStepPromotionFormVersionArgs = {
  where: VersionWhereInput;
};


export type QueryMultiStepPromotionFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MultiStepPromotionFormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MultiStepPromotionFormWhereInput>;
};


export type QueryMultiStepPromotionFormsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MultiStepPromotionFormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MultiStepPromotionFormWhereInput>;
};


export type QueryNavigationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: NavigationWhereUniqueInput;
};


export type QueryNavigationItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: NavigationItemWhereUniqueInput;
};


export type QueryNavigationItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryNavigationItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NavigationItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NavigationItemWhereInput>;
};


export type QueryNavigationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NavigationItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NavigationItemWhereInput>;
};


export type QueryNavigationVersionArgs = {
  where: VersionWhereInput;
};


export type QueryNavigationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NavigationWhereInput>;
};


export type QueryNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NavigationWhereInput>;
};


export type QueryNewsletterComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: NewsletterComponentWhereUniqueInput;
};


export type QueryNewsletterComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryNewsletterComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NewsletterComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NewsletterComponentWhereInput>;
};


export type QueryNewsletterComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NewsletterComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NewsletterComponentWhereInput>;
};


export type QueryNewsletterSubscriptionsArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: NewsletterSubscriptionsWhereUniqueInput;
};


export type QueryNewsletterSubscriptionsPluralArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NewsletterSubscriptionsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NewsletterSubscriptionsWhereInput>;
};


export type QueryNewsletterSubscriptionsPluralConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NewsletterSubscriptionsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NewsletterSubscriptionsWhereInput>;
};


export type QueryNewsletterSubscriptionsVersionArgs = {
  where: VersionWhereInput;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
  locales?: Array<Locale>;
  stage?: Stage;
};


export type QueryNotificationBannerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: NotificationBannerWhereUniqueInput;
};


export type QueryNotificationBannerVersionArgs = {
  where: VersionWhereInput;
};


export type QueryNotificationBannersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NotificationBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NotificationBannerWhereInput>;
};


export type QueryNotificationBannersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NotificationBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NotificationBannerWhereInput>;
};


export type QueryPageFooterArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PageFooterWhereUniqueInput;
};


export type QueryPageFooterVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPageFootersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PageFooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PageFooterWhereInput>;
};


export type QueryPageFootersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PageFooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PageFooterWhereInput>;
};


export type QueryPageHeaderArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PageHeaderWhereUniqueInput;
};


export type QueryPageHeaderVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPageHeadersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PageHeaderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PageHeaderWhereInput>;
};


export type QueryPageHeadersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PageHeaderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PageHeaderWhereInput>;
};


export type QueryPopularSearchComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PopularSearchComponentWhereUniqueInput;
};


export type QueryPopularSearchComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPopularSearchComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PopularSearchComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PopularSearchComponentWhereInput>;
};


export type QueryPopularSearchComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PopularSearchComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PopularSearchComponentWhereInput>;
};


export type QueryProductArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ProductWhereUniqueInput;
};


export type QueryProductBannerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ProductBannerWhereUniqueInput;
};


export type QueryProductBannerVersionArgs = {
  where: VersionWhereInput;
};


export type QueryProductBannersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductBannerWhereInput>;
};


export type QueryProductBannersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductBannerWhereInput>;
};


export type QueryProductCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductCategoryWhereInput>;
};


export type QueryProductCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductCategoryWhereInput>;
};


export type QueryProductCategoryArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ProductCategoryWhereUniqueInput;
};


export type QueryProductCategoryPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ProductCategoryPageWhereUniqueInput;
};


export type QueryProductCategoryPageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductCategoryPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


export type QueryProductCategoryPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductCategoryPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


export type QueryProductCategoryVersionArgs = {
  where: VersionWhereInput;
};


export type QueryProductDetailPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ProductDetailPageWhereUniqueInput;
};


export type QueryProductDetailPageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryProductDetailPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductDetailPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductDetailPageWhereInput>;
};


export type QueryProductDetailPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductDetailPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductDetailPageWhereInput>;
};


export type QueryProductHeroArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ProductHeroWhereUniqueInput;
};


export type QueryProductHeroVersionArgs = {
  where: VersionWhereInput;
};


export type QueryProductHeroesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductHeroOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductHeroWhereInput>;
};


export type QueryProductHeroesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductHeroOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductHeroWhereInput>;
};


export type QueryProductLabelArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ProductLabelWhereUniqueInput;
};


export type QueryProductLabelVersionArgs = {
  where: VersionWhereInput;
};


export type QueryProductLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductLabelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductLabelWhereInput>;
};


export type QueryProductLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductLabelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductLabelWhereInput>;
};


export type QueryProductLandingPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ProductLandingPageWhereUniqueInput;
};


export type QueryProductLandingPageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductLandingPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


export type QueryProductLandingPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductLandingPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


export type QueryProductSubcategoryPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ProductSubcategoryPageWhereUniqueInput;
};


export type QueryProductSubcategoryPageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductSubcategoryPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


export type QueryProductSubcategoryPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductSubcategoryPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


export type QueryProductVersionArgs = {
  where: VersionWhereInput;
};


export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductWhereInput>;
};


export type QueryProductsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProductOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProductWhereInput>;
};


export type QueryPromotionDownloadArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PromotionDownloadWhereUniqueInput;
};


export type QueryPromotionDownloadVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPromotionDownloadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PromotionDownloadOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PromotionDownloadWhereInput>;
};


export type QueryPromotionDownloadsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PromotionDownloadOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PromotionDownloadWhereInput>;
};


export type QueryPromotionFormArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PromotionFormWhereUniqueInput;
};


export type QueryPromotionFormVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPromotionFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PromotionFormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PromotionFormWhereInput>;
};


export type QueryPromotionFormsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PromotionFormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PromotionFormWhereInput>;
};


export type QueryQuestionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: QuestionWhereUniqueInput;
};


export type QueryQuestionCheckboxArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: QuestionCheckboxWhereUniqueInput;
};


export type QueryQuestionCheckboxCollectionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: QuestionCheckboxCollectionWhereUniqueInput;
};


export type QueryQuestionCheckboxCollectionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryQuestionCheckboxCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuestionCheckboxCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<QuestionCheckboxCollectionWhereInput>;
};


export type QueryQuestionCheckboxCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuestionCheckboxCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<QuestionCheckboxCollectionWhereInput>;
};


export type QueryQuestionCheckboxVersionArgs = {
  where: VersionWhereInput;
};


export type QueryQuestionCheckboxesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuestionCheckboxOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<QuestionCheckboxWhereInput>;
};


export type QueryQuestionCheckboxesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuestionCheckboxOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<QuestionCheckboxWhereInput>;
};


export type QueryQuestionRadioButtonArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: QuestionRadioButtonWhereUniqueInput;
};


export type QueryQuestionRadioButtonCollectionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: QuestionRadioButtonCollectionWhereUniqueInput;
};


export type QueryQuestionRadioButtonCollectionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryQuestionRadioButtonCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuestionRadioButtonCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<QuestionRadioButtonCollectionWhereInput>;
};


export type QueryQuestionRadioButtonCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuestionRadioButtonCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<QuestionRadioButtonCollectionWhereInput>;
};


export type QueryQuestionRadioButtonVersionArgs = {
  where: VersionWhereInput;
};


export type QueryQuestionRadioButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuestionRadioButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<QuestionRadioButtonWhereInput>;
};


export type QueryQuestionRadioButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuestionRadioButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<QuestionRadioButtonWhereInput>;
};


export type QueryQuestionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuestionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<QuestionWhereInput>;
};


export type QueryQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuestionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<QuestionWhereInput>;
};


export type QueryRatingArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RatingWhereUniqueInput;
};


export type QueryRatingVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRatingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RatingOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RatingWhereInput>;
};


export type QueryRatingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RatingOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RatingWhereInput>;
};


export type QueryRecipeArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RecipeWhereUniqueInput;
};


export type QueryRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RecipeCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type QueryRecipeCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RecipeCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type QueryRecipeCategoryArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RecipeCategoryWhereUniqueInput;
};


export type QueryRecipeCategoryVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRecipeLandingPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RecipeLandingPageWhereUniqueInput;
};


export type QueryRecipeLandingPageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RecipeLandingPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


export type QueryRecipeLandingPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RecipeLandingPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


export type QueryRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RecipeSubcategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


export type QueryRecipeSubcategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RecipeSubcategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


export type QueryRecipeSubcategoryArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RecipeSubcategoryWhereUniqueInput;
};


export type QueryRecipeSubcategoryVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRecipeVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRecipesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RecipeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RecipeWhereInput>;
};


export type QueryRecipesComparisonQueryComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RecipesComparisonQueryComponentWhereUniqueInput;
};


export type QueryRecipesComparisonQueryComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRecipesComparisonQueryComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RecipesComparisonQueryComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RecipesComparisonQueryComponentWhereInput>;
};


export type QueryRecipesComparisonQueryComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RecipesComparisonQueryComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RecipesComparisonQueryComponentWhereInput>;
};


export type QueryRecipesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RecipeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RecipeWhereInput>;
};


export type QueryRecipesQueriesReferenceArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RecipesQueriesReferenceWhereUniqueInput;
};


export type QueryRecipesQueriesReferenceVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRecipesQueriesReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RecipesQueriesReferenceOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RecipesQueriesReferenceWhereInput>;
};


export type QueryRecipesQueriesReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RecipesQueriesReferenceOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RecipesQueriesReferenceWhereInput>;
};


export type QueryRecipesQueryComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RecipesQueryComponentWhereUniqueInput;
};


export type QueryRecipesQueryComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRecipesQueryComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RecipesQueryComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RecipesQueryComponentWhereInput>;
};


export type QueryRecipesQueryComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RecipesQueryComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RecipesQueryComponentWhereInput>;
};


export type QueryRedirectArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RedirectWhereUniqueInput;
};


export type QueryRedirectVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRedirectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RedirectOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RedirectWhereInput>;
};


export type QueryRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RedirectOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RedirectWhereInput>;
};


export type QueryRewriteArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RewriteWhereUniqueInput;
};


export type QueryRewriteVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRewritesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RewriteOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RewriteWhereInput>;
};


export type QueryRewritesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RewriteOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RewriteWhereInput>;
};


export type QueryRightColumnArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RightColumnWhereUniqueInput;
};


export type QueryRightColumnVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRightColumnsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RightColumnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RightColumnWhereInput>;
};


export type QueryRightColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RightColumnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RightColumnWhereInput>;
};


export type QueryScheduledOperationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledOperationWhereUniqueInput;
};


export type QueryScheduledOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QueryScheduledOperationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QueryScheduledReleaseArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledReleaseWhereUniqueInput;
};


export type QueryScheduledReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type QueryScheduledReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type QuerySearchInputArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SearchInputWhereUniqueInput;
};


export type QuerySearchInputVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySearchInputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SearchInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SearchInputWhereInput>;
};


export type QuerySearchInputsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SearchInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SearchInputWhereInput>;
};


export type QuerySearchOverlayComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SearchOverlayComponentWhereUniqueInput;
};


export type QuerySearchOverlayComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySearchOverlayComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SearchOverlayComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SearchOverlayComponentWhereInput>;
};


export type QuerySearchOverlayComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SearchOverlayComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SearchOverlayComponentWhereInput>;
};


export type QuerySearchResultPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SearchResultPageWhereUniqueInput;
};


export type QuerySearchResultPageVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySearchResultPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SearchResultPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SearchResultPageWhereInput>;
};


export type QuerySearchResultPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SearchResultPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SearchResultPageWhereInput>;
};


export type QuerySeparatorArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SeparatorWhereUniqueInput;
};


export type QuerySeparatorVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySeparatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SeparatorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SeparatorWhereInput>;
};


export type QuerySeparatorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SeparatorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SeparatorWhereInput>;
};


export type QuerySingleStepPromotionFormArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SingleStepPromotionFormWhereUniqueInput;
};


export type QuerySingleStepPromotionFormVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySingleStepPromotionFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SingleStepPromotionFormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SingleStepPromotionFormWhereInput>;
};


export type QuerySingleStepPromotionFormsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SingleStepPromotionFormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SingleStepPromotionFormWhereInput>;
};


export type QuerySocialMediaListComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SocialMediaListComponentWhereUniqueInput;
};


export type QuerySocialMediaListComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySocialMediaListComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SocialMediaListComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SocialMediaListComponentWhereInput>;
};


export type QuerySocialMediaListComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SocialMediaListComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SocialMediaListComponentWhereInput>;
};


export type QuerySpacerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SpacerWhereUniqueInput;
};


export type QuerySpacerVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySpacersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SpacerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SpacerWhereInput>;
};


export type QuerySpacersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SpacerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SpacerWhereInput>;
};


export type QuerySubCategoryKeyImageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SubCategoryKeyImageWhereUniqueInput;
};


export type QuerySubCategoryKeyImageVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySubCategoryKeyImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SubCategoryKeyImageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SubCategoryKeyImageWhereInput>;
};


export type QuerySubCategoryKeyImagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SubCategoryKeyImageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SubCategoryKeyImageWhereInput>;
};


export type QuerySubTabArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SubTabWhereUniqueInput;
};


export type QuerySubTabContentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SubTabContentWhereUniqueInput;
};


export type QuerySubTabContentVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySubTabVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySubTabsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SubTabOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SubTabWhereInput>;
};


export type QuerySubTabsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SubTabOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SubTabWhereInput>;
};


export type QuerySubTabsContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SubTabContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SubTabContentWhereInput>;
};


export type QuerySubTabsContentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SubTabContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SubTabContentWhereInput>;
};


export type QuerySustainabilityBannerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SustainabilityBannerWhereUniqueInput;
};


export type QuerySustainabilityBannerVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySustainabilityBannersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SustainabilityBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SustainabilityBannerWhereInput>;
};


export type QuerySustainabilityBannersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SustainabilityBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SustainabilityBannerWhereInput>;
};


export type QuerySustainabilityInfoArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SustainabilityInfoWhereUniqueInput;
};


export type QuerySustainabilityInfoVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySustainabilityInfosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SustainabilityInfoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SustainabilityInfoWhereInput>;
};


export type QuerySustainabilityInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SustainabilityInfoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SustainabilityInfoWhereInput>;
};


export type QueryTabArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TabWhereUniqueInput;
};


export type QueryTabContentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TabContentWhereUniqueInput;
};


export type QueryTabContentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTabContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TabContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TabContentWhereInput>;
};


export type QueryTabContentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TabContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TabContentWhereInput>;
};


export type QueryTabVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTabsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TabOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TabWhereInput>;
};


export type QueryTabsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TabOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TabWhereInput>;
};


export type QueryTeaserArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TeaserWhereUniqueInput;
};


export type QueryTeaserPlaceholderArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TeaserPlaceholderWhereUniqueInput;
};


export type QueryTeaserPlaceholderVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTeaserPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TeaserPlaceholderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TeaserPlaceholderWhereInput>;
};


export type QueryTeaserPlaceholdersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TeaserPlaceholderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TeaserPlaceholderWhereInput>;
};


export type QueryTeaserSmallArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TeaserSmallWhereUniqueInput;
};


export type QueryTeaserSmallPlaceholderArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TeaserSmallPlaceholderWhereUniqueInput;
};


export type QueryTeaserSmallPlaceholderVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTeaserSmallPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TeaserSmallPlaceholderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
};


export type QueryTeaserSmallPlaceholdersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TeaserSmallPlaceholderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
};


export type QueryTeaserSmallVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTeaserSmallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TeaserSmallOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TeaserSmallWhereInput>;
};


export type QueryTeaserSmallsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TeaserSmallOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TeaserSmallWhereInput>;
};


export type QueryTeaserVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTeasersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TeaserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TeaserWhereInput>;
};


export type QueryTeasersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TeaserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TeaserWhereInput>;
};


export type QueryTestComponentWithRecipeQueriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TestComponentWithRecipeQueryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TestComponentWithRecipeQueryWhereInput>;
};


export type QueryTestComponentWithRecipeQueriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TestComponentWithRecipeQueryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TestComponentWithRecipeQueryWhereInput>;
};


export type QueryTestComponentWithRecipeQueryArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TestComponentWithRecipeQueryWhereUniqueInput;
};


export type QueryTestComponentWithRecipeQueryVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTestTipsANdTricksInAMarketArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};


export type QueryTestTipsANdTricksInAMarketVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTestTipsANdTricksInAMarketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TestTipsANdTricksInAMarketOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TestTipsANdTricksInAMarketWhereInput>;
};


export type QueryTestTipsANdTricksInAMarketsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TestTipsANdTricksInAMarketOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TestTipsANdTricksInAMarketWhereInput>;
};


export type QueryTextComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TextComponentWhereUniqueInput;
};


export type QueryTextComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTextComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TextComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TextComponentWhereInput>;
};


export type QueryTextComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TextComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TextComponentWhereInput>;
};


export type QueryTipsAndTricksDetailsPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};


export type QueryTipsAndTricksDetailsPageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTipsAndTricksDetailsPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TipsAndTricksDetailsPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TipsAndTricksDetailsPageWhereInput>;
};


export type QueryTipsAndTricksDetailsPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TipsAndTricksDetailsPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TipsAndTricksDetailsPageWhereInput>;
};


export type QueryTitleArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TitleWhereUniqueInput;
};


export type QueryTitleVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTitlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TitleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TitleWhereInput>;
};


export type QueryTitlesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TitleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TitleWhereInput>;
};


export type QueryTwitterSeoArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TwitterSeoWhereUniqueInput;
};


export type QueryTwitterSeoVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTwitterSeosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TwitterSeoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TwitterSeoWhereInput>;
};


export type QueryTwitterSeosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TwitterSeoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TwitterSeoWhereInput>;
};


export type QueryUserArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};

export type Question = Entity & Node & {
  __typename?: 'Question';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Question>;
  genericPages: Array<GenericPage>;
  /** List of Question versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<AssetComponent>;
  market: Markets;
  marketName?: Maybe<Market>;
  options?: Maybe<QuestionOptions>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  question: Scalars['String']['output'];
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Page type indicator (e.g. Promotion) */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Used in the CMS and code to identify entries. */
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type QuestionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type QuestionGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type QuestionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type QuestionImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionOptionsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QuestionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type QuestionCheckbox = Entity & Node & {
  __typename?: 'QuestionCheckbox';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<QuestionCheckbox>;
  /** List of QuestionCheckbox versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** Please use a one-word name in camel case to identify this option. (e.g. chocolateMarbleCake) */
  name: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Select true if this option is correct and false if it's wrong. */
  required?: Maybe<Scalars['Boolean']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Only used in the CMS to identify entries. */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type QuestionCheckboxCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionCheckboxDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type QuestionCheckboxHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type QuestionCheckboxMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionCheckboxPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionCheckboxScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QuestionCheckboxUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type QuestionCheckboxCollection = Entity & Node & {
  __typename?: 'QuestionCheckboxCollection';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<QuestionCheckboxCollection>;
  /** List of QuestionCheckboxCollection versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** Please use a one-word name in camel case to identify this collection. (e.g. chocolateMarbleCake) */
  name: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Add all checkbox options related to the same question. */
  questionCheckboxes: Array<QuestionCheckbox>;
  questions: Array<Question>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Only used in the CMS to identify entries. */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type QuestionCheckboxCollectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionCheckboxCollectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type QuestionCheckboxCollectionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type QuestionCheckboxCollectionMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionCheckboxCollectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionCheckboxCollectionQuestionCheckboxesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<QuestionCheckboxOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionCheckboxWhereInput>;
};


export type QuestionCheckboxCollectionQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionWhereInput>;
};


export type QuestionCheckboxCollectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QuestionCheckboxCollectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type QuestionCheckboxCollectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: QuestionCheckboxCollectionWhereUniqueInput;
};

/** A connection to a list of items. */
export type QuestionCheckboxCollectionConnection = {
  __typename?: 'QuestionCheckboxCollectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<QuestionCheckboxCollectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type QuestionCheckboxCollectionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  name: Scalars['String']['input'];
  questionCheckboxes?: InputMaybe<QuestionCheckboxCreateManyInlineInput>;
  questions?: InputMaybe<QuestionCreateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionCheckboxCollectionCreateManyInlineInput = {
  /** Connect multiple existing QuestionCheckboxCollection documents */
  connect?: InputMaybe<Array<QuestionCheckboxCollectionWhereUniqueInput>>;
  /** Create and connect multiple existing QuestionCheckboxCollection documents */
  create?: InputMaybe<Array<QuestionCheckboxCollectionCreateInput>>;
};

export type QuestionCheckboxCollectionCreateOneInlineInput = {
  /** Connect one existing QuestionCheckboxCollection document */
  connect?: InputMaybe<QuestionCheckboxCollectionWhereUniqueInput>;
  /** Create and connect one QuestionCheckboxCollection document */
  create?: InputMaybe<QuestionCheckboxCollectionCreateInput>;
};

/** An edge in a connection. */
export type QuestionCheckboxCollectionEdge = {
  __typename?: 'QuestionCheckboxCollectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: QuestionCheckboxCollection;
};

/** Identifies documents */
export type QuestionCheckboxCollectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionCheckboxCollectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionCheckboxCollectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionCheckboxCollectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuestionCheckboxCollectionWhereStageInput>;
  documentInStages_none?: InputMaybe<QuestionCheckboxCollectionWhereStageInput>;
  documentInStages_some?: InputMaybe<QuestionCheckboxCollectionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  questionCheckboxes_every?: InputMaybe<QuestionCheckboxWhereInput>;
  questionCheckboxes_none?: InputMaybe<QuestionCheckboxWhereInput>;
  questionCheckboxes_some?: InputMaybe<QuestionCheckboxWhereInput>;
  questions_every?: InputMaybe<QuestionWhereInput>;
  questions_none?: InputMaybe<QuestionWhereInput>;
  questions_some?: InputMaybe<QuestionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum QuestionCheckboxCollectionOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type QuestionCheckboxCollectionUpdateInput = {
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  questionCheckboxes?: InputMaybe<QuestionCheckboxUpdateManyInlineInput>;
  questions?: InputMaybe<QuestionUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionCheckboxCollectionUpdateManyInlineInput = {
  /** Connect multiple existing QuestionCheckboxCollection documents */
  connect?: InputMaybe<Array<QuestionCheckboxCollectionConnectInput>>;
  /** Create and connect multiple QuestionCheckboxCollection documents */
  create?: InputMaybe<Array<QuestionCheckboxCollectionCreateInput>>;
  /** Delete multiple QuestionCheckboxCollection documents */
  delete?: InputMaybe<Array<QuestionCheckboxCollectionWhereUniqueInput>>;
  /** Disconnect multiple QuestionCheckboxCollection documents */
  disconnect?: InputMaybe<Array<QuestionCheckboxCollectionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing QuestionCheckboxCollection documents */
  set?: InputMaybe<Array<QuestionCheckboxCollectionWhereUniqueInput>>;
  /** Update multiple QuestionCheckboxCollection documents */
  update?: InputMaybe<Array<QuestionCheckboxCollectionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple QuestionCheckboxCollection documents */
  upsert?: InputMaybe<Array<QuestionCheckboxCollectionUpsertWithNestedWhereUniqueInput>>;
};

export type QuestionCheckboxCollectionUpdateManyInput = {
  market?: InputMaybe<Markets>;
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionCheckboxCollectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: QuestionCheckboxCollectionUpdateManyInput;
  /** Document search */
  where: QuestionCheckboxCollectionWhereInput;
};

export type QuestionCheckboxCollectionUpdateOneInlineInput = {
  /** Connect existing QuestionCheckboxCollection document */
  connect?: InputMaybe<QuestionCheckboxCollectionWhereUniqueInput>;
  /** Create and connect one QuestionCheckboxCollection document */
  create?: InputMaybe<QuestionCheckboxCollectionCreateInput>;
  /** Delete currently connected QuestionCheckboxCollection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected QuestionCheckboxCollection document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single QuestionCheckboxCollection document */
  update?: InputMaybe<QuestionCheckboxCollectionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single QuestionCheckboxCollection document */
  upsert?: InputMaybe<QuestionCheckboxCollectionUpsertWithNestedWhereUniqueInput>;
};

export type QuestionCheckboxCollectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: QuestionCheckboxCollectionUpdateInput;
  /** Unique document search */
  where: QuestionCheckboxCollectionWhereUniqueInput;
};

export type QuestionCheckboxCollectionUpsertInput = {
  /** Create document if it didn't exist */
  create: QuestionCheckboxCollectionCreateInput;
  /** Update document if it exists */
  update: QuestionCheckboxCollectionUpdateInput;
};

export type QuestionCheckboxCollectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: QuestionCheckboxCollectionUpsertInput;
  /** Unique document search */
  where: QuestionCheckboxCollectionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type QuestionCheckboxCollectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type QuestionCheckboxCollectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionCheckboxCollectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionCheckboxCollectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionCheckboxCollectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuestionCheckboxCollectionWhereStageInput>;
  documentInStages_none?: InputMaybe<QuestionCheckboxCollectionWhereStageInput>;
  documentInStages_some?: InputMaybe<QuestionCheckboxCollectionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  questionCheckboxes_every?: InputMaybe<QuestionCheckboxWhereInput>;
  questionCheckboxes_none?: InputMaybe<QuestionCheckboxWhereInput>;
  questionCheckboxes_some?: InputMaybe<QuestionCheckboxWhereInput>;
  questions_every?: InputMaybe<QuestionWhereInput>;
  questions_none?: InputMaybe<QuestionWhereInput>;
  questions_some?: InputMaybe<QuestionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type QuestionCheckboxCollectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionCheckboxCollectionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionCheckboxCollectionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionCheckboxCollectionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<QuestionCheckboxCollectionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References QuestionCheckboxCollection record uniquely */
export type QuestionCheckboxCollectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionCheckboxConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: QuestionCheckboxWhereUniqueInput;
};

/** A connection to a list of items. */
export type QuestionCheckboxConnection = {
  __typename?: 'QuestionCheckboxConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<QuestionCheckboxEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type QuestionCheckboxCreateInput = {
  cl8sx084r452l01t8fewuh3bn?: InputMaybe<QuestionCheckboxCollectionCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  label: Scalars['String']['input'];
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  name: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionCheckboxCreateManyInlineInput = {
  /** Connect multiple existing QuestionCheckbox documents */
  connect?: InputMaybe<Array<QuestionCheckboxWhereUniqueInput>>;
  /** Create and connect multiple existing QuestionCheckbox documents */
  create?: InputMaybe<Array<QuestionCheckboxCreateInput>>;
};

export type QuestionCheckboxCreateOneInlineInput = {
  /** Connect one existing QuestionCheckbox document */
  connect?: InputMaybe<QuestionCheckboxWhereUniqueInput>;
  /** Create and connect one QuestionCheckbox document */
  create?: InputMaybe<QuestionCheckboxCreateInput>;
};

/** An edge in a connection. */
export type QuestionCheckboxEdge = {
  __typename?: 'QuestionCheckboxEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: QuestionCheckbox;
};

/** Identifies documents */
export type QuestionCheckboxManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionCheckboxWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionCheckboxWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionCheckboxWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuestionCheckboxWhereStageInput>;
  documentInStages_none?: InputMaybe<QuestionCheckboxWhereStageInput>;
  documentInStages_some?: InputMaybe<QuestionCheckboxWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum QuestionCheckboxOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type QuestionCheckboxUpdateInput = {
  cl8sx084r452l01t8fewuh3bn?: InputMaybe<QuestionCheckboxCollectionUpdateManyInlineInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionCheckboxUpdateManyInlineInput = {
  /** Connect multiple existing QuestionCheckbox documents */
  connect?: InputMaybe<Array<QuestionCheckboxConnectInput>>;
  /** Create and connect multiple QuestionCheckbox documents */
  create?: InputMaybe<Array<QuestionCheckboxCreateInput>>;
  /** Delete multiple QuestionCheckbox documents */
  delete?: InputMaybe<Array<QuestionCheckboxWhereUniqueInput>>;
  /** Disconnect multiple QuestionCheckbox documents */
  disconnect?: InputMaybe<Array<QuestionCheckboxWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing QuestionCheckbox documents */
  set?: InputMaybe<Array<QuestionCheckboxWhereUniqueInput>>;
  /** Update multiple QuestionCheckbox documents */
  update?: InputMaybe<Array<QuestionCheckboxUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple QuestionCheckbox documents */
  upsert?: InputMaybe<Array<QuestionCheckboxUpsertWithNestedWhereUniqueInput>>;
};

export type QuestionCheckboxUpdateManyInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionCheckboxUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: QuestionCheckboxUpdateManyInput;
  /** Document search */
  where: QuestionCheckboxWhereInput;
};

export type QuestionCheckboxUpdateOneInlineInput = {
  /** Connect existing QuestionCheckbox document */
  connect?: InputMaybe<QuestionCheckboxWhereUniqueInput>;
  /** Create and connect one QuestionCheckbox document */
  create?: InputMaybe<QuestionCheckboxCreateInput>;
  /** Delete currently connected QuestionCheckbox document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected QuestionCheckbox document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single QuestionCheckbox document */
  update?: InputMaybe<QuestionCheckboxUpdateWithNestedWhereUniqueInput>;
  /** Upsert single QuestionCheckbox document */
  upsert?: InputMaybe<QuestionCheckboxUpsertWithNestedWhereUniqueInput>;
};

export type QuestionCheckboxUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: QuestionCheckboxUpdateInput;
  /** Unique document search */
  where: QuestionCheckboxWhereUniqueInput;
};

export type QuestionCheckboxUpsertInput = {
  /** Create document if it didn't exist */
  create: QuestionCheckboxCreateInput;
  /** Update document if it exists */
  update: QuestionCheckboxUpdateInput;
};

export type QuestionCheckboxUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: QuestionCheckboxUpsertInput;
  /** Unique document search */
  where: QuestionCheckboxWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type QuestionCheckboxWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type QuestionCheckboxWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionCheckboxWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionCheckboxWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionCheckboxWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuestionCheckboxWhereStageInput>;
  documentInStages_none?: InputMaybe<QuestionCheckboxWhereStageInput>;
  documentInStages_some?: InputMaybe<QuestionCheckboxWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type QuestionCheckboxWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionCheckboxWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionCheckboxWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionCheckboxWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<QuestionCheckboxWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References QuestionCheckbox record uniquely */
export type QuestionCheckboxWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: QuestionWhereUniqueInput;
};

/** A connection to a list of items. */
export type QuestionConnection = {
  __typename?: 'QuestionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<QuestionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type QuestionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  image?: InputMaybe<AssetComponentCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  options?: InputMaybe<QuestionOptionsCreateOneInlineInput>;
  question: Scalars['String']['input'];
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionCreateManyInlineInput = {
  /** Connect multiple existing Question documents */
  connect?: InputMaybe<Array<QuestionWhereUniqueInput>>;
  /** Create and connect multiple existing Question documents */
  create?: InputMaybe<Array<QuestionCreateInput>>;
};

export type QuestionCreateOneInlineInput = {
  /** Connect one existing Question document */
  connect?: InputMaybe<QuestionWhereUniqueInput>;
  /** Create and connect one Question document */
  create?: InputMaybe<QuestionCreateInput>;
};

/** An edge in a connection. */
export type QuestionEdge = {
  __typename?: 'QuestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Question;
};

/** Identifies documents */
export type QuestionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuestionWhereStageInput>;
  documentInStages_none?: InputMaybe<QuestionWhereStageInput>;
  documentInStages_some?: InputMaybe<QuestionWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** All values in which the union is connected to the given models */
  options?: InputMaybe<QuestionOptionsWhereInput>;
  /** All values in which the union is empty */
  options_empty?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  question?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  question_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  question_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  question_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  question_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  question_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  question_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  question_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  question_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type QuestionOptions = QuestionCheckboxCollection | QuestionRadioButtonCollection;

export type QuestionOptionsConnectInput = {
  QuestionCheckboxCollection?: InputMaybe<QuestionCheckboxCollectionConnectInput>;
  QuestionRadioButtonCollection?: InputMaybe<QuestionRadioButtonCollectionConnectInput>;
};

export type QuestionOptionsCreateInput = {
  QuestionCheckboxCollection?: InputMaybe<QuestionCheckboxCollectionCreateInput>;
  QuestionRadioButtonCollection?: InputMaybe<QuestionRadioButtonCollectionCreateInput>;
};

export type QuestionOptionsCreateManyInlineInput = {
  /** Connect multiple existing QuestionOptions documents */
  connect?: InputMaybe<Array<QuestionOptionsWhereUniqueInput>>;
  /** Create and connect multiple existing QuestionOptions documents */
  create?: InputMaybe<Array<QuestionOptionsCreateInput>>;
};

export type QuestionOptionsCreateOneInlineInput = {
  /** Connect one existing QuestionOptions document */
  connect?: InputMaybe<QuestionOptionsWhereUniqueInput>;
  /** Create and connect one QuestionOptions document */
  create?: InputMaybe<QuestionOptionsCreateInput>;
};

export type QuestionOptionsUpdateInput = {
  QuestionCheckboxCollection?: InputMaybe<QuestionCheckboxCollectionUpdateInput>;
  QuestionRadioButtonCollection?: InputMaybe<QuestionRadioButtonCollectionUpdateInput>;
};

export type QuestionOptionsUpdateManyInlineInput = {
  /** Connect multiple existing QuestionOptions documents */
  connect?: InputMaybe<Array<QuestionOptionsConnectInput>>;
  /** Create and connect multiple QuestionOptions documents */
  create?: InputMaybe<Array<QuestionOptionsCreateInput>>;
  /** Delete multiple QuestionOptions documents */
  delete?: InputMaybe<Array<QuestionOptionsWhereUniqueInput>>;
  /** Disconnect multiple QuestionOptions documents */
  disconnect?: InputMaybe<Array<QuestionOptionsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing QuestionOptions documents */
  set?: InputMaybe<Array<QuestionOptionsWhereUniqueInput>>;
  /** Update multiple QuestionOptions documents */
  update?: InputMaybe<Array<QuestionOptionsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple QuestionOptions documents */
  upsert?: InputMaybe<Array<QuestionOptionsUpsertWithNestedWhereUniqueInput>>;
};

export type QuestionOptionsUpdateManyWithNestedWhereInput = {
  QuestionCheckboxCollection?: InputMaybe<QuestionCheckboxCollectionUpdateManyWithNestedWhereInput>;
  QuestionRadioButtonCollection?: InputMaybe<QuestionRadioButtonCollectionUpdateManyWithNestedWhereInput>;
};

export type QuestionOptionsUpdateOneInlineInput = {
  /** Connect existing QuestionOptions document */
  connect?: InputMaybe<QuestionOptionsWhereUniqueInput>;
  /** Create and connect one QuestionOptions document */
  create?: InputMaybe<QuestionOptionsCreateInput>;
  /** Delete currently connected QuestionOptions document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected QuestionOptions document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single QuestionOptions document */
  update?: InputMaybe<QuestionOptionsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single QuestionOptions document */
  upsert?: InputMaybe<QuestionOptionsUpsertWithNestedWhereUniqueInput>;
};

export type QuestionOptionsUpdateWithNestedWhereUniqueInput = {
  QuestionCheckboxCollection?: InputMaybe<QuestionCheckboxCollectionUpdateWithNestedWhereUniqueInput>;
  QuestionRadioButtonCollection?: InputMaybe<QuestionRadioButtonCollectionUpdateWithNestedWhereUniqueInput>;
};

export type QuestionOptionsUpsertWithNestedWhereUniqueInput = {
  QuestionCheckboxCollection?: InputMaybe<QuestionCheckboxCollectionUpsertWithNestedWhereUniqueInput>;
  QuestionRadioButtonCollection?: InputMaybe<QuestionRadioButtonCollectionUpsertWithNestedWhereUniqueInput>;
};

export type QuestionOptionsWhereInput = {
  QuestionCheckboxCollection?: InputMaybe<QuestionCheckboxCollectionWhereInput>;
  QuestionRadioButtonCollection?: InputMaybe<QuestionRadioButtonCollectionWhereInput>;
};

export type QuestionOptionsWhereUniqueInput = {
  QuestionCheckboxCollection?: InputMaybe<QuestionCheckboxCollectionWhereUniqueInput>;
  QuestionRadioButtonCollection?: InputMaybe<QuestionRadioButtonCollectionWhereUniqueInput>;
};

export enum QuestionOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  question_ASC = 'question_ASC',
  question_DESC = 'question_DESC',
  subtitle_ASC = 'subtitle_ASC',
  subtitle_DESC = 'subtitle_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type QuestionRadioButton = Entity & Node & {
  __typename?: 'QuestionRadioButton';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<QuestionRadioButton>;
  /** List of QuestionRadioButton versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** Please use a one-word name in camel case to identify this option. (e.g. chocolateMarbleCake) */
  name: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Select true if this option is correct and false if it's wrong. */
  required?: Maybe<Scalars['Boolean']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Only used in the CMS to identify entries. */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type QuestionRadioButtonCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionRadioButtonDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type QuestionRadioButtonHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type QuestionRadioButtonMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionRadioButtonPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionRadioButtonScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QuestionRadioButtonUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type QuestionRadioButtonCollection = Entity & Node & {
  __typename?: 'QuestionRadioButtonCollection';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<QuestionRadioButtonCollection>;
  /** List of QuestionRadioButtonCollection versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** Please use a one-word name in camel case to identify this collection. (e.g. chocolateMarbleCake) */
  name: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Add all radio button options related to the same question. */
  questionRadioButtons: Array<QuestionRadioButton>;
  questions: Array<Question>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Only used in the CMS to identify entries. */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type QuestionRadioButtonCollectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionRadioButtonCollectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type QuestionRadioButtonCollectionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type QuestionRadioButtonCollectionMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionRadioButtonCollectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuestionRadioButtonCollectionQuestionRadioButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<QuestionRadioButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionRadioButtonWhereInput>;
};


export type QuestionRadioButtonCollectionQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionWhereInput>;
};


export type QuestionRadioButtonCollectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QuestionRadioButtonCollectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type QuestionRadioButtonCollectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: QuestionRadioButtonCollectionWhereUniqueInput;
};

/** A connection to a list of items. */
export type QuestionRadioButtonCollectionConnection = {
  __typename?: 'QuestionRadioButtonCollectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<QuestionRadioButtonCollectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type QuestionRadioButtonCollectionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  name: Scalars['String']['input'];
  questionRadioButtons?: InputMaybe<QuestionRadioButtonCreateManyInlineInput>;
  questions?: InputMaybe<QuestionCreateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionRadioButtonCollectionCreateManyInlineInput = {
  /** Connect multiple existing QuestionRadioButtonCollection documents */
  connect?: InputMaybe<Array<QuestionRadioButtonCollectionWhereUniqueInput>>;
  /** Create and connect multiple existing QuestionRadioButtonCollection documents */
  create?: InputMaybe<Array<QuestionRadioButtonCollectionCreateInput>>;
};

export type QuestionRadioButtonCollectionCreateOneInlineInput = {
  /** Connect one existing QuestionRadioButtonCollection document */
  connect?: InputMaybe<QuestionRadioButtonCollectionWhereUniqueInput>;
  /** Create and connect one QuestionRadioButtonCollection document */
  create?: InputMaybe<QuestionRadioButtonCollectionCreateInput>;
};

/** An edge in a connection. */
export type QuestionRadioButtonCollectionEdge = {
  __typename?: 'QuestionRadioButtonCollectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: QuestionRadioButtonCollection;
};

/** Identifies documents */
export type QuestionRadioButtonCollectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionRadioButtonCollectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionRadioButtonCollectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionRadioButtonCollectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuestionRadioButtonCollectionWhereStageInput>;
  documentInStages_none?: InputMaybe<QuestionRadioButtonCollectionWhereStageInput>;
  documentInStages_some?: InputMaybe<QuestionRadioButtonCollectionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  questionRadioButtons_every?: InputMaybe<QuestionRadioButtonWhereInput>;
  questionRadioButtons_none?: InputMaybe<QuestionRadioButtonWhereInput>;
  questionRadioButtons_some?: InputMaybe<QuestionRadioButtonWhereInput>;
  questions_every?: InputMaybe<QuestionWhereInput>;
  questions_none?: InputMaybe<QuestionWhereInput>;
  questions_some?: InputMaybe<QuestionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum QuestionRadioButtonCollectionOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type QuestionRadioButtonCollectionUpdateInput = {
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  questionRadioButtons?: InputMaybe<QuestionRadioButtonUpdateManyInlineInput>;
  questions?: InputMaybe<QuestionUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionRadioButtonCollectionUpdateManyInlineInput = {
  /** Connect multiple existing QuestionRadioButtonCollection documents */
  connect?: InputMaybe<Array<QuestionRadioButtonCollectionConnectInput>>;
  /** Create and connect multiple QuestionRadioButtonCollection documents */
  create?: InputMaybe<Array<QuestionRadioButtonCollectionCreateInput>>;
  /** Delete multiple QuestionRadioButtonCollection documents */
  delete?: InputMaybe<Array<QuestionRadioButtonCollectionWhereUniqueInput>>;
  /** Disconnect multiple QuestionRadioButtonCollection documents */
  disconnect?: InputMaybe<Array<QuestionRadioButtonCollectionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing QuestionRadioButtonCollection documents */
  set?: InputMaybe<Array<QuestionRadioButtonCollectionWhereUniqueInput>>;
  /** Update multiple QuestionRadioButtonCollection documents */
  update?: InputMaybe<Array<QuestionRadioButtonCollectionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple QuestionRadioButtonCollection documents */
  upsert?: InputMaybe<Array<QuestionRadioButtonCollectionUpsertWithNestedWhereUniqueInput>>;
};

export type QuestionRadioButtonCollectionUpdateManyInput = {
  market?: InputMaybe<Markets>;
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionRadioButtonCollectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: QuestionRadioButtonCollectionUpdateManyInput;
  /** Document search */
  where: QuestionRadioButtonCollectionWhereInput;
};

export type QuestionRadioButtonCollectionUpdateOneInlineInput = {
  /** Connect existing QuestionRadioButtonCollection document */
  connect?: InputMaybe<QuestionRadioButtonCollectionWhereUniqueInput>;
  /** Create and connect one QuestionRadioButtonCollection document */
  create?: InputMaybe<QuestionRadioButtonCollectionCreateInput>;
  /** Delete currently connected QuestionRadioButtonCollection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected QuestionRadioButtonCollection document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single QuestionRadioButtonCollection document */
  update?: InputMaybe<QuestionRadioButtonCollectionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single QuestionRadioButtonCollection document */
  upsert?: InputMaybe<QuestionRadioButtonCollectionUpsertWithNestedWhereUniqueInput>;
};

export type QuestionRadioButtonCollectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: QuestionRadioButtonCollectionUpdateInput;
  /** Unique document search */
  where: QuestionRadioButtonCollectionWhereUniqueInput;
};

export type QuestionRadioButtonCollectionUpsertInput = {
  /** Create document if it didn't exist */
  create: QuestionRadioButtonCollectionCreateInput;
  /** Update document if it exists */
  update: QuestionRadioButtonCollectionUpdateInput;
};

export type QuestionRadioButtonCollectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: QuestionRadioButtonCollectionUpsertInput;
  /** Unique document search */
  where: QuestionRadioButtonCollectionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type QuestionRadioButtonCollectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type QuestionRadioButtonCollectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionRadioButtonCollectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionRadioButtonCollectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionRadioButtonCollectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuestionRadioButtonCollectionWhereStageInput>;
  documentInStages_none?: InputMaybe<QuestionRadioButtonCollectionWhereStageInput>;
  documentInStages_some?: InputMaybe<QuestionRadioButtonCollectionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  questionRadioButtons_every?: InputMaybe<QuestionRadioButtonWhereInput>;
  questionRadioButtons_none?: InputMaybe<QuestionRadioButtonWhereInput>;
  questionRadioButtons_some?: InputMaybe<QuestionRadioButtonWhereInput>;
  questions_every?: InputMaybe<QuestionWhereInput>;
  questions_none?: InputMaybe<QuestionWhereInput>;
  questions_some?: InputMaybe<QuestionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type QuestionRadioButtonCollectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionRadioButtonCollectionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionRadioButtonCollectionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionRadioButtonCollectionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<QuestionRadioButtonCollectionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References QuestionRadioButtonCollection record uniquely */
export type QuestionRadioButtonCollectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionRadioButtonConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: QuestionRadioButtonWhereUniqueInput;
};

/** A connection to a list of items. */
export type QuestionRadioButtonConnection = {
  __typename?: 'QuestionRadioButtonConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<QuestionRadioButtonEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type QuestionRadioButtonCreateInput = {
  cl8t0bxqh48rd01un1f4f6i2t?: InputMaybe<QuestionRadioButtonCollectionCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  label: Scalars['String']['input'];
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  name: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionRadioButtonCreateManyInlineInput = {
  /** Connect multiple existing QuestionRadioButton documents */
  connect?: InputMaybe<Array<QuestionRadioButtonWhereUniqueInput>>;
  /** Create and connect multiple existing QuestionRadioButton documents */
  create?: InputMaybe<Array<QuestionRadioButtonCreateInput>>;
};

export type QuestionRadioButtonCreateOneInlineInput = {
  /** Connect one existing QuestionRadioButton document */
  connect?: InputMaybe<QuestionRadioButtonWhereUniqueInput>;
  /** Create and connect one QuestionRadioButton document */
  create?: InputMaybe<QuestionRadioButtonCreateInput>;
};

/** An edge in a connection. */
export type QuestionRadioButtonEdge = {
  __typename?: 'QuestionRadioButtonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: QuestionRadioButton;
};

/** Identifies documents */
export type QuestionRadioButtonManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionRadioButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionRadioButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionRadioButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuestionRadioButtonWhereStageInput>;
  documentInStages_none?: InputMaybe<QuestionRadioButtonWhereStageInput>;
  documentInStages_some?: InputMaybe<QuestionRadioButtonWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum QuestionRadioButtonOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type QuestionRadioButtonUpdateInput = {
  cl8t0bxqh48rd01un1f4f6i2t?: InputMaybe<QuestionRadioButtonCollectionUpdateManyInlineInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionRadioButtonUpdateManyInlineInput = {
  /** Connect multiple existing QuestionRadioButton documents */
  connect?: InputMaybe<Array<QuestionRadioButtonConnectInput>>;
  /** Create and connect multiple QuestionRadioButton documents */
  create?: InputMaybe<Array<QuestionRadioButtonCreateInput>>;
  /** Delete multiple QuestionRadioButton documents */
  delete?: InputMaybe<Array<QuestionRadioButtonWhereUniqueInput>>;
  /** Disconnect multiple QuestionRadioButton documents */
  disconnect?: InputMaybe<Array<QuestionRadioButtonWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing QuestionRadioButton documents */
  set?: InputMaybe<Array<QuestionRadioButtonWhereUniqueInput>>;
  /** Update multiple QuestionRadioButton documents */
  update?: InputMaybe<Array<QuestionRadioButtonUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple QuestionRadioButton documents */
  upsert?: InputMaybe<Array<QuestionRadioButtonUpsertWithNestedWhereUniqueInput>>;
};

export type QuestionRadioButtonUpdateManyInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionRadioButtonUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: QuestionRadioButtonUpdateManyInput;
  /** Document search */
  where: QuestionRadioButtonWhereInput;
};

export type QuestionRadioButtonUpdateOneInlineInput = {
  /** Connect existing QuestionRadioButton document */
  connect?: InputMaybe<QuestionRadioButtonWhereUniqueInput>;
  /** Create and connect one QuestionRadioButton document */
  create?: InputMaybe<QuestionRadioButtonCreateInput>;
  /** Delete currently connected QuestionRadioButton document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected QuestionRadioButton document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single QuestionRadioButton document */
  update?: InputMaybe<QuestionRadioButtonUpdateWithNestedWhereUniqueInput>;
  /** Upsert single QuestionRadioButton document */
  upsert?: InputMaybe<QuestionRadioButtonUpsertWithNestedWhereUniqueInput>;
};

export type QuestionRadioButtonUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: QuestionRadioButtonUpdateInput;
  /** Unique document search */
  where: QuestionRadioButtonWhereUniqueInput;
};

export type QuestionRadioButtonUpsertInput = {
  /** Create document if it didn't exist */
  create: QuestionRadioButtonCreateInput;
  /** Update document if it exists */
  update: QuestionRadioButtonUpdateInput;
};

export type QuestionRadioButtonUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: QuestionRadioButtonUpsertInput;
  /** Unique document search */
  where: QuestionRadioButtonWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type QuestionRadioButtonWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type QuestionRadioButtonWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionRadioButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionRadioButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionRadioButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuestionRadioButtonWhereStageInput>;
  documentInStages_none?: InputMaybe<QuestionRadioButtonWhereStageInput>;
  documentInStages_some?: InputMaybe<QuestionRadioButtonWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type QuestionRadioButtonWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionRadioButtonWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionRadioButtonWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionRadioButtonWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<QuestionRadioButtonWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References QuestionRadioButton record uniquely */
export type QuestionRadioButtonWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionUpdateInput = {
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  image?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  options?: InputMaybe<QuestionOptionsUpdateOneInlineInput>;
  question?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionUpdateManyInlineInput = {
  /** Connect multiple existing Question documents */
  connect?: InputMaybe<Array<QuestionConnectInput>>;
  /** Create and connect multiple Question documents */
  create?: InputMaybe<Array<QuestionCreateInput>>;
  /** Delete multiple Question documents */
  delete?: InputMaybe<Array<QuestionWhereUniqueInput>>;
  /** Disconnect multiple Question documents */
  disconnect?: InputMaybe<Array<QuestionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Question documents */
  set?: InputMaybe<Array<QuestionWhereUniqueInput>>;
  /** Update multiple Question documents */
  update?: InputMaybe<Array<QuestionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Question documents */
  upsert?: InputMaybe<Array<QuestionUpsertWithNestedWhereUniqueInput>>;
};

export type QuestionUpdateManyInput = {
  market?: InputMaybe<Markets>;
  question?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: QuestionUpdateManyInput;
  /** Document search */
  where: QuestionWhereInput;
};

export type QuestionUpdateOneInlineInput = {
  /** Connect existing Question document */
  connect?: InputMaybe<QuestionWhereUniqueInput>;
  /** Create and connect one Question document */
  create?: InputMaybe<QuestionCreateInput>;
  /** Delete currently connected Question document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Question document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Question document */
  update?: InputMaybe<QuestionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Question document */
  upsert?: InputMaybe<QuestionUpsertWithNestedWhereUniqueInput>;
};

export type QuestionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: QuestionUpdateInput;
  /** Unique document search */
  where: QuestionWhereUniqueInput;
};

export type QuestionUpsertInput = {
  /** Create document if it didn't exist */
  create: QuestionCreateInput;
  /** Update document if it exists */
  update: QuestionUpdateInput;
};

export type QuestionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: QuestionUpsertInput;
  /** Unique document search */
  where: QuestionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type QuestionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type QuestionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuestionWhereStageInput>;
  documentInStages_none?: InputMaybe<QuestionWhereStageInput>;
  documentInStages_some?: InputMaybe<QuestionWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** All values in which the union is connected to the given models */
  options?: InputMaybe<QuestionOptionsWhereInput>;
  /** All values in which the union is empty */
  options_empty?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  question?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  question_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  question_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  question_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  question_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  question_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  question_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  question_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  question_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type QuestionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuestionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuestionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuestionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<QuestionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Question record uniquely */
export type QuestionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type Rgba = {
  __typename?: 'RGBA';
  a: Scalars['RGBATransparency']['output'];
  b: Scalars['RGBAHue']['output'];
  g: Scalars['RGBAHue']['output'];
  r: Scalars['RGBAHue']['output'];
};

/** Input type representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type RgbaInput = {
  a: Scalars['RGBATransparency']['input'];
  b: Scalars['RGBAHue']['input'];
  g: Scalars['RGBAHue']['input'];
  r: Scalars['RGBAHue']['input'];
};

/** Ratings component used on the recipe details page. */
export type Rating = Entity & Node & {
  __typename?: 'Rating';
  anchorNav?: Maybe<AnchorNavigation>;
  background: Array<Asset>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Rating>;
  /** List of Rating versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  lowerLeftCorner?: Maybe<Asset>;
  market: Markets;
  marketName?: Maybe<Market>;
  message: Array<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  rateThis?: Maybe<Scalars['String']['output']>;
  ratingBody?: Maybe<Scalars['String']['output']>;
  ratingBtn?: Maybe<Scalars['String']['output']>;
  ratingSubtitle?: Maybe<Scalars['String']['output']>;
  ratingThanks?: Maybe<Scalars['String']['output']>;
  ratingTitle?: Maybe<Scalars['String']['output']>;
  recipe?: Maybe<Recipe>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  thanksMessage?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  upperRightCorner?: Maybe<Asset>;
};


/** Ratings component used on the recipe details page. */
export type RatingAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Ratings component used on the recipe details page. */
export type RatingBackgroundArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


/** Ratings component used on the recipe details page. */
export type RatingCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Ratings component used on the recipe details page. */
export type RatingDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Ratings component used on the recipe details page. */
export type RatingHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Ratings component used on the recipe details page. */
export type RatingLowerLeftCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Ratings component used on the recipe details page. */
export type RatingMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Ratings component used on the recipe details page. */
export type RatingPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Ratings component used on the recipe details page. */
export type RatingRecipeArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Ratings component used on the recipe details page. */
export type RatingScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Ratings component used on the recipe details page. */
export type RatingUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Ratings component used on the recipe details page. */
export type RatingUpperRightCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type RatingConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RatingWhereUniqueInput;
};

/** A connection to a list of items. */
export type RatingConnection = {
  __typename?: 'RatingConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RatingEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RatingCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  background?: InputMaybe<AssetCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  lowerLeftCorner?: InputMaybe<AssetCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  rateThis?: InputMaybe<Scalars['String']['input']>;
  ratingBody?: InputMaybe<Scalars['String']['input']>;
  ratingBtn?: InputMaybe<Scalars['String']['input']>;
  ratingSubtitle?: InputMaybe<Scalars['String']['input']>;
  ratingThanks?: InputMaybe<Scalars['String']['input']>;
  ratingTitle?: InputMaybe<Scalars['String']['input']>;
  recipe?: InputMaybe<RecipeCreateOneInlineInput>;
  thanksMessage?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  upperRightCorner?: InputMaybe<AssetCreateOneInlineInput>;
};

export type RatingCreateManyInlineInput = {
  /** Connect multiple existing Rating documents */
  connect?: InputMaybe<Array<RatingWhereUniqueInput>>;
  /** Create and connect multiple existing Rating documents */
  create?: InputMaybe<Array<RatingCreateInput>>;
};

export type RatingCreateOneInlineInput = {
  /** Connect one existing Rating document */
  connect?: InputMaybe<RatingWhereUniqueInput>;
  /** Create and connect one Rating document */
  create?: InputMaybe<RatingCreateInput>;
};

/** An edge in a connection. */
export type RatingEdge = {
  __typename?: 'RatingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Rating;
};

/** Identifies documents */
export type RatingManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RatingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RatingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RatingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  background_every?: InputMaybe<AssetWhereInput>;
  background_none?: InputMaybe<AssetWhereInput>;
  background_some?: InputMaybe<AssetWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RatingWhereStageInput>;
  documentInStages_none?: InputMaybe<RatingWhereStageInput>;
  documentInStages_some?: InputMaybe<RatingWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  lowerLeftCorner?: InputMaybe<AssetWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  message_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  message_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  message_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  message_not?: InputMaybe<Array<Scalars['String']['input']>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  rateThis?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  rateThis_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  rateThis_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  rateThis_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  rateThis_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  rateThis_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  rateThis_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  rateThis_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  rateThis_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  rateThis_starts_with?: InputMaybe<Scalars['String']['input']>;
  ratingBody?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ratingBody_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ratingBody_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ratingBody_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ratingBody_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ratingBody_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ratingBody_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ratingBody_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ratingBody_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ratingBody_starts_with?: InputMaybe<Scalars['String']['input']>;
  ratingBtn?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ratingBtn_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ratingBtn_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ratingBtn_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ratingBtn_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ratingBtn_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ratingBtn_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ratingBtn_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ratingBtn_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ratingBtn_starts_with?: InputMaybe<Scalars['String']['input']>;
  ratingSubtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ratingSubtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ratingSubtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ratingSubtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ratingSubtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ratingSubtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ratingSubtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ratingSubtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ratingSubtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ratingSubtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  ratingThanks?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ratingThanks_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ratingThanks_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ratingThanks_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ratingThanks_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ratingThanks_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ratingThanks_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ratingThanks_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ratingThanks_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ratingThanks_starts_with?: InputMaybe<Scalars['String']['input']>;
  ratingTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ratingTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ratingTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ratingTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ratingTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ratingTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ratingTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ratingTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ratingTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ratingTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  recipe?: InputMaybe<RecipeWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  thanksMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  thanksMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  thanksMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  thanksMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  thanksMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  thanksMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  thanksMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  thanksMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  thanksMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  thanksMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upperRightCorner?: InputMaybe<AssetWhereInput>;
};

export enum RatingOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  message_ASC = 'message_ASC',
  message_DESC = 'message_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  rateThis_ASC = 'rateThis_ASC',
  rateThis_DESC = 'rateThis_DESC',
  ratingBody_ASC = 'ratingBody_ASC',
  ratingBody_DESC = 'ratingBody_DESC',
  ratingBtn_ASC = 'ratingBtn_ASC',
  ratingBtn_DESC = 'ratingBtn_DESC',
  ratingSubtitle_ASC = 'ratingSubtitle_ASC',
  ratingSubtitle_DESC = 'ratingSubtitle_DESC',
  ratingThanks_ASC = 'ratingThanks_ASC',
  ratingThanks_DESC = 'ratingThanks_DESC',
  ratingTitle_ASC = 'ratingTitle_ASC',
  ratingTitle_DESC = 'ratingTitle_DESC',
  thanksMessage_ASC = 'thanksMessage_ASC',
  thanksMessage_DESC = 'thanksMessage_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type RatingUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  background?: InputMaybe<AssetUpdateManyInlineInput>;
  lowerLeftCorner?: InputMaybe<AssetUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  rateThis?: InputMaybe<Scalars['String']['input']>;
  ratingBody?: InputMaybe<Scalars['String']['input']>;
  ratingBtn?: InputMaybe<Scalars['String']['input']>;
  ratingSubtitle?: InputMaybe<Scalars['String']['input']>;
  ratingThanks?: InputMaybe<Scalars['String']['input']>;
  ratingTitle?: InputMaybe<Scalars['String']['input']>;
  recipe?: InputMaybe<RecipeUpdateOneInlineInput>;
  thanksMessage?: InputMaybe<Scalars['String']['input']>;
  upperRightCorner?: InputMaybe<AssetUpdateOneInlineInput>;
};

export type RatingUpdateManyInlineInput = {
  /** Connect multiple existing Rating documents */
  connect?: InputMaybe<Array<RatingConnectInput>>;
  /** Create and connect multiple Rating documents */
  create?: InputMaybe<Array<RatingCreateInput>>;
  /** Delete multiple Rating documents */
  delete?: InputMaybe<Array<RatingWhereUniqueInput>>;
  /** Disconnect multiple Rating documents */
  disconnect?: InputMaybe<Array<RatingWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Rating documents */
  set?: InputMaybe<Array<RatingWhereUniqueInput>>;
  /** Update multiple Rating documents */
  update?: InputMaybe<Array<RatingUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Rating documents */
  upsert?: InputMaybe<Array<RatingUpsertWithNestedWhereUniqueInput>>;
};

export type RatingUpdateManyInput = {
  market?: InputMaybe<Markets>;
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  rateThis?: InputMaybe<Scalars['String']['input']>;
  ratingBody?: InputMaybe<Scalars['String']['input']>;
  ratingBtn?: InputMaybe<Scalars['String']['input']>;
  ratingSubtitle?: InputMaybe<Scalars['String']['input']>;
  ratingThanks?: InputMaybe<Scalars['String']['input']>;
  ratingTitle?: InputMaybe<Scalars['String']['input']>;
  thanksMessage?: InputMaybe<Scalars['String']['input']>;
};

export type RatingUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RatingUpdateManyInput;
  /** Document search */
  where: RatingWhereInput;
};

export type RatingUpdateOneInlineInput = {
  /** Connect existing Rating document */
  connect?: InputMaybe<RatingWhereUniqueInput>;
  /** Create and connect one Rating document */
  create?: InputMaybe<RatingCreateInput>;
  /** Delete currently connected Rating document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Rating document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Rating document */
  update?: InputMaybe<RatingUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Rating document */
  upsert?: InputMaybe<RatingUpsertWithNestedWhereUniqueInput>;
};

export type RatingUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RatingUpdateInput;
  /** Unique document search */
  where: RatingWhereUniqueInput;
};

export type RatingUpsertInput = {
  /** Create document if it didn't exist */
  create: RatingCreateInput;
  /** Update document if it exists */
  update: RatingUpdateInput;
};

export type RatingUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RatingUpsertInput;
  /** Unique document search */
  where: RatingWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RatingWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RatingWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RatingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RatingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RatingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  background_every?: InputMaybe<AssetWhereInput>;
  background_none?: InputMaybe<AssetWhereInput>;
  background_some?: InputMaybe<AssetWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RatingWhereStageInput>;
  documentInStages_none?: InputMaybe<RatingWhereStageInput>;
  documentInStages_some?: InputMaybe<RatingWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  lowerLeftCorner?: InputMaybe<AssetWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  message_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  message_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  message_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  message_not?: InputMaybe<Array<Scalars['String']['input']>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  rateThis?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  rateThis_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  rateThis_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  rateThis_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  rateThis_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  rateThis_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  rateThis_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  rateThis_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  rateThis_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  rateThis_starts_with?: InputMaybe<Scalars['String']['input']>;
  ratingBody?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ratingBody_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ratingBody_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ratingBody_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ratingBody_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ratingBody_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ratingBody_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ratingBody_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ratingBody_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ratingBody_starts_with?: InputMaybe<Scalars['String']['input']>;
  ratingBtn?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ratingBtn_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ratingBtn_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ratingBtn_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ratingBtn_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ratingBtn_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ratingBtn_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ratingBtn_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ratingBtn_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ratingBtn_starts_with?: InputMaybe<Scalars['String']['input']>;
  ratingSubtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ratingSubtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ratingSubtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ratingSubtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ratingSubtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ratingSubtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ratingSubtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ratingSubtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ratingSubtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ratingSubtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  ratingThanks?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ratingThanks_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ratingThanks_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ratingThanks_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ratingThanks_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ratingThanks_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ratingThanks_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ratingThanks_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ratingThanks_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ratingThanks_starts_with?: InputMaybe<Scalars['String']['input']>;
  ratingTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ratingTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ratingTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ratingTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ratingTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ratingTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ratingTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ratingTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ratingTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ratingTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  recipe?: InputMaybe<RecipeWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  thanksMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  thanksMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  thanksMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  thanksMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  thanksMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  thanksMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  thanksMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  thanksMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  thanksMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  thanksMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upperRightCorner?: InputMaybe<AssetWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RatingWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RatingWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RatingWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RatingWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RatingWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Rating record uniquely */
export type RatingWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** A global recipe template for configuring non Recipe DB content */
export type Recipe = Entity & Node & {
  __typename?: 'Recipe';
  /** This title is not displayed on the website; it is only used to identify this item within CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  contactPageData?: Maybe<RichText>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Recipe>;
  genericFollowUs?: Maybe<GenericFollowUs>;
  /** Hide tabs and show ingredients and preparation steps in one column one below other. Only related to mobile version */
  hideTabsOnMobile: Scalars['Boolean']['output'];
  /** List of Recipe versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The address information to appear on the print page for the recipe detail */
  longText?: Maybe<LongText>;
  market: Markets;
  marketName?: Maybe<Market>;
  metaData?: Maybe<MetaData>;
  nutritionIsActive?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  ratingmsg?: Maybe<Rating>;
  /** The life style images that are used throughout the recipe components on the recipe page. */
  recipelifestyle: Array<AssetComponent>;
  scheduledIn: Array<ScheduledOperation>;
  /** If checked, then rating popup will contain comment text input field */
  showCommentFieldInRatingModal: Scalars['Boolean']['output'];
  showContactPageData: Scalars['Boolean']['output'];
  /** Works only for AT market */
  showHappyCartButton: Scalars['Boolean']['output'];
  /** If checked, then rating banner will appear in preparation column, and standalone rating banner component will be hidden */
  showRatingBannerInPreparationColumn: Scalars['Boolean']['output'];
  /** System stage field */
  stage: Stage;
  sustainabilityBanner?: Maybe<SustainabilityBanner>;
  teaserPlaceholders: Array<TeaserPlaceholder>;
  teaserSmallPlaceholders: Array<TeaserSmallPlaceholder>;
  textBlockForRatingBannerInPreparationColumn?: Maybe<Scalars['String']['output']>;
  /** Titles for all the section on the recipe page. This data is not part of the Recipe Database. */
  titles?: Maybe<Dictionary>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** A global recipe template for configuring non Recipe DB content */
export type RecipeCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A global recipe template for configuring non Recipe DB content */
export type RecipeDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** A global recipe template for configuring non Recipe DB content */
export type RecipeGenericFollowUsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A global recipe template for configuring non Recipe DB content */
export type RecipeHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** A global recipe template for configuring non Recipe DB content */
export type RecipeLongTextArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A global recipe template for configuring non Recipe DB content */
export type RecipeMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A global recipe template for configuring non Recipe DB content */
export type RecipeMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A global recipe template for configuring non Recipe DB content */
export type RecipePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A global recipe template for configuring non Recipe DB content */
export type RecipeRatingmsgArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A global recipe template for configuring non Recipe DB content */
export type RecipeRecipelifestyleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentWhereInput>;
};


/** A global recipe template for configuring non Recipe DB content */
export type RecipeScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** A global recipe template for configuring non Recipe DB content */
export type RecipeSustainabilityBannerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A global recipe template for configuring non Recipe DB content */
export type RecipeTeaserPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserPlaceholderWhereInput>;
};


/** A global recipe template for configuring non Recipe DB content */
export type RecipeTeaserSmallPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
};


/** A global recipe template for configuring non Recipe DB content */
export type RecipeTitlesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A global recipe template for configuring non Recipe DB content */
export type RecipeUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RecipeCategory = Entity & Node & {
  __typename?: 'RecipeCategory';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Used to add the English tracking value to be used in the tracking calls */
  dictionaryItem?: Maybe<DictionaryItem>;
  /** Get the document in other stages */
  documentInStages: Array<RecipeCategory>;
  heroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** List of RecipeCategory versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  introText?: Maybe<IntroText>;
  /** Square image with transparent background */
  keyImage?: Maybe<AssetComponent>;
  link?: Maybe<Link>;
  links: Array<Link>;
  market: Markets;
  marketName?: Maybe<Market>;
  metaData?: Maybe<MetaData>;
  name?: Maybe<Scalars['String']['output']>;
  /** No more than 50 components */
  pageComponents: Array<RecipeCategoryPageComponents>;
  promoImage?: Maybe<AssetComponent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeDbCategoryId?: Maybe<Scalars['String']['output']>;
  recipeSubcategories: Array<RecipeSubcategory>;
  /** This is only visible if no content was added to the IntroText component */
  recipeSubcategorySuper: Scalars['String']['output'];
  /** This is only visible if no content was added to the IntroText component */
  recipeSubcategoryTitle: Scalars['String']['output'];
  scheduledIn: Array<ScheduledOperation>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  teaserPlaceholders: Array<TeaserPlaceholder>;
  teaserSmallPlaceholders: Array<TeaserSmallPlaceholder>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type RecipeCategoryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeCategoryDictionaryItemArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeCategoryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type RecipeCategoryHeroCarouselComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeCategoryHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type RecipeCategoryIntroTextArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeCategoryKeyImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeCategoryLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeCategoryLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


export type RecipeCategoryMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeCategoryMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeCategoryPageComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type RecipeCategoryPromoImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeCategoryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeCategoryRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RecipeSubcategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


export type RecipeCategoryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type RecipeCategoryTeaserPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserPlaceholderWhereInput>;
};


export type RecipeCategoryTeaserSmallPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
};


export type RecipeCategoryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RecipeCategoryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RecipeCategoryWhereUniqueInput;
};

/** A connection to a list of items. */
export type RecipeCategoryConnection = {
  __typename?: 'RecipeCategoryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RecipeCategoryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RecipeCategoryCreateInput = {
  cktcsbszz1mhd01xk95xj2xhz?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionaryItem?: InputMaybe<DictionaryItemCreateOneInlineInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateOneInlineInput>;
  introText?: InputMaybe<IntroTextCreateOneInlineInput>;
  keyImage?: InputMaybe<AssetComponentCreateOneInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  links?: InputMaybe<LinkCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  metaData?: InputMaybe<MetaDataCreateOneInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageComponents?: InputMaybe<RecipeCategoryPageComponentsCreateManyInlineInput>;
  promoImage?: InputMaybe<AssetComponentCreateOneInlineInput>;
  recipeDbCategoryId?: InputMaybe<Scalars['String']['input']>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  recipeSubcategorySuper: Scalars['String']['input'];
  recipeSubcategoryTitle: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderCreateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RecipeCategoryCreateManyInlineInput = {
  /** Connect multiple existing RecipeCategory documents */
  connect?: InputMaybe<Array<RecipeCategoryWhereUniqueInput>>;
  /** Create and connect multiple existing RecipeCategory documents */
  create?: InputMaybe<Array<RecipeCategoryCreateInput>>;
};

export type RecipeCategoryCreateOneInlineInput = {
  /** Connect one existing RecipeCategory document */
  connect?: InputMaybe<RecipeCategoryWhereUniqueInput>;
  /** Create and connect one RecipeCategory document */
  create?: InputMaybe<RecipeCategoryCreateInput>;
};

/** An edge in a connection. */
export type RecipeCategoryEdge = {
  __typename?: 'RecipeCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RecipeCategory;
};

/** Identifies documents */
export type RecipeCategoryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipeCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipeCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipeCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaryItem?: InputMaybe<DictionaryItemWhereInput>;
  documentInStages_every?: InputMaybe<RecipeCategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<RecipeCategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<RecipeCategoryWhereStageInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introText?: InputMaybe<IntroTextWhereInput>;
  keyImage?: InputMaybe<AssetComponentWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<RecipeCategoryPageComponentsWhereInput>;
  promoImage?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeDbCategoryId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  recipeDbCategoryId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  recipeDbCategoryId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  recipeDbCategoryId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  recipeDbCategoryId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  recipeDbCategoryId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  recipeDbCategoryId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  recipeDbCategoryId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  recipeDbCategoryId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  recipeDbCategoryId_starts_with?: InputMaybe<Scalars['String']['input']>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategorySuper?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  recipeSubcategorySuper_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  recipeSubcategorySuper_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  recipeSubcategorySuper_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  recipeSubcategorySuper_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  recipeSubcategorySuper_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  recipeSubcategorySuper_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  recipeSubcategorySuper_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  recipeSubcategorySuper_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  recipeSubcategorySuper_starts_with?: InputMaybe<Scalars['String']['input']>;
  recipeSubcategoryTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  recipeSubcategoryTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  recipeSubcategoryTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  recipeSubcategoryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  recipeSubcategoryTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  recipeSubcategoryTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  recipeSubcategoryTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  recipeSubcategoryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  recipeSubcategoryTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  recipeSubcategoryTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum RecipeCategoryOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  recipeDbCategoryId_ASC = 'recipeDbCategoryId_ASC',
  recipeDbCategoryId_DESC = 'recipeDbCategoryId_DESC',
  recipeSubcategorySuper_ASC = 'recipeSubcategorySuper_ASC',
  recipeSubcategorySuper_DESC = 'recipeSubcategorySuper_DESC',
  recipeSubcategoryTitle_ASC = 'recipeSubcategoryTitle_ASC',
  recipeSubcategoryTitle_DESC = 'recipeSubcategoryTitle_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type RecipeCategoryPageComponents = Accordion | Banner1 | Banner2 | Banner2CarouselComponent | CarouselComponent | DownloadApp | DynamicCardGrid | FeaturedContent | GenericAccordion | GenericAccordionTopRated | GenericCardCarouseComponent | GenericDownloadComponent | GenericFollowUs | GenericGridAuthorable | GenericHtml | GlobalSearch | HeroCarouselComponent | Iframe | ImageCopy | LongText | ProductBanner | Spacer;

export type RecipeCategoryPageComponentsConnectInput = {
  Accordion?: InputMaybe<AccordionConnectInput>;
  Banner1?: InputMaybe<Banner1ConnectInput>;
  Banner2?: InputMaybe<Banner2ConnectInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentConnectInput>;
  CarouselComponent?: InputMaybe<CarouselComponentConnectInput>;
  DownloadApp?: InputMaybe<DownloadAppConnectInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridConnectInput>;
  FeaturedContent?: InputMaybe<FeaturedContentConnectInput>;
  GenericAccordion?: InputMaybe<GenericAccordionConnectInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedConnectInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentConnectInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentConnectInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsConnectInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableConnectInput>;
  GenericHtml?: InputMaybe<GenericHtmlConnectInput>;
  GlobalSearch?: InputMaybe<GlobalSearchConnectInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentConnectInput>;
  Iframe?: InputMaybe<IframeConnectInput>;
  ImageCopy?: InputMaybe<ImageCopyConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
  ProductBanner?: InputMaybe<ProductBannerConnectInput>;
  Spacer?: InputMaybe<SpacerConnectInput>;
};

export type RecipeCategoryPageComponentsCreateInput = {
  Accordion?: InputMaybe<AccordionCreateInput>;
  Banner1?: InputMaybe<Banner1CreateInput>;
  Banner2?: InputMaybe<Banner2CreateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentCreateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentCreateInput>;
  DownloadApp?: InputMaybe<DownloadAppCreateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridCreateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentCreateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionCreateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedCreateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentCreateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsCreateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableCreateInput>;
  GenericHtml?: InputMaybe<GenericHtmlCreateInput>;
  GlobalSearch?: InputMaybe<GlobalSearchCreateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateInput>;
  Iframe?: InputMaybe<IframeCreateInput>;
  ImageCopy?: InputMaybe<ImageCopyCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
  ProductBanner?: InputMaybe<ProductBannerCreateInput>;
  Spacer?: InputMaybe<SpacerCreateInput>;
};

export type RecipeCategoryPageComponentsCreateManyInlineInput = {
  /** Connect multiple existing RecipeCategoryPageComponents documents */
  connect?: InputMaybe<Array<RecipeCategoryPageComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing RecipeCategoryPageComponents documents */
  create?: InputMaybe<Array<RecipeCategoryPageComponentsCreateInput>>;
};

export type RecipeCategoryPageComponentsCreateOneInlineInput = {
  /** Connect one existing RecipeCategoryPageComponents document */
  connect?: InputMaybe<RecipeCategoryPageComponentsWhereUniqueInput>;
  /** Create and connect one RecipeCategoryPageComponents document */
  create?: InputMaybe<RecipeCategoryPageComponentsCreateInput>;
};

export type RecipeCategoryPageComponentsUpdateInput = {
  Accordion?: InputMaybe<AccordionUpdateInput>;
  Banner1?: InputMaybe<Banner1UpdateInput>;
  Banner2?: InputMaybe<Banner2UpdateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateInput>;
  Iframe?: InputMaybe<IframeUpdateInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateInput>;
  Spacer?: InputMaybe<SpacerUpdateInput>;
};

export type RecipeCategoryPageComponentsUpdateManyInlineInput = {
  /** Connect multiple existing RecipeCategoryPageComponents documents */
  connect?: InputMaybe<Array<RecipeCategoryPageComponentsConnectInput>>;
  /** Create and connect multiple RecipeCategoryPageComponents documents */
  create?: InputMaybe<Array<RecipeCategoryPageComponentsCreateInput>>;
  /** Delete multiple RecipeCategoryPageComponents documents */
  delete?: InputMaybe<Array<RecipeCategoryPageComponentsWhereUniqueInput>>;
  /** Disconnect multiple RecipeCategoryPageComponents documents */
  disconnect?: InputMaybe<Array<RecipeCategoryPageComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing RecipeCategoryPageComponents documents */
  set?: InputMaybe<Array<RecipeCategoryPageComponentsWhereUniqueInput>>;
  /** Update multiple RecipeCategoryPageComponents documents */
  update?: InputMaybe<Array<RecipeCategoryPageComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple RecipeCategoryPageComponents documents */
  upsert?: InputMaybe<Array<RecipeCategoryPageComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type RecipeCategoryPageComponentsUpdateManyWithNestedWhereInput = {
  Accordion?: InputMaybe<AccordionUpdateManyWithNestedWhereInput>;
  Banner1?: InputMaybe<Banner1UpdateManyWithNestedWhereInput>;
  Banner2?: InputMaybe<Banner2UpdateManyWithNestedWhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateManyWithNestedWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateManyWithNestedWhereInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateManyWithNestedWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateManyWithNestedWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateManyWithNestedWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateManyWithNestedWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateManyWithNestedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateManyWithNestedWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateManyWithNestedWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateManyWithNestedWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateManyWithNestedWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateManyWithNestedWhereInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateManyWithNestedWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateManyWithNestedWhereInput>;
  Iframe?: InputMaybe<IframeUpdateManyWithNestedWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateManyWithNestedWhereInput>;
  Spacer?: InputMaybe<SpacerUpdateManyWithNestedWhereInput>;
};

export type RecipeCategoryPageComponentsUpdateOneInlineInput = {
  /** Connect existing RecipeCategoryPageComponents document */
  connect?: InputMaybe<RecipeCategoryPageComponentsWhereUniqueInput>;
  /** Create and connect one RecipeCategoryPageComponents document */
  create?: InputMaybe<RecipeCategoryPageComponentsCreateInput>;
  /** Delete currently connected RecipeCategoryPageComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected RecipeCategoryPageComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single RecipeCategoryPageComponents document */
  update?: InputMaybe<RecipeCategoryPageComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single RecipeCategoryPageComponents document */
  upsert?: InputMaybe<RecipeCategoryPageComponentsUpsertWithNestedWhereUniqueInput>;
};

export type RecipeCategoryPageComponentsUpdateWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpdateWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpdateWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpdateWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateWithNestedWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateWithNestedWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpdateWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpdateWithNestedWhereUniqueInput>;
};

export type RecipeCategoryPageComponentsUpsertWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpsertWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpsertWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpsertWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpsertWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpsertWithNestedWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppUpsertWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpsertWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpsertWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpsertWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpsertWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpsertWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpsertWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpsertWithNestedWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpsertWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpsertWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpsertWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpsertWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpsertWithNestedWhereUniqueInput>;
};

export type RecipeCategoryPageComponentsWhereInput = {
  Accordion?: InputMaybe<AccordionWhereInput>;
  Banner1?: InputMaybe<Banner1WhereInput>;
  Banner2?: InputMaybe<Banner2WhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  DownloadApp?: InputMaybe<DownloadAppWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereInput>;
  GlobalSearch?: InputMaybe<GlobalSearchWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  Iframe?: InputMaybe<IframeWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereInput>;
  Spacer?: InputMaybe<SpacerWhereInput>;
};

export type RecipeCategoryPageComponentsWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1WhereUniqueInput>;
  Banner2?: InputMaybe<Banner2WhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereUniqueInput>;
  Iframe?: InputMaybe<IframeWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerWhereUniqueInput>;
};

export type RecipeCategoryUpdateInput = {
  cktcsbszz1mhd01xk95xj2xhz?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  dictionaryItem?: InputMaybe<DictionaryItemUpdateOneInlineInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateOneInlineInput>;
  introText?: InputMaybe<IntroTextUpdateOneInlineInput>;
  keyImage?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  links?: InputMaybe<LinkUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  metaData?: InputMaybe<MetaDataUpdateOneInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageComponents?: InputMaybe<RecipeCategoryPageComponentsUpdateManyInlineInput>;
  promoImage?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  recipeDbCategoryId?: InputMaybe<Scalars['String']['input']>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  recipeSubcategorySuper?: InputMaybe<Scalars['String']['input']>;
  recipeSubcategoryTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderUpdateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderUpdateManyInlineInput>;
};

export type RecipeCategoryUpdateManyInlineInput = {
  /** Connect multiple existing RecipeCategory documents */
  connect?: InputMaybe<Array<RecipeCategoryConnectInput>>;
  /** Create and connect multiple RecipeCategory documents */
  create?: InputMaybe<Array<RecipeCategoryCreateInput>>;
  /** Delete multiple RecipeCategory documents */
  delete?: InputMaybe<Array<RecipeCategoryWhereUniqueInput>>;
  /** Disconnect multiple RecipeCategory documents */
  disconnect?: InputMaybe<Array<RecipeCategoryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing RecipeCategory documents */
  set?: InputMaybe<Array<RecipeCategoryWhereUniqueInput>>;
  /** Update multiple RecipeCategory documents */
  update?: InputMaybe<Array<RecipeCategoryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple RecipeCategory documents */
  upsert?: InputMaybe<Array<RecipeCategoryUpsertWithNestedWhereUniqueInput>>;
};

export type RecipeCategoryUpdateManyInput = {
  market?: InputMaybe<Markets>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipeSubcategorySuper?: InputMaybe<Scalars['String']['input']>;
  recipeSubcategoryTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type RecipeCategoryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RecipeCategoryUpdateManyInput;
  /** Document search */
  where: RecipeCategoryWhereInput;
};

export type RecipeCategoryUpdateOneInlineInput = {
  /** Connect existing RecipeCategory document */
  connect?: InputMaybe<RecipeCategoryWhereUniqueInput>;
  /** Create and connect one RecipeCategory document */
  create?: InputMaybe<RecipeCategoryCreateInput>;
  /** Delete currently connected RecipeCategory document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected RecipeCategory document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single RecipeCategory document */
  update?: InputMaybe<RecipeCategoryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single RecipeCategory document */
  upsert?: InputMaybe<RecipeCategoryUpsertWithNestedWhereUniqueInput>;
};

export type RecipeCategoryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RecipeCategoryUpdateInput;
  /** Unique document search */
  where: RecipeCategoryWhereUniqueInput;
};

export type RecipeCategoryUpsertInput = {
  /** Create document if it didn't exist */
  create: RecipeCategoryCreateInput;
  /** Update document if it exists */
  update: RecipeCategoryUpdateInput;
};

export type RecipeCategoryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RecipeCategoryUpsertInput;
  /** Unique document search */
  where: RecipeCategoryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RecipeCategoryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RecipeCategoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipeCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipeCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipeCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaryItem?: InputMaybe<DictionaryItemWhereInput>;
  documentInStages_every?: InputMaybe<RecipeCategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<RecipeCategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<RecipeCategoryWhereStageInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introText?: InputMaybe<IntroTextWhereInput>;
  keyImage?: InputMaybe<AssetComponentWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<RecipeCategoryPageComponentsWhereInput>;
  promoImage?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeDbCategoryId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  recipeDbCategoryId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  recipeDbCategoryId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  recipeDbCategoryId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  recipeDbCategoryId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  recipeDbCategoryId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  recipeDbCategoryId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  recipeDbCategoryId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  recipeDbCategoryId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  recipeDbCategoryId_starts_with?: InputMaybe<Scalars['String']['input']>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategorySuper?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  recipeSubcategorySuper_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  recipeSubcategorySuper_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  recipeSubcategorySuper_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  recipeSubcategorySuper_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  recipeSubcategorySuper_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  recipeSubcategorySuper_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  recipeSubcategorySuper_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  recipeSubcategorySuper_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  recipeSubcategorySuper_starts_with?: InputMaybe<Scalars['String']['input']>;
  recipeSubcategoryTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  recipeSubcategoryTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  recipeSubcategoryTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  recipeSubcategoryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  recipeSubcategoryTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  recipeSubcategoryTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  recipeSubcategoryTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  recipeSubcategoryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  recipeSubcategoryTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  recipeSubcategoryTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RecipeCategoryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipeCategoryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipeCategoryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipeCategoryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RecipeCategoryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References RecipeCategory record uniquely */
export type RecipeCategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  recipeDbCategoryId?: InputMaybe<Scalars['String']['input']>;
};

export type RecipeConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RecipeWhereUniqueInput;
};

/** A connection to a list of items. */
export type RecipeConnection = {
  __typename?: 'RecipeConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RecipeEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RecipeCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  contactPageData?: InputMaybe<Scalars['RichTextAST']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericFollowUs?: InputMaybe<GenericFollowUsCreateOneInlineInput>;
  hideTabsOnMobile: Scalars['Boolean']['input'];
  longText?: InputMaybe<LongTextCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  metaData?: InputMaybe<MetaDataCreateOneInlineInput>;
  nutritionIsActive?: InputMaybe<Scalars['Boolean']['input']>;
  ratingmsg?: InputMaybe<RatingCreateOneInlineInput>;
  recipelifestyle?: InputMaybe<AssetComponentCreateManyInlineInput>;
  showCommentFieldInRatingModal: Scalars['Boolean']['input'];
  showContactPageData: Scalars['Boolean']['input'];
  showHappyCartButton: Scalars['Boolean']['input'];
  showRatingBannerInPreparationColumn: Scalars['Boolean']['input'];
  sustainabilityBanner?: InputMaybe<SustainabilityBannerCreateOneInlineInput>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderCreateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderCreateManyInlineInput>;
  textBlockForRatingBannerInPreparationColumn?: InputMaybe<Scalars['String']['input']>;
  titles?: InputMaybe<DictionaryCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RecipeCreateManyInlineInput = {
  /** Connect multiple existing Recipe documents */
  connect?: InputMaybe<Array<RecipeWhereUniqueInput>>;
  /** Create and connect multiple existing Recipe documents */
  create?: InputMaybe<Array<RecipeCreateInput>>;
};

export type RecipeCreateOneInlineInput = {
  /** Connect one existing Recipe document */
  connect?: InputMaybe<RecipeWhereUniqueInput>;
  /** Create and connect one Recipe document */
  create?: InputMaybe<RecipeCreateInput>;
};

/** An edge in a connection. */
export type RecipeEdge = {
  __typename?: 'RecipeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Recipe;
};

export type RecipeLandingPage = Entity & Node & {
  __typename?: 'RecipeLandingPage';
  anchorNavigationList?: Maybe<AnchorNavigationList>;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<RecipeLandingPage>;
  heroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** List of RecipeLandingPage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  introText?: Maybe<IntroText>;
  link?: Maybe<Link>;
  links: Array<Link>;
  market: Markets;
  marketName?: Maybe<Market>;
  metaData?: Maybe<MetaData>;
  /** No more than 50 components */
  pageComponents: Array<RecipeLandingPagePageComponents>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  scheduledIn: Array<ScheduledOperation>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  teaserPlaceholders: Array<TeaserPlaceholder>;
  teaserSmallPlaceholders: Array<TeaserSmallPlaceholder>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type RecipeLandingPageAnchorNavigationListArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeLandingPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeLandingPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type RecipeLandingPageHeroCarouselComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeLandingPageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type RecipeLandingPageIntroTextArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeLandingPageLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeLandingPageLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


export type RecipeLandingPageMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeLandingPageMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeLandingPagePageComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type RecipeLandingPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipeLandingPageRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RecipeCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type RecipeLandingPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type RecipeLandingPageTeaserPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserPlaceholderWhereInput>;
};


export type RecipeLandingPageTeaserSmallPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
};


export type RecipeLandingPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RecipeLandingPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RecipeLandingPageWhereUniqueInput;
};

/** A connection to a list of items. */
export type RecipeLandingPageConnection = {
  __typename?: 'RecipeLandingPageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RecipeLandingPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RecipeLandingPageCreateInput = {
  anchorNavigationList?: InputMaybe<AnchorNavigationListCreateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateOneInlineInput>;
  introText?: InputMaybe<IntroTextCreateOneInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  links?: InputMaybe<LinkCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  metaData?: InputMaybe<MetaDataCreateOneInlineInput>;
  pageComponents?: InputMaybe<RecipeLandingPagePageComponentsCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderCreateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RecipeLandingPageCreateManyInlineInput = {
  /** Connect multiple existing RecipeLandingPage documents */
  connect?: InputMaybe<Array<RecipeLandingPageWhereUniqueInput>>;
  /** Create and connect multiple existing RecipeLandingPage documents */
  create?: InputMaybe<Array<RecipeLandingPageCreateInput>>;
};

export type RecipeLandingPageCreateOneInlineInput = {
  /** Connect one existing RecipeLandingPage document */
  connect?: InputMaybe<RecipeLandingPageWhereUniqueInput>;
  /** Create and connect one RecipeLandingPage document */
  create?: InputMaybe<RecipeLandingPageCreateInput>;
};

/** An edge in a connection. */
export type RecipeLandingPageEdge = {
  __typename?: 'RecipeLandingPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RecipeLandingPage;
};

/** Identifies documents */
export type RecipeLandingPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipeLandingPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipeLandingPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipeLandingPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNavigationList?: InputMaybe<AnchorNavigationListWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RecipeLandingPageWhereStageInput>;
  documentInStages_none?: InputMaybe<RecipeLandingPageWhereStageInput>;
  documentInStages_some?: InputMaybe<RecipeLandingPageWhereStageInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introText?: InputMaybe<IntroTextWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<RecipeLandingPagePageComponentsWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum RecipeLandingPageOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type RecipeLandingPagePageComponents = Accordion | Banner1 | Banner2 | Banner2CarouselComponent | CarouselComponent | DownloadApp | DynamicCardGrid | FeaturedContent | GenericAccordion | GenericCardCarouseComponent | GenericDownloadComponent | GenericFollowUs | GenericGridAuthorable | GenericHtml | GlobalSearch | HeroCarouselComponent | Iframe | LongText | ProductBanner | Spacer;

export type RecipeLandingPagePageComponentsConnectInput = {
  Accordion?: InputMaybe<AccordionConnectInput>;
  Banner1?: InputMaybe<Banner1ConnectInput>;
  Banner2?: InputMaybe<Banner2ConnectInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentConnectInput>;
  CarouselComponent?: InputMaybe<CarouselComponentConnectInput>;
  DownloadApp?: InputMaybe<DownloadAppConnectInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridConnectInput>;
  FeaturedContent?: InputMaybe<FeaturedContentConnectInput>;
  GenericAccordion?: InputMaybe<GenericAccordionConnectInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentConnectInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentConnectInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsConnectInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableConnectInput>;
  GenericHtml?: InputMaybe<GenericHtmlConnectInput>;
  GlobalSearch?: InputMaybe<GlobalSearchConnectInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentConnectInput>;
  Iframe?: InputMaybe<IframeConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
  ProductBanner?: InputMaybe<ProductBannerConnectInput>;
  Spacer?: InputMaybe<SpacerConnectInput>;
};

export type RecipeLandingPagePageComponentsCreateInput = {
  Accordion?: InputMaybe<AccordionCreateInput>;
  Banner1?: InputMaybe<Banner1CreateInput>;
  Banner2?: InputMaybe<Banner2CreateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentCreateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentCreateInput>;
  DownloadApp?: InputMaybe<DownloadAppCreateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridCreateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentCreateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionCreateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentCreateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsCreateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableCreateInput>;
  GenericHtml?: InputMaybe<GenericHtmlCreateInput>;
  GlobalSearch?: InputMaybe<GlobalSearchCreateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateInput>;
  Iframe?: InputMaybe<IframeCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
  ProductBanner?: InputMaybe<ProductBannerCreateInput>;
  Spacer?: InputMaybe<SpacerCreateInput>;
};

export type RecipeLandingPagePageComponentsCreateManyInlineInput = {
  /** Connect multiple existing RecipeLandingPagePageComponents documents */
  connect?: InputMaybe<Array<RecipeLandingPagePageComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing RecipeLandingPagePageComponents documents */
  create?: InputMaybe<Array<RecipeLandingPagePageComponentsCreateInput>>;
};

export type RecipeLandingPagePageComponentsCreateOneInlineInput = {
  /** Connect one existing RecipeLandingPagePageComponents document */
  connect?: InputMaybe<RecipeLandingPagePageComponentsWhereUniqueInput>;
  /** Create and connect one RecipeLandingPagePageComponents document */
  create?: InputMaybe<RecipeLandingPagePageComponentsCreateInput>;
};

export type RecipeLandingPagePageComponentsUpdateInput = {
  Accordion?: InputMaybe<AccordionUpdateInput>;
  Banner1?: InputMaybe<Banner1UpdateInput>;
  Banner2?: InputMaybe<Banner2UpdateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateInput>;
  Iframe?: InputMaybe<IframeUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateInput>;
  Spacer?: InputMaybe<SpacerUpdateInput>;
};

export type RecipeLandingPagePageComponentsUpdateManyInlineInput = {
  /** Connect multiple existing RecipeLandingPagePageComponents documents */
  connect?: InputMaybe<Array<RecipeLandingPagePageComponentsConnectInput>>;
  /** Create and connect multiple RecipeLandingPagePageComponents documents */
  create?: InputMaybe<Array<RecipeLandingPagePageComponentsCreateInput>>;
  /** Delete multiple RecipeLandingPagePageComponents documents */
  delete?: InputMaybe<Array<RecipeLandingPagePageComponentsWhereUniqueInput>>;
  /** Disconnect multiple RecipeLandingPagePageComponents documents */
  disconnect?: InputMaybe<Array<RecipeLandingPagePageComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing RecipeLandingPagePageComponents documents */
  set?: InputMaybe<Array<RecipeLandingPagePageComponentsWhereUniqueInput>>;
  /** Update multiple RecipeLandingPagePageComponents documents */
  update?: InputMaybe<Array<RecipeLandingPagePageComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple RecipeLandingPagePageComponents documents */
  upsert?: InputMaybe<Array<RecipeLandingPagePageComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type RecipeLandingPagePageComponentsUpdateManyWithNestedWhereInput = {
  Accordion?: InputMaybe<AccordionUpdateManyWithNestedWhereInput>;
  Banner1?: InputMaybe<Banner1UpdateManyWithNestedWhereInput>;
  Banner2?: InputMaybe<Banner2UpdateManyWithNestedWhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateManyWithNestedWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateManyWithNestedWhereInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateManyWithNestedWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateManyWithNestedWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateManyWithNestedWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateManyWithNestedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateManyWithNestedWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateManyWithNestedWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateManyWithNestedWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateManyWithNestedWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateManyWithNestedWhereInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateManyWithNestedWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateManyWithNestedWhereInput>;
  Iframe?: InputMaybe<IframeUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateManyWithNestedWhereInput>;
  Spacer?: InputMaybe<SpacerUpdateManyWithNestedWhereInput>;
};

export type RecipeLandingPagePageComponentsUpdateOneInlineInput = {
  /** Connect existing RecipeLandingPagePageComponents document */
  connect?: InputMaybe<RecipeLandingPagePageComponentsWhereUniqueInput>;
  /** Create and connect one RecipeLandingPagePageComponents document */
  create?: InputMaybe<RecipeLandingPagePageComponentsCreateInput>;
  /** Delete currently connected RecipeLandingPagePageComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected RecipeLandingPagePageComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single RecipeLandingPagePageComponents document */
  update?: InputMaybe<RecipeLandingPagePageComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single RecipeLandingPagePageComponents document */
  upsert?: InputMaybe<RecipeLandingPagePageComponentsUpsertWithNestedWhereUniqueInput>;
};

export type RecipeLandingPagePageComponentsUpdateWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpdateWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpdateWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpdateWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateWithNestedWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateWithNestedWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpdateWithNestedWhereUniqueInput>;
};

export type RecipeLandingPagePageComponentsUpsertWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpsertWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpsertWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpsertWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpsertWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpsertWithNestedWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppUpsertWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpsertWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpsertWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpsertWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpsertWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpsertWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpsertWithNestedWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpsertWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpsertWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpsertWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpsertWithNestedWhereUniqueInput>;
};

export type RecipeLandingPagePageComponentsWhereInput = {
  Accordion?: InputMaybe<AccordionWhereInput>;
  Banner1?: InputMaybe<Banner1WhereInput>;
  Banner2?: InputMaybe<Banner2WhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  DownloadApp?: InputMaybe<DownloadAppWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereInput>;
  GlobalSearch?: InputMaybe<GlobalSearchWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  Iframe?: InputMaybe<IframeWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereInput>;
  Spacer?: InputMaybe<SpacerWhereInput>;
};

export type RecipeLandingPagePageComponentsWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1WhereUniqueInput>;
  Banner2?: InputMaybe<Banner2WhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereUniqueInput>;
  Iframe?: InputMaybe<IframeWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerWhereUniqueInput>;
};

export type RecipeLandingPageUpdateInput = {
  anchorNavigationList?: InputMaybe<AnchorNavigationListUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateOneInlineInput>;
  introText?: InputMaybe<IntroTextUpdateOneInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  links?: InputMaybe<LinkUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  metaData?: InputMaybe<MetaDataUpdateOneInlineInput>;
  pageComponents?: InputMaybe<RecipeLandingPagePageComponentsUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderUpdateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderUpdateManyInlineInput>;
};

export type RecipeLandingPageUpdateManyInlineInput = {
  /** Connect multiple existing RecipeLandingPage documents */
  connect?: InputMaybe<Array<RecipeLandingPageConnectInput>>;
  /** Create and connect multiple RecipeLandingPage documents */
  create?: InputMaybe<Array<RecipeLandingPageCreateInput>>;
  /** Delete multiple RecipeLandingPage documents */
  delete?: InputMaybe<Array<RecipeLandingPageWhereUniqueInput>>;
  /** Disconnect multiple RecipeLandingPage documents */
  disconnect?: InputMaybe<Array<RecipeLandingPageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing RecipeLandingPage documents */
  set?: InputMaybe<Array<RecipeLandingPageWhereUniqueInput>>;
  /** Update multiple RecipeLandingPage documents */
  update?: InputMaybe<Array<RecipeLandingPageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple RecipeLandingPage documents */
  upsert?: InputMaybe<Array<RecipeLandingPageUpsertWithNestedWhereUniqueInput>>;
};

export type RecipeLandingPageUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type RecipeLandingPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RecipeLandingPageUpdateManyInput;
  /** Document search */
  where: RecipeLandingPageWhereInput;
};

export type RecipeLandingPageUpdateOneInlineInput = {
  /** Connect existing RecipeLandingPage document */
  connect?: InputMaybe<RecipeLandingPageWhereUniqueInput>;
  /** Create and connect one RecipeLandingPage document */
  create?: InputMaybe<RecipeLandingPageCreateInput>;
  /** Delete currently connected RecipeLandingPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected RecipeLandingPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single RecipeLandingPage document */
  update?: InputMaybe<RecipeLandingPageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single RecipeLandingPage document */
  upsert?: InputMaybe<RecipeLandingPageUpsertWithNestedWhereUniqueInput>;
};

export type RecipeLandingPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RecipeLandingPageUpdateInput;
  /** Unique document search */
  where: RecipeLandingPageWhereUniqueInput;
};

export type RecipeLandingPageUpsertInput = {
  /** Create document if it didn't exist */
  create: RecipeLandingPageCreateInput;
  /** Update document if it exists */
  update: RecipeLandingPageUpdateInput;
};

export type RecipeLandingPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RecipeLandingPageUpsertInput;
  /** Unique document search */
  where: RecipeLandingPageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RecipeLandingPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RecipeLandingPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipeLandingPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipeLandingPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipeLandingPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNavigationList?: InputMaybe<AnchorNavigationListWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RecipeLandingPageWhereStageInput>;
  documentInStages_none?: InputMaybe<RecipeLandingPageWhereStageInput>;
  documentInStages_some?: InputMaybe<RecipeLandingPageWhereStageInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introText?: InputMaybe<IntroTextWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<RecipeLandingPagePageComponentsWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RecipeLandingPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipeLandingPageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipeLandingPageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipeLandingPageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RecipeLandingPageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References RecipeLandingPage record uniquely */
export type RecipeLandingPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
};

/** Identifies documents */
export type RecipeManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RecipeWhereStageInput>;
  documentInStages_none?: InputMaybe<RecipeWhereStageInput>;
  documentInStages_some?: InputMaybe<RecipeWhereStageInput>;
  genericFollowUs?: InputMaybe<GenericFollowUsWhereInput>;
  hideTabsOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hideTabsOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  longText?: InputMaybe<LongTextWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  nutritionIsActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  nutritionIsActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  ratingmsg?: InputMaybe<RatingWhereInput>;
  recipelifestyle_every?: InputMaybe<AssetComponentWhereInput>;
  recipelifestyle_none?: InputMaybe<AssetComponentWhereInput>;
  recipelifestyle_some?: InputMaybe<AssetComponentWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showCommentFieldInRatingModal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showCommentFieldInRatingModal_not?: InputMaybe<Scalars['Boolean']['input']>;
  showContactPageData?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showContactPageData_not?: InputMaybe<Scalars['Boolean']['input']>;
  showHappyCartButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showHappyCartButton_not?: InputMaybe<Scalars['Boolean']['input']>;
  showRatingBannerInPreparationColumn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showRatingBannerInPreparationColumn_not?: InputMaybe<Scalars['Boolean']['input']>;
  sustainabilityBanner?: InputMaybe<SustainabilityBannerWhereInput>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  textBlockForRatingBannerInPreparationColumn?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  textBlockForRatingBannerInPreparationColumn_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  textBlockForRatingBannerInPreparationColumn_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  textBlockForRatingBannerInPreparationColumn_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  textBlockForRatingBannerInPreparationColumn_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  textBlockForRatingBannerInPreparationColumn_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  textBlockForRatingBannerInPreparationColumn_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  textBlockForRatingBannerInPreparationColumn_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  textBlockForRatingBannerInPreparationColumn_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  textBlockForRatingBannerInPreparationColumn_starts_with?: InputMaybe<Scalars['String']['input']>;
  titles?: InputMaybe<DictionaryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum RecipeOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  hideTabsOnMobile_ASC = 'hideTabsOnMobile_ASC',
  hideTabsOnMobile_DESC = 'hideTabsOnMobile_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  nutritionIsActive_ASC = 'nutritionIsActive_ASC',
  nutritionIsActive_DESC = 'nutritionIsActive_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  showCommentFieldInRatingModal_ASC = 'showCommentFieldInRatingModal_ASC',
  showCommentFieldInRatingModal_DESC = 'showCommentFieldInRatingModal_DESC',
  showContactPageData_ASC = 'showContactPageData_ASC',
  showContactPageData_DESC = 'showContactPageData_DESC',
  showHappyCartButton_ASC = 'showHappyCartButton_ASC',
  showHappyCartButton_DESC = 'showHappyCartButton_DESC',
  showRatingBannerInPreparationColumn_ASC = 'showRatingBannerInPreparationColumn_ASC',
  showRatingBannerInPreparationColumn_DESC = 'showRatingBannerInPreparationColumn_DESC',
  textBlockForRatingBannerInPreparationColumn_ASC = 'textBlockForRatingBannerInPreparationColumn_ASC',
  textBlockForRatingBannerInPreparationColumn_DESC = 'textBlockForRatingBannerInPreparationColumn_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategory = Entity & Node & {
  __typename?: 'RecipeSubcategory';
  /** Select the category or subcategory via the UI Extension. */
  algoliaExtension?: Maybe<AlgoliaExtension>;
  anchorNav?: Maybe<AnchorNavigation>;
  /** Title used in the CMS for filtering and searching. */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Used to add the English tracking value to be used in the tracking calls */
  dictionaryItem?: Maybe<DictionaryItem>;
  /** Get the document in other stages */
  documentInStages: Array<RecipeSubcategory>;
  heroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** List of RecipeSubcategory versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  introText?: Maybe<IntroText>;
  /** Rectangular image without transparent background for cards on all recipes page */
  keyImage?: Maybe<AssetComponent>;
  link?: Maybe<Link>;
  links: Array<Link>;
  market: Markets;
  marketName?: Maybe<Market>;
  metaData?: Maybe<MetaData>;
  pageComponents: Array<RecipeSubcategoryPageComponents>;
  /** Square image with transparent background for card on Category Page */
  promoImage?: Maybe<AssetComponent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategory?: Maybe<RecipeCategory>;
  /** Please be aware that unpublished recipes from PimCore will not appear in the grid. */
  recipeIDs: Array<Scalars['String']['output']>;
  /** The Sub Category name to be used to reference the child categories  */
  recipeSubCategoryName?: Maybe<Scalars['String']['output']>;
  recipeSubSubcategories: Array<RecipeSubcategory>;
  recipeSubcategory?: Maybe<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** Super text shown on sub sub component  */
  subSubCategorySuper?: Maybe<Scalars['String']['output']>;
  /** Title shown on sub sub category component */
  subSubCategoryTitle?: Maybe<Scalars['String']['output']>;
  teaserPlaceholders: Array<TeaserPlaceholder>;
  teaserSmallPlaceholders: Array<TeaserSmallPlaceholder>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryAlgoliaExtensionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryDictionaryItemArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryHeroCarouselComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryIntroTextArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryKeyImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryPageComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryPromoImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryRecipeCategoryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryRecipeSubSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<RecipeSubcategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryRecipeSubcategoryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryTeaserPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserPlaceholderWhereInput>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryTeaserSmallPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
};


/** Create recipe subcategories via the Recipe UI extension to populate the UI */
export type RecipeSubcategoryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RecipeSubcategoryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RecipeSubcategoryWhereUniqueInput;
};

/** A connection to a list of items. */
export type RecipeSubcategoryConnection = {
  __typename?: 'RecipeSubcategoryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RecipeSubcategoryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RecipeSubcategoryCreateInput = {
  algoliaExtension?: InputMaybe<AlgoliaExtensionCreateOneInlineInput>;
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionaryItem?: InputMaybe<DictionaryItemCreateOneInlineInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateOneInlineInput>;
  introText?: InputMaybe<IntroTextCreateOneInlineInput>;
  keyImage?: InputMaybe<AssetComponentCreateOneInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  links?: InputMaybe<LinkCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  metaData?: InputMaybe<MetaDataCreateOneInlineInput>;
  pageComponents?: InputMaybe<RecipeSubcategoryPageComponentsCreateManyInlineInput>;
  promoImage?: InputMaybe<AssetComponentCreateOneInlineInput>;
  recipeCategory?: InputMaybe<RecipeCategoryCreateOneInlineInput>;
  recipeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  recipeSubCategoryName?: InputMaybe<Scalars['String']['input']>;
  recipeSubSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  recipeSubcategory?: InputMaybe<RecipeSubcategoryCreateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subSubCategorySuper?: InputMaybe<Scalars['String']['input']>;
  subSubCategoryTitle?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderCreateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RecipeSubcategoryCreateManyInlineInput = {
  /** Connect multiple existing RecipeSubcategory documents */
  connect?: InputMaybe<Array<RecipeSubcategoryWhereUniqueInput>>;
  /** Create and connect multiple existing RecipeSubcategory documents */
  create?: InputMaybe<Array<RecipeSubcategoryCreateInput>>;
};

export type RecipeSubcategoryCreateOneInlineInput = {
  /** Connect one existing RecipeSubcategory document */
  connect?: InputMaybe<RecipeSubcategoryWhereUniqueInput>;
  /** Create and connect one RecipeSubcategory document */
  create?: InputMaybe<RecipeSubcategoryCreateInput>;
};

/** An edge in a connection. */
export type RecipeSubcategoryEdge = {
  __typename?: 'RecipeSubcategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RecipeSubcategory;
};

/** Identifies documents */
export type RecipeSubcategoryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipeSubcategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipeSubcategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipeSubcategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  algoliaExtension?: InputMaybe<AlgoliaExtensionWhereInput>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaryItem?: InputMaybe<DictionaryItemWhereInput>;
  documentInStages_every?: InputMaybe<RecipeSubcategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<RecipeSubcategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<RecipeSubcategoryWhereStageInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introText?: InputMaybe<IntroTextWhereInput>;
  keyImage?: InputMaybe<AssetComponentWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<RecipeSubcategoryPageComponentsWhereInput>;
  promoImage?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategory?: InputMaybe<RecipeCategoryWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  recipeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  recipeIDs_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  recipeIDs_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  recipeIDs_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  recipeIDs_not?: InputMaybe<Array<Scalars['String']['input']>>;
  recipeSubCategoryName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  recipeSubCategoryName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  recipeSubCategoryName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  recipeSubCategoryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  recipeSubCategoryName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  recipeSubCategoryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  recipeSubCategoryName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  recipeSubCategoryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  recipeSubCategoryName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  recipeSubCategoryName_starts_with?: InputMaybe<Scalars['String']['input']>;
  recipeSubSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategory?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  subSubCategorySuper?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subSubCategorySuper_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subSubCategorySuper_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subSubCategorySuper_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subSubCategorySuper_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subSubCategorySuper_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subSubCategorySuper_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subSubCategorySuper_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subSubCategorySuper_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subSubCategorySuper_starts_with?: InputMaybe<Scalars['String']['input']>;
  subSubCategoryTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subSubCategoryTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subSubCategoryTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subSubCategoryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subSubCategoryTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subSubCategoryTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subSubCategoryTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subSubCategoryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subSubCategoryTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subSubCategoryTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum RecipeSubcategoryOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  recipeIDs_ASC = 'recipeIDs_ASC',
  recipeIDs_DESC = 'recipeIDs_DESC',
  recipeSubCategoryName_ASC = 'recipeSubCategoryName_ASC',
  recipeSubCategoryName_DESC = 'recipeSubCategoryName_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  subSubCategorySuper_ASC = 'subSubCategorySuper_ASC',
  subSubCategorySuper_DESC = 'subSubCategorySuper_DESC',
  subSubCategoryTitle_ASC = 'subSubCategoryTitle_ASC',
  subSubCategoryTitle_DESC = 'subSubCategoryTitle_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type RecipeSubcategoryPageComponents = Accordion | Banner1 | Banner2 | Banner2CarouselComponent | CarouselComponent | DownloadApp | DynamicCardGrid | FeaturedContent | GenericAccordion | GenericAccordionTopRated | GenericCardCarouseComponent | GenericDownloadComponent | GenericFollowUs | GenericGridAuthorable | GenericHtml | GlobalSearch | HeroCarouselComponent | Iframe | ImageCopy | LongText | ProductBanner | Spacer;

export type RecipeSubcategoryPageComponentsConnectInput = {
  Accordion?: InputMaybe<AccordionConnectInput>;
  Banner1?: InputMaybe<Banner1ConnectInput>;
  Banner2?: InputMaybe<Banner2ConnectInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentConnectInput>;
  CarouselComponent?: InputMaybe<CarouselComponentConnectInput>;
  DownloadApp?: InputMaybe<DownloadAppConnectInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridConnectInput>;
  FeaturedContent?: InputMaybe<FeaturedContentConnectInput>;
  GenericAccordion?: InputMaybe<GenericAccordionConnectInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedConnectInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentConnectInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentConnectInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsConnectInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableConnectInput>;
  GenericHtml?: InputMaybe<GenericHtmlConnectInput>;
  GlobalSearch?: InputMaybe<GlobalSearchConnectInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentConnectInput>;
  Iframe?: InputMaybe<IframeConnectInput>;
  ImageCopy?: InputMaybe<ImageCopyConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
  ProductBanner?: InputMaybe<ProductBannerConnectInput>;
  Spacer?: InputMaybe<SpacerConnectInput>;
};

export type RecipeSubcategoryPageComponentsCreateInput = {
  Accordion?: InputMaybe<AccordionCreateInput>;
  Banner1?: InputMaybe<Banner1CreateInput>;
  Banner2?: InputMaybe<Banner2CreateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentCreateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentCreateInput>;
  DownloadApp?: InputMaybe<DownloadAppCreateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridCreateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentCreateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionCreateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedCreateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentCreateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsCreateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableCreateInput>;
  GenericHtml?: InputMaybe<GenericHtmlCreateInput>;
  GlobalSearch?: InputMaybe<GlobalSearchCreateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateInput>;
  Iframe?: InputMaybe<IframeCreateInput>;
  ImageCopy?: InputMaybe<ImageCopyCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
  ProductBanner?: InputMaybe<ProductBannerCreateInput>;
  Spacer?: InputMaybe<SpacerCreateInput>;
};

export type RecipeSubcategoryPageComponentsCreateManyInlineInput = {
  /** Connect multiple existing RecipeSubcategoryPageComponents documents */
  connect?: InputMaybe<Array<RecipeSubcategoryPageComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing RecipeSubcategoryPageComponents documents */
  create?: InputMaybe<Array<RecipeSubcategoryPageComponentsCreateInput>>;
};

export type RecipeSubcategoryPageComponentsCreateOneInlineInput = {
  /** Connect one existing RecipeSubcategoryPageComponents document */
  connect?: InputMaybe<RecipeSubcategoryPageComponentsWhereUniqueInput>;
  /** Create and connect one RecipeSubcategoryPageComponents document */
  create?: InputMaybe<RecipeSubcategoryPageComponentsCreateInput>;
};

export type RecipeSubcategoryPageComponentsUpdateInput = {
  Accordion?: InputMaybe<AccordionUpdateInput>;
  Banner1?: InputMaybe<Banner1UpdateInput>;
  Banner2?: InputMaybe<Banner2UpdateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateInput>;
  Iframe?: InputMaybe<IframeUpdateInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateInput>;
  Spacer?: InputMaybe<SpacerUpdateInput>;
};

export type RecipeSubcategoryPageComponentsUpdateManyInlineInput = {
  /** Connect multiple existing RecipeSubcategoryPageComponents documents */
  connect?: InputMaybe<Array<RecipeSubcategoryPageComponentsConnectInput>>;
  /** Create and connect multiple RecipeSubcategoryPageComponents documents */
  create?: InputMaybe<Array<RecipeSubcategoryPageComponentsCreateInput>>;
  /** Delete multiple RecipeSubcategoryPageComponents documents */
  delete?: InputMaybe<Array<RecipeSubcategoryPageComponentsWhereUniqueInput>>;
  /** Disconnect multiple RecipeSubcategoryPageComponents documents */
  disconnect?: InputMaybe<Array<RecipeSubcategoryPageComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing RecipeSubcategoryPageComponents documents */
  set?: InputMaybe<Array<RecipeSubcategoryPageComponentsWhereUniqueInput>>;
  /** Update multiple RecipeSubcategoryPageComponents documents */
  update?: InputMaybe<Array<RecipeSubcategoryPageComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple RecipeSubcategoryPageComponents documents */
  upsert?: InputMaybe<Array<RecipeSubcategoryPageComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type RecipeSubcategoryPageComponentsUpdateManyWithNestedWhereInput = {
  Accordion?: InputMaybe<AccordionUpdateManyWithNestedWhereInput>;
  Banner1?: InputMaybe<Banner1UpdateManyWithNestedWhereInput>;
  Banner2?: InputMaybe<Banner2UpdateManyWithNestedWhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateManyWithNestedWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateManyWithNestedWhereInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateManyWithNestedWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateManyWithNestedWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateManyWithNestedWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateManyWithNestedWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateManyWithNestedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateManyWithNestedWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateManyWithNestedWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateManyWithNestedWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateManyWithNestedWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateManyWithNestedWhereInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateManyWithNestedWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateManyWithNestedWhereInput>;
  Iframe?: InputMaybe<IframeUpdateManyWithNestedWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateManyWithNestedWhereInput>;
  Spacer?: InputMaybe<SpacerUpdateManyWithNestedWhereInput>;
};

export type RecipeSubcategoryPageComponentsUpdateOneInlineInput = {
  /** Connect existing RecipeSubcategoryPageComponents document */
  connect?: InputMaybe<RecipeSubcategoryPageComponentsWhereUniqueInput>;
  /** Create and connect one RecipeSubcategoryPageComponents document */
  create?: InputMaybe<RecipeSubcategoryPageComponentsCreateInput>;
  /** Delete currently connected RecipeSubcategoryPageComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected RecipeSubcategoryPageComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single RecipeSubcategoryPageComponents document */
  update?: InputMaybe<RecipeSubcategoryPageComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single RecipeSubcategoryPageComponents document */
  upsert?: InputMaybe<RecipeSubcategoryPageComponentsUpsertWithNestedWhereUniqueInput>;
};

export type RecipeSubcategoryPageComponentsUpdateWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpdateWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpdateWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpdateWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateWithNestedWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppUpdateWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateWithNestedWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpdateWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpdateWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpdateWithNestedWhereUniqueInput>;
};

export type RecipeSubcategoryPageComponentsUpsertWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpsertWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpsertWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpsertWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpsertWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpsertWithNestedWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppUpsertWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpsertWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpsertWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpsertWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpsertWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpsertWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpsertWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpsertWithNestedWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchUpsertWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpsertWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpsertWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpsertWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpsertWithNestedWhereUniqueInput>;
};

export type RecipeSubcategoryPageComponentsWhereInput = {
  Accordion?: InputMaybe<AccordionWhereInput>;
  Banner1?: InputMaybe<Banner1WhereInput>;
  Banner2?: InputMaybe<Banner2WhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  DownloadApp?: InputMaybe<DownloadAppWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereInput>;
  GlobalSearch?: InputMaybe<GlobalSearchWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  Iframe?: InputMaybe<IframeWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereInput>;
  Spacer?: InputMaybe<SpacerWhereInput>;
};

export type RecipeSubcategoryPageComponentsWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1WhereUniqueInput>;
  Banner2?: InputMaybe<Banner2WhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereUniqueInput>;
  DownloadApp?: InputMaybe<DownloadAppWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereUniqueInput>;
  GlobalSearch?: InputMaybe<GlobalSearchWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereUniqueInput>;
  Iframe?: InputMaybe<IframeWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerWhereUniqueInput>;
};

export type RecipeSubcategoryUpdateInput = {
  algoliaExtension?: InputMaybe<AlgoliaExtensionUpdateOneInlineInput>;
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  dictionaryItem?: InputMaybe<DictionaryItemUpdateOneInlineInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateOneInlineInput>;
  introText?: InputMaybe<IntroTextUpdateOneInlineInput>;
  keyImage?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  links?: InputMaybe<LinkUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  metaData?: InputMaybe<MetaDataUpdateOneInlineInput>;
  pageComponents?: InputMaybe<RecipeSubcategoryPageComponentsUpdateManyInlineInput>;
  promoImage?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  recipeCategory?: InputMaybe<RecipeCategoryUpdateOneInlineInput>;
  recipeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  recipeSubCategoryName?: InputMaybe<Scalars['String']['input']>;
  recipeSubSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
  recipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subSubCategorySuper?: InputMaybe<Scalars['String']['input']>;
  subSubCategoryTitle?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderUpdateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderUpdateManyInlineInput>;
};

export type RecipeSubcategoryUpdateManyInlineInput = {
  /** Connect multiple existing RecipeSubcategory documents */
  connect?: InputMaybe<Array<RecipeSubcategoryConnectInput>>;
  /** Create and connect multiple RecipeSubcategory documents */
  create?: InputMaybe<Array<RecipeSubcategoryCreateInput>>;
  /** Delete multiple RecipeSubcategory documents */
  delete?: InputMaybe<Array<RecipeSubcategoryWhereUniqueInput>>;
  /** Disconnect multiple RecipeSubcategory documents */
  disconnect?: InputMaybe<Array<RecipeSubcategoryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing RecipeSubcategory documents */
  set?: InputMaybe<Array<RecipeSubcategoryWhereUniqueInput>>;
  /** Update multiple RecipeSubcategory documents */
  update?: InputMaybe<Array<RecipeSubcategoryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple RecipeSubcategory documents */
  upsert?: InputMaybe<Array<RecipeSubcategoryUpsertWithNestedWhereUniqueInput>>;
};

export type RecipeSubcategoryUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  recipeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  recipeSubCategoryName?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subSubCategorySuper?: InputMaybe<Scalars['String']['input']>;
  subSubCategoryTitle?: InputMaybe<Scalars['String']['input']>;
};

export type RecipeSubcategoryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RecipeSubcategoryUpdateManyInput;
  /** Document search */
  where: RecipeSubcategoryWhereInput;
};

export type RecipeSubcategoryUpdateOneInlineInput = {
  /** Connect existing RecipeSubcategory document */
  connect?: InputMaybe<RecipeSubcategoryWhereUniqueInput>;
  /** Create and connect one RecipeSubcategory document */
  create?: InputMaybe<RecipeSubcategoryCreateInput>;
  /** Delete currently connected RecipeSubcategory document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected RecipeSubcategory document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single RecipeSubcategory document */
  update?: InputMaybe<RecipeSubcategoryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single RecipeSubcategory document */
  upsert?: InputMaybe<RecipeSubcategoryUpsertWithNestedWhereUniqueInput>;
};

export type RecipeSubcategoryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RecipeSubcategoryUpdateInput;
  /** Unique document search */
  where: RecipeSubcategoryWhereUniqueInput;
};

export type RecipeSubcategoryUpsertInput = {
  /** Create document if it didn't exist */
  create: RecipeSubcategoryCreateInput;
  /** Update document if it exists */
  update: RecipeSubcategoryUpdateInput;
};

export type RecipeSubcategoryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RecipeSubcategoryUpsertInput;
  /** Unique document search */
  where: RecipeSubcategoryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RecipeSubcategoryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RecipeSubcategoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipeSubcategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipeSubcategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipeSubcategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  algoliaExtension?: InputMaybe<AlgoliaExtensionWhereInput>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaryItem?: InputMaybe<DictionaryItemWhereInput>;
  documentInStages_every?: InputMaybe<RecipeSubcategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<RecipeSubcategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<RecipeSubcategoryWhereStageInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introText?: InputMaybe<IntroTextWhereInput>;
  keyImage?: InputMaybe<AssetComponentWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<RecipeSubcategoryPageComponentsWhereInput>;
  promoImage?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategory?: InputMaybe<RecipeCategoryWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  recipeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  recipeIDs_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  recipeIDs_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  recipeIDs_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  recipeIDs_not?: InputMaybe<Array<Scalars['String']['input']>>;
  recipeSubCategoryName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  recipeSubCategoryName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  recipeSubCategoryName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  recipeSubCategoryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  recipeSubCategoryName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  recipeSubCategoryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  recipeSubCategoryName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  recipeSubCategoryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  recipeSubCategoryName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  recipeSubCategoryName_starts_with?: InputMaybe<Scalars['String']['input']>;
  recipeSubSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategory?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  subSubCategorySuper?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subSubCategorySuper_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subSubCategorySuper_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subSubCategorySuper_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subSubCategorySuper_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subSubCategorySuper_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subSubCategorySuper_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subSubCategorySuper_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subSubCategorySuper_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subSubCategorySuper_starts_with?: InputMaybe<Scalars['String']['input']>;
  subSubCategoryTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subSubCategoryTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subSubCategoryTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subSubCategoryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subSubCategoryTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subSubCategoryTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subSubCategoryTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subSubCategoryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subSubCategoryTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subSubCategoryTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RecipeSubcategoryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipeSubcategoryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipeSubcategoryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipeSubcategoryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RecipeSubcategoryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References RecipeSubcategory record uniquely */
export type RecipeSubcategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RecipeUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  contactPageData?: InputMaybe<Scalars['RichTextAST']['input']>;
  genericFollowUs?: InputMaybe<GenericFollowUsUpdateOneInlineInput>;
  hideTabsOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  longText?: InputMaybe<LongTextUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  metaData?: InputMaybe<MetaDataUpdateOneInlineInput>;
  nutritionIsActive?: InputMaybe<Scalars['Boolean']['input']>;
  ratingmsg?: InputMaybe<RatingUpdateOneInlineInput>;
  recipelifestyle?: InputMaybe<AssetComponentUpdateManyInlineInput>;
  showCommentFieldInRatingModal?: InputMaybe<Scalars['Boolean']['input']>;
  showContactPageData?: InputMaybe<Scalars['Boolean']['input']>;
  showHappyCartButton?: InputMaybe<Scalars['Boolean']['input']>;
  showRatingBannerInPreparationColumn?: InputMaybe<Scalars['Boolean']['input']>;
  sustainabilityBanner?: InputMaybe<SustainabilityBannerUpdateOneInlineInput>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderUpdateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderUpdateManyInlineInput>;
  textBlockForRatingBannerInPreparationColumn?: InputMaybe<Scalars['String']['input']>;
  titles?: InputMaybe<DictionaryUpdateOneInlineInput>;
};

export type RecipeUpdateManyInlineInput = {
  /** Connect multiple existing Recipe documents */
  connect?: InputMaybe<Array<RecipeConnectInput>>;
  /** Create and connect multiple Recipe documents */
  create?: InputMaybe<Array<RecipeCreateInput>>;
  /** Delete multiple Recipe documents */
  delete?: InputMaybe<Array<RecipeWhereUniqueInput>>;
  /** Disconnect multiple Recipe documents */
  disconnect?: InputMaybe<Array<RecipeWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Recipe documents */
  set?: InputMaybe<Array<RecipeWhereUniqueInput>>;
  /** Update multiple Recipe documents */
  update?: InputMaybe<Array<RecipeUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Recipe documents */
  upsert?: InputMaybe<Array<RecipeUpsertWithNestedWhereUniqueInput>>;
};

export type RecipeUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  contactPageData?: InputMaybe<Scalars['RichTextAST']['input']>;
  hideTabsOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  nutritionIsActive?: InputMaybe<Scalars['Boolean']['input']>;
  showCommentFieldInRatingModal?: InputMaybe<Scalars['Boolean']['input']>;
  showContactPageData?: InputMaybe<Scalars['Boolean']['input']>;
  showHappyCartButton?: InputMaybe<Scalars['Boolean']['input']>;
  showRatingBannerInPreparationColumn?: InputMaybe<Scalars['Boolean']['input']>;
  textBlockForRatingBannerInPreparationColumn?: InputMaybe<Scalars['String']['input']>;
};

export type RecipeUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RecipeUpdateManyInput;
  /** Document search */
  where: RecipeWhereInput;
};

export type RecipeUpdateOneInlineInput = {
  /** Connect existing Recipe document */
  connect?: InputMaybe<RecipeWhereUniqueInput>;
  /** Create and connect one Recipe document */
  create?: InputMaybe<RecipeCreateInput>;
  /** Delete currently connected Recipe document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Recipe document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Recipe document */
  update?: InputMaybe<RecipeUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Recipe document */
  upsert?: InputMaybe<RecipeUpsertWithNestedWhereUniqueInput>;
};

export type RecipeUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RecipeUpdateInput;
  /** Unique document search */
  where: RecipeWhereUniqueInput;
};

export type RecipeUpsertInput = {
  /** Create document if it didn't exist */
  create: RecipeCreateInput;
  /** Update document if it exists */
  update: RecipeUpdateInput;
};

export type RecipeUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RecipeUpsertInput;
  /** Unique document search */
  where: RecipeWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RecipeWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RecipeWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RecipeWhereStageInput>;
  documentInStages_none?: InputMaybe<RecipeWhereStageInput>;
  documentInStages_some?: InputMaybe<RecipeWhereStageInput>;
  genericFollowUs?: InputMaybe<GenericFollowUsWhereInput>;
  hideTabsOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hideTabsOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  longText?: InputMaybe<LongTextWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  nutritionIsActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  nutritionIsActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  ratingmsg?: InputMaybe<RatingWhereInput>;
  recipelifestyle_every?: InputMaybe<AssetComponentWhereInput>;
  recipelifestyle_none?: InputMaybe<AssetComponentWhereInput>;
  recipelifestyle_some?: InputMaybe<AssetComponentWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showCommentFieldInRatingModal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showCommentFieldInRatingModal_not?: InputMaybe<Scalars['Boolean']['input']>;
  showContactPageData?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showContactPageData_not?: InputMaybe<Scalars['Boolean']['input']>;
  showHappyCartButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showHappyCartButton_not?: InputMaybe<Scalars['Boolean']['input']>;
  showRatingBannerInPreparationColumn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showRatingBannerInPreparationColumn_not?: InputMaybe<Scalars['Boolean']['input']>;
  sustainabilityBanner?: InputMaybe<SustainabilityBannerWhereInput>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  textBlockForRatingBannerInPreparationColumn?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  textBlockForRatingBannerInPreparationColumn_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  textBlockForRatingBannerInPreparationColumn_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  textBlockForRatingBannerInPreparationColumn_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  textBlockForRatingBannerInPreparationColumn_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  textBlockForRatingBannerInPreparationColumn_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  textBlockForRatingBannerInPreparationColumn_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  textBlockForRatingBannerInPreparationColumn_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  textBlockForRatingBannerInPreparationColumn_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  textBlockForRatingBannerInPreparationColumn_starts_with?: InputMaybe<Scalars['String']['input']>;
  titles?: InputMaybe<DictionaryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RecipeWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipeWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipeWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipeWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RecipeWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Recipe record uniquely */
export type RecipeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
};

export enum RecipesComparisonQueries {
  BakingTimeInMinutes = 'BakingTimeInMinutes',
  PreparationTimeInMinutes = 'PreparationTimeInMinutes',
  TotalTimeInMinutes = 'TotalTimeInMinutes'
}

export type RecipesComparisonQueryComponent = Entity & Node & {
  __typename?: 'RecipesComparisonQueryComponent';
  comparisonOperator: ComparisonOperators;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<RecipesComparisonQueryComponent>;
  /** List of RecipesComparisonQueryComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  queryType: RecipesComparisonQueries;
  recipesQueriesReference?: Maybe<RecipesQueriesReference>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  value: Scalars['String']['output'];
};


export type RecipesComparisonQueryComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipesComparisonQueryComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type RecipesComparisonQueryComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type RecipesComparisonQueryComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipesComparisonQueryComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipesComparisonQueryComponentRecipesQueriesReferenceArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipesComparisonQueryComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type RecipesComparisonQueryComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RecipesComparisonQueryComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RecipesComparisonQueryComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type RecipesComparisonQueryComponentConnection = {
  __typename?: 'RecipesComparisonQueryComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RecipesComparisonQueryComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RecipesComparisonQueryComponentCreateInput = {
  comparisonOperator: ComparisonOperators;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  queryType: RecipesComparisonQueries;
  recipesQueriesReference?: InputMaybe<RecipesQueriesReferenceCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
};

export type RecipesComparisonQueryComponentCreateManyInlineInput = {
  /** Connect multiple existing RecipesComparisonQueryComponent documents */
  connect?: InputMaybe<Array<RecipesComparisonQueryComponentWhereUniqueInput>>;
  /** Create and connect multiple existing RecipesComparisonQueryComponent documents */
  create?: InputMaybe<Array<RecipesComparisonQueryComponentCreateInput>>;
};

export type RecipesComparisonQueryComponentCreateOneInlineInput = {
  /** Connect one existing RecipesComparisonQueryComponent document */
  connect?: InputMaybe<RecipesComparisonQueryComponentWhereUniqueInput>;
  /** Create and connect one RecipesComparisonQueryComponent document */
  create?: InputMaybe<RecipesComparisonQueryComponentCreateInput>;
};

/** An edge in a connection. */
export type RecipesComparisonQueryComponentEdge = {
  __typename?: 'RecipesComparisonQueryComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RecipesComparisonQueryComponent;
};

/** Identifies documents */
export type RecipesComparisonQueryComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipesComparisonQueryComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipesComparisonQueryComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipesComparisonQueryComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  comparisonOperator?: InputMaybe<ComparisonOperators>;
  /** All values that are contained in given list. */
  comparisonOperator_in?: InputMaybe<Array<InputMaybe<ComparisonOperators>>>;
  /** Any other value that exists and is not equal to the given value. */
  comparisonOperator_not?: InputMaybe<ComparisonOperators>;
  /** All values that are not contained in given list. */
  comparisonOperator_not_in?: InputMaybe<Array<InputMaybe<ComparisonOperators>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RecipesComparisonQueryComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<RecipesComparisonQueryComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<RecipesComparisonQueryComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  queryType?: InputMaybe<RecipesComparisonQueries>;
  /** All values that are contained in given list. */
  queryType_in?: InputMaybe<Array<InputMaybe<RecipesComparisonQueries>>>;
  /** Any other value that exists and is not equal to the given value. */
  queryType_not?: InputMaybe<RecipesComparisonQueries>;
  /** All values that are not contained in given list. */
  queryType_not_in?: InputMaybe<Array<InputMaybe<RecipesComparisonQueries>>>;
  recipesQueriesReference?: InputMaybe<RecipesQueriesReferenceWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  value?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  value_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum RecipesComparisonQueryComponentOrderByInput {
  comparisonOperator_ASC = 'comparisonOperator_ASC',
  comparisonOperator_DESC = 'comparisonOperator_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  queryType_ASC = 'queryType_ASC',
  queryType_DESC = 'queryType_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type RecipesComparisonQueryComponentUpdateInput = {
  comparisonOperator?: InputMaybe<ComparisonOperators>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  queryType?: InputMaybe<RecipesComparisonQueries>;
  recipesQueriesReference?: InputMaybe<RecipesQueriesReferenceUpdateOneInlineInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type RecipesComparisonQueryComponentUpdateManyInlineInput = {
  /** Connect multiple existing RecipesComparisonQueryComponent documents */
  connect?: InputMaybe<Array<RecipesComparisonQueryComponentConnectInput>>;
  /** Create and connect multiple RecipesComparisonQueryComponent documents */
  create?: InputMaybe<Array<RecipesComparisonQueryComponentCreateInput>>;
  /** Delete multiple RecipesComparisonQueryComponent documents */
  delete?: InputMaybe<Array<RecipesComparisonQueryComponentWhereUniqueInput>>;
  /** Disconnect multiple RecipesComparisonQueryComponent documents */
  disconnect?: InputMaybe<Array<RecipesComparisonQueryComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing RecipesComparisonQueryComponent documents */
  set?: InputMaybe<Array<RecipesComparisonQueryComponentWhereUniqueInput>>;
  /** Update multiple RecipesComparisonQueryComponent documents */
  update?: InputMaybe<Array<RecipesComparisonQueryComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple RecipesComparisonQueryComponent documents */
  upsert?: InputMaybe<Array<RecipesComparisonQueryComponentUpsertWithNestedWhereUniqueInput>>;
};

export type RecipesComparisonQueryComponentUpdateManyInput = {
  comparisonOperator?: InputMaybe<ComparisonOperators>;
  market?: InputMaybe<Markets>;
  queryType?: InputMaybe<RecipesComparisonQueries>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type RecipesComparisonQueryComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RecipesComparisonQueryComponentUpdateManyInput;
  /** Document search */
  where: RecipesComparisonQueryComponentWhereInput;
};

export type RecipesComparisonQueryComponentUpdateOneInlineInput = {
  /** Connect existing RecipesComparisonQueryComponent document */
  connect?: InputMaybe<RecipesComparisonQueryComponentWhereUniqueInput>;
  /** Create and connect one RecipesComparisonQueryComponent document */
  create?: InputMaybe<RecipesComparisonQueryComponentCreateInput>;
  /** Delete currently connected RecipesComparisonQueryComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected RecipesComparisonQueryComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single RecipesComparisonQueryComponent document */
  update?: InputMaybe<RecipesComparisonQueryComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single RecipesComparisonQueryComponent document */
  upsert?: InputMaybe<RecipesComparisonQueryComponentUpsertWithNestedWhereUniqueInput>;
};

export type RecipesComparisonQueryComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RecipesComparisonQueryComponentUpdateInput;
  /** Unique document search */
  where: RecipesComparisonQueryComponentWhereUniqueInput;
};

export type RecipesComparisonQueryComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: RecipesComparisonQueryComponentCreateInput;
  /** Update document if it exists */
  update: RecipesComparisonQueryComponentUpdateInput;
};

export type RecipesComparisonQueryComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RecipesComparisonQueryComponentUpsertInput;
  /** Unique document search */
  where: RecipesComparisonQueryComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RecipesComparisonQueryComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RecipesComparisonQueryComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipesComparisonQueryComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipesComparisonQueryComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipesComparisonQueryComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  comparisonOperator?: InputMaybe<ComparisonOperators>;
  /** All values that are contained in given list. */
  comparisonOperator_in?: InputMaybe<Array<InputMaybe<ComparisonOperators>>>;
  /** Any other value that exists and is not equal to the given value. */
  comparisonOperator_not?: InputMaybe<ComparisonOperators>;
  /** All values that are not contained in given list. */
  comparisonOperator_not_in?: InputMaybe<Array<InputMaybe<ComparisonOperators>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RecipesComparisonQueryComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<RecipesComparisonQueryComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<RecipesComparisonQueryComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  queryType?: InputMaybe<RecipesComparisonQueries>;
  /** All values that are contained in given list. */
  queryType_in?: InputMaybe<Array<InputMaybe<RecipesComparisonQueries>>>;
  /** Any other value that exists and is not equal to the given value. */
  queryType_not?: InputMaybe<RecipesComparisonQueries>;
  /** All values that are not contained in given list. */
  queryType_not_in?: InputMaybe<Array<InputMaybe<RecipesComparisonQueries>>>;
  recipesQueriesReference?: InputMaybe<RecipesQueriesReferenceWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  value?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  value_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RecipesComparisonQueryComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipesComparisonQueryComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipesComparisonQueryComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipesComparisonQueryComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RecipesComparisonQueryComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References RecipesComparisonQueryComponent record uniquely */
export type RecipesComparisonQueryComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RecipesQueriesReference = Entity & Node & {
  __typename?: 'RecipesQueriesReference';
  anchorNav?: Maybe<AnchorNavigation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<RecipesQueriesReference>;
  /** List of RecipesQueriesReference versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipesQueryComponent: Array<RecipesQueriesReferenceRecipesQueryComponent>;
  scheduledIn: Array<ScheduledOperation>;
  size: Scalars['Int']['output'];
  /** System stage field */
  stage: Stage;
  /** This field is used as an internal identifier within the CMS and is not rendered on the site */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type RecipesQueriesReferenceAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipesQueriesReferenceCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipesQueriesReferenceDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type RecipesQueriesReferenceHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type RecipesQueriesReferenceMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipesQueriesReferencePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RecipesQueriesReferenceRecipesQueryComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type RecipesQueriesReferenceScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type RecipesQueriesReferenceUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RecipesQueriesReferenceConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RecipesQueriesReferenceWhereUniqueInput;
};

/** A connection to a list of items. */
export type RecipesQueriesReferenceConnection = {
  __typename?: 'RecipesQueriesReferenceConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RecipesQueriesReferenceEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RecipesQueriesReferenceCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  ckrm6jccu2t9801xn5pscbzc2?: InputMaybe<TestComponentWithRecipeQueryCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  recipesQueryComponent?: InputMaybe<RecipesQueriesReferenceRecipesQueryComponentCreateManyInlineInput>;
  size: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RecipesQueriesReferenceCreateManyInlineInput = {
  /** Connect multiple existing RecipesQueriesReference documents */
  connect?: InputMaybe<Array<RecipesQueriesReferenceWhereUniqueInput>>;
  /** Create and connect multiple existing RecipesQueriesReference documents */
  create?: InputMaybe<Array<RecipesQueriesReferenceCreateInput>>;
};

export type RecipesQueriesReferenceCreateOneInlineInput = {
  /** Connect one existing RecipesQueriesReference document */
  connect?: InputMaybe<RecipesQueriesReferenceWhereUniqueInput>;
  /** Create and connect one RecipesQueriesReference document */
  create?: InputMaybe<RecipesQueriesReferenceCreateInput>;
};

/** An edge in a connection. */
export type RecipesQueriesReferenceEdge = {
  __typename?: 'RecipesQueriesReferenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RecipesQueriesReference;
};

/** Identifies documents */
export type RecipesQueriesReferenceManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipesQueriesReferenceWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipesQueriesReferenceWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipesQueriesReferenceWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RecipesQueriesReferenceWhereStageInput>;
  documentInStages_none?: InputMaybe<RecipesQueriesReferenceWhereStageInput>;
  documentInStages_some?: InputMaybe<RecipesQueriesReferenceWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values in which the union is empty */
  recipesQueryComponent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  recipesQueryComponent_some?: InputMaybe<RecipesQueriesReferenceRecipesQueryComponentWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  size?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum RecipesQueriesReferenceOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  size_ASC = 'size_ASC',
  size_DESC = 'size_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type RecipesQueriesReferenceRecipesQueryComponent = RecipesComparisonQueryComponent | RecipesQueryComponent;

export type RecipesQueriesReferenceRecipesQueryComponentConnectInput = {
  RecipesComparisonQueryComponent?: InputMaybe<RecipesComparisonQueryComponentConnectInput>;
  RecipesQueryComponent?: InputMaybe<RecipesQueryComponentConnectInput>;
};

export type RecipesQueriesReferenceRecipesQueryComponentCreateInput = {
  RecipesComparisonQueryComponent?: InputMaybe<RecipesComparisonQueryComponentCreateInput>;
  RecipesQueryComponent?: InputMaybe<RecipesQueryComponentCreateInput>;
};

export type RecipesQueriesReferenceRecipesQueryComponentCreateManyInlineInput = {
  /** Connect multiple existing RecipesQueriesReferenceRecipesQueryComponent documents */
  connect?: InputMaybe<Array<RecipesQueriesReferenceRecipesQueryComponentWhereUniqueInput>>;
  /** Create and connect multiple existing RecipesQueriesReferenceRecipesQueryComponent documents */
  create?: InputMaybe<Array<RecipesQueriesReferenceRecipesQueryComponentCreateInput>>;
};

export type RecipesQueriesReferenceRecipesQueryComponentCreateOneInlineInput = {
  /** Connect one existing RecipesQueriesReferenceRecipesQueryComponent document */
  connect?: InputMaybe<RecipesQueriesReferenceRecipesQueryComponentWhereUniqueInput>;
  /** Create and connect one RecipesQueriesReferenceRecipesQueryComponent document */
  create?: InputMaybe<RecipesQueriesReferenceRecipesQueryComponentCreateInput>;
};

export type RecipesQueriesReferenceRecipesQueryComponentUpdateInput = {
  RecipesComparisonQueryComponent?: InputMaybe<RecipesComparisonQueryComponentUpdateInput>;
  RecipesQueryComponent?: InputMaybe<RecipesQueryComponentUpdateInput>;
};

export type RecipesQueriesReferenceRecipesQueryComponentUpdateManyInlineInput = {
  /** Connect multiple existing RecipesQueriesReferenceRecipesQueryComponent documents */
  connect?: InputMaybe<Array<RecipesQueriesReferenceRecipesQueryComponentConnectInput>>;
  /** Create and connect multiple RecipesQueriesReferenceRecipesQueryComponent documents */
  create?: InputMaybe<Array<RecipesQueriesReferenceRecipesQueryComponentCreateInput>>;
  /** Delete multiple RecipesQueriesReferenceRecipesQueryComponent documents */
  delete?: InputMaybe<Array<RecipesQueriesReferenceRecipesQueryComponentWhereUniqueInput>>;
  /** Disconnect multiple RecipesQueriesReferenceRecipesQueryComponent documents */
  disconnect?: InputMaybe<Array<RecipesQueriesReferenceRecipesQueryComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing RecipesQueriesReferenceRecipesQueryComponent documents */
  set?: InputMaybe<Array<RecipesQueriesReferenceRecipesQueryComponentWhereUniqueInput>>;
  /** Update multiple RecipesQueriesReferenceRecipesQueryComponent documents */
  update?: InputMaybe<Array<RecipesQueriesReferenceRecipesQueryComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple RecipesQueriesReferenceRecipesQueryComponent documents */
  upsert?: InputMaybe<Array<RecipesQueriesReferenceRecipesQueryComponentUpsertWithNestedWhereUniqueInput>>;
};

export type RecipesQueriesReferenceRecipesQueryComponentUpdateManyWithNestedWhereInput = {
  RecipesComparisonQueryComponent?: InputMaybe<RecipesComparisonQueryComponentUpdateManyWithNestedWhereInput>;
  RecipesQueryComponent?: InputMaybe<RecipesQueryComponentUpdateManyWithNestedWhereInput>;
};

export type RecipesQueriesReferenceRecipesQueryComponentUpdateOneInlineInput = {
  /** Connect existing RecipesQueriesReferenceRecipesQueryComponent document */
  connect?: InputMaybe<RecipesQueriesReferenceRecipesQueryComponentWhereUniqueInput>;
  /** Create and connect one RecipesQueriesReferenceRecipesQueryComponent document */
  create?: InputMaybe<RecipesQueriesReferenceRecipesQueryComponentCreateInput>;
  /** Delete currently connected RecipesQueriesReferenceRecipesQueryComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected RecipesQueriesReferenceRecipesQueryComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single RecipesQueriesReferenceRecipesQueryComponent document */
  update?: InputMaybe<RecipesQueriesReferenceRecipesQueryComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single RecipesQueriesReferenceRecipesQueryComponent document */
  upsert?: InputMaybe<RecipesQueriesReferenceRecipesQueryComponentUpsertWithNestedWhereUniqueInput>;
};

export type RecipesQueriesReferenceRecipesQueryComponentUpdateWithNestedWhereUniqueInput = {
  RecipesComparisonQueryComponent?: InputMaybe<RecipesComparisonQueryComponentUpdateWithNestedWhereUniqueInput>;
  RecipesQueryComponent?: InputMaybe<RecipesQueryComponentUpdateWithNestedWhereUniqueInput>;
};

export type RecipesQueriesReferenceRecipesQueryComponentUpsertWithNestedWhereUniqueInput = {
  RecipesComparisonQueryComponent?: InputMaybe<RecipesComparisonQueryComponentUpsertWithNestedWhereUniqueInput>;
  RecipesQueryComponent?: InputMaybe<RecipesQueryComponentUpsertWithNestedWhereUniqueInput>;
};

export type RecipesQueriesReferenceRecipesQueryComponentWhereInput = {
  RecipesComparisonQueryComponent?: InputMaybe<RecipesComparisonQueryComponentWhereInput>;
  RecipesQueryComponent?: InputMaybe<RecipesQueryComponentWhereInput>;
};

export type RecipesQueriesReferenceRecipesQueryComponentWhereUniqueInput = {
  RecipesComparisonQueryComponent?: InputMaybe<RecipesComparisonQueryComponentWhereUniqueInput>;
  RecipesQueryComponent?: InputMaybe<RecipesQueryComponentWhereUniqueInput>;
};

export type RecipesQueriesReferenceUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  ckrm6jccu2t9801xn5pscbzc2?: InputMaybe<TestComponentWithRecipeQueryUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  recipesQueryComponent?: InputMaybe<RecipesQueriesReferenceRecipesQueryComponentUpdateManyInlineInput>;
  size?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RecipesQueriesReferenceUpdateManyInlineInput = {
  /** Connect multiple existing RecipesQueriesReference documents */
  connect?: InputMaybe<Array<RecipesQueriesReferenceConnectInput>>;
  /** Create and connect multiple RecipesQueriesReference documents */
  create?: InputMaybe<Array<RecipesQueriesReferenceCreateInput>>;
  /** Delete multiple RecipesQueriesReference documents */
  delete?: InputMaybe<Array<RecipesQueriesReferenceWhereUniqueInput>>;
  /** Disconnect multiple RecipesQueriesReference documents */
  disconnect?: InputMaybe<Array<RecipesQueriesReferenceWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing RecipesQueriesReference documents */
  set?: InputMaybe<Array<RecipesQueriesReferenceWhereUniqueInput>>;
  /** Update multiple RecipesQueriesReference documents */
  update?: InputMaybe<Array<RecipesQueriesReferenceUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple RecipesQueriesReference documents */
  upsert?: InputMaybe<Array<RecipesQueriesReferenceUpsertWithNestedWhereUniqueInput>>;
};

export type RecipesQueriesReferenceUpdateManyInput = {
  market?: InputMaybe<Markets>;
  size?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RecipesQueriesReferenceUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RecipesQueriesReferenceUpdateManyInput;
  /** Document search */
  where: RecipesQueriesReferenceWhereInput;
};

export type RecipesQueriesReferenceUpdateOneInlineInput = {
  /** Connect existing RecipesQueriesReference document */
  connect?: InputMaybe<RecipesQueriesReferenceWhereUniqueInput>;
  /** Create and connect one RecipesQueriesReference document */
  create?: InputMaybe<RecipesQueriesReferenceCreateInput>;
  /** Delete currently connected RecipesQueriesReference document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected RecipesQueriesReference document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single RecipesQueriesReference document */
  update?: InputMaybe<RecipesQueriesReferenceUpdateWithNestedWhereUniqueInput>;
  /** Upsert single RecipesQueriesReference document */
  upsert?: InputMaybe<RecipesQueriesReferenceUpsertWithNestedWhereUniqueInput>;
};

export type RecipesQueriesReferenceUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RecipesQueriesReferenceUpdateInput;
  /** Unique document search */
  where: RecipesQueriesReferenceWhereUniqueInput;
};

export type RecipesQueriesReferenceUpsertInput = {
  /** Create document if it didn't exist */
  create: RecipesQueriesReferenceCreateInput;
  /** Update document if it exists */
  update: RecipesQueriesReferenceUpdateInput;
};

export type RecipesQueriesReferenceUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RecipesQueriesReferenceUpsertInput;
  /** Unique document search */
  where: RecipesQueriesReferenceWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RecipesQueriesReferenceWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RecipesQueriesReferenceWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipesQueriesReferenceWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipesQueriesReferenceWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipesQueriesReferenceWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RecipesQueriesReferenceWhereStageInput>;
  documentInStages_none?: InputMaybe<RecipesQueriesReferenceWhereStageInput>;
  documentInStages_some?: InputMaybe<RecipesQueriesReferenceWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values in which the union is empty */
  recipesQueryComponent_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  recipesQueryComponent_some?: InputMaybe<RecipesQueriesReferenceRecipesQueryComponentWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  size?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RecipesQueriesReferenceWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipesQueriesReferenceWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipesQueriesReferenceWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipesQueriesReferenceWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RecipesQueriesReferenceWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References RecipesQueriesReference record uniquely */
export type RecipesQueriesReferenceWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Used to query recipes with predefined list of ids and values */
export type RecipesQueryComponent = Entity & Node & {
  __typename?: 'RecipesQueryComponent';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<RecipesQueryComponent>;
  /** List of RecipesQueryComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  queryType: ReicpesQueries;
  recipesQueriesReference?: Maybe<RecipesQueriesReference>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  value: Scalars['String']['output'];
};


/** Used to query recipes with predefined list of ids and values */
export type RecipesQueryComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Used to query recipes with predefined list of ids and values */
export type RecipesQueryComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Used to query recipes with predefined list of ids and values */
export type RecipesQueryComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Used to query recipes with predefined list of ids and values */
export type RecipesQueryComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Used to query recipes with predefined list of ids and values */
export type RecipesQueryComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Used to query recipes with predefined list of ids and values */
export type RecipesQueryComponentRecipesQueriesReferenceArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Used to query recipes with predefined list of ids and values */
export type RecipesQueryComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Used to query recipes with predefined list of ids and values */
export type RecipesQueryComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RecipesQueryComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RecipesQueryComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type RecipesQueryComponentConnection = {
  __typename?: 'RecipesQueryComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RecipesQueryComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RecipesQueryComponentCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  queryType: ReicpesQueries;
  recipesQueriesReference?: InputMaybe<RecipesQueriesReferenceCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
};

export type RecipesQueryComponentCreateManyInlineInput = {
  /** Connect multiple existing RecipesQueryComponent documents */
  connect?: InputMaybe<Array<RecipesQueryComponentWhereUniqueInput>>;
  /** Create and connect multiple existing RecipesQueryComponent documents */
  create?: InputMaybe<Array<RecipesQueryComponentCreateInput>>;
};

export type RecipesQueryComponentCreateOneInlineInput = {
  /** Connect one existing RecipesQueryComponent document */
  connect?: InputMaybe<RecipesQueryComponentWhereUniqueInput>;
  /** Create and connect one RecipesQueryComponent document */
  create?: InputMaybe<RecipesQueryComponentCreateInput>;
};

/** An edge in a connection. */
export type RecipesQueryComponentEdge = {
  __typename?: 'RecipesQueryComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RecipesQueryComponent;
};

/** Identifies documents */
export type RecipesQueryComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipesQueryComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipesQueryComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipesQueryComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RecipesQueryComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<RecipesQueryComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<RecipesQueryComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  queryType?: InputMaybe<ReicpesQueries>;
  /** All values that are contained in given list. */
  queryType_in?: InputMaybe<Array<InputMaybe<ReicpesQueries>>>;
  /** Any other value that exists and is not equal to the given value. */
  queryType_not?: InputMaybe<ReicpesQueries>;
  /** All values that are not contained in given list. */
  queryType_not_in?: InputMaybe<Array<InputMaybe<ReicpesQueries>>>;
  recipesQueriesReference?: InputMaybe<RecipesQueriesReferenceWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  value?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  value_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum RecipesQueryComponentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  queryType_ASC = 'queryType_ASC',
  queryType_DESC = 'queryType_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type RecipesQueryComponentUpdateInput = {
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  queryType?: InputMaybe<ReicpesQueries>;
  recipesQueriesReference?: InputMaybe<RecipesQueriesReferenceUpdateOneInlineInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type RecipesQueryComponentUpdateManyInlineInput = {
  /** Connect multiple existing RecipesQueryComponent documents */
  connect?: InputMaybe<Array<RecipesQueryComponentConnectInput>>;
  /** Create and connect multiple RecipesQueryComponent documents */
  create?: InputMaybe<Array<RecipesQueryComponentCreateInput>>;
  /** Delete multiple RecipesQueryComponent documents */
  delete?: InputMaybe<Array<RecipesQueryComponentWhereUniqueInput>>;
  /** Disconnect multiple RecipesQueryComponent documents */
  disconnect?: InputMaybe<Array<RecipesQueryComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing RecipesQueryComponent documents */
  set?: InputMaybe<Array<RecipesQueryComponentWhereUniqueInput>>;
  /** Update multiple RecipesQueryComponent documents */
  update?: InputMaybe<Array<RecipesQueryComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple RecipesQueryComponent documents */
  upsert?: InputMaybe<Array<RecipesQueryComponentUpsertWithNestedWhereUniqueInput>>;
};

export type RecipesQueryComponentUpdateManyInput = {
  market?: InputMaybe<Markets>;
  queryType?: InputMaybe<ReicpesQueries>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type RecipesQueryComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RecipesQueryComponentUpdateManyInput;
  /** Document search */
  where: RecipesQueryComponentWhereInput;
};

export type RecipesQueryComponentUpdateOneInlineInput = {
  /** Connect existing RecipesQueryComponent document */
  connect?: InputMaybe<RecipesQueryComponentWhereUniqueInput>;
  /** Create and connect one RecipesQueryComponent document */
  create?: InputMaybe<RecipesQueryComponentCreateInput>;
  /** Delete currently connected RecipesQueryComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected RecipesQueryComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single RecipesQueryComponent document */
  update?: InputMaybe<RecipesQueryComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single RecipesQueryComponent document */
  upsert?: InputMaybe<RecipesQueryComponentUpsertWithNestedWhereUniqueInput>;
};

export type RecipesQueryComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RecipesQueryComponentUpdateInput;
  /** Unique document search */
  where: RecipesQueryComponentWhereUniqueInput;
};

export type RecipesQueryComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: RecipesQueryComponentCreateInput;
  /** Update document if it exists */
  update: RecipesQueryComponentUpdateInput;
};

export type RecipesQueryComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RecipesQueryComponentUpsertInput;
  /** Unique document search */
  where: RecipesQueryComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RecipesQueryComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RecipesQueryComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipesQueryComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipesQueryComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipesQueryComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RecipesQueryComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<RecipesQueryComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<RecipesQueryComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  queryType?: InputMaybe<ReicpesQueries>;
  /** All values that are contained in given list. */
  queryType_in?: InputMaybe<Array<InputMaybe<ReicpesQueries>>>;
  /** Any other value that exists and is not equal to the given value. */
  queryType_not?: InputMaybe<ReicpesQueries>;
  /** All values that are not contained in given list. */
  queryType_not_in?: InputMaybe<Array<InputMaybe<ReicpesQueries>>>;
  recipesQueriesReference?: InputMaybe<RecipesQueriesReferenceWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  value?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  value_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RecipesQueryComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RecipesQueryComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RecipesQueryComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RecipesQueryComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RecipesQueryComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References RecipesQueryComponent record uniquely */
export type RecipesQueryComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Redirect = Entity & Node & {
  __typename?: 'Redirect';
  anchorNav?: Maybe<AnchorNavigation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Redirect>;
  /** List of Redirect versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** String that can be used to find the component in the CMS */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** The old URL eg. /recipes/apfel-kuchen */
  urlFrom?: Maybe<Scalars['String']['output']>;
  /** The new URL eg. /recipes/neu-apfel-kuchen */
  urlTo?: Maybe<Scalars['String']['output']>;
};


export type RedirectAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RedirectCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RedirectDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type RedirectHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type RedirectMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RedirectPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RedirectScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type RedirectUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RedirectConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RedirectWhereUniqueInput;
};

/** A connection to a list of items. */
export type RedirectConnection = {
  __typename?: 'RedirectConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RedirectEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RedirectCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urlFrom?: InputMaybe<Scalars['String']['input']>;
  urlTo?: InputMaybe<Scalars['String']['input']>;
};

export type RedirectCreateManyInlineInput = {
  /** Connect multiple existing Redirect documents */
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  /** Create and connect multiple existing Redirect documents */
  create?: InputMaybe<Array<RedirectCreateInput>>;
};

export type RedirectCreateOneInlineInput = {
  /** Connect one existing Redirect document */
  connect?: InputMaybe<RedirectWhereUniqueInput>;
  /** Create and connect one Redirect document */
  create?: InputMaybe<RedirectCreateInput>;
};

/** An edge in a connection. */
export type RedirectEdge = {
  __typename?: 'RedirectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Redirect;
};

/** Identifies documents */
export type RedirectManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RedirectWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RedirectWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RedirectWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RedirectWhereStageInput>;
  documentInStages_none?: InputMaybe<RedirectWhereStageInput>;
  documentInStages_some?: InputMaybe<RedirectWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  urlFrom?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  urlFrom_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  urlFrom_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  urlFrom_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  urlFrom_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  urlFrom_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  urlFrom_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  urlFrom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  urlFrom_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  urlFrom_starts_with?: InputMaybe<Scalars['String']['input']>;
  urlTo?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  urlTo_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  urlTo_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  urlTo_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  urlTo_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  urlTo_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  urlTo_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  urlTo_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  urlTo_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  urlTo_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum RedirectOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  urlFrom_ASC = 'urlFrom_ASC',
  urlFrom_DESC = 'urlFrom_DESC',
  urlTo_ASC = 'urlTo_ASC',
  urlTo_DESC = 'urlTo_DESC'
}

export type RedirectUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  urlFrom?: InputMaybe<Scalars['String']['input']>;
  urlTo?: InputMaybe<Scalars['String']['input']>;
};

export type RedirectUpdateManyInlineInput = {
  /** Connect multiple existing Redirect documents */
  connect?: InputMaybe<Array<RedirectConnectInput>>;
  /** Create and connect multiple Redirect documents */
  create?: InputMaybe<Array<RedirectCreateInput>>;
  /** Delete multiple Redirect documents */
  delete?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  /** Disconnect multiple Redirect documents */
  disconnect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Redirect documents */
  set?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  /** Update multiple Redirect documents */
  update?: InputMaybe<Array<RedirectUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Redirect documents */
  upsert?: InputMaybe<Array<RedirectUpsertWithNestedWhereUniqueInput>>;
};

export type RedirectUpdateManyInput = {
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
  urlFrom?: InputMaybe<Scalars['String']['input']>;
  urlTo?: InputMaybe<Scalars['String']['input']>;
};

export type RedirectUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RedirectUpdateManyInput;
  /** Document search */
  where: RedirectWhereInput;
};

export type RedirectUpdateOneInlineInput = {
  /** Connect existing Redirect document */
  connect?: InputMaybe<RedirectWhereUniqueInput>;
  /** Create and connect one Redirect document */
  create?: InputMaybe<RedirectCreateInput>;
  /** Delete currently connected Redirect document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Redirect document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Redirect document */
  update?: InputMaybe<RedirectUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Redirect document */
  upsert?: InputMaybe<RedirectUpsertWithNestedWhereUniqueInput>;
};

export type RedirectUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RedirectUpdateInput;
  /** Unique document search */
  where: RedirectWhereUniqueInput;
};

export type RedirectUpsertInput = {
  /** Create document if it didn't exist */
  create: RedirectCreateInput;
  /** Update document if it exists */
  update: RedirectUpdateInput;
};

export type RedirectUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RedirectUpsertInput;
  /** Unique document search */
  where: RedirectWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RedirectWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RedirectWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RedirectWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RedirectWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RedirectWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RedirectWhereStageInput>;
  documentInStages_none?: InputMaybe<RedirectWhereStageInput>;
  documentInStages_some?: InputMaybe<RedirectWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  urlFrom?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  urlFrom_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  urlFrom_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  urlFrom_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  urlFrom_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  urlFrom_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  urlFrom_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  urlFrom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  urlFrom_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  urlFrom_starts_with?: InputMaybe<Scalars['String']['input']>;
  urlTo?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  urlTo_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  urlTo_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  urlTo_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  urlTo_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  urlTo_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  urlTo_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  urlTo_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  urlTo_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  urlTo_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RedirectWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RedirectWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RedirectWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RedirectWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RedirectWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Redirect record uniquely */
export type RedirectWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum ReicpesQueries {
  Allergens_Id = 'Allergens_Id',
  Category_Id = 'Category_Id',
  DietTypes_Id = 'DietTypes_Id',
  Difficulty = 'Difficulty',
  FromServings = 'FromServings',
  Keywords_Id = 'Keywords_Id',
  MainIngredient_Id = 'MainIngredient_Id',
  MenuTypes_Id = 'MenuTypes_Id',
  Occasions_Id = 'Occasions_Id',
  Price_Id = 'Price_Id',
  Priority = 'Priority',
  Seasons_Id = 'Seasons_Id',
  ToServings = 'ToServings'
}

export type Rewrite = Entity & Node & {
  __typename?: 'Rewrite';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  destination: Scalars['String']['output'];
  /** Get the document in other stages */
  documentInStages: Array<Rewrite>;
  domain: Scalars['String']['output'];
  domains: Array<Scalars['String']['output']>;
  /** List of Rewrite versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Rewrite>;
  market: Markets;
  marketName?: Maybe<Market>;
  page: RewriteTypes;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** if set to true, make sure both source and destination have /{locale} in them at the beginning  */
  showLocale: Scalars['Boolean']['output'];
  source: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  testComponentWithRecipeQuery?: Maybe<TestComponentWithRecipeQuery>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type RewriteCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type RewriteCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RewriteDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type RewriteHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type RewriteLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type RewriteMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RewritePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type RewritePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RewriteScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type RewriteTestComponentWithRecipeQueryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RewriteUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type RewriteUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RewriteConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RewriteWhereUniqueInput;
};

/** A connection to a list of items. */
export type RewriteConnection = {
  __typename?: 'RewriteConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RewriteEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RewriteCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** destination input for default locale (en) */
  destination: Scalars['String']['input'];
  /** domain input for default locale (en) */
  domain: Scalars['String']['input'];
  /** domains input for default locale (en) */
  domains: Array<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<RewriteCreateLocalizationsInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  page: RewriteTypes;
  /** showLocale input for default locale (en) */
  showLocale: Scalars['Boolean']['input'];
  /** source input for default locale (en) */
  source: Scalars['String']['input'];
  testComponentWithRecipeQuery?: InputMaybe<TestComponentWithRecipeQueryCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RewriteCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  destination: Scalars['String']['input'];
  domain: Scalars['String']['input'];
  domains: Array<Scalars['String']['input']>;
  showLocale: Scalars['Boolean']['input'];
  source: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RewriteCreateLocalizationInput = {
  /** Localization input */
  data: RewriteCreateLocalizationDataInput;
  locale: Locale;
};

export type RewriteCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<RewriteCreateLocalizationInput>>;
};

export type RewriteCreateManyInlineInput = {
  /** Connect multiple existing Rewrite documents */
  connect?: InputMaybe<Array<RewriteWhereUniqueInput>>;
  /** Create and connect multiple existing Rewrite documents */
  create?: InputMaybe<Array<RewriteCreateInput>>;
};

export type RewriteCreateOneInlineInput = {
  /** Connect one existing Rewrite document */
  connect?: InputMaybe<RewriteWhereUniqueInput>;
  /** Create and connect one Rewrite document */
  create?: InputMaybe<RewriteCreateInput>;
};

/** An edge in a connection. */
export type RewriteEdge = {
  __typename?: 'RewriteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Rewrite;
};

/** Identifies documents */
export type RewriteManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RewriteWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RewriteWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RewriteWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RewriteWhereStageInput>;
  documentInStages_none?: InputMaybe<RewriteWhereStageInput>;
  documentInStages_some?: InputMaybe<RewriteWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  page?: InputMaybe<RewriteTypes>;
  /** All values that are contained in given list. */
  page_in?: InputMaybe<Array<InputMaybe<RewriteTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  page_not?: InputMaybe<RewriteTypes>;
  /** All values that are not contained in given list. */
  page_not_in?: InputMaybe<Array<InputMaybe<RewriteTypes>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  testComponentWithRecipeQuery?: InputMaybe<TestComponentWithRecipeQueryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum RewriteOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  destination_ASC = 'destination_ASC',
  destination_DESC = 'destination_DESC',
  domain_ASC = 'domain_ASC',
  domain_DESC = 'domain_DESC',
  domains_ASC = 'domains_ASC',
  domains_DESC = 'domains_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  page_ASC = 'page_ASC',
  page_DESC = 'page_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  showLocale_ASC = 'showLocale_ASC',
  showLocale_DESC = 'showLocale_DESC',
  source_ASC = 'source_ASC',
  source_DESC = 'source_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum RewriteTypes {
  categories = 'categories',
  genericPage = 'genericPage',
  product = 'product',
  products = 'products',
  productsCategory = 'productsCategory',
  productsSubCategory = 'productsSubCategory',
  recipe = 'recipe',
  recipes = 'recipes',
  recipesCategory = 'recipesCategory',
  recipesSubCategory = 'recipesSubCategory',
  search = 'search',
  tipAndTrick = 'tipAndTrick',
  tipsAndTricks = 'tipsAndTricks'
}

export type RewriteUpdateInput = {
  /** destination input for default locale (en) */
  destination?: InputMaybe<Scalars['String']['input']>;
  /** domain input for default locale (en) */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** domains input for default locale (en) */
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Manage document localizations */
  localizations?: InputMaybe<RewriteUpdateLocalizationsInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  page?: InputMaybe<RewriteTypes>;
  /** showLocale input for default locale (en) */
  showLocale?: InputMaybe<Scalars['Boolean']['input']>;
  /** source input for default locale (en) */
  source?: InputMaybe<Scalars['String']['input']>;
  testComponentWithRecipeQuery?: InputMaybe<TestComponentWithRecipeQueryUpdateOneInlineInput>;
};

export type RewriteUpdateLocalizationDataInput = {
  destination?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  showLocale?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type RewriteUpdateLocalizationInput = {
  data: RewriteUpdateLocalizationDataInput;
  locale: Locale;
};

export type RewriteUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<RewriteCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<RewriteUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<RewriteUpsertLocalizationInput>>;
};

export type RewriteUpdateManyInlineInput = {
  /** Connect multiple existing Rewrite documents */
  connect?: InputMaybe<Array<RewriteConnectInput>>;
  /** Create and connect multiple Rewrite documents */
  create?: InputMaybe<Array<RewriteCreateInput>>;
  /** Delete multiple Rewrite documents */
  delete?: InputMaybe<Array<RewriteWhereUniqueInput>>;
  /** Disconnect multiple Rewrite documents */
  disconnect?: InputMaybe<Array<RewriteWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Rewrite documents */
  set?: InputMaybe<Array<RewriteWhereUniqueInput>>;
  /** Update multiple Rewrite documents */
  update?: InputMaybe<Array<RewriteUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Rewrite documents */
  upsert?: InputMaybe<Array<RewriteUpsertWithNestedWhereUniqueInput>>;
};

export type RewriteUpdateManyInput = {
  /** destination input for default locale (en) */
  destination?: InputMaybe<Scalars['String']['input']>;
  /** domain input for default locale (en) */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** domains input for default locale (en) */
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<RewriteUpdateManyLocalizationsInput>;
  market?: InputMaybe<Markets>;
  /** showLocale input for default locale (en) */
  showLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RewriteUpdateManyLocalizationDataInput = {
  destination?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  showLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RewriteUpdateManyLocalizationInput = {
  data: RewriteUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type RewriteUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<RewriteUpdateManyLocalizationInput>>;
};

export type RewriteUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RewriteUpdateManyInput;
  /** Document search */
  where: RewriteWhereInput;
};

export type RewriteUpdateOneInlineInput = {
  /** Connect existing Rewrite document */
  connect?: InputMaybe<RewriteWhereUniqueInput>;
  /** Create and connect one Rewrite document */
  create?: InputMaybe<RewriteCreateInput>;
  /** Delete currently connected Rewrite document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Rewrite document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Rewrite document */
  update?: InputMaybe<RewriteUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Rewrite document */
  upsert?: InputMaybe<RewriteUpsertWithNestedWhereUniqueInput>;
};

export type RewriteUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RewriteUpdateInput;
  /** Unique document search */
  where: RewriteWhereUniqueInput;
};

export type RewriteUpsertInput = {
  /** Create document if it didn't exist */
  create: RewriteCreateInput;
  /** Update document if it exists */
  update: RewriteUpdateInput;
};

export type RewriteUpsertLocalizationInput = {
  create: RewriteCreateLocalizationDataInput;
  locale: Locale;
  update: RewriteUpdateLocalizationDataInput;
};

export type RewriteUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RewriteUpsertInput;
  /** Unique document search */
  where: RewriteWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RewriteWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RewriteWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RewriteWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RewriteWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RewriteWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  destination?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  destination_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  destination_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  destination_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  destination_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  destination_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  destination_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  destination_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  destination_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  destination_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<RewriteWhereStageInput>;
  documentInStages_none?: InputMaybe<RewriteWhereStageInput>;
  documentInStages_some?: InputMaybe<RewriteWhereStageInput>;
  domain?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  domain_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  domain_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  domain_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  domain_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  domain_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  domain_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  domain_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  domain_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  domain_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  domains_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  domains_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  domains_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  domains_not?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  page?: InputMaybe<RewriteTypes>;
  /** All values that are contained in given list. */
  page_in?: InputMaybe<Array<InputMaybe<RewriteTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  page_not?: InputMaybe<RewriteTypes>;
  /** All values that are not contained in given list. */
  page_not_in?: InputMaybe<Array<InputMaybe<RewriteTypes>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showLocale?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showLocale_not?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  source_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  source_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  source_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  source_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  source_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  source_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  source_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  source_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  source_starts_with?: InputMaybe<Scalars['String']['input']>;
  testComponentWithRecipeQuery?: InputMaybe<TestComponentWithRecipeQueryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RewriteWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RewriteWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RewriteWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RewriteWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RewriteWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Rewrite record uniquely */
export type RewriteWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<RewriteTypes>;
};

/** Custom type representing a rich text value comprising of raw rich text ast, html, markdown and text values */
export type RichText = {
  __typename?: 'RichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** Returns AST representation */
  raw: Scalars['RichTextAST']['output'];
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};

export type RightColumn = Entity & Node & {
  __typename?: 'RightColumn';
  assetsComponents: Array<AssetComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Right column rich text */
  description?: Maybe<RightColumnDescriptionRichText>;
  /** Get the document in other stages */
  documentInStages: Array<RightColumn>;
  /** List of RightColumn versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Right column title to the rich text */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Video url for right column of ImageCopy component */
  video?: Maybe<Scalars['String']['output']>;
};


export type RightColumnAssetsComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentWhereInput>;
};


export type RightColumnCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RightColumnDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type RightColumnHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type RightColumnMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RightColumnPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RightColumnScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type RightColumnUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RightColumnConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RightColumnWhereUniqueInput;
};

/** A connection to a list of items. */
export type RightColumnConnection = {
  __typename?: 'RightColumnConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RightColumnEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RightColumnCreateInput = {
  assetsComponents?: InputMaybe<AssetComponentCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type RightColumnCreateManyInlineInput = {
  /** Connect multiple existing RightColumn documents */
  connect?: InputMaybe<Array<RightColumnWhereUniqueInput>>;
  /** Create and connect multiple existing RightColumn documents */
  create?: InputMaybe<Array<RightColumnCreateInput>>;
};

export type RightColumnCreateOneInlineInput = {
  /** Connect one existing RightColumn document */
  connect?: InputMaybe<RightColumnWhereUniqueInput>;
  /** Create and connect one RightColumn document */
  create?: InputMaybe<RightColumnCreateInput>;
};

export type RightColumnDescriptionRichText = {
  __typename?: 'RightColumnDescriptionRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<RightColumnDescriptionRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type RightColumnDescriptionRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type RightColumnDescriptionRichTextEmbeddedTypes = Asset;

/** An edge in a connection. */
export type RightColumnEdge = {
  __typename?: 'RightColumnEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RightColumn;
};

/** Identifies documents */
export type RightColumnManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RightColumnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RightColumnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RightColumnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RightColumnWhereStageInput>;
  documentInStages_none?: InputMaybe<RightColumnWhereStageInput>;
  documentInStages_some?: InputMaybe<RightColumnWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  video_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  video_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  video_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  video_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  video_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  video_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  video_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  video_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  video_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum RightColumnOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  video_ASC = 'video_ASC',
  video_DESC = 'video_DESC'
}

export type RightColumnUpdateInput = {
  assetsComponents?: InputMaybe<AssetComponentUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type RightColumnUpdateManyInlineInput = {
  /** Connect multiple existing RightColumn documents */
  connect?: InputMaybe<Array<RightColumnConnectInput>>;
  /** Create and connect multiple RightColumn documents */
  create?: InputMaybe<Array<RightColumnCreateInput>>;
  /** Delete multiple RightColumn documents */
  delete?: InputMaybe<Array<RightColumnWhereUniqueInput>>;
  /** Disconnect multiple RightColumn documents */
  disconnect?: InputMaybe<Array<RightColumnWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing RightColumn documents */
  set?: InputMaybe<Array<RightColumnWhereUniqueInput>>;
  /** Update multiple RightColumn documents */
  update?: InputMaybe<Array<RightColumnUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple RightColumn documents */
  upsert?: InputMaybe<Array<RightColumnUpsertWithNestedWhereUniqueInput>>;
};

export type RightColumnUpdateManyInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type RightColumnUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RightColumnUpdateManyInput;
  /** Document search */
  where: RightColumnWhereInput;
};

export type RightColumnUpdateOneInlineInput = {
  /** Connect existing RightColumn document */
  connect?: InputMaybe<RightColumnWhereUniqueInput>;
  /** Create and connect one RightColumn document */
  create?: InputMaybe<RightColumnCreateInput>;
  /** Delete currently connected RightColumn document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected RightColumn document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single RightColumn document */
  update?: InputMaybe<RightColumnUpdateWithNestedWhereUniqueInput>;
  /** Upsert single RightColumn document */
  upsert?: InputMaybe<RightColumnUpsertWithNestedWhereUniqueInput>;
};

export type RightColumnUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RightColumnUpdateInput;
  /** Unique document search */
  where: RightColumnWhereUniqueInput;
};

export type RightColumnUpsertInput = {
  /** Create document if it didn't exist */
  create: RightColumnCreateInput;
  /** Update document if it exists */
  update: RightColumnUpdateInput;
};

export type RightColumnUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RightColumnUpsertInput;
  /** Unique document search */
  where: RightColumnWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RightColumnWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RightColumnWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RightColumnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RightColumnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RightColumnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RightColumnWhereStageInput>;
  documentInStages_none?: InputMaybe<RightColumnWhereStageInput>;
  documentInStages_some?: InputMaybe<RightColumnWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  video_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  video_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  video_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  video_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  video_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  video_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  video_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  video_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  video_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RightColumnWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RightColumnWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RightColumnWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RightColumnWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RightColumnWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References RightColumn record uniquely */
export type RightColumnWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Scheduled Operation system model */
export type ScheduledOperation = Entity & Node & {
  __typename?: 'ScheduledOperation';
  affectedDocuments: Array<ScheduledOperationAffectedDocument>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Operation description */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledOperation>;
  /** Operation error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Raw operation payload including all details, this field is subject to change */
  rawPayload: Scalars['Json']['output'];
  /** The release this operation is scheduled for */
  release?: Maybe<ScheduledRelease>;
  /** System stage field */
  stage: Stage;
  /** operation Status */
  status: ScheduledOperationStatus;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Operation system model */
export type ScheduledOperationAffectedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Scheduled Operation system model */
export type ScheduledOperationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Scheduled Operation system model */
export type ScheduledOperationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationReleaseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledOperationAffectedDocument = Accordion | AccordionItem | AlgoliaExtension | AnchorNav | AnchorNavigation | AnchorNavigationList | Asset | AssetComponent | AudioComponent | AuthorableContentCard | Banner1 | Banner2 | Banner2CarouselComponent | CardComponent | CarouselComponent | CarouselSlide | CategoryCard | ContactCard | ContactCardContainer | CountrySelectorFooter | CountrySelectorItem | DemoModel | Dictionary | DictionaryItem | DownloadApp | DynamicCardGrid | ErrorPage | EvalancheFormComponent | ExampleComponent | FeaturedContent | FeaturedContentReference | FooterNavigation | FooterSeal | Form | FormCheckbox | FormCheckboxCollection | FormDateInput | FormEmailInput | FormError | FormFileUploader | FormList | FormListItem | FormNumberInput | FormPasswordInput | FormPasswordInputWithConfirmation | FormRadioButton | FormRadioButtonCollection | FormSelectComponent | FormSelectOption | FormSubmitButton | FormSuccessComponent | FormTextInput | FormTextareaInput | GenericAccordion | GenericAccordionItem | GenericAccordionTopRated | GenericCardCarouseComponent | GenericDownloadComponent | GenericFollowUs | GenericGridAuthorable | GenericHtml | GenericLine | GenericLink | GenericPage | GenericPromotionsOverview | GenericQualifio | GenericQualifioOverview | GenericSocialShare | GlobalMetaData | GlobalSearch | GridColumn | GridColumnComponent | HeroBanner | HeroBannerMasterbrand | HeroCarouselComponent | HeroComponent | HeroLoopAnimationComponent | Iframe | ImageAndTextCard | ImageCopy | ImageCopyItem | IntroText | LeftColumn | Link | LongText | Market | MarketUserConnection | MetaData | MobileOnlyMainNavigation | MultiStepPromotionForm | Navigation | NavigationItem | NewsletterComponent | NewsletterSubscriptions | NotificationBanner | PageFooter | PageHeader | PopularSearchComponent | Product | ProductBanner | ProductCategory | ProductCategoryPage | ProductDetailPage | ProductHero | ProductLabel | ProductLandingPage | ProductSubcategoryPage | PromotionDownload | PromotionForm | Question | QuestionCheckbox | QuestionCheckboxCollection | QuestionRadioButton | QuestionRadioButtonCollection | Rating | Recipe | RecipeCategory | RecipeLandingPage | RecipeSubcategory | RecipesComparisonQueryComponent | RecipesQueriesReference | RecipesQueryComponent | Redirect | Rewrite | RightColumn | SearchInput | SearchOverlayComponent | SearchResultPage | Separator | SingleStepPromotionForm | SocialMediaListComponent | Spacer | SubCategoryKeyImage | SubTab | SubTabContent | SustainabilityBanner | SustainabilityInfo | Tab | TabContent | Teaser | TeaserPlaceholder | TeaserSmall | TeaserSmallPlaceholder | TestComponentWithRecipeQuery | TestTipsANdTricksInAMarket | TextComponent | TipsAndTricksDetailsPage | Title | TwitterSeo;

export type ScheduledOperationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledOperationWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledOperationConnection = {
  __typename?: 'ScheduledOperationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledOperationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledOperationCreateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationCreateOneInlineInput = {
  /** Connect one existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
};

/** An edge in a connection. */
export type ScheduledOperationEdge = {
  __typename?: 'ScheduledOperationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduledOperation;
};

/** Identifies documents */
export type ScheduledOperationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledOperationOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  errorMessage_ASC = 'errorMessage_ASC',
  errorMessage_DESC = 'errorMessage_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** System Scheduled Operation Status */
export enum ScheduledOperationStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING'
}

export type ScheduledOperationUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationConnectInput>>;
  /** Disconnect multiple ScheduledOperation documents */
  disconnect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledOperation documents */
  set?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationUpdateOneInlineInput = {
  /** Connect existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
  /** Disconnect currently connected ScheduledOperation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ScheduledOperationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledOperation record uniquely */
export type ScheduledOperationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Scheduled Release system model */
export type ScheduledRelease = Entity & Node & {
  __typename?: 'ScheduledRelease';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Release description */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledRelease>;
  /** Release error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Whether scheduled release should be run */
  isActive: Scalars['Boolean']['output'];
  /** Whether scheduled release is implicit */
  isImplicit: Scalars['Boolean']['output'];
  /** Operations to run with this release */
  operations: Array<ScheduledOperation>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Release date and time */
  releaseAt?: Maybe<Scalars['DateTime']['output']>;
  /** System stage field */
  stage: Stage;
  /** Release Status */
  status: ScheduledReleaseStatus;
  /** Release Title */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Release system model */
export type ScheduledReleaseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Scheduled Release system model */
export type ScheduledReleaseOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Scheduled Release system model */
export type ScheduledReleasePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledReleaseConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledReleaseWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledReleaseConnection = {
  __typename?: 'ScheduledReleaseConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledReleaseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledReleaseCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScheduledReleaseCreateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Create and connect multiple existing ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
};

export type ScheduledReleaseCreateOneInlineInput = {
  /** Connect one existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
};

/** An edge in a connection. */
export type ScheduledReleaseEdge = {
  __typename?: 'ScheduledReleaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduledRelease;
};

/** Identifies documents */
export type ScheduledReleaseManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledReleaseOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  errorMessage_ASC = 'errorMessage_ASC',
  errorMessage_DESC = 'errorMessage_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isActive_ASC = 'isActive_ASC',
  isActive_DESC = 'isActive_DESC',
  isImplicit_ASC = 'isImplicit_ASC',
  isImplicit_DESC = 'isImplicit_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  releaseAt_ASC = 'releaseAt_ASC',
  releaseAt_DESC = 'releaseAt_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** System Scheduled Release Status */
export enum ScheduledReleaseStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING'
}

export type ScheduledReleaseUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseConnectInput>>;
  /** Create and connect multiple ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
  /** Delete multiple ScheduledRelease documents */
  delete?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Disconnect multiple ScheduledRelease documents */
  disconnect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledRelease documents */
  set?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Update multiple ScheduledRelease documents */
  update?: InputMaybe<Array<ScheduledReleaseUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ScheduledRelease documents */
  upsert?: InputMaybe<Array<ScheduledReleaseUpsertWithNestedWhereUniqueInput>>;
};

export type ScheduledReleaseUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ScheduledReleaseUpdateManyInput;
  /** Document search */
  where: ScheduledReleaseWhereInput;
};

export type ScheduledReleaseUpdateOneInlineInput = {
  /** Connect existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
  /** Delete currently connected ScheduledRelease document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ScheduledRelease document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ScheduledRelease document */
  update?: InputMaybe<ScheduledReleaseUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ScheduledRelease document */
  upsert?: InputMaybe<ScheduledReleaseUpsertWithNestedWhereUniqueInput>;
};

export type ScheduledReleaseUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ScheduledReleaseUpdateInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

export type ScheduledReleaseUpsertInput = {
  /** Create document if it didn't exist */
  create: ScheduledReleaseCreateInput;
  /** Update document if it exists */
  update: ScheduledReleaseUpdateInput;
};

export type ScheduledReleaseUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ScheduledReleaseUpsertInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

/** Identifies documents */
export type ScheduledReleaseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledRelease record uniquely */
export type ScheduledReleaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SearchInput = Entity & Node & {
  __typename?: 'SearchInput';
  anchorNav?: Maybe<AnchorNavigation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SearchInput>;
  /** List of SearchInput versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  market: Markets;
  marketName?: Maybe<Market>;
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  showLabel?: Maybe<Scalars['Boolean']['output']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type SearchInputAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchInputCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchInputDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type SearchInputHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type SearchInputMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchInputPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchInputScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SearchInputUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SearchInputConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SearchInputWhereUniqueInput;
};

/** A connection to a list of items. */
export type SearchInputConnection = {
  __typename?: 'SearchInputConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SearchInputEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SearchInputCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  showLabel?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SearchInputCreateManyInlineInput = {
  /** Connect multiple existing SearchInput documents */
  connect?: InputMaybe<Array<SearchInputWhereUniqueInput>>;
  /** Create and connect multiple existing SearchInput documents */
  create?: InputMaybe<Array<SearchInputCreateInput>>;
};

export type SearchInputCreateOneInlineInput = {
  /** Connect one existing SearchInput document */
  connect?: InputMaybe<SearchInputWhereUniqueInput>;
  /** Create and connect one SearchInput document */
  create?: InputMaybe<SearchInputCreateInput>;
};

/** An edge in a connection. */
export type SearchInputEdge = {
  __typename?: 'SearchInputEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SearchInput;
};

/** Identifies documents */
export type SearchInputManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SearchInputWhereStageInput>;
  documentInStages_none?: InputMaybe<SearchInputWhereStageInput>;
  documentInStages_some?: InputMaybe<SearchInputWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholder_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholder_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholder_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholder_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholder_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholder_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholder_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showLabel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showLabel_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SearchInputOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  placeholder_ASC = 'placeholder_ASC',
  placeholder_DESC = 'placeholder_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  showLabel_ASC = 'showLabel_ASC',
  showLabel_DESC = 'showLabel_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SearchInputUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  showLabel?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchInputUpdateManyInlineInput = {
  /** Connect multiple existing SearchInput documents */
  connect?: InputMaybe<Array<SearchInputConnectInput>>;
  /** Create and connect multiple SearchInput documents */
  create?: InputMaybe<Array<SearchInputCreateInput>>;
  /** Delete multiple SearchInput documents */
  delete?: InputMaybe<Array<SearchInputWhereUniqueInput>>;
  /** Disconnect multiple SearchInput documents */
  disconnect?: InputMaybe<Array<SearchInputWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SearchInput documents */
  set?: InputMaybe<Array<SearchInputWhereUniqueInput>>;
  /** Update multiple SearchInput documents */
  update?: InputMaybe<Array<SearchInputUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SearchInput documents */
  upsert?: InputMaybe<Array<SearchInputUpsertWithNestedWhereUniqueInput>>;
};

export type SearchInputUpdateManyInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  showLabel?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchInputUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SearchInputUpdateManyInput;
  /** Document search */
  where: SearchInputWhereInput;
};

export type SearchInputUpdateOneInlineInput = {
  /** Connect existing SearchInput document */
  connect?: InputMaybe<SearchInputWhereUniqueInput>;
  /** Create and connect one SearchInput document */
  create?: InputMaybe<SearchInputCreateInput>;
  /** Delete currently connected SearchInput document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SearchInput document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SearchInput document */
  update?: InputMaybe<SearchInputUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SearchInput document */
  upsert?: InputMaybe<SearchInputUpsertWithNestedWhereUniqueInput>;
};

export type SearchInputUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SearchInputUpdateInput;
  /** Unique document search */
  where: SearchInputWhereUniqueInput;
};

export type SearchInputUpsertInput = {
  /** Create document if it didn't exist */
  create: SearchInputCreateInput;
  /** Update document if it exists */
  update: SearchInputUpdateInput;
};

export type SearchInputUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SearchInputUpsertInput;
  /** Unique document search */
  where: SearchInputWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SearchInputWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SearchInputWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SearchInputWhereStageInput>;
  documentInStages_none?: InputMaybe<SearchInputWhereStageInput>;
  documentInStages_some?: InputMaybe<SearchInputWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholder_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholder_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholder_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholder_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholder_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholder_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholder_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showLabel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showLabel_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SearchInputWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchInputWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchInputWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchInputWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SearchInputWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SearchInput record uniquely */
export type SearchInputWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SearchOverlayComponent = Entity & Node & {
  __typename?: 'SearchOverlayComponent';
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  dictionaries: Array<Dictionary>;
  /** Get the document in other stages */
  documentInStages: Array<SearchOverlayComponent>;
  /** Title on the overlay */
  heading?: Maybe<Scalars['String']['output']>;
  /** List of SearchOverlayComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  links: Array<Link>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Super text on overlay */
  subHeading?: Maybe<Scalars['String']['output']>;
  teaserPlaceholders: Array<TeaserPlaceholder>;
  teaserSmallPlaceholders: Array<TeaserSmallPlaceholder>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type SearchOverlayComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchOverlayComponentDictionariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<DictionaryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DictionaryWhereInput>;
};


export type SearchOverlayComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type SearchOverlayComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type SearchOverlayComponentLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


export type SearchOverlayComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchOverlayComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchOverlayComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SearchOverlayComponentTeaserPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserPlaceholderWhereInput>;
};


export type SearchOverlayComponentTeaserSmallPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
};


export type SearchOverlayComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SearchOverlayComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SearchOverlayComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type SearchOverlayComponentConnection = {
  __typename?: 'SearchOverlayComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SearchOverlayComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SearchOverlayComponentCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionaries?: InputMaybe<DictionaryCreateManyInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<LinkCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderCreateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SearchOverlayComponentCreateManyInlineInput = {
  /** Connect multiple existing SearchOverlayComponent documents */
  connect?: InputMaybe<Array<SearchOverlayComponentWhereUniqueInput>>;
  /** Create and connect multiple existing SearchOverlayComponent documents */
  create?: InputMaybe<Array<SearchOverlayComponentCreateInput>>;
};

export type SearchOverlayComponentCreateOneInlineInput = {
  /** Connect one existing SearchOverlayComponent document */
  connect?: InputMaybe<SearchOverlayComponentWhereUniqueInput>;
  /** Create and connect one SearchOverlayComponent document */
  create?: InputMaybe<SearchOverlayComponentCreateInput>;
};

/** An edge in a connection. */
export type SearchOverlayComponentEdge = {
  __typename?: 'SearchOverlayComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SearchOverlayComponent;
};

/** Identifies documents */
export type SearchOverlayComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchOverlayComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchOverlayComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchOverlayComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaries_every?: InputMaybe<DictionaryWhereInput>;
  dictionaries_none?: InputMaybe<DictionaryWhereInput>;
  dictionaries_some?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<SearchOverlayComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<SearchOverlayComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<SearchOverlayComponentWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SearchOverlayComponentOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subHeading_ASC = 'subHeading_ASC',
  subHeading_DESC = 'subHeading_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SearchOverlayComponentUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  dictionaries?: InputMaybe<DictionaryUpdateManyInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<LinkUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderUpdateManyInlineInput>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderUpdateManyInlineInput>;
};

export type SearchOverlayComponentUpdateManyInlineInput = {
  /** Connect multiple existing SearchOverlayComponent documents */
  connect?: InputMaybe<Array<SearchOverlayComponentConnectInput>>;
  /** Create and connect multiple SearchOverlayComponent documents */
  create?: InputMaybe<Array<SearchOverlayComponentCreateInput>>;
  /** Delete multiple SearchOverlayComponent documents */
  delete?: InputMaybe<Array<SearchOverlayComponentWhereUniqueInput>>;
  /** Disconnect multiple SearchOverlayComponent documents */
  disconnect?: InputMaybe<Array<SearchOverlayComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SearchOverlayComponent documents */
  set?: InputMaybe<Array<SearchOverlayComponentWhereUniqueInput>>;
  /** Update multiple SearchOverlayComponent documents */
  update?: InputMaybe<Array<SearchOverlayComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SearchOverlayComponent documents */
  upsert?: InputMaybe<Array<SearchOverlayComponentUpsertWithNestedWhereUniqueInput>>;
};

export type SearchOverlayComponentUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type SearchOverlayComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SearchOverlayComponentUpdateManyInput;
  /** Document search */
  where: SearchOverlayComponentWhereInput;
};

export type SearchOverlayComponentUpdateOneInlineInput = {
  /** Connect existing SearchOverlayComponent document */
  connect?: InputMaybe<SearchOverlayComponentWhereUniqueInput>;
  /** Create and connect one SearchOverlayComponent document */
  create?: InputMaybe<SearchOverlayComponentCreateInput>;
  /** Delete currently connected SearchOverlayComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SearchOverlayComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SearchOverlayComponent document */
  update?: InputMaybe<SearchOverlayComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SearchOverlayComponent document */
  upsert?: InputMaybe<SearchOverlayComponentUpsertWithNestedWhereUniqueInput>;
};

export type SearchOverlayComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SearchOverlayComponentUpdateInput;
  /** Unique document search */
  where: SearchOverlayComponentWhereUniqueInput;
};

export type SearchOverlayComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: SearchOverlayComponentCreateInput;
  /** Update document if it exists */
  update: SearchOverlayComponentUpdateInput;
};

export type SearchOverlayComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SearchOverlayComponentUpsertInput;
  /** Unique document search */
  where: SearchOverlayComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SearchOverlayComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SearchOverlayComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchOverlayComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchOverlayComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchOverlayComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaries_every?: InputMaybe<DictionaryWhereInput>;
  dictionaries_none?: InputMaybe<DictionaryWhereInput>;
  dictionaries_some?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<SearchOverlayComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<SearchOverlayComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<SearchOverlayComponentWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SearchOverlayComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchOverlayComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchOverlayComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchOverlayComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SearchOverlayComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SearchOverlayComponent record uniquely */
export type SearchOverlayComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
};

export type SearchResultPage = Entity & Node & {
  __typename?: 'SearchResultPage';
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SearchResultPage>;
  /** Title of the page */
  heading?: Maybe<Scalars['String']['output']>;
  /** List of SearchResultPage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  searchPageTitles?: Maybe<Dictionary>;
  /** System stage field */
  stage: Stage;
  /** Super text of the page */
  subHeading?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type SearchResultPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchResultPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type SearchResultPageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type SearchResultPageMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchResultPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchResultPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SearchResultPageSearchPageTitlesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchResultPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SearchResultPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SearchResultPageWhereUniqueInput;
};

/** A connection to a list of items. */
export type SearchResultPageConnection = {
  __typename?: 'SearchResultPageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SearchResultPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SearchResultPageCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  searchPageTitles?: InputMaybe<DictionaryCreateOneInlineInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SearchResultPageCreateManyInlineInput = {
  /** Connect multiple existing SearchResultPage documents */
  connect?: InputMaybe<Array<SearchResultPageWhereUniqueInput>>;
  /** Create and connect multiple existing SearchResultPage documents */
  create?: InputMaybe<Array<SearchResultPageCreateInput>>;
};

export type SearchResultPageCreateOneInlineInput = {
  /** Connect one existing SearchResultPage document */
  connect?: InputMaybe<SearchResultPageWhereUniqueInput>;
  /** Create and connect one SearchResultPage document */
  create?: InputMaybe<SearchResultPageCreateInput>;
};

/** An edge in a connection. */
export type SearchResultPageEdge = {
  __typename?: 'SearchResultPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SearchResultPage;
};

/** Identifies documents */
export type SearchResultPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchResultPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchResultPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchResultPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SearchResultPageWhereStageInput>;
  documentInStages_none?: InputMaybe<SearchResultPageWhereStageInput>;
  documentInStages_some?: InputMaybe<SearchResultPageWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  searchPageTitles?: InputMaybe<DictionaryWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SearchResultPageOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subHeading_ASC = 'subHeading_ASC',
  subHeading_DESC = 'subHeading_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SearchResultPageUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  searchPageTitles?: InputMaybe<DictionaryUpdateOneInlineInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type SearchResultPageUpdateManyInlineInput = {
  /** Connect multiple existing SearchResultPage documents */
  connect?: InputMaybe<Array<SearchResultPageConnectInput>>;
  /** Create and connect multiple SearchResultPage documents */
  create?: InputMaybe<Array<SearchResultPageCreateInput>>;
  /** Delete multiple SearchResultPage documents */
  delete?: InputMaybe<Array<SearchResultPageWhereUniqueInput>>;
  /** Disconnect multiple SearchResultPage documents */
  disconnect?: InputMaybe<Array<SearchResultPageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SearchResultPage documents */
  set?: InputMaybe<Array<SearchResultPageWhereUniqueInput>>;
  /** Update multiple SearchResultPage documents */
  update?: InputMaybe<Array<SearchResultPageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SearchResultPage documents */
  upsert?: InputMaybe<Array<SearchResultPageUpsertWithNestedWhereUniqueInput>>;
};

export type SearchResultPageUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type SearchResultPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SearchResultPageUpdateManyInput;
  /** Document search */
  where: SearchResultPageWhereInput;
};

export type SearchResultPageUpdateOneInlineInput = {
  /** Connect existing SearchResultPage document */
  connect?: InputMaybe<SearchResultPageWhereUniqueInput>;
  /** Create and connect one SearchResultPage document */
  create?: InputMaybe<SearchResultPageCreateInput>;
  /** Delete currently connected SearchResultPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SearchResultPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SearchResultPage document */
  update?: InputMaybe<SearchResultPageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SearchResultPage document */
  upsert?: InputMaybe<SearchResultPageUpsertWithNestedWhereUniqueInput>;
};

export type SearchResultPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SearchResultPageUpdateInput;
  /** Unique document search */
  where: SearchResultPageWhereUniqueInput;
};

export type SearchResultPageUpsertInput = {
  /** Create document if it didn't exist */
  create: SearchResultPageCreateInput;
  /** Update document if it exists */
  update: SearchResultPageUpdateInput;
};

export type SearchResultPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SearchResultPageUpsertInput;
  /** Unique document search */
  where: SearchResultPageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SearchResultPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SearchResultPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchResultPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchResultPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchResultPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SearchResultPageWhereStageInput>;
  documentInStages_none?: InputMaybe<SearchResultPageWhereStageInput>;
  documentInStages_some?: InputMaybe<SearchResultPageWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  searchPageTitles?: InputMaybe<DictionaryWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SearchResultPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchResultPageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchResultPageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchResultPageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SearchResultPageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SearchResultPage record uniquely */
export type SearchResultPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
};

/** Placeholder component which should be used in Page Components field of Multistep pages to Separate steps. */
export type Separator = Entity & Node & {
  __typename?: 'Separator';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Separator>;
  genericPages: Array<GenericPage>;
  /** List of Separator versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Placeholder component which should be used in Page Components field of Multistep pages to Separate steps. */
export type SeparatorCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Placeholder component which should be used in Page Components field of Multistep pages to Separate steps. */
export type SeparatorDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Placeholder component which should be used in Page Components field of Multistep pages to Separate steps. */
export type SeparatorGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Placeholder component which should be used in Page Components field of Multistep pages to Separate steps. */
export type SeparatorHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Placeholder component which should be used in Page Components field of Multistep pages to Separate steps. */
export type SeparatorMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Placeholder component which should be used in Page Components field of Multistep pages to Separate steps. */
export type SeparatorPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Placeholder component which should be used in Page Components field of Multistep pages to Separate steps. */
export type SeparatorScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Placeholder component which should be used in Page Components field of Multistep pages to Separate steps. */
export type SeparatorUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SeparatorConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SeparatorWhereUniqueInput;
};

/** A connection to a list of items. */
export type SeparatorConnection = {
  __typename?: 'SeparatorConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SeparatorEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SeparatorCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SeparatorCreateManyInlineInput = {
  /** Connect multiple existing Separator documents */
  connect?: InputMaybe<Array<SeparatorWhereUniqueInput>>;
  /** Create and connect multiple existing Separator documents */
  create?: InputMaybe<Array<SeparatorCreateInput>>;
};

export type SeparatorCreateOneInlineInput = {
  /** Connect one existing Separator document */
  connect?: InputMaybe<SeparatorWhereUniqueInput>;
  /** Create and connect one Separator document */
  create?: InputMaybe<SeparatorCreateInput>;
};

/** An edge in a connection. */
export type SeparatorEdge = {
  __typename?: 'SeparatorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Separator;
};

/** Identifies documents */
export type SeparatorManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SeparatorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SeparatorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SeparatorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SeparatorWhereStageInput>;
  documentInStages_none?: InputMaybe<SeparatorWhereStageInput>;
  documentInStages_some?: InputMaybe<SeparatorWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SeparatorOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SeparatorUpdateInput = {
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SeparatorUpdateManyInlineInput = {
  /** Connect multiple existing Separator documents */
  connect?: InputMaybe<Array<SeparatorConnectInput>>;
  /** Create and connect multiple Separator documents */
  create?: InputMaybe<Array<SeparatorCreateInput>>;
  /** Delete multiple Separator documents */
  delete?: InputMaybe<Array<SeparatorWhereUniqueInput>>;
  /** Disconnect multiple Separator documents */
  disconnect?: InputMaybe<Array<SeparatorWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Separator documents */
  set?: InputMaybe<Array<SeparatorWhereUniqueInput>>;
  /** Update multiple Separator documents */
  update?: InputMaybe<Array<SeparatorUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Separator documents */
  upsert?: InputMaybe<Array<SeparatorUpsertWithNestedWhereUniqueInput>>;
};

export type SeparatorUpdateManyInput = {
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SeparatorUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SeparatorUpdateManyInput;
  /** Document search */
  where: SeparatorWhereInput;
};

export type SeparatorUpdateOneInlineInput = {
  /** Connect existing Separator document */
  connect?: InputMaybe<SeparatorWhereUniqueInput>;
  /** Create and connect one Separator document */
  create?: InputMaybe<SeparatorCreateInput>;
  /** Delete currently connected Separator document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Separator document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Separator document */
  update?: InputMaybe<SeparatorUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Separator document */
  upsert?: InputMaybe<SeparatorUpsertWithNestedWhereUniqueInput>;
};

export type SeparatorUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SeparatorUpdateInput;
  /** Unique document search */
  where: SeparatorWhereUniqueInput;
};

export type SeparatorUpsertInput = {
  /** Create document if it didn't exist */
  create: SeparatorCreateInput;
  /** Update document if it exists */
  update: SeparatorUpdateInput;
};

export type SeparatorUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SeparatorUpsertInput;
  /** Unique document search */
  where: SeparatorWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SeparatorWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SeparatorWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SeparatorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SeparatorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SeparatorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SeparatorWhereStageInput>;
  documentInStages_none?: InputMaybe<SeparatorWhereStageInput>;
  documentInStages_some?: InputMaybe<SeparatorWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SeparatorWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SeparatorWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SeparatorWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SeparatorWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SeparatorWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Separator record uniquely */
export type SeparatorWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SingleStepPromotionForm = Entity & Node & {
  __typename?: 'SingleStepPromotionForm';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SingleStepPromotionForm>;
  genericPages: Array<GenericPage>;
  /** List of SingleStepPromotionForm versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  links: Array<Link>;
  promotionDownload?: Maybe<PromotionDownload>;
  promotionForm?: Maybe<PromotionForm>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type SingleStepPromotionFormCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SingleStepPromotionFormDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type SingleStepPromotionFormGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type SingleStepPromotionFormHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type SingleStepPromotionFormLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


export type SingleStepPromotionFormPromotionDownloadArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SingleStepPromotionFormPromotionFormArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SingleStepPromotionFormPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SingleStepPromotionFormScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SingleStepPromotionFormUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SingleStepPromotionFormConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SingleStepPromotionFormWhereUniqueInput;
};

/** A connection to a list of items. */
export type SingleStepPromotionFormConnection = {
  __typename?: 'SingleStepPromotionFormConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SingleStepPromotionFormEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SingleStepPromotionFormCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  links?: InputMaybe<LinkCreateManyInlineInput>;
  promotionDownload?: InputMaybe<PromotionDownloadCreateOneInlineInput>;
  promotionForm?: InputMaybe<PromotionFormCreateOneInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SingleStepPromotionFormCreateManyInlineInput = {
  /** Connect multiple existing SingleStepPromotionForm documents */
  connect?: InputMaybe<Array<SingleStepPromotionFormWhereUniqueInput>>;
  /** Create and connect multiple existing SingleStepPromotionForm documents */
  create?: InputMaybe<Array<SingleStepPromotionFormCreateInput>>;
};

export type SingleStepPromotionFormCreateOneInlineInput = {
  /** Connect one existing SingleStepPromotionForm document */
  connect?: InputMaybe<SingleStepPromotionFormWhereUniqueInput>;
  /** Create and connect one SingleStepPromotionForm document */
  create?: InputMaybe<SingleStepPromotionFormCreateInput>;
};

/** An edge in a connection. */
export type SingleStepPromotionFormEdge = {
  __typename?: 'SingleStepPromotionFormEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SingleStepPromotionForm;
};

/** Identifies documents */
export type SingleStepPromotionFormManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SingleStepPromotionFormWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SingleStepPromotionFormWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SingleStepPromotionFormWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SingleStepPromotionFormWhereStageInput>;
  documentInStages_none?: InputMaybe<SingleStepPromotionFormWhereStageInput>;
  documentInStages_some?: InputMaybe<SingleStepPromotionFormWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  promotionDownload?: InputMaybe<PromotionDownloadWhereInput>;
  promotionForm?: InputMaybe<PromotionFormWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SingleStepPromotionFormOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SingleStepPromotionFormUpdateInput = {
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  links?: InputMaybe<LinkUpdateManyInlineInput>;
  promotionDownload?: InputMaybe<PromotionDownloadUpdateOneInlineInput>;
  promotionForm?: InputMaybe<PromotionFormUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SingleStepPromotionFormUpdateManyInlineInput = {
  /** Connect multiple existing SingleStepPromotionForm documents */
  connect?: InputMaybe<Array<SingleStepPromotionFormConnectInput>>;
  /** Create and connect multiple SingleStepPromotionForm documents */
  create?: InputMaybe<Array<SingleStepPromotionFormCreateInput>>;
  /** Delete multiple SingleStepPromotionForm documents */
  delete?: InputMaybe<Array<SingleStepPromotionFormWhereUniqueInput>>;
  /** Disconnect multiple SingleStepPromotionForm documents */
  disconnect?: InputMaybe<Array<SingleStepPromotionFormWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SingleStepPromotionForm documents */
  set?: InputMaybe<Array<SingleStepPromotionFormWhereUniqueInput>>;
  /** Update multiple SingleStepPromotionForm documents */
  update?: InputMaybe<Array<SingleStepPromotionFormUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SingleStepPromotionForm documents */
  upsert?: InputMaybe<Array<SingleStepPromotionFormUpsertWithNestedWhereUniqueInput>>;
};

export type SingleStepPromotionFormUpdateManyInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SingleStepPromotionFormUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SingleStepPromotionFormUpdateManyInput;
  /** Document search */
  where: SingleStepPromotionFormWhereInput;
};

export type SingleStepPromotionFormUpdateOneInlineInput = {
  /** Connect existing SingleStepPromotionForm document */
  connect?: InputMaybe<SingleStepPromotionFormWhereUniqueInput>;
  /** Create and connect one SingleStepPromotionForm document */
  create?: InputMaybe<SingleStepPromotionFormCreateInput>;
  /** Delete currently connected SingleStepPromotionForm document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SingleStepPromotionForm document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SingleStepPromotionForm document */
  update?: InputMaybe<SingleStepPromotionFormUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SingleStepPromotionForm document */
  upsert?: InputMaybe<SingleStepPromotionFormUpsertWithNestedWhereUniqueInput>;
};

export type SingleStepPromotionFormUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SingleStepPromotionFormUpdateInput;
  /** Unique document search */
  where: SingleStepPromotionFormWhereUniqueInput;
};

export type SingleStepPromotionFormUpsertInput = {
  /** Create document if it didn't exist */
  create: SingleStepPromotionFormCreateInput;
  /** Update document if it exists */
  update: SingleStepPromotionFormUpdateInput;
};

export type SingleStepPromotionFormUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SingleStepPromotionFormUpsertInput;
  /** Unique document search */
  where: SingleStepPromotionFormWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SingleStepPromotionFormWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SingleStepPromotionFormWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SingleStepPromotionFormWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SingleStepPromotionFormWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SingleStepPromotionFormWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SingleStepPromotionFormWhereStageInput>;
  documentInStages_none?: InputMaybe<SingleStepPromotionFormWhereStageInput>;
  documentInStages_some?: InputMaybe<SingleStepPromotionFormWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  promotionDownload?: InputMaybe<PromotionDownloadWhereInput>;
  promotionForm?: InputMaybe<PromotionFormWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SingleStepPromotionFormWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SingleStepPromotionFormWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SingleStepPromotionFormWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SingleStepPromotionFormWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SingleStepPromotionFormWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SingleStepPromotionForm record uniquely */
export type SingleStepPromotionFormWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum SocialMediaComponentName {
  EmailShareButton = 'EmailShareButton',
  FacebookShareButton = 'FacebookShareButton',
  HatenaShareButton = 'HatenaShareButton',
  InstapaperShareButton = 'InstapaperShareButton',
  LineShareButton = 'LineShareButton',
  LinkedinShareButton = 'LinkedinShareButton',
  LivejournalShareButton = 'LivejournalShareButton',
  MailruShareButton = 'MailruShareButton',
  OKShareButton = 'OKShareButton',
  PinterestShareButton = 'PinterestShareButton',
  PocketShareButton = 'PocketShareButton',
  RedditShareButton = 'RedditShareButton',
  TelegramShareButton = 'TelegramShareButton',
  TumblrShareButton = 'TumblrShareButton',
  TwitterShareButton = 'TwitterShareButton',
  VKShareButton = 'VKShareButton',
  ViberShareButton = 'ViberShareButton',
  WhatsappShareButton = 'WhatsappShareButton',
  WorkplaceShareButton = 'WorkplaceShareButton'
}

export type SocialMediaListComponent = Entity & Node & {
  __typename?: 'SocialMediaListComponent';
  anchorNav?: Maybe<AnchorNavigation>;
  assetsComponents: Array<AssetComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SocialMediaListComponent>;
  genericSocialShare?: Maybe<GenericSocialShare>;
  /** List of SocialMediaListComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** Name of social media */
  name: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** a message with the social sharing platform , it can be share it, tweet it, etc. */
  shareMsg?: Maybe<Scalars['String']['output']>;
  socialMediaComponentName?: Maybe<SocialMediaComponentName>;
  /** Position of the social media in a page */
  socialSharePosition: Array<SocialSharePosition>;
  /** System stage field */
  stage: Stage;
  subTabContent?: Maybe<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** URL of social media */
  url: Scalars['String']['output'];
};


export type SocialMediaListComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SocialMediaListComponentAssetsComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentWhereInput>;
};


export type SocialMediaListComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SocialMediaListComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type SocialMediaListComponentGenericSocialShareArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SocialMediaListComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type SocialMediaListComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SocialMediaListComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SocialMediaListComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SocialMediaListComponentSubTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SocialMediaListComponentTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SocialMediaListComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SocialMediaListComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SocialMediaListComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type SocialMediaListComponentConnection = {
  __typename?: 'SocialMediaListComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SocialMediaListComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SocialMediaListComponentCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  assetsComponents?: InputMaybe<AssetComponentCreateManyInlineInput>;
  ckryvqsbd252f01z830y60gx1?: InputMaybe<GenericFollowUsCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericSocialShare?: InputMaybe<GenericSocialShareCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  name: Scalars['String']['input'];
  shareMsg?: InputMaybe<Scalars['String']['input']>;
  socialMediaComponentName?: InputMaybe<SocialMediaComponentName>;
  socialSharePosition?: InputMaybe<Array<SocialSharePosition>>;
  subTabContent?: InputMaybe<SubTabContentCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type SocialMediaListComponentCreateManyInlineInput = {
  /** Connect multiple existing SocialMediaListComponent documents */
  connect?: InputMaybe<Array<SocialMediaListComponentWhereUniqueInput>>;
  /** Create and connect multiple existing SocialMediaListComponent documents */
  create?: InputMaybe<Array<SocialMediaListComponentCreateInput>>;
};

export type SocialMediaListComponentCreateOneInlineInput = {
  /** Connect one existing SocialMediaListComponent document */
  connect?: InputMaybe<SocialMediaListComponentWhereUniqueInput>;
  /** Create and connect one SocialMediaListComponent document */
  create?: InputMaybe<SocialMediaListComponentCreateInput>;
};

/** An edge in a connection. */
export type SocialMediaListComponentEdge = {
  __typename?: 'SocialMediaListComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SocialMediaListComponent;
};

/** Identifies documents */
export type SocialMediaListComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SocialMediaListComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SocialMediaListComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SocialMediaListComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SocialMediaListComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<SocialMediaListComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<SocialMediaListComponentWhereStageInput>;
  genericSocialShare?: InputMaybe<GenericSocialShareWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  shareMsg?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shareMsg_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shareMsg_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shareMsg_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shareMsg_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shareMsg_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shareMsg_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shareMsg_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shareMsg_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shareMsg_starts_with?: InputMaybe<Scalars['String']['input']>;
  socialMediaComponentName?: InputMaybe<SocialMediaComponentName>;
  /** All values that are contained in given list. */
  socialMediaComponentName_in?: InputMaybe<Array<InputMaybe<SocialMediaComponentName>>>;
  /** Any other value that exists and is not equal to the given value. */
  socialMediaComponentName_not?: InputMaybe<SocialMediaComponentName>;
  /** All values that are not contained in given list. */
  socialMediaComponentName_not_in?: InputMaybe<Array<InputMaybe<SocialMediaComponentName>>>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  socialSharePosition?: InputMaybe<Array<SocialSharePosition>>;
  /** Matches if the field array contains *all* items provided to the filter */
  socialSharePosition_contains_all?: InputMaybe<Array<SocialSharePosition>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  socialSharePosition_contains_none?: InputMaybe<Array<SocialSharePosition>>;
  /** Matches if the field array contains at least one item provided to the filter */
  socialSharePosition_contains_some?: InputMaybe<Array<SocialSharePosition>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  socialSharePosition_not?: InputMaybe<Array<SocialSharePosition>>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum SocialMediaListComponentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  shareMsg_ASC = 'shareMsg_ASC',
  shareMsg_DESC = 'shareMsg_DESC',
  socialMediaComponentName_ASC = 'socialMediaComponentName_ASC',
  socialMediaComponentName_DESC = 'socialMediaComponentName_DESC',
  socialSharePosition_ASC = 'socialSharePosition_ASC',
  socialSharePosition_DESC = 'socialSharePosition_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC'
}

export type SocialMediaListComponentUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  assetsComponents?: InputMaybe<AssetComponentUpdateManyInlineInput>;
  ckryvqsbd252f01z830y60gx1?: InputMaybe<GenericFollowUsUpdateManyInlineInput>;
  genericSocialShare?: InputMaybe<GenericSocialShareUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  shareMsg?: InputMaybe<Scalars['String']['input']>;
  socialMediaComponentName?: InputMaybe<SocialMediaComponentName>;
  socialSharePosition?: InputMaybe<Array<SocialSharePosition>>;
  subTabContent?: InputMaybe<SubTabContentUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SocialMediaListComponentUpdateManyInlineInput = {
  /** Connect multiple existing SocialMediaListComponent documents */
  connect?: InputMaybe<Array<SocialMediaListComponentConnectInput>>;
  /** Create and connect multiple SocialMediaListComponent documents */
  create?: InputMaybe<Array<SocialMediaListComponentCreateInput>>;
  /** Delete multiple SocialMediaListComponent documents */
  delete?: InputMaybe<Array<SocialMediaListComponentWhereUniqueInput>>;
  /** Disconnect multiple SocialMediaListComponent documents */
  disconnect?: InputMaybe<Array<SocialMediaListComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SocialMediaListComponent documents */
  set?: InputMaybe<Array<SocialMediaListComponentWhereUniqueInput>>;
  /** Update multiple SocialMediaListComponent documents */
  update?: InputMaybe<Array<SocialMediaListComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SocialMediaListComponent documents */
  upsert?: InputMaybe<Array<SocialMediaListComponentUpsertWithNestedWhereUniqueInput>>;
};

export type SocialMediaListComponentUpdateManyInput = {
  market?: InputMaybe<Markets>;
  name?: InputMaybe<Scalars['String']['input']>;
  shareMsg?: InputMaybe<Scalars['String']['input']>;
  socialMediaComponentName?: InputMaybe<SocialMediaComponentName>;
  socialSharePosition?: InputMaybe<Array<SocialSharePosition>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SocialMediaListComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SocialMediaListComponentUpdateManyInput;
  /** Document search */
  where: SocialMediaListComponentWhereInput;
};

export type SocialMediaListComponentUpdateOneInlineInput = {
  /** Connect existing SocialMediaListComponent document */
  connect?: InputMaybe<SocialMediaListComponentWhereUniqueInput>;
  /** Create and connect one SocialMediaListComponent document */
  create?: InputMaybe<SocialMediaListComponentCreateInput>;
  /** Delete currently connected SocialMediaListComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SocialMediaListComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SocialMediaListComponent document */
  update?: InputMaybe<SocialMediaListComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SocialMediaListComponent document */
  upsert?: InputMaybe<SocialMediaListComponentUpsertWithNestedWhereUniqueInput>;
};

export type SocialMediaListComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SocialMediaListComponentUpdateInput;
  /** Unique document search */
  where: SocialMediaListComponentWhereUniqueInput;
};

export type SocialMediaListComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: SocialMediaListComponentCreateInput;
  /** Update document if it exists */
  update: SocialMediaListComponentUpdateInput;
};

export type SocialMediaListComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SocialMediaListComponentUpsertInput;
  /** Unique document search */
  where: SocialMediaListComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SocialMediaListComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SocialMediaListComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SocialMediaListComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SocialMediaListComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SocialMediaListComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SocialMediaListComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<SocialMediaListComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<SocialMediaListComponentWhereStageInput>;
  genericSocialShare?: InputMaybe<GenericSocialShareWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  shareMsg?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shareMsg_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shareMsg_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shareMsg_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shareMsg_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shareMsg_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shareMsg_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shareMsg_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shareMsg_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shareMsg_starts_with?: InputMaybe<Scalars['String']['input']>;
  socialMediaComponentName?: InputMaybe<SocialMediaComponentName>;
  /** All values that are contained in given list. */
  socialMediaComponentName_in?: InputMaybe<Array<InputMaybe<SocialMediaComponentName>>>;
  /** Any other value that exists and is not equal to the given value. */
  socialMediaComponentName_not?: InputMaybe<SocialMediaComponentName>;
  /** All values that are not contained in given list. */
  socialMediaComponentName_not_in?: InputMaybe<Array<InputMaybe<SocialMediaComponentName>>>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  socialSharePosition?: InputMaybe<Array<SocialSharePosition>>;
  /** Matches if the field array contains *all* items provided to the filter */
  socialSharePosition_contains_all?: InputMaybe<Array<SocialSharePosition>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  socialSharePosition_contains_none?: InputMaybe<Array<SocialSharePosition>>;
  /** Matches if the field array contains at least one item provided to the filter */
  socialSharePosition_contains_some?: InputMaybe<Array<SocialSharePosition>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  socialSharePosition_not?: InputMaybe<Array<SocialSharePosition>>;
  subTabContent?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SocialMediaListComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SocialMediaListComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SocialMediaListComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SocialMediaListComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SocialMediaListComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SocialMediaListComponent record uniquely */
export type SocialMediaListComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum SocialSharePosition {
  Footer = 'Footer',
  SocialShareComponent = 'SocialShareComponent'
}

/** Empty spacer block  */
export type Spacer = Entity & Node & {
  __typename?: 'Spacer';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Spacer>;
  genericPages: Array<GenericPage>;
  /** Set block height in px */
  height?: Maybe<Scalars['Int']['output']>;
  /** List of Spacer versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  productCategoryPages: Array<ProductCategoryPage>;
  productLandingPages: Array<ProductLandingPage>;
  productSubcategoryPages: Array<ProductSubcategoryPage>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeCategories: Array<RecipeCategory>;
  recipeLandingPages: Array<RecipeLandingPage>;
  recipeSubcategories: Array<RecipeSubcategory>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Empty spacer block  */
export type SpacerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Empty spacer block  */
export type SpacerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Empty spacer block  */
export type SpacerGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Empty spacer block  */
export type SpacerHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Empty spacer block  */
export type SpacerMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Empty spacer block  */
export type SpacerProductCategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductCategoryPageWhereInput>;
};


/** Empty spacer block  */
export type SpacerProductLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLandingPageWhereInput>;
};


/** Empty spacer block  */
export type SpacerProductSubcategoryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
};


/** Empty spacer block  */
export type SpacerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Empty spacer block  */
export type SpacerRecipeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


/** Empty spacer block  */
export type SpacerRecipeLandingPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeLandingPageWhereInput>;
};


/** Empty spacer block  */
export type SpacerRecipeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeSubcategoryWhereInput>;
};


/** Empty spacer block  */
export type SpacerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Empty spacer block  */
export type SpacerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SpacerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SpacerWhereUniqueInput;
};

/** A connection to a list of items. */
export type SpacerConnection = {
  __typename?: 'SpacerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SpacerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SpacerCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageCreateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageCreateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageCreateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryCreateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageCreateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SpacerCreateManyInlineInput = {
  /** Connect multiple existing Spacer documents */
  connect?: InputMaybe<Array<SpacerWhereUniqueInput>>;
  /** Create and connect multiple existing Spacer documents */
  create?: InputMaybe<Array<SpacerCreateInput>>;
};

export type SpacerCreateOneInlineInput = {
  /** Connect one existing Spacer document */
  connect?: InputMaybe<SpacerWhereUniqueInput>;
  /** Create and connect one Spacer document */
  create?: InputMaybe<SpacerCreateInput>;
};

/** An edge in a connection. */
export type SpacerEdge = {
  __typename?: 'SpacerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Spacer;
};

/** Identifies documents */
export type SpacerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpacerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpacerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpacerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SpacerWhereStageInput>;
  documentInStages_none?: InputMaybe<SpacerWhereStageInput>;
  documentInStages_some?: InputMaybe<SpacerWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SpacerOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  height_ASC = 'height_ASC',
  height_DESC = 'height_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SpacerUpdateInput = {
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  productCategoryPages?: InputMaybe<ProductCategoryPageUpdateManyInlineInput>;
  productLandingPages?: InputMaybe<ProductLandingPageUpdateManyInlineInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageUpdateManyInlineInput>;
  recipeCategories?: InputMaybe<RecipeCategoryUpdateManyInlineInput>;
  recipeLandingPages?: InputMaybe<RecipeLandingPageUpdateManyInlineInput>;
  recipeSubcategories?: InputMaybe<RecipeSubcategoryUpdateManyInlineInput>;
};

export type SpacerUpdateManyInlineInput = {
  /** Connect multiple existing Spacer documents */
  connect?: InputMaybe<Array<SpacerConnectInput>>;
  /** Create and connect multiple Spacer documents */
  create?: InputMaybe<Array<SpacerCreateInput>>;
  /** Delete multiple Spacer documents */
  delete?: InputMaybe<Array<SpacerWhereUniqueInput>>;
  /** Disconnect multiple Spacer documents */
  disconnect?: InputMaybe<Array<SpacerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Spacer documents */
  set?: InputMaybe<Array<SpacerWhereUniqueInput>>;
  /** Update multiple Spacer documents */
  update?: InputMaybe<Array<SpacerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Spacer documents */
  upsert?: InputMaybe<Array<SpacerUpsertWithNestedWhereUniqueInput>>;
};

export type SpacerUpdateManyInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  market?: InputMaybe<Markets>;
};

export type SpacerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SpacerUpdateManyInput;
  /** Document search */
  where: SpacerWhereInput;
};

export type SpacerUpdateOneInlineInput = {
  /** Connect existing Spacer document */
  connect?: InputMaybe<SpacerWhereUniqueInput>;
  /** Create and connect one Spacer document */
  create?: InputMaybe<SpacerCreateInput>;
  /** Delete currently connected Spacer document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Spacer document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Spacer document */
  update?: InputMaybe<SpacerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Spacer document */
  upsert?: InputMaybe<SpacerUpsertWithNestedWhereUniqueInput>;
};

export type SpacerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SpacerUpdateInput;
  /** Unique document search */
  where: SpacerWhereUniqueInput;
};

export type SpacerUpsertInput = {
  /** Create document if it didn't exist */
  create: SpacerCreateInput;
  /** Update document if it exists */
  update: SpacerUpdateInput;
};

export type SpacerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SpacerUpsertInput;
  /** Unique document search */
  where: SpacerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SpacerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SpacerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpacerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpacerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpacerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SpacerWhereStageInput>;
  documentInStages_none?: InputMaybe<SpacerWhereStageInput>;
  documentInStages_some?: InputMaybe<SpacerWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  productCategoryPages_every?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_none?: InputMaybe<ProductCategoryPageWhereInput>;
  productCategoryPages_some?: InputMaybe<ProductCategoryPageWhereInput>;
  productLandingPages_every?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_none?: InputMaybe<ProductLandingPageWhereInput>;
  productLandingPages_some?: InputMaybe<ProductLandingPageWhereInput>;
  productSubcategoryPages_every?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_none?: InputMaybe<ProductSubcategoryPageWhereInput>;
  productSubcategoryPages_some?: InputMaybe<ProductSubcategoryPageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeCategories_every?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_none?: InputMaybe<RecipeCategoryWhereInput>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeLandingPages_every?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_none?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeLandingPages_some?: InputMaybe<RecipeLandingPageWhereInput>;
  recipeSubcategories_every?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_none?: InputMaybe<RecipeSubcategoryWhereInput>;
  recipeSubcategories_some?: InputMaybe<RecipeSubcategoryWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SpacerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpacerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpacerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpacerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SpacerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Spacer record uniquely */
export type SpacerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Stage system enumeration */
export enum Stage {
  /** The Draft is the default stage for all your content. */
  DRAFT = 'DRAFT',
  /** The Published stage is where you can publish your content to. */
  PUBLISHED = 'PUBLISHED'
}

export type SubCategoryKeyImage = Entity & Node & {
  __typename?: 'SubCategoryKeyImage';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SubCategoryKeyImage>;
  /** Image for use on the category & subcategory component that displays on the all recipes page */
  forAllRecipePages?: Maybe<Asset>;
  /** Image for use on subcategory component that displays on recipe category pages */
  forRecipeCategoryPage?: Maybe<Asset>;
  /** List of SubCategoryKeyImage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type SubCategoryKeyImageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SubCategoryKeyImageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type SubCategoryKeyImageForAllRecipePagesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type SubCategoryKeyImageForRecipeCategoryPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type SubCategoryKeyImageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type SubCategoryKeyImageMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SubCategoryKeyImagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SubCategoryKeyImageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SubCategoryKeyImageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SubCategoryKeyImageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SubCategoryKeyImageWhereUniqueInput;
};

/** A connection to a list of items. */
export type SubCategoryKeyImageConnection = {
  __typename?: 'SubCategoryKeyImageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SubCategoryKeyImageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SubCategoryKeyImageCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  forAllRecipePages?: InputMaybe<AssetCreateOneInlineInput>;
  forRecipeCategoryPage?: InputMaybe<AssetCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubCategoryKeyImageCreateManyInlineInput = {
  /** Connect multiple existing SubCategoryKeyImage documents */
  connect?: InputMaybe<Array<SubCategoryKeyImageWhereUniqueInput>>;
  /** Create and connect multiple existing SubCategoryKeyImage documents */
  create?: InputMaybe<Array<SubCategoryKeyImageCreateInput>>;
};

export type SubCategoryKeyImageCreateOneInlineInput = {
  /** Connect one existing SubCategoryKeyImage document */
  connect?: InputMaybe<SubCategoryKeyImageWhereUniqueInput>;
  /** Create and connect one SubCategoryKeyImage document */
  create?: InputMaybe<SubCategoryKeyImageCreateInput>;
};

/** An edge in a connection. */
export type SubCategoryKeyImageEdge = {
  __typename?: 'SubCategoryKeyImageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SubCategoryKeyImage;
};

/** Identifies documents */
export type SubCategoryKeyImageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SubCategoryKeyImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SubCategoryKeyImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SubCategoryKeyImageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SubCategoryKeyImageWhereStageInput>;
  documentInStages_none?: InputMaybe<SubCategoryKeyImageWhereStageInput>;
  documentInStages_some?: InputMaybe<SubCategoryKeyImageWhereStageInput>;
  forAllRecipePages?: InputMaybe<AssetWhereInput>;
  forRecipeCategoryPage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SubCategoryKeyImageOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SubCategoryKeyImageUpdateInput = {
  forAllRecipePages?: InputMaybe<AssetUpdateOneInlineInput>;
  forRecipeCategoryPage?: InputMaybe<AssetUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
};

export type SubCategoryKeyImageUpdateManyInlineInput = {
  /** Connect multiple existing SubCategoryKeyImage documents */
  connect?: InputMaybe<Array<SubCategoryKeyImageConnectInput>>;
  /** Create and connect multiple SubCategoryKeyImage documents */
  create?: InputMaybe<Array<SubCategoryKeyImageCreateInput>>;
  /** Delete multiple SubCategoryKeyImage documents */
  delete?: InputMaybe<Array<SubCategoryKeyImageWhereUniqueInput>>;
  /** Disconnect multiple SubCategoryKeyImage documents */
  disconnect?: InputMaybe<Array<SubCategoryKeyImageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SubCategoryKeyImage documents */
  set?: InputMaybe<Array<SubCategoryKeyImageWhereUniqueInput>>;
  /** Update multiple SubCategoryKeyImage documents */
  update?: InputMaybe<Array<SubCategoryKeyImageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SubCategoryKeyImage documents */
  upsert?: InputMaybe<Array<SubCategoryKeyImageUpsertWithNestedWhereUniqueInput>>;
};

export type SubCategoryKeyImageUpdateManyInput = {
  market?: InputMaybe<Markets>;
};

export type SubCategoryKeyImageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SubCategoryKeyImageUpdateManyInput;
  /** Document search */
  where: SubCategoryKeyImageWhereInput;
};

export type SubCategoryKeyImageUpdateOneInlineInput = {
  /** Connect existing SubCategoryKeyImage document */
  connect?: InputMaybe<SubCategoryKeyImageWhereUniqueInput>;
  /** Create and connect one SubCategoryKeyImage document */
  create?: InputMaybe<SubCategoryKeyImageCreateInput>;
  /** Delete currently connected SubCategoryKeyImage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SubCategoryKeyImage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SubCategoryKeyImage document */
  update?: InputMaybe<SubCategoryKeyImageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SubCategoryKeyImage document */
  upsert?: InputMaybe<SubCategoryKeyImageUpsertWithNestedWhereUniqueInput>;
};

export type SubCategoryKeyImageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SubCategoryKeyImageUpdateInput;
  /** Unique document search */
  where: SubCategoryKeyImageWhereUniqueInput;
};

export type SubCategoryKeyImageUpsertInput = {
  /** Create document if it didn't exist */
  create: SubCategoryKeyImageCreateInput;
  /** Update document if it exists */
  update: SubCategoryKeyImageUpdateInput;
};

export type SubCategoryKeyImageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SubCategoryKeyImageUpsertInput;
  /** Unique document search */
  where: SubCategoryKeyImageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SubCategoryKeyImageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SubCategoryKeyImageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SubCategoryKeyImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SubCategoryKeyImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SubCategoryKeyImageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SubCategoryKeyImageWhereStageInput>;
  documentInStages_none?: InputMaybe<SubCategoryKeyImageWhereStageInput>;
  documentInStages_some?: InputMaybe<SubCategoryKeyImageWhereStageInput>;
  forAllRecipePages?: InputMaybe<AssetWhereInput>;
  forRecipeCategoryPage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SubCategoryKeyImageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SubCategoryKeyImageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SubCategoryKeyImageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SubCategoryKeyImageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SubCategoryKeyImageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SubCategoryKeyImage record uniquely */
export type SubCategoryKeyImageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** A collection of tabs that can be rendered on screen. */
export type SubTab = Entity & Node & {
  __typename?: 'SubTab';
  /** A title to uniquely identify the name of collection of different tabs based on the usage. */
  cmsTabTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SubTab>;
  /** List of SubTab versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subTabs: Array<SubTabContent>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** A collection of tabs that can be rendered on screen. */
export type SubTabCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A collection of tabs that can be rendered on screen. */
export type SubTabDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** A collection of tabs that can be rendered on screen. */
export type SubTabHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** A collection of tabs that can be rendered on screen. */
export type SubTabMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A collection of tabs that can be rendered on screen. */
export type SubTabPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A collection of tabs that can be rendered on screen. */
export type SubTabScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** A collection of tabs that can be rendered on screen. */
export type SubTabSubTabsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SubTabContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubTabContentWhereInput>;
};


/** A collection of tabs that can be rendered on screen. */
export type SubTabTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A collection of tabs that can be rendered on screen. */
export type SubTabUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SubTabConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SubTabWhereUniqueInput;
};

/** A connection to a list of items. */
export type SubTabConnection = {
  __typename?: 'SubTabConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SubTabEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type SubTabContent = Entity & Node & {
  __typename?: 'SubTabContent';
  /** list of components that can be held by a particular tab. */
  components: Array<SubTabContentComponents>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SubTabContent>;
  /** List of SubTabContent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Name of the tab, this is the clickable element which will open the components held by a particular tab. */
  tabTitle: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type SubTabContentComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type SubTabContentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type SubTabContentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type SubTabContentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type SubTabContentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type SubTabContentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type SubTabContentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type SubTabContentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SubTabContentComponents = AuthorableContentCard | Banner1 | Banner2 | Banner2CarouselComponent | CardComponent | CarouselComponent | DynamicCardGrid | EvalancheFormComponent | Form | GenericAccordion | GenericAccordionTopRated | GenericCardCarouseComponent | GenericDownloadComponent | GenericFollowUs | GenericHtml | GenericLine | GenericPage | GridColumn | GridColumnComponent | HeroCarouselComponent | Iframe | ImageCopy | IntroText | Link | LongText | ProductBanner | SocialMediaListComponent;

export type SubTabContentComponentsConnectInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardConnectInput>;
  Banner1?: InputMaybe<Banner1ConnectInput>;
  Banner2?: InputMaybe<Banner2ConnectInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentConnectInput>;
  CardComponent?: InputMaybe<CardComponentConnectInput>;
  CarouselComponent?: InputMaybe<CarouselComponentConnectInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridConnectInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentConnectInput>;
  Form?: InputMaybe<FormConnectInput>;
  GenericAccordion?: InputMaybe<GenericAccordionConnectInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedConnectInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentConnectInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentConnectInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsConnectInput>;
  GenericHtml?: InputMaybe<GenericHtmlConnectInput>;
  GenericLine?: InputMaybe<GenericLineConnectInput>;
  GenericPage?: InputMaybe<GenericPageConnectInput>;
  GridColumn?: InputMaybe<GridColumnConnectInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentConnectInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentConnectInput>;
  Iframe?: InputMaybe<IframeConnectInput>;
  ImageCopy?: InputMaybe<ImageCopyConnectInput>;
  IntroText?: InputMaybe<IntroTextConnectInput>;
  Link?: InputMaybe<LinkConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
  ProductBanner?: InputMaybe<ProductBannerConnectInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentConnectInput>;
};

export type SubTabContentComponentsCreateInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardCreateInput>;
  Banner1?: InputMaybe<Banner1CreateInput>;
  Banner2?: InputMaybe<Banner2CreateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentCreateInput>;
  CardComponent?: InputMaybe<CardComponentCreateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentCreateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridCreateInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentCreateInput>;
  Form?: InputMaybe<FormCreateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionCreateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedCreateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentCreateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsCreateInput>;
  GenericHtml?: InputMaybe<GenericHtmlCreateInput>;
  GenericLine?: InputMaybe<GenericLineCreateInput>;
  GenericPage?: InputMaybe<GenericPageCreateInput>;
  GridColumn?: InputMaybe<GridColumnCreateInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentCreateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateInput>;
  Iframe?: InputMaybe<IframeCreateInput>;
  ImageCopy?: InputMaybe<ImageCopyCreateInput>;
  IntroText?: InputMaybe<IntroTextCreateInput>;
  Link?: InputMaybe<LinkCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
  ProductBanner?: InputMaybe<ProductBannerCreateInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentCreateInput>;
};

export type SubTabContentComponentsCreateManyInlineInput = {
  /** Connect multiple existing SubTabContentComponents documents */
  connect?: InputMaybe<Array<SubTabContentComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing SubTabContentComponents documents */
  create?: InputMaybe<Array<SubTabContentComponentsCreateInput>>;
};

export type SubTabContentComponentsCreateOneInlineInput = {
  /** Connect one existing SubTabContentComponents document */
  connect?: InputMaybe<SubTabContentComponentsWhereUniqueInput>;
  /** Create and connect one SubTabContentComponents document */
  create?: InputMaybe<SubTabContentComponentsCreateInput>;
};

export type SubTabContentComponentsUpdateInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateInput>;
  Banner1?: InputMaybe<Banner1UpdateInput>;
  Banner2?: InputMaybe<Banner2UpdateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateInput>;
  CardComponent?: InputMaybe<CardComponentUpdateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateInput>;
  Form?: InputMaybe<FormUpdateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateInput>;
  GenericLine?: InputMaybe<GenericLineUpdateInput>;
  GenericPage?: InputMaybe<GenericPageUpdateInput>;
  GridColumn?: InputMaybe<GridColumnUpdateInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentUpdateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateInput>;
  Iframe?: InputMaybe<IframeUpdateInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateInput>;
  IntroText?: InputMaybe<IntroTextUpdateInput>;
  Link?: InputMaybe<LinkUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateInput>;
};

export type SubTabContentComponentsUpdateManyInlineInput = {
  /** Connect multiple existing SubTabContentComponents documents */
  connect?: InputMaybe<Array<SubTabContentComponentsConnectInput>>;
  /** Create and connect multiple SubTabContentComponents documents */
  create?: InputMaybe<Array<SubTabContentComponentsCreateInput>>;
  /** Delete multiple SubTabContentComponents documents */
  delete?: InputMaybe<Array<SubTabContentComponentsWhereUniqueInput>>;
  /** Disconnect multiple SubTabContentComponents documents */
  disconnect?: InputMaybe<Array<SubTabContentComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SubTabContentComponents documents */
  set?: InputMaybe<Array<SubTabContentComponentsWhereUniqueInput>>;
  /** Update multiple SubTabContentComponents documents */
  update?: InputMaybe<Array<SubTabContentComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SubTabContentComponents documents */
  upsert?: InputMaybe<Array<SubTabContentComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type SubTabContentComponentsUpdateManyWithNestedWhereInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateManyWithNestedWhereInput>;
  Banner1?: InputMaybe<Banner1UpdateManyWithNestedWhereInput>;
  Banner2?: InputMaybe<Banner2UpdateManyWithNestedWhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateManyWithNestedWhereInput>;
  CardComponent?: InputMaybe<CardComponentUpdateManyWithNestedWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateManyWithNestedWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateManyWithNestedWhereInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateManyWithNestedWhereInput>;
  Form?: InputMaybe<FormUpdateManyWithNestedWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateManyWithNestedWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateManyWithNestedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateManyWithNestedWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateManyWithNestedWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateManyWithNestedWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateManyWithNestedWhereInput>;
  GenericLine?: InputMaybe<GenericLineUpdateManyWithNestedWhereInput>;
  GenericPage?: InputMaybe<GenericPageUpdateManyWithNestedWhereInput>;
  GridColumn?: InputMaybe<GridColumnUpdateManyWithNestedWhereInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentUpdateManyWithNestedWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateManyWithNestedWhereInput>;
  Iframe?: InputMaybe<IframeUpdateManyWithNestedWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateManyWithNestedWhereInput>;
  IntroText?: InputMaybe<IntroTextUpdateManyWithNestedWhereInput>;
  Link?: InputMaybe<LinkUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateManyWithNestedWhereInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateManyWithNestedWhereInput>;
};

export type SubTabContentComponentsUpdateOneInlineInput = {
  /** Connect existing SubTabContentComponents document */
  connect?: InputMaybe<SubTabContentComponentsWhereUniqueInput>;
  /** Create and connect one SubTabContentComponents document */
  create?: InputMaybe<SubTabContentComponentsCreateInput>;
  /** Delete currently connected SubTabContentComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SubTabContentComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SubTabContentComponents document */
  update?: InputMaybe<SubTabContentComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SubTabContentComponents document */
  upsert?: InputMaybe<SubTabContentComponentsUpsertWithNestedWhereUniqueInput>;
};

export type SubTabContentComponentsUpdateWithNestedWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpdateWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpdateWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateWithNestedWhereUniqueInput>;
  CardComponent?: InputMaybe<CardComponentUpdateWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateWithNestedWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateWithNestedWhereUniqueInput>;
  Form?: InputMaybe<FormUpdateWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateWithNestedWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineUpdateWithNestedWhereUniqueInput>;
  GenericPage?: InputMaybe<GenericPageUpdateWithNestedWhereUniqueInput>;
  GridColumn?: InputMaybe<GridColumnUpdateWithNestedWhereUniqueInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentUpdateWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpdateWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpdateWithNestedWhereUniqueInput>;
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateWithNestedWhereUniqueInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateWithNestedWhereUniqueInput>;
};

export type SubTabContentComponentsUpsertWithNestedWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpsertWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpsertWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpsertWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpsertWithNestedWhereUniqueInput>;
  CardComponent?: InputMaybe<CardComponentUpsertWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpsertWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpsertWithNestedWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpsertWithNestedWhereUniqueInput>;
  Form?: InputMaybe<FormUpsertWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpsertWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpsertWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpsertWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpsertWithNestedWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineUpsertWithNestedWhereUniqueInput>;
  GenericPage?: InputMaybe<GenericPageUpsertWithNestedWhereUniqueInput>;
  GridColumn?: InputMaybe<GridColumnUpsertWithNestedWhereUniqueInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentUpsertWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpsertWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpsertWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpsertWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpsertWithNestedWhereUniqueInput>;
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpsertWithNestedWhereUniqueInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpsertWithNestedWhereUniqueInput>;
};

export type SubTabContentComponentsWhereInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereInput>;
  Banner1?: InputMaybe<Banner1WhereInput>;
  Banner2?: InputMaybe<Banner2WhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereInput>;
  CardComponent?: InputMaybe<CardComponentWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentWhereInput>;
  Form?: InputMaybe<FormWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereInput>;
  GenericLine?: InputMaybe<GenericLineWhereInput>;
  GenericPage?: InputMaybe<GenericPageWhereInput>;
  GridColumn?: InputMaybe<GridColumnWhereInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  Iframe?: InputMaybe<IframeWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereInput>;
  IntroText?: InputMaybe<IntroTextWhereInput>;
  Link?: InputMaybe<LinkWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentWhereInput>;
};

export type SubTabContentComponentsWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1WhereUniqueInput>;
  Banner2?: InputMaybe<Banner2WhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereUniqueInput>;
  CardComponent?: InputMaybe<CardComponentWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentWhereUniqueInput>;
  Form?: InputMaybe<FormWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineWhereUniqueInput>;
  GenericPage?: InputMaybe<GenericPageWhereUniqueInput>;
  GridColumn?: InputMaybe<GridColumnWhereUniqueInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereUniqueInput>;
  Iframe?: InputMaybe<IframeWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextWhereUniqueInput>;
  Link?: InputMaybe<LinkWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereUniqueInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentWhereUniqueInput>;
};

export type SubTabContentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SubTabContentWhereUniqueInput;
};

/** A connection to a list of items. */
export type SubTabContentConnection = {
  __typename?: 'SubTabContentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SubTabContentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SubTabContentCreateInput = {
  ckw7t93i50gur01z2exgmhg0c?: InputMaybe<SubTabCreateManyInlineInput>;
  components?: InputMaybe<SubTabContentComponentsCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  tabTitle: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubTabContentCreateManyInlineInput = {
  /** Connect multiple existing SubTabContent documents */
  connect?: InputMaybe<Array<SubTabContentWhereUniqueInput>>;
  /** Create and connect multiple existing SubTabContent documents */
  create?: InputMaybe<Array<SubTabContentCreateInput>>;
};

export type SubTabContentCreateOneInlineInput = {
  /** Connect one existing SubTabContent document */
  connect?: InputMaybe<SubTabContentWhereUniqueInput>;
  /** Create and connect one SubTabContent document */
  create?: InputMaybe<SubTabContentCreateInput>;
};

/** An edge in a connection. */
export type SubTabContentEdge = {
  __typename?: 'SubTabContentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SubTabContent;
};

/** Identifies documents */
export type SubTabContentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SubTabContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SubTabContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SubTabContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  components_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  components_some?: InputMaybe<SubTabContentComponentsWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SubTabContentWhereStageInput>;
  documentInStages_none?: InputMaybe<SubTabContentWhereStageInput>;
  documentInStages_some?: InputMaybe<SubTabContentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tabTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tabTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tabTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tabTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tabTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tabTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tabTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tabTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tabTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SubTabContentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  tabTitle_ASC = 'tabTitle_ASC',
  tabTitle_DESC = 'tabTitle_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SubTabContentUpdateInput = {
  ckw7t93i50gur01z2exgmhg0c?: InputMaybe<SubTabUpdateManyInlineInput>;
  components?: InputMaybe<SubTabContentComponentsUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  tabTitle?: InputMaybe<Scalars['String']['input']>;
};

export type SubTabContentUpdateManyInlineInput = {
  /** Connect multiple existing SubTabContent documents */
  connect?: InputMaybe<Array<SubTabContentConnectInput>>;
  /** Create and connect multiple SubTabContent documents */
  create?: InputMaybe<Array<SubTabContentCreateInput>>;
  /** Delete multiple SubTabContent documents */
  delete?: InputMaybe<Array<SubTabContentWhereUniqueInput>>;
  /** Disconnect multiple SubTabContent documents */
  disconnect?: InputMaybe<Array<SubTabContentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SubTabContent documents */
  set?: InputMaybe<Array<SubTabContentWhereUniqueInput>>;
  /** Update multiple SubTabContent documents */
  update?: InputMaybe<Array<SubTabContentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SubTabContent documents */
  upsert?: InputMaybe<Array<SubTabContentUpsertWithNestedWhereUniqueInput>>;
};

export type SubTabContentUpdateManyInput = {
  market?: InputMaybe<Markets>;
  tabTitle?: InputMaybe<Scalars['String']['input']>;
};

export type SubTabContentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SubTabContentUpdateManyInput;
  /** Document search */
  where: SubTabContentWhereInput;
};

export type SubTabContentUpdateOneInlineInput = {
  /** Connect existing SubTabContent document */
  connect?: InputMaybe<SubTabContentWhereUniqueInput>;
  /** Create and connect one SubTabContent document */
  create?: InputMaybe<SubTabContentCreateInput>;
  /** Delete currently connected SubTabContent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SubTabContent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SubTabContent document */
  update?: InputMaybe<SubTabContentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SubTabContent document */
  upsert?: InputMaybe<SubTabContentUpsertWithNestedWhereUniqueInput>;
};

export type SubTabContentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SubTabContentUpdateInput;
  /** Unique document search */
  where: SubTabContentWhereUniqueInput;
};

export type SubTabContentUpsertInput = {
  /** Create document if it didn't exist */
  create: SubTabContentCreateInput;
  /** Update document if it exists */
  update: SubTabContentUpdateInput;
};

export type SubTabContentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SubTabContentUpsertInput;
  /** Unique document search */
  where: SubTabContentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SubTabContentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SubTabContentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SubTabContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SubTabContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SubTabContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  components_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  components_some?: InputMaybe<SubTabContentComponentsWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SubTabContentWhereStageInput>;
  documentInStages_none?: InputMaybe<SubTabContentWhereStageInput>;
  documentInStages_some?: InputMaybe<SubTabContentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tabTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tabTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tabTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tabTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tabTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tabTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tabTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tabTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tabTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SubTabContentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SubTabContentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SubTabContentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SubTabContentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SubTabContentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SubTabContent record uniquely */
export type SubTabContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SubTabCreateInput = {
  cmsTabTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  subTabs?: InputMaybe<SubTabContentCreateManyInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubTabCreateManyInlineInput = {
  /** Connect multiple existing SubTab documents */
  connect?: InputMaybe<Array<SubTabWhereUniqueInput>>;
  /** Create and connect multiple existing SubTab documents */
  create?: InputMaybe<Array<SubTabCreateInput>>;
};

export type SubTabCreateOneInlineInput = {
  /** Connect one existing SubTab document */
  connect?: InputMaybe<SubTabWhereUniqueInput>;
  /** Create and connect one SubTab document */
  create?: InputMaybe<SubTabCreateInput>;
};

/** An edge in a connection. */
export type SubTabEdge = {
  __typename?: 'SubTabEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SubTab;
};

/** Identifies documents */
export type SubTabManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SubTabWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SubTabWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SubTabWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTabTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTabTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTabTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTabTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTabTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTabTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTabTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTabTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTabTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTabTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SubTabWhereStageInput>;
  documentInStages_none?: InputMaybe<SubTabWhereStageInput>;
  documentInStages_some?: InputMaybe<SubTabWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabs_every?: InputMaybe<SubTabContentWhereInput>;
  subTabs_none?: InputMaybe<SubTabContentWhereInput>;
  subTabs_some?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SubTabOrderByInput {
  cmsTabTitle_ASC = 'cmsTabTitle_ASC',
  cmsTabTitle_DESC = 'cmsTabTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SubTabUpdateInput = {
  cmsTabTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  subTabs?: InputMaybe<SubTabContentUpdateManyInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type SubTabUpdateManyInlineInput = {
  /** Connect multiple existing SubTab documents */
  connect?: InputMaybe<Array<SubTabConnectInput>>;
  /** Create and connect multiple SubTab documents */
  create?: InputMaybe<Array<SubTabCreateInput>>;
  /** Delete multiple SubTab documents */
  delete?: InputMaybe<Array<SubTabWhereUniqueInput>>;
  /** Disconnect multiple SubTab documents */
  disconnect?: InputMaybe<Array<SubTabWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SubTab documents */
  set?: InputMaybe<Array<SubTabWhereUniqueInput>>;
  /** Update multiple SubTab documents */
  update?: InputMaybe<Array<SubTabUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SubTab documents */
  upsert?: InputMaybe<Array<SubTabUpsertWithNestedWhereUniqueInput>>;
};

export type SubTabUpdateManyInput = {
  cmsTabTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
};

export type SubTabUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SubTabUpdateManyInput;
  /** Document search */
  where: SubTabWhereInput;
};

export type SubTabUpdateOneInlineInput = {
  /** Connect existing SubTab document */
  connect?: InputMaybe<SubTabWhereUniqueInput>;
  /** Create and connect one SubTab document */
  create?: InputMaybe<SubTabCreateInput>;
  /** Delete currently connected SubTab document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SubTab document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SubTab document */
  update?: InputMaybe<SubTabUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SubTab document */
  upsert?: InputMaybe<SubTabUpsertWithNestedWhereUniqueInput>;
};

export type SubTabUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SubTabUpdateInput;
  /** Unique document search */
  where: SubTabWhereUniqueInput;
};

export type SubTabUpsertInput = {
  /** Create document if it didn't exist */
  create: SubTabCreateInput;
  /** Update document if it exists */
  update: SubTabUpdateInput;
};

export type SubTabUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SubTabUpsertInput;
  /** Unique document search */
  where: SubTabWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SubTabWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SubTabWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SubTabWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SubTabWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SubTabWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTabTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTabTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTabTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTabTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTabTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTabTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTabTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTabTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTabTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTabTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SubTabWhereStageInput>;
  documentInStages_none?: InputMaybe<SubTabWhereStageInput>;
  documentInStages_some?: InputMaybe<SubTabWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subTabs_every?: InputMaybe<SubTabContentWhereInput>;
  subTabs_none?: InputMaybe<SubTabContentWhereInput>;
  subTabs_some?: InputMaybe<SubTabContentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SubTabWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SubTabWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SubTabWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SubTabWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SubTabWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SubTab record uniquely */
export type SubTabWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Banner for sustainability teaser information */
export type SustainabilityBanner = Entity & Node & {
  __typename?: 'SustainabilityBanner';
  anchorNav?: Maybe<AnchorNavigation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<SustainabilityBanner>;
  /** List of SustainabilityBanner versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  lowerRightCorner?: Maybe<AssetComponent>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  superText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  upperLeftCorner?: Maybe<AssetComponent>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerLowerRightCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerUpperLeftCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SustainabilityBannerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SustainabilityBannerWhereUniqueInput;
};

/** A connection to a list of items. */
export type SustainabilityBannerConnection = {
  __typename?: 'SustainabilityBannerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SustainabilityBannerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SustainabilityBannerCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cksu3qe635toj01yuaqg99qky?: InputMaybe<RecipeCreateManyInlineInput>;
  cktby1ql611f501z7g4f27jd7?: InputMaybe<TipsAndTricksDetailsPageCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  lowerRightCorner?: InputMaybe<AssetComponentCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  upperLeftCorner?: InputMaybe<AssetComponentCreateOneInlineInput>;
};

export type SustainabilityBannerCreateManyInlineInput = {
  /** Connect multiple existing SustainabilityBanner documents */
  connect?: InputMaybe<Array<SustainabilityBannerWhereUniqueInput>>;
  /** Create and connect multiple existing SustainabilityBanner documents */
  create?: InputMaybe<Array<SustainabilityBannerCreateInput>>;
};

export type SustainabilityBannerCreateOneInlineInput = {
  /** Connect one existing SustainabilityBanner document */
  connect?: InputMaybe<SustainabilityBannerWhereUniqueInput>;
  /** Create and connect one SustainabilityBanner document */
  create?: InputMaybe<SustainabilityBannerCreateInput>;
};

/** An edge in a connection. */
export type SustainabilityBannerEdge = {
  __typename?: 'SustainabilityBannerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SustainabilityBanner;
};

/** Identifies documents */
export type SustainabilityBannerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SustainabilityBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SustainabilityBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SustainabilityBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<SustainabilityBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<SustainabilityBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<SustainabilityBannerWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  lowerRightCorner?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upperLeftCorner?: InputMaybe<AssetComponentWhereInput>;
};

export enum SustainabilityBannerOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SustainabilityBannerUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cksu3qe635toj01yuaqg99qky?: InputMaybe<RecipeUpdateManyInlineInput>;
  cktby1ql611f501z7g4f27jd7?: InputMaybe<TipsAndTricksDetailsPageUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  lowerRightCorner?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  upperLeftCorner?: InputMaybe<AssetComponentUpdateOneInlineInput>;
};

export type SustainabilityBannerUpdateManyInlineInput = {
  /** Connect multiple existing SustainabilityBanner documents */
  connect?: InputMaybe<Array<SustainabilityBannerConnectInput>>;
  /** Create and connect multiple SustainabilityBanner documents */
  create?: InputMaybe<Array<SustainabilityBannerCreateInput>>;
  /** Delete multiple SustainabilityBanner documents */
  delete?: InputMaybe<Array<SustainabilityBannerWhereUniqueInput>>;
  /** Disconnect multiple SustainabilityBanner documents */
  disconnect?: InputMaybe<Array<SustainabilityBannerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SustainabilityBanner documents */
  set?: InputMaybe<Array<SustainabilityBannerWhereUniqueInput>>;
  /** Update multiple SustainabilityBanner documents */
  update?: InputMaybe<Array<SustainabilityBannerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SustainabilityBanner documents */
  upsert?: InputMaybe<Array<SustainabilityBannerUpsertWithNestedWhereUniqueInput>>;
};

export type SustainabilityBannerUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SustainabilityBannerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SustainabilityBannerUpdateManyInput;
  /** Document search */
  where: SustainabilityBannerWhereInput;
};

export type SustainabilityBannerUpdateOneInlineInput = {
  /** Connect existing SustainabilityBanner document */
  connect?: InputMaybe<SustainabilityBannerWhereUniqueInput>;
  /** Create and connect one SustainabilityBanner document */
  create?: InputMaybe<SustainabilityBannerCreateInput>;
  /** Delete currently connected SustainabilityBanner document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SustainabilityBanner document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SustainabilityBanner document */
  update?: InputMaybe<SustainabilityBannerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SustainabilityBanner document */
  upsert?: InputMaybe<SustainabilityBannerUpsertWithNestedWhereUniqueInput>;
};

export type SustainabilityBannerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SustainabilityBannerUpdateInput;
  /** Unique document search */
  where: SustainabilityBannerWhereUniqueInput;
};

export type SustainabilityBannerUpsertInput = {
  /** Create document if it didn't exist */
  create: SustainabilityBannerCreateInput;
  /** Update document if it exists */
  update: SustainabilityBannerUpdateInput;
};

export type SustainabilityBannerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SustainabilityBannerUpsertInput;
  /** Unique document search */
  where: SustainabilityBannerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SustainabilityBannerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SustainabilityBannerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SustainabilityBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SustainabilityBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SustainabilityBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<SustainabilityBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<SustainabilityBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<SustainabilityBannerWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  lowerRightCorner?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upperLeftCorner?: InputMaybe<AssetComponentWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SustainabilityBannerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SustainabilityBannerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SustainabilityBannerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SustainabilityBannerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SustainabilityBannerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SustainabilityBanner record uniquely */
export type SustainabilityBannerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfo = Entity & Node & {
  __typename?: 'SustainabilityInfo';
  /** This title is not displayed on the website; it is only used to identify this item within CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SustainabilityInfo>;
  /** List of SustainabilityInfo versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Ingredients heading */
  ingredientsTitle?: Maybe<Scalars['String']['output']>;
  lowerLeftCorner?: Maybe<AssetComponent>;
  lowerRightCorner?: Maybe<AssetComponent>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** Packaging header */
  packagingTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Superscript heading */
  superHeading?: Maybe<Scalars['String']['output']>;
  /** Main heading */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  upperLeftCorner?: Maybe<AssetComponent>;
  upperRightCorner?: Maybe<AssetComponent>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoLowerLeftCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoLowerRightCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoUpperLeftCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoUpperRightCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SustainabilityInfoConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SustainabilityInfoWhereUniqueInput;
};

/** A connection to a list of items. */
export type SustainabilityInfoConnection = {
  __typename?: 'SustainabilityInfoConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SustainabilityInfoEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SustainabilityInfoCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ingredientsTitle?: InputMaybe<Scalars['String']['input']>;
  lowerLeftCorner?: InputMaybe<AssetComponentCreateOneInlineInput>;
  lowerRightCorner?: InputMaybe<AssetComponentCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  packagingTitle?: InputMaybe<Scalars['String']['input']>;
  superHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  upperLeftCorner?: InputMaybe<AssetComponentCreateOneInlineInput>;
  upperRightCorner?: InputMaybe<AssetComponentCreateOneInlineInput>;
};

export type SustainabilityInfoCreateManyInlineInput = {
  /** Connect multiple existing SustainabilityInfo documents */
  connect?: InputMaybe<Array<SustainabilityInfoWhereUniqueInput>>;
  /** Create and connect multiple existing SustainabilityInfo documents */
  create?: InputMaybe<Array<SustainabilityInfoCreateInput>>;
};

export type SustainabilityInfoCreateOneInlineInput = {
  /** Connect one existing SustainabilityInfo document */
  connect?: InputMaybe<SustainabilityInfoWhereUniqueInput>;
  /** Create and connect one SustainabilityInfo document */
  create?: InputMaybe<SustainabilityInfoCreateInput>;
};

/** An edge in a connection. */
export type SustainabilityInfoEdge = {
  __typename?: 'SustainabilityInfoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SustainabilityInfo;
};

/** Identifies documents */
export type SustainabilityInfoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SustainabilityInfoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SustainabilityInfoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SustainabilityInfoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SustainabilityInfoWhereStageInput>;
  documentInStages_none?: InputMaybe<SustainabilityInfoWhereStageInput>;
  documentInStages_some?: InputMaybe<SustainabilityInfoWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  ingredientsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ingredientsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ingredientsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ingredientsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ingredientsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ingredientsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ingredientsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ingredientsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ingredientsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ingredientsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  lowerLeftCorner?: InputMaybe<AssetComponentWhereInput>;
  lowerRightCorner?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  packagingTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  packagingTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  packagingTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  packagingTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  packagingTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  packagingTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  packagingTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  packagingTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  packagingTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  packagingTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upperLeftCorner?: InputMaybe<AssetComponentWhereInput>;
  upperRightCorner?: InputMaybe<AssetComponentWhereInput>;
};

export enum SustainabilityInfoOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  ingredientsTitle_ASC = 'ingredientsTitle_ASC',
  ingredientsTitle_DESC = 'ingredientsTitle_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  packagingTitle_ASC = 'packagingTitle_ASC',
  packagingTitle_DESC = 'packagingTitle_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superHeading_ASC = 'superHeading_ASC',
  superHeading_DESC = 'superHeading_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SustainabilityInfoUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  ingredientsTitle?: InputMaybe<Scalars['String']['input']>;
  lowerLeftCorner?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  lowerRightCorner?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  packagingTitle?: InputMaybe<Scalars['String']['input']>;
  superHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  upperLeftCorner?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  upperRightCorner?: InputMaybe<AssetComponentUpdateOneInlineInput>;
};

export type SustainabilityInfoUpdateManyInlineInput = {
  /** Connect multiple existing SustainabilityInfo documents */
  connect?: InputMaybe<Array<SustainabilityInfoConnectInput>>;
  /** Create and connect multiple SustainabilityInfo documents */
  create?: InputMaybe<Array<SustainabilityInfoCreateInput>>;
  /** Delete multiple SustainabilityInfo documents */
  delete?: InputMaybe<Array<SustainabilityInfoWhereUniqueInput>>;
  /** Disconnect multiple SustainabilityInfo documents */
  disconnect?: InputMaybe<Array<SustainabilityInfoWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SustainabilityInfo documents */
  set?: InputMaybe<Array<SustainabilityInfoWhereUniqueInput>>;
  /** Update multiple SustainabilityInfo documents */
  update?: InputMaybe<Array<SustainabilityInfoUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SustainabilityInfo documents */
  upsert?: InputMaybe<Array<SustainabilityInfoUpsertWithNestedWhereUniqueInput>>;
};

export type SustainabilityInfoUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  ingredientsTitle?: InputMaybe<Scalars['String']['input']>;
  packagingTitle?: InputMaybe<Scalars['String']['input']>;
  superHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SustainabilityInfoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SustainabilityInfoUpdateManyInput;
  /** Document search */
  where: SustainabilityInfoWhereInput;
};

export type SustainabilityInfoUpdateOneInlineInput = {
  /** Connect existing SustainabilityInfo document */
  connect?: InputMaybe<SustainabilityInfoWhereUniqueInput>;
  /** Create and connect one SustainabilityInfo document */
  create?: InputMaybe<SustainabilityInfoCreateInput>;
  /** Delete currently connected SustainabilityInfo document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SustainabilityInfo document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SustainabilityInfo document */
  update?: InputMaybe<SustainabilityInfoUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SustainabilityInfo document */
  upsert?: InputMaybe<SustainabilityInfoUpsertWithNestedWhereUniqueInput>;
};

export type SustainabilityInfoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SustainabilityInfoUpdateInput;
  /** Unique document search */
  where: SustainabilityInfoWhereUniqueInput;
};

export type SustainabilityInfoUpsertInput = {
  /** Create document if it didn't exist */
  create: SustainabilityInfoCreateInput;
  /** Update document if it exists */
  update: SustainabilityInfoUpdateInput;
};

export type SustainabilityInfoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SustainabilityInfoUpsertInput;
  /** Unique document search */
  where: SustainabilityInfoWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SustainabilityInfoWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SustainabilityInfoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SustainabilityInfoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SustainabilityInfoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SustainabilityInfoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SustainabilityInfoWhereStageInput>;
  documentInStages_none?: InputMaybe<SustainabilityInfoWhereStageInput>;
  documentInStages_some?: InputMaybe<SustainabilityInfoWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  ingredientsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ingredientsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ingredientsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ingredientsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ingredientsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ingredientsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ingredientsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ingredientsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ingredientsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ingredientsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  lowerLeftCorner?: InputMaybe<AssetComponentWhereInput>;
  lowerRightCorner?: InputMaybe<AssetComponentWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  packagingTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  packagingTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  packagingTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  packagingTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  packagingTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  packagingTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  packagingTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  packagingTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  packagingTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  packagingTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upperLeftCorner?: InputMaybe<AssetComponentWhereInput>;
  upperRightCorner?: InputMaybe<AssetComponentWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SustainabilityInfoWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SustainabilityInfoWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SustainabilityInfoWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SustainabilityInfoWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SustainabilityInfoWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SustainabilityInfo record uniquely */
export type SustainabilityInfoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
};

export enum SystemDateTimeFieldVariation {
  BASE = 'BASE',
  COMBINED = 'COMBINED',
  LOCALIZATION = 'LOCALIZATION'
}

/** A collection of tabs that can be rendered on screen. */
export type Tab = Entity & Node & {
  __typename?: 'Tab';
  /** A title to uniquely identify the name of collection of different tabs based on the usage. */
  cmsTabTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Tab>;
  genericPages: Array<GenericPage>;
  /** List of Tab versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Contains tabs that can come. */
  tabs: Array<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabTabsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TabContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabContentWhereInput>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TabConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TabWhereUniqueInput;
};

/** A connection to a list of items. */
export type TabConnection = {
  __typename?: 'TabConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TabEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContent = Entity & Node & {
  __typename?: 'TabContent';
  /** list of components that can be held by a particular tab. */
  components: Array<TabContentComponents>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<TabContent>;
  /** List of TabContent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Name of the tab, this is the clickable element which will open the components held by a particular tab. */
  tabTitle: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TabContentComponents = AuthorableContentCard | Banner1 | Banner2 | Banner2CarouselComponent | CardComponent | CarouselComponent | DynamicCardGrid | EvalancheFormComponent | Form | GenericAccordion | GenericAccordionTopRated | GenericCardCarouseComponent | GenericDownloadComponent | GenericFollowUs | GenericHtml | GenericLine | GridColumn | GridColumnComponent | HeroCarouselComponent | Iframe | ImageCopy | IntroText | Link | LongText | ProductBanner | SocialMediaListComponent | SubTab;

export type TabContentComponentsConnectInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardConnectInput>;
  Banner1?: InputMaybe<Banner1ConnectInput>;
  Banner2?: InputMaybe<Banner2ConnectInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentConnectInput>;
  CardComponent?: InputMaybe<CardComponentConnectInput>;
  CarouselComponent?: InputMaybe<CarouselComponentConnectInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridConnectInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentConnectInput>;
  Form?: InputMaybe<FormConnectInput>;
  GenericAccordion?: InputMaybe<GenericAccordionConnectInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedConnectInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentConnectInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentConnectInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsConnectInput>;
  GenericHtml?: InputMaybe<GenericHtmlConnectInput>;
  GenericLine?: InputMaybe<GenericLineConnectInput>;
  GridColumn?: InputMaybe<GridColumnConnectInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentConnectInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentConnectInput>;
  Iframe?: InputMaybe<IframeConnectInput>;
  ImageCopy?: InputMaybe<ImageCopyConnectInput>;
  IntroText?: InputMaybe<IntroTextConnectInput>;
  Link?: InputMaybe<LinkConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
  ProductBanner?: InputMaybe<ProductBannerConnectInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentConnectInput>;
  SubTab?: InputMaybe<SubTabConnectInput>;
};

export type TabContentComponentsCreateInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardCreateInput>;
  Banner1?: InputMaybe<Banner1CreateInput>;
  Banner2?: InputMaybe<Banner2CreateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentCreateInput>;
  CardComponent?: InputMaybe<CardComponentCreateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentCreateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridCreateInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentCreateInput>;
  Form?: InputMaybe<FormCreateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionCreateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedCreateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentCreateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsCreateInput>;
  GenericHtml?: InputMaybe<GenericHtmlCreateInput>;
  GenericLine?: InputMaybe<GenericLineCreateInput>;
  GridColumn?: InputMaybe<GridColumnCreateInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentCreateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateInput>;
  Iframe?: InputMaybe<IframeCreateInput>;
  ImageCopy?: InputMaybe<ImageCopyCreateInput>;
  IntroText?: InputMaybe<IntroTextCreateInput>;
  Link?: InputMaybe<LinkCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
  ProductBanner?: InputMaybe<ProductBannerCreateInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentCreateInput>;
  SubTab?: InputMaybe<SubTabCreateInput>;
};

export type TabContentComponentsCreateManyInlineInput = {
  /** Connect multiple existing TabContentComponents documents */
  connect?: InputMaybe<Array<TabContentComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing TabContentComponents documents */
  create?: InputMaybe<Array<TabContentComponentsCreateInput>>;
};

export type TabContentComponentsCreateOneInlineInput = {
  /** Connect one existing TabContentComponents document */
  connect?: InputMaybe<TabContentComponentsWhereUniqueInput>;
  /** Create and connect one TabContentComponents document */
  create?: InputMaybe<TabContentComponentsCreateInput>;
};

export type TabContentComponentsUpdateInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateInput>;
  Banner1?: InputMaybe<Banner1UpdateInput>;
  Banner2?: InputMaybe<Banner2UpdateInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateInput>;
  CardComponent?: InputMaybe<CardComponentUpdateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateInput>;
  Form?: InputMaybe<FormUpdateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateInput>;
  GenericLine?: InputMaybe<GenericLineUpdateInput>;
  GridColumn?: InputMaybe<GridColumnUpdateInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentUpdateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateInput>;
  Iframe?: InputMaybe<IframeUpdateInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateInput>;
  IntroText?: InputMaybe<IntroTextUpdateInput>;
  Link?: InputMaybe<LinkUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateInput>;
  SubTab?: InputMaybe<SubTabUpdateInput>;
};

export type TabContentComponentsUpdateManyInlineInput = {
  /** Connect multiple existing TabContentComponents documents */
  connect?: InputMaybe<Array<TabContentComponentsConnectInput>>;
  /** Create and connect multiple TabContentComponents documents */
  create?: InputMaybe<Array<TabContentComponentsCreateInput>>;
  /** Delete multiple TabContentComponents documents */
  delete?: InputMaybe<Array<TabContentComponentsWhereUniqueInput>>;
  /** Disconnect multiple TabContentComponents documents */
  disconnect?: InputMaybe<Array<TabContentComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TabContentComponents documents */
  set?: InputMaybe<Array<TabContentComponentsWhereUniqueInput>>;
  /** Update multiple TabContentComponents documents */
  update?: InputMaybe<Array<TabContentComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TabContentComponents documents */
  upsert?: InputMaybe<Array<TabContentComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type TabContentComponentsUpdateManyWithNestedWhereInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateManyWithNestedWhereInput>;
  Banner1?: InputMaybe<Banner1UpdateManyWithNestedWhereInput>;
  Banner2?: InputMaybe<Banner2UpdateManyWithNestedWhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateManyWithNestedWhereInput>;
  CardComponent?: InputMaybe<CardComponentUpdateManyWithNestedWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateManyWithNestedWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateManyWithNestedWhereInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateManyWithNestedWhereInput>;
  Form?: InputMaybe<FormUpdateManyWithNestedWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateManyWithNestedWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateManyWithNestedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateManyWithNestedWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateManyWithNestedWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateManyWithNestedWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateManyWithNestedWhereInput>;
  GenericLine?: InputMaybe<GenericLineUpdateManyWithNestedWhereInput>;
  GridColumn?: InputMaybe<GridColumnUpdateManyWithNestedWhereInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentUpdateManyWithNestedWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateManyWithNestedWhereInput>;
  Iframe?: InputMaybe<IframeUpdateManyWithNestedWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateManyWithNestedWhereInput>;
  IntroText?: InputMaybe<IntroTextUpdateManyWithNestedWhereInput>;
  Link?: InputMaybe<LinkUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateManyWithNestedWhereInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateManyWithNestedWhereInput>;
  SubTab?: InputMaybe<SubTabUpdateManyWithNestedWhereInput>;
};

export type TabContentComponentsUpdateOneInlineInput = {
  /** Connect existing TabContentComponents document */
  connect?: InputMaybe<TabContentComponentsWhereUniqueInput>;
  /** Create and connect one TabContentComponents document */
  create?: InputMaybe<TabContentComponentsCreateInput>;
  /** Delete currently connected TabContentComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TabContentComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TabContentComponents document */
  update?: InputMaybe<TabContentComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TabContentComponents document */
  upsert?: InputMaybe<TabContentComponentsUpsertWithNestedWhereUniqueInput>;
};

export type TabContentComponentsUpdateWithNestedWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpdateWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpdateWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpdateWithNestedWhereUniqueInput>;
  CardComponent?: InputMaybe<CardComponentUpdateWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateWithNestedWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateWithNestedWhereUniqueInput>;
  Form?: InputMaybe<FormUpdateWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpdateWithNestedWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineUpdateWithNestedWhereUniqueInput>;
  GridColumn?: InputMaybe<GridColumnUpdateWithNestedWhereUniqueInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentUpdateWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpdateWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpdateWithNestedWhereUniqueInput>;
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpdateWithNestedWhereUniqueInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateWithNestedWhereUniqueInput>;
  SubTab?: InputMaybe<SubTabUpdateWithNestedWhereUniqueInput>;
};

export type TabContentComponentsUpsertWithNestedWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpsertWithNestedWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1UpsertWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpsertWithNestedWhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentUpsertWithNestedWhereUniqueInput>;
  CardComponent?: InputMaybe<CardComponentUpsertWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpsertWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpsertWithNestedWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpsertWithNestedWhereUniqueInput>;
  Form?: InputMaybe<FormUpsertWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpsertWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpsertWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpsertWithNestedWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlUpsertWithNestedWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineUpsertWithNestedWhereUniqueInput>;
  GridColumn?: InputMaybe<GridColumnUpsertWithNestedWhereUniqueInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentUpsertWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpsertWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpsertWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpsertWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpsertWithNestedWhereUniqueInput>;
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerUpsertWithNestedWhereUniqueInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpsertWithNestedWhereUniqueInput>;
  SubTab?: InputMaybe<SubTabUpsertWithNestedWhereUniqueInput>;
};

export type TabContentComponentsWhereInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereInput>;
  Banner1?: InputMaybe<Banner1WhereInput>;
  Banner2?: InputMaybe<Banner2WhereInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereInput>;
  CardComponent?: InputMaybe<CardComponentWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentWhereInput>;
  Form?: InputMaybe<FormWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereInput>;
  GenericLine?: InputMaybe<GenericLineWhereInput>;
  GridColumn?: InputMaybe<GridColumnWhereInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  Iframe?: InputMaybe<IframeWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereInput>;
  IntroText?: InputMaybe<IntroTextWhereInput>;
  Link?: InputMaybe<LinkWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentWhereInput>;
  SubTab?: InputMaybe<SubTabWhereInput>;
};

export type TabContentComponentsWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereUniqueInput>;
  Banner1?: InputMaybe<Banner1WhereUniqueInput>;
  Banner2?: InputMaybe<Banner2WhereUniqueInput>;
  Banner2CarouselComponent?: InputMaybe<Banner2CarouselComponentWhereUniqueInput>;
  CardComponent?: InputMaybe<CardComponentWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentWhereUniqueInput>;
  Form?: InputMaybe<FormWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereUniqueInput>;
  GenericHtml?: InputMaybe<GenericHtmlWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineWhereUniqueInput>;
  GridColumn?: InputMaybe<GridColumnWhereUniqueInput>;
  GridColumnComponent?: InputMaybe<GridColumnComponentWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereUniqueInput>;
  Iframe?: InputMaybe<IframeWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextWhereUniqueInput>;
  Link?: InputMaybe<LinkWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
  ProductBanner?: InputMaybe<ProductBannerWhereUniqueInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentWhereUniqueInput>;
  SubTab?: InputMaybe<SubTabWhereUniqueInput>;
};

export type TabContentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TabContentWhereUniqueInput;
};

/** A connection to a list of items. */
export type TabContentConnection = {
  __typename?: 'TabContentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TabContentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TabContentCreateInput = {
  cksful2sa0yka01z2e9hsh1fp?: InputMaybe<TabCreateManyInlineInput>;
  components?: InputMaybe<TabContentComponentsCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  tabTitle: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TabContentCreateManyInlineInput = {
  /** Connect multiple existing TabContent documents */
  connect?: InputMaybe<Array<TabContentWhereUniqueInput>>;
  /** Create and connect multiple existing TabContent documents */
  create?: InputMaybe<Array<TabContentCreateInput>>;
};

export type TabContentCreateOneInlineInput = {
  /** Connect one existing TabContent document */
  connect?: InputMaybe<TabContentWhereUniqueInput>;
  /** Create and connect one TabContent document */
  create?: InputMaybe<TabContentCreateInput>;
};

/** An edge in a connection. */
export type TabContentEdge = {
  __typename?: 'TabContentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TabContent;
};

/** Identifies documents */
export type TabContentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TabContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TabContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TabContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  components_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  components_some?: InputMaybe<TabContentComponentsWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TabContentWhereStageInput>;
  documentInStages_none?: InputMaybe<TabContentWhereStageInput>;
  documentInStages_some?: InputMaybe<TabContentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tabTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tabTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tabTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tabTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tabTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tabTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tabTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tabTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tabTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TabContentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  tabTitle_ASC = 'tabTitle_ASC',
  tabTitle_DESC = 'tabTitle_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TabContentUpdateInput = {
  cksful2sa0yka01z2e9hsh1fp?: InputMaybe<TabUpdateManyInlineInput>;
  components?: InputMaybe<TabContentComponentsUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  tabTitle?: InputMaybe<Scalars['String']['input']>;
};

export type TabContentUpdateManyInlineInput = {
  /** Connect multiple existing TabContent documents */
  connect?: InputMaybe<Array<TabContentConnectInput>>;
  /** Create and connect multiple TabContent documents */
  create?: InputMaybe<Array<TabContentCreateInput>>;
  /** Delete multiple TabContent documents */
  delete?: InputMaybe<Array<TabContentWhereUniqueInput>>;
  /** Disconnect multiple TabContent documents */
  disconnect?: InputMaybe<Array<TabContentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TabContent documents */
  set?: InputMaybe<Array<TabContentWhereUniqueInput>>;
  /** Update multiple TabContent documents */
  update?: InputMaybe<Array<TabContentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TabContent documents */
  upsert?: InputMaybe<Array<TabContentUpsertWithNestedWhereUniqueInput>>;
};

export type TabContentUpdateManyInput = {
  market?: InputMaybe<Markets>;
  tabTitle?: InputMaybe<Scalars['String']['input']>;
};

export type TabContentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TabContentUpdateManyInput;
  /** Document search */
  where: TabContentWhereInput;
};

export type TabContentUpdateOneInlineInput = {
  /** Connect existing TabContent document */
  connect?: InputMaybe<TabContentWhereUniqueInput>;
  /** Create and connect one TabContent document */
  create?: InputMaybe<TabContentCreateInput>;
  /** Delete currently connected TabContent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TabContent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TabContent document */
  update?: InputMaybe<TabContentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TabContent document */
  upsert?: InputMaybe<TabContentUpsertWithNestedWhereUniqueInput>;
};

export type TabContentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TabContentUpdateInput;
  /** Unique document search */
  where: TabContentWhereUniqueInput;
};

export type TabContentUpsertInput = {
  /** Create document if it didn't exist */
  create: TabContentCreateInput;
  /** Update document if it exists */
  update: TabContentUpdateInput;
};

export type TabContentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TabContentUpsertInput;
  /** Unique document search */
  where: TabContentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TabContentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TabContentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TabContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TabContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TabContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  components_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  components_some?: InputMaybe<TabContentComponentsWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TabContentWhereStageInput>;
  documentInStages_none?: InputMaybe<TabContentWhereStageInput>;
  documentInStages_some?: InputMaybe<TabContentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tabTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tabTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tabTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tabTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tabTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tabTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tabTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tabTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tabTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TabContentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TabContentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TabContentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TabContentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TabContentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TabContent record uniquely */
export type TabContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TabCreateInput = {
  cmsTabTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  tabs?: InputMaybe<TabContentCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TabCreateManyInlineInput = {
  /** Connect multiple existing Tab documents */
  connect?: InputMaybe<Array<TabWhereUniqueInput>>;
  /** Create and connect multiple existing Tab documents */
  create?: InputMaybe<Array<TabCreateInput>>;
};

export type TabCreateOneInlineInput = {
  /** Connect one existing Tab document */
  connect?: InputMaybe<TabWhereUniqueInput>;
  /** Create and connect one Tab document */
  create?: InputMaybe<TabCreateInput>;
};

/** An edge in a connection. */
export type TabEdge = {
  __typename?: 'TabEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Tab;
};

/** Identifies documents */
export type TabManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TabWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TabWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TabWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTabTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTabTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTabTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTabTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTabTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTabTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTabTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTabTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTabTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTabTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TabWhereStageInput>;
  documentInStages_none?: InputMaybe<TabWhereStageInput>;
  documentInStages_some?: InputMaybe<TabWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabs_every?: InputMaybe<TabContentWhereInput>;
  tabs_none?: InputMaybe<TabContentWhereInput>;
  tabs_some?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TabOrderByInput {
  cmsTabTitle_ASC = 'cmsTabTitle_ASC',
  cmsTabTitle_DESC = 'cmsTabTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TabUpdateInput = {
  cmsTabTitle?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  tabs?: InputMaybe<TabContentUpdateManyInlineInput>;
};

export type TabUpdateManyInlineInput = {
  /** Connect multiple existing Tab documents */
  connect?: InputMaybe<Array<TabConnectInput>>;
  /** Create and connect multiple Tab documents */
  create?: InputMaybe<Array<TabCreateInput>>;
  /** Delete multiple Tab documents */
  delete?: InputMaybe<Array<TabWhereUniqueInput>>;
  /** Disconnect multiple Tab documents */
  disconnect?: InputMaybe<Array<TabWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Tab documents */
  set?: InputMaybe<Array<TabWhereUniqueInput>>;
  /** Update multiple Tab documents */
  update?: InputMaybe<Array<TabUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Tab documents */
  upsert?: InputMaybe<Array<TabUpsertWithNestedWhereUniqueInput>>;
};

export type TabUpdateManyInput = {
  cmsTabTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
};

export type TabUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TabUpdateManyInput;
  /** Document search */
  where: TabWhereInput;
};

export type TabUpdateOneInlineInput = {
  /** Connect existing Tab document */
  connect?: InputMaybe<TabWhereUniqueInput>;
  /** Create and connect one Tab document */
  create?: InputMaybe<TabCreateInput>;
  /** Delete currently connected Tab document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Tab document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Tab document */
  update?: InputMaybe<TabUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Tab document */
  upsert?: InputMaybe<TabUpsertWithNestedWhereUniqueInput>;
};

export type TabUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TabUpdateInput;
  /** Unique document search */
  where: TabWhereUniqueInput;
};

export type TabUpsertInput = {
  /** Create document if it didn't exist */
  create: TabCreateInput;
  /** Update document if it exists */
  update: TabUpdateInput;
};

export type TabUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TabUpsertInput;
  /** Unique document search */
  where: TabWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TabWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TabWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TabWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TabWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TabWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTabTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTabTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTabTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTabTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTabTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTabTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTabTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTabTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTabTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTabTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TabWhereStageInput>;
  documentInStages_none?: InputMaybe<TabWhereStageInput>;
  documentInStages_some?: InputMaybe<TabWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabs_every?: InputMaybe<TabContentWhereInput>;
  tabs_none?: InputMaybe<TabContentWhereInput>;
  tabs_some?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TabWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TabWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TabWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TabWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TabWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Tab record uniquely */
export type TabWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Teaser = Entity & Node & {
  __typename?: 'Teaser';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<Teaser>;
  endDate: Scalars['DateTime']['output'];
  extension?: Maybe<AlgoliaExtension>;
  heading?: Maybe<Scalars['String']['output']>;
  /** List of Teaser versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<AssetComponent>;
  link?: Maybe<Link>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  startDate: Scalars['DateTime']['output'];
  teaserPlaceholders: Array<TeaserPlaceholder>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type TeaserCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeaserDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type TeaserExtensionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeaserHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type TeaserImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeaserLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeaserMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeaserPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeaserScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type TeaserTeaserPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TeaserPlaceholderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserPlaceholderWhereInput>;
};


export type TeaserUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TeaserConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TeaserWhereUniqueInput;
};

/** A connection to a list of items. */
export type TeaserConnection = {
  __typename?: 'TeaserConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TeaserEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TeaserCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  extension?: InputMaybe<AlgoliaExtensionCreateOneInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetComponentCreateOneInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  startDate: Scalars['DateTime']['input'];
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderCreateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeaserCreateManyInlineInput = {
  /** Connect multiple existing Teaser documents */
  connect?: InputMaybe<Array<TeaserWhereUniqueInput>>;
  /** Create and connect multiple existing Teaser documents */
  create?: InputMaybe<Array<TeaserCreateInput>>;
};

export type TeaserCreateOneInlineInput = {
  /** Connect one existing Teaser document */
  connect?: InputMaybe<TeaserWhereUniqueInput>;
  /** Create and connect one Teaser document */
  create?: InputMaybe<TeaserCreateInput>;
};

/** An edge in a connection. */
export type TeaserEdge = {
  __typename?: 'TeaserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Teaser;
};

/** Identifies documents */
export type TeaserManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TeaserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TeaserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TeaserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<TeaserWhereStageInput>;
  documentInStages_none?: InputMaybe<TeaserWhereStageInput>;
  documentInStages_some?: InputMaybe<TeaserWhereStageInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  endDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  endDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  extension?: InputMaybe<AlgoliaExtensionWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  startDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  startDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TeaserOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  endDate_ASC = 'endDate_ASC',
  endDate_DESC = 'endDate_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  startDate_ASC = 'startDate_ASC',
  startDate_DESC = 'startDate_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TeaserPlaceholder = Entity & Node & {
  __typename?: 'TeaserPlaceholder';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<TeaserPlaceholder>;
  /** List of TeaserPlaceholder versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  pages: Array<TeaserPlaceholderPages>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  teasers: Array<Teaser>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type TeaserPlaceholderCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeaserPlaceholderDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type TeaserPlaceholderHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type TeaserPlaceholderMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeaserPlaceholderPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TeaserPlaceholderPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeaserPlaceholderScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type TeaserPlaceholderTeasersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TeaserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserWhereInput>;
};


export type TeaserPlaceholderUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TeaserPlaceholderConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TeaserPlaceholderWhereUniqueInput;
};

/** A connection to a list of items. */
export type TeaserPlaceholderConnection = {
  __typename?: 'TeaserPlaceholderConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TeaserPlaceholderEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TeaserPlaceholderCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  pages?: InputMaybe<TeaserPlaceholderPagesCreateManyInlineInput>;
  teasers?: InputMaybe<TeaserCreateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeaserPlaceholderCreateManyInlineInput = {
  /** Connect multiple existing TeaserPlaceholder documents */
  connect?: InputMaybe<Array<TeaserPlaceholderWhereUniqueInput>>;
  /** Create and connect multiple existing TeaserPlaceholder documents */
  create?: InputMaybe<Array<TeaserPlaceholderCreateInput>>;
};

export type TeaserPlaceholderCreateOneInlineInput = {
  /** Connect one existing TeaserPlaceholder document */
  connect?: InputMaybe<TeaserPlaceholderWhereUniqueInput>;
  /** Create and connect one TeaserPlaceholder document */
  create?: InputMaybe<TeaserPlaceholderCreateInput>;
};

/** An edge in a connection. */
export type TeaserPlaceholderEdge = {
  __typename?: 'TeaserPlaceholderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TeaserPlaceholder;
};

/** Identifies documents */
export type TeaserPlaceholderManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TeaserPlaceholderWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TeaserPlaceholderWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TeaserPlaceholderWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TeaserPlaceholderWhereStageInput>;
  documentInStages_none?: InputMaybe<TeaserPlaceholderWhereStageInput>;
  documentInStages_some?: InputMaybe<TeaserPlaceholderWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** All values in which the union is empty */
  pages_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pages_some?: InputMaybe<TeaserPlaceholderPagesWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  teasers_every?: InputMaybe<TeaserWhereInput>;
  teasers_none?: InputMaybe<TeaserWhereInput>;
  teasers_some?: InputMaybe<TeaserWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TeaserPlaceholderOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TeaserPlaceholderPages = GenericPage | ProductCategoryPage | ProductDetailPage | ProductLandingPage | ProductSubcategoryPage | Recipe | RecipeCategory | RecipeLandingPage | RecipeSubcategory | SearchOverlayComponent;

export type TeaserPlaceholderPagesConnectInput = {
  GenericPage?: InputMaybe<GenericPageConnectInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageConnectInput>;
  ProductDetailPage?: InputMaybe<ProductDetailPageConnectInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageConnectInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageConnectInput>;
  Recipe?: InputMaybe<RecipeConnectInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryConnectInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageConnectInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryConnectInput>;
  SearchOverlayComponent?: InputMaybe<SearchOverlayComponentConnectInput>;
};

export type TeaserPlaceholderPagesCreateInput = {
  GenericPage?: InputMaybe<GenericPageCreateInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageCreateInput>;
  ProductDetailPage?: InputMaybe<ProductDetailPageCreateInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageCreateInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageCreateInput>;
  Recipe?: InputMaybe<RecipeCreateInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryCreateInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageCreateInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryCreateInput>;
  SearchOverlayComponent?: InputMaybe<SearchOverlayComponentCreateInput>;
};

export type TeaserPlaceholderPagesCreateManyInlineInput = {
  /** Connect multiple existing TeaserPlaceholderPages documents */
  connect?: InputMaybe<Array<TeaserPlaceholderPagesWhereUniqueInput>>;
  /** Create and connect multiple existing TeaserPlaceholderPages documents */
  create?: InputMaybe<Array<TeaserPlaceholderPagesCreateInput>>;
};

export type TeaserPlaceholderPagesCreateOneInlineInput = {
  /** Connect one existing TeaserPlaceholderPages document */
  connect?: InputMaybe<TeaserPlaceholderPagesWhereUniqueInput>;
  /** Create and connect one TeaserPlaceholderPages document */
  create?: InputMaybe<TeaserPlaceholderPagesCreateInput>;
};

export type TeaserPlaceholderPagesUpdateInput = {
  GenericPage?: InputMaybe<GenericPageUpdateInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageUpdateInput>;
  ProductDetailPage?: InputMaybe<ProductDetailPageUpdateInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageUpdateInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpdateInput>;
  Recipe?: InputMaybe<RecipeUpdateInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryUpdateInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageUpdateInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateInput>;
  SearchOverlayComponent?: InputMaybe<SearchOverlayComponentUpdateInput>;
};

export type TeaserPlaceholderPagesUpdateManyInlineInput = {
  /** Connect multiple existing TeaserPlaceholderPages documents */
  connect?: InputMaybe<Array<TeaserPlaceholderPagesConnectInput>>;
  /** Create and connect multiple TeaserPlaceholderPages documents */
  create?: InputMaybe<Array<TeaserPlaceholderPagesCreateInput>>;
  /** Delete multiple TeaserPlaceholderPages documents */
  delete?: InputMaybe<Array<TeaserPlaceholderPagesWhereUniqueInput>>;
  /** Disconnect multiple TeaserPlaceholderPages documents */
  disconnect?: InputMaybe<Array<TeaserPlaceholderPagesWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TeaserPlaceholderPages documents */
  set?: InputMaybe<Array<TeaserPlaceholderPagesWhereUniqueInput>>;
  /** Update multiple TeaserPlaceholderPages documents */
  update?: InputMaybe<Array<TeaserPlaceholderPagesUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TeaserPlaceholderPages documents */
  upsert?: InputMaybe<Array<TeaserPlaceholderPagesUpsertWithNestedWhereUniqueInput>>;
};

export type TeaserPlaceholderPagesUpdateManyWithNestedWhereInput = {
  GenericPage?: InputMaybe<GenericPageUpdateManyWithNestedWhereInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageUpdateManyWithNestedWhereInput>;
  ProductDetailPage?: InputMaybe<ProductDetailPageUpdateManyWithNestedWhereInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageUpdateManyWithNestedWhereInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpdateManyWithNestedWhereInput>;
  Recipe?: InputMaybe<RecipeUpdateManyWithNestedWhereInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryUpdateManyWithNestedWhereInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageUpdateManyWithNestedWhereInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateManyWithNestedWhereInput>;
  SearchOverlayComponent?: InputMaybe<SearchOverlayComponentUpdateManyWithNestedWhereInput>;
};

export type TeaserPlaceholderPagesUpdateOneInlineInput = {
  /** Connect existing TeaserPlaceholderPages document */
  connect?: InputMaybe<TeaserPlaceholderPagesWhereUniqueInput>;
  /** Create and connect one TeaserPlaceholderPages document */
  create?: InputMaybe<TeaserPlaceholderPagesCreateInput>;
  /** Delete currently connected TeaserPlaceholderPages document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TeaserPlaceholderPages document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TeaserPlaceholderPages document */
  update?: InputMaybe<TeaserPlaceholderPagesUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TeaserPlaceholderPages document */
  upsert?: InputMaybe<TeaserPlaceholderPagesUpsertWithNestedWhereUniqueInput>;
};

export type TeaserPlaceholderPagesUpdateWithNestedWhereUniqueInput = {
  GenericPage?: InputMaybe<GenericPageUpdateWithNestedWhereUniqueInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageUpdateWithNestedWhereUniqueInput>;
  ProductDetailPage?: InputMaybe<ProductDetailPageUpdateWithNestedWhereUniqueInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageUpdateWithNestedWhereUniqueInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpdateWithNestedWhereUniqueInput>;
  Recipe?: InputMaybe<RecipeUpdateWithNestedWhereUniqueInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryUpdateWithNestedWhereUniqueInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageUpdateWithNestedWhereUniqueInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateWithNestedWhereUniqueInput>;
  SearchOverlayComponent?: InputMaybe<SearchOverlayComponentUpdateWithNestedWhereUniqueInput>;
};

export type TeaserPlaceholderPagesUpsertWithNestedWhereUniqueInput = {
  GenericPage?: InputMaybe<GenericPageUpsertWithNestedWhereUniqueInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageUpsertWithNestedWhereUniqueInput>;
  ProductDetailPage?: InputMaybe<ProductDetailPageUpsertWithNestedWhereUniqueInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageUpsertWithNestedWhereUniqueInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpsertWithNestedWhereUniqueInput>;
  Recipe?: InputMaybe<RecipeUpsertWithNestedWhereUniqueInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryUpsertWithNestedWhereUniqueInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageUpsertWithNestedWhereUniqueInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpsertWithNestedWhereUniqueInput>;
  SearchOverlayComponent?: InputMaybe<SearchOverlayComponentUpsertWithNestedWhereUniqueInput>;
};

export type TeaserPlaceholderPagesWhereInput = {
  GenericPage?: InputMaybe<GenericPageWhereInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageWhereInput>;
  ProductDetailPage?: InputMaybe<ProductDetailPageWhereInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageWhereInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageWhereInput>;
  Recipe?: InputMaybe<RecipeWhereInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryWhereInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageWhereInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryWhereInput>;
  SearchOverlayComponent?: InputMaybe<SearchOverlayComponentWhereInput>;
};

export type TeaserPlaceholderPagesWhereUniqueInput = {
  GenericPage?: InputMaybe<GenericPageWhereUniqueInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageWhereUniqueInput>;
  ProductDetailPage?: InputMaybe<ProductDetailPageWhereUniqueInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageWhereUniqueInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageWhereUniqueInput>;
  Recipe?: InputMaybe<RecipeWhereUniqueInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryWhereUniqueInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageWhereUniqueInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryWhereUniqueInput>;
  SearchOverlayComponent?: InputMaybe<SearchOverlayComponentWhereUniqueInput>;
};

export type TeaserPlaceholderUpdateInput = {
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  pages?: InputMaybe<TeaserPlaceholderPagesUpdateManyInlineInput>;
  teasers?: InputMaybe<TeaserUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TeaserPlaceholderUpdateManyInlineInput = {
  /** Connect multiple existing TeaserPlaceholder documents */
  connect?: InputMaybe<Array<TeaserPlaceholderConnectInput>>;
  /** Create and connect multiple TeaserPlaceholder documents */
  create?: InputMaybe<Array<TeaserPlaceholderCreateInput>>;
  /** Delete multiple TeaserPlaceholder documents */
  delete?: InputMaybe<Array<TeaserPlaceholderWhereUniqueInput>>;
  /** Disconnect multiple TeaserPlaceholder documents */
  disconnect?: InputMaybe<Array<TeaserPlaceholderWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TeaserPlaceholder documents */
  set?: InputMaybe<Array<TeaserPlaceholderWhereUniqueInput>>;
  /** Update multiple TeaserPlaceholder documents */
  update?: InputMaybe<Array<TeaserPlaceholderUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TeaserPlaceholder documents */
  upsert?: InputMaybe<Array<TeaserPlaceholderUpsertWithNestedWhereUniqueInput>>;
};

export type TeaserPlaceholderUpdateManyInput = {
  market?: InputMaybe<Markets>;
};

export type TeaserPlaceholderUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TeaserPlaceholderUpdateManyInput;
  /** Document search */
  where: TeaserPlaceholderWhereInput;
};

export type TeaserPlaceholderUpdateOneInlineInput = {
  /** Connect existing TeaserPlaceholder document */
  connect?: InputMaybe<TeaserPlaceholderWhereUniqueInput>;
  /** Create and connect one TeaserPlaceholder document */
  create?: InputMaybe<TeaserPlaceholderCreateInput>;
  /** Delete currently connected TeaserPlaceholder document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TeaserPlaceholder document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TeaserPlaceholder document */
  update?: InputMaybe<TeaserPlaceholderUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TeaserPlaceholder document */
  upsert?: InputMaybe<TeaserPlaceholderUpsertWithNestedWhereUniqueInput>;
};

export type TeaserPlaceholderUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TeaserPlaceholderUpdateInput;
  /** Unique document search */
  where: TeaserPlaceholderWhereUniqueInput;
};

export type TeaserPlaceholderUpsertInput = {
  /** Create document if it didn't exist */
  create: TeaserPlaceholderCreateInput;
  /** Update document if it exists */
  update: TeaserPlaceholderUpdateInput;
};

export type TeaserPlaceholderUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TeaserPlaceholderUpsertInput;
  /** Unique document search */
  where: TeaserPlaceholderWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TeaserPlaceholderWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TeaserPlaceholderWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TeaserPlaceholderWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TeaserPlaceholderWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TeaserPlaceholderWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TeaserPlaceholderWhereStageInput>;
  documentInStages_none?: InputMaybe<TeaserPlaceholderWhereStageInput>;
  documentInStages_some?: InputMaybe<TeaserPlaceholderWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** All values in which the union is empty */
  pages_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pages_some?: InputMaybe<TeaserPlaceholderPagesWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  teasers_every?: InputMaybe<TeaserWhereInput>;
  teasers_none?: InputMaybe<TeaserWhereInput>;
  teasers_some?: InputMaybe<TeaserWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TeaserPlaceholderWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TeaserPlaceholderWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TeaserPlaceholderWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TeaserPlaceholderWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TeaserPlaceholderWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TeaserPlaceholder record uniquely */
export type TeaserPlaceholderWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TeaserSmall = Entity & Node & {
  __typename?: 'TeaserSmall';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<TeaserSmall>;
  endDate: Scalars['DateTime']['output'];
  heading?: Maybe<Scalars['String']['output']>;
  /** List of TeaserSmall versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  startDate: Scalars['DateTime']['output'];
  teaserSmallPlaceholders: Array<TeaserSmallPlaceholder>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type TeaserSmallCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeaserSmallDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type TeaserSmallHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type TeaserSmallLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeaserSmallMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeaserSmallPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeaserSmallScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type TeaserSmallTeaserSmallPlaceholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TeaserSmallPlaceholderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
};


export type TeaserSmallUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TeaserSmallConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TeaserSmallWhereUniqueInput;
};

/** A connection to a list of items. */
export type TeaserSmallConnection = {
  __typename?: 'TeaserSmallConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TeaserSmallEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TeaserSmallCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  heading?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  startDate: Scalars['DateTime']['input'];
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderCreateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeaserSmallCreateManyInlineInput = {
  /** Connect multiple existing TeaserSmall documents */
  connect?: InputMaybe<Array<TeaserSmallWhereUniqueInput>>;
  /** Create and connect multiple existing TeaserSmall documents */
  create?: InputMaybe<Array<TeaserSmallCreateInput>>;
};

export type TeaserSmallCreateOneInlineInput = {
  /** Connect one existing TeaserSmall document */
  connect?: InputMaybe<TeaserSmallWhereUniqueInput>;
  /** Create and connect one TeaserSmall document */
  create?: InputMaybe<TeaserSmallCreateInput>;
};

/** An edge in a connection. */
export type TeaserSmallEdge = {
  __typename?: 'TeaserSmallEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TeaserSmall;
};

/** Identifies documents */
export type TeaserSmallManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TeaserSmallWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TeaserSmallWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TeaserSmallWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<TeaserSmallWhereStageInput>;
  documentInStages_none?: InputMaybe<TeaserSmallWhereStageInput>;
  documentInStages_some?: InputMaybe<TeaserSmallWhereStageInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  endDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  endDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  startDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  startDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TeaserSmallOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  endDate_ASC = 'endDate_ASC',
  endDate_DESC = 'endDate_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  startDate_ASC = 'startDate_ASC',
  startDate_DESC = 'startDate_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TeaserSmallPlaceholder = Entity & Node & {
  __typename?: 'TeaserSmallPlaceholder';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<TeaserSmallPlaceholder>;
  /** List of TeaserSmallPlaceholder versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  pages: Array<TeaserSmallPlaceholderPages>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  teaserSmalls: Array<TeaserSmall>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type TeaserSmallPlaceholderCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeaserSmallPlaceholderDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type TeaserSmallPlaceholderHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type TeaserSmallPlaceholderMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeaserSmallPlaceholderPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TeaserSmallPlaceholderPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeaserSmallPlaceholderScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type TeaserSmallPlaceholderTeaserSmallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TeaserSmallOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeaserSmallWhereInput>;
};


export type TeaserSmallPlaceholderUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TeaserSmallPlaceholderConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TeaserSmallPlaceholderWhereUniqueInput;
};

/** A connection to a list of items. */
export type TeaserSmallPlaceholderConnection = {
  __typename?: 'TeaserSmallPlaceholderConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TeaserSmallPlaceholderEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TeaserSmallPlaceholderCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  pages?: InputMaybe<TeaserSmallPlaceholderPagesCreateManyInlineInput>;
  teaserSmalls?: InputMaybe<TeaserSmallCreateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeaserSmallPlaceholderCreateManyInlineInput = {
  /** Connect multiple existing TeaserSmallPlaceholder documents */
  connect?: InputMaybe<Array<TeaserSmallPlaceholderWhereUniqueInput>>;
  /** Create and connect multiple existing TeaserSmallPlaceholder documents */
  create?: InputMaybe<Array<TeaserSmallPlaceholderCreateInput>>;
};

export type TeaserSmallPlaceholderCreateOneInlineInput = {
  /** Connect one existing TeaserSmallPlaceholder document */
  connect?: InputMaybe<TeaserSmallPlaceholderWhereUniqueInput>;
  /** Create and connect one TeaserSmallPlaceholder document */
  create?: InputMaybe<TeaserSmallPlaceholderCreateInput>;
};

/** An edge in a connection. */
export type TeaserSmallPlaceholderEdge = {
  __typename?: 'TeaserSmallPlaceholderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TeaserSmallPlaceholder;
};

/** Identifies documents */
export type TeaserSmallPlaceholderManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TeaserSmallPlaceholderWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TeaserSmallPlaceholderWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TeaserSmallPlaceholderWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TeaserSmallPlaceholderWhereStageInput>;
  documentInStages_none?: InputMaybe<TeaserSmallPlaceholderWhereStageInput>;
  documentInStages_some?: InputMaybe<TeaserSmallPlaceholderWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** All values in which the union is empty */
  pages_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pages_some?: InputMaybe<TeaserSmallPlaceholderPagesWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  teaserSmalls_every?: InputMaybe<TeaserSmallWhereInput>;
  teaserSmalls_none?: InputMaybe<TeaserSmallWhereInput>;
  teaserSmalls_some?: InputMaybe<TeaserSmallWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TeaserSmallPlaceholderOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TeaserSmallPlaceholderPages = GenericPage | ProductCategoryPage | ProductDetailPage | ProductLandingPage | ProductSubcategoryPage | Recipe | RecipeCategory | RecipeLandingPage | RecipeSubcategory | SearchOverlayComponent;

export type TeaserSmallPlaceholderPagesConnectInput = {
  GenericPage?: InputMaybe<GenericPageConnectInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageConnectInput>;
  ProductDetailPage?: InputMaybe<ProductDetailPageConnectInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageConnectInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageConnectInput>;
  Recipe?: InputMaybe<RecipeConnectInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryConnectInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageConnectInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryConnectInput>;
  SearchOverlayComponent?: InputMaybe<SearchOverlayComponentConnectInput>;
};

export type TeaserSmallPlaceholderPagesCreateInput = {
  GenericPage?: InputMaybe<GenericPageCreateInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageCreateInput>;
  ProductDetailPage?: InputMaybe<ProductDetailPageCreateInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageCreateInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageCreateInput>;
  Recipe?: InputMaybe<RecipeCreateInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryCreateInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageCreateInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryCreateInput>;
  SearchOverlayComponent?: InputMaybe<SearchOverlayComponentCreateInput>;
};

export type TeaserSmallPlaceholderPagesCreateManyInlineInput = {
  /** Connect multiple existing TeaserSmallPlaceholderPages documents */
  connect?: InputMaybe<Array<TeaserSmallPlaceholderPagesWhereUniqueInput>>;
  /** Create and connect multiple existing TeaserSmallPlaceholderPages documents */
  create?: InputMaybe<Array<TeaserSmallPlaceholderPagesCreateInput>>;
};

export type TeaserSmallPlaceholderPagesCreateOneInlineInput = {
  /** Connect one existing TeaserSmallPlaceholderPages document */
  connect?: InputMaybe<TeaserSmallPlaceholderPagesWhereUniqueInput>;
  /** Create and connect one TeaserSmallPlaceholderPages document */
  create?: InputMaybe<TeaserSmallPlaceholderPagesCreateInput>;
};

export type TeaserSmallPlaceholderPagesUpdateInput = {
  GenericPage?: InputMaybe<GenericPageUpdateInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageUpdateInput>;
  ProductDetailPage?: InputMaybe<ProductDetailPageUpdateInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageUpdateInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpdateInput>;
  Recipe?: InputMaybe<RecipeUpdateInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryUpdateInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageUpdateInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateInput>;
  SearchOverlayComponent?: InputMaybe<SearchOverlayComponentUpdateInput>;
};

export type TeaserSmallPlaceholderPagesUpdateManyInlineInput = {
  /** Connect multiple existing TeaserSmallPlaceholderPages documents */
  connect?: InputMaybe<Array<TeaserSmallPlaceholderPagesConnectInput>>;
  /** Create and connect multiple TeaserSmallPlaceholderPages documents */
  create?: InputMaybe<Array<TeaserSmallPlaceholderPagesCreateInput>>;
  /** Delete multiple TeaserSmallPlaceholderPages documents */
  delete?: InputMaybe<Array<TeaserSmallPlaceholderPagesWhereUniqueInput>>;
  /** Disconnect multiple TeaserSmallPlaceholderPages documents */
  disconnect?: InputMaybe<Array<TeaserSmallPlaceholderPagesWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TeaserSmallPlaceholderPages documents */
  set?: InputMaybe<Array<TeaserSmallPlaceholderPagesWhereUniqueInput>>;
  /** Update multiple TeaserSmallPlaceholderPages documents */
  update?: InputMaybe<Array<TeaserSmallPlaceholderPagesUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TeaserSmallPlaceholderPages documents */
  upsert?: InputMaybe<Array<TeaserSmallPlaceholderPagesUpsertWithNestedWhereUniqueInput>>;
};

export type TeaserSmallPlaceholderPagesUpdateManyWithNestedWhereInput = {
  GenericPage?: InputMaybe<GenericPageUpdateManyWithNestedWhereInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageUpdateManyWithNestedWhereInput>;
  ProductDetailPage?: InputMaybe<ProductDetailPageUpdateManyWithNestedWhereInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageUpdateManyWithNestedWhereInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpdateManyWithNestedWhereInput>;
  Recipe?: InputMaybe<RecipeUpdateManyWithNestedWhereInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryUpdateManyWithNestedWhereInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageUpdateManyWithNestedWhereInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateManyWithNestedWhereInput>;
  SearchOverlayComponent?: InputMaybe<SearchOverlayComponentUpdateManyWithNestedWhereInput>;
};

export type TeaserSmallPlaceholderPagesUpdateOneInlineInput = {
  /** Connect existing TeaserSmallPlaceholderPages document */
  connect?: InputMaybe<TeaserSmallPlaceholderPagesWhereUniqueInput>;
  /** Create and connect one TeaserSmallPlaceholderPages document */
  create?: InputMaybe<TeaserSmallPlaceholderPagesCreateInput>;
  /** Delete currently connected TeaserSmallPlaceholderPages document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TeaserSmallPlaceholderPages document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TeaserSmallPlaceholderPages document */
  update?: InputMaybe<TeaserSmallPlaceholderPagesUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TeaserSmallPlaceholderPages document */
  upsert?: InputMaybe<TeaserSmallPlaceholderPagesUpsertWithNestedWhereUniqueInput>;
};

export type TeaserSmallPlaceholderPagesUpdateWithNestedWhereUniqueInput = {
  GenericPage?: InputMaybe<GenericPageUpdateWithNestedWhereUniqueInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageUpdateWithNestedWhereUniqueInput>;
  ProductDetailPage?: InputMaybe<ProductDetailPageUpdateWithNestedWhereUniqueInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageUpdateWithNestedWhereUniqueInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpdateWithNestedWhereUniqueInput>;
  Recipe?: InputMaybe<RecipeUpdateWithNestedWhereUniqueInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryUpdateWithNestedWhereUniqueInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageUpdateWithNestedWhereUniqueInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpdateWithNestedWhereUniqueInput>;
  SearchOverlayComponent?: InputMaybe<SearchOverlayComponentUpdateWithNestedWhereUniqueInput>;
};

export type TeaserSmallPlaceholderPagesUpsertWithNestedWhereUniqueInput = {
  GenericPage?: InputMaybe<GenericPageUpsertWithNestedWhereUniqueInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageUpsertWithNestedWhereUniqueInput>;
  ProductDetailPage?: InputMaybe<ProductDetailPageUpsertWithNestedWhereUniqueInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageUpsertWithNestedWhereUniqueInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageUpsertWithNestedWhereUniqueInput>;
  Recipe?: InputMaybe<RecipeUpsertWithNestedWhereUniqueInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryUpsertWithNestedWhereUniqueInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageUpsertWithNestedWhereUniqueInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryUpsertWithNestedWhereUniqueInput>;
  SearchOverlayComponent?: InputMaybe<SearchOverlayComponentUpsertWithNestedWhereUniqueInput>;
};

export type TeaserSmallPlaceholderPagesWhereInput = {
  GenericPage?: InputMaybe<GenericPageWhereInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageWhereInput>;
  ProductDetailPage?: InputMaybe<ProductDetailPageWhereInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageWhereInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageWhereInput>;
  Recipe?: InputMaybe<RecipeWhereInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryWhereInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageWhereInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryWhereInput>;
  SearchOverlayComponent?: InputMaybe<SearchOverlayComponentWhereInput>;
};

export type TeaserSmallPlaceholderPagesWhereUniqueInput = {
  GenericPage?: InputMaybe<GenericPageWhereUniqueInput>;
  ProductCategoryPage?: InputMaybe<ProductCategoryPageWhereUniqueInput>;
  ProductDetailPage?: InputMaybe<ProductDetailPageWhereUniqueInput>;
  ProductLandingPage?: InputMaybe<ProductLandingPageWhereUniqueInput>;
  ProductSubcategoryPage?: InputMaybe<ProductSubcategoryPageWhereUniqueInput>;
  Recipe?: InputMaybe<RecipeWhereUniqueInput>;
  RecipeCategory?: InputMaybe<RecipeCategoryWhereUniqueInput>;
  RecipeLandingPage?: InputMaybe<RecipeLandingPageWhereUniqueInput>;
  RecipeSubcategory?: InputMaybe<RecipeSubcategoryWhereUniqueInput>;
  SearchOverlayComponent?: InputMaybe<SearchOverlayComponentWhereUniqueInput>;
};

export type TeaserSmallPlaceholderUpdateInput = {
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  pages?: InputMaybe<TeaserSmallPlaceholderPagesUpdateManyInlineInput>;
  teaserSmalls?: InputMaybe<TeaserSmallUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TeaserSmallPlaceholderUpdateManyInlineInput = {
  /** Connect multiple existing TeaserSmallPlaceholder documents */
  connect?: InputMaybe<Array<TeaserSmallPlaceholderConnectInput>>;
  /** Create and connect multiple TeaserSmallPlaceholder documents */
  create?: InputMaybe<Array<TeaserSmallPlaceholderCreateInput>>;
  /** Delete multiple TeaserSmallPlaceholder documents */
  delete?: InputMaybe<Array<TeaserSmallPlaceholderWhereUniqueInput>>;
  /** Disconnect multiple TeaserSmallPlaceholder documents */
  disconnect?: InputMaybe<Array<TeaserSmallPlaceholderWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TeaserSmallPlaceholder documents */
  set?: InputMaybe<Array<TeaserSmallPlaceholderWhereUniqueInput>>;
  /** Update multiple TeaserSmallPlaceholder documents */
  update?: InputMaybe<Array<TeaserSmallPlaceholderUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TeaserSmallPlaceholder documents */
  upsert?: InputMaybe<Array<TeaserSmallPlaceholderUpsertWithNestedWhereUniqueInput>>;
};

export type TeaserSmallPlaceholderUpdateManyInput = {
  market?: InputMaybe<Markets>;
};

export type TeaserSmallPlaceholderUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TeaserSmallPlaceholderUpdateManyInput;
  /** Document search */
  where: TeaserSmallPlaceholderWhereInput;
};

export type TeaserSmallPlaceholderUpdateOneInlineInput = {
  /** Connect existing TeaserSmallPlaceholder document */
  connect?: InputMaybe<TeaserSmallPlaceholderWhereUniqueInput>;
  /** Create and connect one TeaserSmallPlaceholder document */
  create?: InputMaybe<TeaserSmallPlaceholderCreateInput>;
  /** Delete currently connected TeaserSmallPlaceholder document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TeaserSmallPlaceholder document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TeaserSmallPlaceholder document */
  update?: InputMaybe<TeaserSmallPlaceholderUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TeaserSmallPlaceholder document */
  upsert?: InputMaybe<TeaserSmallPlaceholderUpsertWithNestedWhereUniqueInput>;
};

export type TeaserSmallPlaceholderUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TeaserSmallPlaceholderUpdateInput;
  /** Unique document search */
  where: TeaserSmallPlaceholderWhereUniqueInput;
};

export type TeaserSmallPlaceholderUpsertInput = {
  /** Create document if it didn't exist */
  create: TeaserSmallPlaceholderCreateInput;
  /** Update document if it exists */
  update: TeaserSmallPlaceholderUpdateInput;
};

export type TeaserSmallPlaceholderUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TeaserSmallPlaceholderUpsertInput;
  /** Unique document search */
  where: TeaserSmallPlaceholderWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TeaserSmallPlaceholderWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TeaserSmallPlaceholderWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TeaserSmallPlaceholderWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TeaserSmallPlaceholderWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TeaserSmallPlaceholderWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TeaserSmallPlaceholderWhereStageInput>;
  documentInStages_none?: InputMaybe<TeaserSmallPlaceholderWhereStageInput>;
  documentInStages_some?: InputMaybe<TeaserSmallPlaceholderWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** All values in which the union is empty */
  pages_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pages_some?: InputMaybe<TeaserSmallPlaceholderPagesWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  teaserSmalls_every?: InputMaybe<TeaserSmallWhereInput>;
  teaserSmalls_none?: InputMaybe<TeaserSmallWhereInput>;
  teaserSmalls_some?: InputMaybe<TeaserSmallWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TeaserSmallPlaceholderWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TeaserSmallPlaceholderWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TeaserSmallPlaceholderWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TeaserSmallPlaceholderWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TeaserSmallPlaceholderWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TeaserSmallPlaceholder record uniquely */
export type TeaserSmallPlaceholderWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TeaserSmallUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  teaserSmallPlaceholders?: InputMaybe<TeaserSmallPlaceholderUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TeaserSmallUpdateManyInlineInput = {
  /** Connect multiple existing TeaserSmall documents */
  connect?: InputMaybe<Array<TeaserSmallConnectInput>>;
  /** Create and connect multiple TeaserSmall documents */
  create?: InputMaybe<Array<TeaserSmallCreateInput>>;
  /** Delete multiple TeaserSmall documents */
  delete?: InputMaybe<Array<TeaserSmallWhereUniqueInput>>;
  /** Disconnect multiple TeaserSmall documents */
  disconnect?: InputMaybe<Array<TeaserSmallWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TeaserSmall documents */
  set?: InputMaybe<Array<TeaserSmallWhereUniqueInput>>;
  /** Update multiple TeaserSmall documents */
  update?: InputMaybe<Array<TeaserSmallUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TeaserSmall documents */
  upsert?: InputMaybe<Array<TeaserSmallUpsertWithNestedWhereUniqueInput>>;
};

export type TeaserSmallUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TeaserSmallUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TeaserSmallUpdateManyInput;
  /** Document search */
  where: TeaserSmallWhereInput;
};

export type TeaserSmallUpdateOneInlineInput = {
  /** Connect existing TeaserSmall document */
  connect?: InputMaybe<TeaserSmallWhereUniqueInput>;
  /** Create and connect one TeaserSmall document */
  create?: InputMaybe<TeaserSmallCreateInput>;
  /** Delete currently connected TeaserSmall document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TeaserSmall document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TeaserSmall document */
  update?: InputMaybe<TeaserSmallUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TeaserSmall document */
  upsert?: InputMaybe<TeaserSmallUpsertWithNestedWhereUniqueInput>;
};

export type TeaserSmallUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TeaserSmallUpdateInput;
  /** Unique document search */
  where: TeaserSmallWhereUniqueInput;
};

export type TeaserSmallUpsertInput = {
  /** Create document if it didn't exist */
  create: TeaserSmallCreateInput;
  /** Update document if it exists */
  update: TeaserSmallUpdateInput;
};

export type TeaserSmallUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TeaserSmallUpsertInput;
  /** Unique document search */
  where: TeaserSmallWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TeaserSmallWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TeaserSmallWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TeaserSmallWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TeaserSmallWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TeaserSmallWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<TeaserSmallWhereStageInput>;
  documentInStages_none?: InputMaybe<TeaserSmallWhereStageInput>;
  documentInStages_some?: InputMaybe<TeaserSmallWhereStageInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  endDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  endDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  startDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  startDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  teaserSmallPlaceholders_every?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_none?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  teaserSmallPlaceholders_some?: InputMaybe<TeaserSmallPlaceholderWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TeaserSmallWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TeaserSmallWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TeaserSmallWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TeaserSmallWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TeaserSmallWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TeaserSmall record uniquely */
export type TeaserSmallWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TeaserUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  extension?: InputMaybe<AlgoliaExtensionUpdateOneInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  teaserPlaceholders?: InputMaybe<TeaserPlaceholderUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TeaserUpdateManyInlineInput = {
  /** Connect multiple existing Teaser documents */
  connect?: InputMaybe<Array<TeaserConnectInput>>;
  /** Create and connect multiple Teaser documents */
  create?: InputMaybe<Array<TeaserCreateInput>>;
  /** Delete multiple Teaser documents */
  delete?: InputMaybe<Array<TeaserWhereUniqueInput>>;
  /** Disconnect multiple Teaser documents */
  disconnect?: InputMaybe<Array<TeaserWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Teaser documents */
  set?: InputMaybe<Array<TeaserWhereUniqueInput>>;
  /** Update multiple Teaser documents */
  update?: InputMaybe<Array<TeaserUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Teaser documents */
  upsert?: InputMaybe<Array<TeaserUpsertWithNestedWhereUniqueInput>>;
};

export type TeaserUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TeaserUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TeaserUpdateManyInput;
  /** Document search */
  where: TeaserWhereInput;
};

export type TeaserUpdateOneInlineInput = {
  /** Connect existing Teaser document */
  connect?: InputMaybe<TeaserWhereUniqueInput>;
  /** Create and connect one Teaser document */
  create?: InputMaybe<TeaserCreateInput>;
  /** Delete currently connected Teaser document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Teaser document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Teaser document */
  update?: InputMaybe<TeaserUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Teaser document */
  upsert?: InputMaybe<TeaserUpsertWithNestedWhereUniqueInput>;
};

export type TeaserUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TeaserUpdateInput;
  /** Unique document search */
  where: TeaserWhereUniqueInput;
};

export type TeaserUpsertInput = {
  /** Create document if it didn't exist */
  create: TeaserCreateInput;
  /** Update document if it exists */
  update: TeaserUpdateInput;
};

export type TeaserUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TeaserUpsertInput;
  /** Unique document search */
  where: TeaserWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TeaserWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TeaserWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TeaserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TeaserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TeaserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<TeaserWhereStageInput>;
  documentInStages_none?: InputMaybe<TeaserWhereStageInput>;
  documentInStages_some?: InputMaybe<TeaserWhereStageInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  endDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  endDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  extension?: InputMaybe<AlgoliaExtensionWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  startDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  startDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  teaserPlaceholders_every?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_none?: InputMaybe<TeaserPlaceholderWhereInput>;
  teaserPlaceholders_some?: InputMaybe<TeaserPlaceholderWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TeaserWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TeaserWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TeaserWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TeaserWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TeaserWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Teaser record uniquely */
export type TeaserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TestComponentWithRecipeQuery = Entity & Node & {
  __typename?: 'TestComponentWithRecipeQuery';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<TestComponentWithRecipeQuery>;
  genericPages: Array<GenericPage>;
  /** List of TestComponentWithRecipeQuery versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipesQueriesReference?: Maybe<RecipesQueriesReference>;
  rewriteData: Array<TestComponentWithRecipeQueryRewriteData>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type TestComponentWithRecipeQueryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TestComponentWithRecipeQueryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type TestComponentWithRecipeQueryGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type TestComponentWithRecipeQueryHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type TestComponentWithRecipeQueryMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TestComponentWithRecipeQueryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TestComponentWithRecipeQueryRecipesQueriesReferenceArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TestComponentWithRecipeQueryRewriteDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TestComponentWithRecipeQueryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type TestComponentWithRecipeQueryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TestComponentWithRecipeQueryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TestComponentWithRecipeQueryWhereUniqueInput;
};

/** A connection to a list of items. */
export type TestComponentWithRecipeQueryConnection = {
  __typename?: 'TestComponentWithRecipeQueryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TestComponentWithRecipeQueryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TestComponentWithRecipeQueryCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  recipesQueriesReference?: InputMaybe<RecipesQueriesReferenceCreateOneInlineInput>;
  rewriteData?: InputMaybe<TestComponentWithRecipeQueryRewriteDataCreateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TestComponentWithRecipeQueryCreateManyInlineInput = {
  /** Connect multiple existing TestComponentWithRecipeQuery documents */
  connect?: InputMaybe<Array<TestComponentWithRecipeQueryWhereUniqueInput>>;
  /** Create and connect multiple existing TestComponentWithRecipeQuery documents */
  create?: InputMaybe<Array<TestComponentWithRecipeQueryCreateInput>>;
};

export type TestComponentWithRecipeQueryCreateOneInlineInput = {
  /** Connect one existing TestComponentWithRecipeQuery document */
  connect?: InputMaybe<TestComponentWithRecipeQueryWhereUniqueInput>;
  /** Create and connect one TestComponentWithRecipeQuery document */
  create?: InputMaybe<TestComponentWithRecipeQueryCreateInput>;
};

/** An edge in a connection. */
export type TestComponentWithRecipeQueryEdge = {
  __typename?: 'TestComponentWithRecipeQueryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TestComponentWithRecipeQuery;
};

/** Identifies documents */
export type TestComponentWithRecipeQueryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TestComponentWithRecipeQueryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TestComponentWithRecipeQueryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TestComponentWithRecipeQueryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TestComponentWithRecipeQueryWhereStageInput>;
  documentInStages_none?: InputMaybe<TestComponentWithRecipeQueryWhereStageInput>;
  documentInStages_some?: InputMaybe<TestComponentWithRecipeQueryWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipesQueriesReference?: InputMaybe<RecipesQueriesReferenceWhereInput>;
  /** All values in which the union is empty */
  rewriteData_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  rewriteData_some?: InputMaybe<TestComponentWithRecipeQueryRewriteDataWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TestComponentWithRecipeQueryOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TestComponentWithRecipeQueryRewriteData = Rewrite;

export type TestComponentWithRecipeQueryRewriteDataConnectInput = {
  Rewrite?: InputMaybe<RewriteConnectInput>;
};

export type TestComponentWithRecipeQueryRewriteDataCreateInput = {
  Rewrite?: InputMaybe<RewriteCreateInput>;
};

export type TestComponentWithRecipeQueryRewriteDataCreateManyInlineInput = {
  /** Connect multiple existing TestComponentWithRecipeQueryRewriteData documents */
  connect?: InputMaybe<Array<TestComponentWithRecipeQueryRewriteDataWhereUniqueInput>>;
  /** Create and connect multiple existing TestComponentWithRecipeQueryRewriteData documents */
  create?: InputMaybe<Array<TestComponentWithRecipeQueryRewriteDataCreateInput>>;
};

export type TestComponentWithRecipeQueryRewriteDataCreateOneInlineInput = {
  /** Connect one existing TestComponentWithRecipeQueryRewriteData document */
  connect?: InputMaybe<TestComponentWithRecipeQueryRewriteDataWhereUniqueInput>;
  /** Create and connect one TestComponentWithRecipeQueryRewriteData document */
  create?: InputMaybe<TestComponentWithRecipeQueryRewriteDataCreateInput>;
};

export type TestComponentWithRecipeQueryRewriteDataUpdateInput = {
  Rewrite?: InputMaybe<RewriteUpdateInput>;
};

export type TestComponentWithRecipeQueryRewriteDataUpdateManyInlineInput = {
  /** Connect multiple existing TestComponentWithRecipeQueryRewriteData documents */
  connect?: InputMaybe<Array<TestComponentWithRecipeQueryRewriteDataConnectInput>>;
  /** Create and connect multiple TestComponentWithRecipeQueryRewriteData documents */
  create?: InputMaybe<Array<TestComponentWithRecipeQueryRewriteDataCreateInput>>;
  /** Delete multiple TestComponentWithRecipeQueryRewriteData documents */
  delete?: InputMaybe<Array<TestComponentWithRecipeQueryRewriteDataWhereUniqueInput>>;
  /** Disconnect multiple TestComponentWithRecipeQueryRewriteData documents */
  disconnect?: InputMaybe<Array<TestComponentWithRecipeQueryRewriteDataWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TestComponentWithRecipeQueryRewriteData documents */
  set?: InputMaybe<Array<TestComponentWithRecipeQueryRewriteDataWhereUniqueInput>>;
  /** Update multiple TestComponentWithRecipeQueryRewriteData documents */
  update?: InputMaybe<Array<TestComponentWithRecipeQueryRewriteDataUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TestComponentWithRecipeQueryRewriteData documents */
  upsert?: InputMaybe<Array<TestComponentWithRecipeQueryRewriteDataUpsertWithNestedWhereUniqueInput>>;
};

export type TestComponentWithRecipeQueryRewriteDataUpdateManyWithNestedWhereInput = {
  Rewrite?: InputMaybe<RewriteUpdateManyWithNestedWhereInput>;
};

export type TestComponentWithRecipeQueryRewriteDataUpdateOneInlineInput = {
  /** Connect existing TestComponentWithRecipeQueryRewriteData document */
  connect?: InputMaybe<TestComponentWithRecipeQueryRewriteDataWhereUniqueInput>;
  /** Create and connect one TestComponentWithRecipeQueryRewriteData document */
  create?: InputMaybe<TestComponentWithRecipeQueryRewriteDataCreateInput>;
  /** Delete currently connected TestComponentWithRecipeQueryRewriteData document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TestComponentWithRecipeQueryRewriteData document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TestComponentWithRecipeQueryRewriteData document */
  update?: InputMaybe<TestComponentWithRecipeQueryRewriteDataUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TestComponentWithRecipeQueryRewriteData document */
  upsert?: InputMaybe<TestComponentWithRecipeQueryRewriteDataUpsertWithNestedWhereUniqueInput>;
};

export type TestComponentWithRecipeQueryRewriteDataUpdateWithNestedWhereUniqueInput = {
  Rewrite?: InputMaybe<RewriteUpdateWithNestedWhereUniqueInput>;
};

export type TestComponentWithRecipeQueryRewriteDataUpsertWithNestedWhereUniqueInput = {
  Rewrite?: InputMaybe<RewriteUpsertWithNestedWhereUniqueInput>;
};

export type TestComponentWithRecipeQueryRewriteDataWhereInput = {
  Rewrite?: InputMaybe<RewriteWhereInput>;
};

export type TestComponentWithRecipeQueryRewriteDataWhereUniqueInput = {
  Rewrite?: InputMaybe<RewriteWhereUniqueInput>;
};

export type TestComponentWithRecipeQueryUpdateInput = {
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  recipesQueriesReference?: InputMaybe<RecipesQueriesReferenceUpdateOneInlineInput>;
  rewriteData?: InputMaybe<TestComponentWithRecipeQueryRewriteDataUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TestComponentWithRecipeQueryUpdateManyInlineInput = {
  /** Connect multiple existing TestComponentWithRecipeQuery documents */
  connect?: InputMaybe<Array<TestComponentWithRecipeQueryConnectInput>>;
  /** Create and connect multiple TestComponentWithRecipeQuery documents */
  create?: InputMaybe<Array<TestComponentWithRecipeQueryCreateInput>>;
  /** Delete multiple TestComponentWithRecipeQuery documents */
  delete?: InputMaybe<Array<TestComponentWithRecipeQueryWhereUniqueInput>>;
  /** Disconnect multiple TestComponentWithRecipeQuery documents */
  disconnect?: InputMaybe<Array<TestComponentWithRecipeQueryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TestComponentWithRecipeQuery documents */
  set?: InputMaybe<Array<TestComponentWithRecipeQueryWhereUniqueInput>>;
  /** Update multiple TestComponentWithRecipeQuery documents */
  update?: InputMaybe<Array<TestComponentWithRecipeQueryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TestComponentWithRecipeQuery documents */
  upsert?: InputMaybe<Array<TestComponentWithRecipeQueryUpsertWithNestedWhereUniqueInput>>;
};

export type TestComponentWithRecipeQueryUpdateManyInput = {
  market?: InputMaybe<Markets>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TestComponentWithRecipeQueryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TestComponentWithRecipeQueryUpdateManyInput;
  /** Document search */
  where: TestComponentWithRecipeQueryWhereInput;
};

export type TestComponentWithRecipeQueryUpdateOneInlineInput = {
  /** Connect existing TestComponentWithRecipeQuery document */
  connect?: InputMaybe<TestComponentWithRecipeQueryWhereUniqueInput>;
  /** Create and connect one TestComponentWithRecipeQuery document */
  create?: InputMaybe<TestComponentWithRecipeQueryCreateInput>;
  /** Delete currently connected TestComponentWithRecipeQuery document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TestComponentWithRecipeQuery document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TestComponentWithRecipeQuery document */
  update?: InputMaybe<TestComponentWithRecipeQueryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TestComponentWithRecipeQuery document */
  upsert?: InputMaybe<TestComponentWithRecipeQueryUpsertWithNestedWhereUniqueInput>;
};

export type TestComponentWithRecipeQueryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TestComponentWithRecipeQueryUpdateInput;
  /** Unique document search */
  where: TestComponentWithRecipeQueryWhereUniqueInput;
};

export type TestComponentWithRecipeQueryUpsertInput = {
  /** Create document if it didn't exist */
  create: TestComponentWithRecipeQueryCreateInput;
  /** Update document if it exists */
  update: TestComponentWithRecipeQueryUpdateInput;
};

export type TestComponentWithRecipeQueryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TestComponentWithRecipeQueryUpsertInput;
  /** Unique document search */
  where: TestComponentWithRecipeQueryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TestComponentWithRecipeQueryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TestComponentWithRecipeQueryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TestComponentWithRecipeQueryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TestComponentWithRecipeQueryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TestComponentWithRecipeQueryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TestComponentWithRecipeQueryWhereStageInput>;
  documentInStages_none?: InputMaybe<TestComponentWithRecipeQueryWhereStageInput>;
  documentInStages_some?: InputMaybe<TestComponentWithRecipeQueryWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipesQueriesReference?: InputMaybe<RecipesQueriesReferenceWhereInput>;
  /** All values in which the union is empty */
  rewriteData_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  rewriteData_some?: InputMaybe<TestComponentWithRecipeQueryRewriteDataWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TestComponentWithRecipeQueryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TestComponentWithRecipeQueryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TestComponentWithRecipeQueryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TestComponentWithRecipeQueryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TestComponentWithRecipeQueryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TestComponentWithRecipeQuery record uniquely */
export type TestComponentWithRecipeQueryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TestTipsANdTricksInAMarket = Entity & Node & {
  __typename?: 'TestTipsANdTricksInAMarket';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<TestTipsANdTricksInAMarket>;
  environment?: Maybe<DbEnvironment>;
  /** List of TestTipsANdTricksInAMarket versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  marketName?: Maybe<Market>;
  markets?: Maybe<Markets>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  tipsAndTricks?: Maybe<Scalars['Json']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type TestTipsANdTricksInAMarketCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TestTipsANdTricksInAMarketDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type TestTipsANdTricksInAMarketHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type TestTipsANdTricksInAMarketMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TestTipsANdTricksInAMarketPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TestTipsANdTricksInAMarketScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type TestTipsANdTricksInAMarketUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TestTipsANdTricksInAMarketConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};

/** A connection to a list of items. */
export type TestTipsANdTricksInAMarketConnection = {
  __typename?: 'TestTipsANdTricksInAMarketConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TestTipsANdTricksInAMarketEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TestTipsANdTricksInAMarketCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  environment?: InputMaybe<DbEnvironment>;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  markets?: InputMaybe<Markets>;
  tipsAndTricks?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TestTipsANdTricksInAMarketCreateManyInlineInput = {
  /** Connect multiple existing TestTipsANdTricksInAMarket documents */
  connect?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereUniqueInput>>;
  /** Create and connect multiple existing TestTipsANdTricksInAMarket documents */
  create?: InputMaybe<Array<TestTipsANdTricksInAMarketCreateInput>>;
};

export type TestTipsANdTricksInAMarketCreateOneInlineInput = {
  /** Connect one existing TestTipsANdTricksInAMarket document */
  connect?: InputMaybe<TestTipsANdTricksInAMarketWhereUniqueInput>;
  /** Create and connect one TestTipsANdTricksInAMarket document */
  create?: InputMaybe<TestTipsANdTricksInAMarketCreateInput>;
};

/** An edge in a connection. */
export type TestTipsANdTricksInAMarketEdge = {
  __typename?: 'TestTipsANdTricksInAMarketEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TestTipsANdTricksInAMarket;
};

/** Identifies documents */
export type TestTipsANdTricksInAMarketManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TestTipsANdTricksInAMarketWhereStageInput>;
  documentInStages_none?: InputMaybe<TestTipsANdTricksInAMarketWhereStageInput>;
  documentInStages_some?: InputMaybe<TestTipsANdTricksInAMarketWhereStageInput>;
  environment?: InputMaybe<DbEnvironment>;
  /** All values that are contained in given list. */
  environment_in?: InputMaybe<Array<InputMaybe<DbEnvironment>>>;
  /** Any other value that exists and is not equal to the given value. */
  environment_not?: InputMaybe<DbEnvironment>;
  /** All values that are not contained in given list. */
  environment_not_in?: InputMaybe<Array<InputMaybe<DbEnvironment>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  marketName?: InputMaybe<MarketWhereInput>;
  markets?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  markets_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  markets_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  markets_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values containing the given json path. */
  tipsAndTricks_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  tipsAndTricks_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TestTipsANdTricksInAMarketOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  environment_ASC = 'environment_ASC',
  environment_DESC = 'environment_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  markets_ASC = 'markets_ASC',
  markets_DESC = 'markets_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TestTipsANdTricksInAMarketUpdateInput = {
  environment?: InputMaybe<DbEnvironment>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  markets?: InputMaybe<Markets>;
  tipsAndTricks?: InputMaybe<Scalars['Json']['input']>;
};

export type TestTipsANdTricksInAMarketUpdateManyInlineInput = {
  /** Connect multiple existing TestTipsANdTricksInAMarket documents */
  connect?: InputMaybe<Array<TestTipsANdTricksInAMarketConnectInput>>;
  /** Create and connect multiple TestTipsANdTricksInAMarket documents */
  create?: InputMaybe<Array<TestTipsANdTricksInAMarketCreateInput>>;
  /** Delete multiple TestTipsANdTricksInAMarket documents */
  delete?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereUniqueInput>>;
  /** Disconnect multiple TestTipsANdTricksInAMarket documents */
  disconnect?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TestTipsANdTricksInAMarket documents */
  set?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereUniqueInput>>;
  /** Update multiple TestTipsANdTricksInAMarket documents */
  update?: InputMaybe<Array<TestTipsANdTricksInAMarketUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TestTipsANdTricksInAMarket documents */
  upsert?: InputMaybe<Array<TestTipsANdTricksInAMarketUpsertWithNestedWhereUniqueInput>>;
};

export type TestTipsANdTricksInAMarketUpdateManyInput = {
  environment?: InputMaybe<DbEnvironment>;
  markets?: InputMaybe<Markets>;
  tipsAndTricks?: InputMaybe<Scalars['Json']['input']>;
};

export type TestTipsANdTricksInAMarketUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TestTipsANdTricksInAMarketUpdateManyInput;
  /** Document search */
  where: TestTipsANdTricksInAMarketWhereInput;
};

export type TestTipsANdTricksInAMarketUpdateOneInlineInput = {
  /** Connect existing TestTipsANdTricksInAMarket document */
  connect?: InputMaybe<TestTipsANdTricksInAMarketWhereUniqueInput>;
  /** Create and connect one TestTipsANdTricksInAMarket document */
  create?: InputMaybe<TestTipsANdTricksInAMarketCreateInput>;
  /** Delete currently connected TestTipsANdTricksInAMarket document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TestTipsANdTricksInAMarket document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TestTipsANdTricksInAMarket document */
  update?: InputMaybe<TestTipsANdTricksInAMarketUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TestTipsANdTricksInAMarket document */
  upsert?: InputMaybe<TestTipsANdTricksInAMarketUpsertWithNestedWhereUniqueInput>;
};

export type TestTipsANdTricksInAMarketUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TestTipsANdTricksInAMarketUpdateInput;
  /** Unique document search */
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};

export type TestTipsANdTricksInAMarketUpsertInput = {
  /** Create document if it didn't exist */
  create: TestTipsANdTricksInAMarketCreateInput;
  /** Update document if it exists */
  update: TestTipsANdTricksInAMarketUpdateInput;
};

export type TestTipsANdTricksInAMarketUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TestTipsANdTricksInAMarketUpsertInput;
  /** Unique document search */
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TestTipsANdTricksInAMarketWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TestTipsANdTricksInAMarketWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TestTipsANdTricksInAMarketWhereStageInput>;
  documentInStages_none?: InputMaybe<TestTipsANdTricksInAMarketWhereStageInput>;
  documentInStages_some?: InputMaybe<TestTipsANdTricksInAMarketWhereStageInput>;
  environment?: InputMaybe<DbEnvironment>;
  /** All values that are contained in given list. */
  environment_in?: InputMaybe<Array<InputMaybe<DbEnvironment>>>;
  /** Any other value that exists and is not equal to the given value. */
  environment_not?: InputMaybe<DbEnvironment>;
  /** All values that are not contained in given list. */
  environment_not_in?: InputMaybe<Array<InputMaybe<DbEnvironment>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  marketName?: InputMaybe<MarketWhereInput>;
  markets?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  markets_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  markets_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  markets_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values containing the given json path. */
  tipsAndTricks_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  tipsAndTricks_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TestTipsANdTricksInAMarketWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TestTipsANdTricksInAMarketWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TestTipsANdTricksInAMarket record uniquely */
export type TestTipsANdTricksInAMarketWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Single text component that can be used to add rich text to a page */
export type TextComponent = Entity & Node & {
  __typename?: 'TextComponent';
  /** This title is not displayed on the website; it is only used to identify this item within CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<TextComponent>;
  /** List of TextComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  richtext?: Maybe<RichText>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Rich text editor for adding long form text paragraphs */
  text?: Maybe<TextComponentTextRichText>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Single text component that can be used to add rich text to a page */
export type TextComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Single text component that can be used to add rich text to a page */
export type TextComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Single text component that can be used to add rich text to a page */
export type TextComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Single text component that can be used to add rich text to a page */
export type TextComponentMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Single text component that can be used to add rich text to a page */
export type TextComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Single text component that can be used to add rich text to a page */
export type TextComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Single text component that can be used to add rich text to a page */
export type TextComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TextComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TextComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type TextComponentConnection = {
  __typename?: 'TextComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TextComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TextComponentCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  richtext?: InputMaybe<Scalars['RichTextAST']['input']>;
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TextComponentCreateManyInlineInput = {
  /** Connect multiple existing TextComponent documents */
  connect?: InputMaybe<Array<TextComponentWhereUniqueInput>>;
  /** Create and connect multiple existing TextComponent documents */
  create?: InputMaybe<Array<TextComponentCreateInput>>;
};

export type TextComponentCreateOneInlineInput = {
  /** Connect one existing TextComponent document */
  connect?: InputMaybe<TextComponentWhereUniqueInput>;
  /** Create and connect one TextComponent document */
  create?: InputMaybe<TextComponentCreateInput>;
};

/** An edge in a connection. */
export type TextComponentEdge = {
  __typename?: 'TextComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TextComponent;
};

/** Identifies documents */
export type TextComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TextComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<TextComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<TextComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TextComponentOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TextComponentTextRichText = {
  __typename?: 'TextComponentTextRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<TextComponentTextRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type TextComponentTextRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type TextComponentTextRichTextEmbeddedTypes = Asset;

export type TextComponentUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  richtext?: InputMaybe<Scalars['RichTextAST']['input']>;
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type TextComponentUpdateManyInlineInput = {
  /** Connect multiple existing TextComponent documents */
  connect?: InputMaybe<Array<TextComponentConnectInput>>;
  /** Create and connect multiple TextComponent documents */
  create?: InputMaybe<Array<TextComponentCreateInput>>;
  /** Delete multiple TextComponent documents */
  delete?: InputMaybe<Array<TextComponentWhereUniqueInput>>;
  /** Disconnect multiple TextComponent documents */
  disconnect?: InputMaybe<Array<TextComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TextComponent documents */
  set?: InputMaybe<Array<TextComponentWhereUniqueInput>>;
  /** Update multiple TextComponent documents */
  update?: InputMaybe<Array<TextComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TextComponent documents */
  upsert?: InputMaybe<Array<TextComponentUpsertWithNestedWhereUniqueInput>>;
};

export type TextComponentUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  richtext?: InputMaybe<Scalars['RichTextAST']['input']>;
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type TextComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TextComponentUpdateManyInput;
  /** Document search */
  where: TextComponentWhereInput;
};

export type TextComponentUpdateOneInlineInput = {
  /** Connect existing TextComponent document */
  connect?: InputMaybe<TextComponentWhereUniqueInput>;
  /** Create and connect one TextComponent document */
  create?: InputMaybe<TextComponentCreateInput>;
  /** Delete currently connected TextComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TextComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TextComponent document */
  update?: InputMaybe<TextComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TextComponent document */
  upsert?: InputMaybe<TextComponentUpsertWithNestedWhereUniqueInput>;
};

export type TextComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TextComponentUpdateInput;
  /** Unique document search */
  where: TextComponentWhereUniqueInput;
};

export type TextComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: TextComponentCreateInput;
  /** Update document if it exists */
  update: TextComponentUpdateInput;
};

export type TextComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TextComponentUpsertInput;
  /** Unique document search */
  where: TextComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TextComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TextComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TextComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<TextComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<TextComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TextComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TextComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TextComponent record uniquely */
export type TextComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Theme per page */
export enum Themes {
  christmas = 'christmas',
  christmas_blue_edition = 'christmas_blue_edition',
  suprema = 'suprema'
}

export type TipsAndTricksDetailsPage = Entity & Node & {
  __typename?: 'TipsAndTricksDetailsPage';
  anchorNavigationList?: Maybe<AnchorNavigationList>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<TipsAndTricksDetailsPage>;
  /** List of TipsAndTricksDetailsPage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** card carousel data for related tips and tricks */
  relatedTipsCarouselData?: Maybe<GenericCardCarouseComponent>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  sustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** titles to be referenced on a tip and trick detail page */
  titles?: Maybe<Dictionary>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type TipsAndTricksDetailsPageAnchorNavigationListArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TipsAndTricksDetailsPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TipsAndTricksDetailsPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type TipsAndTricksDetailsPageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type TipsAndTricksDetailsPageMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TipsAndTricksDetailsPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TipsAndTricksDetailsPageRelatedTipsCarouselDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TipsAndTricksDetailsPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type TipsAndTricksDetailsPageSustainabilityBannerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TipsAndTricksDetailsPageTitlesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TipsAndTricksDetailsPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TipsAndTricksDetailsPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};

/** A connection to a list of items. */
export type TipsAndTricksDetailsPageConnection = {
  __typename?: 'TipsAndTricksDetailsPageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TipsAndTricksDetailsPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TipsAndTricksDetailsPageCreateInput = {
  anchorNavigationList?: InputMaybe<AnchorNavigationListCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  relatedTipsCarouselData?: InputMaybe<GenericCardCarouseComponentCreateOneInlineInput>;
  sustainabilityBanner?: InputMaybe<SustainabilityBannerCreateOneInlineInput>;
  titles?: InputMaybe<DictionaryCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TipsAndTricksDetailsPageCreateManyInlineInput = {
  /** Connect multiple existing TipsAndTricksDetailsPage documents */
  connect?: InputMaybe<Array<TipsAndTricksDetailsPageWhereUniqueInput>>;
  /** Create and connect multiple existing TipsAndTricksDetailsPage documents */
  create?: InputMaybe<Array<TipsAndTricksDetailsPageCreateInput>>;
};

export type TipsAndTricksDetailsPageCreateOneInlineInput = {
  /** Connect one existing TipsAndTricksDetailsPage document */
  connect?: InputMaybe<TipsAndTricksDetailsPageWhereUniqueInput>;
  /** Create and connect one TipsAndTricksDetailsPage document */
  create?: InputMaybe<TipsAndTricksDetailsPageCreateInput>;
};

/** An edge in a connection. */
export type TipsAndTricksDetailsPageEdge = {
  __typename?: 'TipsAndTricksDetailsPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TipsAndTricksDetailsPage;
};

/** Identifies documents */
export type TipsAndTricksDetailsPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TipsAndTricksDetailsPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TipsAndTricksDetailsPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TipsAndTricksDetailsPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNavigationList?: InputMaybe<AnchorNavigationListWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TipsAndTricksDetailsPageWhereStageInput>;
  documentInStages_none?: InputMaybe<TipsAndTricksDetailsPageWhereStageInput>;
  documentInStages_some?: InputMaybe<TipsAndTricksDetailsPageWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  relatedTipsCarouselData?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sustainabilityBanner?: InputMaybe<SustainabilityBannerWhereInput>;
  titles?: InputMaybe<DictionaryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TipsAndTricksDetailsPageOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TipsAndTricksDetailsPageUpdateInput = {
  anchorNavigationList?: InputMaybe<AnchorNavigationListUpdateOneInlineInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  relatedTipsCarouselData?: InputMaybe<GenericCardCarouseComponentUpdateOneInlineInput>;
  sustainabilityBanner?: InputMaybe<SustainabilityBannerUpdateOneInlineInput>;
  titles?: InputMaybe<DictionaryUpdateOneInlineInput>;
};

export type TipsAndTricksDetailsPageUpdateManyInlineInput = {
  /** Connect multiple existing TipsAndTricksDetailsPage documents */
  connect?: InputMaybe<Array<TipsAndTricksDetailsPageConnectInput>>;
  /** Create and connect multiple TipsAndTricksDetailsPage documents */
  create?: InputMaybe<Array<TipsAndTricksDetailsPageCreateInput>>;
  /** Delete multiple TipsAndTricksDetailsPage documents */
  delete?: InputMaybe<Array<TipsAndTricksDetailsPageWhereUniqueInput>>;
  /** Disconnect multiple TipsAndTricksDetailsPage documents */
  disconnect?: InputMaybe<Array<TipsAndTricksDetailsPageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TipsAndTricksDetailsPage documents */
  set?: InputMaybe<Array<TipsAndTricksDetailsPageWhereUniqueInput>>;
  /** Update multiple TipsAndTricksDetailsPage documents */
  update?: InputMaybe<Array<TipsAndTricksDetailsPageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TipsAndTricksDetailsPage documents */
  upsert?: InputMaybe<Array<TipsAndTricksDetailsPageUpsertWithNestedWhereUniqueInput>>;
};

export type TipsAndTricksDetailsPageUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type TipsAndTricksDetailsPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TipsAndTricksDetailsPageUpdateManyInput;
  /** Document search */
  where: TipsAndTricksDetailsPageWhereInput;
};

export type TipsAndTricksDetailsPageUpdateOneInlineInput = {
  /** Connect existing TipsAndTricksDetailsPage document */
  connect?: InputMaybe<TipsAndTricksDetailsPageWhereUniqueInput>;
  /** Create and connect one TipsAndTricksDetailsPage document */
  create?: InputMaybe<TipsAndTricksDetailsPageCreateInput>;
  /** Delete currently connected TipsAndTricksDetailsPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TipsAndTricksDetailsPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TipsAndTricksDetailsPage document */
  update?: InputMaybe<TipsAndTricksDetailsPageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TipsAndTricksDetailsPage document */
  upsert?: InputMaybe<TipsAndTricksDetailsPageUpsertWithNestedWhereUniqueInput>;
};

export type TipsAndTricksDetailsPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TipsAndTricksDetailsPageUpdateInput;
  /** Unique document search */
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};

export type TipsAndTricksDetailsPageUpsertInput = {
  /** Create document if it didn't exist */
  create: TipsAndTricksDetailsPageCreateInput;
  /** Update document if it exists */
  update: TipsAndTricksDetailsPageUpdateInput;
};

export type TipsAndTricksDetailsPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TipsAndTricksDetailsPageUpsertInput;
  /** Unique document search */
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TipsAndTricksDetailsPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TipsAndTricksDetailsPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TipsAndTricksDetailsPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TipsAndTricksDetailsPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TipsAndTricksDetailsPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNavigationList?: InputMaybe<AnchorNavigationListWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TipsAndTricksDetailsPageWhereStageInput>;
  documentInStages_none?: InputMaybe<TipsAndTricksDetailsPageWhereStageInput>;
  documentInStages_some?: InputMaybe<TipsAndTricksDetailsPageWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  relatedTipsCarouselData?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sustainabilityBanner?: InputMaybe<SustainabilityBannerWhereInput>;
  titles?: InputMaybe<DictionaryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TipsAndTricksDetailsPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TipsAndTricksDetailsPageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TipsAndTricksDetailsPageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TipsAndTricksDetailsPageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TipsAndTricksDetailsPageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TipsAndTricksDetailsPage record uniquely */
export type TipsAndTricksDetailsPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
};

export type Title = Entity & Node & {
  __typename?: 'Title';
  anchorNav?: Maybe<AnchorNavigation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Title>;
  heading: Scalars['String']['output'];
  /** List of Title versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subheading?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type TitleAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TitleCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TitleDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type TitleHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type TitleMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TitlePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TitleScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type TitleUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TitleConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TitleWhereUniqueInput;
};

/** A connection to a list of items. */
export type TitleConnection = {
  __typename?: 'TitleConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TitleEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TitleCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  heading: Scalars['String']['input'];
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  subheading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TitleCreateManyInlineInput = {
  /** Connect multiple existing Title documents */
  connect?: InputMaybe<Array<TitleWhereUniqueInput>>;
  /** Create and connect multiple existing Title documents */
  create?: InputMaybe<Array<TitleCreateInput>>;
};

export type TitleCreateOneInlineInput = {
  /** Connect one existing Title document */
  connect?: InputMaybe<TitleWhereUniqueInput>;
  /** Create and connect one Title document */
  create?: InputMaybe<TitleCreateInput>;
};

/** An edge in a connection. */
export type TitleEdge = {
  __typename?: 'TitleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Title;
};

/** Identifies documents */
export type TitleManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TitleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TitleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TitleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TitleWhereStageInput>;
  documentInStages_none?: InputMaybe<TitleWhereStageInput>;
  documentInStages_some?: InputMaybe<TitleWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subheading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subheading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subheading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subheading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subheading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subheading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subheading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subheading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subheading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subheading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TitleOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subheading_ASC = 'subheading_ASC',
  subheading_DESC = 'subheading_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TitleUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  subheading?: InputMaybe<Scalars['String']['input']>;
};

export type TitleUpdateManyInlineInput = {
  /** Connect multiple existing Title documents */
  connect?: InputMaybe<Array<TitleConnectInput>>;
  /** Create and connect multiple Title documents */
  create?: InputMaybe<Array<TitleCreateInput>>;
  /** Delete multiple Title documents */
  delete?: InputMaybe<Array<TitleWhereUniqueInput>>;
  /** Disconnect multiple Title documents */
  disconnect?: InputMaybe<Array<TitleWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Title documents */
  set?: InputMaybe<Array<TitleWhereUniqueInput>>;
  /** Update multiple Title documents */
  update?: InputMaybe<Array<TitleUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Title documents */
  upsert?: InputMaybe<Array<TitleUpsertWithNestedWhereUniqueInput>>;
};

export type TitleUpdateManyInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Markets>;
  subheading?: InputMaybe<Scalars['String']['input']>;
};

export type TitleUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TitleUpdateManyInput;
  /** Document search */
  where: TitleWhereInput;
};

export type TitleUpdateOneInlineInput = {
  /** Connect existing Title document */
  connect?: InputMaybe<TitleWhereUniqueInput>;
  /** Create and connect one Title document */
  create?: InputMaybe<TitleCreateInput>;
  /** Delete currently connected Title document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Title document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Title document */
  update?: InputMaybe<TitleUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Title document */
  upsert?: InputMaybe<TitleUpsertWithNestedWhereUniqueInput>;
};

export type TitleUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TitleUpdateInput;
  /** Unique document search */
  where: TitleWhereUniqueInput;
};

export type TitleUpsertInput = {
  /** Create document if it didn't exist */
  create: TitleCreateInput;
  /** Update document if it exists */
  update: TitleUpdateInput;
};

export type TitleUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TitleUpsertInput;
  /** Unique document search */
  where: TitleWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TitleWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TitleWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TitleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TitleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TitleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TitleWhereStageInput>;
  documentInStages_none?: InputMaybe<TitleWhereStageInput>;
  documentInStages_some?: InputMaybe<TitleWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subheading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subheading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subheading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subheading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subheading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subheading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subheading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subheading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subheading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subheading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TitleWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TitleWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TitleWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TitleWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TitleWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Title record uniquely */
export type TitleWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum TwitterCardTypes {
  app = 'app',
  player = 'player',
  summary = 'summary',
  summary_large_image = 'summary_large_image'
}

/** Twitter SEO Optimization object */
export type TwitterSeo = Entity & Node & {
  __typename?: 'TwitterSeo';
  cardType: TwitterCardTypes;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<TwitterSeo>;
  globalMetaData?: Maybe<GlobalMetaData>;
  /**
   * @username for the content creator / author.
   * Only apply if applicable to the page this object is referenced in.
   */
  handle?: Maybe<Scalars['String']['output']>;
  /** List of TwitterSeo versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<TwitterSeo>;
  market: Markets;
  marketName?: Maybe<Market>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** @username for the website used in the card footer */
  site?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Twitter SEO Optimization object */
export type TwitterSeoCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Twitter SEO Optimization object */
export type TwitterSeoCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Twitter SEO Optimization object */
export type TwitterSeoDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Twitter SEO Optimization object */
export type TwitterSeoGlobalMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Twitter SEO Optimization object */
export type TwitterSeoHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Twitter SEO Optimization object */
export type TwitterSeoLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Twitter SEO Optimization object */
export type TwitterSeoMarketNameArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Twitter SEO Optimization object */
export type TwitterSeoPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Twitter SEO Optimization object */
export type TwitterSeoPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Twitter SEO Optimization object */
export type TwitterSeoScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Twitter SEO Optimization object */
export type TwitterSeoUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Twitter SEO Optimization object */
export type TwitterSeoUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TwitterSeoConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TwitterSeoWhereUniqueInput;
};

/** A connection to a list of items. */
export type TwitterSeoConnection = {
  __typename?: 'TwitterSeoConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TwitterSeoEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TwitterSeoCreateInput = {
  /** cardType input for default locale (en) */
  cardType: TwitterCardTypes;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  globalMetaData?: InputMaybe<GlobalMetaDataCreateOneInlineInput>;
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TwitterSeoCreateLocalizationsInput>;
  market: Markets;
  marketName?: InputMaybe<MarketCreateOneInlineInput>;
  site?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TwitterSeoCreateLocalizationDataInput = {
  cardType: TwitterCardTypes;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TwitterSeoCreateLocalizationInput = {
  /** Localization input */
  data: TwitterSeoCreateLocalizationDataInput;
  locale: Locale;
};

export type TwitterSeoCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TwitterSeoCreateLocalizationInput>>;
};

export type TwitterSeoCreateManyInlineInput = {
  /** Connect multiple existing TwitterSeo documents */
  connect?: InputMaybe<Array<TwitterSeoWhereUniqueInput>>;
  /** Create and connect multiple existing TwitterSeo documents */
  create?: InputMaybe<Array<TwitterSeoCreateInput>>;
};

export type TwitterSeoCreateOneInlineInput = {
  /** Connect one existing TwitterSeo document */
  connect?: InputMaybe<TwitterSeoWhereUniqueInput>;
  /** Create and connect one TwitterSeo document */
  create?: InputMaybe<TwitterSeoCreateInput>;
};

/** An edge in a connection. */
export type TwitterSeoEdge = {
  __typename?: 'TwitterSeoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TwitterSeo;
};

/** Identifies documents */
export type TwitterSeoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TwitterSeoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TwitterSeoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TwitterSeoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TwitterSeoWhereStageInput>;
  documentInStages_none?: InputMaybe<TwitterSeoWhereStageInput>;
  documentInStages_some?: InputMaybe<TwitterSeoWhereStageInput>;
  globalMetaData?: InputMaybe<GlobalMetaDataWhereInput>;
  handle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  site?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  site_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  site_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  site_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  site_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  site_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  site_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  site_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  site_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  site_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TwitterSeoOrderByInput {
  cardType_ASC = 'cardType_ASC',
  cardType_DESC = 'cardType_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  handle_ASC = 'handle_ASC',
  handle_DESC = 'handle_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  site_ASC = 'site_ASC',
  site_DESC = 'site_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TwitterSeoUpdateInput = {
  /** cardType input for default locale (en) */
  cardType?: InputMaybe<TwitterCardTypes>;
  globalMetaData?: InputMaybe<GlobalMetaDataUpdateOneInlineInput>;
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<TwitterSeoUpdateLocalizationsInput>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketUpdateOneInlineInput>;
  site?: InputMaybe<Scalars['String']['input']>;
};

export type TwitterSeoUpdateLocalizationDataInput = {
  cardType?: InputMaybe<TwitterCardTypes>;
};

export type TwitterSeoUpdateLocalizationInput = {
  data: TwitterSeoUpdateLocalizationDataInput;
  locale: Locale;
};

export type TwitterSeoUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TwitterSeoCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<TwitterSeoUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<TwitterSeoUpsertLocalizationInput>>;
};

export type TwitterSeoUpdateManyInlineInput = {
  /** Connect multiple existing TwitterSeo documents */
  connect?: InputMaybe<Array<TwitterSeoConnectInput>>;
  /** Create and connect multiple TwitterSeo documents */
  create?: InputMaybe<Array<TwitterSeoCreateInput>>;
  /** Delete multiple TwitterSeo documents */
  delete?: InputMaybe<Array<TwitterSeoWhereUniqueInput>>;
  /** Disconnect multiple TwitterSeo documents */
  disconnect?: InputMaybe<Array<TwitterSeoWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TwitterSeo documents */
  set?: InputMaybe<Array<TwitterSeoWhereUniqueInput>>;
  /** Update multiple TwitterSeo documents */
  update?: InputMaybe<Array<TwitterSeoUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TwitterSeo documents */
  upsert?: InputMaybe<Array<TwitterSeoUpsertWithNestedWhereUniqueInput>>;
};

export type TwitterSeoUpdateManyInput = {
  /** cardType input for default locale (en) */
  cardType?: InputMaybe<TwitterCardTypes>;
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<TwitterSeoUpdateManyLocalizationsInput>;
  market?: InputMaybe<Markets>;
  site?: InputMaybe<Scalars['String']['input']>;
};

export type TwitterSeoUpdateManyLocalizationDataInput = {
  cardType?: InputMaybe<TwitterCardTypes>;
};

export type TwitterSeoUpdateManyLocalizationInput = {
  data: TwitterSeoUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type TwitterSeoUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<TwitterSeoUpdateManyLocalizationInput>>;
};

export type TwitterSeoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TwitterSeoUpdateManyInput;
  /** Document search */
  where: TwitterSeoWhereInput;
};

export type TwitterSeoUpdateOneInlineInput = {
  /** Connect existing TwitterSeo document */
  connect?: InputMaybe<TwitterSeoWhereUniqueInput>;
  /** Create and connect one TwitterSeo document */
  create?: InputMaybe<TwitterSeoCreateInput>;
  /** Delete currently connected TwitterSeo document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TwitterSeo document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TwitterSeo document */
  update?: InputMaybe<TwitterSeoUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TwitterSeo document */
  upsert?: InputMaybe<TwitterSeoUpsertWithNestedWhereUniqueInput>;
};

export type TwitterSeoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TwitterSeoUpdateInput;
  /** Unique document search */
  where: TwitterSeoWhereUniqueInput;
};

export type TwitterSeoUpsertInput = {
  /** Create document if it didn't exist */
  create: TwitterSeoCreateInput;
  /** Update document if it exists */
  update: TwitterSeoUpdateInput;
};

export type TwitterSeoUpsertLocalizationInput = {
  create: TwitterSeoCreateLocalizationDataInput;
  locale: Locale;
  update: TwitterSeoUpdateLocalizationDataInput;
};

export type TwitterSeoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TwitterSeoUpsertInput;
  /** Unique document search */
  where: TwitterSeoWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TwitterSeoWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TwitterSeoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TwitterSeoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TwitterSeoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TwitterSeoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<TwitterCardTypes>;
  /** All values that are contained in given list. */
  cardType_in?: InputMaybe<Array<InputMaybe<TwitterCardTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardType_not?: InputMaybe<TwitterCardTypes>;
  /** All values that are not contained in given list. */
  cardType_not_in?: InputMaybe<Array<InputMaybe<TwitterCardTypes>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TwitterSeoWhereStageInput>;
  documentInStages_none?: InputMaybe<TwitterSeoWhereStageInput>;
  documentInStages_some?: InputMaybe<TwitterSeoWhereStageInput>;
  globalMetaData?: InputMaybe<GlobalMetaDataWhereInput>;
  handle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  marketName?: InputMaybe<MarketWhereInput>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  site?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  site_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  site_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  site_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  site_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  site_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  site_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  site_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  site_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  site_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TwitterSeoWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TwitterSeoWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TwitterSeoWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TwitterSeoWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TwitterSeoWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TwitterSeo record uniquely */
export type TwitterSeoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UnpublishLocaleInput = {
  /** Locales to unpublish */
  locale: Locale;
  /** Stages to unpublish selected locales from */
  stages: Array<Stage>;
};

/** User system model */
export type User = Entity & Node & {
  __typename?: 'User';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** Get the document in other stages */
  documentInStages: Array<User>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Flag to determine if user is active or not */
  isActive: Scalars['Boolean']['output'];
  /** User Kind. Can be either MEMBER, PAT or PUBLIC */
  kind: UserKind;
  muc: Array<MarketUserConnection>;
  /** The username */
  name: Scalars['String']['output'];
  /** Profile Picture url */
  picture?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
};


/** User system model */
export type UserDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** User system model */
export type UserMucArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<MarketUserConnectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MarketUserConnectionWhereInput>;
};

export type UserConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: UserWhereUniqueInput;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type UserCreateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserCreateOneInlineInput = {
  /** Connect one existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

/** System User Kind */
export enum UserKind {
  MEMBER = 'MEMBER',
  PAT = 'PAT',
  PUBLIC = 'PUBLIC',
  WEBHOOK = 'WEBHOOK'
}

/** Identifies documents */
export type UserManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  muc_every?: InputMaybe<MarketUserConnectionWhereInput>;
  muc_none?: InputMaybe<MarketUserConnectionWhereInput>;
  muc_some?: InputMaybe<MarketUserConnectionWhereInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum UserOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isActive_ASC = 'isActive_ASC',
  isActive_DESC = 'isActive_DESC',
  kind_ASC = 'kind_ASC',
  kind_DESC = 'kind_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  picture_ASC = 'picture_ASC',
  picture_DESC = 'picture_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type UserUpdateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Disconnect multiple User documents */
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing User documents */
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserUpdateOneInlineInput = {
  /** Connect existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
  /** Disconnect currently connected User document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** This contains a set of filters that can be used to compare values internally */
export type UserWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type UserWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  muc_every?: InputMaybe<MarketUserConnectionWhereInput>;
  muc_none?: InputMaybe<MarketUserConnectionWhereInput>;
  muc_some?: InputMaybe<MarketUserConnectionWhereInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type UserWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<UserWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References User record uniquely */
export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Validation rules for Text Input field */
export enum ValidationRules {
  age16 = 'age16',
  city = 'city',
  firstName = 'firstName',
  lastName = 'lastName',
  streetNumber = 'streetNumber',
  zipCode = 'zipCode'
}

export type Version = {
  __typename?: 'Version';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  stage: Stage;
};

export type VersionWhereInput = {
  id: Scalars['ID']['input'];
  revision: Scalars['Int']['input'];
  stage: Stage;
};

export enum VerticalAlignment {
  Bottom = 'Bottom',
  Middle = 'Middle',
  Top = 'Top'
}

export enum _FilterKind {
  AND = 'AND',
  NOT = 'NOT',
  OR = 'OR',
  contains = 'contains',
  contains_all = 'contains_all',
  contains_none = 'contains_none',
  contains_some = 'contains_some',
  ends_with = 'ends_with',
  eq = 'eq',
  eq_not = 'eq_not',
  gt = 'gt',
  gte = 'gte',
  in = 'in',
  json_path_exists = 'json_path_exists',
  json_value_recursive = 'json_value_recursive',
  lt = 'lt',
  lte = 'lte',
  not_contains = 'not_contains',
  not_ends_with = 'not_ends_with',
  not_in = 'not_in',
  not_starts_with = 'not_starts_with',
  relational_every = 'relational_every',
  relational_none = 'relational_none',
  relational_single = 'relational_single',
  relational_some = 'relational_some',
  search = 'search',
  starts_with = 'starts_with',
  union_empty = 'union_empty',
  union_every = 'union_every',
  union_none = 'union_none',
  union_single = 'union_single',
  union_some = 'union_some'
}

export enum _MutationInputFieldKind {
  enum = 'enum',
  relation = 'relation',
  richText = 'richText',
  richTextWithEmbeds = 'richTextWithEmbeds',
  scalar = 'scalar',
  union = 'union',
  virtual = 'virtual'
}

export enum _MutationKind {
  create = 'create',
  delete = 'delete',
  deleteMany = 'deleteMany',
  publish = 'publish',
  publishMany = 'publishMany',
  schedulePublish = 'schedulePublish',
  scheduleUnpublish = 'scheduleUnpublish',
  unpublish = 'unpublish',
  unpublishMany = 'unpublishMany',
  update = 'update',
  updateMany = 'updateMany',
  upsert = 'upsert'
}

export enum _OrderDirection {
  asc = 'asc',
  desc = 'desc'
}

export enum _RelationInputCardinality {
  many = 'many',
  one = 'one'
}

export enum _RelationInputKind {
  create = 'create',
  update = 'update'
}

export enum _RelationKind {
  regular = 'regular',
  union = 'union'
}

export enum _SystemDateTimeFieldVariation {
  base = 'base',
  combined = 'combined',
  localization = 'localization'
}

export type GetAnchorNavigationListQueryVariables = Exact<{
  where: AnchorNavigationListWhereUniqueInput;
}>;


export type GetAnchorNavigationListQuery = { __typename?: 'Query', anchorNavigationList?: { __typename?: 'AnchorNavigationList', id: string, anchorNavigations: Array<{ __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null }> } | null };

export type GetAnchorNavigationQueryVariables = Exact<{
  where: AnchorNavigationWhereUniqueInput;
}>;


export type GetAnchorNavigationQuery = { __typename?: 'Query', anchorNavigation?: { __typename: 'AnchorNavigation', id: string } | null };

export type GetAudioComponentQueryVariables = Exact<{
  where: AudioComponentWhereUniqueInput;
}>;


export type GetAudioComponentQuery = { __typename?: 'Query', audioComponent?: { __typename: 'AudioComponent', id: string, title?: string | null, description?: string | null, transcript?: string | null, audioFile?: { __typename?: 'Asset', url: string } | null, image: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', url: string }> }> } | null };

export type GetAuthorableContentCardQueryVariables = Exact<{
  where: AuthorableContentCardWhereUniqueInput;
}>;


export type GetAuthorableContentCardQuery = { __typename?: 'Query', authorableContentCard?: { __typename: 'AuthorableContentCard', id: string, copy: string, name: string, subtitle?: string | null, videoId?: string | null, image?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string, hero: string, tablet: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetBanner1QueryVariables = Exact<{
  where: Banner1WhereUniqueInput;
}>;


export type GetBanner1Query = { __typename?: 'Query', banner1?: { __typename: 'Banner1', id: string, superText?: string | null, title?: string | null, description?: string | null, buttonColor: ButtonColor, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, backgroundAsset?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, background: string }> } | null, upperRightCorner?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, lowerLeftCorner?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetBanner2CarouselQueryVariables = Exact<{
  where: Banner2CarouselComponentWhereUniqueInput;
}>;


export type GetBanner2CarouselQuery = { __typename?: 'Query', banner2CarouselComponent?: { __typename?: 'Banner2CarouselComponent', title?: string | null, id: string, banner2: Array<{ __typename: 'Banner2', id: string, title?: string | null, superText?: string | null, description?: string | null, buttonColor: ButtonColor, fullBleed?: boolean | null, textAlignment?: LeftRight | null, backgroundAsset?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, background: string }> } | null, mobileBackgroundAsset?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, background: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null }> } | null };

export type GetBanner2QueryVariables = Exact<{
  where: Banner2WhereUniqueInput;
}>;


export type GetBanner2Query = { __typename?: 'Query', banner2?: { __typename: 'Banner2', id: string, title?: string | null, superText?: string | null, description?: string | null, buttonColor: ButtonColor, fullBleed?: boolean | null, textAlignment?: LeftRight | null, backgroundAsset?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, background: string }> } | null, mobileBackgroundAsset?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, background: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetCarouselComponentQueryVariables = Exact<{
  where: CarouselComponentWhereUniqueInput;
}>;


export type GetCarouselComponentQuery = { __typename?: 'Query', carouselComponent?: { __typename: 'CarouselComponent', id: string, heading?: string | null, title?: string | null, slidesToShow?: number | null, carouselType: CarouselType, carouselSlides: Array<{ __typename?: 'CarouselSlide', caption?: string | null, videoId?: string | null, slideAsset?: { __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string } | null }>, topRightAsset?: { __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string } | null, bottomLeftAsset?: { __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string } | null, backgroundImg?: { __typename?: 'Asset', url: string } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetContactCardContainerQueryVariables = Exact<{
  where: ContactCardContainerWhereUniqueInput;
}>;


export type GetContactCardContainerQuery = { __typename?: 'Query', contactCardContainer?: { __typename: 'ContactCardContainer', id: string, data: Array<{ __typename?: 'ContactCard', title?: string | null, field1Label?: string | null, field1Text?: string | null, field2Label?: string | null, field2Text?: string | null, contactTypeIcon?: ContactType | null, link?: { __typename?: 'Link', id: string, url?: string | null, displayName: string } | null }>, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetCountrySelectorFooterQueryVariables = Exact<{
  where?: InputMaybe<CountrySelectorFooterWhereInput>;
}>;


export type GetCountrySelectorFooterQuery = { __typename?: 'Query', countrySelectorFooters: Array<{ __typename: 'CountrySelectorFooter', id: string, title?: string | null, countryLabel?: string | null, languageLabel?: string | null, textOnButton?: string | null, countrySelectorList: Array<{ __typename?: 'CountrySelectorItem', id: string, country: string, countryCode: string, countryFlag?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string, altText?: string | null }> } | null, language: Array<{ __typename?: 'Link', id: string, displayName: string, url?: string | null, market: Markets, openInNewTab: boolean }> }> }> };

export type GetDynamicCardGridQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where: DynamicCardGridWhereUniqueInput;
}>;


export type GetDynamicCardGridQuery = { __typename?: 'Query', dynamicCardGrid?: { __typename: 'DynamicCardGrid', id: string, subHeading?: string | null, heading?: string | null, description?: string | null, cardVariation?: CardVariation | null, cardLinkLabel?: string | null, showCards?: number | null, recipeCarouselMarkUp: boolean, gridCta?: { __typename?: 'Link', displayName: string } | null, dictionaryItem: Array<{ __typename?: 'DictionaryItem', key: string, value: string }>, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, environment: DbEnvironment, extension?: any | null, tipsAndTricks?: any | null, products?: any | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetErrorPageQueryVariables = Exact<{
  where?: InputMaybe<ErrorPageWhereInput>;
}>;


export type GetErrorPageQuery = { __typename?: 'Query', errorPages: Array<{ __typename?: 'ErrorPage', id: string, errorType: ErrorType, title?: string | null, description?: string | null, market: Markets, image?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, url: string, mimeType?: string | null }> } | null, link?: { __typename?: 'Link', id: string, displayName: string, url?: string | null } | null }> };

export type GetEvalancheFormComponentQueryVariables = Exact<{
  where: EvalancheFormComponentWhereUniqueInput;
}>;


export type GetEvalancheFormComponentQuery = { __typename?: 'Query', evalancheFormComponent?: { __typename: 'EvalancheFormComponent', evalancheHost: string, formId: string, id: string, collapsed?: boolean | null, fieldsBeforeAccordion?: number | null, fieldsAfterAccordion?: number | null, accordionTitle?: string | null, market: Markets, successMessage?: string | null, successMessageDescription?: string | null, formFileUploader?: { __typename: 'FormFileUploader', id: string, fieldName?: string | null, description?: string | null, uploadButton?: string | null, deleteButton?: string | null, successMessage?: string | null, sizeErrorMessage?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | null } | null };

export type GetExampleComponentQueryVariables = Exact<{
  where: ExampleComponentWhereUniqueInput;
}>;


export type GetExampleComponentQuery = { __typename?: 'Query', exampleComponent?: { __typename?: 'ExampleComponent', id: string, title?: string | null, imageTextAlignment?: ImageTextAlignment | null, description?: { __typename?: 'ExampleComponentDescriptionRichText', text: string, html: string } | null, assetsComponents: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, id: string, mimeType?: string | null, url: string }> }> } | null };

export type GetFeaturedContentQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where: FeaturedContentWhereUniqueInput;
}>;


export type GetFeaturedContentQuery = { __typename?: 'Query', featuredContent?: { __typename: 'FeaturedContent', id: string, title?: string | null, superText?: string | null, dictionary?: { __typename?: 'Dictionary', dictionaryItems: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> } | null, items: Array<{ __typename: 'AuthorableContentCard', id: string, copy: string, name: string, subtitle?: string | null, videoId?: string | null, image?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, mobile: string, desktop: string, hero: string, tablet: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | { __typename: 'FeaturedContentReference', id: string, title?: string | null, recipeId?: string | null }>, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetFooterQueryVariables = Exact<{
  footerNavigation?: InputMaybe<FooterNavigationWhereInput>;
  downloadApp?: InputMaybe<DownloadAppWhereInput>;
  socialMediaListComponent?: InputMaybe<SocialMediaListComponentWhereInput>;
  footerSeal?: InputMaybe<FooterSealWhereInput>;
}>;


export type GetFooterQuery = { __typename?: 'Query', footerNavigations: Array<{ __typename?: 'FooterNavigation', cmsTitle: string, footerNavType: FooterNav, socialMediaLink: boolean, id: string, links: Array<{ __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null }> }>, downloadApps: Array<{ __typename?: 'DownloadApp', heading?: string | null, description?: string | null, googlePlayAssetComponent?: { __typename?: 'AssetComponent', cmsAssetTitle?: string | null, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string }> } | null, appStoreComponent?: { __typename?: 'AssetComponent', cmsAssetTitle?: string | null, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string }> } | null, appStoreLink?: { __typename?: 'Link', displayName: string, url?: string | null } | null, googlePlayLink?: { __typename?: 'Link', displayName: string, url?: string | null } | null }>, socialMediaListComponents: Array<{ __typename?: 'SocialMediaListComponent', name: string, id: string, url: string, socialSharePosition: Array<SocialSharePosition>, assetsComponents: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string }> }> }>, footerSeals: Array<{ __typename?: 'FooterSeal', name: string, id: string, url: string, assetsComponents?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, url: string, mimeType?: string | null }> } | null }> };

export type GetFormQueryVariables = Exact<{
  where: FormWhereUniqueInput;
}>;


export type GetFormQuery = { __typename?: 'Query', form?: { __typename: 'Form', id: string, formType?: FormTypes | null, market: Markets, formFields: Array<{ __typename: 'FormCheckbox', id: string, fieldName?: string | null, label?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, title?: string | null, hidden?: boolean | null, longText?: { __typename?: 'RichText', html: string } | null } | { __typename: 'FormCheckboxCollection', id: string, requiredErrorMessage?: string | null, fieldName?: string | null, required?: boolean | null, title?: string | null, hidden?: boolean | null, formCheckboxes: Array<{ __typename?: 'FormCheckbox', fieldName?: string | null, label?: string | null, required?: boolean | null, title?: string | null }> } | { __typename: 'FormDateInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, invalidErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormEmailInput', id: string, placeholderText?: string | null, label?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormFileUploader', id: string, fieldName?: string | null, description?: string | null, uploadButton?: string | null, deleteButton?: string | null, successMessage?: string | null, sizeErrorMessage?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename: 'FormList', id: string, title?: string | null, fieldName?: string | null, isHidden: boolean, requiredErrorMessage?: string | null, formCheckboxes: Array<{ __typename?: 'FormListItem', fieldName?: string | null, label?: string | null, required?: boolean | null, checked: boolean }> } | { __typename: 'FormNumberInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormPasswordInput', id: string, label?: string | null, fieldName?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormPasswordInputWithConfirmation', id: string, title?: string | null, confirmationTitle?: string | null } | { __typename?: 'FormRadioButtonCollection', id: string, requiredErrorMessage?: string | null, required?: boolean | null, fieldName?: string | null, title?: string | null, hidden?: boolean | null, formRadioButtons: Array<{ __typename?: 'FormRadioButton', label?: string | null, option?: string | null, title?: string | null }> } | { __typename: 'FormSelectComponent', id: string, label?: string | null, fieldName?: string | null, initialValue?: string | null, hidden?: boolean | null, options: Array<{ __typename?: 'FormSelectOption', label: string, id: string, value: string }> } | { __typename: 'FormSubmitButton', id: string, buttonLoadingText?: string | null, buttonText?: string | null } | { __typename: 'FormTextInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null, date?: boolean | null, salesForceValidationRules?: ValidationRules | null } | { __typename: 'FormTextareaInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'GenericAccordion', id: string, numbered?: boolean | null, genericAccordionItems: Array<{ __typename?: 'GenericAccordionItem', id: string, title: string, alignment: AccordionContentAlignment, form: Array<{ __typename: 'Form', id: string, formType?: FormTypes | null, market: Markets, formFields: Array<{ __typename: 'FormCheckbox', id: string, fieldName?: string | null, label?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, title?: string | null, hidden?: boolean | null, longText?: { __typename?: 'RichText', html: string } | null } | { __typename: 'FormCheckboxCollection', id: string, requiredErrorMessage?: string | null, fieldName?: string | null, required?: boolean | null, title?: string | null, hidden?: boolean | null, formCheckboxes: Array<{ __typename?: 'FormCheckbox', fieldName?: string | null, label?: string | null, required?: boolean | null, title?: string | null }> } | { __typename: 'FormDateInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, invalidErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormEmailInput', id: string, placeholderText?: string | null, label?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormFileUploader', id: string, fieldName?: string | null, description?: string | null, uploadButton?: string | null, deleteButton?: string | null, successMessage?: string | null, sizeErrorMessage?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename?: 'FormList' } | { __typename: 'FormNumberInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormPasswordInput', id: string, label?: string | null, fieldName?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormPasswordInputWithConfirmation', id: string, title?: string | null, confirmationTitle?: string | null } | { __typename?: 'FormRadioButtonCollection', id: string, requiredErrorMessage?: string | null, required?: boolean | null, fieldName?: string | null, title?: string | null, hidden?: boolean | null, formRadioButtons: Array<{ __typename?: 'FormRadioButton', label?: string | null, option?: string | null, title?: string | null }> } | { __typename: 'FormSelectComponent', id: string, label?: string | null, fieldName?: string | null, initialValue?: string | null, hidden?: boolean | null, options: Array<{ __typename?: 'FormSelectOption', label: string, id: string, value: string }> } | { __typename: 'FormSubmitButton', id: string, buttonLoadingText?: string | null, buttonText?: string | null } | { __typename: 'FormTextInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null, date?: boolean | null, salesForceValidationRules?: ValidationRules | null } | { __typename: 'FormTextareaInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null } | { __typename?: 'GenericAccordion' } | { __typename?: 'LongText' }>, formErrors: Array<{ __typename?: 'FormError', id: string, message?: string | null, errorCode?: number | null }>, formSuccess?: { __typename?: 'FormSuccessComponent', id: string, message: string, description?: string | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null }> }>, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | { __typename: 'LongText', id: string, longText?: { __typename?: 'LongTextLongTextRichText', text: string, html: string } | null }>, formErrors: Array<{ __typename?: 'FormError', id: string, message?: string | null, errorCode?: number | null }>, formSuccess?: { __typename?: 'FormSuccessComponent', id: string, message: string, description?: string | null, components: Array<{ __typename: 'DynamicCardGrid', id: string } | { __typename: 'GenericCardCarouseComponent', id: string } | { __typename: 'GenericGridAuthorable', id: string }> } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, upperRightCorner?: { __typename?: 'Asset', url: string } | null, lowerLeftCorner?: { __typename?: 'Asset', url: string } | null } | null };

export type CheckboxFragmentFragment = { __typename: 'FormCheckbox', id: string, fieldName?: string | null, label?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, title?: string | null, hidden?: boolean | null, longText?: { __typename?: 'RichText', html: string } | null };

export type CheckboxCollectionFragmentFragment = { __typename: 'FormCheckboxCollection', id: string, requiredErrorMessage?: string | null, fieldName?: string | null, required?: boolean | null, title?: string | null, hidden?: boolean | null, formCheckboxes: Array<{ __typename?: 'FormCheckbox', fieldName?: string | null, label?: string | null, required?: boolean | null, title?: string | null }> };

export type DateFragmentFragment = { __typename: 'FormDateInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, invalidErrorMessage?: string | null, hidden?: boolean | null };

export type EmailFragmentFragment = { __typename: 'FormEmailInput', id: string, placeholderText?: string | null, label?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null };

export type FileUploadFragmentFragment = { __typename: 'FormFileUploader', id: string, fieldName?: string | null, description?: string | null, uploadButton?: string | null, deleteButton?: string | null, successMessage?: string | null, sizeErrorMessage?: string | null, required?: boolean | null, requiredErrorMessage?: string | null };

export type FormFragmentFragment = { __typename: 'Form', id: string, formType?: FormTypes | null, market: Markets, formFields: Array<{ __typename: 'FormCheckbox', id: string, fieldName?: string | null, label?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, title?: string | null, hidden?: boolean | null, longText?: { __typename?: 'RichText', html: string } | null } | { __typename: 'FormCheckboxCollection', id: string, requiredErrorMessage?: string | null, fieldName?: string | null, required?: boolean | null, title?: string | null, hidden?: boolean | null, formCheckboxes: Array<{ __typename?: 'FormCheckbox', fieldName?: string | null, label?: string | null, required?: boolean | null, title?: string | null }> } | { __typename: 'FormDateInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, invalidErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormEmailInput', id: string, placeholderText?: string | null, label?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormFileUploader', id: string, fieldName?: string | null, description?: string | null, uploadButton?: string | null, deleteButton?: string | null, successMessage?: string | null, sizeErrorMessage?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename: 'FormList', id: string, title?: string | null, fieldName?: string | null, isHidden: boolean, requiredErrorMessage?: string | null, formCheckboxes: Array<{ __typename?: 'FormListItem', fieldName?: string | null, label?: string | null, required?: boolean | null, checked: boolean }> } | { __typename: 'FormNumberInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormPasswordInput', id: string, label?: string | null, fieldName?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormPasswordInputWithConfirmation', id: string, title?: string | null, confirmationTitle?: string | null } | { __typename?: 'FormRadioButtonCollection', id: string, requiredErrorMessage?: string | null, required?: boolean | null, fieldName?: string | null, title?: string | null, hidden?: boolean | null, formRadioButtons: Array<{ __typename?: 'FormRadioButton', label?: string | null, option?: string | null, title?: string | null }> } | { __typename: 'FormSelectComponent', id: string, label?: string | null, fieldName?: string | null, initialValue?: string | null, hidden?: boolean | null, options: Array<{ __typename?: 'FormSelectOption', label: string, id: string, value: string }> } | { __typename: 'FormSubmitButton', id: string, buttonLoadingText?: string | null, buttonText?: string | null } | { __typename: 'FormTextInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null, date?: boolean | null, salesForceValidationRules?: ValidationRules | null } | { __typename: 'FormTextareaInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'GenericAccordion', id: string, numbered?: boolean | null, genericAccordionItems: Array<{ __typename?: 'GenericAccordionItem', id: string, title: string, alignment: AccordionContentAlignment, form: Array<{ __typename: 'Form', id: string, formType?: FormTypes | null, market: Markets, formFields: Array<{ __typename: 'FormCheckbox', id: string, fieldName?: string | null, label?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, title?: string | null, hidden?: boolean | null, longText?: { __typename?: 'RichText', html: string } | null } | { __typename: 'FormCheckboxCollection', id: string, requiredErrorMessage?: string | null, fieldName?: string | null, required?: boolean | null, title?: string | null, hidden?: boolean | null, formCheckboxes: Array<{ __typename?: 'FormCheckbox', fieldName?: string | null, label?: string | null, required?: boolean | null, title?: string | null }> } | { __typename: 'FormDateInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, invalidErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormEmailInput', id: string, placeholderText?: string | null, label?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormFileUploader', id: string, fieldName?: string | null, description?: string | null, uploadButton?: string | null, deleteButton?: string | null, successMessage?: string | null, sizeErrorMessage?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename?: 'FormList' } | { __typename: 'FormNumberInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormPasswordInput', id: string, label?: string | null, fieldName?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormPasswordInputWithConfirmation', id: string, title?: string | null, confirmationTitle?: string | null } | { __typename?: 'FormRadioButtonCollection', id: string, requiredErrorMessage?: string | null, required?: boolean | null, fieldName?: string | null, title?: string | null, hidden?: boolean | null, formRadioButtons: Array<{ __typename?: 'FormRadioButton', label?: string | null, option?: string | null, title?: string | null }> } | { __typename: 'FormSelectComponent', id: string, label?: string | null, fieldName?: string | null, initialValue?: string | null, hidden?: boolean | null, options: Array<{ __typename?: 'FormSelectOption', label: string, id: string, value: string }> } | { __typename: 'FormSubmitButton', id: string, buttonLoadingText?: string | null, buttonText?: string | null } | { __typename: 'FormTextInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null, date?: boolean | null, salesForceValidationRules?: ValidationRules | null } | { __typename: 'FormTextareaInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null } | { __typename?: 'GenericAccordion' } | { __typename?: 'LongText' }>, formErrors: Array<{ __typename?: 'FormError', id: string, message?: string | null, errorCode?: number | null }>, formSuccess?: { __typename?: 'FormSuccessComponent', id: string, message: string, description?: string | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null }> }>, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | { __typename: 'LongText', id: string, longText?: { __typename?: 'LongTextLongTextRichText', text: string, html: string } | null }>, formErrors: Array<{ __typename?: 'FormError', id: string, message?: string | null, errorCode?: number | null }>, formSuccess?: { __typename?: 'FormSuccessComponent', id: string, message: string, description?: string | null, components: Array<{ __typename: 'DynamicCardGrid', id: string } | { __typename: 'GenericCardCarouseComponent', id: string } | { __typename: 'GenericGridAuthorable', id: string }> } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, upperRightCorner?: { __typename?: 'Asset', url: string } | null, lowerLeftCorner?: { __typename?: 'Asset', url: string } | null };

export type ListFragmentFragment = { __typename: 'FormList', id: string, title?: string | null, fieldName?: string | null, isHidden: boolean, requiredErrorMessage?: string | null, formCheckboxes: Array<{ __typename?: 'FormListItem', fieldName?: string | null, label?: string | null, required?: boolean | null, checked: boolean }> };

export type LongTextFragmentFragment = { __typename: 'LongText', id: string, longText?: { __typename?: 'LongTextLongTextRichText', text: string, html: string } | null };

export type NumberFragmentFragment = { __typename: 'FormNumberInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null };

export type PasswordFragmentFragment = { __typename: 'FormPasswordInput', id: string, label?: string | null, fieldName?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null };

export type PasswordConfirmationFragmentFragment = { __typename: 'FormPasswordInputWithConfirmation', id: string, title?: string | null, confirmationTitle?: string | null };

export type RadioCollectionFragmentFragment = { __typename?: 'FormRadioButtonCollection', id: string, requiredErrorMessage?: string | null, required?: boolean | null, fieldName?: string | null, title?: string | null, hidden?: boolean | null, formRadioButtons: Array<{ __typename?: 'FormRadioButton', label?: string | null, option?: string | null, title?: string | null }> };

export type SelectFragmentFragment = { __typename: 'FormSelectComponent', id: string, label?: string | null, fieldName?: string | null, initialValue?: string | null, hidden?: boolean | null, options: Array<{ __typename?: 'FormSelectOption', label: string, id: string, value: string }> };

export type SubmitButtonFragmentFragment = { __typename: 'FormSubmitButton', id: string, buttonLoadingText?: string | null, buttonText?: string | null };

export type TextFragmentFragment = { __typename: 'FormTextInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null, date?: boolean | null, salesForceValidationRules?: ValidationRules | null };

export type TextareaFragmentFragment = { __typename: 'FormTextareaInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null };

export type LinkFragmentFragment = { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null };

export type PromotionFormFragmentFragment = { __typename?: 'PromotionForm', internationalPromotionId: string, externalToolId?: string | null, brand: Brand, countryCode: Countries, campaignType?: CampaignTypes | null, promotionType?: PromotionType | null, language: Languages, title: string, description?: string | null, submitSuccessTitle: string, submitSuccessDescription?: string | null, submitButtonText: string, startDate: any, endDate: any, legalCheckboxRequired?: boolean | null, showLegalCheckbox?: boolean | null, showSalutationField?: boolean | null, showBirthdateField?: boolean | null, showMobileNumberField?: boolean | null, showHomeNumberField?: boolean | null, showAddressField?: boolean | null, showGenderField?: boolean | null, newsletterSubscriptions?: { __typename?: 'NewsletterSubscriptions', subscriptions: Array<{ __typename?: 'FormOption', label: string, value: string }> } | null, legalText?: { __typename?: 'RichText', html: string } | null };

export type TeaserFieldsFragment = { __typename: 'Teaser', id: string, title?: string | null, heading?: string | null, description?: string | null, startDate: any, endDate: any, image?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, topRated?: boolean | null, environment: DbEnvironment, extension?: any | null, products?: any | null } | null };

export type TeaserSmallFieldsFragment = { __typename: 'TeaserSmall', id: string, heading?: string | null, description?: string | null, startDate: any, endDate: any, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null };

export type GetGenericAccordionTopRatedQueryVariables = Exact<{
  where: GenericAccordionTopRatedWhereUniqueInput;
}>;


export type GetGenericAccordionTopRatedQuery = { __typename?: 'Query', genericAccordionTopRated?: { __typename: 'GenericAccordionTopRated', id: string, title?: string | null, super?: string | null, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, topRated?: boolean | null, environment: DbEnvironment, extension?: any | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetGenericAccordionQueryVariables = Exact<{
  where: GenericAccordionWhereUniqueInput;
}>;


export type GetGenericAccordionQuery = { __typename?: 'Query', genericAccordion?: { __typename: 'GenericAccordion', id: string, numbered?: boolean | null, genericAccordionItems: Array<{ __typename?: 'GenericAccordionItem', id: string, title: string, alignment: AccordionContentAlignment, collapsed?: boolean | null, text?: { __typename?: 'GenericAccordionItemTextRichText', html: string } | null, image?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, form: Array<{ __typename: 'Form', id: string, formType?: FormTypes | null, market: Markets, formFields: Array<{ __typename: 'FormCheckbox', id: string, fieldName?: string | null, label?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, title?: string | null } | { __typename: 'FormCheckboxCollection', id: string, requiredErrorMessage?: string | null, fieldName?: string | null, required?: boolean | null, title?: string | null, formCheckboxes: Array<{ __typename?: 'FormCheckbox', fieldName?: string | null, label?: string | null, required?: boolean | null, title?: string | null }> } | { __typename: 'FormDateInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, invalidErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormEmailInput', id: string, placeholderText?: string | null, label?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename?: 'FormFileUploader' } | { __typename?: 'FormList' } | { __typename: 'FormNumberInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename: 'FormPasswordInput', id: string, label?: string | null, fieldName?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename: 'FormPasswordInputWithConfirmation', id: string, title?: string | null, confirmationTitle?: string | null } | { __typename?: 'FormRadioButtonCollection', id: string, requiredErrorMessage?: string | null, required?: boolean | null, fieldName?: string | null, title?: string | null, formRadioButtons: Array<{ __typename?: 'FormRadioButton', label?: string | null, option?: string | null, title?: string | null }> } | { __typename: 'FormSelectComponent', id: string, label?: string | null, fieldName?: string | null, initialValue?: string | null, options: Array<{ __typename?: 'FormSelectOption', label: string, id: string, value: string }> } | { __typename: 'FormSubmitButton', id: string, buttonLoadingText?: string | null, buttonText?: string | null } | { __typename: 'FormTextInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null, date?: boolean | null, salesForceValidationRules?: ValidationRules | null } | { __typename: 'FormTextareaInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename?: 'GenericAccordion' } | { __typename?: 'LongText' }>, formErrors: Array<{ __typename?: 'FormError', id: string, message?: string | null, errorCode?: number | null }>, formSuccess?: { __typename?: 'FormSuccessComponent', id: string, message: string, description?: string | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null }> }>, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetGenericGridAuthorableQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where: GenericGridAuthorableWhereUniqueInput;
}>;


export type GetGenericGridAuthorableQuery = { __typename?: 'Query', genericGridAuthorable?: { __typename: 'GenericGridAuthorable', id: string, title?: string | null, superText?: string | null, regularLayout?: boolean | null, recipeCarouselMarkUp: boolean, dictionary?: { __typename?: 'Dictionary', dictionaryItems: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> } | null, cards: Array<{ __typename: 'AuthorableContentCard', id: string, copy: string, name: string, subtitle?: string | null, videoId?: string | null, image?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, mobile: string, desktop: string, hero: string, tablet: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | { __typename: 'FeaturedContentReference', id: string, title?: string | null, recipeId?: string | null, tipsAndTricksId?: string | null, articlePage?: { __typename?: 'GenericPage', slug?: string | null, title: string, id: string } | null }> } | null };

export type GetGenericCardCarouseComponentQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where: GenericCardCarouseComponentWhereUniqueInput;
}>;


export type GetGenericCardCarouseComponentQuery = { __typename?: 'Query', genericCardCarouseComponent?: { __typename: 'GenericCardCarouseComponent', id: string, key?: string | null, subHeading?: string | null, heading?: string | null, cardVariation?: CardVariation | null, buttonColor: ButtonColor, pointCtaToArticlesList?: boolean | null, componentBackground: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string }> }>, floatingObject: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string, altText?: string | null }> }>, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, environment: DbEnvironment, extension?: any | null, tipsAndTricks?: any | null, products?: any | null } | null, dictionaryItem: Array<{ __typename?: 'DictionaryItem', key: string, value: string }>, genericCardCarouselCta?: { __typename?: 'Link', displayName: string, url?: string | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, articles: Array<{ __typename: 'GenericPage', slug?: string | null, subPath?: string | null, title: string, id: string, type: GenericPagesTypes, metaData?: { __typename?: 'MetaData', id: string, images: Array<{ __typename?: 'Asset', url: string, width?: number | null, height?: number | null }> } | null, pageComponents: Array<{ __typename?: 'AnchorNav' } | { __typename?: 'AnchorNavigationList' } | { __typename?: 'AudioComponent' } | { __typename?: 'AuthorableContentCard' } | { __typename?: 'Banner1' } | { __typename?: 'Banner2' } | { __typename?: 'Banner2CarouselComponent' } | { __typename?: 'CarouselComponent' } | { __typename?: 'ContactCardContainer' } | { __typename?: 'DynamicCardGrid' } | { __typename?: 'EvalancheFormComponent' } | { __typename?: 'ExampleComponent' } | { __typename?: 'FeaturedContent' } | { __typename?: 'Form' } | { __typename?: 'GenericAccordion' } | { __typename?: 'GenericAccordionTopRated' } | { __typename?: 'GenericCardCarouseComponent' } | { __typename?: 'GenericDownloadComponent' } | { __typename?: 'GenericFollowUs' } | { __typename?: 'GenericGridAuthorable' } | { __typename?: 'GenericHtml' } | { __typename?: 'GenericLine' } | { __typename?: 'GenericPromotionsOverview' } | { __typename?: 'GenericQualifio' } | { __typename?: 'GenericQualifioOverview' } | { __typename?: 'GenericSocialShare' } | { __typename?: 'GlobalSearch' } | { __typename?: 'GridColumn' } | { __typename?: 'GridColumnComponent' } | { __typename?: 'HeroCarouselComponent' } | { __typename?: 'HeroComponent' } | { __typename?: 'HeroLoopAnimationComponent' } | { __typename?: 'Iframe' } | { __typename?: 'ImageCopy' } | { __typename: 'IntroText', title?: string | null, id: string } | { __typename?: 'Link' } | { __typename?: 'LongText' } | { __typename?: 'MultiStepPromotionForm' } | { __typename?: 'NewsletterComponent' } | { __typename?: 'PageFooter' } | { __typename?: 'PageHeader' } | { __typename?: 'ProductBanner' } | { __typename?: 'Question' } | { __typename?: 'Separator' } | { __typename?: 'Spacer' } | { __typename?: 'Tab' } | { __typename?: 'TestComponentWithRecipeQuery' }> }>, products: Array<{ __typename: 'Product', id: string, createdAt: any, updatedAt: any, slug?: string | null, productTitle: string, productDietList: Array<string>, fillingQuantity?: string | null, metaKeywords?: string | null, productImage?: { __typename?: 'Asset', url: string, mimeType?: string | null, mobile: string, desktop: string } | null }> } | null, readMoreText?: { __typename?: 'DictionaryItem', value: string } | null };

export type GetGenericDownloadComponentQueryVariables = Exact<{
  where: GenericDownloadComponentWhereUniqueInput;
}>;


export type GetGenericDownloadComponentQuery = { __typename?: 'Query', genericDownloadComponent?: { __typename: 'GenericDownloadComponent', id: string, superText: string, title: string, body: string, downloadableFile: { __typename?: 'Asset', url: string }, assetComponent?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, desktop: string, mobile: string }> } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetGenericFollowUsQueryVariables = Exact<{
  where: GenericFollowUsWhereUniqueInput;
}>;


export type GetGenericFollowUsQuery = { __typename?: 'Query', genericFollowUs?: { __typename: 'GenericFollowUs', id: string, super?: string | null, title?: string | null, socialMedia: Array<{ __typename?: 'SocialMediaListComponent', name: string, url: string, assetsComponents: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, id: string, mimeType?: string | null, url: string }> }> }>, middlegroundImage?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, url: string }> } | null, foregroundImage?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, url: string }> } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetGenericHtmlQueryVariables = Exact<{
  where: GenericHtmlWhereUniqueInput;
}>;


export type GetGenericHtmlQuery = { __typename?: 'Query', genericHtml?: { __typename: 'GenericHtml', html: string, id: string } | null };

export type GetGenericLineQueryVariables = Exact<{
  where: GenericLineWhereUniqueInput;
}>;


export type GetGenericLineQuery = { __typename?: 'Query', genericLine?: { __typename: 'GenericLine', enableLine?: boolean | null, id: string } | null };

export type GetGenericPageQueryVariables = Exact<{
  where?: InputMaybe<GenericPageWhereInput>;
}>;


export type GetGenericPageQuery = { __typename?: 'Query', genericPages: Array<{ __typename?: 'GenericPage', slug?: string | null, hideNavigation?: boolean | null, isContactUsPage: boolean, title: string, contentGroupingTrackingValue?: ContentGrouping1 | null, contentGroupingTrackingValues?: ContentGrouping2 | null, type: GenericPagesTypes, cookieBannerRequired?: boolean | null, theme?: Themes | null, savePromotionAnswers?: boolean | null, metaData?: { __typename?: 'MetaData', id: string, pageName: string, description?: string | null, openGraphType?: string | null, images: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, url: string }> } | null, dictionary?: { __typename?: 'Dictionary', dictionaryItems: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> } | null, pageComponents: Array<{ __typename?: 'AnchorNav' } | { __typename: 'AnchorNavigationList', id: string } | { __typename: 'AudioComponent', id: string } | { __typename: 'AuthorableContentCard', id: string } | { __typename: 'Banner1', id: string } | { __typename: 'Banner2', id: string } | { __typename: 'Banner2CarouselComponent', id: string } | { __typename: 'CarouselComponent', id: string } | { __typename: 'ContactCardContainer', id: string } | { __typename: 'DynamicCardGrid', id: string } | { __typename: 'EvalancheFormComponent', id: string } | { __typename: 'ExampleComponent', id: string } | { __typename: 'FeaturedContent', id: string } | { __typename: 'Form', id: string } | { __typename: 'GenericAccordion', id: string } | { __typename: 'GenericAccordionTopRated', id: string } | { __typename: 'GenericCardCarouseComponent', id: string } | { __typename: 'GenericDownloadComponent', id: string } | { __typename: 'GenericFollowUs', id: string } | { __typename: 'GenericGridAuthorable', id: string } | { __typename: 'GenericHtml', id: string } | { __typename: 'GenericLine', id: string } | { __typename: 'GenericPromotionsOverview', id: string } | { __typename: 'GenericQualifio', id: string } | { __typename?: 'GenericQualifioOverview' } | { __typename: 'GenericSocialShare', id: string } | { __typename: 'GlobalSearch', id: string } | { __typename: 'GridColumn', id: string } | { __typename: 'GridColumnComponent', id: string } | { __typename: 'HeroCarouselComponent', id: string } | { __typename: 'HeroComponent', id: string } | { __typename: 'HeroLoopAnimationComponent', id: string } | { __typename: 'Iframe', id: string } | { __typename: 'ImageCopy', id: string } | { __typename: 'IntroText', id: string } | { __typename: 'Link', id: string } | { __typename: 'LongText', id: string } | { __typename: 'MultiStepPromotionForm', id: string } | { __typename: 'NewsletterComponent', id: string } | { __typename?: 'PageFooter' } | { __typename?: 'PageHeader' } | { __typename: 'ProductBanner', id: string } | { __typename: 'Question', id: string } | { __typename: 'Separator', id: string } | { __typename: 'Spacer', id: string } | { __typename: 'Tab', id: string } | { __typename: 'TestComponentWithRecipeQuery', id: string }>, teaserPlaceholders: Array<{ __typename?: 'TeaserPlaceholder', id: string, title?: string | null, teasers: Array<{ __typename: 'Teaser', id: string, title?: string | null, heading?: string | null, description?: string | null, startDate: any, endDate: any, image?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, topRated?: boolean | null, environment: DbEnvironment, extension?: any | null, products?: any | null } | null }> }>, teaserSmallPlaceholders: Array<{ __typename?: 'TeaserSmallPlaceholder', id: string, title?: string | null, teaserSmalls: Array<{ __typename: 'TeaserSmall', id: string, heading?: string | null, description?: string | null, startDate: any, endDate: any, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null }> }> }> };

export type GetGenericPagesSlugsQueryVariables = Exact<{
  where?: InputMaybe<GenericPageWhereInput>;
  first: Scalars['Int']['input'];
}>;


export type GetGenericPagesSlugsQuery = { __typename?: 'Query', genericPages: Array<{ __typename?: 'GenericPage', slug?: string | null, subPath?: string | null, type: GenericPagesTypes }> };

export type GetContactGenericPageQueryVariables = Exact<{
  where?: InputMaybe<GenericPageWhereInput>;
}>;


export type GetContactGenericPageQuery = { __typename?: 'Query', genericPages: Array<{ __typename?: 'GenericPage', slug?: string | null, subPath?: string | null, isContactUsPage: boolean }> };

export type GetGenericPromotionsOverviewQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  id: Scalars['ID']['input'];
  market: Markets;
}>;


export type GetGenericPromotionsOverviewQuery = { __typename?: 'Query', genericPromotionsOverviews: Array<{ __typename: 'GenericPromotionsOverview', id: string, title: string, subTitle?: string | null }>, genericPages: Array<{ __typename: 'GenericPage', id: string, slug?: string | null, showInPromotionsOverview: boolean, title?: string | null, copy?: string | null, image?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, mobile: string, desktop: string, hero: string, tablet: string }> } | null }>, genericQualifios: Array<{ __typename: 'GenericQualifio', id: string, genericPages: Array<{ __typename?: 'GenericPage', slug?: string | null }> }>, learnMoreText?: { __typename?: 'DictionaryItem', value: string } | null };

export type GetGenericQualifioQueryVariables = Exact<{
  where: GenericQualifioWhereUniqueInput;
}>;


export type GetGenericQualifioQuery = { __typename?: 'Query', genericQualifio?: { __typename: 'GenericQualifio', widgetCode: string, id: string } | null };

export type GetGenericSocialShareQueryVariables = Exact<{
  where: GenericSocialShareWhereUniqueInput;
}>;


export type GetGenericSocialShareQuery = { __typename?: 'Query', genericSocialShare?: { __typename: 'GenericSocialShare', id: string, buttonLabel: string, socialMediaList: Array<{ __typename?: 'SocialMediaListComponent', id: string, name: string, shareMsg?: string | null, socialMediaComponentName?: SocialMediaComponentName | null, assetsComponents: Array<{ __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, id: string, mimeType?: string | null, url: string }> }> }> } | null };

export type GetGlobalMetadataQueryVariables = Exact<{
  where: GlobalMetaDataWhereUniqueInput;
}>;


export type GetGlobalMetadataQuery = { __typename?: 'Query', globalMetaData?: { __typename?: 'GlobalMetaData', siteName: string, url: string, titleTemplate?: string | null, description?: string | null, facebookAppId?: string | null, favicon?: { __typename?: 'Asset', url: string } | null, appleTouchIcon?: { __typename?: 'Asset', url: string } | null, image?: { __typename?: 'Asset', url: string, height?: number | null, width?: number | null } | null, twitterSeo?: { __typename?: 'TwitterSeo', handle?: string | null, site?: string | null, cardType: TwitterCardTypes } | null, logo?: { __typename?: 'Asset', url: string, height?: number | null, width?: number | null } | null } | null };

export type GetGlobalSearchQueryVariables = Exact<{
  where: GlobalSearchWhereUniqueInput;
}>;


export type GetGlobalSearchQuery = { __typename?: 'Query', globalSearch?: { __typename: 'GlobalSearch', id: string, superText?: string | null, title?: string | null, backgroundAsset?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, background: string }> } | null, backgroundAssetMobile?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, background: string }> } | null, rightAsset?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, leftAsset?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null } | null };

export type GetGridColumnComponentQueryVariables = Exact<{
  where: GridColumnComponentWhereUniqueInput;
}>;


export type GetGridColumnComponentQuery = { __typename?: 'Query', gridColumnComponent?: { __typename: 'GridColumnComponent', id: string, description?: string | null, heading?: string | null, subHeading?: string | null, column?: Column | null, gridMetaball: boolean, assetComponent?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string, altText?: string | null }> } | null, cardData: Array<{ __typename?: 'ImageAndTextCard', subHeading?: string | null, title?: string | null, description?: string | null, parentPage?: string | null, metaBall?: boolean | null, image?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, desktop: string, mobile: string }> } | null, buttonLink?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null }> } | null };

export type GetGridColumnQueryVariables = Exact<{
  where: GridColumnWhereUniqueInput;
}>;


export type GetGridColumnQuery = { __typename?: 'Query', gridColumn?: { __typename: 'GridColumn', id: string, description?: string | null, heading?: string | null, subHeading?: string | null, column?: Column | null, gridMetaball: boolean, assetComponent?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string, altText?: string | null }> } | null, cardData: Array<{ __typename?: 'ImageAndTextCard', subHeading?: string | null, title?: string | null, description?: string | null, parentPage?: string | null, metaBall?: boolean | null, image?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, desktop: string, mobile: string }> } | null, buttonLink?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null }> } | null };

export type GetHeaderQueryVariables = Exact<{
  where?: InputMaybe<NavigationWhereInput>;
}>;


export type GetHeaderQuery = { __typename?: 'Query', navigations: Array<{ __typename?: 'Navigation', cmsTitle?: string | null, positon: NavigationTypes, key: string, navUrl?: string | null, cardComponentTitle?: string | null, links: Array<{ __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null }>, category: Array<{ __typename?: 'NavigationItem', title?: string | null, targetLink?: string | null, trackingSecondaryNavigation?: string | null, category_link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, subCategory: Array<{ __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null }> }>, navigation_images: Array<{ __typename?: 'AssetComponent', cmsAssetTitle?: string | null, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string, desktop: string, mobile: string }> }>, navCard?: { __typename?: 'CardComponent', cardId: string, category: string, categoryId: string, description?: string | null, difficulty?: string | null, preparationTime?: string | null, rating?: string | null, title: string, video?: string | null, cardVariation?: CardVariation | null, parentPage?: string | null, parentCategory?: string | null, linkTitle?: string | null, image: Array<{ __typename?: 'AssetComponent', id: string, cmsAssetTitle?: string | null, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string, altText?: string | null, desktop: string, mobile: string }> }>, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null } | null }> };

export type GetMobileHeaderQueryVariables = Exact<{
  where: MobileOnlyMainNavigationWhereUniqueInput;
}>;


export type GetMobileHeaderQuery = { __typename?: 'Query', mobileOnlyMainNavigation?: { __typename?: 'MobileOnlyMainNavigation', navigationAsset: Array<{ __typename?: 'AssetComponent', id: string, cmsAssetTitle?: string | null, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, altText?: string | null, mimeType?: string | null, url: string, desktop: string, mobile: string }> }> } | null };

export type GetHeroCarouselComponentQueryVariables = Exact<{
  where: HeroCarouselComponentWhereUniqueInput;
}>;


export type GetHeroCarouselComponentQuery = { __typename?: 'Query', heroCarouselComponent?: { __typename: 'HeroCarouselComponent', id: string, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, banners: Array<{ __typename?: 'HeroBanner', bannerSize?: BannerHeight | null, bannerTitle?: string | null, superText?: string | null, bannerDescriptionText?: string | null, bannerVideoUrl?: string | null, alignment?: AlignmentTypes | null, verticalAlignment?: VerticalAlignment | null, verticalAlignmentMobile?: VerticalAlignment | null, textColor: HeroBannerTextColor, buttonColor: ButtonColor, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, bannerImage: Array<{ __typename?: 'Asset', mimeType?: string | null, imageAlt?: string | null, desktop: string, mobile: string }>, mobileImage?: { __typename?: 'Asset', mimeType?: string | null, mobile: string } | null }>, bannerMasterbrands: Array<{ __typename?: 'HeroBannerMasterbrand', bannerSize: BannerHeight, bannerTitle?: string | null, bannerSubtitle: string, superText?: string | null, bannerDescriptionText?: string | null, bannerVideoUrl?: string | null, alignment?: AlignmentTypes | null, verticalAlignment?: VerticalAlignment | null, verticalAlignmentMobile?: VerticalAlignment | null, textColor: HeroBannerTextColor, buttonColor: ButtonColor, showOverlay: boolean, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, bannerImage: Array<{ __typename?: 'Asset', mimeType?: string | null, imageAlt?: string | null, desktop: string, mobile: string }>, mobileImage?: { __typename?: 'Asset', mimeType?: string | null, mobile: string } | null }> } | null };

export type GetHeroLoopAnimationComponentQueryVariables = Exact<{
  where: HeroLoopAnimationComponentWhereUniqueInput;
}>;


export type GetHeroLoopAnimationComponentQuery = { __typename?: 'Query', heroLoopAnimationComponent?: { __typename: 'HeroLoopAnimationComponent', id: string, videoSource1: { __typename?: 'Asset', fileName: string, size?: number | null, url: string, mimeType?: string | null }, videoSource2?: { __typename?: 'Asset', fileName: string, size?: number | null, url: string, mimeType?: string | null } | null } | null };

export type GetHeroComponentQueryVariables = Exact<{
  where: HeroComponentWhereUniqueInput;
}>;


export type GetHeroComponentQuery = { __typename?: 'Query', heroComponent?: { __typename: 'HeroComponent', id: string, superText?: string | null, title?: string | null, description?: string | null, alignment?: AlignmentTypes | null, verticalAlignment?: VerticalAlignment | null, verticalAlignmentMobile?: VerticalAlignment | null, textColor: HeroBannerTextColor, imageComponent?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, topRightImageAsset?: { __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string } | null, bottomLeftImageAsset?: { __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string } | null, mobileImage?: { __typename?: 'Asset', mimeType?: string | null, mobile: string } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetIframeQueryVariables = Exact<{
  where: IframeWhereUniqueInput;
}>;


export type GetIframeQuery = { __typename?: 'Query', iframe?: { __typename: 'Iframe', id: string, cmsTitle?: string | null, iframeUrl: string, iframeType: IframeTypes, iframeWidth: string, iframeHeight: string, alignment?: IFrameAlignment | null } | null };

export type GetImageCopyQueryVariables = Exact<{
  where: ImageCopyWhereUniqueInput;
}>;


export type GetImageCopyQuery = { __typename?: 'Query', imageCopy?: { __typename: 'ImageCopy', id: string, topRightAsset?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string }> } | null, bottomLeftAsset?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string }> } | null, imageCopyItem: Array<{ __typename?: 'ImageCopyItem', id: string, title?: string | null, columnType?: ColumnType | null, addImage?: boolean | null, imagePosition?: DisplayPosition | null, addTitle?: boolean | null, addVideo?: boolean | null, videoPosition?: DisplayPosition | null, addDescription: boolean, videoId?: string | null, description?: { __typename?: 'RichText', html: string } | null, image: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, altText?: string | null, mimeType?: string | null, desktop: string, mobile: string }> }>, videoPosterImage?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null }>, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetIntroTextQueryVariables = Exact<{
  where: IntroTextWhereUniqueInput;
}>;


export type GetIntroTextQuery = { __typename?: 'Query', introText?: { __typename: 'IntroText', id: string, super?: string | null, title?: string | null, titleTag?: Headlines | null, description?: string | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetLinkQueryVariables = Exact<{
  where: LinkWhereUniqueInput;
}>;


export type GetLinkQuery = { __typename?: 'Query', link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null };

export type GetLongTextQueryVariables = Exact<{
  where: LongTextWhereUniqueInput;
}>;


export type GetLongTextQuery = { __typename?: 'Query', longText?: { __typename: 'LongText', id: string, horizontalAlignment: AlignmentTypes, longText?: { __typename?: 'LongTextLongTextRichText', text: string, html: string, json: any } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetMultiStepPromotionFormQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where: MultiStepPromotionFormWhereUniqueInput;
}>;


export type GetMultiStepPromotionFormQuery = { __typename?: 'Query', multiStepPromotionForm?: { __typename: 'MultiStepPromotionForm', id: string, showOnlyDownloadButton?: boolean | null, footerLinks: Array<{ __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null }>, steps: Array<{ __typename?: 'MultiStepPromotionFormStep', title: string, description?: string | null, image: { __typename?: 'Asset', width?: number | null, height?: number | null, altText?: string | null, url: string, mimeType?: string | null }, formField?: { __typename: 'MultiStepPromotionFormCheckboxes', title: string, requiredErrorMessage?: string | null, checkboxes: Array<{ __typename?: 'FormOption', label: string, value: string }> } | { __typename: 'MultiStepPromotionFormRadio', title: string, requiredErrorMessage?: string | null, radios: Array<{ __typename?: 'FormOption', label: string, value: string }> } | null }>, promotionForm?: { __typename?: 'PromotionForm', internationalPromotionId: string, externalToolId?: string | null, brand: Brand, countryCode: Countries, campaignType?: CampaignTypes | null, promotionType?: PromotionType | null, language: Languages, title: string, description?: string | null, submitSuccessTitle: string, submitSuccessDescription?: string | null, submitButtonText: string, startDate: any, endDate: any, legalCheckboxRequired?: boolean | null, showLegalCheckbox?: boolean | null, showSalutationField?: boolean | null, showBirthdateField?: boolean | null, showMobileNumberField?: boolean | null, showHomeNumberField?: boolean | null, showAddressField?: boolean | null, showGenderField?: boolean | null, newsletterSubscriptions?: { __typename?: 'NewsletterSubscriptions', subscriptions: Array<{ __typename?: 'FormOption', label: string, value: string }> } | null, legalText?: { __typename?: 'RichText', html: string } | null } | null, promotionDownload?: { __typename?: 'PromotionDownload', id: string, localizations: Array<{ __typename?: 'PromotionDownload', buttonText: string }>, file: { __typename?: 'Asset', id: string, url: string, fileName: string } } | null } | null, translations?: { __typename?: 'Dictionary', dictionaryItems: Array<{ __typename?: 'DictionaryItem', value: string, key: string }> } | null, salutationTranslations?: { __typename?: 'Dictionary', dictionaryItems: Array<{ __typename?: 'DictionaryItem', value: string, key: string }> } | null, genderTranslations?: { __typename?: 'Dictionary', dictionaryItems: Array<{ __typename?: 'DictionaryItem', value: string, key: string }> } | null };

export type GetNewsletterQueryVariables = Exact<{
  where?: InputMaybe<NewsletterComponentWhereInput>;
}>;


export type GetNewsletterQuery = { __typename?: 'Query', newsletterComponents: Array<{ __typename: 'NewsletterComponent', id: string, title?: string | null, description?: string | null, formNewsletter: Array<{ __typename: 'Form', id: string, formType?: FormTypes | null, market: Markets, formFields: Array<{ __typename: 'FormCheckbox', id: string, fieldName?: string | null, label?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, title?: string | null, longText?: { __typename?: 'RichText', html: string } | null } | { __typename: 'FormCheckboxCollection', id: string, requiredErrorMessage?: string | null, fieldName?: string | null, required?: boolean | null, title?: string | null, formCheckboxes: Array<{ __typename?: 'FormCheckbox', fieldName?: string | null, label?: string | null, required?: boolean | null, title?: string | null }> } | { __typename: 'FormDateInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, invalidErrorMessage?: string | null, hidden?: boolean | null, salesForceValidationRules?: ValidationRules | null } | { __typename: 'FormEmailInput', id: string, placeholderText?: string | null, label?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename?: 'FormFileUploader' } | { __typename?: 'FormList' } | { __typename: 'FormNumberInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename: 'FormPasswordInput', id: string, label?: string | null, fieldName?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename: 'FormPasswordInputWithConfirmation', id: string, title?: string | null, confirmationTitle?: string | null } | { __typename?: 'FormRadioButtonCollection', id: string, requiredErrorMessage?: string | null, required?: boolean | null, fieldName?: string | null, title?: string | null, formRadioButtons: Array<{ __typename?: 'FormRadioButton', label?: string | null, option?: string | null, title?: string | null }> } | { __typename: 'FormSelectComponent', id: string, label?: string | null, fieldName?: string | null, initialValue?: string | null, options: Array<{ __typename?: 'FormSelectOption', label: string, id: string, value: string }> } | { __typename: 'FormSubmitButton', id: string, buttonLoadingText?: string | null, buttonText?: string | null } | { __typename: 'FormTextInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null, date?: boolean | null, salesForceValidationRules?: ValidationRules | null } | { __typename: 'FormTextareaInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename: 'GenericAccordion', id: string, numbered?: boolean | null, genericAccordionItems: Array<{ __typename?: 'GenericAccordionItem', id: string, title: string, alignment: AccordionContentAlignment, form: Array<{ __typename: 'Form', id: string, formType?: FormTypes | null, market: Markets, formFields: Array<{ __typename: 'FormCheckbox', id: string, fieldName?: string | null, label?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, title?: string | null } | { __typename: 'FormCheckboxCollection', id: string, requiredErrorMessage?: string | null, fieldName?: string | null, required?: boolean | null, title?: string | null, formCheckboxes: Array<{ __typename?: 'FormCheckbox', fieldName?: string | null, label?: string | null, required?: boolean | null, title?: string | null }> } | { __typename: 'FormDateInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, invalidErrorMessage?: string | null, hidden?: boolean | null } | { __typename: 'FormEmailInput', id: string, placeholderText?: string | null, label?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename?: 'FormFileUploader' } | { __typename?: 'FormList' } | { __typename: 'FormNumberInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename: 'FormPasswordInput', id: string, label?: string | null, fieldName?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename: 'FormPasswordInputWithConfirmation', id: string, title?: string | null, confirmationTitle?: string | null } | { __typename?: 'FormRadioButtonCollection', id: string, requiredErrorMessage?: string | null, required?: boolean | null, fieldName?: string | null, title?: string | null, formRadioButtons: Array<{ __typename?: 'FormRadioButton', label?: string | null, option?: string | null, title?: string | null }> } | { __typename: 'FormSelectComponent', id: string, label?: string | null, fieldName?: string | null, initialValue?: string | null, options: Array<{ __typename?: 'FormSelectOption', label: string, id: string, value: string }> } | { __typename: 'FormSubmitButton', id: string, buttonLoadingText?: string | null, buttonText?: string | null } | { __typename: 'FormTextInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, hidden?: boolean | null, date?: boolean | null, salesForceValidationRules?: ValidationRules | null } | { __typename: 'FormTextareaInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename?: 'GenericAccordion' } | { __typename?: 'LongText' }>, formErrors: Array<{ __typename?: 'FormError', id: string, message?: string | null, errorCode?: number | null }>, formSuccess?: { __typename?: 'FormSuccessComponent', id: string, message: string, description?: string | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null }> }>, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | { __typename: 'LongText', id: string, longText?: { __typename?: 'LongTextLongTextRichText', text: string, html: string } | null }>, formErrors: Array<{ __typename?: 'FormError', id: string, message?: string | null, errorCode?: number | null }>, formSuccess?: { __typename?: 'FormSuccessComponent', id: string, message: string, description?: string | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null }> }> };

export type GetNotificationBannerQueryVariables = Exact<{
  where?: InputMaybe<NotificationBannerWhereInput>;
}>;


export type GetNotificationBannerQuery = { __typename?: 'Query', notificationBanners: Array<{ __typename: 'NotificationBanner', id: string, active?: boolean | null, cmsTitle: string, title?: string | null, description?: string | null, bannerType?: BannerType | null, link?: { __typename?: 'Link', displayName: string, url?: string | null, openInNewTab: boolean, id: string } | null }> };

export type GetPageFooterQueryVariables = Exact<{
  where: PageFooterWhereInput;
}>;


export type GetPageFooterQuery = { __typename?: 'Query', pageFooters: Array<{ __typename?: 'PageFooter', id: string, footerImage?: { __typename: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null }> };

export type GetPopularSearchComponentsQueryVariables = Exact<{
  where?: InputMaybe<PopularSearchComponentWhereInput>;
}>;


export type GetPopularSearchComponentsQuery = { __typename?: 'Query', popularSearchComponents: Array<{ __typename?: 'PopularSearchComponent', subHeading?: string | null, heading?: string | null, indices?: string | null, dictionary?: { __typename?: 'Dictionary', dictionaryItems: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> } | null, assetsComponents: Array<{ __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string, altText?: string | null }> }> }> };

export type GetProductBannerQueryVariables = Exact<{
  where: ProductBannerWhereUniqueInput;
}>;


export type GetProductBannerQuery = { __typename?: 'Query', productBanner?: { __typename: 'ProductBanner', id: string, category?: string | null, description?: string | null, buttonColor: ButtonColor, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, product?: { __typename?: 'Product', slug?: string | null, productTitle: string, productImage?: { __typename?: 'Asset', mimeType?: string | null, desktop: string, mobile: string } | null } | null, backgroundImage?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, id: string, mimeType?: string | null, desktop: string, mobile: string }> } | null, toolImage?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, id: string, mimeType?: string | null, desktop: string, mobile: string }> } | null, staticMetaball?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, id: string, mimeType?: string | null, url: string }> } | null, link?: { __typename?: 'Link', id: string, displayName: string, url?: string | null } | null } | null };

export type GetProductLandingPageQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where: ProductLandingPageWhereUniqueInput;
}>;


export type GetProductLandingPageQuery = { __typename?: 'Query', productLandingPage?: { __typename?: 'ProductLandingPage', heroComponent?: { __typename: 'HeroComponent', id: string, superText?: string | null, title?: string | null, description?: string | null, alignment?: AlignmentTypes | null, verticalAlignment?: VerticalAlignment | null, verticalAlignmentMobile?: VerticalAlignment | null, textColor: HeroBannerTextColor, imageComponent?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, imageAlt?: string | null, url: string, desktop: string, mobile: string }> } | null, mobileImage?: { __typename?: 'Asset', mimeType?: string | null, mobile: string } | null, topRightImageAsset?: { __typename?: 'Asset', width?: number | null, mimeType?: string | null, height?: number | null, url: string, desktop: string, mobile: string } | null, bottomLeftImageAsset?: { __typename?: 'Asset', width?: number | null, mimeType?: string | null, height?: number | null, url: string, desktop: string, mobile: string } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null, anchorNavigationList?: { __typename?: 'AnchorNavigationList', id: string, anchorNavigations: Array<{ __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null, externalComponent: Array<AnchorNavigationExternalComponents> }> } | null, featuredContent?: { __typename: 'FeaturedContent', id: string, title?: string | null, superText?: string | null, dictionary?: { __typename?: 'Dictionary', dictionaryItems: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> } | null, items: Array<{ __typename: 'AuthorableContentCard', id: string, copy: string, name: string, subtitle?: string | null, videoId?: string | null, image?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, id: string, url: string, mimeType?: string | null, mobile: string, desktop: string, hero: string, tablet: string }> } | null, link?: { __typename?: 'Link', id: string, url?: string | null, displayName: string } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | { __typename: 'FeaturedContentReference', id: string, title?: string | null, recipeId?: string | null }>, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null, genericCardCarouselComponent?: { __typename: 'GenericCardCarouseComponent', id: string, key?: string | null, subHeading?: string | null, heading?: string | null, cardVariation?: CardVariation | null, componentBackground: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string }> }>, floatingObject: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string, altText?: string | null }> }>, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, environment: DbEnvironment, extension?: any | null, tipsAndTricks?: any | null } | null, dictionaryItem: Array<{ __typename?: 'DictionaryItem', key: string, value: string }>, genericCardCarouselCta?: { __typename?: 'Link', displayName: string, url?: string | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null, productCategoryPages: Array<{ __typename?: 'ProductCategoryPage', id: string, stage: Stage, updatedAt: any, cmsTitle?: string | null, productCategoryName?: string | null, documentInStages: Array<{ __typename?: 'ProductCategoryPage', id: string, stage: Stage, updatedAt: any, publishedAt?: any | null }> }>, teaserPlaceholders: Array<{ __typename?: 'TeaserPlaceholder', id: string, title?: string | null, teasers: Array<{ __typename: 'Teaser', id: string, title?: string | null, heading?: string | null, description?: string | null, startDate: any, endDate: any, image?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, topRated?: boolean | null, environment: DbEnvironment, extension?: any | null, products?: any | null } | null }> }>, teaserSmallPlaceholders: Array<{ __typename?: 'TeaserSmallPlaceholder', id: string, title?: string | null, teaserSmalls: Array<{ __typename: 'TeaserSmall', id: string, heading?: string | null, description?: string | null, startDate: any, endDate: any, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null }> }> } | null };

export type ListOfProductsSlugsQueryVariables = Exact<{
  where?: InputMaybe<ProductWhereInput>;
  first: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
}>;


export type ListOfProductsSlugsQuery = { __typename?: 'Query', productsConnection: { __typename?: 'ProductConnection', edges: Array<{ __typename?: 'ProductEdge', node: { __typename?: 'Product', slug?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, pageSize?: number | null } } };

export type GetProductCategorySlugsQueryVariables = Exact<{
  where?: InputMaybe<ProductCategoryPageWhereInput>;
  first: Scalars['Int']['input'];
}>;


export type GetProductCategorySlugsQuery = { __typename?: 'Query', productCategoryPages: Array<{ __typename?: 'ProductCategoryPage', slug?: string | null, productSubcategoryPages: Array<{ __typename?: 'ProductSubcategoryPage', slug?: string | null, shouldBeIndexed: boolean, subSubcategoryPages: Array<{ __typename?: 'ProductSubcategoryPage', slug?: string | null }> }> }> };

export type GetProductBySlugQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where: ProductWhereInput;
}>;


export type GetProductBySlugQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', slug?: string | null, id: string, productTitle: string, metaDescription?: string | null, metaKeywords?: string | null, gtin?: string | null, productDescription: string, preparationInstructions?: string | null, fillingQuantity?: string | null, ingredients?: string | null, nutrientInformation?: string | null, packagingInformation?: string | null, cookingTips: Array<string>, productPageURL?: string | null, nutriScore?: string | null, categories: Array<{ __typename?: 'ProductCategory', slug?: string | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, shouldBeIndexed: boolean, subcategoryPageName?: string | null, subBrand?: boolean | null, logo?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string }> } | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null, productCategoryName?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, subcategoryPageName?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null, productCategoryName?: string | null } | null } | null } | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null }>, productImage?: { __typename?: 'Asset', mimeType?: string | null, url: string, width?: number | null, height?: number | null, mobile: string, desktop: string } | null, lifestyleImage?: { __typename?: 'Asset', mimeType?: string | null, url: string, width?: number | null, height?: number | null, mobile: string, desktop: string, full: string } | null, labels?: { __typename?: 'Dictionary', dictionaryItems: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> } | null, productLabels: Array<{ __typename?: 'ProductLabel', identifier: string, imageUrl: string, translations?: { __typename?: 'DictionaryItem', key: string, value: string } | null }> }> };

export type GetProductCmsDataQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  market: Markets;
}>;


export type GetProductCmsDataQuery = { __typename?: 'Query', productDetailPages: Array<{ __typename?: 'ProductDetailPage', id: string, nutriScorePopupTitle?: string | null, isActiveNutrition: boolean, isActiveIngredients: boolean, titles?: { __typename?: 'Dictionary', dictionaryItems: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> } | null, productHero?: { __typename?: 'ProductHero', blobBackgroundTexture?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', url: string, width?: number | null, height?: number | null, mimeType?: string | null }> } | null, tipSectionBackground?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, url: string, mimeType?: string | null, full: string, desktop: string, mobile: string }> } | null } | null, teaserPlaceholders: Array<{ __typename?: 'TeaserPlaceholder', id: string, title?: string | null, teasers: Array<{ __typename: 'Teaser', id: string, title?: string | null, heading?: string | null, description?: string | null, startDate: any, endDate: any, image?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, topRated?: boolean | null, environment: DbEnvironment, extension?: any | null, products?: any | null } | null }> }>, teaserSmallPlaceholders: Array<{ __typename?: 'TeaserSmallPlaceholder', id: string, title?: string | null, teaserSmalls: Array<{ __typename: 'TeaserSmall', id: string, heading?: string | null, description?: string | null, startDate: any, endDate: any, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null }> }>, nutriScorePopupDescription?: { __typename?: 'RichText', html: string } | null }> };

export type GetProductsQueryVariables = Exact<{
  where?: InputMaybe<ProductWhereInput>;
}>;


export type GetProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', slug?: string | null, productTitle: string, id: string, productImage?: { __typename?: 'Asset', width?: number | null, height?: number | null, url: string } | null }> };

export type GetProductsLandingPageQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  productLandingPage: ProductLandingPageWhereUniqueInput;
  productCategoryPages?: InputMaybe<ProductCategoryPageWhereInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageWhereInput>;
}>;


export type GetProductsLandingPageQuery = { __typename?: 'Query', productLandingPage?: { __typename: 'ProductLandingPage', id: string, slug?: string | null, metaData?: { __typename?: 'MetaData', id: string, pageName: string, description?: string | null, openGraphType?: string | null, theme?: string | null, images: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, url: string }> } | null, introText?: { __typename: 'IntroText', id: string, super?: string | null, title?: string | null, titleTag?: Headlines | null, description?: string | null } | null, anchorNavigationList?: { __typename?: 'AnchorNavigationList', id: string, anchorNavigations: Array<{ __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null, externalComponent: Array<AnchorNavigationExternalComponents> }> } | null, pageComponents: Array<{ __typename?: 'Accordion' } | { __typename: 'Banner1', id: string } | { __typename: 'Banner2', id: string } | { __typename: 'Banner2CarouselComponent', id: string } | { __typename: 'CarouselComponent', id: string } | { __typename?: 'DownloadApp' } | { __typename: 'DynamicCardGrid', id: string } | { __typename: 'FeaturedContent', id: string } | { __typename: 'GenericAccordion', id: string } | { __typename: 'GenericCardCarouseComponent', id: string } | { __typename: 'GenericDownloadComponent', id: string } | { __typename: 'GenericFollowUs', id: string } | { __typename: 'GenericGridAuthorable', id: string } | { __typename: 'GenericHtml', id: string } | { __typename: 'GlobalSearch', id: string } | { __typename: 'HeroCarouselComponent', id: string } | { __typename: 'Iframe', id: string } | { __typename: 'LongText', id: string } | { __typename: 'ProductBanner', id: string } | { __typename: 'Spacer', id: string }>, productCategoryPages: Array<{ __typename: 'ProductCategoryPage', id: string, productCategoryName?: string | null, slug?: string | null, keyImage?: { __typename?: 'Asset', mimeType?: string | null, mobile: string, desktop: string } | null, promoImage?: { __typename?: 'Asset', mimeType?: string | null, mobile: string, desktop: string } | null, productSubcategoryPages: Array<{ __typename: 'ProductSubcategoryPage', id: string, slug?: string | null, subBrand?: boolean | null, subcategoryPageName?: string | null, keyImage?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, mobile: string, desktop: string }> } | null, promoImage?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, mobile: string, desktop: string }> } | null, subSubcategoryPages: Array<{ __typename: 'ProductSubcategoryPage', id: string, subSubCategoryTitle?: string | null, productCategories: Array<{ __typename: 'ProductCategory', id: string, products: Array<{ __typename: 'Product', id: string }> }> }>, productCategories: Array<{ __typename: 'ProductCategory', categoryName?: string | null, id: string, products: Array<{ __typename?: 'Product', slug?: string | null }> }> }>, productCategories: Array<{ __typename: 'ProductCategory', categoryName?: string | null, id: string, products: Array<{ __typename?: 'Product', slug?: string | null }> }> }>, teaserPlaceholders: Array<{ __typename?: 'TeaserPlaceholder', id: string, title?: string | null, teasers: Array<{ __typename: 'Teaser', id: string, title?: string | null, heading?: string | null, description?: string | null, startDate: any, endDate: any, image?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, topRated?: boolean | null, environment: DbEnvironment, extension?: any | null, products?: any | null } | null }> }>, teaserSmallPlaceholders: Array<{ __typename?: 'TeaserSmallPlaceholder', id: string, title?: string | null, teaserSmalls: Array<{ __typename: 'TeaserSmall', id: string, heading?: string | null, description?: string | null, startDate: any, endDate: any, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null }> }> } | null, learnMoreText?: { __typename?: 'DictionaryItem', value: string } | null, productsText?: { __typename?: 'DictionaryItem', value: string } | null };

export type GetProductCategoryPagesQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  productCategoryPages?: InputMaybe<ProductCategoryPageWhereInput>;
  productSubcategoryPages?: InputMaybe<ProductSubcategoryPageWhereInput>;
}>;


export type GetProductCategoryPagesQuery = { __typename?: 'Query', productCategoryPages: Array<{ __typename: 'ProductCategoryPage', id: string, slug?: string | null, productCategoryName?: string | null, productGridTitle: string, productSubcategorySuper?: string | null, productSubcategoryTitle?: string | null, productSubcategoryPages: Array<{ __typename: 'ProductSubcategoryPage', id: string, slug?: string | null, subBrand?: boolean | null, subcategoryPageName?: string | null, shortDescription?: string | null, primarySubBrandColor?: { __typename?: 'Color', hex: any } | null, keyImage?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string, mobile: string, desktop: string, full: string }> } | null, keyImageMobile?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string, mobile: string, desktop: string, full: string }> } | null, logo?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, mimeType?: string | null, height?: number | null, url: string }> } | null, subSubcategoryPages: Array<{ __typename: 'ProductSubcategoryPage', id: string, productCategories: Array<{ __typename: 'ProductCategory', id: string, categoryName?: string | null, products: Array<{ __typename: 'Product', id: string, createdAt: any, updatedAt: any, slug?: string | null, productTitle: string, productDietList: Array<string>, fillingQuantity?: string | null, metaKeywords?: string | null, productImage?: { __typename?: 'Asset', url: string, mimeType?: string | null, mobile: string, desktop: string } | null }> }> }>, productCategoryPage?: { __typename?: 'ProductCategoryPage', id: string, productCategoryName?: string | null } | null, productCategories: Array<{ __typename: 'ProductCategory', categoryName?: string | null, id: string, products: Array<{ __typename: 'Product', id: string, createdAt: any, updatedAt: any, slug?: string | null, productTitle: string, productDietList: Array<string>, fillingQuantity?: string | null, metaKeywords?: string | null, productImage?: { __typename?: 'Asset', url: string, mimeType?: string | null, mobile: string, desktop: string } | null }> }> }>, metaData?: { __typename?: 'MetaData', id: string, pageName: string, description?: string | null, openGraphType?: string | null, theme?: string | null, images: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, url: string }> } | null, heroCarouselComponent?: { __typename: 'HeroCarouselComponent', id: string, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, banners: Array<{ __typename?: 'HeroBanner', bannerSize?: BannerHeight | null, bannerTitle?: string | null, superText?: string | null, bannerDescriptionText?: string | null, bannerVideoUrl?: string | null, alignment?: AlignmentTypes | null, verticalAlignment?: VerticalAlignment | null, verticalAlignmentMobile?: VerticalAlignment | null, link?: { __typename?: 'Link', url?: string | null, displayName: string, openInNewTab: boolean, id: string } | null, bannerImage: Array<{ __typename?: 'Asset', url: string, mimeType?: string | null, imageAlt?: string | null, desktop: string, mobile: string }>, mobileImage?: { __typename?: 'Asset', url: string, mimeType?: string | null, mobile: string } | null }>, bannerMasterbrands: Array<{ __typename?: 'HeroBannerMasterbrand', bannerSize: BannerHeight, bannerTitle?: string | null, bannerSubtitle: string, superText?: string | null, bannerDescriptionText?: string | null, bannerVideoUrl?: string | null, alignment?: AlignmentTypes | null, verticalAlignment?: VerticalAlignment | null, verticalAlignmentMobile?: VerticalAlignment | null, textColor: HeroBannerTextColor, buttonColor: ButtonColor, showOverlay: boolean, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, bannerImage: Array<{ __typename?: 'Asset', mimeType?: string | null, imageAlt?: string | null, desktop: string, mobile: string }>, mobileImage?: { __typename?: 'Asset', mimeType?: string | null, mobile: string } | null }> } | null, introText?: { __typename: 'IntroText', id: string, super?: string | null, title?: string | null, titleTag?: Headlines | null, description?: string | null } | null, pageComponents: Array<{ __typename?: 'Accordion' } | { __typename: 'Banner1', id: string } | { __typename: 'Banner2', id: string } | { __typename: 'Banner2CarouselComponent', id: string } | { __typename: 'CarouselComponent', id: string } | { __typename?: 'DownloadApp' } | { __typename: 'DynamicCardGrid', id: string } | { __typename: 'FeaturedContent', id: string } | { __typename: 'GenericAccordion', id: string } | { __typename: 'GenericAccordionTopRated', id: string } | { __typename: 'GenericCardCarouseComponent', id: string } | { __typename: 'GenericDownloadComponent', id: string } | { __typename: 'GenericFollowUs', id: string } | { __typename: 'GenericGridAuthorable', id: string } | { __typename: 'GenericHtml', id: string } | { __typename: 'GlobalSearch', id: string } | { __typename: 'HeroCarouselComponent', id: string } | { __typename: 'Iframe', id: string } | { __typename: 'ImageCopy', id: string } | { __typename: 'LongText', id: string } | { __typename: 'ProductBanner', id: string } | { __typename: 'Spacer', id: string }>, ingredientAccentColor?: { __typename?: 'Color', hex: any } | null, backgroundIngredientImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null, mimeType?: string | null, mobile: string, desktop: string } | null, foregroundIngredientImage?: { __typename?: 'Asset', url: string, mimeType?: string | null, width?: number | null, height?: number | null, altText?: string | null, mobile: string, desktop: string } | null, productCategories: Array<{ __typename: 'ProductCategory', id: string, products: Array<{ __typename: 'Product', id: string, createdAt: any, updatedAt: any, slug?: string | null, productTitle: string, productDietList: Array<string>, productImage?: { __typename?: 'Asset', url: string, mimeType?: string | null, mobile: string, desktop: string } | null }> }>, teaserPlaceholders: Array<{ __typename?: 'TeaserPlaceholder', id: string, title?: string | null, teasers: Array<{ __typename: 'Teaser', id: string, title?: string | null, heading?: string | null, description?: string | null, startDate: any, endDate: any, image?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, topRated?: boolean | null, environment: DbEnvironment, extension?: any | null, products?: any | null } | null }> }>, teaserSmallPlaceholders: Array<{ __typename?: 'TeaserSmallPlaceholder', id: string, title?: string | null, teaserSmalls: Array<{ __typename: 'TeaserSmall', id: string, heading?: string | null, description?: string | null, startDate: any, endDate: any, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null }> }> }>, learnMoreText?: { __typename?: 'DictionaryItem', value: string } | null, productsText?: { __typename?: 'DictionaryItem', value: string } | null };

export type GetProductsSubCategoryQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where?: InputMaybe<ProductSubcategoryPageWhereInput>;
}>;


export type GetProductsSubCategoryQuery = { __typename?: 'Query', productSubcategoryPages: Array<{ __typename: 'ProductSubcategoryPage', slug?: string | null, subcategoryPageName?: string | null, productGridTitle?: string | null, subSubCategorySuper?: string | null, subSubCategoryTitle?: string | null, metaData?: { __typename?: 'MetaData', id: string, pageName: string, description?: string | null, openGraphType?: string | null, theme?: string | null, images: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, url: string }> } | null, primarySubBrandColor?: { __typename?: 'Color', hex: any } | null, secondarySubBrandColor?: { __typename?: 'Color', hex: any } | null, heroCarouselComponent?: { __typename: 'HeroCarouselComponent', id: string, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, banners: Array<{ __typename?: 'HeroBanner', bannerSize?: BannerHeight | null, bannerTitle?: string | null, superText?: string | null, bannerDescriptionText?: string | null, bannerVideoUrl?: string | null, alignment?: AlignmentTypes | null, verticalAlignment?: VerticalAlignment | null, verticalAlignmentMobile?: VerticalAlignment | null, link?: { __typename?: 'Link', url?: string | null, displayName: string, openInNewTab: boolean, id: string } | null, bannerImage: Array<{ __typename?: 'Asset', url: string, mimeType?: string | null, imageAlt?: string | null, desktop: string, mobile: string }>, mobileImage?: { __typename?: 'Asset', url: string, mimeType?: string | null, mobile: string } | null }>, bannerMasterbrands: Array<{ __typename?: 'HeroBannerMasterbrand', bannerSize: BannerHeight, bannerTitle?: string | null, bannerSubtitle: string, superText?: string | null, bannerDescriptionText?: string | null, bannerVideoUrl?: string | null, alignment?: AlignmentTypes | null, verticalAlignment?: VerticalAlignment | null, verticalAlignmentMobile?: VerticalAlignment | null, textColor: HeroBannerTextColor, buttonColor: ButtonColor, showOverlay: boolean, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, bannerImage: Array<{ __typename?: 'Asset', mimeType?: string | null, imageAlt?: string | null, desktop: string, mobile: string }>, mobileImage?: { __typename?: 'Asset', mimeType?: string | null, mobile: string } | null }> } | null, introText?: { __typename: 'IntroText', id: string, super?: string | null, title?: string | null, titleTag?: Headlines | null, description?: string | null } | null, pageComponents: Array<{ __typename?: 'Accordion' } | { __typename: 'Banner1', id: string } | { __typename: 'Banner2', id: string } | { __typename: 'Banner2CarouselComponent', id: string } | { __typename: 'CarouselComponent', id: string } | { __typename?: 'DownloadApp' } | { __typename: 'DynamicCardGrid', id: string } | { __typename: 'FeaturedContent', id: string } | { __typename: 'GenericAccordion', id: string } | { __typename: 'GenericAccordionTopRated', id: string } | { __typename: 'GenericCardCarouseComponent', id: string } | { __typename: 'GenericDownloadComponent', id: string } | { __typename: 'GenericFollowUs', id: string } | { __typename: 'GenericGridAuthorable', id: string } | { __typename: 'GenericHtml', id: string } | { __typename: 'GlobalSearch', id: string } | { __typename: 'HeroCarouselComponent', id: string } | { __typename: 'Iframe', id: string } | { __typename: 'ImageCopy', id: string } | { __typename: 'LongText', id: string } | { __typename?: 'MultiStepPromotionForm' } | { __typename: 'ProductBanner', id: string } | { __typename: 'Spacer', id: string }>, subSubcategoryPages: Array<{ __typename: 'ProductSubcategoryPage', id: string, subcategoryPageName?: string | null, slug?: string | null, subBrand?: boolean | null, keyImage?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, url: string, mimeType?: string | null, desktop: string, hero: string, mobile: string }> } | null, productCategories: Array<{ __typename: 'ProductCategory', id: string, categoryName?: string | null, products: Array<{ __typename: 'Product', id: string, createdAt: any, updatedAt: any, slug?: string | null, productTitle: string, productDietList: Array<string>, fillingQuantity?: string | null, metaKeywords?: string | null, productImage?: { __typename?: 'Asset', url: string, mimeType?: string | null, mobile: string, desktop: string } | null }> }> }>, productCategories: Array<{ __typename: 'ProductCategory', id: string, products: Array<{ __typename: 'Product', id: string, createdAt: any, updatedAt: any, slug?: string | null, productTitle: string, productDietList: Array<string>, fillingQuantity?: string | null, metaKeywords?: string | null, productImage?: { __typename?: 'Asset', url: string, mimeType?: string | null, mobile: string, desktop: string } | null }> }>, productCategoryPage?: { __typename?: 'ProductCategoryPage', productCategoryName?: string | null, slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, subcategoryPageName?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null, productCategoryName?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | null }>, productsText?: { __typename?: 'DictionaryItem', value: string } | null };

export type GetProductsSubCategoryPagesQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  subCategorySlug: Scalars['String']['input'];
  categorySlug: Scalars['String']['input'];
  market: Markets;
}>;


export type GetProductsSubCategoryPagesQuery = { __typename?: 'Query', productCategoryPages: Array<{ __typename?: 'ProductCategoryPage', slug?: string | null, id: string, market: Markets, productCategoryName?: string | null, productSubcategoryPages: Array<{ __typename: 'ProductSubcategoryPage', slug?: string | null, shouldBeIndexed: boolean, subcategoryPageName?: string | null, productGridTitle?: string | null, subSubCategorySuper?: string | null, subSubCategoryTitle?: string | null, productCategories: Array<{ __typename: 'ProductCategory', id: string, products: Array<{ __typename: 'Product', id: string, createdAt: any, updatedAt: any, slug?: string | null, productTitle: string, productDietList: Array<string>, fillingQuantity?: string | null, metaKeywords?: string | null, productImage?: { __typename?: 'Asset', url: string, mimeType?: string | null, mobile: string, desktop: string } | null }> }>, metaData?: { __typename?: 'MetaData', id: string, pageName: string, sectionName?: string | null, description?: string | null, openGraphType?: string | null, theme?: string | null, images: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, url: string }> } | null, primarySubBrandColor?: { __typename?: 'Color', hex: any } | null, secondarySubBrandColor?: { __typename?: 'Color', hex: any } | null, heroCarouselComponent?: { __typename: 'HeroCarouselComponent', id: string, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, banners: Array<{ __typename?: 'HeroBanner', bannerSize?: BannerHeight | null, bannerTitle?: string | null, superText?: string | null, bannerDescriptionText?: string | null, bannerVideoUrl?: string | null, alignment?: AlignmentTypes | null, verticalAlignment?: VerticalAlignment | null, verticalAlignmentMobile?: VerticalAlignment | null, link?: { __typename?: 'Link', url?: string | null, displayName: string, openInNewTab: boolean, id: string } | null, bannerImage: Array<{ __typename?: 'Asset', url: string, mimeType?: string | null, imageAlt?: string | null, desktop: string, mobile: string }>, mobileImage?: { __typename?: 'Asset', url: string, mimeType?: string | null, mobile: string } | null }>, bannerMasterbrands: Array<{ __typename?: 'HeroBannerMasterbrand', bannerSize: BannerHeight, bannerTitle?: string | null, bannerSubtitle: string, superText?: string | null, bannerDescriptionText?: string | null, bannerVideoUrl?: string | null, alignment?: AlignmentTypes | null, verticalAlignment?: VerticalAlignment | null, verticalAlignmentMobile?: VerticalAlignment | null, textColor: HeroBannerTextColor, buttonColor: ButtonColor, showOverlay: boolean, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, bannerImage: Array<{ __typename?: 'Asset', mimeType?: string | null, imageAlt?: string | null, desktop: string, mobile: string }>, mobileImage?: { __typename?: 'Asset', mimeType?: string | null, mobile: string } | null }> } | null, introText?: { __typename: 'IntroText', id: string, super?: string | null, title?: string | null, titleTag?: Headlines | null, description?: string | null } | null, pageComponents: Array<{ __typename?: 'Accordion' } | { __typename: 'Banner1', id: string } | { __typename: 'Banner2', id: string } | { __typename: 'Banner2CarouselComponent', id: string } | { __typename: 'CarouselComponent', id: string } | { __typename?: 'DownloadApp' } | { __typename: 'DynamicCardGrid', id: string } | { __typename: 'FeaturedContent', id: string } | { __typename: 'GenericAccordion', id: string } | { __typename: 'GenericAccordionTopRated', id: string } | { __typename: 'GenericCardCarouseComponent', id: string } | { __typename: 'GenericDownloadComponent', id: string } | { __typename: 'GenericFollowUs', id: string } | { __typename: 'GenericGridAuthorable', id: string } | { __typename: 'GenericHtml', id: string } | { __typename: 'GlobalSearch', id: string } | { __typename: 'HeroCarouselComponent', id: string } | { __typename: 'Iframe', id: string } | { __typename: 'ImageCopy', id: string } | { __typename: 'LongText', id: string } | { __typename?: 'MultiStepPromotionForm' } | { __typename: 'ProductBanner', id: string } | { __typename: 'Spacer', id: string }>, subSubcategoryPages: Array<{ __typename: 'ProductSubcategoryPage', id: string, subcategoryPageName?: string | null, slug?: string | null, subBrand?: boolean | null, keyImage?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string, desktop: string, hero: string, mobile: string }> } | null, productCategories: Array<{ __typename: 'ProductCategory', id: string, categoryName?: string | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', subcategoryPageName?: string | null } | null, products: Array<{ __typename: 'Product', id: string, createdAt: any, updatedAt: any, slug?: string | null, productTitle: string, productDietList: Array<string>, fillingQuantity?: string | null, metaKeywords?: string | null, productImage?: { __typename?: 'Asset', url: string, mimeType?: string | null, mobile: string, desktop: string } | null }> }> }>, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, subcategoryPageName?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null, productCategoryName?: string | null } | null } | null, teaserPlaceholders: Array<{ __typename?: 'TeaserPlaceholder', id: string, title?: string | null, teasers: Array<{ __typename: 'Teaser', id: string, title?: string | null, heading?: string | null, description?: string | null, startDate: any, endDate: any, image?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, topRated?: boolean | null, environment: DbEnvironment, extension?: any | null, products?: any | null } | null }> }>, teaserSmallPlaceholders: Array<{ __typename?: 'TeaserSmallPlaceholder', id: string, title?: string | null, teaserSmalls: Array<{ __typename: 'TeaserSmall', id: string, heading?: string | null, description?: string | null, startDate: any, endDate: any, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null }> }> }> }>, productsText?: { __typename?: 'DictionaryItem', value: string } | null };

export type GetGtinFilteredProductQueryVariables = Exact<{
  where?: InputMaybe<ProductWhereInput>;
}>;


export type GetGtinFilteredProductQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', slug?: string | null, productTitle: string, productImage?: { __typename?: 'Asset', url: string, mimeType?: string | null, mobile: string, desktop: string } | null }> };

export type GetProductsSubSubCategoryPagesQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  subSubCategorySlug: Scalars['String']['input'];
  subCategorySlug: Scalars['String']['input'];
  categorySlug: Scalars['String']['input'];
  market: Markets;
}>;


export type GetProductsSubSubCategoryPagesQuery = { __typename?: 'Query', productCategoryPages: Array<{ __typename?: 'ProductCategoryPage', slug?: string | null, market: Markets, productCategoryName?: string | null, productSubcategoryPages: Array<{ __typename: 'ProductSubcategoryPage', slug?: string | null, subSubcategoryPages: Array<{ __typename: 'ProductSubcategoryPage', slug?: string | null, shouldBeIndexed: boolean, subcategoryPageName?: string | null, productGridTitle?: string | null, subSubCategorySuper?: string | null, subSubCategoryTitle?: string | null, metaData?: { __typename?: 'MetaData', id: string, pageName: string, sectionName?: string | null, description?: string | null, openGraphType?: string | null, theme?: string | null, images: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, url: string }> } | null, primarySubBrandColor?: { __typename?: 'Color', hex: any } | null, secondarySubBrandColor?: { __typename?: 'Color', hex: any } | null, heroCarouselComponent?: { __typename: 'HeroCarouselComponent', id: string, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, banners: Array<{ __typename?: 'HeroBanner', bannerSize?: BannerHeight | null, bannerTitle?: string | null, superText?: string | null, bannerDescriptionText?: string | null, bannerVideoUrl?: string | null, alignment?: AlignmentTypes | null, verticalAlignment?: VerticalAlignment | null, verticalAlignmentMobile?: VerticalAlignment | null, link?: { __typename?: 'Link', url?: string | null, displayName: string, openInNewTab: boolean, id: string } | null, bannerImage: Array<{ __typename?: 'Asset', url: string, mimeType?: string | null, imageAlt?: string | null, desktop: string, mobile: string }>, mobileImage?: { __typename?: 'Asset', url: string, mimeType?: string | null, mobile: string } | null }>, bannerMasterbrands: Array<{ __typename?: 'HeroBannerMasterbrand', bannerSize: BannerHeight, bannerTitle?: string | null, bannerSubtitle: string, superText?: string | null, bannerDescriptionText?: string | null, bannerVideoUrl?: string | null, alignment?: AlignmentTypes | null, verticalAlignment?: VerticalAlignment | null, verticalAlignmentMobile?: VerticalAlignment | null, textColor: HeroBannerTextColor, buttonColor: ButtonColor, showOverlay: boolean, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, bannerImage: Array<{ __typename?: 'Asset', mimeType?: string | null, imageAlt?: string | null, desktop: string, mobile: string }>, mobileImage?: { __typename?: 'Asset', mimeType?: string | null, mobile: string } | null }> } | null, introText?: { __typename: 'IntroText', id: string, super?: string | null, title?: string | null, titleTag?: Headlines | null, description?: string | null } | null, pageComponents: Array<{ __typename?: 'Accordion' } | { __typename: 'Banner1', id: string } | { __typename: 'Banner2', id: string } | { __typename: 'Banner2CarouselComponent', id: string } | { __typename: 'CarouselComponent', id: string } | { __typename?: 'DownloadApp' } | { __typename: 'DynamicCardGrid', id: string } | { __typename: 'FeaturedContent', id: string } | { __typename: 'GenericAccordion', id: string } | { __typename: 'GenericAccordionTopRated', id: string } | { __typename: 'GenericCardCarouseComponent', id: string } | { __typename: 'GenericDownloadComponent', id: string } | { __typename: 'GenericFollowUs', id: string } | { __typename: 'GenericGridAuthorable', id: string } | { __typename: 'GenericHtml', id: string } | { __typename: 'GlobalSearch', id: string } | { __typename: 'HeroCarouselComponent', id: string } | { __typename: 'Iframe', id: string } | { __typename: 'ImageCopy', id: string } | { __typename: 'LongText', id: string } | { __typename?: 'MultiStepPromotionForm' } | { __typename: 'ProductBanner', id: string } | { __typename: 'Spacer', id: string }>, productCategories: Array<{ __typename: 'ProductCategory', id: string, products: Array<{ __typename: 'Product', id: string, createdAt: any, updatedAt: any, slug?: string | null, productTitle: string, productDietList: Array<string>, fillingQuantity?: string | null, metaKeywords?: string | null, productImage?: { __typename?: 'Asset', url: string, mimeType?: string | null, mobile: string, desktop: string } | null }> }>, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, subcategoryPageName?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null, productCategoryName?: string | null } | null } | null, teaserPlaceholders: Array<{ __typename?: 'TeaserPlaceholder', id: string, title?: string | null, teasers: Array<{ __typename: 'Teaser', id: string, title?: string | null, heading?: string | null, description?: string | null, startDate: any, endDate: any, image?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, topRated?: boolean | null, environment: DbEnvironment, extension?: any | null, products?: any | null } | null }> }>, teaserSmallPlaceholders: Array<{ __typename?: 'TeaserSmallPlaceholder', id: string, title?: string | null, teaserSmalls: Array<{ __typename: 'TeaserSmall', id: string, heading?: string | null, description?: string | null, startDate: any, endDate: any, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null }> }> }> }> }>, productsText?: { __typename?: 'DictionaryItem', value: string } | null };

export type GetQuestionQueryVariables = Exact<{
  where: QuestionWhereUniqueInput;
}>;


export type GetQuestionQuery = { __typename?: 'Query', question?: { __typename: 'Question', id: string, title: string, subtitle?: string | null, question: string, market: Markets, image?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, mobile: string, desktop: string }> } | null, options?: { __typename: 'QuestionCheckboxCollection', id: string, title?: string | null, name: string, questionCheckboxes: Array<{ __typename?: 'QuestionCheckbox', title?: string | null, name: string, label: string, required?: boolean | null }> } | { __typename?: 'QuestionRadioButtonCollection', id: string, title?: string | null, name: string, questionRadioButtons: Array<{ __typename?: 'QuestionRadioButton', title?: string | null, name: string, label: string, required?: boolean | null }> } | null } | null };

export type GetRecipeQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where: RecipeWhereUniqueInput;
}>;


export type GetRecipeQuery = { __typename?: 'Query', recipe?: { __typename?: 'Recipe', cmsTitle?: string | null, nutritionIsActive?: boolean | null, showRatingBannerInPreparationColumn: boolean, showCommentFieldInRatingModal: boolean, showContactPageData: boolean, hideTabsOnMobile: boolean, textBlockForRatingBannerInPreparationColumn?: string | null, showHappyCartButton: boolean, titles?: { __typename?: 'Dictionary', dictionaryItems: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> } | null, longText?: { __typename?: 'LongText', longText?: { __typename?: 'LongTextLongTextRichText', text: string } | null } | null, recipelifestyle: Array<{ __typename?: 'AssetComponent', cmsAssetTitle?: string | null, asset: Array<{ __typename?: 'Asset', url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, background: string, desktop: string, mobile: string }> }>, ratingmsg?: { __typename?: 'Rating', message: Array<string>, rateThis?: string | null, thanksMessage?: string | null, ratingBtn?: string | null, ratingTitle?: string | null, ratingThanks?: string | null, ratingSubtitle?: string | null, ratingBody?: string | null, upperRightCorner?: { __typename?: 'Asset', url: string } | null, lowerLeftCorner?: { __typename?: 'Asset', url: string } | null, background: Array<{ __typename?: 'Asset', url: string }> } | null, genericFollowUs?: { __typename?: 'GenericFollowUs', id: string, super?: string | null, title?: string | null, socialMedia: Array<{ __typename?: 'SocialMediaListComponent', name: string, url: string, assetsComponents: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, id: string, mimeType?: string | null, url: string }> }> }>, middlegroundImage?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, id: string, mimeType?: string | null, url: string }> } | null, foregroundImage?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, id: string, mimeType?: string | null, url: string }> } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null, sustainabilityBanner?: { __typename?: 'SustainabilityBanner', superText?: string | null, title?: string | null, description?: string | null, upperLeftCorner?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, url: string, mimeType?: string | null, altText?: string | null, desktop: string, mobile: string }> } | null, lowerRightCorner?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, desktop: string, mobile: string }> } | null, link?: { __typename?: 'Link', displayName: string, url?: string | null } | null } | null, teaserPlaceholders: Array<{ __typename?: 'TeaserPlaceholder', id: string, title?: string | null, teasers: Array<{ __typename: 'Teaser', id: string, title?: string | null, heading?: string | null, description?: string | null, startDate: any, endDate: any, image?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, topRated?: boolean | null, environment: DbEnvironment, extension?: any | null, products?: any | null } | null }> }>, teaserSmallPlaceholders: Array<{ __typename?: 'TeaserSmallPlaceholder', id: string, title?: string | null, teaserSmalls: Array<{ __typename: 'TeaserSmall', id: string, heading?: string | null, description?: string | null, startDate: any, endDate: any, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null }> }>, contactPageData?: { __typename?: 'RichText', html: string } | null } | null };

export type GetRecipesCategoriesSubCategoriesSlugsQueryVariables = Exact<{
  market: Markets;
}>;


export type GetRecipesCategoriesSubCategoriesSlugsQuery = { __typename?: 'Query', recipeCategories: Array<{ __typename?: 'RecipeCategory', slug?: string | null, recipeSubcategories: Array<{ __typename?: 'RecipeSubcategory', slug?: string | null, recipeSubSubcategories: Array<{ __typename?: 'RecipeSubcategory', slug?: string | null }> }> }> };

export type GetRecipeLandingPagesQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  market: Markets;
}>;


export type GetRecipeLandingPagesQuery = { __typename?: 'Query', recipeLandingPage?: { __typename: 'RecipeLandingPage', id: string, slug?: string | null, metaData?: { __typename?: 'MetaData', id: string, pageName: string, description?: string | null, openGraphType?: string | null, theme?: string | null, images: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, url: string }> } | null, pageComponents: Array<{ __typename?: 'Accordion' } | { __typename: 'Banner1', id: string } | { __typename: 'Banner2', id: string } | { __typename: 'Banner2CarouselComponent', id: string } | { __typename: 'CarouselComponent', id: string } | { __typename?: 'DownloadApp' } | { __typename: 'DynamicCardGrid', id: string } | { __typename: 'FeaturedContent', id: string } | { __typename: 'GenericAccordion', id: string } | { __typename: 'GenericCardCarouseComponent', id: string } | { __typename: 'GenericDownloadComponent', id: string } | { __typename: 'GenericFollowUs', id: string } | { __typename: 'GenericGridAuthorable', id: string } | { __typename: 'GenericHtml', id: string } | { __typename: 'GlobalSearch', id: string } | { __typename: 'HeroCarouselComponent', id: string } | { __typename: 'Iframe', id: string } | { __typename: 'LongText', id: string } | { __typename: 'ProductBanner', id: string } | { __typename: 'Spacer', id: string }>, heroCarouselComponent?: { __typename: 'HeroCarouselComponent', id: string, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, banners: Array<{ __typename?: 'HeroBanner', bannerSize?: BannerHeight | null, bannerTitle?: string | null, superText?: string | null, bannerDescriptionText?: string | null, bannerVideoUrl?: string | null, alignment?: AlignmentTypes | null, verticalAlignment?: VerticalAlignment | null, verticalAlignmentMobile?: VerticalAlignment | null, link?: { __typename?: 'Link', url?: string | null, displayName: string, openInNewTab: boolean } | null, bannerImage: Array<{ __typename?: 'Asset', url: string, mimeType?: string | null, imageAlt?: string | null, desktop: string, mobile: string }>, mobileImage?: { __typename?: 'Asset', url: string, mimeType?: string | null, mobile: string } | null }>, bannerMasterbrands: Array<{ __typename?: 'HeroBannerMasterbrand', bannerSize: BannerHeight, bannerTitle?: string | null, bannerSubtitle: string, superText?: string | null, bannerDescriptionText?: string | null, bannerVideoUrl?: string | null, alignment?: AlignmentTypes | null, verticalAlignment?: VerticalAlignment | null, verticalAlignmentMobile?: VerticalAlignment | null, textColor: HeroBannerTextColor, buttonColor: ButtonColor, showOverlay: boolean, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, bannerImage: Array<{ __typename?: 'Asset', mimeType?: string | null, imageAlt?: string | null, desktop: string, mobile: string }>, mobileImage?: { __typename?: 'Asset', mimeType?: string | null, mobile: string } | null }> } | null, anchorNavigationList?: { __typename?: 'AnchorNavigationList', id: string, anchorNavigations: Array<{ __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null, externalComponent: Array<AnchorNavigationExternalComponents> }> } | null, introText?: { __typename: 'IntroText', id: string, super?: string | null, title?: string | null, titleTag?: Headlines | null, description?: string | null } | null, recipeCategories: Array<{ __typename: 'RecipeCategory', id: string, recipeDbCategoryId?: string | null, name?: string | null, slug?: string | null, keyImage?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string, desktop: string, mobile: string }> } | null, promoImage?: { __typename?: 'AssetComponent', mobile: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string }>, desktop: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string }> } | null, recipeSubcategories: Array<{ __typename: 'RecipeSubcategory', id: string, slug?: string | null, recipeIDs: Array<string>, recipeSubCategoryName?: string | null, subSubCategorySuper?: string | null, subSubCategoryTitle?: string | null, keyImage?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, url: string, mimeType?: string | null, desktop: string, mobile: string }> } | null, algoliaExtension?: { __typename?: 'AlgoliaExtension', extension?: any | null } | null, recipeSubSubcategories: Array<{ __typename?: 'RecipeSubcategory', id: string, slug?: string | null, promoImage?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string, mobile: string, desktop: string }> } | null }> }> }>, teaserPlaceholders: Array<{ __typename?: 'TeaserPlaceholder', id: string, title?: string | null, teasers: Array<{ __typename: 'Teaser', id: string, title?: string | null, heading?: string | null, description?: string | null, startDate: any, endDate: any, image?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, topRated?: boolean | null, environment: DbEnvironment, extension?: any | null, products?: any | null } | null }> }>, teaserSmallPlaceholders: Array<{ __typename?: 'TeaserSmallPlaceholder', id: string, title?: string | null, teaserSmalls: Array<{ __typename: 'TeaserSmall', id: string, heading?: string | null, description?: string | null, startDate: any, endDate: any, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null }> }> } | null, learnMoreText?: { __typename?: 'DictionaryItem', value: string } | null, recipesText?: { __typename?: 'DictionaryItem', value: string } | null };

export type GetSearchOverlayQueryVariables = Exact<{
  where?: InputMaybe<SearchOverlayComponentWhereInput>;
}>;


export type GetSearchOverlayQuery = { __typename?: 'Query', searchOverlayComponents: Array<{ __typename?: 'SearchOverlayComponent', heading?: string | null, subHeading?: string | null, links: Array<{ __typename?: 'Link', displayName: string, url?: string | null }>, dictionaries: Array<{ __typename?: 'Dictionary', dictionaryTitle?: string | null, dictionaryItems: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> }>, teaserPlaceholders: Array<{ __typename?: 'TeaserPlaceholder', id: string, title?: string | null, teasers: Array<{ __typename: 'Teaser', id: string, title?: string | null, heading?: string | null, description?: string | null, startDate: any, endDate: any, image?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, width?: number | null, height?: number | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, topRated?: boolean | null, environment: DbEnvironment, extension?: any | null, products?: any | null } | null }> }>, teaserSmallPlaceholders: Array<{ __typename?: 'TeaserSmallPlaceholder', id: string, title?: string | null, teaserSmalls: Array<{ __typename: 'TeaserSmall', id: string, heading?: string | null, description?: string | null, startDate: any, endDate: any, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename: 'GenericPage', slug?: string | null, type: GenericPagesTypes, subPath?: string | null } | { __typename: 'ProductCategoryPage', slug?: string | null } | { __typename: 'ProductLandingPage', slug?: string | null } | { __typename: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null, productSubcategoryPage?: { __typename?: 'ProductSubcategoryPage', slug?: string | null, productCategoryPage?: { __typename?: 'ProductCategoryPage', slug?: string | null } | null } | null } | { __typename: 'RecipeCategory', name?: string | null, slug?: string | null } | { __typename: 'RecipeLandingPage', slug?: string | null } | { __typename: 'RecipeSubcategory', slug?: string | null, recipeSubcategory?: { __typename?: 'RecipeSubcategory', slug?: string | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null, recipeCategory?: { __typename?: 'RecipeCategory', slug?: string | null } | null } | null } | null }> }> }> };

export type GetCardCarouselQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where?: InputMaybe<GenericCardCarouseComponentWhereInput>;
}>;


export type GetCardCarouselQuery = { __typename?: 'Query', genericCardCarouseComponents: Array<{ __typename?: 'GenericCardCarouseComponent', subHeading?: string | null, heading?: string | null, cardVariation?: CardVariation | null, componentBackground: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string }> }>, floatingObject: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string, altText?: string | null }> }>, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, environment: DbEnvironment, extension?: any | null, tipsAndTricks?: any | null } | null, dictionaryItem: Array<{ __typename?: 'DictionaryItem', key: string, value: string }>, genericCardCarouselCta?: { __typename?: 'Link', displayName: string, url?: string | null } | null }> };

export type GetSearchResultPageQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where?: InputMaybe<SearchResultPageWhereInput>;
}>;


export type GetSearchResultPageQuery = { __typename?: 'Query', searchResultPages: Array<{ __typename?: 'SearchResultPage', searchPageTitles?: { __typename?: 'Dictionary', dictionaryItems: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> } | null }> };

export type GetSeparatorQueryVariables = Exact<{
  where: SeparatorWhereUniqueInput;
}>;


export type GetSeparatorQuery = { __typename?: 'Query', separator?: { __typename: 'Separator', id: string } | null };

export type GetSocialSharingQueryVariables = Exact<{
  where?: InputMaybe<SocialMediaListComponentWhereInput>;
}>;


export type GetSocialSharingQuery = { __typename?: 'Query', socialMediaListComponents: Array<{ __typename: 'SocialMediaListComponent', id: string, name: string, url: string, shareMsg?: string | null, socialMediaComponentName?: SocialMediaComponentName | null, socialSharePosition: Array<SocialSharePosition>, assetsComponents: Array<{ __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string }> }> }> };

export type GetSpacerQueryVariables = Exact<{
  where: SpacerWhereUniqueInput;
}>;


export type GetSpacerQuery = { __typename?: 'Query', spacer?: { __typename: 'Spacer', id: string, height?: number | null } | null };

export type GetSubTabsQueryVariables = Exact<{
  where: SubTabWhereUniqueInput;
}>;


export type GetSubTabsQuery = { __typename?: 'Query', tab?: { __typename: 'SubTab', id: string, cmsTabTitle: string, tabs: Array<{ __typename?: 'SubTabContent', id: string, tabTitle: string, components: Array<{ __typename: 'AuthorableContentCard', id: string } | { __typename: 'Banner1', id: string } | { __typename: 'Banner2', id: string } | { __typename: 'Banner2CarouselComponent', id: string } | { __typename?: 'CardComponent' } | { __typename: 'CarouselComponent', id: string } | { __typename: 'DynamicCardGrid', id: string } | { __typename: 'EvalancheFormComponent', id: string } | { __typename: 'Form', id: string } | { __typename: 'GenericAccordion', id: string } | { __typename: 'GenericAccordionTopRated', id: string } | { __typename: 'GenericCardCarouseComponent', id: string } | { __typename: 'GenericDownloadComponent', id: string } | { __typename: 'GenericFollowUs', id: string } | { __typename: 'GenericHtml', id: string } | { __typename: 'GenericLine', id: string } | { __typename?: 'GenericPage' } | { __typename: 'GridColumn', id: string } | { __typename: 'GridColumnComponent', id: string } | { __typename: 'HeroCarouselComponent', id: string } | { __typename: 'Iframe', id: string } | { __typename: 'ImageCopy', id: string } | { __typename: 'IntroText', id: string } | { __typename: 'Link', id: string } | { __typename: 'LongText', id: string } | { __typename: 'ProductBanner', id: string } | { __typename?: 'SocialMediaListComponent' }> }> } | null };

export type GetSustainabilityInfoQueryVariables = Exact<{
  where: SustainabilityInfoWhereUniqueInput;
}>;


export type GetSustainabilityInfoQuery = { __typename?: 'Query', sustainabilityInfo?: { __typename?: 'SustainabilityInfo', cmsTitle?: string | null, id: string, superHeading?: string | null, title?: string | null, ingredientsTitle?: string | null, packagingTitle?: string | null, upperLeftCorner?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, url: string, altText?: string | null, mimeType?: string | null }> } | null, upperRightCorner?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, mimeType?: string | null, url: string, altText?: string | null }> } | null, lowerLeftCorner?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, url: string, mimeType?: string | null, altText?: string | null }> } | null, lowerRightCorner?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, url: string, altText?: string | null, mimeType?: string | null }> } | null } | null };

export type GetTabsQueryVariables = Exact<{
  where: TabWhereUniqueInput;
}>;


export type GetTabsQuery = { __typename?: 'Query', tab?: { __typename: 'Tab', id: string, cmsTabTitle: string, tabs: Array<{ __typename?: 'TabContent', id: string, tabTitle: string, components: Array<{ __typename: 'AuthorableContentCard', id: string } | { __typename: 'Banner1', id: string } | { __typename: 'Banner2', id: string } | { __typename: 'Banner2CarouselComponent', id: string } | { __typename?: 'CardComponent' } | { __typename: 'CarouselComponent', id: string } | { __typename: 'DynamicCardGrid', id: string } | { __typename: 'EvalancheFormComponent', id: string } | { __typename: 'Form', id: string } | { __typename: 'GenericAccordion', id: string } | { __typename: 'GenericAccordionTopRated', id: string } | { __typename: 'GenericCardCarouseComponent', id: string } | { __typename: 'GenericDownloadComponent', id: string } | { __typename: 'GenericFollowUs', id: string } | { __typename: 'GenericHtml', id: string } | { __typename: 'GenericLine', id: string } | { __typename: 'GridColumn', id: string } | { __typename: 'GridColumnComponent', id: string } | { __typename: 'HeroCarouselComponent', id: string } | { __typename: 'Iframe', id: string } | { __typename: 'ImageCopy', id: string } | { __typename: 'IntroText', id: string } | { __typename: 'Link', id: string } | { __typename: 'LongText', id: string } | { __typename: 'ProductBanner', id: string } | { __typename?: 'SocialMediaListComponent' } | { __typename: 'SubTab', id: string }> }> } | null };

export type GetTestComponentWithRecipeQueryQueryVariables = Exact<{
  where: TestComponentWithRecipeQueryWhereUniqueInput;
}>;


export type GetTestComponentWithRecipeQueryQuery = { __typename?: 'Query', testComponentWithRecipeQuery?: { __typename?: 'TestComponentWithRecipeQuery', title?: string | null, id: string, rewriteData: Array<{ __typename: 'Rewrite', showLocale: boolean, destination: string, page: RewriteTypes, source: string }>, recipesQueriesReference?: { __typename?: 'RecipesQueriesReference', title?: string | null, id: string, size: number, recipesQueryComponent: Array<{ __typename?: 'RecipesComparisonQueryComponent', value: string, comparisonOperator: ComparisonOperators, queryType: RecipesComparisonQueries } | { __typename?: 'RecipesQueryComponent', value: string, query: ReicpesQueries }> } | null } | null };

export type GetTipsAndTricksQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where: TipsAndTricksDetailsPageWhereUniqueInput;
}>;


export type GetTipsAndTricksQuery = { __typename?: 'Query', tipsAndTricksDetailsPage?: { __typename?: 'TipsAndTricksDetailsPage', sustainabilityBanner?: { __typename?: 'SustainabilityBanner', id: string, superText?: string | null, title?: string | null, description?: string | null, upperLeftCorner?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, url: string, altText?: string | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, lowerRightCorner?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, url: string, altText?: string | null, mimeType?: string | null, desktop: string, mobile: string }> } | null, link?: { __typename?: 'Link', displayName: string, url?: string | null } | null } | null, titles?: { __typename?: 'Dictionary', dictionaryItems: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> } | null, relatedTipsCarouselData?: { __typename?: 'GenericCardCarouseComponent', id: string, heading?: string | null, subHeading?: string | null, cardVariation?: CardVariation | null, genericCardCarouselCta?: { __typename?: 'Link', id: string, url?: string | null, displayName: string } | null, componentBackground: Array<{ __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, url: string, altText?: string | null, mimeType?: string | null }> }>, floatingObject: Array<{ __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', width?: number | null, height?: number | null, url: string, altText?: string | null, mimeType?: string | null }> }> } | null } | null };
